var createDeepARModule = function () {
  var _scriptDir = "undefined" != typeof document && document.currentScript ? document.currentScript.src : void 0;
  return "undefined" != typeof __filename && (_scriptDir = _scriptDir || __filename),
    function (createDeepARModule) {
      var e, aa;
      createDeepARModule = createDeepARModule || {}, (e = e || (void 0 !== createDeepARModule ? createDeepARModule : {})).ready = new Promise(function (a) {
          aa = a
        }),
        function (a) {
          function b() {
            this.name = "NotSupportedError", this.message = "getUserMedia is not implemented in this browser"
          }

          function c() {
            this.then = function () {
              return this
            };
            var r = new b;
            this.catch = function (t) {
              setTimeout(function () {
                t(r)
              })
            }
          }

          function d(r) {
            return f ? k ? navigator.mediaDevices.getUserMedia(r) : new Promise(function (t, x) {
              if (!n) return x(new b);
              n.call(navigator, r, t, x)
            }) : new c
          }
          b.prototype = Error.prototype;
          var f = "undefined" != typeof Promise,
            g = "undefined" != typeof navigator,
            k = g && navigator.mediaDevices && navigator.mediaDevices.getUserMedia,
            n = g && (navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.Dg || navigator.Eg);
          d.Df = b, d.Hg = !(!f || !k && !n), "function" == typeof define && define.Df ? define([], function () {
            return d
          }) : "object" == typeof module && module.exports ? module.exports = d : (a.navigator || (a.navigator = {}), a.navigator.mediaDevices || (a.navigator.mediaDevices = {}), a.navigator.mediaDevices.getUserMedia || (a.navigator.mediaDevices.getUserMedia = d))
        }(this),
        function () {
          function a() {
            var p, v, l;
            n && (window.requestAnimationFrame(a), p = Date.now(), r < (v = p - t) && !e.Jf && (t = p - v % r, p = e.video, v = e.context, l = e.vf, p && v && l && p.readyState === p.HAVE_ENOUGH_DATA && (e._processFrameVideo(0, l.width, l.height, e.Qf), p = e.video, e.Uf && h && ((v = h.uf).bindTexture(v.TEXTURE_2D, e.Uf), v.texImage2D(v.TEXTURE_2D, 0, v.RGBA, v.RGBA, v.UNSIGNED_BYTE, p)), e.Sf && e.Kf ? (e.Jf = !0, x.classify(e.vf).then(function () {
              e.Sf = !1, e.Pf = 1, e.hg = x.getOutput(), e._render(), e.Jf = !1
            })) : e._render()), e.Tf && !e.Kf && e.initializeSegmentation(function () {
              console.log("Segmentation initialized")
            })))
          }
          var c = null,
            d = null,
            f = null,
            g = null,
            k = null;
          e.preinitializedWebGLContext = e.canvas.getContext("webgl", {
            alpha: !1
          }), e.numberOfFaces || (e.numberOfFaces = 1);
          var n = !1;
          e.process = function () {};
          var r = 1e3 / 30,
            t = 0,
            x = null;
          e.setFps = function (p) {
            r = 1e3 / p
          }, e.initializeSegmentation = function (p) {
            e.Tf = !1;
            var v = e.libPath || ".",
              l = e.segmentationInfoZip || "segmentation.zip";
            (x = new window.xzimg.Segmentation).initialize({
              libPath: v,
              filename: l
            }, function () {}).then(function () {
              e.Kf = !0, e.Jf = !1, p && p()
            })
          }, e.startLoop = function () {
            n || (n = !0, a())
          }, e.endLoop = function () {
            n = !1
          }, e.takeScreenshot = function () {
            g(), n || e._render()
          }, e.processFrameRawPixels = function (p, v, l, q) {
            var w = e._malloc(p.length);
            e.HEAPU8.set(p, w), e._processFrameRawPixels(w, v, l, q), n || e._render()
          }, e.setFaceTrackingModel = function (p) {
            e.faceTrackingModelByteArray = p
          }, e.switchEffectByteArray = function (p, v, l) {
            var q;
            c && (q = e._malloc(l.length), e.HEAPU8.set(l, q), c(v, q, l.length, p), n || e._render())
          }, e.switchEffect = function (p, v, l, q) {
            var w = new XMLHttpRequest;
            w.open("GET", l, !0), w.responseType = "arraybuffer", w.onreadystatechange = function () {
              var E;
              4 == w.readyState && 200 == w.status && (E = new Uint8Array(w.response), e.switchEffectByteArray(p, v, E), q && q())
            }, w.send(null)
          }, e.clearEffect = function (p) {
            f && (f(p), n || e._render())
          }, e.moveGameObject = function (p, v) {
            k && (k(p, v), n || e._render())
          }, e.startVideo = function (p, v) {
            var l;
            e.video ? console.log("video already running") : (e.Of = !1, e.qg = v, e.Qf = !!p, (l = document.createElement("video")).muted = !0, l.loop = !0, l.controls = !0, l.setAttribute("playsinline", "playsinline"), l.style.width = "100%", l.style.height = "100%", (p = document.createElement("div")).appendChild(l), p.style.width = "1px", p.style.height = "1px", p.style.position = "absolute", p.style.top = "0px", p.style.left = "0px", p.style["z-index"] = "-1", document.body.appendChild(p), e.Hf = p, e.video = l, p = e.qg || !0, e.Xf(), navigator.mediaDevices.getUserMedia({
              video: p
            }).then(function (q) {
              try {
                l.srcObject = q
              } catch (w) {
                l.src = URL.createObjectURL(q)
              }
              e.Zf(), setTimeout(function () {
                l.play()
              }, 50)
            }).catch(function () {
              e.Yf()
            }), l.addEventListener("loadedmetadata", function () {
              var q = document.createElement("canvas"),
                w = q.getContext("2d");
              e.vf = q, e.context = w, w = 320 / l.videoWidth, q.width = Math.floor(l.videoWidth * w), q.height = Math.floor(l.videoHeight * w), e.Bf = e._malloc(q.width * q.height * 4), e.fg()
            }))
          }, e.shutdown = function () {
            e.stopVideo(), d()
          }, e.setVideoElement = function (p, v) {
            function l() {
              var q = document.createElement("canvas"),
                w = q.getContext("2d");
              e.vf = q, e.context = w, w = 320 / p.videoWidth, q.width = Math.floor(p.videoWidth * w), q.height = Math.floor(p.videoHeight * w), e.Bf = e._malloc(q.width * q.height * 4), p.removeEventListener("loadedmetadata", l)
            }
            e.Qf = !!v, e.Of = !0, (e.video = p).readyState === p.HAVE_ENOUGH_DATA ? l() : p.addEventListener("loadedmetadata", l)
          }, e.stopVideo = function () {
            var p;
            e.Hf && (e.Hf.parentNode.removeChild(e.Hf), e.Hf = null), e.video && (e.Of || ((p = e.video.srcObject.getVideoTracks()) && 0 < p.length && p[0].stop(), e.video.pause()), e.video = null), e.vf = null, e.Bf && e._free(e.Bf), e.Bf = 0, e.context = null
          }, e.ag = function (p, v, l) {
            if (e.apiObject.onFaceTracked) {
              for (var q = [], w = 0; w < l; w++) {
                var E = {
                    detected: 0,
                    translation: [],
                    rotation: [],
                    poseMatrix: [],
                    landmarks: [],
                    landmarks2d: [],
                    faceRect: []
                  },
                  D = p + w * v,
                  ea = D + 4,
                  fa = ea + 12,
                  ha = fa + 12,
                  ia = ha + 64,
                  Nc = ia + 816;
                for (E.detected = !!e.HEAP32[D / Float32Array.BYTES_PER_ELEMENT], D = 0; D < 3; D++) E.translation.push(e.HEAPF32[ea / Float32Array.BYTES_PER_ELEMENT + D]), E.rotation.push(e.HEAPF32[fa / Float32Array.BYTES_PER_ELEMENT + D]);
                for (D = 0; D < 16; D++) E.poseMatrix.push(e.HEAPF32[ha / Float32Array.BYTES_PER_ELEMENT + D]);
                for (D = 0; D < 204; D++) E.landmarks.push(e.HEAPF32[ia / Float32Array.BYTES_PER_ELEMENT + D]), D < 136 && E.landmarks2d.push(e.HEAPF32[Nc / Float32Array.BYTES_PER_ELEMENT + D]);
                q.push(E)
              }
              e.apiObject.onFaceTracked(q)
            }
          }, e.fg = function () {
            e.apiObject.onVideoStarted && e.apiObject.onVideoStarted()
          }, e.sg = function () {
            e.apiObject.onInitialize && e.apiObject.onInitialize()
          }, e.bg = function (p) {
            e.apiObject.onFaceVisibilityChanged && e.apiObject.onFaceVisibilityChanged(p)
          }, e.cg = function (p) {
            e.apiObject.onImageVisibilityChanged && e.apiObject.onImageVisibilityChanged(p)
          }, e.Zf = function () {
            e.apiObject.onCameraPermissionGranted && e.apiObject.onCameraPermissionGranted()
          }, e.Yf = function () {
            e.apiObject.onCameraPermissionDenied && e.apiObject.onCameraPermissionDenied()
          }, e.Xf = function () {
            e.apiObject.onCameraPermissionAsked && e.apiObject.onCameraPermissionAsked()
          }, e.eg = function (p, v, l) {
            var q = document.createElement("canvas"),
              w = q.getContext("2d");
            q.width = v, q.height = l;
            for (var E = w.getImageData(0, 0, q.width, q.height), D = E.data, ea = 0; ea < l; ea++)
              for (var fa = 0; fa < v; fa++) {
                var ha = 4 * ((l - ea - 1) * v + fa),
                  ia = 4 * (ea * v + fa);
                D[ia] = e.HEAPU8[p + ha + 2], D[1 + ia] = e.HEAPU8[p + ha + 1], D[2 + ia] = e.HEAPU8[p + ha + 0], D[3 + ia] = e.HEAPU8[p + ha + 3]
              }
            w.putImageData(E, 0, 0), e.apiObject.onScreenshotTakenCanvas && e.apiObject.onScreenshotTakenCanvas(q), e.apiObject.onScreenshotTaken && e.apiObject.onScreenshotTaken(q.toDataURL("image/png"))
          }, e.Wf = function (p) {
            e.apiObject.onAnimationTransitionedToState && e.apiObject.onAnimationTransitionedToState(p)
          }, e.$f = function (p, v) {
            e.apiObject.onError && e.apiObject.onError(p, v)
          }, e.dg = function (p) {
            e.apiObject.onNumberOfFacesVisibleChanged && e.apiObject.onNumberOfFacesVisibleChanged(p)
          }, e.noInitialRun = !0, e.onRuntimeInitialized = function () {
            c = e.cwrap("switchEffect", null, ["string", "number", "number", "number"]), f = e.cwrap("clearEffect", null, ["string"]), g = e.cwrap("takeScreenshot", null, []), k = e.cwrap("moveGameObject", null, ["string", "string"]), e.changeParameterFloat = e.cwrap("changeParameterFloat", null, ["string", "string", "string", "number"]), e.changeParameterVector = e.cwrap("changeParameterVector", null, "string string string number number number number".split(" ")), e.changeParameterBool = e.cwrap("changeParameterBool", null, ["string", "string", "string", "number"]), e.changeParameterTexture = e.cwrap("changeParameterTexture", null, "string string string number number number number".split(" ")), e.fireTrigger = e.cwrap("fireTrigger", null, ["string"]), e.setFaceDetectionSensitivity = e.cwrap("setFaceDetectionSensitivity", null, ["number"]), e.reset = e.cwrap("reset", null, ["number", "number"]), e.showStats = e.cwrap("showStats", null, ["number"]), e.setLicenseKey = e.cwrap("setLicenseKey", null, ["string"]), e.stringToC = e.cwrap("stringToC", null, ["string", "string"]), d = e.cwrap("shutdownEngine", null, []);
            var p = window.localStorage.getItem("k39d");
            p || (p = function () {
              var p = (new Date).getTime(),
                v = performance && performance.now && 1e3 * performance.now() || 0;
              return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (l) {
                var q = 16 * Math.random();
                return 0 < p ? (q = (p + q) % 16 | 0, p = Math.floor(p / 16)) : (q = (v + q) % 16 | 0, v = Math.floor(v / 16)), ("x" === l ? q : 3 & q | 8).toString(16)
              })
            }(), window.localStorage.setItem("k39d", p)), e.stringToC("uuid", p), e.stringToC("userAgent", navigator.userAgent), e.stringToC("screenResolution", window.screen.width + "x" + window.screen.height), (p = document.title) && 0 !== p.length || (p = "No title"), e.stringToC("applicationName", p), e.stringToC("applicationId", document.domain), e.stringToC("applicationVersion", "1.0.0"), (p = navigator.vendor) && 0 !== p.length || (p = "N/A");
            var v = navigator.platform;
            v && 0 !== v.length || (v = "N/A"), e.stringToC("deviceVendor", p), e.stringToC("deviceModel", v), e.stringToC("operatingSystem", v), e.setLicenseKey(e.licenseKey), e.cwrap("initialize", null, [])()
          }, e.print = function (p) {
            1 < arguments.length && (p = Array.prototype.slice.call(arguments).join(" ")), console.log(p)
          }, e.printErr = function (p) {
            1 < arguments.length && (p = Array.prototype.slice.call(arguments).join(" ")), "string" == typeof p && 0 === p.indexOf("bad name in getProcAddress:") || console.log(p)
          }
        }();
      var m, ba = {};
      for (m in e) e.hasOwnProperty(m) && (ba[m] = e[m]);
      var ca = "./this.program";

      function da(a, b) {
        throw b
      }
      var na, oa, pa, qa, ja = !1,
        ka = !1,
        ja = "object" == typeof window,
        ka = "function" == typeof importScripts,
        la = "object" == typeof process && "object" == typeof process.versions && "string" == typeof process.versions.node,
        ma = !ja && !la && !ka,
        u = "";
      la ? (u = ka ? require("path").dirname(u) + "/" : __dirname + "/", na = function (a, b) {
        return pa = pa || require("fs"), a = (qa = qa || require("path")).normalize(a), pa.readFileSync(a, b ? null : "utf8")
      }, oa = function (a) {
        return (a = na(a, !0)).buffer || (a = new Uint8Array(a)), assert(a.buffer), a
      }, 1 < process.argv.length && (ca = process.argv[1].replace(/\\/g, "/")), process.argv.slice(2), process.on("uncaughtException", function (a) {
        if (!(a instanceof ra)) throw a
      }), process.on("unhandledRejection", sa), da = function (a) {
        process.exit(a)
      }, e.inspect = function () {
        return "[Emscripten Module object]"
      }) : ma ? ("undefined" != typeof read && (na = function (a) {
        return read(a)
      }), oa = function (a) {
        return "function" == typeof readbuffer ? new Uint8Array(readbuffer(a)) : (assert("object" == typeof (a = read(a, "binary"))), a)
      }, "function" == typeof quit && (da = function (a) {
        quit(a)
      }), "undefined" != typeof print && ("undefined" == typeof console && (console = {}), console.log = print, console.warn = console.error = "undefined" != typeof printErr ? printErr : print)) : (ja || ka) && (ka ? u = self.location.href : document.currentScript && (u = document.currentScript.src), _scriptDir && (u = _scriptDir), u = 0 !== u.indexOf("blob:") ? u.substr(0, u.lastIndexOf("/") + 1) : "", na = function (a) {
        var b = new XMLHttpRequest;
        return b.open("GET", a, !1), b.send(null), b.responseText
      }, ka && (oa = function (a) {
        var b = new XMLHttpRequest;
        return b.open("GET", a, !1), b.responseType = "arraybuffer", b.send(null), new Uint8Array(b.response)
      }));
      var ta = e.print || console.log.bind(console),
        y = e.printErr || console.warn.bind(console);
      for (m in ba) ba.hasOwnProperty(m) && (e[m] = ba[m]);
      ba = null, e.thisProgram && (ca = e.thisProgram), e.quit && (da = e.quit);
      var va, xa, noExitRuntime, wa = 0;
      e.wasmBinary && (xa = e.wasmBinary), e.noExitRuntime && (noExitRuntime = e.noExitRuntime), "object" != typeof WebAssembly && y("no native wasm support detected");
      var ya, za = new WebAssembly.Table({
          initial: 1818,
          maximum: 1818,
          element: "anyfunc"
        }),
        Aa = !1;

      function assert(a, b) {
        a || sa("Assertion failed: " + b)
      }

      function Ba(a) {
        var b = e["_" + a];
        return assert(b, "Cannot call unknown function " + a + ", make sure it is exported"), b
      }

      function Ca(a, b, c, d) {
        var t, f = {
            string: function (t) {
              var p, x = 0;
              return null != t && 0 !== t && (p = 1 + (t.length << 2), x = Da(p), z(t, A, x, p)), x
            },
            array: function (t) {
              var x = Da(t.length);
              return Ea.set(t, x), x
            }
          },
          g = Ba(a),
          k = [];
        if (a = 0, d)
          for (var n = 0; n < d.length; n++) {
            var r = f[c[n]];
            r ? (0 === a && (a = B()), k[n] = r(d[n])) : k[n] = d[n]
          }
        return c = g.apply(null, k), t = c, c = "string" === b ? C(t) : "boolean" === b ? !!t : t, 0 !== a && F(a), c
      }
      var Ka, Ea, A, La, G, Ma, H, Na, Fa = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;

      function Ga(a, b, c) {
        var d = b + c;
        for (c = b; a[c] && !(d <= c);) ++c;
        if (16 < c - b && a.subarray && Fa) return Fa.decode(a.subarray(b, c));
        for (d = ""; b < c;) {
          var g, k, f = a[b++];
          128 & f ? (g = 63 & a[b++], 192 == (224 & f) ? d += String.fromCharCode((31 & f) << 6 | g) : (k = 63 & a[b++], (f = 224 == (240 & f) ? (15 & f) << 12 | g << 6 | k : (7 & f) << 18 | g << 12 | k << 6 | 63 & a[b++]) < 65536 ? d += String.fromCharCode(f) : (f -= 65536, d += String.fromCharCode(55296 | f >> 10, 56320 | 1023 & f)))) : d += String.fromCharCode(f)
        }
        return d
      }

      function C(a, b) {
        return a ? Ga(A, a, b) : ""
      }

      function z(a, b, c, d) {
        if (!(0 < d)) return 0;
        var f = c;
        d = c + d - 1;
        for (var g = 0; g < a.length; ++g) {
          var k = a.charCodeAt(g);
          if (55296 <= k && k <= 57343 && (k = 65536 + ((1023 & k) << 10) | 1023 & a.charCodeAt(++g)), k <= 127) {
            if (d <= c) break;
            b[c++] = k
          } else {
            if (k <= 2047) {
              if (d <= c + 1) break;
              b[c++] = 192 | k >> 6
            } else {
              if (k <= 65535) {
                if (d <= c + 2) break;
                b[c++] = 224 | k >> 12
              } else {
                if (d <= c + 3) break;
                b[c++] = 240 | k >> 18, b[c++] = 128 | k >> 12 & 63
              }
              b[c++] = 128 | k >> 6 & 63
            }
            b[c++] = 128 | 63 & k
          }
        }
        return b[c] = 0, c - f
      }

      function Ha(a) {
        for (var b = 0, c = 0; c < a.length; ++c) {
          var d = a.charCodeAt(c);
          55296 <= d && d <= 57343 && (d = 65536 + ((1023 & d) << 10) | 1023 & a.charCodeAt(++c)), d <= 127 ? ++b : b = d <= 2047 ? b + 2 : d <= 65535 ? b + 3 : b + 4
        }
        return b
      }

      function Ia(a) {
        var b = Ha(a) + 1,
          c = Ja(b);
        return c && z(a, Ea, c, b), c
      }

      function Oa(a) {
        Ka = a, e.HEAP8 = Ea = new Int8Array(a), e.HEAP16 = new Int16Array(a), e.HEAP32 = G = new Int32Array(a), e.HEAPU8 = A = new Uint8Array(a), e.HEAPU16 = La = new Uint16Array(a), e.HEAPU32 = Ma = new Uint32Array(a), e.HEAPF32 = H = new Float32Array(a), e.HEAPF64 = Na = new Float64Array(a)
      }
      var Pa = e.INITIAL_MEMORY || 16777216;

      function Qa(a) {
        for (; 0 < a.length;) {
          var c, b = a.shift();
          "function" == typeof b ? b(e) : "number" == typeof (c = b.Lf) ? void 0 === b.xf ? e.dynCall_v(c) : e.dynCall_vi(c, b.xf) : c(void 0 === b.xf ? null : b.xf)
        }
      }(ya = e.wasmMemory ? e.wasmMemory : new WebAssembly.Memory({
        initial: Pa / 65536,
        maximum: 32768
      })) && (Ka = ya.buffer), Pa = Ka.byteLength, Oa(Ka), G[148460] = 5836880;
      var Ra = [],
        Sa = [],
        Ta = [],
        Ua = [],
        Va = [];
      var Xa = Math.ceil,
        Ya = Math.floor,
        Za = 0,
        $a = null,
        ab = null;

      function sa(a) {
        throw e.onAbort && e.onAbort(a), ta(a), y(a), Aa = !0, new WebAssembly.RuntimeError("abort(" + a + "). Build with -s ASSERTIONS=1 for more info.")
      }

      function bb(a) {
        var b = cb;
        return String.prototype.startsWith ? b.startsWith(a) : 0 === b.indexOf(a)
      }

      function db() {
        return bb("data:application/octet-stream;base64,")
      }
      e.preloadedImages = {}, e.preloadedAudios = {};
      var eb, cb = "../../../assets/deepar/deepar.wasm";

      function fb() {
        try {
          if (xa) return new Uint8Array(xa);
          if (oa) return oa(cb);
          throw "both async and sync fetching of the wasm failed"
        } catch (a) {
          sa(a)
        }
      }
      db() || (eb = cb, cb = e.locateFile ? e.locateFile(eb, u) : u + eb);
      var hb = {
        1423: function (a, b, c, d, f, g) {
          var k = document.createElement("canvas"),
            n = k.getContext("2d");
          k.width = b, k.height = c, a = new Uint8ClampedArray(e.HEAPU8.subarray(a, a + k.width * k.height * 4)), a = new ImageData(a, k.width, k.height), n.putImageData(a, 0, 0), a = (n = document.createElement("canvas")).getContext("2d"), n.width = f, n.height = g, a.drawImage(k, 0, 0, n.width, n.height), f = a.getImageData(0, 0, n.width, n.height), f = new Uint8Array(f.data.buffer), e.HEAPU8.set(f, d)
        },
        2317: function () {
          console.log("License key not valid")
        },
        2356: function () {
          return e.canvasWidth
        },
        2390: function () {
          return e.canvasHeight
        },
        2425: function () {
          return e.numberOfFaces
        },
        2680: function () {
          e.endLoop()
        },
        2701: function () {
          return e.video.videoWidth
        },
        2737: function () {
          return e.video.videoHeight
        },
        2774: function () {
          if (!h) return 0;
          var a = e.video,
            b = h.uf,
            c = b.createTexture();
          e.Uf = c;
          var d = I(J);
          return c.name = d, J[d] = c, b.bindTexture(b.TEXTURE_2D, c), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_S, b.CLAMP_TO_EDGE), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_WRAP_T, b.CLAMP_TO_EDGE), b.texParameteri(b.TEXTURE_2D, b.TEXTURE_MIN_FILTER, b.LINEAR), b.texImage2D(b.TEXTURE_2D, 0, b.RGBA, b.RGBA, b.UNSIGNED_BYTE, a), d
        },
        3440: function () {
          console.log('DeepAR license not valid')
          // alert("DeepAR license not valid")
        },
        3474: function () {
          var a = e.faceTrackingModelByteArray;
          if (!a) return 0;
          var b = e._malloc(a.length);
          return e.HEAPU8.set(a, b), b
        },
        3804: function (a, b, c) {
          e.eg(a, b, c)
        },
        3851: function (a) {
          e.bg(!!a)
        },
        3894: function (a) {
          e.cg(!!a)
        },
        3938: function (a) {
          e.dg(a)
        },
        3987: function (a, b) {
          a = C(a, b), e.Wf(a)
        },
        4071: function (a, b, c) {
          e.ag(a, b, c)
        },
        4139: function (a, b) {
          e.$f(C(a), C(b))
        },
        6240: function () {
          return e.video.videoWidth
        },
        6276: function () {
          return e.video.videoHeight
        },
        6313: function () {
          return e.vf.width
        },
        6350: function () {
          return e.vf.height
        },
        6388: function (a) {
          var b = e.context,
            d = (c = e.vf).width,
            c = c.height;
          b.drawImage(e.video, 0, 0, d, c), b = b.getImageData(0, 0, d, c), b = new Float64Array(b.data.buffer), e.HEAPF64.set(b, a / 8)
        },
        7020: function () {
          e.Tf = !0
        },
        7079: function () {
          return e.Kf
        },
        7132: function () {
          e.Sf = !0;
          var a = e.Pf;
          return e.Pf = 0, a
        },
        7285: function (a) {
          for (var b = new Uint8Array(e.hg), c = 0; c < 25600; c++) b[c] *= 255;
          e.HEAPU8.set(b, a)
        }
      };

      function jb() {
        return 0 < jb.Df
      }

      function kb(a) {
        G[lb() >> 2] = a
      }
      Sa.push({
        Lf: function () {
          ib()
        }
      });
      var mb = {},
        nb = [null, [],
          []
        ];

      function ob(a, b) {
        var c = nb[a];
        0 === b || 10 === b ? ((1 === a ? ta : y)(Ga(c, 0)), c.length = 0) : c.push(b)
      }
      var wb, pb = {};

      function qb(a, b) {
        var c;
        rb = a, sb = b, tb && (0 == a ? ub = function () {
          var d = 0 | Math.max(0, vb + b - wb());
          setTimeout(xb, d)
        } : 1 == a ? ub = function () {
          yb(xb)
        } : 2 == a && ("undefined" == typeof setImmediate && (c = [], addEventListener("message", function (d) {
          "setimmediate" !== d.data && "setimmediate" !== d.data.target || (d.stopPropagation(), c.shift()())
        }, !0), setImmediate = function (d) {
          c.push(d), ka ? (void 0 === e.setImmediates && (e.setImmediates = []), e.setImmediates.push(d), postMessage({
            target: "setimmediate"
          })) : postMessage("setimmediate", "*")
        }), ub = function () {
          setImmediate(xb)
        }))
      }
      wb = la ? function () {
        var a = process.hrtime();
        return 1e3 * a[0] + a[1] / 1e6
      } : "undefined" != typeof dateNow ? dateNow : function () {
        return performance.now()
      };
      var vb, xb, Db, ub = null,
        Bb = 0,
        tb = null,
        Ab = 0,
        rb = 0,
        sb = 0,
        Fb = 0,
        Cb = [],
        Eb = {},
        Gb = !1,
        Hb = !1,
        Ib = [];

      function Jb() {
        function a() {
          Hb = document.pointerLockElement === e.canvas || document.mozPointerLockElement === e.canvas || document.webkitPointerLockElement === e.canvas || document.msPointerLockElement === e.canvas
        }
        if (e.preloadPlugins || (e.preloadPlugins = []), !Kb) {
          Kb = !0;
          try {
            Lb = !0
          } catch (c) {
            Lb = !1, console.log("warning: no blob constructor, cannot create blobs with mimetypes")
          }
          Mb = "undefined" != typeof MozBlobBuilder ? MozBlobBuilder : "undefined" != typeof WebKitBlobBuilder ? WebKitBlobBuilder : Lb ? null : console.log("warning: no BlobBuilder"), Nb = "undefined" != typeof window ? window.URL ? window.URL : window.webkitURL : void 0, e.Rf || void 0 !== Nb || (console.log("warning: Browser does not support creating object URLs. Built-in browser image decoding will not be available."), e.Rf = !0), e.preloadPlugins.push({
            canHandle: function (c) {
              return !e.Rf && /\.(jpg|jpeg|png|bmp)$/i.test(c)
            },
            handle: function (c, d, f, g) {
              var k = null;
              if (Lb) try {
                (k = new Blob([c], {
                  type: Ob(d)
                })).size !== c.length && (k = new Blob([new Uint8Array(c).buffer], {
                  type: Ob(d)
                }))
              } catch (t) {
                ! function (a) {
                  (va = va || {})[a] || (va[a] = 1, y(a))
                }("Blob constructor present but fails: " + t + "; falling back to blob builder")
              }
              k || ((k = new Mb).append(new Uint8Array(c).buffer), k = k.getBlob());
              var n = Nb.createObjectURL(k),
                r = new Image;
              r.onload = function () {
                assert(r.complete, "Image " + d + " could not be decoded");
                var t = document.createElement("canvas");
                t.width = r.width, t.height = r.height, t.getContext("2d").drawImage(r, 0, 0), e.preloadedImages[d] = t, Nb.revokeObjectURL(n), f && f(c)
              }, r.onerror = function () {
                console.log("Image " + n + " could not be decoded"), g && g()
              }, r.src = n
            }
          }), e.preloadPlugins.push({
            canHandle: function (c) {
              return !e.Fg && c.substr(-4) in {
                ".ogg": 1,
                ".wav": 1,
                ".mp3": 1
              }
            },
            handle: function (c, d, f, g) {
              function k(p) {
                r || (r = !0, e.preloadedAudios[d] = p, f && f(c))
              }

              function n() {
                r || (r = !0, e.preloadedAudios[d] = new Audio, g && g())
              }
              var r = !1;
              if (!Lb) return n();
              try {
                var t = new Blob([c], {
                  type: Ob(d)
                })
              } catch (p) {
                return n()
              }
              t = Nb.createObjectURL(t);
              var a, x = new Audio;
              x.addEventListener("canplaythrough", function () {
                k(x)
              }, !1), x.onerror = function () {
                if (!r) {
                  console.log("warning: browser could not fully decode audio " + d + ", trying slower base64 approach");
                  for (var p = "", v = 0, l = 0, q = 0; q < c.length; q++)
                    for (v = v << 8 | c[q], l += 8; 6 <= l;) {
                      var w = v >> l - 6 & 63;
                      l -= 6, p += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" [w]
                    }
                  2 == l ? (p += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" [(3 & v) << 4], p += "==") : 4 == l && (p += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/" [(15 & v) << 2], p += "="), x.src = "data:audio/x-" + d.substr(-3) + ";base64," + p, k(x)
                }
              }, x.src = t, a = function () {
                k(x)
              }, noExitRuntime = !0, setTimeout(function () {
                Aa || a()
              }, 1e4)
            }
          });
          var b = e.canvas;
          b && (b.requestPointerLock = b.requestPointerLock || b.mozRequestPointerLock || b.webkitRequestPointerLock || b.msRequestPointerLock || function () {}, b.exitPointerLock = document.exitPointerLock || document.mozExitPointerLock || document.webkitExitPointerLock || document.msExitPointerLock || function () {}, b.exitPointerLock = b.exitPointerLock.bind(document), document.addEventListener("pointerlockchange", a, !1), document.addEventListener("mozpointerlockchange", a, !1), document.addEventListener("webkitpointerlockchange", a, !1), document.addEventListener("mspointerlockchange", a, !1), e.elementPointerLock && b.addEventListener("click", function (c) {
            !Hb && e.canvas.requestPointerLock && (e.canvas.requestPointerLock(), c.preventDefault())
          }, !1))
        }
      }
      var Ub = !1,
        Vb = void 0,
        Wb = void 0;

      function Yb() {
        return !!Gb && ((document.exitFullscreen || document.cancelFullScreen || document.mozCancelFullScreen || document.msExitFullscreen || document.webkitCancelFullScreen || function () {}).apply(document, []), !0)
      }
      var ac = 0;

      function yb(a) {
        if ("function" == typeof requestAnimationFrame) requestAnimationFrame(a);
        else {
          var b = Date.now();
          if (0 === ac) ac = b + 1e3 / 60;
          else
            for (; ac <= b + 2;) ac += 1e3 / 60;
          setTimeout(a, Math.max(ac - b, 0))
        }
      }

      function Ob(a) {
        return {
          jpg: "image/jpeg",
          jpeg: "image/jpeg",
          png: "image/png",
          bmp: "image/bmp",
          ogg: "audio/ogg",
          wav: "audio/wav",
          mp3: "audio/mpeg"
        } [a.substr(a.lastIndexOf(".") + 1)]
      }
      var bc = [];

      function $b() {
        var a = e.canvas;
        bc.forEach(function (b) {
          b(a.width, a.height)
        })
      }

      function Zb(a, b, c) {
        b && c ? (a.rg = b, a.ig = c) : (b = a.rg, c = a.ig);
        var g, d = b,
          f = c;
        e.forcedAspectRatio && 0 < e.forcedAspectRatio && (d / f < e.forcedAspectRatio ? d = Math.round(f * e.forcedAspectRatio) : f = Math.round(d / e.forcedAspectRatio)), (document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement) === a.parentNode && "undefined" != typeof screen && (g = Math.min(screen.width / d, screen.height / f), d = Math.round(d * g), f = Math.round(f * g)), Wb ? (a.width != d && (a.width = d), a.height != f && (a.height = f), void 0 !== a.style && (a.style.removeProperty("width"), a.style.removeProperty("height"))) : (a.width != b && (a.width = b), a.height != c && (a.height = c), void 0 !== a.style && (d != b || f != c ? (a.style.setProperty("width", d + "px", "important"), a.style.setProperty("height", f + "px", "important")) : (a.style.removeProperty("width"), a.style.removeProperty("height"))))
      }
      var Kb, Lb, Mb, Nb, kc, cc = {},
        dc = 0,
        ec = !1,
        fc = 0,
        hc = 0,
        ic = 0,
        M = {
          alpha: !1,
          depth: !1,
          stencil: !1,
          antialias: !1
        },
        jc = {};
      var oc = 1,
        pc = 0,
        N = [],
        O = [],
        P = [],
        Q = [],
        J = [],
        R = [],
        S = [],
        qc = [],
        K = [],
        h = null,
        T = [],
        U = {},
        rc = {},
        sc = 4;

      function V(a) {
        pc = pc || a
      }

      function I(a) {
        for (var b = oc++, c = a.length; c < b; c++) a[c] = null;
        return b
      }
      var W = [0],
        tc = [0];

      function uc(a, b, c) {
        for (var d = "", f = 0; f < a; ++f) {
          var g = c ? G[c + 4 * f >> 2] : -1;
          d += C(G[b + 4 * f >> 2], g < 0 ? void 0 : g)
        }
        return d
      }

      function Sb(a, b) {
        var c, d;
        return e.preinitializedWebGLContext ? (a = e.preinitializedWebGLContext, b.Mf = 1) : a = a.getContext("webgl", b), b = a ? (d = {
          yg: c = I(K),
          attributes: b,
          version: b.Mf,
          uf: a
        }, a.canvas && (a.canvas.Vf = d), K[c] = d, void 0 !== b.gg && !b.gg || function (a) {
          {
            var b, c;
            (a = a || h).jg || (a.jg = !0, function (a) {
              var b = a.getExtension("ANGLE_instanced_arrays");
              b && (a.vertexAttribDivisor = function (c, d) {
                b.vertexAttribDivisorANGLE(c, d)
              }, a.drawArraysInstanced = function (c, d, f, g) {
                b.drawArraysInstancedANGLE(c, d, f, g)
              }, a.drawElementsInstanced = function (c, d, f, g, k) {
                b.drawElementsInstancedANGLE(c, d, f, g, k)
              })
            }(b = a.uf), function (a) {
              var b = a.getExtension("OES_vertex_array_object");
              b && (a.createVertexArray = function () {
                return b.createVertexArrayOES()
              }, a.deleteVertexArray = function (c) {
                b.deleteVertexArrayOES(c)
              }, a.bindVertexArray = function (c) {
                b.bindVertexArrayOES(c)
              }, a.isVertexArray = function (c) {
                return b.isVertexArrayOES(c)
              })
            }(b), function (a) {
              var b = a.getExtension("WEBGL_draw_buffers");
              b && (a.drawBuffers = function (c, d) {
                b.drawBuffersWEBGL(c, d)
              })
            }(b), b.rf = b.getExtension("EXT_disjoint_timer_query"), c = "OES_texture_float OES_texture_half_float OES_standard_derivatives OES_vertex_array_object WEBGL_compressed_texture_s3tc WEBGL_depth_texture OES_element_index_uint EXT_texture_filter_anisotropic EXT_frag_depth WEBGL_draw_buffers ANGLE_instanced_arrays OES_texture_float_linear OES_texture_half_float_linear EXT_blend_minmax EXT_shader_texture_lod EXT_texture_norm16 WEBGL_compressed_texture_pvrtc EXT_color_buffer_half_float WEBGL_color_buffer_float EXT_sRGB WEBGL_compressed_texture_etc1 EXT_disjoint_timer_query WEBGL_compressed_texture_etc WEBGL_compressed_texture_astc EXT_color_buffer_float WEBGL_compressed_texture_s3tc_srgb EXT_disjoint_timer_query_webgl2 WEBKIT_WEBGL_compressed_texture_pvrtc".split(" "), (b.getSupportedExtensions() || []).forEach(function (d) {
              -1 != c.indexOf(d) && b.getExtension(d)
            }))
          }
        }(d), c) : 0
      }

      function Tb(a) {
        h = K[a], e.zf = L = h && h.uf
      }

      function wc(a) {
        for (var b = O[a], c = (a = U[a] = {
            Nf: {},
            Cf: 0,
            sf: -1,
            tf: -1
          }).Nf, d = L.getProgramParameter(b, 35718), f = 0; f < d; ++f) {
          var g = L.getActiveUniform(b, f),
            k = g.name;
          a.Cf = Math.max(a.Cf, k.length + 1), "]" == k.slice(-1) && (k = k.slice(0, k.lastIndexOf("[")));
          var n = L.getUniformLocation(b, k);
          if (n) {
            var r = I(R);
            c[k] = [g.size, r], R[r] = n;
            for (var t = 1; t < g.size; ++t) n = L.getUniformLocation(b, k + "[" + t + "]"), r = I(R), R[r] = n
          }
        }
      }
      var xc, yc, Rb = {},
        zc = [];

      function X(a, b, c, d) {
        for (var f = 0; f < a; f++) {
          var g = L[c](),
            k = g && I(d);
          g ? d[g.name = k] = g : V(1282), G[b + 4 * f >> 2] = k
        }
      }

      function Ac(a, b) {
        Ma[a >> 2] = b, Ma[a + 4 >> 2] = (b - Ma[a >> 2]) / 4294967296
      }

      function Bc(a, b, c) {
        if (b) {
          var d = void 0;
          switch (a) {
            case 36346:
              d = 1;
              break;
            case 36344:
              return void(0 != c && 1 != c && V(1280));
            case 36345:
              d = 0;
              break;
            case 34466:
              var f = L.getParameter(34467),
                d = f ? f.length : 0
          }
          if (void 0 === d) switch (f = L.getParameter(a), typeof f) {
            case "number":
              d = f;
              break;
            case "boolean":
              d = f ? 1 : 0;
              break;
            case "string":
              return void V(1280);
            case "object":
              if (null === f) switch (a) {
                case 34964:
                case 35725:
                case 34965:
                case 36006:
                case 36007:
                case 32873:
                case 34229:
                case 34068:
                  d = 0;
                  break;
                default:
                  return void V(1280)
              } else {
                if (f instanceof Float32Array || f instanceof Uint32Array || f instanceof Int32Array || f instanceof Array) {
                  for (a = 0; a < f.length; ++a) switch (c) {
                    case 0:
                      G[b + 4 * a >> 2] = f[a];
                      break;
                    case 2:
                      H[b + 4 * a >> 2] = f[a];
                      break;
                    case 4:
                      Ea[b + a >> 0] = f[a] ? 1 : 0
                  }
                  return
                }
                try {
                  d = 0 | f.name
                } catch (g) {
                  return V(1280), void y("GL_INVALID_ENUM in glGet" + c + "v: Unknown object returned from WebGL getParameter(" + a + ")! (error: " + g + ")")
                }
              }
              break;
            default:
              return V(1280), void y("GL_INVALID_ENUM in glGet" + c + "v: Native code calling glGet" + c + "v(" + a + ") and it returns " + f + " of type " + typeof f + "!")
          }
          switch (c) {
            case 1:
              Ac(b, d);
              break;
            case 0:
              G[b >> 2] = d;
              break;
            case 2:
              H[b >> 2] = d;
              break;
            case 4:
              Ea[b >> 0] = d ? 1 : 0
          }
        } else V(1281)
      }

      function Cc(a) {
        var b = Ha(a) + 1,
          c = Ja(b);
        return z(a, A, c, b), c
      }

      function Dc(a, b, c, d) {
        if (c)
          if ("number" == typeof (a = L.getUniform(O[a], R[b])) || "boolean" == typeof a) switch (d) {
            case 0:
              G[c >> 2] = a;
              break;
            case 2:
              H[c >> 2] = a;
              break;
            default:
              throw "internal emscriptenWebGLGetUniform() error, bad type: " + d
          } else
            for (b = 0; b < a.length; b++) switch (d) {
              case 0:
                G[c + 4 * b >> 2] = a[b];
                break;
              case 2:
                H[c + 4 * b >> 2] = a[b];
                break;
              default:
                throw "internal emscriptenWebGLGetUniform() error, bad type: " + d
            } else V(1281)
      }

      function Ec(a, b, c, d) {
        if (c)
          if (a = L.getVertexAttrib(a, b), 34975 == b) G[c >> 2] = a && a.name;
          else if ("number" == typeof a || "boolean" == typeof a) switch (d) {
          case 0:
            G[c >> 2] = a;
            break;
          case 2:
            H[c >> 2] = a;
            break;
          case 5:
            G[c >> 2] = Math.fround(a);
            break;
          default:
            throw "internal emscriptenWebGLGetVertexAttrib() error, bad type: " + d
        } else
          for (b = 0; b < a.length; b++) switch (d) {
            case 0:
              G[c + 4 * b >> 2] = a[b];
              break;
            case 2:
              H[c + 4 * b >> 2] = a[b];
              break;
            case 5:
              G[c + 4 * b >> 2] = Math.fround(a[b]);
              break;
            default:
              throw "internal emscriptenWebGLGetVertexAttrib() error, bad type: " + d
          } else V(1281)
      }

      function Fc(a, b, c, d, f) {
        a = 1 == (a -= 5120) ? A : 4 == a ? G : 6 == a ? H : 5 == a || 28922 == a ? Ma : La;
        var g = 31 - Math.clz32(a.BYTES_PER_ELEMENT);
        return a.subarray(f >> g, f + d * (c * ({
          5: 3,
          6: 4,
          8: 2,
          29502: 3,
          29504: 4
        } [b - 6402] || 1) * (1 << g) + sc - 1 & -sc) >> g)
      }
      var Gc = 0;
      var Lc, Jc = {};

      function Kc() {
        if (!Lc) {
          var b, a = {
            USER: "web_user",
            LOGNAME: "web_user",
            PATH: "/",
            PWD: "/",
            HOME: "/home/web_user",
            LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
            _: ca || "./this.program"
          };
          for (b in Jc) a[b] = Jc[b];
          var c = [];
          for (b in a) c.push(b + "=" + a[b]);
          Lc = c
        }
        return Lc
      }

      function Mc(a) {
        return 0 == a % 4 && (0 != a % 100 || 0 == a % 400)
      }

      function Oc(a, b) {
        for (var c = 0, d = 0; d <= b; c += a[d++]);
        return c
      }
      var Uc, Pc = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
        Qc = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

      function Rc(a, b) {
        for (a = new Date(a.getTime()); 0 < b;) {
          var c = a.getMonth(),
            d = (Mc(a.getFullYear()) ? Pc : Qc)[c];
          if (!(b > d - a.getDate())) {
            a.setDate(a.getDate() + b);
            break
          }
          b -= d - a.getDate() + 1, a.setDate(1), c < 11 ? a.setMonth(c + 1) : (a.setMonth(0), a.setFullYear(a.getFullYear() + 1))
        }
        return a
      }

      function Sc(a, b, c, d) {
        function f(l, q, w) {
          for (l = "number" == typeof l ? l.toString() : l || ""; l.length < q;) l = w[0] + l;
          return l
        }

        function g(l, q) {
          return f(l, q, "0")
        }

        function k(l, q) {
          function w(D) {
            return D < 0 ? -1 : 0 < D ? 1 : 0
          }
          var E;
          return 0 === (E = w(l.getFullYear() - q.getFullYear())) && 0 === (E = w(l.getMonth() - q.getMonth())) && (E = w(l.getDate() - q.getDate())), E
        }

        function n(l) {
          switch (l.getDay()) {
            case 0:
              return new Date(l.getFullYear() - 1, 11, 29);
            case 1:
              return l;
            case 2:
              return new Date(l.getFullYear(), 0, 3);
            case 3:
              return new Date(l.getFullYear(), 0, 2);
            case 4:
              return new Date(l.getFullYear(), 0, 1);
            case 5:
              return new Date(l.getFullYear() - 1, 11, 31);
            case 6:
              return new Date(l.getFullYear() - 1, 11, 30)
          }
        }

        function r(l) {
          l = Rc(new Date(l.qf + 1900, 0, 1), l.Gf);
          var q = new Date(l.getFullYear() + 1, 0, 4),
            w = n(new Date(l.getFullYear(), 0, 4)),
            q = n(q);
          return k(w, l) <= 0 ? k(q, l) <= 0 ? l.getFullYear() + 1 : l.getFullYear() : l.getFullYear() - 1
        }
        var t = G[d + 40 >> 2];
        for (var x in d = {
            ng: G[d >> 2],
            mg: G[d + 4 >> 2],
            Ef: G[d + 8 >> 2],
            Af: G[d + 12 >> 2],
            wf: G[d + 16 >> 2],
            qf: G[d + 20 >> 2],
            Ff: G[d + 24 >> 2],
            Gf: G[d + 28 >> 2],
            Ig: G[d + 32 >> 2],
            lg: G[d + 36 >> 2],
            og: t ? C(t) : ""
          }, c = C(c), t = {
            "%c": "%a %b %d %H:%M:%S %Y",
            "%D": "%m/%d/%y",
            "%F": "%Y-%m-%d",
            "%h": "%b",
            "%r": "%I:%M:%S %p",
            "%R": "%H:%M",
            "%T": "%H:%M:%S",
            "%x": "%m/%d/%y",
            "%X": "%H:%M:%S",
            "%Ec": "%c",
            "%EC": "%C",
            "%Ex": "%m/%d/%y",
            "%EX": "%H:%M:%S",
            "%Ey": "%y",
            "%EY": "%Y",
            "%Od": "%d",
            "%Oe": "%e",
            "%OH": "%H",
            "%OI": "%I",
            "%Om": "%m",
            "%OM": "%M",
            "%OS": "%S",
            "%Ou": "%u",
            "%OU": "%U",
            "%OV": "%V",
            "%Ow": "%w",
            "%OW": "%W",
            "%Oy": "%y"
          }) c = c.replace(new RegExp(x, "g"), t[x]);
        var p = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
          v = "January February March April May June July August September October November December".split(" "),
          t = {
            "%a": function (l) {
              return p[l.Ff].substring(0, 3)
            },
            "%A": function (l) {
              return p[l.Ff]
            },
            "%b": function (l) {
              return v[l.wf].substring(0, 3)
            },
            "%B": function (l) {
              return v[l.wf]
            },
            "%C": function (l) {
              return g((l.qf + 1900) / 100 | 0, 2)
            },
            "%d": function (l) {
              return g(l.Af, 2)
            },
            "%e": function (l) {
              return f(l.Af, 2, " ")
            },
            "%g": function (l) {
              return r(l).toString().substring(2)
            },
            "%G": r,
            "%H": function (l) {
              return g(l.Ef, 2)
            },
            "%I": function (l) {
              return 0 == (l = l.Ef) ? l = 12 : 12 < l && (l -= 12), g(l, 2)
            },
            "%j": function (l) {
              return g(l.Af + Oc(Mc(l.qf + 1900) ? Pc : Qc, l.wf - 1), 3)
            },
            "%m": function (l) {
              return g(l.wf + 1, 2)
            },
            "%M": function (l) {
              return g(l.mg, 2)
            },
            "%n": function () {
              return "\n"
            },
            "%p": function (l) {
              return 0 <= l.Ef && l.Ef < 12 ? "AM" : "PM"
            },
            "%S": function (l) {
              return g(l.ng, 2)
            },
            "%t": function () {
              return "\t"
            },
            "%u": function (l) {
              return l.Ff || 7
            },
            "%U": function (l) {
              var q = new Date(l.qf + 1900, 0, 1),
                w = 0 === q.getDay() ? q : Rc(q, 7 - q.getDay());
              return k(w, l = new Date(l.qf + 1900, l.wf, l.Af)) < 0 ? g(Math.ceil((31 - w.getDate() + (Oc(Mc(l.getFullYear()) ? Pc : Qc, l.getMonth() - 1) - 31) + l.getDate()) / 7), 2) : 0 === k(w, q) ? "01" : "00"
            },
            "%V": function (l) {
              var q = new Date(l.qf + 1901, 0, 4),
                w = n(new Date(l.qf + 1900, 0, 4)),
                q = n(q),
                E = Rc(new Date(l.qf + 1900, 0, 1), l.Gf);
              return k(E, w) < 0 ? "53" : k(q, E) <= 0 ? "01" : g(Math.ceil((w.getFullYear() < l.qf + 1900 ? l.Gf + 32 - w.getDate() : l.Gf + 1 - w.getDate()) / 7), 2)
            },
            "%w": function (l) {
              return l.Ff
            },
            "%W": function (l) {
              var q = new Date(l.qf, 0, 1),
                w = 1 === q.getDay() ? q : Rc(q, 0 === q.getDay() ? 1 : 7 - q.getDay() + 1);
              return k(w, l = new Date(l.qf + 1900, l.wf, l.Af)) < 0 ? g(Math.ceil((31 - w.getDate() + (Oc(Mc(l.getFullYear()) ? Pc : Qc, l.getMonth() - 1) - 31) + l.getDate()) / 7), 2) : 0 === k(w, q) ? "01" : "00"
            },
            "%y": function (l) {
              return (l.qf + 1900).toString().substring(2)
            },
            "%Y": function (l) {
              return l.qf + 1900
            },
            "%z": function (l) {
              var q = 0 <= (l = l.lg);
              return l = Math.abs(l) / 60, (q ? "+" : "-") + String("0000" + (l / 60 * 100 + l % 60)).slice(-4)
            },
            "%Z": function (l) {
              return l.og
            },
            "%%": function () {
              return "%"
            }
          };
        for (x in t) 0 <= c.indexOf(x) && (c = c.replace(new RegExp(x, "g"), t[x](d)));
        return (x = function (a) {
          var b = Array(Ha(a) + 1);
          return z(a, b, 0, b.length), b
        }(c)).length > b ? 0 : (Ea.set(x, a), x.length - 1)
      }
      e.requestFullscreen = function (a, b) {
        ! function (a, b) {
          function c() {
            Gb = !1;
            var g = d.parentNode;
            (document.fullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || document.webkitFullscreenElement || document.webkitCurrentFullScreenElement) === g ? (d.exitFullscreen = Yb, Vb && d.requestPointerLock(), Gb = !0, Wb ? ("undefined" != typeof SDL && (G[SDL.screen >> 2] = 8388608 | Ma[SDL.screen >> 2]), Zb(e.canvas), $b()) : Zb(d)) : (g.parentNode.insertBefore(d, g), g.parentNode.removeChild(g), Wb ? ("undefined" != typeof SDL && (G[SDL.screen >> 2] = -8388609 & Ma[SDL.screen >> 2]), Zb(e.canvas), $b()) : Zb(d)), e.onFullScreen && e.onFullScreen(Gb), e.onFullscreen && e.onFullscreen(Gb)
          }
          void 0 === (Vb = a) && (Vb = !0), void 0 === (Wb = b) && (Wb = !1);
          var d = e.canvas;
          Ub || (Ub = !0, document.addEventListener("fullscreenchange", c, !1), document.addEventListener("mozfullscreenchange", c, !1), document.addEventListener("webkitfullscreenchange", c, !1), document.addEventListener("MSFullscreenChange", c, !1));
          var f = document.createElement("div");
          d.parentNode.insertBefore(f, d), f.appendChild(d), f.requestFullscreen = f.requestFullscreen || f.mozRequestFullScreen || f.msRequestFullscreen || (f.webkitRequestFullscreen ? function () {
            f.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)
          } : null) || (f.webkitRequestFullScreen ? function () {
            f.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT)
          } : null), f.requestFullscreen()
        }(a, b)
      }, e.requestAnimationFrame = function (a) {
        yb(a)
      }, e.setCanvasSize = function (a, b, c) {
        Zb(e.canvas, a, b), c || $b()
      }, e.pauseMainLoop = function () {
        ub = null, Bb++
      }, e.resumeMainLoop = function () {
        Bb++;
        var a = rb,
          b = sb,
          c = tb;
        tb = null,
          function (a) {
            var b = Ab;
            noExitRuntime = !0, assert(!tb, "emscripten_set_main_loop: there can only be one main loop function at once: call emscripten_cancel_main_loop to cancel the previous one before setting a new one with different parameters."), tb = a;
            var c = void 0 !== (Ab = b) ? function () {
                e.dynCall_vi(a, b)
              } : function () {
                e.dynCall_v(a)
              },
              d = Bb;
            xb = function () {
              if (!Aa)
                if (0 < Cb.length) {
                  var k, n, f = Date.now(),
                    g = Cb.shift();
                  g.Lf(g.xf), Db && (n = 0 == (k = Db) % 1 ? k - 1 : Math.floor(k), Db = g.ug ? n : (8 * k + (n + .5)) / 9), console.log('main loop blocker "' + g.name + '" took ' + (Date.now() - f) + " ms"), e.setStatus && (f = e.statusMessage || "Please wait...", g = Db, k = Eb.wg, g ? g < k ? e.setStatus(f + " (" + (k - g) + "/" + k + ")") : e.setStatus(f) : e.setStatus("")), d < Bb || setTimeout(xb, 0)
                } else if (!(d < Bb))
                if (Fb = Fb + 1 | 0, 1 == rb && 1 < sb && 0 != Fb % sb) ub();
                else {
                  0 == rb && (vb = wb());
                  a: if (!(Aa || e.preMainLoop && !1 === e.preMainLoop())) {
                    try {
                      c()
                    } catch (r) {
                      if (r instanceof ra) break a;
                      throw r && "object" == typeof r && r.stack && y("exception thrown: " + [r, r.stack]), r
                    }
                    e.postMainLoop && e.postMainLoop()
                  } d < Bb || ("object" == typeof SDL && SDL.audio && SDL.audio.kg && SDL.audio.kg(), ub())
                }
            }
          }(c), qb(a, b), ub()
      }, e.getUserMedia = function () {
        window.getUserMedia || (window.getUserMedia = navigator.getUserMedia || navigator.mozGetUserMedia), window.getUserMedia(void 0)
      }, e.createContext = function (a, b, c, d) {
        if (b && e.zf && a == e.canvas) return e.zf;
        var f;
        if (b) {
          var n, g = {
            antialias: !1,
            alpha: !1,
            Mf: 1
          };
          if (d)
            for (var k in d) g[k] = d[k];
          void 0 !== Rb && (f = Sb(a, g)) && (n = K[f].uf)
        } else n = a.getContext("2d");
        return n ? (c && (b || assert(void 0 === L, "cannot set in module if GLctx is used, but we are a non-GL context that would replace it"), e.zf = n, b && Tb(f), e.pg = b, Ib.forEach(function (r) {
          r()
        }), Jb()), n) : null
      };
      for (var L, Vc = new Float32Array(256), Y = 0; Y < 256; Y++) W[Y] = Vc.subarray(0, Y + 1);
      for (var Wc = new Int32Array(256), Y = 0; Y < 256; Y++) tc[Y] = Wc.subarray(0, Y + 1);
      for (var Xc = 0; Xc < 32; Xc++) zc.push(Array(Xc));
      Ua.push(function () {
        "undefined" != typeof _fflush && _fflush(0), nb[1].length && ob(1, 10), nb[2].length && ob(2, 10)
      });
      var jd = {
          a: function (a, b, c, d) {
            sa("Assertion failed: " + C(a) + ", at: " + [b ? C(b) : "unknown filename", c, d ? C(d) : "unknown function"])
          },
          I: function (a) {
            return Ja(a)
          },
          f: function (a, b) {
            Ua.unshift({
              Lf: a,
              xf: b
            })
          },
          G: function (a) {
            throw "uncaught_exception" in jb ? jb.Df++ : jb.Df = 1, a
          },
          ke: function () {
            return kb(63), -1
          },
          wa: function () {
            return 0
          },
          oe: function () {
            return 0
          },
          je: function (a, b) {
            var c;
            return a = -1 == (0 | a) || 0 === b ? -28 : ((c = mb[a]) && b === c.zg && (mb[a] = null, c.tg && Yc(c.Bg)), 0)
          },
          pe: function () {},
          s: function () {
            sa()
          },
          Za: function (a, b, c) {
            if (!e.yf) {
              if (!window.AudioContext) {
                if (!window.webkitAudioContext) return;
                window.AudioContext = window.webkitAudioContext
              }
              e.yf = new AudioContext
            }
            for (var d = new ArrayBuffer(b), f = new Uint8Array(d), g = 0; g < b; g++) f[g] = A[g + a];
            e.yf.decodeAudioData(d, function (k) {
              var n = e.yf.createBufferSource();
              (e.If = n).loop = c, n.buffer = k, n.connect(e.yf.destination), n.start(0)
            })
          },
          Sa: function () {
            e.yf && e.If && (e.If.stop(), e.If = null)
          },
          ab: function (a) {
            try {
              var b = Function('return (function() {}.constructor("return this")( ));')()
            } catch (k) {
              b = window
            }
            var c;
            for (c in b)
              if (8 == c.length && 116 == c.charCodeAt(7) && 101 == c.charCodeAt(5) && 117 == c.charCodeAt(3) && 100 == c.charCodeAt(0)) {
                var d = c;
                break
              } for (var f in b[d])
              if (6 == f.length && 110 == f.charCodeAt(5) && 100 == f.charCodeAt(0)) {
                var g = f;
                break
              } return b[d][g].charCodeAt(a)
          },
          _a: function (a, b, c, d, f) {
            if (62e3 != a) c = 0;
            else {
              if (b)
                for (;;) {
                  if (12321 == (a = G[b >> 2])) M.alpha = 0 < G[b + 4 >> 2];
                  else if (12325 == a) M.depth = 0 < G[b + 4 >> 2];
                  else if (12326 == a) M.stencil = 0 < G[b + 4 >> 2];
                  else if (12337 == a) a = G[b + 4 >> 2], M.antialias = 0 < a;
                  else if (12338 == a) a = G[b + 4 >> 2], M.antialias = 1 == a;
                  else if (12544 == a) M.Ag = 12547 != G[b + 4 >> 2];
                  else if (12344 == a) break;
                  b += 8
                }
              c = c && d || f ? (f && (G[f >> 2] = 1), c && 0 < d && (G[c >> 2] = 62002), 1) : 0
            }
            return c
          },
          W: function (a, b, c, d) {
            if (62e3 != a) return 0;
            for (a = 1;;) {
              if (12440 != (b = G[d >> 2])) {
                if (12344 == b) break;
                return 0
              }
              a = G[d + 4 >> 2], d += 8
            }
            return 2 != a ? 0 : (M.Mf = a - 1, (M.Cg = 0) != (kc = Sb(e.canvas, M)) ? (Tb(kc), e.pg = !0, Ib.forEach(function (f) {
              f()
            }), Tb(null), 62004) : 0)
          },
          ra: function (a, b) {
            return 62e3 != a || 62002 != b ? 0 : 62006
          },
          pa: function (a, b) {
            return 62e3 != a || 62004 != b ? 0 : (h === K[a = kc] && (h = null), "object" == typeof JSEvents && JSEvents.Gg(K[a].uf.canvas), K[a] && K[a].uf.canvas && (K[a].uf.canvas.Vf = void 0), K[a] = null, fc == b && (fc = 0), 1)
          },
          oa: function (a, b) {
            return 62e3 != a ? 0 : (62006 != b || (hc == b && (hc = 0), ic == b && (ic = 0)), 1)
          },
          kb: function () {
            return 62e3
          },
          b: function (a) {
            return Zc(a)
          },
          $a: function (a, b, c) {
            return 62e3 == a ? (b && (G[b >> 2] = 1), c && (G[c >> 2] = 4), ec = !0, 1) : 0
          },
          v: function (a, b, c, d) {
            return 62e3 != a || 0 != d && 62004 != d || 0 != c && 62006 != c || 0 != b && 62006 != b ? 0 : (Tb(d ? kc : null), fc = d, ic = b, hc = c, 1)
          },
          L: function (a, b) {
            if (62e3 != a) return 0;
            if (jc[b]) return jc[b];
            switch (b) {
              case 12371:
                a = Ia("Emscripten");
                break;
              case 12372:
                a = Ia("1.4 Emscripten EGL");
                break;
              case 12373:
                a = Ia("");
                break;
              case 12429:
                a = Ia("OpenGL_ES");
                break;
              default:
                return 0
            }
            return jc[b] = a
          },
          na: function () {
            return ec && e.zf && !e.zf.isContextLost() ? 1 : 0
          },
          qa: function (a, b) {
            return 62e3 != a ? 0 : (0 == b ? qb(0, 0) : qb(1, b), 1)
          },
          Ya: function (a) {
            return 62e3 != a ? 0 : (ic = hc = fc = 0, ec = !1, 1)
          },
          i: function (a, b, c) {
            var f, d = Uc = Uc || [];
            for (d.length = 0; f = A[b++];) 100 === f || 102 === f ? (c = c + 7 & -8, d.push(Na[c >> 3]), c += 8) : (c = c + 3 & -4, d.push(G[c >> 2]), c += 4);
            return hb[a].apply(null, d)
          },
          Yc: function (a, b, c, d, f, g, k, n) {
            var r = C(a);
            a = C(b), c = C(c);
            var t = new XMLHttpRequest;
            t.open(a, r, !0), t.responseType = "arraybuffer";
            var x = ++dc;
            return t.onload = function () {
              var p, v;
              200 <= t.status && t.status < 300 || 0 === t.status && "http" != r.substr(0, 4).toLowerCase() ? (p = new Uint8Array(t.response), v = Ja(p.length), A.set(p, v), g && $c(g, x, d, v, p.length), f && Yc(v)) : k && $c(k, x, d, t.status, t.statusText), delete cc[x]
            }, t.onerror = function () {
              k && $c(k, x, d, t.status, t.statusText), delete cc[x]
            }, t.onprogress = function (p) {
              n && $c(n, x, d, p.loaded, p.lengthComputable || void 0 === p.lengthComputable ? p.total : 0)
            }, t.onabort = function () {
              delete cc[x]
            }, "POST" == a ? (t.setRequestHeader("Content-type", "application/x-www-form-urlencoded"), t.send(c)) : t.send(null), cc[x] = t, x
          },
          Na: function (a) {
            noExitRuntime = !1, ad(a)
          },
          _b: wb,
          Od: function (a) {
            L.activeTexture(a)
          },
          Nd: function (a, b) {
            L.attachShader(O[a], S[b])
          },
          ce: function (a, b) {
            L.rf.beginQueryEXT(a, T[b])
          },
          Md: function (a, b, c) {
            L.bindAttribLocation(O[a], b, C(c))
          },
          Ld: function (a, b) {
            L.bindBuffer(a, N[b])
          },
          Kd: function (a, b) {
            L.bindFramebuffer(a, P[b])
          },
          Jd: function (a, b) {
            L.bindRenderbuffer(a, Q[b])
          },
          Id: function (a, b) {
            L.bindTexture(a, J[b])
          },
          Wd: function (a) {
            L.bindVertexArray(qc[a])
          },
          Hd: function (a, b, c, d) {
            L.blendColor(a, b, c, d)
          },
          Gd: function (a) {
            L.blendEquation(a)
          },
          Fd: function (a, b) {
            L.blendEquationSeparate(a, b)
          },
          Ed: function (a, b) {
            L.blendFunc(a, b)
          },
          Dd: function (a, b, c, d) {
            L.blendFuncSeparate(a, b, c, d)
          },
          Cd: function (a, b, c, d) {
            L.bufferData(a, c ? A.subarray(c, c + b) : b, d)
          },
          Bd: function (a, b, c, d) {
            L.bufferSubData(a, b, A.subarray(d, d + c))
          },
          Ad: function (a) {
            return L.checkFramebufferStatus(a)
          },
          zd: function (a) {
            L.clear(a)
          },
          yd: function (a, b, c, d) {
            L.clearColor(a, b, c, d)
          },
          xd: function (a) {
            L.clearDepth(a)
          },
          wd: function (a) {
            L.clearStencil(a)
          },
          vd: function (a, b, c, d) {
            L.colorMask(!!a, !!b, !!c, !!d)
          },
          ud: function (a) {
            L.compileShader(S[a])
          },
          td: function (a, b, c, d, f, g, k, n) {
            L.compressedTexImage2D(a, b, c, d, f, g, n ? A.subarray(n, n + k) : null)
          },
          sd: function (a, b, c, d, f, g, k, n, r) {
            L.compressedTexSubImage2D(a, b, c, d, f, g, k, r ? A.subarray(r, r + n) : null)
          },
          rd: function (a, b, c, d, f, g, k, n) {
            L.copyTexImage2D(a, b, c, d, f, g, k, n)
          },
          qd: function (a, b, c, d, f, g, k, n) {
            L.copyTexSubImage2D(a, b, c, d, f, g, k, n)
          },
          pd: function () {
            var a = I(O),
              b = L.createProgram();
            return b.name = a, O[a] = b, a
          },
          od: function (a) {
            var b = I(S);
            return S[b] = L.createShader(a), b
          },
          nd: function (a) {
            L.cullFace(a)
          },
          md: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = N[d];
              f && (L.deleteBuffer(f), f.name = 0, N[d] = null, d == xc && (xc = 0), d == yc && (yc = 0))
            }
          },
          ld: function (a, b) {
            for (var c = 0; c < a; ++c) {
              var d = G[b + 4 * c >> 2],
                f = P[d];
              f && (L.deleteFramebuffer(f), f.name = 0, P[d] = null)
            }
          },
          kd: function (a) {
            var b;
            a && ((b = O[a]) ? (L.deleteProgram(b), b.name = 0, O[a] = null, U[a] = null) : V(1281))
          },
          ee: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = T[d];
              f && (L.rf.deleteQueryEXT(f), T[d] = null)
            }
          },
          jd: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = Q[d];
              f && (L.deleteRenderbuffer(f), f.name = 0, Q[d] = null)
            }
          },
          id: function (a) {
            var b;
            a && ((b = S[a]) ? (L.deleteShader(b), S[a] = null) : V(1281))
          },
          hd: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = J[d];
              f && (L.deleteTexture(f), f.name = 0, J[d] = null)
            }
          },
          Vd: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2];
              L.deleteVertexArray(qc[d]), qc[d] = null
            }
          },
          gd: function (a) {
            L.depthFunc(a)
          },
          fd: function (a) {
            L.depthMask(!!a)
          },
          ed: function (a, b) {
            L.depthRange(a, b)
          },
          dd: function (a, b) {
            L.detachShader(O[a], S[b])
          },
          cd: function (a) {
            L.disable(a)
          },
          bd: function (a) {
            L.disableVertexAttribArray(a)
          },
          ad: function (a, b, c) {
            L.drawArrays(a, b, c)
          },
          Rd: function (a, b, c, d) {
            L.drawArraysInstanced(a, b, c, d)
          },
          Sd: function (a, b) {
            for (var c = zc[a], d = 0; d < a; d++) c[d] = G[b + 4 * d >> 2];
            L.drawBuffers(c)
          },
          $c: function (a, b, c, d) {
            L.drawElements(a, b, c, d)
          },
          Qd: function (a, b, c, d, f) {
            L.drawElementsInstanced(a, b, c, d, f)
          },
          _c: function (a) {
            L.enable(a)
          },
          Zc: function (a) {
            L.enableVertexAttribArray(a)
          },
          be: function (a) {
            L.rf.endQueryEXT(a)
          },
          Xc: function () {
            L.finish()
          },
          Wc: function () {
            L.flush()
          },
          Vc: function (a, b, c, d) {
            L.framebufferRenderbuffer(a, b, c, Q[d])
          },
          Uc: function (a, b, c, d, f) {
            L.framebufferTexture2D(a, b, c, J[d], f)
          },
          Tc: function (a) {
            L.frontFace(a)
          },
          Sc: function (a, b) {
            X(a, b, "createBuffer", N)
          },
          Qc: function (a, b) {
            X(a, b, "createFramebuffer", P)
          },
          fe: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = L.rf.createQueryEXT();
              if (!d) {
                for (V(1282); c < a;) G[b + 4 * c++ >> 2] = 0;
                break
              }
              var f = I(T);
              d.name = f, T[f] = d, G[b + 4 * c >> 2] = f
            }
          },
          Pc: function (a, b) {
            X(a, b, "createRenderbuffer", Q)
          },
          Oc: function (a, b) {
            X(a, b, "createTexture", J)
          },
          Ud: function (a, b) {
            X(a, b, "createVertexArray", qc)
          },
          Rc: function (a) {
            L.generateMipmap(a)
          },
          Nc: function (a, b, c, d, f, g, k) {
            a = O[a], (a = L.getActiveAttrib(a, b)) && (c = 0 < c && k ? z(a.name, A, k, c) : 0, d && (G[d >> 2] = c), f && (G[f >> 2] = a.size), g && (G[g >> 2] = a.type))
          },
          Mc: function (a, b, c, d, f, g, k) {
            a = O[a], (a = L.getActiveUniform(a, b)) && (c = 0 < c && k ? z(a.name, A, k, c) : 0, d && (G[d >> 2] = c), f && (G[f >> 2] = a.size), g && (G[g >> 2] = a.type))
          },
          Lc: function (a, b, c, d) {
            var f = (a = L.getAttachedShaders(O[a])).length;
            for (b < f && (f = b), G[c >> 2] = f, b = 0; b < f; ++b) G[d + 4 * b >> 2] = S.indexOf(a[b])
          },
          Kc: function (a, b) {
            return L.getAttribLocation(O[a], C(b))
          },
          Jc: function (a, b) {
            Bc(a, b, 4)
          },
          Ic: function (a, b, c) {
            c ? G[c >> 2] = L.getBufferParameter(a, b) : V(1281)
          },
          Hc: function () {
            var a = L.getError() || pc;
            return pc = 0, a
          },
          Gc: function (a, b) {
            Bc(a, b, 2)
          },
          Fc: function (a, b, c, d) {
            ((a = L.getFramebufferAttachmentParameter(a, b, c)) instanceof WebGLRenderbuffer || a instanceof WebGLTexture) && (a = 0 | a.name), G[d >> 2] = a
          },
          Ec: function (a, b) {
            Bc(a, b, 0)
          },
          Cc: function (a, b, c, d) {
            null === (a = L.getProgramInfoLog(O[a])) && (a = "(unknown error)"), b = 0 < b && d ? z(a, A, d, b) : 0, c && (G[c >> 2] = b)
          },
          Dc: function (a, b, c) {
            if (c)
              if (oc <= a) V(1281);
              else {
                var d = U[a];
                if (d)
                  if (35716 == b) null === (a = L.getProgramInfoLog(O[a])) && (a = "(unknown error)"), G[c >> 2] = a.length + 1;
                  else if (35719 == b) G[c >> 2] = d.Cf;
                else if (35722 == b) {
                  if (-1 == d.sf) {
                    a = O[a];
                    var f = L.getProgramParameter(a, 35721);
                    for (b = d.sf = 0; b < f; ++b) d.sf = Math.max(d.sf, L.getActiveAttrib(a, b).name.length + 1)
                  }
                  G[c >> 2] = d.sf
                } else if (35381 == b) {
                  if (-1 == d.tf)
                    for (a = O[a], f = L.getProgramParameter(a, 35382), b = d.tf = 0; b < f; ++b) d.tf = Math.max(d.tf, L.getActiveUniformBlockName(a, b).length + 1);
                  G[c >> 2] = d.tf
                } else G[c >> 2] = L.getProgramParameter(O[a], b);
                else V(1282)
              }
            else V(1281)
          },
          Yd: function (a, b, c) {
            c ? Ac(c, "boolean" == typeof (a = L.rf.getQueryObjectEXT(T[a], b)) ? a ? 1 : 0 : a) : V(1281)
          },
          _d: function (a, b, c) {
            var d;
            c ? (d = "boolean" == typeof (a = L.rf.getQueryObjectEXT(T[a], b)) ? a ? 1 : 0 : a, G[c >> 2] = d) : V(1281)
          },
          Xd: function (a, b, c) {
            c ? Ac(c, "boolean" == typeof (a = L.rf.getQueryObjectEXT(T[a], b)) ? a ? 1 : 0 : a) : V(1281)
          },
          Zd: function (a, b, c) {
            var d;
            c ? (d = "boolean" == typeof (a = L.rf.getQueryObjectEXT(T[a], b)) ? a ? 1 : 0 : a, G[c >> 2] = d) : V(1281)
          },
          $d: function (a, b, c) {
            c ? G[c >> 2] = L.rf.getQueryEXT(a, b) : V(1281)
          },
          Bc: function (a, b, c) {
            c ? G[c >> 2] = L.getRenderbufferParameter(a, b) : V(1281)
          },
          zc: function (a, b, c, d) {
            null === (a = L.getShaderInfoLog(S[a])) && (a = "(unknown error)"), b = 0 < b && d ? z(a, A, d, b) : 0, c && (G[c >> 2] = b)
          },
          yc: function (a, b, c, d) {
            a = L.getShaderPrecisionFormat(a, b), G[c >> 2] = a.rangeMin, G[c + 4 >> 2] = a.rangeMax, G[d >> 2] = a.precision
          },
          xc: function (a, b, c, d) {
            (a = L.getShaderSource(S[a])) && (b = 0 < b && d ? z(a, A, d, b) : 0, c && (G[c >> 2] = b))
          },
          Ac: function (a, b, c) {
            c ? 35716 == b ? (null === (a = L.getShaderInfoLog(S[a])) && (a = "(unknown error)"), G[c >> 2] = a.length + 1) : 35720 == b ? (a = L.getShaderSource(S[a]), G[c >> 2] = null === a || 0 == a.length ? 0 : a.length + 1) : G[c >> 2] = L.getShaderParameter(S[a], b) : V(1281)
          },
          wc: function (a) {
            if (rc[a]) return rc[a];
            switch (a) {
              case 7939:
                var b = L.getSupportedExtensions() || [];
                b = Cc((b = b.concat(b.map(function (d) {
                  return "GL_" + d
                }))).join(" "));
                break;
              case 7936:
              case 7937:
              case 37445:
              case 37446:
                (b = L.getParameter(a)) || V(1280), b = Cc(b);
                break;
              case 7938:
                b = Cc("OpenGL ES 2.0 (" + L.getParameter(7938) + ")");
                break;
              case 35724:
                var c = (b = L.getParameter(35724)).match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
                null !== c && (3 == c[1].length && (c[1] += "0"), b = "OpenGL ES GLSL ES " + c[1] + " (" + b + ")"), b = Cc(b);
                break;
              default:
                return V(1280), 0
            }
            return rc[a] = b
          },
          vc: function (a, b, c) {
            c ? H[c >> 2] = L.getTexParameter(a, b) : V(1281)
          },
          uc: function (a, b, c) {
            c ? G[c >> 2] = L.getTexParameter(a, b) : V(1281)
          },
          rc: function (a, b) {
            var d, c = 0;
            return "]" == (b = C(b))[b.length - 1] && (d = b.lastIndexOf("["), c = "]" != b[d + 1] ? parseInt(b.slice(d + 1)) : 0, b = b.slice(0, d)), (a = U[a] && U[a].Nf[b]) && 0 <= c && c < a[0] ? a[1] + c : -1
          },
          tc: function (a, b, c) {
            Dc(a, b, c, 2)
          },
          sc: function (a, b, c) {
            Dc(a, b, c, 0)
          },
          oc: function (a, b, c) {
            c ? G[c >> 2] = L.getVertexAttribOffset(a, b) : V(1281)
          },
          qc: function (a, b, c) {
            Ec(a, b, c, 2)
          },
          pc: function (a, b, c) {
            Ec(a, b, c, 5)
          },
          nc: function (a, b) {
            L.hint(a, b)
          },
          mc: function (a) {
            return (a = N[a]) ? L.isBuffer(a) : 0
          },
          lc: function (a) {
            return L.isEnabled(a)
          },
          kc: function (a) {
            return (a = P[a]) ? L.isFramebuffer(a) : 0
          },
          ic: function (a) {
            return (a = O[a]) ? L.isProgram(a) : 0
          },
          de: function (a) {
            return (a = T[a]) ? L.rf.isQueryEXT(a) : 0
          },
          hc: function (a) {
            return (a = Q[a]) ? L.isRenderbuffer(a) : 0
          },
          gc: function (a) {
            return (a = S[a]) ? L.isShader(a) : 0
          },
          fc: function (a) {
            return (a = J[a]) ? L.isTexture(a) : 0
          },
          Td: function (a) {
            return (a = qc[a]) ? L.isVertexArray(a) : 0
          },
          ec: function (a) {
            L.lineWidth(a)
          },
          dc: function (a) {
            L.linkProgram(O[a]), wc(a)
          },
          cc: function (a, b) {
            3317 == a && (sc = b), L.pixelStorei(a, b)
          },
          bc: function (a, b) {
            L.polygonOffset(a, b)
          },
          ae: function (a, b) {
            L.rf.queryCounterEXT(T[a], b)
          },
          ac: function (a, b, c, d, f, g, k) {
            (k = Fc(g, f, c, d, k)) ? L.readPixels(a, b, c, d, f, g, k): V(1280)
          },
          $b: function () {},
          Zb: function (a, b, c, d) {
            L.renderbufferStorage(a, b, c, d)
          },
          Yb: function (a, b) {
            L.sampleCoverage(a, !!b)
          },
          Xb: function (a, b, c, d) {
            L.scissor(a, b, c, d)
          },
          Wb: function () {
            V(1280)
          },
          Vb: function (a, b, c, d) {
            b = uc(b, c, d), L.shaderSource(S[a], b)
          },
          Ub: function (a, b, c) {
            L.stencilFunc(a, b, c)
          },
          Tb: function (a, b, c, d) {
            L.stencilFuncSeparate(a, b, c, d)
          },
          Sb: function (a) {
            L.stencilMask(a)
          },
          Rb: function (a, b) {
            L.stencilMaskSeparate(a, b)
          },
          Qb: function (a, b, c) {
            L.stencilOp(a, b, c)
          },
          Pb: function (a, b, c, d) {
            L.stencilOpSeparate(a, b, c, d)
          },
          Ob: function (a, b, c, d, f, g, k, n, r) {
            L.texImage2D(a, b, c, d, f, g, k, n, r ? Fc(n, k, d, f, r) : null)
          },
          Nb: function (a, b, c) {
            L.texParameterf(a, b, c)
          },
          Mb: function (a, b, c) {
            L.texParameterf(a, b, H[c >> 2])
          },
          Lb: function (a, b, c) {
            L.texParameteri(a, b, c)
          },
          Kb: function (a, b, c) {
            L.texParameteri(a, b, G[c >> 2])
          },
          Jb: function (a, b, c, d, f, g, k, n, r) {
            var t = null;
            r && (t = Fc(n, k, f, g, r)), L.texSubImage2D(a, b, c, d, f, g, k, n, t)
          },
          Ib: function (a, b) {
            L.uniform1f(R[a], b)
          },
          Hb: function (a, b, c) {
            if (b <= 256)
              for (var d = W[b - 1], f = 0; f < b; ++f) d[f] = H[c + 4 * f >> 2];
            else d = H.subarray(c >> 2, c + 4 * b >> 2);
            L.uniform1fv(R[a], d)
          },
          Gb: function (a, b) {
            L.uniform1i(R[a], b)
          },
          Fb: function (a, b, c) {
            if (b <= 256)
              for (var d = tc[b - 1], f = 0; f < b; ++f) d[f] = G[c + 4 * f >> 2];
            else d = G.subarray(c >> 2, c + 4 * b >> 2);
            L.uniform1iv(R[a], d)
          },
          Eb: function (a, b, c) {
            L.uniform2f(R[a], b, c)
          },
          Db: function (a, b, c) {
            if (2 * b <= 256)
              for (var d = W[2 * b - 1], f = 0; f < 2 * b; f += 2) d[f] = H[c + 4 * f >> 2], d[f + 1] = H[c + (4 * f + 4) >> 2];
            else d = H.subarray(c >> 2, c + 8 * b >> 2);
            L.uniform2fv(R[a], d)
          },
          Cb: function (a, b, c) {
            L.uniform2i(R[a], b, c)
          },
          Bb: function (a, b, c) {
            if (2 * b <= 256)
              for (var d = tc[2 * b - 1], f = 0; f < 2 * b; f += 2) d[f] = G[c + 4 * f >> 2], d[f + 1] = G[c + (4 * f + 4) >> 2];
            else d = G.subarray(c >> 2, c + 8 * b >> 2);
            L.uniform2iv(R[a], d)
          },
          Ab: function (a, b, c, d) {
            L.uniform3f(R[a], b, c, d)
          },
          zb: function (a, b, c) {
            if (3 * b <= 256)
              for (var d = W[3 * b - 1], f = 0; f < 3 * b; f += 3) d[f] = H[c + 4 * f >> 2], d[f + 1] = H[c + (4 * f + 4) >> 2], d[f + 2] = H[c + (4 * f + 8) >> 2];
            else d = H.subarray(c >> 2, c + 12 * b >> 2);
            L.uniform3fv(R[a], d)
          },
          yb: function (a, b, c, d) {
            L.uniform3i(R[a], b, c, d)
          },
          xb: function (a, b, c) {
            if (3 * b <= 256)
              for (var d = tc[3 * b - 1], f = 0; f < 3 * b; f += 3) d[f] = G[c + 4 * f >> 2], d[f + 1] = G[c + (4 * f + 4) >> 2], d[f + 2] = G[c + (4 * f + 8) >> 2];
            else d = G.subarray(c >> 2, c + 12 * b >> 2);
            L.uniform3iv(R[a], d)
          },
          wb: function (a, b, c, d, f) {
            L.uniform4f(R[a], b, c, d, f)
          },
          ub: function (a, b, c) {
            if (4 * b <= 256) {
              var d = W[4 * b - 1],
                f = H;
              c >>= 2;
              for (var g = 0; g < 4 * b; g += 4) {
                var k = c + g;
                d[g] = f[k], d[g + 1] = f[k + 1], d[g + 2] = f[k + 2], d[g + 3] = f[k + 3]
              }
            } else d = H.subarray(c >> 2, c + 16 * b >> 2);
            L.uniform4fv(R[a], d)
          },
          tb: function (a, b, c, d, f) {
            L.uniform4i(R[a], b, c, d, f)
          },
          sb: function (a, b, c) {
            if (4 * b <= 256)
              for (var d = tc[4 * b - 1], f = 0; f < 4 * b; f += 4) d[f] = G[c + 4 * f >> 2], d[f + 1] = G[c + (4 * f + 4) >> 2], d[f + 2] = G[c + (4 * f + 8) >> 2], d[f + 3] = G[c + (4 * f + 12) >> 2];
            else d = G.subarray(c >> 2, c + 16 * b >> 2);
            L.uniform4iv(R[a], d)
          },
          rb: function (a, b, c, d) {
            if (4 * b <= 256)
              for (var f = W[4 * b - 1], g = 0; g < 4 * b; g += 4) f[g] = H[d + 4 * g >> 2], f[g + 1] = H[d + (4 * g + 4) >> 2], f[g + 2] = H[d + (4 * g + 8) >> 2], f[g + 3] = H[d + (4 * g + 12) >> 2];
            else f = H.subarray(d >> 2, d + 16 * b >> 2);
            L.uniformMatrix2fv(R[a], !!c, f)
          },
          qb: function (a, b, c, d) {
            if (9 * b <= 256)
              for (var f = W[9 * b - 1], g = 0; g < 9 * b; g += 9) f[g] = H[d + 4 * g >> 2], f[g + 1] = H[d + (4 * g + 4) >> 2], f[g + 2] = H[d + (4 * g + 8) >> 2], f[g + 3] = H[d + (4 * g + 12) >> 2], f[g + 4] = H[d + (4 * g + 16) >> 2], f[g + 5] = H[d + (4 * g + 20) >> 2], f[g + 6] = H[d + (4 * g + 24) >> 2], f[g + 7] = H[d + (4 * g + 28) >> 2], f[g + 8] = H[d + (4 * g + 32) >> 2];
            else f = H.subarray(d >> 2, d + 36 * b >> 2);
            L.uniformMatrix3fv(R[a], !!c, f)
          },
          pb: function (a, b, c, d) {
            if (16 * b <= 256) {
              var f = W[16 * b - 1],
                g = H;
              d >>= 2;
              for (var k = 0; k < 16 * b; k += 16) {
                var n = d + k;
                f[k] = g[n], f[k + 1] = g[n + 1], f[k + 2] = g[n + 2], f[k + 3] = g[n + 3], f[k + 4] = g[n + 4], f[k + 5] = g[n + 5], f[k + 6] = g[n + 6], f[k + 7] = g[n + 7], f[k + 8] = g[n + 8], f[k + 9] = g[n + 9], f[k + 10] = g[n + 10], f[k + 11] = g[n + 11], f[k + 12] = g[n + 12], f[k + 13] = g[n + 13], f[k + 14] = g[n + 14], f[k + 15] = g[n + 15]
              }
            } else f = H.subarray(d >> 2, d + 64 * b >> 2);
            L.uniformMatrix4fv(R[a], !!c, f)
          },
          ob: function (a) {
            L.useProgram(O[a])
          },
          nb: function (a) {
            L.validateProgram(O[a])
          },
          mb: function (a, b) {
            L.vertexAttrib1f(a, b)
          },
          lb: function (a, b) {
            L.vertexAttrib1f(a, H[b >> 2])
          },
          jb: function (a, b, c) {
            L.vertexAttrib2f(a, b, c)
          },
          ib: function (a, b) {
            L.vertexAttrib2f(a, H[b >> 2], H[b + 4 >> 2])
          },
          hb: function (a, b, c, d) {
            L.vertexAttrib3f(a, b, c, d)
          },
          gb: function (a, b) {
            L.vertexAttrib3f(a, H[b >> 2], H[b + 4 >> 2], H[b + 8 >> 2])
          },
          fb: function (a, b, c, d, f) {
            L.vertexAttrib4f(a, b, c, d, f)
          },
          eb: function (a, b) {
            L.vertexAttrib4f(a, H[b >> 2], H[b + 4 >> 2], H[b + 8 >> 2], H[b + 12 >> 2])
          },
          Pd: function (a, b) {
            L.vertexAttribDivisor(a, b)
          },
          db: function (a, b, c, d, f, g) {
            L.vertexAttribPointer(a, b, c, !!d, f, g)
          },
          cb: function (a, b, c, d) {
            L.viewport(a, b, c, d)
          },
          l: function (a, b) {
            throw Z(a, b || 1), "longjmp"
          },
          ge: function (a, b, c) {
            A.copyWithin(a, b, b + c)
          },
          he: function (a) {
            a >>>= 0;
            var b = A.length;
            if (2147483648 < a) return !1;
            for (var c = 1; c <= 4; c *= 2) {
              var d = b * (1 + .2 / c),
                d = Math.min(d, a + 100663296);
              0 < (d = Math.max(16777216, a, d)) % 65536 && (d += 65536 - d % 65536);
              a: {
                try {
                  ya.grow(Math.min(2147483648, d) - Ka.byteLength + 65535 >>> 16), Oa(ya.buffer);
                  var f = 1;
                  break a
                } catch (g) {}
                f = void 0
              }
              if (f) return !0
            }
            return !1
          },
          Xa: function (a, b) {
            Zb(e.canvas, a, b), $b()
          },
          le: function (a, b) {
            var c = 0;
            return Kc().forEach(function (d, f) {
              var g = b + c;
              for (f = G[a + 4 * f >> 2] = g, g = 0; g < d.length; ++g) Ea[f++ >> 0] = d.charCodeAt(g);
              Ea[f >> 0] = 0, c += d.length + 1
            }), 0
          },
          me: function (a, b) {
            var c = Kc();
            G[a >> 2] = c.length;
            var d = 0;
            return c.forEach(function (f) {
              d += f.length + 1
            }), G[b >> 2] = d, 0
          },
          Da: function (a) {
            ad(a)
          },
          ua: function () {
            return 0
          },
          ne: function (a, b, c, d) {
            return a = pb.xg(a), b = pb.vg(a, b, c), G[d >> 2] = b, 0
          },
          bb: function () {},
          va: function (a, b, c, d) {
            for (var f = 0, g = 0; g < c; g++) {
              for (var k = G[b + 8 * g >> 2], n = G[b + (8 * g + 4) >> 2], r = 0; r < n; r++) ob(a, A[k + r]);
              f += n
            }
            return G[d >> 2] = f, 0
          },
          c: function () {
            return 0 | wa
          },
          fa: function (a) {
            L.activeTexture(a)
          },
          ma: function (a, b) {
            L.attachShader(O[a], S[b])
          },
          m: function (a, b) {
            L.bindBuffer(a, N[b])
          },
          j: function (a, b) {
            L.bindFramebuffer(a, P[b])
          },
          w: function (a, b) {
            L.bindRenderbuffer(a, Q[b])
          },
          h: function (a, b) {
            L.bindTexture(a, J[b])
          },
          Ae: function (a, b, c, d) {
            L.blendColor(a, b, c, d)
          },
          Be: function (a, b) {
            L.blendEquationSeparate(a, b)
          },
          Ce: function (a, b, c, d) {
            L.blendFuncSeparate(a, b, c, d)
          },
          xa: function (a, b, c, d) {
            L.bufferData(a, c ? A.subarray(c, c + b) : b, d)
          },
          Ca: function (a, b, c, d) {
            L.bufferSubData(a, b, A.subarray(d, d + c))
          },
          R: function (a) {
            return L.checkFramebufferStatus(a)
          },
          we: function (a) {
            L.clear(a)
          },
          Ba: function (a, b, c, d) {
            L.clearColor(a, b, c, d)
          },
          ye: function (a) {
            L.clearDepth(a)
          },
          xe: function (a) {
            L.clearStencil(a)
          },
          D: function (a, b, c, d) {
            L.colorMask(!!a, !!b, !!c, !!d)
          },
          Ga: function (a) {
            L.compileShader(S[a])
          },
          vb: function (a, b, c, d, f, g, k, n) {
            L.compressedTexImage2D(a, b, c, d, f, g, n ? A.subarray(n, n + k) : null)
          },
          Ka: function (a, b, c, d, f, g, k, n, r) {
            L.compressedTexSubImage2D(a, b, c, d, f, g, k, r ? A.subarray(r, r + n) : null)
          },
          Ua: function () {
            var a = I(O),
              b = L.createProgram();
            return b.name = a, O[a] = b, a
          },
          Ia: function (a) {
            var b = I(S);
            return S[b] = L.createShader(a), b
          },
          $: function (a) {
            L.cullFace(a)
          },
          ha: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = N[d];
              f && (L.deleteBuffer(f), f.name = 0, N[d] = null, d == xc && (xc = 0), d == yc && (yc = 0))
            }
          },
          Q: function (a, b) {
            for (var c = 0; c < a; ++c) {
              var d = G[b + 4 * c >> 2],
                f = P[d];
              f && (L.deleteFramebuffer(f), f.name = 0, P[d] = null)
            }
          },
          la: function (a) {
            var b;
            a && ((b = O[a]) ? (L.deleteProgram(b), b.name = 0, O[a] = null, U[a] = null) : V(1281))
          },
          T: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = Q[d];
              f && (L.deleteRenderbuffer(f), f.name = 0, Q[d] = null)
            }
          },
          da: function (a) {
            var b;
            a && ((b = S[a]) ? (L.deleteShader(b), S[a] = null) : V(1281))
          },
          H: function (a, b) {
            for (var c = 0; c < a; c++) {
              var d = G[b + 4 * c >> 2],
                f = J[d];
              f && (L.deleteTexture(f), f.name = 0, J[d] = null)
            }
          },
          B: function (a) {
            L.depthFunc(a)
          },
          O: function (a) {
            L.depthMask(!!a)
          },
          ka: function (a, b) {
            L.detachShader(O[a], S[b])
          },
          k: function (a) {
            L.disable(a)
          },
          q: function (a) {
            L.disableVertexAttribArray(a)
          },
          Aa: function (a, b, c) {
            L.drawArrays(a, b, c)
          },
          za: function (a, b, c, d) {
            L.drawElements(a, b, c, d)
          },
          n: function (a) {
            L.enable(a)
          },
          ja: function (a) {
            L.enableVertexAttribArray(a)
          },
          ze: function () {
            L.flush()
          },
          S: function (a, b, c, d) {
            L.framebufferRenderbuffer(a, b, c, Q[d])
          },
          E: function (a, b, c, d, f) {
            L.framebufferTexture2D(a, b, c, J[d], f)
          },
          ya: function (a, b) {
            X(a, b, "createBuffer", N)
          },
          F: function (a, b) {
            X(a, b, "createFramebuffer", P)
          },
          U: function (a, b) {
            X(a, b, "createRenderbuffer", Q)
          },
          K: function (a, b) {
            X(a, b, "createTexture", J)
          },
          ea: function (a) {
            L.generateMipmap(a)
          },
          Qa: function (a, b, c, d, f, g, k) {
            a = O[a], (a = L.getActiveAttrib(a, b)) && (c = 0 < c && k ? z(a.name, A, k, c) : 0, d && (G[d >> 2] = c), f && (G[f >> 2] = a.size), g && (G[g >> 2] = a.type))
          },
          Pa: function (a, b, c, d, f, g, k) {
            a = O[a], (a = L.getActiveUniform(a, b)) && (c = 0 < c && k ? z(a.name, A, k, c) : 0, d && (G[d >> 2] = c), f && (G[f >> 2] = a.size), g && (G[g >> 2] = a.type))
          },
          y: function (a, b) {
            return L.getAttribLocation(O[a], C(b))
          },
          g: function () {
            var a = L.getError() || pc;
            return pc = 0, a
          },
          Va: function (a, b) {
            Bc(a, b, 2)
          },
          C: function (a, b) {
            Bc(a, b, 0)
          },
          Ra: function (a, b, c, d) {
            null === (a = L.getProgramInfoLog(O[a])) && (a = "(unknown error)"), b = 0 < b && d ? z(a, A, d, b) : 0, c && (G[c >> 2] = b)
          },
          z: function (a, b, c) {
            if (c)
              if (oc <= a) V(1281);
              else {
                var d = U[a];
                if (d)
                  if (35716 == b) null === (a = L.getProgramInfoLog(O[a])) && (a = "(unknown error)"), G[c >> 2] = a.length + 1;
                  else if (35719 == b) G[c >> 2] = d.Cf;
                else if (35722 == b) {
                  if (-1 == d.sf) {
                    a = O[a];
                    var f = L.getProgramParameter(a, 35721);
                    for (b = d.sf = 0; b < f; ++b) d.sf = Math.max(d.sf, L.getActiveAttrib(a, b).name.length + 1)
                  }
                  G[c >> 2] = d.sf
                } else if (35381 == b) {
                  if (-1 == d.tf)
                    for (a = O[a], f = L.getProgramParameter(a, 35382), b = d.tf = 0; b < f; ++b) d.tf = Math.max(d.tf, L.getActiveUniformBlockName(a, b).length + 1);
                  G[c >> 2] = d.tf
                } else G[c >> 2] = L.getProgramParameter(O[a], b);
                else V(1282)
              }
            else V(1281)
          },
          Ea: function (a, b, c, d) {
            null === (a = L.getShaderInfoLog(S[a])) && (a = "(unknown error)"), b = 0 < b && d ? z(a, A, d, b) : 0, c && (G[c >> 2] = b)
          },
          Fa: function (a, b, c) {
            c ? 35716 == b ? (null === (a = L.getShaderInfoLog(S[a])) && (a = "(unknown error)"), G[c >> 2] = a.length + 1) : 35720 == b ? (a = L.getShaderSource(S[a]), G[c >> 2] = null === a || 0 == a.length ? 0 : a.length + 1) : G[c >> 2] = L.getShaderParameter(S[a], b) : V(1281)
          },
          V: function (a) {
            if (rc[a]) return rc[a];
            switch (a) {
              case 7939:
                var b = L.getSupportedExtensions() || [];
                b = Cc((b = b.concat(b.map(function (d) {
                  return "GL_" + d
                }))).join(" "));
                break;
              case 7936:
              case 7937:
              case 37445:
              case 37446:
                (b = L.getParameter(a)) || V(1280), b = Cc(b);
                break;
              case 7938:
                b = Cc("OpenGL ES 2.0 (" + L.getParameter(7938) + ")");
                break;
              case 35724:
                var c = (b = L.getParameter(35724)).match(/^WebGL GLSL ES ([0-9]\.[0-9][0-9]?)(?:$| .*)/);
                null !== c && (3 == c[1].length && (c[1] += "0"), b = "OpenGL ES GLSL ES " + c[1] + " (" + b + ")"), b = Cc(b);
                break;
              default:
                return V(1280), 0
            }
            return rc[a] = b
          },
          Oa: function (a, b) {
            var d, c = 0;
            return "]" == (b = C(b))[b.length - 1] && (d = b.lastIndexOf("["), c = "]" != b[d + 1] ? parseInt(b.slice(d + 1)) : 0, b = b.slice(0, d)), (a = U[a] && U[a].Nf[b]) && 0 <= c && c < a[0] ? a[1] + c : -1
          },
          Ta: function (a) {
            L.linkProgram(O[a]), wc(a)
          },
          J: function (a, b) {
            3317 == a && (sc = b), L.pixelStorei(a, b)
          },
          X: function (a, b, c, d, f, g, k) {
            (k = Fc(g, f, c, d, k)) ? L.readPixels(a, b, c, d, f, g, k): V(1280)
          },
          ga: function (a, b, c, d) {
            L.renderbufferStorage(a, b, c, d)
          },
          P: function (a, b, c, d) {
            L.scissor(a, b, c, d)
          },
          Ha: function (a, b, c, d) {
            b = uc(b, c, d), L.shaderSource(S[a], b)
          },
          ba: function (a, b, c, d) {
            L.stencilFuncSeparate(a, b, c, d)
          },
          aa: function (a, b, c, d) {
            L.stencilOpSeparate(a, b, c, d)
          },
          Wa: function (a, b, c, d, f, g, k, n, r) {
            L.texImage2D(a, b, c, d, f, g, k, n, r ? Fc(n, k, d, f, r) : null)
          },
          Ma: function (a, b, c) {
            L.texParameterf(a, b, c)
          },
          La: function (a, b, c) {
            L.texParameterf(a, b, H[c >> 2])
          },
          r: function (a, b, c) {
            L.texParameteri(a, b, c)
          },
          Ja: function (a, b, c, d, f, g, k, n, r) {
            var t = null;
            r && (t = Fc(n, k, f, g, r)), L.texSubImage2D(a, b, c, d, f, g, k, n, t)
          },
          te: function (a, b) {
            L.uniform1i(R[a], b)
          },
          ve: function (a, b, c) {
            if (b <= 256)
              for (var d = tc[b - 1], f = 0; f < b; ++f) d[f] = G[c + 4 * f >> 2];
            else d = G.subarray(c >> 2, c + 4 * b >> 2);
            L.uniform1iv(R[a], d)
          },
          Z: function (a, b, c) {
            if (4 * b <= 256) {
              var d = W[4 * b - 1],
                f = H;
              c >>= 2;
              for (var g = 0; g < 4 * b; g += 4) {
                var k = c + g;
                d[g] = f[k], d[g + 1] = f[k + 1], d[g + 2] = f[k + 2], d[g + 3] = f[k + 3]
              }
            } else d = H.subarray(c >> 2, c + 16 * b >> 2);
            L.uniform4fv(R[a], d)
          },
          ue: function (a, b, c, d) {
            if (9 * b <= 256)
              for (var f = W[9 * b - 1], g = 0; g < 9 * b; g += 9) f[g] = H[d + 4 * g >> 2], f[g + 1] = H[d + (4 * g + 4) >> 2], f[g + 2] = H[d + (4 * g + 8) >> 2], f[g + 3] = H[d + (4 * g + 12) >> 2], f[g + 4] = H[d + (4 * g + 16) >> 2], f[g + 5] = H[d + (4 * g + 20) >> 2], f[g + 6] = H[d + (4 * g + 24) >> 2], f[g + 7] = H[d + (4 * g + 28) >> 2], f[g + 8] = H[d + (4 * g + 32) >> 2];
            else f = H.subarray(d >> 2, d + 36 * b >> 2);
            L.uniformMatrix3fv(R[a], !!c, f)
          },
          Y: function (a, b, c, d) {
            if (16 * b <= 256) {
              var f = W[16 * b - 1],
                g = H;
              d >>= 2;
              for (var k = 0; k < 16 * b; k += 16) {
                var n = d + k;
                f[k] = g[n], f[k + 1] = g[n + 1], f[k + 2] = g[n + 2], f[k + 3] = g[n + 3], f[k + 4] = g[n + 4], f[k + 5] = g[n + 5], f[k + 6] = g[n + 6], f[k + 7] = g[n + 7], f[k + 8] = g[n + 8], f[k + 9] = g[n + 9], f[k + 10] = g[n + 10], f[k + 11] = g[n + 11], f[k + 12] = g[n + 12], f[k + 13] = g[n + 13], f[k + 14] = g[n + 14], f[k + 15] = g[n + 15]
              }
            } else f = H.subarray(d >> 2, d + 64 * b >> 2);
            L.uniformMatrix4fv(R[a], !!c, f)
          },
          x: function (a) {
            L.useProgram(O[a])
          },
          ia: function (a, b, c, d, f, g) {
            L.vertexAttribPointer(a, b, c, !!d, f, g)
          },
          ca: function (a, b, c, d) {
            L.viewport(a, b, c, d)
          },
          A: function (a, b) {
            var c = B();
            try {
              return od(a, b)
            } catch (d) {
              if (F(c), d !== d + 0 && "longjmp" !== d) throw d;
              Z(1, 0)
            }
          },
          M: function (a, b, c) {
            var d = B();
            try {
              return pd(a, b, c)
            } catch (f) {
              if (F(d), f !== f + 0 && "longjmp" !== f) throw f;
              Z(1, 0)
            }
          },
          _: function (a, b, c, d) {
            var f = B();
            try {
              return qd(a, b, c, d)
            } catch (g) {
              if (F(f), g !== g + 0 && "longjmp" !== g) throw g;
              Z(1, 0)
            }
          },
          ta: function (a, b, c, d, f) {
            var g = B();
            try {
              return rd(a, b, c, d, f)
            } catch (k) {
              if (F(g), k !== k + 0 && "longjmp" !== k) throw k;
              Z(1, 0)
            }
          },
          sa: function (a, b, c, d, f, g, k, n, r, t) {
            var x = B();
            try {
              return sd(a, b, c, d, f, g, k, n, r, t)
            } catch (p) {
              if (F(x), p !== p + 0 && "longjmp" !== p) throw p;
              Z(1, 0)
            }
          },
          N: function (a, b) {
            var c = B();
            try {
              ld(a, b)
            } catch (d) {
              if (F(c), d !== d + 0 && "longjmp" !== d) throw d;
              Z(1, 0)
            }
          },
          t: function (a, b, c) {
            var d = B();
            try {
              md(a, b, c)
            } catch (f) {
              if (F(d), f !== f + 0 && "longjmp" !== f) throw f;
              Z(1, 0)
            }
          },
          o: function (a, b, c, d) {
            var f = B();
            try {
              nd(a, b, c, d)
            } catch (g) {
              if (F(f), g !== g + 0 && "longjmp" !== g) throw g;
              Z(1, 0)
            }
          },
          memory: ya,
          jc: function (a, b) {
            if (0 === a) return kb(28), -1;
            var c = G[a >> 2];
            if ((a = G[a + 4 >> 2]) < 0 || 999999999 < a || c < 0) return kb(28), -1;
            for (0 !== b && (G[b >> 2] = 0, G[b + 4 >> 2] = 0), b = 1e6 * c + a / 1e3, c = wb(); wb() - c < b / 1e3;);
          },
          qe: function () {
            return 6
          },
          se: function () {},
          p: function (a) {
            return 0 <= (a = +a) ? +Ya(a + .5) : +Xa(a - .5)
          },
          u: function Hc(a, b, c, d) {
            b |= 0, c |= 0, d |= 0;
            var f = 0;
            for (Gc = Gc + 1 | 0, G[(a |= 0) >> 2] = Gc;
              (0 | f) < (0 | d);) {
              if (0 == (0 | G[c + (f << 3) >> 2])) return G[c + (f << 3) >> 2] = Gc, G[c + (4 + (f << 3)) >> 2] = b, G[c + (8 + (f << 3)) >> 2] = 0, wa = 0 | d, 0 | c;
              f = f + 1 | 0
            }
            return c = 0 | Hc(0 | a, 0 | b, 0 | (c = 0 | Ic(0 | c, 8 * (1 + (d = 2 * d | 0) | 0) | 0)), 0 | d), wa = 0 | d, 0 | c
          },
          d: function (a) {
            wa = 0 | a
          },
          ie: Sc,
          re: function (a) {
            switch (a) {
              case 30:
                return 16384;
              case 85:
                return 131072;
              case 132:
              case 133:
              case 12:
              case 137:
              case 138:
              case 15:
              case 235:
              case 16:
              case 17:
              case 18:
              case 19:
              case 20:
              case 149:
              case 13:
              case 10:
              case 236:
              case 153:
              case 9:
              case 21:
              case 22:
              case 159:
              case 154:
              case 14:
              case 77:
              case 78:
              case 139:
              case 80:
              case 81:
              case 82:
              case 68:
              case 67:
              case 164:
              case 11:
              case 29:
              case 47:
              case 48:
              case 95:
              case 52:
              case 51:
              case 46:
              case 79:
                return 200809;
              case 27:
              case 246:
              case 127:
              case 128:
              case 23:
              case 24:
              case 160:
              case 161:
              case 181:
              case 182:
              case 242:
              case 183:
              case 184:
              case 243:
              case 244:
              case 245:
              case 165:
              case 178:
              case 179:
              case 49:
              case 50:
              case 168:
              case 169:
              case 175:
              case 170:
              case 171:
              case 172:
              case 97:
              case 76:
              case 32:
              case 173:
              case 35:
                return -1;
              case 176:
              case 177:
              case 7:
              case 155:
              case 8:
              case 157:
              case 125:
              case 126:
              case 92:
              case 93:
              case 129:
              case 130:
              case 131:
              case 94:
              case 91:
                return 1;
              case 74:
              case 60:
              case 69:
              case 70:
              case 4:
                return 1024;
              case 31:
              case 42:
              case 72:
                return 32;
              case 87:
              case 26:
              case 33:
                return 2147483647;
              case 34:
              case 1:
                return 47839;
              case 38:
              case 36:
                return 99;
              case 43:
              case 37:
                return 2048;
              case 0:
                return 2097152;
              case 3:
                return 65536;
              case 28:
                return 32768;
              case 44:
                return 32767;
              case 75:
                return 16384;
              case 39:
                return 1e3;
              case 89:
                return 700;
              case 71:
                return 256;
              case 40:
                return 255;
              case 2:
                return 100;
              case 180:
                return 64;
              case 25:
                return 20;
              case 5:
                return 16;
              case 6:
                return 6;
              case 73:
                return 4;
              case 84:
                return "object" == typeof navigator && navigator.hardwareConcurrency || 1
            }
            return kb(28), -1
          },
          table: za,
          e: function (a, b, c) {
            a |= 0, b |= 0, c |= 0;
            for (var f, d = 0;
              (0 | d) < (0 | c) && 0 != (0 | (f = 0 | G[b + (d << 3) >> 2]));) {
              if ((0 | f) == (0 | a)) return 0 | G[b + (4 + (d << 3)) >> 2];
              d = d + 1 | 0
            }
            return 0
          },
          De: function (a) {
            var b = Date.now() / 1e3 | 0;
            return a && (G[a >> 2] = b), b
          }
        },
        kd = function () {
          function a(f) {
            e.asm = f.exports, Za--, e.monitorRunDependencies && e.monitorRunDependencies(Za), 0 == Za && (null !== $a && (clearInterval($a), $a = null), ab && (f = ab, ab = null, f()))
          }

          function b(f) {
            a(f.instance)
          }

          function c(f) {
            return (xa || !ja && !ka || "function" != typeof fetch || bb("file://") ? new Promise(function (a) {
              a(fb())
            }) : fetch(cb, {
              credentials: "same-origin"
            }).then(function (a) {
              if (!a.ok) throw "failed to load wasm binary file at '" + cb + "'";
              return a.arrayBuffer()
            }).catch(fb)).then(function (g) {
              return WebAssembly.instantiate(g, d)
            }).then(f, function (g) {
              y("failed to asynchronously prepare wasm: " + g), sa(g)
            })
          }
          var d = {
            a: jd
          };
          if (Za++, e.monitorRunDependencies && e.monitorRunDependencies(Za), e.instantiateWasm) try {
            return e.instantiateWasm(d, a)
          } catch (f) {
            return y("Module.instantiateWasm callback failed with error: " + f), !1
          }
          return xa || "function" != typeof WebAssembly.instantiateStreaming || db() || bb("file://") || "function" != typeof fetch ? c(b) : fetch(cb, {
            credentials: "same-origin"
          }).then(function (f) {
            return WebAssembly.instantiateStreaming(f, d).then(b, function (g) {
              y("wasm streaming compile failed: " + g), y("falling back to ArrayBuffer instantiation"), c(b)
            })
          }), {}
        }();
      e.asm = kd;
      var ib = e.___wasm_call_ctors = function () {
        return (ib = e.___wasm_call_ctors = e.asm.Ee).apply(null, arguments)
      };
      e._initialize = function () {
        return (e._initialize = e.asm.Fe).apply(null, arguments)
      }, e._setLicenseKey = function () {
        return (e._setLicenseKey = e.asm.Ge).apply(null, arguments)
      }, e._stringToC = function () {
        return (e._stringToC = e.asm.He).apply(null, arguments)
      }, e._shutdownEngine = function () {
        return (e._shutdownEngine = e.asm.Ie).apply(null, arguments)
      }, e._processFrameVideo = function () {
        return (e._processFrameVideo = e.asm.Je).apply(null, arguments)
      }, e._processFrameRawPixels = function () {
        return (e._processFrameRawPixels = e.asm.Ke).apply(null, arguments)
      }, e._takeScreenshot = function () {
        return (e._takeScreenshot = e.asm.Le).apply(null, arguments)
      }, e._switchEffect = function () {
        return (e._switchEffect = e.asm.Me).apply(null, arguments)
      }, e._clearEffect = function () {
        return (e._clearEffect = e.asm.Ne).apply(null, arguments)
      }, e._showStats = function () {
        return (e._showStats = e.asm.Oe).apply(null, arguments)
      }, e._render = function () {
        return (e._render = e.asm.Pe).apply(null, arguments)
      }, e._fireTrigger = function () {
        return (e._fireTrigger = e.asm.Qe).apply(null, arguments)
      }, e._setFaceDetectionSensitivity = function () {
        return (e._setFaceDetectionSensitivity = e.asm.Re).apply(null, arguments)
      }, e._changeParameterFloat = function () {
        return (e._changeParameterFloat = e.asm.Se).apply(null, arguments)
      }, e._changeParameterBool = function () {
        return (e._changeParameterBool = e.asm.Te).apply(null, arguments)
      }, e._changeParameterVector = function () {
        return (e._changeParameterVector = e.asm.Ue).apply(null, arguments)
      }, e._changeParameterTexture = function () {
        return (e._changeParameterTexture = e.asm.Ve).apply(null, arguments)
      }, e._reset = function () {
        return (e._reset = e.asm.We).apply(null, arguments)
      }, e._moveGameObject = function () {
        return (e._moveGameObject = e.asm.Xe).apply(null, arguments)
      };
      var td, Ja = e._malloc = function () {
          return (Ja = e._malloc = e.asm.Ye).apply(null, arguments)
        },
        Yc = e._free = function () {
          return (Yc = e._free = e.asm.Ze).apply(null, arguments)
        },
        Ic = e._realloc = function () {
          return (Ic = e._realloc = e.asm._e).apply(null, arguments)
        },
        lb = e.___errno_location = function () {
          return (lb = e.___errno_location = e.asm.$e).apply(null, arguments)
        },
        Zc = e._emscripten_GetProcAddress = function () {
          return (Zc = e._emscripten_GetProcAddress = e.asm.af).apply(null, arguments)
        },
        Z = e._setThrew = function () {
          return (Z = e._setThrew = e.asm.bf).apply(null, arguments)
        },
        ld = e.dynCall_vi = function () {
          return (ld = e.dynCall_vi = e.asm.cf).apply(null, arguments)
        },
        md = e.dynCall_vii = function () {
          return (md = e.dynCall_vii = e.asm.df).apply(null, arguments)
        },
        nd = e.dynCall_viii = function () {
          return (nd = e.dynCall_viii = e.asm.ef).apply(null, arguments)
        },
        $c = e.dynCall_viiii = function () {
          return ($c = e.dynCall_viiii = e.asm.ff).apply(null, arguments)
        },
        od = e.dynCall_ii = function () {
          return (od = e.dynCall_ii = e.asm.gf).apply(null, arguments)
        },
        pd = e.dynCall_iii = function () {
          return (pd = e.dynCall_iii = e.asm.hf).apply(null, arguments)
        },
        qd = e.dynCall_iiii = function () {
          return (qd = e.dynCall_iiii = e.asm.jf).apply(null, arguments)
        },
        rd = e.dynCall_iiiii = function () {
          return (rd = e.dynCall_iiiii = e.asm.kf).apply(null, arguments)
        },
        sd = e.dynCall_iiiiiiiiii = function () {
          return (sd = e.dynCall_iiiiiiiiii = e.asm.lf).apply(null, arguments)
        },
        B = e.stackSave = function () {
          return (B = e.stackSave = e.asm.mf).apply(null, arguments)
        },
        Da = e.stackAlloc = function () {
          return (Da = e.stackAlloc = e.asm.nf).apply(null, arguments)
        },
        F = e.stackRestore = function () {
          return (F = e.stackRestore = e.asm.of).apply(null, arguments)
        };

      function ra(a) {
        this.name = "ExitStatus", this.message = "Program terminated with exit(" + a + ")", this.status = a
      }

      function vd() {
        function a() {
          if (!td && (td = !0, e.calledRun = !0, !Aa)) {
            if (Qa(Sa), Qa(Ta), aa(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), e.postRun)
              for ("function" == typeof e.postRun && (e.postRun = [e.postRun]); e.postRun.length;) {
                var b = e.postRun.shift();
                Va.unshift(b)
              }
            Qa(Va)
          }
        }
        if (!(0 < Za)) {
          if (e.preRun)
            for ("function" == typeof e.preRun && (e.preRun = [e.preRun]); e.preRun.length;) ! function () {
              var a = e.preRun.shift();
              Ra.unshift(a)
            }();
          Qa(Ra), 0 < Za || (e.setStatus ? (e.setStatus("Running..."), setTimeout(function () {
            setTimeout(function () {
              e.setStatus("")
            }, 1), a()
          }, 1)) : a())
        }
      }

      function ad(a) {
        !noExitRuntime && (Aa = !0, Qa(Ua), e.onExit) && e.onExit(a), da(a, new ra(a))
      }
      if (e.dynCall_v = function () {
          return (e.dynCall_v = e.asm.pf).apply(null, arguments)
        }, e.asm = kd, e.ccall = Ca, e.cwrap = function (a, b, c, d) {
          var f = (c = c || []).every(function (g) {
            return "number" === g
          });
          return "string" !== b && f && !d ? Ba(a) : function () {
            return Ca(a, b, c, arguments)
          }
        }, ab = function ud() {
          td || vd(), td || (ab = ud)
        }, e.run = vd, e.preInit)
        for ("function" == typeof e.preInit && (e.preInit = [e.preInit]); 0 < e.preInit.length;) e.preInit.pop()();
      return vd(), createDeepARModule.ready
    }
}();
"object" == typeof exports && "object" == typeof module ? module.exports = createDeepARModule : "function" == typeof define && define.amd ? define([], function () {
  return createDeepARModule
}) : "object" == typeof exports && (exports.createDeepARModule = createDeepARModule);
var DeepAR = function (params) {
  for (var module = null, functionsToCallOnInitialize = [], callbackFuncs = ["onInitialize", "onVideoStarted", "onAnimationTransitionedToState", "onScreenshotTaken", "onScreenshotTakenCanvas", "onCameraPermissionAsked", "onCameraPermissionDenied", "onCameraPermissionGranted", "onImageVisibilityChanged", "onFaceVisibilityChanged", "onFaceTracked", "onError", "onNumberOfFacesVisibleChanged"], apiObject = {
      switchEffect: function (face, slot, path, cb) {
        module ? module.switchEffect(face, slot, path, cb) : console.log("DeepAR not yet initialized.")
      },
      switchEffectByteArray: function (face, slot, byteArray) {
        module ? module.switchEffectByteArray(face, slot, byteArray) : console.log("DeepAR not yet initialized.")
      },
      clearEffect: function (slot) {
        module ? module.clearEffect(slot) : console.log("DeepAR not yet initialized.")
      },
      startVideo: function (mirror, videoOptions) {
        module ? (module.startVideo(mirror, videoOptions), module.startLoop()) : console.log("DeepAR not yet initialized.")
      },
      stopVideo: function () {
        module ? module.stopVideo() : console.log("DeepAR not yet initialized.")
      },
      setVideoElement: function (videoElement, mirror) {
        module ? (module.setVideoElement(videoElement, mirror), module.startLoop()) : console.log("DeepAR not yet initialized.")
      },
      shutdown: function () {
        module ? module.shutdown() : console.log("DeepAR not yet initialized.")
      },
      setCanvasSize: function (width, height) {
        module ? module.reset(width, height) : functionsToCallOnInitialize.push(function () {
          module.reset(width, height)
        })
      },
      downloadFaceTrackingModel: function (path, cb) {
        var modelFileXHR = new XMLHttpRequest;
        modelFileXHR.open("GET", path, !0), modelFileXHR.responseType = "arraybuffer", modelFileXHR.onreadystatechange = function (event) {
          var byteArray;
          4 == modelFileXHR.readyState && 200 == modelFileXHR.status && (byteArray = new Uint8Array(modelFileXHR.response), module ? (module.setFaceTrackingModel(byteArray), cb && cb()) : functionsToCallOnInitialize.push(function () {
            module.setFaceTrackingModel(byteArray), cb && cb()
          }))
        }, modelFileXHR.send(null)
      },
      loadSegmentationModel: function (cb) {
        module ? module.initializeSegmentation(cb) : functionsToCallOnInitialize.push(function () {
          module.initializeSegmentation(cb)
        })
      },
      setFaceTrackingModel: function (byteArray) {
        module ? module.setFaceTrackingModel(byteArray) : functionsToCallOnInitialize.push(function () {
          module.setFaceTrackingModel(byteArray)
        })
      },
      showStats: function (enabled) {
        module ? module.showStats(enabled) : console.log("DeepAR not yet initialized.")
      },
      processFrame: function (frame, width, height, mirror) {
        module ? module.processFrameRawPixels(frame, width, height, mirror) : console.log("DeepAR not yet initialized.")
      },
      processImageAtUrl: function (url) {},
      processImage: function (image) {
        var canvas, ctx, imageData, byteArray;
        module ? (ctx = (canvas = document.createElement("canvas")).getContext("2d"), canvas.width = image.width, canvas.height = image.height, ctx.drawImage(image, 0, 0), imageData = ctx.getImageData(0, 0, canvas.width, canvas.height), byteArray = new Uint8Array(imageData.data.buffer), deepAR.processFrame(byteArray, image.width, image.height, !1)) : console.log("DeepAR not yet initialized.")
      },
      resume: function () {
        module ? module.startLoop() : console.log("DeepAR not yet initialized.")
      },
      pause: function () {
        module ? module.endLoop() : console.log("DeepAR not yet initialized.")
      },
      changeParameterFloat: function (gameObject, component, parameter, value) {
        module ? module.changeParameterFloat(gameObject, component, parameter, value) : console.log("DeepAR not yet initialized.")
      },
      changeParameterBool: function (gameObject, component, parameter, value) {
        module ? module.changeParameterBool(gameObject, component, parameter, value) : console.log("DeepAR not yet initialized.")
      },
      changeParameterVector: function (gameObject, component, parameter, x, y, z, w) {
        module ? module.changeParameterVector(gameObject, component, parameter, x, y, z, w) : console.log("DeepAR not yet initialized.")
      },
      changeParameterTexture: function (gameObject, component, parameter, textureUrl) {
        var img;
        module ? ((img = new Image).onload = function () {
          var imgCanvas = document.createElement("canvas"),
            imgCanvasContext = imgCanvas.getContext("2d");
          imgCanvas.width = img.width, imgCanvas.height = img.height, imgCanvasContext.drawImage(img, 0, 0);
          var imageData = imgCanvasContext.getImageData(0, 0, imgCanvas.width, imgCanvas.height),
            byteArray = new Uint8Array(imageData.data.buffer),
            buffer = module._malloc(byteArray.length);
          module.HEAPU8.set(byteArray, buffer), module.changeParameterTexture(gameObject, component, parameter, buffer, byteArray.length, imgCanvas.width, imgCanvas.height)
        }, img.src = textureUrl) : console.log("DeepAR not yet initialized.")
      },
      takeScreenshot: function () {
        module ? module.takeScreenshot() : console.log("DeepAR not yet initialized.")
      },
      setFps: function (fps) {
        module ? module.setFps(fps) : console.log("DeepAR not yet initialized.")
      },
      moveGameObject: function (selectedGameObject, targetGameObject) {
        module ? module.moveGameObject(selectedGameObject, targetGameObject) : console.log("DeepAR not yet initialized.")
      },
      fireTrigger: function (trigger) {
        module ? module.fireTrigger(trigger) : console.log("DeepAR not yet initialized.")
      }
    }, i = 0; i < callbackFuncs.length; i++) params[callbackFuncs[i]] && (apiObject[callbackFuncs[i]] = params[callbackFuncs[i]]);
  var p = {
    licenseKey: params.licenseKey,
    canvasWidth: params.canvasWidth,
    canvasHeight: params.canvasHeight,
    canvas: params.canvas,
    numberOfFaces: params.numberOfFaces,
    libPath: params.libPath,
    segmentationInfoZip: params.segmentationInfoZip,
    apiObject: apiObject
  };
  return createDeepARModule(p).then(function (_module) {
    module = _module, apiObject.onInitialize();
    for (var i = 0; i < functionsToCallOnInitialize.length; i++) functionsToCallOnInitialize[i]()
  }), apiObject
};
! function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("xzimg", [], e) : "object" == typeof exports ? exports.xzimg = e() : t.xzimg = e()
}(window, (function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var s = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(s.exports, s, s.exports, n), s.l = !0, s.exports
    }
    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      })
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      })
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
          enumerable: !0,
          value: t
        }), 2 & e && "string" != typeof t)
        for (var s in t) n.d(r, s, function (e) {
          return t[e]
        }.bind(null, s));
      return r
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default
      } : function () {
        return t
      };
      return n.d(e, "a", e), e
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e)
    }, n.p = "", n(n.s = 161)
  }([function (t, e, n) {
    "use strict";
    var r = {};
    n.r(r), n.d(r, "assertParamsValid", (function () {
      return St
    })), n.d(r, "maskToAxes", (function () {
      return _t
    })), n.d(r, "computeOutShape", (function () {
      return kt
    })), n.d(r, "stridesWithElidedDims", (function () {
      return Ct
    })), n.d(r, "startIndicesWithElidedDims", (function () {
      return Tt
    })), n.d(r, "stopIndicesWithElidedDims", (function () {
      return At
    })), n.d(r, "stridesForAxis", (function () {
      return Nt
    })), n.d(r, "startForAxis", (function () {
      return $t
    })), n.d(r, "stopForAxis", (function () {
      return Rt
    })), n.d(r, "isSliceContinous", (function () {
      return jt
    })), n.d(r, "computeFlatOffset", (function () {
      return Dt
    })), n.d(r, "parseSliceParams", (function () {
      return Ft
    }));
    var s = {};
    n.r(s), n.d(s, "segOpComputeOptimalWindowSize", (function () {
      return ze
    })), n.d(s, "computeOutShape", (function () {
      return Le
    })), n.d(s, "collectGatherOpShapeInfo", (function () {
      return Be
    }));
    var i = {};
    n.r(i), n.d(i, "conv2d", (function () {
      return Is
    })), n.d(i, "depthwiseConv2d", (function () {
      return Ns
    })), n.d(i, "matMul", (function () {
      return $s
    }));
    var a = {};
    n.r(a), n.d(a, "abs", (function () {
      return y
    })), n.d(a, "acos", (function () {
      return w
    })), n.d(a, "acosh", (function () {
      return v
    })), n.d(a, "add", (function () {
      return O
    })), n.d(a, "addN", (function () {
      return _
    })), n.d(a, "all", (function () {
      return D
    })), n.d(a, "any", (function () {
      return F
    })), n.d(a, "argMax", (function () {
      return M
    })), n.d(a, "argMin", (function () {
      return z
    })), n.d(a, "asin", (function () {
      return L
    })), n.d(a, "asinh", (function () {
      return B
    })), n.d(a, "atan", (function () {
      return P
    })), n.d(a, "atan2", (function () {
      return W
    })), n.d(a, "atanh", (function () {
      return U
    })), n.d(a, "avgPool", (function () {
      return st
    })), n.d(a, "avgPool3d", (function () {
      return mt
    })), n.d(a, "basicLSTMCell", (function () {
      return Lt
    })), n.d(a, "batchToSpaceND", (function () {
      return Bt
    })), n.d(a, "batchNorm", (function () {
      return Wt
    })), n.d(a, "batchNorm2d", (function () {
      return Ut
    })), n.d(a, "batchNorm3d", (function () {
      return Vt
    })), n.d(a, "batchNorm4d", (function () {
      return Ht
    })), n.d(a, "broadcastTo", (function () {
      return qt
    })), n.d(a, "buffer", (function () {
      return Kt
    })), n.d(a, "cast", (function () {
      return V
    })), n.d(a, "ceil", (function () {
      return Jt
    })), n.d(a, "clipByValue", (function () {
      return Xt
    })), n.d(a, "clone", (function () {
      return Gt
    })), n.d(a, "complex", (function () {
      return Yt.a
    })), n.d(a, "concat", (function () {
      return wt
    })), n.d(a, "concat1d", (function () {
      return Zt
    })), n.d(a, "concat2d", (function () {
      return Qt
    })), n.d(a, "concat3d", (function () {
      return te
    })), n.d(a, "concat4d", (function () {
      return ee
    })), n.d(a, "conv1d", (function () {
      return re
    })), n.d(a, "conv2d", (function () {
      return ne
    })), n.d(a, "conv2dTranspose", (function () {
      return ie
    })), n.d(a, "conv3d", (function () {
      return ae
    })), n.d(a, "conv3dTranspose", (function () {
      return ue
    })), n.d(a, "cos", (function () {
      return ce
    })), n.d(a, "cosh", (function () {
      return le
    })), n.d(a, "cumsum", (function () {
      return he
    })), n.d(a, "depthToSpace", (function () {
      return de
    })), n.d(a, "depthwiseConv2d", (function () {
      return pe
    })), n.d(a, "diag", (function () {
      return fe
    })), n.d(a, "dilation2d", (function () {
      return me
    })), n.d(a, "div", (function () {
      return be
    })), n.d(a, "divNoNan", (function () {
      return _e
    })), n.d(a, "dot", (function () {
      return ke
    })), n.d(a, "elu", (function () {
      return Ce
    })), n.d(a, "equal", (function () {
      return xe
    })), n.d(a, "erf", (function () {
      return Ee
    })), n.d(a, "exp", (function () {
      return Ie
    })), n.d(a, "expandDims", (function () {
      return Te
    })), n.d(a, "expm1", (function () {
      return Ae
    })), n.d(a, "eye", (function () {
      return $e
    })), n.d(a, "fft", (function () {
      return Re
    })), n.d(a, "fill", (function () {
      return je
    })), n.d(a, "floor", (function () {
      return De
    })), n.d(a, "floorDiv", (function () {
      return ge
    })), n.d(a, "gather", (function () {
      return Pe
    })), n.d(a, "greater", (function () {
      return We
    })), n.d(a, "greaterEqual", (function () {
      return Ue
    })), n.d(a, "ifft", (function () {
      return Ve
    })), n.d(a, "imag", (function () {
      return He
    })), n.d(a, "irfft", (function () {
      return Xe
    })), n.d(a, "isFinite", (function () {
      return Ye
    })), n.d(a, "isInf", (function () {
      return Ze
    })), n.d(a, "isNaN", (function () {
      return Qe
    })), n.d(a, "leakyRelu", (function () {
      return en
    })), n.d(a, "less", (function () {
      return nn
    })), n.d(a, "lessEqual", (function () {
      return rn
    })), n.d(a, "linspace", (function () {
      return sn
    })), n.d(a, "localResponseNormalization", (function () {
      return an
    })), n.d(a, "log", (function () {
      return on
    })), n.d(a, "log1p", (function () {
      return un
    })), n.d(a, "logSigmoid", (function () {
      return pn
    })), n.d(a, "logSoftmax", (function () {
      return bn
    })), n.d(a, "logSumExp", (function () {
      return yn
    })), n.d(a, "logicalAnd", (function () {
      return wn
    })), n.d(a, "logicalNot", (function () {
      return vn
    })), n.d(a, "logicalOr", (function () {
      return xn
    })), n.d(a, "logicalXor", (function () {
      return On
    })), n.d(a, "matMul", (function () {
      return vt
    })), n.d(a, "max", (function () {
      return fn
    })), n.d(a, "maxPool", (function () {
      return Sn
    })), n.d(a, "maxPool3d", (function () {
      return _n
    })), n.d(a, "maxPoolWithArgmax", (function () {
      return kn
    })), n.d(a, "maximum", (function () {
      return tn
    })), n.d(a, "mean", (function () {
      return In
    })), n.d(a, "min", (function () {
      return Tn
    })), n.d(a, "minimum", (function () {
      return An
    })), n.d(a, "mod", (function () {
      return Nn
    })), n.d(a, "moments", (function () {
      return Rn
    })), n.d(a, "mul", (function () {
      return xt
    })), n.d(a, "multiRNNCell", (function () {
      return jn
    })), n.d(a, "multinomial", (function () {
      return Dn
    })), n.d(a, "neg", (function () {
      return hn
    })), n.d(a, "notEqual", (function () {
      return Fn
    })), n.d(a, "oneHot", (function () {
      return Mn
    })), n.d(a, "ones", (function () {
      return En
    })), n.d(a, "onesLike", (function () {
      return zn
    })), n.d(a, "outerProduct", (function () {
      return Ln
    })), n.d(a, "pad", (function () {
      return Bn
    })), n.d(a, "pad1d", (function () {
      return Pn
    })), n.d(a, "pad2d", (function () {
      return Wn
    })), n.d(a, "pad3d", (function () {
      return Un
    })), n.d(a, "pad4d", (function () {
      return Vn
    })), n.d(a, "pool", (function () {
      return Gn
    })), n.d(a, "pow", (function () {
      return qn
    })), n.d(a, "prelu", (function () {
      return Kn
    })), n.d(a, "print", (function () {
      return Jn
    })), n.d(a, "prod", (function () {
      return Xn
    })), n.d(a, "rand", (function () {
      return Yn
    })), n.d(a, "randomGamma", (function () {
      return nr
    })), n.d(a, "randomNormal", (function () {
      return rr
    })), n.d(a, "randomUniform", (function () {
      return sr
    })), n.d(a, "range", (function () {
      return ar
    })), n.d(a, "real", (function () {
      return Ge
    })), n.d(a, "reciprocal", (function () {
      return or
    })), n.d(a, "relu", (function () {
      return ur
    })), n.d(a, "relu6", (function () {
      return cr
    })), n.d(a, "reshape", (function () {
      return R
    })), n.d(a, "reverse", (function () {
      return qe
    })), n.d(a, "reverse1d", (function () {
      return lr
    })), n.d(a, "reverse2d", (function () {
      return hr
    })), n.d(a, "reverse3d", (function () {
      return dr
    })), n.d(a, "reverse4d", (function () {
      return pr
    })), n.d(a, "rfft", (function () {
      return gr
    })), n.d(a, "round", (function () {
      return br
    })), n.d(a, "rsqrt", (function () {
      return yr
    })), n.d(a, "scalar", (function () {
      return Je
    })), n.d(a, "selu", (function () {
      return wr
    })), n.d(a, "separableConv2d", (function () {
      return vr
    })), n.d(a, "setdiff1dAsync", (function () {
      return xr
    })), n.d(a, "sigmoid", (function () {
      return Ot
    })), n.d(a, "sign", (function () {
      return Or
    })), n.d(a, "sin", (function () {
      return Sr
    })), n.d(a, "sinh", (function () {
      return _r
    })), n.d(a, "slice", (function () {
      return Mt
    })), n.d(a, "slice1d", (function () {
      return kr
    })), n.d(a, "slice2d", (function () {
      return Cr
    })), n.d(a, "slice3d", (function () {
      return Er
    })), n.d(a, "slice4d", (function () {
      return Ir
    })), n.d(a, "softmax", (function () {
      return Tr
    })), n.d(a, "softplus", (function () {
      return dn
    })), n.d(a, "spaceToBatchND", (function () {
      return Hn
    })), n.d(a, "split", (function () {
      return mr
    })), n.d(a, "sqrt", (function () {
      return Ar
    })), n.d(a, "square", (function () {
      return $n
    })), n.d(a, "squaredDifference", (function () {
      return Nr
    })), n.d(a, "squeeze", (function () {
      return $r
    })), n.d(a, "stack", (function () {
      return Rr
    })), n.d(a, "step", (function () {
      return jr
    })), n.d(a, "stridedSlice", (function () {
      return Dr
    })), n.d(a, "sub", (function () {
      return mn
    })), n.d(a, "sum", (function () {
      return gn
    })), n.d(a, "tan", (function () {
      return Fr
    })), n.d(a, "tanh", (function () {
      return zt
    })), n.d(a, "tensor", (function () {
      return yt.a
    })), n.d(a, "tensor1d", (function () {
      return ir
    })), n.d(a, "tensor2d", (function () {
      return Mr
    })), n.d(a, "tensor3d", (function () {
      return zr
    })), n.d(a, "tensor4d", (function () {
      return Lr
    })), n.d(a, "tensor5d", (function () {
      return Br
    })), n.d(a, "tensor6d", (function () {
      return Pr
    })), n.d(a, "tile", (function () {
      return Ne
    })), n.d(a, "topk", (function () {
      return Wr
    })), n.d(a, "truncatedNormal", (function () {
      return Ur
    })), n.d(a, "unsortedSegmentSum", (function () {
      return Vr
    })), n.d(a, "unstack", (function () {
      return Hr
    })), n.d(a, "variable", (function () {
      return Gr
    })), n.d(a, "where", (function () {
      return Oe
    })), n.d(a, "whereAsync", (function () {
      return Kr
    })), n.d(a, "zeros", (function () {
      return Cn
    })), n.d(a, "zerosLike", (function () {
      return Se
    })), n.d(a, "op", (function () {
      return b.a
    })), n.d(a, "image", (function () {
      return vi
    })), n.d(a, "linalg", (function () {
      return xi
    })), n.d(a, "losses", (function () {
      return Oi
    })), n.d(a, "spectral", (function () {
      return yi
    })), n.d(a, "fused", (function () {
      return i
    })), n.d(a, "signal", (function () {
      return wi
    })), n.d(a, "booleanMaskAsync", (function () {
      return Jr
    })), n.d(a, "equalStrict", (function () {
      return Xr
    })), n.d(a, "greaterEqualStrict", (function () {
      return Yr
    })), n.d(a, "greaterStrict", (function () {
      return Zr
    })), n.d(a, "lessEqualStrict", (function () {
      return Qr
    })), n.d(a, "lessStrict", (function () {
      return ts
    })), n.d(a, "notEqualStrict", (function () {
      return es
    })), n.d(a, "addStrict", (function () {
      return ns
    })), n.d(a, "divStrict", (function () {
      return rs
    })), n.d(a, "maximumStrict", (function () {
      return ss
    })), n.d(a, "minimumStrict", (function () {
      return is
    })), n.d(a, "modStrict", (function () {
      return as
    })), n.d(a, "mulStrict", (function () {
      return os
    })), n.d(a, "powStrict", (function () {
      return us
    })), n.d(a, "squaredDifferenceStrict", (function () {
      return cs
    })), n.d(a, "subStrict", (function () {
      return ls
    })), n.d(a, "transpose", (function () {
      return j
    })), n.d(a, "norm", (function () {
      return hs
    })), n.d(a, "movingAverage", (function () {
      return ds
    })), n.d(a, "scatterND", (function () {
      return gs
    })), n.d(a, "sparseToDense", (function () {
      return bs
    })), n.d(a, "gatherND", (function () {
      return ys
    })), n.d(a, "dropout", (function () {
      return ws
    })), n.d(a, "enclosingPowerOfTwo", (function () {
      return vs
    })), n.d(a, "cosineWindow", (function () {
      return xs
    })), n.d(a, "inTopKAsync", (function () {
      return Os
    }));
    var o = {};
    n.r(o), n.d(o, "copyModel", (function () {
      return Di
    })), n.d(o, "listModels", (function () {
      return Ri
    })), n.d(o, "moveModel", (function () {
      return Fi
    })), n.d(o, "removeModel", (function () {
      return ji
    })), n.d(o, "browserFiles", (function () {
      return la
    })), n.d(o, "browserHTTPRequest", (function () {
      return Oa
    })), n.d(o, "concatenateArrayBuffers", (function () {
      return Si.d
    })), n.d(o, "decodeWeights", (function () {
      return Si.e
    })), n.d(o, "encodeWeights", (function () {
      return Si.f
    })), n.d(o, "fromMemory", (function () {
      return ka
    })), n.d(o, "getLoadHandlers", (function () {
      return Ii
    })), n.d(o, "getModelArtifactsInfoForJSON", (function () {
      return Si.g
    })), n.d(o, "getSaveHandlers", (function () {
      return Ei
    })), n.d(o, "http", (function () {
      return xa
    })), n.d(o, "isHTTPScheme", (function () {
      return wa
    })), n.d(o, "loadWeights", (function () {
      return fa
    })), n.d(o, "registerLoadRouter", (function () {
      return Ci
    })), n.d(o, "registerSaveRouter", (function () {
      return ki
    })), n.d(o, "weightsLoaderFactory", (function () {
      return ma
    })), n.d(o, "withSaveHandler", (function () {
      return Ca
    }));
    var u = {};
    n.r(u), n.d(u, "toPixels", (function () {
      return Ta
    })), n.d(u, "fromPixels", (function () {
      return Aa
    }));
    var c = {};
    n.r(c), n.d(c, "Serializable", (function () {
      return Na
    })), n.d(c, "SerializationMap", (function () {
      return $a
    })), n.d(c, "registerClass", (function () {
      return Ra
    }));
    var l = {};
    n.r(l), n.d(l, "upcastType", (function () {
      return Da.b
    })), n.d(l, "segment_util", (function () {
      return s
    })), n.d(l, "castTensor", (function () {
      return yo
    })), n.d(l, "reshapeTensor", (function () {
      return wo
    })), n.d(l, "linspaceImpl", (function () {
      return vo
    })), n.d(l, "axesAreInnerMostDims", (function () {
      return k
    })), n.d(l, "combineLocations", (function () {
      return C
    })), n.d(l, "computeOutAndReduceShapes", (function () {
      return E
    })), n.d(l, "expandShapeToKeepDim", (function () {
      return I
    })), n.d(l, "assertAxesAreInnerMostDims", (function () {
      return T
    })), n.d(l, "getAxesPermutation", (function () {
      return A
    })), n.d(l, "getUndoAxesPermutation", (function () {
      return N
    })), n.d(l, "getInnerMostAxes", (function () {
      return $
    })), n.d(l, "getBroadcastDims", (function () {
      return ye
    })), n.d(l, "getReductionAxes", (function () {
      return we
    })), n.d(l, "assertAndGetBroadcastShape", (function () {
      return ve
    })), n.d(l, "assertParamsConsistent", (function () {
      return gt
    })), n.d(l, "computeOutShape", (function () {
      return bt
    })), n.d(l, "computeDilation2DInfo", (function () {
      return H
    })), n.d(l, "computePool2DInfo", (function () {
      return G
    })), n.d(l, "computePool3DInfo", (function () {
      return q
    })), n.d(l, "computeConv2DInfo", (function () {
      return K
    })), n.d(l, "computeConv3DInfo", (function () {
      return J
    })), n.d(l, "computeDefaultPad", (function () {
      return X
    })), n.d(l, "tupleValuesAreOne", (function () {
      return et
    })), n.d(l, "eitherStridesOrDilationsAreOne", (function () {
      return nt
    })), n.d(l, "convertConv2DDataFormat", (function () {
      return rt
    })), n.d(l, "getFusedDyActivation", (function () {
      return _s
    })), n.d(l, "getFusedBiasGradient", (function () {
      return ks
    })), n.d(l, "applyActivation", (function () {
      return Cs
    })), n.d(l, "shouldFuse", (function () {
      return Es
    })), n.d(l, "PARALLELIZE_THRESHOLD", (function () {
      return Fe
    })), n.d(l, "computeOptimalWindowSize", (function () {
      return Me
    })), n.d(l, "getImageCenter", (function () {
      return Ga
    })), n.d(l, "getReshaped", (function () {
      return qa
    })), n.d(l, "getPermuted", (function () {
      return Ka
    })), n.d(l, "getReshapedPermuted", (function () {
      return Ja
    })), n.d(l, "getSliceBeginCoords", (function () {
      return Xa
    })), n.d(l, "getSliceSize", (function () {
      return Ya
    })), n.d(l, "prepareAndValidate", (function () {
      return Za
    })), n.d(l, "validateUpdateShape", (function () {
      return ps
    })), n.d(l, "validateInput", (function () {
      return fs
    })), n.d(l, "calculateShapes", (function () {
      return ms
    })), n.d(l, "SELU_SCALEALPHA", (function () {
      return Qa
    })), n.d(l, "SELU_SCALE", (function () {
      return to
    })), n.d(l, "ERF_P", (function () {
      return eo
    })), n.d(l, "ERF_A1", (function () {
      return no
    })), n.d(l, "ERF_A2", (function () {
      return ro
    })), n.d(l, "ERF_A3", (function () {
      return so
    })), n.d(l, "ERF_A4", (function () {
      return io
    })), n.d(l, "ERF_A5", (function () {
      return ao
    })), n.d(l, "warn", (function () {
      return oo
    })), n.d(l, "log", (function () {
      return uo
    })), n.d(l, "mergeRealAndImagArrays", (function () {
      return co
    })), n.d(l, "splitRealAndImagArrays", (function () {
      return lo
    })), n.d(l, "complexWithEvenIndex", (function () {
      return ho
    })), n.d(l, "complexWithOddIndex", (function () {
      return po
    })), n.d(l, "getComplexWithIndex", (function () {
      return fo
    })), n.d(l, "assignToTypedArray", (function () {
      return mo
    })), n.d(l, "exponents", (function () {
      return go
    })), n.d(l, "exponent", (function () {
      return bo
    })), n.d(l, "prepareSplitSize", (function () {
      return fr
    }));
    var h = {};
    n.r(h), n.d(h, "nonMaxSuppressionV3Impl", (function () {
      return Vs
    })), n.d(h, "nonMaxSuppressionV4Impl", (function () {
      return Hs
    })), n.d(h, "nonMaxSuppressionV5Impl", (function () {
      return Gs
    })), n.d(h, "split", (function () {
      return Oo
    })), n.d(h, "tile", (function () {
      return So
    })), n.d(h, "topkImpl", (function () {
      return _o
    })), n.d(h, "whereImpl", (function () {
      return qr
    }));
    var d = n(6),
      p = (n(144), n(9));
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class f {
      fetch(t, e) {
        return fetch(t, e)
      }
      now() {
        return performance.now()
      }
      encode(t, e) {
        if ("utf-8" !== e && "utf8" !== e) throw new Error(`Browser's encoder only supports utf-8, but got ${e}`);
        return null == this.textEncoder && (this.textEncoder = new TextEncoder), this.textEncoder.encode(t)
      }
      decode(t, e) {
        return new TextDecoder(e).decode(t)
      }
    }
    Object(p.b)().get("IS_BROWSER") && Object(p.b)().setPlatform("browser", new f);
    n(145);
    var m = n(4),
      g = n(2),
      b = n(5);
    const y = Object(b.a)({
      abs_:
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t) {
          const e = Object(g.a)(t, "x", "abs"),
            n = {
              x: e
            };
          return d.a.runKernelFunc((t, n) => (n([e]), "complex64" === e.dtype ? t.complexAbs(e) : t.abs(e)), n, null, m.a)
        }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const w = Object(b.a)({
      acos_: function (t) {
        const e = Object(g.a)(t, "x", "acos"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.acos(e);
          return n([e]), r
        }, n, null, m.b)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const v = Object(b.a)({
      acosh_: function (t) {
        const e = Object(g.a)(t, "x", "acosh"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.acosh(e);
          return n([e]), r
        }, n, null, m.c)
      }
    });
    var x = n(8);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const O = Object(b.a)({
      add_: function (t, e) {
        let n = Object(g.a)(t, "a", "add"),
          r = Object(g.a)(e, "b", "add");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.add(n, r);
          return e([n, r]), s
        }, s, null, m.d)
      }
    });
    var S = n(1);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const _ = Object(b.a)({
      addN_: function (t) {
        S.assert(Array.isArray(t), () => "The argument passed to tf.addN() must be a list of tensors"), S.assert(t.length >= 1, () => "Must pass at least one tensor to tf.addN(), but got " + `${t.length}`);
        const e = t.map((t, e) => Object(g.a)(t, `tensors${e}`, "addN")),
          n = e[0];
        e.forEach(t => {
          if (t.dtype !== n.dtype) throw new Error("All tensors passed to tf.addN() must have the same dtype")
        }), e.forEach(t => {
          if (!S.arraysEqual(t.shape, n.shape)) throw new Error("All tensors passed to tf.addN() must have the same shape")
        });
        const r = e;
        return d.a.runKernelFunc((t, n) => {
          const r = t.addN(e);
          return n(e), r
        }, r, null, m.e)
      }
    });
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function k(t, e) {
      for (let n = 0; n < t.length; ++n)
        if (t[t.length - n - 1] !== e - 1 - n) return !1;
      return !0
    }

    function C(t, e, n) {
      const r = t.length + e.length,
        s = [];
      let i = 0,
        a = 0;
      for (let o = 0; o < r; o++) - 1 === n.indexOf(o) ? s.push(t[i++]) : s.push(e[a++]);
      return s
    }

    function E(t, e) {
      const n = [],
        r = t.length;
      for (let s = 0; s < r; s++) - 1 === e.indexOf(s) && n.push(t[s]);
      return [n, e.map(e => t[e])]
    }

    function I(t, e) {
      return C(t, e.map(t => 1), e)
    }

    function T(t, e, n) {
      S.assert(k(e, n), () => `${t} supports only inner-most axes for now. ` + `Got axes ${e} and rank-${n} input.`)
    }

    function A(t, e) {
      if (k(t, e)) return null;
      const n = [];
      for (let r = 0; r < e; ++r) - 1 === t.indexOf(r) && n.push(r);
      return t.forEach(t => n.push(t)), n
    }

    function N(t) {
      return t.map((t, e) => [e, t]).sort((t, e) => t[1] - e[1]).map(t => t[0])
    }

    function $(t, e) {
      const n = [];
      for (let r = e - t; r < e; ++r) n.push(r);
      return n
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const R = Object(b.a)({
      reshape_: function (t, e) {
        const n = Object(g.a)(t, "x", "reshape", null);
        e = S.inferFromImplicitShape(e, n.size), S.assert(n.size === S.sizeFromShape(e), () => "new shape and old shape must have the same number of elements.");
        const r = {
            x: n
          },
          s = {
            shape: e
          };
        return d.a.runKernelFunc((t, r) => (r([n]), t.reshape(n, e)), r, null, m.ec, s)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const j = Object(b.a)({
      transpose_: function (t, e) {
        const n = Object(g.a)(t, "x", "transpose");
        if (null == e && (e = n.shape.map((t, e) => e).reverse()), S.assert(n.rank === e.length, () => `Error in transpose: rank of input ${n.rank} ` + `must match length of perm ${e}.`), e.forEach(t => {
            S.assert(t >= 0 && t < n.rank, () => `All entries in 'perm' must be between 0 and ${n.rank-1}` + ` but got ${e}`)
          }), n.rank <= 1) return n.clone();
        const r = {
            x: n
          },
          s = {
            perm: e
          };
        return d.a.runKernelFunc(t => t.transpose(n, e), r, null, m.Lc, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const D = Object(b.a)({
      all_: function (t, e = null, n = !1) {
        let r = Object(g.a)(t, "x", "all", "bool");
        const s = {
            x: r
          },
          i = {
            axis: e,
            keepDims: n
          };
        return d.a.runKernelFunc(t => {
          const s = Object(S.parseAxisParam)(e, r.shape);
          let i = s;
          const a = A(i, r.rank);
          null != a && (r = j(r, a), i = $(i.length, r.rank));
          const o = t.all(r, i);
          if (n) {
            const t = I(o.shape, s);
            return R(o, t)
          }
          return o
        }, s, null, m.f, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const F = Object(b.a)({
      any_: function (t, e = null, n = !1) {
        let r = Object(g.a)(t, "x", "any", "bool");
        const s = {
            x: r
          },
          i = {
            axis: e,
            keepDims: n
          };
        return d.a.runKernelFunc(t => {
          const s = Object(S.parseAxisParam)(e, r.shape);
          let i = s;
          const a = A(i, r.rank);
          null != a && (r = j(r, a), i = $(i.length, r.rank));
          const o = t.any(r, i);
          if (n) {
            const t = I(o.shape, s);
            return R(o, t)
          }
          return o
        }, s, null, m.g, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const M = Object(b.a)({
      argMax_: function (t, e = 0) {
        let n = Object(g.a)(t, "x", "argMax");
        const r = {
            x: n
          },
          s = {
            axis: e
          };
        return d.a.runKernelFunc((t, r) => {
          r([n]);
          let s = S.parseAxisParam(e, n.shape);
          const i = A(s, n.rank);
          return null != i && (n = j(n, i), s = $(s.length, n.rank)), t.argMax(n, s[0])
        }, r, null, m.h, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const z = Object(b.a)({
      argMin_: function (t, e = 0) {
        let n = Object(g.a)(t, "x", "argMin");
        const r = {
            x: n
          },
          s = {
            axis: e
          };
        return d.a.runKernelFunc((t, r) => {
          r([n]), null == e && (e = 0);
          let s = S.parseAxisParam(e, n.shape);
          const i = A(s, n.rank);
          return null != i && (n = j(n, i), s = $(s.length, n.rank)), t.argMin(n, s[0])
        }, r, null, m.i, s)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const L = Object(b.a)({
      asin_: function (t) {
        const e = Object(g.a)(t, "x", "asin"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.asin(e);
          return n([e]), r
        }, n, null, m.j)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const B = Object(b.a)({
      asinh_: function (t) {
        const e = Object(g.a)(t, "x", "asinh"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.asinh(e);
          return n([e]), r
        }, n, null, m.k)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const P = Object(b.a)({
      atan_: function (t) {
        const e = Object(g.a)(t, "x", "atan"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.atan(e);
          return n([e]), r
        }, n, null, m.l)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const W = Object(b.a)({
      atan2_: function (t, e) {
        let n = Object(g.a)(t, "a", "atan2"),
          r = Object(g.a)(e, "b", "atan2");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.atan2(n, r);
          return e([n, r]), s
        }, s, null, m.m)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const U = Object(b.a)({
      atanh_: function (t) {
        const e = Object(g.a)(t, "x", "atanh"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.atanh(e);
          return n([e]), r
        }, n, null, m.n)
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const V = Object(b.a)({
      cast_: function (t, e) {
        const n = Object(g.a)(t, "x", "cast");
        if (!S.isValidDtype(e)) throw new Error(`Failed to cast to unknown dtype ${e}`);
        if ("string" === e && "string" !== n.dtype || "string" !== e && "string" === n.dtype) throw new Error("Only strings can be casted to strings");
        const r = {
            x: n
          },
          s = {
            dtype: e
          };
        return d.a.runKernelFunc(t => t.cast(n, e), r, null, m.v, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function H(t, e, n, r, s = "NHWC", i) {
      return K(t, [...e, t[3]], n, i, r, null, null, rt(s))
    }

    function G(t, e, n, r, s, i, a = "channelsLast") {
      const [o, u] = Y(e);
      let c;
      if ("channelsLast" === a) c = [o, u, t[3], t[3]];
      else {
        if ("channelsFirst" !== a) throw new Error(`Unknown dataFormat ${a}`);
        c = [o, u, t[1], t[1]]
      }
      return K(t, c, n, r, s, i, !1, a)
    }

    function q(t, e, n, r, s, i, a = "NDHWC") {
      const [o, u, c] = Z(e);
      let l, h;
      if ("NDHWC" === a) h = "channelsLast", l = [o, u, c, t[4], t[4]];
      else {
        if ("NCDHW" !== a) throw new Error(`Unknown dataFormat ${a}`);
        h = "channelsFirst", l = [o, u, c, t[1], t[1]]
      }
      return J(t, l, n, r, s, !1, h, i)
    }

    function K(t, e, n, r, s, i, a = !1, o = "channelsLast") {
      let [u, c, l, h] = [-1, -1, -1, -1];
      if ("channelsLast" === o)[u, c, l, h] = t;
      else {
        if ("channelsFirst" !== o) throw new Error(`Unknown dataFormat ${o}`);
        [u, h, c, l] = t
      }
      const [d, p, , f] = e, [m, g] = Y(n), [b, y] = Y(r), w = Q(d, b), v = Q(p, y), {
        padInfo: x,
        outHeight: O,
        outWidth: _
      } = function (t, e, n, r, s, i, a, o, u) {
        let c, l, h;
        if ("number" == typeof t) {
          c = {
            top: t,
            bottom: t,
            left: t,
            right: t,
            type: 0 === t ? "VALID" : "NUMBER"
          };
          const s = function (t, e, n, r, s) {
            null == r && (r = X(t, e, n));
            const i = t[0],
              a = t[1],
              o = tt((i - e + 2 * r) / n + 1, s);
            S.assert(S.isInt(o), () => `The output # of rows (${o}) must be an integer. ` + "Change the stride and/or zero pad parameters");
            const u = tt((a - e + 2 * r) / n + 1, s);
            return S.assert(S.isInt(u), () => `The output # of columns (${u}) must be an integer. ` + "Change the stride and/or zero pad parameters"), [o, u]
          }([e, n], i, r, t, o);
          l = s[0], h = s[1]
        } else if ("same" === t) {
          l = Math.ceil(e / r), h = Math.ceil(n / s);
          const t = Math.max(0, (l - 1) * r + i - e),
            o = Math.max(0, (h - 1) * s + a - n),
            u = Math.floor(t / 2),
            d = t - u,
            p = Math.floor(o / 2);
          c = {
            top: u,
            bottom: d,
            left: p,
            right: o - p,
            type: "SAME"
          }
        } else if ("valid" === t) c = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          type: "VALID"
        }, l = Math.ceil((e - i + 1) / r), h = Math.ceil((n - a + 1) / s);
        else {
          if ("object" != typeof t) throw Error(`Unknown padding parameter: ${t}`); {
            const d = "channelsLast" === u ? t[1][0] : t[2][0],
              p = "channelsLast" === u ? t[1][1] : t[2][1],
              f = "channelsLast" === u ? t[2][0] : t[3][0],
              m = "channelsLast" === u ? t[2][1] : t[3][1];
            c = {
              top: d,
              bottom: p,
              left: f,
              right: m,
              type: 0 === d && 0 === p && 0 === f && 0 === m ? "VALID" : "EXPLICIT"
            }, l = tt((e - i + d + p) / r + 1, o), h = tt((n - a + f + m) / s + 1, o)
          }
        }
        return {
          padInfo: c,
          outHeight: l,
          outWidth: h
        }
      }(s, c, l, m, g, w, v, i, o), k = a ? f * h : f;
      let C;
      return "channelsFirst" === o ? C = [u, k, O, _] : "channelsLast" === o && (C = [u, O, _, k]), {
        batchSize: u,
        dataFormat: o,
        inHeight: c,
        inWidth: l,
        inChannels: h,
        outHeight: O,
        outWidth: _,
        outChannels: k,
        padInfo: x,
        strideHeight: m,
        strideWidth: g,
        filterHeight: d,
        filterWidth: p,
        effectiveFilterHeight: w,
        effectiveFilterWidth: v,
        dilationHeight: b,
        dilationWidth: y,
        inShape: t,
        outShape: C,
        filterShape: e
      }
    }

    function J(t, e, n, r, s, i = !1, a = "channelsLast", o) {
      let [u, c, l, h, d] = [-1, -1, -1, -1, -1];
      if ("channelsLast" === a)[u, c, l, h, d] = t;
      else {
        if ("channelsFirst" !== a) throw new Error(`Unknown dataFormat ${a}`);
        [u, d, c, l, h] = t
      }
      const [p, f, m, , g] = e, [b, y, w] = Z(n), [v, x, O] = Z(r), _ = Q(p, v), k = Q(f, x), C = Q(m, O), {
        padInfo: E,
        outDepth: I,
        outHeight: T,
        outWidth: A
      } = function (t, e, n, r, s, i, a, o, u, c, l) {
        let h, d, p, f;
        if ("number" == typeof t) {
          h = {
            top: t,
            bottom: t,
            left: t,
            right: t,
            front: t,
            back: t,
            type: 0 === t ? "VALID" : "NUMBER"
          };
          const i = function (t, e, n, r, s, i) {
            null == s && (s = X(t, e, r));
            const a = t[0],
              o = t[1],
              u = t[2],
              c = tt((a - e + 2 * s) / r + 1, i);
            S.assert(S.isInt(c), () => `The output # of depths (${c}) must be an integer. ` + "Change the stride and/or zero pad parameters");
            const l = tt((o - e + 2 * s) / r + 1, i);
            S.assert(S.isInt(l), () => `The output # of rows (${l}) must be an integer. ` + "Change the stride and/or zero pad parameters");
            const h = tt((u - e + 2 * s) / r + 1, i);
            return S.assert(S.isInt(h), () => `The output # of columns (${h}) must be an integer. ` + "Change the stride and/or zero pad parameters"), [c, l, h, n]
          }([e, n, r, 1], o, 1, s, t, l);
          d = i[0], p = i[1], f = i[2]
        } else if ("same" === t) {
          d = Math.ceil(e / s), p = Math.ceil(n / i), f = Math.ceil(r / a);
          const t = (d - 1) * s + o - e,
            l = (p - 1) * i + u - n,
            m = (f - 1) * a + c - r,
            g = Math.floor(t / 2),
            b = t - g,
            y = Math.floor(l / 2),
            w = l - y,
            v = Math.floor(m / 2);
          h = {
            top: y,
            bottom: w,
            left: v,
            right: m - v,
            front: g,
            back: b,
            type: "SAME"
          }
        } else {
          if ("valid" !== t) throw Error(`Unknown padding parameter: ${t}`);
          h = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            front: 0,
            back: 0,
            type: "VALID"
          }, d = Math.ceil((e - o + 1) / s), p = Math.ceil((n - u + 1) / i), f = Math.ceil((r - c + 1) / a)
        }
        return {
          padInfo: h,
          outDepth: d,
          outHeight: p,
          outWidth: f
        }
      }(s, c, l, h, b, y, w, _, k, C, o), N = i ? g * d : g;
      let $;
      return "channelsFirst" === a ? $ = [u, N, I, T, A] : "channelsLast" === a && ($ = [u, I, T, A, N]), {
        batchSize: u,
        dataFormat: a,
        inDepth: c,
        inHeight: l,
        inWidth: h,
        inChannels: d,
        outDepth: I,
        outHeight: T,
        outWidth: A,
        outChannels: N,
        padInfo: E,
        strideDepth: b,
        strideHeight: y,
        strideWidth: w,
        filterDepth: p,
        filterHeight: f,
        filterWidth: m,
        effectiveFilterDepth: _,
        effectiveFilterHeight: k,
        effectiveFilterWidth: C,
        dilationDepth: v,
        dilationHeight: x,
        dilationWidth: O,
        inShape: t,
        outShape: $,
        filterShape: e
      }
    }

    function X(t, e, n, r = 1) {
      const s = Q(e, r);
      return Math.floor((t[0] * (n - 1) - n + s) / 2)
    }

    function Y(t) {
      return "number" == typeof t ? [t, t, t] : 2 === t.length ? [t[0], t[1], 1] : t
    }

    function Z(t) {
      return "number" == typeof t ? [t, t, t] : t
    }

    function Q(t, e) {
      return e <= 1 ? t : t + (t - 1) * (e - 1)
    }

    function tt(t, e) {
      if (!e) return t;
      switch (e) {
        case "round":
          return Math.round(t);
        case "ceil":
          return Math.ceil(t);
        case "floor":
          return Math.floor(t);
        default:
          throw new Error(`Unknown roundingMode ${e}`)
      }
    }

    function et(t) {
      const [e, n, r] = Y(t);
      return 1 === e && 1 === n && 1 === r
    }

    function nt(t, e) {
      return et(t) || et(e)
    }

    function rt(t) {
      if ("NHWC" === t) return "channelsLast";
      if ("NCHW" === t) return "channelsFirst";
      throw new Error(`Unknown dataFormat ${t}`)
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const st = Object(b.a)({
      avgPool_: function (t, e, n, r, s) {
        const i = Object(g.a)(t, "x", "avgPool", "float32");
        S.assert(nt(n, 1), () => "Error in avgPool: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '1'`);
        let a = i,
          o = !1;
        3 === i.rank && (o = !0, a = R(i, [1, i.shape[0], i.shape[1], i.shape[2]])), S.assert(4 === a.rank, () => `Error in avgPool: x must be rank 4 but got rank ${a.rank}.`), null != s && S.assert(S.isInt(r), () => "Error in avgPool: pad must be an integer when using, " + `dimRoundingMode ${s} but got pad ${r}.`);
        const u = {
            x: a
          },
          c = {
            filterSize: e,
            strides: n,
            pad: r,
            dimRoundingMode: s
          };
        let l = d.a.runKernelFunc((t, i) => {
          const o = G(a.shape, e, n, 1, r, s);
          return i([a]), 1 === o.filterWidth && 1 === o.filterHeight && S.arraysEqual(o.inShape, o.outShape) ? a.clone() : t.avgPool(a, o)
        }, u, null, m.o, c);
        return l = V(l, i.dtype), o ? R(l, [l.shape[1], l.shape[2], l.shape[3]]) : l
      }
    });
    var it = n(7);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function at(t) {
      Object(p.b)().getBool("DEPRECATION_WARNINGS_ENABLED") && console.warn(t + " You can disable deprecation warnings with tf.disableDeprecationWarnings().")
    }

    function ot() {
      return d.a
    }

    function ut() {
      return d.a.memory()
    }

    function ct(t, e) {
      return d.a.tidy(t, e)
    }

    function lt(t) {
      Object(x.getTensorsInContainer)(t).forEach(t => t.dispose())
    }

    function ht(t) {
      return d.a.keep(t)
    }

    function dt(t) {
      return d.a.setBackend(t)
    }

    function pt(t, e, n = 1) {
      return d.a.registerBackend(t, e, n)
    }

    function ft() {
      return d.a.backend
    }
    Object(it.d)(at);
    const mt = Object(b.a)({
      avgPool3d_:
        /**
         * @license
         * Copyright 2020 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e, n, r, s, i = "NDHWC", a) {
          null == a ? a = [1, 1, 1] : at("dilations is deprecated, this field will be gone in v3.0.0.");
          const o = Object(g.a)(t, "x", "avgPool3d", "float32");
          let u = o,
            c = !1;
          4 === o.rank && (c = !0, u = R(o, [1, o.shape[0], o.shape[1], o.shape[2], o.shape[3]])), S.assert(5 === u.rank, () => `Error in avgPool3d: x must be rank 5 but got rank ${u.rank}.`), S.assert("NDHWC" === i, () => "Error in avgPool3d: Only NDHWC is currently supported, " + `but got dataFormat of ${i}`), S.assert(nt(n, a), () => "Error in avgPool3d: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '${a}'`), null != s && S.assert(S.isInt(r), () => "Error in avgPool3d: pad must be an integer when using, " + `dimRoundingMode ${s} but got pad ${r}.`);
          const l = {
              x: u
            },
            h = {
              filterSize: e,
              strides: n,
              pad: r,
              dimRoundingMode: s,
              dataFormat: i,
              dilations: a
            };
          let p = d.a.runKernelFunc((t, o) => {
            null == a && (a = [1, 1, 1]);
            const c = q(u.shape, e, n, a, r, s, i);
            return o([u]), t.avgPool3d(u, c)
          }, l, null, m.p, h);
          return p = V(p, u.dtype), c ? R(p, [p.shape[1], p.shape[2], p.shape[3], p.shape[4]]) : p
        }
    });
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function gt(t, e) {
      const n = t[0].length;
      t.forEach((t, e) => {
        S.assert(t.length === n, () => `Error in concat${n}D: rank of tensors[${e}] must be the same ` + `as the rank of the rest (${n})`)
      }), S.assert(e >= 0 && e < n, () => `Error in concat${n}D: axis must be between 0 and ${n-1}.`);
      const r = t[0];
      t.forEach((t, s) => {
        for (let i = 0; i < n; i++) S.assert(i === e || t[i] === r[i], () => `Error in concat${n}D: Shape of tensors[${s}] (${t}) ` + `does not match the shape of the rest (${r}) ` + `along the non-concatenated axis ${s}.`)
      })
    }

    function bt(t, e) {
      const n = t[0].slice();
      for (let r = 1; r < t.length; r++) n[e] += t[r][e];
      return n
    }
    var yt = n(18);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const wt = Object(b.a)({
      concat_: function (t, e = 0) {
        Object(S.assert)(t.length >= 1, () => "Pass at least one tensor to concat");
        let n = Object(g.b)(t, "tensors", "concat");
        "complex64" === n[0].dtype && n.forEach(t => {
          if ("complex64" !== t.dtype) throw new Error(`Cannot concatenate complex64 tensors with a tensor\n          with dtype ${t.dtype}. `)
        });
        const r = Object(S.parseAxisParam)(e, n[0].shape)[0],
          s = bt(n.map(t => t.shape), r);
        if (0 === Object(S.sizeFromShape)(s)) return Object(yt.a)([], s);
        if (n = n.filter(t => t.size > 0), 1 === n.length) return n[0];
        gt(n.map(t => t.shape), r);
        const i = n,
          a = {
            axis: e
          };
        return d.a.runKernelFunc((t, e) => {
          const s = t.concat(n, r);
          return e(n), s
        }, i, null, m.z, a)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const vt = Object(b.a)({
      matMul_: function (t, e, n = !1, r = !1) {
        let s = Object(g.a)(t, "a", "matMul"),
          i = Object(g.a)(e, "b", "matMul");
        [s, i] = Object(x.makeTypesMatch)(s, i), S.assert(s.rank >= 2 && i.rank >= 2 && s.rank === i.rank, () => "Error in matMul: inputs must have the same rank of at least 2, " + `got ranks ${s.rank} and ${i.rank}.`);
        const a = n ? s.shape[s.rank - 2] : s.shape[s.rank - 1],
          o = r ? i.shape[i.rank - 1] : i.shape[i.rank - 2],
          u = n ? s.shape[s.rank - 1] : s.shape[s.rank - 2],
          c = r ? i.shape[i.rank - 2] : i.shape[i.rank - 1],
          l = s.shape.slice(0, -2),
          h = i.shape.slice(0, -2),
          p = S.sizeFromShape(l),
          f = S.sizeFromShape(h);
        S.assert(S.arraysEqual(l, h), () => `Error in matMul: outer dimensions (${l}) and (` + `${h}) of Tensors with shapes ${s.shape} and ` + `${i.shape} must match.`), S.assert(a === o, () => `Error in matMul: inner shapes (${a}) and (` + `${o}) of Tensors with shapes ${s.shape} and ` + `${i.shape} and transposeA=${n}` + ` and transposeB=${r} must match.`);
        const b = s.shape.slice(0, -2).concat([u, c]),
          y = R(s, n ? [p, a, u] : [p, u, a]),
          w = R(i, r ? [f, c, o] : [f, o, c]),
          v = {
            a: y,
            b: w
          },
          O = {
            transposeA: n,
            transposeB: r
          },
          _ = d.a.runKernelFunc((t, e) => (e([y, w]), t.batchMatMul(y, w, n, r)), v, null, m.s, O);
        return R(_, b)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const xt = Object(b.a)({
      mul_: function (t, e) {
        let n = Object(g.a)(t, "a", "mul"),
          r = Object(g.a)(e, "b", "mul");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.multiply(n, r);
          return e([n, r]), s
        }, s, null, m.Nb)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ot = Object(b.a)({
      sigmoid_: function (t) {
        const e = Object(g.a)(t, "x", "sigmoid"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.sigmoid(e);
          return n([r]), r
        }, n, null, m.qc)
      }
    });
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function St(t, e, n) {
      S.assert(t.rank === e.length, () => `Error in slice${t.rank}D: Length of begin ${e} must ` + `match the rank of the array (${t.rank}).`), S.assert(t.rank === n.length, () => `Error in slice${t.rank}D: Length of size ${n} must ` + `match the rank of the array (${t.rank}).`);
      for (let r = 0; r < t.rank; ++r) S.assert(e[r] + n[r] <= t.shape[r], () => `Error in slice${t.rank}D: begin[${r}] + size[${r}] ` + `(${e[r]+n[r]}) would overflow input.shape[${r}] (${t.shape[r]})`)
    }

    function _t(t) {
      const e = [];
      let n = 0;
      for (; t > 0;) 1 & t && e.push(n), t /= 2, n++;
      return e
    }

    function kt(t, e, n) {
      const r = [];
      for (let s = 0; s < t.length; s++) r[s] = Math.ceil((e[s] - t[s]) / n[s]);
      return r
    }

    function Ct(t, e, n, r) {
      const s = [...t];
      for (let t = s.length; t < r.length; t++) s.push(1);
      for (let t = 0; t < n; t++) 0 === t ? s[e] = 1 : (s.splice(e, 0, 1), s.pop());
      return s
    }

    function Et(t, e, n) {
      return n <= t ? n : n - (e - 1)
    }

    function It(t, e) {
      const n = [];
      for (let r = 0; r < t; r++) n.push(e + r);
      return n
    }

    function Tt(t, e, n, r, s) {
      const i = [...s],
        a = It(n, e);
      for (let s = 0; s < i.length; s++)
        if (a.indexOf(s) > -1) i[s] = 0;
        else {
          const a = Et(e, n, s);
          let o = r[a];
          t & 1 << a && (o = 0), i[s] = o
        } return i
    }

    function At(t, e, n, r, s) {
      const i = [...s],
        a = It(n, e);
      for (let s = 0; s < i.length; s++)
        if (a.indexOf(s) > -1) i[s] = Number.MAX_SAFE_INTEGER;
        else {
          const a = Et(e, n, s);
          let o = r[a];
          t & 1 << a && (o = Number.MAX_SAFE_INTEGER), i[s] = o
        } for (let t = 0; t < i.length; t++) {
        const e = s[t];
        i[t] < 0 && (i[t] += e), i[t] = S.clamp(0, i[t], s[t])
      }
      return i
    }

    function Nt(t, e, n) {
      let r = t[e];
      return (n & 1 << e || null == r) && (r = 1), r
    }

    function $t(t, e, n, r, s, i) {
      let a = e[s];
      const o = n[s] || 1;
      (t & 1 << s || i & 1 << s || null == a) && (a = o > 0 ? Number.MIN_SAFE_INTEGER : Number.MAX_SAFE_INTEGER);
      const u = r[s];
      return a < 0 && (a += u), a = S.clamp(0, a, u - 1), a
    }

    function Rt(t, e, n, r, s, i) {
      let a = e[s];
      const o = n[s] || 1;
      (t & 1 << s || i & 1 << s || null == a) && (a = o > 0 ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER);
      const u = r[s];
      return a < 0 && (a += u), a = o > 0 ? S.clamp(0, a, u) : S.clamp(-1, a, u - 1), a
    }

    function jt(t, e, n) {
      let r = n.length;
      for (let t = 0; t < n.length; t++)
        if (n[t] > 1) {
          r = t;
          break
        } for (let s = r + 1; s < n.length; s++)
        if (e[s] > 0 || n[s] !== t[s]) return !1;
      return !0
    }

    function Dt(t, e) {
      let n = t.length > 0 ? t[t.length - 1] : 1;
      for (let r = 0; r < t.length - 1; r++) n += t[r] * e[r];
      return n
    }

    function Ft(t, e, n) {
      let r, s;
      return r = "number" == typeof e ? [e, ...new Array(t.rank - 1).fill(0)] : e.length < t.rank ? e.concat(new Array(t.rank - e.length).fill(0)) : e.slice(), r.forEach(t => {
        S.assert(-1 !== t, () => "slice() does not support negative begin indexing.")
      }), s = null == n ? new Array(t.rank).fill(-1) : "number" == typeof n ? [n, ...new Array(t.rank - 1).fill(-1)] : n.length < t.rank ? n.concat(new Array(t.rank - n.length).fill(-1)) : n, s = s.map((e, n) => e >= 0 ? e : (S.assert(-1 === e, () => "Negative size values should be exactly -1 but got " + `${e} for the slice() size at index ${n}.`), t.shape[n] - r[n])), [r, s]
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Mt = Object(b.a)({
      slice_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "slice");
        if (0 === r.rank) throw new Error("Slicing scalar is not possible");
        const [s, i] = Ft(r, e, n);
        St(r, s, i);
        const a = {
            x: r
          },
          o = {
            begin: e,
            size: n
          };
        return d.a.runKernelFunc((t, e) => (e([r]), t.slice(r, s, i)), a, null, m.uc, o)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const zt = Object(b.a)({
      tanh_: function (t) {
        const e = Object(g.a)(t, "x", "tanh"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.tanh(e);
          return n([r]), r
        }, n, null, m.Ic)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Lt = Object(b.a)({
      basicLSTMCell_: function (t, e, n, r, s, i) {
        const a = Object(g.a)(t, "forgetBias", "basicLSTMCell"),
          o = Object(g.a)(e, "lstmKernel", "basicLSTMCell"),
          u = Object(g.a)(n, "lstmBias", "basicLSTMCell"),
          c = Object(g.a)(r, "data", "basicLSTMCell"),
          l = Object(g.a)(s, "c", "basicLSTMCell"),
          h = Object(g.a)(i, "h", "basicLSTMCell"),
          d = wt([c, h], 1),
          p = vt(d, o),
          f = O(p, u),
          m = f.shape[0],
          b = f.shape[1] / 4,
          y = [m, b],
          w = Mt(f, [0, 0], y),
          v = Mt(f, [0, b], y),
          x = Mt(f, [0, 2 * b], y),
          S = Mt(f, [0, 3 * b], y),
          _ = O(xt(Ot(w), zt(v)), xt(l, Ot(O(a, x))));
        return [_, xt(zt(_), Ot(S))]
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Bt = Object(b.a)({
      batchToSpaceND_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "batchToSpaceND"),
          s = e.reduce((t, e) => t * e);
        S.assert(r.rank >= 1 + e.length, () => `input rank is ${r.rank} but should be > than blockShape.length ${e.length}`), S.assert(n.length === e.length, () => `crops.length is ${n.length} but should be equal to blockShape.length  ${e.length}`), S.assert(r.shape[0] % s == 0, () => `input tensor batch is ${r.shape[0]} but is not divisible by the product of ` + `the elements of blockShape ${e.join(" * ")} === ${s}`);
        const i = {
            x: r
          },
          a = {
            blockShape: e,
            crops: n
          };
        return d.a.runKernelFunc(t => t.batchToSpaceND(r, e, n), i, null, m.t, a)
      }
    });

    function Pt(t) {
      return null == t ? null : 0 === t.rank ? R(t, [t.size]) : 1 === t.rank ? t : 2 === t.rank ? R(t, [1, 1, t.shape[0], t.shape[1]]) : 3 === t.rank ? R(t, [1, t.shape[0], t.shape[1], t.shape[2]]) : t
    }
    const Wt = Object(b.a)({
      batchNorm_:
        /**
         * @license
         * Copyright 2020 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e, n, r, s, i) {
          null == i && (i = .001);
          const a = Object(g.a)(t, "x", "batchNorm"),
            o = Object(g.a)(e, "mean", "batchNorm"),
            u = Object(g.a)(n, "variance", "batchNorm");
          let c, l;
          null != s && (c = Object(g.a)(s, "scale", "batchNorm")), null != r && (l = Object(g.a)(r, "offset", "batchNorm")), S.assert(o.rank === u.rank, () => "Batch normalization gradient requires mean and variance to have equal ranks."), S.assert(null == l || o.rank === l.rank, () => "Batch normalization gradient requires mean and offset to have equal ranks."), S.assert(null == c || o.rank === c.rank, () => "Batch normalization gradient requires mean and scale to have equal ranks.");
          const h = function (t) {
              let e;
              return e = 0 === t.rank || 1 === t.rank ? R(t, [1, 1, 1, t.size]) : 2 === t.rank ? R(t, [1, 1, t.shape[0], t.shape[1]]) : 3 === t.rank ? R(t, [1, t.shape[0], t.shape[1], t.shape[2]]) : t, e
            }(a),
            p = {
              x: h,
              scale: c,
              offset: l,
              mean: o,
              variance: u
            },
            f = {
              varianceEpsilon: i
            },
            b = d.a.runKernelFunc((t, e) => (e([h, o, u, c]), t.batchNorm(h, Pt(o), Pt(u), Pt(l), Pt(c), i)), p, null, m.fb, f);
          return R(b, a.shape)
        }
    });
    const Ut = Object(b.a)({
      batchNorm2d_: function (t, e, n, r, s, i) {
        const a = Object(g.a)(t, "x", "batchNorm"),
          o = Object(g.a)(e, "mean", "batchNorm"),
          u = Object(g.a)(n, "variance", "batchNorm");
        let c, l;
        return null != s && (c = Object(g.a)(s, "scale", "batchNorm")), null != r && (l = Object(g.a)(r, "offset", "batchNorm")), S.assert(2 === a.rank, () => "Error in batchNorm2D: x must be rank 2 but got rank " + `${a.rank}.`), S.assert(2 === o.rank || 1 === o.rank, () => "Error in batchNorm2D: mean must be rank 2 or rank 1 but " + `got rank ${o.rank}.`), S.assert(2 === u.rank || 1 === u.rank, () => "Error in batchNorm2D: variance must be rank 2 or rank 1 " + `but got rank ${u.rank}.`), null != c && S.assert(2 === c.rank || 1 === c.rank, () => "Error in batchNorm2D: scale must be rank 2 or rank 1 " + `but got rank ${c.rank}.`), null != l && S.assert(2 === l.rank || 1 === l.rank, () => "Error in batchNorm2D: offset must be rank 2 or rank 1 " + `but got rank ${l.rank}.`), Wt(a, o, u, l, c, i)
      }
    });
    const Vt = Object(b.a)({
      batchNorm3d_: function (t, e, n, r, s, i) {
        const a = Object(g.a)(t, "x", "batchNorm"),
          o = Object(g.a)(e, "mean", "batchNorm"),
          u = Object(g.a)(n, "variance", "batchNorm");
        let c, l;
        return null != s && (c = Object(g.a)(s, "scale", "batchNorm")), null != r && (l = Object(g.a)(r, "offset", "batchNorm")), S.assert(3 === a.rank, () => "Error in batchNorm3D: x must be rank 3 but got rank " + `${a.rank}.`), S.assert(3 === o.rank || 1 === o.rank, () => "Error in batchNorm3D: mean must be rank 3 or rank 1 but " + `got rank ${o.rank}.`), S.assert(3 === u.rank || 1 === u.rank, () => "Error in batchNorm3D: variance must be rank 3 or rank 1 " + `but got rank ${u.rank}.`), null != c && S.assert(3 === c.rank || 1 === c.rank, () => "Error in batchNorm3D: scale must be rank 3 or rank 1 " + `but got rank ${c.rank}.`), null != l && S.assert(3 === l.rank || 1 === l.rank, () => "Error in batchNorm3D: offset must be rank 3 or rank 1 " + `but got rank ${l.rank}.`), Wt(a, o, u, l, c, i)
      }
    });
    const Ht = Object(b.a)({
      batchNorm4d_: function (t, e, n, r, s, i) {
        const a = Object(g.a)(t, "x", "batchNorm"),
          o = Object(g.a)(e, "mean", "batchNorm"),
          u = Object(g.a)(n, "variance", "batchNorm");
        let c, l;
        return null != s && (c = Object(g.a)(s, "scale", "batchNorm")), null != r && (l = Object(g.a)(r, "offset", "batchNorm")), S.assert(4 === a.rank, () => "Error in batchNorm4D: x must be rank 4 but got rank " + `${a.rank}.`), S.assert(4 === o.rank || 1 === o.rank, () => "Error in batchNorm4D: mean must be rank 4 or rank 1 but " + `got rank ${o.rank}.`), S.assert(4 === u.rank || 1 === u.rank, () => "Error in batchNorm4D: variance must be rank 4 or rank 1 " + `but got rank ${u.rank}.`), null != c && S.assert(4 === c.rank || 1 === c.rank, () => "Error in batchNorm4D: scale must be rank 4 or rank 1 " + `but got rank ${c.rank}.`), null != l && S.assert(4 === l.rank || 1 === l.rank, () => "Error in batchNorm4D: offset must be rank 4 or rank 1 " + `but got rank ${l.rank}.`), Wt(a, o, u, l, c, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Gt = Object(b.a)({
      clone_: function (t) {
        const e = Object(g.a)(t, "x", "clone", null),
          n = {
            x: e
          };
        return d.a.runKernelFunc(() => d.a.makeTensorFromDataId(e.dataId, e.shape, e.dtype), n, null, m.nb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const qt = Object(b.a)({
      broadcastTo_: function (t, e) {
        let n = Object(g.a)(t, "broadcastTo", "x");
        const r = n.shape;
        if (e.some(t => !(t > 0) || t % 1 != 0)) throw new Error(`broadcastTo(): Invalid broadcast shape [${e}].`);
        if (e.length < n.rank) throw new Error(`broadcastTo(): shape.length=${e.length} < input.rank=${n.rank}.`);
        if (e.length > n.rank) {
          const t = n.shape.slice();
          for (; t.length < e.length;) t.unshift(1);
          n = R(n, t)
        }
        const s = n.shape,
          i = Array.from(e);
        for (let t = e.length - 1; t >= 0; t--)
          if (s[t] === e[t]) i[t] = 1;
          else if (1 !== n.shape[t]) throw new Error(`broadcastTo(): [${r}] cannot be broadcast to [${e}].`);
        if (0 === i.map((t, e) => t > 1 ? e : -1).filter(t => t >= 0).length) return Gt(n);
        const a = {
            x: n
          },
          o = {
            shape: e,
            inputShape: s
          };
        return d.a.runKernelFunc(t => t.tile(n, i), a, null, m.u, o)
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Kt(t, e = "float32", n) {
      return e = e || "float32", S.assertNonNegativeIntegerDimensions(t), new it.b(t, e, n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Jt = Object(b.a)({
      ceil_: function (t) {
        const e = Object(g.a)(t, "x", "ceil"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.ceil(e), n, null, m.w)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Xt = Object(b.a)({
      clipByValue_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "clipByValue");
        S.assert(e <= n, () => `Error in clip: min (${e}) must be ` + `less than or equal to max (${n}).`);
        const s = {
            x: r
          },
          i = {
            clipValueMin: e,
            clipValueMax: n
          };
        return d.a.runKernelFunc((t, s) => {
          const i = t.clip(r, e, n);
          return s([r]), i
        }, s, null, m.x, i)
      }
    });
    var Yt = n(15);
    const Zt = Object(b.a)({
      concat1d_: function (t) {
        return wt(t, 0)
      }
    });
    const Qt = Object(b.a)({
      concat2d_: function (t, e) {
        return wt(t, e)
      }
    });
    const te = Object(b.a)({
      concat3d_: function (t, e) {
        return wt(t, e)
      }
    });
    const ee = Object(b.a)({
      concat4d_: function (t, e) {
        return wt(t, e)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ne = Object(b.a)({
      conv2d_: function (t, e, n, r, s = "NHWC", i = [1, 1], a) {
        const o = Object(g.a)(t, "x", "conv2d"),
          u = Object(g.a)(e, "filter", "conv2d");
        let c = o,
          l = !1;
        3 === o.rank && (l = !0, c = R(o, [1, o.shape[0], o.shape[1], o.shape[2]])), S.assert(4 === c.rank, () => `Error in conv2d: input must be rank 4, but got rank ${c.rank}.`), S.assert(4 === u.rank, () => "Error in conv2d: filter must be rank 4, but got rank " + `${u.rank}.`), null != a && S.assert(S.isInt(r), () => "Error in conv2d: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${r}.`);
        const h = "NHWC" === s ? c.shape[3] : c.shape[1];
        S.assert(h === u.shape[2], () => `Error in conv2d: depth of input (${h}) must match ` + `input depth for filter ${u.shape[2]}.`), S.assert(nt(n, i), () => "Error in conv2D: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '${i}'`);
        const p = {
            x: c,
            filter: u
          },
          f = {
            strides: n,
            pad: r,
            dataFormat: s,
            dilations: i,
            dimRoundingMode: a
          },
          b = d.a.runKernelFunc((t, e) => {
            const o = rt(s),
              l = K(c.shape, u.shape, n, i, r, a, !1, o),
              h = t.conv2d(c, u, l);
            return e([c, u]), h
          }, p, null, m.A, f);
        return l ? R(b, [b.shape[1], b.shape[2], b.shape[3]]) : b
      }
    });
    const re = Object(b.a)({
      conv1d_: function (t, e, n, r, s = "NWC", i = 1, a) {
        const o = Object(g.a)(t, "x", "conv1d"),
          u = Object(g.a)(e, "filter", "conv1d");
        let c = o,
          l = !1;
        2 === o.rank && (l = !0, c = R(o, [1, o.shape[0], o.shape[1]])), S.assert(3 === c.rank, () => `Error in conv1d: input must be rank 3, but got rank ${c.rank}.`), S.assert(3 === u.rank, () => "Error in conv1d: filter must be rank 3, but got rank " + `${u.rank}.`), null != a && S.assert(S.isInt(r), () => "Error in conv1d: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${r}.`), S.assert(c.shape[2] === u.shape[1], () => `Error in conv1d: depth of input (${c.shape[2]}) must match ` + `input depth for filter ${u.shape[1]}.`), S.assert(nt(n, i), () => "Error in conv1D: Either stride or dilation must be 1. " + `Got stride ${n} and dilation '${i}'`), S.assert("NWC" === s, () => `Error in conv1d: got dataFormat of ${s} but only NWC is currently supported.`);
        const h = R(u, [1, u.shape[0], u.shape[1], u.shape[2]]),
          d = R(c, [c.shape[0], 1, c.shape[1], c.shape[2]]),
          p = ne(d, h, [1, n], r, "NHWC", [1, i], a);
        return R(p, l ? [p.shape[2], p.shape[3]] : [p.shape[0], p.shape[2], p.shape[3]])
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const se = Object(b.a)({
      conv2DBackpropInput_: function (t, e, n, r, s, i = "NHWC", a) {
        S.assert(t.length === e.rank, () => "Length of inShape " + `(${t.length}) and rank of dy (${e.rank}) must match`);
        let o = t,
          u = e,
          c = !1;
        3 === e.rank && (c = !0, u = R(e, [1, e.shape[0], e.shape[1], e.shape[2]]), o = [1, t[0], t[1], t[2]]), S.assert(4 === o.length, () => "Error in conv2dDerInput: inShape must be length 4, but got length " + `${o.length}.`), S.assert(4 === u.rank, () => "Error in conv2dDerInput: dy must be rank 4, but got " + `rank ${u.rank}`), S.assert(4 === n.rank, () => "Error in conv2dDerInput: filter must be rank 4, but got " + `rank ${n.rank}`);
        const l = "NHWC" === i ? o[3] : o[1],
          h = "NHWC" === i ? u.shape[3] : u.shape[1];
        S.assert(l === n.shape[2], () => `Error in conv2dDerInput: depth of input (${l}) must ` + `match input depth for filter ${n.shape[2]}.`), S.assert(h === n.shape[3], () => `Error in conv2dDerInput: depth of output (${h}) must ` + `match output depth for filter ${n.shape[3]}.`), null != a && S.assert(S.isInt(s), () => "Error in conv2dDerInput: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${s}.`);
        const p = {
            dy: u,
            filter: n
          },
          f = {
            strides: r,
            pad: s,
            dataFormat: i,
            dimRoundingMode: a,
            inputShape: o
          },
          g = d.a.runKernelFunc((t, e) => {
            const c = rt(i),
              l = K(o, n.shape, r, 1, s, a, !1, c),
              h = t.conv2dDerInput(u, n, l);
            return e([u, n]), h
          }, p, null, m.C, f);
        return c ? R(g, [g.shape[1], g.shape[2], g.shape[3]]) : g
      }
    });
    const ie = Object(b.a)({
      conv2dTranspose_: function (t, e, n, r, s, i) {
        const a = Object(g.a)(t, "x", "conv2dTranspose"),
          o = Object(g.a)(e, "filter", "conv2dTranspose");
        return se(n, a, o, r, s, "NHWC", i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ae = Object(b.a)({
      conv3d_: function (t, e, n, r, s = "NDHWC", i = [1, 1, 1]) {
        const a = Object(g.a)(t, "x", "conv3d"),
          o = Object(g.a)(e, "filter", "conv3d");
        let u = a,
          c = !1;
        4 === a.rank && (c = !0, u = R(a, [1, a.shape[0], a.shape[1], a.shape[2], a.shape[3]])), S.assert(5 === u.rank, () => `Error in conv3d: input must be rank 5, but got rank ${u.rank}.`), S.assert(5 === o.rank, () => "Error in conv3d: filter must be rank 5, but got rank " + `${o.rank}.`), S.assert(u.shape[4] === o.shape[3], () => `Error in conv3d: depth of input (${u.shape[4]}) must match ` + `input depth for filter ${o.shape[3]}.`), S.assert(nt(n, i), () => "Error in conv3D: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '${i}'`), S.assert("NDHWC" === s, () => `Error in conv3d: got dataFormat of ${s} but only NDHWC is currently supported.`);
        const l = {
            x: u,
            filter: o
          },
          h = {
            strides: n,
            pad: r,
            dataFormat: s,
            dilations: i
          },
          p = d.a.runKernelFunc((t, e) => {
            const s = J(u.shape, o.shape, n, i, r),
              a = t.conv3d(u, o, s);
            return e([u, o]), a
          }, l, null, m.D, h);
        return c ? R(p, [p.shape[1], p.shape[2], p.shape[3], p.shape[4]]) : p
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const oe = Object(b.a)({
      conv3DBackpropInput_: function (t, e, n, r, s) {
        S.assert(t.length === e.rank, () => "Length of inShape " + `(${t.length}) and rank of dy (${e.rank}) must match`);
        let i = t,
          a = e,
          o = !1;
        4 === e.rank && (o = !0, a = R(e, [1, e.shape[0], e.shape[1], e.shape[2], e.shape[3]]), i = [1, t[0], t[1], t[2], t[3]]);
        const u = i[4],
          c = a.shape[4];
        S.assert(5 === i.length, () => "Error in conv3dDerInput: inShape must be length 5, but got length " + `${i.length}.`), S.assert(5 === a.rank, () => "Error in conv3dDerInput: dy must be rank 5, but got " + `rank ${a.rank}`), S.assert(5 === n.rank, () => "Error in conv3dDerInput: filter must be rank 5, but got " + `rank ${n.rank}`), S.assert(u === n.shape[3], () => `Error in conv3dDerInput: depth of input (${u}) must ` + `match input depth for filter ${n.shape[3]}.`), S.assert(c === n.shape[4], () => `Error in conv3dDerInput: depth of output (${c}) must ` + `match output depth for filter ${n.shape[4]}.`);
        const l = {
            dy: a
          },
          h = {
            pad: s
          },
          p = d.a.runKernelFunc(t => {
            const e = J(i, n.shape, r, 1, s);
            return t.conv3dDerInput(a, n, e)
          }, l, null, m.F, h);
        return o ? R(p, [p.shape[1], p.shape[2], p.shape[3], p.shape[4]]) : p
      }
    });
    const ue = Object(b.a)({
      conv3dTranspose_: function (t, e, n, r, s) {
        const i = Object(g.a)(t, "x", "conv3dTranspose"),
          a = Object(g.a)(e, "filter", "conv3dTranspose");
        return oe(n, i, a, r, s)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ce = Object(b.a)({
      cos_: function (t) {
        const e = Object(g.a)(t, "x", "cos"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.cos(e);
          return n([e]), r
        }, n, null, m.G)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const le = Object(b.a)({
      cosh_: function (t) {
        const e = Object(g.a)(t, "x", "cosh"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.cosh(e);
          return n([e]), r
        }, n, null, m.H)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const he = Object(b.a)({
      cumsum_: function (t, e = 0, n = !1, r = !1) {
        const s = Object(g.a)(t, "x", "cumsum"),
          i = {
            x: s
          },
          a = {
            axis: e,
            exclusive: n,
            reverse: r
          };
        return d.a.runKernelFunc((t, i) => {
          const a = A([e], s.rank);
          let o = s;
          null != a && (o = j(s, a));
          const u = $(1, s.rank)[0];
          let c = t.cumsum(o, u, n, r);
          if (i([s]), null != a) {
            const t = N(a);
            c = j(c, t)
          }
          return c
        }, i, null, m.J, a)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const de = Object(b.a)({
      depthToSpace_: function (t, e, n = "NHWC") {
        const r = Object(g.a)(t, "x", "depthToSpace"),
          s = "NHWC" === n ? r.shape[1] : r.shape[2],
          i = "NHWC" === n ? r.shape[2] : r.shape[3],
          a = "NHWC" === n ? r.shape[3] : r.shape[1];
        S.assert(s * e >= 0, () => `Negative dimension size caused by overflow when multiplying\n    ${s} and ${e}  for depthToSpace with input shape\n    ${r.shape}`), S.assert(i * e >= 0, () => `Negative dimension size caused by overflow when multiplying\n    ${i} and ${e} for depthToSpace with input shape\n        ${r.shape}`), S.assert(a % (e * e) == 0, () => `Dimension size must be evenly divisible by ${e*e} but is ${a} for depthToSpace with input shape ${r.shape}`);
        const o = {
            x: r
          },
          u = {
            blockSize: e,
            dataFormat: n
          };
        return d.a.runKernelFunc(t => t.depthToSpace(r, e, n), o, null, m.K, u)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const pe = Object(b.a)({
      depthwiseConv2d_: function (t, e, n, r, s = "NHWC", i = [1, 1], a) {
        const o = Object(g.a)(t, "x", "depthwiseConv2d"),
          u = Object(g.a)(e, "filter", "depthwiseConv2d");
        let c = o,
          l = !1;
        3 === o.rank && (l = !0, c = R(o, [1, o.shape[0], o.shape[1], o.shape[2]])), S.assert(4 === c.rank, () => "Error in depthwiseConv2d: input must be rank 4, but got " + `rank ${c.rank}.`), S.assert(4 === u.rank, () => "Error in depthwiseConv2d: filter must be rank 4, but got rank " + `${u.rank}.`), S.assert(c.shape[3] === u.shape[2], () => "Error in depthwiseConv2d: number of input channels " + `(${c.shape[3]}) must match the inChannels dimension in ` + `filter ${u.shape[2]}.`), null != a && S.assert(S.isInt(r), () => "Error in depthwiseConv2d: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${r}.`);
        const h = {
            x: c,
            filter: u
          },
          p = {
            strides: n,
            pad: r,
            dataFormat: s,
            dilations: i,
            dimRoundingMode: a
          },
          f = d.a.runKernelFunc((t, e) => {
            null == i && (i = [1, 1]), S.assert(nt(n, i), () => "Error in depthwiseConv2d: Either strides or dilations must be " + `1. Got strides ${n} and dilations '${i}'`);
            const s = K(c.shape, u.shape, n, i, r, a, !0),
              o = t.depthwiseConv2D(c, u, s);
            return e([c, u]), o
          }, h, null, m.L, p);
        return l ? R(f, [f.shape[1], f.shape[2], f.shape[3]]) : f
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const fe = Object(b.a)({
      diag_: function (t) {
        const e = Object(g.a)(t, "x", "diag"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(n => {
          const r = R(e, [e.size]),
            s = n.diag(r),
            i = [...t.shape, ...t.shape];
          return R(s, i)
        }, n, null, m.O)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const me = Object(b.a)({
      dilation2d_: function (t, e, n, r, s = [1, 1], i = "NHWC") {
        const a = Object(g.a)(t, "x", "dilation2d"),
          o = Object(g.a)(e, "filter", "dilation2d");
        S.assert(3 === a.rank || 4 === a.rank, () => "Error in dilation2d: input must be rank 3 or 4, but got rank " + `${a.rank}.`), S.assert(3 === o.rank, () => "Error in dilation2d: filter must be rank 3, but got rank " + `${o.rank}.`), S.assert("NHWC" === i, () => "Error in dilation2d: Only NHWC is currently supported, " + `but got dataFormat of ${i}`);
        let u = a,
          c = !1;
        3 === a.rank && (u = R(a, [1, a.shape[0], a.shape[1], a.shape[2]]), c = !0);
        const l = {
            x: u,
            filter: o
          },
          h = {
            strides: n,
            pad: r,
            dilations: s
          },
          p = d.a.runKernel(m.P, l, h);
        return c ? R(p, [p.shape[1], p.shape[2], p.shape[3]]) : p
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ge = Object(b.a)({
      floorDiv_: function (t, e) {
        let n = Object(g.a)(t, "a", "floorDiv"),
          r = Object(g.a)(e, "b", "floorDiv");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.floorDiv(n, r);
          return e([n, r]), s
        }, s, null, m.db)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const be = Object(b.a)({
      div_: function (t, e) {
        let n = Object(g.a)(t, "a", "div"),
          r = Object(g.a)(e, "b", "div");
        if ([n, r] = Object(x.makeTypesMatch)(n, r), "int32" === n.dtype && "int32" === r.dtype) return ge(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.realDivide(n, r);
          return e([n, r]), s
        }, s, null, m.S, {})
      }
    });
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ye(t, e) {
      const n = t.length,
        r = [];
      for (let s = 0; s < n; s++) {
        const i = n - 1 - s,
          a = t[i] || 1;
        (e[e.length - 1 - s] || 1) > 1 && 1 === a && r.unshift(i)
      }
      return r
    }

    function we(t, e) {
      const n = [];
      for (let r = 0; r < e.length; r++) {
        const s = t[t.length - r - 1],
          i = e.length - r - 1,
          a = e[i];
        (null == s || 1 === s && a > 1) && n.unshift(i)
      }
      return n
    }

    function ve(t, e) {
      const n = [],
        r = Math.max(t.length, e.length);
      for (let s = 0; s < r; s++) {
        let r = t[t.length - s - 1];
        null == r && (r = 1);
        let i = e[e.length - s - 1];
        if (null == i && (i = 1), 1 === r) n.unshift(i);
        else if (1 === i) n.unshift(r);
        else {
          if (r !== i) {
            throw Error("Operands could not be broadcast together with shapes " + `${t} and ${e}.`)
          }
          n.unshift(r)
        }
      }
      return n
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const xe = Object(b.a)({
      equal_: function (t, e) {
        let n = Object(g.a)(t, "a", "equal"),
          r = Object(g.a)(e, "b", "equal");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc(t => t.equal(n, r), s, null, m.V)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Oe = Object(b.a)({
      where_: function (t, e, n) {
        const r = Object(g.a)(e, "a", "where"),
          s = Object(g.a)(n, "b", "where"),
          i = Object(g.a)(t, "condition", "where", "bool"),
          a = ve(r.shape, s.shape),
          o = qt(r, a),
          u = qt(s, a);
        1 === i.rank && Object(S.assert)(i.shape[0] === r.shape[0], () => "The first dimension of `a` must match the size of `condition`."), 1 !== i.rank && Object(S.assertShapesMatch)(i.shape, u.shape, "Error in where: ");
        const c = {
          condition: i,
          t: o,
          e: u
        };
        return d.a.runKernelFunc((t, e) => {
          const n = t.select(i, o, u);
          return e([i]), n
        }, c, null, m.oc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Se = Object(b.a)({
      zerosLike_: function (t) {
        const e = Object(g.a)(t, "x", "zerosLike"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.zerosLike(e), n, null, m.Oc)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const _e = Object(b.a)({
      divNoNan_: function (t, e) {
        let n = Object(g.a)(t, "a", "div"),
          r = Object(g.a)(e, "b", "div");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = be(n, r),
          i = Se(s),
          a = xe(r, i);
        return Oe(a, i, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ke = Object(b.a)({
      dot_: function (t, e) {
        const n = Object(g.a)(t, "t1", "dot"),
          r = Object(g.a)(e, "t2", "dot");
        S.assert(!(1 !== n.rank && 2 !== n.rank || 1 !== r.rank && 2 !== r.rank), () => "Error in dot: inputs must all be rank 1 or 2, but got ranks " + `${n.rank} and ${r.rank}.`);
        const s = 1 === n.rank ? n.size : n.shape[1],
          i = 1 === r.rank ? r.size : r.shape[0];
        if (S.assert(s === i, () => "Error in dot: inner dimensions of inputs must match, but got " + `${s} and ${i}.`), 1 === n.rank && 1 === r.rank) {
          const t = R(n, [1, -1]),
            e = R(r, [-1, 1]),
            s = vt(t, e);
          return R(s, [])
        }
        if (1 === n.rank && 2 === r.rank) {
          const t = R(n, [1, -1]),
            e = R(r, [r.shape[0], r.shape[1]]),
            s = vt(t, e);
          return R(s, [s.size])
        }
        if (2 === n.rank && 1 === r.rank) {
          const t = R(r, [-1, 1]),
            e = vt(n, t);
          return R(e, [e.size])
        } {
          const t = R(r, [r.shape[0], r.shape[1]]);
          return vt(n, t)
        }
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ce = Object(b.a)({
      elu_: function (t) {
        const e = Object(g.a)(t, "x", "elu"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.elu(e);
          return n([r]), r
        }, n, null, m.T)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ee = Object(b.a)({
      erf_: function (t) {
        let e = Object(g.a)(t, "x", "erf");
        S.assert("int32" === e.dtype || "float32" === e.dtype, () => "Input dtype must be `int32` or `float32`."), "int32" === e.dtype && (e = V(e, "float32"));
        const n = {
          x: e
        };
        return d.a.runKernelFunc((t, n) => {
          const r = t.erf(e);
          return n([e]), r
        }, n, null, m.W)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ie = Object(b.a)({
      exp_: function (t) {
        const e = Object(g.a)(t, "x", "exp"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.exp(e);
          return n([r]), r
        }, n, null, m.X)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Te = Object(b.a)({
      expandDims_: function (t, e = 0) {
        const n = Object(g.a)(t, "x", "expandDims", null);
        S.assert(e <= n.rank, () => "Axis must be <= rank of the tensor");
        const r = n.shape.slice();
        return e < 0 && (S.assert(-(n.rank + 1) <= e, () => `Axis must be in the interval [${-(n.rank+1)}, ${n.rank}]`), e = n.rank + e + 1), r.splice(e, 0, 1), R(n, r)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ae = Object(b.a)({
      expm1_: function (t) {
        const e = Object(g.a)(t, "x", "expm1"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.expm1(e);
          return n([e]), r
        }, n, null, m.Y)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ne = Object(b.a)({
      tile_: function (t, e) {
        const n = Object(g.a)(t, "x", "tile", null);
        S.assert(n.rank === e.length, () => `Error in transpose: rank of input ${n.rank} ` + `must match length of reps ${e}.`);
        const r = [n],
          s = {
            x: n
          },
          i = {
            reps: e
          };
        return d.a.runKernelFunc((t, r) => {
          const s = t.tile(n, e);
          return r([n]), s
        }, s, null, m.Jc, i, r)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const $e = Object(b.a)({
      eye_: function (t, e, n, r = "float32") {
        null == e && (e = t);
        const s = Kt([t, e], r),
          i = t <= e ? t : e;
        for (let t = 0; t < i; ++t) s.set(1, t, t);
        const a = R(s.toTensor(), [t, e]);
        if (null == n) return a;
        if (1 === n.length) return Ne(Te(a, 0), [n[0], 1, 1]);
        if (2 === n.length) return Ne(Te(Te(a, 0), 0), [n[0], n[1], 1, 1]);
        if (3 === n.length) return Ne(Te(Te(Te(a, 0), 0), 0), [n[0], n[1], n[2], 1, 1]);
        throw new Error("eye() currently supports only 1D and 2D " + `batchShapes, but received ${n.length}D.`)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Re = Object(b.a)({
      fft_: function (t) {
        Object(S.assert)("complex64" === t.dtype, () => "The dtype for tf.spectral.fft() must be complex64 " + `but got ${t.dtype}.`);
        const e = {
          input: t
        };
        return d.a.runKernelFunc(e => {
          const n = t.shape[t.shape.length - 1],
            r = t.size / n,
            s = t.as2D(r, n);
          return e.fft(s).reshape(t.shape)
        }, e, null, m.Z)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function je(t, e, n) {
      const r = {
        shape: t,
        value: e,
        dtype: n
      };
      return d.a.runKernelFunc(r => r.fill(t, e, n), {}, null, m.ab, r)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const De = Object(b.a)({
        floor_: function (t) {
          const e = Object(g.a)(t, "x", "floor"),
            n = {
              x: e
            };
          return d.a.runKernelFunc(t => t.floor(e), n, null, m.cb)
        }
      }),
      Fe = 30;
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Me(t) {
      return t <= Fe ? t : Object(S.nearestDivisor)(t, Math.floor(Math.sqrt(t)))
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ze(t, e) {
      let n, r = !1;
      for (t <= Fe ? (n = t, r = !0) : n = Object(S.nearestDivisor)(t, Math.floor(Math.sqrt(t))); !r;) n > e || n === t ? r = !0 : n = Object(S.nearestDivisor)(t, n + 1);
      return n
    }

    function Le(t, e, n) {
      const r = [],
        s = t.length;
      for (let i = 0; i < s; i++) i !== e ? r.push(t[i]) : r.push(n);
      return r
    }

    function Be(t, e, n) {
      const r = t.shape[n],
        s = [];
      let i = 1,
        a = 1;
      for (let e = 0; e < n; e++) s.push(t.shape[e]), i *= t.shape[e];
      for (let t = 0; t < e.rank; t++) s.push(e.shape[t]);
      for (let e = n + 1; e < t.rank; e++) s.push(t.shape[e]), a *= t.shape[e];
      return {
        batchSize: i,
        sliceSize: a,
        dimSize: r,
        outputShape: s
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Pe = Object(b.a)({
      gather_: function (t, e, n = 0) {
        const r = Object(g.a)(t, "x", "gather"),
          s = Object(g.a)(e, "indices", "gather", "int32"),
          i = {
            x: r,
            indices: s
          },
          a = {
            axis: n
          };
        return d.a.runKernelFunc((t, e) => {
          const i = Object(S.parseAxisParam)(n, r.shape)[0],
            a = Be(r, s, i),
            o = t.gather(r, R(s, [s.size]), i);
          return e([r, s]), R(o, a.outputShape)
        }, i, null, m.jb, a)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const We = Object(b.a)({
      greater_: function (t, e) {
        let n = Object(g.a)(t, "a", "greater"),
          r = Object(g.a)(e, "b", "greater");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc(t => t.greater(n, r), s, null, m.kb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ue = Object(b.a)({
      greaterEqual_: function (t, e) {
        let n = Object(g.a)(t, "a", "greaterEqual"),
          r = Object(g.a)(e, "b", "greaterEqual");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.greaterEqual(n, r);
          return e([n, r]), s
        }, s, null, m.lb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ve = Object(b.a)({
      ifft_: function (t) {
        Object(S.assert)("complex64" === t.dtype, () => "The dtype for tf.spectral.ifft() must be complex64 " + `but got ${t.dtype}.`);
        const e = {
          input: t
        };
        return d.a.runKernelFunc(e => {
          const n = t.shape[t.shape.length - 1],
            r = t.size / n,
            s = R(t, [r, n]),
            i = e.ifft(s);
          return R(i, t.shape)
        }, e, null, m.mb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const He = Object(b.a)({
      imag_: function (t) {
        const e = Object(g.a)(t, "input", "imag"),
          n = {
            input: e
          };
        return d.a.runKernelFunc(t => t.imag(e), n, null, m.ob)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ge = Object(b.a)({
      real_: function (t) {
        const e = Object(g.a)(t, "input", "real"),
          n = {
            input: e
          };
        return d.a.runKernelFunc(t => t.real(e), n, null, m.ac)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const qe = Object(b.a)({
      reverse_: function (t, e) {
        const n = Object(g.a)(t, "x", "reverse"),
          r = {
            x: n
          },
          s = {
            dims: e
          };
        return d.a.runKernelFunc(t => {
          const r = Object(S.parseAxisParam)(e, n.shape);
          if (0 === n.rank) return Gt(n);
          const s = t.reverse(n, r);
          return R(s, n.shape)
        }, r, null, m.jc, s)
      }
    });
    var Ke = n(14);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Je(t, e) {
      if ((Object(S.isTypedArray)(t) && "string" !== e || Array.isArray(t)) && "complex64" !== e) throw new Error("Error creating a new Scalar: value must be a primitive (number|boolean|string)");
      if ("string" === e && Object(S.isTypedArray)(t) && !(t instanceof Uint8Array)) throw new Error("When making a scalar from encoded string, the value must be `Uint8Array`.");
      return Object(Ke.a)(t, [], [], e)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Xe = Object(b.a)({
      irfft_: function (t) {
        const e = t.shape[t.shape.length - 1],
          n = t.size / e;
        let r;
        if (e <= 2) {
          const s = R(t, [n, e]);
          r = Ve(s)
        } else {
          const s = [n, 2 * (e - 1)],
            i = R(Ge(t), [n, e]),
            a = R(He(t), [n, e]),
            o = qe(Mt(i, [0, 1], [n, e - 2]), 1),
            u = xt(qe(Mt(a, [0, 1], [n, e - 2]), 1), Je(-1)),
            c = wt([i, o], 1),
            l = wt([a, u], 1),
            h = R(Object(Yt.a)(c, l), [s[0], s[1]]);
          r = Ve(h)
        }
        if (r = Ge(r), 3 === t.rank && 0 !== t.shape[0]) {
          const e = r,
            n = t.shape[0];
          r = R(r, [n, r.shape[0] / n, r.shape[1]]), e.dispose()
        }
        return r
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ye = Object(b.a)({
      isFinite_: function (t) {
        const e = Object(g.a)(t, "x", "isFinite"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.isFinite(e), n, null, m.pb)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ze = Object(b.a)({
      isInf_: function (t) {
        const e = Object(g.a)(t, "x", "isInf"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.isInf(e), n, null, m.qb)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Qe = Object(b.a)({
      isNaN_: function (t) {
        const e = Object(g.a)(t, "x", "isNaN"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.isNaN(e), n, null, m.rb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const tn = Object(b.a)({
      maximum_: function (t, e) {
        let n = Object(g.a)(t, "a", "maximum"),
          r = Object(g.a)(e, "b", "maximum");
        [n, r] = Object(x.makeTypesMatch)(n, r), "bool" === n.dtype && (n = V(n, "int32"), r = V(r, "int32")), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.maximum(n, r);
          return e([n, r]), s
        }, s, null, m.Jb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const en = Object(b.a)({
      leakyRelu_: function (t, e = .2) {
        const n = Object(g.a)(t, "x", "leakyRelu");
        return tn(xt(Je(e), n), n)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const nn = Object(b.a)({
      less_: function (t, e) {
        let n = Object(g.a)(t, "a", "less"),
          r = Object(g.a)(e, "b", "less");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc(t => t.less(n, r), s, null, m.ub)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const rn = Object(b.a)({
      lessEqual_: function (t, e) {
        let n = Object(g.a)(t, "a", "lessEqual"),
          r = Object(g.a)(e, "b", "lessEqual");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.lessEqual(n, r);
          return e([n, r]), s
        }, s, null, m.vb)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function sn(t, e, n) {
      if (n <= 0) throw new Error("The number of values should be positive.");
      const r = {
        start: t,
        stop: e,
        num: n
      };
      return d.a.runKernelFunc(r => r.linspace(t, e, n), {}, null, m.wb, r)
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const an = Object(b.a)({
      localResponseNormalization_: function (t, e = 5, n = 1, r = 1, s = .5) {
        const i = Object(g.a)(t, "x", "localResponseNormalization");
        S.assert(4 === i.rank || 3 === i.rank, () => `Error in localResponseNormalization: x must be rank 3 or 4 but got\n               rank ${i.rank}.`), S.assert(S.isInt(e), () => "Error in localResponseNormalization: depthRadius must be an " + `integer but got depthRadius ${e}.`);
        let a = i,
          o = !1;
        3 === i.rank && (o = !0, a = R(i, [1, i.shape[0], i.shape[1], i.shape[2]]));
        const u = {
            x: a
          },
          c = {
            depthRadius: e,
            bias: n,
            alpha: r,
            beta: s
          },
          l = d.a.runKernelFunc((t, i) => {
            const o = t.localResponseNormalization4D(a, e, n, r, s);
            return i([a, o]), o
          }, u, null, m.sb, c);
        return o ? R(l, [l.shape[1], l.shape[2], l.shape[3]]) : l
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const on = Object(b.a)({
      log_: function (t) {
        const e = Object(g.a)(t, "x", "log"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.log(e);
          return n([e]), r
        }, n, null, m.xb)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const un = Object(b.a)({
      log1p_: function (t) {
        const e = Object(g.a)(t, "x", "log1p"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.log1p(e);
          return n([e]), r
        }, n, null, m.yb)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function cn(t, e) {
      S.assert(S.isFunction(t), () => "The f passed in variableGrads(f) must be a function"), S.assert(null == e || Array.isArray(e) && e.every(t => t instanceof it.c), () => "The varList passed in variableGrads(f, varList) must be an array of variables");
      const n = null != e;
      if (!n) {
        e = [];
        for (const t in d.a.registeredVariables) e.push(d.a.registeredVariables[t])
      }
      const r = n ? e.filter(t => !t.trainable) : null,
        s = e.length;
      e = e.filter(t => t.trainable), S.assert(e.length > 0, () => "variableGrads() expects at least one of the input variables to " + `be trainable, but none of the ${s} variables is ` + "trainable.");
      const {
        value: i,
        grads: a
      } = d.a.gradients(t, e, null, !0);
      S.assert(a.some(t => null != t), () => "Cannot find a connection between any variable and the result of the loss function y=f(x). Please make sure the operations that use variables are inside the function f passed to minimize()."), S.assert(0 === i.rank, () => "The f passed in variableGrads(f) must return a scalar, but it " + `returned a rank-${i.rank} tensor`);
      const o = {};
      return e.forEach((t, e) => {
        null != a[e] && (o[t.name] = a[e])
      }), null != r && r.forEach(t => o[t.name] = null), {
        value: i,
        grads: o
      }
    }

    function ln(t) {
      return d.a.customGrad(t)
    }
    const hn = Object(b.a)({
      neg_:
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t) {
          const e = Object(g.a)(t, "x", "neg"),
            n = {
              x: e
            };
          return d.a.runKernelFunc(t => t.neg(e), n, null, m.Ob)
        }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const dn = Object(b.a)({
      softplus_: function (t) {
        const e = Object(g.a)(t, "x", "softplus"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.softplus(e);
          return n([e]), r
        }, n, null, m.wc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const pn = Object(b.a)({
      logSigmoid_: function (t) {
        const e = Object(g.a)(t, "x", "logSigmoid");
        return ln(t => {
          return {
            value: hn(dn(hn(t))),
            gradFunc: e => {
              return xt(e, Ot(hn(t)))
            }
          }
        })(e)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const fn = Object(b.a)({
      max_: function (t, e = null, n = !1) {
        const r = Object(g.a)(t, "x", "max"),
          s = {
            x: r
          },
          i = {
            reductionIndices: e,
            keepDims: n
          };
        return d.a.runKernelFunc((t, s) => {
          let i = S.parseAxisParam(e, r.shape);
          const a = A(i, r.rank);
          let o = r;
          null != a && (o = j(r, a), i = $(i.length, o.rank));
          const u = t.max(o, i);
          null != a && o.dispose();
          let c = u;
          if (n) {
            const t = I(c.shape, S.parseAxisParam(e, r.shape));
            c = R(c, t), u.dispose()
          }
          return s([r, c]), c
        }, s, null, m.Db, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const mn = Object(b.a)({
      sub_: function (t, e) {
        let n = Object(g.a)(t, "a", "sub"),
          r = Object(g.a)(e, "b", "sub");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.subtract(n, r);
          return e([n, r]), s
        }, s, null, m.Fc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const gn = Object(b.a)({
      sum_: function (t, e = null, n = !1) {
        let r = Object(g.a)(t, "x", "sum");
        "bool" === r.dtype && (r = V(r, "int32"));
        const s = {
            x: r
          },
          i = {
            axis: e,
            keepDims: n
          };
        return d.a.runKernelFunc((t, s) => {
          s([r]);
          const i = Object(S.parseAxisParam)(e, r.shape),
            a = A(i, r.rank);
          let o = i,
            u = r;
          null != a && (u = j(r, a), o = $(o.length, r.rank));
          let c = t.sum(u, o);
          if (n) {
            const t = I(c.shape, i);
            c = R(c, t)
          }
          return c
        }, s, null, m.Gc, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const bn = Object(b.a)({
      logSoftmax_: function (t, e = -1) {
        const n = Object(g.a)(t, "logits", "logSoftmax");
        if (-1 === e && (e = n.rank - 1), e !== n.rank - 1) throw Error("Log Softmax along a non-last dimension is not yet supported. " + `Logits was rank ${n.rank} and axis was ${e}`);
        const r = {
            logits: n
          },
          s = {
            axis: e
          };
        return d.a.runKernelFunc((n, r) => {
          const s = fn(t, e, !0),
            i = mn(t, s),
            a = mn(V(i, "float32"), on(gn(Ie(i), e, !0)));
          return r([a]), a
        }, r, null, m.zb, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const yn = Object(b.a)({
      logSumExp_: function (t, e = null, n = !1) {
        const r = Object(g.a)(t, "x", "logSumExp"),
          s = Object(S.parseAxisParam)(e, r.shape),
          i = fn(r, s, !0),
          a = mn(r, i),
          o = Ie(a),
          u = gn(o, s),
          c = on(u),
          l = O(R(i, c.shape), c);
        if (n) {
          const t = I(l.shape, s);
          return R(l, t)
        }
        return l
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const wn = Object(b.a)({
      logicalAnd_: function (t, e) {
        const n = Object(g.a)(t, "a", "logicalAnd", "bool"),
          r = Object(g.a)(e, "b", "logicalAnd", "bool");
        ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc(t => t.logicalAnd(n, r), s, null, m.Ab)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const vn = Object(b.a)({
      logicalNot_: function (t) {
        const e = Object(g.a)(t, "x", "logicalNot", "bool"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.logicalNot(e), n, null, m.Bb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const xn = Object(b.a)({
      logicalOr_: function (t, e) {
        const n = Object(g.a)(t, "a", "logicalOr", "bool"),
          r = Object(g.a)(e, "b", "logicalOr", "bool");
        ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc(t => t.logicalOr(n, r), s, null, m.Cb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const On = Object(b.a)({
      logicalXor_: function (t, e) {
        const n = Object(g.a)(t, "a", "logicalXor", "bool"),
          r = Object(g.a)(e, "b", "logicalXor", "bool");
        return ve(n.shape, r.shape), wn(xn(t, e), vn(wn(t, e)))
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Sn = Object(b.a)({
      maxPool_: function (t, e, n, r, s) {
        const i = Object(g.a)(t, "x", "maxPool");
        let a = i,
          o = !1;
        3 === i.rank && (o = !0, a = R(i, [1, i.shape[0], i.shape[1], i.shape[2]])), S.assert(4 === a.rank, () => `Error in maxPool: input must be rank 4 but got rank ${a.rank}.`), S.assert(nt(n, 1), () => "Error in maxPool: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '1'`), null != s && S.assert(S.isInt(r), () => "Error in maxPool: pad must be an integer when using, " + `dimRoundingMode ${s} but got pad ${r}.`);
        const u = {
            x: a
          },
          c = {
            filterSize: e,
            strides: n,
            pad: r,
            dimRoundingMode: s
          },
          l = d.a.runKernelFunc((t, i) => {
            const o = G(a.shape, e, n, 1, r, s);
            let u;
            return u = 1 === o.filterWidth && 1 === o.filterHeight && S.arraysEqual(o.inShape, o.outShape) ? a.clone() : t.maxPool(a, o), i([a, u]), u
          }, u, null, m.Eb, c);
        return o ? R(l, [l.shape[1], l.shape[2], l.shape[3]]) : l
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const _n = Object(b.a)({
      maxPool3d_: function (t, e = [1, 1, 1], n, r, s, i = "NDHWC", a) {
        null == a ? a = [1, 1, 1] : at("dilations is deprecated, this field will be gone in v3.0.0.");
        const o = Object(g.a)(t, "x", "maxPool3d");
        let u = o,
          c = !1;
        4 === o.rank && (c = !0, u = R(o, [1, o.shape[0], o.shape[1], o.shape[2], o.shape[3]])), S.assert(5 === u.rank, () => `Error in maxPool3d: x must be rank 5 but got rank ${u.rank}.`), S.assert("NDHWC" === i, () => "Error in maxPool3d: Only NDHWC is currently supported, " + `but got dataFormat of ${i}`), S.assert(nt(n, a), () => "Error in maxPool3d: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '${a}'`), null != s && S.assert(S.isInt(r), () => "Error in maxPool3d: pad must be an integer when using, " + `dimRoundingMode ${s} but got pad ${r}.`);
        const l = {
            x: u
          },
          h = {
            filterSize: e,
            strides: n,
            pad: r,
            dimRoundingMode: s,
            dataFormat: i,
            dilations: a
          },
          p = d.a.runKernelFunc((t, o) => {
            null == a && (a = [1, 1, 1]);
            const c = q(u.shape, e, n, a, r, s, i),
              l = t.maxPool3d(u, c);
            return o([u, l]), l
          }, l, null, m.Fb, h);
        return c ? R(p, [p.shape[1], p.shape[2], p.shape[3], p.shape[4]]) : p
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const kn = Object(b.a)({
      maxPoolWithArgmax_: function (t, e, n, r, s = !1) {
        const i = {
            x: Object(g.a)(t, "x", "maxPoolWithArgmax")
          },
          a = {
            filterSize: e,
            strides: n,
            pad: r,
            includeBatchInIndex: s
          },
          o = d.a.runKernel(m.Ib, i, a);
        return {
          result: o[0],
          indexes: o[1]
        }
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Cn(t, e = "float32") {
      if ("complex64" === e) {
        const e = Cn(t, "float32"),
          n = Cn(t, "float32");
        return Object(Yt.a)(e, n)
      }
      const n = Object(S.makeZerosTypedArray)(Object(S.sizeFromShape)(t), e);
      return d.a.makeTensor(n, t, e)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function En(t, e = "float32") {
      if ("complex64" === e) {
        const e = En(t, "float32"),
          n = Cn(t, "float32");
        return Object(Yt.a)(e, n)
      }
      const n = Object(S.makeOnesTypedArray)(Object(S.sizeFromShape)(t), e);
      return d.a.makeTensor(n, t, e)
    }
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const In = Object(b.a)({
      mean_: function (t, e = null, n = !1) {
        const r = Object(g.a)(t, "x", "mean"),
          s = Object(S.parseAxisParam)(e, r.shape),
          i = E(r.shape, s)[1],
          a = Object(S.sizeFromShape)(i);
        return ln(t => {
          const r = Je(a),
            i = r.dtype === t.dtype ? t : V(t, r.dtype),
            o = be(i, r);
          return {
            value: gn(o, e, n),
            gradFunc: e => {
              const n = t.shape.slice();
              s.forEach(t => {
                n[t] = 1
              });
              const r = R(e, n);
              return be(xt(r, En(t.shape, "float32")), a)
            }
          }
        })(r)
      }
    });
    const Tn = Object(b.a)({
      min_: function (t, e = null, n = !1) {
        const r = Object(g.a)(t, "x", "min"),
          s = {
            x: r
          },
          i = {
            axis: e,
            keepDims: n
          };
        return d.a.runKernelFunc((t, s) => {
          const i = Object(S.parseAxisParam)(e, r.shape);
          let a = i;
          const o = A(a, r.rank);
          let u = r;
          null != o && (u = j(r, o), a = $(a.length, r.rank));
          const c = t.min(u, a);
          null != o && u.dispose();
          let l = c;
          if (n) {
            const t = I(l.shape, i);
            l = R(c, t), c.dispose()
          }
          return s([r, l]), l
        }, s, null, m.Kb, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const An = Object(b.a)({
      minimum_: function (t, e) {
        let n = Object(g.a)(t, "a", "minimum"),
          r = Object(g.a)(e, "b", "minimum");
        [n, r] = Object(x.makeTypesMatch)(n, r), "bool" === n.dtype && (n = V(n, "int32"), r = V(r, "int32")), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.minimum(n, r);
          return e([n, r]), s
        }, s, null, m.Lb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Nn = Object(b.a)({
      mod_: function (t, e) {
        let n = Object(g.a)(t, "a", "mod"),
          r = Object(g.a)(e, "b", "mod");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.mod(n, r);
          return e([n, r]), s
        }, s, null, m.Mb)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const $n = Object(b.a)({
      square_: function (t) {
        const e = Object(g.a)(t, "x", "square"),
          n = [e];
        return d.a.runKernelFunc((t, n) => (n([e]), t.square(e)), {
          x: e
        }, null, "Square", {}, n, [])
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Rn = Object(b.a)({
      moments_: function (t, e = null, n = !1) {
        t = Object(g.a)(t, "x", "moments");
        const r = Object(S.parseAxisParam)(e, t.shape),
          s = In(t, r, n);
        let i = s.shape;
        n || (i = I(s.shape, r));
        const a = $n(mn(V(t, "float32"), R(s, i)));
        return {
          mean: s,
          variance: In(a, r, n)
        }
      }
    });
    const jn = Object(b.a)({
      multiRNNCell_: function (t, e, n, r) {
        const s = Object(g.a)(e, "data", "multiRNNCell"),
          i = Object(g.b)(n, "c", "multiRNNCell"),
          a = Object(g.b)(r, "h", "multiRNNCell");
        let o = s;
        const u = [];
        for (let e = 0; e < t.length; e++) {
          const n = t[e](o, i[e], a[e]);
          u.push(n[0]), u.push(n[1]), o = n[1]
        }
        const c = [],
          l = [];
        for (let t = 0; t < u.length; t += 2) c.push(u[t]), l.push(u[t + 1]);
        return [c, l]
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Dn = Object(b.a)({
      multinomial_: function (t, e, n, r = !1) {
        const s = Object(g.a)(t, "logits", "multinomial"),
          i = s.size,
          a = s.rank;
        if (i < 2) throw new Error("Error in multinomial: you need at least 2 outcomes, but got " + `${i}.`);
        if (a > 2) throw new Error(`Rank of probabilities must be 1 or 2, but is ${a}`);
        n = n || Math.random();
        const o = 1 === a ? R(s, [1, -1]) : s,
          u = d.a.runKernelFunc(t => t.multinomial(o, r, e, n), {
            logits2D: o
          });
        return 1 === a ? R(u, [u.size]) : u
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Fn = Object(b.a)({
      notEqual_: function (t, e) {
        let n = Object(g.a)(t, "a", "notEqual"),
          r = Object(g.a)(e, "b", "notEqual");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc(t => t.notEqual(n, r), s, null, m.Sb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Mn = Object(b.a)({
      oneHot_: function (t, e, n = 1, r = 0) {
        if (e < 2) throw new Error(`Error in oneHot: depth must be >=2, but it is ${e}`);
        const s = Object(g.a)(t, "indices", "oneHot", "int32"),
          i = [...s.shape, e],
          a = {
            indices: s
          },
          o = {
            depth: e,
            onValue: n,
            offValue: r
          };
        return d.a.runKernelFunc((t, a) => (a([s]), R(t.oneHot(R(s, [s.size]), e, n, r), i)), a, null, m.Tb, o)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const zn = Object(b.a)({
      onesLike_: function (t) {
        const e = Object(g.a)(t, "x", "onesLike"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          if ("complex64" === e.dtype) {
            const t = zn(Ge(e)),
              n = Se(He(e));
            return Object(Yt.a)(t, n)
          }
          return t.onesLike(e)
        }, n, null, m.Ub)
      }
    });
    const Ln = Object(b.a)({
      outerProduct_: function (t, e) {
        const n = Object(g.a)(t, "v1", "outerProduct"),
          r = Object(g.a)(e, "v2", "outerProduct");
        S.assert(1 === n.rank && 1 === r.rank, () => "Error in outerProduct: inputs must be rank 1, but got ranks " + `${n.rank} and ${r.rank}.`);
        const s = R(n, [-1, 1]),
          i = R(r, [1, -1]);
        return vt(s, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Bn = Object(b.a)({
      pad_: function (t, e, n = 0) {
        const r = Object(g.a)(t, "x", "pad");
        if (0 === r.rank) throw new Error("pad(scalar) is not defined. Pass non-scalar to pad");
        const s = {
            paddings: e,
            constantValue: n
          },
          i = {
            x: r
          };
        return d.a.runKernelFunc((t, s) => (s([r]), t.pad(r, e, n)), i, null, m.Vb, s)
      }
    });
    const Pn = Object(b.a)({
      pad1d_: function (t, e, n = 0) {
        return Object(S.assert)(2 === e.length, () => "Invalid number of paddings. Must be length of 2."), Bn(t, [e], n)
      }
    });
    const Wn = Object(b.a)({
      pad2d_: function (t, e, n = 0) {
        return Object(S.assert)(2 === e.length && 2 === e[0].length && 2 === e[1].length, () => "Invalid number of paddings. Must be length of 2 each."), Bn(t, e, n)
      }
    });
    const Un = Object(b.a)({
      pad3d_: function (t, e, n = 0) {
        return Object(S.assert)(3 === e.length && 2 === e[0].length && 2 === e[1].length && 2 === e[2].length, () => "Invalid number of paddings. Must be length of 2 each."), Bn(t, e, n)
      }
    });
    const Vn = Object(b.a)({
      pad4d_: function (t, e, n = 0) {
        return Object(S.assert)(4 === e.length && 2 === e[0].length && 2 === e[1].length && 2 === e[2].length && 2 === e[3].length, () => "Invalid number of paddings. Must be length of 2 each."), Bn(t, e, n)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Hn = Object(b.a)({
      spaceToBatchND_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "spaceToBatchND");
        S.assert(r.rank >= 1 + e.length, () => `input rank ${r.rank} should be > than [blockShape] ${e.length}`), S.assert(n.length === e.length, () => `paddings.shape[0] ${n.length} must be equal to [blockShape] ${e.length}`), S.assert(r.shape.reduce((t, r, s) => s > 0 && s <= e.length ? t && (r + n[s - 1][0] + n[s - 1][1]) % e[s - 1] == 0 : t, !0), () => `input spatial dimensions ${r.shape.slice(1)} with paddings ${n.toString()} must be divisible by blockShapes ${e.toString()}`);
        const s = {
            x: r
          },
          i = {
            blockShape: e,
            paddings: n
          };
        return d.a.runKernelFunc(t => t.spaceToBatchND(r, e, n), s, null, m.xc, i)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Gn = Object(b.a)({
      pool_: function (t, e, n, r, s, i) {
        null == s && (s = [1, 1]), null == i && (i = 1), 0 === r && (r = "valid");
        const a = Object(g.a)(t, "x", "maxPool");
        let o = a,
          u = !1;
        3 === a.rank && (u = !0, o = R(a, [1, a.shape[0], a.shape[1], a.shape[2]])), S.assert(nt(i, s), () => "Error in pool: Either strides or dilations must be 1. " + `Got strides ${i} and dilations '${s}'`);
        const c = G(o.shape, e, i, s, r),
          l = [c.dilationHeight, c.dilationWidth];
        let h;
        h = "same" === r ? function (t, e) {
          const n = t.map((t, n) => t + (t - 1) * (e[n] - 1)).map(t => t - 1),
            r = n.map(t => Math.floor(t / 2)),
            s = n.map((t, e) => t - r[e]);
          return n.map((t, e) => [r[e], s[e]])
        }([c.filterHeight, c.filterWidth], l) : [
          [0, 0],
          [0, 0]
        ];
        const d = 1 === l[0] && 1 === l[1],
          [p, f] = function (t, e, n) {
            const r = n.map(t => t[0]),
              s = n.map(t => t[1]),
              i = t.concat(r, s),
              a = e.map((t, e) => (t - i[e] % t) % t),
              o = s.map((t, e) => t + a[e]),
              u = e.map((t, e) => [r[e], o[e]]),
              c = e.map((t, e) => [0, a[e]]);
            return [u, c]
          }([c.inHeight, c.inWidth], l, h),
          m = d ? r : "valid",
          b = d ? o : Hn(o, l, p),
          y = ("avg" === n ? () => st(b, e, i, m) : () => Sn(b, e, i, m))(),
          w = d ? y : Bt(y, l, f);
        return u ? R(w, [w.shape[1], w.shape[2], w.shape[3]]) : w
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const qn = Object(b.a)({
      pow_: function (t, e) {
        let n = Object(g.a)(t, "base", "pow"),
          r = Object(g.a)(e, "exp", "pow");
        [n, r] = Object(x.makeTypesMatch)(n, r);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.pow(n, r);
          return e([n, r, s]), s
        }, s, null, m.Wb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Kn = Object(b.a)({
      prelu_: function (t, e) {
        const n = Object(g.a)(t, "x", "prelu"),
          r = Object(g.a)(e, "alpha", "prelu"),
          s = {
            x: n,
            alpha: r
          };
        return d.a.runKernelFunc((t, e) => {
          const s = t.prelu(n, r);
          return e([n, r]), s
        }, s, null, m.Xb)
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Jn(t, e = !1) {
      console.log(t.toString(e))
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Xn = Object(b.a)({
      prod_: function (t, e = null, n = !1) {
        let r = Object(g.a)(t, "x", "prod");
        const s = {
            x: r
          },
          i = {
            axis: e,
            keepDims: n
          };
        return d.a.runKernelFunc(t => {
          "bool" === r.dtype && (r = V(r, "int32"));
          const s = Object(S.parseAxisParam)(e, r.shape),
            i = A(s, r.rank);
          let a = s,
            o = r;
          null != i && (o = j(r, i), a = $(a.length, r.rank));
          let u = t.prod(o, a);
          if (n) {
            const t = I(u.shape, s);
            u = R(u, t)
          }
          return u
        }, s, null, m.Yb, i)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Yn = Object(b.a)({
      rand_: function (t, e, n) {
        const r = Object(S.sizeFromShape)(t);
        let s = null;
        if (null == n || "float32" === n) s = new Float32Array(r);
        else if ("int32" === n) s = new Int32Array(r);
        else {
          if ("bool" !== n) throw new Error(`Unknown data type ${n}`);
          s = new Uint8Array(r)
        }
        for (let t = 0; t < r; t++) s[t] = e();
        return d.a.makeTensor(s, t, n)
      }
    });
    var Zn = n(26);
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Qn {
      constructor(t, e, n, r, s) {
        this.mean = t, this.stdDev = e, this.dtype = n, this.nextVal = NaN, this.truncated = r, this.truncated && (this.upper = this.mean + 2 * this.stdDev, this.lower = this.mean - 2 * this.stdDev);
        const i = s || Math.random();
        this.random = Zn.alea(i.toString())
      }
      nextValue() {
        if (!isNaN(this.nextVal)) {
          const t = this.nextVal;
          return this.nextVal = NaN, t
        }
        let t, e, n = !1;
        for (; !n;) {
          let r, s, i;
          do {
            r = 2 * this.random() - 1, s = 2 * this.random() - 1, i = r * r + s * s
          } while (i >= 1 || 0 === i);
          const a = Math.sqrt(-2 * Math.log(i) / i);
          t = this.mean + this.stdDev * r * a, e = this.mean + this.stdDev * s * a, this.truncated && !this.isValidTruncated(t) || (n = !0)
        }
        return this.truncated && !this.isValidTruncated(e) || (this.nextVal = this.convertValue(e)), this.convertValue(t)
      }
      convertValue(t) {
        return null == this.dtype || "float32" === this.dtype ? t : Math.round(t)
      }
      isValidTruncated(t) {
        return t <= this.upper && t >= this.lower
      }
    }
    class tr {
      constructor(t, e, n, r) {
        this.alpha = t, this.beta = 1 / e, this.dtype = n;
        const s = r || Math.random();
        this.randu = Zn.alea(s.toString()), this.randn = new Qn(0, 1, n, !1, this.randu()), this.d = t < 1 ? t + 2 / 3 : t - 1 / 3, this.c = 1 / Math.sqrt(9 * this.d)
      }
      nextValue() {
        let t, e, n, r, s, i;
        for (;;) {
          do {
            r = this.randn.nextValue(), i = 1 + this.c * r
          } while (i <= 0);
          if (i *= i * i, t = r * r, e = 1 - .331 * t * t, n = .5 * t + this.d * (1 - i + Math.log(i)), s = this.randu(), s < e || Math.log(s) < n) break
        }
        return i = 1 / this.beta * this.d * i, this.alpha < 1 && (i *= Math.pow(this.randu(), 1 / this.alpha)), this.convertValue(i)
      }
      convertValue(t) {
        return "float32" === this.dtype ? t : Math.round(t)
      }
    }
    class er {
      constructor(t = 0, e = 1, n, r) {
        if (this.canReturnFloat = () => null == this.dtype || "float32" === this.dtype, this.min = t, this.range = e - t, this.dtype = n, null == r && (r = Math.random()), "number" == typeof r && (r = r.toString()), !this.canReturnFloat() && this.range <= 1) throw new Error(`The difference between ${t} - ${e} <= 1 and dtype is not float`);
        this.random = Zn.alea(r)
      }
      convertValue(t) {
        return this.canReturnFloat() ? t : Math.round(t)
      }
      nextValue() {
        return this.convertValue(this.min + this.range * this.random())
      }
    }
    const nr = Object(b.a)({
      randomGamma_:
        /**
         * @license
         * Copyright 2020 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e, n = 1, r = "float32", s) {
          if (null == n && (n = 1), null == r && (r = "float32"), "float32" !== r && "int32" !== r) throw new Error(`Unsupported data type ${r}`);
          const i = new tr(e, n, r, s),
            a = Kt(t, r);
          for (let t = 0; t < a.values.length; t++) a.values[t] = i.nextValue();
          return a.toTensor()
        }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const rr = Object(b.a)({
      randomNormal_: function (t, e = 0, n = 1, r, s) {
        if (null != r && "bool" === r) throw new Error(`Unsupported data type ${r}`);
        const i = new Qn(e, n, r, !1, s),
          a = Kt(t, r);
        for (let t = 0; t < a.values.length; t++) a.values[t] = i.nextValue();
        return a.toTensor()
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const sr = Object(b.a)({
      randomUniform_: function (t, e = 0, n = 1, r = "float32", s) {
        const i = Kt(t, r),
          a = new er(e, n, null, s);
        for (let t = 0; t < i.values.length; t++) i.values[t] = a.nextValue();
        return i.toTensor()
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ir(t, e) {
      Object(S.assertNonNull)(t);
      const n = Object(g.c)(t, e);
      if (1 !== n.length) throw new Error("tensor1d() requires values to be a flat/TypedArray");
      return Object(Ke.a)(t, null, n, e)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ar(t, e, n = 1, r = "float32") {
      if (0 === n) throw new Error("Cannot have a step of zero");
      const s = {
        start: t,
        stop: e,
        step: n,
        dtype: r
      };
      return d.a.runKernelFunc(() => {
        if (t === e || t < e && n < 0 || e < t && n > 1) return Cn([0], r);
        const s = Math.abs(Math.ceil((e - t) / n)),
          i = Object(S.makeZerosTypedArray)(s, r);
        e < t && 1 === n && (n = -1), i[0] = t;
        for (let t = 1; t < i.length; t++) i[t] = i[t - 1] + n;
        return ir(i, r)
      }, {}, null, m.Zb, s)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const or = Object(b.a)({
      reciprocal_: function (t) {
        const e = Object(g.a)(t, "x", "reciprocal"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.reciprocal(e);
          return n([e]), r
        }, n, null, m.bc)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ur = Object(b.a)({
      relu_: function (t) {
        const e = Object(g.a)(t, "x", "relu"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => (n([e]), "bool" === e.dtype ? V(e, "int32") : t.relu(e)), n, null, m.cc)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const cr = Object(b.a)({
      relu6_: function (t) {
        const e = Object(g.a)(t, "x", "relu6"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => (n([e]), "bool" === e.dtype ? V(e, "int32") : t.relu6(e)), n, null, m.dc)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const lr = Object(b.a)({
      reverse1d_: function (t) {
        const e = Object(g.a)(t, "x", "reverse");
        return S.assert(1 === e.rank, () => `Error in reverse1D: x must be rank 1 but got rank ${e.rank}.`), qe(e, 0)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const hr = Object(b.a)({
      reverse2d_: function (t, e) {
        const n = Object(g.a)(t, "x", "reverse");
        return S.assert(2 === n.rank, () => `Error in reverse2D: x must be rank 2 but got rank ${n.rank}.`), qe(n, e)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const dr = Object(b.a)({
      reverse3d_: function (t, e) {
        const n = Object(g.a)(t, "x", "reverse");
        return S.assert(3 === n.rank, () => `Error in reverse3D: x must be rank 3 but got rank ${n.rank}.`), qe(n, e)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const pr = Object(b.a)({
      reverse4d_: function (t, e) {
        const n = Object(g.a)(t, "x", "reverse");
        return S.assert(4 === n.rank, () => `Error in reverse4D: x must be rank 4 but got rank ${n.rank}.`), qe(n, e)
      }
    });

    function fr(t, e, n = 0) {
      let r = [];
      if ("number" == typeof e) Object(S.assert)(t.shape[n] % e == 0, () => "Number of splits must evenly divide the axis."), r = new Array(e).fill(t.shape[n] / e);
      else {
        const s = e.reduce((t, e) => (-1 === e && (t += 1), t), 0);
        Object(S.assert)(s <= 1, () => "There should be only one negative value in split array.");
        const i = e.indexOf(-1);
        if (-1 !== i) {
          const r = e.reduce((t, e) => e > 0 ? t + e : t);
          e[i] = t.shape[n] - r
        }
        Object(S.assert)(t.shape[n] === e.reduce((t, e) => t + e), () => "The sum of sizes must match the size of the axis dimension."), r = e
      }
      return r
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const mr = Object(b.a)({
      split_: function (t, e, n = 0) {
        const r = Object(g.a)(t, "x", "split"),
          s = {
            x: r
          },
          i = {
            numOrSizeSplits: e,
            axis: n
          };
        return d.a.runKernelFunc((t, s) => {
          const i = Object(S.parseAxisParam)(n, r.shape)[0],
            a = fr(r, e, i);
          return t.split(r, a, i)
        }, s, null, m.zc, i)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const gr = Object(b.a)({
      rfft_: function (t, e) {
        Object(S.assert)("float32" === t.dtype, () => `The dtype for rfft() must be real value but got ${t.dtype}`);
        let n = t.shape[t.shape.length - 1];
        const r = t.size / n;
        let s;
        if (null != e && e < n) {
          const r = t.shape.map(t => 0),
            i = t.shape.map(t => t);
          i[t.shape.length - 1] = e, s = Mt(t, r, i), n = e
        } else if (null != e && e > n) {
          const r = t.shape.map(t => t);
          r[t.shape.length - 1] = e - n, s = wt([t, Cn(r)], t.shape.length - 1), n = e
        } else s = t;
        const i = Se(s),
          a = R(Object(Yt.a)(s, i), [r, n]),
          o = Re(a),
          u = Math.floor(n / 2) + 1,
          c = Ge(o),
          l = He(o),
          h = mr(c, [u, n - u], c.shape.length - 1),
          d = mr(l, [u, n - u], l.shape.length - 1),
          p = s.shape.slice();
        return p[s.shape.length - 1] = u, R(Object(Yt.a)(h[0], d[0]), p)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const br = Object(b.a)({
      round_: function (t) {
        const e = Object(g.a)(t, "x", "round"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.round(e), n, null, m.lc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const yr = Object(b.a)({
      rsqrt_: function (t) {
        const e = Object(g.a)(t, "x", "rsqrt"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.rsqrt(e);
          return n([e]), r
        }, n, null, m.mc)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const wr = Object(b.a)({
      selu_: function (t) {
        const e = Object(g.a)(t, "x", "selu"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.selu(e);
          return n([e]), r
        }, n, null, m.pc)
      }
    });
    const vr = Object(b.a)({
      separableConv2d_: function (t, e, n, r, s, i = [1, 1], a = "NHWC") {
        const o = Object(g.a)(t, "x", "separableConv2d"),
          u = Object(g.a)(e, "depthwiseFilter", "separableConv2d"),
          c = Object(g.a)(n, "pointwiseFilter", "separableConv2d");
        let l = o,
          h = !1;
        if (3 === o.rank && (h = !0, l = R(o, [1, o.shape[0], o.shape[1], o.shape[2]])), "NCHW" === a) throw new Error("separableConv2d currently does not support dataFormat NCHW; only NHWC is supported");
        S.assert(4 === l.rank, () => "Error in separableConv2d: input must be rank 4, but got " + `rank ${l.rank}.`), S.assert(4 === u.rank, () => "Error in separableConv2d: depthwise filter must be rank 4, but " + `got rank ${u.rank}.`), S.assert(4 === c.rank, () => "Error in separableConv2d: pointwise filter must be rank 4, but " + `got rank ${u.rank}.`), S.assert(1 === c.shape[0], () => "Error in separableConv2d: the first dimension of pointwise filter " + ` must be 1, but got ${c.shape[0]}.`), S.assert(1 === c.shape[1], () => "Error in separableConv2d: the second dimension of pointwise " + `filter must be 1, but got ${c.shape[1]}.`);
        const d = u.shape[2],
          p = u.shape[3];
        S.assert(c.shape[2] === d * p, () => "Error in separableConv2d: the third dimension of pointwise filter " + `must be ${d*p}, ` + `but got ${c.shape[2]}.`);
        const f = pe(l, u, r, s, a, i),
          m = ne(f, c, 1, "valid", a);
        return h ? R(m, [m.shape[1], m.shape[2], m.shape[3]]) : m
      }
    });
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const xr = async function (t, e) {
      const n = Object(g.a)(t, "x", "setdiff1d"),
        r = Object(g.a)(e, "y", "setdiff1d");
      S.assert(n.dtype === r.dtype, () => `x and y should have the same dtype, but got x (${n.dtype}) and y (${r.dtype}).`), S.assert(1 === n.rank, () => `x should be 1D tensor, but got x (${n.shape}).`), S.assert(1 === r.rank, () => `y should be 1D tensor, but got y (${r.shape}).`);
      const s = await n.data(),
        i = await r.data(),
        a = new Set(i);
      let o = 0;
      for (let t = 0; t < s.length; t++) a.has(s[t]) || o++;
      const u = new it.b([o], n.dtype),
        c = new it.b([o], "int32");
      for (let t = 0, e = 0; t < s.length; t++) a.has(s[t]) || (u.values[e] = s[t], c.values[e] = t, e++);
      return [u.toTensor(), c.toTensor()]
    };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Or = Object(b.a)({
      sign_: function (t) {
        const e = Object(g.a)(t, "x", "sign"),
          n = {
            x: e
          };
        return d.a.runKernelFunc(t => t.sign(e), n, null, m.rc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Sr = Object(b.a)({
      sin_: function (t) {
        const e = Object(g.a)(t, "x", "sin"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.sin(e);
          return n([e]), r
        }, n, null, m.sc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const _r = Object(b.a)({
      sinh_: function (t) {
        const e = Object(g.a)(t, "x", "sinh"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.sinh(e);
          return n([e]), r
        }, n, null, m.tc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const kr = Object(b.a)({
      slice1d_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "slice1d");
        return S.assert(1 === r.rank, () => `slice1d expects a rank-1 tensor, but got a rank-${r.rank} tensor`), Mt(r, [e], [n])
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Cr = Object(b.a)({
      slice2d_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "slice2d");
        return S.assert(2 === r.rank, () => `slice2d expects a rank-2 tensor, but got a rank-${r.rank} tensor`), Mt(r, e, n)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Er = Object(b.a)({
      slice3d_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "slice3d");
        return S.assert(3 === r.rank, () => `slice3d expects a rank-3 tensor, but got a rank-${r.rank} tensor`), Mt(r, e, n)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ir = Object(b.a)({
      slice4d_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "slice4d");
        return S.assert(4 === r.rank, () => `slice4d expects a rank-4 tensor, but got a rank-${r.rank} tensor`), Mt(r, e, n)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Tr = Object(b.a)({
      softmax_: function (t, e = -1) {
        const n = Object(g.a)(t, "logits", "softmax", "float32");
        if (-1 === e && (e = n.rank - 1), e !== n.rank - 1) throw Error("Softmax along a non-last dimension is not yet supported. " + `Logits was rank ${n.rank} and dim was ${e}`);
        const r = {
            logits: n
          },
          s = {
            dim: e
          };
        return d.a.runKernelFunc((t, r) => {
          const s = t.softmax(n, e);
          return r([s]), s
        }, r, null, m.vc, s)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ar = Object(b.a)({
      sqrt_: function (t) {
        const e = Object(g.a)(t, "x", "sqrt"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.sqrt(e);
          return n([e]), r
        }, n, null, m.Ac)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Nr = Object(b.a)({
      squaredDifference_: function (t, e) {
        let n = Object(g.a)(t, "a", "squaredDifference"),
          r = Object(g.a)(e, "b", "squaredDifference");
        [n, r] = Object(x.makeTypesMatch)(n, r), ve(n.shape, r.shape);
        const s = {
          a: n,
          b: r
        };
        return d.a.runKernelFunc((t, e) => {
          const s = t.squaredDifference(n, r);
          return e([n, r]), s
        }, s, null, m.Cc, {})
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const $r = Object(b.a)({
      squeeze_: function (t, e) {
        const n = Object(g.a)(t, "x", "squeeze");
        return R(n, Object(S.squeezeShape)(n.shape, e).newShape)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Rr = Object(b.a)({
      stack_: function (t, e = 0) {
        const n = Object(g.b)(t, "tensors", "stack");
        if (S.assert(n.length >= 1, () => "Pass at least one tensor to tf.stack"), 1 === n.length) return Te(n[0], e);
        const r = n[0].rank,
          s = n[0].shape,
          i = n[0].dtype;
        S.assert(e <= r, () => "Axis must be <= rank of the tensor"), n.forEach(t => {
          S.assertShapesMatch(s, t.shape, "All tensors passed to stack must have matching shapes"), S.assert(i === t.dtype, () => "All tensors passed to stack must have matching dtypes")
        });
        const a = n.map(t => Te(t, e));
        return wt(a, e)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const jr = Object(b.a)({
      step_: function (t, e = 0) {
        const n = Object(g.a)(t, "x", "step"),
          r = {
            x: n
          },
          s = {
            alpha: e
          };
        return d.a.runKernelFunc(t => t.step(n, e), r, null, m.Dc, s)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Dr = Object(b.a)({
      stridedSlice_: function (t, e, n, r, s = 0, i = 0, a = 0, o = 0, u = 0) {
        null == r && (r = new Array(e.length));
        let c = Object(g.a)(t, "x", "stridedSlice");
        const l = {
            x: c
          },
          h = {
            begin: e,
            end: n,
            strides: r,
            beginMask: s,
            endMask: i,
            ellipsisMask: a,
            newAxisMask: o,
            shrinkAxisMask: u
          };
        return d.a.runKernelFunc(t => {
          const l = _t(a);
          if (l.length > 1) throw new Error("Multiple ellipses in slice is not allowed.");
          if (0 !== a && 0 !== o) throw new Error("Using both ellipsisMask and newAxisMask is not yet supported.");
          if (0 !== a && 0 !== u) throw new Error("Using both ellipsisMask and shrinkAxisMask is not yet supported.");
          const h = c.rank - e.length,
            d = _t(o),
            p = c.shape.slice();
          if (d.forEach(t => {
              e[t] = 0, n[t] = 1, p.splice(t, 0, 1)
            }), c = R(c, p), l.length && h > 0) {
            const t = l[0],
              a = h + 1;
            e = Tt(s, t, a, e, c.shape), n = At(i, t, a, n, c.shape), r = Ct(r, t, a, c.shape)
          } else
            for (let t = 0; t < c.rank; t++) e[t] = $t(s, e, r, c.shape, t, a), n[t] = Rt(i, n, r, c.shape, t, a), r[t] = Nt(r, t, a);
          const f = _t(u);
          f.forEach(t => {
            n[t] = e[t] + 1, r[t] = 1
          });
          const m = kt(e, n, r),
            g = m.filter((t, e) => -1 === f.indexOf(e));
          if (r.every(t => 1 === t)) return R(Mt(c, e, m), g);
          const b = t.stridedSlice(c, e, n, r);
          return R(b, g)
        }, l, null, m.Ec, h)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Fr = Object(b.a)({
      tan_: function (t) {
        const e = Object(g.a)(t, "x", "tan"),
          n = {
            x: e
          };
        return d.a.runKernelFunc((t, n) => {
          const r = t.tan(e);
          return n([e]), r
        }, n, null, m.Hc)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Mr(t, e, n) {
      if (Object(S.assertNonNull)(t), null != e && 2 !== e.length) throw new Error("tensor2d() requires shape to have two numbers");
      const r = Object(g.c)(t, n);
      if (2 !== r.length && 1 !== r.length) throw new Error("tensor2d() requires values to be number[][] or flat/TypedArray");
      if (1 === r.length && null == e) throw new Error("tensor2d() requires shape to be provided when `values` are a flat/TypedArray");
      return Object(Ke.a)(t, e, r, n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function zr(t, e, n) {
      if (Object(S.assertNonNull)(t), null != e && 3 !== e.length) throw new Error("tensor3d() requires shape to have three numbers");
      const r = Object(g.c)(t, n);
      if (3 !== r.length && 1 !== r.length) throw new Error("tensor3d() requires values to be number[][][] or flat/TypedArray");
      if (1 === r.length && null == e) throw new Error("tensor3d() requires shape to be provided when `values` are a flat array");
      return Object(Ke.a)(t, e, r, n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Lr(t, e, n) {
      if (Object(S.assertNonNull)(t), null != e && 4 !== e.length) throw new Error("tensor4d() requires shape to have four numbers");
      const r = Object(g.c)(t, n);
      if (4 !== r.length && 1 !== r.length) throw new Error("tensor4d() requires values to be number[][][][] or flat/TypedArray");
      if (1 === r.length && null == e) throw new Error("tensor4d() requires shape to be provided when `values` are a flat array");
      return Object(Ke.a)(t, e, r, n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Br(t, e, n) {
      if (Object(S.assertNonNull)(t), null != e && 5 !== e.length) throw new Error("tensor5d() requires shape to have five numbers");
      const r = Object(g.c)(t, n);
      if (5 !== r.length && 1 !== r.length) throw new Error("tensor5d() requires values to be number[][][][][] or flat/TypedArray");
      if (1 === r.length && null == e) throw new Error("tensor5d() requires shape to be provided when `values` are a flat array");
      return Object(Ke.a)(t, e, r, n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Pr(t, e, n) {
      if (Object(S.assertNonNull)(t), null != e && 6 !== e.length) throw new Error("tensor6d() requires shape to have six numbers");
      const r = Object(g.c)(t, n);
      if (6 !== r.length && 1 !== r.length) throw new Error("tensor6d() requires values to be number[][][][][][] or flat/TypedArray");
      if (1 === r.length && null == e) throw new Error("tensor6d() requires shape to be provided when `values` are a flat array");
      return e = e || r, Object(Ke.a)(t, e, r, n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Wr = Object(b.a)({
      topk_: function (t, e = 1, n = !0) {
        const r = Object(g.a)(t, "x", "topk");
        if (0 === r.rank) throw new Error("topk() expects the input to be of rank 1 or higher");
        const s = r.shape[r.shape.length - 1];
        if (e > s) throw new Error(`'k' passed to topk() must be <= the last dimension (${s}) ` + `but got ${e}`);
        const i = {
            x: r
          },
          a = {
            k: e,
            sorted: n
          },
          [o, u] = d.a.runKernelFunc(t => t.topk(r, e, n), i, null, m.Kc, a);
        return {
          values: o,
          indices: u
        }
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ur = Object(b.a)({
      truncatedNormal_: function (t, e = 0, n = 1, r, s) {
        if (null != r && "bool" === r) throw new Error("Unsupported data type $ { dtype }");
        const i = new Qn(e, n, r, !0, s),
          a = Kt(t, r);
        for (let t = 0; t < a.values.length; t++) a.values[t] = i.nextValue();
        return a.toTensor()
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Vr = Object(b.a)({
      unsortedSegmentSum_: function (t, e, n) {
        const r = Object(g.a)(t, "x", "unsortedSegmentSum"),
          s = Object(g.a)(e, "segmentIds", "unsortedSegmentSum", "int32");
        Object(S.assert)(Object(S.isInt)(n), () => "numSegments must be of dtype int");
        const i = {
            x: r,
            segmentIds: s
          },
          a = {
            numSegments: n
          };
        return d.a.runKernelFunc((t, e) => {
          const i = t.unsortedSegmentSum(r, s, n);
          return e([s]), i
        }, i, null, m.Nc, a)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Hr = Object(b.a)({
      unstack_: function (t, e = 0) {
        const n = Object(g.a)(t, "x", "unstack");
        S.assert(e >= -n.shape.length && e < n.shape.length, () => `Axis = ${e} is not in [-${n.shape.length}, ${n.shape.length})`), e < 0 && (e += n.shape.length);
        const r = {
            value: n
          },
          s = {
            axis: e
          };
        return d.a.runKernelFunc(t => t.unstack(n, e), r, null, m.Mc, s)
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Gr(t, e = !0, n, r) {
      return d.a.makeVariable(t, e, n, r)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function qr(t, e) {
      const n = [];
      for (let t = 0; t < e.length; t++) e[t] && n.push(t);
      const r = Kt(t, "int32"),
        s = Kt([n.length, t.length], "int32");
      for (let e = 0; e < n.length; e++) {
        const i = r.indexToLoc(n[e]),
          a = e * t.length;
        s.values.set(i, a)
      }
      return s.toTensor()
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Kr = async function (t) {
      const e = Object(g.a)(t, "condition", "whereAsync", "bool"),
        n = await e.data(),
        r = qr(e.shape, n);
      return t !== e && e.dispose(), r
    };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Jr = async function (t, e, n) {
      const r = Object(g.a)(t, "tensor", "boolMask"),
        s = Object(g.a)(e, "mask", "boolMask", "bool"),
        i = null == n ? 0 : n,
        a = s.rank,
        o = r.shape;
      S.assert(a > 0, () => "mask cannot be scalar"), S.assertShapesMatch(o.slice(i, i + a), s.shape, "mask's shape must match the first K dimensions of tensor's shape,");
      let u = 1;
      for (let t = i; t < i + a; t++) u *= o[t];
      const c = o.slice(0, i).concat([u], o.slice(i + a)),
        l = R(r, c),
        h = R(s, [-1]),
        d = await Kr(h),
        p = $r(d, [1]),
        f = Pe(l, p, i);
      return t !== r && r.dispose(), e !== s && s.dispose(), p.dispose(), l.dispose(), h.dispose(), d.dispose(), f
    };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Xr = Object(b.a)({
        equalStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "equalStrict"),
            r = Object(g.a)(e, "b", "equalStrict");
          return Object(S.assertShapesMatch)(n.shape, r.shape, "Error in equalStrict: "), xe(n, r)
        }
      }),
      Yr = Object(b.a)({
        greaterEqualStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "greaterEqualStrict"),
            r = Object(g.a)(e, "b", "greaterEqualStrict");
          return Object(S.assertShapesMatch)(n.shape, r.shape, "Error in greaterEqualStrict: "), Ue(n, r)
        }
      }),
      Zr = Object(b.a)({
        greaterStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "greaterStrict"),
            r = Object(g.a)(e, "b", "greaterStrict");
          return Object(S.assertShapesMatch)(n.shape, r.shape, "Error in greaterStrict: "), We(n, r)
        }
      }),
      Qr = Object(b.a)({
        lessEqualStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "lessEqualStrict"),
            r = Object(g.a)(e, "b", "lessEqualStrict");
          return Object(S.assertShapesMatch)(n.shape, r.shape, "Error in lessEqualStrict: "), rn(n, r)
        }
      }),
      ts = Object(b.a)({
        lessStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "lessStrict"),
            r = Object(g.a)(e, "b", "lessStrict");
          return Object(S.assertShapesMatch)(n.shape, r.shape, "Error in lessStrict: "), nn(n, r)
        }
      }),
      es = Object(b.a)({
        notEqualStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "notEqualStrict"),
            r = Object(g.a)(e, "b", "notEqualStrict");
          return Object(S.assertShapesMatch)(n.shape, r.shape, "Error in notEqualStrict: "), Fn(n, r)
        }
      });
    const ns = Object(b.a)({
        addStrict_:
          /**
           * @license
           * Copyright 2018 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e) {
            at("strict variants of ops have been deprecated and will be removed in future");
            const n = Object(g.a)(t, "a", "addStrict"),
              r = Object(g.a)(e, "b", "addStrict");
            return S.assertShapesMatch(n.shape, r.shape, "Error in addStrict: "), O(n, r)
          }
      }),
      rs = Object(b.a)({
        divStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "div"),
            r = Object(g.a)(e, "b", "div");
          return S.assertShapesMatch(n.shape, r.shape, "Error in divideStrict: "), be(n, r)
        }
      }),
      ss = Object(b.a)({
        maximumStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "maximumStrict"),
            r = Object(g.a)(e, "b", "maximumStrict");
          return S.assertShapesMatch(n.shape, r.shape, "Error in maximumStrict: "), tn(n, r)
        }
      }),
      is = Object(b.a)({
        minimumStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "minimumStrict"),
            r = Object(g.a)(e, "b", "minimumStrict");
          return S.assertShapesMatch(n.shape, r.shape, "Error in minimumStrict: "), An(n, r)
        }
      }),
      as = Object(b.a)({
        modStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "modStrict"),
            r = Object(g.a)(e, "b", "modStrict");
          return S.assertShapesMatch(n.shape, r.shape, "Error in modStrict: "), Nn(n, r)
        }
      }),
      os = Object(b.a)({
        mulStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "mul"),
            r = Object(g.a)(e, "b", "mul");
          return S.assertShapesMatch(n.shape, r.shape, "Error in multiplyStrict: "), xt(n, r)
        }
      }),
      us = Object(b.a)({
        powStrict_: function (t, e) {
          return at("strict variants of ops have been deprecated and will be removed in future"), S.assertShapesMatch(t.shape, e.shape, "Error in powStrict: "), qn(t, e)
        }
      }),
      cs = Object(b.a)({
        squaredDifferenceStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "squaredDifferenceStrict"),
            r = Object(g.a)(e, "b", "squaredDifferenceStrict");
          return S.assertShapesMatch(n.shape, r.shape, "Error in squaredDifferenceStrict: "), Nr(n, r)
        }
      }),
      ls = Object(b.a)({
        subStrict_: function (t, e) {
          at("strict variants of ops have been deprecated and will be removed in future");
          const n = Object(g.a)(t, "a", "subStrict"),
            r = Object(g.a)(e, "b", "subStrict");
          return S.assertShapesMatch(n.shape, r.shape, "Error in subStrict: "), mn(n, r)
        }
      });
    const hs = Object(b.a)({
      norm_:
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e = "euclidean", n = null, r = !1) {
          const s = function t(e, n, r = null) {
            if (0 === e.rank) return y(e);
            if (1 !== e.rank && null === r) return t(R(e, [-1]), n, r);
            if (1 === e.rank || "number" == typeof r || Array.isArray(r) && 1 === r.length) {
              if (1 === n) return gn(y(e), r);
              if (n === 1 / 0) return fn(y(e), r);
              if (n === -1 / 0) return Tn(y(e), r);
              if ("euclidean" === n || 2 === n) return Ar(gn(qn(y(e), Je(2, "int32")), r));
              throw new Error(`Error in norm: invalid ord value: ${n}`)
            }
            if (Array.isArray(r) && 2 === r.length) {
              if (1 === n) return fn(gn(y(e), r[0]), r[1] - 1);
              if (n === 1 / 0) return fn(gn(y(e), r[1]), r[0]);
              if (n === -1 / 0) return Tn(gn(y(e), r[1]), r[0]);
              if ("fro" === n || "euclidean" === n) return Ar(gn($n(e), r));
              throw new Error(`Error in norm: invalid ord value: ${n}`)
            }
            throw new Error(`Error in norm: invalid axis: ${r}`)
          }(t = Object(g.a)(t, "x", "norm"), e, n);
          let i = s.shape;
          if (r) {
            const e = Object(S.parseAxisParam)(n, t.shape);
            i = I(s.shape, e)
          }
          return R(s, i)
        }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ds = Object(b.a)({
      movingAverage_: function (t, e, n, r, s = !0) {
        const i = Object(g.a)(t, "v", "movingAverage"),
          a = Object(g.a)(e, "x", "movingAverage"),
          o = Object(g.a)(n, "decay", "movingAverage");
        Object(x.assertTypesMatch)(i, a), S.assert(S.arraysEqual(i.shape, a.shape), () => "Shape mismatch in v and x");
        const u = Je(1),
          c = mn(u, o);
        let l = xt(mn(a, i), c);
        if (s) {
          S.assert(null != r, () => "When using zeroDebias: true, step is required.");
          const t = Object(g.a)(r, "step", "movingAverage");
          l = be(l, mn(u, qn(o, t)))
        }
        return O(i, l)
      }
    });

    function ps(t, e, n) {
      const r = e.rank > 1 ? e.shape[e.rank - 1] : 1,
        s = e.rank > 1 ? e.rank - 1 : 1,
        i = "Must have updates.shape = indices.shape[:batchDim] + " + `shape[sliceDim:], got updates.shape: ${n.shape}` + `, indices.shape: ${e.shape}, shape: ${t}` + `, sliceDim: ${r}, and batchDim: ${s}.`;
      if (n.rank < s) throw new Error(i + ` update.rank < ${s}. `);
      if (t.length < r + (n.rank - s)) throw new Error(i + ` Output shape length < ${r+(n.rank-s)}`);
      if (n.rank !== s + t.length - r) throw new Error(i + ` update.rank != ${s+t.length-r}`);
      for (let t = 0; t < s; ++t)
        if (n.shape[t] !== e.shape[t]) throw new Error(i + ` updates.shape[${t}] (${n.shape[t]}) != indices.shape[${t}] (${e.shape[t]}).`);
      for (let e = 0; e < n.rank - s; ++e)
        if (n.shape[e + s] !== t[e + r]) throw new Error(i + ` updates.shape[${e+s}] (${n.shape[e+s]}) != shape[${e+s}] (${t[e+s]})`)
    }

    function fs(t, e, n) {
      if (e.rank < 1) throw new Error("tf.scatterND() expects the indices to be rank 1 or higher," + ` but the rank was ${e.rank}.`);
      if (t.rank < 1) throw new Error("tf.scatterND() expects the updates to be rank 1 or higher," + ` but the rank was ${t.rank}.`);
      if ("int32" !== e.dtype) throw new Error(`The dtype of 'indices' should be int32, but got dtype: ${e.dtype}`);
      if (n.length < 1) throw new Error(`Output rank must be greater or equal to 1, but got shape: ${n}`);
      if (0 === n.length) {
        if (0 === e.size) throw new Error(`Indices specified for empty output. indices shape: ${e.shape}`);
        if (0 === t.size) throw new Error(`Updates specified for empty output. updates shape: ${t.shape}`)
      }
      ps(n, e, t)
    }

    function ms(t, e, n) {
      const r = e.shape.length,
        s = r > 1 ? e.shape[r - 1] : 1,
        i = n.length;
      let a = 1;
      for (let t = s; t < i; ++t) a *= n[t];
      const o = s < 1 ? 1 : s;
      return {
        sliceRank: s,
        numUpdates: Object(S.sizeFromShape)(e.shape) / o,
        sliceSize: a,
        strides: [...Object(S.computeStrides)(n.slice(0, s)), 1],
        outputSize: Object(S.sizeFromShape)(n)
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const gs = Object(b.a)({
      scatterND_: function (t, e, n) {
        const r = Object(g.a)(t, "indices", "scatterND", "int32"),
          s = Object(g.a)(e, "updates", "scatterND");
        fs(s, r, n);
        const i = {
            indices: r,
            updates: s
          },
          a = {
            shape: n
          };
        return d.a.runKernelFunc(t => t.scatterND(r, s, n), i, null, m.nc, a)
      }
    });
    const bs = Object(b.a)({
      sparseToDense_:
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e, n, r = 0) {
          const s = Object(g.a)(t, "sparseIndices", "sparseToDense", "int32"),
            i = Object(g.a)(e, "sparseValues", "sparseToDense"),
            a = Object(g.a)(r, "defaultValue", "sparseToDense", i.dtype);
          ! function (t, e, n, r) {
            if ("int32" !== t.dtype) throw new Error("tf.sparseToDense() expects the indices to be int32 type," + ` but the dtype was ${t.dtype}.`);
            if (t.rank > 2) throw new Error("sparseIndices should be a scalar, vector, or matrix," + ` but got shape ${t.shape}.`);
            const s = t.rank > 0 ? t.shape[0] : 1,
              i = t.rank > 1 ? t.shape[1] : 1;
            if (n.length !== i) throw new Error("outputShape has incorrect number of elements:," + ` ${n.length}, should be: ${i}.`);
            const a = e.size;
            if (0 !== e.rank && (1 !== e.rank || a !== s)) throw new Error("sparseValues has incorrect shape " + `${e.shape}, should be [] or [${s}]`);
            if (e.dtype !== r.dtype) throw new Error("sparseValues.dtype must match defaultValues.dtype")
          }(s, i, n, a);
          const o = {
              sparseIndices: s,
              sparseValues: i,
              defaultValue: a
            },
            u = {
              outputShape: n
            };
          return d.a.runKernelFunc(t => t.sparseToDense(s, i, n, a), o, null, m.yc, u)
        }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ys = Object(b.a)({
      gatherND_: function (t, e) {
        const n = Object(g.a)(e, "indices", "gatherND", "int32"),
          r = Object(g.a)(t, "x", "gatherND"),
          s = {
            params: r,
            indices: n
          };
        return d.a.runKernelFunc(t => t.gatherND(r, n), s, null, m.ib)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ws = Object(b.a)({
      dropout_:
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e, n, r) {
          const s = Object(g.a)(t, "x", "dropout");
          if (S.assert("float32" === s.dtype, () => "x has to be a floating point tensor since it's going to be " + `scaled, but got a ${s.dtype} tensor instead.`), S.assert(e >= 0 && e < 1, () => `rate must be a float in the range [0, 1), but got ${e}.`), 0 === e) return t instanceof it.a ? s.clone() : s;
          const i = function (t, e) {
              if (null == e) return t.shape.slice();
              if (S.arraysEqual(t.shape, e)) return e;
              if (t.shape.length === e.length) {
                const n = [];
                for (let r = 0; r < t.shape.length; r++) null == e[r] && null != t.shape[r] ? n.push(t.shape[r]) : n.push(e[r]);
                return n
              }
              return e
            }(s, n),
            a = 1 - e,
            o = be(De(O(sr(i, 0, 1, "float32", r), a)), a);
          return xt(s, o)
        }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function vs(t) {
      return Math.floor(Math.pow(2, Math.ceil(Math.log(t) / Math.log(2))))
    }

    function xs(t, e, n) {
      const r = 1 - t % 2,
        s = new Float32Array(t);
      for (let i = 0; i < t; ++i) {
        const a = 2 * Math.PI * i / (t + r - 1);
        s[i] = e - n * Math.cos(a)
      }
      return ir(s, "float32")
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Os = async function (t, e, n = 1) {
      const r = Object(g.a)(t, "predictions", "inTopK"),
        s = Object(g.a)(e, "targets", "inTopK");
      Object(S.assert)(r.rank > 1, () => "inTopK() expects the predictions to be of rank 2 or higher, " + `but got ${r.rank}`), Object(S.assert)(r.rank - 1 === s.rank, () => "predictions rank should be 1 larger than targets rank, but got predictions rank " + `${r.rank} and targets rank ${s.rank}`), Object(S.assertShapesMatch)(r.shape.slice(0, r.shape.length - 1), s.shape, "predictions's shape should be align with the targets' shape, except the last dimension.");
      const i = r.shape[r.shape.length - 1];
      Object(S.assert)(n > 0 && n <= i, () => "'k' passed to inTopK() must be > 0 && <= the predictions last " + `dimension (${i}), but got ${n}`);
      const a = await r.data(),
        o = await s.data(),
        [u, c] = [a.length / i, i],
        l = Object(S.getTypedArrayFromDType)("bool", u);
      for (let t = 0; t < u; t++) {
        const e = t * c,
          r = a.subarray(e, e + c),
          s = [];
        for (let t = 0; t < r.length; t++) s.push({
          value: r[t],
          index: t
        });
        s.sort((t, e) => e.value - t.value), l[t] = 0;
        for (let e = 0; e < n; e++)
          if (s[e].index === o[t]) {
            l[t] = 1;
            break
          }
      }
      return t !== r && r.dispose(), e !== s && s.dispose(), Object(yt.a)(l, s.shape, "bool")
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ss = Object(b.a)({
      conv2DBackpropFilter_: function (t, e, n, r, s, i = "NHWC", a) {
        let o = t;
        3 === t.rank && (o = R(t, [1, t.shape[0], t.shape[1], t.shape[2]]));
        let u = e;
        3 === u.rank && (u = R(e, [1, e.shape[0], e.shape[1], e.shape[2]])), S.assert(4 === o.rank, () => "Error in conv2dDerFilter: input must be rank 4, but got shape " + `${o.shape}.`), S.assert(4 === u.rank, () => "Error in conv2dDerFilter: dy must be rank 4, but got shape " + `${u.shape}.`), S.assert(4 === n.length, () => "Error in conv2dDerFilter: filterShape must be length 4, but got " + `${n}.`);
        const c = "NHWC" === i ? o.shape[3] : o.shape[1],
          l = "NHWC" === i ? u.shape[3] : u.shape[1];
        S.assert(c === n[2], () => `Error in conv2dDerFilter: depth of input ${c}) must ` + `match input depth in filter (${n[2]}.`), S.assert(l === n[3], () => `Error in conv2dDerFilter: depth of dy (${l}) must ` + `match output depth for filter (${n[3]}).`), null != a && S.assert(S.isInt(s), () => "Error in conv2dDerFilter: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${s}.`);
        const h = {
            x: o,
            dy: u
          },
          p = {
            strides: r,
            pad: s,
            dataFormat: i,
            dimRoundingMode: a
          };
        return d.a.runKernelFunc(t => {
          const e = rt(i),
            c = K(o.shape, n, r, 1, s, a, !1, e);
          return t.conv2dDerFilter(o, u, c)
        }, h, null, m.B, p)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function _s(t, e, n) {
      if (null == n || "linear" === n) return t;
      if ("relu" === n) return xt(t, jr(e));
      throw new Error(`Cannot compute gradient for fused activation ${n}.`)
    }

    function ks(t, e) {
      let n = e;
      const r = we(t.shape, e.shape);
      return r.length > 0 && (n = gn(n, r)), R(n, t.shape)
    }

    function Cs(t, e, n) {
      if ("linear" === e) return t;
      if ("relu" === e) return ur(t);
      if ("elu" === e) return Ce(t);
      if ("relu6" === e) return cr(t);
      if ("prelu" === e) return Kn(t, n);
      throw new Error(`Unknown fused activation ${e}.`)
    }
    const Es = (t, e) => {
      return !(t > 0) || "linear" === e
    };
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Is = Object(b.a)({
      fusedConv2d_: function ({
        x: t,
        filter: e,
        strides: n,
        pad: r,
        dataFormat: s = "NHWC",
        dilations: i = [1, 1],
        dimRoundingMode: a,
        bias: o,
        activation: u = "linear",
        preluActivationWeights: c
      }) {
        if (u = u || "linear", !1 === Es(d.a.state.gradientDepth, u)) {
          let l = ne(t, e, n, r, s, i, a);
          return null != o && (l = O(l, o)), Cs(l, u, c)
        }
        const l = Object(g.a)(t, "x", "conv2d"),
          h = Object(g.a)(e, "filter", "conv2d");
        let p = l,
          f = !1;
        3 === l.rank && (f = !0, p = R(l, [1, l.shape[0], l.shape[1], l.shape[2]])), S.assert(4 === p.rank, () => "Error in fused conv2d: input must be rank 4, but got rank " + `${p.rank}.`), S.assert(4 === h.rank, () => "Error in fused conv2d: filter must be rank 4, but got rank " + `${h.rank}.`), null != a && S.assert(S.isInt(r), () => "Error in fused conv2d: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${r}.`), S.assert(p.shape[3] === h.shape[2], () => `Error in conv2d: depth of input (${p.shape[3]}) must match ` + `input depth for filter ${h.shape[2]}.`), S.assert(nt(n, i), () => "Error in conv2D: Either strides or dilations must be 1. " + `Got strides ${n} and dilations '${i}'`), S.assert("NHWC" === s, () => `Error in conv2d: got dataFormat of ${s} but only NHWC is currently supported.`);
        const b = K(p.shape, h.shape, n, i, r, a);
        let y, w;
        null != o && (y = Object(g.a)(o, "bias", "fused conv2d"), [y] = Object(x.makeTypesMatch)(y, l), ve(b.outShape, y.shape)), null != c && (w = Object(g.a)(c, "prelu weights", "fused conv2d"));
        const v = (t, e) => {
            const [s, a, o, c] = e, l = _s(t, o, u);
            S.assert(et(i), () => "Error in gradient of fused conv2D: dilation rates greater than 1 " + `are not yet supported in gradients. Got dilations '${i}'`);
            const h = [se(a.shape, l, s, n, r), Ss(a, l, s.shape, n, r)];
            if (null != c) {
              const t = ks(c, l);
              h.push(t)
            }
            return h
          },
          _ = t => {
            return t.fusedConv2d({
              input: p,
              filter: h,
              convInfo: b,
              bias: y,
              activation: u,
              preluActivationWeights: w
            })
          },
          k = {
            x: p,
            filter: h,
            bias: y,
            preluActivationWeights: w
          },
          C = {
            strides: n,
            pad: r,
            dataFormat: s,
            dilations: i,
            dimRoundingMode: a,
            activation: u
          };
        if (null == o) {
          return ln((t, e, n) => {
            let r = d.a.runKernelFunc(_, k, null, m.gb, C);
            return n([e, t, r]), f && (r = R(r, [r.shape[1], r.shape[2], r.shape[3]])), {
              value: r,
              gradFunc: v
            }
          })(p, h)
        }
        return ln((t, e, n, r) => {
          let s = d.a.runKernelFunc(_, k, null, m.gb, C);
          return r([e, t, s, n]), f && (s = R(s, [s.shape[1], s.shape[2], s.shape[3]])), {
            value: s,
            gradFunc: v
          }
        })(p, h, y)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ts = Object(b.a)({
      depthwiseConv2dNativeBackpropFilter_: function (t, e, n, r) {
        let s = t;
        3 === t.rank && (s = R(t, [1, t.shape[0], t.shape[1], t.shape[2]]));
        let i = e;
        3 === i.rank && (i = R(e, [1, e.shape[0], e.shape[1], e.shape[2]]));
        const a = {
          x: s,
          dy: i
        };
        return d.a.runKernelFunc(t => t.depthwiseConv2DDerFilter(s, i, r), a, null, m.M)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const As = Object(b.a)({
      depthwiseConv2dNativeBackpropInput_: function (t, e, n, r) {
        let s = e,
          i = !1;
        3 === e.rank && (i = !0, s = R(e, [1, e.shape[0], e.shape[1], e.shape[2]]));
        const a = {
            dy: s
          },
          o = d.a.runKernelFunc(t => t.depthwiseConv2DDerInput(s, n, r), a, null, m.N);
        return i ? R(o, [o.shape[1], o.shape[2], o.shape[3]]) : o
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ns = Object(b.a)({
      fusedDepthwiseConv2d_: function ({
        x: t,
        filter: e,
        strides: n,
        pad: r,
        dataFormat: s = "NHWC",
        dilations: i = [1, 1],
        dimRoundingMode: a,
        bias: o,
        activation: u = "linear",
        preluActivationWeights: c
      }) {
        if (!1 === Es(d.a.state.gradientDepth, u)) {
          let l = pe(t, e, n, r, s, i, a);
          return null != o && (l = O(l, o)), Cs(l, u, c)
        }
        const l = Object(g.a)(t, "x", "depthwiseConv2d"),
          h = Object(g.a)(e, "filter", "depthwiseConv2d");
        let p = l,
          f = !1;
        3 === l.rank && (f = !0, p = R(l, [1, l.shape[0], l.shape[1], l.shape[2]])), S.assert(4 === p.rank, () => "Error in fused depthwiseConv2d: input must be rank 4, but got " + `rank ${p.rank}.`), S.assert(4 === h.rank, () => "Error in fused depthwiseConv2d: filter must be rank 4, " + `but got rank ${h.rank}.`), S.assert(p.shape[3] === h.shape[2], () => "Error in fused depthwiseConv2d: number of input channels " + `(${p.shape[3]}) must match the inChannels dimension in ` + `filter ${h.shape[2]}.`), null == i && (i = [1, 1]), S.assert(nt(n, i), () => "Error in fused depthwiseConv2d: Either strides or dilations must " + `be 1. Got strides ${n} and dilations '${i}'`), null != a && S.assert(S.isInt(r), () => "Error in fused depthwiseConv2d: pad must be an integer when " + `using dimRoundingMode ${a} but got pad ${r}.`);
        const b = K(p.shape, h.shape, n, i, r, a, !0);
        let y, w;
        null != o && (y = Object(g.a)(o, "bias", "fused conv2d"), [y] = Object(x.makeTypesMatch)(y, l), ve(b.outShape, y.shape)), null != c && (w = Object(g.a)(c, "prelu weights", "fused depthwiseConv2d"));
        const v = (t, e) => {
            S.assert(et(i), () => "Error in gradient of fused depthwiseConv2d: dilation rates greater than 1 are not yet supported. Got dilations " + `'${i}'`);
            const [n, r, s, a] = e, o = _s(t, s, u), c = As(r.shape, o, n, b), l = Ts(r, o, n.shape, b);
            if (null != a) {
              return [c, l, ks(y, o)]
            }
            return [c, l]
          },
          _ = t => {
            return t.fusedDepthwiseConv2D({
              input: p,
              filter: h,
              convInfo: b,
              bias: y,
              activation: u,
              preluActivationWeights: w
            })
          },
          k = {
            x: p,
            filter: h,
            bias: y,
            preluActivationWeights: w
          },
          C = {
            strides: n,
            pad: r,
            dataFormat: s,
            dilations: i,
            dimRoundingMode: a,
            activation: u
          };
        if (null == o) {
          return ln((t, e, n) => {
            let r = d.a.runKernelFunc(_, k, null, m.hb, C);
            return n([e, t, r]), f && (r = R(r, [r.shape[1], r.shape[2], r.shape[3]])), {
              value: r,
              gradFunc: v
            }
          })(p, h)
        }
        return ln((t, e, n, r) => {
          let s = d.a.runKernelFunc(_, k, null, m.hb, C);
          return r([e, t, s, n]), f && (s = R(s, [s.shape[1], s.shape[2], s.shape[3]])), {
            value: s,
            gradFunc: v
          }
        })(p, h, y)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const $s = Object(b.a)({
      fusedMatMul_: function ({
        a: t,
        b: e,
        transposeA: n = !1,
        transposeB: r = !1,
        bias: s,
        activation: i = "linear",
        preluActivationWeights: a
      }) {
        if (!1 === Es(d.a.state.gradientDepth, i)) {
          let o = vt(t, e, n, r);
          return null != s && (o = O(o, s)), Cs(o, i, a)
        }
        let o = Object(g.a)(t, "a", "fused matMul"),
          u = Object(g.a)(e, "b", "fused matMul");
        [o, u] = Object(x.makeTypesMatch)(o, u);
        const c = n ? o.shape[o.rank - 2] : o.shape[o.rank - 1],
          l = r ? u.shape[u.rank - 1] : u.shape[u.rank - 2],
          h = n ? o.shape[o.rank - 1] : o.shape[o.rank - 2],
          p = r ? u.shape[u.rank - 2] : u.shape[u.rank - 1],
          f = o.shape.slice(0, -2),
          b = u.shape.slice(0, -2),
          y = S.sizeFromShape(f),
          w = S.sizeFromShape(b);
        S.assert(o.rank >= 2 && u.rank >= 2 && o.rank === u.rank, () => "Error in fused matMul: inputs must have the same rank of at least " + `2, got ranks ${o.rank} and ${u.rank}.`), S.assert(S.arraysEqual(f, b), () => `Error in fused matMul: outer dimensions (${f}) and (` + `${b}) of Tensors with shapes ${o.shape} and ` + `${u.shape} must match.`), S.assert(c === l, () => `Error in fused matMul: inner shapes (${c}) and (` + `${l}) of Tensors with shapes ${o.shape} and ` + `${u.shape} and transposeA=${n}` + ` and transposeB=${r} must match.`);
        const v = o.shape.slice(0, -2).concat([h, p]),
          _ = R(o, n ? [y, c, h] : [y, h, c]),
          k = R(u, r ? [w, p, l] : [w, l, p]);
        let C, E;
        null != s && (C = Object(g.a)(s, "bias", "fused matMul"), [C] = Object(x.makeTypesMatch)(C, o), ve(v, C.shape)), null != a && (E = Object(g.a)(a, "prelu weights", "fused matMul"));
        const I = (t, e) => {
            const [a, o, u, c] = e, l = _s(R(t, u.shape), u, i);
            let h, d;
            if (n || r ? !n && r ? (h = vt(l, o, !1, !1), d = vt(l, a, !0, !1)) : n && !r ? (h = vt(o, l, !1, !0), d = vt(a, l, !1, !1)) : (h = vt(o, l, !0, !0), d = vt(l, a, !0, !0)) : (h = vt(l, o, !1, !0), d = vt(a, l, !0, !1)), null != s) {
              return [h, d, ks(c, l)]
            }
            return [h, d]
          },
          T = t => {
            return t.fusedBatchMatMul({
              a: _,
              b: k,
              transposeA: n,
              transposeB: r,
              bias: C,
              activation: i,
              preluActivationWeights: E
            })
          },
          A = {
            a: _,
            b: k,
            bias: C,
            preluActivationWeights: E
          },
          N = {
            transposeA: n,
            transposeB: r,
            activation: i
          };
        if (null == s) {
          return ln((t, e, n) => {
            const r = d.a.runKernelFunc(T, A, null, m.Pc, N);
            return n([t, e, r]), {
              value: R(r, v),
              gradFunc: I
            }
          })(_, k)
        }
        return ln((t, e, n, r) => {
          const s = d.a.runKernelFunc(T, A, null, m.Pc, N);
          return r([t, e, s, n]), {
            value: R(s, v),
            gradFunc: I
          }
        })(_, k, C)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Rs = Object(b.a)({
      hammingWindow_: function (t) {
        return xs(t, .54, .46)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const js = Object(b.a)({
      hannWindow_: function (t) {
        return xs(t, .5, .5)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ds = Object(b.a)({
      frame_: function (t, e, n, r = !1, s = 0) {
        let i = 0;
        const a = [];
        for (; i + e <= t.size;) a.push(Mt(t, i, e)), i += n;
        if (r)
          for (; i < t.size;) {
            const r = i + e - t.size,
              o = wt([Mt(t, i, e - r), je([r], s)]);
            a.push(o), i += n
          }
        return 0 === a.length ? Mr([], [0, e]) : R(wt(a), [a.length, e])
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Fs = Object(b.a)({
      stft_: function (t, e, n, r, s = js) {
        null == r && (r = vs(e));
        const i = Ds(t, e, n),
          a = xt(i, s(e)),
          o = [];
        for (let t = 0; t < i.shape[0]; t++) o.push(gr(Mt(a, [t, 0], [1, e]), r));
        return wt(o)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ms = Object(b.a)({
      cropAndResize_: function (t, e, n, r, s, i) {
        const a = Object(g.a)(t, "image", "cropAndResize"),
          o = Object(g.a)(e, "boxes", "cropAndResize", "float32"),
          u = Object(g.a)(n, "boxInd", "cropAndResize", "int32");
        s = s || "bilinear", i = i || 0;
        const c = o.shape[0];
        S.assert(4 === a.rank, () => "Error in cropAndResize: image must be rank 4," + `but got rank ${a.rank}.`), S.assert(2 === o.rank && 4 === o.shape[1], () => `Error in cropAndResize: boxes must be have size [${c},4] ` + `but had shape ${o.shape}.`), S.assert(1 === u.rank && u.shape[0] === c, () => `Error in cropAndResize: boxInd must be have size [${c}] ` + `but had shape ${o.shape}.`), S.assert(2 === r.length, () => "Error in cropAndResize: cropSize must be of length 2, but got " + `length ${r.length}.`), S.assert(r[0] >= 1 && r[1] >= 1, () => `cropSize must be atleast [1,1], but was ${r}`), S.assert("bilinear" === s || "nearest" === s, () => `method must be bilinear or nearest, but was ${s}`);
        const l = {
            image: a,
            boxes: o,
            boxInd: u
          },
          h = {
            method: s,
            extrapolationValue: i,
            cropSize: r
          };
        return d.a.runKernelFunc(t => t.cropAndResize(a, o, u, r, s, i), l, null, m.I, h)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const zs = Object(b.a)({
      flipLeftRight_: function (t) {
        const e = Object(g.a)(t, "image", "flipLeftRight", "float32");
        S.assert(4 === e.rank, () => "Error in flipLeftRight: image must be rank 4," + `but got rank ${e.rank}.`);
        const n = {
          image: e
        };
        return d.a.runKernel(m.bb, n, {})
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ls = Object(b.a)({
      rotateWithOffset_: function (t, e, n = 0, r = .5) {
        const s = Object(g.a)(t, "image", "rotateWithOffset", "float32");
        S.assert(4 === s.rank, () => "Error in rotateWithOffset: image must be rank 4," + `but got rank ${s.rank}.`);
        const i = {
            image: s
          },
          a = {
            radians: e,
            fillValue: n,
            center: r
          };
        return d.a.runKernel(m.kc, i, a)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Bs(t, e, n, r, s, i) {
      null == r && (r = .5), null == s && (s = Number.NEGATIVE_INFINITY), null == i && (i = 0);
      const a = t.shape[0];
      return n = Math.min(n, a), S.assert(0 <= r && r <= 1, () => `iouThreshold must be in [0, 1], but was '${r}'`), S.assert(2 === t.rank, () => `boxes must be a 2D tensor, but was of rank '${t.rank}'`), S.assert(4 === t.shape[1], () => `boxes must have 4 columns, but 2nd dimension was ${t.shape[1]}`), S.assert(1 === e.rank, () => "scores must be a 1D tensor"), S.assert(e.shape[0] === a, () => `scores has incompatible shape with boxes. Expected ${a}, ` + `but was ${e.shape[0]}`), S.assert(0 <= i && i <= 1, () => `softNmsSigma must be in [0, 1], but was '${i}'`), {
        maxOutputSize: n,
        iouThreshold: r,
        scoreThreshold: s,
        softNmsSigma: i
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ps = Object(b.a)({
      nonMaxSuppression_: function (t, e, n, r = .5, s = Number.NEGATIVE_INFINITY) {
        const i = Object(g.a)(t, "boxes", "nonMaxSuppression"),
          a = Object(g.a)(e, "scores", "nonMaxSuppression"),
          o = Bs(i, a, n, r, s);
        n = o.maxOutputSize, r = o.iouThreshold, s = o.scoreThreshold;
        const u = {
          maxOutputSize: n,
          iouThreshold: r,
          scoreThreshold: s
        };
        return d.a.runKernelFunc(t => t.nonMaxSuppression(i, a, n, r, s), {
          boxes: i,
          scores: a
        }, null, m.Pb, u)
      }
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Ws(t, e, n) {
      const r = function (t, e, n) {
          return function (t, e, n) {
            let r = 0,
              s = t.length,
              i = 0,
              a = !1;
            for (; r < s;) {
              i = r + (s - r >>> 1);
              const o = n(e, t[i]);
              o > 0 ? r = i + 1 : (s = i, a = !o)
            }
            return a ? r : -r - 1
          }
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          (t, e, n || Us)
        }(t, e, n),
        s = r < 0 ? -(r + 1) : r;
      t.splice(s, 0, e)
    }

    function Us(t, e) {
      return t > e ? 1 : t < e ? -1 : 0
    }

    function Vs(t, e, n, r, s) {
      return qs(t, e, n, r, s, 0).selectedIndices
    }

    function Hs(t, e, n, r, s, i) {
      return qs(t, e, n, r, s, 0, !1, i, !0)
    }

    function Gs(t, e, n, r, s, i) {
      return qs(t, e, n, r, s, i, !0)
    }

    function qs(t, e, n, r, s, i, a = !1, o = !1, u = !1) {
      const c = [];
      for (let t = 0; t < e.length; t++) e[t] > s && c.push({
        score: e[t],
        boxIndex: t,
        suppressBeginIndex: 0
      });
      c.sort(Xs);
      const l = i > 0 ? -.5 / i : 0,
        h = [],
        d = [];
      for (; h.length < n && c.length > 0;) {
        const e = c.pop(),
          {
            score: n,
            boxIndex: i,
            suppressBeginIndex: a
          } = e;
        if (n < s) break;
        let o = !1;
        for (let n = h.length - 1; n >= a; --n) {
          const a = Ks(t, i, h[n]);
          if (a >= r) {
            o = !0;
            break
          }
          if (e.score = e.score * Js(r, l, a), e.score <= s) break
        }
        e.suppressBeginIndex = h.length, o || (e.score === n ? (h.push(i), d.push(e.score)) : e.score > s && Ws(c, e, Xs))
      }
      const p = h.length,
        f = n - p;
      o && f > 0 && (h.push(...new Array(f).fill(0)), d.push(...new Array(f).fill(0)));
      const m = {
        selectedIndices: ir(h, "int32")
      };
      return a && (m.selectedScores = ir(d, "float32")), u && (m.validOutputs = Je(p, "int32")), m
    }

    function Ks(t, e, n) {
      const r = t.subarray(4 * e, 4 * e + 4),
        s = t.subarray(4 * n, 4 * n + 4),
        i = Math.min(r[0], r[2]),
        a = Math.min(r[1], r[3]),
        o = Math.max(r[0], r[2]),
        u = Math.max(r[1], r[3]),
        c = Math.min(s[0], s[2]),
        l = Math.min(s[1], s[3]),
        h = Math.max(s[0], s[2]),
        d = Math.max(s[1], s[3]),
        p = (o - i) * (u - a),
        f = (h - c) * (d - l);
      if (p <= 0 || f <= 0) return 0;
      const m = Math.max(i, c),
        g = Math.max(a, l),
        b = Math.min(o, h),
        y = Math.min(u, d),
        w = Math.max(b - m, 0) * Math.max(y - g, 0);
      return w / (p + f - w)
    }

    function Js(t, e, n) {
      const r = Math.exp(e * n * n);
      return n <= t ? r : 0
    }

    function Xs(t, e) {
      return t.score - e.score || t.score === e.score && e.boxIndex - t.boxIndex
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ys = async function (t, e, n, r = .5, s = Number.NEGATIVE_INFINITY) {
      const i = Object(g.a)(t, "boxes", "nonMaxSuppressionAsync"),
        a = Object(g.a)(e, "scores", "nonMaxSuppressionAsync"),
        o = Bs(i, a, n, r, s);
      n = o.maxOutputSize, r = o.iouThreshold, s = o.scoreThreshold;
      const u = await Promise.all([i.data(), a.data()]),
        c = Vs(u[0], u[1], n, r, s);
      return i !== t && i.dispose(), a !== e && a.dispose(), c
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Zs = Object(b.a)({
      nonMaxSuppressionWithScore_: function (t, e, n, r = .5, s = Number.NEGATIVE_INFINITY, i = 0) {
        const a = Object(g.a)(t, "boxes", "nonMaxSuppression"),
          o = Object(g.a)(e, "scores", "nonMaxSuppression"),
          u = Bs(a, o, n, r, s, i),
          c = {
            boxes: a,
            scores: o
          },
          l = {
            maxOutputSize: n = u.maxOutputSize,
            iouThreshold: r = u.iouThreshold,
            scoreThreshold: s = u.scoreThreshold,
            softNmsSigma: i = u.softNmsSigma
          },
          h = d.a.runKernel(m.Rb, c, l);
        return {
          selectedIndices: h[0],
          selectedScores: h[1]
        }
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Qs = async function (t, e, n, r = .5, s = Number.NEGATIVE_INFINITY, i = 0) {
      const a = Object(g.a)(t, "boxes", "nonMaxSuppressionAsync"),
        o = Object(g.a)(e, "scores", "nonMaxSuppressionAsync"),
        u = Bs(a, o, n, r, s, i);
      n = u.maxOutputSize, r = u.iouThreshold, s = u.scoreThreshold, i = u.softNmsSigma;
      const c = await Promise.all([a.data(), o.data()]),
        l = Gs(c[0], c[1], n, r, s, i);
      return a !== t && a.dispose(), o !== e && o.dispose(), l
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ti = Object(b.a)({
      nonMaxSuppressionPadded_: function (t, e, n, r = .5, s = Number.NEGATIVE_INFINITY, i = !1) {
        const a = Object(g.a)(t, "boxes", "nonMaxSuppression"),
          o = Object(g.a)(e, "scores", "nonMaxSuppression"),
          u = Bs(a, o, n, r, s, null),
          c = {
            boxes: a,
            scores: o
          },
          l = {
            maxOutputSize: u.maxOutputSize,
            iouThreshold: u.iouThreshold,
            scoreThreshold: u.scoreThreshold,
            padToMaxOutputSize: i
          },
          h = d.a.runKernel(m.Qb, c, l);
        return {
          selectedIndices: h[0],
          validOutputs: h[1]
        }
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ei = async function (t, e, n, r = .5, s = Number.NEGATIVE_INFINITY, i = !1) {
      const a = Object(g.a)(t, "boxes", "nonMaxSuppressionAsync"),
        o = Object(g.a)(e, "scores", "nonMaxSuppressionAsync"),
        u = Bs(a, o, n, r, s, null),
        c = u.maxOutputSize,
        l = u.iouThreshold,
        h = u.scoreThreshold,
        [d, p] = await Promise.all([a.data(), o.data()]),
        f = Hs(d, p, c, l, h, i);
      return a !== t && a.dispose(), o !== e && o.dispose(), f
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ni = Object(b.a)({
      resizeBilinear_: function (t, e, n = !1) {
        const r = Object(g.a)(t, "images", "resizeBilinear");
        S.assert(3 === r.rank || 4 === r.rank, () => "Error in resizeBilinear: x must be rank 3 or 4, but got " + `rank ${r.rank}.`), S.assert(2 === e.length, () => "Error in resizeBilinear: new shape must 2D, but got shape " + `${e}.`);
        let s = r,
          i = !1;
        3 === r.rank && (i = !0, s = R(r, [1, r.shape[0], r.shape[1], r.shape[2]]));
        const [a, o] = e, u = {
          images: s
        }, c = {
          alignCorners: n,
          size: e
        }, l = d.a.runKernelFunc((t, e) => (e([s]), t.resizeBilinear(s, a, o, n)), u, null, m.fc, c);
        return i ? R(l, [l.shape[1], l.shape[2], l.shape[3]]) : l
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ri = Object(b.a)({
      resizeNearestNeighbor_: function (t, e, n = !1) {
        const r = Object(g.a)(t, "images", "resizeNearestNeighbor");
        S.assert(3 === r.rank || 4 === r.rank, () => "Error in resizeNearestNeighbor: x must be rank 3 or 4, but got " + `rank ${r.rank}.`), S.assert(2 === e.length, () => "Error in resizeNearestNeighbor: new shape must 2D, but got shape " + `${e}.`), S.assert("float32" === r.dtype || "int32" === r.dtype, () => "`images` must have `int32` or `float32` as dtype");
        let s = r,
          i = !1;
        3 === r.rank && (i = !0, s = R(r, [1, r.shape[0], r.shape[1], r.shape[2]]));
        const [a, o] = e, u = {
          images: s
        }, c = {
          alignCorners: n,
          size: e
        }, l = d.a.runKernelFunc((t, e) => (e([s]), t.resizeNearestNeighbor(s, a, o, n)), u, null, m.hc, c);
        return i ? R(l, [l.shape[1], l.shape[2], l.shape[3]]) : l
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const si = Object(b.a)({
      bandPart_: function (t, e, n) {
        Object(S.assert)(e % 1 == 0, () => `bandPart(): numLower must be an integer, got ${e}.`), Object(S.assert)(n % 1 == 0, () => `bandPart(): numUpper must be an integer, got ${n}.`);
        const r = Object(g.a)(t, "a", "bandPart");
        Object(S.assert)(r.rank >= 2, () => `bandPart(): Rank must be at least 2, got ${r.rank}.`);
        const s = r.shape,
          [i, a] = r.shape.slice(-2);
        if (!(e <= i)) throw new Error(`bandPart(): numLower (${e})` + ` must not be greater than the number of rows (${i}).`);
        if (!(n <= a)) throw new Error(`bandPart(): numUpper (${n})` + ` must not be greater than the number of columns (${a}).`);
        e < 0 && (e = i), n < 0 && (n = a);
        const o = R(ar(0, i, 1, "int32"), [-1, 1]),
          u = ar(0, a, 1, "int32"),
          c = mn(o, u),
          l = wn(rn(c, Je(+e, "int32")), Ue(c, Je(-n, "int32"))),
          h = Cn([i, a], r.dtype);
        return R(Rr(Hr(R(r, [-1, i, a])).map(t => Oe(l, t, h))), s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ii = Object(b.a)({
      gramSchmidt_: function (t) {
        let e;
        if (Array.isArray(t)) {
          e = !1, Object(S.assert)(null != t && t.length > 0, () => "Gram-Schmidt process: input must not be null, undefined, or empty");
          const n = t[0].shape[0];
          for (let e = 1; e < t.length; ++e) Object(S.assert)(t[e].shape[0] === n, () => "Gram-Schmidt: Non-unique lengths found in the input vectors: " + `(${t[e].shape[0]} vs. ${n})`)
        } else e = !0, t = mr(t, t.shape[0], 0).map(t => $r(t, [0]));
        Object(S.assert)(t.length <= t[0].shape[0], () => `Gram-Schmidt: Number of vectors (${t.length}) exceeds ` + `number of dimensions (${t[0].shape[0]}).`);
        const n = [],
          r = t;
        for (let e = 0; e < t.length; ++e) n.push(d.a.tidy(() => {
          let t = r[e];
          if (e > 0)
            for (let r = 0; r < e; ++r) {
              const e = xt(gn(xt(n[r], t)), n[r]);
              t = mn(t, e)
            }
          return be(t, hs(t, "euclidean"))
        }));
        return e ? Rr(n, 0) : n
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ai(t, e = !1) {
      return d.a.tidy(() => {
        Object(S.assert)(2 === t.shape.length, () => `qr2d() requires a 2D Tensor, but got a ${t.shape.length}D Tensor.`);
        const n = t.shape[0],
          r = t.shape[1];
        let s = $e(n),
          i = Gt(t);
        const a = Mr([
          [1]
        ], [1, 1]);
        let o = Gt(a);
        const u = n >= r ? r : n;
        for (let t = 0; t < u; ++t) {
          const e = i,
            u = o,
            c = s;
          [o, i, s] = d.a.tidy(() => {
            const e = Mt(i, [t, t], [n - t, 1]),
              u = hs(e),
              c = Mt(i, [t, t], [1, 1]),
              l = Oe(We(c, 0), Mr([
                [-1]
              ]), Mr([
                [1]
              ])),
              h = mn(c, xt(l, u)),
              d = be(e, h);
            o = 1 === d.shape[0] ? Gt(a) : wt([a, Mt(d, [1, 0], [d.shape[0] - 1, d.shape[1]])], 0);
            const p = hn(be(vt(l, h), u)),
              f = Mt(i, [t, 0], [n - t, r]),
              m = xt(p, o),
              g = j(o);
            if (0 === t) i = mn(f, vt(m, vt(g, f)));
            else {
              const e = mn(f, vt(m, vt(g, f)));
              i = wt([Mt(i, [0, 0], [t, r]), e], 0)
            }
            const b = j(m),
              y = Mt(s, [0, t], [n, s.shape[1] - t]);
            if (0 === t) s = mn(y, vt(vt(y, o), b));
            else {
              const e = mn(y, vt(vt(y, o), b));
              s = wt([Mt(s, [0, 0], [n, t]), e], 1)
            }
            return [o, i, s]
          }), lt([e, u, c])
        }
        return !e && n > r && (s = Mt(s, [0, 0], [n, r]), i = Mt(i, [0, 0], [r, r])), [s, i]
      })
    }
    const oi = Object(b.a)({
      qr_: function (t, e = !1) {
        if (Object(S.assert)(t.rank >= 2, () => `qr() requires input tensor to have a rank >= 2, but got rank ${t.rank}`), 2 === t.rank) return ai(t, e); {
          const n = t.shape.slice(0, t.shape.length - 2).reduce((t, e) => t * e),
            r = Hr(R(t, [n, t.shape[t.shape.length - 2], t.shape[t.shape.length - 1]]), 0),
            s = [],
            i = [];
          return r.forEach(t => {
            const [n, r] = ai(t, e);
            s.push(n), i.push(r)
          }), [R(Rr(s, 0), t.shape), R(Rr(i, 0), t.shape)]
        }
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    var ui;
    ! function (t) {
      t[t.NONE = 0] = "NONE", t[t.MEAN = 1] = "MEAN", t[t.SUM = 2] = "SUM", t[t.SUM_BY_NONZERO_WEIGHTS = 3] = "SUM_BY_NONZERO_WEIGHTS"
    }(ui || (ui = {}));
    const ci = Object(b.a)({
      computeWeightedLoss_: function (t, e, n = ui.SUM_BY_NONZERO_WEIGHTS) {
        const r = Object(g.a)(t, "losses", "computeWeightedLoss");
        let s = null;
        null != e && (s = Object(g.a)(e, "weights", "computeWeightedLoss"));
        const i = null == s ? r : xt(r, s);
        if (n === ui.NONE) return i;
        if (n === ui.SUM) return gn(i);
        if (n === ui.MEAN) {
          if (null == s) return In(i); {
            const t = r.size / s.size,
              e = be(gn(i), gn(s));
            return t > 1 ? be(e, Je(t)) : e
          }
        }
        if (n === ui.SUM_BY_NONZERO_WEIGHTS) {
          if (null == s) return be(gn(i), Je(r.size)); {
            const t = xt(s, En(r.shape)),
              e = V(gn(Fn(t, Je(0))), "float32");
            return be(gn(i), e)
          }
        }
        throw Error(`Unknown reduction: ${n}`)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const li = Object(b.a)({
      absoluteDifference_: function (t, e, n, r = ui.SUM_BY_NONZERO_WEIGHTS) {
        const s = Object(g.a)(t, "labels", "absoluteDifference"),
          i = Object(g.a)(e, "predictions", "absoluteDifference");
        let a = null;
        null != n && (a = Object(g.a)(n, "weights", "absoluteDifference")), Object(S.assertShapesMatch)(s.shape, i.shape, "Error in absoluteDifference: ");
        const o = y(mn(s, i));
        return ci(o, a, r)
      }
    });
    const hi = Object(b.a)({
      cosineDistance_: function (t, e, n, r, s = ui.SUM_BY_NONZERO_WEIGHTS) {
        const i = Object(g.a)(t, "labels", "cosineDistance"),
          a = Object(g.a)(e, "predictions", "cosineDistance");
        let o = null;
        null != r && (o = Object(g.a)(r, "weights", "cosineDistance")), Object(S.assertShapesMatch)(i.shape, a.shape, "Error in cosineDistance: ");
        const u = Je(1),
          c = mn(u, gn(xt(i, a), n, !0));
        return ci(c, o, s)
      }
    });
    const di = Object(b.a)({
      hingeLoss_: function (t, e, n, r = ui.SUM_BY_NONZERO_WEIGHTS) {
        let s = Object(g.a)(t, "labels", "hingeLoss");
        const i = Object(g.a)(e, "predictions", "hingeLoss");
        let a = null;
        null != n && (a = Object(g.a)(n, "weights", "hingeLoss")), Object(S.assertShapesMatch)(s.shape, i.shape, "Error in hingeLoss: ");
        const o = Je(1);
        s = mn(xt(Je(2), s), o);
        const u = ur(mn(o, xt(s, i)));
        return ci(u, a, r)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const pi = Object(b.a)({
      huberLoss_: function (t, e, n, r = 1, s = ui.SUM_BY_NONZERO_WEIGHTS) {
        const i = Object(g.a)(t, "labels", "huberLoss"),
          a = Object(g.a)(e, "predictions", "huberLoss");
        let o = null;
        null != n && (o = Object(g.a)(n, "weights", "huberLoss")), Object(S.assertShapesMatch)(i.shape, a.shape, "Error in huberLoss: ");
        const u = Je(r),
          c = y(mn(a, i)),
          l = An(c, u),
          h = mn(c, l),
          d = O(xt(Je(.5), $n(l)), xt(u, h));
        return ci(d, o, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const fi = Object(b.a)({
      logLoss_: function (t, e, n, r = 1e-7, s = ui.SUM_BY_NONZERO_WEIGHTS) {
        const i = Object(g.a)(t, "labels", "logLoss"),
          a = Object(g.a)(e, "predictions", "logLoss");
        let o = null;
        null != n && (o = Object(g.a)(n, "weights", "logLoss")), Object(S.assertShapesMatch)(i.shape, a.shape, "Error in logLoss: ");
        const u = Je(1),
          c = Je(r),
          l = hn(xt(i, on(O(a, c)))),
          h = xt(mn(u, i), on(O(mn(u, a), c))),
          d = mn(l, h);
        return ci(d, o, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const mi = Object(b.a)({
      meanSquaredError_: function (t, e, n, r = ui.SUM_BY_NONZERO_WEIGHTS) {
        const s = Object(g.a)(t, "labels", "meanSquaredError"),
          i = Object(g.a)(e, "predictions", "meanSquaredError");
        let a = null;
        null != n && (a = Object(g.a)(n, "weights", "meanSquaredError")), Object(S.assertShapesMatch)(s.shape, i.shape, "Error in meanSquaredError: ");
        const o = Nr(s, i);
        return ci(o, a, r)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const gi = Object(b.a)({
      sigmoidCrossEntropy_: function (t, e, n, r = 0, s = ui.SUM_BY_NONZERO_WEIGHTS) {
        let i = Object(g.a)(t, "multiClassLabels", "sigmoidCrossEntropy");
        const a = Object(g.a)(e, "logits", "sigmoidCrossEntropy");
        let o = null;
        if (null != n && (o = Object(g.a)(n, "weights", "sigmoidCrossEntropy")), Object(S.assertShapesMatch)(i.shape, a.shape, "Error in sigmoidCrossEntropy: "), r > 0) {
          const t = Je(r),
            e = Je(1),
            n = Je(.5);
          i = O(xt(i, mn(e, t)), xt(n, t))
        }
        const u = function (t, e) {
          const n = Object(g.a)(t, "labels", "sigmoidCrossEntropyWithLogits"),
            r = Object(g.a)(e, "logits", "sigmoidCrossEntropyWithLogits");
          Object(S.assertShapesMatch)(n.shape, r.shape, "Error in sigmoidCrossEntropyWithLogits: ");
          const s = ur(r),
            i = xt(r, n),
            a = un(Ie(hn(y(r))));
          return O(mn(s, i), a)
        }(i, a);
        return ci(u, o, s)
      }
    });
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const bi = Object(b.a)({
        softmaxCrossEntropy_: function (t, e, n, r = 0, s = ui.SUM_BY_NONZERO_WEIGHTS) {
          let i = Object(g.a)(t, "onehotLabels", "softmaxCrossEntropy");
          const a = Object(g.a)(e, "logits", "softmaxCrossEntropy");
          let o = null;
          if (null != n && (o = Object(g.a)(n, "weights", "softmaxCrossEntropy")), Object(S.assertShapesMatch)(i.shape, a.shape, "Error in softmaxCrossEntropy: "), r > 0) {
            const t = Je(r),
              e = Je(1),
              n = Je(i.shape[1]);
            i = O(xt(i, mn(e, t)), be(t, n))
          }
          const u = function (t, e, n = -1) {
            if (-1 === n && (n = e.rank - 1), n !== e.rank - 1) throw Error("Softmax cross entropy along a non-last dimension is not yet " + `supported. Labels / logits was rank ${e.rank} ` + `and dim was ${n}`);
            return ln((t, e, r) => {
              const s = yn(e, [n], !0),
                i = mn(V(e, "float32"), s);
              r([t, i]);
              const a = hn(xt(i, t));
              return {
                value: gn(a, [n]),
                gradFunc: (t, e) => {
                  const [r, s] = e, i = I(t.shape, [n]);
                  return [xt(R(t, i), mn(V(r, "float32"), Ie(s))), xt(R(t, i), mn(Ie(s), V(r, "float32")))]
                }
              }
            })(t, e)
          }(i, a);
          return ci(u, o, s)
        }
      }),
      yi = {
        fft: Re,
        ifft: Ve,
        rfft: gr,
        irfft: Xe
      },
      wi = {
        hammingWindow: Rs,
        hannWindow: js,
        frame: Ds,
        stft: Fs
      },
      vi = {
        flipLeftRight: zs,
        resizeNearestNeighbor: ri,
        resizeBilinear: ni,
        rotateWithOffset: Ls,
        cropAndResize: Ms,
        nonMaxSuppression: Ps,
        nonMaxSuppressionAsync: Ys,
        nonMaxSuppressionWithScore: Zs,
        nonMaxSuppressionWithScoreAsync: Qs,
        nonMaxSuppressionPadded: ti,
        nonMaxSuppressionPaddedAsync: ei
      },
      xi = {
        bandPart: si,
        gramSchmidt: ii,
        qr: oi
      },
      Oi = {
        absoluteDifference: li,
        computeWeightedLoss: ci,
        cosineDistance: hi,
        hingeLoss: di,
        huberLoss: pi,
        logLoss: fi,
        meanSquaredError: mi,
        sigmoidCrossEntropy: gi,
        softmaxCrossEntropy: bi
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    Object(it.e)(a);
    var Si = n(11);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class _i {
      constructor() {
        this.saveRouters = [], this.loadRouters = []
      }
      static getInstance() {
        return null == _i.instance && (_i.instance = new _i), _i.instance
      }
      static registerSaveRouter(t) {
        _i.getInstance().saveRouters.push(t)
      }
      static registerLoadRouter(t) {
        _i.getInstance().loadRouters.push(t)
      }
      static getSaveHandlers(t) {
        return _i.getHandlers(t, "save")
      }
      static getLoadHandlers(t, e) {
        return _i.getHandlers(t, "load", e)
      }
      static getHandlers(t, e, n) {
        const r = [];
        return ("load" === e ? _i.getInstance().loadRouters : _i.getInstance().saveRouters).forEach(e => {
          const s = e(t, n);
          null !== s && r.push(s)
        }), r
      }
    }
    const ki = t => _i.registerSaveRouter(t),
      Ci = t => _i.registerLoadRouter(t),
      Ei = t => _i.getSaveHandlers(t),
      Ii = (t, e) => _i.getLoadHandlers(t, e),
      Ti = "://";
    class Ai {
      constructor() {
        this.managers = {}
      }
      static getInstance() {
        return null == Ai.instance && (Ai.instance = new Ai), Ai.instance
      }
      static registerManager(t, e) {
        Object(S.assert)(null != t, () => "scheme must not be undefined or null."), t.endsWith(Ti) && (t = t.slice(0, t.indexOf(Ti))), Object(S.assert)(t.length > 0, () => "scheme must not be an empty string.");
        const n = Ai.getInstance();
        Object(S.assert)(null == n.managers[t], () => `A model store manager is already registered for scheme '${t}'.`), n.managers[t] = e
      }
      static getManager(t) {
        const e = this.getInstance().managers[t];
        if (null == e) throw new Error(`Cannot find model manager for scheme '${t}'`);
        return e
      }
      static getSchemes() {
        return Object.keys(this.getInstance().managers)
      }
    }

    function Ni(t) {
      if (-1 === t.indexOf(Ti)) throw new Error("The url string provided does not contain a scheme. Supported schemes are: " + `${Ai.getSchemes().join(",")}`);
      return {
        scheme: t.split(Ti)[0],
        path: t.split(Ti)[1]
      }
    }
    async function $i(t, e, n = !1) {
      Object(S.assert)(t !== e, () => `Old path and new path are the same: '${t}'`);
      const r = _i.getLoadHandlers(t);
      Object(S.assert)(r.length > 0, () => `Copying failed because no load handler is found for source URL ${t}.`), Object(S.assert)(r.length < 2, () => `Copying failed because more than one (${r.length}) ` + `load handlers for source URL ${t}.`);
      const s = r[0],
        i = _i.getSaveHandlers(e);
      Object(S.assert)(i.length > 0, () => "Copying failed because no save handler is found for destination " + `URL ${e}.`), Object(S.assert)(i.length < 2, () => `Copying failed because more than one (${r.length}) ` + `save handlers for destination URL ${e}.`);
      const a = i[0],
        o = Ni(t).scheme,
        u = Ni(t).path,
        c = o === Ni(t).scheme,
        l = await s.load();
      n && c && await Ai.getManager(o).removeModel(u);
      const h = await a.save(l);
      return n && !c && await Ai.getManager(o).removeModel(u), h.modelArtifactsInfo
    }
    async function Ri() {
      const t = Ai.getSchemes(),
        e = {};
      for (const n of t) {
        const t = await Ai.getManager(n).listModels();
        for (const r in t) {
          e[n + Ti + r] = t[r]
        }
      }
      return e
    }
    async function ji(t) {
      const e = Ni(t);
      return Ai.getManager(e.scheme).removeModel(e.path)
    }
    async function Di(t, e) {
      return $i(t, e, !1)
    }
    async function Fi(t, e) {
      return $i(t, e, !0)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Mi = "tensorflowjs",
      zi = 1,
      Li = "models_store",
      Bi = "model_info_store";

    function Pi() {
      if (!Object(p.b)().getBool("IS_BROWSER")) throw new Error("Failed to obtain IndexedDB factory because the current environmentis not a web browser.");
      const t = "undefined" == typeof window ? self : window,
        e = t.indexedDB || t.mozIndexedDB || t.webkitIndexedDB || t.msIndexedDB || t.shimIndexedDB;
      if (null == e) throw new Error("The current browser does not appear to support IndexedDB.");
      return e
    }

    function Wi(t) {
      const e = t.result;
      e.createObjectStore(Li, {
        keyPath: "modelPath"
      }), e.createObjectStore(Bi, {
        keyPath: "modelPath"
      })
    }
    class Ui {
      constructor(t) {
        if (this.indexedDB = Pi(), null == t || !t) throw new Error("For IndexedDB, modelPath must not be null, undefined or empty.");
        this.modelPath = t
      }
      async save(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet.");
        return this.databaseAction(this.modelPath, t)
      }
      async load() {
        return this.databaseAction(this.modelPath)
      }
      databaseAction(t, e) {
        return new Promise((t, n) => {
          const r = this.indexedDB.open(Mi, zi);
          r.onupgradeneeded = () => Wi(r), r.onsuccess = () => {
            const s = r.result;
            if (null == e) {
              const e = s.transaction(Li, "readonly"),
                r = e.objectStore(Li).get(this.modelPath);
              r.onsuccess = () => {
                if (null == r.result) return s.close(), n(new Error(`Cannot find model with path '${this.modelPath}' ` + "in IndexedDB."));
                t(r.result.modelArtifacts)
              }, r.onerror = t => (s.close(), n(r.error)), e.oncomplete = () => s.close()
            } else {
              const r = Object(Si.g)(e),
                i = s.transaction(Bi, "readwrite");
              let a = i.objectStore(Bi);
              const o = a.put({
                modelPath: this.modelPath,
                modelArtifactsInfo: r
              });
              let u;
              o.onsuccess = () => {
                u = s.transaction(Li, "readwrite");
                const o = u.objectStore(Li).put({
                  modelPath: this.modelPath,
                  modelArtifacts: e,
                  modelArtifactsInfo: r
                });
                o.onsuccess = () => t({
                  modelArtifactsInfo: r
                }), o.onerror = t => {
                  a = i.objectStore(Bi);
                  const e = a.delete(this.modelPath);
                  e.onsuccess = () => (s.close(), n(o.error)), e.onerror = t => (s.close(), n(o.error))
                }
              }, o.onerror = t => (s.close(), n(o.error)), i.oncomplete = () => {
                null == u ? s.close() : u.oncomplete = () => s.close()
              }
            }
          }, r.onerror = t => n(r.error)
        })
      }
    }
    Ui.URL_SCHEME = "indexeddb://";
    const Vi = t => Object(p.b)().getBool("IS_BROWSER") && !Array.isArray(t) && t.startsWith(Ui.URL_SCHEME) ? function (t) {
      return new Ui(t)
    }(t.slice(Ui.URL_SCHEME.length)) : null;
    _i.registerSaveRouter(Vi), _i.registerLoadRouter(Vi);
    class Hi {
      constructor() {
        this.indexedDB = Pi()
      }
      async listModels() {
        return new Promise((t, e) => {
          const n = this.indexedDB.open(Mi, zi);
          n.onupgradeneeded = () => Wi(n), n.onsuccess = () => {
            const r = n.result,
              s = r.transaction(Bi, "readonly"),
              i = s.objectStore(Bi).getAll();
            i.onsuccess = () => {
              const e = {};
              for (const t of i.result) e[t.modelPath] = t.modelArtifactsInfo;
              t(e)
            }, i.onerror = t => (r.close(), e(i.error)), s.oncomplete = () => r.close()
          }, n.onerror = t => e(n.error)
        })
      }
      async removeModel(t) {
        var e;
        return t = (e = t).startsWith(Ui.URL_SCHEME) ? e.slice(Ui.URL_SCHEME.length) : e, new Promise((e, n) => {
          const r = this.indexedDB.open(Mi, zi);
          r.onupgradeneeded = () => Wi(r), r.onsuccess = () => {
            const s = r.result,
              i = s.transaction(Bi, "readwrite"),
              a = i.objectStore(Bi),
              o = a.get(t);
            let u;
            o.onsuccess = () => {
              if (null == o.result) return s.close(), n(new Error(`Cannot find model with path '${t}' ` + "in IndexedDB.")); {
                const r = a.delete(t),
                  i = () => {
                    u = s.transaction(Li, "readwrite");
                    const r = u.objectStore(Li).delete(t);
                    r.onsuccess = () => e(o.result.modelArtifactsInfo), r.onerror = t => n(o.error)
                  };
                r.onsuccess = i, r.onerror = t => (i(), s.close(), n(o.error))
              }
            }, o.onerror = t => (s.close(), n(o.error)), i.oncomplete = () => {
              null == u ? s.close() : u.oncomplete = () => s.close()
            }
          }, r.onerror = t => n(r.error)
        })
      }
    }
    if (Object(p.b)().getBool("IS_BROWSER")) try {
      Ai.registerManager(Ui.URL_SCHEME, new Hi)
    } catch (t) {}
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Gi = "/",
      qi = "tensorflowjs_models",
      Ki = "info",
      Ji = "model_topology",
      Xi = "weight_specs",
      Yi = "weight_data",
      Zi = "model_metadata";

    function Qi(t) {
      return {
        info: [qi, t, Ki].join(Gi),
        topology: [qi, t, Ji].join(Gi),
        weightSpecs: [qi, t, Xi].join(Gi),
        weightData: [qi, t, Yi].join(Gi),
        modelMetadata: [qi, t, Zi].join(Gi)
      }
    }

    function ta(t) {
      const e = t.split(Gi);
      if (e.length < 3) throw new Error(`Invalid key format: ${t}`);
      return e.slice(1, e.length - 1).join(Gi)
    }
    class ea {
      constructor(t) {
        if (!Object(p.b)().getBool("IS_BROWSER") || "undefined" == typeof window || void 0 === window.localStorage) throw new Error("The current environment does not support local storage.");
        if (this.LS = window.localStorage, null == t || !t) throw new Error("For local storage, modelPath must not be null, undefined or empty.");
        this.modelPath = t, this.keys = Qi(this.modelPath)
      }
      async save(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserLocalStorage.save() does not support saving model topology in binary formats yet."); {
          const e = JSON.stringify(t.modelTopology),
            n = JSON.stringify(t.weightSpecs),
            r = Object(Si.g)(t);
          try {
            return this.LS.setItem(this.keys.info, JSON.stringify(r)), this.LS.setItem(this.keys.topology, e), this.LS.setItem(this.keys.weightSpecs, n), this.LS.setItem(this.keys.weightData, Object(Si.a)(t.weightData)), this.LS.setItem(this.keys.modelMetadata, JSON.stringify({
              format: t.format,
              generatedBy: t.generatedBy,
              convertedBy: t.convertedBy,
              userDefinedMetadata: t.userDefinedMetadata
            })), {
              modelArtifactsInfo: r
            }
          } catch (t) {
            throw this.LS.removeItem(this.keys.info), this.LS.removeItem(this.keys.topology), this.LS.removeItem(this.keys.weightSpecs), this.LS.removeItem(this.keys.weightData), this.LS.removeItem(this.keys.modelMetadata), new Error(`Failed to save model '${this.modelPath}' to local storage: ` + "size quota being exceeded is a possible cause of this failure: " + `modelTopologyBytes=${r.modelTopologyBytes}, ` + `weightSpecsBytes=${r.weightSpecsBytes}, ` + `weightDataBytes=${r.weightDataBytes}.`)
          }
        }
      }
      async load() {
        const t = JSON.parse(this.LS.getItem(this.keys.info));
        if (null == t) throw new Error(`In local storage, there is no model with name '${this.modelPath}'`);
        if ("JSON" !== t.modelTopologyType) throw new Error("BrowserLocalStorage does not support loading non-JSON model topology yet.");
        const e = {},
          n = JSON.parse(this.LS.getItem(this.keys.topology));
        if (null == n) throw new Error(`In local storage, the topology of model '${this.modelPath}' ` + "is missing.");
        e.modelTopology = n;
        const r = JSON.parse(this.LS.getItem(this.keys.weightSpecs));
        if (null == r) throw new Error(`In local storage, the weight specs of model '${this.modelPath}' ` + "are missing.");
        e.weightSpecs = r;
        const s = this.LS.getItem(this.keys.modelMetadata);
        if (null != s) {
          const t = JSON.parse(s);
          e.format = t.format, e.generatedBy = t.generatedBy, e.convertedBy = t.convertedBy, e.userDefinedMetadata = t.userDefinedMetadata
        }
        const i = this.LS.getItem(this.keys.weightData);
        if (null == i) throw new Error("In local storage, the binary weight values of model " + `'${this.modelPath}' are missing.`);
        return e.weightData = Object(Si.b)(i), e
      }
    }
    ea.URL_SCHEME = "localstorage://";
    const na = t => Object(p.b)().getBool("IS_BROWSER") && !Array.isArray(t) && t.startsWith(ea.URL_SCHEME) ? function (t) {
      return new ea(t)
    }(t.slice(ea.URL_SCHEME.length)) : null;
    _i.registerSaveRouter(na), _i.registerLoadRouter(na);
    class ra {
      constructor() {
        Object(S.assert)(Object(p.b)().getBool("IS_BROWSER"), () => "Current environment is not a web browser"), Object(S.assert)("undefined" == typeof window || void 0 !== window.localStorage, () => "Current browser does not appear to support localStorage"), this.LS = window.localStorage
      }
      async listModels() {
        const t = {},
          e = qi + Gi,
          n = Gi + Ki;
        for (let r = 0; r < this.LS.length; ++r) {
          const s = this.LS.key(r);
          if (s.startsWith(e) && s.endsWith(n)) {
            t[ta(s)] = JSON.parse(this.LS.getItem(s))
          }
        }
        return t
      }
      async removeModel(t) {
        var e;
        const n = Qi(t = (e = t).startsWith(ea.URL_SCHEME) ? e.slice(ea.URL_SCHEME.length) : e);
        if (null == this.LS.getItem(n.info)) throw new Error(`Cannot find model at path '${t}'`);
        const r = JSON.parse(this.LS.getItem(n.info));
        return this.LS.removeItem(n.info), this.LS.removeItem(n.topology), this.LS.removeItem(n.weightSpecs), this.LS.removeItem(n.weightData), r
      }
    }
    if (Object(p.b)().getBool("IS_BROWSER")) try {
      Ai.registerManager(ea.URL_SCHEME, new ra)
    } catch (t) {}
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const sa = "model",
      ia = ".json",
      aa = ".weights.bin";

    function oa(t) {
      return new Promise(t => setTimeout(t)).then(t)
    }
    class ua {
      constructor(t) {
        if (!Object(p.b)().getBool("IS_BROWSER")) throw new Error("browserDownloads() cannot proceed because the current environment is not a browser.");
        t.startsWith(ua.URL_SCHEME) && (t = t.slice(ua.URL_SCHEME.length)), null != t && 0 !== t.length || (t = sa), this.modelTopologyFileName = t + ia, this.weightDataFileName = t + aa
      }
      async save(t) {
        if ("undefined" == typeof document) throw new Error("Browser downloads are not supported in this environment since `document` is not present");
        const e = window.URL.createObjectURL(new Blob([t.weightData], {
          type: "application/octet-stream"
        }));
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserDownloads.save() does not support saving model topology in binary formats yet."); {
          const n = [{
              paths: ["./" + this.weightDataFileName],
              weights: t.weightSpecs
            }],
            r = {
              modelTopology: t.modelTopology,
              format: t.format,
              generatedBy: t.generatedBy,
              convertedBy: t.convertedBy,
              weightsManifest: n
            },
            s = window.URL.createObjectURL(new Blob([JSON.stringify(r)], {
              type: "application/json"
            })),
            i = null == this.jsonAnchor ? document.createElement("a") : this.jsonAnchor;
          if (i.download = this.modelTopologyFileName, i.href = s, await oa(() => i.dispatchEvent(new MouseEvent("click"))), null != t.weightData) {
            const t = null == this.weightDataAnchor ? document.createElement("a") : this.weightDataAnchor;
            t.download = this.weightDataFileName, t.href = e, await oa(() => t.dispatchEvent(new MouseEvent("click")))
          }
          return {
            modelArtifactsInfo: Object(Si.g)(t)
          }
        }
      }
    }
    ua.URL_SCHEME = "downloads://";
    class ca {
      constructor(t) {
        if (null == t || t.length < 1) throw new Error("When calling browserFiles, at least 1 file is required, " + `but received ${t}`);
        this.files = t
      }
      async load() {
        const t = this.files[0],
          e = this.files.slice(1);
        return new Promise((n, r) => {
          const s = new FileReader;
          s.onload = s => {
            const i = JSON.parse(s.target.result),
              a = i.modelTopology;
            if (null == a) return void r(new Error(`modelTopology field is missing from file ${t.name}`));
            0 === e.length && n({
              modelTopology: a
            });
            const o = i.weightsManifest;
            if (null == o) return void r(new Error(`weightManifest field is missing from file ${t.name}`));
            let u;
            try {
              u = this.checkManifestAndWeightFiles(o, e)
            } catch (t) {
              return void r(t)
            }
            const c = [],
              l = [],
              h = [];
            o.forEach(t => {
              t.paths.forEach(t => {
                l.push(t), h.push(null)
              }), c.push(...t.weights)
            }), o.forEach(t => {
              t.paths.forEach(t => {
                const e = new FileReader;
                e.onload = e => {
                  const r = e.target.result,
                    s = l.indexOf(t);
                  h[s] = r, -1 === h.indexOf(null) && n({
                    modelTopology: a,
                    weightSpecs: c,
                    weightData: Object(Si.d)(h),
                    format: i.format,
                    generatedBy: i.generatedBy,
                    convertedBy: i.convertedBy,
                    userDefinedMetadata: i.userDefinedMetadata
                  })
                }, e.onerror = e => r(`Failed to weights data from file of path '${t}'.`), e.readAsArrayBuffer(u[t])
              })
            })
          }, s.onerror = e => r("Failed to read model topology and weights manifest JSON " + `from file '${t.name}'. BrowserFiles supports loading ` + "Keras-style tf.Model artifacts only."), s.readAsText(t)
        })
      }
      checkManifestAndWeightFiles(t, e) {
        const n = [],
          r = e.map(t => Object(Si.c)(t.name)),
          s = {};
        for (const i of t) i.paths.forEach(t => {
          const i = Object(Si.c)(t);
          if (-1 !== n.indexOf(i)) throw new Error("Duplicate file basename found in weights manifest: " + `'${i}'`);
          if (n.push(i), -1 === r.indexOf(i)) throw new Error(`Weight file with basename '${i}' is not provided.`);
          s[t] = e[r.indexOf(i)]
        });
        if (n.length !== e.length) throw new Error("Mismatch in the number of files in weights manifest " + `(${n.length}) and the number of weight files provided ` + `(${e.length}).`);
        return s
      }
    }

    function la(t) {
      return new ca(t)
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ha(t, e, n, r) {
      ! function (t) {
        Object(S.assert)(null != t && Array.isArray(t) && t.length > 0, () => "promises must be a none empty array")
      }(t),
      function (t, e) {
        Object(S.assert)(t >= 0 && t <= 1, () => "Progress fraction must be in range [0, 1], but " + `got startFraction ${t}`), Object(S.assert)(e >= 0 && e <= 1, () => "Progress fraction must be in range [0, 1], but " + `got endFraction ${e}`), Object(S.assert)(e >= t, () => "startFraction must be no more than endFraction, but " + `got startFraction ${t} and endFraction ` + `${e}`)
      }(n = null == n ? 0 : n, r = null == r ? 1 : r);
      let s = 0;
      return Promise.all(t.map(i => (i.then(i => {
        const a = n + ++s / t.length * (r - n);
        return e(a), i
      }), i)))
    }
    _i.registerSaveRouter(t => Object(p.b)().getBool("IS_BROWSER") && !Array.isArray(t) && t.startsWith(ua.URL_SCHEME) ? function (t = "model") {
      return new ua(t)
    }(t.slice(ua.URL_SCHEME.length)) : null);
    var da = n(45);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    async function pa(t, e) {
      null == e && (e = {});
      const n = null == e.fetchFunc ? Object(p.b)().platform.fetch : e.fetchFunc,
        r = t.map(t => n(t, e.requestInit, {
          isBinary: !0
        })),
        s = (null == e.onProgress ? await Promise.all(r) : await ha(r, e.onProgress, 0, .5)).map(t => t.arrayBuffer());
      return null == e.onProgress ? await Promise.all(s) : await ha(s, e.onProgress, .5, 1)
    }
    async function fa(t, e = "", n, r) {
      return ma(t => pa(t, {
        requestInit: r
      }))(t, e, n)
    }

    function ma(t) {
      return async (e, n = "", r) => {
        const s = e.map(() => !1),
          i = {},
          a = null != r ? r.map(() => !1) : [],
          o = [];
        if (e.forEach((t, e) => {
            let n = 0;
            t.weights.forEach(t => {
              const u = "quantization" in t ? t.quantization.dtype : t.dtype,
                c = da.a[u] * S.sizeFromShape(t.shape),
                l = () => {
                  s[e] = !0, null == i[e] && (i[e] = []), i[e].push({
                    manifestEntry: t,
                    groupOffset: n,
                    sizeBytes: c
                  })
                };
              null != r ? r.forEach((e, n) => {
                e === t.name && (l(), a[n] = !0)
              }) : l(), o.push(t.name), n += c
            })
          }), !a.every(t => t)) {
          const t = r.filter((t, e) => !a[e]);
          throw new Error("Could not find weights in manifest with names: " + `${t.join(", ")}. \n` + "Manifest JSON has weights with names: " + `${o.join(", ")}.`)
        }
        const u = s.reduce((t, e, n) => (e && t.push(n), t), []),
          c = [];
        u.forEach(t => {
          e[t].paths.forEach(t => {
            const e = n + (n.endsWith("/") ? "" : "/") + t;
            c.push(e)
          })
        });
        const l = await t(c),
          h = {};
        let d = 0;
        return u.forEach(t => {
          const n = e[t].paths.length;
          let r = 0;
          for (let t = 0; t < n; t++) r += l[d + t].byteLength;
          const s = new ArrayBuffer(r),
            a = new Uint8Array(s);
          let o = 0;
          for (let t = 0; t < n; t++) {
            const e = new Uint8Array(l[d + t]);
            a.set(e, o), o += e.byteLength
          }
          i[t].forEach(t => {
            const e = s.slice(t.groupOffset, t.groupOffset + t.sizeBytes),
              n = Object(Si.e)(e, [t.manifestEntry]);
            for (const t in n) h[t] = n[t]
          }), d += n
        }), h
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ga = "application/octet-stream",
      ba = "application/json";
    class ya {
      constructor(t, e) {
        if (this.DEFAULT_METHOD = "POST", null == e && (e = {}), this.weightPathPrefix = e.weightPathPrefix, this.onProgress = e.onProgress, null != e.fetchFunc ? (Object(S.assert)("function" == typeof e.fetchFunc, () => "Must pass a function that matches the signature of `fetch` (see https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API)"), this.fetch = e.fetchFunc) : this.fetch = Object(p.b)().platform.fetch, Object(S.assert)(null != t && t.length > 0, () => "URL path for http must not be null, undefined or empty."), Array.isArray(t) && Object(S.assert)(2 === t.length, () => "URL paths for http must have a length of 2, " + `(actual length is ${t.length}).`), this.path = t, null != e.requestInit && null != e.requestInit.body) throw new Error("requestInit is expected to have no pre-existing body, but has one.");
        this.requestInit = e.requestInit || {}
      }
      async save(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("BrowserHTTPRequest.save() does not support saving model topology in binary formats yet.");
        const e = Object.assign({
          method: this.DEFAULT_METHOD
        }, this.requestInit);
        e.body = new FormData;
        const n = [{
            paths: ["./model.weights.bin"],
            weights: t.weightSpecs
          }],
          r = {
            modelTopology: t.modelTopology,
            format: t.format,
            generatedBy: t.generatedBy,
            convertedBy: t.convertedBy,
            userDefinedMetadata: t.userDefinedMetadata,
            weightsManifest: n
          };
        e.body.append("model.json", new Blob([JSON.stringify(r)], {
          type: ba
        }), "model.json"), null != t.weightData && e.body.append("model.weights.bin", new Blob([t.weightData], {
          type: ga
        }), "model.weights.bin");
        const s = await this.fetch(this.path, e);
        if (s.ok) return {
          modelArtifactsInfo: Object(Si.g)(t),
          responses: [s]
        };
        throw new Error("BrowserHTTPRequest.save() failed due to HTTP response status " + `${s.status}.`)
      }
      async load() {
        const t = await this.fetch(this.path, this.requestInit);
        if (!t.ok) throw new Error(`Request to ${this.path} failed with status code ` + `${t.status}. Please verify this URL points to ` + "the model JSON of the model to load.");
        let e;
        try {
          e = await t.json()
        } catch (t) {
          let e = `Failed to parse model JSON of response from ${this.path}.`;
          throw this.path.endsWith(".pb") ? e += " Your path contains a .pb file extension. Support for .pb models have been removed in TensorFlow.js 1.0 in favor of .json models. You can re-convert your Python TensorFlow model using the TensorFlow.js 1.0 conversion scripts or you can convert your.pb models with the 'pb2json'NPM script in the tensorflow/tfjs-converter repository." : e += " Please make sure the server is serving valid JSON for this request.", new Error(e)
        }
        const n = e.modelTopology,
          r = e.weightsManifest,
          s = e.generatedBy,
          i = e.convertedBy,
          a = e.format,
          o = e.userDefinedMetadata;
        if (null == n && null == r) throw new Error(`The JSON from HTTP path ${this.path} contains neither model ` + "topology or manifest for weights.");
        let u, c;
        if (null != r) {
          const t = await this.loadWeights(r);
          [u, c] = t
        }
        return {
          modelTopology: n,
          weightSpecs: u,
          weightData: c,
          userDefinedMetadata: o,
          generatedBy: s,
          convertedBy: i,
          format: a
        }
      }
      async loadWeights(t) {
        const e = Array.isArray(this.path) ? this.path[1] : this.path,
          [n, r] = function (t) {
            const e = t.lastIndexOf("/"),
              n = t.lastIndexOf("?"),
              r = t.substring(0, e),
              s = n > e ? t.substring(n) : "";
            return [r + "/", s]
          }(e),
          s = this.weightPathPrefix || n,
          i = [];
        for (const e of t) i.push(...e.weights);
        const a = [];
        t.forEach(t => {
          t.paths.forEach(t => {
            a.push(s + t + r)
          })
        });
        const o = await pa(a, {
          requestInit: this.requestInit,
          fetchFunc: this.fetch,
          onProgress: this.onProgress
        });
        return [i, Object(Si.d)(o)]
      }
    }

    function wa(t) {
      return null != t.match(ya.URL_SCHEME_REGEX)
    }
    ya.URL_SCHEME_REGEX = /^https?:\/\//;
    const va = (t, e) => {
      if ("undefined" == typeof fetch && (null == e || null == e.fetchFunc)) return null; {
        let n = !0;
        if (n = Array.isArray(t) ? t.every(t => wa(t)) : wa(t), n) return xa(t, e)
      }
      return null
    };

    function xa(t, e) {
      return new ya(t, e)
    }

    function Oa(t, e) {
      return xa(t, e)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    _i.registerSaveRouter(va), _i.registerLoadRouter(va);
    class Sa {
      constructor(t) {
        this.modelArtifacts = t
      }
      async load() {
        return this.modelArtifacts
      }
    }
    class _a {
      constructor(t) {
        this.saveHandler = t
      }
      async save(t) {
        return this.saveHandler(t)
      }
    }

    function ka(t, e, n, r) {
      if (1 === arguments.length) {
        return null != t.modelTopology || null != t.weightSpecs ? new Sa(t) : (console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release."), new Sa({
          modelTopology: t
        }))
      }
      return console.warn("Please call tf.io.fromMemory() with only one argument. The argument should be of type ModelArtifacts. The multi-argument signature of tf.io.fromMemory() has been deprecated and will be removed in a future release."), new Sa({
        modelTopology: t,
        weightSpecs: e,
        weightData: n,
        trainingConfig: r
      })
    }

    function Ca(t) {
      return new _a(t)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    var Ea = n(23);
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    let Ia;
    async function Ta(t, e) {
      let n = Object(g.a)(t, "img", "toPixels");
      if (!(t instanceof it.a)) {
        const t = n;
        n = V(t, "int32"), t.dispose()
      }
      if (2 !== n.rank && 3 !== n.rank) throw new Error(`toPixels only supports rank 2 or 3 tensors, got rank ${n.rank}.`);
      const [r, s] = n.shape.slice(0, 2), i = 2 === n.rank ? 1 : n.shape[2];
      if (i > 4 || 2 === i) throw new Error("toPixels only supports depth of size " + `1, 3 or 4 but got ${i}`);
      const a = await n.data(),
        o = Tn(n),
        u = fn(n),
        c = await Promise.all([o.data(), u.data()]),
        l = c[0],
        h = c[1],
        d = l[0],
        p = h[0];
      if (o.dispose(), u.dispose(), "float32" === n.dtype) {
        if (d < 0 || p > 1) throw new Error("Tensor values for a float32 Tensor must be in the " + `range [0 - 1] but got range [${d} - ${p}].`)
      } else {
        if ("int32" !== n.dtype) throw new Error(`Unsupported type for toPixels: ${n.dtype}.` + " Please use float32 or int32 tensors.");
        if (d < 0 || p > 255) throw new Error("Tensor values for a int32 Tensor must be in the " + `range [0 - 255] but got range [${d} - ${p}].`)
      }
      const f = "float32" === n.dtype ? 255 : 1,
        m = new Uint8ClampedArray(s * r * 4);
      for (let t = 0; t < r * s; ++t) {
        let e, n, r, s;
        1 === i ? (e = a[t] * f, n = a[t] * f, r = a[t] * f, s = 255) : 3 === i ? (e = a[3 * t] * f, n = a[3 * t + 1] * f, r = a[3 * t + 2] * f, s = 255) : 4 === i && (e = a[4 * t] * f, n = a[4 * t + 1] * f, r = a[4 * t + 2] * f, s = a[4 * t + 3] * f);
        const o = 4 * t;
        m[o + 0] = Math.round(e), m[o + 1] = Math.round(n), m[o + 2] = Math.round(r), m[o + 3] = Math.round(s)
      }
      if (null != e) {
        e.width = s, e.height = r;
        const t = e.getContext("2d"),
          n = new ImageData(m, s, r);
        t.putImageData(n, 0, 0)
      }
      return n !== t && n.dispose(), m
    }
    const Aa = Object(b.a)({
      fromPixels_: function (t, e = 3) {
        if (e > 4) throw new Error("Cannot construct Tensor with more than 4 channels from pixels.");
        if (null == t) throw new Error("pixels passed to tf.browser.fromPixels() can not be null");
        let n = !1,
          r = !1,
          s = !1,
          i = !1,
          a = !1;
        if (t.data instanceof Uint8Array) n = !0;
        else if ("undefined" != typeof ImageData && t instanceof ImageData) r = !0;
        else if ("undefined" != typeof HTMLVideoElement && t instanceof HTMLVideoElement) s = !0;
        else if ("undefined" != typeof HTMLImageElement && t instanceof HTMLImageElement) i = !0;
        else {
          if (null == t.getContext) throw new Error("pixels passed to tf.browser.fromPixels() must be either an HTMLVideoElement, HTMLImageElement, HTMLCanvasElement, ImageData in browser, or OffscreenCanvas, ImageData in webworker or {data: Uint32Array, width: number, height: number}, " + `but was ${t.constructor.name}`);
          a = !0
        }
        if (s) {
          const e = 2;
          if (s && t.readyState < e) throw new Error("The video element has not loaded data yet. Please wait for `loadeddata` event on the <video> element.")
        }
        if (null != Object(Ea.b)(m.eb, d.a.backendName)) {
          const n = {
              pixels: t
            },
            r = {
              numChannels: e
            };
          return d.a.runKernel(m.eb, n, r)
        }
        const [o, u] = s ? [t.videoWidth, t.videoHeight] : [t.width, t.height];
        let c, l;
        if (a ? c = t.getContext("2d").getImageData(0, 0, o, u).data : r || n ? c = t.data : (i || s) && (null == Ia && (Ia = document.createElement("canvas").getContext("2d")), Ia.canvas.width = o, Ia.canvas.height = u, Ia.drawImage(t, 0, 0, o, u), c = Ia.getImageData(0, 0, o, u).data), 4 === e) l = new Int32Array(c);
        else {
          const t = o * u;
          l = new Int32Array(t * e);
          for (let n = 0; n < t; n++)
            for (let t = 0; t < e; ++t) l[n * e + t] = c[4 * n + t]
        }
        return zr(l, [u, o, e], "int32")
      }
    });
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Na {
      getClassName() {
        return this.constructor.className
      }
      static fromConfig(t, e) {
        return new t(e)
      }
    }
    class $a {
      constructor() {
        this.classNameMap = {}
      }
      static getMap() {
        return null == $a.instance && ($a.instance = new $a), $a.instance
      }
      static register(t) {
        $a.getMap().classNameMap[t.className] = [t, t.fromConfig]
      }
    }

    function Ra(t) {
      Object(S.assert)(null != t.className, () => "Class being registered does not have the static className property defined."), Object(S.assert)("string" == typeof t.className, () => "className is required to be a string, but got type " + typeof t.className), Object(S.assert)(t.className.length > 0, () => "Class being registered has an empty-string as its className, which is disallowed."), $a.register(t)
    }
    /** @license See the LICENSE file. */
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class ja extends Na {
      minimize(t, e = !1, n) {
        const {
          value: r,
          grads: s
        } = this.computeGradients(t, n);
        if (null != n) {
          const t = n.map(t => ({
            name: t.name,
            tensor: s[t.name]
          }));
          this.applyGradients(t)
        } else this.applyGradients(s);
        return lt(s), e ? r : (r.dispose(), null)
      }
      get iterations() {
        return null == this.iterations_ && (this.iterations_ = 0), this.iterations_
      }
      incrementIterations() {
        this.iterations_ = this.iterations + 1
      }
      computeGradients(t, e) {
        return cn(t, e)
      }
      dispose() {
        null != this.iterations_ && lt(this.iterations_)
      }
      async saveIterations() {
        return null == this.iterations_ && (this.iterations_ = 0), {
          name: "iter",
          tensor: Je(this.iterations_, "int32")
        }
      }
      async getWeights() {
        throw new Error("getWeights() is not implemented for this optimizer yet.")
      }
      async setWeights(t) {
        throw new Error("setWeights() is not implemented for this optimizer class " + `${this.getClassName()}`)
      }
      async extractIterations(t) {
        return this.iterations_ = (await t[0].tensor.data())[0], t.slice(1)
      }
    }
    Object.defineProperty(ja, Symbol.hasInstance, {
      value: t => null != t.minimize && null != t.computeGradients && null != t.applyGradients
    });
    var Da = n(31);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Fa extends ja {
      constructor(t, e, n = null) {
        super(), this.learningRate = t, this.rho = e, this.epsilon = n, this.accumulatedGrads = [], this.accumulatedUpdates = [], null == n && (this.epsilon = d.a.backend.epsilon())
      }
      applyGradients(t) {
        (Array.isArray(t) ? t.map(t => t.name) : Object.keys(t)).forEach((e, n) => {
          const r = d.a.registeredVariables[e];
          null == this.accumulatedGrads[n] && (this.accumulatedGrads[n] = {
            originalName: `${e}/accum_grad`,
            variable: ct(() => Se(r).variable(!1))
          }), null == this.accumulatedUpdates[n] && (this.accumulatedUpdates[n] = {
            originalName: `${e}/accum_var`,
            variable: ct(() => Se(r).variable(!1))
          });
          const s = Array.isArray(t) ? t[n].tensor : t[e];
          if (null == s) return;
          const i = this.accumulatedGrads[n].variable,
            a = this.accumulatedUpdates[n].variable;
          ct(() => {
            const t = O(xt(i, this.rho), xt($n(s), 1 - this.rho)),
              e = xt(be(Ar(O(a, this.epsilon)), Ar(O(i, this.epsilon))), s),
              n = O(xt(a, this.rho), xt($n(e), 1 - this.rho));
            i.assign(t), a.assign(n);
            const o = O(xt(e, -this.learningRate), r);
            r.assign(o)
          })
        }), this.incrementIterations()
      }
      dispose() {
        null != this.accumulatedUpdates && (lt(this.accumulatedGrads.map(t => t.variable)), lt(this.accumulatedUpdates.map(t => t.variable)))
      }
      async getWeights() {
        const t = [...this.accumulatedGrads, ...this.accumulatedUpdates];
        return [await this.saveIterations()].concat(t.map(t => ({
          name: t.originalName,
          tensor: t.variable
        })))
      }
      async setWeights(t) {
        const e = (t = await this.extractIterations(t)).length / 2;
        this.accumulatedGrads = t.slice(0, e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        })), this.accumulatedUpdates = t.slice(e, 2 * e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        }))
      }
      getConfig() {
        return {
          learningRate: this.learningRate,
          rho: this.rho,
          epsilon: this.epsilon
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate, e.rho, e.epsilon)
      }
    }
    Fa.className = "Adadelta", Ra(Fa);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ma extends ja {
      constructor(t, e = .1) {
        super(), this.learningRate = t, this.initialAccumulatorValue = e, this.accumulatedGrads = []
      }
      applyGradients(t) {
        (Array.isArray(t) ? t.map(t => t.name) : Object.keys(t)).forEach((e, n) => {
          const r = d.a.registeredVariables[e];
          if (null == this.accumulatedGrads[n]) {
            const t = !1;
            this.accumulatedGrads[n] = {
              originalName: `${e}/accumulator`,
              variable: ct(() => je(r.shape, this.initialAccumulatorValue).variable(t))
            }
          }
          const s = Array.isArray(t) ? t[n].tensor : t[e];
          if (null == s) return;
          const i = this.accumulatedGrads[n].variable;
          ct(() => {
            const t = O(i, $n(s));
            i.assign(t);
            const e = O(xt(be(s, Ar(O(t, d.a.backend.epsilon()))), -this.learningRate), r);
            r.assign(e)
          })
        }), this.incrementIterations()
      }
      dispose() {
        null != this.accumulatedGrads && lt(this.accumulatedGrads.map(t => t.variable))
      }
      async getWeights() {
        return [await this.saveIterations()].concat(this.accumulatedGrads.map(t => ({
          name: t.originalName,
          tensor: t.variable
        })))
      }
      async setWeights(t) {
        t = await this.extractIterations(t);
        this.accumulatedGrads = t.map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        }))
      }
      getConfig() {
        return {
          learningRate: this.learningRate,
          initialAccumulatorValue: this.initialAccumulatorValue
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate, e.initialAccumulatorValue)
      }
    }
    Ma.className = "Adagrad", Ra(Ma);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class za extends ja {
      constructor(t, e, n, r = null) {
        super(), this.learningRate = t, this.beta1 = e, this.beta2 = n, this.epsilon = r, this.accumulatedFirstMoment = [], this.accumulatedSecondMoment = [], ct(() => {
          this.accBeta1 = Je(e).variable(), this.accBeta2 = Je(n).variable()
        }), null == r && (this.epsilon = d.a.backend.epsilon())
      }
      applyGradients(t) {
        const e = Array.isArray(t) ? t.map(t => t.name) : Object.keys(t);
        ct(() => {
          const n = mn(1, this.accBeta1),
            r = mn(1, this.accBeta2);
          e.forEach((e, s) => {
            const i = d.a.registeredVariables[e];
            null == this.accumulatedFirstMoment[s] && (this.accumulatedFirstMoment[s] = {
              originalName: `${e}/m`,
              variable: ct(() => Se(i).variable(!1))
            }), null == this.accumulatedSecondMoment[s] && (this.accumulatedSecondMoment[s] = {
              originalName: `${e}/v`,
              variable: ct(() => Se(i).variable(!1))
            });
            const a = Array.isArray(t) ? t[s].tensor : t[e];
            if (null == a) return;
            const o = this.accumulatedFirstMoment[s].variable,
              u = this.accumulatedSecondMoment[s].variable,
              c = O(xt(o, this.beta1), xt(a, 1 - this.beta1)),
              l = O(xt(u, this.beta2), xt($n(a), 1 - this.beta2)),
              h = be(c, n),
              p = be(l, r);
            o.assign(c), u.assign(l);
            const f = O(xt(be(h, O(Ar(p), this.epsilon)), -this.learningRate), i);
            i.assign(f)
          }), this.accBeta1.assign(xt(this.accBeta1, this.beta1)), this.accBeta2.assign(xt(this.accBeta2, this.beta2))
        }), this.incrementIterations()
      }
      dispose() {
        this.accBeta1.dispose(), this.accBeta2.dispose(), null != this.accumulatedFirstMoment && lt(this.accumulatedFirstMoment.map(t => t.variable)), null != this.accumulatedSecondMoment && lt(this.accumulatedSecondMoment.map(t => t.variable))
      }
      async getWeights() {
        const t = [...this.accumulatedFirstMoment, ...this.accumulatedSecondMoment];
        return [await this.saveIterations()].concat(t.map(t => ({
          name: t.originalName,
          tensor: t.variable
        })))
      }
      async setWeights(t) {
        t = await this.extractIterations(t), ct(() => {
          this.accBeta1.assign(qn(this.beta1, this.iterations_ + 1)), this.accBeta2.assign(qn(this.beta2, this.iterations_ + 1))
        });
        const e = t.length / 2;
        this.accumulatedFirstMoment = t.slice(0, e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        })), this.accumulatedSecondMoment = t.slice(e, 2 * e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        }))
      }
      getConfig() {
        return {
          learningRate: this.learningRate,
          beta1: this.beta1,
          beta2: this.beta2,
          epsilon: this.epsilon
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate, e.beta1, e.beta2, e.epsilon)
      }
    }
    za.className = "Adam", Ra(za);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class La extends ja {
      constructor(t, e, n, r = null, s = 0) {
        super(), this.learningRate = t, this.beta1 = e, this.beta2 = n, this.epsilon = r, this.decay = s, this.accumulatedFirstMoment = [], this.accumulatedWeightedInfNorm = [], ct(() => {
          this.iteration = Je(0).variable(), this.accBeta1 = Je(e).variable()
        }), null == r && (this.epsilon = d.a.backend.epsilon())
      }
      applyGradients(t) {
        const e = Array.isArray(t) ? t.map(t => t.name) : Object.keys(t);
        ct(() => {
          const n = mn(1, this.accBeta1),
            r = be(-this.learningRate, O(xt(this.iteration, this.decay), 1));
          e.forEach((e, s) => {
            const i = d.a.registeredVariables[e];
            null == this.accumulatedFirstMoment[s] && (this.accumulatedFirstMoment[s] = {
              originalName: `${e}/m`,
              variable: Se(i).variable(!1)
            }), null == this.accumulatedWeightedInfNorm[s] && (this.accumulatedWeightedInfNorm[s] = {
              originalName: `${e}/v`,
              variable: Se(i).variable(!1)
            });
            const a = Array.isArray(t) ? t[s].tensor : t[e];
            if (null == a) return;
            const o = this.accumulatedFirstMoment[s].variable,
              u = this.accumulatedWeightedInfNorm[s].variable,
              c = O(xt(o, this.beta1), xt(a, 1 - this.beta1)),
              l = xt(u, this.beta2),
              h = y(a),
              p = tn(l, h);
            o.assign(c), u.assign(p);
            const f = O(xt(be(r, n), be(c, O(p, this.epsilon))), i);
            i.assign(f)
          }), this.iteration.assign(O(this.iteration, 1)), this.accBeta1.assign(xt(this.accBeta1, this.beta1))
        }), this.incrementIterations()
      }
      dispose() {
        this.accBeta1.dispose(), this.iteration.dispose(), null != this.accumulatedFirstMoment && lt(this.accumulatedFirstMoment.map(t => t.variable)), null != this.accumulatedWeightedInfNorm && lt(this.accumulatedWeightedInfNorm.map(t => t.variable))
      }
      async getWeights() {
        throw new Error("getWeights() is not implemented for Adamax yet.")
      }
      async setWeights(t) {
        throw new Error("setWeights() is not implemented for Adamax yet.")
      }
      getConfig() {
        return {
          learningRate: this.learningRate,
          beta1: this.beta1,
          beta2: this.beta2,
          epsilon: this.epsilon,
          decay: this.decay
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate, e.beta1, e.beta2, e.epsilon, e.decay)
      }
    }
    La.className = "Adamax", Ra(La);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ba extends ja {
      constructor(t) {
        super(), this.learningRate = t, this.setLearningRate(t)
      }
      applyGradients(t) {
        (Array.isArray(t) ? t.map(t => t.name) : Object.keys(t)).forEach((e, n) => {
          const r = Array.isArray(t) ? t[n].tensor : t[e];
          if (null == r) return;
          const s = d.a.registeredVariables[e];
          ct(() => {
            const t = O(xt(this.c, r), s);
            s.assign(t)
          })
        }), this.incrementIterations()
      }
      setLearningRate(t) {
        this.learningRate = t, null != this.c && this.c.dispose(), this.c = ht(Je(-t))
      }
      dispose() {
        this.c.dispose()
      }
      async getWeights() {
        return [await this.saveIterations()]
      }
      async setWeights(t) {
        if (0 !== (t = await this.extractIterations(t)).length) throw new Error("SGD optimizer does not have settable weights.")
      }
      getConfig() {
        return {
          learningRate: this.learningRate
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate)
      }
    }
    Ba.className = "SGD", Ra(Ba);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Pa extends Ba {
      constructor(t, e, n = !1) {
        super(t), this.learningRate = t, this.momentum = e, this.useNesterov = n, this.accumulations = [], this.m = Je(this.momentum)
      }
      applyGradients(t) {
        (Array.isArray(t) ? t.map(t => t.name) : Object.keys(t)).forEach((e, n) => {
          const r = d.a.registeredVariables[e];
          if (null == this.accumulations[n]) {
            const t = !1;
            this.accumulations[n] = {
              originalName: `${e}/momentum`,
              variable: ct(() => Se(r).variable(t))
            }
          }
          const s = this.accumulations[n].variable,
            i = Array.isArray(t) ? t[n].tensor : t[e];
          null != i && ct(() => {
            let t;
            const e = O(xt(this.m, s), i);
            t = this.useNesterov ? O(xt(this.c, O(i, xt(e, this.m))), r) : O(xt(this.c, e), r), s.assign(e), r.assign(t)
          })
        }), this.incrementIterations()
      }
      dispose() {
        this.m.dispose(), null != this.accumulations && lt(this.accumulations.map(t => t.variable))
      }
      setMomentum(t) {
        this.momentum = t
      }
      async getWeights() {
        return [await this.saveIterations()].concat(this.accumulations.map(t => ({
          name: t.originalName,
          tensor: t.variable
        })))
      }
      async setWeights(t) {
        t = await this.extractIterations(t);
        this.accumulations = t.map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        }))
      }
      getConfig() {
        return {
          learningRate: this.learningRate,
          momentum: this.momentum,
          useNesterov: this.useNesterov
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate, e.momentum, e.useNesterov)
      }
    }
    Pa.className = "Momentum", Ra(Pa);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Wa extends ja {
      constructor(t, e = .9, n = 0, r = null, s = !1) {
        if (super(), this.learningRate = t, this.decay = e, this.momentum = n, this.epsilon = r, this.accumulatedMeanSquares = [], this.accumulatedMoments = [], this.accumulatedMeanGrads = [], this.centered = s, null == r && (this.epsilon = d.a.backend.epsilon()), null == t) throw new Error("learningRate for RMSPropOptimizer must be defined.")
      }
      applyGradients(t) {
        (Array.isArray(t) ? t.map(t => t.name) : Object.keys(t)).forEach((e, n) => {
          const r = d.a.registeredVariables[e];
          null == this.accumulatedMeanSquares[n] && (this.accumulatedMeanSquares[n] = {
            originalName: `${e}/rms`,
            variable: ct(() => Se(r).variable(!1))
          }), null == this.accumulatedMoments[n] && (this.accumulatedMoments[n] = {
            originalName: `${e}/momentum`,
            variable: ct(() => Se(r).variable(!1))
          }), null == this.accumulatedMeanGrads[n] && this.centered && (this.accumulatedMeanGrads[n] = {
            originalName: `${e}/mg`,
            variable: ct(() => Se(r).variable(!1))
          });
          const s = Array.isArray(t) ? t[n].tensor : t[e];
          if (null == s) return;
          const i = this.accumulatedMeanSquares[n].variable,
            a = this.accumulatedMoments[n].variable;
          ct(() => {
            const t = O(xt(i, this.decay), xt($n(s), 1 - this.decay));
            if (this.centered) {
              const e = this.accumulatedMeanGrads[n].variable,
                o = O(xt(e, this.decay), xt(s, 1 - this.decay)),
                u = be(xt(s, this.learningRate), Ar(mn(t, O($n(o), this.epsilon)))),
                c = O(xt(a, this.momentum), u);
              i.assign(t), e.assign(o), a.assign(c);
              const l = mn(r, c);
              r.assign(l)
            } else {
              const t = O(xt(i, this.decay), xt($n(s), 1 - this.decay)),
                e = O(xt(a, this.momentum), be(xt(s, this.learningRate), Ar(O(t, this.epsilon))));
              i.assign(t), a.assign(e);
              const n = mn(r, e);
              r.assign(n)
            }
          })
        }), this.incrementIterations()
      }
      dispose() {
        null != this.accumulatedMeanSquares && lt(this.accumulatedMeanSquares.map(t => t.variable)), null != this.accumulatedMeanGrads && this.centered && lt(this.accumulatedMeanGrads.map(t => t.variable)), null != this.accumulatedMoments && lt(this.accumulatedMoments.map(t => t.variable))
      }
      async getWeights() {
        const t = [...this.accumulatedMeanSquares, ...this.accumulatedMoments];
        return this.centered && t.push(...this.accumulatedMeanGrads), [await this.saveIterations()].concat(t.map(t => ({
          name: t.originalName,
          tensor: t.variable
        })))
      }
      async setWeights(t) {
        t = await this.extractIterations(t);
        const e = this.centered ? t.length / 3 : t.length / 2;
        this.accumulatedMeanSquares = t.slice(0, e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        })), this.accumulatedMoments = t.slice(e, 2 * e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        })), this.centered && (this.accumulatedMeanGrads = t.slice(2 * e, 3 * e).map(t => ({
          originalName: t.name,
          variable: t.tensor.variable(!1)
        })))
      }
      getConfig() {
        return {
          learningRate: this.learningRate,
          decay: this.decay,
          momentum: this.momentum,
          epsilon: this.epsilon,
          centered: this.centered
        }
      }
      static fromConfig(t, e) {
        return new t(e.learningRate, e.decay, e.momentum, e.epsilon, e.centered)
      }
    }
    Wa.className = "RMSProp", Ra(Wa);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ua {
      static sgd(t) {
        return new Ba(t)
      }
      static momentum(t, e, n = !1) {
        return new Pa(t, e, n)
      }
      static rmsprop(t, e = .9, n = 0, r = null, s = !1) {
        return new Wa(t, e, n, r, s)
      }
      static adam(t = .001, e = .9, n = .999, r = null) {
        return new za(t, e, n, r)
      }
      static adadelta(t = .001, e = .95, n = null) {
        return new Fa(t, e, n)
      }
      static adamax(t = .002, e = .9, n = .999, r = null, s = 0) {
        return new La(t, e, n, r, s)
      }
      static adagrad(t, e = .1) {
        return new Ma(t, e)
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Va = {
      sgd: Ua.sgd,
      momentum: Ua.momentum,
      adadelta: Ua.adadelta,
      adagrad: Ua.adagrad,
      rmsprop: Ua.rmsprop,
      adamax: Ua.adamax,
      adam: Ua.adam
    };
    var Ha = n(82);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Ga(t, e, n) {
      return [n * ("number" == typeof t ? t : t[0]), e * ("number" == typeof t ? t : t[1])]
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function qa(t, e, n, r = !0) {
      let s = [];
      if (r) s = s.concat(e.slice(0)), s.push(t[0] / n), s = s.concat(t.slice(1));
      else {
        s = s.concat(t[0]);
        const n = e.length;
        for (let r = 0; r < n; ++r) s = s.concat([t[r + 1] / e[r], e[r]]);
        s = s.concat(t.slice(n + 1))
      }
      return s
    }

    function Ka(t, e, n = !0) {
      const r = [];
      if (n) {
        r.push(e);
        for (let n = e + 1; n < t; ++n) n <= 2 * e ? (r.push(n), r.push(n - (e + 1))) : r.push(n)
      } else {
        const n = [],
          s = [];
        for (let r = 1; r < t; ++r) r >= 2 * e + 1 || r % 2 == 1 ? s.push(r) : n.push(r);
        r.push(...n), r.push(0), r.push(...s)
      }
      return r
    }

    function Ja(t, e, n, r = !0) {
      const s = [];
      r ? s.push(t[0] / n) : s.push(t[0] * n);
      for (let n = 1; n < t.length; ++n) n <= e.length ? r ? s.push(e[n - 1] * t[n]) : s.push(t[n] / e[n - 1]) : s.push(t[n]);
      return s
    }

    function Xa(t, e) {
      const n = [0];
      for (let r = 0; r < e; ++r) n.push(t[r][0]);
      return n
    }

    function Ya(t, e, n) {
      const r = t.slice(0, 1);
      for (let s = 0; s < n; ++s) r.push(t[s + 1] - e[s][0] - e[s][1]);
      return r
    }

    function Za(t, e) {
      if (t.rank < 1) throw new Error("tf.gatherND() expects the input to be rank 1 or higher," + ` but the rank was ${t.rank}.`);
      if (e.rank < 1) throw new Error("tf.gatherND() expects the indices to be rank 1 or higher," + ` but the rank was ${e.rank}.`);
      if ("int32" !== e.dtype) throw new Error("tf.gatherND() expects the indices to be int32 type," + ` but the dtype was ${e.dtype}.`);
      if (e.shape[e.rank - 1] > t.rank) throw new Error("index innermost dimension length must be <= tensor rank; saw: " + `${e.shape[e.rank-1]} vs. ${t.rank}`);
      if (0 === t.size) throw new Error("Requested more than 0 entries, but input is empty." + ` Input shape: ${t.shape}.`);
      const n = e.shape,
        r = n[n.length - 1];
      let s = 1;
      for (let t = 0; t < n.length - 1; ++t) s *= n[t];
      const i = t.shape,
        a = n.slice();
      a.pop();
      let o = 1;
      for (let e = r; e < t.rank; ++e) o *= i[e], a.push(i[e]);
      const u = [...Object(S.computeStrides)(t.shape).map(t => t / o), 1].slice(0, r);
      return [a, s, o, u]
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Qa = 1.7580993408473768,
      to = 1.0507009873554805,
      eo = .3275911,
      no = .254829592,
      ro = -.284496736,
      so = 1.421413741,
      io = -1.453152027,
      ao = 1.061405429;
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function oo(...t) {
      Object(p.b)().getBool("IS_TEST") || console.warn(...t)
    }

    function uo(...t) {
      Object(p.b)().getBool("IS_TEST") || console.log(...t)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function co(t, e) {
      if (t.length !== e.length) throw new Error("Cannot merge real and imag arrays of different lengths. real:" + `${t.length}, imag: ${e.length}.`);
      const n = new Float32Array(2 * t.length);
      for (let r = 0; r < n.length; r += 2) n[r] = t[r / 2], n[r + 1] = e[r / 2];
      return n
    }

    function lo(t) {
      const e = new Float32Array(t.length / 2),
        n = new Float32Array(t.length / 2);
      for (let r = 0; r < t.length; r += 2) e[r / 2] = t[r], n[r / 2] = t[r + 1];
      return {
        real: e,
        imag: n
      }
    }

    function ho(t) {
      const e = Math.ceil(t.length / 4),
        n = new Float32Array(e),
        r = new Float32Array(e);
      for (let e = 0; e < t.length; e += 4) n[Math.floor(e / 4)] = t[e], r[Math.floor(e / 4)] = t[e + 1];
      return {
        real: n,
        imag: r
      }
    }

    function po(t) {
      const e = Math.floor(t.length / 4),
        n = new Float32Array(e),
        r = new Float32Array(e);
      for (let e = 2; e < t.length; e += 4) n[Math.floor(e / 4)] = t[e], r[Math.floor(e / 4)] = t[e + 1];
      return {
        real: n,
        imag: r
      }
    }

    function fo(t, e) {
      return {
        real: t[2 * e],
        imag: t[2 * e + 1]
      }
    }

    function mo(t, e, n, r) {
      t[2 * r] = e, t[2 * r + 1] = n
    }

    function go(t, e) {
      const n = new Float32Array(t / 2),
        r = new Float32Array(t / 2);
      for (let s = 0; s < Math.ceil(t / 2); s++) {
        const i = (e ? 2 : -2) * Math.PI * (s / t);
        n[s] = Math.cos(i), r[s] = Math.sin(i)
      }
      return {
        real: n,
        imag: r
      }
    }

    function bo(t, e, n) {
      const r = (n ? 2 : -2) * Math.PI * (t / e);
      return {
        real: Math.cos(r),
        imag: Math.sin(r)
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function yo(t, e, n) {
      if ("complex64" === e) {
        if ("complex64" === t.dtype) return t.clone();
        const e = Cn(t.shape),
          r = V(t, "float32"),
          s = n.complex(r, e);
        return e.dispose(), r.dispose(), s
      }
      if (!Object(S.hasEncodingLoss)(t.dtype, e)) return d.a.makeTensorFromDataId(t.dataId, t.shape, e);
      if ("complex64" === t.dtype) {
        const r = n.real(t),
          s = V(r, e);
        return r.dispose(), s
      }
      if ("int32" === e) return n.int(t);
      if ("bool" === e) {
        const e = Je(0, t.dtype),
          r = n.notEqual(t, e);
        return e.dispose(), r
      }
      throw new Error(`Error in Cast: failed to cast ${t.dtype} to ${e}`)
    }

    function wo(t, e) {
      return d.a.makeTensorFromDataId(t.dataId, e, t.dtype)
    }

    function vo(t, e, n) {
      const r = (e - t) / (n - 1),
        s = Object(S.makeZerosTypedArray)(n, "float32");
      s[0] = t;
      for (let t = 1; t < s.length; t++) s[t] = s[t - 1] + r;
      return ir(s, "float32")
    }
    var xo = n(49);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Oo(t, e, n) {
      const r = new Array(t.rank).fill(0),
        s = t.shape.slice();
      return e.map(e => {
        const i = [...s];
        i[n] = e;
        const a = Mt(t, r, i);
        return r[n] += e, a
      })
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function So(t, e) {
      const n = new Array(t.rank);
      for (let r = 0; r < n.length; r++) n[r] = t.shape[r] * e[r];
      const r = Kt(n, t.dtype);
      for (let e = 0; e < r.values.length; ++e) {
        const n = r.indexToLoc(e),
          s = new Array(t.rank);
        for (let e = 0; e < s.length; e++) s[e] = n[e] % t.shape[e];
        const i = t.locToIndex(s);
        r.values[e] = t.values[i]
      }
      return r.toTensor()
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function _o(t, e, n, r, s) {
      const i = e[e.length - 1],
        [a, o] = [t.length / i, i],
        u = Object(S.getTypedArrayFromDType)(n, a * r),
        c = Object(S.getTypedArrayFromDType)("int32", a * r);
      for (let e = 0; e < a; e++) {
        const n = e * o,
          s = t.subarray(n, n + o),
          i = [];
        for (let t = 0; t < s.length; t++) i.push({
          value: s[t],
          index: t
        });
        i.sort((t, e) => e.value - t.value);
        const a = e * r,
          l = u.subarray(a, a + r),
          h = c.subarray(a, a + r);
        for (let t = 0; t < r; t++) l[t] = i[t].value, h[t] = i[t].index
      }
      const l = e.slice();
      return l[l.length - 1] = r, [Object(yt.a)(u, l, n), Object(yt.a)(c, l, "int32")]
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ko = 1e-7,
      Co = 1e-4;
    class Eo {
      constructor(t, e) {
        this.backend = t, this.dataMover = e, this.data = new WeakMap, this.dataIdsCount = 0
      }
      get(t) {
        return this.data.has(t) || this.dataMover.moveData(this.backend, t), this.data.get(t)
      }
      set(t, e) {
        this.dataIdsCount++, this.data.set(t, e)
      }
      has(t) {
        return this.data.has(t)
      }
      delete(t) {
        return this.dataIdsCount--, this.data.delete(t)
      }
      numDataIds() {
        return this.dataIdsCount
      }
    }
    class Io {
      time(t) {
        return To("time")
      }
      read(t) {
        return To("read")
      }
      readSync(t) {
        return To("readSync")
      }
      numDataIds() {
        return To("numDataIds")
      }
      disposeData(t) {
        return To("disposeData")
      }
      write(t, e, n) {
        return To("write")
      }
      move(t, e, n, r) {
        return To("move")
      }
      memory() {
        return To("memory")
      }
      floatPrecision() {
        return To("floatPrecision")
      }
      epsilon() {
        return 32 === this.floatPrecision() ? ko : Co
      }
      batchMatMul(t, e, n, r) {
        return To("batchMatMul")
      }
      fusedBatchMatMul({
        a: t,
        b: e,
        transposeA: n,
        transposeB: r,
        bias: s,
        activation: i,
        preluActivationWeights: a
      }) {
        return To("fusedBatchMatMul")
      }
      slice(t, e, n) {
        return To("slice")
      }
      stridedSlice(t, e, n, r) {
        return To("stridedSlice")
      }
      unstack(t, e) {
        return To("unstack")
      }
      reverse(t, e) {
        return To("reverse")
      }
      concat(t, e) {
        return To("concat")
      }
      neg(t) {
        return To("neg")
      }
      add(t, e) {
        return To("add")
      }
      addN(t) {
        return To("addN")
      }
      subtract(t, e) {
        return To("subtract")
      }
      multiply(t, e) {
        return To("multiply")
      }
      realDivide(t, e) {
        return To("realDivide")
      }
      floorDiv(t, e) {
        return To("floorDiv")
      }
      sum(t, e) {
        return To("sum")
      }
      prod(t, e) {
        return To("prod")
      }
      unsortedSegmentSum(t, e, n) {
        return To("unsortedSegmentSum")
      }
      argMin(t, e) {
        return To("argMin")
      }
      argMax(t, e) {
        return To("argMax")
      }
      equal(t, e) {
        return To("equal")
      }
      notEqual(t, e) {
        return To("notEqual")
      }
      less(t, e) {
        return To("less")
      }
      lessEqual(t, e) {
        return To("lessEqual")
      }
      greater(t, e) {
        return To("greater")
      }
      greaterEqual(t, e) {
        return To("greaterEqual")
      }
      logicalNot(t) {
        return To("logicalNot")
      }
      logicalAnd(t, e) {
        return To("logicalAnd")
      }
      logicalOr(t, e) {
        return To("logicalOr")
      }
      where(t) {
        return To("where")
      }
      select(t, e, n) {
        return To("select")
      }
      topk(t, e, n) {
        return To("topk")
      }
      min(t, e) {
        return To("min")
      }
      minimum(t, e) {
        return To("minimum")
      }
      mod(t, e) {
        return To("mod")
      }
      max(t, e) {
        return To("max")
      }
      maximum(t, e) {
        return To("maximum")
      }
      all(t, e) {
        return To("all")
      }
      any(t, e) {
        return To("any")
      }
      squaredDifference(t, e) {
        return To("squaredDifference")
      }
      ceil(t) {
        return To("ceil")
      }
      floor(t) {
        return To("floor")
      }
      round(t) {
        return To("round")
      }
      sign(t) {
        return To("sign")
      }
      isNaN(t) {
        return To("isNaN")
      }
      isInf(t) {
        return To("isInf")
      }
      isFinite(t) {
        return To("isFinite")
      }
      pow(t, e) {
        return To("pow")
      }
      exp(t) {
        return To("exp")
      }
      expm1(t) {
        return To("expm1")
      }
      softmax(t, e) {
        return To("softmax")
      }
      log(t) {
        return To("log")
      }
      log1p(t) {
        return To("log1p")
      }
      sqrt(t) {
        return To("sqrt")
      }
      rsqrt(t) {
        return To("rsqrt")
      }
      square(t) {
        return To("square")
      }
      reciprocal(t) {
        return To("reciprocal")
      }
      relu(t) {
        return To("relu")
      }
      relu6(t) {
        return To("relu6")
      }
      prelu(t, e) {
        return To("prelu")
      }
      elu(t) {
        return To("elu")
      }
      eluDer(t, e) {
        return To("eluDer")
      }
      selu(t) {
        return To("selu")
      }
      int(t) {
        return To("int")
      }
      clip(t, e, n) {
        return To("clip")
      }
      abs(t) {
        return To("abs")
      }
      complexAbs(t) {
        return To("complexAbs")
      }
      sigmoid(t) {
        return To("sigmoid")
      }
      softplus(t) {
        return To("softplus")
      }
      sin(t) {
        return To("sin")
      }
      cos(t) {
        return To("cos")
      }
      tan(t) {
        return To("tan")
      }
      asin(t) {
        return To("asin")
      }
      acos(t) {
        return To("acos")
      }
      atan(t) {
        return To("atan")
      }
      atan2(t, e) {
        return To("atan2")
      }
      sinh(t) {
        return To("sinh")
      }
      cosh(t) {
        return To("cosh")
      }
      tanh(t) {
        return To("tanh")
      }
      asinh(t) {
        return To("asinh")
      }
      acosh(t) {
        return To("acosh")
      }
      atanh(t) {
        return To("atanh")
      }
      erf(t) {
        return To("erf")
      }
      step(t, e) {
        return To("step")
      }
      fusedConv2d({
        input: t,
        filter: e,
        convInfo: n,
        bias: r,
        activation: s,
        preluActivationWeights: i
      }) {
        return To("fusedConv2d")
      }
      conv2d(t, e, n) {
        return To("conv2d")
      }
      conv2dDerInput(t, e, n) {
        return To("conv2dDerInput")
      }
      conv2dDerFilter(t, e, n) {
        return To("conv2dDerFilter")
      }
      fusedDepthwiseConv2D({
        input: t,
        filter: e,
        convInfo: n,
        bias: r,
        activation: s,
        preluActivationWeights: i
      }) {
        return To("fusedDepthwiseConv2D")
      }
      depthwiseConv2D(t, e, n) {
        return To("depthwiseConv2D")
      }
      depthwiseConv2DDerInput(t, e, n) {
        return To("depthwiseConv2DDerInput")
      }
      depthwiseConv2DDerFilter(t, e, n) {
        return To("depthwiseConv2DDerFilter")
      }
      conv3d(t, e, n) {
        return To("conv3d")
      }
      conv3dDerInput(t, e, n) {
        return To("conv3dDerInput")
      }
      conv3dDerFilter(t, e, n) {
        return To("conv3dDerFilter")
      }
      maxPool(t, e) {
        return To("maxPool")
      }
      maxPoolBackprop(t, e, n, r) {
        return To("maxPoolBackprop")
      }
      avgPool(t, e) {
        return To("avgPool")
      }
      avgPoolBackprop(t, e, n) {
        return To("avgPoolBackprop")
      }
      avgPool3d(t, e) {
        return To("avgPool3d")
      }
      avgPool3dBackprop(t, e, n) {
        return To("avgPool3dBackprop")
      }
      maxPool3d(t, e) {
        return To("maxPool3d")
      }
      maxPool3dBackprop(t, e, n, r) {
        return To("maxPool3dBackprop")
      }
      reshape(t, e) {
        return To("reshape")
      }
      cast(t, e) {
        return To("cast")
      }
      tile(t, e) {
        return To("tile")
      }
      pad(t, e, n) {
        return To("pad")
      }
      transpose(t, e) {
        return To("transpose")
      }
      gather(t, e, n) {
        return To("gather")
      }
      gatherND(t, e) {
        return To("gatherND")
      }
      scatterND(t, e, n) {
        return To("scatterND")
      }
      batchToSpaceND(t, e, n) {
        return To("batchToSpaceND")
      }
      spaceToBatchND(t, e, n) {
        return To("spaceToBatchND")
      }
      resizeBilinear(t, e, n, r) {
        return To("resizeBilinear")
      }
      resizeBilinearBackprop(t, e, n) {
        return To("resizeBilinearBackprop")
      }
      resizeNearestNeighbor(t, e, n, r) {
        return To("resizeNearestNeighbor")
      }
      resizeNearestNeighborBackprop(t, e, n) {
        return To("resizeNearestNeighborBackprop")
      }
      batchNorm(t, e, n, r, s, i) {
        return To("batchNorm")
      }
      localResponseNormalization4D(t, e, n, r, s) {
        return To("localResponseNormalization4D")
      }
      LRNGrad(t, e, n, r, s, i, a) {
        return To("LRNGrad")
      }
      multinomial(t, e, n, r) {
        return To("multinomial")
      }
      oneHot(t, e, n, r) {
        return To("oneHot")
      }
      cumsum(t, e, n, r) {
        return To("cumsum")
      }
      nonMaxSuppression(t, e, n, r, s) {
        return To("nonMaxSuppression")
      }
      fft(t) {
        return To("fft")
      }
      ifft(t) {
        return To("ifft")
      }
      complex(t, e) {
        return To("complex")
      }
      real(t) {
        return To("real")
      }
      imag(t) {
        return To("imag")
      }
      cropAndResize(t, e, n, r, s, i) {
        return To("cropAndResize")
      }
      depthToSpace(t, e, n) {
        return To("depthToSpace")
      }
      split(t, e, n) {
        return To("split")
      }
      sparseToDense(t, e, n, r) {
        return To("sparseToDense")
      }
      diag(t) {
        return To("diag")
      }
      fill(t, e, n) {
        return To("fill")
      }
      onesLike(t) {
        return To("onesLike")
      }
      zerosLike(t) {
        return To("zerosLike")
      }
      linspace(t, e, n) {
        return To("linspace")
      }
      dispose() {
        return To("dispose")
      }
    }

    function To(t) {
      throw new Error(`'${t}' not yet implemented or not found in the registry. ` + "Did you forget to import the kernel?")
    }
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Ao = {
        kernelName: m.a,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, jr(V(n, "float32"), -1))
          }
        }
      },
      No = {
        kernelName: m.b,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => {
              const e = $n(V(n, "float32")),
                r = Ar(mn(Je(1), e));
              return hn(be(t, r))
            }
          }
        }
      },
      $o = {
        kernelName: m.c,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => {
              const e = Ar(mn($n(V(n, "float32")), 1));
              return be(t, e)
            }
          }
        }
      },
      Ro = {
        kernelName: m.d,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = ve(n.shape, r.shape);
          return {
            a: () => {
              let e = t;
              const r = we(n.shape, s);
              return r.length > 0 && (e = gn(e, r)), R(e, n.shape)
            },
            b: () => {
              let e = t;
              const n = we(r.shape, s);
              return n.length > 0 && (e = gn(e, n)), R(e, r.shape)
            }
          }
        }
      },
      jo = {
        kernelName: m.e,
        saveAllInputs: !0,
        gradFunc: (t, e) => {
          const n = {};
          return e.forEach((e, r) => {
            n[r] = () => t.clone()
          }), n
        }
      },
      Do = {
        kernelName: m.h,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => Se(n)
          }
        }
      },
      Fo = {
        kernelName: m.i,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => Se(n)
          }
        }
      },
      Mo = {
        kernelName: m.j,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, Ar(mn(Je(1), $n(V(n, "float32")))))
          }
        }
      },
      zo = {
        kernelName: m.k,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => {
              const e = Ar(O(Je(1), $n(V(n, "float32"))));
              return be(t, e)
            }
          }
        }
      },
      Lo = {
        kernelName: m.m,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = ve(n.shape, r.shape);
          return {
            a: () => {
              const e = O($n(n), $n(r));
              let i = xt(t, be(r, e));
              const a = we(n.shape, s);
              return a.length > 0 && (i = gn(i, a)), R(i, n.shape)
            },
            b: () => {
              const e = O($n(n), $n(r));
              let i = hn(xt(t, be(n, e)));
              const a = we(r.shape, s);
              return a.length > 0 && (i = gn(i, a)), R(i, r.shape)
            }
          }
        }
      },
      Bo = {
        kernelName: m.l,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, O($n(V(n, "float32")), 1))
          }
        }
      },
      Po = {
        kernelName: m.n,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, mn(Je(1), $n(V(n, "float32"))))
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Wo = Object(b.a)({
        avgPool3dBackprop_:
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e, n, r, s = [1, 1, 1], i, a) {
            const o = Object(g.a)(t, "dy", "avgPool3dBackprop"),
              u = Object(g.a)(e, "input", "avgPool3dBackprop");
            let c = o,
              l = u,
              h = !1;
            4 === u.rank && (h = !0, c = R(o, [1, o.shape[0], o.shape[1], o.shape[2], o.shape[3]]), l = R(u, [1, u.shape[0], u.shape[1], u.shape[2], u.shape[3]])), S.assert(5 === c.rank, () => "Error in avgPool3dBackprop: dy must be rank 5 but got rank " + `${c.rank}.`), S.assert(5 === l.rank, () => "Error in avgPool3dBackprop: input must be rank 5 but got rank " + `${l.rank}.`), S.assert(nt(r, s), () => "Error in avgPool3dBackprop: Either strides or dilations " + `must be 1. Got strides ${r} and dilations '${s}'`), null != a && S.assert(S.isInt(i), () => "Error in maxPool3dBackprop: pad must be an integer when " + `using, dimRoundingMode ${a} but got pad ${i}.`);
            const p = {
                dy: c,
                input: l
              },
              f = {
                filterSize: n,
                strides: r,
                dilations: s,
                pad: i,
                dimRoundingMode: a
              },
              b = d.a.runKernelFunc(t => {
                const e = q(l.shape, n, r, s, i, a);
                return t.avgPool3dBackprop(c, l, e)
              }, p, null, m.q, f);
            return h ? R(b, [b.shape[1], b.shape[2], b.shape[3], b.shape[4]]) : b
          }
      }),
      Uo = {
        kernelName: m.p,
        inputsToSave: ["x"],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            filterSize: s,
            strides: i,
            dilations: a,
            pad: o,
            dimRoundingMode: u
          } = n, c = null == a ? [1, 1, 1] : a;
          return {
            x: () => Wo(t, r, s, i, c, o, u)
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Vo = Object(b.a)({
        avgPoolBackprop_:
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e, n, r, s) {
            const i = Object(g.a)(t, "dy", "avgPoolBackprop"),
              a = Object(g.a)(e, "input", "avgPoolBackprop");
            S.assert(a.rank === i.rank, () => `Rank of input (${a.rank}) does not match rank of dy (${i.rank})`);
            let o = a,
              u = i,
              c = !1;
            3 === a.rank && (c = !0, o = R(a, [1, a.shape[0], a.shape[1], a.shape[2]]), u = R(i, [1, i.shape[0], i.shape[1], i.shape[2]])), S.assert(4 === u.rank, () => "Error in avgPoolBackprop: dy must be rank 4 but got rank " + `${u.rank}.`), S.assert(4 === o.rank, () => "Error in avgPoolBackprop: input must be rank 4 but got rank " + `${o.rank}.`);
            const l = {
                dy: u,
                input: o
              },
              h = {
                filterSize: n,
                strides: r,
                pad: s
              },
              p = d.a.runKernelFunc(t => {
                const e = G(o.shape, n, r, 1, s);
                return t.avgPoolBackprop(u, o, e)
              }, l, null, m.r, h);
            return c ? R(p, [p.shape[1], p.shape[2], p.shape[3]]) : p
          }
      }),
      Ho = {
        kernelName: m.o,
        inputsToSave: ["x"],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            filterSize: s,
            strides: i,
            pad: a
          } = n;
          return {
            x: () => Vo(t, r, s, i, a)
          }
        }
      },
      Go = {
        kernelName: m.s,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            transposeA: i,
            transposeB: a
          } = n;
          return i || a ? !i && a ? {
            a: () => vt(t, s, !1, !1),
            b: () => vt(t, r, !0, !1)
          } : i && !a ? {
            a: () => vt(s, t, !1, !0),
            b: () => vt(r, t, !1, !1)
          } : {
            a: () => vt(s, t, !0, !0),
            b: () => vt(t, r, !0, !0)
          } : {
            a: () => vt(t, s, !1, !0),
            b: () => vt(r, t, !0, !1)
          }
        }
      },
      qo = {
        kernelName: m.t,
        gradFunc: (t, e, n) => {
          const {
            blockShape: r,
            crops: s
          } = n;
          return {
            x: () => Hn(t, r, s)
          }
        }
      },
      Ko = {
        kernelName: m.u,
        gradFunc: (t, e, n) => {
          const r = n,
            s = r.inputShape,
            i = r.shape,
            a = Array.from(i);
          for (let t = s.length - 1; t >= 0; t--)
            if (s[t] === i[t]) a[t] = 1;
            else if (1 !== s[t]) throw new Error(`broadcastTo(): [${s}] cannot be broadcast to [${i}].`);
          const o = [];
          for (let t = 0; t < a.length; t++) a[t] > 1 && o.push(t);
          return {
            x: () => gn(t, o, !0)
          }
        }
      },
      Jo = {
        kernelName: m.v,
        gradFunc: t => ({
          x: () => t.clone()
        })
      },
      Xo = {
        kernelName: m.w,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      Yo = {
        kernelName: m.x,
        inputsToSave: ["x"],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            clipValueMin: s,
            clipValueMax: i
          } = n;
          return {
            x: () => Oe(wn(Ue(r, s), rn(r, i)), t, Se(t))
          }
        }
      },
      Zo = {
        kernelName: m.z,
        saveAllInputs: !0,
        gradFunc: (t, e, n) => {
          const r = e.map(t => t.shape),
            {
              axis: s
            } = n,
            i = Object(S.parseAxisParam)(s, e[0].shape)[0],
            a = r.map(t => t[i]);
          return mr(t, a, i).map(t => () => t)
        }
      },
      Qo = {
        kernelName: m.A,
        inputsToSave: ["x", "filter"],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            dilations: i,
            strides: a,
            pad: o,
            dataFormat: u
          } = n;
          return S.assert(et(i), () => "Error in gradient of conv2D: dilation rates greater than 1 " + `are not yet supported in gradients. Got dilations '${i}'`), {
            x: () => se(r.shape, t, s, a, o, u),
            filter: () => Ss(r, t, s.shape, a, o, u)
          }
        }
      },
      tu = {
        kernelName: m.C,
        inputsToSave: ["dy", "filter"],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            strides: i,
            pad: a,
            dataFormat: o,
            dimRoundingMode: u
          } = n;
          return {
            dy: () => ne(t, s, i, a, o, 1, u),
            filter: () => Ss(t, r, s.shape, i, a, o, u)
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const eu = Object(b.a)({
        conv3DBackpropFilter_:
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e, n, r, s) {
            let i = t;
            4 === t.rank && (i = R(t, [1, t.shape[0], t.shape[1], t.shape[2], t.shape[3]]));
            let a = e;
            4 === a.rank && (a = R(e, [1, e.shape[0], e.shape[1], e.shape[2], e.shape[3]])), S.assert(5 === i.rank, () => "Error in conv3dDerFilter: input must be rank 5, but got shape " + `${i.shape}.`), S.assert(5 === a.rank, () => "Error in conv3dDerFilter: dy must be rank 5, but got shape " + `${a.shape}.`), S.assert(5 === n.length, () => "Error in conv3dDerFilter: filterShape must be length 5, but got " + `${n}.`), S.assert(i.shape[4] === n[3], () => `Error in conv3dDerFilter: depth of input ${i.shape[4]}) must ` + `match input depth in filter (${n[3]}.`), S.assert(a.shape[4] === n[4], () => `Error in conv3dDerFilter: depth of dy (${a.shape[4]}) must ` + `match output depth for filter (${n[4]}).`);
            const o = {
                x: i,
                y: a
              },
              u = {
                strides: r,
                pad: s
              };
            return d.a.runKernelFunc(t => {
              const e = J(i.shape, n, r, 1, s);
              return t.conv3dDerFilter(i, a, e)
            }, o, null, m.E, u)
          }
      }),
      nu = {
        kernelName: m.D,
        inputsToSave: ["x", "filter"],
        gradFunc: (t, e, n) => {
          const {
            dilations: r,
            strides: s,
            pad: i
          } = n;
          S.assert(et(r), () => "Error in gradient of conv3D: dilation rates greater than 1 are " + `not yet supported in gradients. Got dilations '${r}'`);
          const [a, o] = e;
          return {
            x: () => oe(a.shape, t, o, s, i),
            filter: () => eu(a, t, o.shape, s, i)
          }
        }
      },
      ru = {
        kernelName: m.G,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(hn(Sr(V(n, "float32"))), t)
          }
        }
      },
      su = {
        kernelName: m.H,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(_r(V(n, "float32")), t)
          }
        }
      },
      iu = {
        kernelName: m.J,
        inputsToSave: ["x"],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            axis: s,
            exclusive: i,
            reverse: a
          } = n;
          return {
            x: () => {
              const e = A([s], r.rank);
              let n = he(t, s, i, !a);
              return null != e && (n = j(n, e)), n
            }
          }
        }
      },
      au = {
        kernelName: m.L,
        inputsToSave: ["x", "filter"],
        gradFunc: (t, e, n) => {
          const {
            dilations: r,
            strides: s,
            pad: i,
            dimRoundingMode: a
          } = n, o = null == r ? [1, 1] : r;
          S.assert(et(o), () => "Error in gradient of depthwiseConv2dNative: dilation rates greater than 1 are not yet supported. Got dilations " + `'${o}'`);
          const [u, c] = e;
          S.assert(4 === u.rank, () => "Error in gradient of depthwiseConv2dNative: input must be " + `rank 4, but got rank ${u.rank}.`), S.assert(4 === c.rank, () => "Error in gradient of depthwiseConv2dNative: filter must be " + `rank 4, but got rank ${c.rank}.`), S.assert(u.shape[3] === c.shape[2], () => "Error in gradient of depthwiseConv2d: number of input " + `channels (${u.shape[3]}) must match the inChannels dimension ` + `in filter ${c.shape[2]}.`), S.assert(nt(s, o), () => "Error in gradient of depthwiseConv2d: Either strides or " + `dilations must be  1. Got strides ${s} and dilations ` + `'${o}'.`), null != a && S.assert(S.isInt(i), () => "Error in depthwiseConv2d: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${i}.`);
          const l = K(u.shape, c.shape, s, o, i, a, !0);
          return {
            x: () => As(u.shape, t, c, l),
            filter: () => Ts(u, t, c.shape, l)
          }
        }
      },
      ou = {
        kernelName: m.P,
        inputsToSave: ["x", "filter"],
        gradFunc: (t, e, n) => {
          const [r, s] = e, i = {
            x: r,
            filter: s,
            dy: t
          }, a = {
            x: r,
            filter: s,
            dy: t
          };
          return {
            x: () => d.a.runKernel(m.R, i, n),
            filter: () => d.a.runKernel(m.Q, a, n)
          }
        }
      },
      uu = {
        kernelName: m.S,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = ve(n.shape, r.shape);
          return {
            a: () => {
              const e = be(t, V(r, "float32")),
                i = we(n.shape, s);
              return i.length > 0 ? R(gn(e, i), n.shape) : e
            },
            b: () => {
              let e = xt(t, V(n, "float32"));
              const i = we(r.shape, s);
              i.length > 0 && (e = R(gn(e, i), r.shape));
              const a = $n(r);
              return hn(be(e, V(a, "float32")))
            }
          }
        }
      },
      cu = {
        kernelName: m.T,
        outputsToSave: [!0],
        gradFunc: (t, e) => {
          const [n] = e, r = e => e.eluDer(t, n), s = {
            dy: t,
            y: n
          };
          return {
            x: () => d.a.runKernelFunc(r, s, null, m.U)
          }
        }
      },
      lu = {
        kernelName: m.W,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e, r = xt(Ie(hn($n(n))), 2 / Math.sqrt(Math.PI));
          return {
            x: () => xt(t, r)
          }
        }
      },
      hu = {
        kernelName: m.X,
        outputsToSave: [!0],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, n)
          }
        }
      },
      du = {
        kernelName: m.Y,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, Ie(n))
          }
        }
      },
      pu = {
        kernelName: m.cb,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      fu = {
        kernelName: m.db,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = ve(n.shape, r.shape);
          return {
            a: () => {
              const e = be(t, V(r, "float32")),
                i = we(n.shape, s);
              return i.length > 0 ? R(gn(e, i), n.shape) : e
            },
            b: () => {
              let e = xt(t, V(n, "float32"));
              const i = we(r.shape, s);
              i.length > 0 && (e = R(gn(e, i), r.shape));
              const a = $n(r);
              return hn(be(e, V(a, "float32")))
            }
          }
        }
      },
      mu = {
        kernelName: m.fb,
        inputsToSave: ["x", "mean", "variance", "scale"],
        gradFunc: (t, e, n) => {
          const {
            varianceEpsilon: r
          } = n, [s, i, a, o] = e, u = null == o ? Je(1) : o, c = we(i.shape, s.shape), l = [];
          if (1 === i.rank) {
            for (let t = 0; t < s.shape.length - 1; ++t) l.push(s.shape[t]);
            l.push(1)
          }
          const h = mn(s, i),
            d = xt(t, u),
            p = yr(O(a, Je(r))),
            f = xt(xt(xt(p, p), p), Je(-.5));
          return {
            x: () => 1 === i.rank ? R(xt(xt(t, Ne(R(p, [1, 1, 1, i.shape[0]]), l)), u), s.shape) : R(xt(xt(t, p), u), s.shape),
            mean: () => {
              let t = xt(xt(p, Je(-1)), d);
              return 1 === i.rank && (t = gn(t, c)), R(t, i.shape)
            },
            variance: () => {
              let t = xt(xt(f, h), d);
              return 1 === i.rank && (t = gn(t, c)), R(t, i.shape)
            },
            scale: () => {
              const e = xt(h, p);
              let n = xt(t, e);
              return 1 === i.rank && (n = gn(n, c)), R(n, i.shape)
            },
            offset: () => {
              let e = t;
              return 1 === i.rank && (e = gn(e, c)), R(e, i.shape)
            }
          }
        }
      },
      gu = {
        kernelName: m.jb,
        inputsToSave: ["x", "indices"],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            axis: i
          } = n, a = Object(S.parseAxisParam)(i, r.shape)[0];
          return {
            x: () => {
              const e = r.shape,
                n = s.size,
                o = e.slice(0, a),
                u = o.length,
                c = e.slice(i, e.length).slice(1),
                l = c.length,
                h = bu(0, u),
                d = bu(u + 1, u + 1 + l),
                p = yu([o, [n], c]),
                f = R(t, p),
                m = R(s, [n]),
                g = yu([
                  [u], h, d
                ]),
                b = j(f, g);
              let y = Vr(b, m, r.shape[a]);
              const w = N(g);
              return y = j(y, w), y
            },
            indices: () => s
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function bu(t, e) {
      const n = [];
      for (let r = t; r < e; ++r) n.push(r);
      return n
    }

    function yu(t) {
      const e = [];
      for (let n = 0; n < t.length; ++n)
        for (let r = 0; r < t[n].length; ++r) e.push(t[n][r]);
      return e
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const wu = {
        kernelName: m.lb,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e;
          return {
            a: () => Se(n),
            b: () => Se(r)
          }
        }
      },
      vu = {
        kernelName: m.nb,
        gradFunc: t => ({
          x: () => V(t, "float32")
        })
      },
      xu = {
        kernelName: m.pb,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      Ou = {
        kernelName: m.qb,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      Su = {
        kernelName: m.rb,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      _u = {
        kernelName: m.yb,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, O(n, 1))
          }
        }
      },
      ku = {
        kernelName: m.xb,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, V(n, "float32"))
          }
        }
      },
      Cu = {
        kernelName: m.zb,
        inputsToSave: [],
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            axis: s
          } = n;
          return {
            logits: () => {
              const e = Ie(r);
              return mn(t, xt(gn(t, s, !0), e))
            }
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Eu = Object(b.a)({
        localResponseNormalizationBackprop_:
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e, n, r = 5, s = 1, i = 1, a = .5) {
            const o = {
                x: t,
                y: e,
                dy: n
              },
              u = {
                depthRadius: r,
                bias: s,
                alpha: i,
                beta: a
              };
            return d.a.runKernelFunc(o => o.LRNGrad(n, t, e, r, s, i, a), o, null, m.tb, u)
          }
      }),
      Iu = {
        kernelName: m.sb,
        inputsToSave: ["x"],
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            depthRadius: i,
            bias: a,
            alpha: o,
            beta: u
          } = n;
          return {
            x: () => Eu(r, s, t, i, a, o, u)
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Tu(t, e, n, r, s) {
      return e.rank < n.rank && (e = R(e, I(e.shape, r))), t.rank < n.rank && (t = R(t, I(t.shape, r))), {
        x: () => {
          const r = xt(t, V(xe(n, e), t.dtype));
          return null == s ? r : j(r, s)
        }
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Au = {
        kernelName: m.Db,
        inputsToSave: ["x"],
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const r = n,
            {
              reductionIndices: s
            } = r,
            [i, a] = e,
            o = S.parseAxisParam(s, i.shape),
            u = A(o, i.rank),
            c = Tu(t, a, i, o, u);
          return {
            x: () => {
              let t = c.x();
              return null != u && (t = j(t)), t
            }
          }
        }
      },
      Nu = {
        kernelName: m.Jb,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e;
          return {
            a: () => xt(t, V(Ue(n, r), "float32")),
            b: () => xt(t, V(nn(n, r), "float32"))
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const $u = Object(b.a)({
        maxPool3dBackprop_:
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e, n, r, s, i = [1, 1, 1], a, o) {
            const u = Object(g.a)(t, "dy", "maxPool3dBackprop"),
              c = Object(g.a)(e, "input", "maxPool3dBackprop"),
              l = Object(g.a)(n, "output", "maxPool3dBackprop");
            let h = u,
              p = c,
              f = l,
              b = !1;
            4 === c.rank && (b = !0, h = R(u, [1, u.shape[0], u.shape[1], u.shape[2], u.shape[3]]), p = R(c, [1, c.shape[0], c.shape[1], c.shape[2], c.shape[3]]), f = R(l, [1, l.shape[0], l.shape[1], l.shape[2], l.shape[3]])), S.assert(5 === h.rank, () => "Error in maxPool3dBackprop: dy must be rank 5 but got rank " + `${h.rank}.`), S.assert(5 === p.rank, () => "Error in maxPool3dBackprop: input must be rank 5 but got rank " + `${p.rank}.`), S.assert(5 === f.rank, () => "Error in maxPool3dBackprop: output must be rank 5 but got rank " + `${f.rank}.`), S.assert(nt(s, i), () => "Error in maxPool3dBackprop: Either strides or dilations " + `must be 1. Got strides ${s} and dilations '${i}'`), null != o && S.assert(S.isInt(a), () => "Error in maxPool3dBackprop: pad must be an integer when " + `using, dimRoundingMode ${o} but got pad ${a}.`);
            const y = {
                dy: h,
                input: p,
                output: f
              },
              w = {
                filterSize: r,
                strides: s,
                dilations: i,
                pad: a,
                dimRoundingMode: o
              },
              v = d.a.runKernelFunc(t => {
                const e = q(p.shape, r, s, i, a, o);
                return t.maxPool3dBackprop(h, p, f, e)
              }, y, null, m.Gb, w);
            return b ? R(v, [v.shape[1], v.shape[2], v.shape[3], v.shape[4]]) : v
          }
      }),
      Ru = {
        kernelName: m.Fb,
        inputsToSave: ["x"],
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            filterSize: i,
            strides: a,
            dilations: o,
            pad: u,
            dimRoundingMode: c
          } = n, l = null == o ? [1, 1, 1] : o;
          return {
            x: () => $u(t, r, s, i, a, l, u, c)
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ju = Object(b.a)({
        maxPoolBackprop_:
          /**
           * @license
           * Copyright 2020 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          function (t, e, n, r, s, i, a) {
            const o = Object(g.a)(t, "dy", "maxPoolBackprop"),
              u = Object(g.a)(e, "input", "maxPoolBackprop"),
              c = Object(g.a)(n, "output", "maxPoolBackprop");
            S.assert(u.rank === o.rank, () => `Rank of input (${u.rank}) does not match rank of dy ` + `(${o.rank})`), S.assert(4 === o.rank, () => "Error in maxPoolBackprop: dy must be rank 4 but got rank " + `${o.rank}.`), S.assert(4 === u.rank, () => "Error in maxPoolBackprop: input must be rank 4 but got rank " + `${u.rank}.`), null != a && S.assert(S.isInt(i), () => "Error in maxPoolBackprop: pad must be an integer when using, " + `dimRoundingMode ${a} but got pad ${i}.`);
            const l = {
                dy: o,
                input: u,
                output: c
              },
              h = {
                filterSize: r,
                strides: s,
                pad: i,
                dimRoundingMode: a
              };
            return d.a.runKernelFunc(t => {
              const e = G(u.shape, r, s, 1, i, a);
              return t.maxPoolBackprop(o, u, c, e)
            }, l, null, m.Hb, h)
          }
      }),
      Du = {
        kernelName: m.Eb,
        inputsToSave: ["x"],
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const [r, s] = e, {
            filterSize: i,
            strides: a,
            pad: o
          } = n;
          return {
            x: () => ju(t, r, s, i, a, o)
          }
        }
      },
      Fu = {
        kernelName: m.Kb,
        inputsToSave: ["x"],
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const r = n,
            {
              axis: s
            } = r,
            [i, a] = e,
            o = S.parseAxisParam(s, i.shape),
            u = A(o, i.rank),
            c = Tu(t, a, i, o, u);
          return {
            x: () => {
              let t = c.x();
              return null != u && (t = j(t)), t
            }
          }
        }
      },
      Mu = {
        kernelName: m.Lb,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e;
          return {
            a: () => xt(t, V(rn(n, r), "float32")),
            b: () => xt(t, V(We(n, r), "float32"))
          }
        }
      },
      zu = {
        kernelName: m.Mb,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = ve(n.shape, r.shape);
          return {
            a: () => {
              const e = we(n.shape, s);
              return e.length > 0 ? R(gn(t, e), n.shape) : t
            },
            b: () => {
              const e = xt(t, hn(De(be(n, r)))),
                i = we(r.shape, s);
              return i.length > 0 ? R(gn(e, i), r.shape) : e
            }
          }
        }
      },
      Lu = {
        kernelName: m.Nb,
        inputsToSave: ["a", "b"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = ve(n.shape, r.shape);
          return {
            a: () => {
              const e = xt(t, V(r, "float32")),
                i = we(n.shape, s);
              return i.length > 0 ? R(gn(e, i), n.shape) : e
            },
            b: () => {
              const e = xt(t, V(n, "float32")),
                i = we(r.shape, s);
              return i.length > 0 ? R(gn(e, i), r.shape) : e
            }
          }
        }
      },
      Bu = {
        kernelName: m.Ob,
        gradFunc: t => ({
          x: () => hn(t)
        })
      },
      Pu = {
        kernelName: m.Tb,
        inputsToSave: ["indices"],
        gradFunc: (t, e) => {
          const n = e[0];
          return {
            indices: () => Cn(n.shape, "float32")
          }
        }
      },
      Wu = {
        kernelName: m.Ub,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      Uu = {
        kernelName: m.Vb,
        inputsToSave: ["x"],
        gradFunc: (t, e, n) => {
          const r = e[0],
            {
              paddings: s
            } = n,
            i = s.map(t => t[0]);
          return {
            x: () => Mt(t, i, r.shape)
          }
        }
      },
      Vu = {
        kernelName: m.Wb,
        inputsToSave: ["a", "b"],
        outputsToSave: [!0],
        gradFunc: (t, e) => {
          const [n, r, s] = e, i = n, a = r, o = ve(i.shape, a.shape);
          return {
            a: () => {
              const e = V(a, "float32");
              let n = xt(t, xt(e, qn(i, mn(e, Je(1)))));
              const r = we(i.shape, o);
              return r.length > 0 && (n = gn(n, r)), R(n, i.shape)
            },
            b: () => {
              const e = We(i, 0),
                n = Oe(e, on(i), Se(i));
              let r = xt(t, xt(s, n));
              const u = we(a.shape, o);
              return u.length > 0 && (r = gn(r, u)), R(r, a.shape)
            }
          }
        }
      },
      Hu = {
        kernelName: m.Xb,
        inputsToSave: ["x", "alpha"],
        gradFunc: (t, e) => {
          const [n, r] = e, s = We(n, 0);
          return {
            x: () => Oe(s, t, xt(t, r)),
            alpha: () => {
              let e = Oe(s, Se(t), xt(t, n));
              const i = we(r.shape, t.shape);
              return i.length > 0 && (e = gn(e, i)), R(e, r.shape)
            }
          }
        }
      },
      Gu = {
        kernelName: m.bc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, hn($n(n)))
          }
        }
      },
      qu = {
        kernelName: m.dc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e, r = xt(rn(n, 6), jr(n));
          return {
            x: () => xt(t, V(r, "float32"))
          }
        }
      },
      Ku = {
        kernelName: m.cc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, V(jr(n), "float32"))
          }
        }
      },
      Ju = {
        kernelName: m.ec,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => R(t, n.shape)
          }
        }
      },
      Xu = {
        kernelName: m.fc,
        inputsToSave: ["images"],
        gradFunc: (t, e, n) => {
          const [r] = e, s = e => {
            const {
              alignCorners: s
            } = n;
            return e.resizeBilinearBackprop(t, r, s)
          }, i = {
            images: r
          };
          return {
            images: () => d.a.runKernelFunc(s, i, null, m.gc, n)
          }
        }
      },
      Yu = {
        kernelName: m.hc,
        inputsToSave: ["images"],
        gradFunc: (t, e, n) => {
          const [r] = e, s = e => {
            const {
              alignCorners: s
            } = n;
            return e.resizeNearestNeighborBackprop(t, r, s)
          }, i = {
            images: r
          };
          return {
            images: () => d.a.runKernelFunc(s, i, null, m.ic, n)
          }
        }
      },
      Zu = {
        kernelName: m.jc,
        gradFunc: (t, e, n) => {
          const {
            dims: r
          } = n, s = Object(S.parseAxisParam)(r, t.shape);
          return {
            x: () => qe(t, s)
          }
        }
      },
      Qu = {
        kernelName: m.lc,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      tc = {
        kernelName: m.mc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => hn(be(t, xt(qn(n, 1.5), 2)))
          }
        }
      },
      ec = {
        kernelName: m.oc,
        inputsToSave: ["condition"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            condition: () => V(Se(n), "float32"),
            t: () => xt(t, V(n, t.dtype)),
            e: () => xt(t, V(vn(n), t.dtype))
          }
        }
      },
      nc = {
        kernelName: m.pc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => {
              const e = We(n, Je(0)),
                r = Je(Qa),
                s = Je(to),
                i = xt(t, s),
                a = xt(xt(t, r), Ie(V(n, "float32")));
              return Oe(e, i, a)
            }
          }
        }
      },
      rc = {
        kernelName: m.qc,
        outputsToSave: [!0],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, xt(n, mn(Je(1), n)))
          }
        }
      },
      sc = {
        kernelName: m.rc,
        gradFunc: t => ({
          x: () => Se(t)
        })
      },
      ic = {
        kernelName: m.sc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(ce(V(n, "float32")), t)
          }
        }
      },
      ac = {
        kernelName: m.tc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(le(V(n, "float32")), t)
          }
        }
      },
      oc = {
        kernelName: m.uc,
        inputsToSave: ["x"],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            begin: s,
            size: i
          } = n, a = r.shape, [o, u] = Ft(r, s, i), c = [];
          for (let e = 0; e < t.rank; e++) c.push([o[e], a[e] - o[e] - u[e]]);
          return {
            x: () => Bn(t, c)
          }
        }
      },
      uc = {
        kernelName: m.vc,
        outputsToSave: [!0],
        gradFunc: (t, e, n) => {
          const [r] = e, {
            dim: s
          } = n, i = xt(t, r);
          return {
            logits: () => mn(i, xt(gn(i, [s], !0), r))
          }
        }
      },
      cc = {
        kernelName: m.wc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, Ot(n))
          }
        }
      },
      lc = {
        kernelName: m.xc,
        gradFunc: (t, e, n) => {
          const {
            blockShape: r,
            paddings: s
          } = n;
          return {
            x: () => Bt(t, r, s)
          }
        }
      },
      hc = {
        kernelName: m.zc,
        gradFunc: (t, e, n) => {
          const {
            axis: r
          } = n;
          return {
            x: () => wt(t, r)
          }
        }
      },
      dc = {
        kernelName: m.Ac,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => be(t, xt(Ar(V(n, "float32")), 2))
          }
        }
      },
      pc = {
        kernelName: m.Bc,
        inputsToSave: ["x"],
        gradFunc: (t, e) => {
          const [n] = e;
          return {
            x: () => xt(t, xt(V(n, "float32"), 2))
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const fc = [Ao, No, $o, Ro, jo, Do, Fo, Mo, zo, Lo, Bo, Po, Uo, Ho, Go, qo, Ko, Jo, Xo, Yo, Zo, tu, Qo, nu, ru, su, iu, au, ou, uu, cu, lu, hu, du, fu, pu, mu, gu, wu, vu, xu, Ou, Su, _u, ku, Cu, Iu, Au, Au, Nu, Ru, Du, Fu, Mu, zu, Lu, Bu, Pu, Wu, Uu, Uu, Vu, Hu, Gu, qu, Ku, Ju, Xu, Yu, Zu, Qu, tc, ec, nc, rc, sc, ic, ac, oc, uc, cc, lc, lc, hc, hc, dc, {
      kernelName: m.Cc,
      inputsToSave: ["a", "b"],
      gradFunc: (t, e) => {
        const [n, r] = e, s = Je(2);
        return {
          a: () => xt(t, xt(s, mn(n, r))),
          b: () => xt(t, xt(s, mn(r, n)))
        }
      }
    }, pc, {
      kernelName: m.Dc,
      gradFunc: t => ({
        x: () => Se(t)
      })
    }, {
      kernelName: m.Fc,
      inputsToSave: ["a", "b"],
      gradFunc: (t, e) => {
        const [n, r] = e, s = ve(n.shape, r.shape);
        return {
          a: () => {
            let e = t;
            const r = we(n.shape, s);
            return r.length > 0 && (e = gn(e, r)), R(e, n.shape)
          },
          b: () => {
            let e = t;
            const n = we(r.shape, s);
            return n.length > 0 && (e = gn(e, n)), R(hn(e), r.shape)
          }
        }
      }
    }, {
      kernelName: m.Gc,
      inputsToSave: ["x"],
      gradFunc: (t, e, n) => {
        const [r] = e, s = r.shape.slice(), {
          axis: i
        } = n;
        Object(S.parseAxisParam)(i, r.shape).forEach(t => {
          s[t] = 1
        });
        const a = R(t, s),
          o = xt(a, En(r.shape, "float32"));
        return {
          x: () => o
        }
      }
    }, {
      kernelName: m.Hc,
      inputsToSave: ["x"],
      gradFunc: (t, e) => {
        const [n] = e;
        return {
          x: () => be(t, $n(ce(n)))
        }
      }
    }, {
      kernelName: m.Ic,
      outputsToSave: [!0],
      gradFunc: (t, e) => {
        const [n] = e;
        return {
          x: () => xt(mn(Je(1), $n(n)), t)
        }
      }
    }, {
      kernelName: m.Jc,
      inputsToSave: ["x"],
      gradFunc: (t, e, n) => {
        const [r] = e, {
          reps: s
        } = n;
        return {
          x: () => {
            let e = Se(r);
            if (1 === r.rank)
              for (let n = 0; n < s[0]; ++n) e = O(e, Mt(t, [n * r.shape[0]], [r.shape[0]]));
            else if (2 === r.rank)
              for (let n = 0; n < s[0]; ++n)
                for (let i = 0; i < s[1]; ++i) e = O(e, Mt(t, [n * r.shape[0], i * r.shape[1]], [r.shape[0], r.shape[1]]));
            else if (3 === r.rank)
              for (let n = 0; n < s[0]; ++n)
                for (let i = 0; i < s[1]; ++i)
                  for (let a = 0; a < s[2]; ++a) e = O(e, Mt(t, [n * r.shape[0], i * r.shape[1], a * r.shape[2]], [r.shape[0], r.shape[1], r.shape[2]]));
            else {
              if (4 !== r.rank) throw new Error("Gradient for tile operation is not implemented for rank-" + `${r.rank} tensors yet.`);
              for (let n = 0; n < s[0]; ++n)
                for (let i = 0; i < s[1]; ++i)
                  for (let a = 0; a < s[2]; ++a)
                    for (let o = 0; o < s[3]; ++o) e = O(e, Mt(t, [n * r.shape[0], i * r.shape[1], a * r.shape[2], o * r.shape[3]], [r.shape[0], r.shape[1], r.shape[2], r.shape[3]]))
            }
            return e
          }
        }
      }
    }, {
      kernelName: m.Lc,
      gradFunc: (t, e, n) => {
        const r = n,
          {
            perm: s
          } = r,
          i = N(s);
        return {
          x: () => j(t, i)
        }
      }
    }, {
      kernelName: m.Mc,
      gradFunc: (t, e, n) => {
        const r = n,
          {
            axis: s
          } = r;
        return {
          value: () => Rr(t, s)
        }
      }
    }, {
      kernelName: m.Nc,
      inputsToSave: ["segmentIds"],
      gradFunc: (t, e) => {
        const [n] = e;
        return {
          x: () => (function (t, e) {
            const n = tn(e, Se(e)),
              r = Pe(t, n);
            let s = Ue(e, Je(0, "int32"));
            const i = r.rank - s.rank;
            for (let t = 0; t < i; ++t) s = Te(s, t + 1);
            s = wn(s, En(r.shape, "bool"));
            const a = Se(r);
            return Oe(s, r, a)
          })(t, n)
        }
      }
    }, {
      kernelName: m.Oc,
      gradFunc: t => ({
        x: () => Se(t)
      })
    }];
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    for (const t of fc) Object(Ea.d)(t);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    it.a.prototype.abs = function () {
        return this.throwIfDisposed(), y(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.acos = function () {
        return this.throwIfDisposed(), w(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.acosh = function () {
        return this.throwIfDisposed(), v(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.addStrict = function (t) {
        return this.throwIfDisposed(), ns(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.add = function (t) {
        return this.throwIfDisposed(), O(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.all = function (t, e) {
        return this.throwIfDisposed(), D(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.any = function (t, e) {
        return this.throwIfDisposed(), F(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.argMax = function (t) {
        return this.throwIfDisposed(), M(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.argMin = function (t) {
        return this.throwIfDisposed(), z(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.asScalar = function () {
        return this.throwIfDisposed(), Object(S.assert)(1 === this.size, () => "The array must have only 1 element."), R(this, [])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.asType = function (t) {
        return this.throwIfDisposed(), V(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.as1D = function () {
        return this.throwIfDisposed(), R(this, [this.size])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.as2D = function (t, e) {
        return this.throwIfDisposed(), R(this, [t, e])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.as3D = function (t, e, n) {
        return this.throwIfDisposed(), R(this, [t, e, n])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.as4D = function (t, e, n, r) {
        return this.throwIfDisposed(), R(this, [t, e, n, r])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.as5D = function (t, e, n, r, s) {
        return this.throwIfDisposed(), R(this, [t, e, n, r, s])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.asin = function () {
        return this.throwIfDisposed(), L(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.asinh = function () {
        return this.throwIfDisposed(), B(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.atan = function () {
        return this.throwIfDisposed(), P(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.atan2 = function (t) {
        return this.throwIfDisposed(), W(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.atanh = function () {
        return this.throwIfDisposed(), U(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.avgPool = function (t, e, n, r) {
        return this.throwIfDisposed(), st(this, t, e, n, r)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.batchToSpaceND = function (t, e) {
        return this.throwIfDisposed(), Bt(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.batchNorm = function (t, e, n, r, s) {
        return this.throwIfDisposed(), Wt(this, t, e, n, r, s)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.broadcastTo = function (t) {
        return this.throwIfDisposed(), qt(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.cast = function (t) {
        return this.throwIfDisposed(), V(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.ceil = function () {
        return this.throwIfDisposed(), Jt(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.clipByValue = function (t, e) {
        return this.throwIfDisposed(), Xt(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.concat = function (t, e) {
        return this.throwIfDisposed(), t instanceof it.a && (t = [t]), wt([this, ...t], e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.conv1d = function (t, e, n, r, s, i) {
        return this.throwIfDisposed(), re(this, t, e, n, r, s, i)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.conv2dTranspose = function (t, e, n, r, s) {
        return this.throwIfDisposed(), ie(this, t, e, n, r, s)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.conv2d = function (t, e, n, r, s, i) {
        return this.throwIfDisposed(), ne(this, t, e, n, r, s, i)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.cos = function () {
        return this.throwIfDisposed(), ce(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.cosh = function () {
        return this.throwIfDisposed(), le(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.cumsum = function (t, e, n) {
        return this.throwIfDisposed(), he(this, t, e, n)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.depthToSpace = function (t, e) {
        return this.throwIfDisposed(), de(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.depthwiseConv2D = function (t, e, n, r, s, i) {
        return at("depthwiseConv2D is deprecated, use depthwiseConv2d instead"), this.throwIfDisposed(), pe(this, t, e, n, r, s, i)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.depthwiseConv2d = function (t, e, n, r, s, i) {
        return this.throwIfDisposed(), pe(this, t, e, n, r, s, i)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.dilation2d = function (t, e, n, r, s) {
        return this.throwIfDisposed(), me(this, t, e, n, r, s)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.divNoNan = function (t) {
        return this.throwIfDisposed(), _e(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.divStrict = function (t) {
        return this.throwIfDisposed(), rs(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.div = function (t) {
        return this.throwIfDisposed(), be(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.dot = function (t) {
        return this.throwIfDisposed(), ke(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.elu = function () {
        return this.throwIfDisposed(), Ce(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.equalStrict = function (t) {
        return this.throwIfDisposed(), Xr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.equal = function (t) {
        return this.throwIfDisposed(), xe(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.erf = function () {
        return this.throwIfDisposed(), Ee(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.exp = function () {
        return this.throwIfDisposed(), Ie(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.expandDims = function (t) {
        return this.throwIfDisposed(), Te(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.expm1 = function () {
        return this.throwIfDisposed(), Ae(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.fft = function () {
        return this.throwIfDisposed(), Re(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.flatten = function () {
        return this.throwIfDisposed(), R(this, [this.size])
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.floor = function () {
        return this.throwIfDisposed(), De(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.floorDiv = function (t) {
        return this.throwIfDisposed(), ge(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.gather = function (t, e) {
        return this.throwIfDisposed(), Pe(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.greaterEqualStrict = function (t) {
        return this.throwIfDisposed(), Yr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.greaterEqual = function (t) {
        return this.throwIfDisposed(), Ue(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.greaterStrict = function (t) {
        return this.throwIfDisposed(), Zr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.greater = function (t) {
        return this.throwIfDisposed(), We(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.ifft = function () {
        return this.throwIfDisposed(), Ve(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.irfft = function () {
        return this.throwIfDisposed(), Xe(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.isFinite = function () {
        return this.throwIfDisposed(), Ye(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.isInf = function () {
        return this.throwIfDisposed(), Ze(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.isNaN = function () {
        return this.throwIfDisposed(), Qe(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.leakyRelu = function (t) {
        return this.throwIfDisposed(), en(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.lessEqualStrict = function (t) {
        return this.throwIfDisposed(), Qr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.lessEqual = function (t) {
        return this.throwIfDisposed(), rn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.lessStrict = function (t) {
        return this.throwIfDisposed(), ts(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.less = function (t) {
        return this.throwIfDisposed(), nn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.localResponseNormalization = function (t, e, n, r) {
        return this.throwIfDisposed(), an(this, t, e, n, r)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logSigmoid = function () {
        return this.throwIfDisposed(), pn(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logSoftmax = function (t) {
        return this.throwIfDisposed(), bn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logSumExp = function (t, e) {
        return this.throwIfDisposed(), yn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.log = function () {
        return this.throwIfDisposed(), on(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.log1p = function () {
        return this.throwIfDisposed(), un(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logicalAnd = function (t) {
        return this.throwIfDisposed(), wn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logicalNot = function () {
        return this.throwIfDisposed(), vn(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logicalOr = function (t) {
        return this.throwIfDisposed(), xn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.logicalXor = function (t) {
        return this.throwIfDisposed(), On(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.matMul = function (t, e, n) {
        return this.throwIfDisposed(), vt(this, t, e, n)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.maxPool = function (t, e, n, r) {
        return this.throwIfDisposed(), Sn(this, t, e, n, r)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.max = function (t, e) {
        return this.throwIfDisposed(), fn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.maximumStrict = function (t) {
        return this.throwIfDisposed(), ss(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.maximum = function (t) {
        return this.throwIfDisposed(), tn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.mean = function (t, e) {
        return this.throwIfDisposed(), In(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.min = function (t, e) {
        return this.throwIfDisposed(), Tn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.minimumStrict = function (t) {
        return this.throwIfDisposed(), is(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.minimum = function (t) {
        return this.throwIfDisposed(), An(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.modStrict = function (t) {
        return this.throwIfDisposed(), as(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.mod = function (t) {
        return this.throwIfDisposed(), Nn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.mulStrict = function (t) {
        return this.throwIfDisposed(), os(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.mul = function (t) {
        return this.throwIfDisposed(), xt(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.neg = function () {
        return this.throwIfDisposed(), hn(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.norm = function (t, e, n) {
        return this.throwIfDisposed(), hs(this, t, e, n)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.notEqualStrict = function (t) {
        return this.throwIfDisposed(), es(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.notEqual = function (t) {
        return this.throwIfDisposed(), Fn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.oneHot = function (t, e = 1, n = 0) {
        return this.throwIfDisposed(), Mn(this, t, e, n)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.onesLike = function () {
        return this.throwIfDisposed(), zn(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.pad = function (t, e) {
        return this.throwIfDisposed(), Bn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.pool = function (t, e, n, r, s) {
        return this.throwIfDisposed(), Gn(this, t, e, n, r, s)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.powStrict = function (t) {
        return this.throwIfDisposed(), us(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.pow = function (t) {
        return this.throwIfDisposed(), qn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.prelu = function (t) {
        return this.throwIfDisposed(), Kn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.prod = function (t, e) {
        return this.throwIfDisposed(), Xn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.reciprocal = function () {
        return this.throwIfDisposed(), or(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.relu = function () {
        return this.throwIfDisposed(), ur(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.relu6 = function () {
        return this.throwIfDisposed(), cr(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.reshapeAs = function (t) {
        return this.throwIfDisposed(), R(this, t.shape)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.reshape = function (t) {
        return this.throwIfDisposed(), R(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.resizeBilinear = function (t, e) {
        return this.throwIfDisposed(), ni(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.resizeNearestNeighbor = function (t, e) {
        return this.throwIfDisposed(), ri(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.reverse = function (t) {
        return this.throwIfDisposed(), qe(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.rfft = function () {
        return this.throwIfDisposed(), gr(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.round = function () {
        return this.throwIfDisposed(), br(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.rsqrt = function () {
        return this.throwIfDisposed(), yr(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.selu = function () {
        return this.throwIfDisposed(), wr(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.separableConv2d = function (t, e, n, r, s, i) {
        return this.throwIfDisposed(), vr(this, t, e, n, r, s, i)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sigmoid = function () {
        return this.throwIfDisposed(), Ot(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sign = function () {
        return this.throwIfDisposed(), Or(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sin = function () {
        return this.throwIfDisposed(), Sr(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sinh = function () {
        return this.throwIfDisposed(), _r(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.slice = function (t, e) {
        return this.throwIfDisposed(), Mt(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.softmax = function (t) {
        return this.throwIfDisposed(), Tr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.softplus = function () {
        return this.throwIfDisposed(), dn(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.spaceToBatchND = function (t, e) {
        return this.throwIfDisposed(), Hn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.split = function (t, e) {
        return this.throwIfDisposed(), mr(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sqrt = function () {
        return this.throwIfDisposed(), Ar(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.square = function () {
        return this.throwIfDisposed(), $n(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.squaredDifference = function (t) {
        return this.throwIfDisposed(), Nr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.squaredDifferenceStrict = function (t) {
        return this.throwIfDisposed(), cs(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.squeeze = function (t) {
        return this.throwIfDisposed(), $r(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.stack = function (t, e) {
        this.throwIfDisposed();
        const n = t instanceof it.a ? [this, t] : [this, ...t];
        return Rr(n, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.step = function (t) {
        return this.throwIfDisposed(), jr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.stridedSlice = function (t, e, n, r, s, i, a, o) {
        return this.throwIfDisposed(), Dr(this, t, e, n, r, s, i, a, o)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.subStrict = function (t) {
        return this.throwIfDisposed(), ls(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sub = function (t) {
        return this.throwIfDisposed(), mn(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.sum = function (t, e) {
        return this.throwIfDisposed(), gn(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.tan = function () {
        return this.throwIfDisposed(), Fr(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.tanh = function () {
        return this.throwIfDisposed(), zt(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.tile = function (t) {
        return this.throwIfDisposed(), Ne(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.toBool = function () {
        return this.throwIfDisposed(), V(this, "bool")
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.toFloat = function () {
        return this.throwIfDisposed(), V(this, "float32")
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.toInt = function () {
        return this.throwIfDisposed(), V(this, "int32")
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.topk = function (t, e) {
        return this.throwIfDisposed(), Wr(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.transpose = function (t) {
        return this.throwIfDisposed(), j(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.unsortedSegmentSum = function (t, e) {
        return this.throwIfDisposed(), Vr(this, t, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.unstack = function (t) {
        return this.throwIfDisposed(), Hr(this, t)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.where = function (t, e) {
        return this.throwIfDisposed(), Oe(t, this, e)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      it.a.prototype.zerosLike = function () {
        return this.throwIfDisposed(), Se(this)
      },
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      n.d(e, "n", (function () {
        return ja
      })), n.d(e, "r", (function () {
        return it.a
      })), n.d(e, "s", (function () {
        return it.b
      })), n.d(e, "td", (function () {
        return Da.a
      })), n.d(e, "Id", (function () {
        return Da.b
      })), n.d(e, "Ld", (function () {
        return cn
      })), n.d(e, "vb", (function () {
        return p.b
      })), n.d(e, "Md", (function () {
        return "2.3.0"
      })), n.d(e, "tc", (function () {
        return Ha.a
      })), n.d(e, "S", (function () {
        return u
      })), n.d(e, "Ob", (function () {
        return o
      })), n.d(e, "Tc", (function () {
        return c
      })), n.d(e, "Jd", (function () {
        return S
      })), n.d(e, "L", (function () {
        return l
      })), n.d(e, "Ad", (function () {
        return x
      })), n.d(e, "fd", (function () {
        return r
      })), n.d(e, "nb", (function () {
        return xo
      })), n.d(e, "Rb", (function () {
        return h
      })), n.d(e, "h", (function () {
        return Io
      })), n.d(e, "a", (function () {
        return Eo
      })), n.d(e, "u", (function () {
        return y
      })), n.d(e, "v", (function () {
        return w
      })), n.d(e, "w", (function () {
        return v
      })), n.d(e, "x", (function () {
        return O
      })), n.d(e, "y", (function () {
        return _
      })), n.d(e, "z", (function () {
        return D
      })), n.d(e, "A", (function () {
        return F
      })), n.d(e, "B", (function () {
        return M
      })), n.d(e, "C", (function () {
        return z
      })), n.d(e, "D", (function () {
        return L
      })), n.d(e, "E", (function () {
        return B
      })), n.d(e, "F", (function () {
        return P
      })), n.d(e, "G", (function () {
        return W
      })), n.d(e, "H", (function () {
        return U
      })), n.d(e, "I", (function () {
        return st
      })), n.d(e, "J", (function () {
        return mt
      })), n.d(e, "Q", (function () {
        return Bt
      })), n.d(e, "M", (function () {
        return Wt
      })), n.d(e, "N", (function () {
        return Ut
      })), n.d(e, "O", (function () {
        return Vt
      })), n.d(e, "P", (function () {
        return Ht
      })), n.d(e, "R", (function () {
        return qt
      })), n.d(e, "T", (function () {
        return Kt
      })), n.d(e, "U", (function () {
        return V
      })), n.d(e, "V", (function () {
        return Jt
      })), n.d(e, "W", (function () {
        return Xt
      })), n.d(e, "X", (function () {
        return Gt
      })), n.d(e, "Y", (function () {
        return Yt.a
      })), n.d(e, "Z", (function () {
        return wt
      })), n.d(e, "ab", (function () {
        return Zt
      })), n.d(e, "bb", (function () {
        return Qt
      })), n.d(e, "cb", (function () {
        return te
      })), n.d(e, "db", (function () {
        return ee
      })), n.d(e, "eb", (function () {
        return re
      })), n.d(e, "fb", (function () {
        return ne
      })), n.d(e, "gb", (function () {
        return ie
      })), n.d(e, "hb", (function () {
        return ae
      })), n.d(e, "ib", (function () {
        return ce
      })), n.d(e, "jb", (function () {
        return le
      })), n.d(e, "kb", (function () {
        return he
      })), n.d(e, "lb", (function () {
        return de
      })), n.d(e, "mb", (function () {
        return pe
      })), n.d(e, "ob", (function () {
        return me
      })), n.d(e, "qb", (function () {
        return be
      })), n.d(e, "rb", (function () {
        return _e
      })), n.d(e, "tb", (function () {
        return Ce
      })), n.d(e, "wb", (function () {
        return xe
      })), n.d(e, "xb", (function () {
        return Ee
      })), n.d(e, "yb", (function () {
        return Ie
      })), n.d(e, "zb", (function () {
        return Te
      })), n.d(e, "Ab", (function () {
        return Ae
      })), n.d(e, "Bb", (function () {
        return $e
      })), n.d(e, "Cb", (function () {
        return Re
      })), n.d(e, "Db", (function () {
        return je
      })), n.d(e, "Eb", (function () {
        return De
      })), n.d(e, "Fb", (function () {
        return ge
      })), n.d(e, "Hb", (function () {
        return Pe
      })), n.d(e, "Jb", (function () {
        return We
      })), n.d(e, "Kb", (function () {
        return Ue
      })), n.d(e, "Lb", (function () {
        return Ve
      })), n.d(e, "Mb", (function () {
        return He
      })), n.d(e, "Pb", (function () {
        return Xe
      })), n.d(e, "Sb", (function () {
        return en
      })), n.d(e, "Tb", (function () {
        return nn
      })), n.d(e, "Ub", (function () {
        return rn
      })), n.d(e, "Wb", (function () {
        return sn
      })), n.d(e, "Xb", (function () {
        return an
      })), n.d(e, "Yb", (function () {
        return on
      })), n.d(e, "Zb", (function () {
        return un
      })), n.d(e, "ac", (function () {
        return bn
      })), n.d(e, "bc", (function () {
        return wn
      })), n.d(e, "cc", (function () {
        return vn
      })), n.d(e, "dc", (function () {
        return xn
      })), n.d(e, "ec", (function () {
        return vt
      })), n.d(e, "fc", (function () {
        return fn
      })), n.d(e, "gc", (function () {
        return Sn
      })), n.d(e, "hc", (function () {
        return _n
      })), n.d(e, "ic", (function () {
        return kn
      })), n.d(e, "jc", (function () {
        return tn
      })), n.d(e, "kc", (function () {
        return In
      })), n.d(e, "mc", (function () {
        return Tn
      })), n.d(e, "nc", (function () {
        return An
      })), n.d(e, "oc", (function () {
        return Nn
      })), n.d(e, "pc", (function () {
        return Rn
      })), n.d(e, "qc", (function () {
        return xt
      })), n.d(e, "rc", (function () {
        return Dn
      })), n.d(e, "sc", (function () {
        return hn
      })), n.d(e, "uc", (function () {
        return Fn
      })), n.d(e, "vc", (function () {
        return Mn
      })), n.d(e, "wc", (function () {
        return En
      })), n.d(e, "xc", (function () {
        return zn
      })), n.d(e, "yc", (function () {
        return Bn
      })), n.d(e, "zc", (function () {
        return qn
      })), n.d(e, "Ac", (function () {
        return Kn
      })), n.d(e, "Bc", (function () {
        return Xn
      })), n.d(e, "Cc", (function () {
        return rr
      })), n.d(e, "Dc", (function () {
        return sr
      })), n.d(e, "Ec", (function () {
        return ar
      })), n.d(e, "Fc", (function () {
        return Ge
      })), n.d(e, "Gc", (function () {
        return or
      })), n.d(e, "Jc", (function () {
        return ur
      })), n.d(e, "Kc", (function () {
        return R
      })), n.d(e, "Lc", (function () {
        return qe
      })), n.d(e, "Mc", (function () {
        return gr
      })), n.d(e, "Nc", (function () {
        return br
      })), n.d(e, "Oc", (function () {
        return yr
      })), n.d(e, "Pc", (function () {
        return Je
      })), n.d(e, "Rc", (function () {
        return wr
      })), n.d(e, "Sc", (function () {
        return vr
      })), n.d(e, "Vc", (function () {
        return xr
      })), n.d(e, "Wc", (function () {
        return Ot
      })), n.d(e, "Xc", (function () {
        return Or
      })), n.d(e, "Yc", (function () {
        return Sr
      })), n.d(e, "Zc", (function () {
        return _r
      })), n.d(e, "ad", (function () {
        return Mt
      })), n.d(e, "bd", (function () {
        return kr
      })), n.d(e, "cd", (function () {
        return Cr
      })), n.d(e, "dd", (function () {
        return Er
      })), n.d(e, "ed", (function () {
        return Ir
      })), n.d(e, "gd", (function () {
        return Tr
      })), n.d(e, "hd", (function () {
        return dn
      })), n.d(e, "id", (function () {
        return Hn
      })), n.d(e, "kd", (function () {
        return mr
      })), n.d(e, "ld", (function () {
        return Ar
      })), n.d(e, "md", (function () {
        return $n
      })), n.d(e, "nd", (function () {
        return Nr
      })), n.d(e, "od", (function () {
        return $r
      })), n.d(e, "pd", (function () {
        return Rr
      })), n.d(e, "qd", (function () {
        return Dr
      })), n.d(e, "rd", (function () {
        return mn
      })), n.d(e, "sd", (function () {
        return gn
      })), n.d(e, "ud", (function () {
        return Fr
      })), n.d(e, "vd", (function () {
        return zt
      })), n.d(e, "wd", (function () {
        return yt.a
      })), n.d(e, "xd", (function () {
        return ir
      })), n.d(e, "yd", (function () {
        return Mr
      })), n.d(e, "zd", (function () {
        return Lr
      })), n.d(e, "Cd", (function () {
        return Ne
      })), n.d(e, "Dd", (function () {
        return Wr
      })), n.d(e, "Gd", (function () {
        return Ur
      })), n.d(e, "Hd", (function () {
        return Hr
      })), n.d(e, "Kd", (function () {
        return Gr
      })), n.d(e, "Nd", (function () {
        return Oe
      })), n.d(e, "Od", (function () {
        return Kr
      })), n.d(e, "Pd", (function () {
        return Cn
      })), n.d(e, "Qd", (function () {
        return Se
      })), n.d(e, "Nb", (function () {
        return vi
      })), n.d(e, "Vb", (function () {
        return xi
      })), n.d(e, "Gb", (function () {
        return i
      })), n.d(e, "Ed", (function () {
        return Va
      })), n.d(e, "ub", (function () {
        return ot
      })), n.d(e, "lc", (function () {
        return ut
      })), n.d(e, "Bd", (function () {
        return ct
      })), n.d(e, "pb", (function () {
        return lt
      })), n.d(e, "Qb", (function () {
        return ht
      })), n.d(e, "Uc", (function () {
        return dt
      })), n.d(e, "Hc", (function () {
        return pt
      })), n.d(e, "K", (function () {
        return ft
      })), n.d(e, "Ic", (function () {
        return Ea.e
      })), n.d(e, "b", (function () {
        return m.P
      })), n.d(e, "d", (function () {
        return m.R
      })), n.d(e, "c", (function () {
        return m.Q
      })), n.d(e, "e", (function () {
        return m.S
      })), n.d(e, "f", (function () {
        return m.bb
      })), n.d(e, "i", (function () {
        return m.Db
      })), n.d(e, "j", (function () {
        return m.Ib
      })), n.d(e, "k", (function () {
        return m.Pb
      })), n.d(e, "l", (function () {
        return m.Qb
      })), n.d(e, "m", (function () {
        return m.Rb
      })), n.d(e, "q", (function () {
        return m.Cc
      })), n.d(e, "p", (function () {
        return m.Bc
      })), n.d(e, "t", (function () {
        return m.Lc
      })), n.d(e, "g", (function () {
        return m.eb
      })), n.d(e, "o", (function () {
        return m.kc
      })), n.d(e, "Fd", (function () {
        return j
      })), n.d(e, "Qc", (function () {
        return gs
      })), n.d(e, "jd", (function () {
        return bs
      })), n.d(e, "Ib", (function () {
        return ys
      })), n.d(e, "sb", (function () {
        return ws
      }))
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "shuffle", (function () {
      return s
    })), n.d(e, "clamp", (function () {
      return i
    })), n.d(e, "nearestLargerEven", (function () {
      return a
    })), n.d(e, "sum", (function () {
      return o
    })), n.d(e, "randUniform", (function () {
      return u
    })), n.d(e, "distSquared", (function () {
      return c
    })), n.d(e, "assert", (function () {
      return l
    })), n.d(e, "assertShapesMatch", (function () {
      return h
    })), n.d(e, "assertNonNull", (function () {
      return d
    })), n.d(e, "flatten", (function () {
      return p
    })), n.d(e, "sizeFromShape", (function () {
      return f
    })), n.d(e, "isScalarShape", (function () {
      return m
    })), n.d(e, "arraysEqual", (function () {
      return g
    })), n.d(e, "isInt", (function () {
      return b
    })), n.d(e, "tanh", (function () {
      return y
    })), n.d(e, "sizeToSquarishShape", (function () {
      return w
    })), n.d(e, "createShuffledIndices", (function () {
      return v
    })), n.d(e, "rightPad", (function () {
      return x
    })), n.d(e, "repeatedTry", (function () {
      return O
    })), n.d(e, "inferFromImplicitShape", (function () {
      return S
    })), n.d(e, "parseAxisParam", (function () {
      return _
    })), n.d(e, "squeezeShape", (function () {
      return k
    })), n.d(e, "getTypedArrayFromDType", (function () {
      return C
    })), n.d(e, "getArrayFromDType", (function () {
      return E
    })), n.d(e, "checkConversionForErrors", (function () {
      return I
    })), n.d(e, "isValidDtype", (function () {
      return T
    })), n.d(e, "hasEncodingLoss", (function () {
      return A
    })), n.d(e, "isTypedArray", (function () {
      return N
    })), n.d(e, "bytesPerElement", (function () {
      return $
    })), n.d(e, "bytesFromStringArray", (function () {
      return R
    })), n.d(e, "isString", (function () {
      return j
    })), n.d(e, "isBoolean", (function () {
      return D
    })), n.d(e, "isNumber", (function () {
      return F
    })), n.d(e, "inferDtype", (function () {
      return M
    })), n.d(e, "isFunction", (function () {
      return z
    })), n.d(e, "nearestDivisor", (function () {
      return L
    })), n.d(e, "computeStrides", (function () {
      return B
    })), n.d(e, "toTypedArray", (function () {
      return P
    })), n.d(e, "toNestedArray", (function () {
      return W
    })), n.d(e, "makeOnesTypedArray", (function () {
      return U
    })), n.d(e, "makeZerosTypedArray", (function () {
      return V
    })), n.d(e, "makeZerosNestedTypedArray", (function () {
      return H
    })), n.d(e, "now", (function () {
      return G
    })), n.d(e, "assertNonNegativeIntegerDimensions", (function () {
      return q
    })), n.d(e, "fetch", (function () {
      return K
    })), n.d(e, "encodeString", (function () {
      return J
    })), n.d(e, "decodeString", (function () {
      return X
    })), n.d(e, "locToIndex", (function () {
      return Y
    })), n.d(e, "indexToLoc", (function () {
      return Z
    }));
    var r = n(9);
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function s(t) {
      let e = t.length,
        n = 0,
        r = 0;
      for (; e > 0;) r = Math.random() * e | 0, e--, n = t[e], t[e] = t[r], t[r] = n
    }

    function i(t, e, n) {
      return Math.max(t, Math.min(e, n))
    }

    function a(t) {
      return t % 2 == 0 ? t : t + 1
    }

    function o(t) {
      let e = 0;
      for (let n = 0; n < t.length; n++) e += t[n];
      return e
    }

    function u(t, e) {
      const n = Math.random();
      return e * n + (1 - n) * t
    }

    function c(t, e) {
      let n = 0;
      for (let r = 0; r < t.length; r++) {
        const s = Number(t[r]) - Number(e[r]);
        n += s * s
      }
      return n
    }

    function l(t, e) {
      if (!t) throw new Error("string" == typeof e ? e : e())
    }

    function h(t, e, n = "") {
      l(g(t, e), () => n + ` Shapes ${t} and ${e} must match`)
    }

    function d(t) {
      l(null != t, () => "The input to the tensor constructor must be a non-null value.")
    }

    function p(t, e = [], n = !1) {
      if (null == e && (e = []), Array.isArray(t) || N(t) && !n)
        for (let r = 0; r < t.length; ++r) p(t[r], e, n);
      else e.push(t);
      return e
    }

    function f(t) {
      if (0 === t.length) return 1;
      let e = t[0];
      for (let n = 1; n < t.length; n++) e *= t[n];
      return e
    }

    function m(t) {
      return 0 === t.length
    }

    function g(t, e) {
      if (t === e) return !0;
      if (null == t || null == e) return !1;
      if (t.length !== e.length) return !1;
      for (let n = 0; n < t.length; n++)
        if (t[n] !== e[n]) return !1;
      return !0
    }

    function b(t) {
      return t % 1 == 0
    }

    function y(t) {
      if (null != Math.tanh) return Math.tanh(t);
      if (t === 1 / 0) return 1;
      if (t === -1 / 0) return -1; {
        const e = Math.exp(2 * t);
        return (e - 1) / (e + 1)
      }
    }

    function w(t) {
      const e = Math.ceil(Math.sqrt(t));
      return [e, Math.ceil(t / e)]
    }

    function v(t) {
      const e = new Uint32Array(t);
      for (let n = 0; n < t; ++n) e[n] = n;
      return s(e), e
    }

    function x(t, e) {
      return e <= t.length ? t : t + " ".repeat(e - t.length)
    }

    function O(t, e = (t => 0), n) {
      return new Promise((r, s) => {
        let i = 0;
        const a = () => {
          if (t()) return void r();
          i++;
          const o = e(i);
          null != n && i >= n ? s() : setTimeout(a, o)
        };
        a()
      })
    }

    function S(t, e) {
      let n = 1,
        r = -1;
      for (let e = 0; e < t.length; ++e)
        if (t[e] >= 0) n *= t[e];
        else if (-1 === t[e]) {
        if (-1 !== r) throw Error("Shapes can only have 1 implicit size. " + `Found -1 at dim ${r} and dim ${e}`);
        r = e
      } else if (t[e] < 0) throw Error(`Shapes can not be < 0. Found ${t[e]} at dim ${e}`);
      if (-1 === r) {
        if (e > 0 && e !== n) throw Error(`Size(${e}) must match the product of shape ${t}`);
        return t
      }
      if (0 === n) throw Error(`Cannot infer the missing size in [${t}] when ` + "there are 0 elements");
      if (e % n != 0) throw Error("The implicit shape can't be a fractional number. " + `Got ${e} / ${n}`);
      const s = t.slice();
      return s[r] = e / n, s
    }

    function _(t, e) {
      const n = e.length;
      return l((t = null == t ? e.map((t, e) => e) : [].concat(t)).every(t => t >= -n && t < n), () => `All values in axis param must be in range [-${n}, ${n}) but ` + `got axis ${t}`), l(t.every(t => b(t)), () => "All values in axis param must be integers but " + `got axis ${t}`), t.map(t => t < 0 ? n + t : t)
    }

    function k(t, e) {
      const n = [],
        r = [],
        s = null != e && Array.isArray(e) && 0 === e.length,
        i = null == e || s ? null : _(e, t).sort();
      let a = 0;
      for (let e = 0; e < t.length; ++e) {
        if (null != i) {
          if (i[a] === e && 1 !== t[e]) throw new Error(`Can't squeeze axis ${e} since its dim '${t[e]}' is not 1`);
          (null == i[a] || i[a] > e) && 1 === t[e] && (n.push(t[e]), r.push(e)), i[a] <= e && a++
        }
        1 !== t[e] && (n.push(t[e]), r.push(e))
      }
      return {
        newShape: n,
        keptDims: r
      }
    }

    function C(t, e) {
      let n = null;
      if (null == t || "float32" === t) n = new Float32Array(e);
      else if ("int32" === t) n = new Int32Array(e);
      else {
        if ("bool" !== t) throw new Error(`Unknown data type ${t}`);
        n = new Uint8Array(e)
      }
      return n
    }

    function E(t, e) {
      let n = null;
      if (null == t || "float32" === t) n = new Float32Array(e);
      else if ("int32" === t) n = new Int32Array(e);
      else if ("bool" === t) n = new Uint8Array(e);
      else {
        if ("string" !== t) throw new Error(`Unknown data type ${t}`);
        n = new Array(e)
      }
      return n
    }

    function I(t, e) {
      for (let n = 0; n < t.length; n++) {
        const r = t[n];
        if (isNaN(r) || !isFinite(r)) throw Error(`A tensor of type ${e} being uploaded contains ${r}.`)
      }
    }

    function T(t) {
      return "bool" === t || "complex64" === t || "float32" === t || "int32" === t || "string" === t
    }

    function A(t, e) {
      return "complex64" !== e && (("float32" !== e || "complex64" === t) && (("int32" !== e || "float32" === t || "complex64" === t) && ("bool" !== e || "bool" !== t)))
    }

    function N(t) {
      return t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array
    }

    function $(t) {
      if ("float32" === t || "int32" === t) return 4;
      if ("complex64" === t) return 8;
      if ("bool" === t) return 1;
      throw new Error(`Unknown dtype ${t}`)
    }

    function R(t) {
      if (null == t) return 0;
      let e = 0;
      return t.forEach(t => e += t.length), e
    }

    function j(t) {
      return "string" == typeof t || t instanceof String
    }

    function D(t) {
      return "boolean" == typeof t
    }

    function F(t) {
      return "number" == typeof t
    }

    function M(t) {
      return Array.isArray(t) ? M(t[0]) : t instanceof Float32Array ? "float32" : t instanceof Int32Array || t instanceof Uint8Array ? "int32" : F(t) ? "float32" : j(t) ? "string" : D(t) ? "bool" : "float32"
    }

    function z(t) {
      return !!(t && t.constructor && t.call && t.apply)
    }

    function L(t, e) {
      for (let n = e; n < t; ++n)
        if (t % n == 0) return n;
      return t
    }

    function B(t) {
      const e = t.length;
      if (e < 2) return [];
      const n = new Array(e - 1);
      n[e - 2] = t[e - 1];
      for (let r = e - 3; r >= 0; --r) n[r] = n[r + 1] * t[r + 1];
      return n
    }

    function P(t, e) {
      if ("string" === e) throw new Error("Cannot convert a string[] to a TypedArray");
      if (Array.isArray(t) && (t = p(t)), Object(r.b)().getBool("DEBUG") && I(t, e), function (t, e) {
          return t instanceof Float32Array && "float32" === e || t instanceof Int32Array && "int32" === e || t instanceof Uint8Array && "bool" === e
        }(t, e)) return t;
      if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);
      if ("int32" === e) return new Int32Array(t);
      if ("bool" === e) {
        const e = new Uint8Array(t.length);
        for (let n = 0; n < e.length; ++n) 0 !== Math.round(t[n]) && (e[n] = 1);
        return e
      }
      throw new Error(`Unknown data type ${e}`)
    }

    function W(t, e) {
      if (0 === t.length) return e[0];
      const n = t.reduce((t, e) => t * e);
      if (0 === n) return [];
      if (n !== e.length) throw new Error(`[${t}] does not match the input size ${e.length}.`);
      return function t(e, n, r) {
        const s = new Array;
        if (1 === n.length) {
          const t = n[0];
          for (let n = 0; n < t; n++) s[n] = r[e + n]
        } else {
          const i = n[0],
            a = n.slice(1),
            o = a.reduce((t, e) => t * e);
          for (let n = 0; n < i; n++) s[n] = t(e + n * o, a, r)
        }
        return s
      }(0, t, e)
    }

    function U(t, e) {
      const n = V(t, e);
      for (let t = 0; t < n.length; t++) n[t] = 1;
      return n
    }

    function V(t, e) {
      if (null == e || "float32" === e || "complex64" === e) return new Float32Array(t);
      if ("int32" === e) return new Int32Array(t);
      if ("bool" === e) return new Uint8Array(t);
      throw new Error(`Unknown data type ${e}`)
    }

    function H(t, e) {
      const n = t.reduce((t, e) => t * e, 1);
      if (null == e || "float32" === e) return W(t, new Float32Array(n));
      if ("int32" === e) return W(t, new Int32Array(n));
      if ("bool" === e) return W(t, new Uint8Array(n));
      throw new Error(`Unknown data type ${e}`)
    }

    function G() {
      return Object(r.b)().platform.now()
    }

    function q(t) {
      t.forEach(e => {
        l(Number.isInteger(e) && e >= 0, () => "Tensor must have a shape comprised of positive integers but got " + `shape [${t}].`)
      })
    }

    function K(t, e) {
      return Object(r.b)().platform.fetch(t, e)
    }

    function J(t, e = "utf-8") {
      return e = e || "utf-8", Object(r.b)().platform.encode(t, e)
    }

    function X(t, e = "utf-8") {
      return e = e || "utf-8", Object(r.b)().platform.decode(t, e)
    }

    function Y(t, e, n) {
      if (0 === e) return 0;
      if (1 === e) return t[0];
      let r = t[t.length - 1];
      for (let e = 0; e < t.length - 1; ++e) r += n[e] * t[e];
      return r
    }

    function Z(t, e, n) {
      if (0 === e) return [];
      if (1 === e) return [t];
      const r = new Array(e);
      for (let e = 0; e < r.length - 1; ++e) r[e] = Math.floor(t / n[e]), t -= r[e] * n[e];
      return r[r.length - 1] = t, r
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "c", (function () {
      return o
    })), n.d(e, "a", (function () {
      return c
    })), n.d(e, "b", (function () {
      return l
    }));
    var r = n(6),
      s = n(9),
      i = n(7),
      a = n(1);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function o(t, e) {
      let n = t;
      if (Object(a.isTypedArray)(t)) return "string" === e ? [] : [t.length];
      if (!Array.isArray(t)) return [];
      const r = [];
      for (; Array.isArray(n) || Object(a.isTypedArray)(n) && "string" !== e;) r.push(n.length), n = n[0];
      return Array.isArray(t) && Object(s.b)().getBool("TENSORLIKE_CHECK_SHAPE_CONSISTENCY") && function t(e, n, r) {
        if (r = r || [], !Array.isArray(e) && !Object(a.isTypedArray)(e)) return void Object(a.assert)(0 === n.length, () => `Element arr[${r.join("][")}] is a primitive, ` + `but should be an array/TypedArray of ${n[0]} elements`);
        Object(a.assert)(n.length > 0, () => `Element arr[${r.join("][")}] should be a primitive, ` + `but is an array of ${e.length} elements`), Object(a.assert)(e.length === n[0], () => `Element arr[${r.join("][")}] should have ${n[0]} ` + `elements, but has ${e.length} elements`);
        const s = n.slice(1);
        for (let n = 0; n < e.length; ++n) t(e[n], s, r.concat(n))
      }(t, r, []), r
    }

    function u(t, e, n, r) {
      if (null != t && ("numeric" !== t && t !== e || "numeric" === t && "string" === e)) throw new Error(`Argument '${n}' passed to '${r}' must ` + `be ${t} tensor, but got ${e} tensor`)
    }

    function c(t, e, n, s = "numeric") {
      if (t instanceof i.a) return u(s, t.dtype, e, n), t;
      let c = Object(a.inferDtype)(t);
      if ("string" !== c && ["bool", "int32", "float32"].indexOf(s) >= 0 && (c = s), u(s, c, e, n), null == t || !Object(a.isTypedArray)(t) && !Array.isArray(t) && "number" != typeof t && "boolean" != typeof t && "string" != typeof t) {
        const r = null == t ? "null" : t.constructor.name;
        throw new Error(`Argument '${e}' passed to '${n}' must be a ` + `Tensor or TensorLike, but got '${r}'`)
      }
      const l = o(t, c);
      Object(a.isTypedArray)(t) || Array.isArray(t) || (t = [t]);
      const h = "string" !== c ? Object(a.toTypedArray)(t, c) : Object(a.flatten)(t, [], !0);
      return r.a.makeTensor(h, l, c)
    }

    function l(t, e, n, r = "numeric") {
      if (!Array.isArray(t)) throw new Error(`Argument ${e} passed to ${n} must be a ` + "`Tensor[]` or `TensorLike[]`");
      return t.map((t, r) => c(t, `${e}[${r}]`, n), r)
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "d", (function () {
      return s
    })), n.d(e, "e", (function () {
      return i
    })), n.d(e, "f", (function () {
      return a
    })), n.d(e, "b", (function () {
      return o
    })), n.d(e, "g", (function () {
      return c
    })), n.d(e, "c", (function () {
      return l
    })), n.d(e, "a", (function () {
      return h
    }));
    var r = n(0);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function s(t, e, n, s) {
      const a = e.inputParams[t];
      if (a && void 0 !== a.inputIndexStart) {
        const t = a.inputIndexStart,
          o = 0 === a.inputIndexEnd ? void 0 : void 0 === a.inputIndexEnd ? t + 1 : a.inputIndexEnd;
        if ("tensor" === a.type) return i(e.inputNames[a.inputIndexStart], n, s);
        if ("tensors" === a.type) {
          return e.inputNames.slice(t, o).map(t => i(t, n, s))
        }
        const u = i(e.inputNames.slice(t)[0], n, s),
          c = u.dataSync();
        return "number" === a.type ? c[0] : r.Jd.toNestedArray(u.shape, c)
      }
      const o = e.attrParams[t];
      return o && o.value
    }

    function i(t, e, n) {
      const [r, s] = c(t), i = n.currentContextIds.find(t => !!e[u(r, t)]);
      return void 0 !== i ? e[u(r, i)][s] : void 0
    }

    function a(t, e, n) {
      return e[u(t, n.currentContextId)]
    }

    function o(t, e) {
      const [n, r] = c(t);
      return [u(n, e && e.currentContextId), r]
    }

    function u(t, e) {
      return e ? `${t}-${e}` : t
    }

    function c(t) {
      const e = t.split(":");
      return 1 === e.length ? [t, 0] : [e[0], Number(e[e.length - 1])]
    }

    function l(t, e, n) {
      let r = s("pad", t, e, n);
      if ("explicit" === r) {
        r = s("explicitPaddings", t, e, n);
        const i = [
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0]
        ];
        for (let t = 0; t < 4; t++) i[t][0] = r[2 * t], i[t][1] = r[2 * t + 1];
        return i
      }
      return r
    }

    function h(t) {
      return t.kept ? t : r.X(t)
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return r
    })), n.d(e, "b", (function () {
      return s
    })), n.d(e, "c", (function () {
      return i
    })), n.d(e, "d", (function () {
      return a
    })), n.d(e, "e", (function () {
      return o
    })), n.d(e, "f", (function () {
      return u
    })), n.d(e, "g", (function () {
      return c
    })), n.d(e, "h", (function () {
      return l
    })), n.d(e, "i", (function () {
      return h
    })), n.d(e, "j", (function () {
      return d
    })), n.d(e, "k", (function () {
      return p
    })), n.d(e, "l", (function () {
      return f
    })), n.d(e, "n", (function () {
      return m
    })), n.d(e, "m", (function () {
      return g
    })), n.d(e, "o", (function () {
      return b
    })), n.d(e, "r", (function () {
      return y
    })), n.d(e, "p", (function () {
      return w
    })), n.d(e, "q", (function () {
      return v
    })), n.d(e, "s", (function () {
      return x
    })), n.d(e, "t", (function () {
      return O
    })), n.d(e, "u", (function () {
      return S
    })), n.d(e, "v", (function () {
      return _
    })), n.d(e, "w", (function () {
      return k
    })), n.d(e, "x", (function () {
      return C
    })), n.d(e, "y", (function () {
      return E
    })), n.d(e, "z", (function () {
      return I
    })), n.d(e, "A", (function () {
      return T
    })), n.d(e, "B", (function () {
      return A
    })), n.d(e, "C", (function () {
      return N
    })), n.d(e, "D", (function () {
      return $
    })), n.d(e, "E", (function () {
      return R
    })), n.d(e, "F", (function () {
      return j
    })), n.d(e, "G", (function () {
      return D
    })), n.d(e, "H", (function () {
      return F
    })), n.d(e, "J", (function () {
      return M
    })), n.d(e, "I", (function () {
      return z
    })), n.d(e, "K", (function () {
      return L
    })), n.d(e, "L", (function () {
      return B
    })), n.d(e, "M", (function () {
      return P
    })), n.d(e, "N", (function () {
      return W
    })), n.d(e, "O", (function () {
      return U
    })), n.d(e, "P", (function () {
      return V
    })), n.d(e, "R", (function () {
      return H
    })), n.d(e, "Q", (function () {
      return G
    })), n.d(e, "S", (function () {
      return q
    })), n.d(e, "T", (function () {
      return K
    })), n.d(e, "U", (function () {
      return J
    })), n.d(e, "W", (function () {
      return X
    })), n.d(e, "V", (function () {
      return Y
    })), n.d(e, "X", (function () {
      return Z
    })), n.d(e, "Y", (function () {
      return Q
    })), n.d(e, "Z", (function () {
      return tt
    })), n.d(e, "ab", (function () {
      return et
    })), n.d(e, "bb", (function () {
      return nt
    })), n.d(e, "cb", (function () {
      return rt
    })), n.d(e, "db", (function () {
      return st
    })), n.d(e, "fb", (function () {
      return it
    })), n.d(e, "jb", (function () {
      return at
    })), n.d(e, "ib", (function () {
      return ot
    })), n.d(e, "kb", (function () {
      return ut
    })), n.d(e, "lb", (function () {
      return ct
    })), n.d(e, "nb", (function () {
      return lt
    })), n.d(e, "mb", (function () {
      return ht
    })), n.d(e, "ob", (function () {
      return dt
    })), n.d(e, "pb", (function () {
      return pt
    })), n.d(e, "qb", (function () {
      return ft
    })), n.d(e, "rb", (function () {
      return mt
    })), n.d(e, "ub", (function () {
      return gt
    })), n.d(e, "vb", (function () {
      return bt
    })), n.d(e, "wb", (function () {
      return yt
    })), n.d(e, "xb", (function () {
      return wt
    })), n.d(e, "yb", (function () {
      return vt
    })), n.d(e, "Ab", (function () {
      return xt
    })), n.d(e, "Bb", (function () {
      return Ot
    })), n.d(e, "Cb", (function () {
      return St
    })), n.d(e, "zb", (function () {
      return _t
    })), n.d(e, "sb", (function () {
      return kt
    })), n.d(e, "tb", (function () {
      return Ct
    })), n.d(e, "Db", (function () {
      return Et
    })), n.d(e, "Jb", (function () {
      return It
    })), n.d(e, "Eb", (function () {
      return Tt
    })), n.d(e, "Hb", (function () {
      return At
    })), n.d(e, "Fb", (function () {
      return Nt
    })), n.d(e, "Gb", (function () {
      return $t
    })), n.d(e, "Ib", (function () {
      return Rt
    })), n.d(e, "Kb", (function () {
      return jt
    })), n.d(e, "Lb", (function () {
      return Dt
    })), n.d(e, "Mb", (function () {
      return Ft
    })), n.d(e, "Nb", (function () {
      return Mt
    })), n.d(e, "Ob", (function () {
      return zt
    })), n.d(e, "Sb", (function () {
      return Lt
    })), n.d(e, "Pb", (function () {
      return Bt
    })), n.d(e, "Qb", (function () {
      return Pt
    })), n.d(e, "Rb", (function () {
      return Wt
    })), n.d(e, "Ub", (function () {
      return Ut
    })), n.d(e, "Tb", (function () {
      return Vt
    })), n.d(e, "Vb", (function () {
      return Ht
    })), n.d(e, "Wb", (function () {
      return Gt
    })), n.d(e, "Xb", (function () {
      return qt
    })), n.d(e, "Yb", (function () {
      return Kt
    })), n.d(e, "Zb", (function () {
      return Jt
    })), n.d(e, "ac", (function () {
      return Xt
    })), n.d(e, "bc", (function () {
      return Yt
    })), n.d(e, "cc", (function () {
      return Zt
    })), n.d(e, "ec", (function () {
      return Qt
    })), n.d(e, "hc", (function () {
      return te
    })), n.d(e, "ic", (function () {
      return ee
    })), n.d(e, "fc", (function () {
      return ne
    })), n.d(e, "gc", (function () {
      return re
    })), n.d(e, "dc", (function () {
      return se
    })), n.d(e, "jc", (function () {
      return ie
    })), n.d(e, "lc", (function () {
      return ae
    })), n.d(e, "mc", (function () {
      return oe
    })), n.d(e, "nc", (function () {
      return ue
    })), n.d(e, "oc", (function () {
      return ce
    })), n.d(e, "pc", (function () {
      return le
    })), n.d(e, "uc", (function () {
      return he
    })), n.d(e, "sc", (function () {
      return de
    })), n.d(e, "tc", (function () {
      return pe
    })), n.d(e, "rc", (function () {
      return fe
    })), n.d(e, "qc", (function () {
      return me
    })), n.d(e, "wc", (function () {
      return ge
    })), n.d(e, "Ac", (function () {
      return be
    })), n.d(e, "Gc", (function () {
      return ye
    })), n.d(e, "xc", (function () {
      return we
    })), n.d(e, "zc", (function () {
      return ve
    })), n.d(e, "vc", (function () {
      return xe
    })), n.d(e, "Cc", (function () {
      return Oe
    })), n.d(e, "Bc", (function () {
      return Se
    })), n.d(e, "Fc", (function () {
      return _e
    })), n.d(e, "yc", (function () {
      return ke
    })), n.d(e, "Ec", (function () {
      return Ce
    })), n.d(e, "Hc", (function () {
      return Ee
    })), n.d(e, "Ic", (function () {
      return Ie
    })), n.d(e, "Jc", (function () {
      return Te
    })), n.d(e, "Kc", (function () {
      return Ae
    })), n.d(e, "Lc", (function () {
      return Ne
    })), n.d(e, "Mc", (function () {
      return $e
    })), n.d(e, "Nc", (function () {
      return Re
    })), n.d(e, "Oc", (function () {
      return je
    })), n.d(e, "Dc", (function () {
      return De
    })), n.d(e, "eb", (function () {
      return Fe
    })), n.d(e, "kc", (function () {
      return Me
    })), n.d(e, "Pc", (function () {
      return ze
    })), n.d(e, "gb", (function () {
      return Le
    })), n.d(e, "hb", (function () {
      return Be
    }));
    const r = "Abs",
      s = "Acos",
      i = "Acosh",
      a = "Add",
      o = "AddN",
      u = "All",
      c = "Any",
      l = "ArgMax",
      h = "ArgMin",
      d = "Asin",
      p = "Asinh",
      f = "Atan",
      m = "Atanh",
      g = "Atan2",
      b = "AvgPool",
      y = "AvgPoolBackprop",
      w = "AvgPool3D",
      v = "AvgPool3DBackprop",
      x = "BatchMatMul",
      O = "BatchToSpaceND",
      S = "BroadcastTo",
      _ = "Cast",
      k = "Ceil",
      C = "ClipByValue",
      E = "Complex",
      I = "Concat",
      T = "Conv2D",
      A = "Conv2DBackpropFilter",
      N = "Conv2DBackpropInput",
      $ = "Conv3D",
      R = "Conv3DBackpropFilterV2",
      j = "Conv3DBackpropInputV2",
      D = "Cos",
      F = "Cosh",
      M = "Cumsum",
      z = "CropAndResize",
      L = "DepthToSpace",
      B = "DepthwiseConv2dNative",
      P = "DepthwiseConv2dNativeBackpropFilter",
      W = "DepthwiseConv2dNativeBackpropInput",
      U = "Diag",
      V = "Dilation2D",
      H = "Dilation2DBackpropInput",
      G = "Dilation2DBackpropFilter",
      q = "Div",
      K = "Elu",
      J = "EluGrad",
      X = "Erf",
      Y = "Equal",
      Z = "Exp",
      Q = "Expm1",
      tt = "FFT",
      et = "Fill",
      nt = "FlipLeftRight",
      rt = "Floor",
      st = "FloorDiv",
      it = "FusedBatchNorm",
      at = "GatherV2",
      ot = "GatherNd",
      ut = "Greater",
      ct = "GreaterEqual",
      lt = "Identity",
      ht = "IFFT",
      dt = "Imag",
      pt = "IsFinite",
      ft = "IsInf",
      mt = "IsNan",
      gt = "Less",
      bt = "LessEqual",
      yt = "LinSpace",
      wt = "Log",
      vt = "Log1p",
      xt = "LogicalAnd",
      Ot = "LogicalNot",
      St = "LogicalOr",
      _t = "LogSoftmax",
      kt = "LRN",
      Ct = "LRNBackprop",
      Et = "Max",
      It = "Maximum",
      Tt = "MaxPool",
      At = "MaxPoolBackprop",
      Nt = "MaxPool3D",
      $t = "MaxPool3DBackprop",
      Rt = "MaxPoolWithArgmax",
      jt = "Min",
      Dt = "Minimum",
      Ft = "Mod",
      Mt = "Multiply",
      zt = "Negate",
      Lt = "NotEqual",
      Bt = "NonMaxSuppressionV3",
      Pt = "NonMaxSuppressionV4",
      Wt = "NonMaxSuppressionV5",
      Ut = "OnesLike",
      Vt = "OneHot",
      Ht = "PadV2",
      Gt = "Pow",
      qt = "Prelu",
      Kt = "Prod",
      Jt = "Range",
      Xt = "Real",
      Yt = "Reciprocal",
      Zt = "Relu",
      Qt = "Reshape",
      te = "ResizeNearestNeighbor",
      ee = "ResizeNearestNeighborGrad",
      ne = "ResizeBilinear",
      re = "ResizeBilinearGrad",
      se = "Relu6",
      ie = "Reverse",
      ae = "Round",
      oe = "Rsqrt",
      ue = "ScatterNd",
      ce = "SelectV2",
      le = "Selu",
      he = "Slice",
      de = "Sin",
      pe = "Sinh",
      fe = "Sign",
      me = "Sigmoid",
      ge = "Softplus",
      be = "Sqrt",
      ye = "Sum",
      we = "SpaceToBatchND",
      ve = "SplitV",
      xe = "Softmax",
      Oe = "SquaredDifference",
      Se = "Square",
      _e = "Sub",
      ke = "SparseToDense",
      Ce = "StridedSlice",
      Ee = "Tan",
      Ie = "Tanh",
      Te = "Tile",
      Ae = "TopK",
      Ne = "Transpose",
      $e = "Unpack",
      Re = "UnsortedSegmentSum",
      je = "ZerosLike",
      De = "Step",
      Fe = "FromPixels",
      Me = "RotateWithOffset",
      ze = "_FusedMatMul",
      Le = "FusedConv2D",
      Be = "FusedDepthwiseConv2D"
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return s
    }));
    var r = n(6);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function s(t) {
      const e = Object.keys(t);
      if (1 !== e.length) throw new Error("Please provide an object with a single key (operation name) mapping to a function. Got an object with " + `${e.length} keys.`);
      let n = e[0];
      const s = t[n];
      n.endsWith("_") && (n = n.substring(0, n.length - 1));
      const i = (...t) => {
        r.a.startScope(n);
        try {
          const e = s(...t);
          return e instanceof Promise && console.error("Cannot return a Promise inside of tidy."), r.a.endScope(e), e
        } catch (t) {
          throw r.a.endScope(null), t
        }
      };
      return Object.defineProperty(i, "name", {
        value: n,
        configurable: !0
      }), i
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(9),
      s = n(44),
      i = n(4),
      a = n(23),
      o = n(1);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class u {
      constructor(t, e) {
        this.backendTimer = t, this.logger = e, null == e && (this.logger = new c)
      }
      profileKernel(t, e, n) {
        let r;
        const s = this.backendTimer.time(() => {
          r = n()
        });
        return r.map(e => {
          e.data().then(n => {
            ! function (t, e, n) {
              if ("float32" !== e) return !1;
              for (let e = 0; e < t.length; e++) {
                const r = t[e];
                if (isNaN(r) || !isFinite(r)) return console.warn(`Found ${r} in the result of '${n}'`), !0
              }
            }(n, e.dtype, t)
          })
        }), {
          kernelName: t,
          outputs: r,
          inputs: e,
          timeMs: s.then(t => t.kernelMs),
          extraInfo: s.then(t => null != t.getExtraProfileInfo ? t.getExtraProfileInfo() : "")
        }
      }
      logKernelProfile(t) {
        const {
          kernelName: e,
          outputs: n,
          timeMs: r,
          inputs: s,
          extraInfo: i
        } = t;
        n.forEach(t => {
          Promise.all([t.data(), r, i]).then(n => {
            this.logger.logKernelProfile(e, t, n[0], n[1], s, n[2])
          })
        })
      }
    }
    class c {
      logKernelProfile(t, e, n, r, s, i) {
        const a = "number" == typeof r ? o.rightPad(`${r}ms`, 9) : r.error,
          u = o.rightPad(t, 25),
          c = e.rank,
          l = e.size,
          h = o.rightPad(e.shape.toString(), 14);
        let d = "";
        for (const t in s) {
          const n = s[t];
          if (null != n) {
            const r = n.shape || e.shape,
              s = r.length;
            d += `${t}: ${s}D ${s>0?r:""} `
          }
        }
        console.log(`%c${u}\t%c${a}\t%c${c}D ${h}\t%c${l}\t%c${d}\t%c${i}`, "font-weight:bold", "color:red", "color:blue", "color: orange", "color: green", "color: steelblue")
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    var l = n(7),
      h = n(8);
    n.d(e, "a", (function () {
      return f
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class d {
      constructor() {
        this.registeredVariables = {}, this.nextTapeNodeId = 0, this.numBytes = 0, this.numTensors = 0, this.numStringTensors = 0, this.numDataBuffers = 0, this.gradientDepth = 0, this.kernelDepth = 0, this.scopeStack = [], this.numDataMovesStack = [], this.nextScopeId = 0, this.tensorInfo = new WeakMap, this.profiling = !1, this.activeProfile = {
          newBytes: 0,
          newTensors: 0,
          peakBytes: 0,
          kernels: [],
          result: null
        }
      }
      dispose() {
        for (const t in this.registeredVariables) this.registeredVariables[t].dispose()
      }
    }
    class p {
      constructor(t) {
        this.ENV = t, this.registry = {}, this.registryFactory = {}, this.pendingBackendInitId = 0, this.state = new d
      }
      async ready() {
        if (null != this.pendingBackendInit) return this.pendingBackendInit.then(() => {});
        if (null != this.backendInstance) return;
        const t = this.getSortedBackends();
        for (let e = 0; e < t.length; e++) {
          const n = t[e];
          if (await this.initializeBackend(n).success) return void await this.setBackend(n)
        }
        throw new Error("Could not initialize any backends, all backend initializations failed.")
      }
      get backend() {
        if (null != this.pendingBackendInit) throw new Error(`Backend '${this.backendName}' has not yet been initialized. Make ` + "sure to await tf.ready() or await tf.setBackend() before calling other methods");
        if (null == this.backendInstance) {
          const {
            name: t,
            asyncInit: e
          } = this.initializeBackendsAndReturnBest();
          if (e) throw new Error(`The highest priority backend '${t}' has not yet been ` + "initialized. Make sure to await tf.ready() or await tf.setBackend() before calling other methods");
          this.setBackend(t)
        }
        return this.backendInstance
      }
      backendNames() {
        return Object.keys(this.registryFactory)
      }
      findBackend(t) {
        if (!(t in this.registry)) {
          if (!(t in this.registryFactory)) return null; {
            const {
              asyncInit: e
            } = this.initializeBackend(t);
            if (e) return null
          }
        }
        return this.registry[t]
      }
      findBackendFactory(t) {
        return t in this.registryFactory ? this.registryFactory[t].factory : null
      }
      registerBackend(t, e, n = 1) {
        return t in this.registryFactory ? (console.warn(`${t} backend was already registered. ` + "Reusing existing backend factory."), !1) : (this.registryFactory[t] = {
          factory: e,
          priority: n
        }, !0)
      }
      async setBackend(t) {
        if (null == this.registryFactory[t]) throw new Error(`Backend name '${t}' not found in registry`);
        if (this.backendName = t, null == this.registry[t]) {
          this.backendInstance = null;
          const {
            success: e,
            asyncInit: n
          } = this.initializeBackend(t);
          if (!(n ? await e : e)) return !1
        }
        return this.backendInstance = this.registry[t], this.setupRegisteredKernels(), this.profiler = new u(this.backendInstance), !0
      }
      setupRegisteredKernels() {
        Object(a.c)(this.backendName).forEach(t => {
          null != t.setupFunc && t.setupFunc(this.backendInstance)
        })
      }
      disposeRegisteredKernels(t) {
        Object(a.c)(t).forEach(e => {
          null != e.disposeFunc && e.disposeFunc(this.registry[t])
        })
      }
      initializeBackend(t) {
        const e = this.registryFactory[t];
        if (null == e) throw new Error(`Cannot initialize backend ${t}, no registration found.`);
        try {
          const n = e.factory();
          if (Promise.resolve(n) === n) {
            const e = ++this.pendingBackendInitId,
              r = n.then(n => !(e < this.pendingBackendInitId) && (this.registry[t] = n, this.pendingBackendInit = null, !0)).catch(n => !(e < this.pendingBackendInitId) && (this.pendingBackendInit = null, console.warn(`Initialization of backend ${t} failed`), console.warn(n.stack || n.message), !1));
            return this.pendingBackendInit = r, {
              success: r,
              asyncInit: !0
            }
          }
          return this.registry[t] = n, {
            success: !0,
            asyncInit: !1
          }
        } catch (e) {
          return console.warn(`Initialization of backend ${t} failed`), console.warn(e.stack || e.message), {
            success: !1,
            asyncInit: !1
          }
        }
      }
      removeBackend(t) {
        if (!(t in this.registryFactory)) throw new Error(`${t} backend not found in registry`);
        this.backendName === t && null != this.pendingBackendInit && this.pendingBackendInitId++, t in this.registry && (this.disposeRegisteredKernels(t), this.registry[t].dispose(), delete this.registry[t]), delete this.registryFactory[t], this.backendName === t && (this.pendingBackendInit = null, this.backendName = null, this.backendInstance = null)
      }
      getSortedBackends() {
        if (0 === Object.keys(this.registryFactory).length) throw new Error("No backend found in registry.");
        return Object.keys(this.registryFactory).sort((t, e) => this.registryFactory[e].priority - this.registryFactory[t].priority)
      }
      initializeBackendsAndReturnBest() {
        const t = this.getSortedBackends();
        for (let e = 0; e < t.length; e++) {
          const n = t[e],
            {
              success: r,
              asyncInit: s
            } = this.initializeBackend(n);
          if (s || r) return {
            name: n,
            asyncInit: s
          }
        }
        throw new Error("Could not initialize any backends, all backend initializations failed.")
      }
      moveData(t, e) {
        const n = this.state.tensorInfo.get(e),
          r = n.backend,
          s = this.readSync(e);
        r.disposeData(e), n.backend = t, t.move(e, s, n.shape, n.dtype), this.shouldCheckForMemLeaks() && this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1]++
      }
      tidy(t, e) {
        let n, r = null;
        if (null == e) {
          if ("function" != typeof t) throw new Error("Please provide a function to tidy()");
          e = t
        } else {
          if ("string" != typeof t && !(t instanceof String)) throw new Error("When calling with two arguments, the first argument to tidy() must be a string");
          if ("function" != typeof e) throw new Error("When calling with two arguments, the 2nd argument to tidy() must be a function");
          r = t
        }
        return this.scopedRun(() => this.startScope(r), () => this.endScope(n), () => (n = e(), n instanceof Promise && console.error("Cannot return a Promise inside of tidy."), n))
      }
      scopedRun(t, e, n) {
        t();
        try {
          const t = n();
          return e(), t
        } catch (t) {
          throw e(), t
        }
      }
      nextTensorId() {
        return p.nextTensorId++
      }
      nextVariableId() {
        return p.nextVariableId++
      }
      clone(t) {
        const e = this.makeTensorFromDataId(t.dataId, t.shape, t.dtype),
          n = {
            x: t
          };
        return this.addTapeNode(this.state.activeScope.name, n, [e], t => ({
          x: () => {
            const e = {
                x: t
              },
              n = {
                dtype: "float32"
              };
            return f.runKernelFunc(e => e.cast(t, "float32"), e, null, i.v, n)
          }
        }), [], {}), e
      }
      runKernel(t, e, n, r, s) {
        return this.runKernelFunc(null, e, null, t, n, r, s)
      }
      shouldCheckForMemLeaks() {
        return this.ENV.getBool("IS_TEST")
      }
      checkKernelForMemLeak(t, e, n) {
        const r = this.backend.numDataIds();
        let s = 0;
        n.forEach(t => {
          s += "complex64" === t.dtype ? 3 : 1
        });
        const i = this.state.numDataMovesStack[this.state.numDataMovesStack.length - 1],
          a = r - e - s - i;
        if (a > 0) throw new Error(`Backend '${this.backendName}' has an internal memory leak ` + `(${a} data ids) after running '${t}'`)
      }
      runKernelFunc(t, e, n, r, s, i, o) {
        let u, c = [];
        const l = this.isTapeOn();
        null == r && (r = null != this.state.activeScope ? this.state.activeScope.name : "");
        const h = this.state.numBytes,
          d = this.state.numTensors;
        let p;
        this.shouldCheckForMemLeaks() && this.state.numDataMovesStack.push(0);
        const f = Object(a.b)(r, this.backendName);
        let m, g;
        if (null != f) p = () => {
          const t = this.backend.numDataIds();
          m = f.kernelFunc({
            inputs: e,
            attrs: s,
            backend: this.backend
          });
          const n = Array.isArray(m) ? m : [m];
          this.shouldCheckForMemLeaks() && this.checkKernelForMemLeak(r, t, n);
          const a = n.map(({
            dataId: t,
            shape: e,
            dtype: n
          }) => this.makeTensorFromDataId(t, e, n));
          if (l) {
            let t = this.getTensorsForGradient(r, e, a);
            if (null == t) {
              null == o && (o = []);
              const e = a.filter((t, e) => o[e]);
              t = (i || []).slice().concat(e)
            }
            c = this.saveTensorsForBackwardMode(t)
          }
          return a
        };
        else {
          const e = t => {
            l && (c = t.map(t => this.keep(this.clone(t))))
          };
          p = () => {
            const n = this.backend.numDataIds();
            m = this.tidy(() => t(this.backend, e));
            const s = Array.isArray(m) ? m : [m];
            return this.shouldCheckForMemLeaks() && this.checkKernelForMemLeak(r, n, s), s
          }
        }
        return this.scopedRun(() => this.state.kernelDepth++, () => this.state.kernelDepth--, () => {
          this.ENV.getBool("DEBUG") || this.state.profiling ? (g = this.profiler.profileKernel(r, e, () => p()), this.ENV.getBool("DEBUG") && this.profiler.logKernelProfile(g), u = g.outputs) : u = p()
        }), l && this.addTapeNode(r, e, u, n, c, s), this.state.profiling && this.state.activeProfile.kernels.push({
          name: r,
          bytesAdded: this.state.numBytes - h,
          totalBytesSnapshot: this.state.numBytes,
          tensorsAdded: this.state.numTensors - d,
          totalTensorsSnapshot: this.state.numTensors,
          inputShapes: Object.keys(e).map(t => null != e[t] ? e[t].shape : null),
          outputShapes: u.map(t => t.shape),
          kernelTimeMs: g.timeMs,
          extraInfo: g.extraInfo
        }), Array.isArray(m) ? u : u[0]
      }
      saveTensorsForBackwardMode(t) {
        return t.map(t => this.keep(this.clone(t)))
      }
      getTensorsForGradient(t, e, n) {
        const r = Object(a.a)(t);
        if (null != r) {
          const t = r.inputsToSave || [],
            s = r.outputsToSave || [];
          let i;
          r.saveAllInputs ? (o.assert(Array.isArray(e), () => "saveAllInputs is true, expected inputs to be an array."), i = Object.keys(e).map(t => e[t])) : i = t.map(t => e[t]);
          const a = n.filter((t, e) => s[e]);
          return i.concat(a)
        }
        return null
      }
      makeTensor(t, e, n, r) {
        if (null == t) throw new Error("Values passed to engine.makeTensor() are null");
        n = n || "float32", r = r || this.backend;
        let s = t;
        "string" === n && o.isString(t[0]) && (s = t.map(t => o.encodeString(t)));
        const i = r.write(s, e, n),
          a = new l.a(e, n, i, this.nextTensorId());
        if (this.incRef(a, r), "string" === n) {
          const t = this.state.tensorInfo.get(i),
            e = Object(o.bytesFromStringArray)(s);
          this.state.numBytes += e - t.bytes, t.bytes = e
        }
        return a
      }
      makeTensorFromDataId(t, e, n, r) {
        n = n || "float32";
        const s = new l.a(e, n, t, this.nextTensorId());
        return this.incRef(s, r), s
      }
      makeVariable(t, e = !0, n, r) {
        n = n || this.nextVariableId().toString(), null != r && r !== t.dtype && (t = t.cast(r));
        const s = new l.c(t, e, n, this.nextTensorId());
        if (null != this.state.registeredVariables[s.name]) throw new Error(`Variable with name ${s.name} was already registered`);
        return this.state.registeredVariables[s.name] = s, this.incRef(s, this.backend), s
      }
      incRef(t, e) {
        const n = this.state.tensorInfo.has(t.dataId) ? this.state.tensorInfo.get(t.dataId).refCount : 0;
        if (this.state.numTensors++, "string" === t.dtype && this.state.numStringTensors++, 0 === n) {
          this.state.numDataBuffers++;
          let n = 0;
          "complex64" !== t.dtype && "string" !== t.dtype && (n = t.size * o.bytesPerElement(t.dtype)), this.state.tensorInfo.set(t.dataId, {
            backend: e || this.backend,
            dtype: t.dtype,
            shape: t.shape,
            bytes: n,
            refCount: 0
          }), this.state.numBytes += n
        }
        this.state.tensorInfo.get(t.dataId).refCount++, t instanceof l.c || this.track(t)
      }
      disposeTensor(t) {
        if (!this.state.tensorInfo.has(t.dataId)) return;
        this.state.numTensors--, "string" === t.dtype && this.state.numStringTensors--;
        const e = this.state.tensorInfo.get(t.dataId);
        e.refCount <= 1 ? ("complex64" !== t.dtype && (this.state.numBytes -= e.bytes), this.state.numDataBuffers--, e.backend.disposeData(t.dataId), this.state.tensorInfo.delete(t.dataId)) : this.state.tensorInfo.get(t.dataId).refCount--
      }
      disposeVariables() {
        for (const t in this.state.registeredVariables) {
          const e = this.state.registeredVariables[t];
          this.disposeVariable(e)
        }
      }
      disposeVariable(t) {
        this.disposeTensor(t), null != this.state.registeredVariables[t.name] && delete this.state.registeredVariables[t.name]
      }
      memory() {
        const t = this.backend.memory();
        return t.numTensors = this.state.numTensors, t.numDataBuffers = this.state.numDataBuffers, t.numBytes = this.state.numBytes, this.state.numStringTensors > 0 && (t.unreliable = !0, null == t.reasons && (t.reasons = []), t.reasons.push("Memory usage by string tensors is approximate (2 bytes per character)")), t
      }
      async profile(t) {
        this.state.profiling = !0;
        const e = this.state.numBytes,
          n = this.state.numTensors;
        this.state.activeProfile.kernels = [], this.state.activeProfile.result = await t(), this.state.profiling = !1, this.state.activeProfile.peakBytes = Math.max(...this.state.activeProfile.kernels.map(t => t.totalBytesSnapshot)), this.state.activeProfile.newBytes = this.state.numBytes - e, this.state.activeProfile.newTensors = this.state.numTensors - n;
        for (const t of this.state.activeProfile.kernels) t.kernelTimeMs = await t.kernelTimeMs, t.extraInfo = await t.extraInfo;
        return this.state.activeProfile
      }
      isTapeOn() {
        return this.state.gradientDepth > 0 && 0 === this.state.kernelDepth
      }
      addTapeNode(t, e, n, r, s, i) {
        const u = {
            id: this.state.nextTapeNodeId++,
            kernelName: t,
            inputs: e,
            outputs: n,
            saved: s
          },
          c = Object(a.a)(t);
        null != c && (r = c.gradFunc), null != r && (u.gradient = t => (t = t.map((t, e) => {
          if (null == t) {
            const t = n[e],
              r = o.makeZerosTypedArray(t.size, t.dtype);
            return this.makeTensor(r, t.shape, t.dtype)
          }
          return t
        }), r(t.length > 1 ? t : t[0], s, i))), this.state.activeTape.push(u)
      }
      keep(t) {
        return t.kept = !0, t
      }
      startTape() {
        0 === this.state.gradientDepth && (this.state.activeTape = []), this.state.gradientDepth++
      }
      endTape() {
        this.state.gradientDepth--
      }
      startScope(t) {
        const e = {
          track: [],
          name: "unnamed scope",
          id: this.state.nextScopeId++
        };
        t && (e.name = t), this.state.scopeStack.push(e), this.state.activeScope = e
      }
      endScope(t) {
        const e = Object(h.getTensorsInContainer)(t),
          n = new Set(e.map(t => t.id));
        for (let t = 0; t < this.state.activeScope.track.length; t++) {
          const e = this.state.activeScope.track[t];
          e.kept || n.has(e.id) || e.dispose()
        }
        const r = this.state.scopeStack.pop();
        this.state.activeScope = 0 === this.state.scopeStack.length ? null : this.state.scopeStack[this.state.scopeStack.length - 1], e.forEach(t => {
          t.kept || t.scopeId !== r.id || this.track(t)
        })
      }
      gradients(t, e, n, r = !1) {
        if (o.assert(e.length > 0, () => "gradients() received an empty list of xs."), null != n && "float32" !== n.dtype) throw new Error(`dy must have 'float32' dtype, but has '${n.dtype}'`);
        const s = this.scopedRun(() => this.startTape(), () => this.endTape(), () => this.tidy("forward", t));
        o.assert(s instanceof l.a, () => "The result y returned by f() must be a tensor.");
        const i = function (t, e, n) {
          const r = {},
            s = {};
          for (let t = 0; t < e.length; t++) r[e[t].id] = !0;
          for (let n = 0; n < t.length; n++) {
            const i = t[n],
              a = i.inputs;
            for (const t in a) {
              const n = a[t];
              let o = !1;
              for (let t = 0; t < e.length; t++)
                if (r[n.id]) {
                  i.outputs.forEach(t => r[t.id] = !0), o = !0, s[i.id] = !0;
                  break
                } if (o) break
            }
          }
          const i = {};
          i[n.id] = !0;
          const a = {};
          for (let e = t.length - 1; e >= 0; e--) {
            const n = t[e],
              r = n.inputs;
            for (let t = 0; t < n.outputs.length; t++)
              if (i[n.outputs[t].id]) {
                for (const t in r) i[r[t].id] = !0, a[n.id] = !0;
                break
              }
          }
          const o = [];
          for (let e = 0; e < t.length; e++) {
            const n = t[e];
            if (s[n.id] && a[n.id]) {
              const t = {};
              for (const e in n.inputs) {
                const s = n.inputs[e];
                r[s.id] && (t[e] = s)
              }
              const e = Object.assign({}, n);
              e.inputs = t, e.outputs = n.outputs, o.push(e)
            }
          }
          return o
        }(this.state.activeTape, e, s);
        if (!r && 0 === i.length && e.length > 0) throw new Error("Cannot compute gradient of y=f(x) with respect to x. Make sure that the f you passed encloses all operations that lead from x to y.");
        return this.tidy("backward", () => {
          const t = {};
          t[s.id] = null == n ? function (t) {
              const e = Object(o.makeOnesTypedArray)(Object(o.sizeFromShape)(t), "float32");
              return f.makeTensor(e, t, "float32")
            }(s.shape) : n,
            function (t, e, n, r) {
              for (let s = e.length - 1; s >= 0; s--) {
                const i = e[s],
                  a = [];
                if (i.outputs.forEach(e => {
                    const n = t[e.id];
                    null != n ? a.push(n) : a.push(null)
                  }), null == i.gradient) throw new Error("Cannot compute gradient: gradient function not found " + `for ${i.kernelName}.`);
                const u = i.gradient(a);
                for (const e in i.inputs) {
                  if (!(e in u)) throw new Error(`Cannot backprop through input ${e}. ` + `Available gradients found: ${Object.keys(u)}.`);
                  const s = n(() => u[e]());
                  if ("float32" !== s.dtype) throw new Error(`Error in gradient for op ${i.kernelName}. The gradient of input ` + `${e} must have 'float32' dtype, but has '${s.dtype}'`);
                  const a = i.inputs[e];
                  if (!o.arraysEqual(s.shape, a.shape)) throw new Error(`Error in gradient for op ${i.kernelName}. The gradient of input ` + `'${e}' has shape '${s.shape}', which does not match ` + `the shape of the input '${a.shape}'`);
                  if (null == t[a.id]) t[a.id] = s;
                  else {
                    const e = t[a.id];
                    t[a.id] = r(e, s), e.dispose()
                  }
                }
              }
            }(t, i, t => this.tidy(t), m);
          const r = e.map(e => t[e.id]);
          return 0 === this.state.gradientDepth && (this.state.activeTape.forEach(t => {
            for (const e of t.saved) e.dispose()
          }), this.state.activeTape = null), {
            value: s,
            grads: r
          }
        })
      }
      customGrad(t) {
        return o.assert(o.isFunction(t), () => "The f passed in customGrad(f) must be a function."), (...e) => {
          let n;
          o.assert(e.every(t => t instanceof l.a), () => "The args passed in customGrad(f)(x1, x2,...) must all be tensors");
          const r = {};
          return e.forEach((t, e) => {
            r[e] = t
          }), this.runKernelFunc((r, s) => (n = t(...e, s), o.assert(n.value instanceof l.a, () => "The function f passed in customGrad(f) must return an object where `obj.value` is a tensor"), o.assert(o.isFunction(n.gradFunc), () => "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function."), n.value), r, (t, r) => {
            const s = n.gradFunc(t, r),
              i = Array.isArray(s) ? s : [s];
            o.assert(i.length === e.length, () => "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns the same number of tensors as inputs passed to f(...)."), o.assert(i.every(t => t instanceof l.a), () => "The function f passed in customGrad(f) must return an object where `obj.gradFunc` is a function that returns a list of only tensors.");
            const a = {};
            return i.forEach((t, e) => {
              a[e] = () => t
            }), a
          })
        }
      }
      readSync(t) {
        return this.state.tensorInfo.get(t).backend.readSync(t)
      }
      read(t) {
        return this.state.tensorInfo.get(t).backend.read(t)
      }
      async time(t) {
        const e = Object(o.now)(),
          n = await this.backend.time(t);
        return n.wallMs = Object(o.now)() - e, n
      }
      track(t) {
        return null != this.state.activeScope && (t.scopeId = this.state.activeScope.id, this.state.activeScope.track.push(t)), t
      }
      get registeredVariables() {
        return this.state.registeredVariables
      }
      reset() {
        this.pendingBackendInitId++, this.state.dispose(), this.ENV.reset(), this.state = new d;
        for (const t in this.registry) this.disposeRegisteredKernels(t), this.registry[t].dispose(), delete this.registry[t];
        this.backendName = null, this.backendInstance = null, this.pendingBackendInit = null
      }
    }
    p.nextTensorId = 0, p.nextVariableId = 0;
    const f = function () {
      const t = Object(s.b)();
      if (null == t._tfengine) {
        const e = new r.a(t);
        t._tfengine = new p(e)
      }
      return Object(r.c)(t._tfengine.ENV), Object(l.f)(() => t._tfengine), t._tfengine
    }();

    function m(t, e) {
      const n = {
        a: t,
        b: e
      };
      return f.runKernelFunc((n, r) => {
        const s = n.add(t, e);
        return r([t, e]), s
      }, n, null, i.d)
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(1);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const s = 20,
      i = 3,
      a = 7;

    function o(t, e, n, a) {
      const o = Object(r.computeStrides)(e),
        h = function (t, e, n, s) {
          const i = Object(r.sizeFromShape)(e),
            a = s[s.length - 1],
            o = new Array(a).fill(0),
            c = e.length,
            h = "complex64" === n ? l(t) : t;
          if (c > 1)
            for (let t = 0; t < i / a; t++) {
              const e = t * a;
              for (let t = 0; t < a; t++) o[t] = Math.max(o[t], u(h[e + t], 0, n).length)
            }
          return o
        }(t, e, n, o),
        d = e.length,
        p = function t(e, n, r, a, o, h = !0) {
          const d = "complex64" === r ? 2 : 1,
            p = n[0],
            f = n.length;
          if (0 === f) {
            if ("complex64" === r) {
              return [u(l(e)[0], 0, r)]
            }
            return "bool" === r ? [c(e[0])] : [e[0].toString()]
          }
          if (1 === f) {
            if (p > s) {
              const t = i * d;
              let n = Array.from(e.slice(0, t)),
                s = Array.from(e.slice((p - i) * d, p * d));
              return "complex64" === r && (n = l(n), s = l(s)), ["[" + n.map((t, e) => u(t, o[e], r)).join(", ") + ", ..., " + s.map((t, e) => u(t, o[p - i + e], r)).join(", ") + "]"]
            }
            return ["[" + ("complex64" === r ? l(e) : Array.from(e)).map((t, e) => u(t, o[e], r)).join(", ") + "]"]
          }
          const m = n.slice(1),
            g = a.slice(1),
            b = a[0] * d,
            y = [];
          if (p > s) {
            for (let n = 0; n < i; n++) {
              const s = n * b,
                i = s + b;
              y.push(...t(e.slice(s, i), m, r, g, o, !1))
            }
            y.push("...");
            for (let n = p - i; n < p; n++) {
              const s = n * b,
                i = s + b;
              y.push(...t(e.slice(s, i), m, r, g, o, n === p - 1))
            }
          } else
            for (let n = 0; n < p; n++) {
              const s = n * b,
                i = s + b;
              y.push(...t(e.slice(s, i), m, r, g, o, n === p - 1))
            }
          const w = 2 === f ? "," : "";
          y[0] = "[" + y[0] + w;
          for (let t = 1; t < y.length - 1; t++) y[t] = " " + y[t] + w;
          let v = ",\n";
          for (let t = 2; t < f; t++) v += "\n";
          return y[y.length - 1] = " " + y[y.length - 1] + "]" + (h ? "" : v), y
        }(t, e, n, o, h),
        f = ["Tensor"];
      return a && (f.push(`  dtype: ${n}`), f.push(`  rank: ${d}`), f.push(`  shape: [${e}]`), f.push("  values:")), f.push(p.map(t => "    " + t).join("\n")), f.join("\n")
    }

    function u(t, e, n) {
      let s;
      return s = Array.isArray(t) ? `${parseFloat(t[0].toFixed(a))} + ` + `${parseFloat(t[1].toFixed(a))}j` : Object(r.isString)(t) ? `'${t}'` : "bool" === n ? c(t) : parseFloat(t.toFixed(a)).toString(), Object(r.rightPad)(s, e)
    }

    function c(t) {
      return 0 === t ? "false" : "true"
    }

    function l(t) {
      const e = [];
      for (let n = 0; n < t.length; n += 2) e.push([t[n], t[n + 1]]);
      return e
    }
    n.d(e, "b", (function () {
      return h
    })), n.d(e, "f", (function () {
      return m
    })), n.d(e, "e", (function () {
      return g
    })), n.d(e, "d", (function () {
      return b
    })), n.d(e, "a", (function () {
      return y
    })), n.d(e, "c", (function () {
      return w
    }));
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class h {
      constructor(t, e, n) {
        if (this.dtype = e, this.shape = t.slice(), this.size = r.sizeFromShape(t), null != n) {
          const t = n.length;
          r.assert(t === this.size, () => `Length of values '${t}' does not match the size ` + `inferred by the shape '${this.size}'.`)
        }
        if ("complex64" === e) throw new Error("complex64 dtype TensorBuffers are not supported. Please create a TensorBuffer for the real and imaginary parts separately and call tf.complex(real, imag).");
        this.values = n || r.getArrayFromDType(e, this.size), this.strides = Object(r.computeStrides)(t)
      }
      set(t, ...e) {
        0 === e.length && (e = [0]), r.assert(e.length === this.rank, () => `The number of provided coordinates (${e.length}) must ` + `match the rank (${this.rank})`);
        const n = this.locToIndex(e);
        this.values[n] = t
      }
      get(...t) {
        0 === t.length && (t = [0]);
        let e = 0;
        for (const n of t) {
          if (n < 0 || n >= this.shape[e]) {
            const e = `Requested out of range element at ${t}. ` + `  Buffer shape=${this.shape}`;
            throw new Error(e)
          }
          e++
        }
        let n = t[t.length - 1];
        for (let e = 0; e < t.length - 1; ++e) n += this.strides[e] * t[e];
        return this.values[n]
      }
      locToIndex(t) {
        if (0 === this.rank) return 0;
        if (1 === this.rank) return t[0];
        let e = t[t.length - 1];
        for (let n = 0; n < t.length - 1; ++n) e += this.strides[n] * t[n];
        return e
      }
      indexToLoc(t) {
        if (0 === this.rank) return [];
        if (1 === this.rank) return [t];
        const e = new Array(this.shape.length);
        for (let n = 0; n < e.length - 1; ++n) e[n] = Math.floor(t / this.strides[n]), t -= e[n] * this.strides[n];
        return e[e.length - 1] = t, e
      }
      get rank() {
        return this.shape.length
      }
      toTensor() {
        return d().makeTensor(this.values, this.shape, this.dtype)
      }
    }
    let d = null,
      p = null,
      f = null;

    function m(t) {
      d = t
    }

    function g(t) {
      p = t
    }

    function b(t) {
      f = t
    }
    class y {
      constructor(t, e, n, s) {
        this.kept = !1, this.isDisposedInternal = !1, this.shape = t.slice(), this.dtype = e || "float32", this.size = r.sizeFromShape(t), this.strides = Object(r.computeStrides)(t), this.dataId = n, this.id = s, this.rankType = this.rank < 5 ? this.rank.toString() : "higher"
      }
      get rank() {
        return this.shape.length
      }
      async buffer() {
        const t = await this.data();
        return p.buffer(this.shape, this.dtype, t)
      }
      bufferSync() {
        return p.buffer(this.shape, this.dtype, this.dataSync())
      }
      async array() {
        const t = await this.data();
        return Object(r.toNestedArray)(this.shape, t)
      }
      arraySync() {
        return Object(r.toNestedArray)(this.shape, this.dataSync())
      }
      async data() {
        this.throwIfDisposed();
        const t = d().read(this.dataId);
        if ("string" === this.dtype) {
          const e = await t;
          try {
            return e.map(t => r.decodeString(t))
          } catch (t) {
            throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().")
          }
        }
        return t
      }
      dataSync() {
        this.throwIfDisposed();
        const t = d().readSync(this.dataId);
        if ("string" === this.dtype) try {
          return t.map(t => r.decodeString(t))
        } catch (t) {
          throw new Error("Failed to decode the string bytes into utf-8. To get the original bytes, call tensor.bytes().")
        }
        return t
      }
      async bytes() {
        this.throwIfDisposed();
        const t = await d().read(this.dataId);
        return "string" === this.dtype ? t : new Uint8Array(t.buffer)
      }
      dispose() {
        this.isDisposed || (d().disposeTensor(this), this.isDisposedInternal = !0)
      }
      get isDisposed() {
        return this.isDisposedInternal
      }
      throwIfDisposed() {
        if (this.isDisposed) throw new Error("Tensor is disposed.")
      }
      print(t = !1) {
        return p.print(this, t)
      }
      clone() {
        return this.throwIfDisposed(), p.clone(this)
      }
      toString(t = !1) {
        return o(this.dataSync(), this.shape, this.dtype, t)
      }
      cast(t) {
        return this.throwIfDisposed(), p.cast(this, t)
      }
      variable(t = !0, e, n) {
        return this.throwIfDisposed(), d().makeVariable(this, t, e, n)
      }
    }
    Object.defineProperty(y, Symbol.hasInstance, {
      value: t => !!t && null != t.dataId && null != t.shape && null != t.dtype
    });
    class w extends y {
      constructor(t, e, n, r) {
        super(t.shape, t.dtype, t.dataId, r), this.trainable = e, this.name = n
      }
      assign(t) {
        if (t.dtype !== this.dtype) throw new Error(`dtype of the new value (${t.dtype}) and ` + `previous value (${this.dtype}) must match`);
        if (!r.arraysEqual(t.shape, this.shape)) throw new Error(`shape of the new value (${t.shape}) and ` + `previous value (${this.shape}) must match`);
        d().disposeTensor(this), this.dataId = t.dataId, d().incRef(this, null)
      }
      dispose() {
        d().disposeVariable(this), this.isDisposedInternal = !0
      }
    }
    Object.defineProperty(w, Symbol.hasInstance, {
      value: t => t instanceof y && null != t.assign && t.assign instanceof Function
    })
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "makeTypesMatch", (function () {
      return a
    })), n.d(e, "assertTypesMatch", (function () {
      return o
    })), n.d(e, "isTensorInList", (function () {
      return u
    })), n.d(e, "getTensorsInContainer", (function () {
      return c
    }));
    var r = n(7),
      s = n(31),
      i = n(1);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function a(t, e) {
      if (t.dtype === e.dtype) return [t, e];
      const n = Object(s.b)(t.dtype, e.dtype);
      return [t.cast(n), e.cast(n)]
    }

    function o(t, e) {
      Object(i.assert)(t.dtype === e.dtype, () => `The dtypes of the first(${t.dtype}) and` + ` second(${e.dtype}) input must match`)
    }

    function u(t, e) {
      return e.some(e => e.id === t.id)
    }

    function c(t) {
      const e = [];
      return function t(e, n, s) {
        if (null == e) return;
        if (e instanceof r.a) return void n.push(e);
        if (i = e, !Array.isArray(i) && "object" != typeof i) return;
        var i;
        const a = e;
        for (const e in a) {
          const r = a[e];
          s.has(r) || (s.add(r), t(r, n, s))
        }
      }(t, e, new Set), e
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return s
    })), n.d(e, "b", (function () {
      return i
    })), n.d(e, "c", (function () {
      return o
    }));
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = "tfjsflags";
    class s {
      constructor(t) {
        this.global = t, this.flags = {}, this.flagRegistry = {}, this.urlFlags = {}, this.populateURLFlags()
      }
      setPlatform(t, e) {
        null != this.platform && console.warn(`Platform ${this.platformName} has already been set. ` + `Overwriting the platform with ${e}.`), this.platformName = t, this.platform = e
      }
      registerFlag(t, e, n) {
        if (this.flagRegistry[t] = {
            evaluationFn: e,
            setHook: n
          }, null != this.urlFlags[t]) {
          const e = this.urlFlags[t];
          console.warn(`Setting feature override from URL ${t}: ${e}.`), this.set(t, e)
        }
      }
      async getAsync(t) {
        return t in this.flags ? this.flags[t] : (this.flags[t] = await this.evaluateFlag(t), this.flags[t])
      }
      get(t) {
        if (t in this.flags) return this.flags[t];
        const e = this.evaluateFlag(t);
        if (e instanceof Promise) throw new Error(`Flag ${t} cannot be synchronously evaluated. ` + "Please use getAsync() instead.");
        return this.flags[t] = e, this.flags[t]
      }
      getNumber(t) {
        return this.get(t)
      }
      getBool(t) {
        return this.get(t)
      }
      getFlags() {
        return this.flags
      }
      get features() {
        return this.flags
      }
      set(t, e) {
        if (null == this.flagRegistry[t]) throw new Error(`Cannot set flag ${t} as it has not been registered.`);
        this.flags[t] = e, null != this.flagRegistry[t].setHook && this.flagRegistry[t].setHook(e)
      }
      evaluateFlag(t) {
        if (null == this.flagRegistry[t]) throw new Error(`Cannot evaluate flag '${t}': no evaluation function found.`);
        return this.flagRegistry[t].evaluationFn()
      }
      setFlags(t) {
        this.flags = Object.assign({}, t)
      }
      reset() {
        this.flags = {}, this.urlFlags = {}, this.populateURLFlags()
      }
      populateURLFlags() {
        if (void 0 === this.global || void 0 === this.global.location || void 0 === this.global.location.search) return;
        const t = function (t) {
          const e = {};
          return t.replace(/[?&]([^=?&]+)(?:=([^&]*))?/g, (t, ...n) => (function (t, e, n) {
            t[decodeURIComponent(e)] = decodeURIComponent(n || "")
          }(e, n[0], n[1]), n.join("="))), e
        }(this.global.location.search);
        if (r in t) {
          t[r].split(",").forEach(t => {
            const [e, n] = t.split(":");
            this.urlFlags[e] = function (t, e) {
              if ("true" === (e = e.toLowerCase()) || "false" === e) return "true" === e;
              if (`${+e}` === e) return +e;
              throw new Error(`Could not parse value flag value ${e} for flag ${t}.`)
            }(e, n)
          })
        }
      }
    }

    function i() {
      return a
    }
    let a = null;

    function o(t) {
      a = t
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(28),
      s = n(65),
      i = n(48),
      a = n(120),
      o = n(41);

    function u(t) {
      return t
    }

    function c(t, e) {
      for (var n = 0; n < t.length; ++n) e[n] = 255 & t.charCodeAt(n);
      return e
    }
    e.newBlob = function (t, n) {
      e.checkSupport("blob");
      try {
        return new Blob([t], {
          type: n
        })
      } catch (e) {
        try {
          var r = new(self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
          return r.append(t), r.getBlob(n)
        } catch (t) {
          throw new Error("Bug : can't construct the Blob.")
        }
      }
    };
    var l = {
      stringifyByChunk: function (t, e, n) {
        var r = [],
          s = 0,
          i = t.length;
        if (i <= n) return String.fromCharCode.apply(null, t);
        for (; s < i;) "array" === e || "nodebuffer" === e ? r.push(String.fromCharCode.apply(null, t.slice(s, Math.min(s + n, i)))) : r.push(String.fromCharCode.apply(null, t.subarray(s, Math.min(s + n, i)))), s += n;
        return r.join("")
      },
      stringifyByChar: function (t) {
        for (var e = "", n = 0; n < t.length; n++) e += String.fromCharCode(t[n]);
        return e
      },
      applyCanBeUsed: {
        uint8array: function () {
          try {
            return r.uint8array && 1 === String.fromCharCode.apply(null, new Uint8Array(1)).length
          } catch (t) {
            return !1
          }
        }(),
        nodebuffer: function () {
          try {
            return r.nodebuffer && 1 === String.fromCharCode.apply(null, i.allocBuffer(1)).length
          } catch (t) {
            return !1
          }
        }()
      }
    };

    function h(t) {
      var n = 65536,
        r = e.getTypeOf(t),
        s = !0;
      if ("uint8array" === r ? s = l.applyCanBeUsed.uint8array : "nodebuffer" === r && (s = l.applyCanBeUsed.nodebuffer), s)
        for (; n > 1;) try {
          return l.stringifyByChunk(t, r, n)
        } catch (t) {
          n = Math.floor(n / 2)
        }
      return l.stringifyByChar(t)
    }

    function d(t, e) {
      for (var n = 0; n < t.length; n++) e[n] = t[n];
      return e
    }
    e.applyFromCharCode = h;
    var p = {};
    p.string = {
      string: u,
      array: function (t) {
        return c(t, new Array(t.length))
      },
      arraybuffer: function (t) {
        return p.string.uint8array(t).buffer
      },
      uint8array: function (t) {
        return c(t, new Uint8Array(t.length))
      },
      nodebuffer: function (t) {
        return c(t, i.allocBuffer(t.length))
      }
    }, p.array = {
      string: h,
      array: u,
      arraybuffer: function (t) {
        return new Uint8Array(t).buffer
      },
      uint8array: function (t) {
        return new Uint8Array(t)
      },
      nodebuffer: function (t) {
        return i.newBufferFrom(t)
      }
    }, p.arraybuffer = {
      string: function (t) {
        return h(new Uint8Array(t))
      },
      array: function (t) {
        return d(new Uint8Array(t), new Array(t.byteLength))
      },
      arraybuffer: u,
      uint8array: function (t) {
        return new Uint8Array(t)
      },
      nodebuffer: function (t) {
        return i.newBufferFrom(new Uint8Array(t))
      }
    }, p.uint8array = {
      string: h,
      array: function (t) {
        return d(t, new Array(t.length))
      },
      arraybuffer: function (t) {
        return t.buffer
      },
      uint8array: u,
      nodebuffer: function (t) {
        return i.newBufferFrom(t)
      }
    }, p.nodebuffer = {
      string: h,
      array: function (t) {
        return d(t, new Array(t.length))
      },
      arraybuffer: function (t) {
        return p.nodebuffer.uint8array(t).buffer
      },
      uint8array: function (t) {
        return d(t, new Uint8Array(t.length))
      },
      nodebuffer: u
    }, e.transformTo = function (t, n) {
      if (n || (n = ""), !t) return n;
      e.checkSupport(t);
      var r = e.getTypeOf(n);
      return p[r][t](n)
    }, e.getTypeOf = function (t) {
      return "string" == typeof t ? "string" : "[object Array]" === Object.prototype.toString.call(t) ? "array" : r.nodebuffer && i.isBuffer(t) ? "nodebuffer" : r.uint8array && t instanceof Uint8Array ? "uint8array" : r.arraybuffer && t instanceof ArrayBuffer ? "arraybuffer" : void 0
    }, e.checkSupport = function (t) {
      if (!r[t.toLowerCase()]) throw new Error(t + " is not supported by this platform")
    }, e.MAX_VALUE_16BITS = 65535, e.MAX_VALUE_32BITS = -1, e.pretty = function (t) {
      var e, n, r = "";
      for (n = 0; n < (t || "").length; n++) r += "\\x" + ((e = t.charCodeAt(n)) < 16 ? "0" : "") + e.toString(16).toUpperCase();
      return r
    }, e.delay = function (t, e, n) {
      a((function () {
        t.apply(n || null, e || [])
      }))
    }, e.inherits = function (t, e) {
      var n = function () {};
      n.prototype = e.prototype, t.prototype = new n
    }, e.extend = function () {
      var t, e, n = {};
      for (t = 0; t < arguments.length; t++)
        for (e in arguments[t]) arguments[t].hasOwnProperty(e) && void 0 === n[e] && (n[e] = arguments[t][e]);
      return n
    }, e.prepareContent = function (t, n, i, a, u) {
      return o.Promise.resolve(n).then((function (t) {
        return r.blob && (t instanceof Blob || -1 !== ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(t))) && "undefined" != typeof FileReader ? new o.Promise((function (e, n) {
          var r = new FileReader;
          r.onload = function (t) {
            e(t.target.result)
          }, r.onerror = function (t) {
            n(t.target.error)
          }, r.readAsArrayBuffer(t)
        })) : t
      })).then((function (n) {
        var l, h = e.getTypeOf(n);
        return h ? ("arraybuffer" === h ? n = e.transformTo("uint8array", n) : "string" === h && (u ? n = s.decode(n) : i && !0 !== a && (n = c(l = n, r.uint8array ? new Uint8Array(l.length) : new Array(l.length)))), n) : o.Promise.reject(new Error("Can't read the data of '" + t + "'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))
      }))
    }
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      n.d(e, "f", (function () {
        return u
      })), n.d(e, "e", (function () {
        return c
      })), n.d(e, "a", (function () {
        return p
      })), n.d(e, "b", (function () {
        return f
      })), n.d(e, "d", (function () {
        return m
      })), n.d(e, "c", (function () {
        return g
      })), n.d(e, "g", (function () {
        return b
      }));
      var r = n(15),
        s = n(18),
        i = n(1),
        a = n(45);
      /**
       * @license
       * Copyright 2018 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      const o = 4;
      async function u(t, e) {
        const n = [],
          r = [],
          s = Array.isArray(t) ? t.map(t => t.name) : Object.keys(t);
        for (let i = 0; i < s.length; ++i) {
          const a = s[i],
            u = Array.isArray(t) ? t[i].tensor : t[a];
          if ("float32" !== u.dtype && "int32" !== u.dtype && "bool" !== u.dtype && "string" !== u.dtype && "complex64" !== u.dtype) throw new Error(`Unsupported dtype in weight '${a}': ${u.dtype}`);
          const c = {
            name: a,
            shape: u.shape,
            dtype: u.dtype
          };
          if ("string" === u.dtype) {
            const t = new Promise(async t => {
              const e = await u.bytes(),
                n = e.reduce((t, e) => t + e.length, 0) + o * e.length,
                r = new Uint8Array(n);
              let s = 0;
              for (let t = 0; t < e.length; t++) {
                const n = e[t],
                  i = new Uint8Array(new Uint32Array([n.length]).buffer);
                r.set(i, s), s += o, r.set(n, s), s += n.length
              }
              t(r)
            });
            r.push(t)
          } else r.push(u.data());
          null != e && (c.group = e), n.push(c)
        }
        return {
          data: l(await Promise.all(r)),
          specs: n
        }
      }

      function c(t, e) {
        const n = {};
        let u, c = 0;
        for (const l of e) {
          const e = l.name,
            h = l.dtype,
            d = l.shape,
            p = Object(i.sizeFromShape)(d);
          let f;
          if ("quantization" in l) {
            const n = l.quantization;
            if ("uint8" === n.dtype || "uint16" === n.dtype) {
              if (!("min" in n && "scale" in n)) throw new Error(`Weight ${l.name} with quantization ${n.dtype} ` + "doesn't have corresponding metadata min and scale.")
            } else {
              if ("float16" !== n.dtype) throw new Error(`Weight ${l.name} has unknown ` + `quantization dtype ${n.dtype}. ` + "Supported quantization dtypes are: 'uint8', 'uint16', and 'float16'.");
              if ("float32" !== h) throw new Error(`Weight ${l.name} is quantized with ${n.dtype} ` + `which only supports weights of type float32 not ${h}.`)
            }
            const r = a.a[n.dtype],
              s = t.slice(c, c + p * r),
              i = "uint8" === n.dtype ? new Uint8Array(s) : new Uint16Array(s);
            if ("float32" === h)
              if ("uint8" === n.dtype || "uint16" === n.dtype) {
                f = new Float32Array(i.length);
                for (let t = 0; t < i.length; t++) {
                  const e = i[t];
                  f[t] = e * n.scale + n.min
                }
              } else {
                if ("float16" !== n.dtype) throw new Error(`Unsupported quantization type ${n.dtype} ` + "for weight type float32.");
                void 0 === u && (u = y()), f = u(i)
              }
            else {
              if ("int32" !== h) throw new Error(`Unsupported dtype in weight '${e}': ${h}`);
              if ("uint8" !== n.dtype && "uint16" !== n.dtype) throw new Error(`Unsupported quantization type ${n.dtype} ` + "for weight type int32.");
              f = new Int32Array(i.length);
              for (let t = 0; t < i.length; t++) {
                const e = i[t];
                f[t] = Math.round(e * n.scale + n.min)
              }
            }
            c += p * r
          } else if ("string" === h) {
            const e = Object(i.sizeFromShape)(l.shape);
            f = [];
            for (let n = 0; n < e; n++) {
              const e = new Uint32Array(t.slice(c, c + o))[0];
              c += o;
              const n = new Uint8Array(t.slice(c, c + e));
              f.push(n), c += e
            }
          } else {
            const i = a.a[h],
              o = t.slice(c, c + p * i);
            if ("float32" === h) f = new Float32Array(o);
            else if ("int32" === h) f = new Int32Array(o);
            else if ("bool" === h) f = new Uint8Array(o);
            else {
              if ("complex64" !== h) throw new Error(`Unsupported dtype in weight '${e}': ${h}`); {
                f = new Float32Array(o);
                const t = new Float32Array(f.length / 2),
                  i = new Float32Array(f.length / 2);
                for (let e = 0; e < t.length; e++) t[e] = f[2 * e], i[e] = f[2 * e + 1];
                const a = Object(s.a)(t, d, "float32"),
                  u = Object(s.a)(i, d, "float32");
                n[e] = Object(r.a)(a, u)
              }
            }
            c += p * i
          }
          "complex64" !== h && (n[e] = Object(s.a)(f, d, h))
        }
        return n
      }

      function l(t) {
        if (null === t) throw new Error(`Invalid input value: ${JSON.stringify(t)}`);
        let e = 0;
        const n = [];
        t.forEach(t => {
          if (e += t.byteLength, n.push(t.byteLength === t.buffer.byteLength ? t : new t.constructor(t)), !(t instanceof Float32Array || t instanceof Int32Array || t instanceof Uint8Array)) throw new Error(`Unsupported TypedArray subtype: ${t.constructor.name}`)
        });
        const r = new Uint8Array(e);
        let s = 0;
        return n.forEach(t => {
          r.set(new Uint8Array(t.buffer), s), s += t.byteLength
        }), r.buffer
      }
      const h = void 0 !== t && ("undefined" == typeof Blob || "undefined" == typeof atob || "undefined" == typeof btoa);

      function d(e) {
        return h ? t.byteLength(e) : new Blob([e]).size
      }

      function p(e) {
        if (h) return t.from(e).toString("base64");
        const n = new Uint8Array(e);
        let r = "";
        for (let t = 0, e = n.length; t < e; t++) r += String.fromCharCode(n[t]);
        return btoa(r)
      }

      function f(e) {
        if (h) {
          const n = t.from(e, "base64");
          return n.buffer.slice(n.byteOffset, n.byteOffset + n.byteLength)
        }
        const n = atob(e),
          r = new Uint8Array(n.length);
        for (let t = 0; t < n.length; ++t) r.set([n.charCodeAt(t)], t);
        return r.buffer
      }

      function m(t) {
        if (1 === t.length) return t[0];
        let e = 0;
        t.forEach(t => {
          e += t.byteLength
        });
        const n = new Uint8Array(e);
        let r = 0;
        return t.forEach(t => {
          n.set(new Uint8Array(t), r), r += t.byteLength
        }), n.buffer
      }

      function g(t) {
        for (t = t.trim(); t.endsWith("/");) t = t.slice(0, t.length - 1);
        const e = t.split("/");
        return e[e.length - 1]
      }

      function b(t) {
        if (t.modelTopology instanceof ArrayBuffer) throw new Error("Expected JSON model topology, received ArrayBuffer.");
        return {
          dateSaved: new Date,
          modelTopologyType: "JSON",
          modelTopologyBytes: null == t.modelTopology ? 0 : d(JSON.stringify(t.modelTopology)),
          weightSpecsBytes: null == t.weightSpecs ? 0 : d(JSON.stringify(t.weightSpecs)),
          weightDataBytes: null == t.weightData ? 0 : t.weightData.byteLength
        }
      }

      function y() {
        const t = function () {
            const t = t => {
                let e = t << 13,
                  n = 0;
                for (; 0 == (8388608 & e);) n -= 8388608, e <<= 1;
                return e &= -8388609, n += 947912704, e | n
              },
              e = new Uint32Array(2048);
            e[0] = 0;
            for (let n = 1; n < 1024; n++) e[n] = t(n);
            for (let t = 1024; t < 2048; t++) e[t] = 939524096 + (t - 1024 << 13);
            return e
          }(),
          e = function () {
            const t = new Uint32Array(64);
            t[0] = 0, t[31] = 1199570944, t[32] = 2147483648, t[63] = 3347054592;
            for (let e = 1; e < 31; e++) t[e] = e << 23;
            for (let e = 33; e < 63; e++) t[e] = 2147483648 + (e - 32 << 23);
            return t
          }(),
          n = function () {
            const t = new Uint32Array(64);
            for (let e = 0; e < 64; e++) t[e] = 1024;
            return t[0] = t[32] = 0, t
          }();
        return r => {
          const s = new ArrayBuffer(4 * r.length),
            i = new Uint32Array(s);
          for (let s = 0; s < r.length; s++) {
            const a = r[s],
              o = t[n[a >> 10] + (1023 & a)] + e[a >> 10];
            i[s] = o
          }
          return new Float32Array(s)
        }
      }
    }).call(this, n(29).Buffer)
  }, , function (t, e, n) {
    "use strict";
    var r, s = n(0),
      i = n(26),
      a = n(24);

    function o(t) {
      return t instanceof s.r ? {
        value: t.clone(),
        recurse: !1
      } : Object(a.e)(t) ? {
        value: null,
        recurse: !0
      } : {
        value: t,
        recurse: !1
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    class u {
      constructor(t) {
        if (this.capacity = t, this.begin = 0, this.end = 0, null == t) throw new RangeError("Can't create a ring buffer of unknown capacity.");
        if (t < 1) throw new RangeError("Can't create ring buffer of capacity < 1.");
        this.data = new Array(t), this.doubledCapacity = 2 * t
      }
      wrap(t) {
        for (; t < 0;) t += this.doubledCapacity;
        return t % this.doubledCapacity
      }
      get(t) {
        if (t < 0) throw new RangeError("Can't get item at a negative index.");
        return this.data[t % this.capacity]
      }
      set(t, e) {
        if (t < 0) throw new RangeError("Can't set item at a negative index.");
        this.data[t % this.capacity] = e
      }
      length() {
        let t = this.end - this.begin;
        return t < 0 && (t = this.doubledCapacity + t), t
      }
      isFull() {
        return this.length() === this.capacity
      }
      isEmpty() {
        return 0 === this.length()
      }
      push(t) {
        if (this.isFull()) throw new RangeError("Ring buffer is full.");
        this.set(this.end, t), this.end = this.wrap(this.end + 1)
      }
      pushAll(t) {
        for (const e of t) this.push(e)
      }
      pop() {
        if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
        this.end = this.wrap(this.end - 1);
        const t = this.get(this.end);
        return this.set(this.end, void 0), t
      }
      unshift(t) {
        if (this.isFull()) throw new RangeError("Ring buffer is full.");
        this.begin = this.wrap(this.begin - 1), this.set(this.begin, t)
      }
      shift() {
        if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
        const t = this.get(this.begin);
        return this.set(this.begin, void 0), this.begin = this.wrap(this.begin + 1), t
      }
      shuffleExcise(t) {
        if (this.isEmpty()) throw new RangeError("Ring buffer is empty.");
        const e = this.wrap(this.begin + t),
          n = this.get(e);
        return this.set(e, this.pop()), n
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    class c extends u {
      constructor() {
        super(c.INITIAL_CAPACITY)
      }
      isFull() {
        return !1
      }
      push(t) {
        super.isFull() && this.expand(), super.push(t)
      }
      unshift(t) {
        super.isFull() && this.expand(), super.unshift(t)
      }
      expand() {
        const t = 2 * this.capacity,
          e = new Array(t),
          n = this.length();
        for (let t = 0; t < n; t++) e[t] = this.get(this.wrap(this.begin + t));
        this.data = e, this.capacity = t, this.doubledCapacity = 2 * this.capacity, this.begin = 0, this.end = n
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    function l(t) {
      return new m(t)
    }

    function h(t) {
      return new g(t)
    }

    function d(t, e) {
      return new E(t, e)
    }

    function p(t, e = r.FAIL) {
      return new I(t, e)
    }
    c.INITIAL_CAPACITY = 32, n.d(e, "f", (function () {
      return l
    })), n.d(e, "e", (function () {
      return h
    })), n.d(e, "d", (function () {
      return d
    })), n.d(e, "g", (function () {
      return p
    })), n.d(e, "a", (function () {
      return f
    })), n.d(e, "b", (function () {
      return k
    })), n.d(e, "c", (function () {
      return r
    }));
    class f {
      async toArray() {
        const t = [];
        let e = await this.next();
        for (; !e.done;) t.push(e.value), e = await this.next();
        return t
      }
      async toArrayForTest() {
        const t = this.prefetch(100),
          e = [];
        let n = await t.next();
        for (; !n.done;) e.push(n.value), n = await t.next();
        return e
      }
      async resolveFully() {
        let t = await this.next();
        for (; !t.done;) t = await this.next()
      }
      async resolveWhile(t) {
        let e = await this.next(),
          n = t(e.value);
        for (; !e.done && n;) e = await this.next(), n = t(e.value)
      }
      handleErrors(t) {
        return new S(this, t)
      }
      filter(t) {
        return new x(this, t)
      }
      map(t) {
        return new O(this, t)
      }
      mapAsync(t) {
        return new _(this, t)
      }
      serialMapAsync(t) {
        return new _(this, t).serial()
      }
      flatmap(t) {
        return new C(this, t)
      }
      async forEachAsync(t) {
        return this.map(t).resolveFully()
      }
      async serialForEach(t) {
        return this.serialMapAsync(t).resolveWhile(t => !0 === t)
      }
      rowMajorBatch(t, e = !0) {
        return new v(this, t, e)
      }
      columnMajorBatch(t, e = !0, n = a.f) {
        return this.rowMajorBatch(t, e).map(t => Object(a.d)(t, n))
      }
      concatenate(t, e) {
        return new E(l([this, t]), e)
      }
      take(t) {
        return t < 0 || null == t ? this : new w(this, t)
      }
      skip(t) {
        return t < 0 || null == t ? this : new y(this, t)
      }
      prefetch(t) {
        return new T(this, t)
      }
      shuffle(t, e) {
        return new A(this, t, e)
      }
      serial() {
        return new b(this)
      }
    }
    class m extends f {
      constructor(t) {
        super(), this.items = t, this.trav = 0
      }
      summary() {
        return `Array of ${this.items.length} items`
      }
      async next() {
        if (this.trav >= this.items.length) return {
          value: null,
          done: !0
        };
        const t = this.items[this.trav];
        return this.trav++, {
          value: (e = t, Object(a.b)(e, o)),
          done: !1
        };
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         *
         * =============================================================================
         */
        var e
      }
    }
    class g extends f {
      constructor(t) {
        super(), this.nextFn = t
      }
      summary() {
        return "Function call"
      }
      async next() {
        try {
          return this.nextFn()
        } catch (t) {
          throw t.message = `Error thrown while iterating through a dataset: ${t.message}`, t
        }
      }
    }
    class b extends f {
      constructor(t) {
        super(), this.upstream = t, this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      summary() {
        return `${this.upstream.summary()} -> Serial`
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      async serialNext() {
        return this.upstream.next()
      }
    }
    class y extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.maxCount = e, this.count = 0, this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      summary() {
        return `${this.upstream.summary()} -> Skip`
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      async serialNext() {
        for (; this.count++ < this.maxCount;) {
          const t = await this.upstream.next();
          if (t.done) return t;
          s.pb(t.value)
        }
        return this.upstream.next()
      }
    }
    class w extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.maxCount = e, this.count = 0
      }
      summary() {
        return `${this.upstream.summary()} -> Take`
      }
      async next() {
        return this.count++ >= this.maxCount ? {
          value: null,
          done: !0
        } : this.upstream.next()
      }
    }
    class v extends f {
      constructor(t, e, n = !0) {
        super(), this.upstream = t, this.batchSize = e, this.enableSmallLastBatch = n, this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      summary() {
        return `${this.upstream.summary()} -> RowMajorBatch`
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      async serialNext() {
        const t = [];
        for (; t.length < this.batchSize;) {
          const e = await this.upstream.next();
          if (e.done) return this.enableSmallLastBatch && t.length > 0 ? {
            value: t,
            done: !1
          } : {
            value: null,
            done: !0
          };
          t.push(e.value)
        }
        return {
          value: t,
          done: !1
        }
      }
    }
    class x extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.predicate = e, this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      summary() {
        return `${this.upstream.summary()} -> Filter`
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      async serialNext() {
        for (;;) {
          const t = await this.upstream.next();
          if (t.done || this.predicate(t.value)) return t;
          s.pb(t.value)
        }
      }
    }
    class O extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.transform = e
      }
      summary() {
        return `${this.upstream.summary()} -> Map`
      }
      async next() {
        const t = await this.upstream.next();
        if (t.done) return {
          value: null,
          done: !0
        };
        const e = s.Ad.getTensorsInContainer(t.value),
          n = this.transform(t.value),
          r = s.Ad.getTensorsInContainer(n);
        for (const t of e) s.Ad.isTensorInList(t, r) || t.dispose();
        return {
          value: n,
          done: !1
        }
      }
    }
    class S extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.handler = e, this.count = 0, this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      summary() {
        return `${this.upstream.summary()} -> handleErrors`
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      async serialNext() {
        for (;;) try {
          return await this.upstream.next()
        } catch (t) {
          if (!this.handler(t)) return {
            value: null,
            done: !0
          }
        }
      }
    }
    class _ extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.transform = e
      }
      summary() {
        return `${this.upstream.summary()} -> AsyncMap`
      }
      async next() {
        const t = await this.upstream.next();
        if (t.done) return {
          value: null,
          done: !0
        };
        const e = s.Ad.getTensorsInContainer(t.value),
          n = await this.transform(t.value),
          r = s.Ad.getTensorsInContainer(n);
        for (const t of e) s.Ad.isTensorInList(t, r) || t.dispose();
        return {
          value: n,
          done: !1
        }
      }
    }
    class k extends f {
      constructor() {
        super(), this.outputQueue = new c, this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      async serialNext() {
        for (; 0 === this.outputQueue.length();)
          if (!await this.pump()) return {
            value: null,
            done: !0
          };
        return {
          value: this.outputQueue.shift(),
          done: !1
        }
      }
    }
    class C extends k {
      constructor(t, e) {
        super(), this.upstream = t, this.transform = e
      }
      summary() {
        return `${this.upstream.summary()} -> Flatmap`
      }
      async pump() {
        const t = await this.upstream.next();
        if (t.done) return !1;
        const e = s.Ad.getTensorsInContainer(t.value),
          n = this.transform(t.value),
          r = s.Ad.getTensorsInContainer(n);
        this.outputQueue.pushAll(n);
        for (const t of e) s.Ad.isTensorInList(t, r) || t.dispose();
        return !0
      }
    }
    class E extends f {
      constructor(t, e) {
        super(), this.baseErrorHandler = e, this.lastRead = null, this.iterator = null, this.moreIterators = t
      }
      summary() {
        return "TODO: fill in upstream of chained summaries -> Chained"
      }
      async next() {
        return this.lastRead = this.readFromChain(this.lastRead), this.lastRead
      }
      async readFromChain(t) {
        if (await t, null == this.iterator) {
          const t = await this.moreIterators.next();
          if (t.done) return {
            value: null,
            done: !0
          };
          this.iterator = t.value, null != this.baseErrorHandler && (this.iterator = this.iterator.handleErrors(this.baseErrorHandler))
        }
        const e = await this.iterator.next();
        return e.done ? (this.iterator = null, this.readFromChain(t)) : e
      }
    }! function (t) {
      t[t.FAIL = 0] = "FAIL", t[t.SHORTEST = 1] = "SHORTEST", t[t.LONGEST = 2] = "LONGEST"
    }(r || (r = {}));
    class I extends f {
      constructor(t, e = r.FAIL) {
        super(), this.iterators = t, this.mismatchMode = e, this.count = 0, this.currentPromise = null
      }
      summary() {
        return "{TODO: fill in upstream of zip summaries} -> Zip"
      }
      async nextState(t) {
        await t;
        let e = 0,
          n = 0;
        const s = await Object(a.c)(this.iterators, (function (t) {
          if (t instanceof f) {
            return {
              value: t.next().then(t => (e++, t.done && n++, t.value)),
              recurse: !1
            }
          }
          return {
            value: null,
            recurse: !0
          }
        }));
        if (e === n) return {
          value: null,
          done: !0
        };
        if (n > 0) switch (this.mismatchMode) {
          case r.FAIL:
            throw new Error("Zipped streams should have the same length. " + `Mismatched at element ${this.count}.`);
          case r.SHORTEST:
            return {
              value: null, done: !0
            };
          case r.LONGEST:
        }
        return this.count++, {
          value: s,
          done: !1
        }
      }
      async next() {
        return this.currentPromise = this.nextState(this.currentPromise), this.currentPromise
      }
    }
    class T extends f {
      constructor(t, e) {
        super(), this.upstream = t, this.bufferSize = e, this.buffer = new u(e)
      }
      summary() {
        return `${this.upstream.summary()} -> Prefetch`
      }
      refill() {
        for (; !this.buffer.isFull();) {
          const t = this.upstream.next();
          this.buffer.push(t)
        }
      }
      next() {
        return this.refill(), this.buffer.shift()
      }
    }
    class A extends T {
      constructor(t, e, n) {
        super(t, e), this.upstream = t, this.windowSize = e, this.upstreamExhausted = !1, this.random = i.alea(n || s.Jd.now().toString()), this.lastRead = Promise.resolve({
          value: null,
          done: !1
        })
      }
      async next() {
        return this.lastRead = this.lastRead.then(() => this.serialNext()), this.lastRead
      }
      randomInt(t) {
        return Math.floor(this.random() * t)
      }
      chooseIndex() {
        return this.randomInt(this.buffer.length())
      }
      async serialNext() {
        for (this.upstreamExhausted || this.refill(); !this.buffer.isEmpty();) {
          const t = this.chooseIndex(),
            e = await this.buffer.shuffleExcise(t);
          if (!e.done) return this.refill(), e;
          this.upstreamExhausted = !0
        }
        return {
          value: null,
          done: !0
        }
      }
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return i
    }));
    var r = n(6),
      s = n(1);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function i(t, e, n, i) {
      if (null == i && (i = Object(s.inferDtype)(t)), "complex64" === i) throw new Error("Cannot construct a complex64 tensor directly. Please use tf.complex(real, imag).");
      if (!Object(s.isTypedArray)(t) && !Array.isArray(t) && "number" != typeof t && "boolean" != typeof t && "string" != typeof t) throw new Error("values passed to tensor(values) must be a number/boolean/string or an array of numbers/booleans/strings, or a TypedArray");
      if (null != e) {
        Object(s.assertNonNegativeIntegerDimensions)(e);
        const t = Object(s.sizeFromShape)(e),
          r = Object(s.sizeFromShape)(n);
        Object(s.assert)(t === r, () => `Based on the provided shape, [${e}], the tensor should have ` + `${t} values but has ${r}`);
        for (let t = 0; t < n.length; ++t) {
          const r = n[t],
            i = t !== n.length - 1 || r !== Object(s.sizeFromShape)(e.slice(t));
          Object(s.assert)(n[t] === e[t] || !i, () => "Error creating a new Tensor. Inferred shape " + `(${n}) does not match the provided ` + `shape (${e}). `)
        }
      }
      return Object(s.isTypedArray)(t) || Array.isArray(t) || (t = [t]), e = e || n, t = "string" !== i ? Object(s.toTypedArray)(t, i) : Object(s.flatten)(t, [], !0), r.a.makeTensor(t, e, i)
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return u
    }));
    var r = n(6),
      s = n(4),
      i = n(2),
      a = n(1),
      o = n(5);
    const u = Object(o.a)({
      complex_:
        /**
         * @license
         * Copyright 2020 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e) {
          const n = Object(i.a)(t, "real", "complex"),
            o = Object(i.a)(e, "imag", "complex");
          a.assertShapesMatch(n.shape, o.shape, `real and imag shapes, ${n.shape} and ${o.shape}, ` + "must match in call to tf.complex().");
          const u = {
            real: n,
            imag: o
          };
          return r.a.runKernelFunc(t => t.complex(n, o), u, null, s.y)
        }
    })
  }, , function (t, e, n) {
    "use strict";
    (function (t) {
      n.d(e, "a", (function () {
        return i
      }));
      var r = "undefined" != typeof window && window,
        s = "undefined" != typeof self && "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope && self,
        i = r || void 0 !== t && t || s
    }).call(this, n(25))
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return i
    }));
    var r = n(2),
      s = n(14);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function i(t, e, n) {
      const i = Object(r.c)(t, n);
      return Object(s.a)(t, e, i, n)
    }
  }, , function (t, e, n) {
    "use strict";
    (function (t) {
      n.d(e, "a", (function () {
        return S
      })), n.d(e, "i", (function () {
        return k
      })), n.d(e, "c", (function () {
        return C
      })), n.d(e, "f", (function () {
        return E
      })), n.d(e, "e", (function () {
        return A
      })), n.d(e, "d", (function () {
        return N
      })), n.d(e, "k", (function () {
        return R
      })), n.d(e, "g", (function () {
        return j
      })), n.d(e, "h", (function () {
        return D
      })), n.d(e, "j", (function () {
        return F
      })), n.d(e, "b", (function () {
        return M
      }));
      var r = n(0),
        s = n(27),
        i = n(34),
        a = n(3),
        o = n(83),
        u = n(84),
        c = n(85),
        l = n(86),
        h = n(87),
        d = n(88),
        p = n(89),
        f = n(90),
        m = n(91),
        g = n(92),
        b = n(93),
        y = n(94),
        w = n(95),
        v = n(96),
        x = n(97),
        O = n(98);
      /**
       * @license
       * Copyright 2018 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      class S {
        static get Instance() {
          return this._instance || (this._instance = new this)
        }
        constructor() {
          const t = [].concat(...[o, u, c, l, h, d, p, g, m, f, b, y, w, v, x, O].map(t => t.json));
          this.opMappers = t.reduce((t, e) => (t[e.tfOpName] = e, t), {})
        }
        transformGraph(t, e = {}) {
          const n = t.node,
            r = [],
            s = [],
            i = n.reduce((t, e) => (t[e.name] = this.mapNode(e), e.op.startsWith("Placeholder") && r.push(t[e.name]), "Const" === e.op && s.push(t[e.name]), t), {});
          let o = [];
          const u = [];
          let c = {},
            l = {};
          null != e && (c = this.mapSignatureEntries(e.inputs), l = this.mapSignatureEntries(e.outputs));
          const h = Object.keys(i);
          h.forEach(t => {
            const e = i[t];
            e.inputNames.forEach(t => {
              const [n] = Object(a.b)(t);
              e.inputs.push(i[n]), i[n].children.push(e)
            })
          }), 0 === Object.keys(l).length ? h.forEach(t => {
            const e = i[t];
            0 === e.children.length && u.push(e)
          }) : Object.keys(l).forEach(t => {
            const [e] = Object(a.b)(t), n = i[e];
            null != n && (n.signatureKey = l[t], u.push(n))
          }), Object.keys(c).length > 0 ? Object.keys(c).forEach(t => {
            const [e] = Object(a.b)(t), n = i[e];
            n && (n.signatureKey = c[t], o.push(n))
          }) : o = r;
          let d = {};
          return null != t.library && null != t.library.function && (d = t.library.function.reduce((t, e) => (t[e.signature.name] = this.mapFunction(e), t), {})), {
            nodes: i,
            inputs: o,
            outputs: u,
            weights: s,
            placeholders: r,
            signature: e,
            functions: d
          }
        }
        mapSignatureEntries(t) {
          return Object.keys(t || {}).reduce((e, n) => (e[t[n].name] = n, e), {})
        }
        mapNode(t) {
          const e = Object(i.a)(t.op) || this.opMappers[t.op] || {};
          null == t.attr && (t.attr = {});
          const n = {
            name: t.name,
            op: t.op,
            category: e.category,
            inputNames: (t.input || []).map(t => t.startsWith("^") ? t.substr(1) : t),
            inputs: [],
            children: [],
            inputParams: {},
            attrParams: {},
            rawAttrs: t.attr
          };
          return null != e.inputs && (n.inputParams = e.inputs.reduce((t, e) => (t[e.name] = {
            type: e.type,
            inputIndexStart: e.start,
            inputIndexEnd: e.end
          }, t), {})), null != e.attrs && (n.attrParams = e.attrs.reduce((e, n) => {
            const r = n.type;
            let s = void 0;
            switch (n.type) {
              case "string":
                s = k(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = k(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "string[]":
                s = D(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = D(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "number":
                s = E(t.attr, n.tfName, n.defaultValue || 0), void 0 === s && n.tfDeprecatedName && (s = E(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "number[]":
                s = j(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = j(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "bool":
                s = C(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = C(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "bool[]":
                s = M(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = M(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "shape":
                s = R(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = R(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "shape[]":
                s = F(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = F(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "dtype":
                s = A(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = A(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "dtype[]":
                s = N(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = N(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "func":
                s = T(t.attr, n.tfName, n.defaultValue), void 0 === s && n.tfDeprecatedName && (s = T(t.attr, n.tfDeprecatedName, n.defaultValue));
                break;
              case "tensor":
              case "tensors":
                break;
              default:
                throw new Error(`Unsupported param type: ${n.type} for op: ${t.op}`)
            }
            return e[n.name] = {
              value: s,
              type: r
            }, e
          }, {})), n
        }
        mapFunction(t) {
          const e = t.nodeDef,
            n = [];
          let r = {};
          null != e && (r = e.reduce((t, e) => (t[e.name] = this.mapNode(e), "Const" === e.op && n.push(t[e.name]), t), {}));
          const s = [],
            i = [];
          t.signature.inputArg.forEach(t => {
            const [e] = Object(a.b)(t.name), n = {
              name: e,
              op: "Placeholder",
              inputs: [],
              inputNames: [],
              category: "graph",
              inputParams: {},
              attrParams: {
                dtype: {
                  value: I(t.type),
                  type: "dtype"
                }
              },
              children: []
            };
            n.signatureKey = t.name, s.push(n), r[e] = n
          }), Object.keys(r).forEach(t => {
            const e = r[t];
            e.inputNames.forEach(t => {
              const [n] = Object(a.b)(t);
              e.inputs.push(r[n]), r[n].children.push(e)
            })
          });
          const o = t.ret;
          t.signature.outputArg.forEach(t => {
            const [e, n] = Object(a.b)(o[t.name]), s = r[e];
            null != s && (s.defaultOutput = n, i.push(s))
          });
          const u = this.mapArgsToSignature(t);
          return {
            nodes: r,
            inputs: s,
            outputs: i,
            weights: n,
            placeholders: [],
            signature: u
          }
        }
        mapArgsToSignature(t) {
          return {
            methodName: t.signature.name,
            inputs: t.signature.inputArg.reduce((t, e) => (t[e.name] = this.mapArgToTensorInfo(e), t), {}),
            outputs: t.signature.outputArg.reduce((e, n) => (e[n.name] = this.mapArgToTensorInfo(n, t.ret), e), {})
          }
        }
        mapArgToTensorInfo(t, e) {
          let n = t.name;
          return null != e && (n = e[n]), {
            name: n,
            dtype: t.type
          }
        }
      }

      function _(e, n) {
        const s = Array.isArray(e) ? String.fromCharCode.apply(null, e) : function (e) {
          const n = Object(r.vb)().global;
          if (void 0 !== n.atob) return n.atob(e);
          if (void 0 !== t) return new t(e, "base64").toString();
          throw new Error("Unable to decode base64 in this environment. Missing built-in atob() or Buffer()")
        }(e);
        return n ? s : s.toLowerCase()
      }

      function k(t, e, n, r = !1) {
        const s = t[e];
        return null != s ? _(s.s, r) : n
      }

      function C(t, e, n) {
        const r = t[e];
        return r ? r.b : n
      }

      function E(t, e, n) {
        const r = t[e] || {},
          s = null != r.i ? r.i : null != r.f ? r.f : n;
        return "number" == typeof s ? s : parseInt(s, 10)
      }

      function I(t) {
        switch ("string" == typeof t && (t = s.a[t]), t) {
          case s.a.DT_FLOAT:
            return "float32";
          case s.a.DT_INT32:
          case s.a.DT_INT64:
          case s.a.DT_INT8:
          case s.a.DT_UINT8:
            return "int32";
          case s.a.DT_BOOL:
            return "bool";
          case s.a.DT_DOUBLE:
            return "float32";
          case s.a.DT_STRING:
            return "string";
          default:
            return null
        }
      }

      function T(t, e, n) {
        const r = t[e];
        return r && r.func ? r.func.name : n
      }

      function A(t, e, n) {
        const r = t[e];
        return r && r.type ? I(r.type) : n
      }

      function N(t, e, n) {
        const r = t[e];
        return r && r.list && r.list.type ? r.list.type.map(t => I(t)) : n
      }

      function $(t) {
        if (!t.unknownRank) return null != t.dim ? t.dim.map(t => "number" == typeof t.size ? t.size : parseInt(t.size, 10)) : []
      }

      function R(t, e, n) {
        const r = t[e];
        return r && r.shape ? $(r.shape) : n
      }

      function j(t, e, n) {
        const r = t[e];
        return r ? ((r.list.f && r.list.f.length ? r.list.f : r.list.i) || []).map(t => "number" == typeof t ? t : parseInt(t, 10)) : n
      }

      function D(t, e, n, r = !1) {
        const s = t[e];
        return s && s.list && s.list.s ? s.list.s.map(t => _(t, r)) : n
      }

      function F(t, e, n) {
        const r = t[e];
        return r && r.list && r.list.shape ? r.list.shape.map(t => $(t)) : n
      }

      function M(t, e, n) {
        const r = t[e];
        return r && r.list && r.list.b ? r.list.b : n
      }
    }).call(this, n(29).Buffer)
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      this.name = t || "default", this.streamInfo = {}, this.generatedError = null, this.extraStreamInfo = {}, this.isPaused = !0, this.isFinished = !1, this.isLocked = !1, this._listeners = {
        data: [],
        end: [],
        error: []
      }, this.previous = null
    }
    r.prototype = {
      push: function (t) {
        this.emit("data", t)
      },
      end: function () {
        if (this.isFinished) return !1;
        this.flush();
        try {
          this.emit("end"), this.cleanUp(), this.isFinished = !0
        } catch (t) {
          this.emit("error", t)
        }
        return !0
      },
      error: function (t) {
        return !this.isFinished && (this.isPaused ? this.generatedError = t : (this.isFinished = !0, this.emit("error", t), this.previous && this.previous.error(t), this.cleanUp()), !0)
      },
      on: function (t, e) {
        return this._listeners[t].push(e), this
      },
      cleanUp: function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null, this._listeners = []
      },
      emit: function (t, e) {
        if (this._listeners[t])
          for (var n = 0; n < this._listeners[t].length; n++) this._listeners[t][n].call(this, e)
      },
      pipe: function (t) {
        return t.registerPrevious(this)
      },
      registerPrevious: function (t) {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.streamInfo = t.streamInfo, this.mergeStreamInfo(), this.previous = t;
        var e = this;
        return t.on("data", (function (t) {
          e.processChunk(t)
        })), t.on("end", (function () {
          e.end()
        })), t.on("error", (function (t) {
          e.error(t)
        })), this
      },
      pause: function () {
        return !this.isPaused && !this.isFinished && (this.isPaused = !0, this.previous && this.previous.pause(), !0)
      },
      resume: function () {
        if (!this.isPaused || this.isFinished) return !1;
        this.isPaused = !1;
        var t = !1;
        return this.generatedError && (this.error(this.generatedError), t = !0), this.previous && this.previous.resume(), !t
      },
      flush: function () {},
      processChunk: function (t) {
        this.push(t)
      },
      withStreamInfo: function (t, e) {
        return this.extraStreamInfo[t] = e, this.mergeStreamInfo(), this
      },
      mergeStreamInfo: function () {
        for (var t in this.extraStreamInfo) this.extraStreamInfo.hasOwnProperty(t) && (this.streamInfo[t] = this.extraStreamInfo[t])
      },
      lock: function () {
        if (this.isLocked) throw new Error("The stream '" + this + "' has already been used.");
        this.isLocked = !0, this.previous && this.previous.lock()
      },
      toString: function () {
        var t = "Worker " + this.name;
        return this.previous ? this.previous + " -> " + t : t
      }
    }, t.exports = r
  }, function (t, e) {
    t.exports = function () {
      throw new Error("define cannot be used indirect")
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "b", (function () {
      return o
    })), n.d(e, "a", (function () {
      return u
    })), n.d(e, "c", (function () {
      return c
    })), n.d(e, "e", (function () {
      return l
    })), n.d(e, "d", (function () {
      return h
    }));
    var r = n(9),
      s = n(44);
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const i = Object(s.a)("kernelRegistry", () => new Map),
      a = Object(s.a)("gradRegistry", () => new Map);

    function o(t, e) {
      const n = d(t, e);
      return i.get(n)
    }

    function u(t) {
      return a.get(t)
    }

    function c(t) {
      const e = i.entries(),
        n = [];
      for (;;) {
        const {
          done: r,
          value: s
        } = e.next();
        if (r) break;
        const [i, a] = s, [o] = i.split("_");
        o === t && n.push(a)
      }
      return n
    }

    function l(t) {
      const {
        kernelName: e,
        backendName: n
      } = t, r = d(e, n);
      i.has(r) && console.warn(`The kernel '${e}' for backend ` + `'${n}' is already registered`), i.set(r, t)
    }

    function h(t) {
      const {
        kernelName: e
      } = t;
      a.has(e) && Object(r.b)().getBool("DEBUG") && console.warn(`Overriding the gradient for '${e}'`), a.set(e, t)
    }

    function d(t, e) {
      return `${e}_${t}`
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "b", (function () {
      return s
    })), n.d(e, "d", (function () {
      return a
    })), n.d(e, "f", (function () {
      return o
    })), n.d(e, "c", (function () {
      return u
    })), n.d(e, "e", (function () {
      return c
    })), n.d(e, "a", (function () {
      return l
    }));
    var r = n(0);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    function s(t, e) {
      return i(t, e)
    }

    function i(t, e, n = new Map, r = new Set) {
      if (null == t) return null;
      if (r.has(t)) throw new Error("Circular references are not supported.");
      if (n.has(t)) return n.get(t);
      const s = e(t);
      if (s.recurse && null !== s.value) throw new Error("A deep map function may not return both a value and recurse=true.");
      if (s.recurse) {
        if (c(t)) {
          const s = Array.isArray(t) ? [] : {};
          r.add(t);
          for (const a in t) {
            const o = i(t[a], e, n, r);
            s[a] = o
          }
          return r.delete(t), s
        }
        throw new Error(`Can't recurse into non-iterable type: ${t}`)
      }
      return n.set(t, s.value), s.value
    }

    function a(t, e = o) {
      return function t(e, n, r = new Set) {
        const s = e[0];
        if (r.has(s)) throw new Error("Circular references are not supported.");
        const i = n(e);
        if (i.recurse && null !== i.value) throw new Error("A deep zip function may not return both a value and recurse=true.");
        if (i.recurse) {
          if (c(s)) {
            const i = Array.isArray(s) ? [] : {};
            r.add(s);
            for (const a in s) {
              const s = e.map(t => t[a]),
                o = t(s, n, r);
              i[a] = o
            }
            return r.delete(s), i
          }
          throw new Error(`Can't recurse into non-iterable type: ${s}`)
        }
        return i.value
      }(t, e)
    }

    function o(t) {
      return null === t ? null : c(t[0]) ? {
        value: null,
        recurse: !0
      } : {
        value: t,
        recurse: !1
      }
    }
    async function u(t, e) {
      const n = new Map;
      i(t, e, n);
      for (const t of Array.from(n.keys())) {
        const e = n.get(t);
        if (e instanceof Promise) {
          const r = await e;
          n.set(t, r)
        }
      }
      return i(t, e, n)
    }

    function c(t) {
      return null != t && !ArrayBuffer.isView(t) && (Array.isArray(t) || "object" == typeof t && !(t instanceof r.r))
    }

    function l(t) {
      return null == t || (null === (e = t) || "object" != typeof e && "function" != typeof e) || Array.isArray(t) || "object" == typeof t && t instanceof r.r || r.Jd.isTypedArray(t);
      var e
    }
  }, function (t, e) {
    var n;
    n = function () {
      return this
    }();
    try {
      n = n || new Function("return this")()
    } catch (t) {
      "object" == typeof window && (n = window)
    }
    t.exports = n
  }, function (t, e, n) {
    var r = n(148),
      s = n(149),
      i = n(150),
      a = n(151),
      o = n(152),
      u = n(153),
      c = n(154);
    c.alea = r, c.xor128 = s, c.xorwow = i, c.xorshift7 = a, c.xor4096 = o, c.tychei = u, t.exports = c
  }, function (t, e, n) {
    "use strict";
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    var r, s;
    n.d(e, "a", (function () {
        return r
      })),
      function (t) {
        t[t.DT_INVALID = 0] = "DT_INVALID", t[t.DT_FLOAT = 1] = "DT_FLOAT", t[t.DT_DOUBLE = 2] = "DT_DOUBLE", t[t.DT_INT32 = 3] = "DT_INT32", t[t.DT_UINT8 = 4] = "DT_UINT8", t[t.DT_INT16 = 5] = "DT_INT16", t[t.DT_INT8 = 6] = "DT_INT8", t[t.DT_STRING = 7] = "DT_STRING", t[t.DT_COMPLEX64 = 8] = "DT_COMPLEX64", t[t.DT_INT64 = 9] = "DT_INT64", t[t.DT_BOOL = 10] = "DT_BOOL", t[t.DT_QINT8 = 11] = "DT_QINT8", t[t.DT_QUINT8 = 12] = "DT_QUINT8", t[t.DT_QINT32 = 13] = "DT_QINT32", t[t.DT_BFLOAT16 = 14] = "DT_BFLOAT16", t[t.DT_FLOAT_REF = 101] = "DT_FLOAT_REF", t[t.DT_DOUBLE_REF = 102] = "DT_DOUBLE_REF", t[t.DT_INT32_REF = 103] = "DT_INT32_REF", t[t.DT_UINT8_REF = 104] = "DT_UINT8_REF", t[t.DT_INT16_REF = 105] = "DT_INT16_REF", t[t.DT_INT8_REF = 106] = "DT_INT8_REF", t[t.DT_STRING_REF = 107] = "DT_STRING_REF", t[t.DT_COMPLEX64_REF = 108] = "DT_COMPLEX64_REF", t[t.DT_INT64_REF = 109] = "DT_INT64_REF", t[t.DT_BOOL_REF = 110] = "DT_BOOL_REF", t[t.DT_QINT8_REF = 111] = "DT_QINT8_REF", t[t.DT_QUINT8_REF = 112] = "DT_QUINT8_REF", t[t.DT_QINT32_REF = 113] = "DT_QINT32_REF", t[t.DT_BFLOAT16_REF = 114] = "DT_BFLOAT16_REF"
      }(r || (r = {})),
      function (t) {
        let e;
        ! function (t) {
          t[t.LEGACY = 0] = "LEGACY", t[t.V1 = 1] = "V1", t[t.V2 = 2] = "V2"
        }(e = t.CheckpointFormatVersion || (t.CheckpointFormatVersion = {}))
      }(s || (s = {}))
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      if (e.base64 = !0, e.array = !0, e.string = !0, e.arraybuffer = "undefined" != typeof ArrayBuffer && "undefined" != typeof Uint8Array, e.nodebuffer = void 0 !== t, e.uint8array = "undefined" != typeof Uint8Array, "undefined" == typeof ArrayBuffer) e.blob = !1;
      else {
        var r = new ArrayBuffer(0);
        try {
          e.blob = 0 === new Blob([r], {
            type: "application/zip"
          }).size
        } catch (t) {
          try {
            var s = new(self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder);
            s.append(r), e.blob = 0 === s.getBlob("application/zip").size
          } catch (t) {
            e.blob = !1
          }
        }
      }
      try {
        e.nodestream = !!n(59).Readable
      } catch (t) {
        e.nodestream = !1
      }
    }).call(this, n(29).Buffer)
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      /*!
       * The buffer module from node.js, for the browser.
       *
       * @author   Feross Aboukhadijeh <http://feross.org>
       * @license  MIT
       */
      var r = n(107),
        s = n(108),
        i = n(58);

      function a() {
        return u.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823
      }

      function o(t, e) {
        if (a() < e) throw new RangeError("Invalid typed array length");
        return u.TYPED_ARRAY_SUPPORT ? (t = new Uint8Array(e)).__proto__ = u.prototype : (null === t && (t = new u(e)), t.length = e), t
      }

      function u(t, e, n) {
        if (!(u.TYPED_ARRAY_SUPPORT || this instanceof u)) return new u(t, e, n);
        if ("number" == typeof t) {
          if ("string" == typeof e) throw new Error("If encoding is specified then the first argument must be a string");
          return h(this, t)
        }
        return c(this, t, e, n)
      }

      function c(t, e, n, r) {
        if ("number" == typeof e) throw new TypeError('"value" argument must not be a number');
        return "undefined" != typeof ArrayBuffer && e instanceof ArrayBuffer ? function (t, e, n, r) {
          if (e.byteLength, n < 0 || e.byteLength < n) throw new RangeError("'offset' is out of bounds");
          if (e.byteLength < n + (r || 0)) throw new RangeError("'length' is out of bounds");
          e = void 0 === n && void 0 === r ? new Uint8Array(e) : void 0 === r ? new Uint8Array(e, n) : new Uint8Array(e, n, r);
          u.TYPED_ARRAY_SUPPORT ? (t = e).__proto__ = u.prototype : t = d(t, e);
          return t
        }(t, e, n, r) : "string" == typeof e ? function (t, e, n) {
          "string" == typeof n && "" !== n || (n = "utf8");
          if (!u.isEncoding(n)) throw new TypeError('"encoding" must be a valid string encoding');
          var r = 0 | f(e, n),
            s = (t = o(t, r)).write(e, n);
          s !== r && (t = t.slice(0, s));
          return t
        }(t, e, n) : function (t, e) {
          if (u.isBuffer(e)) {
            var n = 0 | p(e.length);
            return 0 === (t = o(t, n)).length ? t : (e.copy(t, 0, 0, n), t)
          }
          if (e) {
            if ("undefined" != typeof ArrayBuffer && e.buffer instanceof ArrayBuffer || "length" in e) return "number" != typeof e.length || (r = e.length) != r ? o(t, 0) : d(t, e);
            if ("Buffer" === e.type && i(e.data)) return d(t, e.data)
          }
          var r;
          throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")
        }(t, e)
      }

      function l(t) {
        if ("number" != typeof t) throw new TypeError('"size" argument must be a number');
        if (t < 0) throw new RangeError('"size" argument must not be negative')
      }

      function h(t, e) {
        if (l(e), t = o(t, e < 0 ? 0 : 0 | p(e)), !u.TYPED_ARRAY_SUPPORT)
          for (var n = 0; n < e; ++n) t[n] = 0;
        return t
      }

      function d(t, e) {
        var n = e.length < 0 ? 0 : 0 | p(e.length);
        t = o(t, n);
        for (var r = 0; r < n; r += 1) t[r] = 255 & e[r];
        return t
      }

      function p(t) {
        if (t >= a()) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + a().toString(16) + " bytes");
        return 0 | t
      }

      function f(t, e) {
        if (u.isBuffer(t)) return t.length;
        if ("undefined" != typeof ArrayBuffer && "function" == typeof ArrayBuffer.isView && (ArrayBuffer.isView(t) || t instanceof ArrayBuffer)) return t.byteLength;
        "string" != typeof t && (t = "" + t);
        var n = t.length;
        if (0 === n) return 0;
        for (var r = !1;;) switch (e) {
          case "ascii":
          case "latin1":
          case "binary":
            return n;
          case "utf8":
          case "utf-8":
          case void 0:
            return P(t).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return 2 * n;
          case "hex":
            return n >>> 1;
          case "base64":
            return W(t).length;
          default:
            if (r) return P(t).length;
            e = ("" + e).toLowerCase(), r = !0
        }
      }

      function m(t, e, n) {
        var r = !1;
        if ((void 0 === e || e < 0) && (e = 0), e > this.length) return "";
        if ((void 0 === n || n > this.length) && (n = this.length), n <= 0) return "";
        if ((n >>>= 0) <= (e >>>= 0)) return "";
        for (t || (t = "utf8");;) switch (t) {
          case "hex":
            return A(this, e, n);
          case "utf8":
          case "utf-8":
            return C(this, e, n);
          case "ascii":
            return I(this, e, n);
          case "latin1":
          case "binary":
            return T(this, e, n);
          case "base64":
            return k(this, e, n);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return N(this, e, n);
          default:
            if (r) throw new TypeError("Unknown encoding: " + t);
            t = (t + "").toLowerCase(), r = !0
        }
      }

      function g(t, e, n) {
        var r = t[e];
        t[e] = t[n], t[n] = r
      }

      function b(t, e, n, r, s) {
        if (0 === t.length) return -1;
        if ("string" == typeof n ? (r = n, n = 0) : n > 2147483647 ? n = 2147483647 : n < -2147483648 && (n = -2147483648), n = +n, isNaN(n) && (n = s ? 0 : t.length - 1), n < 0 && (n = t.length + n), n >= t.length) {
          if (s) return -1;
          n = t.length - 1
        } else if (n < 0) {
          if (!s) return -1;
          n = 0
        }
        if ("string" == typeof e && (e = u.from(e, r)), u.isBuffer(e)) return 0 === e.length ? -1 : y(t, e, n, r, s);
        if ("number" == typeof e) return e &= 255, u.TYPED_ARRAY_SUPPORT && "function" == typeof Uint8Array.prototype.indexOf ? s ? Uint8Array.prototype.indexOf.call(t, e, n) : Uint8Array.prototype.lastIndexOf.call(t, e, n) : y(t, [e], n, r, s);
        throw new TypeError("val must be string, number or Buffer")
      }

      function y(t, e, n, r, s) {
        var i, a = 1,
          o = t.length,
          u = e.length;
        if (void 0 !== r && ("ucs2" === (r = String(r).toLowerCase()) || "ucs-2" === r || "utf16le" === r || "utf-16le" === r)) {
          if (t.length < 2 || e.length < 2) return -1;
          a = 2, o /= 2, u /= 2, n /= 2
        }

        function c(t, e) {
          return 1 === a ? t[e] : t.readUInt16BE(e * a)
        }
        if (s) {
          var l = -1;
          for (i = n; i < o; i++)
            if (c(t, i) === c(e, -1 === l ? 0 : i - l)) {
              if (-1 === l && (l = i), i - l + 1 === u) return l * a
            } else -1 !== l && (i -= i - l), l = -1
        } else
          for (n + u > o && (n = o - u), i = n; i >= 0; i--) {
            for (var h = !0, d = 0; d < u; d++)
              if (c(t, i + d) !== c(e, d)) {
                h = !1;
                break
              } if (h) return i
          }
        return -1
      }

      function w(t, e, n, r) {
        n = Number(n) || 0;
        var s = t.length - n;
        r ? (r = Number(r)) > s && (r = s) : r = s;
        var i = e.length;
        if (i % 2 != 0) throw new TypeError("Invalid hex string");
        r > i / 2 && (r = i / 2);
        for (var a = 0; a < r; ++a) {
          var o = parseInt(e.substr(2 * a, 2), 16);
          if (isNaN(o)) return a;
          t[n + a] = o
        }
        return a
      }

      function v(t, e, n, r) {
        return U(P(e, t.length - n), t, n, r)
      }

      function x(t, e, n, r) {
        return U(function (t) {
          for (var e = [], n = 0; n < t.length; ++n) e.push(255 & t.charCodeAt(n));
          return e
        }(e), t, n, r)
      }

      function O(t, e, n, r) {
        return x(t, e, n, r)
      }

      function S(t, e, n, r) {
        return U(W(e), t, n, r)
      }

      function _(t, e, n, r) {
        return U(function (t, e) {
          for (var n, r, s, i = [], a = 0; a < t.length && !((e -= 2) < 0); ++a) n = t.charCodeAt(a), r = n >> 8, s = n % 256, i.push(s), i.push(r);
          return i
        }(e, t.length - n), t, n, r)
      }

      function k(t, e, n) {
        return 0 === e && n === t.length ? r.fromByteArray(t) : r.fromByteArray(t.slice(e, n))
      }

      function C(t, e, n) {
        n = Math.min(t.length, n);
        for (var r = [], s = e; s < n;) {
          var i, a, o, u, c = t[s],
            l = null,
            h = c > 239 ? 4 : c > 223 ? 3 : c > 191 ? 2 : 1;
          if (s + h <= n) switch (h) {
            case 1:
              c < 128 && (l = c);
              break;
            case 2:
              128 == (192 & (i = t[s + 1])) && (u = (31 & c) << 6 | 63 & i) > 127 && (l = u);
              break;
            case 3:
              i = t[s + 1], a = t[s + 2], 128 == (192 & i) && 128 == (192 & a) && (u = (15 & c) << 12 | (63 & i) << 6 | 63 & a) > 2047 && (u < 55296 || u > 57343) && (l = u);
              break;
            case 4:
              i = t[s + 1], a = t[s + 2], o = t[s + 3], 128 == (192 & i) && 128 == (192 & a) && 128 == (192 & o) && (u = (15 & c) << 18 | (63 & i) << 12 | (63 & a) << 6 | 63 & o) > 65535 && u < 1114112 && (l = u)
          }
          null === l ? (l = 65533, h = 1) : l > 65535 && (l -= 65536, r.push(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), r.push(l), s += h
        }
        return function (t) {
          var e = t.length;
          if (e <= E) return String.fromCharCode.apply(String, t);
          var n = "",
            r = 0;
          for (; r < e;) n += String.fromCharCode.apply(String, t.slice(r, r += E));
          return n
        }(r)
      }
      e.Buffer = u, e.SlowBuffer = function (t) {
        +t != t && (t = 0);
        return u.alloc(+t)
      }, e.INSPECT_MAX_BYTES = 50, u.TYPED_ARRAY_SUPPORT = void 0 !== t.TYPED_ARRAY_SUPPORT ? t.TYPED_ARRAY_SUPPORT : function () {
        try {
          var t = new Uint8Array(1);
          return t.__proto__ = {
            __proto__: Uint8Array.prototype,
            foo: function () {
              return 42
            }
          }, 42 === t.foo() && "function" == typeof t.subarray && 0 === t.subarray(1, 1).byteLength
        } catch (t) {
          return !1
        }
      }(), e.kMaxLength = a(), u.poolSize = 8192, u._augment = function (t) {
        return t.__proto__ = u.prototype, t
      }, u.from = function (t, e, n) {
        return c(null, t, e, n)
      }, u.TYPED_ARRAY_SUPPORT && (u.prototype.__proto__ = Uint8Array.prototype, u.__proto__ = Uint8Array, "undefined" != typeof Symbol && Symbol.species && u[Symbol.species] === u && Object.defineProperty(u, Symbol.species, {
        value: null,
        configurable: !0
      })), u.alloc = function (t, e, n) {
        return function (t, e, n, r) {
          return l(e), e <= 0 ? o(t, e) : void 0 !== n ? "string" == typeof r ? o(t, e).fill(n, r) : o(t, e).fill(n) : o(t, e)
        }(null, t, e, n)
      }, u.allocUnsafe = function (t) {
        return h(null, t)
      }, u.allocUnsafeSlow = function (t) {
        return h(null, t)
      }, u.isBuffer = function (t) {
        return !(null == t || !t._isBuffer)
      }, u.compare = function (t, e) {
        if (!u.isBuffer(t) || !u.isBuffer(e)) throw new TypeError("Arguments must be Buffers");
        if (t === e) return 0;
        for (var n = t.length, r = e.length, s = 0, i = Math.min(n, r); s < i; ++s)
          if (t[s] !== e[s]) {
            n = t[s], r = e[s];
            break
          } return n < r ? -1 : r < n ? 1 : 0
      }, u.isEncoding = function (t) {
        switch (String(t).toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "latin1":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return !0;
          default:
            return !1
        }
      }, u.concat = function (t, e) {
        if (!i(t)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (0 === t.length) return u.alloc(0);
        var n;
        if (void 0 === e)
          for (e = 0, n = 0; n < t.length; ++n) e += t[n].length;
        var r = u.allocUnsafe(e),
          s = 0;
        for (n = 0; n < t.length; ++n) {
          var a = t[n];
          if (!u.isBuffer(a)) throw new TypeError('"list" argument must be an Array of Buffers');
          a.copy(r, s), s += a.length
        }
        return r
      }, u.byteLength = f, u.prototype._isBuffer = !0, u.prototype.swap16 = function () {
        var t = this.length;
        if (t % 2 != 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
        for (var e = 0; e < t; e += 2) g(this, e, e + 1);
        return this
      }, u.prototype.swap32 = function () {
        var t = this.length;
        if (t % 4 != 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
        for (var e = 0; e < t; e += 4) g(this, e, e + 3), g(this, e + 1, e + 2);
        return this
      }, u.prototype.swap64 = function () {
        var t = this.length;
        if (t % 8 != 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
        for (var e = 0; e < t; e += 8) g(this, e, e + 7), g(this, e + 1, e + 6), g(this, e + 2, e + 5), g(this, e + 3, e + 4);
        return this
      }, u.prototype.toString = function () {
        var t = 0 | this.length;
        return 0 === t ? "" : 0 === arguments.length ? C(this, 0, t) : m.apply(this, arguments)
      }, u.prototype.equals = function (t) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        return this === t || 0 === u.compare(this, t)
      }, u.prototype.inspect = function () {
        var t = "",
          n = e.INSPECT_MAX_BYTES;
        return this.length > 0 && (t = this.toString("hex", 0, n).match(/.{2}/g).join(" "), this.length > n && (t += " ... ")), "<Buffer " + t + ">"
      }, u.prototype.compare = function (t, e, n, r, s) {
        if (!u.isBuffer(t)) throw new TypeError("Argument must be a Buffer");
        if (void 0 === e && (e = 0), void 0 === n && (n = t ? t.length : 0), void 0 === r && (r = 0), void 0 === s && (s = this.length), e < 0 || n > t.length || r < 0 || s > this.length) throw new RangeError("out of range index");
        if (r >= s && e >= n) return 0;
        if (r >= s) return -1;
        if (e >= n) return 1;
        if (this === t) return 0;
        for (var i = (s >>>= 0) - (r >>>= 0), a = (n >>>= 0) - (e >>>= 0), o = Math.min(i, a), c = this.slice(r, s), l = t.slice(e, n), h = 0; h < o; ++h)
          if (c[h] !== l[h]) {
            i = c[h], a = l[h];
            break
          } return i < a ? -1 : a < i ? 1 : 0
      }, u.prototype.includes = function (t, e, n) {
        return -1 !== this.indexOf(t, e, n)
      }, u.prototype.indexOf = function (t, e, n) {
        return b(this, t, e, n, !0)
      }, u.prototype.lastIndexOf = function (t, e, n) {
        return b(this, t, e, n, !1)
      }, u.prototype.write = function (t, e, n, r) {
        if (void 0 === e) r = "utf8", n = this.length, e = 0;
        else if (void 0 === n && "string" == typeof e) r = e, n = this.length, e = 0;
        else {
          if (!isFinite(e)) throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
          e |= 0, isFinite(n) ? (n |= 0, void 0 === r && (r = "utf8")) : (r = n, n = void 0)
        }
        var s = this.length - e;
        if ((void 0 === n || n > s) && (n = s), t.length > 0 && (n < 0 || e < 0) || e > this.length) throw new RangeError("Attempt to write outside buffer bounds");
        r || (r = "utf8");
        for (var i = !1;;) switch (r) {
          case "hex":
            return w(this, t, e, n);
          case "utf8":
          case "utf-8":
            return v(this, t, e, n);
          case "ascii":
            return x(this, t, e, n);
          case "latin1":
          case "binary":
            return O(this, t, e, n);
          case "base64":
            return S(this, t, e, n);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return _(this, t, e, n);
          default:
            if (i) throw new TypeError("Unknown encoding: " + r);
            r = ("" + r).toLowerCase(), i = !0
        }
      }, u.prototype.toJSON = function () {
        return {
          type: "Buffer",
          data: Array.prototype.slice.call(this._arr || this, 0)
        }
      };
      var E = 4096;

      function I(t, e, n) {
        var r = "";
        n = Math.min(t.length, n);
        for (var s = e; s < n; ++s) r += String.fromCharCode(127 & t[s]);
        return r
      }

      function T(t, e, n) {
        var r = "";
        n = Math.min(t.length, n);
        for (var s = e; s < n; ++s) r += String.fromCharCode(t[s]);
        return r
      }

      function A(t, e, n) {
        var r = t.length;
        (!e || e < 0) && (e = 0), (!n || n < 0 || n > r) && (n = r);
        for (var s = "", i = e; i < n; ++i) s += B(t[i]);
        return s
      }

      function N(t, e, n) {
        for (var r = t.slice(e, n), s = "", i = 0; i < r.length; i += 2) s += String.fromCharCode(r[i] + 256 * r[i + 1]);
        return s
      }

      function $(t, e, n) {
        if (t % 1 != 0 || t < 0) throw new RangeError("offset is not uint");
        if (t + e > n) throw new RangeError("Trying to access beyond buffer length")
      }

      function R(t, e, n, r, s, i) {
        if (!u.isBuffer(t)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (e > s || e < i) throw new RangeError('"value" argument is out of bounds');
        if (n + r > t.length) throw new RangeError("Index out of range")
      }

      function j(t, e, n, r) {
        e < 0 && (e = 65535 + e + 1);
        for (var s = 0, i = Math.min(t.length - n, 2); s < i; ++s) t[n + s] = (e & 255 << 8 * (r ? s : 1 - s)) >>> 8 * (r ? s : 1 - s)
      }

      function D(t, e, n, r) {
        e < 0 && (e = 4294967295 + e + 1);
        for (var s = 0, i = Math.min(t.length - n, 4); s < i; ++s) t[n + s] = e >>> 8 * (r ? s : 3 - s) & 255
      }

      function F(t, e, n, r, s, i) {
        if (n + r > t.length) throw new RangeError("Index out of range");
        if (n < 0) throw new RangeError("Index out of range")
      }

      function M(t, e, n, r, i) {
        return i || F(t, 0, n, 4), s.write(t, e, n, r, 23, 4), n + 4
      }

      function z(t, e, n, r, i) {
        return i || F(t, 0, n, 8), s.write(t, e, n, r, 52, 8), n + 8
      }
      u.prototype.slice = function (t, e) {
        var n, r = this.length;
        if ((t = ~~t) < 0 ? (t += r) < 0 && (t = 0) : t > r && (t = r), (e = void 0 === e ? r : ~~e) < 0 ? (e += r) < 0 && (e = 0) : e > r && (e = r), e < t && (e = t), u.TYPED_ARRAY_SUPPORT)(n = this.subarray(t, e)).__proto__ = u.prototype;
        else {
          var s = e - t;
          n = new u(s, void 0);
          for (var i = 0; i < s; ++i) n[i] = this[i + t]
        }
        return n
      }, u.prototype.readUIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || $(t, e, this.length);
        for (var r = this[t], s = 1, i = 0; ++i < e && (s *= 256);) r += this[t + i] * s;
        return r
      }, u.prototype.readUIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || $(t, e, this.length);
        for (var r = this[t + --e], s = 1; e > 0 && (s *= 256);) r += this[t + --e] * s;
        return r
      }, u.prototype.readUInt8 = function (t, e) {
        return e || $(t, 1, this.length), this[t]
      }, u.prototype.readUInt16LE = function (t, e) {
        return e || $(t, 2, this.length), this[t] | this[t + 1] << 8
      }, u.prototype.readUInt16BE = function (t, e) {
        return e || $(t, 2, this.length), this[t] << 8 | this[t + 1]
      }, u.prototype.readUInt32LE = function (t, e) {
        return e || $(t, 4, this.length), (this[t] | this[t + 1] << 8 | this[t + 2] << 16) + 16777216 * this[t + 3]
      }, u.prototype.readUInt32BE = function (t, e) {
        return e || $(t, 4, this.length), 16777216 * this[t] + (this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3])
      }, u.prototype.readIntLE = function (t, e, n) {
        t |= 0, e |= 0, n || $(t, e, this.length);
        for (var r = this[t], s = 1, i = 0; ++i < e && (s *= 256);) r += this[t + i] * s;
        return r >= (s *= 128) && (r -= Math.pow(2, 8 * e)), r
      }, u.prototype.readIntBE = function (t, e, n) {
        t |= 0, e |= 0, n || $(t, e, this.length);
        for (var r = e, s = 1, i = this[t + --r]; r > 0 && (s *= 256);) i += this[t + --r] * s;
        return i >= (s *= 128) && (i -= Math.pow(2, 8 * e)), i
      }, u.prototype.readInt8 = function (t, e) {
        return e || $(t, 1, this.length), 128 & this[t] ? -1 * (255 - this[t] + 1) : this[t]
      }, u.prototype.readInt16LE = function (t, e) {
        e || $(t, 2, this.length);
        var n = this[t] | this[t + 1] << 8;
        return 32768 & n ? 4294901760 | n : n
      }, u.prototype.readInt16BE = function (t, e) {
        e || $(t, 2, this.length);
        var n = this[t + 1] | this[t] << 8;
        return 32768 & n ? 4294901760 | n : n
      }, u.prototype.readInt32LE = function (t, e) {
        return e || $(t, 4, this.length), this[t] | this[t + 1] << 8 | this[t + 2] << 16 | this[t + 3] << 24
      }, u.prototype.readInt32BE = function (t, e) {
        return e || $(t, 4, this.length), this[t] << 24 | this[t + 1] << 16 | this[t + 2] << 8 | this[t + 3]
      }, u.prototype.readFloatLE = function (t, e) {
        return e || $(t, 4, this.length), s.read(this, t, !0, 23, 4)
      }, u.prototype.readFloatBE = function (t, e) {
        return e || $(t, 4, this.length), s.read(this, t, !1, 23, 4)
      }, u.prototype.readDoubleLE = function (t, e) {
        return e || $(t, 8, this.length), s.read(this, t, !0, 52, 8)
      }, u.prototype.readDoubleBE = function (t, e) {
        return e || $(t, 8, this.length), s.read(this, t, !1, 52, 8)
      }, u.prototype.writeUIntLE = function (t, e, n, r) {
        (t = +t, e |= 0, n |= 0, r) || R(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        var s = 1,
          i = 0;
        for (this[e] = 255 & t; ++i < n && (s *= 256);) this[e + i] = t / s & 255;
        return e + n
      }, u.prototype.writeUIntBE = function (t, e, n, r) {
        (t = +t, e |= 0, n |= 0, r) || R(this, t, e, n, Math.pow(2, 8 * n) - 1, 0);
        var s = n - 1,
          i = 1;
        for (this[e + s] = 255 & t; --s >= 0 && (i *= 256);) this[e + s] = t / i & 255;
        return e + n
      }, u.prototype.writeUInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 1, 255, 0), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), this[e] = 255 & t, e + 1
      }, u.prototype.writeUInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2
      }, u.prototype.writeUInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 2, 65535, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2
      }, u.prototype.writeUInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e + 3] = t >>> 24, this[e + 2] = t >>> 16, this[e + 1] = t >>> 8, this[e] = 255 & t) : D(this, t, e, !0), e + 4
      }, u.prototype.writeUInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 4, 4294967295, 0), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : D(this, t, e, !1), e + 4
      }, u.prototype.writeIntLE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var s = Math.pow(2, 8 * n - 1);
          R(this, t, e, n, s - 1, -s)
        }
        var i = 0,
          a = 1,
          o = 0;
        for (this[e] = 255 & t; ++i < n && (a *= 256);) t < 0 && 0 === o && 0 !== this[e + i - 1] && (o = 1), this[e + i] = (t / a >> 0) - o & 255;
        return e + n
      }, u.prototype.writeIntBE = function (t, e, n, r) {
        if (t = +t, e |= 0, !r) {
          var s = Math.pow(2, 8 * n - 1);
          R(this, t, e, n, s - 1, -s)
        }
        var i = n - 1,
          a = 1,
          o = 0;
        for (this[e + i] = 255 & t; --i >= 0 && (a *= 256);) t < 0 && 0 === o && 0 !== this[e + i + 1] && (o = 1), this[e + i] = (t / a >> 0) - o & 255;
        return e + n
      }, u.prototype.writeInt8 = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 1, 127, -128), u.TYPED_ARRAY_SUPPORT || (t = Math.floor(t)), t < 0 && (t = 255 + t + 1), this[e] = 255 & t, e + 1
      }, u.prototype.writeInt16LE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8) : j(this, t, e, !0), e + 2
      }, u.prototype.writeInt16BE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 2, 32767, -32768), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 8, this[e + 1] = 255 & t) : j(this, t, e, !1), e + 2
      }, u.prototype.writeInt32LE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 4, 2147483647, -2147483648), u.TYPED_ARRAY_SUPPORT ? (this[e] = 255 & t, this[e + 1] = t >>> 8, this[e + 2] = t >>> 16, this[e + 3] = t >>> 24) : D(this, t, e, !0), e + 4
      }, u.prototype.writeInt32BE = function (t, e, n) {
        return t = +t, e |= 0, n || R(this, t, e, 4, 2147483647, -2147483648), t < 0 && (t = 4294967295 + t + 1), u.TYPED_ARRAY_SUPPORT ? (this[e] = t >>> 24, this[e + 1] = t >>> 16, this[e + 2] = t >>> 8, this[e + 3] = 255 & t) : D(this, t, e, !1), e + 4
      }, u.prototype.writeFloatLE = function (t, e, n) {
        return M(this, t, e, !0, n)
      }, u.prototype.writeFloatBE = function (t, e, n) {
        return M(this, t, e, !1, n)
      }, u.prototype.writeDoubleLE = function (t, e, n) {
        return z(this, t, e, !0, n)
      }, u.prototype.writeDoubleBE = function (t, e, n) {
        return z(this, t, e, !1, n)
      }, u.prototype.copy = function (t, e, n, r) {
        if (n || (n = 0), r || 0 === r || (r = this.length), e >= t.length && (e = t.length), e || (e = 0), r > 0 && r < n && (r = n), r === n) return 0;
        if (0 === t.length || 0 === this.length) return 0;
        if (e < 0) throw new RangeError("targetStart out of bounds");
        if (n < 0 || n >= this.length) throw new RangeError("sourceStart out of bounds");
        if (r < 0) throw new RangeError("sourceEnd out of bounds");
        r > this.length && (r = this.length), t.length - e < r - n && (r = t.length - e + n);
        var s, i = r - n;
        if (this === t && n < e && e < r)
          for (s = i - 1; s >= 0; --s) t[s + e] = this[s + n];
        else if (i < 1e3 || !u.TYPED_ARRAY_SUPPORT)
          for (s = 0; s < i; ++s) t[s + e] = this[s + n];
        else Uint8Array.prototype.set.call(t, this.subarray(n, n + i), e);
        return i
      }, u.prototype.fill = function (t, e, n, r) {
        if ("string" == typeof t) {
          if ("string" == typeof e ? (r = e, e = 0, n = this.length) : "string" == typeof n && (r = n, n = this.length), 1 === t.length) {
            var s = t.charCodeAt(0);
            s < 256 && (t = s)
          }
          if (void 0 !== r && "string" != typeof r) throw new TypeError("encoding must be a string");
          if ("string" == typeof r && !u.isEncoding(r)) throw new TypeError("Unknown encoding: " + r)
        } else "number" == typeof t && (t &= 255);
        if (e < 0 || this.length < e || this.length < n) throw new RangeError("Out of range index");
        if (n <= e) return this;
        var i;
        if (e >>>= 0, n = void 0 === n ? this.length : n >>> 0, t || (t = 0), "number" == typeof t)
          for (i = e; i < n; ++i) this[i] = t;
        else {
          var a = u.isBuffer(t) ? t : P(new u(t, r).toString()),
            o = a.length;
          for (i = 0; i < n - e; ++i) this[i + e] = a[i % o]
        }
        return this
      };
      var L = /[^+\/0-9A-Za-z-_]/g;

      function B(t) {
        return t < 16 ? "0" + t.toString(16) : t.toString(16)
      }

      function P(t, e) {
        var n;
        e = e || 1 / 0;
        for (var r = t.length, s = null, i = [], a = 0; a < r; ++a) {
          if ((n = t.charCodeAt(a)) > 55295 && n < 57344) {
            if (!s) {
              if (n > 56319) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue
              }
              if (a + 1 === r) {
                (e -= 3) > -1 && i.push(239, 191, 189);
                continue
              }
              s = n;
              continue
            }
            if (n < 56320) {
              (e -= 3) > -1 && i.push(239, 191, 189), s = n;
              continue
            }
            n = 65536 + (s - 55296 << 10 | n - 56320)
          } else s && (e -= 3) > -1 && i.push(239, 191, 189);
          if (s = null, n < 128) {
            if ((e -= 1) < 0) break;
            i.push(n)
          } else if (n < 2048) {
            if ((e -= 2) < 0) break;
            i.push(n >> 6 | 192, 63 & n | 128)
          } else if (n < 65536) {
            if ((e -= 3) < 0) break;
            i.push(n >> 12 | 224, n >> 6 & 63 | 128, 63 & n | 128)
          } else {
            if (!(n < 1114112)) throw new Error("Invalid code point");
            if ((e -= 4) < 0) break;
            i.push(n >> 18 | 240, n >> 12 & 63 | 128, n >> 6 & 63 | 128, 63 & n | 128)
          }
        }
        return i
      }

      function W(t) {
        return r.toByteArray(function (t) {
          if ((t = function (t) {
              return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "")
            }(t).replace(L, "")).length < 2) return "";
          for (; t.length % 4 != 0;) t += "=";
          return t
        }(t))
      }

      function U(t, e, n, r) {
        for (var s = 0; s < r && !(s + n >= e.length || s >= t.length); ++s) e[s + n] = t[s];
        return s
      }
    }).call(this, n(25))
  }, function (t, e, n) {
    "use strict";
    var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Int32Array;

    function s(t, e) {
      return Object.prototype.hasOwnProperty.call(t, e)
    }
    e.assign = function (t) {
      for (var e = Array.prototype.slice.call(arguments, 1); e.length;) {
        var n = e.shift();
        if (n) {
          if ("object" != typeof n) throw new TypeError(n + "must be non-object");
          for (var r in n) s(n, r) && (t[r] = n[r])
        }
      }
      return t
    }, e.shrinkBuf = function (t, e) {
      return t.length === e ? t : t.subarray ? t.subarray(0, e) : (t.length = e, t)
    };
    var i = {
        arraySet: function (t, e, n, r, s) {
          if (e.subarray && t.subarray) t.set(e.subarray(n, n + r), s);
          else
            for (var i = 0; i < r; i++) t[s + i] = e[n + i]
        },
        flattenChunks: function (t) {
          var e, n, r, s, i, a;
          for (r = 0, e = 0, n = t.length; e < n; e++) r += t[e].length;
          for (a = new Uint8Array(r), s = 0, e = 0, n = t.length; e < n; e++) i = t[e], a.set(i, s), s += i.length;
          return a
        }
      },
      a = {
        arraySet: function (t, e, n, r, s) {
          for (var i = 0; i < r; i++) t[s + i] = e[n + i]
        },
        flattenChunks: function (t) {
          return [].concat.apply([], t)
        }
      };
    e.setTyped = function (t) {
      t ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, i)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, a))
    }, e.setTyped(r)
  }, function (t, e, n) {
    "use strict";
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    var r, s, i, a, o;
    n.d(e, "b", (function () {
        return c
      })), n.d(e, "a", (function () {
        return l
      })),
      function (t) {
        t.R0 = "R0", t.R1 = "R1", t.R2 = "R2", t.R3 = "R3", t.R4 = "R4", t.R5 = "R5", t.R6 = "R6"
      }(r || (r = {})),
      function (t) {
        t.float32 = "float32", t.int32 = "int32", t.bool = "int32", t.complex64 = "complex64"
      }(s || (s = {})),
      function (t) {
        t.float32 = "float32", t.int32 = "int32", t.bool = "bool", t.complex64 = "complex64"
      }(i || (i = {})),
      function (t) {
        t.float32 = "float32", t.int32 = "float32", t.bool = "float32", t.complex64 = "complex64"
      }(a || (a = {})),
      function (t) {
        t.float32 = "complex64", t.int32 = "complex64", t.bool = "complex64", t.complex64 = "complex64"
      }(o || (o = {}));
    const u = {
      float32: a,
      int32: s,
      bool: i,
      complex64: o
    };

    function c(t, e) {
      if ("string" === t || "string" === e) {
        if ("string" === t && "string" === e) return "string";
        throw new Error(`Can not upcast ${t} with ${e}`)
      }
      return u[t][e]
    }

    function l(t) {
      return c(t, "int32")
    }
  }, function (t, e) {
    var n, r, s = t.exports = {};

    function i() {
      throw new Error("setTimeout has not been defined")
    }

    function a() {
      throw new Error("clearTimeout has not been defined")
    }

    function o(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === i || !n) && setTimeout) return n = setTimeout, setTimeout(t, 0);
      try {
        return n(t, 0)
      } catch (e) {
        try {
          return n.call(null, t, 0)
        } catch (e) {
          return n.call(this, t, 0)
        }
      }
    }! function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : i
      } catch (t) {
        n = i
      }
      try {
        r = "function" == typeof clearTimeout ? clearTimeout : a
      } catch (t) {
        r = a
      }
    }();
    var u, c = [],
      l = !1,
      h = -1;

    function d() {
      l && u && (l = !1, u.length ? c = u.concat(c) : h = -1, c.length && p())
    }

    function p() {
      if (!l) {
        var t = o(d);
        l = !0;
        for (var e = c.length; e;) {
          for (u = c, c = []; ++h < e;) u && u[h].run();
          h = -1, e = c.length
        }
        u = null, l = !1,
          function (t) {
            if (r === clearTimeout) return clearTimeout(t);
            if ((r === a || !r) && clearTimeout) return r = clearTimeout, clearTimeout(t);
            try {
              r(t)
            } catch (e) {
              try {
                return r.call(null, t)
              } catch (e) {
                return r.call(this, t)
              }
            }
          }(t)
      }
    }

    function f(t, e) {
      this.fun = t, this.array = e
    }

    function m() {}
    s.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1)
        for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      c.push(new f(t, e)), 1 !== c.length || l || o(p)
    }, f.prototype.run = function () {
      this.fun.apply(null, this.array)
    }, s.title = "browser", s.browser = !0, s.env = {}, s.argv = [], s.version = "", s.versions = {}, s.on = m, s.addListener = m, s.once = m, s.off = m, s.removeListener = m, s.removeAllListeners = m, s.emit = m, s.prependListener = m, s.prependOnceListener = m, s.listeners = function (t) {
      return []
    }, s.binding = function (t) {
      throw new Error("process.binding is not supported")
    }, s.cwd = function () {
      return "/"
    }, s.chdir = function (t) {
      throw new Error("process.chdir is not supported")
    }, s.umask = function () {
      return 0
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(46),
      s = Object.keys || function (t) {
        var e = [];
        for (var n in t) e.push(n);
        return e
      };
    t.exports = h;
    var i = n(40);
    i.inherits = n(36);
    var a = n(60),
      o = n(53);
    i.inherits(h, a);
    for (var u = s(o.prototype), c = 0; c < u.length; c++) {
      var l = u[c];
      h.prototype[l] || (h.prototype[l] = o.prototype[l])
    }

    function h(t) {
      if (!(this instanceof h)) return new h(t);
      a.call(this, t), o.call(this, t), t && !1 === t.readable && (this.readable = !1), t && !1 === t.writable && (this.writable = !1), this.allowHalfOpen = !0, t && !1 === t.allowHalfOpen && (this.allowHalfOpen = !1), this.once("end", d)
    }

    function d() {
      this.allowHalfOpen || this._writableState.ended || r.nextTick(p, this)
    }

    function p(t) {
      t.end()
    }
    Object.defineProperty(h.prototype, "writableHighWaterMark", {
      enumerable: !1,
      get: function () {
        return this._writableState.highWaterMark
      }
    }), Object.defineProperty(h.prototype, "destroyed", {
      get: function () {
        return void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed && this._writableState.destroyed)
      },
      set: function (t) {
        void 0 !== this._readableState && void 0 !== this._writableState && (this._readableState.destroyed = t, this._writableState.destroyed = t)
      }
    }), h.prototype._destroy = function (t, e) {
      this.push(null), this.end(), r.nextTick(e, t)
    }
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return s
    }));
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = {};

    function s(t) {
      return r[t]
    }
  }, function (t, e, n) {
    "use strict";
    for (var r = n(10), s = n(28), i = n(48), a = n(21), o = new Array(256), u = 0; u < 256; u++) o[u] = u >= 252 ? 6 : u >= 248 ? 5 : u >= 240 ? 4 : u >= 224 ? 3 : u >= 192 ? 2 : 1;
    o[254] = o[254] = 1;

    function c() {
      a.call(this, "utf-8 decode"), this.leftOver = null
    }

    function l() {
      a.call(this, "utf-8 encode")
    }
    e.utf8encode = function (t) {
      return s.nodebuffer ? i.newBufferFrom(t, "utf-8") : function (t) {
        var e, n, r, i, a, o = t.length,
          u = 0;
        for (i = 0; i < o; i++) 55296 == (64512 & (n = t.charCodeAt(i))) && i + 1 < o && 56320 == (64512 & (r = t.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++), u += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
        for (e = s.uint8array ? new Uint8Array(u) : new Array(u), a = 0, i = 0; a < u; i++) 55296 == (64512 & (n = t.charCodeAt(i))) && i + 1 < o && 56320 == (64512 & (r = t.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (r - 56320), i++), n < 128 ? e[a++] = n : n < 2048 ? (e[a++] = 192 | n >>> 6, e[a++] = 128 | 63 & n) : n < 65536 ? (e[a++] = 224 | n >>> 12, e[a++] = 128 | n >>> 6 & 63, e[a++] = 128 | 63 & n) : (e[a++] = 240 | n >>> 18, e[a++] = 128 | n >>> 12 & 63, e[a++] = 128 | n >>> 6 & 63, e[a++] = 128 | 63 & n);
        return e
      }(t)
    }, e.utf8decode = function (t) {
      return s.nodebuffer ? r.transformTo("nodebuffer", t).toString("utf-8") : function (t) {
        var e, n, s, i, a = t.length,
          u = new Array(2 * a);
        for (n = 0, e = 0; e < a;)
          if ((s = t[e++]) < 128) u[n++] = s;
          else if ((i = o[s]) > 4) u[n++] = 65533, e += i - 1;
        else {
          for (s &= 2 === i ? 31 : 3 === i ? 15 : 7; i > 1 && e < a;) s = s << 6 | 63 & t[e++], i--;
          i > 1 ? u[n++] = 65533 : s < 65536 ? u[n++] = s : (s -= 65536, u[n++] = 55296 | s >> 10 & 1023, u[n++] = 56320 | 1023 & s)
        }
        return u.length !== n && (u.subarray ? u = u.subarray(0, n) : u.length = n), r.applyFromCharCode(u)
      }(t = r.transformTo(s.uint8array ? "uint8array" : "array", t))
    }, r.inherits(c, a), c.prototype.processChunk = function (t) {
      var n = r.transformTo(s.uint8array ? "uint8array" : "array", t.data);
      if (this.leftOver && this.leftOver.length) {
        if (s.uint8array) {
          var i = n;
          (n = new Uint8Array(i.length + this.leftOver.length)).set(this.leftOver, 0), n.set(i, this.leftOver.length)
        } else n = this.leftOver.concat(n);
        this.leftOver = null
      }
      var a = function (t, e) {
          var n;
          for ((e = e || t.length) > t.length && (e = t.length), n = e - 1; n >= 0 && 128 == (192 & t[n]);) n--;
          return n < 0 ? e : 0 === n ? e : n + o[t[n]] > e ? n : e
        }(n),
        u = n;
      a !== n.length && (s.uint8array ? (u = n.subarray(0, a), this.leftOver = n.subarray(a, n.length)) : (u = n.slice(0, a), this.leftOver = n.slice(a, n.length))), this.push({
        data: e.utf8decode(u),
        meta: t.meta
      })
    }, c.prototype.flush = function () {
      this.leftOver && this.leftOver.length && (this.push({
        data: e.utf8decode(this.leftOver),
        meta: {}
      }), this.leftOver = null)
    }, e.Utf8DecodeWorker = c, r.inherits(l, a), l.prototype.processChunk = function (t) {
      this.push({
        data: e.utf8encode(t.data),
        meta: t.meta
      })
    }, e.Utf8EncodeWorker = l
  }, function (t, e) {
    "function" == typeof Object.create ? t.exports = function (t, e) {
      e && (t.super_ = e, t.prototype = Object.create(e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }))
    } : t.exports = function (t, e) {
      if (e) {
        t.super_ = e;
        var n = function () {};
        n.prototype = e.prototype, t.prototype = new n, t.prototype.constructor = t
      }
    }
  }, function (t, e) {
    t.exports = function (t) {
      return t.webpackPolyfill || (t.deprecate = function () {}, t.paths = [], t.children || (t.children = []), Object.defineProperty(t, "loaded", {
        enumerable: !0,
        get: function () {
          return t.l
        }
      }), Object.defineProperty(t, "id", {
        enumerable: !0,
        get: function () {
          return t.i
        }
      }), t.webpackPolyfill = 1), t
    }
  }, function (t, e) {
    (function (e) {
      t.exports = e
    }).call(this, {})
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      if (t)
        for (var e = 0; e < t.length; e++) t[e] = ~t[e];
      return t
    }

    function s(t) {
      if (t)
        for (var e = 0; e < t.length; e++) t[e] = ~t[e];
      return t
    }
    n.d(e, "b", (function () {
      return r
    })), n.d(e, "a", (function () {
      return s
    }))
  }, function (t, e, n) {
    (function (t) {
      function n(t) {
        return Object.prototype.toString.call(t)
      }
      e.isArray = function (t) {
        return Array.isArray ? Array.isArray(t) : "[object Array]" === n(t)
      }, e.isBoolean = function (t) {
        return "boolean" == typeof t
      }, e.isNull = function (t) {
        return null === t
      }, e.isNullOrUndefined = function (t) {
        return null == t
      }, e.isNumber = function (t) {
        return "number" == typeof t
      }, e.isString = function (t) {
        return "string" == typeof t
      }, e.isSymbol = function (t) {
        return "symbol" == typeof t
      }, e.isUndefined = function (t) {
        return void 0 === t
      }, e.isRegExp = function (t) {
        return "[object RegExp]" === n(t)
      }, e.isObject = function (t) {
        return "object" == typeof t && null !== t
      }, e.isDate = function (t) {
        return "[object Date]" === n(t)
      }, e.isError = function (t) {
        return "[object Error]" === n(t) || t instanceof Error
      }, e.isFunction = function (t) {
        return "function" == typeof t
      }, e.isPrimitive = function (t) {
        return null === t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || "symbol" == typeof t || void 0 === t
      }, e.isBuffer = t.isBuffer
    }).call(this, n(29).Buffer)
  }, function (t, e, n) {
    "use strict";
    var r = null;
    r = "undefined" != typeof Promise ? Promise : n(121), t.exports = {
      Promise: r
    }
  }, , , function (t, e, n) {
    "use strict";
    (function (t, r) {
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      let s;

      function i() {
        if (null == s) {
          let e;
          if ("undefined" != typeof window) e = window;
          else if (void 0 !== t) e = t;
          else if (void 0 !== r) e = r;
          else {
            if ("undefined" == typeof self) throw new Error("Could not find a global object");
            e = self
          }
          s = e
        }
        return s
      }

      function a(t, e) {
        const n = function () {
          const t = i();
          return null == t._tfGlobals && (t._tfGlobals = new Map), t._tfGlobals
        }();
        if (n.has(t)) return n.get(t); {
          const r = e();
          return n.set(t, r), n.get(t)
        }
      }
      n.d(e, "b", (function () {
        return i
      })), n.d(e, "a", (function () {
        return a
      }))
    }).call(this, n(25), n(32))
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = {
      float32: 4,
      float16: 2,
      int32: 4,
      uint16: 2,
      uint8: 1,
      bool: 1,
      complex64: 8
    }
  }, function (t, e, n) {
    "use strict";
    (function (e) {
      void 0 === e || !e.version || 0 === e.version.indexOf("v0.") || 0 === e.version.indexOf("v1.") && 0 !== e.version.indexOf("v1.8.") ? t.exports = {
        nextTick: function (t, n, r, s) {
          if ("function" != typeof t) throw new TypeError('"callback" argument must be a function');
          var i, a, o = arguments.length;
          switch (o) {
            case 0:
            case 1:
              return e.nextTick(t);
            case 2:
              return e.nextTick((function () {
                t.call(null, n)
              }));
            case 3:
              return e.nextTick((function () {
                t.call(null, n, r)
              }));
            case 4:
              return e.nextTick((function () {
                t.call(null, n, r, s)
              }));
            default:
              for (i = new Array(o - 1), a = 0; a < i.length;) i[a++] = arguments[a];
              return e.nextTick((function () {
                t.apply(null, i)
              }))
          }
        }
      } : t.exports = e
    }).call(this, n(32))
  }, function (t, e, n) {
    var r = n(29),
      s = r.Buffer;

    function i(t, e) {
      for (var n in t) e[n] = t[n]
    }

    function a(t, e, n) {
      return s(t, e, n)
    }
    s.from && s.alloc && s.allocUnsafe && s.allocUnsafeSlow ? t.exports = r : (i(r, e), e.Buffer = a), i(s, a), a.from = function (t, e, n) {
      if ("number" == typeof t) throw new TypeError("Argument must not be a number");
      return s(t, e, n)
    }, a.alloc = function (t, e, n) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      var r = s(t);
      return void 0 !== e ? "string" == typeof n ? r.fill(e, n) : r.fill(e) : r.fill(0), r
    }, a.allocUnsafe = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return s(t)
    }, a.allocUnsafeSlow = function (t) {
      if ("number" != typeof t) throw new TypeError("Argument must be a number");
      return r.SlowBuffer(t)
    }
  }, function (t, e, n) {
    "use strict";
    (function (e) {
      t.exports = {
        isNode: void 0 !== e,
        newBufferFrom: function (t, n) {
          if (e.from && e.from !== Uint8Array.from) return e.from(t, n);
          if ("number" == typeof t) throw new Error('The "data" argument must not be a number');
          return new e(t, n)
        },
        allocBuffer: function (t) {
          if (e.alloc) return e.alloc(t);
          var n = new e(t);
          return n.fill(0), n
        },
        isBuffer: function (t) {
          return e.isBuffer(t)
        },
        isStream: function (t) {
          return t && "function" == typeof t.on && "function" == typeof t.pause && "function" == typeof t.resume
        }
      }
    }).call(this, n(29).Buffer)
  }, function (t, e, n) {
    "use strict";

    function r() {
      if ("undefined" != typeof navigator && null != navigator) {
        const t = navigator.userAgent || navigator.vendor || window.opera;
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(t) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(t.substr(0, 4))
      }
      return !1
    }

    function s() {
      return "undefined" != typeof window && null != window.document || "undefined" != typeof WorkerGlobalScope
    }
    n.r(e), n.d(e, "isMobile", (function () {
      return r
    })), n.d(e, "isBrowser", (function () {
      return s
    }))
  }, function (t, e, n) {
    "use strict";

    function r() {
      if (!(this instanceof r)) return new r;
      if (arguments.length) throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
      this.files = {}, this.comment = null, this.root = "", this.clone = function () {
        var t = new r;
        for (var e in this) "function" != typeof this[e] && (t[e] = this[e]);
        return t
      }
    }
    r.prototype = n(106), r.prototype.loadAsync = n(139), r.support = n(28), r.defaults = n(67), r.version = "3.2.0", r.loadAsync = function (t, e) {
      return (new r).loadAsync(t, e)
    }, r.external = n(41), t.exports = r
  }, function (t, e, n) {
    "use strict";
    var r, s = "object" == typeof Reflect ? Reflect : null,
      i = s && "function" == typeof s.apply ? s.apply : function (t, e, n) {
        return Function.prototype.apply.call(t, e, n)
      };
    r = s && "function" == typeof s.ownKeys ? s.ownKeys : Object.getOwnPropertySymbols ? function (t) {
      return Object.getOwnPropertyNames(t).concat(Object.getOwnPropertySymbols(t))
    } : function (t) {
      return Object.getOwnPropertyNames(t)
    };
    var a = Number.isNaN || function (t) {
      return t != t
    };

    function o() {
      o.init.call(this)
    }
    t.exports = o, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
    var u = 10;

    function c(t) {
      return void 0 === t._maxListeners ? o.defaultMaxListeners : t._maxListeners
    }

    function l(t, e, n, r) {
      var s, i, a, o;
      if ("function" != typeof n) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
      if (void 0 === (i = t._events) ? (i = t._events = Object.create(null), t._eventsCount = 0) : (void 0 !== i.newListener && (t.emit("newListener", e, n.listener ? n.listener : n), i = t._events), a = i[e]), void 0 === a) a = i[e] = n, ++t._eventsCount;
      else if ("function" == typeof a ? a = i[e] = r ? [n, a] : [a, n] : r ? a.unshift(n) : a.push(n), (s = c(t)) > 0 && a.length > s && !a.warned) {
        a.warned = !0;
        var u = new Error("Possible EventEmitter memory leak detected. " + a.length + " " + String(e) + " listeners added. Use emitter.setMaxListeners() to increase limit");
        u.name = "MaxListenersExceededWarning", u.emitter = t, u.type = e, u.count = a.length, o = u, console && console.warn && console.warn(o)
      }
      return t
    }

    function h() {
      for (var t = [], e = 0; e < arguments.length; e++) t.push(arguments[e]);
      this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, i(this.listener, this.target, t))
    }

    function d(t, e, n) {
      var r = {
          fired: !1,
          wrapFn: void 0,
          target: t,
          type: e,
          listener: n
        },
        s = h.bind(r);
      return s.listener = n, r.wrapFn = s, s
    }

    function p(t, e, n) {
      var r = t._events;
      if (void 0 === r) return [];
      var s = r[e];
      return void 0 === s ? [] : "function" == typeof s ? n ? [s.listener || s] : [s] : n ? function (t) {
        for (var e = new Array(t.length), n = 0; n < e.length; ++n) e[n] = t[n].listener || t[n];
        return e
      }(s) : m(s, s.length)
    }

    function f(t) {
      var e = this._events;
      if (void 0 !== e) {
        var n = e[t];
        if ("function" == typeof n) return 1;
        if (void 0 !== n) return n.length
      }
      return 0
    }

    function m(t, e) {
      for (var n = new Array(e), r = 0; r < e; ++r) n[r] = t[r];
      return n
    }
    Object.defineProperty(o, "defaultMaxListeners", {
      enumerable: !0,
      get: function () {
        return u
      },
      set: function (t) {
        if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + t + ".");
        u = t
      }
    }), o.init = function () {
      void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0
    }, o.prototype.setMaxListeners = function (t) {
      if ("number" != typeof t || t < 0 || a(t)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + t + ".");
      return this._maxListeners = t, this
    }, o.prototype.getMaxListeners = function () {
      return c(this)
    }, o.prototype.emit = function (t) {
      for (var e = [], n = 1; n < arguments.length; n++) e.push(arguments[n]);
      var r = "error" === t,
        s = this._events;
      if (void 0 !== s) r = r && void 0 === s.error;
      else if (!r) return !1;
      if (r) {
        var a;
        if (e.length > 0 && (a = e[0]), a instanceof Error) throw a;
        var o = new Error("Unhandled error." + (a ? " (" + a.message + ")" : ""));
        throw o.context = a, o
      }
      var u = s[t];
      if (void 0 === u) return !1;
      if ("function" == typeof u) i(u, this, e);
      else {
        var c = u.length,
          l = m(u, c);
        for (n = 0; n < c; ++n) i(l[n], this, e)
      }
      return !0
    }, o.prototype.addListener = function (t, e) {
      return l(this, t, e, !1)
    }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function (t, e) {
      return l(this, t, e, !0)
    }, o.prototype.once = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.on(t, d(this, t, e)), this
    }, o.prototype.prependOnceListener = function (t, e) {
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      return this.prependListener(t, d(this, t, e)), this
    }, o.prototype.removeListener = function (t, e) {
      var n, r, s, i, a;
      if ("function" != typeof e) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
      if (void 0 === (r = this._events)) return this;
      if (void 0 === (n = r[t])) return this;
      if (n === e || n.listener === e) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[t], r.removeListener && this.emit("removeListener", t, n.listener || e));
      else if ("function" != typeof n) {
        for (s = -1, i = n.length - 1; i >= 0; i--)
          if (n[i] === e || n[i].listener === e) {
            a = n[i].listener, s = i;
            break
          } if (s < 0) return this;
        0 === s ? n.shift() : function (t, e) {
          for (; e + 1 < t.length; e++) t[e] = t[e + 1];
          t.pop()
        }(n, s), 1 === n.length && (r[t] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", t, a || e)
      }
      return this
    }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function (t) {
      var e, n, r;
      if (void 0 === (n = this._events)) return this;
      if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[t] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[t]), this;
      if (0 === arguments.length) {
        var s, i = Object.keys(n);
        for (r = 0; r < i.length; ++r) "removeListener" !== (s = i[r]) && this.removeAllListeners(s);
        return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this
      }
      if ("function" == typeof (e = n[t])) this.removeListener(t, e);
      else if (void 0 !== e)
        for (r = e.length - 1; r >= 0; r--) this.removeListener(t, e[r]);
      return this
    }, o.prototype.listeners = function (t) {
      return p(this, t, !0)
    }, o.prototype.rawListeners = function (t) {
      return p(this, t, !1)
    }, o.listenerCount = function (t, e) {
      return "function" == typeof t.listenerCount ? t.listenerCount(e) : f.call(t, e)
    }, o.prototype.listenerCount = f, o.prototype.eventNames = function () {
      return this._eventsCount > 0 ? r(this._events) : []
    }
  }, function (t, e, n) {
    (e = t.exports = n(60)).Stream = e, e.Readable = e, e.Writable = n(53), e.Duplex = n(33), e.Transform = n(64), e.PassThrough = n(115)
  }, function (t, e, n) {
    "use strict";
    (function (e, r, s) {
      var i = n(46);

      function a(t) {
        var e = this;
        this.next = null, this.entry = null, this.finish = function () {
          ! function (t, e, n) {
            var r = t.entry;
            t.entry = null;
            for (; r;) {
              var s = r.callback;
              e.pendingcb--, s(n), r = r.next
            }
            e.corkedRequestsFree ? e.corkedRequestsFree.next = t : e.corkedRequestsFree = t
          }(e, t)
        }
      }
      t.exports = y;
      var o, u = !e.browser && ["v0.10", "v0.9."].indexOf(e.version.slice(0, 5)) > -1 ? r : i.nextTick;
      y.WritableState = b;
      var c = n(40);
      c.inherits = n(36);
      var l = {
          deprecate: n(114)
        },
        h = n(61),
        d = n(47).Buffer,
        p = s.Uint8Array || function () {};
      var f, m = n(62);

      function g() {}

      function b(t, e) {
        o = o || n(33), t = t || {};
        var r = e instanceof o;
        this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.writableObjectMode);
        var s = t.highWaterMark,
          c = t.writableHighWaterMark,
          l = this.objectMode ? 16 : 16384;
        this.highWaterMark = s || 0 === s ? s : r && (c || 0 === c) ? c : l, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
        var h = !1 === t.decodeStrings;
        this.decodeStrings = !h, this.defaultEncoding = t.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function (t) {
          ! function (t, e) {
            var n = t._writableState,
              r = n.sync,
              s = n.writecb;
            if (function (t) {
                t.writing = !1, t.writecb = null, t.length -= t.writelen, t.writelen = 0
              }(n), e) ! function (t, e, n, r, s) {
              --e.pendingcb, n ? (i.nextTick(s, r), i.nextTick(_, t, e), t._writableState.errorEmitted = !0, t.emit("error", r)) : (s(r), t._writableState.errorEmitted = !0, t.emit("error", r), _(t, e))
            }(t, n, r, e, s);
            else {
              var a = O(n);
              a || n.corked || n.bufferProcessing || !n.bufferedRequest || x(t, n), r ? u(v, t, n, a, s) : v(t, n, a, s)
            }
          }(e, t)
        }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new a(this)
      }

      function y(t) {
        if (o = o || n(33), !(f.call(y, this) || this instanceof o)) return new y(t);
        this._writableState = new b(t, this), this.writable = !0, t && ("function" == typeof t.write && (this._write = t.write), "function" == typeof t.writev && (this._writev = t.writev), "function" == typeof t.destroy && (this._destroy = t.destroy), "function" == typeof t.final && (this._final = t.final)), h.call(this)
      }

      function w(t, e, n, r, s, i, a) {
        e.writelen = r, e.writecb = a, e.writing = !0, e.sync = !0, n ? t._writev(s, e.onwrite) : t._write(s, i, e.onwrite), e.sync = !1
      }

      function v(t, e, n, r) {
        n || function (t, e) {
          0 === e.length && e.needDrain && (e.needDrain = !1, t.emit("drain"))
        }(t, e), e.pendingcb--, r(), _(t, e)
      }

      function x(t, e) {
        e.bufferProcessing = !0;
        var n = e.bufferedRequest;
        if (t._writev && n && n.next) {
          var r = e.bufferedRequestCount,
            s = new Array(r),
            i = e.corkedRequestsFree;
          i.entry = n;
          for (var o = 0, u = !0; n;) s[o] = n, n.isBuf || (u = !1), n = n.next, o += 1;
          s.allBuffers = u, w(t, e, !0, e.length, s, "", i.finish), e.pendingcb++, e.lastBufferedRequest = null, i.next ? (e.corkedRequestsFree = i.next, i.next = null) : e.corkedRequestsFree = new a(e), e.bufferedRequestCount = 0
        } else {
          for (; n;) {
            var c = n.chunk,
              l = n.encoding,
              h = n.callback;
            if (w(t, e, !1, e.objectMode ? 1 : c.length, c, l, h), n = n.next, e.bufferedRequestCount--, e.writing) break
          }
          null === n && (e.lastBufferedRequest = null)
        }
        e.bufferedRequest = n, e.bufferProcessing = !1
      }

      function O(t) {
        return t.ending && 0 === t.length && null === t.bufferedRequest && !t.finished && !t.writing
      }

      function S(t, e) {
        t._final((function (n) {
          e.pendingcb--, n && t.emit("error", n), e.prefinished = !0, t.emit("prefinish"), _(t, e)
        }))
      }

      function _(t, e) {
        var n = O(e);
        return n && (! function (t, e) {
          e.prefinished || e.finalCalled || ("function" == typeof t._final ? (e.pendingcb++, e.finalCalled = !0, i.nextTick(S, t, e)) : (e.prefinished = !0, t.emit("prefinish")))
        }(t, e), 0 === e.pendingcb && (e.finished = !0, t.emit("finish"))), n
      }
      c.inherits(y, h), b.prototype.getBuffer = function () {
          for (var t = this.bufferedRequest, e = []; t;) e.push(t), t = t.next;
          return e
        },
        function () {
          try {
            Object.defineProperty(b.prototype, "buffer", {
              get: l.deprecate((function () {
                return this.getBuffer()
              }), "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
            })
          } catch (t) {}
        }(), "function" == typeof Symbol && Symbol.hasInstance && "function" == typeof Function.prototype[Symbol.hasInstance] ? (f = Function.prototype[Symbol.hasInstance], Object.defineProperty(y, Symbol.hasInstance, {
          value: function (t) {
            return !!f.call(this, t) || this === y && (t && t._writableState instanceof b)
          }
        })) : f = function (t) {
          return t instanceof this
        }, y.prototype.pipe = function () {
          this.emit("error", new Error("Cannot pipe, not readable"))
        }, y.prototype.write = function (t, e, n) {
          var r, s = this._writableState,
            a = !1,
            o = !s.objectMode && (r = t, d.isBuffer(r) || r instanceof p);
          return o && !d.isBuffer(t) && (t = function (t) {
            return d.from(t)
          }(t)), "function" == typeof e && (n = e, e = null), o ? e = "buffer" : e || (e = s.defaultEncoding), "function" != typeof n && (n = g), s.ended ? function (t, e) {
            var n = new Error("write after end");
            t.emit("error", n), i.nextTick(e, n)
          }(this, n) : (o || function (t, e, n, r) {
            var s = !0,
              a = !1;
            return null === n ? a = new TypeError("May not write null values to stream") : "string" == typeof n || void 0 === n || e.objectMode || (a = new TypeError("Invalid non-string/buffer chunk")), a && (t.emit("error", a), i.nextTick(r, a), s = !1), s
          }(this, s, t, n)) && (s.pendingcb++, a = function (t, e, n, r, s, i) {
            if (!n) {
              var a = function (t, e, n) {
                t.objectMode || !1 === t.decodeStrings || "string" != typeof e || (e = d.from(e, n));
                return e
              }(e, r, s);
              r !== a && (n = !0, s = "buffer", r = a)
            }
            var o = e.objectMode ? 1 : r.length;
            e.length += o;
            var u = e.length < e.highWaterMark;
            u || (e.needDrain = !0);
            if (e.writing || e.corked) {
              var c = e.lastBufferedRequest;
              e.lastBufferedRequest = {
                chunk: r,
                encoding: s,
                isBuf: n,
                callback: i,
                next: null
              }, c ? c.next = e.lastBufferedRequest : e.bufferedRequest = e.lastBufferedRequest, e.bufferedRequestCount += 1
            } else w(t, e, !1, o, r, s, i);
            return u
          }(this, s, o, t, e, n)), a
        }, y.prototype.cork = function () {
          this._writableState.corked++
        }, y.prototype.uncork = function () {
          var t = this._writableState;
          t.corked && (t.corked--, t.writing || t.corked || t.finished || t.bufferProcessing || !t.bufferedRequest || x(this, t))
        }, y.prototype.setDefaultEncoding = function (t) {
          if ("string" == typeof t && (t = t.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((t + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + t);
          return this._writableState.defaultEncoding = t, this
        }, Object.defineProperty(y.prototype, "writableHighWaterMark", {
          enumerable: !1,
          get: function () {
            return this._writableState.highWaterMark
          }
        }), y.prototype._write = function (t, e, n) {
          n(new Error("_write() is not implemented"))
        }, y.prototype._writev = null, y.prototype.end = function (t, e, n) {
          var r = this._writableState;
          "function" == typeof t ? (n = t, t = null, e = null) : "function" == typeof e && (n = e, e = null), null != t && this.write(t, e), r.corked && (r.corked = 1, this.uncork()), r.ending || r.finished || function (t, e, n) {
            e.ending = !0, _(t, e), n && (e.finished ? i.nextTick(n) : t.once("finish", n));
            e.ended = !0, t.writable = !1
          }(this, r, n)
        }, Object.defineProperty(y.prototype, "destroyed", {
          get: function () {
            return void 0 !== this._writableState && this._writableState.destroyed
          },
          set: function (t) {
            this._writableState && (this._writableState.destroyed = t)
          }
        }), y.prototype.destroy = m.destroy, y.prototype._undestroy = m.undestroy, y.prototype._destroy = function (t, e) {
          this.end(), e(t)
        }
    }).call(this, n(32), n(54).setImmediate, n(25))
  }, function (t, e, n) {
    (function (t) {
      var r = void 0 !== t && t || "undefined" != typeof self && self || window,
        s = Function.prototype.apply;

      function i(t, e) {
        this._id = t, this._clearFn = e
      }
      e.setTimeout = function () {
        return new i(s.call(setTimeout, r, arguments), clearTimeout)
      }, e.setInterval = function () {
        return new i(s.call(setInterval, r, arguments), clearInterval)
      }, e.clearTimeout = e.clearInterval = function (t) {
        t && t.close()
      }, i.prototype.unref = i.prototype.ref = function () {}, i.prototype.close = function () {
        this._clearFn.call(r, this._id)
      }, e.enroll = function (t, e) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = e
      }, e.unenroll = function (t) {
        clearTimeout(t._idleTimeoutId), t._idleTimeout = -1
      }, e._unrefActive = e.active = function (t) {
        clearTimeout(t._idleTimeoutId);
        var e = t._idleTimeout;
        e >= 0 && (t._idleTimeoutId = setTimeout((function () {
          t._onTimeout && t._onTimeout()
        }), e))
      }, n(113), e.setImmediate = "undefined" != typeof self && self.setImmediate || void 0 !== t && t.setImmediate || this && this.setImmediate, e.clearImmediate = "undefined" != typeof self && self.clearImmediate || void 0 !== t && t.clearImmediate || this && this.clearImmediate
    }).call(this, n(25))
  }, function (t, e, n) {
    "use strict";
    var r = n(41),
      s = n(68),
      i = n(69),
      a = n(70);
    i = n(69);

    function o(t, e, n, r, s) {
      this.compressedSize = t, this.uncompressedSize = e, this.crc32 = n, this.compression = r, this.compressedContent = s
    }
    o.prototype = {
      getContentWorker: function () {
        var t = new s(r.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new i("data_length")),
          e = this;
        return t.on("end", (function () {
          if (this.streamInfo.data_length !== e.uncompressedSize) throw new Error("Bug : uncompressed data size mismatch")
        })), t
      },
      getCompressedWorker: function () {
        return new s(r.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression)
      }
    }, o.createWorkerFrom = function (t, e, n) {
      return t.pipe(new a).pipe(new i("uncompressedSize")).pipe(e.compressWorker(n)).pipe(new i("compressedSize")).withStreamInfo("compression", e)
    }, t.exports = o
  }, function (t, e, n) {
    "use strict";
    var r = n(10);
    var s = function () {
      for (var t, e = [], n = 0; n < 256; n++) {
        t = n;
        for (var r = 0; r < 8; r++) t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
        e[n] = t
      }
      return e
    }();
    t.exports = function (t, e) {
      return void 0 !== t && t.length ? "string" !== r.getTypeOf(t) ? function (t, e, n, r) {
        var i = s,
          a = r + n;
        t ^= -1;
        for (var o = r; o < a; o++) t = t >>> 8 ^ i[255 & (t ^ e[o])];
        return -1 ^ t
      }(0 | e, t, t.length, 0) : function (t, e, n, r) {
        var i = s,
          a = r + n;
        t ^= -1;
        for (var o = r; o < a; o++) t = t >>> 8 ^ i[255 & (t ^ e.charCodeAt(o))];
        return -1 ^ t
      }(0 | e, t, t.length, 0) : 0
    }
  }, function (t, e, n) {
    "use strict";
    t.exports = {
      2: "need dictionary",
      1: "stream end",
      0: "",
      "-1": "file error",
      "-2": "stream error",
      "-3": "data error",
      "-4": "insufficient memory",
      "-5": "buffer error",
      "-6": "incompatible version"
    }
  }, function (t, e) {
    var n = {}.toString;
    t.exports = Array.isArray || function (t) {
      return "[object Array]" == n.call(t)
    }
  }, function (t, e, n) {
    t.exports = n(109)
  }, function (t, e, n) {
    "use strict";
    (function (e, r) {
      var s = n(46);
      t.exports = w;
      var i, a = n(58);
      w.ReadableState = y;
      n(51).EventEmitter;
      var o = function (t, e) {
          return t.listeners(e).length
        },
        u = n(61),
        c = n(47).Buffer,
        l = e.Uint8Array || function () {};
      var h = n(40);
      h.inherits = n(36);
      var d = n(110),
        p = void 0;
      p = d && d.debuglog ? d.debuglog("stream") : function () {};
      var f, m = n(111),
        g = n(62);
      h.inherits(w, u);
      var b = ["error", "close", "destroy", "pause", "resume"];

      function y(t, e) {
        t = t || {};
        var r = e instanceof(i = i || n(33));
        this.objectMode = !!t.objectMode, r && (this.objectMode = this.objectMode || !!t.readableObjectMode);
        var s = t.highWaterMark,
          a = t.readableHighWaterMark,
          o = this.objectMode ? 16 : 16384;
        this.highWaterMark = s || 0 === s ? s : r && (a || 0 === a) ? a : o, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new m, this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = t.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, t.encoding && (f || (f = n(63).StringDecoder), this.decoder = new f(t.encoding), this.encoding = t.encoding)
      }

      function w(t) {
        if (i = i || n(33), !(this instanceof w)) return new w(t);
        this._readableState = new y(t, this), this.readable = !0, t && ("function" == typeof t.read && (this._read = t.read), "function" == typeof t.destroy && (this._destroy = t.destroy)), u.call(this)
      }

      function v(t, e, n, r, s) {
        var i, a = t._readableState;
        null === e ? (a.reading = !1, function (t, e) {
          if (e.ended) return;
          if (e.decoder) {
            var n = e.decoder.end();
            n && n.length && (e.buffer.push(n), e.length += e.objectMode ? 1 : n.length)
          }
          e.ended = !0, _(t)
        }(t, a)) : (s || (i = function (t, e) {
          var n;
          r = e, c.isBuffer(r) || r instanceof l || "string" == typeof e || void 0 === e || t.objectMode || (n = new TypeError("Invalid non-string/buffer chunk"));
          var r;
          return n
        }(a, e)), i ? t.emit("error", i) : a.objectMode || e && e.length > 0 ? ("string" == typeof e || a.objectMode || Object.getPrototypeOf(e) === c.prototype || (e = function (t) {
          return c.from(t)
        }(e)), r ? a.endEmitted ? t.emit("error", new Error("stream.unshift() after end event")) : x(t, a, e, !0) : a.ended ? t.emit("error", new Error("stream.push() after EOF")) : (a.reading = !1, a.decoder && !n ? (e = a.decoder.write(e), a.objectMode || 0 !== e.length ? x(t, a, e, !1) : C(t, a)) : x(t, a, e, !1))) : r || (a.reading = !1));
        return function (t) {
          return !t.ended && (t.needReadable || t.length < t.highWaterMark || 0 === t.length)
        }(a)
      }

      function x(t, e, n, r) {
        e.flowing && 0 === e.length && !e.sync ? (t.emit("data", n), t.read(0)) : (e.length += e.objectMode ? 1 : n.length, r ? e.buffer.unshift(n) : e.buffer.push(n), e.needReadable && _(t)), C(t, e)
      }
      Object.defineProperty(w.prototype, "destroyed", {
        get: function () {
          return void 0 !== this._readableState && this._readableState.destroyed
        },
        set: function (t) {
          this._readableState && (this._readableState.destroyed = t)
        }
      }), w.prototype.destroy = g.destroy, w.prototype._undestroy = g.undestroy, w.prototype._destroy = function (t, e) {
        this.push(null), e(t)
      }, w.prototype.push = function (t, e) {
        var n, r = this._readableState;
        return r.objectMode ? n = !0 : "string" == typeof t && ((e = e || r.defaultEncoding) !== r.encoding && (t = c.from(t, e), e = ""), n = !0), v(this, t, e, !1, n)
      }, w.prototype.unshift = function (t) {
        return v(this, t, null, !0, !1)
      }, w.prototype.isPaused = function () {
        return !1 === this._readableState.flowing
      }, w.prototype.setEncoding = function (t) {
        return f || (f = n(63).StringDecoder), this._readableState.decoder = new f(t), this._readableState.encoding = t, this
      };
      var O = 8388608;

      function S(t, e) {
        return t <= 0 || 0 === e.length && e.ended ? 0 : e.objectMode ? 1 : t != t ? e.flowing && e.length ? e.buffer.head.data.length : e.length : (t > e.highWaterMark && (e.highWaterMark = function (t) {
          return t >= O ? t = O : (t--, t |= t >>> 1, t |= t >>> 2, t |= t >>> 4, t |= t >>> 8, t |= t >>> 16, t++), t
        }(t)), t <= e.length ? t : e.ended ? e.length : (e.needReadable = !0, 0))
      }

      function _(t) {
        var e = t._readableState;
        e.needReadable = !1, e.emittedReadable || (p("emitReadable", e.flowing), e.emittedReadable = !0, e.sync ? s.nextTick(k, t) : k(t))
      }

      function k(t) {
        p("emit readable"), t.emit("readable"), A(t)
      }

      function C(t, e) {
        e.readingMore || (e.readingMore = !0, s.nextTick(E, t, e))
      }

      function E(t, e) {
        for (var n = e.length; !e.reading && !e.flowing && !e.ended && e.length < e.highWaterMark && (p("maybeReadMore read 0"), t.read(0), n !== e.length);) n = e.length;
        e.readingMore = !1
      }

      function I(t) {
        p("readable nexttick read 0"), t.read(0)
      }

      function T(t, e) {
        e.reading || (p("resume read 0"), t.read(0)), e.resumeScheduled = !1, e.awaitDrain = 0, t.emit("resume"), A(t), e.flowing && !e.reading && t.read(0)
      }

      function A(t) {
        var e = t._readableState;
        for (p("flow", e.flowing); e.flowing && null !== t.read(););
      }

      function N(t, e) {
        return 0 === e.length ? null : (e.objectMode ? n = e.buffer.shift() : !t || t >= e.length ? (n = e.decoder ? e.buffer.join("") : 1 === e.buffer.length ? e.buffer.head.data : e.buffer.concat(e.length), e.buffer.clear()) : n = function (t, e, n) {
          var r;
          t < e.head.data.length ? (r = e.head.data.slice(0, t), e.head.data = e.head.data.slice(t)) : r = t === e.head.data.length ? e.shift() : n ? function (t, e) {
            var n = e.head,
              r = 1,
              s = n.data;
            t -= s.length;
            for (; n = n.next;) {
              var i = n.data,
                a = t > i.length ? i.length : t;
              if (a === i.length ? s += i : s += i.slice(0, t), 0 === (t -= a)) {
                a === i.length ? (++r, n.next ? e.head = n.next : e.head = e.tail = null) : (e.head = n, n.data = i.slice(a));
                break
              }++r
            }
            return e.length -= r, s
          }(t, e) : function (t, e) {
            var n = c.allocUnsafe(t),
              r = e.head,
              s = 1;
            r.data.copy(n), t -= r.data.length;
            for (; r = r.next;) {
              var i = r.data,
                a = t > i.length ? i.length : t;
              if (i.copy(n, n.length - t, 0, a), 0 === (t -= a)) {
                a === i.length ? (++s, r.next ? e.head = r.next : e.head = e.tail = null) : (e.head = r, r.data = i.slice(a));
                break
              }++s
            }
            return e.length -= s, n
          }(t, e);
          return r
        }(t, e.buffer, e.decoder), n);
        var n
      }

      function $(t) {
        var e = t._readableState;
        if (e.length > 0) throw new Error('"endReadable()" called on non-empty stream');
        e.endEmitted || (e.ended = !0, s.nextTick(R, e, t))
      }

      function R(t, e) {
        t.endEmitted || 0 !== t.length || (t.endEmitted = !0, e.readable = !1, e.emit("end"))
      }

      function j(t, e) {
        for (var n = 0, r = t.length; n < r; n++)
          if (t[n] === e) return n;
        return -1
      }
      w.prototype.read = function (t) {
        p("read", t), t = parseInt(t, 10);
        var e = this._readableState,
          n = t;
        if (0 !== t && (e.emittedReadable = !1), 0 === t && e.needReadable && (e.length >= e.highWaterMark || e.ended)) return p("read: emitReadable", e.length, e.ended), 0 === e.length && e.ended ? $(this) : _(this), null;
        if (0 === (t = S(t, e)) && e.ended) return 0 === e.length && $(this), null;
        var r, s = e.needReadable;
        return p("need readable", s), (0 === e.length || e.length - t < e.highWaterMark) && p("length less than watermark", s = !0), e.ended || e.reading ? p("reading or ended", s = !1) : s && (p("do read"), e.reading = !0, e.sync = !0, 0 === e.length && (e.needReadable = !0), this._read(e.highWaterMark), e.sync = !1, e.reading || (t = S(n, e))), null === (r = t > 0 ? N(t, e) : null) ? (e.needReadable = !0, t = 0) : e.length -= t, 0 === e.length && (e.ended || (e.needReadable = !0), n !== t && e.ended && $(this)), null !== r && this.emit("data", r), r
      }, w.prototype._read = function (t) {
        this.emit("error", new Error("_read() is not implemented"))
      }, w.prototype.pipe = function (t, e) {
        var n = this,
          i = this._readableState;
        switch (i.pipesCount) {
          case 0:
            i.pipes = t;
            break;
          case 1:
            i.pipes = [i.pipes, t];
            break;
          default:
            i.pipes.push(t)
        }
        i.pipesCount += 1, p("pipe count=%d opts=%j", i.pipesCount, e);
        var u = (!e || !1 !== e.end) && t !== r.stdout && t !== r.stderr ? l : w;

        function c(e, r) {
          p("onunpipe"), e === n && r && !1 === r.hasUnpiped && (r.hasUnpiped = !0, p("cleanup"), t.removeListener("close", b), t.removeListener("finish", y), t.removeListener("drain", h), t.removeListener("error", g), t.removeListener("unpipe", c), n.removeListener("end", l), n.removeListener("end", w), n.removeListener("data", m), d = !0, !i.awaitDrain || t._writableState && !t._writableState.needDrain || h())
        }

        function l() {
          p("onend"), t.end()
        }
        i.endEmitted ? s.nextTick(u) : n.once("end", u), t.on("unpipe", c);
        var h = function (t) {
          return function () {
            var e = t._readableState;
            p("pipeOnDrain", e.awaitDrain), e.awaitDrain && e.awaitDrain--, 0 === e.awaitDrain && o(t, "data") && (e.flowing = !0, A(t))
          }
        }(n);
        t.on("drain", h);
        var d = !1;
        var f = !1;

        function m(e) {
          p("ondata"), f = !1, !1 !== t.write(e) || f || ((1 === i.pipesCount && i.pipes === t || i.pipesCount > 1 && -1 !== j(i.pipes, t)) && !d && (p("false write response, pause", n._readableState.awaitDrain), n._readableState.awaitDrain++, f = !0), n.pause())
        }

        function g(e) {
          p("onerror", e), w(), t.removeListener("error", g), 0 === o(t, "error") && t.emit("error", e)
        }

        function b() {
          t.removeListener("finish", y), w()
        }

        function y() {
          p("onfinish"), t.removeListener("close", b), w()
        }

        function w() {
          p("unpipe"), n.unpipe(t)
        }
        return n.on("data", m),
          function (t, e, n) {
            if ("function" == typeof t.prependListener) return t.prependListener(e, n);
            t._events && t._events[e] ? a(t._events[e]) ? t._events[e].unshift(n) : t._events[e] = [n, t._events[e]] : t.on(e, n)
          }(t, "error", g), t.once("close", b), t.once("finish", y), t.emit("pipe", n), i.flowing || (p("pipe resume"), n.resume()), t
      }, w.prototype.unpipe = function (t) {
        var e = this._readableState,
          n = {
            hasUnpiped: !1
          };
        if (0 === e.pipesCount) return this;
        if (1 === e.pipesCount) return t && t !== e.pipes ? this : (t || (t = e.pipes), e.pipes = null, e.pipesCount = 0, e.flowing = !1, t && t.emit("unpipe", this, n), this);
        if (!t) {
          var r = e.pipes,
            s = e.pipesCount;
          e.pipes = null, e.pipesCount = 0, e.flowing = !1;
          for (var i = 0; i < s; i++) r[i].emit("unpipe", this, n);
          return this
        }
        var a = j(e.pipes, t);
        return -1 === a ? this : (e.pipes.splice(a, 1), e.pipesCount -= 1, 1 === e.pipesCount && (e.pipes = e.pipes[0]), t.emit("unpipe", this, n), this)
      }, w.prototype.on = function (t, e) {
        var n = u.prototype.on.call(this, t, e);
        if ("data" === t) !1 !== this._readableState.flowing && this.resume();
        else if ("readable" === t) {
          var r = this._readableState;
          r.endEmitted || r.readableListening || (r.readableListening = r.needReadable = !0, r.emittedReadable = !1, r.reading ? r.length && _(this) : s.nextTick(I, this))
        }
        return n
      }, w.prototype.addListener = w.prototype.on, w.prototype.resume = function () {
        var t = this._readableState;
        return t.flowing || (p("resume"), t.flowing = !0, function (t, e) {
          e.resumeScheduled || (e.resumeScheduled = !0, s.nextTick(T, t, e))
        }(this, t)), this
      }, w.prototype.pause = function () {
        return p("call pause flowing=%j", this._readableState.flowing), !1 !== this._readableState.flowing && (p("pause"), this._readableState.flowing = !1, this.emit("pause")), this
      }, w.prototype.wrap = function (t) {
        var e = this,
          n = this._readableState,
          r = !1;
        for (var s in t.on("end", (function () {
            if (p("wrapped end"), n.decoder && !n.ended) {
              var t = n.decoder.end();
              t && t.length && e.push(t)
            }
            e.push(null)
          })), t.on("data", (function (s) {
            (p("wrapped data"), n.decoder && (s = n.decoder.write(s)), n.objectMode && null == s) || (n.objectMode || s && s.length) && (e.push(s) || (r = !0, t.pause()))
          })), t) void 0 === this[s] && "function" == typeof t[s] && (this[s] = function (e) {
          return function () {
            return t[e].apply(t, arguments)
          }
        }(s));
        for (var i = 0; i < b.length; i++) t.on(b[i], this.emit.bind(this, b[i]));
        return this._read = function (e) {
          p("wrapped _read", e), r && (r = !1, t.resume())
        }, this
      }, Object.defineProperty(w.prototype, "readableHighWaterMark", {
        enumerable: !1,
        get: function () {
          return this._readableState.highWaterMark
        }
      }), w._fromList = N
    }).call(this, n(25), n(32))
  }, function (t, e, n) {
    t.exports = n(51).EventEmitter
  }, function (t, e, n) {
    "use strict";
    var r = n(46);

    function s(t, e) {
      t.emit("error", e)
    }
    t.exports = {
      destroy: function (t, e) {
        var n = this,
          i = this._readableState && this._readableState.destroyed,
          a = this._writableState && this._writableState.destroyed;
        return i || a ? (e ? e(t) : !t || this._writableState && this._writableState.errorEmitted || r.nextTick(s, this, t), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(t || null, (function (t) {
          !e && t ? (r.nextTick(s, n, t), n._writableState && (n._writableState.errorEmitted = !0)) : e && e(t)
        })), this)
      },
      undestroy: function () {
        this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1)
      }
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(47).Buffer,
      s = r.isEncoding || function (t) {
        switch ((t = "" + t) && t.toLowerCase()) {
          case "hex":
          case "utf8":
          case "utf-8":
          case "ascii":
          case "binary":
          case "base64":
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
          case "raw":
            return !0;
          default:
            return !1
        }
      };

    function i(t) {
      var e;
      switch (this.encoding = function (t) {
        var e = function (t) {
          if (!t) return "utf8";
          for (var e;;) switch (t) {
            case "utf8":
            case "utf-8":
              return "utf8";
            case "ucs2":
            case "ucs-2":
            case "utf16le":
            case "utf-16le":
              return "utf16le";
            case "latin1":
            case "binary":
              return "latin1";
            case "base64":
            case "ascii":
            case "hex":
              return t;
            default:
              if (e) return;
              t = ("" + t).toLowerCase(), e = !0
          }
        }(t);
        if ("string" != typeof e && (r.isEncoding === s || !s(t))) throw new Error("Unknown encoding: " + t);
        return e || t
      }(t), this.encoding) {
        case "utf16le":
          this.text = u, this.end = c, e = 4;
          break;
        case "utf8":
          this.fillLast = o, e = 4;
          break;
        case "base64":
          this.text = l, this.end = h, e = 3;
          break;
        default:
          return this.write = d, void(this.end = p)
      }
      this.lastNeed = 0, this.lastTotal = 0, this.lastChar = r.allocUnsafe(e)
    }

    function a(t) {
      return t <= 127 ? 0 : t >> 5 == 6 ? 2 : t >> 4 == 14 ? 3 : t >> 3 == 30 ? 4 : t >> 6 == 2 ? -1 : -2
    }

    function o(t) {
      var e = this.lastTotal - this.lastNeed,
        n = function (t, e, n) {
          if (128 != (192 & e[0])) return t.lastNeed = 0, "�";
          if (t.lastNeed > 1 && e.length > 1) {
            if (128 != (192 & e[1])) return t.lastNeed = 1, "�";
            if (t.lastNeed > 2 && e.length > 2 && 128 != (192 & e[2])) return t.lastNeed = 2, "�"
          }
        }(this, t);
      return void 0 !== n ? n : this.lastNeed <= t.length ? (t.copy(this.lastChar, e, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal)) : (t.copy(this.lastChar, e, 0, t.length), void(this.lastNeed -= t.length))
    }

    function u(t, e) {
      if ((t.length - e) % 2 == 0) {
        var n = t.toString("utf16le", e);
        if (n) {
          var r = n.charCodeAt(n.length - 1);
          if (r >= 55296 && r <= 56319) return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1], n.slice(0, -1)
        }
        return n
      }
      return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = t[t.length - 1], t.toString("utf16le", e, t.length - 1)
    }

    function c(t) {
      var e = t && t.length ? this.write(t) : "";
      if (this.lastNeed) {
        var n = this.lastTotal - this.lastNeed;
        return e + this.lastChar.toString("utf16le", 0, n)
      }
      return e
    }

    function l(t, e) {
      var n = (t.length - e) % 3;
      return 0 === n ? t.toString("base64", e) : (this.lastNeed = 3 - n, this.lastTotal = 3, 1 === n ? this.lastChar[0] = t[t.length - 1] : (this.lastChar[0] = t[t.length - 2], this.lastChar[1] = t[t.length - 1]), t.toString("base64", e, t.length - n))
    }

    function h(t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : e
    }

    function d(t) {
      return t.toString(this.encoding)
    }

    function p(t) {
      return t && t.length ? this.write(t) : ""
    }
    e.StringDecoder = i, i.prototype.write = function (t) {
      if (0 === t.length) return "";
      var e, n;
      if (this.lastNeed) {
        if (void 0 === (e = this.fillLast(t))) return "";
        n = this.lastNeed, this.lastNeed = 0
      } else n = 0;
      return n < t.length ? e ? e + this.text(t, n) : this.text(t, n) : e || ""
    }, i.prototype.end = function (t) {
      var e = t && t.length ? this.write(t) : "";
      return this.lastNeed ? e + "�" : e
    }, i.prototype.text = function (t, e) {
      var n = function (t, e, n) {
        var r = e.length - 1;
        if (r < n) return 0;
        var s = a(e[r]);
        if (s >= 0) return s > 0 && (t.lastNeed = s - 1), s;
        if (--r < n || -2 === s) return 0;
        if ((s = a(e[r])) >= 0) return s > 0 && (t.lastNeed = s - 2), s;
        if (--r < n || -2 === s) return 0;
        if ((s = a(e[r])) >= 0) return s > 0 && (2 === s ? s = 0 : t.lastNeed = s - 3), s;
        return 0
      }(this, t, e);
      if (!this.lastNeed) return t.toString("utf8", e);
      this.lastTotal = n;
      var r = t.length - (n - this.lastNeed);
      return t.copy(this.lastChar, 0, r), t.toString("utf8", e, r)
    }, i.prototype.fillLast = function (t) {
      if (this.lastNeed <= t.length) return t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
      t.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, t.length), this.lastNeed -= t.length
    }
  }, function (t, e, n) {
    "use strict";
    t.exports = a;
    var r = n(33),
      s = n(40);

    function i(t, e) {
      var n = this._transformState;
      n.transforming = !1;
      var r = n.writecb;
      if (!r) return this.emit("error", new Error("write callback called multiple times"));
      n.writechunk = null, n.writecb = null, null != e && this.push(e), r(t);
      var s = this._readableState;
      s.reading = !1, (s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark)
    }

    function a(t) {
      if (!(this instanceof a)) return new a(t);
      r.call(this, t), this._transformState = {
        afterTransform: i.bind(this),
        needTransform: !1,
        transforming: !1,
        writecb: null,
        writechunk: null,
        writeencoding: null
      }, this._readableState.needReadable = !0, this._readableState.sync = !1, t && ("function" == typeof t.transform && (this._transform = t.transform), "function" == typeof t.flush && (this._flush = t.flush)), this.on("prefinish", o)
    }

    function o() {
      var t = this;
      "function" == typeof this._flush ? this._flush((function (e, n) {
        u(t, e, n)
      })) : u(this, null, null)
    }

    function u(t, e, n) {
      if (e) return t.emit("error", e);
      if (null != n && t.push(n), t._writableState.length) throw new Error("Calling transform done when ws.length != 0");
      if (t._transformState.transforming) throw new Error("Calling transform done when still transforming");
      return t.push(null)
    }
    s.inherits = n(36), s.inherits(a, r), a.prototype.push = function (t, e) {
      return this._transformState.needTransform = !1, r.prototype.push.call(this, t, e)
    }, a.prototype._transform = function (t, e, n) {
      throw new Error("_transform() is not implemented")
    }, a.prototype._write = function (t, e, n) {
      var r = this._transformState;
      if (r.writecb = n, r.writechunk = t, r.writeencoding = e, !r.transforming) {
        var s = this._readableState;
        (r.needTransform || s.needReadable || s.length < s.highWaterMark) && this._read(s.highWaterMark)
      }
    }, a.prototype._read = function (t) {
      var e = this._transformState;
      null !== e.writechunk && e.writecb && !e.transforming ? (e.transforming = !0, this._transform(e.writechunk, e.writeencoding, e.afterTransform)) : e.needTransform = !0
    }, a.prototype._destroy = function (t, e) {
      var n = this;
      r.prototype._destroy.call(this, t, (function (t) {
        e(t), n.emit("close")
      }))
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(28),
      i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    e.encode = function (t) {
      for (var e, n, s, a, o, u, c, l = [], h = 0, d = t.length, p = d, f = "string" !== r.getTypeOf(t); h < t.length;) p = d - h, f ? (e = t[h++], n = h < d ? t[h++] : 0, s = h < d ? t[h++] : 0) : (e = t.charCodeAt(h++), n = h < d ? t.charCodeAt(h++) : 0, s = h < d ? t.charCodeAt(h++) : 0), a = e >> 2, o = (3 & e) << 4 | n >> 4, u = p > 1 ? (15 & n) << 2 | s >> 6 : 64, c = p > 2 ? 63 & s : 64, l.push(i.charAt(a) + i.charAt(o) + i.charAt(u) + i.charAt(c));
      return l.join("")
    }, e.decode = function (t) {
      var e, n, r, a, o, u, c = 0,
        l = 0;
      if ("data:" === t.substr(0, "data:".length)) throw new Error("Invalid base64 input, it looks like a data url.");
      var h, d = 3 * (t = t.replace(/[^A-Za-z0-9\+\/\=]/g, "")).length / 4;
      if (t.charAt(t.length - 1) === i.charAt(64) && d--, t.charAt(t.length - 2) === i.charAt(64) && d--, d % 1 != 0) throw new Error("Invalid base64 input, bad content length.");
      for (h = s.uint8array ? new Uint8Array(0 | d) : new Array(0 | d); c < t.length;) e = i.indexOf(t.charAt(c++)) << 2 | (a = i.indexOf(t.charAt(c++))) >> 4, n = (15 & a) << 4 | (o = i.indexOf(t.charAt(c++))) >> 2, r = (3 & o) << 6 | (u = i.indexOf(t.charAt(c++))), h[l++] = e, 64 !== o && (h[l++] = n), 64 !== u && (h[l++] = r);
      return h
    }
  }, function (t, e, n) {
    "use strict";
    (function (e) {
      var r = n(10),
        s = n(123),
        i = n(21),
        a = n(65),
        o = n(28),
        u = n(41),
        c = null;
      if (o.nodestream) try {
        c = n(124)
      } catch (t) {}

      function l(t, n) {
        return new u.Promise((function (s, i) {
          var o = [],
            u = t._internalType,
            c = t._outputType,
            l = t._mimeType;
          t.on("data", (function (t, e) {
            o.push(t), n && n(e)
          })).on("error", (function (t) {
            o = [], i(t)
          })).on("end", (function () {
            try {
              var t = function (t, e, n) {
                switch (t) {
                  case "blob":
                    return r.newBlob(r.transformTo("arraybuffer", e), n);
                  case "base64":
                    return a.encode(e);
                  default:
                    return r.transformTo(t, e)
                }
              }(c, function (t, n) {
                var r, s = 0,
                  i = null,
                  a = 0;
                for (r = 0; r < n.length; r++) a += n[r].length;
                switch (t) {
                  case "string":
                    return n.join("");
                  case "array":
                    return Array.prototype.concat.apply([], n);
                  case "uint8array":
                    for (i = new Uint8Array(a), r = 0; r < n.length; r++) i.set(n[r], s), s += n[r].length;
                    return i;
                  case "nodebuffer":
                    return e.concat(n);
                  default:
                    throw new Error("concat : unsupported type '" + t + "'")
                }
              }(u, o), l);
              s(t)
            } catch (t) {
              i(t)
            }
            o = []
          })).resume()
        }))
      }

      function h(t, e, n) {
        var a = e;
        switch (e) {
          case "blob":
          case "arraybuffer":
            a = "uint8array";
            break;
          case "base64":
            a = "string"
        }
        try {
          this._internalType = a, this._outputType = e, this._mimeType = n, r.checkSupport(a), this._worker = t.pipe(new s(a)), t.lock()
        } catch (t) {
          this._worker = new i("error"), this._worker.error(t)
        }
      }
      h.prototype = {
        accumulate: function (t) {
          return l(this, t)
        },
        on: function (t, e) {
          var n = this;
          return "data" === t ? this._worker.on(t, (function (t) {
            e.call(n, t.data, t.meta)
          })) : this._worker.on(t, (function () {
            r.delay(e, arguments, n)
          })), this
        },
        resume: function () {
          return r.delay(this._worker.resume, [], this._worker), this
        },
        pause: function () {
          return this._worker.pause(), this
        },
        toNodejsStream: function (t) {
          if (r.checkSupport("nodestream"), "nodebuffer" !== this._outputType) throw new Error(this._outputType + " is not supported by this method");
          return new c(this, {
            objectMode: "nodebuffer" !== this._outputType
          }, t)
        }
      }, t.exports = h
    }).call(this, n(29).Buffer)
  }, function (t, e, n) {
    "use strict";
    e.base64 = !1, e.binary = !1, e.dir = !1, e.createFolders = !0, e.date = null, e.compression = null, e.compressionOptions = null, e.comment = null, e.unixPermissions = null, e.dosPermissions = null
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(21);

    function i(t) {
      s.call(this, "DataWorker");
      var e = this;
      this.dataIsReady = !1, this.index = 0, this.max = 0, this.data = null, this.type = "", this._tickScheduled = !1, t.then((function (t) {
        e.dataIsReady = !0, e.data = t, e.max = t && t.length || 0, e.type = r.getTypeOf(t), e.isPaused || e._tickAndRepeat()
      }), (function (t) {
        e.error(t)
      }))
    }
    r.inherits(i, s), i.prototype.cleanUp = function () {
      s.prototype.cleanUp.call(this), this.data = null
    }, i.prototype.resume = function () {
      return !!s.prototype.resume.call(this) && (!this._tickScheduled && this.dataIsReady && (this._tickScheduled = !0, r.delay(this._tickAndRepeat, [], this)), !0)
    }, i.prototype._tickAndRepeat = function () {
      this._tickScheduled = !1, this.isPaused || this.isFinished || (this._tick(), this.isFinished || (r.delay(this._tickAndRepeat, [], this), this._tickScheduled = !0))
    }, i.prototype._tick = function () {
      if (this.isPaused || this.isFinished) return !1;
      var t = null,
        e = Math.min(this.max, this.index + 16384);
      if (this.index >= this.max) return this.end();
      switch (this.type) {
        case "string":
          t = this.data.substring(this.index, e);
          break;
        case "uint8array":
          t = this.data.subarray(this.index, e);
          break;
        case "array":
        case "nodebuffer":
          t = this.data.slice(this.index, e)
      }
      return this.index = e, this.push({
        data: t,
        meta: {
          percent: this.max ? this.index / this.max * 100 : 0
        }
      })
    }, t.exports = i
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(21);

    function i(t) {
      s.call(this, "DataLengthProbe for " + t), this.propName = t, this.withStreamInfo(t, 0)
    }
    r.inherits(i, s), i.prototype.processChunk = function (t) {
      if (t) {
        var e = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = e + t.data.length
      }
      s.prototype.processChunk.call(this, t)
    }, t.exports = i
  }, function (t, e, n) {
    "use strict";
    var r = n(21),
      s = n(56);

    function i() {
      r.call(this, "Crc32Probe"), this.withStreamInfo("crc32", 0)
    }
    n(10).inherits(i, r), i.prototype.processChunk = function (t) {
      this.streamInfo.crc32 = s(t.data, this.streamInfo.crc32 || 0), this.push(t)
    }, t.exports = i
  }, function (t, e, n) {
    "use strict";
    var r = n(21);
    e.STORE = {
      magic: "\0\0",
      compressWorker: function (t) {
        return new r("STORE compression")
      },
      uncompressWorker: function () {
        return new r("STORE decompression")
      }
    }, e.DEFLATE = n(127)
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t, e, n, r) {
      for (var s = 65535 & t | 0, i = t >>> 16 & 65535 | 0, a = 0; 0 !== n;) {
        n -= a = n > 2e3 ? 2e3 : n;
        do {
          i = i + (s = s + e[r++] | 0) | 0
        } while (--a);
        s %= 65521, i %= 65521
      }
      return s | i << 16 | 0
    }
  }, function (t, e, n) {
    "use strict";
    var r = function () {
      for (var t, e = [], n = 0; n < 256; n++) {
        t = n;
        for (var r = 0; r < 8; r++) t = 1 & t ? 3988292384 ^ t >>> 1 : t >>> 1;
        e[n] = t
      }
      return e
    }();
    t.exports = function (t, e, n, s) {
      var i = r,
        a = s + n;
      t ^= -1;
      for (var o = s; o < a; o++) t = t >>> 8 ^ i[255 & (t ^ e[o])];
      return -1 ^ t
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(30),
      s = !0,
      i = !0;
    try {
      String.fromCharCode.apply(null, [0])
    } catch (t) {
      s = !1
    }
    try {
      String.fromCharCode.apply(null, new Uint8Array(1))
    } catch (t) {
      i = !1
    }
    for (var a = new r.Buf8(256), o = 0; o < 256; o++) a[o] = o >= 252 ? 6 : o >= 248 ? 5 : o >= 240 ? 4 : o >= 224 ? 3 : o >= 192 ? 2 : 1;

    function u(t, e) {
      if (e < 65534 && (t.subarray && i || !t.subarray && s)) return String.fromCharCode.apply(null, r.shrinkBuf(t, e));
      for (var n = "", a = 0; a < e; a++) n += String.fromCharCode(t[a]);
      return n
    }
    a[254] = a[254] = 1, e.string2buf = function (t) {
      var e, n, s, i, a, o = t.length,
        u = 0;
      for (i = 0; i < o; i++) 55296 == (64512 & (n = t.charCodeAt(i))) && i + 1 < o && 56320 == (64512 & (s = t.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (s - 56320), i++), u += n < 128 ? 1 : n < 2048 ? 2 : n < 65536 ? 3 : 4;
      for (e = new r.Buf8(u), a = 0, i = 0; a < u; i++) 55296 == (64512 & (n = t.charCodeAt(i))) && i + 1 < o && 56320 == (64512 & (s = t.charCodeAt(i + 1))) && (n = 65536 + (n - 55296 << 10) + (s - 56320), i++), n < 128 ? e[a++] = n : n < 2048 ? (e[a++] = 192 | n >>> 6, e[a++] = 128 | 63 & n) : n < 65536 ? (e[a++] = 224 | n >>> 12, e[a++] = 128 | n >>> 6 & 63, e[a++] = 128 | 63 & n) : (e[a++] = 240 | n >>> 18, e[a++] = 128 | n >>> 12 & 63, e[a++] = 128 | n >>> 6 & 63, e[a++] = 128 | 63 & n);
      return e
    }, e.buf2binstring = function (t) {
      return u(t, t.length)
    }, e.binstring2buf = function (t) {
      for (var e = new r.Buf8(t.length), n = 0, s = e.length; n < s; n++) e[n] = t.charCodeAt(n);
      return e
    }, e.buf2string = function (t, e) {
      var n, r, s, i, o = e || t.length,
        c = new Array(2 * o);
      for (r = 0, n = 0; n < o;)
        if ((s = t[n++]) < 128) c[r++] = s;
        else if ((i = a[s]) > 4) c[r++] = 65533, n += i - 1;
      else {
        for (s &= 2 === i ? 31 : 3 === i ? 15 : 7; i > 1 && n < o;) s = s << 6 | 63 & t[n++], i--;
        i > 1 ? c[r++] = 65533 : s < 65536 ? c[r++] = s : (s -= 65536, c[r++] = 55296 | s >> 10 & 1023, c[r++] = 56320 | 1023 & s)
      }
      return u(c, r)
    }, e.utf8border = function (t, e) {
      var n;
      for ((e = e || t.length) > t.length && (e = t.length), n = e - 1; n >= 0 && 128 == (192 & t[n]);) n--;
      return n < 0 ? e : 0 === n ? e : n + a[t[n]] > e ? n : e
    }
  }, function (t, e, n) {
    "use strict";
    t.exports = function () {
      this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0
    }
  }, function (t, e, n) {
    "use strict";
    t.exports = {
      Z_NO_FLUSH: 0,
      Z_PARTIAL_FLUSH: 1,
      Z_SYNC_FLUSH: 2,
      Z_FULL_FLUSH: 3,
      Z_FINISH: 4,
      Z_BLOCK: 5,
      Z_TREES: 6,
      Z_OK: 0,
      Z_STREAM_END: 1,
      Z_NEED_DICT: 2,
      Z_ERRNO: -1,
      Z_STREAM_ERROR: -2,
      Z_DATA_ERROR: -3,
      Z_BUF_ERROR: -5,
      Z_NO_COMPRESSION: 0,
      Z_BEST_SPEED: 1,
      Z_BEST_COMPRESSION: 9,
      Z_DEFAULT_COMPRESSION: -1,
      Z_FILTERED: 1,
      Z_HUFFMAN_ONLY: 2,
      Z_RLE: 3,
      Z_FIXED: 4,
      Z_DEFAULT_STRATEGY: 0,
      Z_BINARY: 0,
      Z_TEXT: 1,
      Z_UNKNOWN: 2,
      Z_DEFLATED: 8
    }
  }, function (t, e, n) {
    "use strict";
    e.LOCAL_FILE_HEADER = "PK", e.CENTRAL_FILE_HEADER = "PK", e.CENTRAL_DIRECTORY_END = "PK", e.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK", e.ZIP64_CENTRAL_DIRECTORY_END = "PK", e.DATA_DESCRIPTOR = "PK\b"
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(28),
      i = n(79),
      a = n(141),
      o = n(142),
      u = n(81);
    t.exports = function (t) {
      var e = r.getTypeOf(t);
      return r.checkSupport(e), "string" !== e || s.uint8array ? "nodebuffer" === e ? new o(t) : s.uint8array ? new u(r.transformTo("uint8array", t)) : new i(r.transformTo("array", t)) : new a(t)
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(80);

    function s(t) {
      r.call(this, t);
      for (var e = 0; e < this.data.length; e++) t[e] = 255 & t[e]
    }
    n(10).inherits(s, r), s.prototype.byteAt = function (t) {
      return this.data[this.zero + t]
    }, s.prototype.lastIndexOfSignature = function (t) {
      for (var e = t.charCodeAt(0), n = t.charCodeAt(1), r = t.charCodeAt(2), s = t.charCodeAt(3), i = this.length - 4; i >= 0; --i)
        if (this.data[i] === e && this.data[i + 1] === n && this.data[i + 2] === r && this.data[i + 3] === s) return i - this.zero;
      return -1
    }, s.prototype.readAndCheckSignature = function (t) {
      var e = t.charCodeAt(0),
        n = t.charCodeAt(1),
        r = t.charCodeAt(2),
        s = t.charCodeAt(3),
        i = this.readData(4);
      return e === i[0] && n === i[1] && r === i[2] && s === i[3]
    }, s.prototype.readData = function (t) {
      if (this.checkOffset(t), 0 === t) return [];
      var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
      return this.index += t, e
    }, t.exports = s
  }, function (t, e, n) {
    "use strict";
    var r = n(10);

    function s(t) {
      this.data = t, this.length = t.length, this.index = 0, this.zero = 0
    }
    s.prototype = {
      checkOffset: function (t) {
        this.checkIndex(this.index + t)
      },
      checkIndex: function (t) {
        if (this.length < this.zero + t || t < 0) throw new Error("End of data reached (data length = " + this.length + ", asked index = " + t + "). Corrupted zip ?")
      },
      setIndex: function (t) {
        this.checkIndex(t), this.index = t
      },
      skip: function (t) {
        this.setIndex(this.index + t)
      },
      byteAt: function (t) {},
      readInt: function (t) {
        var e, n = 0;
        for (this.checkOffset(t), e = this.index + t - 1; e >= this.index; e--) n = (n << 8) + this.byteAt(e);
        return this.index += t, n
      },
      readString: function (t) {
        return r.transformTo("string", this.readData(t))
      },
      readData: function (t) {},
      lastIndexOfSignature: function (t) {},
      readAndCheckSignature: function (t) {},
      readDate: function () {
        var t = this.readInt(4);
        return new Date(Date.UTC(1980 + (t >> 25 & 127), (t >> 21 & 15) - 1, t >> 16 & 31, t >> 11 & 31, t >> 5 & 63, (31 & t) << 1))
      }
    }, t.exports = s
  }, function (t, e, n) {
    "use strict";
    var r = n(79);

    function s(t) {
      r.call(this, t)
    }
    n(10).inherits(s, r), s.prototype.readData = function (t) {
      if (this.checkOffset(t), 0 === t) return new Uint8Array(0);
      var e = this.data.subarray(this.zero + this.index, this.zero + this.index + t);
      return this.index += t, e
    }, t.exports = s
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      n.d(e, "a", (function () {
        return s
      }));
      /**
       * @license
       * Copyright 2017 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      const r = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : void 0 !== t ? t : t => t();

      function s() {
        return new Promise(t => r(() => t()))
      }
    }).call(this, n(54).setImmediate)
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "Add",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "AddV2",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "AddN",
      category: "arithmetic",
      inputs: [{
        start: 0,
        end: 0,
        name: "tensors",
        type: "tensors"
      }]
    }, {
      tfOpName: "BiasAdd",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Sub",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "RealDiv",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Div",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "DivNoNan",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "FloorDiv",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Mul",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Maximum",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }]
    }, {
      tfOpName: "Minimum",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }]
    }, {
      tfOpName: "Pow",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "SquaredDifference",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Mod",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "FloorMod",
      category: "arithmetic",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "Abs",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Acos",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Asin",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Atan",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Atan2",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "y",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Ceil",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "ClipByValue",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "clip_value_min",
        name: "clipValueMin",
        type: "number"
      }, {
        tfName: "clip_value_max",
        name: "clipValueMax",
        type: "number"
      }]
    }, {
      tfOpName: "Complex",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "real",
        type: "tensor"
      }, {
        start: 1,
        name: "imag",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "ComplexAbs",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Cos",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Cosh",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Elu",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Exp",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Floor",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Log",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Imag",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "Tout",
        name: "outputType",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Neg",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Real",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "Tout",
        name: "outputType",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Prelu",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "alpha",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Relu",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Relu6",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "clipValueMin",
        name: "clipValueMin",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "clipValueMax",
        name: "clipValueMax",
        type: "number",
        defaultValue: 6
      }]
    }, {
      tfOpName: "Selu",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Sigmoid",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Sin",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Sinh",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Sqrt",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Rsqrt",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Square",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Tan",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Tanh",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Sign",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Round",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Expm1",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Log1p",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Reciprocal",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Softplus",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Asinh",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Acosh",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Atanh",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Erf",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Prod",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axes",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool",
        notSupported: !0
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "LeakyRelu",
      category: "basic_math",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "alpha",
        name: "alpha",
        type: "number",
        defaultValue: .2
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "LoopCond",
      category: "control",
      inputs: [{
        start: 0,
        name: "pred",
        type: "tensor"
      }]
    }, {
      tfOpName: "Switch",
      category: "control",
      inputs: [{
        start: 0,
        name: "data",
        type: "tensor"
      }, {
        start: 1,
        name: "pred",
        type: "tensor"
      }]
    }, {
      tfOpName: "Merge",
      category: "control",
      inputs: [{
        start: 0,
        end: 0,
        name: "tensors",
        type: "tensors"
      }]
    }, {
      tfOpName: "Enter",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "frame_name",
        name: "frameName",
        type: "string"
      }, {
        tfName: "is_constant",
        name: "isConstant",
        type: "bool"
      }]
    }, {
      tfOpName: "Exit",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "NextIteration",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "TensorArrayV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "size",
        type: "number"
      }],
      attrs: [{
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }, {
        tfName: "element_shape",
        name: "elementShape",
        type: "shape"
      }, {
        tfName: "dynamic_size",
        name: "dynamicSize",
        type: "bool"
      }, {
        tfName: "clear_after_read",
        name: "clearAfterRead",
        type: "bool"
      }, {
        tfName: "identical_element_shapes",
        name: "identicalElementShapes",
        type: "bool"
      }, {
        tfName: "tensor_array_name",
        name: "name",
        type: "string"
      }]
    }, {
      tfOpName: "TensorArrayWriteV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "index",
        type: "number"
      }, {
        start: 2,
        name: "tensor",
        type: "tensor"
      }, {
        start: 3,
        name: "flowIn",
        type: "number"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "TensorArrayReadV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "index",
        type: "number"
      }, {
        start: 2,
        name: "flowIn",
        type: "number"
      }],
      attrs: [{
        tfName: "dtype",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "TensorArrayGatherV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "number[]"
      }, {
        start: 2,
        name: "flowIn",
        type: "number"
      }],
      attrs: [{
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }, {
        tfName: "element_shape",
        name: "elementShape",
        type: "shape"
      }]
    }, {
      tfOpName: "TensorArrayScatterV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "number[]"
      }, {
        start: 2,
        name: "tensor",
        type: "tensor"
      }, {
        start: 3,
        name: "flowIn",
        type: "number"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorArrayConcatV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "flowIn",
        type: "number"
      }],
      attrs: [{
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }, {
        tfName: "element_shape_except0",
        name: "elementShapeExcept0",
        type: "shape",
        notSupported: !0
      }]
    }, {
      tfOpName: "TensorArraySplitV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "tensor",
        type: "tensor"
      }, {
        start: 2,
        name: "lengths",
        type: "number[]"
      }, {
        start: 3,
        name: "flowIn",
        type: "number"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorArraySizeV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }, {
        start: 1,
        name: "flowIn",
        type: "number"
      }]
    }, {
      tfOpName: "TensorArrayCloseV3",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorArrayId",
        type: "tensor"
      }]
    }, {
      tfOpName: "StatelessIf",
      category: "control",
      inputs: [{
        start: 0,
        name: "cond",
        type: "tensor"
      }, {
        start: 1,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "then_branch",
        name: "thenBranch",
        type: "func"
      }, {
        tfName: "else_branch",
        name: "elseBranch",
        type: "func"
      }]
    }, {
      tfOpName: "If",
      category: "control",
      inputs: [{
        start: 0,
        name: "cond",
        type: "tensor"
      }, {
        start: 1,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "then_branch",
        name: "thenBranch",
        type: "func"
      }, {
        tfName: "else_branch",
        name: "elseBranch",
        type: "func"
      }]
    }, {
      tfOpName: "StatelessWhile",
      category: "control",
      inputs: [{
        start: 0,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "cond",
        name: "cond",
        type: "func"
      }, {
        tfName: "body",
        name: "body",
        type: "func"
      }]
    }, {
      tfOpName: "While",
      category: "control",
      inputs: [{
        start: 0,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "cond",
        name: "cond",
        type: "func"
      }, {
        tfName: "body",
        name: "body",
        type: "func"
      }]
    }, {
      tfOpName: "TensorListScatter",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "number[]"
      }, {
        start: 2,
        name: "elementShape",
        type: "shape"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListScatterV2",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "number[]"
      }, {
        start: 2,
        name: "elementShape",
        type: "shape"
      }, {
        start: 3,
        name: "numElements",
        type: "number"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListGather",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "number[]"
      }, {
        start: 2,
        name: "elementShape",
        type: "shape"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListGetItem",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }, {
        start: 1,
        name: "index",
        type: "number"
      }, {
        start: 2,
        name: "elementShape",
        type: "shape"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListSetItem",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }, {
        start: 1,
        name: "index",
        type: "number"
      }, {
        start: 2,
        name: "tensor",
        type: "tensor"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListReserve",
      category: "control",
      inputs: [{
        start: 0,
        name: "elementShape",
        type: "shape"
      }, {
        start: 1,
        name: "numElements",
        type: "number"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListFromTensor",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }, {
        start: 1,
        name: "elementShape",
        type: "shape"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListStack",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }, {
        start: 1,
        name: "elementShape",
        type: "shape"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }, {
        tfName: "num_elements",
        name: "numElements",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListSplit",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }, {
        start: 1,
        name: "elementShape",
        type: "shape"
      }, {
        start: 2,
        name: "lengths",
        type: "number[]"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListConcat",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }],
      attrs: [{
        tfName: "element_shape",
        name: "elementShape",
        type: "shape"
      }, {
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListPopBack",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }, {
        start: 1,
        name: "elementShape",
        type: "shape"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }, {
      tfOpName: "TensorListPushBack",
      category: "control",
      inputs: [{
        start: 0,
        name: "tensorListId",
        type: "tensor"
      }, {
        start: 1,
        name: "tensor",
        type: "tensor"
      }],
      attrs: [{
        tfName: "element_dtype",
        name: "elementDType",
        type: "dtype"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "AvgPool",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }, {
        tfName: "ksize",
        name: "kernelSize",
        type: "number[]"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "MaxPool",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }, {
        tfName: "ksize",
        name: "kernelSize",
        type: "number[]"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "MaxPoolWithArgmax",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "ksize",
        name: "kernelSize",
        type: "number[]"
      }, {
        tfName: "include_batch_in_index",
        name: "includeBatchInIndex",
        type: "bool"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "AvgPool3D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }, {
        tfName: "ksize",
        name: "kernelSize",
        type: "number[]"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "MaxPool3D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }, {
        tfName: "ksize",
        name: "kernelSize",
        type: "number[]"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Conv1D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }],
      attrs: [{
        tfName: "stride",
        name: "stride",
        type: "number"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NWC"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "dilation",
        name: "dilation",
        type: "number",
        defaultValue: 1
      }]
    }, {
      tfOpName: "Conv2D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "useCudnnOnGpu",
        name: "useCudnnOnGpu",
        type: "bool"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NHWC"
      }, {
        tfName: "explicit_paddings",
        name: "explicitPaddings",
        type: "number[]",
        defaultValue: []
      }, {
        tfName: "dilations",
        name: "dilations",
        type: "number[]"
      }]
    }, {
      tfOpName: "_FusedConv2D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }, {
        start: 2,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "num_args",
        name: "numArgs",
        type: "number"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "explicit_paddings",
        name: "explicitPaddings",
        type: "number[]",
        defaultValue: []
      }, {
        tfName: "use_cudnn_on_gpu",
        name: "useCudnnOnGpu",
        type: "bool",
        defaultValue: !0
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NHWC"
      }, {
        tfName: "dilations",
        name: "dilations",
        type: "number[]",
        defaultValue: [1, 1, 1, 1]
      }, {
        tfName: "fused_ops",
        name: "fusedOps",
        type: "string[]",
        defaultValue: []
      }, {
        tfName: "epsilon",
        name: "epsilon",
        type: "number",
        defaultValue: 1e-4
      }]
    }, {
      tfOpName: "Conv2DBackpropInput",
      category: "convolution",
      inputs: [{
        start: 2,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }, {
        start: 0,
        name: "outputShape",
        type: "number[]"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }, {
        tfName: "explicit_paddings",
        name: "explicitPaddings",
        type: "number[]",
        defaultValue: []
      }]
    }, {
      tfOpName: "DepthwiseConv2d",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "input",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NHWC"
      }, {
        tfName: "explicit_paddings",
        name: "explicitPaddings",
        type: "number[]",
        defaultValue: []
      }, {
        tfName: "dilations",
        name: "dilations",
        type: "number[]"
      }]
    }, {
      tfOpName: "DepthwiseConv2dNative",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "input",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NHWC"
      }, {
        tfName: "explicit_paddings",
        name: "explicitPaddings",
        type: "number[]",
        defaultValue: []
      }, {
        tfName: "dilations",
        name: "dilations",
        type: "number[]"
      }]
    }, {
      tfOpName: "FusedDepthwiseConv2dNative",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }, {
        start: 2,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "num_args",
        name: "numArgs",
        type: "number"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NHWC"
      }, {
        tfName: "dilations",
        name: "dilations",
        type: "number[]",
        defaultValue: [1, 1, 1, 1]
      }, {
        tfName: "fused_ops",
        name: "fusedOps",
        type: "string[]",
        defaultValue: []
      }]
    }, {
      tfOpName: "Conv3D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        defaultValue: "NHWC"
      }, {
        tfName: "dilations",
        name: "dilations",
        type: "number[]"
      }]
    }, {
      tfOpName: "Dilation2D",
      category: "convolution",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "filter",
        type: "tensor"
      }],
      attrs: [{
        tfName: "strides",
        name: "strides",
        type: "number[]"
      }, {
        tfName: "rates",
        name: "dilations",
        type: "number[]"
      }, {
        tfName: "padding",
        name: "pad",
        type: "string"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "Fill",
      category: "creation",
      inputs: [{
        start: 0,
        name: "shape",
        type: "number[]"
      }, {
        start: 1,
        name: "value",
        type: "number"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "LinSpace",
      category: "creation",
      inputs: [{
        start: 0,
        name: "start",
        type: "number"
      }, {
        start: 1,
        name: "stop",
        type: "number"
      }, {
        start: 2,
        name: "num",
        type: "number"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "OneHot",
      category: "creation",
      inputs: [{
        start: 0,
        name: "indices",
        type: "tensor"
      }, {
        start: 1,
        name: "depth",
        type: "number"
      }, {
        start: 2,
        name: "onValue",
        type: "number",
        defaultValue: 1
      }, {
        start: 3,
        name: "offValue",
        type: "number",
        defaultValue: 0
      }],
      attrs: [{
        tfName: "axis",
        name: "axis",
        type: "number",
        notSupported: !0
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Ones",
      category: "creation",
      inputs: [{
        start: 0,
        name: "shape",
        type: "number[]"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "OnesLike",
      category: "creation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "RandomUniform",
      category: "creation",
      inputs: [{
        start: 0,
        name: "shape",
        type: "number[]"
      }],
      attrs: [{
        tfName: "minval",
        name: "minval",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "maxval",
        name: "maxval",
        type: "number",
        defaultValue: 1
      }, {
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }, {
        tfName: "seed",
        name: "seed",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "seed2",
        name: "seed2",
        type: "number",
        defaultValue: 0,
        notSupported: !0
      }, {
        tfName: "T",
        name: "T",
        type: "number",
        notSupported: !0
      }]
    }, {
      tfOpName: "Range",
      category: "creation",
      inputs: [{
        start: 0,
        name: "start",
        type: "number"
      }, {
        start: 1,
        name: "stop",
        type: "number"
      }, {
        start: 2,
        name: "step",
        type: "number",
        defaultValue: 0
      }],
      attrs: [{
        tfName: "Tidx",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "TruncatedNormal",
      category: "creation",
      inputs: [{
        start: 0,
        name: "shape",
        type: "number[]"
      }],
      attrs: [{
        tfName: "means",
        name: "mean",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "stddev",
        name: "stdDev",
        type: "number",
        defaultValue: 1
      }, {
        tfName: "seed",
        name: "seed",
        type: "number"
      }, {
        tfName: "seed2",
        name: "seed2",
        type: "number",
        defaultValue: 0,
        notSupported: !0
      }, {
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }, {
        tfName: "T",
        name: "T",
        type: "number",
        notSupported: !0
      }]
    }, {
      tfOpName: "Zeros",
      category: "creation",
      inputs: [{
        start: 0,
        name: "shape",
        type: "number[]"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "ZerosLike",
      category: "creation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "Multinomial",
      category: "creation",
      inputs: [{
        start: 0,
        name: "logits",
        type: "tensor"
      }, {
        start: 1,
        name: "numSamples",
        type: "number"
      }],
      attrs: [{
        tfName: "seed",
        name: "seed",
        type: "number"
      }, {
        tfName: "seed2",
        name: "seed2",
        type: "number"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype"
      }, {
        tfName: "output_dtype",
        name: "output_dtype",
        type: "dtype"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "NonMaxSuppressionV2",
      category: "dynamic",
      inputs: [{
        start: 0,
        name: "boxes",
        type: "tensor"
      }, {
        start: 1,
        name: "scores",
        type: "tensor"
      }, {
        start: 2,
        name: "maxOutputSize",
        type: "number"
      }, {
        start: 3,
        name: "iouThreshold",
        type: "number"
      }]
    }, {
      tfOpName: "NonMaxSuppressionV3",
      category: "dynamic",
      inputs: [{
        start: 0,
        name: "boxes",
        type: "tensor"
      }, {
        start: 1,
        name: "scores",
        type: "tensor"
      }, {
        start: 2,
        name: "maxOutputSize",
        type: "number"
      }, {
        start: 3,
        name: "iouThreshold",
        type: "number"
      }, {
        start: 4,
        name: "scoreThreshold",
        type: "number"
      }]
    }, {
      tfOpName: "NonMaxSuppressionV4",
      category: "dynamic",
      inputs: [{
        start: 0,
        name: "boxes",
        type: "tensor"
      }, {
        start: 1,
        name: "scores",
        type: "tensor"
      }, {
        start: 2,
        name: "maxOutputSize",
        type: "number"
      }, {
        start: 3,
        name: "iouThreshold",
        type: "number"
      }, {
        start: 4,
        name: "scoreThreshold",
        type: "number"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "T_threshold",
        name: "threshold",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "pad_to_max_output_size",
        name: "padToMaxOutputSize",
        type: "bool"
      }]
    }, {
      tfOpName: "NonMaxSuppressionV5",
      category: "dynamic",
      inputs: [{
        start: 0,
        name: "boxes",
        type: "tensor"
      }, {
        start: 1,
        name: "scores",
        type: "tensor"
      }, {
        start: 2,
        name: "maxOutputSize",
        type: "number"
      }, {
        start: 3,
        name: "iouThreshold",
        type: "number"
      }, {
        start: 4,
        name: "scoreThreshold",
        type: "number"
      }, {
        start: 5,
        name: "softNmsSigma",
        type: "number"
      }]
    }, {
      tfOpName: "Where",
      category: "dynamic",
      inputs: [{
        start: 0,
        name: "condition",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "ListDiff",
      category: "dynamic",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "y",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "TopKV2",
      category: "evaluation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "k",
        type: "number"
      }],
      attrs: [{
        tfName: "sorted",
        name: "sorted",
        type: "bool"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "PlaceholderWithDefault",
      category: "graph",
      inputs: [{
        start: 0,
        name: "default",
        type: "tensor"
      }],
      attrs: [{
        tfName: "shape",
        name: "shape",
        type: "shape"
      }, {
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "Placeholder",
      category: "graph",
      attrs: [{
        tfName: "shape",
        name: "shape",
        type: "shape"
      }, {
        tfName: "dtype",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "Const",
      category: "graph"
    }, {
      tfOpName: "Identity",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "IdentityN",
      category: "graph",
      inputs: [{
        start: 0,
        end: 0,
        name: "x",
        type: "tensors"
      }]
    }, {
      tfOpName: "Snapshot",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "Rank",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "Size",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "Shape",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "ShapeN",
      category: "graph",
      inputs: [{
        start: 0,
        end: 0,
        name: "x",
        type: "tensors"
      }]
    }, {
      tfOpName: "Print",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "data",
        type: "tensors"
      }],
      attrs: [{
        tfName: "message",
        name: "message",
        type: "string"
      }, {
        tfName: "first_n",
        name: "firstN",
        type: "number",
        notSupported: !0
      }, {
        tfName: "summarize",
        name: "summarize",
        type: "number",
        defaultValue: 3
      }]
    }, {
      tfOpName: "NoOp",
      category: "graph",
      inputs: []
    }, {
      tfOpName: "StopGradient",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "FakeQuantWithMinMaxVars",
      category: "graph",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "min",
        name: "min",
        type: "number"
      }, {
        tfName: "max",
        name: "max",
        type: "number"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "ResizeBilinear",
      category: "image",
      inputs: [{
        start: 0,
        name: "images",
        type: "tensor"
      }, {
        start: 1,
        name: "size",
        type: "number[]"
      }],
      attrs: [{
        tfName: "align_corners",
        name: "alignCorners",
        type: "bool"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "ResizeNearestNeighbor",
      category: "image",
      inputs: [{
        start: 0,
        name: "images",
        type: "tensor"
      }, {
        start: 1,
        name: "size",
        type: "number[]"
      }],
      attrs: [{
        tfName: "align_corners",
        name: "alignCorners",
        type: "bool"
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "CropAndResize",
      category: "image",
      inputs: [{
        start: 0,
        name: "image",
        type: "tensor"
      }, {
        start: 1,
        name: "boxes",
        type: "tensor"
      }, {
        start: 2,
        name: "boxInd",
        type: "tensor"
      }, {
        start: 3,
        name: "cropSize",
        type: "number[]"
      }],
      attrs: [{
        tfName: "method",
        name: "method",
        type: "string"
      }, {
        tfName: "extrapolation_value",
        name: "extrapolationValue",
        type: "number"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "Equal",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "NotEqual",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Greater",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "GreaterEqual",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Less",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "LessEqual",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "LogicalAnd",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "LogicalNot",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "LogicalOr",
      category: "logical",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Select",
      category: "logical",
      inputs: [{
        start: 0,
        name: "condition",
        type: "tensor"
      }, {
        start: 1,
        name: "a",
        type: "tensor"
      }, {
        start: 2,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "SelectV2",
      category: "logical",
      inputs: [{
        start: 0,
        name: "condition",
        type: "tensor"
      }, {
        start: 1,
        name: "a",
        type: "tensor"
      }, {
        start: 2,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "_FusedMatMul",
      category: "matrices",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }, {
        start: 2,
        end: 0,
        name: "args",
        type: "tensors"
      }],
      attrs: [{
        tfName: "num_args",
        name: "numArgs",
        type: "number"
      }, {
        tfName: "fused_ops",
        name: "fusedOps",
        type: "string[]",
        defaultValue: []
      }, {
        tfName: "epsilon",
        name: "epsilon",
        type: "number",
        defaultValue: 1e-4
      }, {
        tfName: "transpose_a",
        name: "transposeA",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "transpose_b",
        name: "transposeB",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "MatMul",
      category: "matrices",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "transpose_a",
        name: "transposeA",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "transpose_b",
        name: "transposeB",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "BatchMatMul",
      category: "matrices",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "adj_x",
        name: "transposeA",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "adj_y",
        name: "transposeB",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "BatchMatMulV2",
      category: "matrices",
      inputs: [{
        start: 0,
        name: "a",
        type: "tensor"
      }, {
        start: 1,
        name: "b",
        type: "tensor"
      }],
      attrs: [{
        tfName: "adj_x",
        name: "transposeA",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "adj_y",
        name: "transposeB",
        type: "bool",
        defaultValue: !1
      }, {
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }, {
      tfOpName: "Transpose",
      category: "matrices",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "perm",
        type: "number[]"
      }],
      attrs: [{
        tfName: "T",
        name: "dtype",
        type: "dtype",
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "FusedBatchNorm",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "scale",
        type: "tensor"
      }, {
        start: 2,
        name: "offset",
        type: "tensor"
      }, {
        start: 3,
        name: "mean",
        type: "tensor"
      }, {
        start: 4,
        name: "variance",
        type: "tensor"
      }],
      attrs: [{
        tfName: "epsilon",
        name: "epsilon",
        type: "number",
        defaultValue: .001
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }]
    }, {
      tfOpName: "FusedBatchNormV2",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "scale",
        type: "tensor"
      }, {
        start: 2,
        name: "offset",
        type: "tensor"
      }, {
        start: 3,
        name: "mean",
        type: "tensor"
      }, {
        start: 4,
        name: "variance",
        type: "tensor"
      }],
      attrs: [{
        tfName: "epsilon",
        name: "epsilon",
        type: "number",
        defaultValue: .001
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }]
    }, {
      tfOpName: "FusedBatchNormV3",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "scale",
        type: "tensor"
      }, {
        start: 2,
        name: "offset",
        type: "tensor"
      }, {
        start: 3,
        name: "mean",
        type: "tensor"
      }, {
        start: 4,
        name: "variance",
        type: "tensor"
      }],
      attrs: [{
        tfName: "epsilon",
        name: "epsilon",
        type: "number",
        defaultValue: .001
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string",
        notSupported: !0
      }]
    }, {
      tfOpName: "LRN",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "depth_radius",
        name: "radius",
        type: "number",
        defaultValue: 5
      }, {
        tfName: "bias",
        name: "bias",
        type: "number",
        defaultValue: 1
      }, {
        tfName: "alpha",
        name: "alpha",
        type: "number",
        defaultValue: 1
      }, {
        tfName: "beta",
        name: "beta",
        type: "number",
        defaultValue: .5
      }]
    }, {
      tfOpName: "Softmax",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "LogSoftmax",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "SparseToDense",
      category: "normalization",
      inputs: [{
        start: 0,
        name: "sparseIndices",
        type: "tensor"
      }, {
        start: 1,
        name: "outputShape",
        type: "number[]"
      }, {
        start: 2,
        name: "sparseValues",
        type: "tensor"
      }, {
        start: 3,
        name: "defaultValue",
        type: "tensor"
      }],
      attrs: [{
        tfName: "validate_indices",
        name: "validateIndices",
        type: "bool",
        defaultValue: !0,
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "Max",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "Mean",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "Min",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "Sum",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "All",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "Any",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "ArgMax",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number"
      }]
    }, {
      tfOpName: "ArgMin",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number"
      }]
    }, {
      tfOpName: "Prod",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }],
      attrs: [{
        tfName: "keep_dims",
        name: "keepDims",
        type: "bool"
      }]
    }, {
      tfOpName: "Cumsum",
      category: "reduction",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number"
      }],
      attrs: [{
        tfName: "exclusive",
        name: "exclusive",
        type: "bool"
      }, {
        tfName: "reverse",
        name: "reverse",
        type: "bool"
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "ConcatV2",
      category: "slice_join",
      inputs: [{
        start: 0,
        end: -1,
        name: "tensors",
        type: "tensors"
      }, {
        start: -1,
        name: "axis",
        type: "number"
      }],
      attrs: [{
        tfName: "N",
        name: "n",
        type: "number",
        defaultValue: 2
      }]
    }, {
      tfOpName: "Concat",
      category: "slice_join",
      inputs: [{
        start: 1,
        end: 0,
        name: "tensors",
        type: "tensors"
      }, {
        start: 0,
        name: "axis",
        type: "number"
      }],
      attrs: [{
        tfName: "N",
        name: "n",
        type: "number",
        defaultValue: 2
      }]
    }, {
      tfOpName: "GatherV2",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "tensor"
      }, {
        start: 2,
        name: "axis",
        type: "number",
        defaultValue: 0
      }]
    }, {
      tfOpName: "Gather",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "tensor"
      }],
      attrs: [{
        tfName: "axis",
        name: "axis",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "validate_indices",
        name: "validateIndices",
        type: "bool",
        notSupported: !0
      }]
    }, {
      tfOpName: "Reverse",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "dims",
        type: "bool",
        notSupported: !0
      }]
    }, {
      tfOpName: "ReverseV2",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number[]"
      }]
    }, {
      tfOpName: "Slice",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "begin",
        type: "number[]"
      }, {
        start: 2,
        name: "size",
        type: "number[]"
      }]
    }, {
      tfOpName: "StridedSlice",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "begin",
        type: "number[]"
      }, {
        start: 2,
        name: "end",
        type: "number[]"
      }, {
        start: 3,
        name: "strides",
        type: "number[]"
      }],
      attrs: [{
        tfName: "begin_mask",
        name: "beginMask",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "end_mask",
        name: "endMask",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "new_axis_mask",
        name: "newAxisMask",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "ellipsis_mask",
        name: "ellipsisMask",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "shrink_axis_mask",
        name: "shrinkAxisMask",
        type: "number",
        defaultValue: 0
      }]
    }, {
      tfOpName: "Pack",
      category: "slice_join",
      inputs: [{
        start: 0,
        end: 0,
        name: "tensors",
        type: "tensors"
      }],
      attrs: [{
        tfName: "axis",
        name: "axis",
        type: "number",
        defaultValue: 0
      }]
    }, {
      tfOpName: "Unpack",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "tensor",
        type: "tensor"
      }],
      attrs: [{
        tfName: "axis",
        name: "axis",
        type: "number",
        defaultValue: 0
      }, {
        tfName: "num",
        name: "num",
        type: "number",
        defaultValue: 0,
        notSupported: !0
      }]
    }, {
      tfOpName: "Tile",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "reps",
        type: "number[]"
      }]
    }, {
      tfOpName: "Split",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "axis",
        type: "number",
        defaultValue: 0
      }, {
        start: 1,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "num_split",
        name: "numOrSizeSplits",
        type: "number",
        defaultValue: 1
      }]
    }, {
      tfOpName: "SplitV",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "numOrSizeSplits",
        type: "number[]"
      }, {
        start: 2,
        name: "axis",
        type: "number",
        defaultValue: 0
      }]
    }, {
      tfOpName: "ScatterNd",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "indices",
        type: "tensor"
      }, {
        start: 1,
        name: "values",
        type: "tensor"
      }, {
        start: 2,
        name: "shape",
        type: "number[]"
      }]
    }, {
      tfOpName: "GatherNd",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "indices",
        type: "tensor"
      }]
    }, {
      tfOpName: "SparseToDense",
      category: "slice_join",
      inputs: [{
        start: 0,
        name: "sparseIndices",
        type: "tensor"
      }, {
        start: 1,
        name: "outputShape",
        type: "number[]"
      }, {
        start: 2,
        name: "sparseValues",
        type: "tensor"
      }, {
        start: 3,
        name: "defaultValue",
        type: "tensor"
      }],
      attrs: [{
        tfName: "validate_indices",
        name: "validateIndices",
        type: "bool",
        defaultValue: !1,
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "FFT",
      category: "spectral",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "IFFT",
      category: "spectral",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }]
    }, {
      tfOpName: "RFFT",
      category: "spectral",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "fft_length",
        type: "number",
        notSupported: !0
      }]
    }, {
      tfOpName: "IRFFT",
      category: "spectral",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "fft_length",
        type: "number",
        notSupported: !0
      }]
    }]
  }, function (t, e, n) {
    "use strict";
    n.r(e), n.d(e, "json", (function () {
      return r
    }));
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const r = [{
      tfOpName: "Cast",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "SrcT",
        name: "sdtype",
        type: "dtype",
        notSupported: !0
      }, {
        tfName: "DstT",
        name: "dtype",
        type: "dtype"
      }]
    }, {
      tfOpName: "ExpandDims",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "axis",
        type: "number"
      }]
    }, {
      tfOpName: "Pad",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "padding",
        type: "number[]"
      }],
      attrs: [{
        tfName: "constant_value",
        name: "constantValue",
        type: "number",
        defaultValue: 0
      }]
    }, {
      tfOpName: "PadV2",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "padding",
        type: "number[]"
      }, {
        start: 2,
        name: "constantValue",
        type: "number",
        defaultValue: 0
      }]
    }, {
      tfOpName: "Reshape",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "shape",
        type: "number[]"
      }]
    }, {
      tfOpName: "Squeeze",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "axis",
        tfDeprecatedName: "squeeze_dims",
        name: "axis",
        type: "number[]"
      }]
    }, {
      tfOpName: "SpaceToBatchND",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "blockShape",
        type: "number[]"
      }, {
        start: 2,
        name: "paddings",
        type: "number[]"
      }]
    }, {
      tfOpName: "BatchToSpaceND",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "blockShape",
        type: "number[]"
      }, {
        start: 2,
        name: "crops",
        type: "number[]"
      }]
    }, {
      tfOpName: "DepthToSpace",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }],
      attrs: [{
        tfName: "block_size",
        name: "blockSize",
        type: "number"
      }, {
        tfName: "data_format",
        name: "dataFormat",
        type: "string"
      }]
    }, {
      tfOpName: "BroadcastTo",
      category: "transformation",
      inputs: [{
        start: 0,
        name: "x",
        type: "tensor"
      }, {
        start: 1,
        name: "shape",
        type: "number[]"
      }],
      attrs: []
    }]
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      n.d(e, "a", (function () {
        return a
      }));
      var r = n(0),
        s = n(13),
        i = n(100);
      /**
       * @license
       * Copyright 2018 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       *
       * =============================================================================
       */
      class a extends s.a {
        decodeUTF8() {
          return new o(this)
        }
      }
      class o extends i.a {
        constructor(t) {
          super(), this.upstream = t, this.impl = new u(t)
        }
        summary() {
          return this.impl.summary()
        }
        async next() {
          return this.impl.next()
        }
      }
      class u extends s.b {
        constructor(t) {
          if (super(), this.upstream = t, Object(r.vb)().get("IS_BROWSER")) this.decoder = new TextDecoder("utf-8");
          else {
            const {
              StringDecoder: t
            } = n(156);
            this.decoder = new t("utf8")
          }
        }
        summary() {
          return `${this.upstream.summary()} -> Utf8`
        }
        async pump() {
          const e = await this.upstream.next();
          let n, s;
          return !e.done && (n = e.value, s = Object(r.vb)().get("IS_BROWSER") ? this.decoder.decode(n, {
            stream: !0
          }) : this.decoder.write(t.from(n.buffer)), this.outputQueue.push(s), !0)
        }
      }
    }).call(this, n(29).Buffer)
  }, function (t, e, n) {
    "use strict";
    n.d(e, "a", (function () {
      return s
    }));
    var r = n(13);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    class s extends r.a {
      split(t) {
        return new i(this, t)
      }
    }
    class i extends s {
      constructor(t, e) {
        super(), this.upstream = t, this.impl = new a(t, e)
      }
      summary() {
        return this.impl.summary()
      }
      async next() {
        return this.impl.next()
      }
    }
    class a extends r.b {
      constructor(t, e) {
        super(), this.upstream = t, this.separator = e, this.carryover = ""
      }
      summary() {
        return `${this.upstream.summary()} -> Split('${this.separator}')`
      }
      async pump() {
        const t = await this.upstream.next();
        if (t.done) return "" !== this.carryover && (this.outputQueue.push(this.carryover), this.carryover = "", !0);
        const e = t.value.split(this.separator);
        e[0] = this.carryover + e[0];
        for (const t of e.slice(0, -1)) this.outputQueue.push(t);
        return this.carryover = e[e.length - 1], !0
      }
    }
  }, , , , , , function (t, e, n) {
    "use strict";
    var r = n(35),
      s = n(10),
      i = n(21),
      a = n(66),
      o = n(67),
      u = n(55),
      c = n(125),
      l = n(126),
      h = n(48),
      d = n(138),
      p = function (t, e, n) {
        var r, a = s.getTypeOf(e),
          l = s.extend(n || {}, o);
        l.date = l.date || new Date, null !== l.compression && (l.compression = l.compression.toUpperCase()), "string" == typeof l.unixPermissions && (l.unixPermissions = parseInt(l.unixPermissions, 8)), l.unixPermissions && 16384 & l.unixPermissions && (l.dir = !0), l.dosPermissions && 16 & l.dosPermissions && (l.dir = !0), l.dir && (t = m(t)), l.createFolders && (r = f(t)) && g.call(this, r, !0);
        var p = "string" === a && !1 === l.binary && !1 === l.base64;
        n && void 0 !== n.binary || (l.binary = !p), (e instanceof u && 0 === e.uncompressedSize || l.dir || !e || 0 === e.length) && (l.base64 = !1, l.binary = !0, e = "", l.compression = "STORE", a = "string");
        var b = null;
        b = e instanceof u || e instanceof i ? e : h.isNode && h.isStream(e) ? new d(t, e) : s.prepareContent(t, e, l.binary, l.optimizedBinaryString, l.base64);
        var y = new c(t, b, l);
        this.files[t] = y
      },
      f = function (t) {
        "/" === t.slice(-1) && (t = t.substring(0, t.length - 1));
        var e = t.lastIndexOf("/");
        return e > 0 ? t.substring(0, e) : ""
      },
      m = function (t) {
        return "/" !== t.slice(-1) && (t += "/"), t
      },
      g = function (t, e) {
        return e = void 0 !== e ? e : o.createFolders, t = m(t), this.files[t] || p.call(this, t, null, {
          dir: !0,
          createFolders: e
        }), this.files[t]
      };

    function b(t) {
      return "[object RegExp]" === Object.prototype.toString.call(t)
    }
    var y = {
      load: function () {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")
      },
      forEach: function (t) {
        var e, n, r;
        for (e in this.files) this.files.hasOwnProperty(e) && (r = this.files[e], (n = e.slice(this.root.length, e.length)) && e.slice(0, this.root.length) === this.root && t(n, r))
      },
      filter: function (t) {
        var e = [];
        return this.forEach((function (n, r) {
          t(n, r) && e.push(r)
        })), e
      },
      file: function (t, e, n) {
        if (1 === arguments.length) {
          if (b(t)) {
            var r = t;
            return this.filter((function (t, e) {
              return !e.dir && r.test(t)
            }))
          }
          var s = this.files[this.root + t];
          return s && !s.dir ? s : null
        }
        return (t = this.root + t, p.call(this, t, e, n), this)
      },
      folder: function (t) {
        if (!t) return this;
        if (b(t)) return this.filter((function (e, n) {
          return n.dir && t.test(e)
        }));
        var e = this.root + t,
          n = g.call(this, e),
          r = this.clone();
        return r.root = n.name, r
      },
      remove: function (t) {
        t = this.root + t;
        var e = this.files[t];
        if (e || ("/" !== t.slice(-1) && (t += "/"), e = this.files[t]), e && !e.dir) delete this.files[t];
        else
          for (var n = this.filter((function (e, n) {
              return n.name.slice(0, t.length) === t
            })), r = 0; r < n.length; r++) delete this.files[n[r].name];
        return this
      },
      generate: function (t) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")
      },
      generateInternalStream: function (t) {
        var e, n = {};
        try {
          if ((n = s.extend(t || {}, {
              streamFiles: !1,
              compression: "STORE",
              compressionOptions: null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: "application/zip",
              encodeFileName: r.utf8encode
            })).type = n.type.toLowerCase(), n.compression = n.compression.toUpperCase(), "binarystring" === n.type && (n.type = "string"), !n.type) throw new Error("No output type specified.");
          s.checkSupport(n.type), "darwin" !== n.platform && "freebsd" !== n.platform && "linux" !== n.platform && "sunos" !== n.platform || (n.platform = "UNIX"), "win32" === n.platform && (n.platform = "DOS");
          var o = n.comment || this.comment || "";
          e = l.generateWorker(this, n, o)
        } catch (t) {
          (e = new i("error")).error(t)
        }
        return new a(e, n.type || "string", n.mimeType)
      },
      generateAsync: function (t, e) {
        return this.generateInternalStream(t).accumulate(e)
      },
      generateNodeStream: function (t, e) {
        return (t = t || {}).type || (t.type = "nodebuffer"), this.generateInternalStream(t).toNodejsStream(e)
      }
    };
    t.exports = y
  }, function (t, e, n) {
    "use strict";
    e.byteLength = function (t) {
      var e = c(t),
        n = e[0],
        r = e[1];
      return 3 * (n + r) / 4 - r
    }, e.toByteArray = function (t) {
      var e, n, r = c(t),
        a = r[0],
        o = r[1],
        u = new i(function (t, e, n) {
          return 3 * (e + n) / 4 - n
        }(0, a, o)),
        l = 0,
        h = o > 0 ? a - 4 : a;
      for (n = 0; n < h; n += 4) e = s[t.charCodeAt(n)] << 18 | s[t.charCodeAt(n + 1)] << 12 | s[t.charCodeAt(n + 2)] << 6 | s[t.charCodeAt(n + 3)], u[l++] = e >> 16 & 255, u[l++] = e >> 8 & 255, u[l++] = 255 & e;
      2 === o && (e = s[t.charCodeAt(n)] << 2 | s[t.charCodeAt(n + 1)] >> 4, u[l++] = 255 & e);
      1 === o && (e = s[t.charCodeAt(n)] << 10 | s[t.charCodeAt(n + 1)] << 4 | s[t.charCodeAt(n + 2)] >> 2, u[l++] = e >> 8 & 255, u[l++] = 255 & e);
      return u
    }, e.fromByteArray = function (t) {
      for (var e, n = t.length, s = n % 3, i = [], a = 0, o = n - s; a < o; a += 16383) i.push(l(t, a, a + 16383 > o ? o : a + 16383));
      1 === s ? (e = t[n - 1], i.push(r[e >> 2] + r[e << 4 & 63] + "==")) : 2 === s && (e = (t[n - 2] << 8) + t[n - 1], i.push(r[e >> 10] + r[e >> 4 & 63] + r[e << 2 & 63] + "="));
      return i.join("")
    };
    for (var r = [], s = [], i = "undefined" != typeof Uint8Array ? Uint8Array : Array, a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", o = 0, u = a.length; o < u; ++o) r[o] = a[o], s[a.charCodeAt(o)] = o;

    function c(t) {
      var e = t.length;
      if (e % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
      var n = t.indexOf("=");
      return -1 === n && (n = e), [n, n === e ? 0 : 4 - n % 4]
    }

    function l(t, e, n) {
      for (var s, i, a = [], o = e; o < n; o += 3) s = (t[o] << 16 & 16711680) + (t[o + 1] << 8 & 65280) + (255 & t[o + 2]), a.push(r[(i = s) >> 18 & 63] + r[i >> 12 & 63] + r[i >> 6 & 63] + r[63 & i]);
      return a.join("")
    }
    s["-".charCodeAt(0)] = 62, s["_".charCodeAt(0)] = 63
  }, function (t, e) {
    e.read = function (t, e, n, r, s) {
      var i, a, o = 8 * s - r - 1,
        u = (1 << o) - 1,
        c = u >> 1,
        l = -7,
        h = n ? s - 1 : 0,
        d = n ? -1 : 1,
        p = t[e + h];
      for (h += d, i = p & (1 << -l) - 1, p >>= -l, l += o; l > 0; i = 256 * i + t[e + h], h += d, l -= 8);
      for (a = i & (1 << -l) - 1, i >>= -l, l += r; l > 0; a = 256 * a + t[e + h], h += d, l -= 8);
      if (0 === i) i = 1 - c;
      else {
        if (i === u) return a ? NaN : 1 / 0 * (p ? -1 : 1);
        a += Math.pow(2, r), i -= c
      }
      return (p ? -1 : 1) * a * Math.pow(2, i - r)
    }, e.write = function (t, e, n, r, s, i) {
      var a, o, u, c = 8 * i - s - 1,
        l = (1 << c) - 1,
        h = l >> 1,
        d = 23 === s ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        p = r ? 0 : i - 1,
        f = r ? 1 : -1,
        m = e < 0 || 0 === e && 1 / e < 0 ? 1 : 0;
      for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (o = isNaN(e) ? 1 : 0, a = l) : (a = Math.floor(Math.log(e) / Math.LN2), e * (u = Math.pow(2, -a)) < 1 && (a--, u *= 2), (e += a + h >= 1 ? d / u : d * Math.pow(2, 1 - h)) * u >= 2 && (a++, u /= 2), a + h >= l ? (o = 0, a = l) : a + h >= 1 ? (o = (e * u - 1) * Math.pow(2, s), a += h) : (o = e * Math.pow(2, h - 1) * Math.pow(2, s), a = 0)); s >= 8; t[n + p] = 255 & o, p += f, o /= 256, s -= 8);
      for (a = a << s | o, c += s; c > 0; t[n + p] = 255 & a, p += f, a /= 256, c -= 8);
      t[n + p - f] |= 128 * m
    }
  }, function (t, e, n) {
    t.exports = s;
    var r = n(51).EventEmitter;

    function s() {
      r.call(this)
    }
    n(36)(s, r), s.Readable = n(52), s.Writable = n(116), s.Duplex = n(117), s.Transform = n(118), s.PassThrough = n(119), s.Stream = s, s.prototype.pipe = function (t, e) {
      var n = this;

      function s(e) {
        t.writable && !1 === t.write(e) && n.pause && n.pause()
      }

      function i() {
        n.readable && n.resume && n.resume()
      }
      n.on("data", s), t.on("drain", i), t._isStdio || e && !1 === e.end || (n.on("end", o), n.on("close", u));
      var a = !1;

      function o() {
        a || (a = !0, t.end())
      }

      function u() {
        a || (a = !0, "function" == typeof t.destroy && t.destroy())
      }

      function c(t) {
        if (l(), 0 === r.listenerCount(this, "error")) throw t
      }

      function l() {
        n.removeListener("data", s), t.removeListener("drain", i), n.removeListener("end", o), n.removeListener("close", u), n.removeListener("error", c), t.removeListener("error", c), n.removeListener("end", l), n.removeListener("close", l), t.removeListener("close", l)
      }
      return n.on("error", c), t.on("error", c), n.on("end", l), n.on("close", l), t.on("close", l), t.emit("pipe", n), t
    }
  }, function (t, e) {}, function (t, e, n) {
    "use strict";
    var r = n(47).Buffer,
      s = n(112);
    t.exports = function () {
      function t() {
        ! function (t, e) {
          if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
        }(this, t), this.head = null, this.tail = null, this.length = 0
      }
      return t.prototype.push = function (t) {
        var e = {
          data: t,
          next: null
        };
        this.length > 0 ? this.tail.next = e : this.head = e, this.tail = e, ++this.length
      }, t.prototype.unshift = function (t) {
        var e = {
          data: t,
          next: this.head
        };
        0 === this.length && (this.tail = e), this.head = e, ++this.length
      }, t.prototype.shift = function () {
        if (0 !== this.length) {
          var t = this.head.data;
          return 1 === this.length ? this.head = this.tail = null : this.head = this.head.next, --this.length, t
        }
      }, t.prototype.clear = function () {
        this.head = this.tail = null, this.length = 0
      }, t.prototype.join = function (t) {
        if (0 === this.length) return "";
        for (var e = this.head, n = "" + e.data; e = e.next;) n += t + e.data;
        return n
      }, t.prototype.concat = function (t) {
        if (0 === this.length) return r.alloc(0);
        if (1 === this.length) return this.head.data;
        for (var e, n, s, i = r.allocUnsafe(t >>> 0), a = this.head, o = 0; a;) e = a.data, n = i, s = o, e.copy(n, s), o += a.data.length, a = a.next;
        return i
      }, t
    }(), s && s.inspect && s.inspect.custom && (t.exports.prototype[s.inspect.custom] = function () {
      var t = s.inspect({
        length: this.length
      });
      return this.constructor.name + " " + t
    })
  }, function (t, e) {}, function (t, e, n) {
    (function (t, e) {
      ! function (t, n) {
        "use strict";
        if (!t.setImmediate) {
          var r, s, i, a, o, u = 1,
            c = {},
            l = !1,
            h = t.document,
            d = Object.getPrototypeOf && Object.getPrototypeOf(t);
          d = d && d.setTimeout ? d : t, "[object process]" === {}.toString.call(t.process) ? r = function (t) {
            e.nextTick((function () {
              f(t)
            }))
          } : ! function () {
            if (t.postMessage && !t.importScripts) {
              var e = !0,
                n = t.onmessage;
              return t.onmessage = function () {
                e = !1
              }, t.postMessage("", "*"), t.onmessage = n, e
            }
          }() ? t.MessageChannel ? ((i = new MessageChannel).port1.onmessage = function (t) {
            f(t.data)
          }, r = function (t) {
            i.port2.postMessage(t)
          }) : h && "onreadystatechange" in h.createElement("script") ? (s = h.documentElement, r = function (t) {
            var e = h.createElement("script");
            e.onreadystatechange = function () {
              f(t), e.onreadystatechange = null, s.removeChild(e), e = null
            }, s.appendChild(e)
          }) : r = function (t) {
            setTimeout(f, 0, t)
          } : (a = "setImmediate$" + Math.random() + "$", o = function (e) {
            e.source === t && "string" == typeof e.data && 0 === e.data.indexOf(a) && f(+e.data.slice(a.length))
          }, t.addEventListener ? t.addEventListener("message", o, !1) : t.attachEvent("onmessage", o), r = function (e) {
            t.postMessage(a + e, "*")
          }), d.setImmediate = function (t) {
            "function" != typeof t && (t = new Function("" + t));
            for (var e = new Array(arguments.length - 1), n = 0; n < e.length; n++) e[n] = arguments[n + 1];
            var s = {
              callback: t,
              args: e
            };
            return c[u] = s, r(u), u++
          }, d.clearImmediate = p
        }

        function p(t) {
          delete c[t]
        }

        function f(t) {
          if (l) setTimeout(f, 0, t);
          else {
            var e = c[t];
            if (e) {
              l = !0;
              try {
                ! function (t) {
                  var e = t.callback,
                    r = t.args;
                  switch (r.length) {
                    case 0:
                      e();
                      break;
                    case 1:
                      e(r[0]);
                      break;
                    case 2:
                      e(r[0], r[1]);
                      break;
                    case 3:
                      e(r[0], r[1], r[2]);
                      break;
                    default:
                      e.apply(n, r)
                  }
                }(e)
              } finally {
                p(t), l = !1
              }
            }
          }
        }
      }("undefined" == typeof self ? void 0 === t ? this : t : self)
    }).call(this, n(25), n(32))
  }, function (t, e, n) {
    (function (e) {
      function n(t) {
        try {
          if (!e.localStorage) return !1
        } catch (t) {
          return !1
        }
        var n = e.localStorage[t];
        return null != n && "true" === String(n).toLowerCase()
      }
      t.exports = function (t, e) {
        if (n("noDeprecation")) return t;
        var r = !1;
        return function () {
          if (!r) {
            if (n("throwDeprecation")) throw new Error(e);
            n("traceDeprecation") ? console.trace(e) : console.warn(e), r = !0
          }
          return t.apply(this, arguments)
        }
      }
    }).call(this, n(25))
  }, function (t, e, n) {
    "use strict";
    t.exports = i;
    var r = n(64),
      s = n(40);

    function i(t) {
      if (!(this instanceof i)) return new i(t);
      r.call(this, t)
    }
    s.inherits = n(36), s.inherits(i, r), i.prototype._transform = function (t, e, n) {
      n(null, t)
    }
  }, function (t, e, n) {
    t.exports = n(53)
  }, function (t, e, n) {
    t.exports = n(33)
  }, function (t, e, n) {
    t.exports = n(52).Transform
  }, function (t, e, n) {
    t.exports = n(52).PassThrough
  }, function (t, e, n) {
    "use strict";
    (function (e) {
      t.exports = "function" == typeof e ? e : function () {
        var t = [].slice.apply(arguments);
        t.splice(1, 0, 0), setTimeout.apply(null, t)
      }
    }).call(this, n(54).setImmediate)
  }, function (t, e, n) {
    "use strict";
    var r = n(122);

    function s() {}
    var i = {},
      a = ["REJECTED"],
      o = ["FULFILLED"],
      u = ["PENDING"];

    function c(t) {
      if ("function" != typeof t) throw new TypeError("resolver must be a function");
      this.state = u, this.queue = [], this.outcome = void 0, t !== s && p(this, t)
    }

    function l(t, e, n) {
      this.promise = t, "function" == typeof e && (this.onFulfilled = e, this.callFulfilled = this.otherCallFulfilled), "function" == typeof n && (this.onRejected = n, this.callRejected = this.otherCallRejected)
    }

    function h(t, e, n) {
      r((function () {
        var r;
        try {
          r = e(n)
        } catch (e) {
          return i.reject(t, e)
        }
        r === t ? i.reject(t, new TypeError("Cannot resolve promise with itself")) : i.resolve(t, r)
      }))
    }

    function d(t) {
      var e = t && t.then;
      if (t && ("object" == typeof t || "function" == typeof t) && "function" == typeof e) return function () {
        e.apply(t, arguments)
      }
    }

    function p(t, e) {
      var n = !1;

      function r(e) {
        n || (n = !0, i.reject(t, e))
      }

      function s(e) {
        n || (n = !0, i.resolve(t, e))
      }
      var a = f((function () {
        e(s, r)
      }));
      "error" === a.status && r(a.value)
    }

    function f(t, e) {
      var n = {};
      try {
        n.value = t(e), n.status = "success"
      } catch (t) {
        n.status = "error", n.value = t
      }
      return n
    }
    t.exports = c, c.prototype.finally = function (t) {
      if ("function" != typeof t) return this;
      var e = this.constructor;
      return this.then((function (n) {
        return e.resolve(t()).then((function () {
          return n
        }))
      }), (function (n) {
        return e.resolve(t()).then((function () {
          throw n
        }))
      }))
    }, c.prototype.catch = function (t) {
      return this.then(null, t)
    }, c.prototype.then = function (t, e) {
      if ("function" != typeof t && this.state === o || "function" != typeof e && this.state === a) return this;
      var n = new this.constructor(s);
      this.state !== u ? h(n, this.state === o ? t : e, this.outcome) : this.queue.push(new l(n, t, e));
      return n
    }, l.prototype.callFulfilled = function (t) {
      i.resolve(this.promise, t)
    }, l.prototype.otherCallFulfilled = function (t) {
      h(this.promise, this.onFulfilled, t)
    }, l.prototype.callRejected = function (t) {
      i.reject(this.promise, t)
    }, l.prototype.otherCallRejected = function (t) {
      h(this.promise, this.onRejected, t)
    }, i.resolve = function (t, e) {
      var n = f(d, e);
      if ("error" === n.status) return i.reject(t, n.value);
      var r = n.value;
      if (r) p(t, r);
      else {
        t.state = o, t.outcome = e;
        for (var s = -1, a = t.queue.length; ++s < a;) t.queue[s].callFulfilled(e)
      }
      return t
    }, i.reject = function (t, e) {
      t.state = a, t.outcome = e;
      for (var n = -1, r = t.queue.length; ++n < r;) t.queue[n].callRejected(e);
      return t
    }, c.resolve = function (t) {
      if (t instanceof this) return t;
      return i.resolve(new this(s), t)
    }, c.reject = function (t) {
      var e = new this(s);
      return i.reject(e, t)
    }, c.all = function (t) {
      var e = this;
      if ("[object Array]" !== Object.prototype.toString.call(t)) return this.reject(new TypeError("must be an array"));
      var n = t.length,
        r = !1;
      if (!n) return this.resolve([]);
      var a = new Array(n),
        o = 0,
        u = -1,
        c = new this(s);
      for (; ++u < n;) l(t[u], u);
      return c;

      function l(t, s) {
        e.resolve(t).then((function (t) {
          a[s] = t, ++o !== n || r || (r = !0, i.resolve(c, a))
        }), (function (t) {
          r || (r = !0, i.reject(c, t))
        }))
      }
    }, c.race = function (t) {
      var e = this;
      if ("[object Array]" !== Object.prototype.toString.call(t)) return this.reject(new TypeError("must be an array"));
      var n = t.length,
        r = !1;
      if (!n) return this.resolve([]);
      var a = -1,
        o = new this(s);
      for (; ++a < n;) u = t[a], e.resolve(u).then((function (t) {
        r || (r = !0, i.resolve(o, t))
      }), (function (t) {
        r || (r = !0, i.reject(o, t))
      }));
      var u;
      return o
    }
  }, function (t, e, n) {
    "use strict";
    (function (e) {
      var n, r, s = e.MutationObserver || e.WebKitMutationObserver;
      if (s) {
        var i = 0,
          a = new s(l),
          o = e.document.createTextNode("");
        a.observe(o, {
          characterData: !0
        }), n = function () {
          o.data = i = ++i % 2
        }
      } else if (e.setImmediate || void 0 === e.MessageChannel) n = "document" in e && "onreadystatechange" in e.document.createElement("script") ? function () {
        var t = e.document.createElement("script");
        t.onreadystatechange = function () {
          l(), t.onreadystatechange = null, t.parentNode.removeChild(t), t = null
        }, e.document.documentElement.appendChild(t)
      } : function () {
        setTimeout(l, 0)
      };
      else {
        var u = new e.MessageChannel;
        u.port1.onmessage = l, n = function () {
          u.port2.postMessage(0)
        }
      }
      var c = [];

      function l() {
        var t, e;
        r = !0;
        for (var n = c.length; n;) {
          for (e = c, c = [], t = -1; ++t < n;) e[t]();
          n = c.length
        }
        r = !1
      }
      t.exports = function (t) {
        1 !== c.push(t) || r || n()
      }
    }).call(this, n(25))
  }, function (t, e, n) {
    "use strict";
    var r = n(21),
      s = n(10);

    function i(t) {
      r.call(this, "ConvertWorker to " + t), this.destType = t
    }
    s.inherits(i, r), i.prototype.processChunk = function (t) {
      this.push({
        data: s.transformTo(this.destType, t.data),
        meta: t.meta
      })
    }, t.exports = i
  }, function (t, e, n) {
    "use strict";
    var r = n(59).Readable;

    function s(t, e, n) {
      r.call(this, e), this._helper = t;
      var s = this;
      t.on("data", (function (t, e) {
        s.push(t) || s._helper.pause(), n && n(e)
      })).on("error", (function (t) {
        s.emit("error", t)
      })).on("end", (function () {
        s.push(null)
      }))
    }
    n(10).inherits(s, r), s.prototype._read = function () {
      this._helper.resume()
    }, t.exports = s
  }, function (t, e, n) {
    "use strict";
    var r = n(66),
      s = n(68),
      i = n(35),
      a = n(55),
      o = n(21),
      u = function (t, e, n) {
        this.name = t, this.dir = n.dir, this.date = n.date, this.comment = n.comment, this.unixPermissions = n.unixPermissions, this.dosPermissions = n.dosPermissions, this._data = e, this._dataBinary = n.binary, this.options = {
          compression: n.compression,
          compressionOptions: n.compressionOptions
        }
      };
    u.prototype = {
      internalStream: function (t) {
        var e = null,
          n = "string";
        try {
          if (!t) throw new Error("No output type specified.");
          var s = "string" === (n = t.toLowerCase()) || "text" === n;
          "binarystring" !== n && "text" !== n || (n = "string"), e = this._decompressWorker();
          var a = !this._dataBinary;
          a && !s && (e = e.pipe(new i.Utf8EncodeWorker)), !a && s && (e = e.pipe(new i.Utf8DecodeWorker))
        } catch (t) {
          (e = new o("error")).error(t)
        }
        return new r(e, n, "")
      },
      async: function (t, e) {
        return this.internalStream(t).accumulate(e)
      },
      nodeStream: function (t, e) {
        return this.internalStream(t || "nodebuffer").toNodejsStream(e)
      },
      _compressWorker: function (t, e) {
        if (this._data instanceof a && this._data.compression.magic === t.magic) return this._data.getCompressedWorker();
        var n = this._decompressWorker();
        return this._dataBinary || (n = n.pipe(new i.Utf8EncodeWorker)), a.createWorkerFrom(n, t, e)
      },
      _decompressWorker: function () {
        return this._data instanceof a ? this._data.getContentWorker() : this._data instanceof o ? this._data : new s(this._data)
      }
    };
    for (var c = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"], l = function () {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")
      }, h = 0; h < c.length; h++) u.prototype[c[h]] = l;
    t.exports = u
  }, function (t, e, n) {
    "use strict";
    var r = n(71),
      s = n(137);
    e.generateWorker = function (t, e, n) {
      var i = new s(e.streamFiles, n, e.platform, e.encodeFileName),
        a = 0;
      try {
        t.forEach((function (t, n) {
          a++;
          var s = function (t, e) {
              var n = t || e,
                s = r[n];
              if (!s) throw new Error(n + " is not a valid compression method !");
              return s
            }(n.options.compression, e.compression),
            o = n.options.compressionOptions || e.compressionOptions || {},
            u = n.dir,
            c = n.date;
          n._compressWorker(s, o).withStreamInfo("file", {
            name: t,
            dir: u,
            date: c,
            comment: n.comment || "",
            unixPermissions: n.unixPermissions,
            dosPermissions: n.dosPermissions
          }).pipe(i)
        })), i.entriesCount = a
      } catch (t) {
        i.error(t)
      }
      return i
    }
  }, function (t, e, n) {
    "use strict";
    var r = "undefined" != typeof Uint8Array && "undefined" != typeof Uint16Array && "undefined" != typeof Uint32Array,
      s = n(128),
      i = n(10),
      a = n(21),
      o = r ? "uint8array" : "array";

    function u(t, e) {
      a.call(this, "FlateWorker/" + t), this._pako = null, this._pakoAction = t, this._pakoOptions = e, this.meta = {}
    }
    e.magic = "\b\0", i.inherits(u, a), u.prototype.processChunk = function (t) {
      this.meta = t.meta, null === this._pako && this._createPako(), this._pako.push(i.transformTo(o, t.data), !1)
    }, u.prototype.flush = function () {
      a.prototype.flush.call(this), null === this._pako && this._createPako(), this._pako.push([], !0)
    }, u.prototype.cleanUp = function () {
      a.prototype.cleanUp.call(this), this._pako = null
    }, u.prototype._createPako = function () {
      this._pako = new s[this._pakoAction]({
        raw: !0,
        level: this._pakoOptions.level || -1
      });
      var t = this;
      this._pako.onData = function (e) {
        t.push({
          data: e,
          meta: t.meta
        })
      }
    }, e.compressWorker = function (t) {
      return new u("Deflate", t)
    }, e.uncompressWorker = function () {
      return new u("Inflate", {})
    }
  }, function (t, e, n) {
    "use strict";
    var r = {};
    (0, n(30).assign)(r, n(129), n(132), n(76)), t.exports = r
  }, function (t, e, n) {
    "use strict";
    var r = n(130),
      s = n(30),
      i = n(74),
      a = n(57),
      o = n(75),
      u = Object.prototype.toString,
      c = 0,
      l = -1,
      h = 0,
      d = 8;

    function p(t) {
      if (!(this instanceof p)) return new p(t);
      this.options = s.assign({
        level: l,
        method: d,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: h,
        to: ""
      }, t || {});
      var e = this.options;
      e.raw && e.windowBits > 0 ? e.windowBits = -e.windowBits : e.gzip && e.windowBits > 0 && e.windowBits < 16 && (e.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new o, this.strm.avail_out = 0;
      var n = r.deflateInit2(this.strm, e.level, e.method, e.windowBits, e.memLevel, e.strategy);
      if (n !== c) throw new Error(a[n]);
      if (e.header && r.deflateSetHeader(this.strm, e.header), e.dictionary) {
        var f;
        if (f = "string" == typeof e.dictionary ? i.string2buf(e.dictionary) : "[object ArrayBuffer]" === u.call(e.dictionary) ? new Uint8Array(e.dictionary) : e.dictionary, (n = r.deflateSetDictionary(this.strm, f)) !== c) throw new Error(a[n]);
        this._dict_set = !0
      }
    }

    function f(t, e) {
      var n = new p(e);
      if (n.push(t, !0), n.err) throw n.msg || a[n.err];
      return n.result
    }
    p.prototype.push = function (t, e) {
      var n, a, o = this.strm,
        l = this.options.chunkSize;
      if (this.ended) return !1;
      a = e === ~~e ? e : !0 === e ? 4 : 0, "string" == typeof t ? o.input = i.string2buf(t) : "[object ArrayBuffer]" === u.call(t) ? o.input = new Uint8Array(t) : o.input = t, o.next_in = 0, o.avail_in = o.input.length;
      do {
        if (0 === o.avail_out && (o.output = new s.Buf8(l), o.next_out = 0, o.avail_out = l), 1 !== (n = r.deflate(o, a)) && n !== c) return this.onEnd(n), this.ended = !0, !1;
        0 !== o.avail_out && (0 !== o.avail_in || 4 !== a && 2 !== a) || ("string" === this.options.to ? this.onData(i.buf2binstring(s.shrinkBuf(o.output, o.next_out))) : this.onData(s.shrinkBuf(o.output, o.next_out)))
      } while ((o.avail_in > 0 || 0 === o.avail_out) && 1 !== n);
      return 4 === a ? (n = r.deflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === c) : 2 !== a || (this.onEnd(c), o.avail_out = 0, !0)
    }, p.prototype.onData = function (t) {
      this.chunks.push(t)
    }, p.prototype.onEnd = function (t) {
      t === c && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = s.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg
    }, e.Deflate = p, e.deflate = f, e.deflateRaw = function (t, e) {
      return (e = e || {}).raw = !0, f(t, e)
    }, e.gzip = function (t, e) {
      return (e = e || {}).gzip = !0, f(t, e)
    }
  }, function (t, e, n) {
    "use strict";
    var r, s = n(30),
      i = n(131),
      a = n(72),
      o = n(73),
      u = n(57),
      c = 0,
      l = 1,
      h = 3,
      d = 4,
      p = 5,
      f = 0,
      m = 1,
      g = -2,
      b = -3,
      y = -5,
      w = -1,
      v = 1,
      x = 2,
      O = 3,
      S = 4,
      _ = 0,
      k = 2,
      C = 8,
      E = 9,
      I = 15,
      T = 8,
      A = 286,
      N = 30,
      $ = 19,
      R = 2 * A + 1,
      j = 15,
      D = 3,
      F = 258,
      M = F + D + 1,
      z = 32,
      L = 42,
      B = 69,
      P = 73,
      W = 91,
      U = 103,
      V = 113,
      H = 666,
      G = 1,
      q = 2,
      K = 3,
      J = 4,
      X = 3;

    function Y(t, e) {
      return t.msg = u[e], e
    }

    function Z(t) {
      return (t << 1) - (t > 4 ? 9 : 0)
    }

    function Q(t) {
      for (var e = t.length; --e >= 0;) t[e] = 0
    }

    function tt(t) {
      var e = t.state,
        n = e.pending;
      n > t.avail_out && (n = t.avail_out), 0 !== n && (s.arraySet(t.output, e.pending_buf, e.pending_out, n, t.next_out), t.next_out += n, e.pending_out += n, t.total_out += n, t.avail_out -= n, e.pending -= n, 0 === e.pending && (e.pending_out = 0))
    }

    function et(t, e) {
      i._tr_flush_block(t, t.block_start >= 0 ? t.block_start : -1, t.strstart - t.block_start, e), t.block_start = t.strstart, tt(t.strm)
    }

    function nt(t, e) {
      t.pending_buf[t.pending++] = e
    }

    function rt(t, e) {
      t.pending_buf[t.pending++] = e >>> 8 & 255, t.pending_buf[t.pending++] = 255 & e
    }

    function st(t, e) {
      var n, r, s = t.max_chain_length,
        i = t.strstart,
        a = t.prev_length,
        o = t.nice_match,
        u = t.strstart > t.w_size - M ? t.strstart - (t.w_size - M) : 0,
        c = t.window,
        l = t.w_mask,
        h = t.prev,
        d = t.strstart + F,
        p = c[i + a - 1],
        f = c[i + a];
      t.prev_length >= t.good_match && (s >>= 2), o > t.lookahead && (o = t.lookahead);
      do {
        if (c[(n = e) + a] === f && c[n + a - 1] === p && c[n] === c[i] && c[++n] === c[i + 1]) {
          i += 2, n++;
          do {} while (c[++i] === c[++n] && c[++i] === c[++n] && c[++i] === c[++n] && c[++i] === c[++n] && c[++i] === c[++n] && c[++i] === c[++n] && c[++i] === c[++n] && c[++i] === c[++n] && i < d);
          if (r = F - (d - i), i = d - F, r > a) {
            if (t.match_start = e, a = r, r >= o) break;
            p = c[i + a - 1], f = c[i + a]
          }
        }
      } while ((e = h[e & l]) > u && 0 != --s);
      return a <= t.lookahead ? a : t.lookahead
    }

    function it(t) {
      var e, n, r, i, u, c, l, h, d, p, f = t.w_size;
      do {
        if (i = t.window_size - t.lookahead - t.strstart, t.strstart >= f + (f - M)) {
          s.arraySet(t.window, t.window, f, f, 0), t.match_start -= f, t.strstart -= f, t.block_start -= f, e = n = t.hash_size;
          do {
            r = t.head[--e], t.head[e] = r >= f ? r - f : 0
          } while (--n);
          e = n = f;
          do {
            r = t.prev[--e], t.prev[e] = r >= f ? r - f : 0
          } while (--n);
          i += f
        }
        if (0 === t.strm.avail_in) break;
        if (c = t.strm, l = t.window, h = t.strstart + t.lookahead, d = i, p = void 0, (p = c.avail_in) > d && (p = d), n = 0 === p ? 0 : (c.avail_in -= p, s.arraySet(l, c.input, c.next_in, p, h), 1 === c.state.wrap ? c.adler = a(c.adler, l, p, h) : 2 === c.state.wrap && (c.adler = o(c.adler, l, p, h)), c.next_in += p, c.total_in += p, p), t.lookahead += n, t.lookahead + t.insert >= D)
          for (u = t.strstart - t.insert, t.ins_h = t.window[u], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[u + 1]) & t.hash_mask; t.insert && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[u + D - 1]) & t.hash_mask, t.prev[u & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = u, u++, t.insert--, !(t.lookahead + t.insert < D)););
      } while (t.lookahead < M && 0 !== t.strm.avail_in)
    }

    function at(t, e) {
      for (var n, r;;) {
        if (t.lookahead < M) {
          if (it(t), t.lookahead < M && e === c) return G;
          if (0 === t.lookahead) break
        }
        if (n = 0, t.lookahead >= D && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), 0 !== n && t.strstart - n <= t.w_size - M && (t.match_length = st(t, n)), t.match_length >= D)
          if (r = i._tr_tally(t, t.strstart - t.match_start, t.match_length - D), t.lookahead -= t.match_length, t.match_length <= t.max_lazy_match && t.lookahead >= D) {
            t.match_length--;
            do {
              t.strstart++, t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart
            } while (0 != --t.match_length);
            t.strstart++
          } else t.strstart += t.match_length, t.match_length = 0, t.ins_h = t.window[t.strstart], t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + 1]) & t.hash_mask;
        else r = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++;
        if (r && (et(t, !1), 0 === t.strm.avail_out)) return G
      }
      return t.insert = t.strstart < D - 1 ? t.strstart : D - 1, e === d ? (et(t, !0), 0 === t.strm.avail_out ? K : J) : t.last_lit && (et(t, !1), 0 === t.strm.avail_out) ? G : q
    }

    function ot(t, e) {
      for (var n, r, s;;) {
        if (t.lookahead < M) {
          if (it(t), t.lookahead < M && e === c) return G;
          if (0 === t.lookahead) break
        }
        if (n = 0, t.lookahead >= D && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart), t.prev_length = t.match_length, t.prev_match = t.match_start, t.match_length = D - 1, 0 !== n && t.prev_length < t.max_lazy_match && t.strstart - n <= t.w_size - M && (t.match_length = st(t, n), t.match_length <= 5 && (t.strategy === v || t.match_length === D && t.strstart - t.match_start > 4096) && (t.match_length = D - 1)), t.prev_length >= D && t.match_length <= t.prev_length) {
          s = t.strstart + t.lookahead - D, r = i._tr_tally(t, t.strstart - 1 - t.prev_match, t.prev_length - D), t.lookahead -= t.prev_length - 1, t.prev_length -= 2;
          do {
            ++t.strstart <= s && (t.ins_h = (t.ins_h << t.hash_shift ^ t.window[t.strstart + D - 1]) & t.hash_mask, n = t.prev[t.strstart & t.w_mask] = t.head[t.ins_h], t.head[t.ins_h] = t.strstart)
          } while (0 != --t.prev_length);
          if (t.match_available = 0, t.match_length = D - 1, t.strstart++, r && (et(t, !1), 0 === t.strm.avail_out)) return G
        } else if (t.match_available) {
          if ((r = i._tr_tally(t, 0, t.window[t.strstart - 1])) && et(t, !1), t.strstart++, t.lookahead--, 0 === t.strm.avail_out) return G
        } else t.match_available = 1, t.strstart++, t.lookahead--
      }
      return t.match_available && (r = i._tr_tally(t, 0, t.window[t.strstart - 1]), t.match_available = 0), t.insert = t.strstart < D - 1 ? t.strstart : D - 1, e === d ? (et(t, !0), 0 === t.strm.avail_out ? K : J) : t.last_lit && (et(t, !1), 0 === t.strm.avail_out) ? G : q
    }

    function ut(t, e, n, r, s) {
      this.good_length = t, this.max_lazy = e, this.nice_length = n, this.max_chain = r, this.func = s
    }

    function ct() {
      this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = C, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new s.Buf16(2 * R), this.dyn_dtree = new s.Buf16(2 * (2 * N + 1)), this.bl_tree = new s.Buf16(2 * (2 * $ + 1)), Q(this.dyn_ltree), Q(this.dyn_dtree), Q(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new s.Buf16(j + 1), this.heap = new s.Buf16(2 * A + 1), Q(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new s.Buf16(2 * A + 1), Q(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0
    }

    function lt(t) {
      var e;
      return t && t.state ? (t.total_in = t.total_out = 0, t.data_type = k, (e = t.state).pending = 0, e.pending_out = 0, e.wrap < 0 && (e.wrap = -e.wrap), e.status = e.wrap ? L : V, t.adler = 2 === e.wrap ? 0 : 1, e.last_flush = c, i._tr_init(e), f) : Y(t, g)
    }

    function ht(t) {
      var e, n = lt(t);
      return n === f && ((e = t.state).window_size = 2 * e.w_size, Q(e.head), e.max_lazy_match = r[e.level].max_lazy, e.good_match = r[e.level].good_length, e.nice_match = r[e.level].nice_length, e.max_chain_length = r[e.level].max_chain, e.strstart = 0, e.block_start = 0, e.lookahead = 0, e.insert = 0, e.match_length = e.prev_length = D - 1, e.match_available = 0, e.ins_h = 0), n
    }

    function dt(t, e, n, r, i, a) {
      if (!t) return g;
      var o = 1;
      if (e === w && (e = 6), r < 0 ? (o = 0, r = -r) : r > 15 && (o = 2, r -= 16), i < 1 || i > E || n !== C || r < 8 || r > 15 || e < 0 || e > 9 || a < 0 || a > S) return Y(t, g);
      8 === r && (r = 9);
      var u = new ct;
      return t.state = u, u.strm = t, u.wrap = o, u.gzhead = null, u.w_bits = r, u.w_size = 1 << u.w_bits, u.w_mask = u.w_size - 1, u.hash_bits = i + 7, u.hash_size = 1 << u.hash_bits, u.hash_mask = u.hash_size - 1, u.hash_shift = ~~((u.hash_bits + D - 1) / D), u.window = new s.Buf8(2 * u.w_size), u.head = new s.Buf16(u.hash_size), u.prev = new s.Buf16(u.w_size), u.lit_bufsize = 1 << i + 6, u.pending_buf_size = 4 * u.lit_bufsize, u.pending_buf = new s.Buf8(u.pending_buf_size), u.d_buf = 1 * u.lit_bufsize, u.l_buf = 3 * u.lit_bufsize, u.level = e, u.strategy = a, u.method = n, ht(t)
    }
    r = [new ut(0, 0, 0, 0, (function (t, e) {
      var n = 65535;
      for (n > t.pending_buf_size - 5 && (n = t.pending_buf_size - 5);;) {
        if (t.lookahead <= 1) {
          if (it(t), 0 === t.lookahead && e === c) return G;
          if (0 === t.lookahead) break
        }
        t.strstart += t.lookahead, t.lookahead = 0;
        var r = t.block_start + n;
        if ((0 === t.strstart || t.strstart >= r) && (t.lookahead = t.strstart - r, t.strstart = r, et(t, !1), 0 === t.strm.avail_out)) return G;
        if (t.strstart - t.block_start >= t.w_size - M && (et(t, !1), 0 === t.strm.avail_out)) return G
      }
      return t.insert = 0, e === d ? (et(t, !0), 0 === t.strm.avail_out ? K : J) : (t.strstart > t.block_start && (et(t, !1), t.strm.avail_out), G)
    })), new ut(4, 4, 8, 4, at), new ut(4, 5, 16, 8, at), new ut(4, 6, 32, 32, at), new ut(4, 4, 16, 16, ot), new ut(8, 16, 32, 32, ot), new ut(8, 16, 128, 128, ot), new ut(8, 32, 128, 256, ot), new ut(32, 128, 258, 1024, ot), new ut(32, 258, 258, 4096, ot)], e.deflateInit = function (t, e) {
      return dt(t, e, C, I, T, _)
    }, e.deflateInit2 = dt, e.deflateReset = ht, e.deflateResetKeep = lt, e.deflateSetHeader = function (t, e) {
      return t && t.state ? 2 !== t.state.wrap ? g : (t.state.gzhead = e, f) : g
    }, e.deflate = function (t, e) {
      var n, s, a, u;
      if (!t || !t.state || e > p || e < 0) return t ? Y(t, g) : g;
      if (s = t.state, !t.output || !t.input && 0 !== t.avail_in || s.status === H && e !== d) return Y(t, 0 === t.avail_out ? y : g);
      if (s.strm = t, n = s.last_flush, s.last_flush = e, s.status === L)
        if (2 === s.wrap) t.adler = 0, nt(s, 31), nt(s, 139), nt(s, 8), s.gzhead ? (nt(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (s.gzhead.extra ? 4 : 0) + (s.gzhead.name ? 8 : 0) + (s.gzhead.comment ? 16 : 0)), nt(s, 255 & s.gzhead.time), nt(s, s.gzhead.time >> 8 & 255), nt(s, s.gzhead.time >> 16 & 255), nt(s, s.gzhead.time >> 24 & 255), nt(s, 9 === s.level ? 2 : s.strategy >= x || s.level < 2 ? 4 : 0), nt(s, 255 & s.gzhead.os), s.gzhead.extra && s.gzhead.extra.length && (nt(s, 255 & s.gzhead.extra.length), nt(s, s.gzhead.extra.length >> 8 & 255)), s.gzhead.hcrc && (t.adler = o(t.adler, s.pending_buf, s.pending, 0)), s.gzindex = 0, s.status = B) : (nt(s, 0), nt(s, 0), nt(s, 0), nt(s, 0), nt(s, 0), nt(s, 9 === s.level ? 2 : s.strategy >= x || s.level < 2 ? 4 : 0), nt(s, X), s.status = V);
        else {
          var b = C + (s.w_bits - 8 << 4) << 8;
          b |= (s.strategy >= x || s.level < 2 ? 0 : s.level < 6 ? 1 : 6 === s.level ? 2 : 3) << 6, 0 !== s.strstart && (b |= z), b += 31 - b % 31, s.status = V, rt(s, b), 0 !== s.strstart && (rt(s, t.adler >>> 16), rt(s, 65535 & t.adler)), t.adler = 1
        } if (s.status === B)
        if (s.gzhead.extra) {
          for (a = s.pending; s.gzindex < (65535 & s.gzhead.extra.length) && (s.pending !== s.pending_buf_size || (s.gzhead.hcrc && s.pending > a && (t.adler = o(t.adler, s.pending_buf, s.pending - a, a)), tt(t), a = s.pending, s.pending !== s.pending_buf_size));) nt(s, 255 & s.gzhead.extra[s.gzindex]), s.gzindex++;
          s.gzhead.hcrc && s.pending > a && (t.adler = o(t.adler, s.pending_buf, s.pending - a, a)), s.gzindex === s.gzhead.extra.length && (s.gzindex = 0, s.status = P)
        } else s.status = P;
      if (s.status === P)
        if (s.gzhead.name) {
          a = s.pending;
          do {
            if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > a && (t.adler = o(t.adler, s.pending_buf, s.pending - a, a)), tt(t), a = s.pending, s.pending === s.pending_buf_size)) {
              u = 1;
              break
            }
            u = s.gzindex < s.gzhead.name.length ? 255 & s.gzhead.name.charCodeAt(s.gzindex++) : 0, nt(s, u)
          } while (0 !== u);
          s.gzhead.hcrc && s.pending > a && (t.adler = o(t.adler, s.pending_buf, s.pending - a, a)), 0 === u && (s.gzindex = 0, s.status = W)
        } else s.status = W;
      if (s.status === W)
        if (s.gzhead.comment) {
          a = s.pending;
          do {
            if (s.pending === s.pending_buf_size && (s.gzhead.hcrc && s.pending > a && (t.adler = o(t.adler, s.pending_buf, s.pending - a, a)), tt(t), a = s.pending, s.pending === s.pending_buf_size)) {
              u = 1;
              break
            }
            u = s.gzindex < s.gzhead.comment.length ? 255 & s.gzhead.comment.charCodeAt(s.gzindex++) : 0, nt(s, u)
          } while (0 !== u);
          s.gzhead.hcrc && s.pending > a && (t.adler = o(t.adler, s.pending_buf, s.pending - a, a)), 0 === u && (s.status = U)
        } else s.status = U;
      if (s.status === U && (s.gzhead.hcrc ? (s.pending + 2 > s.pending_buf_size && tt(t), s.pending + 2 <= s.pending_buf_size && (nt(s, 255 & t.adler), nt(s, t.adler >> 8 & 255), t.adler = 0, s.status = V)) : s.status = V), 0 !== s.pending) {
        if (tt(t), 0 === t.avail_out) return s.last_flush = -1, f
      } else if (0 === t.avail_in && Z(e) <= Z(n) && e !== d) return Y(t, y);
      if (s.status === H && 0 !== t.avail_in) return Y(t, y);
      if (0 !== t.avail_in || 0 !== s.lookahead || e !== c && s.status !== H) {
        var w = s.strategy === x ? function (t, e) {
          for (var n;;) {
            if (0 === t.lookahead && (it(t), 0 === t.lookahead)) {
              if (e === c) return G;
              break
            }
            if (t.match_length = 0, n = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++, n && (et(t, !1), 0 === t.strm.avail_out)) return G
          }
          return t.insert = 0, e === d ? (et(t, !0), 0 === t.strm.avail_out ? K : J) : t.last_lit && (et(t, !1), 0 === t.strm.avail_out) ? G : q
        }(s, e) : s.strategy === O ? function (t, e) {
          for (var n, r, s, a, o = t.window;;) {
            if (t.lookahead <= F) {
              if (it(t), t.lookahead <= F && e === c) return G;
              if (0 === t.lookahead) break
            }
            if (t.match_length = 0, t.lookahead >= D && t.strstart > 0 && (r = o[s = t.strstart - 1]) === o[++s] && r === o[++s] && r === o[++s]) {
              a = t.strstart + F;
              do {} while (r === o[++s] && r === o[++s] && r === o[++s] && r === o[++s] && r === o[++s] && r === o[++s] && r === o[++s] && r === o[++s] && s < a);
              t.match_length = F - (a - s), t.match_length > t.lookahead && (t.match_length = t.lookahead)
            }
            if (t.match_length >= D ? (n = i._tr_tally(t, 1, t.match_length - D), t.lookahead -= t.match_length, t.strstart += t.match_length, t.match_length = 0) : (n = i._tr_tally(t, 0, t.window[t.strstart]), t.lookahead--, t.strstart++), n && (et(t, !1), 0 === t.strm.avail_out)) return G
          }
          return t.insert = 0, e === d ? (et(t, !0), 0 === t.strm.avail_out ? K : J) : t.last_lit && (et(t, !1), 0 === t.strm.avail_out) ? G : q
        }(s, e) : r[s.level].func(s, e);
        if (w !== K && w !== J || (s.status = H), w === G || w === K) return 0 === t.avail_out && (s.last_flush = -1), f;
        if (w === q && (e === l ? i._tr_align(s) : e !== p && (i._tr_stored_block(s, 0, 0, !1), e === h && (Q(s.head), 0 === s.lookahead && (s.strstart = 0, s.block_start = 0, s.insert = 0))), tt(t), 0 === t.avail_out)) return s.last_flush = -1, f
      }
      return e !== d ? f : s.wrap <= 0 ? m : (2 === s.wrap ? (nt(s, 255 & t.adler), nt(s, t.adler >> 8 & 255), nt(s, t.adler >> 16 & 255), nt(s, t.adler >> 24 & 255), nt(s, 255 & t.total_in), nt(s, t.total_in >> 8 & 255), nt(s, t.total_in >> 16 & 255), nt(s, t.total_in >> 24 & 255)) : (rt(s, t.adler >>> 16), rt(s, 65535 & t.adler)), tt(t), s.wrap > 0 && (s.wrap = -s.wrap), 0 !== s.pending ? f : m)
    }, e.deflateEnd = function (t) {
      var e;
      return t && t.state ? (e = t.state.status) !== L && e !== B && e !== P && e !== W && e !== U && e !== V && e !== H ? Y(t, g) : (t.state = null, e === V ? Y(t, b) : f) : g
    }, e.deflateSetDictionary = function (t, e) {
      var n, r, i, o, u, c, l, h, d = e.length;
      if (!t || !t.state) return g;
      if (2 === (o = (n = t.state).wrap) || 1 === o && n.status !== L || n.lookahead) return g;
      for (1 === o && (t.adler = a(t.adler, e, d, 0)), n.wrap = 0, d >= n.w_size && (0 === o && (Q(n.head), n.strstart = 0, n.block_start = 0, n.insert = 0), h = new s.Buf8(n.w_size), s.arraySet(h, e, d - n.w_size, n.w_size, 0), e = h, d = n.w_size), u = t.avail_in, c = t.next_in, l = t.input, t.avail_in = d, t.next_in = 0, t.input = e, it(n); n.lookahead >= D;) {
        r = n.strstart, i = n.lookahead - (D - 1);
        do {
          n.ins_h = (n.ins_h << n.hash_shift ^ n.window[r + D - 1]) & n.hash_mask, n.prev[r & n.w_mask] = n.head[n.ins_h], n.head[n.ins_h] = r, r++
        } while (--i);
        n.strstart = r, n.lookahead = D - 1, it(n)
      }
      return n.strstart += n.lookahead, n.block_start = n.strstart, n.insert = n.lookahead, n.lookahead = 0, n.match_length = n.prev_length = D - 1, n.match_available = 0, t.next_in = c, t.input = l, t.avail_in = u, n.wrap = o, f
    }, e.deflateInfo = "pako deflate (from Nodeca project)"
  }, function (t, e, n) {
    "use strict";
    var r = n(30),
      s = 4,
      i = 0,
      a = 1,
      o = 2;

    function u(t) {
      for (var e = t.length; --e >= 0;) t[e] = 0
    }
    var c = 0,
      l = 1,
      h = 2,
      d = 29,
      p = 256,
      f = p + 1 + d,
      m = 30,
      g = 19,
      b = 2 * f + 1,
      y = 15,
      w = 16,
      v = 7,
      x = 256,
      O = 16,
      S = 17,
      _ = 18,
      k = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
      C = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
      E = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7],
      I = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
      T = new Array(2 * (f + 2));
    u(T);
    var A = new Array(2 * m);
    u(A);
    var N = new Array(512);
    u(N);
    var $ = new Array(256);
    u($);
    var R = new Array(d);
    u(R);
    var j, D, F, M = new Array(m);

    function z(t, e, n, r, s) {
      this.static_tree = t, this.extra_bits = e, this.extra_base = n, this.elems = r, this.max_length = s, this.has_stree = t && t.length
    }

    function L(t, e) {
      this.dyn_tree = t, this.max_code = 0, this.stat_desc = e
    }

    function B(t) {
      return t < 256 ? N[t] : N[256 + (t >>> 7)]
    }

    function P(t, e) {
      t.pending_buf[t.pending++] = 255 & e, t.pending_buf[t.pending++] = e >>> 8 & 255
    }

    function W(t, e, n) {
      t.bi_valid > w - n ? (t.bi_buf |= e << t.bi_valid & 65535, P(t, t.bi_buf), t.bi_buf = e >> w - t.bi_valid, t.bi_valid += n - w) : (t.bi_buf |= e << t.bi_valid & 65535, t.bi_valid += n)
    }

    function U(t, e, n) {
      W(t, n[2 * e], n[2 * e + 1])
    }

    function V(t, e) {
      var n = 0;
      do {
        n |= 1 & t, t >>>= 1, n <<= 1
      } while (--e > 0);
      return n >>> 1
    }

    function H(t, e, n) {
      var r, s, i = new Array(y + 1),
        a = 0;
      for (r = 1; r <= y; r++) i[r] = a = a + n[r - 1] << 1;
      for (s = 0; s <= e; s++) {
        var o = t[2 * s + 1];
        0 !== o && (t[2 * s] = V(i[o]++, o))
      }
    }

    function G(t) {
      var e;
      for (e = 0; e < f; e++) t.dyn_ltree[2 * e] = 0;
      for (e = 0; e < m; e++) t.dyn_dtree[2 * e] = 0;
      for (e = 0; e < g; e++) t.bl_tree[2 * e] = 0;
      t.dyn_ltree[2 * x] = 1, t.opt_len = t.static_len = 0, t.last_lit = t.matches = 0
    }

    function q(t) {
      t.bi_valid > 8 ? P(t, t.bi_buf) : t.bi_valid > 0 && (t.pending_buf[t.pending++] = t.bi_buf), t.bi_buf = 0, t.bi_valid = 0
    }

    function K(t, e, n, r) {
      var s = 2 * e,
        i = 2 * n;
      return t[s] < t[i] || t[s] === t[i] && r[e] <= r[n]
    }

    function J(t, e, n) {
      for (var r = t.heap[n], s = n << 1; s <= t.heap_len && (s < t.heap_len && K(e, t.heap[s + 1], t.heap[s], t.depth) && s++, !K(e, r, t.heap[s], t.depth));) t.heap[n] = t.heap[s], n = s, s <<= 1;
      t.heap[n] = r
    }

    function X(t, e, n) {
      var r, s, i, a, o = 0;
      if (0 !== t.last_lit)
        do {
          r = t.pending_buf[t.d_buf + 2 * o] << 8 | t.pending_buf[t.d_buf + 2 * o + 1], s = t.pending_buf[t.l_buf + o], o++, 0 === r ? U(t, s, e) : (U(t, (i = $[s]) + p + 1, e), 0 !== (a = k[i]) && W(t, s -= R[i], a), U(t, i = B(--r), n), 0 !== (a = C[i]) && W(t, r -= M[i], a))
        } while (o < t.last_lit);
      U(t, x, e)
    }

    function Y(t, e) {
      var n, r, s, i = e.dyn_tree,
        a = e.stat_desc.static_tree,
        o = e.stat_desc.has_stree,
        u = e.stat_desc.elems,
        c = -1;
      for (t.heap_len = 0, t.heap_max = b, n = 0; n < u; n++) 0 !== i[2 * n] ? (t.heap[++t.heap_len] = c = n, t.depth[n] = 0) : i[2 * n + 1] = 0;
      for (; t.heap_len < 2;) i[2 * (s = t.heap[++t.heap_len] = c < 2 ? ++c : 0)] = 1, t.depth[s] = 0, t.opt_len--, o && (t.static_len -= a[2 * s + 1]);
      for (e.max_code = c, n = t.heap_len >> 1; n >= 1; n--) J(t, i, n);
      s = u;
      do {
        n = t.heap[1], t.heap[1] = t.heap[t.heap_len--], J(t, i, 1), r = t.heap[1], t.heap[--t.heap_max] = n, t.heap[--t.heap_max] = r, i[2 * s] = i[2 * n] + i[2 * r], t.depth[s] = (t.depth[n] >= t.depth[r] ? t.depth[n] : t.depth[r]) + 1, i[2 * n + 1] = i[2 * r + 1] = s, t.heap[1] = s++, J(t, i, 1)
      } while (t.heap_len >= 2);
      t.heap[--t.heap_max] = t.heap[1],
        function (t, e) {
          var n, r, s, i, a, o, u = e.dyn_tree,
            c = e.max_code,
            l = e.stat_desc.static_tree,
            h = e.stat_desc.has_stree,
            d = e.stat_desc.extra_bits,
            p = e.stat_desc.extra_base,
            f = e.stat_desc.max_length,
            m = 0;
          for (i = 0; i <= y; i++) t.bl_count[i] = 0;
          for (u[2 * t.heap[t.heap_max] + 1] = 0, n = t.heap_max + 1; n < b; n++)(i = u[2 * u[2 * (r = t.heap[n]) + 1] + 1] + 1) > f && (i = f, m++), u[2 * r + 1] = i, r > c || (t.bl_count[i]++, a = 0, r >= p && (a = d[r - p]), o = u[2 * r], t.opt_len += o * (i + a), h && (t.static_len += o * (l[2 * r + 1] + a)));
          if (0 !== m) {
            do {
              for (i = f - 1; 0 === t.bl_count[i];) i--;
              t.bl_count[i]--, t.bl_count[i + 1] += 2, t.bl_count[f]--, m -= 2
            } while (m > 0);
            for (i = f; 0 !== i; i--)
              for (r = t.bl_count[i]; 0 !== r;)(s = t.heap[--n]) > c || (u[2 * s + 1] !== i && (t.opt_len += (i - u[2 * s + 1]) * u[2 * s], u[2 * s + 1] = i), r--)
          }
        }(t, e), H(i, c, t.bl_count)
    }

    function Z(t, e, n) {
      var r, s, i = -1,
        a = e[1],
        o = 0,
        u = 7,
        c = 4;
      for (0 === a && (u = 138, c = 3), e[2 * (n + 1) + 1] = 65535, r = 0; r <= n; r++) s = a, a = e[2 * (r + 1) + 1], ++o < u && s === a || (o < c ? t.bl_tree[2 * s] += o : 0 !== s ? (s !== i && t.bl_tree[2 * s]++, t.bl_tree[2 * O]++) : o <= 10 ? t.bl_tree[2 * S]++ : t.bl_tree[2 * _]++, o = 0, i = s, 0 === a ? (u = 138, c = 3) : s === a ? (u = 6, c = 3) : (u = 7, c = 4))
    }

    function Q(t, e, n) {
      var r, s, i = -1,
        a = e[1],
        o = 0,
        u = 7,
        c = 4;
      for (0 === a && (u = 138, c = 3), r = 0; r <= n; r++)
        if (s = a, a = e[2 * (r + 1) + 1], !(++o < u && s === a)) {
          if (o < c)
            do {
              U(t, s, t.bl_tree)
            } while (0 != --o);
          else 0 !== s ? (s !== i && (U(t, s, t.bl_tree), o--), U(t, O, t.bl_tree), W(t, o - 3, 2)) : o <= 10 ? (U(t, S, t.bl_tree), W(t, o - 3, 3)) : (U(t, _, t.bl_tree), W(t, o - 11, 7));
          o = 0, i = s, 0 === a ? (u = 138, c = 3) : s === a ? (u = 6, c = 3) : (u = 7, c = 4)
        }
    }
    u(M);
    var tt = !1;

    function et(t, e, n, s) {
      W(t, (c << 1) + (s ? 1 : 0), 3),
        function (t, e, n, s) {
          q(t), s && (P(t, n), P(t, ~n)), r.arraySet(t.pending_buf, t.window, e, n, t.pending), t.pending += n
        }(t, e, n, !0)
    }
    e._tr_init = function (t) {
      tt || (! function () {
        var t, e, n, r, s, i = new Array(y + 1);
        for (n = 0, r = 0; r < d - 1; r++)
          for (R[r] = n, t = 0; t < 1 << k[r]; t++) $[n++] = r;
        for ($[n - 1] = r, s = 0, r = 0; r < 16; r++)
          for (M[r] = s, t = 0; t < 1 << C[r]; t++) N[s++] = r;
        for (s >>= 7; r < m; r++)
          for (M[r] = s << 7, t = 0; t < 1 << C[r] - 7; t++) N[256 + s++] = r;
        for (e = 0; e <= y; e++) i[e] = 0;
        for (t = 0; t <= 143;) T[2 * t + 1] = 8, t++, i[8]++;
        for (; t <= 255;) T[2 * t + 1] = 9, t++, i[9]++;
        for (; t <= 279;) T[2 * t + 1] = 7, t++, i[7]++;
        for (; t <= 287;) T[2 * t + 1] = 8, t++, i[8]++;
        for (H(T, f + 1, i), t = 0; t < m; t++) A[2 * t + 1] = 5, A[2 * t] = V(t, 5);
        j = new z(T, k, p + 1, f, y), D = new z(A, C, 0, m, y), F = new z(new Array(0), E, 0, g, v)
      }(), tt = !0), t.l_desc = new L(t.dyn_ltree, j), t.d_desc = new L(t.dyn_dtree, D), t.bl_desc = new L(t.bl_tree, F), t.bi_buf = 0, t.bi_valid = 0, G(t)
    }, e._tr_stored_block = et, e._tr_flush_block = function (t, e, n, r) {
      var u, c, d = 0;
      t.level > 0 ? (t.strm.data_type === o && (t.strm.data_type = function (t) {
        var e, n = 4093624447;
        for (e = 0; e <= 31; e++, n >>>= 1)
          if (1 & n && 0 !== t.dyn_ltree[2 * e]) return i;
        if (0 !== t.dyn_ltree[18] || 0 !== t.dyn_ltree[20] || 0 !== t.dyn_ltree[26]) return a;
        for (e = 32; e < p; e++)
          if (0 !== t.dyn_ltree[2 * e]) return a;
        return i
      }(t)), Y(t, t.l_desc), Y(t, t.d_desc), d = function (t) {
        var e;
        for (Z(t, t.dyn_ltree, t.l_desc.max_code), Z(t, t.dyn_dtree, t.d_desc.max_code), Y(t, t.bl_desc), e = g - 1; e >= 3 && 0 === t.bl_tree[2 * I[e] + 1]; e--);
        return t.opt_len += 3 * (e + 1) + 5 + 5 + 4, e
      }(t), u = t.opt_len + 3 + 7 >>> 3, (c = t.static_len + 3 + 7 >>> 3) <= u && (u = c)) : u = c = n + 5, n + 4 <= u && -1 !== e ? et(t, e, n, r) : t.strategy === s || c === u ? (W(t, (l << 1) + (r ? 1 : 0), 3), X(t, T, A)) : (W(t, (h << 1) + (r ? 1 : 0), 3), function (t, e, n, r) {
        var s;
        for (W(t, e - 257, 5), W(t, n - 1, 5), W(t, r - 4, 4), s = 0; s < r; s++) W(t, t.bl_tree[2 * I[s] + 1], 3);
        Q(t, t.dyn_ltree, e - 1), Q(t, t.dyn_dtree, n - 1)
      }(t, t.l_desc.max_code + 1, t.d_desc.max_code + 1, d + 1), X(t, t.dyn_ltree, t.dyn_dtree)), G(t), r && q(t)
    }, e._tr_tally = function (t, e, n) {
      return t.pending_buf[t.d_buf + 2 * t.last_lit] = e >>> 8 & 255, t.pending_buf[t.d_buf + 2 * t.last_lit + 1] = 255 & e, t.pending_buf[t.l_buf + t.last_lit] = 255 & n, t.last_lit++, 0 === e ? t.dyn_ltree[2 * n]++ : (t.matches++, e--, t.dyn_ltree[2 * ($[n] + p + 1)]++, t.dyn_dtree[2 * B(e)]++), t.last_lit === t.lit_bufsize - 1
    }, e._tr_align = function (t) {
      W(t, l << 1, 3), U(t, x, T),
        function (t) {
          16 === t.bi_valid ? (P(t, t.bi_buf), t.bi_buf = 0, t.bi_valid = 0) : t.bi_valid >= 8 && (t.pending_buf[t.pending++] = 255 & t.bi_buf, t.bi_buf >>= 8, t.bi_valid -= 8)
        }(t)
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(133),
      s = n(30),
      i = n(74),
      a = n(76),
      o = n(57),
      u = n(75),
      c = n(136),
      l = Object.prototype.toString;

    function h(t) {
      if (!(this instanceof h)) return new h(t);
      this.options = s.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ""
      }, t || {});
      var e = this.options;
      e.raw && e.windowBits >= 0 && e.windowBits < 16 && (e.windowBits = -e.windowBits, 0 === e.windowBits && (e.windowBits = -15)), !(e.windowBits >= 0 && e.windowBits < 16) || t && t.windowBits || (e.windowBits += 32), e.windowBits > 15 && e.windowBits < 48 && 0 == (15 & e.windowBits) && (e.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new u, this.strm.avail_out = 0;
      var n = r.inflateInit2(this.strm, e.windowBits);
      if (n !== a.Z_OK) throw new Error(o[n]);
      if (this.header = new c, r.inflateGetHeader(this.strm, this.header), e.dictionary && ("string" == typeof e.dictionary ? e.dictionary = i.string2buf(e.dictionary) : "[object ArrayBuffer]" === l.call(e.dictionary) && (e.dictionary = new Uint8Array(e.dictionary)), e.raw && (n = r.inflateSetDictionary(this.strm, e.dictionary)) !== a.Z_OK)) throw new Error(o[n])
    }

    function d(t, e) {
      var n = new h(e);
      if (n.push(t, !0), n.err) throw n.msg || o[n.err];
      return n.result
    }
    h.prototype.push = function (t, e) {
      var n, o, u, c, h, d = this.strm,
        p = this.options.chunkSize,
        f = this.options.dictionary,
        m = !1;
      if (this.ended) return !1;
      o = e === ~~e ? e : !0 === e ? a.Z_FINISH : a.Z_NO_FLUSH, "string" == typeof t ? d.input = i.binstring2buf(t) : "[object ArrayBuffer]" === l.call(t) ? d.input = new Uint8Array(t) : d.input = t, d.next_in = 0, d.avail_in = d.input.length;
      do {
        if (0 === d.avail_out && (d.output = new s.Buf8(p), d.next_out = 0, d.avail_out = p), (n = r.inflate(d, a.Z_NO_FLUSH)) === a.Z_NEED_DICT && f && (n = r.inflateSetDictionary(this.strm, f)), n === a.Z_BUF_ERROR && !0 === m && (n = a.Z_OK, m = !1), n !== a.Z_STREAM_END && n !== a.Z_OK) return this.onEnd(n), this.ended = !0, !1;
        d.next_out && (0 !== d.avail_out && n !== a.Z_STREAM_END && (0 !== d.avail_in || o !== a.Z_FINISH && o !== a.Z_SYNC_FLUSH) || ("string" === this.options.to ? (u = i.utf8border(d.output, d.next_out), c = d.next_out - u, h = i.buf2string(d.output, u), d.next_out = c, d.avail_out = p - c, c && s.arraySet(d.output, d.output, u, c, 0), this.onData(h)) : this.onData(s.shrinkBuf(d.output, d.next_out)))), 0 === d.avail_in && 0 === d.avail_out && (m = !0)
      } while ((d.avail_in > 0 || 0 === d.avail_out) && n !== a.Z_STREAM_END);
      return n === a.Z_STREAM_END && (o = a.Z_FINISH), o === a.Z_FINISH ? (n = r.inflateEnd(this.strm), this.onEnd(n), this.ended = !0, n === a.Z_OK) : o !== a.Z_SYNC_FLUSH || (this.onEnd(a.Z_OK), d.avail_out = 0, !0)
    }, h.prototype.onData = function (t) {
      this.chunks.push(t)
    }, h.prototype.onEnd = function (t) {
      t === a.Z_OK && ("string" === this.options.to ? this.result = this.chunks.join("") : this.result = s.flattenChunks(this.chunks)), this.chunks = [], this.err = t, this.msg = this.strm.msg
    }, e.Inflate = h, e.inflate = d, e.inflateRaw = function (t, e) {
      return (e = e || {}).raw = !0, d(t, e)
    }, e.ungzip = d
  }, function (t, e, n) {
    "use strict";
    var r = n(30),
      s = n(72),
      i = n(73),
      a = n(134),
      o = n(135),
      u = 0,
      c = 1,
      l = 2,
      h = 4,
      d = 5,
      p = 6,
      f = 0,
      m = 1,
      g = 2,
      b = -2,
      y = -3,
      w = -4,
      v = -5,
      x = 8,
      O = 1,
      S = 2,
      _ = 3,
      k = 4,
      C = 5,
      E = 6,
      I = 7,
      T = 8,
      A = 9,
      N = 10,
      $ = 11,
      R = 12,
      j = 13,
      D = 14,
      F = 15,
      M = 16,
      z = 17,
      L = 18,
      B = 19,
      P = 20,
      W = 21,
      U = 22,
      V = 23,
      H = 24,
      G = 25,
      q = 26,
      K = 27,
      J = 28,
      X = 29,
      Y = 30,
      Z = 31,
      Q = 32,
      tt = 852,
      et = 592,
      nt = 15;

    function rt(t) {
      return (t >>> 24 & 255) + (t >>> 8 & 65280) + ((65280 & t) << 8) + ((255 & t) << 24)
    }

    function st() {
      this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new r.Buf16(320), this.work = new r.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0
    }

    function it(t) {
      var e;
      return t && t.state ? (e = t.state, t.total_in = t.total_out = e.total = 0, t.msg = "", e.wrap && (t.adler = 1 & e.wrap), e.mode = O, e.last = 0, e.havedict = 0, e.dmax = 32768, e.head = null, e.hold = 0, e.bits = 0, e.lencode = e.lendyn = new r.Buf32(tt), e.distcode = e.distdyn = new r.Buf32(et), e.sane = 1, e.back = -1, f) : b
    }

    function at(t) {
      var e;
      return t && t.state ? ((e = t.state).wsize = 0, e.whave = 0, e.wnext = 0, it(t)) : b
    }

    function ot(t, e) {
      var n, r;
      return t && t.state ? (r = t.state, e < 0 ? (n = 0, e = -e) : (n = 1 + (e >> 4), e < 48 && (e &= 15)), e && (e < 8 || e > 15) ? b : (null !== r.window && r.wbits !== e && (r.window = null), r.wrap = n, r.wbits = e, at(t))) : b
    }

    function ut(t, e) {
      var n, r;
      return t ? (r = new st, t.state = r, r.window = null, (n = ot(t, e)) !== f && (t.state = null), n) : b
    }
    var ct, lt, ht = !0;

    function dt(t) {
      if (ht) {
        var e;
        for (ct = new r.Buf32(512), lt = new r.Buf32(32), e = 0; e < 144;) t.lens[e++] = 8;
        for (; e < 256;) t.lens[e++] = 9;
        for (; e < 280;) t.lens[e++] = 7;
        for (; e < 288;) t.lens[e++] = 8;
        for (o(c, t.lens, 0, 288, ct, 0, t.work, {
            bits: 9
          }), e = 0; e < 32;) t.lens[e++] = 5;
        o(l, t.lens, 0, 32, lt, 0, t.work, {
          bits: 5
        }), ht = !1
      }
      t.lencode = ct, t.lenbits = 9, t.distcode = lt, t.distbits = 5
    }

    function pt(t, e, n, s) {
      var i, a = t.state;
      return null === a.window && (a.wsize = 1 << a.wbits, a.wnext = 0, a.whave = 0, a.window = new r.Buf8(a.wsize)), s >= a.wsize ? (r.arraySet(a.window, e, n - a.wsize, a.wsize, 0), a.wnext = 0, a.whave = a.wsize) : ((i = a.wsize - a.wnext) > s && (i = s), r.arraySet(a.window, e, n - s, i, a.wnext), (s -= i) ? (r.arraySet(a.window, e, n - s, s, 0), a.wnext = s, a.whave = a.wsize) : (a.wnext += i, a.wnext === a.wsize && (a.wnext = 0), a.whave < a.wsize && (a.whave += i))), 0
    }
    e.inflateReset = at, e.inflateReset2 = ot, e.inflateResetKeep = it, e.inflateInit = function (t) {
      return ut(t, nt)
    }, e.inflateInit2 = ut, e.inflate = function (t, e) {
      var n, tt, et, nt, st, it, at, ot, ut, ct, lt, ht, ft, mt, gt, bt, yt, wt, vt, xt, Ot, St, _t, kt, Ct = 0,
        Et = new r.Buf8(4),
        It = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      if (!t || !t.state || !t.output || !t.input && 0 !== t.avail_in) return b;
      (n = t.state).mode === R && (n.mode = j), st = t.next_out, et = t.output, at = t.avail_out, nt = t.next_in, tt = t.input, it = t.avail_in, ot = n.hold, ut = n.bits, ct = it, lt = at, St = f;
      t: for (;;) switch (n.mode) {
        case O:
          if (0 === n.wrap) {
            n.mode = j;
            break
          }
          for (; ut < 16;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          if (2 & n.wrap && 35615 === ot) {
            n.check = 0, Et[0] = 255 & ot, Et[1] = ot >>> 8 & 255, n.check = i(n.check, Et, 2, 0), ot = 0, ut = 0, n.mode = S;
            break
          }
          if (n.flags = 0, n.head && (n.head.done = !1), !(1 & n.wrap) || (((255 & ot) << 8) + (ot >> 8)) % 31) {
            t.msg = "incorrect header check", n.mode = Y;
            break
          }
          if ((15 & ot) !== x) {
            t.msg = "unknown compression method", n.mode = Y;
            break
          }
          if (ut -= 4, Ot = 8 + (15 & (ot >>>= 4)), 0 === n.wbits) n.wbits = Ot;
          else if (Ot > n.wbits) {
            t.msg = "invalid window size", n.mode = Y;
            break
          }
          n.dmax = 1 << Ot, t.adler = n.check = 1, n.mode = 512 & ot ? N : R, ot = 0, ut = 0;
          break;
        case S:
          for (; ut < 16;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          if (n.flags = ot, (255 & n.flags) !== x) {
            t.msg = "unknown compression method", n.mode = Y;
            break
          }
          if (57344 & n.flags) {
            t.msg = "unknown header flags set", n.mode = Y;
            break
          }
          n.head && (n.head.text = ot >> 8 & 1), 512 & n.flags && (Et[0] = 255 & ot, Et[1] = ot >>> 8 & 255, n.check = i(n.check, Et, 2, 0)), ot = 0, ut = 0, n.mode = _;
        case _:
          for (; ut < 32;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          n.head && (n.head.time = ot), 512 & n.flags && (Et[0] = 255 & ot, Et[1] = ot >>> 8 & 255, Et[2] = ot >>> 16 & 255, Et[3] = ot >>> 24 & 255, n.check = i(n.check, Et, 4, 0)), ot = 0, ut = 0, n.mode = k;
        case k:
          for (; ut < 16;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          n.head && (n.head.xflags = 255 & ot, n.head.os = ot >> 8), 512 & n.flags && (Et[0] = 255 & ot, Et[1] = ot >>> 8 & 255, n.check = i(n.check, Et, 2, 0)), ot = 0, ut = 0, n.mode = C;
        case C:
          if (1024 & n.flags) {
            for (; ut < 16;) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            n.length = ot, n.head && (n.head.extra_len = ot), 512 & n.flags && (Et[0] = 255 & ot, Et[1] = ot >>> 8 & 255, n.check = i(n.check, Et, 2, 0)), ot = 0, ut = 0
          } else n.head && (n.head.extra = null);
          n.mode = E;
        case E:
          if (1024 & n.flags && ((ht = n.length) > it && (ht = it), ht && (n.head && (Ot = n.head.extra_len - n.length, n.head.extra || (n.head.extra = new Array(n.head.extra_len)), r.arraySet(n.head.extra, tt, nt, ht, Ot)), 512 & n.flags && (n.check = i(n.check, tt, ht, nt)), it -= ht, nt += ht, n.length -= ht), n.length)) break t;
          n.length = 0, n.mode = I;
        case I:
          if (2048 & n.flags) {
            if (0 === it) break t;
            ht = 0;
            do {
              Ot = tt[nt + ht++], n.head && Ot && n.length < 65536 && (n.head.name += String.fromCharCode(Ot))
            } while (Ot && ht < it);
            if (512 & n.flags && (n.check = i(n.check, tt, ht, nt)), it -= ht, nt += ht, Ot) break t
          } else n.head && (n.head.name = null);
          n.length = 0, n.mode = T;
        case T:
          if (4096 & n.flags) {
            if (0 === it) break t;
            ht = 0;
            do {
              Ot = tt[nt + ht++], n.head && Ot && n.length < 65536 && (n.head.comment += String.fromCharCode(Ot))
            } while (Ot && ht < it);
            if (512 & n.flags && (n.check = i(n.check, tt, ht, nt)), it -= ht, nt += ht, Ot) break t
          } else n.head && (n.head.comment = null);
          n.mode = A;
        case A:
          if (512 & n.flags) {
            for (; ut < 16;) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            if (ot !== (65535 & n.check)) {
              t.msg = "header crc mismatch", n.mode = Y;
              break
            }
            ot = 0, ut = 0
          }
          n.head && (n.head.hcrc = n.flags >> 9 & 1, n.head.done = !0), t.adler = n.check = 0, n.mode = R;
          break;
        case N:
          for (; ut < 32;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          t.adler = n.check = rt(ot), ot = 0, ut = 0, n.mode = $;
        case $:
          if (0 === n.havedict) return t.next_out = st, t.avail_out = at, t.next_in = nt, t.avail_in = it, n.hold = ot, n.bits = ut, g;
          t.adler = n.check = 1, n.mode = R;
        case R:
          if (e === d || e === p) break t;
        case j:
          if (n.last) {
            ot >>>= 7 & ut, ut -= 7 & ut, n.mode = K;
            break
          }
          for (; ut < 3;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          switch (n.last = 1 & ot, ut -= 1, 3 & (ot >>>= 1)) {
            case 0:
              n.mode = D;
              break;
            case 1:
              if (dt(n), n.mode = P, e === p) {
                ot >>>= 2, ut -= 2;
                break t
              }
              break;
            case 2:
              n.mode = z;
              break;
            case 3:
              t.msg = "invalid block type", n.mode = Y
          }
          ot >>>= 2, ut -= 2;
          break;
        case D:
          for (ot >>>= 7 & ut, ut -= 7 & ut; ut < 32;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          if ((65535 & ot) != (ot >>> 16 ^ 65535)) {
            t.msg = "invalid stored block lengths", n.mode = Y;
            break
          }
          if (n.length = 65535 & ot, ot = 0, ut = 0, n.mode = F, e === p) break t;
        case F:
          n.mode = M;
        case M:
          if (ht = n.length) {
            if (ht > it && (ht = it), ht > at && (ht = at), 0 === ht) break t;
            r.arraySet(et, tt, nt, ht, st), it -= ht, nt += ht, at -= ht, st += ht, n.length -= ht;
            break
          }
          n.mode = R;
          break;
        case z:
          for (; ut < 14;) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          if (n.nlen = 257 + (31 & ot), ot >>>= 5, ut -= 5, n.ndist = 1 + (31 & ot), ot >>>= 5, ut -= 5, n.ncode = 4 + (15 & ot), ot >>>= 4, ut -= 4, n.nlen > 286 || n.ndist > 30) {
            t.msg = "too many length or distance symbols", n.mode = Y;
            break
          }
          n.have = 0, n.mode = L;
        case L:
          for (; n.have < n.ncode;) {
            for (; ut < 3;) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            n.lens[It[n.have++]] = 7 & ot, ot >>>= 3, ut -= 3
          }
          for (; n.have < 19;) n.lens[It[n.have++]] = 0;
          if (n.lencode = n.lendyn, n.lenbits = 7, _t = {
              bits: n.lenbits
            }, St = o(u, n.lens, 0, 19, n.lencode, 0, n.work, _t), n.lenbits = _t.bits, St) {
            t.msg = "invalid code lengths set", n.mode = Y;
            break
          }
          n.have = 0, n.mode = B;
        case B:
          for (; n.have < n.nlen + n.ndist;) {
            for (; bt = (Ct = n.lencode[ot & (1 << n.lenbits) - 1]) >>> 16 & 255, yt = 65535 & Ct, !((gt = Ct >>> 24) <= ut);) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            if (yt < 16) ot >>>= gt, ut -= gt, n.lens[n.have++] = yt;
            else {
              if (16 === yt) {
                for (kt = gt + 2; ut < kt;) {
                  if (0 === it) break t;
                  it--, ot += tt[nt++] << ut, ut += 8
                }
                if (ot >>>= gt, ut -= gt, 0 === n.have) {
                  t.msg = "invalid bit length repeat", n.mode = Y;
                  break
                }
                Ot = n.lens[n.have - 1], ht = 3 + (3 & ot), ot >>>= 2, ut -= 2
              } else if (17 === yt) {
                for (kt = gt + 3; ut < kt;) {
                  if (0 === it) break t;
                  it--, ot += tt[nt++] << ut, ut += 8
                }
                ut -= gt, Ot = 0, ht = 3 + (7 & (ot >>>= gt)), ot >>>= 3, ut -= 3
              } else {
                for (kt = gt + 7; ut < kt;) {
                  if (0 === it) break t;
                  it--, ot += tt[nt++] << ut, ut += 8
                }
                ut -= gt, Ot = 0, ht = 11 + (127 & (ot >>>= gt)), ot >>>= 7, ut -= 7
              }
              if (n.have + ht > n.nlen + n.ndist) {
                t.msg = "invalid bit length repeat", n.mode = Y;
                break
              }
              for (; ht--;) n.lens[n.have++] = Ot
            }
          }
          if (n.mode === Y) break;
          if (0 === n.lens[256]) {
            t.msg = "invalid code -- missing end-of-block", n.mode = Y;
            break
          }
          if (n.lenbits = 9, _t = {
              bits: n.lenbits
            }, St = o(c, n.lens, 0, n.nlen, n.lencode, 0, n.work, _t), n.lenbits = _t.bits, St) {
            t.msg = "invalid literal/lengths set", n.mode = Y;
            break
          }
          if (n.distbits = 6, n.distcode = n.distdyn, _t = {
              bits: n.distbits
            }, St = o(l, n.lens, n.nlen, n.ndist, n.distcode, 0, n.work, _t), n.distbits = _t.bits, St) {
            t.msg = "invalid distances set", n.mode = Y;
            break
          }
          if (n.mode = P, e === p) break t;
        case P:
          n.mode = W;
        case W:
          if (it >= 6 && at >= 258) {
            t.next_out = st, t.avail_out = at, t.next_in = nt, t.avail_in = it, n.hold = ot, n.bits = ut, a(t, lt), st = t.next_out, et = t.output, at = t.avail_out, nt = t.next_in, tt = t.input, it = t.avail_in, ot = n.hold, ut = n.bits, n.mode === R && (n.back = -1);
            break
          }
          for (n.back = 0; bt = (Ct = n.lencode[ot & (1 << n.lenbits) - 1]) >>> 16 & 255, yt = 65535 & Ct, !((gt = Ct >>> 24) <= ut);) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          if (bt && 0 == (240 & bt)) {
            for (wt = gt, vt = bt, xt = yt; bt = (Ct = n.lencode[xt + ((ot & (1 << wt + vt) - 1) >> wt)]) >>> 16 & 255, yt = 65535 & Ct, !(wt + (gt = Ct >>> 24) <= ut);) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            ot >>>= wt, ut -= wt, n.back += wt
          }
          if (ot >>>= gt, ut -= gt, n.back += gt, n.length = yt, 0 === bt) {
            n.mode = q;
            break
          }
          if (32 & bt) {
            n.back = -1, n.mode = R;
            break
          }
          if (64 & bt) {
            t.msg = "invalid literal/length code", n.mode = Y;
            break
          }
          n.extra = 15 & bt, n.mode = U;
        case U:
          if (n.extra) {
            for (kt = n.extra; ut < kt;) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            n.length += ot & (1 << n.extra) - 1, ot >>>= n.extra, ut -= n.extra, n.back += n.extra
          }
          n.was = n.length, n.mode = V;
        case V:
          for (; bt = (Ct = n.distcode[ot & (1 << n.distbits) - 1]) >>> 16 & 255, yt = 65535 & Ct, !((gt = Ct >>> 24) <= ut);) {
            if (0 === it) break t;
            it--, ot += tt[nt++] << ut, ut += 8
          }
          if (0 == (240 & bt)) {
            for (wt = gt, vt = bt, xt = yt; bt = (Ct = n.distcode[xt + ((ot & (1 << wt + vt) - 1) >> wt)]) >>> 16 & 255, yt = 65535 & Ct, !(wt + (gt = Ct >>> 24) <= ut);) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            ot >>>= wt, ut -= wt, n.back += wt
          }
          if (ot >>>= gt, ut -= gt, n.back += gt, 64 & bt) {
            t.msg = "invalid distance code", n.mode = Y;
            break
          }
          n.offset = yt, n.extra = 15 & bt, n.mode = H;
        case H:
          if (n.extra) {
            for (kt = n.extra; ut < kt;) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            n.offset += ot & (1 << n.extra) - 1, ot >>>= n.extra, ut -= n.extra, n.back += n.extra
          }
          if (n.offset > n.dmax) {
            t.msg = "invalid distance too far back", n.mode = Y;
            break
          }
          n.mode = G;
        case G:
          if (0 === at) break t;
          if (ht = lt - at, n.offset > ht) {
            if ((ht = n.offset - ht) > n.whave && n.sane) {
              t.msg = "invalid distance too far back", n.mode = Y;
              break
            }
            ht > n.wnext ? (ht -= n.wnext, ft = n.wsize - ht) : ft = n.wnext - ht, ht > n.length && (ht = n.length), mt = n.window
          } else mt = et, ft = st - n.offset, ht = n.length;
          ht > at && (ht = at), at -= ht, n.length -= ht;
          do {
            et[st++] = mt[ft++]
          } while (--ht);
          0 === n.length && (n.mode = W);
          break;
        case q:
          if (0 === at) break t;
          et[st++] = n.length, at--, n.mode = W;
          break;
        case K:
          if (n.wrap) {
            for (; ut < 32;) {
              if (0 === it) break t;
              it--, ot |= tt[nt++] << ut, ut += 8
            }
            if (lt -= at, t.total_out += lt, n.total += lt, lt && (t.adler = n.check = n.flags ? i(n.check, et, lt, st - lt) : s(n.check, et, lt, st - lt)), lt = at, (n.flags ? ot : rt(ot)) !== n.check) {
              t.msg = "incorrect data check", n.mode = Y;
              break
            }
            ot = 0, ut = 0
          }
          n.mode = J;
        case J:
          if (n.wrap && n.flags) {
            for (; ut < 32;) {
              if (0 === it) break t;
              it--, ot += tt[nt++] << ut, ut += 8
            }
            if (ot !== (4294967295 & n.total)) {
              t.msg = "incorrect length check", n.mode = Y;
              break
            }
            ot = 0, ut = 0
          }
          n.mode = X;
        case X:
          St = m;
          break t;
        case Y:
          St = y;
          break t;
        case Z:
          return w;
        case Q:
        default:
          return b
      }
      return t.next_out = st, t.avail_out = at, t.next_in = nt, t.avail_in = it, n.hold = ot, n.bits = ut, (n.wsize || lt !== t.avail_out && n.mode < Y && (n.mode < K || e !== h)) && pt(t, t.output, t.next_out, lt - t.avail_out) ? (n.mode = Z, w) : (ct -= t.avail_in, lt -= t.avail_out, t.total_in += ct, t.total_out += lt, n.total += lt, n.wrap && lt && (t.adler = n.check = n.flags ? i(n.check, et, lt, t.next_out - lt) : s(n.check, et, lt, t.next_out - lt)), t.data_type = n.bits + (n.last ? 64 : 0) + (n.mode === R ? 128 : 0) + (n.mode === P || n.mode === F ? 256 : 0), (0 === ct && 0 === lt || e === h) && St === f && (St = v), St)
    }, e.inflateEnd = function (t) {
      if (!t || !t.state) return b;
      var e = t.state;
      return e.window && (e.window = null), t.state = null, f
    }, e.inflateGetHeader = function (t, e) {
      var n;
      return t && t.state ? 0 == (2 & (n = t.state).wrap) ? b : (n.head = e, e.done = !1, f) : b
    }, e.inflateSetDictionary = function (t, e) {
      var n, r = e.length;
      return t && t.state ? 0 !== (n = t.state).wrap && n.mode !== $ ? b : n.mode === $ && s(1, e, r, 0) !== n.check ? y : pt(t, e, r, r) ? (n.mode = Z, w) : (n.havedict = 1, f) : b
    }, e.inflateInfo = "pako inflate (from Nodeca project)"
  }, function (t, e, n) {
    "use strict";
    t.exports = function (t, e) {
      var n, r, s, i, a, o, u, c, l, h, d, p, f, m, g, b, y, w, v, x, O, S, _, k, C;
      n = t.state, r = t.next_in, k = t.input, s = r + (t.avail_in - 5), i = t.next_out, C = t.output, a = i - (e - t.avail_out), o = i + (t.avail_out - 257), u = n.dmax, c = n.wsize, l = n.whave, h = n.wnext, d = n.window, p = n.hold, f = n.bits, m = n.lencode, g = n.distcode, b = (1 << n.lenbits) - 1, y = (1 << n.distbits) - 1;
      t: do {
        f < 15 && (p += k[r++] << f, f += 8, p += k[r++] << f, f += 8), w = m[p & b];
        e: for (;;) {
          if (p >>>= v = w >>> 24, f -= v, 0 === (v = w >>> 16 & 255)) C[i++] = 65535 & w;
          else {
            if (!(16 & v)) {
              if (0 == (64 & v)) {
                w = m[(65535 & w) + (p & (1 << v) - 1)];
                continue e
              }
              if (32 & v) {
                n.mode = 12;
                break t
              }
              t.msg = "invalid literal/length code", n.mode = 30;
              break t
            }
            x = 65535 & w, (v &= 15) && (f < v && (p += k[r++] << f, f += 8), x += p & (1 << v) - 1, p >>>= v, f -= v), f < 15 && (p += k[r++] << f, f += 8, p += k[r++] << f, f += 8), w = g[p & y];
            n: for (;;) {
              if (p >>>= v = w >>> 24, f -= v, !(16 & (v = w >>> 16 & 255))) {
                if (0 == (64 & v)) {
                  w = g[(65535 & w) + (p & (1 << v) - 1)];
                  continue n
                }
                t.msg = "invalid distance code", n.mode = 30;
                break t
              }
              if (O = 65535 & w, f < (v &= 15) && (p += k[r++] << f, (f += 8) < v && (p += k[r++] << f, f += 8)), (O += p & (1 << v) - 1) > u) {
                t.msg = "invalid distance too far back", n.mode = 30;
                break t
              }
              if (p >>>= v, f -= v, O > (v = i - a)) {
                if ((v = O - v) > l && n.sane) {
                  t.msg = "invalid distance too far back", n.mode = 30;
                  break t
                }
                if (S = 0, _ = d, 0 === h) {
                  if (S += c - v, v < x) {
                    x -= v;
                    do {
                      C[i++] = d[S++]
                    } while (--v);
                    S = i - O, _ = C
                  }
                } else if (h < v) {
                  if (S += c + h - v, (v -= h) < x) {
                    x -= v;
                    do {
                      C[i++] = d[S++]
                    } while (--v);
                    if (S = 0, h < x) {
                      x -= v = h;
                      do {
                        C[i++] = d[S++]
                      } while (--v);
                      S = i - O, _ = C
                    }
                  }
                } else if (S += h - v, v < x) {
                  x -= v;
                  do {
                    C[i++] = d[S++]
                  } while (--v);
                  S = i - O, _ = C
                }
                for (; x > 2;) C[i++] = _[S++], C[i++] = _[S++], C[i++] = _[S++], x -= 3;
                x && (C[i++] = _[S++], x > 1 && (C[i++] = _[S++]))
              } else {
                S = i - O;
                do {
                  C[i++] = C[S++], C[i++] = C[S++], C[i++] = C[S++], x -= 3
                } while (x > 2);
                x && (C[i++] = C[S++], x > 1 && (C[i++] = C[S++]))
              }
              break
            }
          }
          break
        }
      } while (r < s && i < o);
      r -= x = f >> 3, p &= (1 << (f -= x << 3)) - 1, t.next_in = r, t.next_out = i, t.avail_in = r < s ? s - r + 5 : 5 - (r - s), t.avail_out = i < o ? o - i + 257 : 257 - (i - o), n.hold = p, n.bits = f
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(30),
      s = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0],
      i = [16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78],
      a = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0],
      o = [16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
    t.exports = function (t, e, n, u, c, l, h, d) {
      var p, f, m, g, b, y, w, v, x, O = d.bits,
        S = 0,
        _ = 0,
        k = 0,
        C = 0,
        E = 0,
        I = 0,
        T = 0,
        A = 0,
        N = 0,
        $ = 0,
        R = null,
        j = 0,
        D = new r.Buf16(16),
        F = new r.Buf16(16),
        M = null,
        z = 0;
      for (S = 0; S <= 15; S++) D[S] = 0;
      for (_ = 0; _ < u; _++) D[e[n + _]]++;
      for (E = O, C = 15; C >= 1 && 0 === D[C]; C--);
      if (E > C && (E = C), 0 === C) return c[l++] = 20971520, c[l++] = 20971520, d.bits = 1, 0;
      for (k = 1; k < C && 0 === D[k]; k++);
      for (E < k && (E = k), A = 1, S = 1; S <= 15; S++)
        if (A <<= 1, (A -= D[S]) < 0) return -1;
      if (A > 0 && (0 === t || 1 !== C)) return -1;
      for (F[1] = 0, S = 1; S < 15; S++) F[S + 1] = F[S] + D[S];
      for (_ = 0; _ < u; _++) 0 !== e[n + _] && (h[F[e[n + _]]++] = _);
      if (0 === t ? (R = M = h, y = 19) : 1 === t ? (R = s, j -= 257, M = i, z -= 257, y = 256) : (R = a, M = o, y = -1), $ = 0, _ = 0, S = k, b = l, I = E, T = 0, m = -1, g = (N = 1 << E) - 1, 1 === t && N > 852 || 2 === t && N > 592) return 1;
      for (;;) {
        w = S - T, h[_] < y ? (v = 0, x = h[_]) : h[_] > y ? (v = M[z + h[_]], x = R[j + h[_]]) : (v = 96, x = 0), p = 1 << S - T, k = f = 1 << I;
        do {
          c[b + ($ >> T) + (f -= p)] = w << 24 | v << 16 | x | 0
        } while (0 !== f);
        for (p = 1 << S - 1; $ & p;) p >>= 1;
        if (0 !== p ? ($ &= p - 1, $ += p) : $ = 0, _++, 0 == --D[S]) {
          if (S === C) break;
          S = e[n + h[_]]
        }
        if (S > E && ($ & g) !== m) {
          for (0 === T && (T = E), b += k, A = 1 << (I = S - T); I + T < C && !((A -= D[I + T]) <= 0);) I++, A <<= 1;
          if (N += 1 << I, 1 === t && N > 852 || 2 === t && N > 592) return 1;
          c[m = $ & g] = E << 24 | I << 16 | b - l | 0
        }
      }
      return 0 !== $ && (c[b + $] = S - T << 24 | 64 << 16 | 0), d.bits = E, 0
    }
  }, function (t, e, n) {
    "use strict";
    t.exports = function () {
      this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(21),
      i = n(35),
      a = n(56),
      o = n(77),
      u = function (t, e) {
        var n, r = "";
        for (n = 0; n < e; n++) r += String.fromCharCode(255 & t), t >>>= 8;
        return r
      },
      c = function (t, e, n, s, c, l) {
        var h, d, p = t.file,
          f = t.compression,
          m = l !== i.utf8encode,
          g = r.transformTo("string", l(p.name)),
          b = r.transformTo("string", i.utf8encode(p.name)),
          y = p.comment,
          w = r.transformTo("string", l(y)),
          v = r.transformTo("string", i.utf8encode(y)),
          x = b.length !== p.name.length,
          O = v.length !== y.length,
          S = "",
          _ = "",
          k = "",
          C = p.dir,
          E = p.date,
          I = {
            crc32: 0,
            compressedSize: 0,
            uncompressedSize: 0
          };
        e && !n || (I.crc32 = t.crc32, I.compressedSize = t.compressedSize, I.uncompressedSize = t.uncompressedSize);
        var T = 0;
        e && (T |= 8), m || !x && !O || (T |= 2048);
        var A, N, $, R = 0,
          j = 0;
        C && (R |= 16), "UNIX" === c ? (j = 798, R |= (A = p.unixPermissions, N = C, $ = A, A || ($ = N ? 16893 : 33204), (65535 & $) << 16)) : (j = 20, R |= 63 & (p.dosPermissions || 0)), h = E.getUTCHours(), h <<= 6, h |= E.getUTCMinutes(), h <<= 5, h |= E.getUTCSeconds() / 2, d = E.getUTCFullYear() - 1980, d <<= 4, d |= E.getUTCMonth() + 1, d <<= 5, d |= E.getUTCDate(), x && (_ = u(1, 1) + u(a(g), 4) + b, S += "up" + u(_.length, 2) + _), O && (k = u(1, 1) + u(a(w), 4) + v, S += "uc" + u(k.length, 2) + k);
        var D = "";
        return D += "\n\0", D += u(T, 2), D += f.magic, D += u(h, 2), D += u(d, 2), D += u(I.crc32, 4), D += u(I.compressedSize, 4), D += u(I.uncompressedSize, 4), D += u(g.length, 2), D += u(S.length, 2), {
          fileRecord: o.LOCAL_FILE_HEADER + D + g + S,
          dirRecord: o.CENTRAL_FILE_HEADER + u(j, 2) + D + u(w.length, 2) + "\0\0\0\0" + u(R, 4) + u(s, 4) + g + S + w
        }
      },
      l = function (t) {
        return o.DATA_DESCRIPTOR + u(t.crc32, 4) + u(t.compressedSize, 4) + u(t.uncompressedSize, 4)
      };

    function h(t, e, n, r) {
      s.call(this, "ZipFileWorker"), this.bytesWritten = 0, this.zipComment = e, this.zipPlatform = n, this.encodeFileName = r, this.streamFiles = t, this.accumulate = !1, this.contentBuffer = [], this.dirRecords = [], this.currentSourceOffset = 0, this.entriesCount = 0, this.currentFile = null, this._sources = []
    }
    r.inherits(h, s), h.prototype.push = function (t) {
      var e = t.meta.percent || 0,
        n = this.entriesCount,
        r = this._sources.length;
      this.accumulate ? this.contentBuffer.push(t) : (this.bytesWritten += t.data.length, s.prototype.push.call(this, {
        data: t.data,
        meta: {
          currentFile: this.currentFile,
          percent: n ? (e + 100 * (n - r - 1)) / n : 100
        }
      }))
    }, h.prototype.openedSource = function (t) {
      this.currentSourceOffset = this.bytesWritten, this.currentFile = t.file.name;
      var e = this.streamFiles && !t.file.dir;
      if (e) {
        var n = c(t, e, !1, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
          data: n.fileRecord,
          meta: {
            percent: 0
          }
        })
      } else this.accumulate = !0
    }, h.prototype.closedSource = function (t) {
      this.accumulate = !1;
      var e = this.streamFiles && !t.file.dir,
        n = c(t, e, !0, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
      if (this.dirRecords.push(n.dirRecord), e) this.push({
        data: l(t),
        meta: {
          percent: 100
        }
      });
      else
        for (this.push({
            data: n.fileRecord,
            meta: {
              percent: 0
            }
          }); this.contentBuffer.length;) this.push(this.contentBuffer.shift());
      this.currentFile = null
    }, h.prototype.flush = function () {
      for (var t = this.bytesWritten, e = 0; e < this.dirRecords.length; e++) this.push({
        data: this.dirRecords[e],
        meta: {
          percent: 100
        }
      });
      var n = this.bytesWritten - t,
        s = function (t, e, n, s, i) {
          var a = r.transformTo("string", i(s));
          return o.CENTRAL_DIRECTORY_END + "\0\0\0\0" + u(t, 2) + u(t, 2) + u(e, 4) + u(n, 4) + u(a.length, 2) + a
        }(this.dirRecords.length, n, t, this.zipComment, this.encodeFileName);
      this.push({
        data: s,
        meta: {
          percent: 100
        }
      })
    }, h.prototype.prepareNextSource = function () {
      this.previous = this._sources.shift(), this.openedSource(this.previous.streamInfo), this.isPaused ? this.previous.pause() : this.previous.resume()
    }, h.prototype.registerPrevious = function (t) {
      this._sources.push(t);
      var e = this;
      return t.on("data", (function (t) {
        e.processChunk(t)
      })), t.on("end", (function () {
        e.closedSource(e.previous.streamInfo), e._sources.length ? e.prepareNextSource() : e.end()
      })), t.on("error", (function (t) {
        e.error(t)
      })), this
    }, h.prototype.resume = function () {
      return !!s.prototype.resume.call(this) && (!this.previous && this._sources.length ? (this.prepareNextSource(), !0) : this.previous || this._sources.length || this.generatedError ? void 0 : (this.end(), !0))
    }, h.prototype.error = function (t) {
      var e = this._sources;
      if (!s.prototype.error.call(this, t)) return !1;
      for (var n = 0; n < e.length; n++) try {
        e[n].error(t)
      } catch (t) {}
      return !0
    }, h.prototype.lock = function () {
      s.prototype.lock.call(this);
      for (var t = this._sources, e = 0; e < t.length; e++) t[e].lock()
    }, t.exports = h
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(21);

    function i(t, e) {
      s.call(this, "Nodejs stream input adapter for " + t), this._upstreamEnded = !1, this._bindStream(e)
    }
    r.inherits(i, s), i.prototype._bindStream = function (t) {
      var e = this;
      this._stream = t, t.pause(), t.on("data", (function (t) {
        e.push({
          data: t,
          meta: {
            percent: 0
          }
        })
      })).on("error", (function (t) {
        e.isPaused ? this.generatedError = t : e.error(t)
      })).on("end", (function () {
        e.isPaused ? e._upstreamEnded = !0 : e.end()
      }))
    }, i.prototype.pause = function () {
      return !!s.prototype.pause.call(this) && (this._stream.pause(), !0)
    }, i.prototype.resume = function () {
      return !!s.prototype.resume.call(this) && (this._upstreamEnded ? this.end() : this._stream.resume(), !0)
    }, t.exports = i
  }, function (t, e, n) {
    "use strict";
    var r = n(10),
      s = n(41),
      i = n(35),
      a = (r = n(10), n(140)),
      o = n(70),
      u = n(48);

    function c(t) {
      return new s.Promise((function (e, n) {
        var r = t.decompressed.getContentWorker().pipe(new o);
        r.on("error", (function (t) {
          n(t)
        })).on("end", (function () {
          r.streamInfo.crc32 !== t.decompressed.crc32 ? n(new Error("Corrupted zip : CRC32 mismatch")) : e()
        })).resume()
      }))
    }
    t.exports = function (t, e) {
      var n = this;
      return e = r.extend(e || {}, {
        base64: !1,
        checkCRC32: !1,
        optimizedBinaryString: !1,
        createFolders: !1,
        decodeFileName: i.utf8decode
      }), u.isNode && u.isStream(t) ? s.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")) : r.prepareContent("the loaded zip file", t, !0, e.optimizedBinaryString, e.base64).then((function (t) {
        var n = new a(e);
        return n.load(t), n
      })).then((function (t) {
        var n = [s.Promise.resolve(t)],
          r = t.files;
        if (e.checkCRC32)
          for (var i = 0; i < r.length; i++) n.push(c(r[i]));
        return s.Promise.all(n)
      })).then((function (t) {
        for (var r = t.shift(), s = r.files, i = 0; i < s.length; i++) {
          var a = s[i];
          n.file(a.fileNameStr, a.decompressed, {
            binary: !0,
            optimizedBinaryString: !0,
            date: a.date,
            dir: a.dir,
            comment: a.fileCommentStr.length ? a.fileCommentStr : null,
            unixPermissions: a.unixPermissions,
            dosPermissions: a.dosPermissions,
            createFolders: e.createFolders
          })
        }
        return r.zipComment.length && (n.comment = r.zipComment), n
      }))
    }
  }, function (t, e, n) {
    "use strict";
    var r = n(78),
      s = n(10),
      i = n(77),
      a = n(143),
      o = (n(35), n(28));

    function u(t) {
      this.files = [], this.loadOptions = t
    }
    u.prototype = {
      checkSignature: function (t) {
        if (!this.reader.readAndCheckSignature(t)) {
          this.reader.index -= 4;
          var e = this.reader.readString(4);
          throw new Error("Corrupted zip or bug: unexpected signature (" + s.pretty(e) + ", expected " + s.pretty(t) + ")")
        }
      },
      isSignature: function (t, e) {
        var n = this.reader.index;
        this.reader.setIndex(t);
        var r = this.reader.readString(4) === e;
        return this.reader.setIndex(n), r
      },
      readBlockEndOfCentral: function () {
        this.diskNumber = this.reader.readInt(2), this.diskWithCentralDirStart = this.reader.readInt(2), this.centralDirRecordsOnThisDisk = this.reader.readInt(2), this.centralDirRecords = this.reader.readInt(2), this.centralDirSize = this.reader.readInt(4), this.centralDirOffset = this.reader.readInt(4), this.zipCommentLength = this.reader.readInt(2);
        var t = this.reader.readData(this.zipCommentLength),
          e = o.uint8array ? "uint8array" : "array",
          n = s.transformTo(e, t);
        this.zipComment = this.loadOptions.decodeFileName(n)
      },
      readBlockZip64EndOfCentral: function () {
        this.zip64EndOfCentralSize = this.reader.readInt(8), this.reader.skip(4), this.diskNumber = this.reader.readInt(4), this.diskWithCentralDirStart = this.reader.readInt(4), this.centralDirRecordsOnThisDisk = this.reader.readInt(8), this.centralDirRecords = this.reader.readInt(8), this.centralDirSize = this.reader.readInt(8), this.centralDirOffset = this.reader.readInt(8), this.zip64ExtensibleData = {};
        for (var t, e, n, r = this.zip64EndOfCentralSize - 44; 0 < r;) t = this.reader.readInt(2), e = this.reader.readInt(4), n = this.reader.readData(e), this.zip64ExtensibleData[t] = {
          id: t,
          length: e,
          value: n
        }
      },
      readBlockZip64EndOfCentralLocator: function () {
        if (this.diskWithZip64CentralDirStart = this.reader.readInt(4), this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8), this.disksCount = this.reader.readInt(4), this.disksCount > 1) throw new Error("Multi-volumes zip are not supported")
      },
      readLocalFiles: function () {
        var t, e;
        for (t = 0; t < this.files.length; t++) e = this.files[t], this.reader.setIndex(e.localHeaderOffset), this.checkSignature(i.LOCAL_FILE_HEADER), e.readLocalPart(this.reader), e.handleUTF8(), e.processAttributes()
      },
      readCentralDir: function () {
        var t;
        for (this.reader.setIndex(this.centralDirOffset); this.reader.readAndCheckSignature(i.CENTRAL_FILE_HEADER);)(t = new a({
          zip64: this.zip64
        }, this.loadOptions)).readCentralPart(this.reader), this.files.push(t);
        if (this.centralDirRecords !== this.files.length && 0 !== this.centralDirRecords && 0 === this.files.length) throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length)
      },
      readEndOfCentral: function () {
        var t = this.reader.lastIndexOfSignature(i.CENTRAL_DIRECTORY_END);
        if (t < 0) throw !this.isSignature(0, i.LOCAL_FILE_HEADER) ? new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html") : new Error("Corrupted zip: can't find end of central directory");
        this.reader.setIndex(t);
        var e = t;
        if (this.checkSignature(i.CENTRAL_DIRECTORY_END), this.readBlockEndOfCentral(), this.diskNumber === s.MAX_VALUE_16BITS || this.diskWithCentralDirStart === s.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === s.MAX_VALUE_16BITS || this.centralDirRecords === s.MAX_VALUE_16BITS || this.centralDirSize === s.MAX_VALUE_32BITS || this.centralDirOffset === s.MAX_VALUE_32BITS) {
          if (this.zip64 = !0, (t = this.reader.lastIndexOfSignature(i.ZIP64_CENTRAL_DIRECTORY_LOCATOR)) < 0) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
          if (this.reader.setIndex(t), this.checkSignature(i.ZIP64_CENTRAL_DIRECTORY_LOCATOR), this.readBlockZip64EndOfCentralLocator(), !this.isSignature(this.relativeOffsetEndOfZip64CentralDir, i.ZIP64_CENTRAL_DIRECTORY_END) && (this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(i.ZIP64_CENTRAL_DIRECTORY_END), this.relativeOffsetEndOfZip64CentralDir < 0)) throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
          this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir), this.checkSignature(i.ZIP64_CENTRAL_DIRECTORY_END), this.readBlockZip64EndOfCentral()
        }
        var n = this.centralDirOffset + this.centralDirSize;
        this.zip64 && (n += 20, n += 12 + this.zip64EndOfCentralSize);
        var r = e - n;
        if (r > 0) this.isSignature(e, i.CENTRAL_FILE_HEADER) || (this.reader.zero = r);
        else if (r < 0) throw new Error("Corrupted zip: missing " + Math.abs(r) + " bytes.")
      },
      prepareReader: function (t) {
        this.reader = r(t)
      },
      load: function (t) {
        this.prepareReader(t), this.readEndOfCentral(), this.readCentralDir(), this.readLocalFiles()
      }
    }, t.exports = u
  }, function (t, e, n) {
    "use strict";
    var r = n(80);

    function s(t) {
      r.call(this, t)
    }
    n(10).inherits(s, r), s.prototype.byteAt = function (t) {
      return this.data.charCodeAt(this.zero + t)
    }, s.prototype.lastIndexOfSignature = function (t) {
      return this.data.lastIndexOf(t) - this.zero
    }, s.prototype.readAndCheckSignature = function (t) {
      return t === this.readData(4)
    }, s.prototype.readData = function (t) {
      this.checkOffset(t);
      var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
      return this.index += t, e
    }, t.exports = s
  }, function (t, e, n) {
    "use strict";
    var r = n(81);

    function s(t) {
      r.call(this, t)
    }
    n(10).inherits(s, r), s.prototype.readData = function (t) {
      this.checkOffset(t);
      var e = this.data.slice(this.zero + this.index, this.zero + this.index + t);
      return this.index += t, e
    }, t.exports = s
  }, function (t, e, n) {
    "use strict";
    var r = n(78),
      s = n(10),
      i = n(55),
      a = n(56),
      o = n(35),
      u = n(71),
      c = n(28);

    function l(t, e) {
      this.options = t, this.loadOptions = e
    }
    l.prototype = {
      isEncrypted: function () {
        return 1 == (1 & this.bitFlag)
      },
      useUTF8: function () {
        return 2048 == (2048 & this.bitFlag)
      },
      readLocalPart: function (t) {
        var e, n;
        if (t.skip(22), this.fileNameLength = t.readInt(2), n = t.readInt(2), this.fileName = t.readData(this.fileNameLength), t.skip(n), -1 === this.compressedSize || -1 === this.uncompressedSize) throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory (compressedSize === -1 || uncompressedSize === -1)");
        if (null === (e = function (t) {
            for (var e in u)
              if (u.hasOwnProperty(e) && u[e].magic === t) return u[e];
            return null
          }(this.compressionMethod))) throw new Error("Corrupted zip : compression " + s.pretty(this.compressionMethod) + " unknown (inner file : " + s.transformTo("string", this.fileName) + ")");
        this.decompressed = new i(this.compressedSize, this.uncompressedSize, this.crc32, e, t.readData(this.compressedSize))
      },
      readCentralPart: function (t) {
        this.versionMadeBy = t.readInt(2), t.skip(2), this.bitFlag = t.readInt(2), this.compressionMethod = t.readString(2), this.date = t.readDate(), this.crc32 = t.readInt(4), this.compressedSize = t.readInt(4), this.uncompressedSize = t.readInt(4);
        var e = t.readInt(2);
        if (this.extraFieldsLength = t.readInt(2), this.fileCommentLength = t.readInt(2), this.diskNumberStart = t.readInt(2), this.internalFileAttributes = t.readInt(2), this.externalFileAttributes = t.readInt(4), this.localHeaderOffset = t.readInt(4), this.isEncrypted()) throw new Error("Encrypted zip are not supported");
        t.skip(e), this.readExtraFields(t), this.parseZIP64ExtraField(t), this.fileComment = t.readData(this.fileCommentLength)
      },
      processAttributes: function () {
        this.unixPermissions = null, this.dosPermissions = null;
        var t = this.versionMadeBy >> 8;
        this.dir = !!(16 & this.externalFileAttributes), 0 === t && (this.dosPermissions = 63 & this.externalFileAttributes), 3 === t && (this.unixPermissions = this.externalFileAttributes >> 16 & 65535), this.dir || "/" !== this.fileNameStr.slice(-1) || (this.dir = !0)
      },
      parseZIP64ExtraField: function (t) {
        if (this.extraFields[1]) {
          var e = r(this.extraFields[1].value);
          this.uncompressedSize === s.MAX_VALUE_32BITS && (this.uncompressedSize = e.readInt(8)), this.compressedSize === s.MAX_VALUE_32BITS && (this.compressedSize = e.readInt(8)), this.localHeaderOffset === s.MAX_VALUE_32BITS && (this.localHeaderOffset = e.readInt(8)), this.diskNumberStart === s.MAX_VALUE_32BITS && (this.diskNumberStart = e.readInt(4))
        }
      },
      readExtraFields: function (t) {
        var e, n, r, s = t.index + this.extraFieldsLength;
        for (this.extraFields || (this.extraFields = {}); t.index < s;) e = t.readInt(2), n = t.readInt(2), r = t.readData(n), this.extraFields[e] = {
          id: e,
          length: n,
          value: r
        }
      },
      handleUTF8: function () {
        var t = c.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) this.fileNameStr = o.utf8decode(this.fileName), this.fileCommentStr = o.utf8decode(this.fileComment);
        else {
          var e = this.findExtraFieldUnicodePath();
          if (null !== e) this.fileNameStr = e;
          else {
            var n = s.transformTo(t, this.fileName);
            this.fileNameStr = this.loadOptions.decodeFileName(n)
          }
          var r = this.findExtraFieldUnicodeComment();
          if (null !== r) this.fileCommentStr = r;
          else {
            var i = s.transformTo(t, this.fileComment);
            this.fileCommentStr = this.loadOptions.decodeFileName(i)
          }
        }
      },
      findExtraFieldUnicodePath: function () {
        var t = this.extraFields[28789];
        if (t) {
          var e = r(t.value);
          return 1 !== e.readInt(1) ? null : a(this.fileName) !== e.readInt(4) ? null : o.utf8decode(e.readData(t.length - 5))
        }
        return null
      },
      findExtraFieldUnicodeComment: function () {
        var t = this.extraFields[25461];
        if (t) {
          var e = r(t.value);
          return 1 !== e.readInt(1) ? null : a(this.fileComment) !== e.readInt(4) ? null : o.utf8decode(e.readData(t.length - 5))
        }
        return null
      }
    }, t.exports = l
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      var e = n(49),
        r = n(9);
      /**
       * @license
       * Copyright 2019 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      const s = Object(r.b)();
      s.registerFlag("DEBUG", () => !1, t => {
        t && console.warn("Debugging mode is ON. The output of every math call will be downloaded to CPU and checked for NaNs. This significantly impacts performance.")
      }), s.registerFlag("IS_BROWSER", () => e.isBrowser()), s.registerFlag("IS_NODE", () => void 0 !== t && void 0 !== t.versions && void 0 !== t.versions.node), s.registerFlag("IS_CHROME", () => "undefined" != typeof navigator && null != navigator && null != navigator.userAgent && /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)), s.registerFlag("PROD", () => !1), s.registerFlag("TENSORLIKE_CHECK_SHAPE_CONSISTENCY", () => s.getBool("DEBUG")), s.registerFlag("DEPRECATION_WARNINGS_ENABLED", () => !0), s.registerFlag("IS_TEST", () => !1)
    }).call(this, n(32))
  }, function (t, e, n) {
    "use strict";
    (function (t) {
      var e = n(9);
      /**
       * @license
       * Copyright 2019 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      const r = {
        importFetch: () => n(146)
      };
      let s;
      class i {
        constructor() {
          this.util = n(147), this.textEncoder = new this.util.TextEncoder
        }
        fetch(t, n) {
          return null != Object(e.b)().global.fetch ? Object(e.b)().global.fetch(t, n) : (null == s && (s = r.importFetch()), s(t, n))
        }
        now() {
          const e = t.hrtime();
          return 1e3 * e[0] + e[1] / 1e6
        }
        encode(t, e) {
          if ("utf-8" !== e && "utf8" !== e) throw new Error(`Node built-in encoder only supports utf-8, but got ${e}`);
          return this.textEncoder.encode(t)
        }
        decode(t, e) {
          return 0 === t.length ? "" : new this.util.TextDecoder(e).decode(t)
        }
      }
      Object(e.b)().get("IS_NODE") && Object(e.b)().setPlatform("node", new i)
    }).call(this, n(32))
  }, function (t, e) {}, function (t, e) {}, function (t, e, n) {
    (function (t) {
      var r;
      ! function (t, s, i) {
        function a(t) {
          var e, n = this,
            r = (e = 4022871197, function (t) {
              t = t.toString();
              for (var n = 0; n < t.length; n++) {
                var r = .02519603282416938 * (e += t.charCodeAt(n));
                r -= e = r >>> 0, e = (r *= e) >>> 0, e += 4294967296 * (r -= e)
              }
              return 2.3283064365386963e-10 * (e >>> 0)
            });
          n.next = function () {
            var t = 2091639 * n.s0 + 2.3283064365386963e-10 * n.c;
            return n.s0 = n.s1, n.s1 = n.s2, n.s2 = t - (n.c = 0 | t)
          }, n.c = 1, n.s0 = r(" "), n.s1 = r(" "), n.s2 = r(" "), n.s0 -= r(t), n.s0 < 0 && (n.s0 += 1), n.s1 -= r(t), n.s1 < 0 && (n.s1 += 1), n.s2 -= r(t), n.s2 < 0 && (n.s2 += 1), r = null
        }

        function o(t, e) {
          return e.c = t.c, e.s0 = t.s0, e.s1 = t.s1, e.s2 = t.s2, e
        }

        function u(t, e) {
          var n = new a(t),
            r = e && e.state,
            s = n.next;
          return s.int32 = function () {
            return 4294967296 * n.next() | 0
          }, s.double = function () {
            return s() + 11102230246251565e-32 * (2097152 * s() | 0)
          }, s.quick = s, r && ("object" == typeof r && o(r, n), s.state = function () {
            return o(n, {})
          }), s
        }
        s && s.exports ? s.exports = u : n(22) && n(38) ? void 0 === (r = function () {
          return u
        }.call(e, n, e, s)) || (s.exports = r) : this.alea = u
      }(0, t, n(22))
    }).call(this, n(37)(t))
  }, function (t, e, n) {
    (function (t) {
      var r;
      ! function (t, s, i) {
        function a(t) {
          var e = this,
            n = "";
          e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.next = function () {
            var t = e.x ^ e.x << 11;
            return e.x = e.y, e.y = e.z, e.z = e.w, e.w ^= e.w >>> 19 ^ t ^ t >>> 8
          }, t === (0 | t) ? e.x = t : n += t;
          for (var r = 0; r < n.length + 64; r++) e.x ^= 0 | n.charCodeAt(r), e.next()
        }

        function o(t, e) {
          return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e
        }

        function u(t, e) {
          var n = new a(t),
            r = e && e.state,
            s = function () {
              return (n.next() >>> 0) / 4294967296
            };
          return s.double = function () {
            do {
              var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21)
            } while (0 === t);
            return t
          }, s.int32 = n.next, s.quick = s, r && ("object" == typeof r && o(r, n), s.state = function () {
            return o(n, {})
          }), s
        }
        s && s.exports ? s.exports = u : n(22) && n(38) ? void 0 === (r = function () {
          return u
        }.call(e, n, e, s)) || (s.exports = r) : this.xor128 = u
      }(0, t, n(22))
    }).call(this, n(37)(t))
  }, function (t, e, n) {
    (function (t) {
      var r;
      ! function (t, s, i) {
        function a(t) {
          var e = this,
            n = "";
          e.next = function () {
            var t = e.x ^ e.x >>> 2;
            return e.x = e.y, e.y = e.z, e.z = e.w, e.w = e.v, (e.d = e.d + 362437 | 0) + (e.v = e.v ^ e.v << 4 ^ t ^ t << 1) | 0
          }, e.x = 0, e.y = 0, e.z = 0, e.w = 0, e.v = 0, t === (0 | t) ? e.x = t : n += t;
          for (var r = 0; r < n.length + 64; r++) e.x ^= 0 | n.charCodeAt(r), r == n.length && (e.d = e.x << 10 ^ e.x >>> 4), e.next()
        }

        function o(t, e) {
          return e.x = t.x, e.y = t.y, e.z = t.z, e.w = t.w, e.v = t.v, e.d = t.d, e
        }

        function u(t, e) {
          var n = new a(t),
            r = e && e.state,
            s = function () {
              return (n.next() >>> 0) / 4294967296
            };
          return s.double = function () {
            do {
              var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21)
            } while (0 === t);
            return t
          }, s.int32 = n.next, s.quick = s, r && ("object" == typeof r && o(r, n), s.state = function () {
            return o(n, {})
          }), s
        }
        s && s.exports ? s.exports = u : n(22) && n(38) ? void 0 === (r = function () {
          return u
        }.call(e, n, e, s)) || (s.exports = r) : this.xorwow = u
      }(0, t, n(22))
    }).call(this, n(37)(t))
  }, function (t, e, n) {
    (function (t) {
      var r;
      ! function (t, s, i) {
        function a(t) {
          var e = this;
          e.next = function () {
              var t, n, r = e.x,
                s = e.i;
              return t = r[s], n = (t ^= t >>> 7) ^ t << 24, n ^= (t = r[s + 1 & 7]) ^ t >>> 10, n ^= (t = r[s + 3 & 7]) ^ t >>> 3, n ^= (t = r[s + 4 & 7]) ^ t << 7, t = r[s + 7 & 7], n ^= (t ^= t << 13) ^ t << 9, r[s] = n, e.i = s + 1 & 7, n
            },
            function (t, e) {
              var n, r = [];
              if (e === (0 | e)) r[0] = e;
              else
                for (e = "" + e, n = 0; n < e.length; ++n) r[7 & n] = r[7 & n] << 15 ^ e.charCodeAt(n) + r[n + 1 & 7] << 13;
              for (; r.length < 8;) r.push(0);
              for (n = 0; n < 8 && 0 === r[n]; ++n);
              for (8 == n ? r[7] = -1 : r[n], t.x = r, t.i = 0, n = 256; n > 0; --n) t.next()
            }(e, t)
        }

        function o(t, e) {
          return e.x = t.x.slice(), e.i = t.i, e
        }

        function u(t, e) {
          null == t && (t = +new Date);
          var n = new a(t),
            r = e && e.state,
            s = function () {
              return (n.next() >>> 0) / 4294967296
            };
          return s.double = function () {
            do {
              var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21)
            } while (0 === t);
            return t
          }, s.int32 = n.next, s.quick = s, r && (r.x && o(r, n), s.state = function () {
            return o(n, {})
          }), s
        }
        s && s.exports ? s.exports = u : n(22) && n(38) ? void 0 === (r = function () {
          return u
        }.call(e, n, e, s)) || (s.exports = r) : this.xorshift7 = u
      }(0, t, n(22))
    }).call(this, n(37)(t))
  }, function (t, e, n) {
    (function (t) {
      var r;
      ! function (t, s, i) {
        function a(t) {
          var e = this;
          e.next = function () {
              var t, n, r = e.w,
                s = e.X,
                i = e.i;
              return e.w = r = r + 1640531527 | 0, n = s[i + 34 & 127], t = s[i = i + 1 & 127], n ^= n << 13, t ^= t << 17, n ^= n >>> 15, t ^= t >>> 12, n = s[i] = n ^ t, e.i = i, n + (r ^ r >>> 16) | 0
            },
            function (t, e) {
              var n, r, s, i, a, o = [],
                u = 128;
              for (e === (0 | e) ? (r = e, e = null) : (e += "\0", r = 0, u = Math.max(u, e.length)), s = 0, i = -32; i < u; ++i) e && (r ^= e.charCodeAt((i + 32) % e.length)), 0 === i && (a = r), r ^= r << 10, r ^= r >>> 15, r ^= r << 4, r ^= r >>> 13, i >= 0 && (a = a + 1640531527 | 0, s = 0 == (n = o[127 & i] ^= r + a) ? s + 1 : 0);
              for (s >= 128 && (o[127 & (e && e.length || 0)] = -1), s = 127, i = 512; i > 0; --i) r = o[s + 34 & 127], n = o[s = s + 1 & 127], r ^= r << 13, n ^= n << 17, r ^= r >>> 15, n ^= n >>> 12, o[s] = r ^ n;
              t.w = a, t.X = o, t.i = s
            }(e, t)
        }

        function o(t, e) {
          return e.i = t.i, e.w = t.w, e.X = t.X.slice(), e
        }

        function u(t, e) {
          null == t && (t = +new Date);
          var n = new a(t),
            r = e && e.state,
            s = function () {
              return (n.next() >>> 0) / 4294967296
            };
          return s.double = function () {
            do {
              var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21)
            } while (0 === t);
            return t
          }, s.int32 = n.next, s.quick = s, r && (r.X && o(r, n), s.state = function () {
            return o(n, {})
          }), s
        }
        s && s.exports ? s.exports = u : n(22) && n(38) ? void 0 === (r = function () {
          return u
        }.call(e, n, e, s)) || (s.exports = r) : this.xor4096 = u
      }(0, t, n(22))
    }).call(this, n(37)(t))
  }, function (t, e, n) {
    (function (t) {
      var r;
      ! function (t, s, i) {
        function a(t) {
          var e = this,
            n = "";
          e.next = function () {
            var t = e.b,
              n = e.c,
              r = e.d,
              s = e.a;
            return t = t << 25 ^ t >>> 7 ^ n, n = n - r | 0, r = r << 24 ^ r >>> 8 ^ s, s = s - t | 0, e.b = t = t << 20 ^ t >>> 12 ^ n, e.c = n = n - r | 0, e.d = r << 16 ^ n >>> 16 ^ s, e.a = s - t | 0
          }, e.a = 0, e.b = 0, e.c = -1640531527, e.d = 1367130551, t === Math.floor(t) ? (e.a = t / 4294967296 | 0, e.b = 0 | t) : n += t;
          for (var r = 0; r < n.length + 20; r++) e.b ^= 0 | n.charCodeAt(r), e.next()
        }

        function o(t, e) {
          return e.a = t.a, e.b = t.b, e.c = t.c, e.d = t.d, e
        }

        function u(t, e) {
          var n = new a(t),
            r = e && e.state,
            s = function () {
              return (n.next() >>> 0) / 4294967296
            };
          return s.double = function () {
            do {
              var t = ((n.next() >>> 11) + (n.next() >>> 0) / 4294967296) / (1 << 21)
            } while (0 === t);
            return t
          }, s.int32 = n.next, s.quick = s, r && ("object" == typeof r && o(r, n), s.state = function () {
            return o(n, {})
          }), s
        }
        s && s.exports ? s.exports = u : n(22) && n(38) ? void 0 === (r = function () {
          return u
        }.call(e, n, e, s)) || (s.exports = r) : this.tychei = u
      }(0, t, n(22))
    }).call(this, n(37)(t))
  }, function (t, e, n) {
    var r;
    ! function (s, i) {
      var a, o = this,
        u = 256,
        c = 6,
        l = "random",
        h = i.pow(u, c),
        d = i.pow(2, 52),
        p = 2 * d,
        f = u - 1;

      function m(t, e, n) {
        var r = [],
          f = y(function t(e, n) {
            var r, s = [],
              i = typeof e;
            if (n && "object" == i)
              for (r in e) try {
                s.push(t(e[r], n - 1))
              } catch (t) {}
            return s.length ? s : "string" == i ? e : e + "\0"
          }((e = 1 == e ? {
            entropy: !0
          } : e || {}).entropy ? [t, w(s)] : null == t ? function () {
            try {
              var t;
              return a && (t = a.randomBytes) ? t = t(u) : (t = new Uint8Array(u), (o.crypto || o.msCrypto).getRandomValues(t)), w(t)
            } catch (t) {
              var e = o.navigator,
                n = e && e.plugins;
              return [+new Date, o, n, o.screen, w(s)]
            }
          }() : t, 3), r),
          m = new g(r),
          v = function () {
            for (var t = m.g(c), e = h, n = 0; t < d;) t = (t + n) * u, e *= u, n = m.g(1);
            for (; t >= p;) t /= 2, e /= 2, n >>>= 1;
            return (t + n) / e
          };
        return v.int32 = function () {
          return 0 | m.g(4)
        }, v.quick = function () {
          return m.g(4) / 4294967296
        }, v.double = v, y(w(m.S), s), (e.pass || n || function (t, e, n, r) {
          return r && (r.S && b(r, m), t.state = function () {
            return b(m, {})
          }), n ? (i[l] = t, e) : t
        })(v, f, "global" in e ? e.global : this == i, e.state)
      }

      function g(t) {
        var e, n = t.length,
          r = this,
          s = 0,
          i = r.i = r.j = 0,
          a = r.S = [];
        for (n || (t = [n++]); s < u;) a[s] = s++;
        for (s = 0; s < u; s++) a[s] = a[i = f & i + t[s % n] + (e = a[s])], a[i] = e;
        (r.g = function (t) {
          for (var e, n = 0, s = r.i, i = r.j, a = r.S; t--;) e = a[s = f & s + 1], n = n * u + a[f & (a[s] = a[i = f & i + e]) + (a[i] = e)];
          return r.i = s, r.j = i, n
        })(u)
      }

      function b(t, e) {
        return e.i = t.i, e.j = t.j, e.S = t.S.slice(), e
      }

      function y(t, e) {
        for (var n, r = t + "", s = 0; s < r.length;) e[f & s] = f & (n ^= 19 * e[f & s]) + r.charCodeAt(s++);
        return w(e)
      }

      function w(t) {
        return String.fromCharCode.apply(0, t)
      }
      if (i["seed" + l] = m, y(i.random(), s), t.exports) {
        t.exports = m;
        try {
          a = n(155)
        } catch (t) {}
      } else void 0 === (r = function () {
        return m
      }.call(e, n, e, t)) || (t.exports = r)
    }([], Math)
  }, function (t, e) {}, function (t, e) {}, function (t, e) {}, , , , function (t, e, n) {
    "use strict";
    n.r(e);
    var r = {};
    n.r(r), n.d(r, "maxImpl", (function () {
      return wo
    })), n.d(r, "transposeImpl", (function () {
      return vo
    }));
    var s, i = (s = "undefined" != typeof document && document.currentScript ? document.currentScript.src : void 0, function (t) {
        var e, n;
        t = t || {}, e || (e = void 0 !== t ? t : {}), e.ready = new Promise((function (t) {
          n = t
        }));
        var r, i = {};
        for (r in e) e.hasOwnProperty(r) && (i[r] = e[r]);
        var a = "./this.program",
          o = "";
        document.currentScript && (o = document.currentScript.src), s && (o = s), o = 0 !== o.indexOf("blob:") ? o.substr(0, o.lastIndexOf("/") + 1) : "";
        var u, c = e.print || console.log.bind(console),
          l = e.printErr || console.warn.bind(console);
        for (r in i) i.hasOwnProperty(r) && (e[r] = i[r]);
        i = null, e.thisProgram && (a = e.thisProgram), e.wasmBinary && (u = e.wasmBinary), e.noExitRuntime && e.noExitRuntime, "object" != typeof WebAssembly && l("no native wasm support detected");
        var h, d = new WebAssembly.Table({
            initial: 525,
            maximum: 525,
            element: "anyfunc"
          }),
          p = !1;

        function f(t) {
          var n = e["_" + t];
          return n || U("Assertion failed: Cannot call unknown function " + t + ", make sure it is exported"), n
        }

        function m(t, e, n, r) {
          var s, i = {
              string: function (t) {
                var e = 0;
                if (null != t && 0 !== t) {
                  var n = 1 + (t.length << 2);
                  e = de(n), C(t, y, e, n)
                }
                return e
              },
              array: function (t) {
                var e = de(t.length);
                return b.set(t, e), e
              }
            },
            a = f(t),
            o = [];
          if (t = 0, r)
            for (var u = 0; u < r.length; u++) {
              var c = i[n[u]];
              c ? (0 === t && (t = he()), o[u] = c(r[u])) : o[u] = r[u]
            }
          return n = a.apply(null, o), s = n, n = "string" === e ? k(s) : "boolean" === e ? !!s : s, 0 !== t && pe(t), n
        }
        var g, b, y, w, v, x, O, S = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;

        function _(t, e, n) {
          var r = e + n;
          for (n = e; t[n] && !(n >= r);) ++n;
          if (16 < n - e && t.subarray && S) return S.decode(t.subarray(e, n));
          for (r = ""; e < n;) {
            var s = t[e++];
            if (128 & s) {
              var i = 63 & t[e++];
              if (192 == (224 & s)) r += String.fromCharCode((31 & s) << 6 | i);
              else {
                var a = 63 & t[e++];
                65536 > (s = 224 == (240 & s) ? (15 & s) << 12 | i << 6 | a : (7 & s) << 18 | i << 12 | a << 6 | 63 & t[e++]) ? r += String.fromCharCode(s) : (s -= 65536, r += String.fromCharCode(55296 | s >> 10, 56320 | 1023 & s))
              }
            } else r += String.fromCharCode(s)
          }
          return r
        }

        function k(t) {
          return t ? _(y, t, void 0) : ""
        }

        function C(t, e, n, r) {
          if (!(0 < r)) return 0;
          var s = n;
          r = n + r - 1;
          for (var i = 0; i < t.length; ++i) {
            var a = t.charCodeAt(i);
            if (55296 <= a && 57343 >= a && (a = 65536 + ((1023 & a) << 10) | 1023 & t.charCodeAt(++i)), 127 >= a) {
              if (n >= r) break;
              e[n++] = a
            } else {
              if (2047 >= a) {
                if (n + 1 >= r) break;
                e[n++] = 192 | a >> 6
              } else {
                if (65535 >= a) {
                  if (n + 2 >= r) break;
                  e[n++] = 224 | a >> 12
                } else {
                  if (n + 3 >= r) break;
                  e[n++] = 240 | a >> 18, e[n++] = 128 | a >> 12 & 63
                }
                e[n++] = 128 | a >> 6 & 63
              }
              e[n++] = 128 | 63 & a
            }
          }
          return e[n] = 0, n - s
        }

        function E(t) {
          g = t, e.HEAP8 = b = new Int8Array(t), e.HEAP16 = w = new Int16Array(t), e.HEAP32 = v = new Int32Array(t), e.HEAPU8 = y = new Uint8Array(t), e.HEAPU16 = new Uint16Array(t), e.HEAPU32 = new Uint32Array(t), e.HEAPF32 = x = new Float32Array(t), e.HEAPF64 = O = new Float64Array(t)
        }
        "undefined" != typeof TextDecoder && new TextDecoder("utf-16le");
        var I = e.INITIAL_MEMORY || 16777216;

        function T(t) {
          for (; 0 < t.length;) {
            var n = t.shift();
            if ("function" == typeof n) n(e);
            else {
              var r = n.$;
              "number" == typeof r ? void 0 === n.H ? e.dynCall_v(r) : e.dynCall_vi(r, n.H) : r(void 0 === n.H ? null : n.H)
            }
          }
        }(h = e.wasmMemory ? e.wasmMemory : new WebAssembly.Memory({
          initial: I / 65536,
          maximum: 32768
        })) && (g = h.buffer), I = g.byteLength, E(g), v[80848] = 5566432;
        var A = [],
          N = [],
          $ = [],
          R = [],
          j = [];

        function D() {
          var t = e.preRun.shift();
          A.unshift(t)
        }
        var F = Math.abs,
          M = Math.ceil,
          z = Math.floor,
          L = Math.min,
          B = 0,
          P = null,
          W = null;

        function U(t) {
          throw e.onAbort && e.onAbort(t), c(t), l(t), p = !0, new WebAssembly.RuntimeError("abort(" + t + "). Build with -s ASSERTIONS=1 for more info.")
        }

        function V() {
          var t = q;
          return String.prototype.startsWith ? t.startsWith("data:application/octet-stream;base64,") : 0 === t.indexOf("data:application/octet-stream;base64,")
        }
        e.preloadedImages = {}, e.preloadedAudios = {};
        var H, G, q = "libxzimgMagicFace.wasm";
        if (!V()) {
          var K = q;
          q = e.locateFile ? e.locateFile(K, o) : o + K
        }

        function J() {
          try {
            if (u) return new Uint8Array(u);
            throw "both async and sync fetching of the wasm failed"
          } catch (t) {
            U(t)
          }
        }

        function X() {
          return 0 < X.V
        }

        function Y(t, e) {
          for (var n = 0, r = t.length - 1; 0 <= r; r--) {
            var s = t[r];
            "." === s ? t.splice(r, 1) : ".." === s ? (t.splice(r, 1), n++) : n && (t.splice(r, 1), n--)
          }
          if (e)
            for (; n; n--) t.unshift("..");
          return t
        }

        function Z(t) {
          var e = "/" === t.charAt(0),
            n = "/" === t.substr(-1);
          return (t = Y(t.split("/").filter((function (t) {
            return !!t
          })), !e).join("/")) || e || (t = "."), t && n && (t += "/"), (e ? "/" : "") + t
        }

        function Q(t) {
          var e = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/.exec(t).slice(1);
          return t = e[0], e = e[1], t || e ? (e && (e = e.substr(0, e.length - 1)), t + e) : "."
        }

        function tt(t) {
          if ("/" === t) return "/";
          var e = t.lastIndexOf("/");
          return -1 === e ? t : t.substr(e + 1)
        }

        function et() {
          for (var t = "", e = !1, n = arguments.length - 1; - 1 <= n && !e; n--) {
            if ("string" != typeof (e = 0 <= n ? arguments[n] : "/")) throw new TypeError("Arguments to path.resolve must be strings");
            if (!e) return "";
            t = e + "/" + t, e = "/" === e.charAt(0)
          }
          return (e ? "/" : "") + (t = Y(t.split("/").filter((function (t) {
            return !!t
          })), !e).join("/")) || "."
        }
        N.push({
          $: function () {
            ae()
          }
        });
        var nt = [];

        function rt(t, e) {
          nt[t] = {
            input: [],
            i: [],
            B: e
          }, Tt(t, st)
        }
        var st = {
            open: function (t) {
              var e = nt[t.node.L];
              if (!e) throw new mt(43);
              t.h = e, t.seekable = !1
            },
            close: function (t) {
              t.h.B.flush(t.h)
            },
            flush: function (t) {
              t.h.B.flush(t.h)
            },
            read: function (t, e, n, r) {
              if (!t.h || !t.h.B.aa) throw new mt(60);
              for (var s = 0, i = 0; i < r; i++) {
                try {
                  var a = t.h.B.aa(t.h)
                } catch (t) {
                  throw new mt(29)
                }
                if (void 0 === a && 0 === s) throw new mt(6);
                if (null == a) break;
                s++, e[n + i] = a
              }
              return s && (t.node.timestamp = Date.now()), s
            },
            write: function (t, e, n, r) {
              if (!t.h || !t.h.B.S) throw new mt(60);
              try {
                for (var s = 0; s < r; s++) t.h.B.S(t.h, e[n + s])
              } catch (t) {
                throw new mt(29)
              }
              return r && (t.node.timestamp = Date.now()), s
            }
          },
          it = {
            aa: function (t) {
              if (!t.input.length) {
                var e = null;
                if ("undefined" != typeof window && "function" == typeof window.prompt ? null !== (e = window.prompt("Input: ")) && (e += "\n") : "function" == typeof readline && null !== (e = readline()) && (e += "\n"), !e) return null;
                t.input = re(e, !0)
              }
              return t.input.shift()
            },
            S: function (t, e) {
              null === e || 10 === e ? (c(_(t.i, 0)), t.i = []) : 0 != e && t.i.push(e)
            },
            flush: function (t) {
              t.i && 0 < t.i.length && (c(_(t.i, 0)), t.i = [])
            }
          },
          at = {
            S: function (t, e) {
              null === e || 10 === e ? (l(_(t.i, 0)), t.i = []) : 0 != e && t.i.push(e)
            },
            flush: function (t) {
              t.i && 0 < t.i.length && (l(_(t.i, 0)), t.i = [])
            }
          },
          ot = {
            l: null,
            o: function () {
              return ot.createNode(null, "/", 16895, 0)
            },
            createNode: function (t, e, n, r) {
              if (24576 == (61440 & n) || 4096 == (61440 & n)) throw new mt(63);
              return ot.l || (ot.l = {
                dir: {
                  node: {
                    u: ot.f.u,
                    m: ot.f.m,
                    D: ot.f.D,
                    I: ot.f.I,
                    ea: ot.f.ea,
                    ga: ot.f.ga,
                    fa: ot.f.fa,
                    da: ot.f.da,
                    M: ot.f.M
                  },
                  stream: {
                    A: ot.c.A
                  }
                },
                file: {
                  node: {
                    u: ot.f.u,
                    m: ot.f.m
                  },
                  stream: {
                    A: ot.c.A,
                    read: ot.c.read,
                    write: ot.c.write,
                    U: ot.c.U,
                    ba: ot.c.ba,
                    K: ot.c.K
                  }
                },
                link: {
                  node: {
                    u: ot.f.u,
                    m: ot.f.m,
                    F: ot.f.F
                  },
                  stream: {}
                },
                W: {
                  node: {
                    u: ot.f.u,
                    m: ot.f.m
                  },
                  stream: It
                }
              }), 16384 == (61440 & (n = xt(t, e, n, r)).mode) ? (n.f = ot.l.dir.node, n.c = ot.l.dir.stream, n.b = {}) : 32768 == (61440 & n.mode) ? (n.f = ot.l.file.node, n.c = ot.l.file.stream, n.g = 0, n.b = null) : 40960 == (61440 & n.mode) ? (n.f = ot.l.link.node, n.c = ot.l.link.stream) : 8192 == (61440 & n.mode) && (n.f = ot.l.W.node, n.c = ot.l.W.stream), n.timestamp = Date.now(), t && (t.b[e] = n), n
            },
            ya: function (t) {
              if (t.b && t.b.subarray) {
                for (var e = [], n = 0; n < t.g; ++n) e.push(t.b[n]);
                return e
              }
              return t.b
            },
            za: function (t) {
              return t.b ? t.b.subarray ? t.b.subarray(0, t.g) : new Uint8Array(t.b) : new Uint8Array(0)
            },
            X: function (t, e) {
              var n = t.b ? t.b.length : 0;
              n >= e || (e = Math.max(e, n * (1048576 > n ? 2 : 1.125) >>> 0), 0 != n && (e = Math.max(e, 256)), n = t.b, t.b = new Uint8Array(e), 0 < t.g && t.b.set(n.subarray(0, t.g), 0))
            },
            ma: function (t, e) {
              if (t.g != e)
                if (0 == e) t.b = null, t.g = 0;
                else {
                  if (!t.b || t.b.subarray) {
                    var n = t.b;
                    t.b = new Uint8Array(e), n && t.b.set(n.subarray(0, Math.min(e, t.g)))
                  } else if (t.b || (t.b = []), t.b.length > e) t.b.length = e;
                  else
                    for (; t.b.length < e;) t.b.push(0);
                  t.g = e
                }
            },
            f: {
              u: function (t) {
                var e = {};
                return e.wa = 8192 == (61440 & t.mode) ? t.id : 1, e.Ba = t.id, e.mode = t.mode, e.Fa = 1, e.uid = 0, e.Aa = 0, e.L = t.L, 16384 == (61440 & t.mode) ? e.size = 4096 : 32768 == (61440 & t.mode) ? e.size = t.g : 40960 == (61440 & t.mode) ? e.size = t.link.length : e.size = 0, e.ta = new Date(t.timestamp), e.Ea = new Date(t.timestamp), e.va = new Date(t.timestamp), e.ia = 4096, e.ua = Math.ceil(e.size / e.ia), e
              },
              m: function (t, e) {
                void 0 !== e.mode && (t.mode = e.mode), void 0 !== e.timestamp && (t.timestamp = e.timestamp), void 0 !== e.size && ot.ma(t, e.size)
              },
              D: function () {
                throw gt[44]
              },
              I: function (t, e, n, r) {
                return ot.createNode(t, e, n, r)
              },
              ea: function (t, e, n) {
                if (16384 == (61440 & t.mode)) {
                  try {
                    var r = vt(e, n)
                  } catch (t) {}
                  if (r)
                    for (var s in r.b) throw new mt(55)
                }
                delete t.parent.b[t.name], t.name = n, e.b[n] = t, t.parent = e
              },
              ga: function (t, e) {
                delete t.b[e]
              },
              fa: function (t, e) {
                var n, r = vt(t, e);
                for (n in r.b) throw new mt(55);
                delete t.b[e]
              },
              da: function (t) {
                var e, n = [".", ".."];
                for (e in t.b) t.b.hasOwnProperty(e) && n.push(e);
                return n
              },
              M: function (t, e, n) {
                return (t = ot.createNode(t, e, 41471, 0)).link = n, t
              },
              F: function (t) {
                if (40960 != (61440 & t.mode)) throw new mt(28);
                return t.link
              }
            },
            c: {
              read: function (t, e, n, r, s) {
                var i = t.node.b;
                if (s >= t.node.g) return 0;
                if (8 < (t = Math.min(t.node.g - s, r)) && i.subarray) e.set(i.subarray(s, s + t), n);
                else
                  for (r = 0; r < t; r++) e[n + r] = i[s + r];
                return t
              },
              write: function (t, e, n, r, s, i) {
                if (e.buffer === b.buffer && (i = !1), !r) return 0;
                if ((t = t.node).timestamp = Date.now(), e.subarray && (!t.b || t.b.subarray)) {
                  if (i) return t.b = e.subarray(n, n + r), t.g = r;
                  if (0 === t.g && 0 === s) return t.b = e.slice(n, n + r), t.g = r;
                  if (s + r <= t.g) return t.b.set(e.subarray(n, n + r), s), r
                }
                if (ot.X(t, s + r), t.b.subarray && e.subarray) t.b.set(e.subarray(n, n + r), s);
                else
                  for (i = 0; i < r; i++) t.b[s + i] = e[n + i];
                return t.g = Math.max(t.g, s + r), r
              },
              A: function (t, e, n) {
                if (1 === n ? e += t.position : 2 === n && 32768 == (61440 & t.node.mode) && (e += t.node.g), 0 > e) throw new mt(28);
                return e
              },
              U: function (t, e, n) {
                ot.X(t.node, e + n), t.node.g = Math.max(t.node.g, e + n)
              },
              ba: function (t, e, n, r, s, i, a) {
                if (32768 != (61440 & t.node.mode)) throw new mt(43);
                if (t = t.node.b, 2 & a || t.buffer !== e.buffer) {
                  if ((0 < s || s + r < t.length) && (t = t.subarray ? t.subarray(s, s + r) : Array.prototype.slice.call(t, s, s + r)), s = !0, a = e.buffer == b.buffer, !(r = oe(r))) throw new mt(48);
                  (a ? b : e).set(t, r)
                } else s = !1, r = t.byteOffset;
                return {
                  Ia: r,
                  ha: s
                }
              },
              K: function (t, e, n, r, s) {
                if (32768 != (61440 & t.node.mode)) throw new mt(43);
                return 2 & s ? 0 : (ot.c.write(t, e, 0, r, n, !1), 0)
              }
            }
          },
          ut = null,
          ct = {},
          lt = [],
          ht = 1,
          dt = null,
          pt = !0,
          ft = {},
          mt = null,
          gt = {};

        function bt(t, e) {
          if (e = e || {}, !(t = et("/", t))) return {
            path: "",
            node: null
          };
          var n, r = {
            Z: !0,
            T: 0
          };
          for (n in r) void 0 === e[n] && (e[n] = r[n]);
          if (8 < e.T) throw new mt(32);
          t = Y(t.split("/").filter((function (t) {
            return !!t
          })), !1);
          var s = ut;
          for (r = "/", n = 0; n < t.length; n++) {
            var i = n === t.length - 1;
            if (i && e.parent) break;
            if (s = vt(s, t[n]), r = Z(r + "/" + t[n]), s.J && (!i || i && e.Z) && (s = s.J.root), !i || e.Y)
              for (i = 0; 40960 == (61440 & s.mode);)
                if (s = Dt(r), s = bt(r = et(Q(r), s), {
                    T: e.T
                  }).node, 40 < i++) throw new mt(32)
          }
          return {
            path: r,
            node: s
          }
        }

        function yt(t) {
          for (var e;;) {
            if (t === t.parent) return t = t.o.ca, e ? "/" !== t[t.length - 1] ? t + "/" + e : t + e : t;
            e = e ? t.name + "/" + e : t.name, t = t.parent
          }
        }

        function wt(t, e) {
          for (var n = 0, r = 0; r < e.length; r++) n = (n << 5) - n + e.charCodeAt(r) | 0;
          return (t + n >>> 0) % dt.length
        }

        function vt(t, e) {
          var n;
          if (n = (n = _t(t, "x")) ? n : t.f.D ? 0 : 2) throw new mt(n, t);
          for (n = dt[wt(t.id, e)]; n; n = n.la) {
            var r = n.name;
            if (n.parent.id === t.id && r === e) return n
          }
          return t.f.D(t, e)
        }

        function xt(t, e, n, r) {
          return e = wt((t = new ne(t, e, n, r)).parent.id, t.name), t.la = dt[e], dt[e] = t
        }
        var Ot = {
          r: 0,
          rs: 1052672,
          "r+": 2,
          w: 577,
          wx: 705,
          xw: 705,
          "w+": 578,
          "wx+": 706,
          "xw+": 706,
          a: 1089,
          ax: 1217,
          xa: 1217,
          "a+": 1090,
          "ax+": 1218,
          "xa+": 1218
        };

        function St(t) {
          var e = ["r", "w", "rw"][3 & t];
          return 512 & t && (e += "w"), e
        }

        function _t(t, e) {
          return pt ? 0 : (-1 === e.indexOf("r") || 292 & t.mode) && (-1 === e.indexOf("w") || 146 & t.mode) && (-1 === e.indexOf("x") || 73 & t.mode) ? 0 : 2
        }

        function kt(t, e) {
          try {
            return vt(t, e), 20
          } catch (t) {}
          return _t(t, "wx")
        }

        function Ct(t) {
          Pt || ((Pt = function () {}).prototype = {});
          var e, n = new Pt;
          for (e in t) n[e] = t[e];
          return t = n, n = function () {
            for (var t = 0; t <= 4096; t++)
              if (!lt[t]) return t;
            throw new mt(33)
          }(), t.s = n, lt[n] = t
        }
        var Et, It = {
          open: function (t) {
            t.c = ct[t.node.L].c, t.c.open && t.c.open(t)
          },
          A: function () {
            throw new mt(70)
          }
        };

        function Tt(t, e) {
          ct[t] = {
            c: e
          }
        }

        function At(t, e) {
          var n = "/" === e,
            r = !e;
          if (n && ut) throw new mt(10);
          if (!n && !r) {
            var s = bt(e, {
              Z: !1
            });
            if (e = s.path, (s = s.node).J) throw new mt(10);
            if (16384 != (61440 & s.mode)) throw new mt(54)
          }
          e = {
            type: t,
            Ga: {},
            ca: e,
            ka: []
          }, (t = t.o(e)).o = e, e.root = t, n ? ut = t : s && (s.J = e, s.o && s.o.ka.push(e))
        }

        function Nt(t, e, n) {
          var r = bt(t, {
            parent: !0
          }).node;
          if (!(t = tt(t)) || "." === t || ".." === t) throw new mt(28);
          var s = kt(r, t);
          if (s) throw new mt(s);
          if (!r.f.I) throw new mt(63);
          return r.f.I(r, t, e, n)
        }

        function $t(t) {
          Nt(t, 16895, 0)
        }

        function Rt(t, e, n) {
          void 0 === n && (n = e, e = 438), Nt(t, 8192 | e, n)
        }

        function jt(t, e) {
          if (!et(t)) throw new mt(44);
          var n = bt(e, {
            parent: !0
          }).node;
          if (!n) throw new mt(44);
          var r = kt(n, e = tt(e));
          if (r) throw new mt(r);
          if (!n.f.M) throw new mt(63);
          n.f.M(n, e, t)
        }

        function Dt(t) {
          if (!(t = bt(t).node)) throw new mt(44);
          if (!t.f.F) throw new mt(28);
          return et(yt(t.parent), t.f.F(t))
        }

        function Ft(t, n, r) {
          if ("" === t) throw new mt(44);
          if ("string" == typeof n) {
            var s = Ot[n];
            if (void 0 === s) throw Error("Unknown file open mode: " + n);
            n = s
          }
          if (r = 64 & n ? 4095 & (void 0 === r ? 438 : r) | 32768 : 0, "object" == typeof t) var i = t;
          else {
            t = Z(t);
            try {
              i = bt(t, {
                Y: !(131072 & n)
              }).node
            } catch (t) {}
          }
          if (s = !1, 64 & n)
            if (i) {
              if (128 & n) throw new mt(20)
            } else i = Nt(t, r, 0), s = !0;
          if (!i) throw new mt(44);
          if (8192 == (61440 & i.mode) && (n &= -513), 65536 & n && 16384 != (61440 & i.mode)) throw new mt(54);
          if (!s && (r = i ? 40960 == (61440 & i.mode) ? 32 : 16384 == (61440 & i.mode) && ("r" !== St(n) || 512 & n) ? 31 : _t(i, St(n)) : 44)) throw new mt(r);
          if (512 & n) {
            var a;
            if (!(a = "string" == typeof (r = i) ? bt(r, {
                Y: !0
              }).node : r).f.m) throw new mt(63);
            if (16384 == (61440 & a.mode)) throw new mt(31);
            if (32768 != (61440 & a.mode)) throw new mt(28);
            if (r = _t(a, "w")) throw new mt(r);
            a.f.m(a, {
              size: 0,
              timestamp: Date.now()
            })
          }
          n &= -131713, (i = Ct({
            node: i,
            path: yt(i),
            flags: n,
            seekable: !0,
            position: 0,
            c: i.c,
            sa: [],
            error: !1
          })).c.open && i.c.open(i), !e.logReadFiles || 1 & n || (Wt || (Wt = {}), t in Wt || (Wt[t] = 1, l("FS.trackingDelegate error on read file: " + t)));
          try {
            ft.onOpenFile && (a = 0, 1 != (2097155 & n) && (a |= 1), 0 != (2097155 & n) && (a |= 2), ft.onOpenFile(t, a))
          } catch (e) {
            l("FS.trackingDelegate['onOpenFile']('" + t + "', flags) threw an exception: " + e.message)
          }
          return i
        }

        function Mt(t, e, n) {
          if (null === t.s) throw new mt(8);
          if (!t.seekable || !t.c.A) throw new mt(70);
          if (0 != n && 1 != n && 2 != n) throw new mt(28);
          t.position = t.c.A(t, e, n), t.sa = []
        }

        function zt() {
          mt || ((mt = function (t, e) {
            this.node = e, this.na = function (t) {
              this.v = t
            }, this.na(t), this.message = "FS error"
          }).prototype = Error(), mt.prototype.constructor = mt, [44].forEach((function (t) {
            gt[t] = new mt(t), gt[t].stack = "<generic error, no stack>"
          })))
        }

        function Lt(t, e, n) {
          t = Z("/dev/" + t);
          var r = function (t, e) {
            var n = 0;
            return t && (n |= 365), e && (n |= 146), n
          }(!!e, !!n);
          Bt || (Bt = 64);
          var s = Bt++ << 8 | 0;
          Tt(s, {
            open: function (t) {
              t.seekable = !1
            },
            close: function () {
              n && n.buffer && n.buffer.length && n(10)
            },
            read: function (t, n, r, s) {
              for (var i = 0, a = 0; a < s; a++) {
                try {
                  var o = e()
                } catch (t) {
                  throw new mt(29)
                }
                if (void 0 === o && 0 === i) throw new mt(6);
                if (null == o) break;
                i++, n[r + a] = o
              }
              return i && (t.node.timestamp = Date.now()), i
            },
            write: function (t, e, r, s) {
              for (var i = 0; i < s; i++) try {
                n(e[r + i])
              } catch (t) {
                throw new mt(29)
              }
              return s && (t.node.timestamp = Date.now()), i
            }
          }), Rt(t, r, s)
        }
        var Bt, Pt, Wt, Ut = {},
          Vt = {},
          Ht = void 0;

        function Gt() {
          return v[(Ht += 4) - 4 >> 2]
        }

        function qt(t) {
          if (!(t = lt[t])) throw new mt(8);
          return t
        }
        var Kt, Jt = {};

        function Xt() {
          if (!Kt) {
            var t, e = {
              USER: "web_user",
              LOGNAME: "web_user",
              PATH: "/",
              PWD: "/",
              HOME: "/home/web_user",
              LANG: ("object" == typeof navigator && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8",
              _: a || "./this.program"
            };
            for (t in Jt) e[t] = Jt[t];
            var n = [];
            for (t in e) n.push(t + "=" + e[t]);
            Kt = n
          }
          return Kt
        }

        function Yt(t) {
          return 0 == t % 4 && (0 != t % 100 || 0 == t % 400)
        }

        function Zt(t, e) {
          for (var n = 0, r = 0; r <= e; n += t[r++]);
          return n
        }
        var Qt = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          te = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

        function ee(t, e) {
          for (t = new Date(t.getTime()); 0 < e;) {
            var n = t.getMonth(),
              r = (Yt(t.getFullYear()) ? Qt : te)[n];
            if (!(e > r - t.getDate())) {
              t.setDate(t.getDate() + e);
              break
            }
            e -= r - t.getDate() + 1, t.setDate(1), 11 > n ? t.setMonth(n + 1) : (t.setMonth(0), t.setFullYear(t.getFullYear() + 1))
          }
          return t
        }

        function ne(t, e, n, r) {
          t || (t = this), this.parent = t, this.o = t.o, this.J = null, this.id = ht++, this.name = e, this.mode = n, this.f = {}, this.c = {}, this.L = r
        }

        function re(t, e) {
          for (var n = 0, r = 0; r < t.length; ++r) {
            var s = t.charCodeAt(r);
            55296 <= s && 57343 >= s && (s = 65536 + ((1023 & s) << 10) | 1023 & t.charCodeAt(++r)), 127 >= s ? ++n : n = 2047 >= s ? n + 2 : 65535 >= s ? n + 3 : n + 4
          }
          return t = C(t, n = Array(n + 1), 0, n.length), e && (n.length = t), n
        }
        Object.defineProperties(ne.prototype, {
            read: {
              get: function () {
                return 365 == (365 & this.mode)
              },
              set: function (t) {
                t ? this.mode |= 365 : this.mode &= -366
              }
            },
            write: {
              get: function () {
                return 146 == (146 & this.mode)
              },
              set: function (t) {
                t ? this.mode |= 146 : this.mode &= -147
              }
            }
          }), zt(), dt = Array(4096), At(ot, "/"), $t("/tmp"), $t("/home"), $t("/home/web_user"),
          function () {
            if ($t("/dev"), Tt(259, {
                read: function () {
                  return 0
                },
                write: function (t, e, n, r) {
                  return r
                }
              }), Rt("/dev/null", 259), rt(1280, it), rt(1536, at), Rt("/dev/tty", 1280), Rt("/dev/tty1", 1536), "object" == typeof crypto && "function" == typeof crypto.getRandomValues) var t = new Uint8Array(1),
              e = function () {
                return crypto.getRandomValues(t), t[0]
              };
            e || (e = function () {
              U("random_device")
            }), Lt("random", e), Lt("urandom", e), $t("/dev/shm"), $t("/dev/shm/tmp")
          }(), $t("/proc"), $t("/proc/self"), $t("/proc/self/fd"), At({
            o: function () {
              var t = xt("/proc/self", "fd", 16895, 73);
              return t.f = {
                D: function (t, e) {
                  var n = lt[+e];
                  if (!n) throw new mt(8);
                  return (t = {
                    parent: null,
                    o: {
                      ca: "fake"
                    },
                    f: {
                      F: function () {
                        return n.path
                      }
                    }
                  }).parent = t
                }
              }, t
            }
          }, "/proc/self/fd");
        var se = {
            __assert_fail: function (t, e, n, r) {
              U("Assertion failed: " + k(t) + ", at: " + [e ? k(e) : "unknown filename", n, r ? k(r) : "unknown function"])
            },
            __cxa_allocate_exception: function (t) {
              return oe(t)
            },
            __cxa_atexit: function (t, e) {
              R.unshift({
                $: t,
                H: e
              })
            },
            __cxa_throw: function (t) {
              throw "uncaught_exception" in X ? X.V++ : X.V = 1, t
            },
            __map_file: function () {
              return v[ce() >> 2] = 63, -1
            },
            __sys_ioctl: function (t, e, n) {
              Ht = n;
              try {
                var r = qt(t);
                switch (e) {
                  case 21509:
                  case 21505:
                    return r.h ? 0 : -59;
                  case 21510:
                  case 21511:
                  case 21512:
                  case 21506:
                  case 21507:
                  case 21508:
                    return r.h ? 0 : -59;
                  case 21519:
                    if (!r.h) return -59;
                    var s = Gt();
                    return v[s >> 2] = 0;
                  case 21520:
                    return r.h ? -28 : -59;
                  case 21531:
                    if (t = s = Gt(), !r.c.ja) throw new mt(59);
                    return r.c.ja(r, e, t);
                  case 21523:
                  case 21524:
                    return r.h ? 0 : -59;
                  default:
                    U("bad ioctl syscall " + e)
                }
              } catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), -t.v
              }
            },
            __sys_munmap: function (t, e) {
              try {
                if (-1 == (0 | t) || 0 === e) var n = -28;
                else {
                  var r = Vt[t];
                  if (r && e === r.Ca) {
                    var s = lt[r.s];
                    2 & r.Ha && s && s.c.K && s.c.K(s, y.slice(t, t + e), r.offset, e, r.flags), Vt[t] = null, r.ha && ue(r.Da)
                  }
                  n = 0
                }
                return n
              } catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), -t.v
              }
            },
            __sys_open: function (t, e, n) {
              Ht = n;
              try {
                return Ft(k(t), e, Gt()).s
              } catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), -t.v
              }
            },
            abort: function () {
              U()
            },
            emscripten_get_sbrk_ptr: function () {
              return 323392
            },
            emscripten_memcpy_big: function (t, e, n) {
              y.copyWithin(t, e, e + n)
            },
            emscripten_resize_heap: function (t) {
              t >>>= 0;
              var e = y.length;
              if (2147483648 < t) return !1;
              for (var n = 1; 4 >= n; n *= 2) {
                var r = e * (1 + .2 / n);
                r = Math.min(r, t + 100663296), 0 < (r = Math.max(16777216, t, r)) % 65536 && (r += 65536 - r % 65536);
                t: {
                  try {
                    h.grow(Math.min(2147483648, r) - g.byteLength + 65535 >>> 16), E(h.buffer);
                    var s = 1;
                    break t
                  } catch (t) {}
                  s = void 0
                }
                if (s) return !0
              }
              return !1
            },
            environ_get: function (t, e) {
              var n = 0;
              return Xt().forEach((function (r, s) {
                var i = e + n;
                for (s = v[t + 4 * s >> 2] = i, i = 0; i < r.length; ++i) b[s++ >> 0] = r.charCodeAt(i);
                b[s >> 0] = 0, n += r.length + 1
              })), 0
            },
            environ_sizes_get: function (t, e) {
              var n = Xt();
              v[t >> 2] = n.length;
              var r = 0;
              return n.forEach((function (t) {
                r += t.length + 1
              })), v[e >> 2] = r, 0
            },
            fd_close: function (t) {
              try {
                var e = qt(t);
                if (null === e.s) throw new mt(8);
                e.R && (e.R = null);
                try {
                  e.c.close && e.c.close(e)
                } catch (t) {
                  throw t
                } finally {
                  lt[e.s] = null
                }
                return e.s = null, 0
              } catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), t.v
              }
            },
            fd_read: function (t, e, n, r) {
              try {
                t: {
                  for (var s = qt(t), i = t = 0; i < n; i++) {
                    var a = v[e + (8 * i + 4) >> 2],
                      o = s,
                      u = v[e + 8 * i >> 2],
                      c = a,
                      l = void 0,
                      h = b;
                    if (0 > c || 0 > l) throw new mt(28);
                    if (null === o.s) throw new mt(8);
                    if (1 == (2097155 & o.flags)) throw new mt(8);
                    if (16384 == (61440 & o.node.mode)) throw new mt(31);
                    if (!o.c.read) throw new mt(28);
                    var d = void 0 !== l;
                    if (d) {
                      if (!o.seekable) throw new mt(70)
                    } else l = o.position;
                    var p = o.c.read(o, h, u, c, l);
                    d || (o.position += p);
                    var f = p;
                    if (0 > f) {
                      var m = -1;
                      break t
                    }
                    if (t += f, f < a) break
                  }
                  m = t
                }
                return v[r >> 2] = m,
                0
              }
              catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), t.v
              }
            },
            fd_seek: function (t, e, n, r, s) {
              try {
                var i = qt(t);
                return -9007199254740992 >= (t = 4294967296 * n + (e >>> 0)) || 9007199254740992 <= t ? -61 : (Mt(i, t, r), G = [i.position >>> 0, (H = i.position, 1 <= +F(H) ? 0 < H ? (0 | L(+z(H / 4294967296), 4294967295)) >>> 0 : ~~+M((H - +(~~H >>> 0)) / 4294967296) >>> 0 : 0)], v[s >> 2] = G[0], v[s + 4 >> 2] = G[1], i.R && 0 === t && 0 === r && (i.R = null), 0)
              } catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), t.v
              }
            },
            fd_write: function (t, e, n, r) {
              try {
                t: {
                  for (var s = qt(t), i = t = 0; i < n; i++) {
                    var a = s,
                      o = v[e + 8 * i >> 2],
                      u = v[e + (8 * i + 4) >> 2],
                      c = void 0,
                      h = b;
                    if (0 > u || 0 > c) throw new mt(28);
                    if (null === a.s) throw new mt(8);
                    if (0 == (2097155 & a.flags)) throw new mt(8);
                    if (16384 == (61440 & a.node.mode)) throw new mt(31);
                    if (!a.c.write) throw new mt(28);
                    a.seekable && 1024 & a.flags && Mt(a, 0, 2);
                    var d = void 0 !== c;
                    if (d) {
                      if (!a.seekable) throw new mt(70)
                    } else c = a.position;
                    var p = a.c.write(a, h, o, u, c, void 0);
                    d || (a.position += p);
                    try {
                      a.path && ft.onWriteToFile && ft.onWriteToFile(a.path)
                    } catch (t) {
                      l("FS.trackingDelegate['onWriteToFile']('" + a.path + "') threw an exception: " + t.message)
                    }
                    var f = p;
                    if (0 > f) {
                      var m = -1;
                      break t
                    }
                    t += f
                  }
                  m = t
                }
                return v[r >> 2] = m,
                0
              }
              catch (t) {
                return void 0 !== Ut && t instanceof mt || U(t), t.v
              }
            },
            memory: h,
            pthread_create: function () {
              return 6
            },
            pthread_join: function () {},
            roundf: function (t) {
              return 0 <= (t = +t) ? +z(t + .5) : +M(t - .5)
            },
            setTempRet0: function () {},
            strftime_l: function (t, e, n, r) {
              return function (t, e, n, r) {
                function s(t, e, n) {
                  for (t = "number" == typeof t ? t.toString() : t || ""; t.length < e;) t = n[0] + t;
                  return t
                }

                function i(t, e) {
                  return s(t, e, "0")
                }

                function a(t, e) {
                  function n(t) {
                    return 0 > t ? -1 : 0 < t ? 1 : 0
                  }
                  var r;
                  return 0 === (r = n(t.getFullYear() - e.getFullYear())) && 0 === (r = n(t.getMonth() - e.getMonth())) && (r = n(t.getDate() - e.getDate())), r
                }

                function o(t) {
                  switch (t.getDay()) {
                    case 0:
                      return new Date(t.getFullYear() - 1, 11, 29);
                    case 1:
                      return t;
                    case 2:
                      return new Date(t.getFullYear(), 0, 3);
                    case 3:
                      return new Date(t.getFullYear(), 0, 2);
                    case 4:
                      return new Date(t.getFullYear(), 0, 1);
                    case 5:
                      return new Date(t.getFullYear() - 1, 11, 31);
                    case 6:
                      return new Date(t.getFullYear() - 1, 11, 30)
                  }
                }

                function u(t) {
                  t = ee(new Date(t.j + 1900, 0, 1), t.P);
                  var e = new Date(t.getFullYear() + 1, 0, 4),
                    n = o(new Date(t.getFullYear(), 0, 4));
                  return e = o(e), 0 >= a(n, t) ? 0 >= a(e, t) ? t.getFullYear() + 1 : t.getFullYear() : t.getFullYear() - 1
                }
                var c = v[r + 40 >> 2];
                for (var l in r = {
                    qa: v[r >> 2],
                    pa: v[r + 4 >> 2],
                    N: v[r + 8 >> 2],
                    G: v[r + 12 >> 2],
                    C: v[r + 16 >> 2],
                    j: v[r + 20 >> 2],
                    O: v[r + 24 >> 2],
                    P: v[r + 28 >> 2],
                    Ja: v[r + 32 >> 2],
                    oa: v[r + 36 >> 2],
                    ra: c ? k(c) : ""
                  }, n = k(n), c = {
                    "%c": "%a %b %d %H:%M:%S %Y",
                    "%D": "%m/%d/%y",
                    "%F": "%Y-%m-%d",
                    "%h": "%b",
                    "%r": "%I:%M:%S %p",
                    "%R": "%H:%M",
                    "%T": "%H:%M:%S",
                    "%x": "%m/%d/%y",
                    "%X": "%H:%M:%S",
                    "%Ec": "%c",
                    "%EC": "%C",
                    "%Ex": "%m/%d/%y",
                    "%EX": "%H:%M:%S",
                    "%Ey": "%y",
                    "%EY": "%Y",
                    "%Od": "%d",
                    "%Oe": "%e",
                    "%OH": "%H",
                    "%OI": "%I",
                    "%Om": "%m",
                    "%OM": "%M",
                    "%OS": "%S",
                    "%Ou": "%u",
                    "%OU": "%U",
                    "%OV": "%V",
                    "%Ow": "%w",
                    "%OW": "%W",
                    "%Oy": "%y"
                  }) n = n.replace(new RegExp(l, "g"), c[l]);
                var h = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
                  d = "January February March April May June July August September October November December".split(" ");
                for (l in c = {
                    "%a": function (t) {
                      return h[t.O].substring(0, 3)
                    },
                    "%A": function (t) {
                      return h[t.O]
                    },
                    "%b": function (t) {
                      return d[t.C].substring(0, 3)
                    },
                    "%B": function (t) {
                      return d[t.C]
                    },
                    "%C": function (t) {
                      return i((t.j + 1900) / 100 | 0, 2)
                    },
                    "%d": function (t) {
                      return i(t.G, 2)
                    },
                    "%e": function (t) {
                      return s(t.G, 2, " ")
                    },
                    "%g": function (t) {
                      return u(t).toString().substring(2)
                    },
                    "%G": function (t) {
                      return u(t)
                    },
                    "%H": function (t) {
                      return i(t.N, 2)
                    },
                    "%I": function (t) {
                      return 0 == (t = t.N) ? t = 12 : 12 < t && (t -= 12), i(t, 2)
                    },
                    "%j": function (t) {
                      return i(t.G + Zt(Yt(t.j + 1900) ? Qt : te, t.C - 1), 3)
                    },
                    "%m": function (t) {
                      return i(t.C + 1, 2)
                    },
                    "%M": function (t) {
                      return i(t.pa, 2)
                    },
                    "%n": function () {
                      return "\n"
                    },
                    "%p": function (t) {
                      return 0 <= t.N && 12 > t.N ? "AM" : "PM"
                    },
                    "%S": function (t) {
                      return i(t.qa, 2)
                    },
                    "%t": function () {
                      return "\t"
                    },
                    "%u": function (t) {
                      return t.O || 7
                    },
                    "%U": function (t) {
                      var e = new Date(t.j + 1900, 0, 1),
                        n = 0 === e.getDay() ? e : ee(e, 7 - e.getDay());
                      return 0 > a(n, t = new Date(t.j + 1900, t.C, t.G)) ? i(Math.ceil((31 - n.getDate() + (Zt(Yt(t.getFullYear()) ? Qt : te, t.getMonth() - 1) - 31) + t.getDate()) / 7), 2) : 0 === a(n, e) ? "01" : "00"
                    },
                    "%V": function (t) {
                      var e = new Date(t.j + 1901, 0, 4),
                        n = o(new Date(t.j + 1900, 0, 4));
                      e = o(e);
                      var r = ee(new Date(t.j + 1900, 0, 1), t.P);
                      return 0 > a(r, n) ? "53" : 0 >= a(e, r) ? "01" : i(Math.ceil((n.getFullYear() < t.j + 1900 ? t.P + 32 - n.getDate() : t.P + 1 - n.getDate()) / 7), 2)
                    },
                    "%w": function (t) {
                      return t.O
                    },
                    "%W": function (t) {
                      var e = new Date(t.j, 0, 1),
                        n = 1 === e.getDay() ? e : ee(e, 0 === e.getDay() ? 1 : 7 - e.getDay() + 1);
                      return 0 > a(n, t = new Date(t.j + 1900, t.C, t.G)) ? i(Math.ceil((31 - n.getDate() + (Zt(Yt(t.getFullYear()) ? Qt : te, t.getMonth() - 1) - 31) + t.getDate()) / 7), 2) : 0 === a(n, e) ? "01" : "00"
                    },
                    "%y": function (t) {
                      return (t.j + 1900).toString().substring(2)
                    },
                    "%Y": function (t) {
                      return t.j + 1900
                    },
                    "%z": function (t) {
                      var e = 0 <= (t = t.oa);
                      return t = Math.abs(t) / 60, (e ? "+" : "-") + String("0000" + (t / 60 * 100 + t % 60)).slice(-4)
                    },
                    "%Z": function (t) {
                      return t.ra
                    },
                    "%%": function () {
                      return "%"
                    }
                  }) 0 <= n.indexOf(l) && (n = n.replace(new RegExp(l, "g"), c[l](r)));
                return (l = re(n, !1)).length > e ? 0 : (b.set(l, t), l.length - 1)
              }(t, e, n, r)
            },
            sysconf: function (t) {
              switch (t) {
                case 30:
                  return 16384;
                case 85:
                  return 131072;
                case 132:
                case 133:
                case 12:
                case 137:
                case 138:
                case 15:
                case 235:
                case 16:
                case 17:
                case 18:
                case 19:
                case 20:
                case 149:
                case 13:
                case 10:
                case 236:
                case 153:
                case 9:
                case 21:
                case 22:
                case 159:
                case 154:
                case 14:
                case 77:
                case 78:
                case 139:
                case 80:
                case 81:
                case 82:
                case 68:
                case 67:
                case 164:
                case 11:
                case 29:
                case 47:
                case 48:
                case 95:
                case 52:
                case 51:
                case 46:
                case 79:
                  return 200809;
                case 27:
                case 246:
                case 127:
                case 128:
                case 23:
                case 24:
                case 160:
                case 161:
                case 181:
                case 182:
                case 242:
                case 183:
                case 184:
                case 243:
                case 244:
                case 245:
                case 165:
                case 178:
                case 179:
                case 49:
                case 50:
                case 168:
                case 169:
                case 175:
                case 170:
                case 171:
                case 172:
                case 97:
                case 76:
                case 32:
                case 173:
                case 35:
                  return -1;
                case 176:
                case 177:
                case 7:
                case 155:
                case 8:
                case 157:
                case 125:
                case 126:
                case 92:
                case 93:
                case 129:
                case 130:
                case 131:
                case 94:
                case 91:
                  return 1;
                case 74:
                case 60:
                case 69:
                case 70:
                case 4:
                  return 1024;
                case 31:
                case 42:
                case 72:
                  return 32;
                case 87:
                case 26:
                case 33:
                  return 2147483647;
                case 34:
                case 1:
                  return 47839;
                case 38:
                case 36:
                  return 99;
                case 43:
                case 37:
                  return 2048;
                case 0:
                  return 2097152;
                case 3:
                  return 65536;
                case 28:
                  return 32768;
                case 44:
                  return 32767;
                case 75:
                  return 16384;
                case 39:
                  return 1e3;
                case 89:
                  return 700;
                case 71:
                  return 256;
                case 40:
                  return 255;
                case 2:
                  return 100;
                case 180:
                  return 64;
                case 25:
                  return 20;
                case 5:
                  return 16;
                case 6:
                  return 6;
                case 73:
                  return 4;
                case 84:
                  return "object" == typeof navigator && navigator.hardwareConcurrency || 1
              }
              return v[ce() >> 2] = 28, -1
            },
            table: d
          },
          ie = function () {
            function t(t) {
              e.asm = t.exports, B--, e.monitorRunDependencies && e.monitorRunDependencies(B), 0 == B && (null !== P && (clearInterval(P), P = null), W && (t = W, W = null, t()))
            }

            function n(e) {
              t(e.instance)
            }

            function r(t) {
              return (u || "function" != typeof fetch ? new Promise((function (t) {
                t(J())
              })) : fetch(q, {
                credentials: "same-origin"
              }).then((function (t) {
                if (!t.ok) throw "failed to load wasm binary file at '" + q + "'";
                return t.arrayBuffer()
              })).catch((function () {
                return J()
              }))).then((function (t) {
                return WebAssembly.instantiate(t, s)
              })).then(t, (function (t) {
                l("failed to asynchronously prepare wasm: " + t), U(t)
              }))
            }
            var s = {
              env: se,
              wasi_snapshot_preview1: se
            };
            if (B++, e.monitorRunDependencies && e.monitorRunDependencies(B), e.instantiateWasm) try {
              return e.instantiateWasm(s, t)
            } catch (t) {
              return l("Module.instantiateWasm callback failed with error: " + t), !1
            }
            return function () {
              if (u || "function" != typeof WebAssembly.instantiateStreaming || V() || "function" != typeof fetch) return r(n);
              fetch(q, {
                credentials: "same-origin"
              }).then((function (t) {
                return WebAssembly.instantiateStreaming(t, s).then(n, (function (t) {
                  l("wasm streaming compile failed: " + t), l("falling back to ArrayBuffer instantiation"), r(n)
                }))
              }))
            }(), {}
          }();
        e.asm = ie;
        var ae = e.___wasm_call_ctors = function () {
            return (ae = e.___wasm_call_ctors = e.asm.__wasm_call_ctors).apply(null, arguments)
          },
          oe = e._malloc = function () {
            return (oe = e._malloc = e.asm.malloc).apply(null, arguments)
          },
          ue = e._free = function () {
            return (ue = e._free = e.asm.free).apply(null, arguments)
          };
        e._xzimgMagicFaceInitialize = function () {
          return (e._xzimgMagicFaceInitialize = e.asm.xzimgMagicFaceInitialize).apply(null, arguments)
        }, e._xzimgMagicFaceInitializeEmotion = function () {
          return (e._xzimgMagicFaceInitializeEmotion = e.asm.xzimgMagicFaceInitializeEmotion).apply(null, arguments)
        }, e._xzimgMagicFaceRelease = function () {
          return (e._xzimgMagicFaceRelease = e.asm.xzimgMagicFaceRelease).apply(null, arguments)
        }, e._xzimgMagicFaceDetectNonRigidFaces2D = function () {
          return (e._xzimgMagicFaceDetectNonRigidFaces2D = e.asm.xzimgMagicFaceDetectNonRigidFaces2D).apply(null, arguments)
        }, e._xzimgMagicFaceTrackNonRigidFaces = function () {
          return (e._xzimgMagicFaceTrackNonRigidFaces = e.asm.xzimgMagicFaceTrackNonRigidFaces).apply(null, arguments)
        }, e._xzimgMagicFaceGetFaceData = function () {
          return (e._xzimgMagicFaceGetFaceData = e.asm.xzimgMagicFaceGetFaceData).apply(null, arguments)
        }, e._xzimgSetFaceDetectionSensibility = function () {
          return (e._xzimgSetFaceDetectionSensibility = e.asm.xzimgSetFaceDetectionSensibility).apply(null, arguments)
        }, e._xzimgSetFilteringLevel = function () {
          return (e._xzimgSetFilteringLevel = e.asm.xzimgSetFilteringLevel).apply(null, arguments)
        }, e._xzimgMagicFaceProcessEmotion = function () {
          return (e._xzimgMagicFaceProcessEmotion = e.asm.xzimgMagicFaceProcessEmotion).apply(null, arguments)
        }, e._xzimgMagicFaceGetNumActionUnits = function () {
          return (e._xzimgMagicFaceGetNumActionUnits = e.asm.xzimgMagicFaceGetNumActionUnits).apply(null, arguments)
        }, e._xzimgMagicFaceGetActionUnits = function () {
          return (e._xzimgMagicFaceGetActionUnits = e.asm.xzimgMagicFaceGetActionUnits).apply(null, arguments)
        }, e._xzimgMagicFaceUpdateResolution = function () {
          return (e._xzimgMagicFaceUpdateResolution = e.asm.xzimgMagicFaceUpdateResolution).apply(null, arguments)
        }, e._xzimgGetMeshVertices = function () {
          return (e._xzimgGetMeshVertices = e.asm.xzimgGetMeshVertices).apply(null, arguments)
        }, e._xzimgMagicSegmentationInitialize = function () {
          return (e._xzimgMagicSegmentationInitialize = e.asm.xzimgMagicSegmentationInitialize).apply(null, arguments)
        }, e._xzimgMagicSegmentationIsInitialized = function () {
          return (e._xzimgMagicSegmentationIsInitialized = e.asm.xzimgMagicSegmentationIsInitialized).apply(null, arguments)
        }, e._xzimgMagicSegmentationRelease = function () {
          return (e._xzimgMagicSegmentationRelease = e.asm.xzimgMagicSegmentationRelease).apply(null, arguments)
        }, e._xzimgMagicSegmentationPause = function () {
          return (e._xzimgMagicSegmentationPause = e.asm.xzimgMagicSegmentationPause).apply(null, arguments)
        }, e._xzimgMagicSegmentationProcess = function () {
          return (e._xzimgMagicSegmentationProcess = e.asm.xzimgMagicSegmentationProcess).apply(null, arguments)
        }, e._xzimgMagicSegmentationDyeHairs = function () {
          return (e._xzimgMagicSegmentationDyeHairs = e.asm.xzimgMagicSegmentationDyeHairs).apply(null, arguments)
        }, e._xzimgMagicSegmentationSetColor = function () {
          return (e._xzimgMagicSegmentationSetColor = e.asm.xzimgMagicSegmentationSetColor).apply(null, arguments)
        }, e._xzimgMagicSegmentationGetSegmentationImage = function () {
          return (e._xzimgMagicSegmentationGetSegmentationImage = e.asm.xzimgMagicSegmentationGetSegmentationImage).apply(null, arguments)
        };
        var ce = e.___errno_location = function () {
          return (ce = e.___errno_location = e.asm.__errno_location).apply(null, arguments)
        };
        e._setThrew = function () {
          return (e._setThrew = e.asm.setThrew).apply(null, arguments)
        }, e._emscripten_main_thread_process_queued_calls = function () {
          return (e._emscripten_main_thread_process_queued_calls = e.asm.emscripten_main_thread_process_queued_calls).apply(null, arguments)
        };
        var le, he = e.stackSave = function () {
            return (he = e.stackSave = e.asm.stackSave).apply(null, arguments)
          },
          de = e.stackAlloc = function () {
            return (de = e.stackAlloc = e.asm.stackAlloc).apply(null, arguments)
          },
          pe = e.stackRestore = function () {
            return (pe = e.stackRestore = e.asm.stackRestore).apply(null, arguments)
          };

        function fe() {
          function t() {
            if (!le && (le = !0, e.calledRun = !0, !p)) {
              if (e.noFSInit || Et || (Et = !0, zt(), e.stdin = e.stdin, e.stdout = e.stdout, e.stderr = e.stderr, e.stdin ? Lt("stdin", e.stdin) : jt("/dev/tty", "/dev/stdin"), e.stdout ? Lt("stdout", null, e.stdout) : jt("/dev/tty", "/dev/stdout"), e.stderr ? Lt("stderr", null, e.stderr) : jt("/dev/tty1", "/dev/stderr"), Ft("/dev/stdin", "r"), Ft("/dev/stdout", "w"), Ft("/dev/stderr", "w")), T(N), pt = !1, T($), n(e), e.onRuntimeInitialized && e.onRuntimeInitialized(), e.postRun)
                for ("function" == typeof e.postRun && (e.postRun = [e.postRun]); e.postRun.length;) {
                  var t = e.postRun.shift();
                  j.unshift(t)
                }
              T(j)
            }
          }
          if (!(0 < B)) {
            if (e.preRun)
              for ("function" == typeof e.preRun && (e.preRun = [e.preRun]); e.preRun.length;) D();
            T(A), 0 < B || (e.setStatus ? (e.setStatus("Running..."), setTimeout((function () {
              setTimeout((function () {
                e.setStatus("")
              }), 1), t()
            }), 1)) : t())
          }
        }
        if (e.__growWasmMemory = function () {
            return (e.__growWasmMemory = e.asm.__growWasmMemory).apply(null, arguments)
          }, e.dynCall_vi = function () {
            return (e.dynCall_vi = e.asm.dynCall_vi).apply(null, arguments)
          }, e.dynCall_ii = function () {
            return (e.dynCall_ii = e.asm.dynCall_ii).apply(null, arguments)
          }, e.dynCall_iidiiii = function () {
            return (e.dynCall_iidiiii = e.asm.dynCall_iidiiii).apply(null, arguments)
          }, e.dynCall_vii = function () {
            return (e.dynCall_vii = e.asm.dynCall_vii).apply(null, arguments)
          }, e.dynCall_jiji = function () {
            return (e.dynCall_jiji = e.asm.dynCall_jiji).apply(null, arguments)
          }, e.dynCall_iiii = function () {
            return (e.dynCall_iiii = e.asm.dynCall_iiii).apply(null, arguments)
          }, e.dynCall_viii = function () {
            return (e.dynCall_viii = e.asm.dynCall_viii).apply(null, arguments)
          }, e.dynCall_viijii = function () {
            return (e.dynCall_viijii = e.asm.dynCall_viijii).apply(null, arguments)
          }, e.dynCall_viiii = function () {
            return (e.dynCall_viiii = e.asm.dynCall_viiii).apply(null, arguments)
          }, e.dynCall_iii = function () {
            return (e.dynCall_iii = e.asm.dynCall_iii).apply(null, arguments)
          }, e.dynCall_viiiiiiii = function () {
            return (e.dynCall_viiiiiiii = e.asm.dynCall_viiiiiiii).apply(null, arguments)
          }, e.dynCall_v = function () {
            return (e.dynCall_v = e.asm.dynCall_v).apply(null, arguments)
          }, e.dynCall_iiiii = function () {
            return (e.dynCall_iiiii = e.asm.dynCall_iiiii).apply(null, arguments)
          }, e.dynCall_iiiiiiiii = function () {
            return (e.dynCall_iiiiiiiii = e.asm.dynCall_iiiiiiiii).apply(null, arguments)
          }, e.dynCall_iiiiiii = function () {
            return (e.dynCall_iiiiiii = e.asm.dynCall_iiiiiii).apply(null, arguments)
          }, e.dynCall_iiiiii = function () {
            return (e.dynCall_iiiiii = e.asm.dynCall_iiiiii).apply(null, arguments)
          }, e.dynCall_viiiiii = function () {
            return (e.dynCall_viiiiii = e.asm.dynCall_viiiiii).apply(null, arguments)
          }, e.dynCall_iiiiiiii = function () {
            return (e.dynCall_iiiiiiii = e.asm.dynCall_iiiiiiii).apply(null, arguments)
          }, e.dynCall_iiiiiijj = function () {
            return (e.dynCall_iiiiiijj = e.asm.dynCall_iiiiiijj).apply(null, arguments)
          }, e.dynCall_iiiiij = function () {
            return (e.dynCall_iiiiij = e.asm.dynCall_iiiiij).apply(null, arguments)
          }, e.dynCall_iiiiid = function () {
            return (e.dynCall_iiiiid = e.asm.dynCall_iiiiid).apply(null, arguments)
          }, e.dynCall_iiiiijj = function () {
            return (e.dynCall_iiiiijj = e.asm.dynCall_iiiiijj).apply(null, arguments)
          }, e.dynCall_viiiii = function () {
            return (e.dynCall_viiiii = e.asm.dynCall_viiiii).apply(null, arguments)
          }, e.asm = ie, e.ccall = m, e.cwrap = function (t, e, n, r) {
            var s = (n = n || []).every((function (t) {
              return "number" === t
            }));
            return "string" !== e && s && !r ? f(t) : function () {
              return m(t, e, n, arguments)
            }
          }, e.setValue = function (t, e, n) {
            switch ("*" === (n = n || "i8").charAt(n.length - 1) && (n = "i32"), n) {
              case "i1":
              case "i8":
                b[t >> 0] = e;
                break;
              case "i16":
                w[t >> 1] = e;
                break;
              case "i32":
                v[t >> 2] = e;
                break;
              case "i64":
                G = [e >>> 0, (H = e, 1 <= +F(H) ? 0 < H ? (0 | L(+z(H / 4294967296), 4294967295)) >>> 0 : ~~+M((H - +(~~H >>> 0)) / 4294967296) >>> 0 : 0)], v[t >> 2] = G[0], v[t + 4 >> 2] = G[1];
                break;
              case "float":
                x[t >> 2] = e;
                break;
              case "double":
                O[t >> 3] = e;
                break;
              default:
                U("invalid type for setValue: " + n)
            }
          }, e.getValue = function (t, e) {
            switch ("*" === (e = e || "i8").charAt(e.length - 1) && (e = "i32"), e) {
              case "i1":
              case "i8":
                return b[t >> 0];
              case "i16":
                return w[t >> 1];
              case "i32":
              case "i64":
                return v[t >> 2];
              case "float":
                return x[t >> 2];
              case "double":
                return O[t >> 3];
              default:
                U("invalid type for getValue: " + e)
            }
            return null
          }, W = function t() {
            le || fe(), le || (W = t)
          }, e.run = fe, e.preInit)
          for ("function" == typeof e.preInit && (e.preInit = [e.preInit]); 0 < e.preInit.length;) e.preInit.pop()();
        return fe(), t.ready
      }),
      a = {
        libPath: "./",
        fovY: 50,
        emotions: !1
      },
      o = function (t, e) {
        return (o = Object.setPrototypeOf || {
            __proto__: []
          }
          instanceof Array && function (t, e) {
            t.__proto__ = e
          } || function (t, e) {
            for (var n in e) e.hasOwnProperty(n) && (t[n] = e[n])
          })(t, e)
      };

    function u(t, e) {
      function n() {
        this.constructor = t
      }
      o(t, e), t.prototype = null === e ? Object.create(e) : (n.prototype = e.prototype, new n)
    }
    var c = n(17);

    function l(t) {
      return "function" == typeof t
    }
    var h = !1,
      d = {
        Promise: void 0,
        set useDeprecatedSynchronousErrorHandling(t) {
          t && (new Error).stack;
          h = t
        },
        get useDeprecatedSynchronousErrorHandling() {
          return h
        }
      };

    function p(t) {
      setTimeout((function () {
        throw t
      }), 0)
    }
    var f = {
        closed: !0,
        next: function (t) {},
        error: function (t) {
          if (d.useDeprecatedSynchronousErrorHandling) throw t;
          p(t)
        },
        complete: function () {}
      },
      m = function () {
        return Array.isArray || function (t) {
          return t && "number" == typeof t.length
        }
      }();

    function g(t) {
      return null !== t && "object" == typeof t
    }
    var b = function () {
        function t(t) {
          return Error.call(this), this.message = t ? t.length + " errors occurred during unsubscription:\n" + t.map((function (t, e) {
            return e + 1 + ") " + t.toString()
          })).join("\n  ") : "", this.name = "UnsubscriptionError", this.errors = t, this
        }
        return t.prototype = Object.create(Error.prototype), t
      }(),
      y = function () {
        function t(t) {
          this.closed = !1, this._parentOrParents = null, this._subscriptions = null, t && (this._unsubscribe = t)
        }
        return t.prototype.unsubscribe = function () {
          var e;
          if (!this.closed) {
            var n = this._parentOrParents,
              r = this._unsubscribe,
              s = this._subscriptions;
            if (this.closed = !0, this._parentOrParents = null, this._subscriptions = null, n instanceof t) n.remove(this);
            else if (null !== n)
              for (var i = 0; i < n.length; ++i) {
                n[i].remove(this)
              }
            if (l(r)) try {
              r.call(this)
            } catch (t) {
              e = t instanceof b ? w(t.errors) : [t]
            }
            if (m(s)) {
              i = -1;
              for (var a = s.length; ++i < a;) {
                var o = s[i];
                if (g(o)) try {
                  o.unsubscribe()
                } catch (t) {
                  e = e || [], t instanceof b ? e = e.concat(w(t.errors)) : e.push(t)
                }
              }
            }
            if (e) throw new b(e)
          }
        }, t.prototype.add = function (e) {
          var n = e;
          if (!e) return t.EMPTY;
          switch (typeof e) {
            case "function":
              n = new t(e);
            case "object":
              if (n === this || n.closed || "function" != typeof n.unsubscribe) return n;
              if (this.closed) return n.unsubscribe(), n;
              if (!(n instanceof t)) {
                var r = n;
                (n = new t)._subscriptions = [r]
              }
              break;
            default:
              throw new Error("unrecognized teardown " + e + " added to Subscription.")
          }
          var s = n._parentOrParents;
          if (null === s) n._parentOrParents = this;
          else if (s instanceof t) {
            if (s === this) return n;
            n._parentOrParents = [s, this]
          } else {
            if (-1 !== s.indexOf(this)) return n;
            s.push(this)
          }
          var i = this._subscriptions;
          return null === i ? this._subscriptions = [n] : i.push(n), n
        }, t.prototype.remove = function (t) {
          var e = this._subscriptions;
          if (e) {
            var n = e.indexOf(t); - 1 !== n && e.splice(n, 1)
          }
        }, t.EMPTY = function (t) {
          return t.closed = !0, t
        }(new t), t
      }();

    function w(t) {
      return t.reduce((function (t, e) {
        return t.concat(e instanceof b ? e.errors : e)
      }), [])
    }
    var v = function () {
        return "function" == typeof Symbol ? Symbol("rxSubscriber") : "@@rxSubscriber_" + Math.random()
      }(),
      x = function (t) {
        function e(n, r, s) {
          var i = t.call(this) || this;
          switch (i.syncErrorValue = null, i.syncErrorThrown = !1, i.syncErrorThrowable = !1, i.isStopped = !1, arguments.length) {
            case 0:
              i.destination = f;
              break;
            case 1:
              if (!n) {
                i.destination = f;
                break
              }
              if ("object" == typeof n) {
                n instanceof e ? (i.syncErrorThrowable = n.syncErrorThrowable, i.destination = n, n.add(i)) : (i.syncErrorThrowable = !0, i.destination = new O(i, n));
                break
              }
              default:
                i.syncErrorThrowable = !0, i.destination = new O(i, n, r, s)
          }
          return i
        }
        return u(e, t), e.prototype[v] = function () {
          return this
        }, e.create = function (t, n, r) {
          var s = new e(t, n, r);
          return s.syncErrorThrowable = !1, s
        }, e.prototype.next = function (t) {
          this.isStopped || this._next(t)
        }, e.prototype.error = function (t) {
          this.isStopped || (this.isStopped = !0, this._error(t))
        }, e.prototype.complete = function () {
          this.isStopped || (this.isStopped = !0, this._complete())
        }, e.prototype.unsubscribe = function () {
          this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this))
        }, e.prototype._next = function (t) {
          this.destination.next(t)
        }, e.prototype._error = function (t) {
          this.destination.error(t), this.unsubscribe()
        }, e.prototype._complete = function () {
          this.destination.complete(), this.unsubscribe()
        }, e.prototype._unsubscribeAndRecycle = function () {
          var t = this._parentOrParents;
          return this._parentOrParents = null, this.unsubscribe(), this.closed = !1, this.isStopped = !1, this._parentOrParents = t, this
        }, e
      }(y),
      O = function (t) {
        function e(e, n, r, s) {
          var i, a = t.call(this) || this;
          a._parentSubscriber = e;
          var o = a;
          return l(n) ? i = n : n && (i = n.next, r = n.error, s = n.complete, n !== f && (l((o = Object.create(n)).unsubscribe) && a.add(o.unsubscribe.bind(o)), o.unsubscribe = a.unsubscribe.bind(a))), a._context = o, a._next = i, a._error = r, a._complete = s, a
        }
        return u(e, t), e.prototype.next = function (t) {
          if (!this.isStopped && this._next) {
            var e = this._parentSubscriber;
            d.useDeprecatedSynchronousErrorHandling && e.syncErrorThrowable ? this.__tryOrSetError(e, this._next, t) && this.unsubscribe() : this.__tryOrUnsub(this._next, t)
          }
        }, e.prototype.error = function (t) {
          if (!this.isStopped) {
            var e = this._parentSubscriber,
              n = d.useDeprecatedSynchronousErrorHandling;
            if (this._error) n && e.syncErrorThrowable ? (this.__tryOrSetError(e, this._error, t), this.unsubscribe()) : (this.__tryOrUnsub(this._error, t), this.unsubscribe());
            else if (e.syncErrorThrowable) n ? (e.syncErrorValue = t, e.syncErrorThrown = !0) : p(t), this.unsubscribe();
            else {
              if (this.unsubscribe(), n) throw t;
              p(t)
            }
          }
        }, e.prototype.complete = function () {
          var t = this;
          if (!this.isStopped) {
            var e = this._parentSubscriber;
            if (this._complete) {
              var n = function () {
                return t._complete.call(t._context)
              };
              d.useDeprecatedSynchronousErrorHandling && e.syncErrorThrowable ? (this.__tryOrSetError(e, n), this.unsubscribe()) : (this.__tryOrUnsub(n), this.unsubscribe())
            } else this.unsubscribe()
          }
        }, e.prototype.__tryOrUnsub = function (t, e) {
          try {
            t.call(this._context, e)
          } catch (t) {
            if (this.unsubscribe(), d.useDeprecatedSynchronousErrorHandling) throw t;
            p(t)
          }
        }, e.prototype.__tryOrSetError = function (t, e, n) {
          if (!d.useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
          try {
            e.call(this._context, n)
          } catch (e) {
            return d.useDeprecatedSynchronousErrorHandling ? (t.syncErrorValue = e, t.syncErrorThrown = !0, !0) : (p(e), !0)
          }
          return !1
        }, e.prototype._unsubscribe = function () {
          var t = this._parentSubscriber;
          this._context = null, this._parentSubscriber = null, t.unsubscribe()
        }, e
      }(x);
    var S = function () {
      return "function" == typeof Symbol && Symbol.observable || "@@observable"
    }();

    function _() {}

    function k(t) {
      return t ? 1 === t.length ? t[0] : function (e) {
        return t.reduce((function (t, e) {
          return e(t)
        }), e)
      } : _
    }
    var C = function () {
      function t(t) {
        this._isScalar = !1, t && (this._subscribe = t)
      }
      return t.prototype.lift = function (e) {
        var n = new t;
        return n.source = this, n.operator = e, n
      }, t.prototype.subscribe = function (t, e, n) {
        var r = this.operator,
          s = function (t, e, n) {
            if (t) {
              if (t instanceof x) return t;
              if (t[v]) return t[v]()
            }
            return t || e || n ? new x(t, e, n) : new x(f)
          }(t, e, n);
        if (r ? s.add(r.call(s, this.source)) : s.add(this.source || d.useDeprecatedSynchronousErrorHandling && !s.syncErrorThrowable ? this._subscribe(s) : this._trySubscribe(s)), d.useDeprecatedSynchronousErrorHandling && s.syncErrorThrowable && (s.syncErrorThrowable = !1, s.syncErrorThrown)) throw s.syncErrorValue;
        return s
      }, t.prototype._trySubscribe = function (t) {
        try {
          return this._subscribe(t)
        } catch (e) {
          d.useDeprecatedSynchronousErrorHandling && (t.syncErrorThrown = !0, t.syncErrorValue = e), ! function (t) {
            for (; t;) {
              var e = t,
                n = e.closed,
                r = e.destination,
                s = e.isStopped;
              if (n || s) return !1;
              t = r && r instanceof x ? r : null
            }
            return !0
          }(t) ? console.warn(e) : t.error(e)
        }
      }, t.prototype.forEach = function (t, e) {
        var n = this;
        return new(e = E(e))((function (e, r) {
          var s;
          s = n.subscribe((function (e) {
            try {
              t(e)
            } catch (t) {
              r(t), s && s.unsubscribe()
            }
          }), r, e)
        }))
      }, t.prototype._subscribe = function (t) {
        var e = this.source;
        return e && e.subscribe(t)
      }, t.prototype[S] = function () {
        return this
      }, t.prototype.pipe = function () {
        for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
        return 0 === t.length ? this : k(t)(this)
      }, t.prototype.toPromise = function (t) {
        var e = this;
        return new(t = E(t))((function (t, n) {
          var r;
          e.subscribe((function (t) {
            return r = t
          }), (function (t) {
            return n(t)
          }), (function () {
            return t(r)
          }))
        }))
      }, t.create = function (e) {
        return new t(e)
      }, t
    }();

    function E(t) {
      if (t || (t = d.Promise || Promise), !t) throw new Error("no Promise impl found");
      return t
    }

    function I(t, e) {
      return function (n) {
        if ("function" != typeof t) throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return n.lift(new T(t, e))
      }
    }
    var T = function () {
        function t(t, e) {
          this.project = t, this.thisArg = e
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new A(t, this.project, this.thisArg))
        }, t
      }(),
      A = function (t) {
        function e(e, n, r) {
          var s = t.call(this, e) || this;
          return s.project = n, s.count = 0, s.thisArg = r || s, s
        }
        return u(e, t), e.prototype._next = function (t) {
          var e;
          try {
            e = this.project.call(this.thisArg, t, this.count++)
          } catch (t) {
            return void this.destination.error(t)
          }
          this.destination.next(e)
        }, e
      }(x);

    function N(t, e) {
      return void 0 === e && (e = null), new z({
        method: "GET",
        url: t,
        headers: e
      })
    }

    function $(t, e, n) {
      return new z({
        method: "POST",
        url: t,
        body: e,
        headers: n
      })
    }

    function R(t, e) {
      return new z({
        method: "DELETE",
        url: t,
        headers: e
      })
    }

    function j(t, e, n) {
      return new z({
        method: "PUT",
        url: t,
        body: e,
        headers: n
      })
    }

    function D(t, e, n) {
      return new z({
        method: "PATCH",
        url: t,
        body: e,
        headers: n
      })
    }
    var F = I((function (t, e) {
      return t.response
    }));

    function M(t, e) {
      return F(new z({
        method: "GET",
        url: t,
        responseType: "json",
        headers: e
      }))
    }
    var z = function (t) {
        function e(e) {
          var n = t.call(this) || this,
            r = {
              async: !0,
              createXHR: function () {
                return this.crossDomain ? function () {
                  if (c.a.XMLHttpRequest) return new c.a.XMLHttpRequest;
                  if (c.a.XDomainRequest) return new c.a.XDomainRequest;
                  throw new Error("CORS is not supported by your browser")
                }() : function () {
                  if (c.a.XMLHttpRequest) return new c.a.XMLHttpRequest;
                  var t = void 0;
                  try {
                    for (var e = ["Msxml2.XMLHTTP", "Microsoft.XMLHTTP", "Msxml2.XMLHTTP.4.0"], n = 0; n < 3; n++) try {
                      if (t = e[n], new c.a.ActiveXObject(t)) break
                    } catch (t) {}
                    return new c.a.ActiveXObject(t)
                  } catch (t) {
                    throw new Error("XMLHttpRequest is not supported by your browser")
                  }
                }()
              },
              crossDomain: !0,
              withCredentials: !1,
              headers: {},
              method: "GET",
              responseType: "json",
              timeout: 0
            };
          if ("string" == typeof e) r.url = e;
          else
            for (var s in e) e.hasOwnProperty(s) && (r[s] = e[s]);
          return n.request = r, n
        }
        var n;
        return u(e, t), e.prototype._subscribe = function (t) {
          return new L(t, this.request)
        }, e.create = ((n = function (t) {
          return new e(t)
        }).get = N, n.post = $, n.delete = R, n.put = j, n.patch = D, n.getJSON = M, n), e
      }(C),
      L = function (t) {
        function e(e, n) {
          var r = t.call(this, e) || this;
          r.request = n, r.done = !1;
          var s = n.headers = n.headers || {};
          return n.crossDomain || r.getHeader(s, "X-Requested-With") || (s["X-Requested-With"] = "XMLHttpRequest"), r.getHeader(s, "Content-Type") || c.a.FormData && n.body instanceof c.a.FormData || void 0 === n.body || (s["Content-Type"] = "application/x-www-form-urlencoded; charset=UTF-8"), n.body = r.serializeBody(n.body, r.getHeader(n.headers, "Content-Type")), r.send(), r
        }
        return u(e, t), e.prototype.next = function (t) {
          this.done = !0;
          var e, n = this.xhr,
            r = this.request,
            s = this.destination;
          try {
            e = new B(t, n, r)
          } catch (t) {
            return s.error(t)
          }
          s.next(e)
        }, e.prototype.send = function () {
          var t = this.request,
            e = this.request,
            n = e.user,
            r = e.method,
            s = e.url,
            i = e.async,
            a = e.password,
            o = e.headers,
            u = e.body;
          try {
            var c = this.xhr = t.createXHR();
            this.setupEvents(c, t), n ? c.open(r, s, i, n, a) : c.open(r, s, i), i && (c.timeout = t.timeout, c.responseType = t.responseType), "withCredentials" in c && (c.withCredentials = !!t.withCredentials), this.setHeaders(c, o), u ? c.send(u) : c.send()
          } catch (t) {
            this.error(t)
          }
        }, e.prototype.serializeBody = function (t, e) {
          if (!t || "string" == typeof t) return t;
          if (c.a.FormData && t instanceof c.a.FormData) return t;
          if (e) {
            var n = e.indexOf(";"); - 1 !== n && (e = e.substring(0, n))
          }
          switch (e) {
            case "application/x-www-form-urlencoded":
              return Object.keys(t).map((function (e) {
                return encodeURIComponent(e) + "=" + encodeURIComponent(t[e])
              })).join("&");
            case "application/json":
              return JSON.stringify(t);
            default:
              return t
          }
        }, e.prototype.setHeaders = function (t, e) {
          for (var n in e) e.hasOwnProperty(n) && t.setRequestHeader(n, e[n])
        }, e.prototype.getHeader = function (t, e) {
          for (var n in t)
            if (n.toLowerCase() === e.toLowerCase()) return t[n]
        }, e.prototype.setupEvents = function (t, e) {
          var n = e.progressSubscriber;

          function r(t) {
            var e, n = r,
              s = n.subscriber,
              i = n.progressSubscriber,
              a = n.request;
            i && i.error(t);
            try {
              e = new U(this, a)
            } catch (t) {
              e = t
            }
            s.error(e)
          }
          if (t.ontimeout = r, r.request = e, r.subscriber = this, r.progressSubscriber = n, t.upload && "withCredentials" in t) {
            var s, i;
            if (n) s = function (t) {
              s.progressSubscriber.next(t)
            }, c.a.XDomainRequest ? t.onprogress = s : t.upload.onprogress = s, s.progressSubscriber = n;
            i = function (t) {
              var e, n = i,
                r = n.progressSubscriber,
                s = n.subscriber,
                a = n.request;
              r && r.error(t);
              try {
                e = new P("ajax error", this, a)
              } catch (t) {
                e = t
              }
              s.error(e)
            }, t.onerror = i, i.request = e, i.subscriber = this, i.progressSubscriber = n
          }

          function a(t) {}

          function o(t) {
            var e = o,
              n = e.subscriber,
              r = e.progressSubscriber,
              s = e.request;
            if (4 === this.readyState) {
              var i = 1223 === this.status ? 204 : this.status,
                a = "text" === this.responseType ? this.response || this.responseText : this.response;
              if (0 === i && (i = a ? 200 : 0), i < 400) r && r.complete(), n.next(t), n.complete();
              else {
                r && r.error(t);
                var u = void 0;
                try {
                  u = new P("ajax error " + i, this, s)
                } catch (t) {
                  u = t
                }
                n.error(u)
              }
            }
          }
          t.onreadystatechange = a, a.subscriber = this, a.progressSubscriber = n, a.request = e, t.onload = o, o.subscriber = this, o.progressSubscriber = n, o.request = e
        }, e.prototype.unsubscribe = function () {
          var e = this.done,
            n = this.xhr;
          !e && n && 4 !== n.readyState && "function" == typeof n.abort && n.abort(), t.prototype.unsubscribe.call(this)
        }, e
      }(x),
      B = function () {
        return function (t, e, n) {
          this.originalEvent = t, this.xhr = e, this.request = n, this.status = e.status, this.responseType = e.responseType || n.responseType, this.response = W(this.responseType, e)
        }
      }(),
      P = function () {
        function t(t, e, n) {
          return Error.call(this), this.message = t, this.name = "AjaxError", this.xhr = e, this.request = n, this.status = e.status, this.responseType = e.responseType || n.responseType, this.response = W(this.responseType, e), this
        }
        return t.prototype = Object.create(Error.prototype), t
      }();

    function W(t, e) {
      switch (t) {
        case "json":
          return function (t) {
            return "response" in t ? t.responseType ? t.response : JSON.parse(t.response || t.responseText || "null") : JSON.parse(t.responseText || "null")
          }(e);
        case "xml":
          return e.responseXML;
        case "text":
        default:
          return "response" in e ? e.response : e.responseText
      }
    }
    var U = function (t, e) {
        return P.call(this, "ajax timeout", t, e), this.name = "AjaxTimeoutError", this
      },
      V = function () {
        return z.create
      }(),
      H = function () {
        function t() {
          return Error.call(this), this.message = "object unsubscribed", this.name = "ObjectUnsubscribedError", this
        }
        return t.prototype = Object.create(Error.prototype), t
      }(),
      G = function (t) {
        function e(e, n) {
          var r = t.call(this) || this;
          return r.subject = e, r.subscriber = n, r.closed = !1, r
        }
        return u(e, t), e.prototype.unsubscribe = function () {
          if (!this.closed) {
            this.closed = !0;
            var t = this.subject,
              e = t.observers;
            if (this.subject = null, e && 0 !== e.length && !t.isStopped && !t.closed) {
              var n = e.indexOf(this.subscriber); - 1 !== n && e.splice(n, 1)
            }
          }
        }, e
      }(y),
      q = function (t) {
        function e(e) {
          var n = t.call(this, e) || this;
          return n.destination = e, n
        }
        return u(e, t), e
      }(x),
      K = function (t) {
        function e() {
          var e = t.call(this) || this;
          return e.observers = [], e.closed = !1, e.isStopped = !1, e.hasError = !1, e.thrownError = null, e
        }
        return u(e, t), e.prototype[v] = function () {
          return new q(this)
        }, e.prototype.lift = function (t) {
          var e = new J(this, this);
          return e.operator = t, e
        }, e.prototype.next = function (t) {
          if (this.closed) throw new H;
          if (!this.isStopped)
            for (var e = this.observers, n = e.length, r = e.slice(), s = 0; s < n; s++) r[s].next(t)
        }, e.prototype.error = function (t) {
          if (this.closed) throw new H;
          this.hasError = !0, this.thrownError = t, this.isStopped = !0;
          for (var e = this.observers, n = e.length, r = e.slice(), s = 0; s < n; s++) r[s].error(t);
          this.observers.length = 0
        }, e.prototype.complete = function () {
          if (this.closed) throw new H;
          this.isStopped = !0;
          for (var t = this.observers, e = t.length, n = t.slice(), r = 0; r < e; r++) n[r].complete();
          this.observers.length = 0
        }, e.prototype.unsubscribe = function () {
          this.isStopped = !0, this.closed = !0, this.observers = null
        }, e.prototype._trySubscribe = function (e) {
          if (this.closed) throw new H;
          return t.prototype._trySubscribe.call(this, e)
        }, e.prototype._subscribe = function (t) {
          if (this.closed) throw new H;
          return this.hasError ? (t.error(this.thrownError), y.EMPTY) : this.isStopped ? (t.complete(), y.EMPTY) : (this.observers.push(t), new G(this, t))
        }, e.prototype.asObservable = function () {
          var t = new C;
          return t.source = this, t
        }, e.create = function (t, e) {
          return new J(t, e)
        }, e
      }(C),
      J = function (t) {
        function e(e, n) {
          var r = t.call(this) || this;
          return r.destination = e, r.source = n, r
        }
        return u(e, t), e.prototype.next = function (t) {
          var e = this.destination;
          e && e.next && e.next(t)
        }, e.prototype.error = function (t) {
          var e = this.destination;
          e && e.error && this.destination.error(t)
        }, e.prototype.complete = function () {
          var t = this.destination;
          t && t.complete && this.destination.complete()
        }, e.prototype._subscribe = function (t) {
          return this.source ? this.source.subscribe(t) : y.EMPTY
        }, e
      }(K),
      X = function (t) {
        function e(e) {
          var n = t.call(this) || this;
          return n._value = e, n
        }
        return u(e, t), Object.defineProperty(e.prototype, "value", {
          get: function () {
            return this.getValue()
          },
          enumerable: !0,
          configurable: !0
        }), e.prototype._subscribe = function (e) {
          var n = t.prototype._subscribe.call(this, e);
          return n && !n.closed && e.next(this._value), n
        }, e.prototype.getValue = function () {
          if (this.hasError) throw this.thrownError;
          if (this.closed) throw new H;
          return this._value
        }, e.prototype.next = function (e) {
          t.prototype.next.call(this, this._value = e)
        }, e
      }(K);

    function Y(t) {
      return t && "function" == typeof t.schedule
    }
    var Z = function (t) {
      return function (e) {
        for (var n = 0, r = t.length; n < r && !e.closed; n++) e.next(t[n]);
        e.complete()
      }
    };

    function Q(t, e) {
      return new C((function (n) {
        var r = new y,
          s = 0;
        return r.add(e.schedule((function () {
          s !== t.length ? (n.next(t[s++]), n.closed || r.add(this.schedule())) : n.complete()
        }))), r
      }))
    }

    function tt(t, e) {
      return e ? Q(t, e) : new C(Z(t))
    }

    function et() {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      var n = t[t.length - 1];
      return Y(n) ? (t.pop(), Q(t, n)) : tt(t)
    }
    var nt = function (t) {
        function e() {
          return null !== t && t.apply(this, arguments) || this
        }
        return u(e, t), e.prototype.notifyNext = function (t, e, n, r, s) {
          this.destination.next(e)
        }, e.prototype.notifyError = function (t, e) {
          this.destination.error(t)
        }, e.prototype.notifyComplete = function (t) {
          this.destination.complete()
        }, e
      }(x),
      rt = function (t) {
        function e(e, n, r) {
          var s = t.call(this) || this;
          return s.parent = e, s.outerValue = n, s.outerIndex = r, s.index = 0, s
        }
        return u(e, t), e.prototype._next = function (t) {
          this.parent.notifyNext(this.outerValue, t, this.outerIndex, this.index++, this)
        }, e.prototype._error = function (t) {
          this.parent.notifyError(t, this), this.unsubscribe()
        }, e.prototype._complete = function () {
          this.parent.notifyComplete(this), this.unsubscribe()
        }, e
      }(x);

    function st() {
      return "function" == typeof Symbol && Symbol.iterator ? Symbol.iterator : "@@iterator"
    }
    var it = st(),
      at = function (t) {
        return t && "number" == typeof t.length && "function" != typeof t
      };

    function ot(t) {
      return !!t && "function" != typeof t.subscribe && "function" == typeof t.then
    }
    var ut = function (t) {
      if (t && "function" == typeof t[S]) return r = t,
        function (t) {
          var e = r[S]();
          if ("function" != typeof e.subscribe) throw new TypeError("Provided object does not correctly implement Symbol.observable");
          return e.subscribe(t)
        };
      if (at(t)) return Z(t);
      if (ot(t)) return n = t,
        function (t) {
          return n.then((function (e) {
            t.closed || (t.next(e), t.complete())
          }), (function (e) {
            return t.error(e)
          })).then(null, p), t
        };
      if (t && "function" == typeof t[it]) return e = t,
        function (t) {
          for (var n = e[it]();;) {
            var r = n.next();
            if (r.done) {
              t.complete();
              break
            }
            if (t.next(r.value), t.closed) break
          }
          return "function" == typeof n.return && t.add((function () {
            n.return && n.return()
          })), t
        };
      var e, n, r, s = g(t) ? "an invalid object" : "'" + t + "'";
      throw new TypeError("You provided " + s + " where a stream was expected. You can provide an Observable, Promise, Array, or Iterable.")
    };

    function ct(t, e, n, r, s) {
      if (void 0 === s && (s = new rt(t, n, r)), !s.closed) return e instanceof C ? e.subscribe(s) : ut(e)(s)
    }
    var lt = {};

    function ht() {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      var n = null,
        r = null;
      return Y(t[t.length - 1]) && (r = t.pop()), "function" == typeof t[t.length - 1] && (n = t.pop()), 1 === t.length && m(t[0]) && (t = t[0]), tt(t, r).lift(new dt(n))
    }
    var dt = function () {
        function t(t) {
          this.resultSelector = t
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new pt(t, this.resultSelector))
        }, t
      }(),
      pt = function (t) {
        function e(e, n) {
          var r = t.call(this, e) || this;
          return r.resultSelector = n, r.active = 0, r.values = [], r.observables = [], r
        }
        return u(e, t), e.prototype._next = function (t) {
          this.values.push(lt), this.observables.push(t)
        }, e.prototype._complete = function () {
          var t = this.observables,
            e = t.length;
          if (0 === e) this.destination.complete();
          else {
            this.active = e, this.toRespond = e;
            for (var n = 0; n < e; n++) {
              var r = t[n];
              this.add(ct(this, r, r, n))
            }
          }
        }, e.prototype.notifyComplete = function (t) {
          0 == (this.active -= 1) && this.destination.complete()
        }, e.prototype.notifyNext = function (t, e, n, r, s) {
          var i = this.values,
            a = i[n],
            o = this.toRespond ? a === lt ? --this.toRespond : this.toRespond : 0;
          i[n] = e, 0 === o && (this.resultSelector ? this._tryResultSelector(i) : this.destination.next(i.slice()))
        }, e.prototype._tryResultSelector = function (t) {
          var e;
          try {
            e = this.resultSelector.apply(this, t)
          } catch (t) {
            return void this.destination.error(t)
          }
          this.destination.next(e)
        }, e
      }(nt);

    function ft(t, e) {
      if (null != t) {
        if (function (t) {
            return t && "function" == typeof t[S]
          }(t)) return function (t, e) {
          return new C((function (n) {
            var r = new y;
            return r.add(e.schedule((function () {
              var s = t[S]();
              r.add(s.subscribe({
                next: function (t) {
                  r.add(e.schedule((function () {
                    return n.next(t)
                  })))
                },
                error: function (t) {
                  r.add(e.schedule((function () {
                    return n.error(t)
                  })))
                },
                complete: function () {
                  r.add(e.schedule((function () {
                    return n.complete()
                  })))
                }
              }))
            }))), r
          }))
        }(t, e);
        if (ot(t)) return function (t, e) {
          return new C((function (n) {
            var r = new y;
            return r.add(e.schedule((function () {
              return t.then((function (t) {
                r.add(e.schedule((function () {
                  n.next(t), r.add(e.schedule((function () {
                    return n.complete()
                  })))
                })))
              }), (function (t) {
                r.add(e.schedule((function () {
                  return n.error(t)
                })))
              }))
            }))), r
          }))
        }(t, e);
        if (at(t)) return Q(t, e);
        if (function (t) {
            return t && "function" == typeof t[it]
          }(t) || "string" == typeof t) return function (t, e) {
          if (!t) throw new Error("Iterable cannot be null");
          return new C((function (n) {
            var r, s = new y;
            return s.add((function () {
              r && "function" == typeof r.return && r.return()
            })), s.add(e.schedule((function () {
              r = t[it](), s.add(e.schedule((function () {
                if (!n.closed) {
                  var t, e;
                  try {
                    var s = r.next();
                    t = s.value, e = s.done
                  } catch (t) {
                    return void n.error(t)
                  }
                  e ? n.complete() : (n.next(t), this.schedule())
                }
              })))
            }))), s
          }))
        }(t, e)
      }
      throw new TypeError((null !== t && typeof t || t) + " is not observable")
    }

    function mt(t, e) {
      return e ? ft(t, e) : t instanceof C ? t : new C(ut(t))
    }

    function gt() {
      for (var t = [], e = 0; e < arguments.length; e++) t[e] = arguments[e];
      if (1 === t.length) {
        var n = t[0];
        if (m(n)) return bt(n, null);
        if (g(n) && Object.getPrototypeOf(n) === Object.prototype) {
          var r = Object.keys(n);
          return bt(r.map((function (t) {
            return n[t]
          })), r)
        }
      }
      if ("function" == typeof t[t.length - 1]) {
        var s = t.pop();
        return bt(t = 1 === t.length && m(t[0]) ? t[0] : t, null).pipe(I((function (t) {
          return s.apply(void 0, t)
        })))
      }
      return bt(t, null)
    }

    function bt(t, e) {
      return new C((function (n) {
        var r = t.length;
        if (0 !== r)
          for (var s = new Array(r), i = 0, a = 0, o = function (o) {
              var u = mt(t[o]),
                c = !1;
              n.add(u.subscribe({
                next: function (t) {
                  c || (c = !0, a++), s[o] = t
                },
                error: function (t) {
                  return n.error(t)
                },
                complete: function () {
                  ++i !== r && c || (a === r && n.next(e ? e.reduce((function (t, e, n) {
                    return t[e] = s[n], t
                  }), {}) : s), n.complete())
                }
              }))
            }, u = 0; u < r; u++) o(u);
        else n.complete()
      }))
    }

    function yt(t, e) {
      return new C(e ? function (n) {
        return e.schedule(wt, 0, {
          error: t,
          subscriber: n
        })
      } : function (e) {
        return e.error(t)
      })
    }

    function wt(t) {
      var e = t.error;
      t.subscriber.error(e)
    }
    var vt = function () {
        function t(t, e) {
          this.predicate = t, this.inclusive = e
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new xt(t, this.predicate, this.inclusive))
        }, t
      }(),
      xt = function (t) {
        function e(e, n, r) {
          var s = t.call(this, e) || this;
          return s.predicate = n, s.inclusive = r, s.index = 0, s
        }
        return u(e, t), e.prototype._next = function (t) {
          var e, n = this.destination;
          try {
            e = this.predicate(t, this.index++)
          } catch (t) {
            return void n.error(t)
          }
          this.nextOrComplete(t, e)
        }, e.prototype.nextOrComplete = function (t, e) {
          var n = this.destination;
          Boolean(e) ? n.next(t) : (this.inclusive && n.next(t), n.complete())
        }, e
      }(x);

    function Ot(t) {
      return void 0 === t && (t = -1),
        function (e) {
          return e.lift(new St(t, e))
        }
    }
    var St = function () {
        function t(t, e) {
          this.count = t, this.source = e
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new _t(t, this.count, this.source))
        }, t
      }(),
      _t = function (t) {
        function e(e, n, r) {
          var s = t.call(this, e) || this;
          return s.count = n, s.source = r, s
        }
        return u(e, t), e.prototype.error = function (e) {
          if (!this.isStopped) {
            var n = this.source,
              r = this.count;
            if (0 === r) return t.prototype.error.call(this, e);
            r > -1 && (this.count = r - 1), n.subscribe(this._unsubscribeAndRecycle())
          }
        }, e
      }(x);

    function kt(t, e) {
      return "function" == typeof e ? function (n) {
        return n.pipe(kt((function (n, r) {
          return mt(t(n, r)).pipe(I((function (t, s) {
            return e(n, t, r, s)
          })))
        })))
      } : function (e) {
        return e.lift(new Ct(t))
      }
    }
    var Ct = function () {
        function t(t) {
          this.project = t
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new Et(t, this.project))
        }, t
      }(),
      Et = function (t) {
        function e(e, n) {
          var r = t.call(this, e) || this;
          return r.project = n, r.index = 0, r
        }
        return u(e, t), e.prototype._next = function (t) {
          var e, n = this.index++;
          try {
            e = this.project(t, n)
          } catch (t) {
            return void this.destination.error(t)
          }
          this._innerSub(e, t, n)
        }, e.prototype._innerSub = function (t, e, n) {
          var r = this.innerSubscription;
          r && r.unsubscribe();
          var s = new rt(this, e, n),
            i = this.destination;
          i.add(s), this.innerSubscription = ct(this, t, void 0, void 0, s), this.innerSubscription !== s && i.add(this.innerSubscription)
        }, e.prototype._complete = function () {
          var e = this.innerSubscription;
          e && !e.closed || t.prototype._complete.call(this), this.unsubscribe()
        }, e.prototype._unsubscribe = function () {
          this.innerSubscription = null
        }, e.prototype.notifyComplete = function (e) {
          this.destination.remove(e), this.innerSubscription = null, this.isStopped && t.prototype._complete.call(this)
        }, e.prototype.notifyNext = function (t, e, n, r, s) {
          this.destination.next(e)
        }, e
      }(nt),
      It = n(50),
      Tt = function () {
        return (Tt = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++)
            for (var s in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
          return t
        }).apply(this, arguments)
      },
      At = function (t, e, n, r) {
        return new(n || (n = Promise))((function (s, i) {
          function a(t) {
            try {
              u(r.next(t))
            } catch (t) {
              i(t)
            }
          }

          function o(t) {
            try {
              u(r.throw(t))
            } catch (t) {
              i(t)
            }
          }

          function u(t) {
            var e;
            t.done ? s(t.value) : (e = t.value, e instanceof n ? e : new n((function (t) {
              t(e)
            }))).then(a, o)
          }
          u((r = r.apply(t, e || [])).next())
        }))
      },
      Nt = function (t, e) {
        var n, r, s, i, a = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1]
          },
          trys: [],
          ops: []
        };
        return i = {
          next: o(0),
          throw: o(1),
          return: o(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this
        }), i;

        function o(i) {
          return function (o) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (s = 2 & i[0] ? r.return : i[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, i[1])).done) return s;
                switch (r = 0, s && (i = [2 & i[0], s.value]), i[0]) {
                  case 0:
                  case 1:
                    s = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(s = (s = a.trys).length > 0 && s[s.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue
                    }
                    if (3 === i[0] && (!s || i[1] > s[0] && i[1] < s[3])) {
                      a.label = i[1];
                      break
                    }
                    if (6 === i[0] && a.label < s[1]) {
                      a.label = s[1], s = i;
                      break
                    }
                    if (s && a.label < s[2]) {
                      a.label = s[2], a.ops.push(i);
                      break
                    }
                    s[2] && a.ops.pop(), a.trys.pop();
                    continue
                }
                i = e.call(t, a)
              } catch (t) {
                i = [6, t], r = 0
              } finally {
                n = s = 0
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              }
            }([i, o])
          }
        }
      },
      $t = 2190,
      Rt = function () {
        function t() {
          var t = this;
          this._faceModuleLoaded = new X(!1), this._initialized = !1, this._modelClassifiers = {}, this._emotionClassifiers = {}, this._currentWidth = 0, this._currentHeight = 0, this._trackingBuffersInitialized = !1, this._isFaceDetected = !1, this._facePosition = [0, 0, 0], this._faceRotation = [
            [1, 0, 0],
            [0, 1, 0],
            [0, 0, 1]
          ], this._faceVertices = new Float32Array($t), this._emoScore = [1, 0, 0, 0, 0, 0, 0, 0], i().then((function (e) {
            t._faceModule = e, t._faceModuleLoaded.next(!0)
          }))
        }
        return Object.defineProperty(t.prototype, "faceModelObj", {
          get: function () {
            return this._faceModelObj
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "isFaceDetected", {
          get: function () {
            return this._isFaceDetected
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "facePosition", {
          get: function () {
            return this._facePosition
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "faceRotation", {
          get: function () {
            return this._faceRotation
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.getDetectedObjectID = function (t) {
          return -1
        }, t.prototype.getObjectPosition = function (t) {
          return this._facePosition
        }, t.prototype.getObjectRotation = function (t) {
          return this._faceRotation
        }, Object.defineProperty(t.prototype, "faceVertices", {
          get: function () {
            return this._faceVertices
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "emoScore", {
          get: function () {
            return this._emoScore
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.initialize = function (t, e) {
          return At(this, void 0, void 0, (function () {
            var n, r, s, i, o, u, c = this;
            return Nt(this, (function (l) {
              switch (l.label) {
                case 0:
                  return this.deInitialize(), this._config = t ? Tt(Tt({}, a), t) : a, this._config.emotions = !1, console.debug("Config: ", this._config), n = new X(0), r = this._modelClassifiers.file || this._modelClassifiers.pointer ? et(null) : this.retrieveModelClassifier(this._config.libPath + "/models-68-BS.zip", "models-68-BS.cl", n), s = new X(0), i = !this._config.emotions || this._emotionClassifiers.file || this._emotionClassifiers.pointer ? et(null) : this.retrieveEmotionsClassifier(this._config.libPath + "/ENET50-32-EMO-CPU.bytes", s), o = new X(0), u = this._faceModelObj ? et(null) : this.retrieveFaceMask(this._config.libPath + "/face-model.obj", o), this._initializeSubscription = new y, this._initializeSubscription.add(ht(n, s, o).subscribe((function (t) {
                    e && e(t.reduce((function (t, e) {
                      return t + e
                    }), 0) / t.length)
                  }))), [4, gt({
                    module: this._faceModuleLoaded.pipe((h = function (t) {
                      return !t
                    }, d = !0, void 0 === d && (d = !1), function (t) {
                      return t.lift(new vt(h, d))
                    })),
                    modelClassifiers: r,
                    emotionsClassifiers: i,
                    faceModelObj: u
                  }).pipe(I((function (t) {
                    if (c._initialized = !0, n.next(1), s.next(1), o.next(1), t.modelClassifiers && (c._modelClassifiers.file = t.modelClassifiers), c._modelClassifiers.file && !c._modelClassifiers.pointer) {
                      var e = new Uint8Array(c._modelClassifiers.file);
                      c._modelClassifiers.pointer = c._faceModule._malloc(e.byteLength), c._faceModule.HEAPU8.set(e, c._modelClassifiers.pointer)
                    }
                    if (t.emotionsClassifiers && (c._emotionClassifiers.file = t.emotionsClassifiers), c._emotionClassifiers.file && !c._emotionClassifiers.pointer) {
                      e = new Uint8Array(c._emotionClassifiers.file);
                      c._emotionClassifiers.pointer = c._faceModule._malloc(e.byteLength), c._faceModule.HEAPU8.set(e, c._emotionClassifiers.pointer)
                    }
                    t.faceModelObj && (c._faceModelObj = t.faceModelObj)
                  }))).toPromise()];
                case 1:
                  return l.sent(), this._initializeSubscription.unsubscribe(), [2]
              }
              var h, d
            }))
          }))
        }, t.prototype.release = function () {
          this._initializeSubscription && this._initializeSubscription.unsubscribe(), this._initialized = !1, this.releaseTrackingBuffers(), void 0 !== this._modelClassifiers.pointer && (this._faceModule._free(this._modelClassifiers.pointer), this._modelClassifiers = {
            file: this._modelClassifiers.file
          }), void 0 !== this._emotionClassifiers.pointer && (this._faceModule._free(this._emotionClassifiers.pointer), this._emotionClassifiers = {
            file: this._emotionClassifiers.file
          })
        }, t.prototype.isInitialized = function () {
          return this._initialized
        }, t.prototype.track = function (t) {
          if (this._initialized) {
            if (t.width !== this._currentWidth || t.height !== this._currentHeight) this._faceModule.cwrap("xzimgMagicFaceRelease")(), this.releaseTrackingBuffers(), this._currentWidth = t.width, this._currentHeight = t.height, this.initializeTrackingBuffers(this._currentWidth, this._currentHeight), this.initializeFace(this._currentWidth, this._currentHeight), this._config.emotions && this.initializeEmotionsCassifiers();
            var e = t.getContext("2d");
            if (e) {
              var n = e.getImageData(0, 0, this._currentWidth, this._currentHeight),
                r = new Uint32Array(n.data.buffer),
                s = r.length,
                i = this._imageDataBuffer / 4;
              this._faceModule.HEAPU32.subarray(i, i + s).set(r);
              var a = this._faceModule.cwrap("xzimgMagicFaceTrackNonRigidFaces", "number", ["number", "number"])(this._imageStructBuffer, 0);
              if (a > 0) {
                if (this._config.emotions) this._faceModule.cwrap("xzimgProcessEmotion", "number", ["number", "number"])(0, .5);
                if ((a = this._faceModule.cwrap("xzimgMagicFaceGetFaceData", "number", ["number", "number"])(0, this._faceDataBuffer)) < 0 && console.error("Error tracking: " + a), this._isFaceDetected = 1 === this._faceModule.getValue(this._faceDataBuffer, "i32"), this._isFaceDetected) {
                  this._faceModule.getValue(this._faceDataBuffer + 4, "i32");
                  this._facePosition = [this._faceModule.getValue(this._faceDataBuffer + 8 + 0, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 4, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 8, "float")], this._faceRotation = [
                    [this._faceModule.getValue(this._faceDataBuffer + 8 + 40, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 44, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 48, "float")],
                    [this._faceModule.getValue(this._faceDataBuffer + 8 + 52, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 56, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 60, "float")],
                    [this._faceModule.getValue(this._faceDataBuffer + 8 + 64, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 68, "float"), this._faceModule.getValue(this._faceDataBuffer + 8 + 72, "float")]
                  ];
                  this._faceModule.getValue(this._faceDataBuffer + 8 + 76, "i32"), this._faceModule.getValue(this._faceDataBuffer + 8 + 76 + 4, "i32");
                  this._faceVertices = new Float32Array(this._faceModule.HEAPF32.buffer, this._landmarks3DBuffer, $t), this._emoScore = [this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 0, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 4, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 8, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 12, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 16, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 20, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 24, "float"), this._faceModule.getValue(this._faceDataBuffer + 20 + 76 + 40 + 16 + 28, "float")]
                }
              }
            } else console.error("No rendering context")
          } else console.warn("Plugin must be initialized to track")
        }, t.prototype.deInitialize = function () {
          this._initialized = !1, this._initializeSubscription && this._initializeSubscription.unsubscribe(), this._currentWidth = 0, this._currentHeight = 0, this.releaseTrackingBuffers()
        }, t.prototype.retrieveModelClassifier = function (t, e, n) {
          return V({
            url: t,
            method: "GET",
            responseType: "arraybuffer",
            async: !0,
            progressSubscriber: new x((function (t) {
              return n.next(.5 * t.loaded / t.total)
            }), (function (t) {}), (function () {
              return n.next(.5)
            }))
          }).pipe(Ot(2), kt((function (t) {
            return mt((new It).loadAsync(t.response))
          })), kt((function (r) {
            var s = r.file(e);
            return s ? mt(s.async("arraybuffer", (function (t) {
              n.next(.5 + t.percent / 200)
            }))) : yt("File " + e + " not found in " + t)
          })))
        }, t.prototype.retrieveEmotionsClassifier = function (t, e) {
          return V({
            url: t,
            method: "GET",
            responseType: "arraybuffer",
            async: !0,
            progressSubscriber: new x((function (t) {
              return e.next(t.loaded / t.total)
            }), (function (t) {}), (function () {
              return e.next(1)
            }))
          }).pipe(Ot(2), I((function (t) {
            return t.response
          })))
        }, t.prototype.retrieveFaceMask = function (t, e) {
          var n = this;
          return V({
            url: t,
            method: "GET",
            responseType: "text",
            async: !0,
            progressSubscriber: new x((function (t) {
              return e.next(t.loaded / t.total)
            }), (function (t) {
              return console.error("Progress face mask error: ", t)
            }), (function () {
              return e.next(1)
            }))
          }).pipe(Ot(2), I((function (t) {
            return n.parseObjFile(t.response)
          })))
        }, t.prototype.parseObjFile = function (t) {
          var e, n, r, s, i = {
              vertices: new Float32Array,
              uvs: new Float32Array,
              faces: new Uint16Array
            },
            a = t.match(/^v( -?\d+(\.\d+)?){3}$/gm);
          if (a) {
            var o = a.map((function (t) {
                var e = t.split(" ");
                return e.shift(), e.map((function (t) {
                  return +t
                }))
              })),
              u = (e = []).concat.apply(e, o);
            i.vertices = new Float32Array(u)
          }
          var c = t.match(/^vt( -?\d+(\.\d+)?){2}$/gm);
          if (c) {
            var l = c.map((function (t) {
                var e = t.split(" ");
                return e.shift(), e.map((function (t) {
                  return +t
                }))
              })),
              h = (n = []).concat.apply(n, l);
            i.uvs = new Float32Array(h)
          }
          var d = t.match(/^f( \d+\/\d+\/\d+){3}$/gm);
          if (d) {
            var p = d.map((function (t) {
                var e = t.split(" ");
                return e.shift(), [+e[0].split("/")[0] - 1, +e[1].split("/")[0] - 1, +e[2].split("/")[0] - 1]
              })),
              f = (r = []).concat.apply(r, p);
            i.faces = new Uint16Array(f);
            var m = d.map((function (t) {
                var e = t.split(" ");
                return e.shift(), [+e[0].split("/")[1] - 1, +e[1].split("/")[1] - 1, +e[2].split("/")[1] - 1]
              })),
              g = new Uint16Array((s = []).concat.apply(s, m)),
              b = i.uvs;
            i.uvs = new Float32Array(b.length);
            for (var y = 0; y < g.length; y++) {
              var w = g[y],
                v = b[2 * w],
                x = b[2 * w + 1],
                O = i.faces[y];
              i.uvs[2 * O] = v, i.uvs[2 * O + 1] = x
            }
          }
          for (y = 0; y < i.faces.length; y += 3) {
            var S = i.faces[y];
            i.faces[y] = i.faces[y + 1], i.faces[y + 1] = S
          }
          for (y = 0; y < i.vertices.length; y += 3) i.vertices[y] = -i.vertices[y];
          return i
        }, t.prototype.initializeFace = function (t, e) {
          var n = this._faceModule._malloc(52);
          this._faceModule.setValue(n + 0, 4, "i32"), this._faceModule.setValue(n + 4, t, "i32"), this._faceModule.setValue(n + 8, e, "i32"), this._faceModule.setValue(n + 12, 68, "i32"), this._faceModule.setValue(n + 16, 1, "i32"), this._faceModule.setValue(n + 20, this._config.fovY, "float"), this._faceModule.setValue(n + 24, 0, "i32"), this._faceModule.setValue(n + 28, 0, "i32"), this._faceModule.setValue(n + 32, this._modelClassifiers.pointer, "*"), console.debug("==> [begin] xzimgMagicFaceInitialize");
          var r = this._faceModule.cwrap("xzimgMagicFaceInitialize", "number", ["number"])(n);
          r < 0 && console.error("Error initializing model classifiers: " + r), console.debug("==> [end] xzimgMagicFaceInitialize = " + r), this._faceModule._free(n)
        }, t.prototype.initializeEmotionsCassifiers = function () {
          var t = this._faceModule._malloc(52);
          this._faceModule.setValue(t + 0, 48, "i32"), this._faceModule.setValue(t + 4, 48, "i32"), this._faceModule.setValue(t + 8, 0, "i32"), this._faceModule.setValue(t + 12, 1, "i32"), console.debug("==> [begin] xzimgMagicFaceInitializeEmotion");
          var e = this._faceModule.cwrap("xzimgMagicFaceInitializeEmotion", "number", ["number", "number"])(this._emotionClassifiers.pointer, t);
          e < 0 && console.error("Error initializing emotions classifiers: " + e), console.debug("==> [end] xzimgMagicFaceInitializeEmotion = " + e), this._faceModule._free(t)
        }, t.prototype.initializeTrackingBuffers = function (t, e) {
          this._imageStructBuffer = this._faceModule._malloc(28), this._imageDataBuffer = this._faceModule._malloc(t * e * 4), this._faceModule.setValue(this._imageStructBuffer + 0, t, "i32"), this._faceModule.setValue(this._imageStructBuffer + 4, e, "i32"), this._faceModule.setValue(this._imageStructBuffer + 8, this._imageDataBuffer, "*"), this._faceModule.setValue(this._imageStructBuffer + 12, 0, "i32"), this._faceModule.setValue(this._imageStructBuffer + 16, 4, "i32"), this._faceModule.setValue(this._imageStructBuffer + 20, 0, "i32"), this._faceModule.setValue(this._imageStructBuffer + 24, 0, "i32"), this._landmarks3DBuffer = this._faceModule._malloc(4 * $t), this._landmarks2DBuffer = this._faceModule._malloc(544), this._tmpData3 = this._faceModule._malloc(4e3), this._tmpData4 = this._faceModule._malloc(2400), this._faceDataBuffer = this._faceModule._malloc(208), this._faceModule.setValue(this._faceDataBuffer + 8 + 76 + 8, this._landmarks3DBuffer, "*"), this._faceModule.setValue(this._faceDataBuffer + 8 + 76 + 12, this._landmarks2DBuffer, "*"), this._faceModule.setValue(this._faceDataBuffer + 8 + 76 + 20, this._tmpData3, "*"), this._faceModule.setValue(this._faceDataBuffer + 8 + 76 + 24, this._tmpData4, "*"), this._trackingBuffersInitialized = !0
        }, t.prototype.releaseTrackingBuffers = function () {
          this._trackingBuffersInitialized && (this._trackingBuffersInitialized = !1, this._faceModule._free(this._imageDataBuffer), this._faceModule._free(this._imageStructBuffer), this._faceModule._free(this._faceDataBuffer), this._faceModule._free(this._landmarks3DBuffer), this._faceModule._free(this._landmarks2DBuffer), this._faceModule._free(this._tmpData3), this._faceModule._free(this._tmpData4))
        }, t
      }();
    var jt = function () {
        function t(t, e) {
          void 0 === e && (e = Number.POSITIVE_INFINITY), this.project = t, this.concurrent = e
        }
        return t.prototype.call = function (t, e) {
          return e.subscribe(new Dt(t, this.project, this.concurrent))
        }, t
      }(),
      Dt = function (t) {
        function e(e, n, r) {
          void 0 === r && (r = Number.POSITIVE_INFINITY);
          var s = t.call(this, e) || this;
          return s.project = n, s.concurrent = r, s.hasCompleted = !1, s.buffer = [], s.active = 0, s.index = 0, s
        }
        return u(e, t), e.prototype._next = function (t) {
          this.active < this.concurrent ? this._tryNext(t) : this.buffer.push(t)
        }, e.prototype._tryNext = function (t) {
          var e, n = this.index++;
          try {
            e = this.project(t, n)
          } catch (t) {
            return void this.destination.error(t)
          }
          this.active++, this._innerSub(e, t, n)
        }, e.prototype._innerSub = function (t, e, n) {
          var r = new rt(this, e, n),
            s = this.destination;
          s.add(r);
          var i = ct(this, t, void 0, void 0, r);
          i !== r && s.add(i)
        }, e.prototype._complete = function () {
          this.hasCompleted = !0, 0 === this.active && 0 === this.buffer.length && this.destination.complete(), this.unsubscribe()
        }, e.prototype.notifyNext = function (t, e, n, r, s) {
          this.destination.next(e)
        }, e.prototype.notifyComplete = function (t) {
          var e = this.buffer;
          this.remove(t), this.active--, e.length > 0 ? this._next(e.shift()) : 0 === this.active && this.hasCompleted && this.destination.complete()
        }, e
      }(nt),
      Ft = n(0);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    let Mt;

    function zt() {
      return null == Mt && (Mt = Object(Ft.K)().epsilon()), Mt
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class Lt extends Error {
      constructor(t) {
        super(t), Object.setPrototypeOf(this, Lt.prototype)
      }
    }
    class Bt extends Error {
      constructor(t) {
        super(t), Object.setPrototypeOf(this, Bt.prototype)
      }
    }
    class Pt extends Error {
      constructor(t) {
        super(t), Object.setPrototypeOf(this, Pt.prototype)
      }
    }
    class Wt extends Error {
      constructor(t) {
        super(t), Object.setPrototypeOf(this, Wt.prototype)
      }
    }
    class Ut extends Error {
      constructor(t) {
        super(t), Object.setPrototypeOf(this, Ut.prototype)
      }
    }
    Error;
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Vt(t, e) {
      if (Array.isArray(t)) {
        let n = [];
        for (let r = 0; r < e; r++) n = n.concat(t);
        return n
      } {
        const n = new Array(e);
        return n.fill(t), n
      }
    }

    function Ht(t, e) {
      if (!t) throw new Ut(e)
    }

    function Gt(t, e) {
      let n = 0;
      for (const r of t) r === e && n++;
      return n
    }

    function qt(t) {
      return 1 === t.length ? t[0] : t
    }

    function Kt(t) {
      return Array.isArray(t) ? t : [t]
    }

    function Jt(t) {
      const e = t.replace(/(.)([A-Z][a-z0-9]+)/g, "$1_$2").replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
      return "_" !== e[0] ? e : "private" + e
    }

    function Xt(t) {
      return t.length <= 1 ? t : -1 === t.indexOf("_") ? t : t.replace(/[_]+(\w|$)/g, (t, e) => e.toUpperCase())
    }
    let Yt = {};

    function Zt(t) {
      if (null == t) return null;
      const e = {};
      return e.className = t.getClassName(), e.config = t.getConfig(), e
    }

    function Qt(t, e = {}, n = {}, r = "object", s = !1) {
      if ("string" == typeof t) {
        const s = t;
        let i;
        if (s in n) i = n[s];
        else if (s in Yt) i = Yt[s];
        else if (i = e[s], null == i) throw new Pt(`Unknown ${r}: ${t}. ` + "This may be due to one of the following reasons:\n" + `1. The ${r} is defined in Python, in which ` + "case it needs to be ported to TensorFlow.js or your JavaScript code.\n" + `2. The custom ${r} is defined in JavaScript, ` + "but is not registered properly with tf.serialization.registerClass().");
        return i
      } {
        const i = t;
        if (null == i.className || null == i.config) throw new Pt(`${r}: Improper config format: ` + `${JSON.stringify(i)}.\n` + "'className' and 'config' must set.");
        const a = i.className;
        let o, u;
        if (a in n ? [o, u] = n[a] : a in Yt ? [o, u] = Yt.className : a in e && ([o, u] = e[a]), null == o) throw new Pt(`Unknown ${r}: ${a}. ` + "This may be due to one of the following reasons:\n" + `1. The ${r} is defined in Python, in which ` + "case it needs to be ported to TensorFlow.js or your JavaScript code.\n" + `2. The custom ${r} is defined in JavaScript, ` + "but is not registered properly with tf.serialization.registerClass().");
        if (null != u) {
          const t = {};
          for (const e of Object.keys(Yt)) t[e] = Yt[e];
          for (const e of Object.keys(n)) t[e] = n[e];
          i.config.customObjects = t;
          const e = Object.assign({}, Yt);
          for (const t of Object.keys(n)) Yt[t] = n[t];
          ! function t(e) {
            if (null != e && "object" == typeof e)
              if (Array.isArray(e)) e.forEach(e => t(e));
              else {
                const n = Object.keys(e);
                for (const r of n) {
                  const n = e[r];
                  null != n && "object" == typeof n && (Array.isArray(n) || "ndarray" !== n.type || "number" != typeof n.value ? t(n) : e[r] = n.value)
                }
              }
          }(i.config);
          const r = u(o, i.config, n, s);
          return Yt = Object.assign({}, e), r
        } {
          const t = Object.assign({}, Yt);
          for (const t of Object.keys(n)) Yt[t] = n[t];
          const e = new o(i.config);
          return Yt = Object.assign({}, t), e
        }
      }
    }

    function te(t, e) {
      return -1 * function (t, e) {
        return t < e ? -1 : t > e ? 1 : 0
      }(t, e)
    }

    function ee(t) {
      if (null == t) return t;
      const e = [];
      for (const n of t) - 1 === e.indexOf(n) && e.push(n);
      return e
    }

    function ne(t) {
      if (null == t) throw new Pt(`Invalid value in obj: ${JSON.stringify(t)}`);
      for (const e in t)
        if (t.hasOwnProperty(e)) return !1;
      return !0
    }

    function re(t, e, n) {
      if (null != n && t.indexOf(n) < 0) throw new Pt(`${n} is not a valid ${e}.  Valid values are ${t} or null/undefined.`)
    }

    function se(t, e, n = 0, r = 1 / 0) {
      return Ht(n >= 0), Ht(r >= n), Array.isArray(t) && t.length >= n && t.length <= r && t.every(t => typeof t === e)
    }

    function ie(t, e) {
      Array.isArray(t) ? (Ft.Jd.assert(t.length > 0, () => `${e} is unexpectedly an empty array.`), t.forEach((t, n) => ie(t, `element ${n+1} of ${e}`))) : Ft.Jd.assert(Number.isInteger(t) && t > 0, () => `Expected ${e} to be a positive integer, but got ` + `${function t(e){return null===e?"null":Array.isArray(e)?"["+e.map(e=>t(e)).join(",")+"]":"string"==typeof e?`"${e}"`:`${e}`}(t)}.`)
    }

    function ae(t) {
      return "relu" === t ? "relu" : "linear" === t ? "linear" : "elu" === t ? "elu" : null
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function oe(t, e) {
      return Object(Ft.Bd)(() => Ft.ld(Ft.sd(Ft.qc(t, t), e, !0)))
    }
    class ue extends Ft.Tc.Serializable {
      getConfig() {
        return {}
      }
    }
    class ce extends ue {
      constructor(t) {
        super(), this.defaultMaxValue = 2, this.defaultAxis = 0, this.maxValue = null != t.maxValue ? t.maxValue : this.defaultMaxValue, this.axis = null != t.axis ? t.axis : this.defaultAxis
      }
      apply(t) {
        return Object(Ft.Bd)(() => {
          const e = oe(t, this.axis),
            n = Ft.W(e, 0, this.maxValue);
          return Ft.qc(t, Ft.qb(n, Ft.x(zt(), e)))
        })
      }
      getConfig() {
        return {
          maxValue: this.maxValue,
          axis: this.axis
        }
      }
    }
    ce.className = "MaxNorm", Ft.Tc.registerClass(ce);
    class le extends ue {
      constructor(t) {
        super(), this.defaultAxis = 0, this.axis = null != t.axis ? t.axis : this.defaultAxis
      }
      apply(t) {
        return Object(Ft.Bd)(() => Ft.qb(t, Ft.x(zt(), oe(t, this.axis))))
      }
      getConfig() {
        return {
          axis: this.axis
        }
      }
    }
    le.className = "UnitNorm", Ft.Tc.registerClass(le);
    class he extends ue {
      apply(t) {
        return Ft.Jc(t)
      }
    }
    he.className = "NonNeg", Ft.Tc.registerClass(he);
    class de extends ue {
      constructor(t) {
        super(), this.defaultMinValue = 0, this.defaultMaxValue = 1, this.defaultRate = 1, this.defaultAxis = 0, this.minValue = null != t.minValue ? t.minValue : this.defaultMinValue, this.maxValue = null != t.maxValue ? t.maxValue : this.defaultMaxValue, this.rate = null != t.rate ? t.rate : this.defaultRate, this.axis = null != t.axis ? t.axis : this.defaultAxis
      }
      apply(t) {
        return Object(Ft.Bd)(() => {
          const e = oe(t, this.axis),
            n = Ft.x(Ft.qc(this.rate, Ft.W(e, this.minValue, this.maxValue)), Ft.qc(1 - this.rate, e));
          return Ft.qc(t, Ft.qb(n, Ft.x(zt(), e)))
        })
      }
      getConfig() {
        return {
          minValue: this.minValue,
          maxValue: this.maxValue,
          rate: this.rate,
          axis: this.axis
        }
      }
    }
    de.className = "MinMaxNorm", Ft.Tc.registerClass(de);
    const pe = {
      maxNorm: "MaxNorm",
      minMaxNorm: "MinMaxNorm",
      nonNeg: "NonNeg",
      unitNorm: "UnitNorm"
    };

    function fe(t) {
      return Zt(t)
    }

    function me(t, e = {}) {
      return Qt(t, Ft.Tc.SerializationMap.getMap().classNameMap, e, "constraint")
    }

    function ge(t) {
      if (null == t) return null;
      if ("string" == typeof t) {
        return me({
          className: t in pe ? pe[t] : t,
          config: {}
        })
      }
      return t instanceof ue ? t : me(t)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    const be = ["channelsFirst", "channelsLast"],
      ye = ["valid", "same", "causal"],
      we = ["max", "avg"],
      ve = ["sum", "mul", "concat", "ave"],
      xe = new Map;

    function Oe(t) {
      re(be, "DataFormat", t)
    }

    function Se(t) {
      re(ye, "PaddingMode", t)
    }

    function _e(t) {
      re(we, "PoolMode", t)
    }
    const ke = [],
      Ce = "/";

    function Ee(t, e) {
      ke.push(t);
      try {
        const t = e();
        return ke.pop(), t
      } catch (t) {
        throw ke.pop(), t
      }
    }

    function Ie(t) {
      if (!Ne(t)) throw new Error("Not a valid tensor name: '" + t + "'");
      return (0 === ke.length ? "" : ke.join(Ce) + Ce) + t
    }

    function Te(t) {
      if (!Ne(t)) throw new Error("Not a valid tensor name: '" + t + "'");
      xe.has(t) || xe.set(t, 0);
      const e = xe.get(t);
      if (xe.set(t, xe.get(t) + 1), e > 0) {
        const n = `${t}_${e}`;
        return xe.set(n, 1), n
      }
      return t
    }
    const Ae = new RegExp(/^[A-Za-z0-9][-A-Za-z0-9\._\/]*$/);

    function Ne(t) {
      return !!t.match(Ae)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function $e(t, e, n) {
      null == e && (e = 0), null == n && (n = t.length);
      let r = 1;
      for (let s = e; s < n; ++s) r *= t[s];
      return r
    }

    function Re(t) {
      return t = Array.isArray(t) ? new Float32Array(t) : t, Object(Ft.xd)(t)
    }

    function je(t) {
      return Ft.mc(Re(t)).dataSync()[0]
    }

    function De(t) {
      return Ft.fc(Re(t)).dataSync()[0]
    }

    function Fe(t, e) {
      if (e < t) throw new Pt(`end (${e}) < begin (${t}) is forbidden.`);
      const n = [];
      for (let r = t; r < e; ++r) n.push(r);
      return n
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Me(t, e) {
      return t.asType(e)
    }

    function ze(t, e = -1) {
      const n = t.shape.slice();
      return e < 0 && (e = n.length + e + 1), n.splice(e, 0, 1), t.reshape(n)
    }

    function Le(t, e, n) {
      return Object(Ft.Bd)(() => {
        switch (t.rank) {
          case 1:
            return Ft.bd(t, e, n);
          case 2:
            return Ft.cd(t, [e, 0], [n, t.shape[1]]);
          case 3:
            return Ft.dd(t, [e, 0, 0], [n, t.shape[1], t.shape[2]]);
          case 4:
            return Ft.ed(t, [e, 0, 0, 0], [n, t.shape[1], t.shape[2], t.shape[3]]);
          case 5:
            return Ft.ad(t, [e, 0, 0, 0, 0], [n, t.shape[1], t.shape[2], t.shape[3], t.shape[4]]);
          case 6:
            return Ft.ad(t, [e, 0, 0, 0, 0, 0], [n, t.shape[1], t.shape[2], t.shape[3], t.shape[4], t.shape[5]]);
          default:
            throw new Pt("sliceAlongFirstAxis() received an unsupported tensor rank: " + `${t.rank}`)
        }
      })
    }

    function Be(t, e, n) {
      return Object(Ft.Bd)(() => {
        switch (t.rank) {
          case 1:
            return Ft.bd(t, e, n);
          case 2:
            return Ft.cd(t, [0, e], [t.shape[0], n]);
          case 3:
            return Ft.dd(t, [0, 0, e], [t.shape[0], t.shape[1], n]);
          case 4:
            return Ft.ed(t, [0, 0, 0, e], [t.shape[0], t.shape[1], t.shape[2], n]);
          default:
            throw new Pt("sliceAlongLastAxis() received an unsupported tensor rank: " + `${t.rank}`)
        }
      })
    }

    function Pe(t, e, n, r) {
      return Object(Ft.Bd)(() => {
        switch (t.rank) {
          case 1:
            return Ft.bd(t, e, n);
          case 2:
            switch (r) {
              case 1:
                return Le(t, e, n);
              case 2:
                return Be(t, e, n);
              default:
                throw new Pt("The axis is not within the rank of the tensor " + `${r}`)
            }
            case 3:
              switch (r) {
                case 1:
                  return Le(t, e, n);
                case 2:
                  return Ft.dd(t, [0, e, 0], [t.shape[0], n, t.shape[2]]);
                case 3:
                  return Be(t, e, n);
                default:
                  throw new Pt("The axis is not within the rank of the tensor " + `${r}`)
              }
              case 4:
                switch (r) {
                  case 1:
                    return Le(t, e, n);
                  case 2:
                    return Ft.ed(t, [0, e, 0, 0], [t.shape[0], n, t.shape[2], t.shape[3]]);
                  case 3:
                    return Ft.ed(t, [0, 0, e, 0], [t.shape[0], t.shape[1], n, t.shape[3]]);
                  case 4:
                    return Be(t, e, n);
                  default:
                    throw new Pt("The axis is not within the rank of the tensor " + `${r}`)
                }
                default:
                  throw new Pt("sliceAlongLastAxis() received an unsupported tensor rank: " + `${t.rank}`)
        }
      })
    }

    function We(t, e = -1) {
      let n;
      return e < 0 && (n = t[0].rank, e = 0 !== n ? n : 0), e === t[0].rank && (e = -1), Ft.Z(t, e)
    }

    function Ue(t, e) {
      switch (t.rank) {
        case 1:
          return Ft.ab([t, e]);
        case 2:
          return Ft.bb([t, e], 0);
        case 3:
          return Ft.cb([t, e], 0);
        case 4:
          return Ft.db([t, e], 0);
        default:
          throw new Pt("concatAlongFirstAxis() received an unsupported " + `tensor rank: ${t.rank}`)
      }
    }

    function Ve(t, e) {
      if (Array.isArray(e) || (e = [e]), t.rank !== e.length) throw new Pt(`The length of input n (${e.length}) does not match ` + `the number of dimensions in input x (${t.rank})`);
      return Ft.Cd(t, e)
    }

    function He(t, e = 0, n = 1, r, s) {
      return Ft.Cc(t, e, n, r, s)
    }

    function Ge(t, e, n, r) {
      if (t.rank < 2 || e.rank < 2) throw new Wt("dot requires both inputs to be rank >= 2" + ` but got x shape = ${t.shape} and y shape = ${e.shape}`);
      if (e.rank >= 3) {
        if (t.shape.slice(-1)[0] !== e.shape.slice(-2)[0]) throw new Wt("If rank y >= 3, then the second last dim" + ` of y must equal the last dim of x but got x shape = ${t.shape} and ` + ` y shape = ${e.shape}`)
      }
      if (2 === t.rank && 2 === e.rank) {
        const s = !1,
          i = !1;
        return Ft.Gb.matMul({
          a: t,
          b: e,
          transposeA: s,
          transposeB: i,
          bias: r ? Je(t.rank, r, "channelsLast") : null,
          activation: n
        })
      } {
        const s = t.shape.slice(),
          i = s.pop();
        t = t.reshape([-1, i]);
        const a = e.shape.slice(),
          o = a.pop(),
          u = a.pop(),
          c = [...a, o],
          l = Array.from({
            length: e.rank
          }, (t, n) => 0 === n ? e.rank - 2 : n <= e.rank - 2 ? n - 1 : n);
        e = e.transpose(l).reshape([u, -1]);
        const h = [...s, ...c],
          d = !1,
          p = !1;
        return Ft.Gb.matMul({
          a: t,
          b: e,
          transposeA: d,
          transposeB: p,
          bias: r ? Je(t.rank, r, "channelsLast") : null,
          activation: n
        }).reshape(h)
      }
    }

    function qe(t, e, n) {
      return Object(Ft.Bd)(() => (e = Array.isArray(e) ? Object(Ft.xd)(e, "int32") : e.toInt(), Ft.Hb(t, e, n)))
    }

    function Ke(t) {
      return Ft.qc(t, t)
    }

    function Je(t, e, n) {
      const r = e.shape;
      if (1 !== e.rank && e.rank !== t) throw new Pt(`Unexpected bias dimensions: ${e.rank}` + `; expected it to be 1 or ${t}`);
      if (5 === t) {
        if ("channelsFirst" === n) return 1 === r.length ? e.reshape([1, r[0], 1, 1, 1]) : e.reshape([1, r[3], r[0], r[1], r[2]]);
        if ("channelsLast" === n) return 1 === r.length ? e.reshape([1, 1, 1, 1, r[0]]) : e.reshape([1].concat(r))
      } else if (4 === t) {
        if ("channelsFirst" === n) return 1 === r.length ? e.reshape([1, r[0], 1, 1]) : e.reshape([1, r[2], r[0], r[1]]);
        if ("channelsLast" === n) return 1 === r.length ? e.reshape([1, 1, 1, r[0]]) : e.reshape([1].concat(r))
      } else if (3 === t) {
        if ("channelsFirst" === n) return 1 === r.length ? e.reshape([1, r[0], 1]) : e.reshape([1, r[1], r[0]]);
        if ("channelsLast" === n) return 1 === r.length ? e.reshape([1, 1, r[0]]) : e.reshape([1].concat(r))
      } else if (t < 3) return e;
      throw new Pt(`Unsupported input rank by biasAdd: ${e.rank}`)
    }

    function Xe(t, e, n) {
      return Object(Ft.Bd)(() => (null == n && (n = "channelsLast"), Oe(n), t.add(Je(t.rank, e, n))))
    }

    function Ye(t, e, n, r) {
      return Object(Ft.Bd)(() => Ft.sb(t, e, n, r))
    }

    function Ze(t, e, n = !1) {
      return n ? t() : e()
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    const Qe = ["fanIn", "fanOut", "fanAvg"],
      tn = ["normal", "uniform", "truncatedNormal"];
    class en extends Ft.Tc.Serializable {
      fromConfigUsesCustomObjects() {
        return !1
      }
      getConfig() {
        return {}
      }
    }
    class nn extends en {
      apply(t, e) {
        return Object(Ft.Pd)(t, e)
      }
    }
    nn.className = "Zeros", Ft.Tc.registerClass(nn);
    class rn extends en {
      apply(t, e) {
        return Object(Ft.wc)(t, e)
      }
    }
    rn.className = "Ones", Ft.Tc.registerClass(rn);
    class sn extends en {
      constructor(t) {
        if (super(), "object" != typeof t) throw new Pt(`Expected argument of type ConstantConfig but got ${t}`);
        if (void 0 === t.value) throw new Pt(`config must have value set but got ${t}`);
        this.value = t.value
      }
      apply(t, e) {
        return Object(Ft.Bd)(() => Object(Ft.qc)(Object(Ft.Pc)(this.value), Object(Ft.wc)(t, e)))
      }
      getConfig() {
        return {
          value: this.value
        }
      }
    }
    sn.className = "Constant", Ft.Tc.registerClass(sn);
    class an extends en {
      constructor(t) {
        super(), this.DEFAULT_MINVAL = -.05, this.DEFAULT_MAXVAL = .05, this.minval = t.minval || this.DEFAULT_MINVAL, this.maxval = t.maxval || this.DEFAULT_MAXVAL, this.seed = t.seed
      }
      apply(t, e) {
        return Object(Ft.Dc)(t, this.minval, this.maxval, e)
      }
      getConfig() {
        return {
          minval: this.minval,
          maxval: this.maxval,
          seed: this.seed
        }
      }
    }
    an.className = "RandomUniform", Ft.Tc.registerClass(an);
    class on extends en {
      constructor(t) {
        super(), this.DEFAULT_MEAN = 0, this.DEFAULT_STDDEV = .05, this.mean = t.mean || this.DEFAULT_MEAN, this.stddev = t.stddev || this.DEFAULT_STDDEV, this.seed = t.seed
      }
      apply(t, e) {
        if ("float32" !== (e = e || "float32") && "int32" !== e) throw new Wt(`randomNormal does not support dType ${e}.`);
        return He(t, this.mean, this.stddev, e, this.seed)
      }
      getConfig() {
        return {
          mean: this.mean,
          stddev: this.stddev,
          seed: this.seed
        }
      }
    }
    on.className = "RandomNormal", Ft.Tc.registerClass(on);
    class un extends en {
      constructor(t) {
        super(), this.DEFAULT_MEAN = 0, this.DEFAULT_STDDEV = .05, this.mean = t.mean || this.DEFAULT_MEAN, this.stddev = t.stddev || this.DEFAULT_STDDEV, this.seed = t.seed
      }
      apply(t, e) {
        if ("float32" !== (e = e || "float32") && "int32" !== e) throw new Wt(`truncatedNormal does not support dType ${e}.`);
        return Object(Ft.Gd)(t, this.mean, this.stddev, e, this.seed)
      }
      getConfig() {
        return {
          mean: this.mean,
          stddev: this.stddev,
          seed: this.seed
        }
      }
    }
    un.className = "TruncatedNormal", Ft.Tc.registerClass(un);
    class cn extends en {
      constructor(t) {
        super(), this.gain = null != t.gain ? t.gain : 1
      }
      apply(t, e) {
        return Object(Ft.Bd)(() => {
          if (2 !== t.length || t[0] !== t[1]) throw new Pt("Identity matrix initializer can only be used for 2D square matrices.");
          return Object(Ft.qc)(this.gain, Object(Ft.Bb)(t[0]))
        })
      }
      getConfig() {
        return {
          gain: this.gain
        }
      }
    }
    cn.className = "Identity", Ft.Tc.registerClass(cn);
    class ln extends en {
      constructor(t) {
        if (super(), t.scale < 0) throw new Pt(`scale must be a positive float. Got: ${t.scale}`);
        /**
         * @license
         * Copyright 2018 Google LLC
         *
         * Use of this source code is governed by an MIT-style
         * license that can be found in the LICENSE file or at
         * https://opensource.org/licenses/MIT.
         * =============================================================================
         */
        var e;
        this.scale = null == t.scale ? 1 : t.scale, this.mode = null == t.mode ? "fanIn" : t.mode, e = this.mode, re(Qe, "FanMode", e), this.distribution = null == t.distribution ? "normal" : t.distribution,
          function (t) {
            re(tn, "Distribution", t)
          }(this.distribution), this.seed = t.seed
      }
      apply(t, e) {
        const n = function (t, e = "channelsLast") {
            let n, r;
            if (Oe(e), 2 === t.length) n = t[0], r = t[1];
            else if (-1 !== [3, 4, 5].indexOf(t.length)) {
              if ("channelsFirst" === e) {
                const e = $e(t, 2);
                n = t[1] * e, r = t[0] * e
              } else if ("channelsLast" === e) {
                const e = $e(t, 0, t.length - 2);
                n = t[t.length - 2] * e, r = t[t.length - 1] * e
              }
            } else {
              const e = $e(t);
              n = Math.sqrt(e), r = Math.sqrt(e)
            }
            return [n, r]
          }(t),
          r = n[0],
          s = n[1];
        let i = this.scale;
        if ("fanIn" === this.mode ? i /= Math.max(1, r) : "fanOut" === this.mode ? i /= Math.max(1, s) : i /= Math.max(1, (r + s) / 2), "normal" === this.distribution) {
          const n = Math.sqrt(i);
          if ("float32" !== (e = e || "float32") && "int32" !== e) throw new Wt(`${this.getClassName()} does not support dType ${e}.`);
          return Object(Ft.Gd)(t, 0, n, e, this.seed)
        } {
          const n = Math.sqrt(3 * i);
          return Object(Ft.Dc)(t, -n, n, e)
        }
      }
      getConfig() {
        return {
          scale: this.scale,
          mode: this.mode,
          distribution: this.distribution,
          seed: this.seed
        }
      }
    }
    ln.className = "VarianceScaling", Ft.Tc.registerClass(ln);
    class hn extends ln {
      constructor(t) {
        super({
          scale: 1,
          mode: "fanAvg",
          distribution: "uniform",
          seed: null == t ? null : t.seed
        })
      }
      getClassName() {
        return ln.className
      }
    }
    hn.className = "GlorotUniform", Ft.Tc.registerClass(hn);
    class dn extends ln {
      constructor(t) {
        super({
          scale: 1,
          mode: "fanAvg",
          distribution: "normal",
          seed: null == t ? null : t.seed
        })
      }
      getClassName() {
        return ln.className
      }
    }
    dn.className = "GlorotNormal", Ft.Tc.registerClass(dn);
    class pn extends ln {
      constructor(t) {
        super({
          scale: 2,
          mode: "fanIn",
          distribution: "normal",
          seed: null == t ? null : t.seed
        })
      }
      getClassName() {
        return ln.className
      }
    }
    pn.className = "HeNormal", Ft.Tc.registerClass(pn);
    class fn extends ln {
      constructor(t) {
        super({
          scale: 2,
          mode: "fanIn",
          distribution: "uniform",
          seed: null == t ? null : t.seed
        })
      }
      getClassName() {
        return ln.className
      }
    }
    fn.className = "HeUniform", Ft.Tc.registerClass(fn);
    class mn extends ln {
      constructor(t) {
        super({
          scale: 1,
          mode: "fanIn",
          distribution: "normal",
          seed: null == t ? null : t.seed
        })
      }
      getClassName() {
        return ln.className
      }
    }
    mn.className = "LeCunNormal", Ft.Tc.registerClass(mn);
    class gn extends ln {
      constructor(t) {
        super({
          scale: 1,
          mode: "fanIn",
          distribution: "uniform",
          seed: null == t ? null : t.seed
        })
      }
      getClassName() {
        return ln.className
      }
    }
    gn.className = "LeCunNormal", Ft.Tc.registerClass(gn);
    class bn extends en {
      constructor(t) {
        if (super(), this.DEFAULT_GAIN = 1, this.gain = null == t.gain ? this.DEFAULT_GAIN : t.gain, this.seed = t.seed, null != this.seed) throw new Wt("Random seed is not implemented for Orthogonal Initializer yet.")
      }
      apply(t, e) {
        return Object(Ft.Bd)(() => {
          if (2 !== t.length) throw new Wt("The Orthogonal Initializer does not support non-2D shapes yet.");
          t[0] * t[1] > 2e3 && console.warn("Orthogonal initializer is being called on a matrix with more " + `than 2000 (${t[0]*t[1]}) elements: ` + "Slowness may result.");
          const e = He(t[0] > t[1] ? [t[1], t[0]] : t, 0, 1, "float32");
          let n = Ft.Vb.gramSchmidt(e);
          return t[0] > t[1] && (n = n.transpose()), Object(Ft.qc)(this.gain, n)
        })
      }
      getConfig() {
        return {
          gain: this.gain,
          seed: this.seed
        }
      }
    }
    bn.className = "Orthogonal", Ft.Tc.registerClass(bn);
    const yn = {
      constant: "Constant",
      glorotNormal: "GlorotNormal",
      glorotUniform: "GlorotUniform",
      heNormal: "HeNormal",
      heUniform: "HeUniform",
      identity: "Identity",
      leCunNormal: "LeCunNormal",
      leCunUniform: "LeCunUniform",
      ones: "Ones",
      orthogonal: "Orthogonal",
      randomNormal: "RandomNormal",
      randomUniform: "RandomUniform",
      truncatedNormal: "TruncatedNormal",
      varianceScaling: "VarianceScaling",
      zeros: "Zeros"
    };

    function wn(t, e = {}) {
      return Qt(t, Ft.Tc.SerializationMap.getMap().classNameMap, e, "initializer")
    }

    function vn(t) {
      return Zt(t)
    }

    function xn(t) {
      if ("string" == typeof t) {
        const e = t in yn ? yn[t] : t;
        if ("GlorotNormal" === e) return new dn;
        if ("GlorotUniform" === e) return new hn;
        if ("HeNormal" === e) return new pn;
        if ("HeUniform" === e) return new fn;
        if ("LeCunNormal" === e) return new mn;
        if ("LeCunUniform" === e) return new gn; {
          const t = {};
          return t.className = e, t.config = {}, wn(t)
        }
      }
      return t instanceof en ? t : wn(t)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    let On = 0;

    function Sn() {
      return On++
    }
    const _n = {};

    function kn(t = "") {
      return t in _n || (_n[t] = 0), _n[t] += 1, t + _n[t].toString()
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Cn(t) {
      return Array.isArray(t) && Array.isArray(t[0])
    }

    function En(t) {
      return 0 === t.length ? [] : Array.isArray(t[0]) ? t : [t]
    }

    function In(t) {
      let e;
      if (Array.isArray(t)) {
        if (1 !== t.length) throw new Pt(`Expected Tensor length to be 1; got ${t.length}`);
        e = t[0]
      } else e = t;
      return e
    }

    function Tn(t) {
      if (Array.isArray(t) && Array.isArray(t[0])) {
        if (1 === t.length) return (t = t)[0];
        throw new Pt(`Expected exactly 1 Shape; got ${t.length}`)
      }
      return t
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function An(t) {
      let e = 0;
      for (const n of t) 0 === n.shape.length ? e += 1 : e += n.shape.reduce((t, e) => t * e);
      return e
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    const Nn = "Variable";
    class $n {
      constructor(t, e = "float32", n = Nn, r = !0, s = null) {
        this.dtype = null == e ? "float32" : e, this.shape = t.shape, this.id = Sn(), n = null == n ? Nn : n, this.originalName = Ie(n), this.name = Te(this.originalName), this.trainable_ = r, this.constraint = s, this.val = Ft.Kd(t, this.trainable_, this.name, this.dtype)
      }
      read() {
        return this.assertNotDisposed(), this.val
      }
      write(t) {
        return this.assertNotDisposed(),
          function (t, e) {
            if (t.shape.toString() !== e.shape.toString()) throw new Error("Shape mismatch: " + JSON.stringify(t.shape) + " vs. " + JSON.stringify(e.shape))
          }(this.val, t), this.val.id !== t.id && (this.val.assign(t), null != this.constraint && this.val.assign(this.constraint.apply(this.val))), this
      }
      dispose() {
        this.assertNotDisposed(), this.val.dispose()
      }
      assertNotDisposed() {
        if (this.val.isDisposed) throw new Error(`LayersVariable ${this.name} is already disposed.`)
      }
      get trainable() {
        return this.trainable_
      }
      set trainable(t) {
        this.trainable_ = t, this.val.trainable = t
      }
    }

    function Rn(t) {
      return t.map(t => t.read())
    }

    function jn(t) {
      t.forEach(t => {
        t[0].write(t[1])
      })
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class Dn {
      constructor(t) {
        this.dtype = t.dtype, this.shape = t.shape, null != t.shape ? this.ndim = t.shape.length : this.ndim = t.ndim, this.maxNDim = t.maxNDim, this.minNDim = t.minNDim, this.axes = t.axes || {}
      }
    }
    class Fn {
      constructor(t, e, n, r, s, i, a) {
        this.dtype = t, this.shape = e, this.sourceLayer = n, this.inputs = r, this.callArgs = s, this.outputTensorIndex = a, this.id = Sn(), null != i && (this.originalName = Ie(i), this.name = Te(this.originalName)), this.rank = e.length
      }
    }
    let Mn = 0;
    class zn {
      constructor(t, e) {
        this.callArgs = e, this.id = Mn++, this.outboundLayer = t.outboundLayer, this.inboundLayers = t.inboundLayers, this.nodeIndices = t.nodeIndices, this.tensorIndices = t.tensorIndices, this.inputTensors = t.inputTensors, this.outputTensors = t.outputTensors, this.inputMasks = t.inputMasks, this.outputMasks = t.outputMasks, this.inputShapes = t.inputShapes, this.outputShapes = t.outputShapes;
        for (const e of t.inboundLayers) null != e && e.outboundNodes.push(this);
        t.outboundLayer.inboundNodes.push(this)
      }
      getConfig() {
        const t = [];
        for (const e of this.inboundLayers) null != e ? t.push(e.name) : t.push(null);
        return {
          outboundLayer: this.outboundLayer ? this.outboundLayer.name : null,
          inboundLayers: t,
          nodeIndices: this.nodeIndices,
          tensorIndices: this.tensorIndices
        }
      }
    }
    let Ln = 0;
    class Bn extends Ft.Tc.Serializable {
      constructor(t = {}) {
        super(), this._callHook = null, this._addedWeightNames = [], this._stateful = !1, this.id = Ln++, this.activityRegularizer = null, this.inputSpec = null, this.supportsMasking = !1, this._trainableWeights = [], this._nonTrainableWeights = [], this._losses = [], this._updates = [], this._built = !1, this.inboundNodes = [], this.outboundNodes = [];
        let e = t.name;
        if (!e) {
          const t = this.getClassName();
          e = Jt(t) + "_" + kn(t)
        }
        if (this.name = e, this.trainable_ = null == t.trainable || t.trainable, null != t.inputShape || null != t.batchInputShape) {
          let e;
          if (null != t.batchInputShape) e = t.batchInputShape;
          else if (null != t.inputShape) {
            let n = null;
            null != t.batchSize && (n = t.batchSize), e = [n].concat(t.inputShape)
          }
          this.batchInputShape = e;
          let n = t.dtype;
          null == n && (n = t.inputDType), null == n && (n = "float32"), this.dtype = n
        }
        null != t.weights ? this.initialWeights = t.weights : this.initialWeights = null, this._refCount = null, this.fastWeightInitDuringBuild = !1
      }
      static nodeKey(t, e) {
        return t.name + "_ib-" + e.toString()
      }
      getNodeAtIndex(t, e) {
        if (0 === this.inboundNodes.length) throw new Bt("The layer has never been called " + `and thus has no defined ${e}.`);
        if (this.inboundNodes.length <= t) throw new Pt(`Asked to get ${e} at node ${t}, ` + `but the layer has only ${this.inboundNodes.length} inbound nodes.`);
        return this.inboundNodes[t]
      }
      getInputAt(t) {
        return qt(this.getNodeAtIndex(t, "input").inputTensors)
      }
      getOutputAt(t) {
        return qt(this.getNodeAtIndex(t, "output").outputTensors)
      }
      get input() {
        if (this.inboundNodes.length > 1) throw new Lt(`Layer ${this.name}` + ' has multiple inbound nodes, hence the notion of "layer input" is ill-defined. Use `getInputAt(nodeIndex)` instead.');
        if (0 === this.inboundNodes.length) throw new Lt(`Layer ${this.name}` + " is not connected, no input to return.");
        return qt(this.getNodeAtIndex(0, "input").inputTensors)
      }
      get output() {
        if (0 === this.inboundNodes.length) throw new Lt(`Layer ${this.name}` + " has no inbound nodes.");
        if (this.inboundNodes.length > 1) throw new Lt(`Layer ${this.name}` + ' has multiple inbound nodes, hence the notion of "layer output" is ill-defined. Use `getOutputAt(nodeIndex)` instead.');
        return qt(this.getNodeAtIndex(0, "output").outputTensors)
      }
      get losses() {
        return this._losses
      }
      calculateLosses() {
        return this.losses.map(t => t())
      }
      get updates() {
        return this._updates
      }
      get built() {
        return this._built
      }
      set built(t) {
        this._built = t
      }
      get trainable() {
        return this.trainable_
      }
      set trainable(t) {
        this._trainableWeights.forEach(e => e.trainable = t), this.trainable_ = t
      }
      get trainableWeights() {
        return this.trainable_ ? this._trainableWeights.filter(t => t.trainable) : []
      }
      set trainableWeights(t) {
        this._trainableWeights = t
      }
      get nonTrainableWeights() {
        return this.trainable ? this._trainableWeights.filter(t => !t.trainable).concat(this._nonTrainableWeights) : this._trainableWeights.concat(this._nonTrainableWeights)
      }
      set nonTrainableWeights(t) {
        this._nonTrainableWeights = t
      }
      get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights)
      }
      get stateful() {
        return this._stateful
      }
      resetStates() {
        if (!this.stateful) throw new Error("Cannot call the resetStates() method of a non-stateful Layer object.")
      }
      assertInputCompatibility(t) {
        if (t = Kt(t), null == this.inputSpec || 0 === this.inputSpec.length) return;
        const e = Kt(this.inputSpec);
        if (t.length !== e.length) throw new Pt(`Layer ${this.name} expects ${e.length} inputs, ` + `but it received ${t.length} input tensors. ` + `Input received: ${t}`);
        for (let n = 0; n < t.length; n++) {
          const r = t[n],
            s = e[n];
          if (null == s) continue;
          const i = r.rank;
          if (null != s.ndim && i !== s.ndim) throw new Pt(`Input ${n} is incompatible with layer ${this.name}: ` + `expected ndim=${s.ndim}, found ndim=${i}`);
          if (null != s.maxNDim && i > s.maxNDim) throw new Pt(`Input ${n} is incompatible with layer ${this.name}` + `: expected max_ndim=${s.maxNDim}, found ndim=${i}`);
          if (null != s.minNDim && i < s.minNDim) throw new Pt(`Input ${n} is incompatible with layer ${this.name}` + `: expected min_ndim=${s.minNDim}, found ndim=${i}.`);
          if (null != s.dtype && r.dtype !== s.dtype) throw new Pt(`Input ${n} is incompatible with layer ${this.name} ` + `: expected dtype=${s.dtype}, found dtype=${r.dtype}.`);
          if (s.axes) {
            const t = r.shape;
            for (const e in s.axes) {
              const r = Number(e),
                i = s.axes[e],
                a = r >= 0 ? t[r] : t[t.length + r];
              if (null != i && -1 === [i, null].indexOf(a)) throw new Pt(`Input ${n} is incompatible with layer ` + `${this.name}: expected axis ${r} of input shape to ` + `have value ${i} but got shape ${t}.`)
            }
          }
          if (null != s.shape)
            for (let t = 0; t < s.shape.length; ++t) {
              const e = s.shape[t],
                i = r.shape[t];
              if (null != e && null != i && e !== i) throw new Pt(`Input ${n} is incompatible with layer ` + `${this.name}: expected shape=${s.shape}, ` + `found shape=${r.shape}.`)
            }
        }
      }
      call(t, e) {
        return t
      }
      invokeCallHook(t, e) {
        null != this._callHook && this._callHook(t, e)
      }
      setCallHook(t) {
        this._callHook = t
      }
      clearCallHook() {
        this._callHook = null
      }
      apply(t, e) {
        e = e || {}, this.assertNotDisposed();
        const n = Kt(t);
        let r = !0;
        for (const t of n)
          if (!(t instanceof Fn)) {
            r = !1;
            break
          } let s = !0;
        for (const t of n)
          if (t instanceof Fn) {
            s = !1;
            break
          } if (r === s) throw new Pt("Arguments to apply() must be all SymbolicTensors or all Tensors");
        return Ee(this.name, () => {
          if (!this.built) {
            this.assertInputCompatibility(t);
            const e = [];
            for (const n of Kt(t)) e.push(n.shape);
            this.build(qt(e)), this.built = !0, this.initialWeights && this.setWeights(this.initialWeights), null === this._refCount && s && (this._refCount = 1)
          }
          if (this.assertInputCompatibility(t), s) {
            let r = this.call(t, e);
            const s = Kt(r),
              i = [];
            for (let t of s) - 1 !== n.indexOf(t) && (t = t.clone()), i.push(t);
            if (r = qt(i), null != this.activityRegularizer) throw new Wt("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
            return r
          } {
            const n = function (t) {
                t = Kt(t);
                const e = [];
                for (const n of t) e.push(n.shape);
                return qt(e)
              }(t),
              r = this.computeOutputShape(n);
            let s;
            const i = "float32";
            if (this.warnOnIncompatibleInputShape(Array.isArray(t) ? n[0] : n), s = null != r && r.length > 0 && Array.isArray(r[0]) ? r.map((n, r) => new Fn(i, n, this, Kt(t), e, this.name, r)) : new Fn(i, r, this, Kt(t), e, this.name), this.addInboundNode(t, s, null, null, n, r, e), this._refCount++, null != this.activityRegularizer) throw new Wt("Layer invocation in the presence of activity regularizer(s) is not supported yet.");
            return s
          }
        })
      }
      warnOnIncompatibleInputShape(t) {
        if (null != this.batchInputShape)
          if (t.length !== this.batchInputShape.length) console.warn("The rank of the input tensor provided (shape: " + `${JSON.stringify(t)}) does not match that of the ` + `batchInputShape (${JSON.stringify(this.batchInputShape)}) ` + `of the layer ${this.name}`);
          else {
            let e = !1;
            this.batchInputShape.forEach((n, r) => {
              null != n && null != t[r] && t[r] !== n && (e = !0)
            }), e && console.warn("The shape of the input tensor " + `(${JSON.stringify(t)}) does not ` + `match the expectation of layer ${this.name}: ` + `${JSON.stringify(this.batchInputShape)}`)
          }
      }
      get outputShape() {
        if (null == this.inboundNodes || 0 === this.inboundNodes.length) throw new Lt(`The layer ${this.name} has never been called and thus has no ` + "defined output shape.");
        const t = [];
        for (const e of this.inboundNodes) {
          const n = JSON.stringify(e.outputShapes); - 1 === t.indexOf(n) && t.push(n)
        }
        if (1 === t.length) {
          const t = this.inboundNodes[0].outputShapes;
          return Array.isArray(t) && Array.isArray(t[0]) && 1 === t.length ? t[0] : t
        }
        throw new Lt(`The layer ${this.name} has multiple inbound nodes with different ` + 'output shapes. Hence the notion of "output shape" is ill-defined for the layer.')
      }
      countParams() {
        if (!this.built) throw new Bt(`You tried to call countParams() on ${this.name}, ` + "but the layer is not built yet. Build it first by calling build(batchInputShape).");
        return An(this.weights)
      }
      build(t) {
        this.built = !0
      }
      getWeights(t = !1) {
        return Rn(t ? this.trainableWeights : this.weights)
      }
      setWeights(t) {
        Object(Ft.Bd)(() => {
          const e = this.weights;
          if (e.length !== t.length) throw new Pt(`You called setWeights(weights) on layer "${this.name}" ` + `with a weight list of length ${t.length}, ` + `but the layer was expecting ${e.length} weights. ` + `Provided weights: ${t}...`);
          if (0 === e.length) return;
          const n = [],
            r = Rn(e);
          for (let s = 0; s < r.length; ++s) {
            const i = r[s],
              a = e[s],
              o = t[s];
            if (!Ft.Jd.arraysEqual(i.shape, o.shape)) throw new Pt(`Layer weight shape ${i.shape} ` + `not compatible with provided weight shape ${o.shape}`);
            n.push([a, o])
          }
          jn(n)
        })
      }
      addWeight(t, e, n, r, s, i, a) {
        if (-1 !== this._addedWeightNames.indexOf(t)) throw new Pt(`Duplicate weight name ${t} for layer ${this.name}`);
        this._addedWeightNames.push(t), null == n && (n = "float32"), this.fastWeightInitDuringBuild && (r = xn("zeros"));
        const o = r.apply(e, n),
          u = new $n(o, n, t, i, a);
        return o.dispose(), null != s && this.addLoss(() => s.apply(u.read())), null == i && (i = !0), i ? this._trainableWeights.push(u) : this._nonTrainableWeights.push(u), u
      }
      setFastWeightInitDuringBuild(t) {
        this.fastWeightInitDuringBuild = t
      }
      addLoss(t) {
        null == t || Array.isArray(t) && 0 === t.length || (t = Kt(t), void 0 !== this._losses && null !== this._losses && this.losses.push(...t))
      }
      computeOutputShape(t) {
        return t
      }
      computeMask(t, e) {
        if (!this.supportsMasking) {
          if (null != e) {
            if (!Array.isArray(e)) throw new TypeError(`Layer ${this.name} does not support masking, ` + "but was passed an inputMask.");
            e.forEach(t => {
              if (null != t) throw new TypeError(`Layer ${this.name} does not support masking, ` + "but was passed an inputMask.")
            })
          }
          return null
        }
        return e
      }
      addInboundNode(t, e, n, r, s, i, a = null) {
        const o = Kt(t);
        e = Kt(e), n = Kt(n), r = Kt(r), s = En(s), i = En(i);
        const u = [],
          c = [],
          l = [];
        for (const t of o) u.push(t.sourceLayer), c.push(t.nodeIndex), l.push(t.tensorIndex);
        new zn({
          outboundLayer: this,
          inboundLayers: u,
          nodeIndices: c,
          tensorIndices: l,
          inputTensors: o,
          outputTensors: e,
          inputMasks: n,
          outputMasks: r,
          inputShapes: s,
          outputShapes: i
        }, a);
        for (let t = 0; t < e.length; t++) e[t].sourceLayer = this, e[t].nodeIndex = this.inboundNodes.length - 1, e[t].tensorIndex = t
      }
      getConfig() {
        const t = {
          name: this.name,
          trainable: this.trainable
        };
        return null != this.batchInputShape && (t.batchInputShape = this.batchInputShape), null != this.dtype && (t.dtype = this.dtype), t
      }
      disposeWeights() {
        return this.weights.forEach(t => t.dispose()), this.weights.length
      }
      assertNotDisposed() {
        if (0 === this._refCount) throw new Error(`Layer '${this.name}' is already disposed.`)
      }
      dispose() {
        if (!this.built) throw new Error(`Cannot dispose Layer ${this.name} because it has not been ` + "built yet.");
        if (null === this._refCount) throw new Error(`Cannot dispose Layer ${this.name} because it has not been used ` + "yet.");
        this.assertNotDisposed();
        let t = 0;
        return 0 == --this._refCount && (t = this.disposeWeights()), {
          refCountAfterDispose: this._refCount,
          numDisposedVariables: t
        }
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class Pn extends Bn {
      constructor(t) {
        if (super({
            dtype: t.dtype,
            name: null != t.name ? t.name : kn("input").toString()
          }), null == t.batchSize && (t.batchSize = null), null == t.sparse && (t.sparse = !1), this.trainable = !1, this.built = !0, this.sparse = t.sparse, null != t.inputShape && null != t.batchInputShape) throw new Pt("Only provide the inputShape OR batchInputShape argument to inputLayer, not both at the same time.");
        let e = t.batchInputShape;
        if (null == e) {
          if (null == t.inputShape) throw new Pt("An InputLayer should be passed either a `batchInputShape` or an `inputShape`.");
          e = [t.batchSize].concat(t.inputShape)
        } else if (null != t.batchSize) throw new Pt("Cannot specify batchSize if batchInputShape is specified when creating an InputLayer.");
        const n = t.dtype || "float32";
        this.batchInputShape = e, this.dtype = n, this.inputSpec = [{
          shape: e
        }];
        const r = new Fn(this.dtype, this.batchInputShape, this, [], {}, this.name);
        r.nodeIndex = 0, r.tensorIndex = 0, new zn({
          outboundLayer: this,
          inboundLayers: [],
          nodeIndices: [],
          tensorIndices: [],
          inputTensors: [r],
          outputTensors: [r],
          inputMasks: [null],
          outputMasks: [null],
          inputShapes: [e],
          outputShapes: [e]
        })
      }
      apply(t, e) {
        throw new Pt("Cannot pass any input to an " + `InputLayer's apply() method. InputLayer name: ${this.name}`)
      }
      dispose() {
        return {
          refCountAfterDispose: this._refCount,
          numDisposedVariables: 0
        }
      }
      getConfig() {
        return {
          batchInputShape: this.batchInputShape,
          dtype: this.dtype,
          sparse: this.sparse,
          name: this.name
        }
      }
    }

    function Wn(t) {
      if (null == t.batchShape && null == t.shape) throw new Error("Please provide to Input either a `shape` or a `batchShape` argument. Note that `shape` does not include the batch dimension.");
      if (null != t.batchShape && null != t.shape) throw new Pt("Please provide either a `shape` or `batchShape` argument to Input, but not both.");
      let e = t.batchShape;
      null != t.shape && null == e && (e = [null].concat(t.shape));
      let n = t.dtype;
      return null == n && (n = "float32"), new Pn({
        batchInputShape: e,
        name: t.name,
        dtype: n,
        sparse: t.sparse
      }).inboundNodes[0].outputTensors[0]
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    async function Un(t) {
      if (null == t) return;
      const e = [],
        n = [],
        r = [];
      for (const s in t) {
        const i = t[s];
        if ("number" != typeof i) {
          const t = i;
          e.push(t.data()), n.push(s), r.push(t)
        }
      }
      if (e.length > 0) {
        const s = await Promise.all(e);
        for (let e = 0; e < s.length; ++e) t[n[e]] = s[e][0];
        Object(Ft.pb)(r)
      }
    }

    function Vn(t) {
      if (null != t)
        for (const e in t) {
          const n = t[e];
          "number" != typeof n && n.dispose()
        }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    var Hn;
    Pn.className = "InputLayer", Ft.Tc.registerClass(Pn),
      function (t) {
        t[t.SILENT = 0] = "SILENT", t[t.VERBOSE = 1] = "VERBOSE"
      }(Hn || (Hn = {}));
    const Gn = 125;
    class qn {
      constructor() {
        this.validationData = null
      }
      setParams(t) {
        this.params = t
      }
      async onEpochBegin(t, e) {}
      async onEpochEnd(t, e) {}
      async onBatchBegin(t, e) {}
      async onBatchEnd(t, e) {}
      async onTrainBegin(t) {}
      async onTrainEnd(t) {}
      setModel(t) {}
    }
    class Kn {
      constructor(t, e = 10) {
        null == t && (t = []), this.callbacks = t, this.queueLength = e
      }
      append(t) {
        this.callbacks.push(t)
      }
      setParams(t) {
        for (const e of this.callbacks) e.setParams(t)
      }
      setModel(t) {
        for (const e of this.callbacks) e.setModel(t)
      }
      async onEpochBegin(t, e) {
        null == e && (e = {});
        for (const n of this.callbacks) await n.onEpochBegin(t, e)
      }
      async onEpochEnd(t, e) {
        null == e && (e = {});
        for (const n of this.callbacks) await n.onEpochEnd(t, e)
      }
      async onBatchBegin(t, e) {
        null == e && (e = {});
        for (const n of this.callbacks) await n.onBatchBegin(t, e)
      }
      async onBatchEnd(t, e) {
        null == e && (e = {});
        for (const n of this.callbacks) await n.onBatchEnd(t, e)
      }
      async onTrainBegin(t) {
        null == t && (t = {});
        for (const e of this.callbacks) await e.onTrainBegin(t)
      }
      async onTrainEnd(t) {
        null == t && (t = {});
        for (const e of this.callbacks) await e.onTrainEnd(t)
      }
    }
    class Jn extends qn {
      constructor() {
        super()
      }
      async onEpochBegin(t) {
        this.seen = 0, this.totals = {}
      }
      async onBatchEnd(t, e) {
        null == e && (e = {});
        const n = null == e.size ? 0 : e.size;
        this.seen += n;
        for (const t in e) {
          const r = e[t];
          if ("number" == typeof r) this.totals.hasOwnProperty(t) || (this.totals[t] = 0), this.totals[t] = this.totals[t] + r * n;
          else {
            let e;
            t in this.totals ? e = this.totals[t] : this.totals[t] = 0;
            const s = Object(Ft.Bd)(() => Object(Ft.x)(this.totals[t], Object(Ft.qc)(r, n)));
            this.totals[t] = s, null != e && e.dispose()
          }
        }
      }
      async onEpochEnd(t, e) {
        if (null != e)
          for (const t of this.params.metrics) null != this.totals[t] && ("number" == typeof this.totals[t] ? e[t] = this.totals[t] / this.seen : Object(Ft.Bd)(() => {
            const n = Object(Ft.qc)(Object(Ft.qb)(1, this.seen), this.totals[t]);
            e[t] = n, this.totals[t].dispose(), Object(Ft.Qb)(e[t])
          }))
      }
    }
    class Xn extends qn {
      async onTrainBegin(t) {
        this.epoch = [], this.history = {}
      }
      async onEpochEnd(t, e) {
        null == e && (e = {}), this.epoch.push(t);
        for (const t in e) null == this.history[t] && (this.history[t] = []), this.history[t].push(e[t])
      }
      async syncData() {
        const t = [],
          e = [],
          n = [];
        for (const r in this.history) {
          const s = this.history[r];
          for (let i = 0; i < s.length; ++i)
            if ("number" != typeof s[i]) {
              const a = s[i];
              t.push(a.data()), e.push(r), n.push(i)
            }
        }
        const r = await Promise.all(t);
        for (let t = 0; t < r.length; ++t) {
          this.history[e[t]][n[t]].dispose(), this.history[e[t]][n[t]] = r[t][0]
        }
      }
    }
    class Yn extends qn {
      constructor(t, e) {
        if (super(), this.currentEpoch = 0, this.yieldEvery = e || "auto", "auto" === this.yieldEvery && (this.yieldEvery = Gn), "never" === this.yieldEvery && null != t.onYield) throw new Error("yieldEvery is `never` but you provided an `onYield` callback. Either change `yieldEvery` or remove the callback");
        Ft.Jd.isNumber(this.yieldEvery) && (this.maybeWait = function (t, e) {
          let n, r = Ft.Jd.now();
          return (...s) => {
            const i = Ft.Jd.now();
            return i - r < e ? n : (r = i, n = t(...s), n)
          }
        }(this.maybeWait.bind(this), this.yieldEvery)), this.trainBegin = t.onTrainBegin, this.trainEnd = t.onTrainEnd, this.epochBegin = t.onEpochBegin, this.epochEnd = t.onEpochEnd, this.batchBegin = t.onBatchBegin, this.batchEnd = t.onBatchEnd, this.yield = t.onYield
      }
      async maybeWait(t, e, n) {
        const r = [];
        null != this.yield && (await Un(n), r.push(this.yield(t, e, n))), r.push(Object(Ft.tc)()), await Promise.all(r)
      }
      async onEpochBegin(t, e) {
        this.currentEpoch = t, null != this.epochBegin && (await Un(e), await this.epochBegin(t, e))
      }
      async onEpochEnd(t, e) {
        const n = [];
        null != this.epochEnd && (await Un(e), n.push(this.epochEnd(t, e))), "epoch" === this.yieldEvery && n.push(Object(Ft.tc)()), await Promise.all(n)
      }
      async onBatchBegin(t, e) {
        null != this.batchBegin && (await Un(e), await this.batchBegin(t, e))
      }
      async onBatchEnd(t, e) {
        const n = [];
        null != this.batchEnd && (await Un(e), n.push(this.batchEnd(t, e))), "batch" === this.yieldEvery ? n.push(Object(Ft.tc)()) : Ft.Jd.isNumber(this.yieldEvery) && n.push(this.maybeWait(this.currentEpoch, t, e)), await Promise.all(n)
      }
      async onTrainBegin(t) {
        null != this.trainBegin && (await Un(t), await this.trainBegin(t))
      }
      async onTrainEnd(t) {
        null != this.trainEnd && (await Un(t), await this.trainEnd(t))
      }
    }

    function Zn(t, e) {
      if (null == t && (t = {}), t instanceof qn) return [t];
      if (Array.isArray(t) && t[0] instanceof qn) return t;
      return Kt(t).map(t => new Yn(t, e))
    }
    class Qn {
      constructor() {}
      static registerCallbackConstructor(t, e) {
        Ft.Jd.assert(t >= 0 && Number.isInteger(t), () => "Verbosity level is expected to be an integer >= 0, " + `but got ${t}`), Qn.checkForDuplicate(e), null == Qn.constructors[t] && (Qn.constructors[t] = []), Qn.constructors[t].push(e)
      }
      static checkForDuplicate(t) {
        for (const e in Qn.constructors) {
          Qn.constructors[+e].forEach(e => {
            if (e === t) throw new Pt("Duplicate callback constructor.")
          })
        }
      }
      static clear() {
        Qn.constructors = {}
      }
      static createCallbacks(t) {
        const e = [];
        for (const n in Qn.constructors) {
          const r = +n;
          t >= r && e.push(...Qn.constructors[r])
        }
        return e.map(t => new t)
      }
    }

    function tr(t, e, n, r, s, i, a, o, u) {
      const c = new Xn,
        l = [new Jn, ...Qn.createCallbacks(e)];
      null != t && l.push(...t), l.push(c);
      const h = new Kn(l);
      return h.setParams({
        epochs: n,
        initialEpoch: r,
        samples: s,
        steps: i,
        batchSize: a,
        verbose: e,
        doValidation: o,
        metrics: u
      }), {
        callbackList: h,
        history: c
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function er(t, e = {}, n = !1) {
      return Qt(t, Ft.Tc.SerializationMap.getMap().classNameMap, e, "layer", n)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function nr(t, e) {
      return Object(Ft.Bd)(() => {
        "float32" !== t.dtype && (t = t.asType("float32"));
        const n = Ft.sd(Ke(t), e, !0),
          r = Ft.Db(n.shape, zt()),
          s = Ft.ld(Ft.jc(n, r));
        return Ft.qb(t, s)
      })
    }

    function rr(t, e) {
      return Object(Ft.Bd)(() => Ft.kc(Ke(Ft.rd(e, t)), -1))
    }

    function sr(t, e) {
      return Object(Ft.Bd)(() => Ft.kc(Ft.u(Ft.rd(e, t)), -1))
    }

    function ir(t, e) {
      return Object(Ft.Bd)(() => {
        const n = Ft.rd(t, e),
          r = Ft.W(Ft.u(t), zt(), Number.MAX_VALUE),
          s = Ft.u(Ft.qb(n, r));
        return Ft.qc(100, Ft.kc(s, -1))
      })
    }

    function ar(t, e) {
      return Object(Ft.Bd)(() => {
        const n = Ft.W(e, zt(), Number.MAX_VALUE),
          r = Ft.Yb(Ft.x(1, n)),
          s = Ft.W(t, zt(), Number.MAX_VALUE),
          i = Ft.Yb(Ft.x(1, s));
        return Ft.kc(Ke(Ft.rd(r, i)), -1)
      })
    }

    function or(t, e, n = !1) {
      return Object(Ft.Bd)(() => {
        if (n) e = Ft.gd(e);
        else {
          const t = Ft.sd(e, e.shape.length - 1, !0);
          e = Ft.qb(e, t)
        }
        return e = Ft.W(e, zt(), 1 - zt()), Ft.sc(Ft.sd(Ft.qc(t.toFloat(), Ft.Yb(e)), e.shape.length - 1))
      })
    }

    function ur(t, e, n = !1) {
      return Object(Ft.Bd)(() => {
        const r = Ft.Eb(function (t) {
            const e = [$e(t.shape)];
            return t.reshape(e)
          }(t)).toInt(),
          s = (e = Ft.W(e, zt(), 1 - zt())).shape;
        return or(Ft.vc(r, s[s.length - 1]).reshape(s), e, n)
      })
    }

    function cr(t, e) {
      return Object(Ft.Bd)(() => {
        let n;
        return n = Ft.W(e, zt(), 1 - zt()), n = Ft.Yb(Ft.qb(n, Ft.rd(1, n))), Ft.kc(function (t, e) {
          if (!Ft.Jd.arraysEqual(t.shape, e.shape)) throw new Pt("logits and labels must have the same shape, but got shapes " + `${JSON.stringify(t.shape)} and ${JSON.stringify(e.shape)}`);
          return Object(Ft.Bd)(() => {
            const n = e.relu(),
              r = e.abs().neg();
            return n.sub(e.mul(t)).add(r.exp().log1p())
          })
        }(t, n), -1)
      })
    }

    function lr(t, e) {
      return Object(Ft.Bd)(() => {
        const n = Ft.W(t, zt(), 1),
          r = Ft.W(e, zt(), 1);
        return Ft.sd(Ft.qc(t, Ft.Yb(Ft.qb(n, r))), -1)
      })
    }

    function hr(t, e) {
      return Object(Ft.Bd)(() => {
        const n = nr(t, -1),
          r = nr(e, -1),
          s = Ft.qc(n, r);
        return Ft.sc(Ft.sd(s, -1))
      })
    }
    Qn.constructors = {};
    const dr = {
      meanSquaredError: rr,
      meanAbsoluteError: sr,
      meanAbsolutePercentageError: ir,
      meanSquaredLogarithmicError: ar,
      squaredHinge: function (t, e) {
        return Object(Ft.Bd)(() => {
          const n = Ft.jc(0, Ft.rd(1, Ft.qc(t, e)));
          return Ft.kc(Ke(n), -1)
        })
      },
      hinge: function (t, e) {
        return Object(Ft.Bd)(() => {
          const n = Ft.jc(0, Ft.rd(1, Ft.qc(t, e)));
          return Ft.kc(n, -1)
        })
      },
      categoricalHinge: function (t, e) {
        return Object(Ft.Bd)(() => {
          const n = Ft.sd(Ft.qc(t, e), -1),
            r = Ft.fc(Ft.qc(Ft.rd(1, t), e), -1);
          return Ft.jc(0, Ft.x(1, Ft.rd(r, n)))
        })
      },
      logcosh: function (t, e) {
        return Object(Ft.Bd)(() => {
          const n = Math.log(2),
            r = Ft.rd(e, t),
            s = Ft.rd(Ft.x(r, Ft.hd(Ft.qc(-2, r))), n);
          return Ft.kc(s, -1)
        })
      },
      categoricalCrossentropy: or,
      sparseCategoricalCrossentropy: ur,
      binaryCrossentropy: cr,
      kullbackLeiblerDivergence: lr,
      poisson: function (t, e) {
        return Object(Ft.Bd)(() => {
          const n = Ft.Yb(Ft.x(zt(), e));
          return Ft.kc(Ft.rd(e, Ft.qc(t, n)), -1)
        })
      },
      cosineProximity: hr
    };

    function pr(t) {
      if ("string" == typeof t) {
        if (t in dr) return dr[t];
        let e = `Unknown loss ${t}`;
        throw t.toLowerCase().includes("softmaxcrossentropy") && (e = `Unknown loss ${t}. ` + 'Use "categoricalCrossentropy" as the string name for tf.losses.softmaxCrossEntropy'), new Pt(e)
      }
      return t
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function fr(t, e) {
      return Object(Ft.Bd)(() => {
        const n = Ft.qc(.5, Ft.xc(e)),
          r = Me(Ft.Jb(e, n), t.dtype);
        return Ft.kc(Ft.wb(t, r), -1)
      })
    }

    function mr(t, e) {
      return Object(Ft.Bd)(() => Me(Ft.wb(Ft.B(t, -1), Ft.B(e, -1)), "float32"))
    }

    function gr(t, e) {
      return Object(Ft.Bd)(() => Ft.bc(t.equal(1), e.equal(1)).sum().cast("float32"))
    }

    function br(t, e) {
      return Object(Ft.Bd)(() => {
        const n = gr(t, e),
          r = function (t, e) {
            return Object(Ft.Bd)(() => Ft.bc(t.equal(0), e.equal(1)).sum().cast("float32"))
          }(t, e),
          s = n.add(r);
        return Ft.Nd(Ft.Jb(s, 0), n.div(s), 0).cast("float32")
      })
    }

    function yr(t, e) {
      return cr(t, e)
    }

    function wr(t, e) {
      return t.rank === e.rank && (t = t.squeeze([t.rank - 1])), (e = e.argMax(-1)).dtype !== t.dtype && (e = e.asType(t.dtype)), Ft.wb(t, e).asType("float32")
    }
    const vr = or,
      xr = ur,
      Or = {
        binaryAccuracy: fr,
        categoricalAccuracy: mr,
        precision: br,
        categoricalCrossentropy: vr,
        sparseCategoricalCrossentropy: xr,
        mse: rr,
        MSE: rr,
        mae: sr,
        MAE: sr,
        mape: ir,
        MAPE: ir,
        cosine: hr
      };

    function Sr(t) {
      if ("string" == typeof t && t in Or) return Or[t];
      if ("string" != typeof t && null != t) return t;
      throw new Pt(`Unknown metric ${t}`)
    }

    function _r(t) {
      if (Ht(null !== t, `Unknown LossOrMetricFn ${t}`), "string" == typeof t) return t; {
        let e;
        for (const n of Object.keys(dr))
          if (dr[n] === t) {
            e = n;
            break
          } if (void 0 !== e) return e;
        for (const n of Object.keys(Or))
          if (Or[n] === t) {
            e = n;
            break
          } return void 0 !== e ? e : t.name
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2019 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    const kr = 1048576;

    function Cr(t, e, n = !1) {
      if (null == t || "object" != typeof t || Object.getPrototypeOf(t) !== Object.prototype || ! function t(e) {
          if (null === e) return !0;
          if ("object" == typeof e) {
            if (Object.getPrototypeOf(e) === Object.prototype) {
              const n = Object.keys(e);
              for (const r of n) {
                if ("string" != typeof r) return !1;
                if (!t(e[r])) return !1
              }
              return !0
            }
            if (Array.isArray(e)) {
              for (const n of e)
                if (!t(n)) return !1;
              return !0
            }
            return !1
          } {
            const t = typeof e;
            return "string" === t || "number" === t || "boolean" === t
          }
        }
        /**
         * @license
         * Copyright 2018 Google LLC
         *
         * Use of this source code is governed by an MIT-style
         * license that can be found in the LICENSE file or at
         * https://opensource.org/licenses/MIT.
         * =============================================================================
         */
        (t)) throw new Error("User-defined metadata is expected to be a JSON object, but is not.");
      if (n) {
        const n = JSON.stringify(t);
        n.length > kr && console.warn(`User-defined metadata of model "${e}" is too large in ` + `size (length=${n.length} when serialized). It is not ` + "recommended to store such large objects in user-defined metadata. Please make sure its serialized length is <= " + `${kr}.`)
      }
    }

    function Er(t, e, n, r = console.log) {
      const s = function (t) {
          let e = !0;
          const n = [],
            r = [];
          for (const e in t.nodesByDepth) n.push(t.nodesByDepth[e]);
          for (const t of n) {
            if (t.length > 1 || 1 === t.length && t[0].inboundLayers.length > 1) {
              e = !1;
              break
            }
            r.push(...t)
          }
          if (e)
            for (const n of t.layers) {
              let t = !1;
              for (const s of n.inboundNodes)
                if (-1 !== r.indexOf(s)) {
                  if (t) {
                    e = !1;
                    break
                  }
                  t = !0
                } if (!e) break
            }
          return e
        }(t),
        i = ["Layer (type)", "Output shape", "Param #"];
      let a;
      if (s ? (e = e || 65, n = n || [.45, .85, 1]) : (e = e || 98, n = n || [.33, .55, .67, 1]), n[n.length - 1] <= 1 && (n = n.map(t => Math.floor(e * t))), !s) {
        i.push("Receives inputs"), a = [];
        for (const e in t.nodesByDepth) a.push(...t.nodesByDepth[e])
      }
      r("_".repeat(e)), Ir(i, n, r), r("=".repeat(e));
      const o = t.layers;
      for (let t = 0; t < o.length; ++t) s ? Tr(o[t], n, r) : Ar(o[t], n, a, r), r((t === o.length - 1 ? "=" : "_").repeat(e));
      t.checkTrainableWeightsConsistency();
      const u = function (t) {
          let e;
          e = null != t.collectedTrainableWeights ? An(t.collectedTrainableWeights) : An(t.trainableWeights);
          return e
        }(t),
        c = An(t.nonTrainableWeights);
      r(`Total params: ${u+c}`), r(`Trainable params: ${u}`), r(`Non-trainable params: ${c}`), r("_".repeat(e))
    }

    function Ir(t, e, n = console.log) {
      let r = "";
      for (let n = 0; n < t.length; ++n) n > 0 && (r = r.slice(0, r.length - 1) + " "), r += t[n], r = r.slice(0, e[n]), r += " ".repeat(e[n] - r.length);
      n(r)
    }

    function Tr(t, e, n) {
      let r;
      try {
        r = JSON.stringify(t.outputShape)
      } catch (t) {
        r = "multiple"
      }
      Ir([`${t.name} (${t.getClassName()})`, r, t.countParams().toString()], e, n)
    }

    function Ar(t, e, n, r) {
      let s;
      try {
        s = JSON.stringify(t.outputShape)
      } catch (t) {
        s = "multiple"
      }
      const i = [];
      for (const e of t.inboundNodes)
        if (!(null != n && n.length > 0 && -1 === n.indexOf(e)))
          for (let t = 0; t < e.inboundLayers.length; ++t) {
            const n = e.inboundLayers[t].name,
              r = e.nodeIndices[t],
              s = e.tensorIndices[t];
            i.push(`${n}[${r}][${s}]`)
          }
      const a = t.name,
        o = t.getClassName(),
        u = 0 === i.length ? "" : i[0];
      Ir([`${a} (${o})`, s, t.countParams().toString(), u], e, r);
      for (let t = 1; t < i.length; ++t) Ir(["", "", "", i[t]], e, r)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Nr(t, e, n) {
      return ("inboundNodes" === t || "outputLayers" === t || "inputLayers" === t) && 0 === e && "string" == typeof n
    }

    function $r(t, e) {
      if (null === t) return null;
      if ("string" == typeof t) return Xt(t);
      if ("number" == typeof t || "boolean" == typeof t) return t;
      if (t instanceof Array) {
        const n = [],
          r = t.length;
        for (let s = 0; s < r; ++s) {
          const r = t[s];
          Nr(e, s, r) ? n.push(r) : n.push($r(r, e))
        }
        return n
      } {
        const e = {};
        for (const n of Object.keys(t)) {
          const r = t[n];
          if ("name" === n && "string" == typeof r) e[n] = r;
          else {
            const t = Xt(n);
            e[t] = $r(r, t)
          }
        }
        return e
      }
    }
    /** @license See the LICENSE file. */
    const Rr = "2.3.0";
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class jr {
      constructor(t) {
        if (this.id2Value = {}, this.id2Mask = {}, this.name2Id = {}, t instanceof jr)
          for (const e in t.id2Value) this.id2Value[e] = t.id2Value[e], e in t.id2Mask && (this.id2Mask[e] = t.id2Mask[e]);
        else {
          if (null == t) return;
          for (const e of t) this.add(e.key, e.value)
        }
      }
      add(t, e, n) {
        if (null != this.id2Value[t.id]) throw new Pt(`Duplicate key: name=${t.name}, id=${t.id}`);
        return this.id2Value[t.id] = function (t, e) {
          if (null == t.dtype || t.dtype === e.dtype) return e;
          try {
            return Object(Ft.U)(e, t.dtype)
          } catch (n) {
            throw new Pt(`The dtype of the feed (${e.dtype}) can not be cast to the dtype ` + `of the key '${t.name}' (${t.dtype}).`)
          }
        }(t, e), this.name2Id[t.name] = t.id, null != n && (this.id2Mask[t.id] = n), this
      }
      addFeed(t) {
        this.add(t.key, t.value)
      }
      hasKey(t) {
        return null != this.id2Value[t.id]
      }
      names() {
        return Object.keys(this.name2Id)
      }
      getValue(t) {
        if (t instanceof Fn) {
          if (null == this.id2Value[t.id]) throw new Pt(`Nonexistent key: ${t.name}`);
          return this.id2Value[t.id]
        } {
          const e = this.name2Id[t];
          if (null == e) throw new Pt(`Feed dict has no SymbolicTensor name: ${t}`);
          return this.id2Value[e]
        }
      }
      getMask(t) {
        if (t instanceof Fn) {
          if (null == this.id2Value[t.id]) throw new Pt(`Nonexistent key: ${t.name}`);
          return this.id2Mask[t.id]
        } {
          const e = this.name2Id[t];
          if (null == e) throw new Pt(`Feed dict has no SymbolicTensor name: ${t}`);
          return this.id2Mask[e]
        }
      }
      disposeMasks() {
        null != this.id2Mask && Object(Ft.pb)(this.id2Mask)
      }
    }
    const Dr = {},
      Fr = {};

    function Mr(t, e, n, r) {
      const s = null != n && n.training,
        i = Array.isArray(t),
        a = i ? t : [t],
        o = a.map(t => t.name),
        u = [],
        c = e.names();
      for (const t of o) - 1 !== c.indexOf(t) ? u.push(e.getValue(t)) : u.push(null);
      null != r && (r.maxNumTensors = -1 / 0, r.minNumTensors = 1 / 0);
      const l = o.join(",") + "|" + e.names().join(",");
      let h, d;
      if (null == Dr[l]) {
        const t = function (t, e) {
          Ft.Jd.assert(null != t && t.length > 0, () => "Expected at least one fetch, got none");
          let n = [],
            r = {};
          if (1 === t.length) {
            const s = Lr(t[0], e);
            n = s.sorted, r = s.recipientMap
          } else {
            const s = new Set;
            for (const i of t) {
              const {
                sorted: t,
                recipientMap: a
              } = Lr(i, e);
              for (const e of t) s.has(e.name) || (n.push(e), s.add(e.name));
              for (const t in a) null == r[t] && (r[t] = new Set), a[t].forEach(e => r[t].add(e))
            }
          }
          return {
            sorted: n,
            recipientCounts: zr(r)
          }
        }(a, e);
        h = t.sorted, d = t.recipientCounts, Dr[l] = h, Fr[l] = d
      }
      h = Dr[l], d = {}, s || Object.assign(d, Fr[l]);
      const p = new jr(e);
      for (let t = 0; t < h.length; ++t) {
        if (null != r) {
          const t = Object(Ft.lc)().numTensors;
          t > r.maxNumTensors && (r.maxNumTensors = t), t < r.minNumTensors && (r.minNumTensors = t)
        }
        const i = h[t],
          a = i.sourceLayer;
        if (a instanceof Pn) continue;
        const c = [],
          l = [],
          f = [];
        let m = !1;
        for (const t of i.inputs) {
          const n = p.getValue(t),
            r = p.getMask(t);
          c.push(n), l.push(r), null != r && (m = !0), s || (d[t.name]--, 0 !== d[t.name] || e.hasKey(t) || -1 !== o.indexOf(t.name) || n.isDisposed || !0 === t.sourceLayer.stateful || f.push(n))
        }
        m && ((n = n || {}).mask = l[0]);
        const g = Kt(a.apply(c, n));
        let b = null;
        a.supportsMasking && (b = a.computeMask(c, l));
        const y = Br(i),
          w = Array.isArray(y) ? y : [y];
        for (let t = 0; t < w.length; ++t) {
          p.hasKey(w[t]) || p.add(w[t], g[t], Array.isArray(b) ? b[0] : b);
          const e = o.indexOf(w[t].name); - 1 !== e && (u[e] = g[t])
        }
        s || Object(Ft.pb)(f)
      }
      return p.disposeMasks(), i ? u : u[0]
    }

    function zr(t) {
      const e = {};
      for (const n in t) e[n] = t[n].size;
      return e
    }

    function Lr(t, e) {
      const n = new Set,
        r = [],
        s = {};
      for (const t of e.names()) n.add(t);
      const i = [],
        a = [];
      for (i.push(t); i.length > 0;) {
        const t = i[i.length - 1];
        if (n.has(t.name)) {
          i.pop();
          continue
        }
        const e = a[a.length - 1] === i.length - 1;
        if (0 === t.inputs.length || e) i.pop(), r.push(t), n.add(t.name), e && a.pop();
        else {
          a.push(i.length - 1);
          for (const e of t.inputs) null == s[e.name] && (s[e.name] = new Set), s[e.name].add(t.name), n.has(e.name) || i.push(e)
        }
      }
      return {
        sorted: r,
        recipientMap: s
      }
    }

    function Br(t) {
      let e;
      if (1 === t.sourceLayer.inboundNodes.length) e = t.sourceLayer.output;
      else {
        let n = null;
        for (let e = 0; e < t.sourceLayer.inboundNodes.length; ++e)
          for (const r of t.sourceLayer.inboundNodes[e].outputTensors)
            if (r.id === t.id) {
              n = e;
              break
            } e = t.sourceLayer.getOutputAt(n)
      }
      return e
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class Pr extends Bn {
      constructor(t) {
        if (super({}), this.containerNodes = new Set, this.name = t.name, null == this.name) {
          const t = this.getClassName().toLowerCase();
          this.name = kn(t)
        }
        if (this.supportsMasking = !1, this.trainable_ = !0, Array.isArray(t.inputs) ? this.inputs = t.inputs.slice() : this.inputs = [t.inputs], Array.isArray(t.outputs) ? this.outputs = t.outputs.slice() : this.outputs = [t.outputs], ee(this.inputs).length !== this.inputs.length) throw new Pt("The list of inputs passed to the model is redundant. All inputs should only appear once. Found: " + `${this.inputs.map(t=>t.name)}`);
        ee(this.outputs).length !== this.outputs.length && console.warn("The list of outputs passed to the model is redundant. All outputs should only appear once. Found: " + `${this.outputs.map(t=>t.name)}`), this.inputLayers = [], this.inputLayersNodeIndices = [], this.inputLayersTensorIndices = [], this.outputLayers = [], this.outputLayersNodeIndices = [], this.outputLayersTensorIndices = [], this.layers = [], this.internalContainerRefs = [];
        for (const t of this.outputs) {
          const e = t.sourceLayer,
            n = t.nodeIndex,
            r = t.tensorIndex;
          this.outputLayers.push(e), this.outputLayersNodeIndices.push(n), this.outputLayersTensorIndices.push(r)
        }
        for (const t of this.inputs) {
          const e = t.sourceLayer,
            n = t.nodeIndex,
            r = t.tensorIndex;
          Ht(0 === n, "input layer has >1 nodes"), Ht(0 === r, "input layer has >1 tensors"), this.inputLayers.push(e), this.inputLayersNodeIndices.push(n), this.inputLayersTensorIndices.push(r)
        }
        this.inputNames = [], this.outputNames = [], this.feedInputShapes = [], this.feedInputNames = [], this.feedOutputNames = [];
        for (let e = 0; e < this.inputLayers.length; e++) {
          const n = this.inputLayers[e];
          if (!(n instanceof Pn)) throw new TypeError("Input layers to a LayersModel must be InputLayer objects. " + `Received inputs: ${t.inputs}. ` + `Input ${e} (0-based) originates ` + `from layer type ${n.getClassName()}.`);
          this.inputNames.push(n.name), this.feedInputShapes.push(n.batchInputShape), this.feedInputNames.push(n.name)
        }
        for (const t of this.outputLayers) this.outputNames.push(t.name);
        this.internalInputShapes = this.inputs.map(t => t.shape), this.internalOutputShapes = this.outputs.map(t => t.shape);
        const e = {},
          n = {},
          r = {},
          s = {},
          i = {},
          a = [],
          o = (t, e, n, r, s, u) => {
            null != r && null != s && null != u || (r = t.sourceLayer, s = t.nodeIndex, u = t.tensorIndex);
            const c = r.inboundNodes[s];
            if (-1 !== n.indexOf(c)) throw new Bt(`The tensor ${t.name} at layer "${r.name}" ` + "is part of a cycle.");
            if (-1 !== e.indexOf(c)) return;
            this.containerNodes.add(Pr.nodeKey(r, s)), r.id in i || (i[r.id] = Object.keys(i).length), -1 === n.indexOf(c) && n.push(c);
            const l = c.inboundLayers.length;
            for (let t = 0; t < l; t++) {
              const r = c.inputTensors[t],
                s = c.inboundLayers[t],
                i = c.nodeIndices[t],
                a = c.tensorIndices[t];
              o(r, e, n, s, i, a)
            }
            for (e.push(c); n.indexOf(c) >= 0;) n.splice(n.indexOf(c), 1);
            a.push(c)
          },
          u = [],
          c = [];
        for (const t of this.outputs) o(t, u, c);
        const l = a.slice().reverse();
        for (const t of l) {
          n[t.id] = t, t.id in e || (e[t.id] = 0);
          let i = e[t.id];
          const a = null == r[t.outboundLayer.id] ? 0 : r[t.outboundLayer.id];
          i = Math.max(i, a), r[t.outboundLayer.id] = i, s[t.outboundLayer.id] = t.outboundLayer, e[t.id] = i;
          for (let r = 0; r < t.inboundLayers.length; r++) {
            const s = t.inboundLayers[r],
              a = t.nodeIndices[r],
              o = s.inboundNodes[a],
              u = null == e[o.id] ? 0 : e[o.id];
            e[o.id] = Math.max(i + 1, u), n[o.id] = o
          }
        }
        const h = {};
        for (const t in e) {
          const r = e[t];
          r in h || (h[r] = []), h[r].push(n[t])
        }
        const d = {};
        for (const t in r) {
          const e = r[t];
          e in d || (d[e] = []), d[e].push(s[t])
        }
        let p = Object.keys(d).map(t => parseInt(t, 10)).sort(te);
        this.layers = [];
        for (const t of p) {
          const e = d[t];
          e.sort((t, e) => {
            const n = i[t.id],
              r = i[e.id];
            return n < r ? -1 : n > r ? 1 : 0
          });
          for (const t of e) t instanceof Pr && this.internalContainerRefs.push(t), this.layers.push(t)
        }
        this.layersByDepth = d, p = Object.keys(h).map(t => parseInt(t, 10)).sort(te);
        const f = this.inputs.slice(),
          m = [];
        for (const t of p)
          for (const e of h[t]) {
            const t = e.outboundLayer;
            if (null != t) {
              for (const n of e.inputTensors)
                if (-1 === f.indexOf(n)) throw new Bt(`Graph disconnected: cannot obtain value for tensor ${n}` + ` at layer "${t.name}". ` + "The following previous layers were accessed without " + `issue: ${m}`);
              for (const t of e.outputTensors) f.push(t);
              m.push(t.name)
            }
          }
        this.nodesByDepth = h;
        const g = this.layers.map(t => t.name);
        for (const t of g) {
          const e = g.filter(e => e === t).length;
          if (1 !== e) throw new Bt(`The name "${t}" is used ${e} times ` + "in the model. All layer names should be unique. Layer names: " + JSON.stringify(g))
        }
        this.outboundNodes = [], this.inboundNodes = [], new zn({
          outboundLayer: this,
          inboundLayers: [],
          nodeIndices: [],
          tensorIndices: [],
          inputTensors: this.inputs,
          outputTensors: this.outputs,
          inputMasks: this.inputs.map(t => null),
          outputMasks: this.outputs.map(t => null),
          inputShapes: this.inputs.map(t => t.shape),
          outputShapes: this.outputs.map(t => t.shape)
        }), this.built = !0, this._refCount = 1
      }
      assertNotDisposed() {
        if (0 === this._refCount) throw new Error(`Container '${this.name}' is already disposed.`)
      }
      dispose() {
        this.assertNotDisposed();
        const t = {
          refCountAfterDispose: null,
          numDisposedVariables: 0
        };
        if (0 == --this._refCount) {
          for (const e of this.layers) t.numDisposedVariables += e.dispose().numDisposedVariables;
          for (const e of this.internalContainerRefs) t.numDisposedVariables += e.dispose().numDisposedVariables
        }
        return t.refCountAfterDispose = this._refCount, t
      }
      get trainable() {
        return this.trainable_
      }
      set trainable(t) {
        this.layers.forEach(e => {
          e._trainableWeights.forEach(e => e.trainable = t)
        }), this.trainable_ = t
      }
      get trainableWeights() {
        if (this._trainableWeights.length > 0) throw new Pt("Container instance unexpectedly contains _trainableWeights.The trainable weights of a Container are a union of the trainable weights of its consituent Layers. Its own _trainableWeights must remain an empty Array.");
        if (!this.trainable) return [];
        let t = [];
        for (const e of this.layers) t = t.concat(e.trainableWeights);
        return t
      }
      get nonTrainableWeights() {
        const t = [];
        for (const e of this.layers) t.push(...e.nonTrainableWeights);
        if (!this.trainable) {
          const e = [];
          for (const t of this.layers) e.push(...t.trainableWeights);
          return e.concat(t)
        }
        return t
      }
      get weights() {
        return this.trainableWeights.concat(this.nonTrainableWeights)
      }
      loadWeights(t, e = !0) {
        const n = {};
        let r = 0;
        for (const t of this.layers)
          for (const e of t.weights) {
            if (null != n[e.originalName]) throw new Pt(`Duplicate weight name: ${e.originalName}`);
            n[e.originalName] = e, r++
          }
        const s = [];
        for (const r in t) {
          let i = r;
          if (null == n[r]) {
            const t = r.split("/");
            i = t.slice(0, -2).concat([t[t.length - 1]]).join("/")
          }
          if (null != n[i]) s.push([n[i], t[r]]);
          else if (e) throw new Pt(`Provided weight data has no target variable: ${r}`);
          delete n[i]
        }
        if (e) {
          const t = [];
          for (const e in n) t.push(e);
          if (t.length > 0) throw new Pt(`${t.length} of ${r} weights are not set: ` + `${t}`)
        }
        jn(s)
      }
      updatedConfig() {
        const t = this.getConfig(),
          e = {};
        return e.className = this.getClassName(), e.config = t, e.kerasVersion = `tfjs-layers ${Rr}`, e.backend = "TensorFlow.js", e
      }
      toJSON(t, e = !0) {
        const n = function t(e, n) {
          if (null == e) return null;
          if ("string" == typeof e) return Jt(e);
          if ("number" == typeof e || "boolean" == typeof e) return e;
          if (e instanceof Array) {
            const r = [],
              s = e.length;
            for (let i = 0; i < s; ++i) {
              const s = e[i];
              Nr(n, i, s) ? r.push(s) : r.push(t(s, n))
            }
            return r
          } {
            const n = {};
            for (const r of Object.keys(e)) {
              const s = e[r],
                i = Jt(r);
              n[i] = "name" !== r && "className" !== r || "string" != typeof s ? t(s, r) : s
            }
            return n
          }
        }(this.updatedConfig());
        return e ? JSON.stringify(n) : n
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          t = Kt(t);
          const n = new jr;
          for (let e = 0; e < this.inputs.length; ++e) n.add(this.inputs[e], t[e]);
          return Mr(this.outputs, n, e)
        })
      }
      computeMask(t, e) {
        return Object(Ft.Bd)(() => {
          let n;
          return t = Kt(t), n = null == e ? Vt(null, t.length) : Kt(e), this.runInternalGraph(t, n)[1]
        })
      }
      computeOutputShape(t) {
        const e = En(t);
        if (e.length !== this.inputLayers.length) throw new Pt(`Invalid inputShape argument ${t}: ` + `model has ${this.inputLayers.length} tensor inputs.`);
        const n = {};
        for (let t = 0; t < e.length; t++) {
          const r = this.inputLayers[t],
            s = e[t];
          n[r.name + "_0_0"] = s
        }
        const r = Object.keys(this.nodesByDepth).map(t => parseInt(t, 10)).sort(te);
        if (r.length > 1)
          for (const t of r) {
            const e = this.nodesByDepth[t];
            for (const t of e) {
              const e = t.outboundLayer;
              if (-1 !== this.inputLayers.map(t => t.id).indexOf(e.id)) continue;
              const r = [];
              for (let e = 0; e < t.inboundLayers.length; e++) {
                const s = t.inboundLayers[e],
                  i = t.nodeIndices[e],
                  a = t.tensorIndices[e],
                  o = n[`${s.name}_${i}_${a}`];
                r.push(o)
              }
              const s = En(e.computeOutputShape(qt(r))),
                i = e.inboundNodes.indexOf(t);
              for (let t = 0; t < s.length; t++) {
                n[`${e.name}_${i}_${t}`] = s[t]
              }
            }
          }
        const s = [],
          i = [];
        for (let t = 0; t < this.outputLayers.length; t++) {
          const e = this.outputLayers[t],
            n = this.outputLayersNodeIndices[t],
            r = this.outputLayersTensorIndices[t],
            s = `${e.name}_${n}_${r}`;
          i.push(s)
        }
        for (let t = 0; t < i.length; t++) {
          const e = i[t];
          Ht(e in n), s.push(n[e])
        }
        return qt(s)
      }
      runInternalGraph(t, e) {
        null == e && (e = Vt(null, t.length));
        const n = {};
        for (let r = 0; r < this.inputs.length; ++r) {
          const s = this.inputs[r],
            i = t[r],
            a = e[r];
          n[s.id] = [i, a]
        }
        const r = Object.keys(this.nodesByDepth).map(t => parseInt(t, 10)).sort(te);
        for (const t of r) {
          const e = this.nodesByDepth[t];
          for (const t of e) {
            const e = t.outboundLayer,
              r = t.inputTensors,
              s = t.outputTensors,
              i = new Array;
            for (const t of r) t.id in n && i.push(n[t.id]);
            if (i.length === r.length) {
              let r, a, o, u, c = {};
              if (null != t.callArgs && (c = t.callArgs), 1 === i.length) {
                const [t, n] = i[0];
                null == c.mask && (c.mask = n), o = Kt(e.call(t, c)), u = Kt(e.computeMask(t, n)), r = [t], a = [n]
              } else r = i.map(t => t[0]), a = i.map(t => t[1]), null == c.mask && (c.mask = a), o = Kt(e.call(r, c)), u = Kt(e.computeMask(r, a));
              if (e.activityRegularizer) throw new Wt("LayersModel invocation with concrete Tensor value(s) in the presence of activity regularizer(s) is not supported yet.");
              for (let t = 0; t < s.length; ++t) {
                const e = s[t],
                  r = o[t],
                  i = u[t];
                n[e.id] = [r, i]
              }
            }
          }
        }
        const s = [],
          i = [],
          a = [];
        for (const t of this.outputs) {
          Ht(t.id in n, `Could not compute output ${t.name} : ${t.id}`);
          const [e, r] = n[t.id];
          a.push(e.shape), s.push(e), i.push(r)
        }
        return [s, i, a]
      }
      buildNodeConversionMap(t) {
        const e = {};
        let n;
        for (const t of this.layers) {
          n = t instanceof Pr ? 1 : 0;
          for (let r = 0; r < t.inboundNodes.length; r++) {
            const s = Pr.nodeKey(t, r);
            this.containerNodes.has(s) && (e[s] = n, n += 1)
          }
        }
        return e
      }
      getLayer(t, e) {
        if (null != e) {
          if (this.layers.length <= e) throw new Pt(`Was asked to retrieve layer at index ${e}, but model only ` + `has ${this.layers.length} layer(s).`);
          return this.layers[e]
        }
        if (null == t) throw new Pt("Provide either a layer name or layer index");
        for (const e of this.layers)
          if (e.name === t) return e;
        throw new Pt(`No such layer: ${t}`)
      }
      calculateLosses() {
        return Object(Ft.Bd)(() => {
          const t = [];
          for (const e of this.layers)
            for (let n = 0; n < e.inboundNodes.length; ++n) {
              const r = Pr.nodeKey(e, n);
              this.containerNodes.has(r) && t.push(...e.calculateLosses())
            }
          return t
        })
      }
      getConfig() {
        const t = {
            name: this.name
          },
          e = this.buildNodeConversionMap(this.layers),
          n = [];
        for (const t of this.layers) {
          const r = t.getClassName(),
            s = t.getConfig(),
            i = [];
          for (let n = 0; n < t.inboundNodes.length; n++) {
            const r = t.inboundNodes[n],
              s = Pr.nodeKey(t, n);
            let a = {};
            if (this.containerNodes.has(s)) {
              if (r.callArgs) try {
                JSON.stringify(r.callArgs), a = r.callArgs
              } catch (e) {
                console.warn(`Layer ${t.name} was passed ` + "non-serializable keyword arguments: " + `${r.callArgs}. They will not be included ` + "in the serialized model (and thus will be missing at deserialization time)."), a = {}
              }
              if (r.inboundLayers.length > 0) {
                const t = [];
                for (let n = 0; n < r.inboundLayers.length; n++) {
                  const s = r.inboundLayers[n],
                    i = r.nodeIndices[n],
                    o = r.tensorIndices[n];
                  let u = e[Pr.nodeKey(s, i)];
                  null == u && (u = 0), t.push([s.name, u, o, a])
                }
                i.push(t)
              }
            }
          }
          const a = {};
          a.name = t.name, a.className = r, a.config = s, a.inboundNodes = i, n.push(a)
        }
        t.layers = n;
        const r = [];
        for (let t = 0; t < this.inputLayers.length; t++) {
          const n = this.inputLayers[t],
            s = this.inputLayersNodeIndices[t],
            i = Pr.nodeKey(n, s);
          if (!this.containerNodes.has(i)) continue;
          let a = e[i];
          null == a && (a = 0);
          const o = this.inputLayersTensorIndices[t];
          r.push([n.name, a, o])
        }
        t.inputLayers = r;
        const s = [];
        for (let t = 0; t < this.outputLayers.length; t++) {
          const n = this.outputLayers[t],
            r = this.outputLayersNodeIndices[t],
            i = Pr.nodeKey(n, r);
          if (!this.containerNodes.has(i)) continue;
          let a = e[i];
          null == a && (a = 0);
          const o = this.outputLayersTensorIndices[t];
          s.push([n.name, a, o])
        }
        return t.outputLayers = s, t
      }
      static fromConfig(t, e, n = {}, r = !1) {
        const s = {},
          i = {};

        function a(t, e) {
          t.name in i ? i[t.name].push(e) : i[t.name] = [e]
        }

        function o(t, e) {
          const n = [];
          let r;
          for (const i of e) {
            const o = i[0],
              u = i[1],
              c = i[2];
            if (r = null == i[3] ? {} : i[3], !(o in s)) return void a(t, e);
            const l = s[o];
            if (l.inboundNodes.length <= u) return void a(t, e);
            const h = l.inboundNodes[u];
            n.push(h.outputTensors[c])
          }
          n.length > 0 && t.apply(qt(n), r)
        }

        function u(t) {
          const n = t.name,
            i = er(t, null != e.customObjects ? e.customObjects : {});
          i.setFastWeightInitDuringBuild(r), s[n] = i, t.inboundNodes.forEach(t => {
            if (!(t instanceof Array)) throw new Pt(`Corrupted configuration, expected array for nodeData: ${t}`);
            a(i, t)
          })
        }
        const c = e.name,
          l = e.layers;
        for (const t of l) u(t);
        for (; !ne(i);)
          for (const t of l) {
            const e = s[t.name];
            if (e.name in i) {
              const t = i[e.name];
              delete i[e.name];
              for (const n of t) o(e, n)
            }
          }
        const h = [],
          d = [],
          p = e.inputLayers;
        for (const t of p) {
          const e = t[0],
            n = t[1],
            r = t[2];
          Ht(e in s);
          const i = s[e].inboundNodes[n].outputTensors;
          h.push(i[r])
        }
        const f = e.outputLayers;
        for (const t of f) {
          const e = t[0],
            n = t[1],
            r = t[2];
          Ht(e in s);
          const i = s[e].inboundNodes[n].outputTensors;
          d.push(i[r])
        }
        return new t({
          inputs: h,
          outputs: d,
          name: c
        })
      }
      get stateful() {
        if (this._stateful) throw new Pt("Container instance unexpectedly has _stateful = true. The statefulness of a Container is determined by the Layers it contains. Its _stateful property must remain the default false.");
        for (const t of this.layers)
          if (t.stateful) return !0;
        return !1
      }
      resetStates() {
        Object(Ft.Bd)(() => {
          this.layers.forEach(t => {
            t.stateful && t.resetStates()
          })
        })
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Wr(t, e, n) {
      const r = e.length;
      if (null == t || Array.isArray(t) && 0 === t.length) return e.map(t => null);
      if (1 === r) return Array.isArray(t) && 1 === t.length ? t : "object" == typeof t && e[0] in t ? [t[e[0]]] : [t];
      if (Array.isArray(t)) {
        if (t.length !== r) throw new Error(`Provided ${n} is an array of ${t.length} ` + `element(s), but the model has ${r} outputs. ` + "Make sure a set of weights is provided for each model output.");
        return t
      }
      if ("object" == typeof t && Object.keys(t).length > 0 && "object" == typeof t[Object.keys(t)[0]]) {
        const n = [];
        return e.forEach(e => {
          e in t ? n.push(t[e]) : n.push(null)
        }), n
      }
      throw new Error(`The model has multiple (${r}) outputs, ` + `so ${n} must be either an array with ` + `${r} elements or an object with ${e} keys. ` + `Provided ${n} not understood: ${JSON.stringify(t)}`)
    }

    function Ur(t, e) {
      return Wr(t, e, "classWeight")
    }
    async function Vr(t, e, n, r) {
      if (null != e || null != r) throw new Error("Support sampleWeight is not implemented yet");
      if (null != n) {
        const e = Object(Ft.Bd)(() => {
            if (1 === t.shape.length) return t.clone();
            if (2 === t.shape.length) {
              if (t.shape[1] > 1) {
                const e = 1;
                return t.argMax(e)
              }
              if (1 === t.shape[1]) return t.reshape([t.shape[0]]);
              throw new Error(`Encountered unexpected last-dimension size (${t.shape[1]}) ` + "during handling of class weights. The size is expected to be >= 1.")
            }
            throw new Error(`Unexpected rank of target (y) tensor (${t.rank}) during ` + "handling of class weights. The rank is expected to be 1 or 2.")
          }),
          r = Array.from(await e.data());
        Object(Ft.pb)(e);
        const s = [];
        return r.forEach(t => {
          if (null == n[t]) throw new Error("classWeight must contain all classes in the training data. " + `The class ${t} exists in the data but not in ` + "classWeight");
          s.push(n[t])
        }), Object(Ft.xd)(s, "float32")
      }
      return null
    }

    function Hr(t, e) {
      return Object(Ft.qc)(t, e)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    const Gr = 32;

    function qr(t, e) {
      let n, r;
      const s = e;
      n = s.xs, r = s.ys, Ft.Jd.assert(null != n && null != r, () => "A Dataset iterator for fitDataset() is expected to generate objects of the form `{xs: xVal, ys: yVal}`, where the two values may be `tf.Tensor`, an array of Tensors, or a map of string to Tensor.  The provided Dataset instead generates " + `${e}`);
      const i = Kr("input", t.inputNames, n),
        a = Kr("output", t.outputNames, r),
        o = i[0].shape[0];
      Ft.Jd.assert(i.length === t.inputs.length, () => `LayersModel has ${t.inputs.length} inputs, but the dataset ` + `provides ${i.length} inputs.  (Expected input keys: ` + `${JSON.stringify(t.inputNames)})`), Ft.Jd.assert(a.length === t.outputs.length, () => `LayersModel has ${t.outputs.length} outputs, but the dataset ` + `provides ${a.length} outputs.  (Expected output keys: ` + `${JSON.stringify(t.outputNames)})`);
      for (let e = 0; e < i.length; e++) Ft.Jd.assert(i[e].shape[0] === o, () => "Batch size mismatch: input " + `${t.inputNames[e]} has ${i[e].shape[0]}; ` + `expected  ${o} based on input ${t.inputNames[0]}.`);
      for (let e = 0; e < a.length; e++) Ft.Jd.assert(a[e].shape[0] === o, () => "Batch size mismatch: output " + `${t.outputNames[e]} has ${a[e].shape[0]}; ` + `expected  ${o} based on input ${t.inputNames[0]}.`);
      return {
        xs: i,
        ys: a
      }
    }

    function Kr(t, e, n) {
      if (n instanceof Ft.r) return [n];
      if (Array.isArray(n)) return Ft.Jd.assert(n.length === e.length, () => `Received an array of ${n.length} Tensors, but expected ${e.length} to match the ${t} keys ${e}.`), n; {
        const r = [];
        for (const s of e) {
          if (null == n[s]) throw new Pt("The feature data generated by the dataset lacks the required " + `${t} key '${s}'.`);
          r.push(n[s])
        }
        return r
      }
    }
    async function Jr(t, e, n) {
      const r = null != n.batchesPerEpoch;
      if (Ft.Jd.assert(null != t.optimizer, () => "You must compile a model before training/testing. Use LayersModel.compile(modelCompileConfig)."), Ft.Jd.assert(null != n, () => "For fitDataset(), the 2nd argument (config) is required, but it is not provided in this call."), Ft.Jd.assert(null != n.epochs && n.epochs > 0 && Number.isInteger(n.epochs), () => "For fitDataset(), config.epochs is expected to be a positive " + `integer, but got ${n.epochs}`), Ft.Jd.assert(!r || n.batchesPerEpoch > 0 && Number.isInteger(n.batchesPerEpoch), () => "For fitDataset(), config.batchesPerEpoch is expected to be a " + `positive integer if specified, but got ${n.batchesPerEpoch}`), Ft.Jd.assert(null == n.validationSplit, () => "`validationSplit` is not supported by `fitDataset()`. Use validationData instead."), t.isTraining) throw new Error("Cannot start training because another fit() call is ongoing.");
      t.isTraining = !0;
      try {
        const s = null != n.validationData;
        let i, a;
        if (s)
          if (Xr(n.validationData)) Ft.Jd.assert(null == n.validationBatches || n.validationBatches > 0 && Number.isInteger(n.validationBatches), () => "For fitDataset() with dataset-based validation, config.validationBatches is expected not to be provided, or to be a positive integer, " + `but got ${n.validationBatches}`);
          else {
            const t = function (t) {
              if (3 === t.length) throw new Wt("Validation with sample weights is not implemented yet.");
              return {
                xs: t[0],
                ys: t[1]
              }
            }(n.validationData);
            i = t.xs, a = t.ys
          } const o = t.makeTrainFunction(),
          u = t.getDedupedMetricsNames();
        let c;
        c = s ? u.slice().concat(u.map(t => "val_" + t)) : u.slice();
        const l = Zn(n.callbacks, n.yieldEvery),
          h = null == n.verbose ? 1 : n.verbose,
          {
            callbackList: d,
            history: p
          } = tr(l, h, n.epochs, null, null, function (t, e) {
            let n = null;
            null != e.batchesPerEpoch ? n = e.batchesPerEpoch : Number.isFinite(t.size) && (n = t.size);
            return n
          }(e, n), null, s, c);
        d.setModel(t), t.history = p, await d.onTrainBegin(), t.stopTraining_ = !1;
        let f = null == n.initialEpoch ? 0 : n.initialEpoch,
          m = await e.iterator();
        for (; f < n.epochs;) {
          const c = {};
          await d.onEpochBegin(f);
          let l = 0,
            h = 0;
          for (r || (m = await e.iterator()); !r || l < n.batchesPerEpoch;) {
            const e = await m.next();
            if (r && e.done) {
              console.warn("You provided `batchesPerEpoch` as " + `${n.batchesPerEpoch}, ` + "but your dataset iterator ran out of data after " + `${l} batches; ` + "interrupting training. Make sure that your dataset can generate at least `batchesPerEpoch * epochs` batches (in this case, " + `${n.batchesPerEpoch*n.epochs} batches). ` + "You may need to use the repeat() function when building your dataset.");
              break
            }
            if (null != e.value) {
              const {
                xs: r,
                ys: s
              } = qr(t, e.value), i = {};
              i.batch = h, i.size = r[0].shape[0], await d.onBatchBegin(h, i);
              const a = [];
              if (null != n.classWeight) {
                const e = Ur(n.classWeight, t.outputNames);
                for (let t = 0; t < e.length; ++t) a.push(await Vr(s[t], null, e[t]))
              }
              const c = r.concat(s).concat(a),
                p = o(c);
              Ft.pb(c);
              for (let t = 0; t < u.length; ++t) {
                const e = u[t],
                  n = p[t];
                i[e] = n, Ft.Qb(n)
              }
              await d.onBatchEnd(h, i), Vn(i), h++, l++
            }
            if (r ? l >= n.batchesPerEpoch : e.done) {
              if (s) {
                let e;
                e = Xr(n.validationData) ? Kt(await t.evaluateDataset(n.validationData, {
                  batches: n.validationBatches
                })) : Kt(t.evaluate(i, a, {
                  batchSize: null == n.validationBatchSize ? Gr : n.validationBatchSize,
                  verbose: 0
                }));
                for (let n = 0; n < t.metricsNames.length; ++n) c[`val_${t.metricsNames[n]}`] = e[n]
              }
              break
            }
            if (t.stopTraining_) break
          }
          if (await d.onEpochEnd(f, c), f++, t.stopTraining_) break
        }
        return await d.onTrainEnd(), await t.history.syncData(), t.history
      } finally {
        t.isTraining = !1
      }
    }

    function Xr(t) {
      return "function" == typeof t.iterator
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Yr(t) {
      Ft.Jd.assert(t > 0 && Number.isInteger(t), () => `batchSize is required to be a positive integer, but got ${t}`)
    }

    function Zr(t, e, n) {
      return null == t ? [null] : Array.isArray(t) ? t.map(t => Le(t, e, n - e)) : Le(t, e, n - e)
    }

    function Qr(t, e) {
      return Ft.Bd(() => null == t ? null : Array.isArray(t) ? t.map(t => Qr(t, e)) : qe(t, "int32" === e.dtype ? e : e.toInt()))
    }

    function ts(t, e) {
      const n = [];
      let r = 0,
        s = null;
      for (; r < t;) s = r + e, s >= t && (s = t), n.push([r, s]), r = s;
      return n
    }
    async function es(t, e, n, r = {}) {
      if (t.isTraining) throw new Error("Cannot start training because another fit() call is ongoing.");
      let s, i, a, o, u, c, l;
      t.isTraining = !0;
      try {
        const h = null == r.batchSize ? 32 : r.batchSize;
        Yr(h);
        const d = !1,
          p = await t.standardizeUserData(e, n, r.sampleWeight, r.classWeight, d, h);
        s = p[0], i = p[1], l = p[2];
        let f, m = !1;
        if (null != r.validationData && r.validationData.length > 0) {
          if (m = !0, 2 !== r.validationData.length) throw 3 === r.validationData.length ? new Wt("validationData including sample weights is not supported yet.") : new Pt("When passing validation data, it must contain 2 (valX, valY) or 3 (valX, valY, valSampleWeight) items; " + `${r.validationData} is invalid.`);
          a = r.validationData[0], o = r.validationData[1];
          const e = !0,
            n = await t.standardizeUserData(a, o, null, null, e, h);
          u = n[0], c = n[1], f = u.concat(c)
        } else if (null != r.validationSplit && r.validationSplit > 0 && r.validationSplit < 1) {
          m = !0;
          const t = Math.floor(s[0].shape[0] * (1 - r.validationSplit)),
            e = s[0].shape[0];
          u = Zr(s, t, e), s = Zr(s, 0, t), c = Zr(i, t, e), i = Zr(i, 0, t), f = u.concat(c)
        } else null != r.validationSteps && (m = !0);
        const g = s.concat(i).concat(l);
        t.checkTrainableWeightsConsistency();
        const b = t.makeTrainFunction(),
          y = t.getDedupedMetricsNames();
        let w, v;
        m ? (t.makeTestFunction(), w = t.testFunction, v = y.slice().concat(y.map(t => "val_" + t))) : (w = null, f = [], v = y.slice());
        const x = Zn(r.callbacks, r.yieldEvery);
        return await async function (t, e, n, r, s, i, a, o, u, c, l, h, d, p, f) {
          null == s && (s = 32), null == i && (i = 1), null == l && (l = !0), null == d && (d = 0);
          let m = !1;
          if (null != u && null != c && (m = !0), null != f && (m = !0, null == p)) throw new Pt("Can only use `validationSteps` when doing step-wise training, i.e., `stepsPerEpoch` must be set.");
          const g = t.checkNumSamples(n, s, p, "steps_per_epoch");
          let b;
          null != g && (b = Fe(0, g)), null == a && (a = 1);
          const {
            callbackList: y,
            history: w
          } = tr(o, a, i, d, g, p, s, m, h);
          y.setModel(t), t.history = w, await y.onTrainBegin(), t.stopTraining_ = !1;
          for (let a = d; a < i; ++a) {
            await y.onEpochBegin(a);
            const i = {};
            if (null != p) throw new Wt("stepsPerEpoch mode is not implemented yet."); {
              if ("batch" === l) throw new Wt("batch shuffling is not implemneted yet");
              l && Ft.Jd.shuffle(b);
              const a = Object(Ft.xd)(b),
                o = ts(g, s);
              for (let l = 0; l < o.length; ++l) {
                const h = {};
                if (await y.onBatchBegin(l, h), Ft.Bd(() => {
                    const d = o[l][0],
                      p = o[l][1],
                      f = Le(a, d, p - d);
                    h.batch = l, h.size = p - d;
                    const g = Qr(n, f),
                      b = e(g);
                    for (let t = 0; t < r.length; ++t) {
                      const e = r[t],
                        n = b[t];
                      h[e] = n, Ft.Qb(n)
                    }
                    if (l === o.length - 1 && m) {
                      const e = t.testLoop(u, c, s);
                      for (let t = 0; t < r.length; ++t) {
                        const n = r[t],
                          s = e[t];
                        Ft.Qb(s), i["val_" + n] = s
                      }
                    }
                  }), await y.onBatchEnd(l, h), Vn(h), t.stopTraining_) break
              }
              a.dispose()
            }
            if (await y.onEpochEnd(a, i), t.stopTraining_) break
          }
          return await y.onTrainEnd(), await t.history.syncData(), t.history
        }(t, b, g, y, h, r.epochs, r.verbose, x, w, f, r.shuffle, v, r.initialEpoch, null, null)
      } finally {
        t.isTraining = !1, rs(s, e), rs(i, n), rs(u, a), rs(c, o), null != l && Ft.pb(l)
      }
    }

    function ns(t) {
      const e = [];
      t instanceof Ft.r && (t = [t]);
      for (let n = 0; n < t.length; ++n) {
        const r = t[n];
        if (1 === r.rank) e.push(ze(r, 1));
        else {
          if (0 === r.rank) throw new Error("Expected tensor to be at least 1D, but received a 0D tensor (scalar).");
          e.push(r)
        }
      }
      return e
    }

    function rs(t, e) {
      if (null == t) return;
      const n = [];
      if (e instanceof Ft.r) n.push(e.id);
      else if (Array.isArray(e)) e.forEach(t => n.push(t.id));
      else if (null != e)
        for (const t in e) {
          const r = e[t];
          n.push(r.id)
        }
      const r = [];
      if (t instanceof Ft.r) - 1 === n.indexOf(t.id) && r.push(t);
      else if (Array.isArray(t)) t.forEach(t => {
        -1 === n.indexOf(t.id) && r.push(t)
      });
      else if (null != t)
        for (const e in t) {
          const s = t[e]; - 1 === n.indexOf(s.id) && r.push(s)
        }
      r.forEach(t => {
        t.isDisposed || t.dispose()
      })
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function ss(t) {
      return Array.isArray(t)
    }

    function is(t) {
      return ! function (t) {
        return t instanceof Ft.r
      }(t) && !ss(t)
    }

    function as(t, e, n, r = !0, s = "") {
      if (null == e || 0 === e.length) {
        if (null != t) {
          let e = !1;
          if (ss(t) && t.length > 0) e = !0;
          else if (is(t)) {
            for (const n in t)
              if (t.hasOwnProperty(n)) {
                e = !0;
                break
              }
          } else e = !0;
          if (e) throw new Pt(`Error when checking model ${s} expected no data, ` + `but got ${t}`)
        }
        return []
      }
      if (null == t) return e.map(t => null);
      let i;
      if (is(t)) {
        t = t, i = [];
        for (const n of e) {
          if (null == t[n]) throw new Pt(`No data provided for "${n}". Need data for each key in: ` + `${e}`);
          i.push(t[n])
        }
      } else if (ss(t)) {
        if ((t = t).length !== e.length) throw new Pt(`Error when checking model ${s}: the Array of ` + "Tensors that you are passing to your model is not the size the " + `model expected. Expected to see ${e.length} Tensor(s), but ` + `instead got the following list of Tensor(s): ${t}`);
        i = t
      } else {
        if (t = t, e.length > 1) throw new Pt(`The model ${s} expects ${e.length} Tensor(s), ` + `but only received one Tensor. Found: Tensor with shape ${t.shape}`);
        i = [t]
      }
      if (i = ns(i), null != n)
        for (let t = 0; t < e.length; ++t) {
          if (null == n[t]) continue;
          const a = i[t];
          if (a.shape.length !== n[t].length) throw new Pt(`Error when checking ${s}: expected ${e[t]} ` + `to have ${n[t].length} dimension(s). but got array with ` + `shape ${a.shape}`);
          for (let i = 0; i < n[t].length; ++i) {
            if (0 === i && !r) continue;
            const o = a.shape[i],
              u = n[t][i];
            if (null != u && u >= 0 && o !== u) throw new Pt(`Error when checking ${s}: expected ${e[t]} ` + `to have shape [${n[t]}], but got array with shape ` + `[${a.shape}].`)
          }
        }
      return i
    }

    function os(t, e, n, r = !0, s = "") {
      let i;
      if (Array.isArray(t)) {
        if (t.length !== e.length) throw new Pt(`Error when checking model ${s}: the Array of ` + "Tensors that you are passing to your model is not the size the " + `the model expected. Expected to see ${e.length} Tensor(s),` + ` but instead got ${t.length} Tensors(s).`);
        i = t
      } else {
        if (e.length > 1) throw new Pt(`The model expects ${e.length} ${s} Tensors, ` + "but only received one Tensor. Found: array with shape " + `${JSON.stringify(t.shape)}.`);
        i = [t]
      }
      if (null != n)
        for (let t = 0; t < e.length; ++t) {
          if (null == n[t]) continue;
          const a = i[t];
          if (a.shape.length !== n[t].length) throw new Pt(`Error when checking ${s}: expected ${e[t]} ` + `to have ${n[t].length} dimension(s), but got array with ` + `shape ${JSON.stringify(a.shape)}`);
          for (let i = 0; i < n[t].length; ++i) {
            if (0 === i && !r) continue;
            const o = a.shape[i],
              u = n[t][i];
            if (null != u && u !== o) throw new Pt(`Error when checking ${s}: expected ` + `${e[t]} to have shape ${JSON.stringify(n[t])} but ` + `got array with shape ${JSON.stringify(a.shape)}.`)
          }
        }
    }
    const us = "layers-model";
    class cs extends Pr {
      constructor(t) {
        super(t), this.isTraining = !1
      }
      summary(t, e, n = console.log) {
        if (!this.built) throw new Pt("This model has never been called, thus its weights have not been created yet. So no summary can be displayed. Build the model first (e.g., by calling it on some test data).");
        Er(this, t, e, n)
      }
      compile(t) {
        if (null == t.loss && (t.loss = []), this.loss = t.loss, "string" == typeof t.optimizer) this.optimizer_ = function (t) {
          const e = {
            Adagrad: () => Ft.Ed.adagrad(.01),
            Adadelta: () => Ft.Ed.adadelta(1, .95, zt()),
            Adam: () => Ft.Ed.adam(.001, .9, .999, zt()),
            Adamax: () => Ft.Ed.adamax(.002, .9, .999, zt(), 0),
            RMSProp: () => Ft.Ed.rmsprop(.001, .9, 0, zt()),
            SGD: () => Ft.Ed.sgd(.01)
          };
          if (e.adagrad = e.Adagrad, e.adadelta = e.Adadelta, e.adam = e.Adam, e.adamax = e.Adamax, e.rmsprop = e.RMSProp, e.sgd = e.SGD, t in e) return e[t]();
          throw new Pt(`Unknown Optimizer ${t}`)
        }(t.optimizer), this.isOptimizerOwned = !0;
        else {
          if (!(t.optimizer instanceof Ft.n)) throw new Pt("User-defined optimizer must be an instance of tf.Optimizer.");
          this.optimizer_ = t.optimizer, this.isOptimizerOwned = !1
        }
        let e = [];
        if (Array.isArray(t.loss) || "string" == typeof t.loss || "function" == typeof t.loss)
          if (Array.isArray(t.loss)) {
            if (t.loss.length !== this.outputs.length) throw new Pt("When passing an Array as loss, it should have one entry per " + `model output. The model has ${this.outputs.length} output(s), ` + `but you passed loss=${t.loss}.`);
            const n = t.loss;
            e = n.map(t => pr(t))
          } else {
            const n = pr(t.loss);
            this.outputs.forEach(t => {
              e.push(n)
            })
          }
        else {
          t.loss = t.loss;
          for (const e in t.loss)
            if (-1 === this.outputNames.indexOf(e)) throw new Pt(`Unknown entry in loss dictionary: "${e}". ` + `Only expected the following keys: ${this.outputNames}`);
          for (const n of this.outputNames) null == t.loss[n] && console.warn(`Output "${n}" is missing from loss dictionary. We assume ` + "this was done on purpose, and we will not be expecting data " + `to be passed to ${n} during training`), e.push(pr(t.loss[n]))
        }
        this.lossFunctions = e, this.feedOutputNames = [], this.feedOutputShapes = [], this.feedLossFns = [];
        for (let t = 0; t < this.outputs.length; ++t) {
          const e = this.internalOutputShapes[t],
            n = this.outputNames[t];
          this.feedOutputNames.push(n), this.feedOutputShapes.push(e), this.feedLossFns.push(this.lossFunctions[t])
        }
        const n = [];
        this.metrics = t.metrics, this.metricsNames = ["loss"], this.metricsTensors = [], Ee("loss", () => {
          for (let t = 0; t < this.outputs.length; ++t) {
            if (-1 !== n.indexOf(t)) continue;
            const e = this.lossFunctions[t];
            this.outputs.length > 1 && (this.metricsTensors.push([e, t]), this.metricsNames.push(this.outputNames[t] + "_loss"))
          }
        });
        const r = function (t, e) {
            if (null == t || Array.isArray(t) && 0 === t.length) return e.map(t => []);
            let n;
            if ("string" == typeof t || "function" == typeof t) n = [t];
            else {
              if (!Array.isArray(t) && "object" != typeof t) throw new TypeError("Type of metrics argument not understood. Expected an string," + `function, Array, or Object, found: ${t}`);
              n = t
            }
            if (Array.isArray(n)) return e.map(t => n); {
              const t = [];
              for (const r of e) {
                let e = n.hasOwnProperty(r) ? n[r] : [];
                Array.isArray(e) || (e = [e]), t.push(e)
              }
              return t
            }
          }(t.metrics, this.outputNames),
          s = (t, e, n) => {
            this.outputNames.length > 1 && (e = this.outputNames[t] + "_" + e), this.metricsNames.push(e), this.metricsTensors.push([n, t])
          };
        Ee("metric", () => {
          for (let t = 0; t < this.outputs.length; ++t) {
            if (-1 !== n.indexOf(t)) continue;
            (e => {
              let n, r, i;
              for (const a of e) {
                if ("string" == typeof a && -1 !== ["accuracy", "acc", "crossentropy", "ce"].indexOf(a)) {
                  const e = this.internalOutputShapes[t];
                  let s;
                  1 === e[e.length - 1] || this.lossFunctions[t] === cr ? -1 !== ["accuracy", "acc"].indexOf(a) ? r = fr : -1 !== ["crossentropy", "ce"].indexOf(a) && (r = yr) : this.lossFunctions[t] === ur ? -1 !== ["accuracy", "acc"].indexOf(a) ? r = wr : -1 !== ["crossentropy", "ce"].indexOf(a) && (r = xr) : -1 !== ["accuracy", "acc"].indexOf(a) ? r = mr : -1 !== ["crossentropy", "ce"].indexOf(a) && (r = vr), -1 !== ["accuracy", "acc"].indexOf(a) ? s = "acc" : -1 !== ["crossentropy", "ce"].indexOf(a) && (s = "ce"), i = r, n = "" + s
                } else {
                  const t = Sr(a);
                  i = t, n = "" + _r(a)
                }
                let e;
                Ee(n, () => {
                  e = i
                }), s(t, n, e)
              }
            })(r[t])
          }
        }), this.collectedTrainableWeights = this.trainableWeights
      }
      checkTrainableWeightsConsistency() {
        null != this.collectedTrainableWeights && this.trainableWeights.length !== this.collectedTrainableWeights.length && console.warn("Discrepancy between trainableweights and collected trainable weights. Did you set `model.trainable` without calling `model.compile()` afterwards?")
      }
      evaluate(t, e, n = {}) {
        const r = null == n.batchSize ? 32 : n.batchSize;
        Yr(r);
        const s = this.standardizeUserDataXY(t, e, !0, r);
        try {
          const i = s[0].concat(s[1]);
          this.makeTestFunction();
          const a = this.testFunction;
          return qt(this.testLoop(a, i, r, n.verbose, n.steps))
        } finally {
          rs(s[0], t), rs(s[1], e)
        }
      }
      async evaluateDataset(t, e) {
        return this.makeTestFunction(), async function (t, e, n) {
          const r = null != (n = n || {}).batches,
            s = t.testFunction;
          let i = [];
          if (n.verbose > 0) throw new Wt("Verbose mode is not implemented yet.");
          Ft.Jd.assert(!r || n.batches > 0 && Number.isInteger(n.batches), () => "Test loop expects `batches` to be a positive integer, but " + `received ${JSON.stringify(n.batches)}`);
          const a = "function" == typeof e.next ? e : await e.iterator();
          let o = 0,
            u = 0;
          for (; !r || u < n.batches;) {
            const e = await a.next();
            if (i = Ft.Bd(() => {
                if (e.value) {
                  const {
                    xs: n,
                    ys: r
                  } = qr(t, e.value), a = n.concat(r), c = Ft.Bd(() => s(a));
                  if (Ft.pb(a), 0 === u)
                    for (let t = 0; t < c.length; ++t) i.push(Object(Ft.Pc)(0));
                  const l = a[0].shape[0];
                  for (let t = 0; t < c.length; ++t) {
                    const e = c[t],
                      n = i[t];
                    i[t] = Ft.Bd(() => Ft.x(i[t], Ft.qc(l, e))), u > 0 && Ft.pb(n)
                  }
                  Ft.pb(c), o += l, ++u
                }
                return i
              }), e.done) {
              r && console.warn("Your dataset iterator ran out of data during evaluateDataset(). Interrupting evalution. Make sure that your dataset can generate at least `batches` " + `batches (in this case, ${n.batches} batches). ` + "You may need to use the repeat() function when building your dataset.");
              break
            }
          }
          for (let t = 0; t < i.length; ++t) {
            const e = i[t];
            i[t] = Ft.qb(i[t], o), Ft.pb(e)
          }
          return qt(i)
        }(this, t, e)
      }
      checkNumSamples(t, e, n, r = "steps") {
        let s;
        if (null != n) {
          if (s = null, null != e) throw new Pt(`If ${r} is set, batchSize must be null or undefined.` + `Got batchSize = ${e}`)
        } else {
          if (null == t) throw new Pt("Either the input data should have a defined shape, or " + `${r} shoud be specified.`);
          s = Array.isArray(t) ? t[0].shape[0] : t.shape[0]
        }
        return s
      }
      execute(t, e) {
        if (Array.isArray(e) && 0 === e.length) throw new Pt("`outputs` is an empty Array, which is not allowed.");
        const n = Array.isArray(e),
          r = n ? e : [e],
          s = this.retrieveSymbolicTensors(r),
          i = new jr;
        if (t instanceof Ft.r && (t = [t]), Array.isArray(t)) {
          if (t.length !== this.inputs.length) throw new Pt(`The number of inputs provided (${t.length}) ` + "does not match the number of inputs of this model " + `(${this.inputs.length}).`);
          for (let e = 0; e < this.inputs.length; ++e) i.add(this.inputs[e], t[e])
        } else
          for (const e of this.inputs) {
            const n = t[e.name];
            if (null == n) throw new Pt(`No value is provided for the model's input ${e.name}`);
            i.add(e, n)
          }
        const a = Mr(s, i);
        return n ? a : a[0]
      }
      retrieveSymbolicTensors(t) {
        const e = Vt(null, t.length);
        let n = t.length;
        for (const r of this.layers) {
          const s = Array.isArray(r.output) ? r.output : [r.output],
            i = s.map(t => t.name);
          for (let r = 0; r < t.length; ++r) {
            const a = i.indexOf(t[r]);
            if (-1 !== a && (e[r] = s[a], n--), 0 === n) break
          }
          if (0 === n) break
        }
        if (n > 0) {
          const n = [];
          throw e.forEach((e, r) => {
            null == e && n.push(t[r])
          }), new Pt("Cannot find SymbolicTensors for output name(s): " + `${JSON.stringify(n)}`)
        }
        return e
      }
      predictLoop(t, e = 32, n = !1) {
        return Ft.Bd(() => {
          const r = this.checkNumSamples(t);
          if (n) throw new Wt("Verbose predictLoop() is not implemented yet.");
          const s = ts(r, e),
            i = this.outputs.map(t => []);
          for (let e = 0; e < s.length; ++e) {
            Ft.Bd(() => {
              const n = s[e][0],
                r = s[e][1],
                i = Zr(t, n, r),
                a = [];
              if (Array.isArray(i))
                for (let t = 0; t < i.length; ++t) a.push({
                  key: this.inputs[t],
                  value: i[t]
                });
              else a.push({
                key: this.inputs[0],
                value: i
              });
              const o = new jr(a);
              return Mr(this.outputs, o)
            }).forEach((t, e) => i[e].push(t))
          }
          return qt(i.map(t => Ft.Z(t, 0)))
        })
      }
      predict(t, e = {}) {
        const n = ns(t);
        os(n, this.inputNames, this.feedInputShapes, !1);
        try {
          const r = null == e.batchSize ? 32 : e.batchSize;
          return Yr(r), this.predictLoop(n, r)
        } finally {
          rs(n, t)
        }
      }
      predictOnBatch(t) {
        os(t, this.inputNames, this.feedInputShapes, !0);
        const e = (Array.isArray(t) ? t[0] : t).shape[0];
        return this.predictLoop(t, e)
      }
      standardizeUserDataXY(t, e, n = !0, r) {
        if (null == this.optimizer_) throw new Bt("You must compile a model before training/testing. Use LayersModel.compile(modelCompileArgs).");
        const s = [];
        for (let t = 0; t < this.feedOutputShapes.length; ++t) {
          const e = this.feedOutputShapes[t];
          this.feedLossFns[t] === ur ? s.push(e.slice(0, e.length - 1).concat([1])) : s.push(e)
        }
        if (function (t, e, n) {
            const r = ee(t.map(t => t.shape[0]));
            r.sort();
            const s = ee(e.map(t => t.shape[0]));
            if (s.sort(), r.length > 1) throw new Pt("All input Tensors (x) should have the same number of samples. Got array shapes: " + `${JSON.stringify(t.map(t=>t.shape))}`);
            if (s.length > 1) throw new Pt("All target Tensors (y) should have the same number of samples. Got array shapes: " + `${JSON.stringify(e.map(t=>t.shape))}`);
            if (r.length > 0 && s.length > 0 && !Ft.Jd.arraysEqual(r, s)) throw new Pt("Input Tensors should have the same number of samples as target " + `Tensors. Found ${r[0]} input sample(s) and ${s[0]} target ` + "sample(s).")
          }(t = as(t, this.feedInputNames, this.feedInputShapes, !1, "input"), e = as(e, this.feedOutputNames, s, !1, "target")), function (t, e, n) {
            const r = [rr, cr, or];
            for (let s = 0; s < t.length; ++s) {
              const i = t[s],
                a = e[s],
                o = n[s];
              if (null != a) {
                if (a === or && 1 === i.shape[i.shape.length - 1]) throw new Pt(`You are passing a target array of shape ${i.shape} while using ` + "a loss 'categorical_crossentropy'. 'categorical_crossentropy'expects targets to be binary matrices (1s and 0s) of shape [samples, classes].");
                if (-1 !== r.indexOf(a)) {
                  const t = i.shape.slice(1),
                    e = o.slice(1);
                  for (let n = 0; n < t.length; ++n) {
                    const r = t[n],
                      s = e[n];
                    if (null != s && r !== s) throw new Pt(`A target Tensor with shape ${i.shape} was passed for an ` + `output of shape ${o}, while using a loss function that ` + "expects targets to have the same shape as the output.")
                  }
                }
              }
            }
          }(e, this.feedLossFns, this.feedOutputShapes), this.stateful && null != r && r > 0 && t[0].shape[0] % r != 0) throw new Pt("In a stateful network, you should only pass inputs with a number of samples that is divisible by the batch size " + `${r}. Found: ${t[0].shape[0]} sample(s).`);
        return [t, e]
      }
      async standardizeUserData(t, e, n, r, s = !0, i) {
        const [a, o] = this.standardizeUserDataXY(t, e, s, i);
        if (null != n) throw new Error("sample weight is not supported yet.");
        let u = null;
        if (null != r) {
          const t = Ur(r, this.outputNames);
          u = [];
          for (let e = 0; e < t.length; ++e) u.push(await Vr(o[e], null, t[e]))
        }
        return [a, o, u]
      }
      testLoop(t, e, n, r = 0, s) {
        return Ft.Bd(() => {
          const i = this.checkNumSamples(e, n, s, "steps"),
            a = [];
          if (r > 0) throw new Wt("Verbose mode is not implemented yet.");
          if (null != s) throw new Wt("steps mode in testLoop() is not implemented yet"); {
            const r = ts(i, n),
              s = Object(Ft.xd)(Fe(0, i));
            for (let n = 0; n < r.length; ++n) {
              const i = r[n][0],
                o = r[n][1],
                u = Le(s, i, o - i),
                c = Qr(e, u),
                l = t(c);
              if (0 === n)
                for (let t = 0; t < l.length; ++t) a.push(Object(Ft.Pc)(0));
              for (let t = 0; t < l.length; ++t) {
                const e = l[t];
                a[t] = Ft.x(a[t], Ft.qc(o - i, e))
              }
            }
            for (let t = 0; t < a.length; ++t) a[t] = Ft.qb(a[t], i)
          }
          return a
        })
      }
      getDedupedMetricsNames() {
        const t = this.metricsNames,
          e = [];
        for (let n = 0; n < t.length; ++n) {
          const r = t[n];
          let s = r;
          if (Gt(t, r) > 1) {
            s += `_${Gt(t.slice(0,n),r)}`
          }
          e.push(s)
        }
        return e
      }
      makeTrainFunction() {
        return t => {
          const e = [],
            n = t.slice(0, this.inputs.length),
            r = t.slice(this.inputs.length, this.inputs.length + this.outputs.length),
            s = t.slice(this.inputs.length + this.outputs.length, this.inputs.length + 2 * this.outputs.length),
            i = [],
            a = this.collectedTrainableWeights.map(t => t.read());
          return [this.optimizer_.minimize(() => {
            const t = [];
            for (let e = 0; e < this.inputs.length; ++e) t.push({
              key: this.inputs[e],
              value: n[e]
            });
            const a = new jr(t),
              o = Mr(this.outputs, a, {
                training: !0
              });
            let u;
            for (let t = 0; t < this.lossFunctions.length; ++t) {
              let n = (0, this.lossFunctions[t])(r[t], o[t]);
              null != s[t] && (n = Hr(n, s[t]));
              const i = Ft.kc(n);
              e.push(i), u = 0 === t ? n : Ft.x(u, n)
            }
            for (let t = 0; t < this.metricsTensors.length; ++t) {
              let n;
              if (this.outputs.length > 1 && t < this.outputs.length) n = e[t];
              else {
                const e = this.metricsTensors[t][0],
                  s = this.metricsTensors[t][1];
                n = Ft.kc(e(r[s], o[s]))
              }
              Ft.Qb(n), i.push(n)
            }
            return u = Ft.kc(u), this.calculateLosses().forEach(t => {
              u = Ft.x(u, t)
            }), u
          }, !0, a)].concat(i)
        }
      }
      makeTestFunction() {
        this.testFunction = t => Ft.Bd(() => {
          const e = [];
          let n;
          const r = t.slice(0, this.inputs.length),
            s = t.slice(this.inputs.length, this.inputs.length + this.outputs.length),
            i = [];
          for (let t = 0; t < this.inputs.length; ++t) i.push({
            key: this.inputs[t],
            value: r[t]
          });
          const a = new jr(i),
            o = Mr(this.outputs, a);
          for (let t = 0; t < this.lossFunctions.length; ++t) {
            const r = this.lossFunctions[t],
              i = Ft.kc(r(s[t], o[t]));
            n = 0 === t ? i : Ft.x(n, i), e.push(n)
          }
          for (let t = 0; t < this.metricsTensors.length; ++t) {
            const n = this.metricsTensors[t][0],
              r = this.metricsTensors[t][1],
              i = Ft.kc(n(s[r], o[r]));
            e.push(i)
          }
          return e
        })
      }
      async fit(t, e, n = {}) {
        return es(this, t, e, n)
      }
      async fitDataset(t, e) {
        return Jr(this, t, e)
      }
      async trainOnBatch(t, e) {
        const n = await this.standardizeUserData(t, e),
          r = n[0],
          s = n[1],
          i = this.makeTrainFunction()(r.concat(s)),
          a = [];
        for (const t of i) {
          const e = await t.data();
          a.push(e[0])
        }
        return Ft.pb(i), qt(a)
      }
      getNamedWeights(t) {
        const e = [],
          n = null != t && t.trainableOnly,
          r = n ? this.trainableWeights : this.weights,
          s = this.getWeights(n);
        for (let t = 0; t < r.length; ++t) n && !r[t].trainable || e.push({
          name: r[t].originalName,
          tensor: s[t]
        });
        return e
      }
      set stopTraining(t) {
        this.stopTraining_ = t
      }
      get stopTraining() {
        return this.stopTraining_
      }
      get optimizer() {
        return this.optimizer_
      }
      set optimizer(t) {
        this.optimizer_ !== t && (this.optimizer_ = t, this.isOptimizerOwned = !1)
      }
      dispose() {
        const t = super.dispose();
        if (0 === t.refCountAfterDispose && null != this.optimizer && this.isOptimizerOwned) {
          const e = Ft.lc().numTensors;
          this.optimizer_.dispose(), t.numDisposedVariables += e - Ft.lc().numTensors
        }
        return t
      }
      getLossIdentifiers() {
        let t;
        if ("string" == typeof this.loss) t = Jt(this.loss);
        else if (Array.isArray(this.loss)) {
          for (const t of this.loss)
            if ("string" != typeof t) throw new Error("Serialization of non-string loss is not supported.");
          t = this.loss.map(t => Jt(t))
        } else {
          const e = Object.keys(this.loss);
          t = {};
          const n = this.loss;
          for (const r of e) {
            if ("string" != typeof n[r]) throw new Error("Serialization of non-string loss is not supported.");
            t[r] = Jt(n[r])
          }
        }
        return t
      }
      getMetricIdentifiers() {
        if ("string" == typeof this.metrics || "function" == typeof this.metrics) return [Jt(_r(this.metrics))];
        if (Array.isArray(this.metrics)) return this.metrics.map(t => Jt(_r(t))); {
          const t = {};
          for (const e in this.metrics) t[e] = Jt(_r(this.metrics[e]));
          return t
        }
      }
      getTrainingConfig() {
        return {
          loss: this.getLossIdentifiers(),
          metrics: this.getMetricIdentifiers(),
          optimizer_config: {
            class_name: this.optimizer.getClassName(),
            config: this.optimizer.getConfig()
          }
        }
      }
      loadTrainingConfig(t) {
        if (null != t.weighted_metrics) throw new Error("Loading weight_metrics is not supported yet.");
        if (null != t.loss_weights) throw new Error("Loading loss_weights is not supported yet.");
        if (null != t.sample_weight_mode) throw new Error("Loading sample_weight_mode is not supported yet.");
        const e = er($r(t.optimizer_config));
        let n, r;
        if ("string" == typeof t.loss) n = Xt(t.loss);
        else if (Array.isArray(t.loss)) n = t.loss.map(t => Xt(t));
        else if (null != t.loss) {
          n = {};
          for (const e in t.loss) n[e] = Xt(t.loss[e])
        }
        if (Array.isArray(t.metrics)) r = t.metrics.map(t => Xt(t));
        else if (null != t.metrics) {
          r = {};
          for (const e in t.metrics) r[e] = Xt(t.metrics[e])
        }
        this.compile({
          loss: n,
          metrics: r,
          optimizer: e
        })
      }
      async save(t, e) {
        if ("string" == typeof t) {
          const e = Ft.Ob.getSaveHandlers(t);
          if (0 === e.length) throw new Pt(`Cannot find any save handlers for URL '${t}'`);
          if (e.length > 1) throw new Pt(`Found more than one (${e.length}) save handlers for ` + `URL '${t}'`);
          t = e[0]
        }
        if (null == t.save) throw new Pt("LayersModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        const n = await Ft.Ob.encodeWeights(this.getNamedWeights(e)),
          r = {
            modelTopology: this.toJSON(null, !1),
            format: us,
            generatedBy: `TensorFlow.js tfjs-layers v${Rr}`,
            convertedBy: null
          };
        if (null != e && e.includeOptimizer && null != this.optimizer) {
          r.trainingConfig = this.getTrainingConfig();
          const t = "optimizer",
            {
              data: e,
              specs: s
            } = await Ft.Ob.encodeWeights(await this.optimizer.getWeights(), t);
          n.specs.push(...s), n.data = Ft.Ob.concatenateArrayBuffers([n.data, e])
        }
        if (null != this.userDefinedMetadata) {
          const t = !0;
          Cr(this.userDefinedMetadata, this.name, t), r.userDefinedMetadata = this.userDefinedMetadata
        }
        return r.weightData = n.data, r.weightSpecs = n.specs, t.save(r)
      }
      setUserDefinedMetadata(t) {
        Cr(t, this.name), this.userDefinedMetadata = t
      }
      getUserDefinedMetadata() {
        return this.userDefinedMetadata
      }
    }
    cs.className = "Model", Ft.Tc.registerClass(cs);
    class ls extends cs {
      constructor(t) {
        if (super({
            inputs: [],
            outputs: []
          }), t = t || {}, this.trainable = !0, this.built = !1, this.name = null != t.name ? t.name : kn("sequential_"), null != t.layers)
          for (const e of t.layers) this.add(e)
      }
      checkShape(t) {
        if (t.inboundNodes[0].outputTensors[0].shape.some(t => t < 0)) throw new Pt("Negative dimension size caused by adding layer " + `${t.name} with input shape [` + `${t.inboundNodes[0].inputTensors[0].shape}]`)
      }
      add(t) {
        const e = t instanceof ls || t instanceof cs;
        let n;
        if (e) {
          if (n = t, 1 !== n.outputs.length) throw new Pt("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
          if (1 !== n.inputs.length) throw new Pt("All layers in a Sequential model should have a single input tensor. For multi-input layers, use the functional API.")
        }
        if (0 === this.outputs.length) {
          if (0 === t.inboundNodes.length) {
            if (null == t.batchInputShape) throw new Pt("The first layer in a Sequential model must get an `inputShape` or `batchInputShape` argument.");
            const e = Wn({
              batchShape: t.batchInputShape,
              dtype: t.dtype,
              name: t.name + "_input"
            });
            t.apply(e)
          }
          if (e) this.outputs = n.outputs, this.inputs = n.inputs;
          else {
            if (1 !== t.inboundNodes.length) throw new Pt("A layer added to a Sequential model must not already be " + `connected somewhere else. LayersModel received layer ${t.name} ` + `which has ${t.inboundNodes.length} pre-existing inbound ` + "connections.");
            if (1 !== t.inboundNodes[0].outputTensors.length) throw new Pt("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
            this.checkShape(t), this.outputs = [t.inboundNodes[0].outputTensors[0]], this.inputs = function t(e, n, r) {
              if ((null == n || null != r && r > 0) && (n = e.sourceLayer, r = e.nodeIndex), 0 === n.inboundNodes.length) return [e]; {
                const e = n.inboundNodes[r];
                if (0 === e.inboundLayers.length) return e.inputTensors; {
                  const n = [];
                  for (let r = 0; r < e.inboundLayers.length; r++) {
                    const s = t(e.inputTensors[r], e.inboundLayers[r], e.nodeIndices[r]);
                    for (const t of s) - 1 === n.indexOf(t) && n.push(t)
                  }
                  return n
                }
              }
            }(this.outputs[0])
          }
          this.inboundNodes = [], new zn({
            outboundLayer: this,
            inboundLayers: [],
            nodeIndices: [],
            tensorIndices: [],
            inputTensors: this.inputs,
            outputTensors: this.outputs,
            inputMasks: Vt(null, this.inputs.length),
            outputMasks: [null],
            inputShapes: this.inputs.map(t => t.shape),
            outputShapes: this.outputs[0].shape
          })
        } else {
          const e = t.apply(this.outputs[0]);
          if (Array.isArray(e)) throw new TypeError("All layers in a Sequential model should have a single output tensor. For multi-output layers, use the functional API.");
          this.checkShape(t), this.outputs = [e], this.inboundNodes[0].outputTensors = this.outputs, this.inboundNodes[0].outputShapes = [this.outputs[0].shape]
        }
        this.layers.push(t), this.built = !1
      }
      pop() {
        if (0 === this.layers.length) throw new TypeError("There are no layers in the model.");
        if (this.layers.pop(), 0 === this.layers.length) this.outputs = [], this.inboundNodes = [], this.outboundNodes = [];
        else {
          const t = this.layers.length - 1;
          this.layers[t].outboundNodes = [], this.outputs = [this.layers[t].output], this.inboundNodes[0].outputTensors = this.outputs, this.inboundNodes[0].outputShapes = [this.outputs[0].shape]
        }
      }
      call(t, e) {
        return null == this.model && this.build(), this.model.call(t, e)
      }
      build(t) {
        if (Tn(t), 0 === this.inputs.length || 0 === this.outputs.length) throw new TypeError("Sequential model cannot be built: model is empty. Add some layers first.");
        this.model = new cs({
          inputs: this.inputs,
          outputs: this.outputs[0],
          name: this.name + "_model"
        }), this.model.trainable = this.trainable, this.supportsMasking = this.model.supportsMasking, this.inputLayers = this.model.inputLayers, this.inputLayersNodeIndices = this.model.inputLayersNodeIndices, this.inputLayersTensorIndices = this.model.inputLayersTensorIndices, this.outputLayers = this.model.outputLayers, this.outputLayersNodeIndices = this.model.outputLayersNodeIndices, this.outputLayersTensorIndices = this.model.outputLayersTensorIndices, this.nodesByDepth = this.model.nodesByDepth, this.containerNodes = this.model.containerNodes, this.outputNames = this.model.outputNames, this.inputNames = this.model.inputNames, this.built = !0
      }
      countParams() {
        return this.built || this.build(), super.countParams()
      }
      summary(t, e, n = console.log) {
        this.built || this.build(), super.summary(t, e, n)
      }
      setWeights(t) {
        null == this.model && this.build(), this.model.setWeights(t)
      }
      evaluate(t, e, n = {}) {
        if (!this.built) throw new Bt("The model needs to be compiled before being used.");
        return this.model.evaluate(t, e, n)
      }
      async evaluateDataset(t, e) {
        if (!this.built) throw new Bt("The model needs to be compiled before being used.");
        return this.model.evaluateDataset(t, e)
      }
      predict(t, e = {}) {
        return null == this.model && this.build(), this.model.predict(t, e)
      }
      predictOnBatch(t) {
        return null == this.model && this.build(), this.model.predictOnBatch(t)
      }
      compile(t) {
        this.build(), this.model.compile(t), this.optimizer_ = this.model.optimizer, this.isOptimizerOwned = this.model.isOptimizerOwned, this.loss = this.model.loss, this.metrics = this.model.metrics, this.metricsTensors = this.model.metricsTensors, this.metricsNames = this.model.metricsNames
      }
      get optimizer() {
        return null == this.model ? void 0 : this.model.optimizer
      }
      set optimizer(t) {
        this.model.optimizer = t
      }
      async fit(t, e, n = {}) {
        if (!this.built) throw new Bt("The model needs to be compiled before being used.");
        return this.model.fit(t, e, n)
      }
      async fitDataset(t, e) {
        if (!this.built) throw new Bt("The model needs to be compiled before being used.");
        return this.model.fitDataset(t, e)
      }
      async trainOnBatch(t, e) {
        return this.model.trainOnBatch(t, e)
      }
      static fromConfig(t, e, n = {}, r = !1) {
        let s, i = {};
        if (e instanceof Array) {
          if (null == e[0].className || "Merge" === e[0].className) throw new Pt("Legacy serialization format not supported yet.");
          s = e
        } else Ft.Jd.assert(null != e.layers, () => "When the config data for a Sequential model is not an Array, it must be an Object that contains the 'layers' field."), s = e.layers, delete e.layers, i = e;
        const a = new t(i);
        if (!(a instanceof ls)) throw new Wt(`Sequential.fromConfig called on non-Sequential input: ${a}`);
        for (const t of s) {
          const e = er(t, void 0, r);
          r && e.setFastWeightInitDuringBuild(!0), a.add(e)
        }
        return a
      }
      set stopTraining(t) {
        if (null == this.model) throw new Pt("Cannot set the stopTraining property of a sequential model before it is compiled.");
        this.model.stopTraining = t
      }
      get stopTraining() {
        if (null == this.model) throw new Pt("Cannot get the stopTraining property of a sequential model before it is compiled.");
        return this.model.stopTraining
      }
      getConfig() {
        const t = [];
        for (const e of this.layers) {
          const n = {};
          n.className = e.getClassName(), n.config = e.getConfig(), t.push(n)
        }
        return {
          name: this.name,
          layers: t
        }
      }
    }
    ls.className = "Sequential", Ft.Tc.registerClass(ls);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class hs extends Ft.Tc.Serializable {
      getConfig() {
        return {}
      }
    }
    class ds extends hs {
      apply(t, e = 1) {
        return function (t, e = 1) {
          if (1 !== e) throw new Wt(`Support for alpha values other than 1 (${e}) is not implemented ` + "yet.");
          return Ft.tb(t)
        }(t, e)
      }
    }
    ds.className = "elu", Ft.Tc.registerClass(ds);
    class ps extends hs {
      apply(t) {
        return Ft.Rc(t)
      }
    }
    ps.className = "selu", Ft.Tc.registerClass(ps);
    class fs extends hs {
      apply(t) {
        return Ft.Jc(t)
      }
    }
    fs.className = "relu", Ft.Tc.registerClass(fs);
    class ms extends hs {
      apply(t) {
        return Object(Ft.Bd)(() => Ft.nc(6, Ft.Jc(t)))
      }
    }
    ms.className = "relu6", Ft.Tc.registerClass(ms);
    class gs extends hs {
      apply(t) {
        return t
      }
    }
    gs.className = "linear", Ft.Tc.registerClass(gs);
    class bs extends hs {
      apply(t) {
        return Ft.Wc(t)
      }
    }
    bs.className = "sigmoid", Ft.Tc.registerClass(bs);
    class ys extends hs {
      apply(t) {
        return function (t) {
          return Object(Ft.Bd)(() => {
            const e = Ft.x(.5, Ft.qc(.2, t));
            return Ft.W(e, 0, 1)
          })
        }(t)
      }
    }
    ys.className = "hardSigmoid", Ft.Tc.registerClass(ys);
    class ws extends hs {
      apply(t) {
        return Ft.hd(t)
      }
    }
    ws.className = "softplus", Ft.Tc.registerClass(ws);
    class vs extends hs {
      apply(t) {
        return function (t) {
          return Object(Ft.Bd)(() => Ft.qb(t, Ft.u(t).add(1)))
        }(t)
      }
    }
    vs.className = "softsign", Ft.Tc.registerClass(vs);
    class xs extends hs {
      apply(t) {
        return Ft.vd(t)
      }
    }
    xs.className = "tanh", Ft.Tc.registerClass(xs);
    class Os extends hs {
      apply(t, e = -1) {
        return Ft.gd(t, e)
      }
    }
    Os.className = "softmax", Ft.Tc.registerClass(Os);
    class Ss extends hs {
      apply(t, e = -1) {
        return Ft.ac(t, e)
      }
    }

    function _s(t) {
      return t.getClassName()
    }

    function ks(t, e = {}) {
      return Qt(t, Ft.Tc.SerializationMap.getMap().classNameMap, e, "activation")
    }

    function Cs(t) {
      if (null == t) {
        const t = {
          className: "linear",
          config: {}
        };
        return ks(t)
      }
      if ("string" == typeof t) {
        const e = {};
        return e.className = t, e.config = {}, ks(e)
      }
      return t instanceof hs ? t : ks(t)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Es(t) {
      if (null != t && "object" != typeof t) throw new Error("Argument to L1L2 regularizer's constructor is expected to be an " + `object, but received: ${t}`)
    }
    Ss.className = "logSoftmax", Ft.Tc.registerClass(Ss);
    class Is extends Ft.Tc.Serializable {}
    class Ts extends Is {
      constructor(t) {
        super(), Es(t), this.l1 = null == t || null == t.l1 ? .01 : t.l1, this.l2 = null == t || null == t.l2 ? .01 : t.l2, this.hasL1 = 0 !== this.l1, this.hasL2 = 0 !== this.l2
      }
      apply(t) {
        return Object(Ft.Bd)(() => {
          let e = Object(Ft.Pd)([1]);
          return this.hasL1 && (e = Object(Ft.x)(e, Object(Ft.sd)(Ft.qc(this.l1, Object(Ft.u)(t))))), this.hasL2 && (e = Object(Ft.x)(e, Object(Ft.sd)(Ft.qc(this.l2, Ke(t))))), e.asScalar()
        })
      }
      getConfig() {
        return {
          l1: this.l1,
          l2: this.l2
        }
      }
      static fromConfig(t, e) {
        return new t({
          l1: e.l1,
          l2: e.l2
        })
      }
    }
    Ts.className = "L1L2", Ft.Tc.registerClass(Ts);
    const As = {
      l1l2: "L1L2"
    };

    function Ns(t) {
      return Zt(t)
    }

    function $s(t, e = {}) {
      return Qt(t, Ft.Tc.SerializationMap.getMap().classNameMap, e, "regularizer")
    }

    function Rs(t) {
      if (null == t) return null;
      if ("string" == typeof t) {
        return $s({
          className: t in As ? As[t] : t,
          config: {}
        })
      }
      return t instanceof Is ? t : $s(t)
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class js extends Bn {
      constructor(t) {
        super(null == t ? {} : t), this.supportsMasking = !0, null != t && (this.maxValue = t.maxValue)
      }
      call(t, e) {
        t = In(t);
        let n = Object(Ft.Jc)(t);
        return null != this.maxValue && (n = Object(Ft.W)(n, 0, this.maxValue)), n
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = {
            maxValue: this.maxValue
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    js.className = "ReLU", Ft.Tc.registerClass(js);
    class Ds extends Bn {
      constructor(t) {
        super(null == t ? {} : t), this.DEFAULT_ALPHA = .3, null == t && (t = {}), this.alpha = null == t.alpha ? this.DEFAULT_ALPHA : t.alpha
      }
      call(t, e) {
        const n = In(t);
        return Object(Ft.Sb)(n, this.alpha)
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = {
            alpha: this.alpha
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Ds.className = "LeakyReLU", Ft.Tc.registerClass(Ds);
    class Fs extends Bn {
      constructor(t) {
        if (super(null == t ? {} : t), this.DEFAULT_ALPHA_INITIALIZER = "zeros", null == t && (t = {}), this.supportsMasking = !0, this.alphaInitializer = xn(t.alphaInitializer || this.DEFAULT_ALPHA_INITIALIZER), this.alphaRegularizer = Rs(t.alphaRegularizer), this.alphaConstraint = ge(t.alphaConstraint), null == t.sharedAxes) this.sharedAxes = null;
        else if (Array.isArray(t.sharedAxes)) this.sharedAxes = t.sharedAxes;
        else {
          if ("number" != typeof t.sharedAxes) throw new Pt("Expected sharedAxes to be a number or an array of numbers, " + `but got ${t.sharedAxes}`);
          this.sharedAxes = [t.sharedAxes]
        }
      }
      build(t) {
        const e = (t = Tn(t)).slice(1);
        if (null != this.sharedAxes)
          for (const t of this.sharedAxes) e[t - 1] = 1;
        this.alpha = this.addWeight("alpha", e, "float32", this.alphaInitializer, this.alphaRegularizer, !0, this.alphaConstraint);
        const n = {};
        if (null != this.sharedAxes)
          for (let e = 1; e < t.length; ++e) n[e] = t[e];
        this.inputSpec = [new Dn({
          ndim: t.length,
          axes: n
        })], this.built = !0
      }
      call(t, e) {
        return t = In(t), Object(Ft.Ac)(t, this.alpha.read())
      }
      getConfig() {
        const t = {
            alphaInitializer: vn(this.alphaInitializer),
            alphaRegularizer: Ns(this.alphaRegularizer),
            alphaConstraint: fe(this.alphaConstraint),
            sharedAxes: this.sharedAxes
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Fs.className = "PReLU", Ft.Tc.registerClass(Fs);
    class Ms extends Bn {
      constructor(t) {
        if (super(null == t ? {} : t), this.DEFAULT_ALPHA = 1, null == t && (t = {}), null != t.alpha && t.alpha !== this.DEFAULT_ALPHA) throw new Wt(`Non-default alpha value (${t.alpha}) is not supported by the ` + "ELU layer yet.");
        this.alpha = null == t.alpha ? this.DEFAULT_ALPHA : t.alpha
      }
      call(t, e) {
        const n = In(t);
        return Object(Ft.tb)(n)
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = {
            alpha: this.alpha
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Ms.className = "ELU", Ft.Tc.registerClass(Ms);
    class zs extends Bn {
      constructor(t) {
        super(null == t ? {} : t), this.DEFAULT_THETA = 1, null == t && (t = {}), this.theta = null == t.theta ? this.DEFAULT_THETA : t.theta
      }
      call(t, e) {
        const n = In(t);
        return n.mul(Me(n.greater(this.theta), "float32"))
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = {
            theta: this.theta
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    zs.className = "ThresholdedReLU", Ft.Tc.registerClass(zs);
    class Ls extends Bn {
      constructor(t) {
        super(null == t ? {} : t), this.DEFAULT_AXIS = 1, null == t && (t = {}), this.softmax = (new Os).apply, this.axis = null == t.axis ? this.DEFAULT_AXIS : t.axis
      }
      call(t, e) {
        const n = In(t);
        return this.softmax(n, this.axis)
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = {
            axis: this.axis
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Bs(t, e, n) {
      if ("number" == typeof t) return Vt(t, e);
      if (t.length !== e) throw new Pt(`The ${n} argument must be an integer or tuple of ${e} integers.` + ` Received: ${t.length} elements.`);
      for (let s = 0; s < e; ++s) {
        const i = t[s];
        if ((r = i) !== parseInt(r.toString(), 10)) throw new Pt(`The ${n} argument must be an integer or tuple of ${e}` + ` integers. Received: ${JSON.stringify(t)} including a` + ` non-integer number ${i}`)
      }
      return t;
      var r
    }

    function Ps(t, e, n, r, s = 1) {
      if (null == t) return t;
      let i;
      return i = "same" === n ? t : t - (e + (e - 1) * (s - 1)) + 1, Math.floor((i + r - 1) / r)
    }

    function Ws(t, e, n, r) {
      if (null == t) return null;
      if ("valid" === r) t = t * e + De([n - e, 0]);
      else {
        if ("same" !== r) throw new Pt(`Unsupport padding mode: ${r}.`);
        t *= e
      }
      return t
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Us(t, e) {
      return Object(Ft.Bd)(() => (Oe(e), "channelsFirst" === e ? Ft.Fd(t, [0, 2, 3, 1]) : t))
    }

    function Vs(t, e) {
      return Object(Ft.Bd)(() => (Oe(e), "channelsFirst" === e ? Ft.Fd(t, [0, 2, 3, 4, 1]) : t))
    }

    function Hs(t, e, n, r = 1, s = "valid", i, a = 1) {
      return Object(Ft.Bd)(() => {
        if (null == i && (i = "channelsLast"), Oe(i), 3 !== t.shape.length) throw new Pt("The input of a conv1dWithBias operation should be 3, but is " + `${t.shape.length} instead.`);
        if (3 !== e.shape.length) throw new Pt("The kernel for a conv1dWithBias operation should be 3, but is " + `${e.shape.length} instead`);
        if (null != n && 1 !== n.shape.length) throw new Pt("The bias for a conv1dWithBias operation should be 1, but is " + `${e.shape.length} instead`);
        if ("channelsFirst" === i && (t = Ft.Fd(t, [0, 2, 1])), "causal" === s) throw new Wt("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        let o = Ft.eb(t, e, r, "same" === s ? "same" : "valid", "NWC", a);
        return null != n && (o = Xe(o, n)), o
      })
    }

    function Gs(t, e, n, r = [1, 1], s = "valid", i, a, o = null) {
      return Object(Ft.Bd)(() => {
        if (null == i && (i = "channelsLast"), Oe(i), 3 !== t.rank && 4 !== t.rank) throw new Pt("conv2dWithBiasActivation expects input to be of rank 3 or 4, " + `but received ${t.rank}.`);
        if (3 !== e.rank && 4 !== e.rank) throw new Pt("conv2dWithBiasActivation expects kernel to be of rank 3 or 4, " + `but received ${t.rank}.`);
        let u = Us(t, i);
        if ("causal" === s) throw new Wt("The support for CAUSAL padding mode in conv1dWithBias is not implemented yet.");
        return u = Ft.Gb.conv2d({
          x: u,
          filter: e,
          strides: r,
          pad: "same" === s ? "same" : "valid",
          dilations: a,
          dataFormat: "NHWC",
          bias: n,
          activation: o
        }), "channelsFirst" === i && (u = Ft.Fd(u, [0, 3, 1, 2])), u
      })
    }

    function qs(t, e, n, r = [1, 1, 1], s = "valid", i, a) {
      return Object(Ft.Bd)(() => {
        if (null == i && (i = "channelsLast"), Oe(i), 4 !== t.rank && 5 !== t.rank) throw new Pt("conv3dWithBias expects input to be of rank 4 or 5, but received " + `${t.rank}.`);
        if (4 !== e.rank && 5 !== e.rank) throw new Pt("conv3dWithBias expects kernel to be of rank 4 or 5, but received " + `${t.rank}.`);
        let o = Vs(t, i);
        if ("causal" === s) throw new Wt("The support for CAUSAL padding mode in conv3dWithBias is not implemented yet.");
        return o = Ft.hb(o, e, r, "same" === s ? "same" : "valid", "NDHWC", a), null != n && (o = Xe(o, n)), "channelsFirst" === i && (o = Ft.Fd(o, [0, 4, 1, 2, 3])), o
      })
    }
    Ls.className = "Softmax", Ft.Tc.registerClass(Ls);
    class Ks extends Bn {
      constructor(t, e) {
        if (super(e), this.bias = null, this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_BIAS_INITIALIZER = "zeros", Ks.verifyArgs(e), this.rank = t, ie(this.rank, "rank"), 1 !== this.rank && 2 !== this.rank && 3 !== this.rank) throw new Wt(`Convolution layer for rank other than 1, 2, or 3 (${this.rank}) is ` + "not implemented yet.");
        if (this.kernelSize = Bs(e.kernelSize, t, "kernelSize"), this.strides = Bs(null == e.strides ? 1 : e.strides, t, "strides"), this.padding = null == e.padding ? "valid" : e.padding, Se(this.padding), this.dataFormat = null == e.dataFormat ? "channelsLast" : e.dataFormat, Oe(this.dataFormat), this.activation = Cs(e.activation), this.useBias = null == e.useBias || e.useBias, this.biasInitializer = xn(e.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.biasConstraint = ge(e.biasConstraint), this.biasRegularizer = Rs(e.biasRegularizer), this.activityRegularizer = Rs(e.activityRegularizer), this.dilationRate = Bs(null == e.dilationRate ? 1 : e.dilationRate, t, "dilationRate"), 1 === this.rank && Array.isArray(this.dilationRate) && 1 !== this.dilationRate.length) throw new Pt("dilationRate must be a number or an array of a single number for 1D convolution, but received " + `${JSON.stringify(this.dilationRate)}`);
        if (2 === this.rank) {
          if ("number" == typeof this.dilationRate) this.dilationRate = [this.dilationRate, this.dilationRate];
          else if (2 !== this.dilationRate.length) throw new Pt("dilationRate must be a number or array of two numbers for 2D " + `convolution, but received ${JSON.stringify(this.dilationRate)}`)
        } else if (3 === this.rank)
          if ("number" == typeof this.dilationRate) this.dilationRate = [this.dilationRate, this.dilationRate, this.dilationRate];
          else if (3 !== this.dilationRate.length) throw new Pt("dilationRate must be a number or array of three numbers for 3D " + `convolution, but received ${JSON.stringify(this.dilationRate)}`)
      }
      static verifyArgs(t) {
        if (Ht("kernelSize" in t, "required key 'kernelSize' not in config"), "number" != typeof t.kernelSize && !se(t.kernelSize, "number", 1, 3)) throw new Pt("BaseConv expects config.kernelSize to be number or number[] with " + `length 1, 2, or 3, but received ${JSON.stringify(t.kernelSize)}.`)
      }
      getConfig() {
        const t = {
            kernelSize: this.kernelSize,
            strides: this.strides,
            padding: this.padding,
            dataFormat: this.dataFormat,
            dilationRate: this.dilationRate,
            activation: _s(this.activation),
            useBias: this.useBias,
            biasInitializer: vn(this.biasInitializer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            biasConstraint: fe(this.biasConstraint)
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    class Js extends Ks {
      constructor(t, e) {
        super(t, e), this.kernel = null, Js.verifyArgs(e), this.filters = e.filters, ie(this.filters, "filters"), this.kernelInitializer = xn(e.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.kernelConstraint = ge(e.kernelConstraint), this.kernelRegularizer = Rs(e.kernelRegularizer)
      }
      build(t) {
        t = Tn(t);
        const e = "channelsFirst" === this.dataFormat ? 1 : t.length - 1;
        if (null == t[e]) throw new Pt("The channel dimension of the input should be defined. " + `Found ${t[e]}`);
        const n = t[e],
          r = this.kernelSize.concat([n, this.filters]);
        this.kernel = this.addWeight("kernel", r, null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [this.filters], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [{
          ndim: this.rank + 2,
          axes: {
            [e]: n
          }
        }], this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          let e;
          t = In(t);
          const n = null == this.bias ? null : this.bias.read(),
            r = ae(this.activation.getClassName());
          if (null != r && 2 === this.rank) e = Gs(t, this.kernel.read(), n, this.strides, this.padding, this.dataFormat, this.dilationRate, r);
          else {
            if (1 === this.rank) e = Hs(t, this.kernel.read(), n, this.strides[0], this.padding, this.dataFormat, this.dilationRate[0]);
            else if (2 === this.rank) e = Gs(t, this.kernel.read(), n, this.strides, this.padding, this.dataFormat, this.dilationRate);
            else {
              if (3 !== this.rank) throw new Wt("convolutions greater than 3D are not implemented yet.");
              e = qs(t, this.kernel.read(), n, this.strides, this.padding, this.dataFormat, this.dilationRate)
            }
            null != this.activation && (e = this.activation.apply(e))
          }
          return e
        })
      }
      computeOutputShape(t) {
        t = Tn(t);
        const e = [],
          n = "channelsLast" === this.dataFormat ? t.slice(1, t.length - 1) : t.slice(2);
        for (let t = 0; t < n.length; ++t) {
          const r = Ps(n[t], this.kernelSize[t], this.padding, this.strides[t], "number" == typeof this.dilationRate ? this.dilationRate : this.dilationRate[t]);
          e.push(r)
        }
        let r = [t[0]];
        return "channelsLast" === this.dataFormat ? (r = r.concat(e), r.push(this.filters)) : (r.push(this.filters), r = r.concat(e)), r
      }
      getConfig() {
        const t = {
            filters: this.filters,
            kernelInitializer: vn(this.kernelInitializer),
            kernelRegularizer: Ns(this.kernelRegularizer),
            kernelConstraint: fe(this.kernelConstraint)
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
      static verifyArgs(t) {
        if (!("filters" in t) || "number" != typeof t.filters || t.filters < 1) throw new Pt("Convolution layer expected config.filters to be a 'number' > 0 " + `but got ${JSON.stringify(t.filters)}`)
      }
    }
    class Xs extends Js {
      constructor(t) {
        super(2, t), Xs.verifyArgs(t)
      }
      getConfig() {
        const t = super.getConfig();
        return delete t.rank, t
      }
      static verifyArgs(t) {
        if ("number" != typeof t.kernelSize && !se(t.kernelSize, "number", 1, 2)) throw new Pt("Conv2D expects config.kernelSize to be number or number[] with " + `length 1 or 2, but received ${JSON.stringify(t.kernelSize)}.`)
      }
    }
    Xs.className = "Conv2D", Ft.Tc.registerClass(Xs);
    class Ys extends Js {
      constructor(t) {
        super(3, t), Ys.verifyArgs(t)
      }
      getConfig() {
        const t = super.getConfig();
        return delete t.rank, t
      }
      static verifyArgs(t) {
        if ("number" != typeof t.kernelSize && (!Array.isArray(t.kernelSize) || 1 !== t.kernelSize.length && 3 !== t.kernelSize.length)) throw new Pt("Conv3D expects config.kernelSize to be number or" + ` [number, number, number], but received ${JSON.stringify(t.kernelSize)}.`)
      }
    }
    Ys.className = "Conv3D", Ft.Tc.registerClass(Ys);
    class Zs extends Xs {
      constructor(t) {
        if (super(t), this.inputSpec = [new Dn({
            ndim: 4
          })], "same" !== this.padding && "valid" !== this.padding) throw new Pt("Conv2DTranspose currently supports only padding modes 'same' " + `and 'valid', but received padding mode ${this.padding}`)
      }
      build(t) {
        if (4 !== (t = Tn(t)).length) throw new Pt("Input should have rank 4; Received input shape: " + JSON.stringify(t));
        const e = "channelsFirst" === this.dataFormat ? 1 : t.length - 1;
        if (null == t[e]) throw new Pt("The channel dimension of the inputs should be defined. Found `None`.");
        const n = t[e],
          r = this.kernelSize.concat([this.filters, n]);
        this.kernel = this.addWeight("kernel", r, "float32", this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint)), this.inputSpec = [new Dn({
          ndim: 4,
          axes: {
            [e]: n
          }
        })], this.built = !0
      }
      call(t, e) {
        return Ft.Bd(() => {
          let e = In(t);
          if (4 !== e.shape.length) throw new Pt("Conv2DTranspose.call() expects input tensor to be rank-4, but " + `received a tensor of rank-${e.shape.length}`);
          const n = e.shape,
            r = n[0];
          let s, i;
          "channelsFirst" === this.dataFormat ? (s = 2, i = 3) : (s = 1, i = 2);
          const a = n[s],
            o = n[i],
            u = this.kernelSize[0],
            c = this.kernelSize[1],
            l = this.strides[0],
            h = this.strides[1],
            d = [r, Ws(a, l, u, this.padding), Ws(o, h, c, this.padding), this.filters];
          "channelsLast" !== this.dataFormat && (e = Ft.Fd(e, [0, 2, 3, 1]));
          let p = Ft.gb(e, this.kernel.read(), d, this.strides, this.padding);
          return "channelsLast" !== this.dataFormat && (p = Ft.Fd(p, [0, 3, 1, 2])), null != this.bias && (p = Xe(p, this.bias.read(), this.dataFormat)), null != this.activation && (p = this.activation.apply(p)), p
        })
      }
      computeOutputShape(t) {
        const e = (t = Tn(t)).slice();
        let n, r, s;
        "channelsFirst" === this.dataFormat ? (n = 1, r = 2, s = 3) : (n = 3, r = 1, s = 2);
        const i = this.kernelSize[0],
          a = this.kernelSize[1],
          o = this.strides[0],
          u = this.strides[1];
        return e[n] = this.filters, e[r] = Ws(e[r], o, i, this.padding), e[s] = Ws(e[s], u, a, this.padding), e
      }
      getConfig() {
        const t = super.getConfig();
        return delete t.dilationRate, t
      }
    }
    Zs.className = "Conv2DTranspose", Ft.Tc.registerClass(Zs);
    class Qs extends Js {
      constructor(t, e) {
        if (super(t, e), this.DEFAULT_DEPTHWISE_INITIALIZER = "glorotUniform", this.DEFAULT_POINTWISE_INITIALIZER = "glorotUniform", this.depthwiseKernel = null, this.pointwiseKernel = null, null == e.filters) throw new Pt("The `filters` configuration field is required by SeparableConv, but is unspecified.");
        if (null != e.kernelInitializer || null != e.kernelRegularizer || null != e.kernelConstraint) throw new Pt("Fields kernelInitializer, kernelRegularizer and kernelConstraint are invalid for SeparableConv2D. Use depthwiseInitializer, depthwiseRegularizer, depthwiseConstraint, pointwiseInitializer, pointwiseRegularizer and pointwiseConstraint instead.");
        if (null != e.padding && "same" !== e.padding && "valid" !== e.padding) throw new Pt(`SeparableConv${this.rank}D supports only padding modes: ` + `'same' and 'valid', but received ${JSON.stringify(e.padding)}`);
        this.depthMultiplier = null == e.depthMultiplier ? 1 : e.depthMultiplier, this.depthwiseInitializer = xn(e.depthwiseInitializer || this.DEFAULT_DEPTHWISE_INITIALIZER), this.depthwiseRegularizer = Rs(e.depthwiseRegularizer), this.depthwiseConstraint = ge(e.depthwiseConstraint), this.pointwiseInitializer = xn(e.depthwiseInitializer || this.DEFAULT_POINTWISE_INITIALIZER), this.pointwiseRegularizer = Rs(e.pointwiseRegularizer), this.pointwiseConstraint = ge(e.pointwiseConstraint)
      }
      build(t) {
        if ((t = Tn(t)).length < this.rank + 2) throw new Pt(`Inputs to SeparableConv${this.rank}D should have rank ` + `${this.rank+2}, but received input shape: ` + `${JSON.stringify(t)}`);
        const e = "channelsFirst" === this.dataFormat ? 1 : t.length - 1;
        if (null == t[e] || t[e] < 0) throw new Pt("The channel dimension of the inputs should be defined, " + `but found ${JSON.stringify(t[e])}`);
        const n = t[e],
          r = this.kernelSize.concat([n, this.depthMultiplier]),
          s = [];
        for (let t = 0; t < this.rank; ++t) s.push(1);
        s.push(n * this.depthMultiplier, this.filters);
        this.depthwiseKernel = this.addWeight("depthwise_kernel", r, "float32", this.depthwiseInitializer, this.depthwiseRegularizer, !0, this.depthwiseConstraint), this.pointwiseKernel = this.addWeight("pointwise_kernel", s, "float32", this.pointwiseInitializer, this.pointwiseRegularizer, !0, this.pointwiseConstraint), this.useBias ? this.bias = this.addWeight("bias", [this.filters], "float32", this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.inputSpec = [new Dn({
          ndim: this.rank + 2,
          axes: {
            [e]: n
          }
        })], this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          let e;
          if (t = In(t), 1 === this.rank) throw new Wt("1D separable convolution is not implemented yet.");
          return 2 === this.rank && ("channelsFirst" === this.dataFormat && (t = Ft.Fd(t, [0, 2, 3, 1])), e = Ft.Sc(t, this.depthwiseKernel.read(), this.pointwiseKernel.read(), this.strides, this.padding, this.dilationRate, "NHWC")), this.useBias && (e = Xe(e, this.bias.read(), this.dataFormat)), null != this.activation && (e = this.activation.apply(e)), "channelsFirst" === this.dataFormat && (e = Ft.Fd(e, [0, 3, 1, 2])), e
        })
      }
      getConfig() {
        const t = super.getConfig();
        return delete t.rank, delete t.kernelInitializer, delete t.kernelRegularizer, delete t.kernelConstraint, t.depthwiseInitializer = vn(this.depthwiseInitializer), t.pointwiseInitializer = vn(this.pointwiseInitializer), t.depthwiseRegularizer = Ns(this.depthwiseRegularizer), t.pointwiseRegularizer = Ns(this.pointwiseRegularizer), t.depthwiseConstraint = fe(this.depthwiseConstraint), t.pointwiseConstraint = fe(this.pointwiseConstraint), t
      }
    }
    Qs.className = "SeparableConv";
    class ti extends Qs {
      constructor(t) {
        super(2, t)
      }
    }
    ti.className = "SeparableConv2D", Ft.Tc.registerClass(ti);
    class ei extends Js {
      constructor(t) {
        super(1, t), ei.verifyArgs(t), this.inputSpec = [{
          ndim: 3
        }]
      }
      getConfig() {
        const t = super.getConfig();
        return delete t.rank, delete t.dataFormat, t
      }
      static verifyArgs(t) {
        if ("number" != typeof t.kernelSize && !se(t.kernelSize, "number", 1, 1)) throw new Pt("Conv1D expects config.kernelSize to be number or number[] with " + `length 1, but received ${JSON.stringify(t.kernelSize)}.`)
      }
    }
    ei.className = "Conv1D", Ft.Tc.registerClass(ei);
    class ni extends Bn {
      constructor(t) {
        super(t), "number" == typeof t.cropping ? this.cropping = [
          [t.cropping, t.cropping],
          [t.cropping, t.cropping]
        ] : "number" == typeof t.cropping[0] ? this.cropping = [
          [t.cropping[0], t.cropping[0]],
          [t.cropping[1], t.cropping[1]]
        ] : this.cropping = t.cropping, this.dataFormat = void 0 === t.dataFormat ? "channelsLast" : t.dataFormat, this.inputSpec = [{
          ndim: 4
        }]
      }
      computeOutputShape(t) {
        return "channelsFirst" === this.dataFormat ? [t[0], t[1], t[2] - this.cropping[0][0] - this.cropping[0][1], t[3] - this.cropping[1][0] - this.cropping[1][1]] : [t[0], t[1] - this.cropping[0][0] - this.cropping[0][1], t[2] - this.cropping[1][0] - this.cropping[1][1], t[3]]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          if (t = In(t), "channelsLast" === this.dataFormat) {
            const e = Pe(t, this.cropping[0][0], t.shape[1] - this.cropping[0][0] - this.cropping[0][1], 2);
            return Pe(e, this.cropping[1][0], t.shape[2] - this.cropping[1][1] - this.cropping[1][0], 3)
          } {
            const e = Pe(t, this.cropping[0][0], t.shape[2] - this.cropping[0][0] - this.cropping[0][1], 3);
            return Pe(e, this.cropping[1][0], t.shape[3] - this.cropping[1][1] - this.cropping[1][0], 4)
          }
        })
      }
      getConfig() {
        const t = {
            cropping: this.cropping,
            dataFormat: this.dataFormat
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    ni.className = "Cropping2D", Ft.Tc.registerClass(ni);
    class ri extends Bn {
      constructor(t) {
        super(t), this.DEFAULT_SIZE = [2, 2], this.inputSpec = [{
          ndim: 4
        }], this.size = null == t.size ? this.DEFAULT_SIZE : t.size, this.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat
      }
      computeOutputShape(t) {
        if ("channelsFirst" === this.dataFormat) {
          const e = null == t[2] ? null : this.size[0] * t[2],
            n = null == t[3] ? null : this.size[1] * t[3];
          return [t[0], t[1], e, n]
        } {
          const e = null == t[1] ? null : this.size[0] * t[1],
            n = null == t[2] ? null : this.size[1] * t[2];
          return [t[0], e, n, t[3]]
        }
      }
      call(t, e) {
        return Ft.Bd(() => {
          let e = In(t);
          const n = e.shape;
          if ("channelsFirst" === this.dataFormat) {
            e = Ft.Fd(e, [0, 2, 3, 1]);
            const t = this.size[0] * n[2],
              r = this.size[1] * n[3],
              s = e.resizeNearestNeighbor([t, r]);
            return Ft.Fd(s, [0, 3, 1, 2])
          } {
            const t = this.size[0] * n[1],
              r = this.size[1] * n[2];
            return e.resizeNearestNeighbor([t, r])
          }
        })
      }
      getConfig() {
        const t = {
            size: this.size,
            dataFormat: this.dataFormat
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    ri.className = "UpSampling2D", Ft.Tc.registerClass(ri);
    class si extends Ks {
      constructor(t) {
        super(2, t), this.depthwiseKernel = null, this.depthMultiplier = null == t.depthMultiplier ? 1 : t.depthMultiplier, this.depthwiseInitializer = xn(t.depthwiseInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.depthwiseConstraint = ge(t.depthwiseConstraint), this.depthwiseRegularizer = Rs(t.depthwiseRegularizer)
      }
      build(t) {
        if ((t = Tn(t)).length < 4) throw new Pt("Inputs to DepthwiseConv2D should have rank 4. " + `Received input shape: ${JSON.stringify(t)}.`);
        const e = "channelsFirst" === this.dataFormat ? 1 : 3;
        if (null == t[e] || t[e] < 0) throw new Pt("The channel dimension of the inputs to DepthwiseConv2D should " + `be defined, but is not (${t[e]}).`);
        const n = t[e],
          r = [this.kernelSize[0], this.kernelSize[1], n, this.depthMultiplier];
        this.depthwiseKernel = this.addWeight("depthwise_kernel", r, null, this.depthwiseInitializer, this.depthwiseRegularizer, !0, this.depthwiseConstraint), this.useBias ? this.bias = this.addWeight("bias", [n * this.depthMultiplier], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          let e =
            /**
             * @license
             * Copyright 2018 Google LLC
             *
             * Use of this source code is governed by an MIT-style
             * license that can be found in the LICENSE file or at
             * https://opensource.org/licenses/MIT.
             * =============================================================================
             */
            function (t, e, n = [1, 1], r = "valid", s, i) {
              return Object(Ft.Bd)(() => {
                null == s && (s = "channelsLast"), Oe(s);
                let a = Us(t, s);
                if (4 !== t.rank) throw new Pt("Input for depthwiseConv2d is required to be 4-D, but is instead " + `${t.rank}-D`);
                if (4 !== e.rank) throw new Pt("depthwiseKernel is required to be 4-D, but is instead " + `${e.rank}-D`);
                return a = Ft.mb(a, e, n, "same" === r ? "same" : "valid", "NHWC", i), "channelsFirst" === s && (a = Ft.Fd(a, [0, 3, 1, 2])), a
              })
            }(t = In(t), this.depthwiseKernel.read(), this.strides, this.padding, this.dataFormat, null);
          return this.useBias && (e = Xe(e, this.bias.read(), this.dataFormat)), null != this.activation && (e = this.activation.apply(e)), e
        })
      }
      computeOutputShape(t) {
        t = Tn(t);
        const e = "channelsFirst" === this.dataFormat ? t[2] : t[1],
          n = "channelsFirst" === this.dataFormat ? t[3] : t[2],
          r = "channelsFirst" === this.dataFormat ? t[1] * this.depthMultiplier : t[3] * this.depthMultiplier,
          s = Ps(e, this.kernelSize[0], this.padding, this.strides[0]),
          i = Ps(n, this.kernelSize[1], this.padding, this.strides[1]);
        return "channelsFirst" === this.dataFormat ? [t[0], r, s, i] : [t[0], s, i, r]
      }
      getConfig() {
        const t = super.getConfig();
        return t.depthMultiplier = this.depthMultiplier, t.depthwiseInitializer = vn(this.depthwiseInitializer), t.depthwiseRegularizer = Ns(this.depthwiseRegularizer), t.depthwiseConstraint = fe(this.depthwiseRegularizer), t
      }
    }
    si.className = "DepthwiseConv2D", Ft.Tc.registerClass(si);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class ii extends Bn {
      constructor(t) {
        super(t), this.rate = Math.max(Math.min(t.rate, 1), 0), this.noiseShape = t.noiseShape, this.seed = t.seed, this.supportsMasking = !0
      }
      getNoiseShape(t) {
        if (null == this.noiseShape) return this.noiseShape;
        const e = t.shape,
          n = [];
        for (let t = 0; t < this.noiseShape.length; ++t) n.push(null == this.noiseShape[t] ? e[t] : this.noiseShape[t]);
        return n
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t);
          if (0 < this.rate && this.rate < 1) {
            const t = null != e.training && e.training,
              r = this.getNoiseShape(n);
            return Ze(() => Ye(n, this.rate, r, this.seed), () => n, t)
          }
          return t
        })
      }
      getConfig() {
        const t = {
            rate: this.rate,
            noiseShape: this.noiseShape,
            seed: this.seed
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
      dispose() {
        return super.dispose()
      }
    }
    ii.className = "Dropout", Ft.Tc.registerClass(ii);
    class ai extends ii {
      constructor(t) {
        super(t), this.inputSpec = [{
          ndim: 3
        }]
      }
      getNoiseShape(t) {
        const e = t.shape;
        return [e[0], 1, e[2]]
      }
    }
    ai.className = "SpatialDropout1D", Ft.Tc.registerClass(ai);
    class oi extends Bn {
      constructor(t) {
        if (super(t), this.activation = null, this.useBias = !0, this.kernel = null, this.bias = null, this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_BIAS_INITIALIZER = "zeros", null == t.batchInputShape && null == t.inputShape && null != t.inputDim) {
          let e = null;
          null != t.batchSize && (e = t.batchSize), this.batchInputShape = [e, t.inputDim]
        }
        this.units = t.units, ie(this.units, "units"), this.activation = Cs(t.activation), null != t.useBias && (this.useBias = t.useBias), this.kernelInitializer = xn(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.biasInitializer = xn(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.kernelConstraint = ge(t.kernelConstraint), this.biasConstraint = ge(t.biasConstraint), this.kernelRegularizer = Rs(t.kernelRegularizer), this.biasRegularizer = Rs(t.biasRegularizer), this.activityRegularizer = Rs(t.activityRegularizer), this.supportsMasking = !0, this.inputSpec = [{
          minNDim: 2
        }]
      }
      build(t) {
        const e = (t = Tn(t))[t.length - 1];
        null == this.kernel && (this.kernel = this.addWeight("kernel", [e, this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.useBias && (this.bias = this.addWeight("bias", [this.units], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint))), this.inputSpec = [{
          minNDim: 2,
          axes: {
            [-1]: e
          }
        }], this.built = !0
      }
      computeOutputShape(t) {
        const e = (t = Tn(t)).slice();
        return e[e.length - 1] = this.units, e
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t),
            r = ae(this.activation.getClassName());
          let s;
          return null != r ? s = Ge(n, this.kernel.read(), r, this.bias ? this.bias.read() : null) : (s = Ge(n, this.kernel.read()), null != this.bias && (s = Xe(s, this.bias.read())), null != this.activation && (s = this.activation.apply(s))), s
        })
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            biasInitializer: vn(this.biasInitializer),
            kernelRegularizer: Ns(this.kernelRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            biasConstraint: fe(this.biasConstraint)
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    oi.className = "Dense", Ft.Tc.registerClass(oi);
    class ui extends Bn {
      constructor(t) {
        super(t = t || {}), this.inputSpec = [{
          minNDim: 3
        }], this.dataFormat = t.dataFormat
      }
      computeOutputShape(t) {
        t = Tn(t);
        for (const e of t.slice(1))
          if (null == e) throw new Pt('The shape of the input to "Flatten" is not fully defined ' + `(got ${t.slice(1)}). Make sure to pass a complete ` + '"input_shape" or "batch_input_shape" argument to the first layer in your model.');
        return [t[0], $e(t, 1)]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          let n = In(t);
          if ("channelsFirst" === this.dataFormat && n.rank > 1) {
            const t = [0];
            for (let e = 2; e < n.rank; ++e) t.push(e);
            t.push(1), n = n.transpose(t)
          }
          return function (t) {
            if (t.rank <= 1) throw new Pt(`batchFlatten requires a minimum rank of 2. Got rank: ${t.rank}.`);
            const e = [t.shape[0], $e(t.shape, 1)];
            return t.reshape(e)
          }(n)
        })
      }
      getConfig() {
        const t = {};
        null != this.dataFormat && (t.dataFormat = this.dataFormat);
        const e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    ui.className = "Flatten", Ft.Tc.registerClass(ui);
    class ci extends Bn {
      constructor(t) {
        super(t), this.supportsMasking = !0, this.activation = Cs(t.activation)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t);
          return this.activation.apply(n)
        })
      }
      getConfig() {
        const t = {
            activation: _s(this.activation)
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    ci.className = "Activation", Ft.Tc.registerClass(ci);
    class li extends Bn {
      constructor(t) {
        super(t), this.n = t.n, this.inputSpec = [{
          ndim: 2
        }]
      }
      computeOutputShape(t) {
        return [t[0], this.n, t[1]]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => (function (t, e) {
          return Object(Ft.Bd)(() => {
            if (2 !== t.shape.length) throw new Pt("repeat() expects a rank-2 tensor, but received a " + `rank-${t.shape.length} tensor.`);
            return Ve(ze(t, 1), [1, e, 1])
          })
        })(t = In(t), this.n))
      }
      getConfig() {
        const t = {
            n: this.n
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    li.className = "RepeatVector", Ft.Tc.registerClass(li);
    class hi extends Bn {
      constructor(t) {
        super(t), this.targetShape = t.targetShape;
        for (let t = 0; t < this.targetShape.length; ++t) this.isUnknown(this.targetShape[t]) && (this.targetShape[t] = null)
      }
      isUnknown(t) {
        return t < 0 || null == t
      }
      fixUnknownDimension(t, e) {
        const n = "Total size of new array must be unchanged.",
          r = e.slice();
        let s = 1,
          i = null;
        for (let t = 0; t < r.length; ++t) {
          const e = r[t];
          if (this.isUnknown(e)) {
            if (null !== i) throw new Pt("Can only specifiy one unknown dimension.");
            i = t
          } else s *= e
        }
        const a = $e(t);
        if (null !== i) {
          if (0 === s || a % s != 0) throw new Pt(n);
          r[i] = a / s
        } else if (a !== s) throw new Pt(n);
        return r
      }
      computeOutputShape(t) {
        let e = !1;
        for (let n = 0; n < t.length; ++n)
          if (this.isUnknown(t[n])) {
            e = !0;
            break
          } return e ? t.slice(0, 1).concat(this.targetShape) : t.slice(0, 1).concat(this.fixUnknownDimension(t.slice(1), this.targetShape))
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t),
            r = n.shape,
            s = r.slice(0, 1).concat(this.fixUnknownDimension(r.slice(1), this.targetShape));
          return n.reshape(s)
        })
      }
      getConfig() {
        const t = {
            targetShape: this.targetShape
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    hi.className = "Reshape", Ft.Tc.registerClass(hi);
    class di extends Bn {
      constructor(t) {
        if (super(t), null == t.dims) throw new Error("Required configuration field `dims` is missing during Permute constructor call.");
        if (!Array.isArray(t.dims)) throw new Error("Permute constructor requires `dims` to be an Array, but received " + `${t.dims} instead.`);
        const e = Fe(1, t.dims.length + 1);
        if (!Ft.Jd.arraysEqual(t.dims.slice().sort(), e)) throw new Error("Invalid permutation `dims`: " + JSON.stringify(t.dims) + " `dims` must contain consecutive integers starting from 1.");
        this.dims = t.dims, this.dimsIncludingBatch = [0].concat(this.dims), this.inputSpec = [new Dn({
          ndim: this.dims.length + 1
        })]
      }
      computeOutputShape(t) {
        const e = (t = Tn(t)).slice();
        return this.dims.forEach((n, r) => {
          e[r + 1] = t[n]
        }), e
      }
      call(t, e) {
        return Object(Ft.Fd)(In(t), this.dimsIncludingBatch)
      }
      getConfig() {
        const t = {
            dims: this.dims
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    di.className = "Permute", Ft.Tc.registerClass(di);
    class pi extends Bn {
      constructor(t) {
        super(null == t ? {} : t), this.supportsMasking = !0, this.maskValue = null != t ? null == t.maskValue ? 0 : t.maskValue : 0
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = super.getConfig(),
          e = {
            maskValue: this.maskValue
          };
        return Object.assign(e, t), e
      }
      computeMask(t, e) {
        const n = In(t);
        return Object(Ft.A)(Object(Ft.uc)(n, this.maskValue), -1)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t),
            r = Object(Ft.A)(Object(Ft.uc)(n, this.maskValue), -1, !0);
          return n.mul(r.asType(n.dtype))
        })
      }
    }
    pi.className = "Masking", Ft.Tc.registerClass(pi);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class fi extends Bn {
      constructor(t) {
        if (super(t), this.embeddings = null, this.DEFAULT_EMBEDDINGS_INITIALIZER = "randomUniform", null == t.batchInputShape && null == t.inputShape) {
          let e = null;
          null != t.batchSize && (e = t.batchSize), null == t.inputLength ? this.batchInputShape = [e, null] : this.batchInputShape = [e].concat(Kt(t.inputLength))
        }
        this.inputDim = t.inputDim, ie(this.inputDim, "inputDim"), this.outputDim = t.outputDim, ie(this.outputDim, "outputDim"), this.embeddingsInitializer = xn(t.embeddingsInitializer || this.DEFAULT_EMBEDDINGS_INITIALIZER), this.embeddingsRegularizer = Rs(t.embeddingsRegularizer), this.activityRegularizer = Rs(t.activityRegularizer), this.embeddingsConstraint = ge(t.embeddingsConstraint), this.maskZero = t.maskZero, this.supportsMasking = t.maskZero, this.inputLength = t.inputLength
      }
      build(t) {
        this.embeddings = this.addWeight("embeddings", [this.inputDim, this.outputDim], this.dtype, this.embeddingsInitializer, this.embeddingsRegularizer, !0, this.embeddingsConstraint), this.built = !0
      }
      warnOnIncompatibleInputShape(t) {}
      computeMask(t, e) {
        return Object(Ft.Bd)(() => this.maskZero ? (t = In(t), Object(Ft.uc)(t, Object(Ft.Qd)(t))) : null)
      }
      computeOutputShape(t) {
        if (t = Tn(t), null == this.inputLength) return [...t, this.outputDim];
        const e = Kt(this.inputLength);
        if (e.length !== t.length - 1) throw new Pt(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${t}`); {
          let n = 0;
          for (let r = 0; r < e.length; ++r) {
            const s = e[r],
              i = t[r + 1];
            if (null != s && null != i && s !== i) throw new Pt(`"inputLength" is ${this.inputLength}, but received ` + `input shape has shape ${t}`);
            null == s && (e[n] = i), n++
          }
        }
        return [t[0], ...e, this.outputDim]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          let n = In(t);
          return "int32" !== n.dtype && (n = Me(n, "int32")), qe(this.embeddings.read(), n.as1D()).reshape(Tn(this.computeOutputShape(n.shape)))
        })
      }
      getConfig() {
        const t = {
            inputDim: this.inputDim,
            outputDim: this.outputDim,
            embeddingsInitializer: vn(this.embeddingsInitializer),
            embeddingsRegularizer: Ns(this.embeddingsRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            embeddingsConstraint: fe(this.embeddingsConstraint),
            maskZero: this.maskZero,
            inputLength: this.inputLength
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    fi.className = "Embedding", Ft.Tc.registerClass(fi);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class mi extends Bn {
      constructor(t) {
        super(t || {}), this.supportsMasking = !0
      }
      mergeFunction(t) {
        throw new Wt
      }
      computeElementwiseOpOutputShape(t, e) {
        if (null == t || null == e) return null;
        if (t.length < e.length) return this.computeElementwiseOpOutputShape(e, t);
        if (0 === e.length) return t;
        const n = t.slice(0, t.length - e.length);
        for (let r = 0; r < e.length; ++r) {
          const s = t[t.length - e.length + r],
            i = e[r];
          if (null == s || null == i || s < 0 || i < 0) n.push(null);
          else if (1 === s) n.push(i);
          else if (1 === i) n.push(s);
          else {
            if (s !== i) throw new Pt("Operands could not be broadcast together with shapes " + JSON.stringify(t) + " " + JSON.stringify(e));
            n.push(s)
          }
        }
        return n
      }
      build(t) {
        if (Array.isArray(t) && !Array.isArray(t[0]) && (t = [Tn(t)]), (t = t).length < 2) throw new Pt("A merge layer should be called on an Array of at least 2 inputs." + ` Got ${t.length} input(s).`);
        let e = [];
        for (const n of t) null != n && null !== n[0] && e.push(n[0]);
        if (e = ee(e), e.length > 1) throw new Pt("Can not merge tensors with different batch sizes. " + `Got tensors with shapes: ${JSON.stringify(t)}.`);
        let n = null == t[0] ? null : t[0].slice(1);
        for (let e = 1; e < t.length; ++e) {
          const r = null == t[e] ? null : t[e].slice(1);
          n = this.computeElementwiseOpOutputShape(n, r)
        }
        const r = t.map(t => t.length); - 1 === t.indexOf(null) && 1 === ee(r).length ? this.reshapeRequired = !1 : this.reshapeRequired = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          if (t = t, this.reshapeRequired) {
            const e = [],
              n = t.map(t => t.rank);
            if (-1 === n.indexOf(null)) {
              const r = De(n);
              for (let n of t) {
                const t = n.rank;
                for (let e = 0; e < r - t; ++e) n = ze(n, 1);
                e.push(n)
              }
              return this.mergeFunction(e)
            } {
              let n = !1;
              for (const r of t) {
                const t = r.rank;
                if (null == t) {
                  const t = r.shape,
                    s = t[0],
                    i = t.slice(1).concat([s]);
                  let a = r.reshape([s].concat($e(t.slice(1))));
                  a = Ft.Fd(a, [1, 0]), a = a.reshape(i), e.push(a), n = !0
                } else if (t > 1) {
                  const s = Fe(1, t).concat([0]);
                  e.push(Ft.Fd(r, s)), n = !0
                } else e.push(r)
              }
              let r = this.mergeFunction(e);
              const s = r.rank;
              if (n)
                if (null == s) {
                  const t = r.shape,
                    e = t[t.length - 1],
                    n = [e].concat(t.slice(0, t.length - 1));
                  r = Ft.Fd(r.reshape([-1, e]), [1, 0]).reshape(n)
                } else if (s > 1) {
                const t = [s - 1].concat(Fe(0, s - 1));
                r = Ft.Fd(r, t)
              }
              return r
            }
          }
          return this.mergeFunction(t)
        })
      }
      computeOutputShape(t) {
        let e;
        e = null == (t = t)[0] ? null : t[0].slice(1);
        for (let n = 1; n < t.length; ++n) {
          const r = null == t[n] ? null : t[n].slice(1);
          e = this.computeElementwiseOpOutputShape(e, r)
        }
        let n = [];
        for (const e of t) null != e && null !== e[0] && n.push(e[0]);
        return n = ee(n), e = 1 === n.length ? n.concat(e) : [null].concat(e), e
      }
      computeMask(t, e) {
        return Ft.Bd(() => {
          if (null == e) return null;
          if (!Array.isArray(e)) throw new Pt("`mask` should be an Array");
          if (!Array.isArray(t)) throw new Pt("`inputs` should be an Array");
          if (e.length !== t.length) throw new Pt("The Array 'inputs' and 'mask' are expected to have the same length, but have different lengths " + `(${t.length} vs ${e.length})`);
          if (e.every(t => null == t)) return null;
          let n = (e = e.map(t => null == t ? t : Ft.zb(t, 0)))[0];
          for (let t = 1; t < e.length - 1; ++t) n = Ft.bc(n, e[t]);
          return n
        })
      }
    }
    class gi extends mi {
      constructor(t) {
        super(t)
      }
      mergeFunction(t) {
        return Object(Ft.Bd)(() => {
          let e = t[0].clone();
          for (let n = 1; n < t.length; ++n) e = Ft.x(e, t[n]);
          return e
        })
      }
    }
    gi.className = "Add", Ft.Tc.registerClass(gi);
    class bi extends mi {
      constructor(t) {
        super(t)
      }
      mergeFunction(t) {
        return Object(Ft.Bd)(() => {
          let e = t[0].clone();
          for (let n = 1; n < t.length; ++n) e = Ft.qc(e, t[n]);
          return e
        })
      }
    }
    bi.className = "Multiply", Ft.Tc.registerClass(bi);
    class yi extends mi {
      constructor(t) {
        super(t)
      }
      mergeFunction(t) {
        return Object(Ft.Bd)(() => {
          let e = t[0].clone();
          for (let n = 1; n < t.length; ++n) e = Ft.x(e, t[n]);
          return Ft.qc(1 / t.length, e)
        })
      }
    }
    yi.className = "Average", Ft.Tc.registerClass(yi);
    class wi extends mi {
      constructor(t) {
        super(t)
      }
      mergeFunction(t) {
        return Object(Ft.Bd)(() => {
          let e = t[0];
          for (let n = 1; n < t.length; ++n) e = Ft.jc(e, t[n]);
          return e
        })
      }
    }
    wi.className = "Maximum", Ft.Tc.registerClass(wi);
    class vi extends mi {
      constructor(t) {
        super(t)
      }
      mergeFunction(t) {
        return Object(Ft.Bd)(() => {
          let e = t[0];
          for (let n = 1; n < t.length; ++n) e = Ft.nc(e, t[n]);
          return e
        })
      }
    }
    vi.className = "Minimum", Ft.Tc.registerClass(vi);
    class xi extends mi {
      constructor(t) {
        super(t), this.DEFAULT_AXIS = -1, null == t && (t = {}), this.axis = null == t.axis ? this.DEFAULT_AXIS : t.axis, this.supportsMasking = !0, this.reshapeRequired = !1
      }
      build(t) {
        if (!Array.isArray(t) || !Array.isArray(t[0]) || 1 === t.length) throw new Pt("A `Concatenate` layer should be called on a list of at least 2 inputs");
        t = t;
        let e = !0;
        for (const n of t)
          if (null != n) {
            e = !1;
            break
          } if (e) return;
        const n = [];
        for (let e = 0; e < t.length; ++e) {
          const r = t[e].slice();
          r.splice(this.axis, 1);
          let s = !1;
          for (const t of n)
            if (Ft.Jd.arraysEqual(t, r)) {
              s = !0;
              break
            } s || n.push(r)
        }
        if (n.length > 1) throw new Pt("A `Concatenate` layer requires inputs with matching shapes except for the concat axis. Got input shapes: " + JSON.stringify(t))
      }
      mergeFunction(t) {
        return Object(Ft.Bd)(() => We(t, this.axis))
      }
      computeOutputShape(t) {
        if (!Array.isArray(t) || !Array.isArray(t[0])) throw new Pt("A `Concatenate` layer should be called on a list of inputs.");
        const e = t,
          n = e[0].slice(),
          r = this.axis < 0 ? n.length + this.axis : this.axis;
        for (const t of e.slice(1)) {
          if (null == n[r] || null == t[r]) {
            n[r] = null;
            break
          }
          n[r] += t[r]
        }
        return n
      }
      computeMask(t, e) {
        if (null == e) return null;
        if (!Array.isArray(e)) throw new Pt("`mask` should be an array for Concatenate");
        if (!Array.isArray(t)) throw new Pt("`inputs` should be an array for Concatenate");
        if (e.length !== t.length) throw new Pt(`Mismatch in the length of mask (${e.length}) ` + `and the legnth of inputs (${t.length})`);
        return Ft.Bd(() => {
          let n = !0;
          if (e.forEach(t => {
              null == t || (n = !1)
            }), n) return null;
          const r = [];
          for (let n = 0; n < t.length; ++n) null == e[n] ? r.push(Ft.xc(t[n]).asType("bool")) : e[n].rank < t[n].rank ? r.push(Ft.zb(e[n], -1)) : r.push(e[n]);
          const s = Ft.Z(r, this.axis);
          return Ft.z(s, -1, !1)
        })
      }
      getConfig() {
        const t = {
            axis: this.axis
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }

    function Oi(t, e) {
      for (; t < 0;) t += e;
      return t
    }
    xi.className = "Concatenate", Ft.Tc.registerClass(xi);
    class Si extends mi {
      constructor(t) {
        super(t), this.axes = t.axes, this.normalize = null != t.normalize && t.normalize, this.supportsMasking = !0, this.reshapeRequired = !1
      }
      build(t) {
        Ft.Jd.assert(Array.isArray(t) && 2 === t.length && Array.isArray(t[0]) && Array.isArray(t[1]), () => "A `Dot` layer should be called on a list of exactly 2 inputs.");
        const e = t[0],
          n = t[1];
        if (e.length > 3 || n.length > 3) throw new Wt("Dot layer does not support tensors of 4D or higher rank yet.");
        const r = this.interpretAxes(e, n);
        if (e[r[0]] !== n[r[1]]) throw new Pt("Dimension incompatibility: " + `${e[r[0]]} !== ${n[r[1]]}`)
      }
      mergeFunction(t) {
        if (2 !== t.length) throw new Pt("A `Dot` layer must be called on exactly 2 inputs, " + `but received ${t.length} input(s).`);
        let e, n = t[0],
          r = t[1];
        return e = Array.isArray(this.axes) ? this.axes.map((e, n) => Oi(e, t[n].shape.length)) : [Oi(this.axes, n.shape.length), Oi(this.axes, r.shape.length)], this.normalize && (n = nr(n, e[0]), r = nr(r, e[1])),
          function (t, e, n) {
            if (t.shape.length > 3 || e.shape.length > 3) throw new Wt("batchDot is not implemented for tensors of 4D or higher rank yet");
            if (Ft.Jd.assert(t.shape.length >= 2, () => "batchDot requires the rank of x to be >= 2, " + `but got ${t.shape.length}`), Ft.Jd.assert(t.shape.length >= 2, () => "batchDot requires the rank of y to be >= 2, " + `but got ${e.shape.length}`), "number" == typeof n && (n = [n, n]), "complex64" === t.dtype || "complex64" === e.dtype) throw new Wt("batchDot is not implemented for complex64-type Tensors yet.");
            const r = t.shape.length,
              s = e.shape.length;
            null == n && (n = [r - 1, s - 2]);
            const i = n;
            return Ft.Bd(() => {
              let n, a;
              if (r > s) {
                n = r - s;
                const t = [];
                for (let e = 0; e < n; ++e) t.push(1);
                e = e.reshape(e.shape.concat(t))
              } else if (s > r) {
                n = s - r;
                const e = [];
                for (let t = 0; t < n; ++t) e.push(1);
                t = t.reshape(t.shape.concat(e))
              } else n = 0;
              if (2 === t.shape.length && 2 === e.shape.length) a = i[0] === i[1] ? t.mul(e).sum(i[0]) : t.transpose([1, 0]).mul(e).sum(i[1]);
              else {
                const n = i[0] !== t.shape.length - 1,
                  r = i[1] === e.shape.length - 1;
                a = t.matMul(e, n, r)
              }
              if (n > 0) {
                let t;
                t = r > s ? r + s - 3 : r - 1;
                const e = [];
                for (let r = t; r < t + n; ++r) e.push(r);
                a = a.squeeze(e)
              }
              return 1 === a.shape.length && (a = a.expandDims(1)), a
            })
          }(n, r, e)
      }
      interpretAxes(t, e) {
        let n;
        return n = Array.isArray(this.axes) ? this.axes : [Oi(this.axes, t.length), Oi(this.axes, e.length)], n
      }
      computeOutputShape(t) {
        Ft.Jd.assert(Array.isArray(t) && 2 === t.length && Array.isArray(t[0]) && Array.isArray(t[1]), () => "A `Dot` layer should be called on a list of exactly 2 inputs.");
        const e = t[0].slice(),
          n = t[1].slice();
        if (e.length > 3 || n.length > 3) throw new Wt("Dot layer does not support tensors of 4D or higher rank yet.");
        const r = this.interpretAxes(e, n);
        e.splice(r[0], 1), n.splice(r[1], 1), n.splice(0, 1);
        const s = e.concat(n);
        return 1 === s.length && s.push(1), s
      }
      computeMask(t, e) {
        return null
      }
      getConfig() {
        const t = {
            axes: this.axes,
            normalize: this.normalize
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Si.className = "Dot", Ft.Tc.registerClass(Si);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    class _i extends Bn {
      constructor(t) {
        super(t), this.supportsMasking = !0, this.stddev = t.stddev
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = super.getConfig(),
          e = {
            stddev: this.stddev
          };
        return Object.assign(e, t), e
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t);
          return Ze(() => He(n.shape, 0, this.stddev).add(n), () => n, e.training || !1)
        })
      }
    }
    _i.className = "GaussianNoise", Ft.Tc.registerClass(_i);
    class ki extends Bn {
      constructor(t) {
        super(t), this.supportsMasking = !0, this.rate = t.rate
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = super.getConfig(),
          e = {
            rate: this.rate
          };
        return Object.assign(e, t), e
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e);
          const n = In(t);
          if (this.rate > 0 && this.rate < 1) {
            return Ze(() => {
              const t = Math.sqrt(this.rate / (1 - this.rate));
              return n.mul(He(n.shape, 1, t))
            }, () => n, e.training || !1)
          }
          return n
        })
      }
    }
    ki.className = "GaussianDropout", Ft.Tc.registerClass(ki);
    class Ci extends Bn {
      constructor(t) {
        super(t), this.supportsMasking = !0, this.rate = t.rate, this.noiseShape = t.noiseShape
      }
      _getNoiseShape(t) {
        return this.noiseShape || In(t).shape
      }
      computeOutputShape(t) {
        return t
      }
      getConfig() {
        const t = super.getConfig(),
          e = {
            rate: this.rate
          };
        return Object.assign(e, t), e
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          if (this.rate < 1 && this.rate > 0) {
            const n = this._getNoiseShape(t);
            return Ze(() => {
              const e = In(t),
                r = -1.7580993408473766;
              let s = Object(Ft.Kb)(Object(Ft.Dc)(n), this.rate);
              s = Me(s, "float32");
              const i = ((1 - this.rate) * (1 + this.rate * r ** 2)) ** -.5,
                a = -i * r * this.rate;
              return e.mul(s).add(s.add(-1).mul(r)).mul(i).add(a)
            }, () => In(t), e.training || !1)
          }
          return t
        })
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Ei(t, e, n, r, s, i = .001) {
      let a;
      if (2 === t.rank) a = Ft.N(t, e, n, r, s, i);
      else if (3 === t.rank) a = Ft.O(t, e, n, r, s, i);
      else {
        if (4 !== t.rank) throw new Wt(`batchNormalization is not implemented for array of rank ${t.rank} ` + "yet");
        a = Ft.P(t, e, n, r, s, i)
      }
      return a
    }

    function Ii(t, e, n, r, s = .001) {
      return Ft.Jd.arraysEqual(r.slice().sort(), Fe(0, t.rank - 1)) ? function (t, e, n, r, s = .001) {
        return Object(Ft.Bd)(() => {
          const i = Ft.pc(t, r),
            a = i.mean,
            o = i.variance;
          return [Ei(t, a, o, n, e, s), a, o]
        })
      }(t, e, n, r, s) : function (t, e, n, r, s = .001) {
        return Object(Ft.Bd)(() => {
          const i = Ft.pc(t, r),
            a = i.mean,
            o = i.variance,
            u = [];
          for (const e of Fe(0, t.rank)) - 1 !== r.indexOf(e) ? u.push(1) : u.push(t.shape[e]);
          const c = a.reshape(u),
            l = o.reshape(u),
            h = null == e ? null : e.reshape(u),
            d = null == n ? null : n.reshape(u);
          return [Ei(t, c, l, d, h, s), a, o]
        })
      }(t, e, n, r, s)
    }
    Ci.className = "AlphaDropout", Ft.Tc.registerClass(Ci);
    class Ti extends Bn {
      constructor(t) {
        null == t && (t = {}), super(t), this.supportsMasking = !0, this.axis = null == t.axis ? -1 : t.axis, this.momentum = null == t.momentum ? .99 : t.momentum, this.epsilon = null == t.epsilon ? .001 : t.epsilon, this.center = null == t.center || t.center, this.scale = null == t.scale || t.scale, this.betaInitializer = xn(t.betaInitializer || "zeros"), this.gammaInitializer = xn(t.gammaInitializer || "ones"), this.movingMeanInitializer = xn(t.movingMeanInitializer || "zeros"), this.movingVarianceInitializer = xn(t.movingVarianceInitializer || "ones"), this.betaConstraint = ge(t.betaConstraint), this.gammaConstraint = ge(t.gammaConstraint), this.betaRegularizer = Rs(t.betaRegularizer), this.gammaRegularizer = Rs(t.gammaRegularizer)
      }
      build(t) {
        t = Tn(t);
        const e = this.axis >= 0 ? this.axis : this.axis + t.length,
          n = t[e];
        if (null == n) throw new Pt(`Axis ${e} of input tensor should have a defined dimension but ` + "the layer received an input with shape " + `${JSON.stringify(t)}.`);
        this.inputSpec = [new Dn({
          ndim: t.length,
          axes: {
            [e]: n
          }
        })];
        const r = [n];
        this.scale && (this.gamma = this.addWeight("gamma", r, null, this.gammaInitializer, this.gammaRegularizer, !0, this.gammaConstraint)), this.center && (this.beta = this.addWeight("beta", r, null, this.betaInitializer, this.betaRegularizer, !0, this.betaConstraint)), this.movingMean = this.addWeight("moving_mean", r, null, this.movingMeanInitializer, null, !1), this.movingVariance = this.addWeight("moving_variance", r, null, this.movingVarianceInitializer, null, !1), this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const n = null != e.training && e.training,
            r = In(t),
            s = r.shape,
            i = s.length,
            a = Fe(0, i),
            o = this.axis >= 0 ? this.axis : this.axis + i;
          a.splice(o, 1);
          const u = Vt(1, i);
          u[o] = s[o];
          const c = a.slice();
          c.sort();
          const l = !Ft.Jd.arraysEqual(c, Fe(0, i).slice(0, i - 1));
          if (!n) return (() => {
            if (l) {
              const t = this.movingMean.read().reshape(u),
                e = this.movingVariance.read().reshape(u),
                n = this.center ? this.beta.read().reshape(u) : null,
                s = this.scale ? this.gamma.read().reshape(u) : null;
              return Ei(r, t, e, n, s, this.epsilon)
            }
            return Ei(r, this.movingMean.read(), this.movingVariance.read(), null == this.beta ? null : this.beta.read(), null == this.gamma ? null : this.gamma.read(), this.epsilon)
          })();
          const [h, d, p] = Ii(r, this.gamma.read(), this.beta.read(), a, this.epsilon), f = (t, e, n) => {
            Ft.Bd(() => {
              const r = 1 - n,
                s = t.read(),
                i = s.sub(e).mul(r);
              t.write(s.sub(i))
            })
          };
          return (() => {
            f(this.movingMean, d, this.momentum), f(this.movingVariance, p, this.momentum)
          })(), h
        })
      }
      getConfig() {
        const t = {
            axis: this.axis,
            momentum: this.momentum,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: vn(this.betaInitializer),
            gammaInitializer: vn(this.gammaInitializer),
            movingMeanInitializer: vn(this.movingMeanInitializer),
            movingVarianceInitializer: vn(this.movingVarianceInitializer),
            betaRegularizer: Ns(this.betaRegularizer),
            gammaRegularizer: Ns(this.gammaRegularizer),
            betaConstraint: fe(this.betaConstraint),
            gammaConstraint: fe(this.gammaConstraint)
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Ti.className = "BatchNormalization", Ft.Tc.registerClass(Ti);
    class Ai extends Bn {
      constructor(t) {
        if (null == t && (t = {}), super(t), this.axis = null == t.axis ? -1 : t.axis, "number" == typeof this.axis) {
          if (!Number.isInteger(this.axis)) throw new Error(`Expected axis to be an integer, but received ${this.axis}`)
        } else {
          if (!Array.isArray(this.axis)) throw new Error("Expected axis to be an integer or an array of integers, " + `but received ${JSON.stringify(this.axis)}`);
          for (const t of this.axis)
            if (!Number.isInteger(t)) throw new Error("Expected axis to be an array of integers, " + `but received ${JSON.stringify(this.axis)}`)
        }
        this.epsilon = null == t.epsilon ? .001 : t.epsilon, this.center = null == t.center || t.center, this.scale = null == t.scale || t.scale, this.betaInitializer = xn(t.betaInitializer || "zeros"), this.gammaInitializer = xn(t.gammaInitializer || "ones"), this.betaRegularizer = Rs(t.betaRegularizer), this.gammaRegularizer = Rs(t.gammaRegularizer), this.supportsMasking = !0
      }
      build(t) {
        const e = (t = Tn(t)).length;
        "number" == typeof this.axis && (this.axis = [this.axis]);
        for (let t = 0; t < this.axis.length; ++t) this.axis[t] < 0 && (this.axis[t] += e);
        for (const t of this.axis)
          if (t < 0 || t >= e) throw new Error(`Invalid axis: ${t}`);
        if (this.axis.length !== ee(this.axis).length) throw new Error(`Found duplicate axes in: ${this.axis}`);
        const n = this.axis.map(e => t[e]);
        this.scale ? this.gamma = this.addWeight("gamma", n, "float32", this.gammaInitializer, this.gammaRegularizer, !0) : this.gamma = null, this.center ? this.beta = this.addWeight("beta", n, "float32", this.betaInitializer, this.betaRegularizer, !0) : this.beta = null, this.built = !0
      }
      call(t, e) {
        const n = In(t),
          r = n.shape,
          s = r.length;
        return Object(Ft.Bd)(() => {
          let {
            mean: t,
            variance: e
          } = Object(Ft.pc)(n, this.axis, !0);
          const i = Vt(1, s);
          for (const t of this.axis) i[t] = r[t];
          const a = t => null != t && t.shape.length !== s && this.axis !== [s - 1] ? t.reshape(i) : t;
          let o = a(this.gamma.read()),
            u = a(this.beta.read());
          const c = [],
            l = [];
          for (let t = 0; t < s; ++t) - 1 !== this.axis.indexOf(t) ? (c.push(r[t]), l.push(1)) : (c.push(1), l.push(r[t]));
          return t = t.tile(c), e = e.tile(c), o = o.tile(l), u = u.tile(l), Ei(n, t, e, u, o, this.epsilon)
        })
      }
      getConfig() {
        const t = {
            axis: this.axis,
            epsilon: this.epsilon,
            center: this.center,
            scale: this.scale,
            betaInitializer: vn(this.betaInitializer),
            gammaInitializer: vn(this.gammaInitializer),
            betaRegularizer: Ns(this.betaRegularizer),
            gammaRegularizer: Ns(this.gammaRegularizer)
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Ai.className = "LayerNormalization", Ft.Tc.registerClass(Ai);
    class Ni extends Bn {
      constructor(t) {
        if (null == t && (t = {}), super(t), this.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, null == t.padding) this.padding = [
          [1, 1],
          [1, 1]
        ];
        else if ("number" == typeof t.padding) this.padding = [
          [t.padding, t.padding],
          [t.padding, t.padding]
        ];
        else {
          if (t.padding = t.padding, 2 !== t.padding.length) throw new Pt("ZeroPadding2D expects padding to be a length-2 array, but " + `received a length-${t.padding.length} array.`);
          let e, n;
          if ("number" == typeof t.padding[0]) e = [t.padding[0], t.padding[0]], n = [t.padding[1], t.padding[1]];
          else {
            if (t.padding = t.padding, 2 !== t.padding[0].length) throw new Pt("ZeroPadding2D expects height padding to be a length-2 array, " + `but received a length-${t.padding[0].length} array.`);
            if (e = t.padding[0], 2 !== t.padding[1].length) throw new Pt("ZeroPadding2D expects width padding to be a length-2 array, " + `but received a length-${t.padding[1].length} array.`);
            n = t.padding[1]
          }
          this.padding = [e, n]
        }
        this.inputSpec = [new Dn({
          ndim: 4
        })]
      }
      computeOutputShape(t) {
        let e, n;
        return t = Tn(t), "channelsFirst" === this.dataFormat ? (e = null != t[2] && t[2] >= 0 ? t[2] + this.padding[0][0] + this.padding[0][1] : null, n = null != t[3] && t[3] >= 0 ? t[3] + this.padding[1][0] + this.padding[1][1] : null, [t[0], t[1], e, n]) : (e = null != t[1] && t[1] >= 0 ? t[1] + this.padding[0][0] + this.padding[0][1] : null, n = null != t[2] && t[2] >= 0 ? t[2] + this.padding[1][0] + this.padding[1][1] : null, [t[0], e, n, t[3]])
      }
      call(t, e) {
        return Object(Ft.Bd)(() => (function (t, e, n) {
          return Object(Ft.Bd)(() => {
            if (4 !== t.rank) throw new Pt("temporalPadding expects input tensor to be 4-D, but received a " + `${t.rank}-D tensor.`);
            if (null == e && (e = [
                [1, 1],
                [1, 1]
              ]), 2 !== e.length || 2 !== e[0].length || 2 !== e[1].length) throw new Pt("spatial2dPadding expects `padding` to be an Array of two Arrays, each of which is an Array of two integers.");
            if (null == n && (n = "channelsLast"), "channelsLast" !== n && "channelsFirst" !== n) throw new Pt(`Unknown data format: ${n}. ` + "Supported data formats are 'channelsLast' and 'channelsFirst.");
            let r;
            return r = "channelsFirst" === n ? [
              [0, 0],
              [0, 0], e[0], e[1]
            ] : [
              [0, 0], e[0], e[1],
              [0, 0]
            ], Ft.yc(t, r)
          })
        })(In(t), this.padding, this.dataFormat))
      }
      getConfig() {
        const t = {
            padding: this.padding,
            dataFormat: this.dataFormat
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function $i(t, e, n, r, s, i) {
      return Object(Ft.Bd)(() => {
        let a;
        Oe(s), _e(i), Se(r), null == n && (n = [1, 1]), null == r && (r = "valid"), null == s && (s = "channelsLast"), null == i && (i = "max"), t = Us(t, s);
        const o = "same" === r ? "same" : "valid";
        return a = "max" === i ? Ft.gc(t, e, n, o) : Ft.I(t, e, n, o), "channelsFirst" === s && (a = Ft.Fd(a, [0, 3, 1, 2])), a
      })
    }

    function Ri(t, e, n, r, s, i) {
      return Object(Ft.Bd)(() => {
        let a;
        Oe(s), _e(i), Se(r), null == n && (n = [1, 1, 1]), null == r && (r = "valid"), null == s && (s = "channelsLast"), null == i && (i = "max"), t = Vs(t, s);
        const o = "same" === r ? "same" : "valid";
        return a = "max" === i ? Ft.hc(t, e, n, o) : Ft.J(t, e, n, o), "channelsFirst" === s && (a = Ft.Fd(a, [0, 4, 1, 2, 3])), a
      })
    }
    Ni.className = "ZeroPadding2D", Ft.Tc.registerClass(Ni);
    class ji extends Bn {
      constructor(t) {
        if (null == t.poolSize && (t.poolSize = 2), super(t), "number" == typeof t.poolSize) this.poolSize = [t.poolSize];
        else {
          if (!Array.isArray(t.poolSize) || 1 !== t.poolSize.length || "number" != typeof t.poolSize[0]) throw new Pt("poolSize for 1D convolutional layer must be a number or an Array of a single number, but received " + `${JSON.stringify(t.poolSize)}`);
          this.poolSize = t.poolSize
        }
        if (ie(this.poolSize, "poolSize"), null == t.strides) this.strides = this.poolSize;
        else if ("number" == typeof t.strides) this.strides = [t.strides];
        else {
          if (!Array.isArray(t.strides) || 1 !== t.strides.length || "number" != typeof t.strides[0]) throw new Pt("strides for 1D convolutional layer must be a number or an Array of a single number, but received " + `${JSON.stringify(t.strides)}`);
          this.strides = t.strides
        }
        ie(this.strides, "strides"), this.padding = null == t.padding ? "valid" : t.padding, Se(this.padding), this.inputSpec = [new Dn({
          ndim: 3
        })]
      }
      computeOutputShape(t) {
        const e = Ps((t = Tn(t))[1], this.poolSize[0], this.padding, this.strides[0]);
        return [t[0], e, t[2]]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          this.invokeCallHook(t, e), t = ze(In(t), 2);
          const n = this.poolingFunction(In(t), [this.poolSize[0], 1], [this.strides[0], 1], this.padding, "channelsLast");
          return Ft.od(n, [2])
        })
      }
      getConfig() {
        const t = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    class Di extends ji {
      constructor(t) {
        super(t)
      }
      poolingFunction(t, e, n, r, s) {
        return Oe(s), Se(r), $i(t, e, n, r, s, "max")
      }
    }
    Di.className = "MaxPooling1D", Ft.Tc.registerClass(Di);
    class Fi extends ji {
      constructor(t) {
        super(t)
      }
      poolingFunction(t, e, n, r, s) {
        return Oe(s), Se(r), $i(t, e, n, r, s, "avg")
      }
    }
    Fi.className = "AveragePooling1D", Ft.Tc.registerClass(Fi);
    class Mi extends Bn {
      constructor(t) {
        if (null == t.poolSize && (t.poolSize = [2, 2]), super(t), this.poolSize = Array.isArray(t.poolSize) ? t.poolSize : [t.poolSize, t.poolSize], null == t.strides) this.strides = this.poolSize;
        else if (Array.isArray(t.strides)) {
          if (2 !== t.strides.length) throw new Pt("If the strides property of a 2D pooling layer is an Array, it is expected to have a length of 2, but received length " + `${t.strides.length}.`);
          this.strides = t.strides
        } else this.strides = [t.strides, t.strides];
        ie(this.poolSize, "poolSize"), ie(this.strides, "strides"), this.padding = null == t.padding ? "valid" : t.padding, this.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, Oe(this.dataFormat), Se(this.padding), this.inputSpec = [new Dn({
          ndim: 4
        })]
      }
      computeOutputShape(t) {
        t = Tn(t);
        let e = "channelsFirst" === this.dataFormat ? t[2] : t[1],
          n = "channelsFirst" === this.dataFormat ? t[3] : t[2];
        return e = Ps(e, this.poolSize[0], this.padding, this.strides[0]), n = Ps(n, this.poolSize[1], this.padding, this.strides[1]), "channelsFirst" === this.dataFormat ? [t[0], t[1], e, n] : [t[0], e, n, t[3]]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => (this.invokeCallHook(t, e), this.poolingFunction(In(t), this.poolSize, this.strides, this.padding, this.dataFormat)))
      }
      getConfig() {
        const t = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    class zi extends Mi {
      constructor(t) {
        super(t)
      }
      poolingFunction(t, e, n, r, s) {
        return Oe(s), Se(r), $i(t, e, n, r, s, "max")
      }
    }
    zi.className = "MaxPooling2D", Ft.Tc.registerClass(zi);
    class Li extends Mi {
      constructor(t) {
        super(t)
      }
      poolingFunction(t, e, n, r, s) {
        return Oe(s), Se(r), $i(t, e, n, r, s, "avg")
      }
    }
    Li.className = "AveragePooling2D", Ft.Tc.registerClass(Li);
    class Bi extends Bn {
      constructor(t) {
        if (null == t.poolSize && (t.poolSize = [2, 2, 2]), super(t), this.poolSize = Array.isArray(t.poolSize) ? t.poolSize : [t.poolSize, t.poolSize, t.poolSize], null == t.strides) this.strides = this.poolSize;
        else if (Array.isArray(t.strides)) {
          if (3 !== t.strides.length) throw new Pt("If the strides property of a 3D pooling layer is an Array, it is expected to have a length of 3, but received length " + `${t.strides.length}.`);
          this.strides = t.strides
        } else this.strides = [t.strides, t.strides, t.strides];
        ie(this.poolSize, "poolSize"), ie(this.strides, "strides"), this.padding = null == t.padding ? "valid" : t.padding, this.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, Oe(this.dataFormat), Se(this.padding), this.inputSpec = [new Dn({
          ndim: 5
        })]
      }
      computeOutputShape(t) {
        t = Tn(t);
        let e = "channelsFirst" === this.dataFormat ? t[2] : t[1],
          n = "channelsFirst" === this.dataFormat ? t[3] : t[2],
          r = "channelsFirst" === this.dataFormat ? t[4] : t[3];
        return e = Ps(e, this.poolSize[0], this.padding, this.strides[0]), n = Ps(n, this.poolSize[1], this.padding, this.strides[1]), r = Ps(r, this.poolSize[2], this.padding, this.strides[2]), "channelsFirst" === this.dataFormat ? [t[0], t[1], e, n, r] : [t[0], e, n, r, t[4]]
      }
      call(t, e) {
        return Object(Ft.Bd)(() => (this.invokeCallHook(t, e), this.poolingFunction(In(t), this.poolSize, this.strides, this.padding, this.dataFormat)))
      }
      getConfig() {
        const t = {
            poolSize: this.poolSize,
            padding: this.padding,
            strides: this.strides,
            dataFormat: this.dataFormat
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    class Pi extends Bi {
      constructor(t) {
        super(t)
      }
      poolingFunction(t, e, n, r, s) {
        return Oe(s), Se(r), Ri(t, e, n, r, s, "max")
      }
    }
    Pi.className = "MaxPooling3D", Ft.Tc.registerClass(Pi);
    class Wi extends Bi {
      constructor(t) {
        super(t)
      }
      poolingFunction(t, e, n, r, s) {
        return Oe(s), Se(r), Ri(t, e, n, r, s, "avg")
      }
    }
    Wi.className = "AveragePooling3D", Ft.Tc.registerClass(Wi);
    class Ui extends Bn {
      constructor(t) {
        super(t), this.inputSpec = [new Dn({
          ndim: 3
        })]
      }
      computeOutputShape(t) {
        return [t[0], t[2]]
      }
      call(t, e) {
        throw new Wt
      }
    }
    class Vi extends Ui {
      constructor(t) {
        super(t || {})
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const e = In(t);
          return Ft.kc(e, 1)
        })
      }
    }
    Vi.className = "GlobalAveragePooling1D", Ft.Tc.registerClass(Vi);
    class Hi extends Ui {
      constructor(t) {
        super(t || {})
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const e = In(t);
          return Ft.fc(e, 1)
        })
      }
    }
    Hi.className = "GlobalMaxPooling1D", Ft.Tc.registerClass(Hi);
    class Gi extends Bn {
      constructor(t) {
        super(t), this.dataFormat = null == t.dataFormat ? "channelsLast" : t.dataFormat, Oe(this.dataFormat), this.inputSpec = [new Dn({
          ndim: 4
        })]
      }
      computeOutputShape(t) {
        return t = t, "channelsLast" === this.dataFormat ? [t[0], t[3]] : [t[0], t[1]]
      }
      call(t, e) {
        throw new Wt
      }
      getConfig() {
        const t = {
            dataFormat: this.dataFormat
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    class qi extends Gi {
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const e = In(t);
          return "channelsLast" === this.dataFormat ? Ft.kc(e, [1, 2]) : Ft.kc(e, [2, 3])
        })
      }
    }
    qi.className = "GlobalAveragePooling2D", Ft.Tc.registerClass(qi);
    class Ki extends Gi {
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const e = In(t);
          return "channelsLast" === this.dataFormat ? Ft.fc(e, [1, 2]) : Ft.fc(e, [2, 3])
        })
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    function Ji(t, e, n, r) {
      if (Array.isArray(t)) {
        if (null != e || null != n) throw new Pt("When inputs is an array, neither initialState or constants should be provided");
        null != r && (n = t.slice(t.length - r, t.length), t = t.slice(0, t.length - r)), t.length > 1 && (e = t.slice(1, t.length)), t = t[0]
      }

      function s(t) {
        return null == t || Array.isArray(t) ? t : [t]
      }
      return {
        inputs: t,
        initialState: e = s(e),
        constants: n = s(n)
      }
    }

    function Xi(t, e, n, r = !1, s, i, a = !1, o = !1) {
      return Ft.Bd(() => {
        const u = e.shape.length;
        if (u < 3) throw new Pt(`Input should be at least 3D, but is ${u}D.`);
        const c = [1, 0].concat(Fe(2, u));
        if (e = Ft.Fd(e, c), null != i) throw new Wt("The rnn() functoin of the deeplearn.js backend does not support constants yet.");
        a && console.warn("Backend rnn(): the unroll = true option is not applicable to the imperative deeplearn.js backend."), null != s && ((s = s.asType("bool").asType("float32")).rank === u - 1 && (s = Ft.zb(s, -1)), s = Ft.Fd(s, c)), r && (e = Ft.Lc(e, 0), null != s && (s = Ft.Lc(s, 0)));
        const l = [];
        let h, d = n;
        const p = e.shape[0],
          f = Ft.Hd(e);
        let m, g;
        null != s && (m = Ft.Hd(s));
        for (let e = 0; e < p; ++e) {
          const n = f[e],
            r = Ft.Bd(() => t(n, d));
          if (null == s) h = r[0], d = r[1];
          else {
            const t = Ft.Bd(() => {
              const t = m[e],
                n = Ft.xc(t).sub(t);
              return {
                output: r[0].mul(t).add(d[0].mul(n)),
                newStates: d.map((e, s) => r[1][s].mul(t).add(e.mul(n)))
              }
            });
            h = t.output, d = t.newStates
          }
          o && l.push(h)
        }
        if (o) {
          const t = 1;
          g = Ft.pd(l, t)
        }
        return [h, g, d]
      })
    }
    Ki.className = "GlobalMaxPooling2D", Ft.Tc.registerClass(Ki);
    class Yi extends Bn {
      constructor(t) {
        let e;
        if (super(t), null == t.cell) throw new Pt("cell property is missing for the constructor of RNN.");
        if (e = Array.isArray(t.cell) ? new ia({
            cells: t.cell
          }) : t.cell, null == e.stateSize) throw new Pt("The RNN cell should have an attribute `stateSize` (tuple of integers, one integer per RNN state).");
        this.cell = e, this.returnSequences = null != t.returnSequences && t.returnSequences, this.returnState = null != t.returnState && t.returnState, this.goBackwards = null != t.goBackwards && t.goBackwards, this._stateful = null != t.stateful && t.stateful, this.unroll = null != t.unroll && t.unroll, this.supportsMasking = !0, this.inputSpec = [new Dn({
          ndim: 3
        })], this.stateSpec = null, this.states_ = null, this.numConstants = null, this.keptStates = []
      }
      getStates() {
        if (null == this.states_) {
          return Fe(0, Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1).map(t => null)
        }
        return this.states_
      }
      setStates(t) {
        this.states_ = t
      }
      computeOutputShape(t) {
        Cn(t) && (t = t[0]), t = t;
        let e = this.cell.stateSize;
        Array.isArray(e) || (e = [e]);
        const n = e[0];
        let r;
        if (r = this.returnSequences ? [t[0], t[1], n] : [t[0], n], this.returnState) {
          const n = [];
          for (const r of e) n.push([t[0], r]);
          return [r].concat(n)
        }
        return r
      }
      computeMask(t, e) {
        return Ft.Bd(() => {
          Array.isArray(e) && (e = e[0]);
          const t = this.returnSequences ? e : null;
          if (this.returnState) {
            const e = this.states.map(t => null);
            return [t].concat(e)
          }
          return t
        })
      }
      get states() {
        if (null == this.states_) {
          const t = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1,
            e = [];
          for (let n = 0; n < t; ++n) e.push(null);
          return e
        }
        return this.states_
      }
      set states(t) {
        this.states_ = t
      }
      build(t) {
        if (null != this.numConstants) throw new Wt("Constants support is not implemented in RNN yet.");
        Cn(t) && (t = t[0]), t = t;
        const e = this.stateful ? t[0] : null,
          n = t[t.length - 1];
        this.inputSpec[0] = new Dn({
          shape: [e, null, n]
        });
        const r = [t[0]].concat(t.slice(2));
        let s;
        if (this.cell.build(r), s = Array.isArray(this.cell.stateSize) ? this.cell.stateSize : [this.cell.stateSize], null != this.stateSpec) {
          if (!Ft.Jd.arraysEqual(this.stateSpec.map(t => t.shape[t.shape.length - 1]), s)) throw new Pt("An initialState was passed that is not compatible with " + `cell.stateSize. Received stateSpec=${this.stateSpec}; ` + `However cell.stateSize is ${this.cell.stateSize}`)
        } else this.stateSpec = s.map(t => new Dn({
          shape: [null, t]
        }));
        this.stateful && this.resetStates()
      }
      resetStates(t, e = !1) {
        Object(Ft.Bd)(() => {
          if (!this.stateful) throw new Lt("Cannot call resetStates() on an RNN Layer that is not stateful.");
          const n = this.inputSpec[0].shape[0];
          if (null == n) throw new Pt("If an RNN is stateful, it needs to know its batch size. Specify the batch size of your input tensors: \n- If using a Sequential model, specify the batch size by passing a `batchInputShape` option to your first layer.\n- If using the functional API, specify the batch size by passing a `batchShape` option to your Input layer.");
          if (null == this.states_) Array.isArray(this.cell.stateSize) ? this.states_ = this.cell.stateSize.map(t => Ft.Pd([n, t])) : this.states_ = [Ft.Pd([n, this.cell.stateSize])];
          else if (null == t) Ft.pb(this.states_), null != this.keptStates && (Ft.pb(this.keptStates), this.keptStates = []), Array.isArray(this.cell.stateSize) ? this.states_ = this.cell.stateSize.map(t => Ft.Pd([n, t])) : this.states_[0] = Ft.Pd([n, this.cell.stateSize]);
          else {
            if (Array.isArray(t) || (t = [t]), t.length !== this.states_.length) throw new Pt(`Layer ${this.name} expects ${this.states_.length} state(s), ` + `but it received ${t.length} state value(s). Input ` + `received: ${t}`);
            !0 === e ? this.keptStates.push(this.states_.slice()) : Ft.pb(this.states_);
            for (let e = 0; e < this.states_.length; ++e) {
              const r = t[e],
                s = Array.isArray(this.cell.stateSize) ? this.cell.stateSize[e] : this.cell.stateSize,
                i = [n, s];
              if (!Ft.Jd.arraysEqual(r.shape, i)) throw new Pt(`State ${e} is incompatible with layer ${this.name}: ` + `expected shape=${i}, received shape=${r.shape}`);
              this.states_[e] = r
            }
          }
          this.states_ = this.states_.map(t => Ft.Qb(t.clone()))
        })
      }
      apply(t, e) {
        let n = null == e ? null : e.initialState,
          r = null == e ? null : e.constants;
        null == e && (e = {});
        const s = Ji(t, n, r, this.numConstants);
        t = s.inputs, n = s.initialState, r = s.constants;
        let i = [],
          a = [];
        if (null != n) {
          e.initialState = n, i = i.concat(n), this.stateSpec = [];
          for (const t of n) this.stateSpec.push(new Dn({
            shape: t.shape
          }));
          a = a.concat(this.stateSpec)
        }
        if (null != r && (e.constants = r, i = i.concat(r), this.numConstants = r.length), i[0] instanceof Fn) {
          const n = [t].concat(i),
            r = this.inputSpec.concat(a),
            s = this.inputSpec;
          this.inputSpec = r;
          const o = super.apply(n, e);
          return this.inputSpec = s, o
        }
        return super.apply(t, e)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const n = null == e ? null : e.mask,
            r = null == e ? null : e.training;
          let s = null == e ? null : e.initialState;
          t = In(t), null == s && (s = this.stateful ? this.states_ : this.getInitialState(t));
          const i = Array.isArray(this.cell.stateSize) ? this.cell.stateSize.length : 1;
          if (s.length !== i) throw new Pt(`RNN Layer has ${i} state(s) but was passed ` + `${s.length} initial state(s).`);
          this.unroll && console.warn("Ignoring unroll = true for RNN layer, due to imperative backend.");
          const a = {
              training: r
            },
            o = Xi((t, e) => {
              const n = this.cell.call([t].concat(e), a);
              return [n[0], n.slice(1)]
            }, t, s, this.goBackwards, n, null, this.unroll, this.returnSequences),
            u = o[0],
            c = o[1],
            l = o[2];
          this.stateful && this.resetStates(l, r);
          const h = this.returnSequences ? c : u;
          return this.returnState ? [h].concat(l) : h
        })
      }
      getInitialState(t) {
        return Object(Ft.Bd)(() => {
          let e = Ft.Pd(t.shape);
          return e = Ft.sd(e, [1, 2]), e = ze(e), Array.isArray(this.cell.stateSize) ? this.cell.stateSize.map(t => t > 1 ? Ve(e, [1, t]) : e) : this.cell.stateSize > 1 ? [Ve(e, [1, this.cell.stateSize])] : [e]
        })
      }
      get trainableWeights() {
        return this.trainable ? this.cell.trainableWeights : []
      }
      get nonTrainableWeights() {
        return this.trainable ? this.cell.nonTrainableWeights : this.cell.weights
      }
      setFastWeightInitDuringBuild(t) {
        super.setFastWeightInitDuringBuild(t), null != this.cell && this.cell.setFastWeightInitDuringBuild(t)
      }
      getConfig() {
        const t = {
          returnSequences: this.returnSequences,
          returnState: this.returnState,
          goBackwards: this.goBackwards,
          stateful: this.stateful,
          unroll: this.unroll
        };
        null != this.numConstants && (t.numConstants = this.numConstants);
        const e = this.cell.getConfig();
        t.cell = {
          className: this.cell.getClassName(),
          config: e
        };
        const n = super.getConfig();
        return Object.assign(t, n), t
      }
      static fromConfig(t, e, n = {}) {
        const r = er(e.cell, n);
        return new t(Object.assign(e, {
          cell: r
        }))
      }
    }
    Yi.className = "RNN", Ft.Tc.registerClass(Yi);
    class Zi extends Bn {}
    class Qi extends Zi {
      constructor(t) {
        super(t), this.DEFAULT_ACTIVATION = "tanh", this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", this.DEFAULT_BIAS_INITIALIZER = "zeros", this.units = t.units, ie(this.units, "units"), this.activation = Cs(null == t.activation ? this.DEFAULT_ACTIVATION : t.activation), this.useBias = null == t.useBias || t.useBias, this.kernelInitializer = xn(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.recurrentInitializer = xn(t.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER), this.biasInitializer = xn(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.kernelRegularizer = Rs(t.kernelRegularizer), this.recurrentRegularizer = Rs(t.recurrentRegularizer), this.biasRegularizer = Rs(t.biasRegularizer), this.kernelConstraint = ge(t.kernelConstraint), this.recurrentConstraint = ge(t.recurrentConstraint), this.biasConstraint = ge(t.biasConstraint), this.dropout = je([1, De([0, null == t.dropout ? 0 : t.dropout])]), this.recurrentDropout = je([1, De([0, null == t.recurrentDropout ? 0 : t.recurrentDropout])]), this.stateSize = this.units, this.dropoutMask = null, this.recurrentDropoutMask = null
      }
      build(t) {
        t = Tn(t), this.kernel = this.addWeight("kernel", [t[t.length - 1], this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, this.units], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias ? this.bias = this.addWeight("bias", [this.units], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          if (2 !== (t = t).length) throw new Pt(`SimpleRNNCell expects 2 input Tensors, got ${t.length}.`);
          let n = t[1];
          t = t[0];
          const r = null != e.training && e.training;
          let s;
          0 < this.dropout && this.dropout < 1 && null == this.dropoutMask && (this.dropoutMask = aa(() => Ft.xc(t), this.dropout, r)), 0 < this.recurrentDropout && this.recurrentDropout < 1 && null == this.recurrentDropoutMask && (this.recurrentDropoutMask = aa(() => Ft.xc(n), this.recurrentDropout, r));
          const i = this.dropoutMask,
            a = this.recurrentDropoutMask;
          s = Ge(null != i ? Ft.qc(t, i) : t, this.kernel.read()), null != this.bias && (s = Xe(s, this.bias.read())), null != a && (n = Ft.qc(n, a));
          let o = Ft.x(s, Ge(n, this.recurrentKernel.read()));
          return null != this.activation && (o = this.activation.apply(o)), [o, o]
        })
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            recurrentInitializer: vn(this.recurrentInitializer),
            biasInitializer: vn(this.biasInitializer),
            kernelRegularizer: Ns(this.kernelRegularizer),
            recurrentRegularizer: Ns(this.recurrentRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            recurrentConstraint: fe(this.recurrentConstraint),
            biasConstraint: fe(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    Qi.className = "SimpleRNNCell", Ft.Tc.registerClass(Qi);
    class ta extends Yi {
      constructor(t) {
        t.cell = new Qi(t), super(t)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          null != this.cell.dropoutMask && (Ft.pb(this.cell.dropoutMask), this.cell.dropoutMask = null), null != this.cell.recurrentDropoutMask && (Ft.pb(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null);
          const n = null == e ? null : e.mask,
            r = null == e ? null : e.training,
            s = null == e ? null : e.initialState;
          return super.call(t, {
            mask: n,
            training: r,
            initialState: s
          })
        })
      }
      get units() {
        return this.cell.units
      }
      get activation() {
        return this.cell.activation
      }
      get useBias() {
        return this.cell.useBias
      }
      get kernelInitializer() {
        return this.cell.kernelInitializer
      }
      get recurrentInitializer() {
        return this.cell.recurrentInitializer
      }
      get biasInitializer() {
        return this.cell.biasInitializer
      }
      get kernelRegularizer() {
        return this.cell.kernelRegularizer
      }
      get recurrentRegularizer() {
        return this.cell.recurrentRegularizer
      }
      get biasRegularizer() {
        return this.cell.biasRegularizer
      }
      get kernelConstraint() {
        return this.cell.kernelConstraint
      }
      get recurrentConstraint() {
        return this.cell.recurrentConstraint
      }
      get biasConstraint() {
        return this.cell.biasConstraint
      }
      get dropout() {
        return this.cell.dropout
      }
      get recurrentDropout() {
        return this.cell.recurrentDropout
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            recurrentInitializer: vn(this.recurrentInitializer),
            biasInitializer: vn(this.biasInitializer),
            kernelRegularizer: Ns(this.kernelRegularizer),
            recurrentRegularizer: Ns(this.recurrentRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            recurrentConstraint: fe(this.recurrentConstraint),
            biasConstraint: fe(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout
          },
          e = super.getConfig();
        return delete e.cell, Object.assign(t, e), t
      }
      static fromConfig(t, e) {
        return new t(e)
      }
    }
    ta.className = "SimpleRNN", Ft.Tc.registerClass(ta);
    class ea extends Zi {
      constructor(t) {
        if (super(t), this.DEFAULT_ACTIVATION = "tanh", this.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid", this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", this.DEFAULT_BIAS_INITIALIZER = "zeros", t.resetAfter) throw new Pt("GRUCell does not support reset_after parameter set to true.");
        this.units = t.units, ie(this.units, "units"), this.activation = Cs(void 0 === t.activation ? this.DEFAULT_ACTIVATION : t.activation), this.recurrentActivation = Cs(void 0 === t.recurrentActivation ? this.DEFAULT_RECURRENT_ACTIVATION : t.recurrentActivation), this.useBias = null == t.useBias || t.useBias, this.kernelInitializer = xn(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.recurrentInitializer = xn(t.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER), this.biasInitializer = xn(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.kernelRegularizer = Rs(t.kernelRegularizer), this.recurrentRegularizer = Rs(t.recurrentRegularizer), this.biasRegularizer = Rs(t.biasRegularizer), this.kernelConstraint = ge(t.kernelConstraint), this.recurrentConstraint = ge(t.recurrentConstraint), this.biasConstraint = ge(t.biasConstraint), this.dropout = je([1, De([0, null == t.dropout ? 0 : t.dropout])]), this.recurrentDropout = je([1, De([0, null == t.recurrentDropout ? 0 : t.recurrentDropout])]), this.implementation = t.implementation, this.stateSize = this.units, this.dropoutMask = null, this.recurrentDropoutMask = null
      }
      build(t) {
        const e = (t = Tn(t))[t.length - 1];
        this.kernel = this.addWeight("kernel", [e, 3 * this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, 3 * this.units], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias ? this.bias = this.addWeight("bias", [3 * this.units], null, this.biasInitializer, this.biasRegularizer, !0, this.biasConstraint) : this.bias = null, this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          if (2 !== (t = t).length) throw new Pt("GRUCell expects 2 input Tensors (inputs, h, c), got " + `${t.length}.`);
          const n = null != e.training && e.training;
          let r = t[1];
          t = t[0], 0 < this.dropout && this.dropout < 1 && null == this.dropoutMask && (this.dropoutMask = aa(() => Ft.xc(t), this.dropout, n, 3)), 0 < this.recurrentDropout && this.recurrentDropout < 1 && null == this.recurrentDropoutMask && (this.recurrentDropoutMask = aa(() => Ft.xc(r), this.recurrentDropout, n, 3));
          const s = this.dropoutMask,
            i = this.recurrentDropoutMask;
          let a, o, u;
          0 < this.dropout && this.dropout < 1 && (t = Ft.qc(t, s[0]));
          let c = Ge(t, this.kernel.read());
          this.useBias && (c = Xe(c, this.bias.read())), 0 < this.recurrentDropout && this.recurrentDropout < 1 && (r = Ft.qc(r, i[0]));
          const l = this.recurrentKernel.read(),
            [h, d] = Ft.kd(l, [2 * this.units, this.units], l.rank - 1),
            p = Ge(r, h),
            [f, m, g] = Ft.kd(c, 3, c.rank - 1),
            [b, y] = Ft.kd(p, 2, p.rank - 1);
          a = this.recurrentActivation.apply(Ft.x(f, b)), o = this.recurrentActivation.apply(Ft.x(m, y));
          const w = Ge(Ft.qc(o, r), d);
          u = this.activation.apply(Ft.x(g, w));
          const v = Ft.x(Ft.qc(a, r), Ft.qc(Ft.x(1, Ft.sc(a)), u));
          return [v, v]
        })
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            recurrentActivation: _s(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            recurrentInitializer: vn(this.recurrentInitializer),
            biasInitializer: vn(this.biasInitializer),
            kernelRegularizer: Ns(this.kernelRegularizer),
            recurrentRegularizer: Ns(this.recurrentRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            recurrentConstraint: fe(this.recurrentConstraint),
            biasConstraint: fe(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation,
            resetAfter: !1
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    ea.className = "GRUCell", Ft.Tc.registerClass(ea);
    class na extends Yi {
      constructor(t) {
        0 === t.implementation && console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."), t.cell = new ea(t), super(t)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          null != this.cell.dropoutMask && (Ft.pb(this.cell.dropoutMask), this.cell.dropoutMask = null), null != this.cell.recurrentDropoutMask && (Ft.pb(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null);
          const n = null == e ? null : e.mask,
            r = null == e ? null : e.training,
            s = null == e ? null : e.initialState;
          return super.call(t, {
            mask: n,
            training: r,
            initialState: s
          })
        })
      }
      get units() {
        return this.cell.units
      }
      get activation() {
        return this.cell.activation
      }
      get recurrentActivation() {
        return this.cell.recurrentActivation
      }
      get useBias() {
        return this.cell.useBias
      }
      get kernelInitializer() {
        return this.cell.kernelInitializer
      }
      get recurrentInitializer() {
        return this.cell.recurrentInitializer
      }
      get biasInitializer() {
        return this.cell.biasInitializer
      }
      get kernelRegularizer() {
        return this.cell.kernelRegularizer
      }
      get recurrentRegularizer() {
        return this.cell.recurrentRegularizer
      }
      get biasRegularizer() {
        return this.cell.biasRegularizer
      }
      get kernelConstraint() {
        return this.cell.kernelConstraint
      }
      get recurrentConstraint() {
        return this.cell.recurrentConstraint
      }
      get biasConstraint() {
        return this.cell.biasConstraint
      }
      get dropout() {
        return this.cell.dropout
      }
      get recurrentDropout() {
        return this.cell.recurrentDropout
      }
      get implementation() {
        return this.cell.implementation
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            recurrentActivation: _s(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            recurrentInitializer: vn(this.recurrentInitializer),
            biasInitializer: vn(this.biasInitializer),
            kernelRegularizer: Ns(this.kernelRegularizer),
            recurrentRegularizer: Ns(this.recurrentRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            recurrentConstraint: fe(this.recurrentConstraint),
            biasConstraint: fe(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation,
            resetAfter: !1
          },
          e = super.getConfig();
        return delete e.cell, Object.assign(t, e), t
      }
      static fromConfig(t, e) {
        return 0 === e.implmentation && (e.implementation = 1), new t(e)
      }
    }
    na.className = "GRU", Ft.Tc.registerClass(na);
    class ra extends Zi {
      constructor(t) {
        super(t), this.DEFAULT_ACTIVATION = "tanh", this.DEFAULT_RECURRENT_ACTIVATION = "hardSigmoid", this.DEFAULT_KERNEL_INITIALIZER = "glorotNormal", this.DEFAULT_RECURRENT_INITIALIZER = "orthogonal", this.DEFAULT_BIAS_INITIALIZER = "zeros", this.units = t.units, ie(this.units, "units"), this.activation = Cs(void 0 === t.activation ? this.DEFAULT_ACTIVATION : t.activation), this.recurrentActivation = Cs(void 0 === t.recurrentActivation ? this.DEFAULT_RECURRENT_ACTIVATION : t.recurrentActivation), this.useBias = null == t.useBias || t.useBias, this.kernelInitializer = xn(t.kernelInitializer || this.DEFAULT_KERNEL_INITIALIZER), this.recurrentInitializer = xn(t.recurrentInitializer || this.DEFAULT_RECURRENT_INITIALIZER), this.biasInitializer = xn(t.biasInitializer || this.DEFAULT_BIAS_INITIALIZER), this.unitForgetBias = t.unitForgetBias, this.kernelRegularizer = Rs(t.kernelRegularizer), this.recurrentRegularizer = Rs(t.recurrentRegularizer), this.biasRegularizer = Rs(t.biasRegularizer), this.kernelConstraint = ge(t.kernelConstraint), this.recurrentConstraint = ge(t.recurrentConstraint), this.biasConstraint = ge(t.biasConstraint), this.dropout = je([1, De([0, null == t.dropout ? 0 : t.dropout])]), this.recurrentDropout = je([1, De([0, null == t.recurrentDropout ? 0 : t.recurrentDropout])]), this.implementation = t.implementation, this.stateSize = [this.units, this.units], this.dropoutMask = null, this.recurrentDropoutMask = null
      }
      build(t) {
        var e;
        const n = (t = Tn(t))[t.length - 1];
        let r;
        if (this.kernel = this.addWeight("kernel", [n, 4 * this.units], null, this.kernelInitializer, this.kernelRegularizer, !0, this.kernelConstraint), this.recurrentKernel = this.addWeight("recurrent_kernel", [this.units, 4 * this.units], null, this.recurrentInitializer, this.recurrentRegularizer, !0, this.recurrentConstraint), this.useBias) {
          if (this.unitForgetBias) {
            const t = this.biasInitializer,
              n = this.units;
            r = new((e = class extends en {
              apply(e, r) {
                const s = t.apply([n]),
                  i = (new rn).apply([n]),
                  a = t.apply([2 * n]);
                return Ue(Ue(s, i), a)
              }
            }).className = "CustomInit", e)
          } else r = this.biasInitializer;
          this.bias = this.addWeight("bias", [4 * this.units], null, r, this.biasRegularizer, !0, this.biasConstraint)
        } else this.bias = null;
        this.built = !0
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const n = null != e.training && e.training;
          if (3 !== (t = t).length) throw new Pt("LSTMCell expects 3 input Tensors (inputs, h, c), got " + `${t.length}.`);
          let r = t[1];
          const s = t[2];
          t = t[0], 0 < this.dropout && this.dropout < 1 && null == this.dropoutMask && (this.dropoutMask = aa(() => Ft.xc(t), this.dropout, n, 4)), 0 < this.recurrentDropout && this.recurrentDropout < 1 && null == this.recurrentDropoutMask && (this.recurrentDropoutMask = aa(() => Ft.xc(r), this.recurrentDropout, n, 4));
          const i = this.dropoutMask,
            a = this.recurrentDropoutMask;
          let o, u, c, l;
          0 < this.dropout && this.dropout < 1 && (t = Ft.qc(t, i[0]));
          let h = Ge(t, this.kernel.read());
          0 < this.recurrentDropout && this.recurrentDropout < 1 && (r = Ft.qc(r, a[0])), h = Ft.x(h, Ge(r, this.recurrentKernel.read())), this.useBias && (h = Xe(h, this.bias.read()));
          const [d, p, f, m] = Ft.kd(h, 4, h.rank - 1);
          o = this.recurrentActivation.apply(d), u = this.recurrentActivation.apply(p), c = Ft.x(Ft.qc(u, s), Ft.qc(o, this.activation.apply(f))), l = this.recurrentActivation.apply(m);
          const g = Ft.qc(l, this.activation.apply(c));
          return [g, g, c]
        })
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            recurrentActivation: _s(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            recurrentInitializer: vn(this.recurrentInitializer),
            biasInitializer: vn(this.biasInitializer),
            unitForgetBias: this.unitForgetBias,
            kernelRegularizer: Ns(this.kernelRegularizer),
            recurrentRegularizer: Ns(this.recurrentRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            recurrentConstraint: fe(this.recurrentConstraint),
            biasConstraint: fe(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
    }
    ra.className = "LSTMCell", Ft.Tc.registerClass(ra);
    class sa extends Yi {
      constructor(t) {
        0 === t.implementation && console.warn("`implementation=0` has been deprecated, and now defaults to `implementation=1`. Please update your layer call."), t.cell = new ra(t), super(t)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          null != this.cell.dropoutMask && (Ft.pb(this.cell.dropoutMask), this.cell.dropoutMask = null), null != this.cell.recurrentDropoutMask && (Ft.pb(this.cell.recurrentDropoutMask), this.cell.recurrentDropoutMask = null);
          const n = null == e ? null : e.mask,
            r = null == e ? null : e.training,
            s = null == e ? null : e.initialState;
          return super.call(t, {
            mask: n,
            training: r,
            initialState: s
          })
        })
      }
      get units() {
        return this.cell.units
      }
      get activation() {
        return this.cell.activation
      }
      get recurrentActivation() {
        return this.cell.recurrentActivation
      }
      get useBias() {
        return this.cell.useBias
      }
      get kernelInitializer() {
        return this.cell.kernelInitializer
      }
      get recurrentInitializer() {
        return this.cell.recurrentInitializer
      }
      get biasInitializer() {
        return this.cell.biasInitializer
      }
      get unitForgetBias() {
        return this.cell.unitForgetBias
      }
      get kernelRegularizer() {
        return this.cell.kernelRegularizer
      }
      get recurrentRegularizer() {
        return this.cell.recurrentRegularizer
      }
      get biasRegularizer() {
        return this.cell.biasRegularizer
      }
      get kernelConstraint() {
        return this.cell.kernelConstraint
      }
      get recurrentConstraint() {
        return this.cell.recurrentConstraint
      }
      get biasConstraint() {
        return this.cell.biasConstraint
      }
      get dropout() {
        return this.cell.dropout
      }
      get recurrentDropout() {
        return this.cell.recurrentDropout
      }
      get implementation() {
        return this.cell.implementation
      }
      getConfig() {
        const t = {
            units: this.units,
            activation: _s(this.activation),
            recurrentActivation: _s(this.recurrentActivation),
            useBias: this.useBias,
            kernelInitializer: vn(this.kernelInitializer),
            recurrentInitializer: vn(this.recurrentInitializer),
            biasInitializer: vn(this.biasInitializer),
            unitForgetBias: this.unitForgetBias,
            kernelRegularizer: Ns(this.kernelRegularizer),
            recurrentRegularizer: Ns(this.recurrentRegularizer),
            biasRegularizer: Ns(this.biasRegularizer),
            activityRegularizer: Ns(this.activityRegularizer),
            kernelConstraint: fe(this.kernelConstraint),
            recurrentConstraint: fe(this.recurrentConstraint),
            biasConstraint: fe(this.biasConstraint),
            dropout: this.dropout,
            recurrentDropout: this.recurrentDropout,
            implementation: this.implementation
          },
          e = super.getConfig();
        return delete e.cell, Object.assign(t, e), t
      }
      static fromConfig(t, e) {
        return 0 === e.implmentation && (e.implementation = 1), new t(e)
      }
    }
    sa.className = "LSTM", Ft.Tc.registerClass(sa);
    class ia extends Zi {
      constructor(t) {
        super(t), this.cells = t.cells
      }
      get stateSize() {
        const t = [];
        for (const e of this.cells.slice().reverse()) Array.isArray(e.stateSize) ? t.push(...e.stateSize) : t.push(e.stateSize);
        return t
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          let n = (t = t).slice(1);
          const r = [];
          for (const t of this.cells.slice().reverse()) Array.isArray(t.stateSize) ? r.push(n.splice(0, t.stateSize.length)) : r.push(n.splice(0, 1));
          r.reverse();
          const s = [];
          let i;
          for (let a = 0; a < this.cells.length; ++a) {
            const o = this.cells[a];
            n = r[a], i = 0 === a ? [t[0]].concat(n) : [i[0]].concat(n), i = o.call(i, e), s.push(i.slice(1))
          }
          n = [];
          for (const t of s.slice().reverse()) n.push(...t);
          return [i[0]].concat(n)
        })
      }
      build(t) {
        let e;
        Cn(t) && (t = t[0]), t = t, this.cells.forEach((n, r) => {
          Ee(`RNNCell_${r}`, () => {
            n.build(t), e = Array.isArray(n.stateSize) ? n.stateSize[0] : n.stateSize, t = [t[0], e]
          })
        }), this.built = !0
      }
      getConfig() {
        const t = [];
        for (const e of this.cells) t.push({
          className: e.getClassName(),
          config: e.getConfig()
        });
        const e = {
            cells: t
          },
          n = super.getConfig();
        return Object.assign(e, n), e
      }
      static fromConfig(t, e, n = {}) {
        const r = [];
        for (const t of e.cells) r.push(er(t, n));
        return new t({
          cells: r
        })
      }
      get trainableWeights() {
        if (!this.trainable) return [];
        const t = [];
        for (const e of this.cells) t.push(...e.trainableWeights);
        return t
      }
      get nonTrainableWeights() {
        const t = [];
        for (const e of this.cells) t.push(...e.nonTrainableWeights);
        if (!this.trainable) {
          const e = [];
          for (const t of this.cells) e.push(...t.trainableWeights);
          return e.concat(t)
        }
        return t
      }
      getWeights() {
        const t = [];
        for (const e of this.cells) t.push(...e.weights);
        return Rn(t)
      }
      setWeights(t) {
        const e = [];
        for (const n of this.cells) {
          const r = n.weights.length,
            s = t.splice(r);
          for (let t = 0; t < n.weights.length; ++t) e.push([n.weights[t], s[t]])
        }
        jn(e)
      }
    }

    function aa(t, e, n = null, r = 1) {
      function s() {
        return Ye(t(), e)
      }
      if (r > 1) {
        const e = [];
        for (let i = 0; i < r; i++) e.push(Ze(s, t, n));
        return e.map(t => Ft.Qb(t.clone()))
      }
      return Ft.Qb(Ze(s, t, n).clone())
    }
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    ia.className = "StackedRNNCells", Ft.Tc.registerClass(ia);
    class oa extends Bn {
      constructor(t) {
        super(t), this.layer = t.layer
      }
      build(t) {
        this.built = !0
      }
      get trainable() {
        return null != this.layer && this.layer.trainable
      }
      set trainable(t) {
        null != this.layer && (this.layer.trainable = t)
      }
      get trainableWeights() {
        return this.layer.trainableWeights
      }
      get nonTrainableWeights() {
        return this.layer.nonTrainableWeights
      }
      get updates() {
        return this.layer._updates
      }
      get losses() {
        return this.layer.losses
      }
      getWeights() {
        return this.layer.getWeights()
      }
      setWeights(t) {
        this.layer.setWeights(t)
      }
      getConfig() {
        const t = {
            layer: {
              className: this.layer.getClassName(),
              config: this.layer.getConfig()
            }
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
      setFastWeightInitDuringBuild(t) {
        super.setFastWeightInitDuringBuild(t), null != this.layer && this.layer.setFastWeightInitDuringBuild(t)
      }
      static fromConfig(t, e, n = {}) {
        const r = er(e.layer, n);
        delete e.layer;
        const s = {
          layer: r
        };
        return Object.assign(s, e), new t(s)
      }
    }
    class ua extends oa {
      constructor(t) {
        super(t), this.supportsMasking = !0
      }
      build(t) {
        if ((t = Tn(t)).length < 3) throw new Pt("TimeDistributed layer expects an input shape >= 3D, but received " + `input shape ${JSON.stringify(t)}`);
        this.inputSpec = [{
          shape: t
        }];
        const e = [t[0]].concat(t.slice(2));
        this.layer.built || (this.layer.build(e), this.layer.built = !0), super.build(t)
      }
      computeOutputShape(t) {
        const e = [(t = Tn(t))[0]].concat(t.slice(2)),
          n = this.layer.computeOutputShape(e),
          r = t[1];
        return [n[0], r].concat(n.slice(1))
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          return Xi((t, n) => {
            return [In(this.layer.call(t, e)), []]
          }, t = In(t), [], !1, null, null, !1, !0)[1]
        })
      }
    }
    ua.className = "TimeDistributed", Ft.Tc.registerClass(ua);
    const ca = "concat";
    class la extends oa {
      constructor(t) {
        super(t);
        const e = t.layer.getConfig(),
          n = {};
        n.className = t.layer.getClassName(), n.config = e, this.forwardLayer = er(n), e.goBackwards = !0 !== e.goBackwards;
        const r = {};
        var s;
        if (r.className = t.layer.getClassName(), r.config = e, this.backwardLayer = er(r), this.forwardLayer.name = "forward_" + this.forwardLayer.name, this.backwardLayer.name = "backward_" + this.backwardLayer.name, this.mergeMode = void 0 === t.mergeMode ? ca : t.mergeMode, s = this.mergeMode, re(ve, "BidirectionalMergeMode", s), t.weights) throw new Wt("weights support is not implemented for Bidirectional layer yet.");
        this._stateful = t.layer.stateful, this.returnSequences = t.layer.returnSequences, this.returnState = t.layer.returnState, this.supportsMasking = !0, this._trainable = !0, this.inputSpec = t.layer.inputSpec, this.numConstants = null
      }
      get trainable() {
        return this._trainable
      }
      set trainable(t) {
        this._trainable = t, null != this.forwardLayer && (this.forwardLayer.trainable = t), null != this.backwardLayer && (this.backwardLayer.trainable = t)
      }
      getWeights() {
        return this.forwardLayer.getWeights().concat(this.backwardLayer.getWeights())
      }
      setWeights(t) {
        const e = t.length,
          n = Math.floor(e / 2);
        this.forwardLayer.setWeights(t.slice(0, n)), this.backwardLayer.setWeights(t.slice(n))
      }
      computeOutputShape(t) {
        let e, n, r, s = this.forwardLayer.computeOutputShape(t);
        return Array.isArray(s) && Array.isArray(s[0]) || (s = [s]), s = s, this.returnState ? (r = s.slice(1), e = s[0]) : e = s[0], e = e, "concat" === this.mergeMode ? (e[e.length - 1] *= 2, n = [e]) : n = null == this.mergeMode ? [e, e.slice()] : [e], this.returnState ? null == this.mergeMode ? n.concat(r).concat(r.slice()) : [e].concat(r).concat(r.slice()) : qt(n)
      }
      apply(t, e) {
        let n = null == e ? null : e.initialState,
          r = null == e ? null : e.constants;
        null == e && (e = {});
        const s = Ji(t, n, r, this.numConstants);
        if (t = s.inputs, n = s.initialState, r = s.constants, Array.isArray(t) && (n = t.slice(1), t = t[0]), (null == n || 0 === n.length) && null == r) return super.apply(t, e);
        const i = [],
          a = [];
        if (null != n) {
          const t = n.length;
          if (t % 2 > 0) throw new Pt("When passing `initialState` to a Bidrectional RNN, the state should be an Array containing the states of the underlying RNNs.");
          e.initialState = n, i.push(...n);
          const r = n.map(t => new Dn({
            shape: t.shape
          }));
          this.forwardLayer.stateSpec = r.slice(0, t / 2), this.backwardLayer.stateSpec = r.slice(t / 2), a.push(...r)
        }
        if (null != r) throw new Wt("Support for constants in Bidirectional layers is not implemented yet.");
        const o = i[0] instanceof Fn;
        for (const t of i)
          if (t instanceof Fn !== o) throw new Pt("The initial state of a Bidirectional layer cannot be specified as a mix of symbolic and non-symbolic tensors");
        if (o) {
          const n = [t].concat(i),
            r = this.inputSpec.concat(a),
            s = this.inputSpec;
          this.inputSpec = r;
          const o = super.apply(n, e);
          return this.inputSpec = s, o
        }
        return super.apply(t, e)
      }
      call(t, e) {
        return Object(Ft.Bd)(() => {
          const n = e.initialState;
          let r, s, i, a;
          if (null == n) r = this.forwardLayer.call(t, e), s = this.backwardLayer.call(t, e);
          else {
            const i = n.slice(0, n.length / 2),
              a = n.slice(n.length / 2);
            r = this.forwardLayer.call(t, Object.assign(e, {
              initialState: i
            })), s = this.backwardLayer.call(t, Object.assign(e, {
              initialState: a
            }))
          }
          return this.returnState && (Array.isArray(r) && (i = r.slice(1).concat(s.slice(1))), r = r[0], s = s[0]), this.returnSequences && (s = Ft.Lc(s, 1)), "concat" === this.mergeMode ? a = We([r, s]) : "sum" === this.mergeMode ? a = Ft.x(r, s) : "ave" === this.mergeMode ? a = Ft.qc(.5, Ft.x(r, s)) : "mul" === this.mergeMode ? a = Ft.qc(r, s) : null == this.mergeMode && (a = [r, s]), this.returnState ? null == this.mergeMode ? a.concat(i) : [a].concat(i) : a
        })
      }
      resetStates(t) {
        this.forwardLayer.resetStates(), this.backwardLayer.resetStates()
      }
      build(t) {
        Ee(this.forwardLayer.name, () => {
          this.forwardLayer.build(t)
        }), Ee(this.backwardLayer.name, () => {
          this.backwardLayer.build(t)
        }), this.built = !0
      }
      computeMask(t, e) {
        let n;
        if (Array.isArray(e) && (e = e[0]), n = this.returnSequences ? null == this.mergeMode ? [e, e] : e : null == this.mergeMode ? [null, null] : null, this.returnState) {
          const t = this.forwardLayer.states.map(t => null);
          return Array.isArray(n) ? n.concat(t).concat(t) : [n].concat(t).concat(t)
        }
        return n
      }
      get trainableWeights() {
        return this.forwardLayer.trainableWeights.concat(this.backwardLayer.trainableWeights)
      }
      get nonTrainableWeights() {
        return this.forwardLayer.nonTrainableWeights.concat(this.backwardLayer.nonTrainableWeights)
      }
      setFastWeightInitDuringBuild(t) {
        super.setFastWeightInitDuringBuild(t), null != this.forwardLayer && this.forwardLayer.setFastWeightInitDuringBuild(t), null != this.backwardLayer && this.backwardLayer.setFastWeightInitDuringBuild(t)
      }
      getConfig() {
        const t = {
            mergeMode: this.mergeMode
          },
          e = super.getConfig();
        return Object.assign(t, e), t
      }
      static fromConfig(t, e) {
        const n = er(e.layer);
        if (delete e.layer, null != e.numConstants) throw new Wt("Deserialization of a Bidirectional layer with numConstants present is not supported yet.");
        const r = e;
        return r.layer = n, new t(r)
      }
    }
    la.className = "Bidirectional", Ft.Tc.registerClass(la);
    /**
     * @license
     * Copyright 2018 Google LLC
     *
     * Use of this source code is governed by an MIT-style
     * license that can be found in the LICENSE file or at
     * https://opensource.org/licenses/MIT.
     * =============================================================================
     */
    var ha = n(20),
      da = n(3);
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class pa {
      constructor(t, e, n) {
        this.node = t, this.tensorMap = e, this.context = n, this.inputs = [], this.attrs = {}, this.inputs = t.inputNames.map(t => this.getInput(t)), null != t.rawAttrs && (this.attrs = Object.keys(t.rawAttrs).reduce((t, e) => (t[e] = this.getAttr(e), t), {}))
      }
      getInput(t) {
        return Object(da.e)(t, this.tensorMap, this.context)
      }
      getAttr(t, e) {
        const n = this.node.rawAttrs[t];
        if (null != n.tensor) return Object(da.e)(t, this.tensorMap, this.context);
        if (null != n.i || null != n.f) return Object(ha.f)(this.node.rawAttrs, t, e);
        if (null != n.s) return Object(ha.i)(this.node.rawAttrs, t, e);
        if (null != n.b) return Object(ha.c)(this.node.rawAttrs, t, e);
        if (null != n.shape) return Object(ha.k)(this.node.rawAttrs, t, e);
        if (null != n.type) return Object(ha.e)(this.node.rawAttrs, t, e);
        if (null != n.list) {
          if (null != n.list.i || null != n.list.f) return Object(ha.g)(this.node.rawAttrs, t, e);
          if (null != n.list.s) return Object(ha.h)(this.node.rawAttrs, t, e);
          if (null != n.list.shape) return Object(ha.j)(this.node.rawAttrs, t, e);
          if (null != n.list.b) return Object(ha.b)(this.node.rawAttrs, t, e);
          if (null != n.list.type) return Object(ha.d)(this.node.rawAttrs, t, e)
        }
        return e
      }
    }
    var fa = n(34);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ma = (t, e, n) => {
        switch (t.op) {
          case "BiasAdd":
          case "AddV2":
          case "Add":
            return [Ft.x(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "AddN":
            return [Ft.y(Object(da.d)("tensors", t, e, n))];
          case "FloorMod":
          case "Mod":
            return [Ft.oc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "Mul":
            return [Ft.qc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "RealDiv":
          case "Div":
            return [Ft.qb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "DivNoNan":
            return [Ft.rb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "FloorDiv":
            return [Ft.Fb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "Sub":
            return [Ft.rd(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "Minimum":
            return [Ft.nc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "Maximum":
            return [Ft.jc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "Pow":
            return [Ft.zc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          case "SquaredDifference":
            return [Ft.nd(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
          default:
            throw TypeError(`Node type ${t.op} is not implemented`)
        }
      },
      ga = (t, e, n) => {
        switch (t.op) {
          case "Abs":
          case "ComplexAbs":
            return [Ft.u(Object(da.d)("x", t, e, n))];
          case "Acos":
            return [Ft.v(Object(da.d)("x", t, e, n))];
          case "Acosh":
            return [Ft.w(Object(da.d)("x", t, e, n))];
          case "Asin":
            return [Ft.D(Object(da.d)("x", t, e, n))];
          case "Asinh":
            return [Ft.E(Object(da.d)("x", t, e, n))];
          case "Atan":
            return [Ft.F(Object(da.d)("x", t, e, n))];
          case "Atan2":
            return [Ft.G(Object(da.d)("x", t, e, n), Object(da.d)("y", t, e, n))];
          case "Atanh":
            return [Ft.H(Object(da.d)("x", t, e, n))];
          case "Ceil":
            return [Ft.V(Object(da.d)("x", t, e, n))];
          case "Complex":
            return [Ft.Y(Object(da.d)("real", t, e, n), Object(da.d)("imag", t, e, n))];
          case "Cos":
            return [Ft.ib(Object(da.d)("x", t, e, n))];
          case "Cosh":
            return [Ft.jb(Object(da.d)("x", t, e, n))];
          case "Elu":
            return [Ft.tb(Object(da.d)("x", t, e, n))];
          case "Erf":
            return [Ft.xb(Object(da.d)("x", t, e, n))];
          case "Exp":
            return [Ft.yb(Object(da.d)("x", t, e, n))];
          case "Expm1":
            return [Ft.Ab(Object(da.d)("x", t, e, n))];
          case "Floor":
            return [Ft.Eb(Object(da.d)("x", t, e, n))];
          case "Log":
            return [Ft.Yb(Object(da.d)("x", t, e, n))];
          case "Log1p":
            return [Ft.Zb(Object(da.d)("x", t, e, n))];
          case "Imag":
            return [Ft.Mb(Object(da.d)("x", t, e, n))];
          case "Neg":
            return [Ft.sc(Object(da.d)("x", t, e, n))];
          case "Reciprocal":
            return [Ft.Gc(Object(da.d)("x", t, e, n))];
          case "Real":
            return [Ft.Fc(Object(da.d)("x", t, e, n))];
          case "Relu":
            return [Ft.Jc(Object(da.d)("x", t, e, n))];
          case "Round":
            return [Ft.Nc(Object(da.d)("x", t, e, n))];
          case "Selu":
            return [Ft.Rc(Object(da.d)("x", t, e, n))];
          case "Sigmoid":
            return [Ft.Wc(Object(da.d)("x", t, e, n))];
          case "Sin":
            return [Ft.Yc(Object(da.d)("x", t, e, n))];
          case "Sign":
            return [Ft.Xc(Object(da.d)("x", t, e, n))];
          case "Sinh":
            return [Ft.Zc(Object(da.d)("x", t, e, n))];
          case "Softplus":
            return [Ft.hd(Object(da.d)("x", t, e, n))];
          case "Sqrt":
            return [Ft.ld(Object(da.d)("x", t, e, n))];
          case "Square":
            return [Ft.md(Object(da.d)("x", t, e, n))];
          case "Tanh":
            return [Ft.vd(Object(da.d)("x", t, e, n))];
          case "Tan":
            return [Ft.ud(Object(da.d)("x", t, e, n))];
          case "Relu6":
          case "ClipByValue":
            return [Ft.W(Object(da.d)("x", t, e, n), Object(da.d)("clipValueMin", t, e, n), Object(da.d)("clipValueMax", t, e, n))];
          case "Rsqrt":
            return [Ft.Oc(Object(da.e)(t.inputNames[0], e, n))];
          case "Prod":
            return [Ft.Bc(Object(da.d)("x", t, e, n), Object(da.d)("axes", t, e, n))];
          case "LeakyRelu":
            return [Ft.Sb(Object(da.d)("x", t, e, n), Object(da.d)("alpha", t, e, n))];
          case "Prelu":
            return [Ft.Ac(Object(da.d)("x", t, e, n), Object(da.d)("alpha", t, e, n))];
          default:
            throw TypeError(`Node type ${t.op} is not implemented`)
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ba(t, e, n = "") {
      Ft.Jd.assert(function (t, e) {
          if (t.length !== e.length) return !1;
          for (let n = 0; n < t.length; n++)
            if (-1 !== t[n] && -1 !== e[n] && t[n] !== e[n]) return !1;
          return !0
        }
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        (t, e), () => n + ` Shapes ${t} and ${e} must match`)
    }
    class ya {
      constructor(t, e, n, r, s, i, a) {
        this.name = t, this.dtype = e, this.maxSize = n, this.elementShape = r, this.identicalElementShapes = s, this.dynamicSize = i, this.clearAfterRead = a, this.tensors = [], this.closed_ = !1, this.idTensor = Object(Ft.Pc)(0), Object(Ft.Qb)(this.idTensor)
      }
      get id() {
        return this.idTensor.id
      }
      get closed() {
        return this.closed_
      }
      clearAndClose() {
        this.tensors.forEach(t => t.tensor.dispose()), this.tensors = [], this.closed_ = !0, this.idTensor.dispose()
      }
      size() {
        return this.tensors.length
      }
      read(t) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (t < 0 || t >= this.size()) throw new Error(`Tried to read from index ${t}, but array size is: ${this.size()}`);
        const e = this.tensors[t];
        if (e.cleared) throw new Error(`TensorArray ${this.name}: Could not read index ${t} twice because it was cleared after a previous read ` + "(perhaps try setting clear_after_read = false?).");
        return this.clearAfterRead && (e.cleared = !0), e.read = !0, e.tensor
      }
      readMany(t) {
        return t.map(t => this.read(t))
      }
      write(t, e) {
        if (this.closed_) throw new Error(`TensorArray ${this.name} has already been closed.`);
        if (t < 0 || !this.dynamicSize && t >= this.maxSize) throw new Error(`Tried to write to index ${t}, but array is not resizeable and size is: ${this.maxSize}`);
        const n = this.tensors[t] || {};
        if (e.dtype !== this.dtype) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${t},\n          because the value dtype is ${e.dtype}, but TensorArray dtype is ${this.dtype}.`);
        if (0 !== this.size() || null != this.elementShape && 0 !== this.elementShape.length || (this.elementShape = e.shape), ba(this.elementShape, e.shape, `TensorArray ${this.name}: Could not write to TensorArray index ${t}.`), n.read) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${t}, because it has already been read.`);
        if (n.written) throw new Error(`TensorArray ${this.name}: Could not write to TensorArray index ${t}, because it has already been written.`);
        n.tensor = e, Object(Ft.Qb)(e), n.written = !0, this.tensors[t] = n
      }
      writeMany(t, e) {
        if (t.length !== e.length) throw new Error(`TensorArray ${this.name}: could not write multiple tensors,` + `because the index size: ${t.length} is not the same as tensors size: ${e.length}.`);
        t.forEach((t, n) => this.write(t, e[n]))
      }
      gather(t, e) {
        if (e && e !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but gather requested dtype ${e}`);
        if (t) t = t.slice(0, this.size());
        else {
          t = [];
          for (let e = 0; e < this.size(); e++) t.push(e)
        }
        if (0 === t.length) return Object(Ft.wd)([], [0].concat(this.elementShape));
        const n = this.readMany(t);
        return ba(this.elementShape, n[0].shape, "TensorArray shape mismatch: "), Object(Ft.pd)(n, 0)
      }
      concat(t) {
        if (t && t !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but concat requested dtype ${t}`);
        if (0 === this.size()) return Object(Ft.wd)([], [0].concat(this.elementShape));
        const e = [];
        for (let t = 0; t < this.size(); t++) e.push(t);
        const n = this.readMany(e);
        return ba(this.elementShape, n[0].shape, `TensorArray shape mismatch: tensor array shape (${this.elementShape}) vs first tensor shape (${n[0].shape})`), Object(Ft.Z)(n, 0)
      }
      scatter(t, e) {
        if (e.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${e.dtype}`);
        if (t.length !== e.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${t.length} vs. ${e.shape[0]}`);
        const n = Math.max(...t);
        if (!this.dynamicSize && n >= this.maxSize) throw new Error(`Max index must be < array size (${n}  vs. ${this.maxSize})`);
        this.writeMany(t, Object(Ft.Hd)(e, 0))
      }
      split(t, e) {
        if (e.dtype !== this.dtype) throw new Error(`TensorArray dtype is ${this.dtype} but tensor has dtype ${e.dtype}`);
        let n = 0;
        const r = t.map(t => (n += t, n));
        if (n !== e.shape[0]) throw new Error(`Expected sum of lengths to be equal to\n          tensor.shape[0], but sum of lengths is\n        ${n}, and tensor's shape is: ${e.shape}`);
        if (!this.dynamicSize && t.length !== this.maxSize) throw new Error(`TensorArray's size is not equal to the size of lengths (${this.maxSize} vs. ${t.length}), ` + "and the TensorArray is not marked as dynamically resizeable");
        const s = 0 === n ? 0 : e.size / n,
          i = [];
        Object(Ft.Bd)(() => {
          e = e.reshape([1, n, s]);
          for (let n = 0; n < t.length; ++n) {
            const a = [0, 0 === n ? 0 : r[n - 1], 0],
              o = [1, t[n], s];
            i[n] = Object(Ft.ad)(e, a, o).reshape(this.elementShape)
          }
          return i
        });
        const a = [];
        for (let e = 0; e < t.length; e++) a[e] = e;
        this.writeMany(a, i)
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class wa {
      constructor(t, e, n, r = -1) {
        this.tensors = t, this.elementShape = e, this.elementDtype = n, null != t && t.forEach(t => {
          if (n !== t.dtype) throw new Error(`Invalid data types; op elements ${n}, but list elements ${t.dtype}`);
          ba(e, t.shape, "TensorList shape mismatch: "), Object(Ft.Qb)(t)
        }), this.idTensor = Object(Ft.Pc)(0), this.maxNumElements = r, Object(Ft.Qb)(this.idTensor)
      }
      get id() {
        return this.idTensor.id
      }
      copy() {
        return new wa([...this.tensors], this.elementShape, this.elementDtype)
      }
      clearAndClose() {
        this.tensors.forEach(t => t.dispose()), this.tensors.length = 0, this.idTensor.dispose()
      }
      size() {
        return this.tensors.length
      }
      stack(t, e, n = -1) {
        if (e !== this.elementDtype) throw new Error(`Invalid data types; op elements ${e}, but list elements ${this.elementDtype}`);
        if (-1 !== n && this.tensors.length !== n) throw new Error(`Operation expected a list with ${n} elements but got a list with ${this.tensors.length} elements.`);
        return ba(t, this.elementShape, "TensorList shape mismatch: "), Object(Ft.Bd)(() => {
          const e = this.tensors.map(e => e.reshape(t));
          return Object(Ft.pd)(e, 0)
        })
      }
      popBack(t, e) {
        if (e !== this.elementDtype) throw new Error(`Invalid data types; op elements ${e}, but list elements ${this.elementDtype}`);
        if (0 === this.size()) throw new Error("Trying to pop from an empty list.");
        const n = this.tensors.pop();
        return ba(n.shape, t, "TensorList shape mismatch: "), n.reshape(t)
      }
      pushBack(t) {
        if (t.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${t.dtype}, but list elements ${this.elementDtype}`);
        if (ba(t.shape, this.elementShape, "TensorList shape mismatch: "), this.maxNumElements === this.size()) throw new Error("Trying to push element into a full list.");
        Object(Ft.Qb)(t), this.tensors.push(t)
      }
      resize(t) {
        if (t < 0) throw new Error(`TensorListResize expects size to be non-negative. Got: ${t}`);
        if (-1 !== this.maxNumElements && t > this.maxNumElements) throw new Error(`TensorListResize input size ${t} is greater maxNumElement ${this.maxNumElements}.`);
        this.tensors.length = t
      }
      getItem(t, e, n) {
        if (n !== this.elementDtype) throw new Error(`Invalid data types; op elements ${n}, but list elements ${this.elementDtype}`);
        if (t < 0 || t > this.tensors.length) throw new Error(`Trying to access element ${t} in a list with ${this.tensors.length} elements.`);
        if (null == this.tensors[t]) throw new Error(`element at index ${t} is null.`);
        return ba(this.tensors[t].shape, e, "TensorList shape mismatch: "), this.tensors[t]
      }
      setItem(t, e) {
        if (e.dtype !== this.elementDtype) throw new Error(`Invalid data types; op elements ${e.dtype}, but list elements ${this.elementDtype}`);
        if (t < 0 || -1 !== this.maxNumElements && t >= this.maxNumElements) throw new Error(`Trying to set element ${t} in a list with max ${this.maxNumElements} elements.`);
        ba(this.elementShape, e.shape, "TensorList shape mismatch: "), Object(Ft.Qb)(e), this.tensors[t] = e
      }
      gather(t, e, n) {
        if (e !== this.elementDtype) throw new Error(`Invalid data types; op elements ${e}, but list elements ${this.elementDtype}`);
        return ba(this.elementShape, n, "TensorList shape mismatch: "), 0 === (t = t.slice(0, this.size())).length ? Object(Ft.wd)([], [0].concat(this.elementShape)) : Object(Ft.Bd)(() => {
          const e = t.map(t => this.tensors[t].reshape(n));
          return Object(Ft.pd)(e, 0)
        })
      }
      concat(t, e) {
        if (t && t !== this.elementDtype) throw new Error(`TensorList dtype is ${this.elementDtype} but concat requested dtype ${t}`);
        return ba(this.elementShape, e, "TensorList shape mismatch: "), 0 === this.size() ? Object(Ft.wd)([], [0].concat(this.elementShape)) : Object(Ft.Bd)(() => {
          const t = this.tensors.map(t => t.reshape(e));
          return Object(Ft.Z)(t, 0)
        })
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const va = async (t, e, n) => {
      switch (t.op) {
        case "If":
        case "StatelessIf": {
          const r = Object(da.d)("thenBranch", t, e, n),
            s = Object(da.d)("elseBranch", t, e, n),
            i = Object(da.d)("cond", t, e, n),
            a = Object(da.d)("args", t, e, n);
          return (await i.data())[0] ? n.functionMap[r].executeFunctionAsync(a, n.tensorArrayMap, n.tensorListMap) : n.functionMap[s].executeFunctionAsync(a, n.tensorArrayMap, n.tensorListMap)
        }
        case "While":
        case "StatelessWhile": {
          const r = Object(da.d)("body", t, e, n),
            s = Object(da.d)("cond", t, e, n),
            i = Object(da.d)("args", t, e, n),
            a = await n.functionMap[s].executeFunctionAsync(i, n.tensorArrayMap, n.tensorListMap),
            o = i.map(t => t.id);
          let u = await a[0].data();
          a.forEach(t => {
            t.kept || -1 !== o.indexOf(t.id) || t.dispose()
          });
          let c = i;
          for (; u[0];) {
            const t = c;
            c = await n.functionMap[r].executeFunctionAsync(c, n.tensorArrayMap, n.tensorListMap);
            const e = c.map(t => t.id);
            t.forEach(t => {
              t.kept || -1 !== o.indexOf(t.id) || -1 !== e.indexOf(t.id) || t.dispose()
            });
            const i = await n.functionMap[s].executeFunctionAsync(c, n.tensorArrayMap, n.tensorListMap);
            u = await i[0].data(), i.forEach(t => {
              t.kept || -1 !== o.indexOf(t.id) || -1 !== e.indexOf(t.id) || t.dispose()
            })
          }
          return c
        }
        case "LoopCond": {
          const r = Object(da.d)("pred", t, e, n);
          return [Object(da.a)(r)]
        }
        case "Switch": {
          const r = Object(da.d)("pred", t, e, n);
          let s = Object(da.d)("data", t, e, n);
          return s.kept || (s = Object(da.a)(s)), (await r.data())[0] ? [void 0, s] : [s, void 0]
        }
        case "Merge": {
          const r = t.inputNames.find(t => void 0 !== Object(da.e)(t, e, n));
          if (r) {
            const t = Object(da.e)(r, e, n);
            return [Object(da.a)(t)]
          }
          return
        }
        case "Enter": {
          const r = Object(da.d)("frameName", t, e, n),
            s = Object(da.d)("tensor", t, e, n);
          return n.enterFrame(r), [Object(da.a)(s)]
        }
        case "Exit": {
          const r = Object(da.d)("tensor", t, e, n);
          return n.exitFrame(), [Object(da.a)(r)]
        }
        case "NextIteration": {
          const r = Object(da.d)("tensor", t, e, n);
          return n.nextIteration(), [Object(da.a)(r)]
        }
        case "TensorArrayV3": {
          const r = Object(da.d)("size", t, e, n),
            s = Object(da.d)("dtype", t, e, n),
            i = Object(da.d)("elementShape", t, e, n),
            a = Object(da.d)("dynamicSize", t, e, n),
            o = Object(da.d)("clearAfterRead", t, e, n),
            u = Object(da.d)("identicalElementShapes", t, e, n),
            c = Object(da.d)("name", t, e, n),
            l = new ya(c, s, r, i, u, a, o);
          return n.addTensorArray(l), [l.idTensor, Object(Ft.Pc)(1)]
        }
        case "TensorArrayWriteV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = Object(da.d)("index", t, e, n),
            i = Object(da.d)("tensor", t, e, n),
            a = n.getTensorArray(r.id);
          return a.write(s, i), [a.idTensor]
        }
        case "TensorArrayReadV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = Object(da.d)("index", t, e, n);
          return [n.getTensorArray(r.id).read(s)]
        }
        case "TensorArrayGatherV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = Object(da.d)("indices", t, e, n),
            i = Object(da.d)("dtype", t, e, n);
          return [n.getTensorArray(r.id).gather(s, i)]
        }
        case "TensorArrayScatterV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = Object(da.d)("indices", t, e, n),
            i = Object(da.d)("tensor", t, e, n),
            a = n.getTensorArray(r.id);
          return a.scatter(s, i), [a.idTensor]
        }
        case "TensorArrayConcatV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = n.getTensorArray(r.id),
            i = Object(da.d)("dtype", t, e, n);
          return [s.concat(i)]
        }
        case "TensorArraySplitV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = Object(da.d)("tensor", t, e, n),
            i = Object(da.d)("lengths", t, e, n),
            a = n.getTensorArray(r.id);
          return a.split(i, s), [a.idTensor]
        }
        case "TensorArraySizeV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = n.getTensorArray(r.id);
          return [Object(Ft.Pc)(s.size(), "int32")]
        }
        case "TensorArrayCloseV3": {
          const r = Object(da.d)("tensorArrayId", t, e, n),
            s = n.getTensorArray(r.id);
          return s.clearAndClose(), [s.idTensor]
        }
        case "TensorListSetItem": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = Object(da.d)("index", t, e, n),
            i = Object(da.d)("tensor", t, e, n),
            a = n.getTensorList(r.id);
          return a.setItem(s, i), [a.idTensor]
        }
        case "TensorListGetItem": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = Object(da.d)("index", t, e, n),
            i = Object(da.d)("elementShape", t, e, n),
            a = Object(da.d)("elementDType", t, e, n);
          return [n.getTensorList(r.id).getItem(s, i, a)]
        }
        case "TensorListScatterV2":
        case "TensorListScatter": {
          const r = Object(da.d)("indices", t, e, n),
            s = function (t, e, n, r) {
              if (e.length !== t.shape[0]) throw new Error(`Expected len(indices) == tensor.shape[0], but saw: ${e.length} vs. ${t.shape[0]}`);
              const s = Math.max(...e);
              if (null != r && -1 !== r && s >= r) throw new Error(`Max index must be < array size (${s}  vs. ${r})`);
              const i = new wa([], n, t.dtype, r),
                a = Object(Ft.Hd)(t, 0);
              return e.forEach((t, e) => {
                i.setItem(t, a[e])
              }), i
            }(Object(da.d)("tensor", t, e, n), r, Object(da.d)("elementShape", t, e, n), Object(da.d)("numElements", t, e, n));
          return n.addTensorList(s), [s.idTensor]
        }
        case "TensorListReserve": {
          const r = function (t, e, n) {
            return new wa([], t, e, n)
          }(Object(da.d)("elementShape", t, e, n), Object(da.d)("elementDType", t, e, n), Object(da.d)("numElements", t, e, n));
          return n.addTensorList(r), [r.idTensor]
        }
        case "TensorListGather": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = Object(da.d)("indices", t, e, n),
            i = Object(da.d)("elementShape", t, e, n),
            a = Object(da.d)("elementDType", t, e, n);
          return [n.getTensorList(r.id).gather(s, a, i)]
        }
        case "TensorListStack": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = Object(da.d)("elementShape", t, e, n),
            i = Object(da.d)("elementDType", t, e, n),
            a = Object(da.d)("numElements", t, e, n);
          return [n.getTensorList(r.id).stack(s, i, a)]
        }
        case "TensorListFromTensor": {
          const r = function (t, e, n) {
            const r = t.dtype;
            if (t.shape.length < 1) throw new Error(`Tensor must be at least a vector, but saw shape: ${t.shape}`);
            if (t.dtype !== n) throw new Error(`Invalid data types; op elements ${t.dtype}, but list elements ${n}`);
            ba(t.shape.slice(1), e, "TensorList shape mismatch: ");
            const s = t.unstack();
            return new wa(s, e, r)
          }(Object(da.d)("tensor", t, e, n), Object(da.d)("elementShape", t, e, n), Object(da.d)("elementDType", t, e, n));
          return n.addTensorList(r), [r.idTensor]
        }
        case "TensorListConcat": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = n.getTensorList(r.id),
            i = Object(da.d)("dtype", t, e, n),
            a = Object(da.d)("elementShape", t, e, n);
          return [s.concat(i, a)]
        }
        case "TensorListPushBack": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = Object(da.d)("tensor", t, e, n),
            i = n.getTensorList(r.id);
          return i.pushBack(s), [i.idTensor]
        }
        case "TensorListPopBack": {
          const r = Object(da.d)("tensorListId", t, e, n),
            s = Object(da.d)("elementShape", t, e, n),
            i = Object(da.d)("elementDType", t, e, n);
          return [n.getTensorList(r.id).popBack(s, i)]
        }
        case "TensorListSplit": {
          const r = Object(da.d)("tensor", t, e, n),
            s = Object(da.d)("elementShape", t, e, n),
            i = function (t, e, n) {
              let r = 0;
              const s = e.map(t => (r += t, r));
              if (r !== t.shape[0]) throw new Error(`Expected sum of lengths to be equal to\n          tensor.shape[0], but sum of lengths is\n        ${r}, and tensor's shape is: ${t.shape}`);
              const i = 0 === r ? 0 : t.size / r,
                a = Object(Ft.Bd)(() => {
                  const a = [];
                  t = t.reshape([1, r, i]);
                  for (let r = 0; r < e.length; ++r) {
                    const o = [0, 0 === r ? 0 : s[r - 1], 0],
                      u = [1, e[r], i];
                    a[r] = Object(Ft.ad)(t, o, u).reshape(n)
                  }
                  return t.dispose(), a
                }),
                o = new wa([], n, t.dtype, e.length);
              for (let t = 0; t < a.length; t++) o.setItem(t, a[t]);
              return o
            }(r, Object(da.d)("lengths", t, e, n), s);
          return n.addTensorList(i), [i.idTensor]
        }
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function xa(t, e, n) {
      const [r, s] = Object(da.d)("fusedOps", t, e, n), i = "biasadd" === r, a = "prelu" === s, o = "fusedbatchnorm" === r, u = Object(da.d)("numArgs", t, e, n);
      if (i) {
        if (a && 2 !== u) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
        if (!a && 1 !== u) throw new Error("FusedConv2d and DepthwiseConv2d with BiasAdd must have one extra argument: bias.")
      }
      if (o) throw new Error("FusedConv2d and DepthwiseConv2d with FusedBatchNorm is not supported.");
      const c = Object(da.d)("strides", t, e, n),
        l = Object(da.c)(t, e, n),
        h = Object(da.d)("dataFormat", t, e, n).toUpperCase(),
        d = Object(da.d)("dilations", t, e, n),
        [p, f] = Object(da.d)("args", t, e, n);
      return {
        stride: c,
        pad: l,
        dataFormat: h,
        dilations: d,
        biasArg: p,
        preluArg: f,
        activationFunc: s
      }
    }
    const Oa = (t, e, n) => {
        switch (t.op) {
          case "Conv1D": {
            const r = Object(da.d)("stride", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("dataFormat", t, e, n).toUpperCase(),
              a = Object(da.d)("dilation", t, e, n);
            return [Ft.eb(Object(da.d)("x", t, e, n), Object(da.d)("filter", t, e, n), r, s, i, a)]
          }
          case "Conv2D": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.c)(t, e, n),
              i = Object(da.d)("dataFormat", t, e, n).toUpperCase(),
              a = Object(da.d)("dilations", t, e, n);
            return [Ft.fb(Object(da.d)("x", t, e, n), Object(da.d)("filter", t, e, n), [r[1], r[2]], s, i, [a[1], a[2]])]
          }
          case "_FusedConv2D": {
            const {
              stride: r,
              pad: s,
              dataFormat: i,
              dilations: a,
              biasArg: o,
              preluArg: u,
              activationFunc: c
            } = xa(t, e, n);
            return [Ft.Gb.conv2d({
              x: Object(da.d)("x", t, e, n),
              filter: Object(da.d)("filter", t, e, n),
              strides: [r[1], r[2]],
              pad: s,
              dataFormat: i,
              dilations: [a[1], a[2]],
              bias: o,
              activation: c,
              preluActivationWeights: u
            })]
          }
          case "FusedDepthwiseConv2dNative": {
            const {
              stride: r,
              pad: s,
              dataFormat: i,
              dilations: a,
              biasArg: o,
              preluArg: u,
              activationFunc: c
            } = xa(t, e, n);
            return [Ft.Gb.depthwiseConv2d({
              x: Object(da.d)("x", t, e, n),
              filter: Object(da.d)("filter", t, e, n),
              strides: [r[1], r[2]],
              pad: s,
              dataFormat: i,
              dilations: [a[1], a[2]],
              bias: o,
              activation: c,
              preluActivationWeights: u
            })]
          }
          case "Conv2DBackpropInput":
          case "Conv2dTranspose": {
            const r = Object(da.d)("outputShape", t, e, n),
              s = Object(da.d)("strides", t, e, n),
              i = Object(da.c)(t, e, n);
            return [Ft.gb(Object(da.d)("x", t, e, n), Object(da.d)("filter", t, e, n), r, [s[1], s[2]], i)]
          }
          case "DepthwiseConv2dNative":
          case "DepthwiseConv2d": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.c)(t, e, n),
              i = Object(da.d)("dilations", t, e, n),
              a = Object(da.d)("dataFormat", t, e, n).toUpperCase();
            return [Ft.mb(Object(da.d)("input", t, e, n), Object(da.d)("filter", t, e, n), [r[1], r[2]], s, a, [i[1], i[2]])]
          }
          case "Conv3D": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("dataFormat", t, e, n).toUpperCase(),
              a = Object(da.d)("dilations", t, e, n);
            return [Ft.hb(Object(da.d)("x", t, e, n), Object(da.d)("filter", t, e, n), [r[1], r[2], r[3]], s, i, [a[1], a[2], a[3]])]
          }
          case "AvgPool": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("kernelSize", t, e, n);
            return [Ft.I(Object(da.d)("x", t, e, n), [i[1], i[2]], [r[1], r[2]], s)]
          }
          case "MaxPool": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("kernelSize", t, e, n);
            return [Ft.gc(Object(da.d)("x", t, e, n), [i[1], i[2]], [r[1], r[2]], s)]
          }
          case "MaxPoolWithArgmax": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("kernelSize", t, e, n),
              a = Object(da.d)("includeBatchInIndex", t, e, n),
              {
                result: o,
                indexes: u
              } = Ft.ic(Object(da.d)("x", t, e, n), [i[1], i[2]], [r[1], r[2]], s, a);
            return [o, u]
          }
          case "AvgPool3D": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("kernelSize", t, e, n);
            return [Ft.J(Object(da.d)("x", t, e, n), [i[1], i[2], i[3]], [r[1], r[2], r[3]], s)]
          }
          case "MaxPool3D": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("kernelSize", t, e, n);
            return [Ft.hc(Object(da.d)("x", t, e, n), [i[1], i[2], i[3]], [r[1], r[2], r[3]], s)]
          }
          case "Dilation2D": {
            const r = Object(da.d)("strides", t, e, n),
              s = Object(da.d)("pad", t, e, n),
              i = Object(da.d)("dilations", t, e, n),
              a = r[1],
              o = r[2],
              u = i[1],
              c = i[2];
            return [Ft.ob(Object(da.d)("x", t, e, n), Object(da.d)("filter", t, e, n), [a, o], s, [u, c], "NHWC")]
          }
          default:
            throw TypeError(`Node type ${t.op} is not implemented`)
        }
      },
      Sa = (t, e, n) => {
        switch (t.op) {
          case "Fill": {
            const r = Object(da.d)("shape", t, e, n),
              s = Object(da.d)("dtype", t, e, n),
              i = Object(da.d)("value", t, e, n);
            return [Ft.Db(r, i, s)]
          }
          case "LinSpace": {
            const r = Object(da.d)("start", t, e, n),
              s = Object(da.d)("stop", t, e, n),
              i = Object(da.d)("num", t, e, n);
            return [Ft.Wb(r, s, i)]
          }
          case "Multinomial": {
            const r = Object(da.d)("logits", t, e, n),
              s = Object(da.d)("numSamples", t, e, n),
              i = Object(da.d)("seed", t, e, n);
            return [Ft.rc(r, s, i)]
          }
          case "OneHot": {
            const r = Object(da.d)("indices", t, e, n),
              s = Object(da.d)("depth", t, e, n),
              i = Object(da.d)("onValue", t, e, n),
              a = Object(da.d)("offValue", t, e, n);
            return [Ft.vc(r, s, i, a)]
          }
          case "Ones":
            return [Ft.wc(Object(da.d)("shape", t, e, n), Object(da.d)("dtype", t, e, n))];
          case "OnesLike":
            return [Ft.xc(Object(da.d)("x", t, e, n))];
          case "RandomUniform":
            return [Ft.Dc(Object(da.d)("shape", t, e, n), Object(da.d)("minval", t, e, n), Object(da.d)("maxval", t, e, n), Object(da.d)("dtype", t, e, n))];
          case "Range": {
            const r = Object(da.d)("start", t, e, n),
              s = Object(da.d)("stop", t, e, n),
              i = Object(da.d)("step", t, e, n);
            return [Ft.Ec(r, s, i, Object(da.d)("dtype", t, e, n))]
          }
          case "TruncatedNormal": {
            const r = Object(da.d)("shape", t, e, n),
              s = Object(da.d)("mean", t, e, n),
              i = Object(da.d)("stdDev", t, e, n),
              a = Object(da.d)("seed", t, e, n);
            return [Ft.Gd(r, s, i, Object(da.d)("dtype", t, e, n), a)]
          }
          case "Zeros":
            return [Ft.Pd(Object(da.d)("shape", t, e, n), Object(da.d)("dtype", t, e, n))];
          case "ZerosLike":
            return [Ft.Qd(Object(da.d)("x", t, e, n))];
          default:
            throw TypeError(`Node type ${t.op} is not implemented`)
        }
      };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function _a(t, e, n) {
      return {
        boxes: Object(da.d)("boxes", t, e, n),
        scores: Object(da.d)("scores", t, e, n),
        maxOutputSize: Object(da.d)("maxOutputSize", t, e, n),
        iouThreshold: Object(da.d)("iouThreshold", t, e, n),
        scoreThreshold: Object(da.d)("scoreThreshold", t, e, n),
        softNmsSigma: Object(da.d)("softNmsSigma", t, e, n)
      }
    }
    const ka = async (t, e, n) => {
      switch (t.op) {
        case "NonMaxSuppressionV5": {
          const {
            boxes: r,
            scores: s,
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o,
            softNmsSigma: u
          } = _a(t, e, n), c = await Ft.Nb.nonMaxSuppressionWithScoreAsync(r, s, i, a, o, u);
          return [c.selectedIndices, c.selectedScores]
        }
        case "NonMaxSuppressionV4": {
          const {
            boxes: r,
            scores: s,
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o
          } = _a(t, e, n), u = Object(da.d)("padToMaxOutputSize", t, e, n), c = await Ft.Nb.nonMaxSuppressionPaddedAsync(r, s, i, a, o, u);
          return [c.selectedIndices, c.validOutputs]
        }
        case "NonMaxSuppressionV3":
        case "NonMaxSuppressionV2": {
          const {
            boxes: r,
            scores: s,
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o
          } = _a(t, e, n);
          return [await Ft.Nb.nonMaxSuppressionAsync(r, s, i, a, o)]
        }
        case "Where": {
          const r = Object(da.d)("condition", t, e, n).asType("bool"),
            s = [await Ft.Od(r)];
          return r.dispose(), s
        }
        case "ListDiff":
          return Ft.Vc(Object(da.d)("x", t, e, n), Object(da.d)("y", t, e, n));
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Ca = (t, e, n) => {
      switch (t.op) {
        case "TopKV2": {
          const r = Object(da.d)("x", t, e, n),
            s = Object(da.d)("k", t, e, n),
            i = Object(da.d)("sorted", t, e, n),
            a = Ft.Dd(r, s, i);
          return [a.values, a.indices]
        }
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Ea = (t, e, n) => {
      switch (t.op) {
        case "Const":
          return e[t.name];
        case "PlaceholderWithDefault":
          const r = Object(da.d)("default", t, e, n);
          return [Object(da.e)(t.name, e, n) || r];
        case "Placeholder":
          return [Object(da.e)(t.name, e, n)];
        case "Identity":
        case "StopGradient":
        case "FakeQuantWithMinMaxVars": {
          const r = Object(da.d)("x", t, e, n);
          return [Object(da.a)(r)]
        }
        case "IdentityN":
          return Object(da.d)("x", t, e, n).map(t => Object(da.a)(t));
        case "Snapshot":
          const s = Object(da.d)("x", t, e, n);
          return [Object(da.a)(s)];
        case "Shape":
          return [Ft.xd(Object(da.d)("x", t, e, n).shape, "int32")];
        case "ShapeN":
          return Object(da.d)("x", t, e, n).map(t => Ft.xd(t.shape));
        case "Size":
          return [Ft.Pc(Object(da.d)("x", t, e, n).size, "int32")];
        case "Rank":
          return [Ft.Pc(Object(da.d)("x", t, e, n).rank, "int32")];
        case "NoOp":
          return [Ft.Pc(1)];
        case "Print":
          const i = Object(da.d)("x", t, e, n),
            a = Object(da.d)("data", t, e, n),
            o = Object(da.d)("message", t, e, n),
            u = Object(da.d)("summarize", t, e, n);
          console.warn("The graph has a tf.print() operation,usually used for debugging, which slows down performance."), console.log(o);
          for (let t = 0; t < a.length; t++) console.log(Array.prototype.slice.call(a[t].dataSync()).slice(0, u));
          return [i];
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Ia = (t, e, n) => {
      switch (t.op) {
        case "ResizeBilinear": {
          const r = Object(da.d)("images", t, e, n),
            s = Object(da.d)("size", t, e, n),
            i = Object(da.d)("alignCorners", t, e, n);
          return [Ft.Nb.resizeBilinear(r, [s[0], s[1]], i)]
        }
        case "ResizeNearestNeighbor": {
          const r = Object(da.d)("images", t, e, n),
            s = Object(da.d)("size", t, e, n),
            i = Object(da.d)("alignCorners", t, e, n);
          return [Ft.Nb.resizeNearestNeighbor(r, [s[0], s[1]], i)]
        }
        case "CropAndResize": {
          const r = Object(da.d)("image", t, e, n),
            s = Object(da.d)("boxes", t, e, n),
            i = Object(da.d)("boxInd", t, e, n),
            a = Object(da.d)("cropSize", t, e, n),
            o = Object(da.d)("method", t, e, n),
            u = Object(da.d)("extrapolationValue", t, e, n);
          return [Ft.Nb.cropAndResize(r, s, i, a, o, u)]
        }
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Ta = (t, e, n) => {
      switch (t.op) {
        case "Equal":
          return [Ft.wb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "NotEqual":
          return [Ft.uc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "Greater":
          return [Ft.Jb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "GreaterEqual":
          return [Ft.Kb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "Less":
          return [Ft.Tb(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "LessEqual":
          return [Ft.Ub(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "LogicalAnd":
          return [Ft.bc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "LogicalNot":
          return [Ft.cc(Object(da.d)("a", t, e, n))];
        case "LogicalOr":
          return [Ft.dc(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        case "Select":
        case "SelectV2":
          return [Ft.Nd(Object(da.d)("condition", t, e, n), Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n))];
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Aa = (t, e, n) => {
      switch (t.op) {
        case "BatchMatMul":
        case "BatchMatMulV2":
        case "MatMul":
          return [Ft.ec(Object(da.d)("a", t, e, n), Object(da.d)("b", t, e, n), Object(da.d)("transposeA", t, e, n), Object(da.d)("transposeB", t, e, n))];
        case "Transpose":
          return [Ft.Fd(Object(da.d)("x", t, e, n), Object(da.d)("perm", t, e, n))];
        case "_FusedMatMul":
          const [r, s] = Object(da.d)("fusedOps", t, e, n), i = "biasadd" === r, a = "prelu" === s, o = Object(da.d)("numArgs", t, e, n);
          if (i) {
            if (a && 2 !== o) throw new Error("Fused MatMul with BiasAdd and Prelu must have two extra arguments: bias and alpha.");
            if (!a && 1 !== o) throw new Error("Fused MatMul with BiasAdd must have one extra argument: bias.")
          }
          const [u, c] = Object(da.d)("args", t, e, n);
          return [Ft.Gb.matMul({
            a: Object(da.d)("a", t, e, n),
            b: Object(da.d)("b", t, e, n),
            transposeA: Object(da.d)("transposeA", t, e, n),
            transposeB: Object(da.d)("transposeB", t, e, n),
            bias: u,
            activation: s,
            preluActivationWeights: c
          })];
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Na = (t, e, n) => {
      switch (t.op) {
        case "FusedBatchNorm":
        case "FusedBatchNormV2":
        case "FusedBatchNormV3":
          return [Ft.M(Object(da.d)("x", t, e, n), Object(da.d)("mean", t, e, n), Object(da.d)("variance", t, e, n), Object(da.d)("offset", t, e, n), Object(da.d)("scale", t, e, n), Object(da.d)("epsilon", t, e, n))];
        case "LRN":
          return [Ft.Xb(Object(da.d)("x", t, e, n), Object(da.d)("radius", t, e, n), Object(da.d)("bias", t, e, n), Object(da.d)("alpha", t, e, n), Object(da.d)("beta", t, e, n))];
        case "Softmax":
          return [Ft.gd(Object(da.d)("x", t, e, n))];
        case "LogSoftmax":
          return [Ft.ac(Object(da.d)("x", t, e, n))];
        case "SparseToDense":
          return [Ft.jd(Object(da.d)("sparseIndices", t, e, n), Object(da.d)("outputShape", t, e, n), Object(da.d)("sparseValues", t, e, n), Object(da.d)("defaultValue", t, e, n))];
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, $a = (t, e, n) => {
      switch (t.op) {
        case "Max": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.fc(Object(da.d)("x", t, e, n), r, s)]
        }
        case "Mean": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.kc(Object(da.d)("x", t, e, n), r, s)]
        }
        case "Min": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.mc(Object(da.d)("x", t, e, n), r, s)]
        }
        case "Sum": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.sd(Object(da.d)("x", t, e, n), r, s)]
        }
        case "All": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.z(Object(da.d)("x", t, e, n), r, s)]
        }
        case "Any": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.A(Object(da.d)("x", t, e, n), r, s)]
        }
        case "ArgMax": {
          const r = Object(da.d)("axis", t, e, n);
          return [Ft.B(Object(da.d)("x", t, e, n), r)]
        }
        case "ArgMin": {
          const r = Object(da.d)("axis", t, e, n);
          return [Ft.C(Object(da.d)("x", t, e, n), r)]
        }
        case "Prod": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("keepDims", t, e, n);
          return [Ft.Bc(Object(da.d)("x", t, e, n), r, s)]
        }
        case "Cumsum": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("exclusive", t, e, n),
            i = Object(da.d)("reverse", t, e, n);
          return [Ft.kb(Object(da.d)("x", t, e, n), r, s, i)]
        }
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Ra = (t, e, n) => {
      switch (t.op) {
        case "ConcatV2":
        case "Concat": {
          const r = Object(da.d)("n", t, e, n),
            s = Object(da.d)("axis", t, e, n);
          let i = Object(da.d)("tensors", t, e, n);
          return i = i.slice(0, r), [Ft.Z(i, s)]
        }
        case "GatherV2":
        case "Gather": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("x", t, e, n),
            i = Object(da.d)("indices", t, e, n);
          return [Ft.Hb(s, i.asType("int32"), r)]
        }
        case "ReverseV2":
        case "Reverse": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("x", t, e, n);
          return [Ft.Lc(s, r)]
        }
        case "Slice": {
          const r = Object(da.d)("begin", t, e, n),
            s = Object(da.d)("size", t, e, n);
          return [Ft.ad(Object(da.d)("x", t, e, n), r, s)]
        }
        case "StridedSlice": {
          const r = Object(da.d)("begin", t, e, n),
            s = Object(da.d)("end", t, e, n),
            i = Object(da.d)("strides", t, e, n),
            a = Object(da.d)("beginMask", t, e, n),
            o = Object(da.d)("endMask", t, e, n),
            u = Object(da.d)("ellipsisMask", t, e, n),
            c = Object(da.d)("newAxisMask", t, e, n),
            l = Object(da.d)("shrinkAxisMask", t, e, n),
            h = Object(da.d)("x", t, e, n);
          return [Ft.qd(h, r, s, i, a, o, u, c, l)]
        }
        case "Pack":
          return Ft.Bd(() => {
            const r = Object(da.d)("axis", t, e, n),
              s = Object(da.d)("tensors", t, e, n),
              i = s[0].shape,
              a = s[0].squeeze().shape,
              o = s.map(t => {
                const e = Ft.Jd.arraysEqual(t.shape, i);
                if (!e && !Ft.Jd.arraysEqual(t.squeeze().shape, a)) throw new Error("the input tensors shape does not match");
                return e ? t : t.reshape(i)
              });
            return [Ft.pd(o, r)]
          });
        case "Unpack": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("tensor", t, e, n);
          return Ft.Hd(s, r)
        }
        case "Tile": {
          const r = Object(da.d)("reps", t, e, n);
          return [Ft.Cd(Object(da.d)("x", t, e, n), r)]
        }
        case "Split":
        case "SplitV": {
          const r = Object(da.d)("axis", t, e, n),
            s = Object(da.d)("numOrSizeSplits", t, e, n),
            i = Object(da.d)("x", t, e, n);
          return Ft.kd(i, s, r)
        }
        case "ScatterNd": {
          const r = Object(da.d)("indices", t, e, n),
            s = Object(da.d)("values", t, e, n),
            i = Object(da.d)("shape", t, e, n);
          return [Ft.Qc(r, s, i)]
        }
        case "GatherNd": {
          const r = Object(da.d)("x", t, e, n),
            s = Object(da.d)("indices", t, e, n);
          return [Ft.Ib(r, s)]
        }
        case "SparseToDense": {
          const r = Object(da.d)("sparseIndices", t, e, n),
            s = Object(da.d)("outputShape", t, e, n),
            i = Object(da.d)("sparseValues", t, e, n),
            a = Object(da.d)("defaultValue", t, e, n);
          return [Ft.jd(r, i, s, i.dtype === a.dtype ? a : a.asType(i.dtype))]
        }
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, ja = (t, e, n) => {
      switch (t.op) {
        case "FFT":
          return [Ft.Cb(Object(da.d)("x", t, e, n))];
        case "IFFT":
          return [Ft.Lb(Object(da.d)("x", t, e, n))];
        case "RFFT":
          return [Ft.Mc(Object(da.d)("x", t, e, n))];
        case "IRFFT":
          return [Ft.Pb(Object(da.d)("x", t, e, n))];
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    }, Da = (t, e, n) => {
      switch (t.op) {
        case "Cast":
          return [Ft.U(Object(da.d)("x", t, e, n), Object(da.d)("dtype", t, e, n))];
        case "ExpandDims": {
          const r = Object(da.d)("axis", t, e, n);
          return [Ft.zb(Object(da.d)("x", t, e, n), r)]
        }
        case "Squeeze": {
          const r = Object(da.d)("axis", t, e, n);
          return [Ft.od(Object(da.d)("x", t, e, n), r)]
        }
        case "Reshape":
          return [Ft.Kc(Object(da.d)("x", t, e, n), Object(da.d)("shape", t, e, n))];
        case "PadV2":
        case "Pad":
          return [Ft.yc(Object(da.d)("x", t, e, n), Object(da.d)("padding", t, e, n), Object(da.d)("constantValue", t, e, n))];
        case "SpaceToBatchND": {
          const r = Object(da.d)("blockShape", t, e, n),
            s = Object(da.d)("paddings", t, e, n);
          return [Ft.id(Object(da.d)("x", t, e, n), r, s)]
        }
        case "BatchToSpaceND": {
          const r = Object(da.d)("blockShape", t, e, n),
            s = Object(da.d)("crops", t, e, n);
          return [Ft.Q(Object(da.d)("x", t, e, n), r, s)]
        }
        case "DepthToSpace": {
          const r = Object(da.d)("blockSize", t, e, n),
            s = Object(da.d)("dataFormat", t, e, n).toUpperCase();
          return [Ft.lb(Object(da.d)("x", t, e, n), r, s)]
        }
        case "BroadcastTo":
          return [Ft.R(Object(da.d)("x", t, e, n), Object(da.d)("shape", t, e, n))];
        default:
          throw TypeError(`Node type ${t.op} is not implemented`)
      }
    };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Fa(t, e, n) {
      const r = ((t, e, n) => {
        switch (t.category) {
          case "arithmetic":
            return Ft.Bd(() => ma(t, e, n));
          case "basic_math":
            return Ft.Bd(() => ga(t, e, n));
          case "control":
            return va(t, e, n);
          case "convolution":
            return Ft.Bd(() => Oa(t, e, n));
          case "creation":
            return Ft.Bd(() => Sa(t, e, n));
          case "dynamic":
            return ka(t, e, n);
          case "evaluation":
            return Ft.Bd(() => Ca(t, e, n));
          case "image":
            return Ft.Bd(() => Ia(t, e, n));
          case "graph":
            return Ft.Bd(() => Ea(t, e, n));
          case "logical":
            return Ft.Bd(() => Ta(t, e, n));
          case "matrices":
            return Ft.Bd(() => Aa(t, e, n));
          case "normalization":
            return Ft.Bd(() => Na(t, e, n));
          case "reduction":
            return Ft.Bd(() => $a(t, e, n));
          case "slice_join":
            return Ft.Bd(() => Ra(t, e, n));
          case "spectral":
            return Ft.Bd(() => ja(t, e, n));
          case "transformation":
            return Ft.Bd(() => Da(t, e, n));
          case "custom":
            const r = Object(fa.a)(t.op);
            if (r && r.customExecutor) return r.customExecutor(new pa(t, e, n));
            throw TypeError(`Custom op ${t.op} is not registered.`);
          default:
            throw TypeError(`Unknown op '${t.op}'. File an issue at ` + "https://github.com/tensorflow/tfjs/issues so we can add it, or register a custom execution with tf.registerOp()")
        }
      })(t, e, n);
      return r instanceof Promise ? r.then(t => [].concat(t)) : [].concat(r)
    }
    class Ma {
      constructor(t = {}, e = {}, n = {}, r = {}) {
        this.weightMap = t, this.tensorArrayMap = e, this.tensorListMap = n, this.functionMap = r, this.rootContext = {
          id: 0,
          frameName: "",
          iterationId: 0
        }, this.contexts = [this.rootContext], this.lastId = 0, this.generateCurrentContextIds()
      }
      newFrame(t, e) {
        return {
          id: t,
          frameName: e,
          iterationId: 0
        }
      }
      set currentContext(t) {
        this.contexts !== t && (this.contexts = t, this.generateCurrentContextIds())
      }
      get currentContext() {
        return this.contexts
      }
      get currentContextId() {
        return this._currentContextIds[0]
      }
      get currentContextIds() {
        return this._currentContextIds
      }
      generateCurrentContextIds() {
        const t = [];
        for (let e = 0; e < this.contexts.length - 1; e++) {
          const n = this.contexts.slice(0, this.contexts.length - e);
          t.push(this.contextIdforContexts(n))
        }
        t.push(""), this._currentContextIds = t
      }
      contextIdforContexts(t) {
        return t ? t.map(t => 0 === t.id && 0 === t.iterationId ? "" : `${t.frameName}-${t.iterationId}`).join("/") : ""
      }
      enterFrame(t) {
        this.contexts && (this.lastId++, this.contexts = this.contexts.slice(), this.contexts.push(this.newFrame(this.lastId, t)), this._currentContextIds.unshift(this.contextIdforContexts(this.contexts)))
      }
      exitFrame() {
        if (!(this.contexts && this.contexts.length > 1)) throw new Error("Cannot exit frame, the context is empty");
        this.contexts = this.contexts.slice(), this.contexts.splice(-1), this.currentContextIds.shift()
      }
      nextIteration() {
        if (!(this.contexts && this.contexts.length > 0)) throw new Error("Cannot increase frame iteration, the context is empty"); {
          this.contexts = this.contexts.slice(), this.lastId++;
          const t = Object.assign({}, this.contexts[this.contexts.length - 1]);
          t.iterationId += 1, t.id = this.lastId, this.contexts.splice(-1, 1, t), this._currentContextIds.splice(0, 1, this.contextIdforContexts(this.contexts))
        }
      }
      getWeight(t) {
        return this.weightMap[t]
      }
      addTensorArray(t) {
        this.tensorArrayMap[t.id] = t
      }
      getTensorArray(t) {
        return this.tensorArrayMap[t]
      }
      addTensorList(t) {
        this.tensorListMap[t.id] = t
      }
      getTensorList(t) {
        return this.tensorListMap[t]
      }
      dispose() {
        for (const t in this.tensorArrayMap) this.tensorArrayMap[t].clearAndClose();
        for (const t in this.tensorListMap) this.tensorListMap[t].clearAndClose()
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function za(t, e, n) {
      const r = new Set,
        s = [];
      let i = null,
        a = null;
      const o = new Set,
        u = Object.keys(t).map(t => Object(da.g)(t)[0]),
        c = [...e];
      for (; c.length > 0;) {
        const t = c.pop();
        (Pa(t) || Wa(t)) && null == i && (i = t, a = i.children.map(t => t.name).filter(t => r.has(t))), r.add(t.name), null == n[t.name] && (-1 === u.indexOf(t.name) && (0 !== t.inputs.length ? t.inputs.forEach(t => {
          o.has(t.name) || (o.add(t.name), c.push(t))
        }) : s.push(t.name)))
      }
      return {
        inputs: t,
        outputs: e,
        usedNodes: r,
        missingInputs: s,
        dynamicNode: i,
        syncInputs: a
      }
    }
    const La = ["Switch", "Merge", "Enter", "Exit", "NextIteration", "StatelessIf", "StatelessWhile", "if", "While"],
      Ba = ["NonMaxSuppressionV2", "NonMaxSuppressionV3", "NonMaxSuppressionV5", "Where"];

    function Pa(t) {
      return La.indexOf(t.op) >= 0
    }

    function Wa(t) {
      return Ba.indexOf(t.op) >= 0
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ua {
      constructor(t, e) {
        this.graph = t, this.parent = e, this.compiledMap = new Map, this._weightMap = {}, this.SEPERATOR = ",", this._functions = {}, this._functionExecutorMap = {}, this._outputs = t.outputs, this._inputs = t.inputs, this._signature = t.signature, this._functions = t.functions, null != t.functions && Object.keys(t.functions).forEach(e => {
          this._functionExecutorMap[e] = new Ua(t.functions[e], this)
        })
      }
      get weightIds() {
        return this.parent ? this.parent.weightIds : this._weightIds
      }
      get functionExecutorMap() {
        return this.parent ? this.parent.functionExecutorMap : this._functionExecutorMap
      }
      get weightMap() {
        return this.parent ? this.parent.weightMap : this._weightMap
      }
      set weightMap(t) {
        const e = Object.keys(t).map(e => t[e].map(t => t.id));
        this._weightIds = [].concat(...e), this._weightMap = t
      }
      get inputs() {
        return this._inputs.map(t => ({
          name: t.name,
          shape: t.attrParams.shape ? t.attrParams.shape.value : void 0,
          dtype: t.attrParams.dtype ? t.attrParams.dtype.value : void 0
        }))
      }
      get outputs() {
        return this._outputs.map(t => ({
          name: t.name,
          shape: t.attrParams.shape ? t.attrParams.shape.value : void 0,
          dtype: t.attrParams.dtype ? t.attrParams.dtype.value : void 0
        }))
      }
      get inputNodes() {
        return this._inputs.map(t => t.signatureKey || t.name)
      }
      get outputNodes() {
        return this._outputs.map(t => {
          const e = t.signatureKey || t.name;
          return t.defaultOutput ? `${e}:${t.defaultOutput}` : e
        })
      }
      get functions() {
        return Object.keys(this._functions).reduce((t, e) => (t[e] = this._functions[e].signature, t), {})
      }
      getCompilationKey(t, e) {
        const n = t.map(t => t.name).sort(),
          r = e.map(t => t.name).sort();
        return n.join(this.SEPERATOR) + "--" + r.join(this.SEPERATOR)
      }
      compile(t, e) {
        const n = za(t, e, this.weightMap),
          {
            missingInputs: r,
            dynamicNode: s,
            syncInputs: i
          } = n;
        if (null != s) throw new Error(`This execution contains the node '${s.name}', which has ` + `the dynamic op '${s.op}'. Please use ` + "model.executeAsync() instead. Alternatively, to avoid the " + `dynamic ops, specify the inputs [${i}]`);
        if (r.length > 0) {
          const n = e.map(t => t.name),
            s = Object.keys(t);
          throw new Error(`Cannot compute the outputs [${n}] from the provided inputs ` + `[${s}]. Missing the following inputs: [${r}]`)
        }
        return function (t, e, n) {
          const {
            usedNodes: r,
            inputs: s
          } = n, i = [];
          Object.keys(s).map(t => Object(da.g)(t)[0]).map(e => t.nodes[e]).forEach(t => {
            r.has(t.name) && i.push(t)
          }), t.weights.forEach(t => {
            r.has(t.name) && i.push(t)
          });
          const a = new Set,
            o = [];
          for (; i.length > 0;) {
            const t = i.pop();
            a.add(t.name), e[t.name] || o.push(t), t.children.forEach(t => {
              !a.has(t.name) && r.has(t.name) && t.inputs.every(t => a.has(t.name)) && i.push(t)
            })
          }
          return o
        }(this.graph, this.weightMap, n)
      }
      execute(t, e) {
        t = this.mapInputs(t);
        const n = Object.keys(t).sort();
        this.checkInputs(t), this.checkInputShapeAndType(t), e = this.mapOutputs(e), this.checkOutputs(e);
        const r = n.map(t => this.graph.nodes[Object(da.g)(t)[0]]),
          s = e.map(t => this.graph.nodes[Object(da.g)(t)[0]]),
          i = this.getCompilationKey(r, s);
        let a = this.compiledMap.get(i);
        null == a && (a = this.compile(t, s), this.compiledMap.set(i, a));
        const o = {},
          u = {};
        return Object(Ft.Bd)(() => {
          const n = new Ma(this.weightMap, o, u, this.functionExecutorMap),
            r = Object.assign({}, this.weightMap);
          Object.keys(t).forEach(e => {
            const [n, s] = Object(da.g)(e), i = [];
            i[s] = t[e], r[n] = i
          });
          const s = this.getFrozenTensorIds(r),
            i = {};
          for (let t = 0; t < a.length; t++) {
            const o = a[t];
            if (!r[o.name]) {
              const t = Fa(o, r, n);
              if (t instanceof Promise) throw new Error(`The execution of the op '${o.op}' returned a promise. ` + "Please use model.executeAsync() instead.");
              r[o.name] = t, this.checkTensorForDisposal(o.name, o, r, n, s, e, i)
            }
          }
          return null == this.parent && n.dispose(), e.map(t => Object(da.e)(t, r, n))
        })
      }
      getFrozenTensorIds(t) {
        const e = [].concat.apply([], Object.keys(t).map(e => t[e]).map(t => t.map(t => t.id)));
        return new Set(e)
      }
      checkTensorForDisposal(t, e, n, r, s, i, a) {
        "control" !== e.category && -1 === i.indexOf(t) && (n[t].forEach(t => {
          null != t && (a[t.id] = (a[t.id] || 0) + e.children.length)
        }), e.inputs.forEach(t => {
          if ("control" !== t.category) {
            const e = Object(da.f)(t.name, n, r);
            null != e && e.forEach(t => {
              if (t && !s.has(t.id)) {
                const e = a[t.id];
                1 === e ? (t.dispose(), delete a[t.id]) : null != e && a[t.id]--
              }
            })
          }
        }))
      }
      async executeAsync(t, e) {
        return this._executeAsync(t, e)
      }
      async _executeAsync(t, e, n = !1, r = {}, s = {}) {
        n || (t = this.mapInputs(t), this.checkInputs(t), this.checkInputShapeAndType(t), e = this.mapOutputs(e), this.checkOutputs(e));
        const i = new Ma(this.weightMap, r, s, this.functionExecutorMap),
          a = await this.executeWithControlFlow(t, i, e, n),
          o = e.map(t => Object(da.e)(t, a, i)),
          u = new Set(o.map(t => t.id)),
          c = new Set(Object.keys(t).map(e => t[e].id));
        return Object.keys(a).forEach(t => {
          a[t].forEach(t => {
            !t || t.isDisposed || u.has(t.id) || c.has(t.id) || -1 !== this.weightIds.indexOf(t.id) || t.dispose()
          })
        }), null == this.parent && i.dispose(), o
      }
      async executeFunctionAsync(t, e, n) {
        const r = t.reduce((t, e, n) => (t[this.inputs[n].name] = e, t), {});
        return this._executeAsync(r, this.outputNodes, !0, e, n)
      }
      async executeWithControlFlow(t, e, n, r) {
        const s = Object.keys(t),
          i = s.map(t => this.graph.nodes[Object(da.g)(t)[0]]),
          a = n.map(t => this.graph.nodes[Object(da.g)(t)[0]]),
          {
            usedNodes: o,
            missingInputs: u,
            dynamicNode: c,
            syncInputs: l
          } = za(t, a, this.weightMap),
          h = [...i, ...this.graph.weights].map(t => ({
            node: t,
            contexts: e.currentContext
          })),
          d = Object.assign({}, this.weightMap);
        Object.keys(t).forEach(e => {
          const [n, r] = Object(da.g)(e), s = [];
          s[r] = t[e], d[n] = s
        });
        const p = {},
          f = this.getFrozenTensorIds(d),
          m = {};
        for (; h.length > 0;) {
          const t = this.processStack(i, h, e, d, m, f, n, p, o);
          await Promise.all(t)
        }
        null != c || r || console.warn("This model execution did not contain any nodes with control flow or dynamic output shapes. You can use model.execute() instead.");
        const g = a.filter(t => !Pa(t) && !Object(da.e)(t.name, d, e)).map(t => t.name);
        if (g.length > 0) {
          let t = "";
          throw null != c && (t = "Alternatively, to avoid the dynamic ops, use model.execute() " + `and specify the inputs [${l}]`), new Error(`Cannot compute the outputs [${g}] from the provided ` + `inputs [${s}]. Consider providing the following inputs: ` + `[${u}]. ${t}`)
        }
        return d
      }
      processStack(t, e, n, r, s, i, a, o, u) {
        const c = [];
        for (; e.length > 0;) {
          const l = e.pop();
          n.currentContext = l.contexts;
          let h = "";
          if ("Enter" === l.node.op && Object(da.d)("isConstant", l.node, r, n) && ([h] = Object(da.b)(l.node.name, n)), -1 === t.indexOf(l.node)) {
            const t = Fa(l.node, r, n);
            h || ([h] = Object(da.b)(l.node.name, n));
            const d = n.currentContext;
            t instanceof Promise ? c.push(t.then(t => (r[h] = t, n.currentContext = d, this.checkTensorForDisposal(h, l.node, r, n, i, a, o), this.processChildNodes(l.node, e, n, r, s, u), t))) : (r[h] = t, this.checkTensorForDisposal(h, l.node, r, n, i, a, o), this.processChildNodes(l.node, e, n, r, s, u))
          } else this.processChildNodes(l.node, e, n, r, s, u)
        }
        return c
      }
      processChildNodes(t, e, n, r, s, i) {
        t.children.forEach(t => {
          const [a] = Object(da.b)(t.name, n);
          !s[a] && i.has(t.name) && ("Merge" === t.op ? t.inputNames.some(t => !!Object(da.e)(t, r, n)) && (s[a] = !0, e.push({
            contexts: n.currentContext,
            node: t
          })) : t.inputNames.every(t => !!Object(da.e)(t, r, n)) && (s[a] = !0, e.push({
            contexts: n.currentContext,
            node: t
          })))
        })
      }
      dispose() {
        Object.keys(this.weightMap).forEach(t => this.weightMap[t].forEach(t => t.dispose()))
      }
      checkInputShapeAndType(t) {
        Object.keys(t).forEach(e => {
          const n = t[e],
            [r] = Object(da.g)(e),
            s = this.graph.nodes[r];
          if (s.attrParams.shape && s.attrParams.shape.value) {
            const t = s.attrParams.shape.value,
              e = t.length === n.shape.length && n.shape.every((e, n) => -1 === t[n] || t[n] === e);
            Ft.Jd.assert(e, () => `The shape of dict['${s.name}'] provided in ` + `model.execute(dict) must be [${t}], but was ` + `[${n.shape}]`)
          }
          s.attrParams.dtype && s.attrParams.dtype.value && Ft.Jd.assert(n.dtype === s.attrParams.dtype.value, () => `The dtype of dict['${s.name}'] provided in ` + "model.execute(dict) must be " + `${s.attrParams.dtype.value}, but was ${n.dtype}`)
        })
      }
      mapInputs(t) {
        const e = {};
        for (const n in t)
          if (null != this._signature && null != this._signature.inputs && null != this._signature.inputs[n]) {
            e[this._signature.inputs[n].name] = t[n]
          } else e[n] = t[n];
        return e
      }
      checkInputs(t) {
        const e = Object.keys(t).filter(t => {
          const [e] = Object(da.g)(t);
          return null == this.graph.nodes[e]
        });
        if (e.length > 0) throw new Error("The dict provided in model.execute(dict) has " + `keys: [${e}] that are not part of graph`)
      }
      mapOutputs(t) {
        return t.map(t => {
          if (null != this._signature && null != this._signature.outputs && null != this._signature.outputs[t]) {
            return this._signature.outputs[t].name
          }
          return t
        }, {})
      }
      checkOutputs(t) {
        t.forEach(t => {
          const [e] = Object(da.g)(t);
          if (!this.graph.nodes[e]) throw new Error(`The output '${t}' is not found in the graph`)
        })
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Va = "?tfjs-format=file",
      Ha = "model.json";
    class Ga {
      constructor(t, e = {}) {
        this.modelUrl = t, this.loadOptions = e, this.version = "n/a", null == e && (this.loadOptions = {})
      }
      get modelVersion() {
        return this.version
      }
      get inputNodes() {
        return this.executor.inputNodes
      }
      get outputNodes() {
        return this.executor.outputNodes
      }
      get inputs() {
        return this.executor.inputs
      }
      get outputs() {
        return this.executor.outputs
      }
      get weights() {
        return this.executor.weightMap
      }
      findIOHandler() {
        const t = this.modelUrl;
        if (null != t.load) this.handler = t;
        else if (null != this.loadOptions.requestInit) this.handler = Ft.Ob.browserHTTPRequest(t, this.loadOptions);
        else {
          const e = Ft.Ob.getLoadHandlers(t, this.loadOptions);
          if (0 === e.length) e.push(Ft.Ob.browserHTTPRequest(t, this.loadOptions));
          else if (e.length > 1) throw new Error(`Found more than one (${e.length}) load handlers for ` + `URL '${[t]}'`);
          this.handler = e[0]
        }
      }
      async load() {
        if (this.findIOHandler(), null == this.handler.load) throw new Error("Cannot proceed with model loading because the IOHandler provided does not have the `load` method implemented.");
        const t = await this.handler.load();
        return this.loadSync(t)
      }
      loadSync(t) {
        this.artifacts = t;
        const e = this.artifacts.modelTopology;
        let n = {};
        null != this.artifacts.userDefinedMetadata && (n = this.artifacts.userDefinedMetadata.signature), this.version = `${e.versions.producer}.${e.versions.minConsumer}`;
        const r = Ft.Ob.decodeWeights(this.artifacts.weightData, this.artifacts.weightSpecs);
        return this.executor = new Ua(ha.a.Instance.transformGraph(e, n)), this.executor.weightMap = this.convertTensorMapToTensorsMap(r), !0
      }
      async save(t, e) {
        if ("string" == typeof t) {
          const e = Ft.Ob.getSaveHandlers(t);
          if (0 === e.length) throw new Error(`Cannot find any save handlers for URL '${t}'`);
          if (e.length > 1) throw new Error(`Found more than one (${e.length}) save handlers for ` + `URL '${t}'`);
          t = e[0]
        }
        if (null == t.save) throw new Error("GraphModel.save() cannot proceed because the IOHandler provided does not have the `save` attribute defined.");
        return t.save(this.artifacts)
      }
      predict(t, e) {
        return this.execute(t, this.outputNodes)
      }
      normalizeInputs(t) {
        if (!(t instanceof Ft.r || Array.isArray(t))) return t;
        if ((t = Array.isArray(t) ? t : [t]).length !== this.inputNodes.length) throw new Error("Input tensor count mismatch," + `the graph model has ${this.inputNodes.length} placeholders, ` + `while there are ${t.length} input tensors.`);
        return this.inputNodes.reduce((e, n, r) => (e[n] = t[r], e), {})
      }
      normalizeOutputs(t) {
        return t = t || this.outputNodes, Array.isArray(t) ? t : [t]
      }
      execute(t, e) {
        t = this.normalizeInputs(t), e = this.normalizeOutputs(e);
        const n = this.executor.execute(t, e);
        return n.length > 1 ? n : n[0]
      }
      async executeAsync(t, e) {
        t = this.normalizeInputs(t), e = this.normalizeOutputs(e);
        const n = await this.executor.executeAsync(t, e);
        return n.length > 1 ? n : n[0]
      }
      convertTensorMapToTensorsMap(t) {
        return Object.keys(t).reduce((e, n) => (e[n] = [t[n]], e), {})
      }
      dispose() {
        this.executor.dispose()
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    var qa = n(26),
      Ka = n(13),
      Ja = n(24);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    class Xa {
      constructor() {
        this.size = null
      }
      batch(t, e = !0) {
        const n = this;
        let r;
        return Ft.Jd.assert(t > 0, () => `batchSize needs to be positive, but it is\n      ${t}`), r = this.size === 1 / 0 || null == this.size ? this.size : e ? Math.ceil(this.size / t) : Math.floor(this.size / t), Ya(async () => (await n.iterator()).columnMajorBatch(t, e, Za), r)
      }
      concatenate(t) {
        const e = this;
        let n;
        return n = this.size === 1 / 0 || t.size === 1 / 0 ? 1 / 0 : null != this.size && null != t.size ? this.size + t.size : null, Ya(async () => (await e.iterator()).concatenate(await t.iterator()), n)
      }
      filter(t) {
        const e = this;
        let n;
        return n = this.size === 1 / 0 ? 1 / 0 : null, Ya(async () => (await e.iterator()).filter(e => Ft.Bd(() => t(e))), n)
      }
      async forEachAsync(t) {
        return (await this.iterator()).forEachAsync(t)
      }
      map(t) {
        const e = this;
        return Ya(async () => (await e.iterator()).map(e => Ft.Bd(() => t(e))), this.size)
      }
      mapAsync(t) {
        const e = this;
        return Ya(async () => (await e.iterator()).mapAsync(t), this.size)
      }
      prefetch(t) {
        if (null == t) throw new RangeError("`Dataset.prefetch()` requires bufferSize to be specified.");
        const e = this;
        return Ya(async () => (await e.iterator()).prefetch(t), this.size)
      }
      repeat(t) {
        const e = this;
        let n;
        return n = null != this.size && t > 0 ? this.size * t : 0 === t ? 0 : null != this.size && (void 0 === t || t < 0) ? 1 / 0 : null, Ya(async () => {
          const n = Object(Ka.e)(async () => ({
            value: await e.iterator(),
            done: !1
          }));
          return Object(Ka.d)(n.take(t))
        }, n)
      }
      skip(t) {
        const e = this;
        let n;
        return n = null != this.size && t >= 0 && this.size >= t ? this.size - t : null != this.size && (this.size < t || void 0 === t || t < 0) ? 0 : null, Ya(async () => (await e.iterator()).skip(t), n)
      }
      shuffle(t, e, n = !0) {
        if (null == t || t < 0) throw null == this.size ? new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.") : new RangeError("`Dataset.shuffle()` requires bufferSize to be specified.  If your data fits in main memory (for regular JS objects), and/or GPU memory (for `tf.Tensor`s), consider setting " + `bufferSize to the dataset size (${this.size} elements)`);
        const r = this,
          s = qa.alea(e || Ft.Jd.now().toString());
        return Ya(async () => {
          let e = s.int32();
          return n && (e += s.int32()), (await r.iterator()).shuffle(t, e.toString())
        }, this.size)
      }
      take(t) {
        const e = this;
        let n;
        return n = null != this.size && this.size > t ? t : null != this.size && this.size <= t ? this.size : null, Ya(async () => (await e.iterator()).take(t), n)
      }
      async toArray() {
        if (this.size === 1 / 0) throw new Error("Can not convert infinite data stream to array.");
        return (await this.iterator()).toArray()
      }
      async toArrayForTest() {
        if (this.size === 1 / 0) throw new Error("Can not convert infinite data stream to array.");
        return (await this.iterator()).toArrayForTest()
      }
    }

    function Ya(t, e = null) {
      return new class extends Xa {
        constructor() {
          super(...arguments), this.size = e
        }
        async iterator() {
          return t()
        }
      }
    }

    function Za(t) {
      if (null === t) return null;
      const e = t[0];
      if (Object(Ja.a)(e)) {
        return {
          value: function (t) {
            if (0 === t.length) throw new Error("Can't make a batch of zero elements.");
            return t[0] instanceof Ft.r ? Ft.pd(t) : Ft.wd(t)
          }
          /**
           * @license
           * Copyright 2018 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           *
           * =============================================================================
           */
          (t),
          recurse: !1
        }
      }
      return {
        value: null,
        recurse: !0
      }
    }
    Xa.MAX_BUFFER_SIZE = 1e4;
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    Symbol("out"), Symbol("field"), Symbol("quote"), Symbol("quoteafterquote"), Symbol("quoteinquote");
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    Ka.a;
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    Ka.a;
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    var Qa = n(99);
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    Qa.a;
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function to(t, e) {
      Array.isArray(t) || (t = [t]), t.forEach(t => {
        null != t && Ft.Jd.assert("complex64" !== t.dtype, () => `${e} does not support complex64 tensors in the CPU backend.`)
      })
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function eo(t, e, n, r, s, i) {
      const a = s.strideHeight,
        o = s.strideWidth,
        u = s.dilationHeight,
        c = s.dilationWidth,
        l = s.effectiveFilterHeight,
        h = s.effectiveFilterWidth,
        d = s.padInfo.top,
        p = s.padInfo.left,
        f = "max" === i ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
        m = Object(Ft.T)(s.outShape, n),
        g = m.values,
        b = s.outShape[1] * s.outShape[2] * s.outShape[3],
        y = s.outShape[2] * s.outShape[3],
        w = s.outShape[3];
      for (let e = 0; e < s.batchSize; ++e) {
        const n = e * b,
          m = e * r[0];
        for (let e = 0; e < s.inChannels; ++e)
          for (let b = 0; b < s.outHeight; ++b) {
            const v = b * a - d,
              x = Math.max(0, v),
              O = Math.min(s.inHeight, l + v),
              S = n + b * y;
            for (let n = 0; n < s.outWidth; ++n) {
              const a = n * o - p,
                l = Math.max(0, a),
                d = Math.min(s.inWidth, h + a);
              let b = f,
                y = 0,
                v = 0;
              for (let n = x; n < O; n += u) {
                const s = m + n * r[1];
                for (let n = l; n < d; n += c) {
                  const a = t[s + n * r[2] + e];
                  "max" === i && a > b ? b = a : "avg" === i && (y += a, v++)
                }
                if (isNaN(b)) break
              }
              g[S + n * w + e] = "avg" === i ? y / v : b
            }
          }
      }
      return m
    }

    function no(t, e, n, r, s = !1, i = !1) {
      const a = Object(Ft.T)(r.outShape, "int32"),
        o = r.strideHeight,
        u = r.strideWidth,
        c = r.dilationHeight,
        l = r.dilationWidth,
        h = r.effectiveFilterHeight,
        d = r.effectiveFilterWidth,
        p = r.padInfo.top,
        f = r.padInfo.left,
        m = Object(Ft.T)(e, n, t);
      for (let t = 0; t < r.batchSize; ++t)
        for (let e = 0; e < r.inChannels; ++e)
          for (let n = 0; n < r.outHeight; ++n) {
            const g = n * o - p;
            let b = g;
            for (; b < 0;) b += c;
            const y = Math.min(r.inHeight, h + g);
            for (let o = 0; o < r.outWidth; ++o) {
              const h = o * u - f;
              let p = h;
              for (; p < 0;) p += l;
              const w = Math.min(r.inWidth, d + h);
              let v = Number.NEGATIVE_INFINITY,
                x = -1;
              for (let n = b; n < y; n += c) {
                const a = n - g;
                for (let o = p; o < w; o += l) {
                  const u = o - h,
                    c = m.get(t, n, o, e);
                  c > v && (v = c, x = s ? i ? ((t * r.inHeight + n) * r.inWidth + o) * r.inChannels + e : (n * r.inWidth + o) * r.inChannels + e : a * d + u)
                }
              }
              a.set(x, t, n, o, e)
            }
          }
      return a
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ro = Ft.Rb.nonMaxSuppressionV3Impl,
      so = Ft.Rb.split,
      io = Ft.Rb.tile,
      ao = Ft.Rb.topkImpl,
      oo = Ft.Rb.whereImpl;

    function uo(t, e, n, r) {
      if ("linear" === n) return t.linear(e);
      if ("relu" === n) return t.relu(e);
      if ("elu" === n) return t.elu(e);
      if ("relu6" === n) return t.relu6(e);
      if ("prelu" === n) return t.prelu(e, r);
      throw new Error(`Activation ${n} has not been implemented for the CPU backend.`)
    }
    class co extends Ft.h {
      constructor() {
        super(), this.blockSize = 48, this.firstUse = !0, this.data = new Ft.a(this, Object(Ft.ub)())
      }
      write(t, e, n) {
        this.firstUse && (this.firstUse = !1, Object(Ft.vb)().get("IS_NODE") && Ft.L.warn("\n============================\nHi there 👋. Looks like you are running TensorFlow.js in Node.js. To speed things up dramatically, install our node backend, which binds to TensorFlow C++, by running npm i @tensorflow/tfjs-node, or npm i @tensorflow/tfjs-node-gpu if you have CUDA. Then call require('@tensorflow/tfjs-node'); (-gpu suffix for CUDA) at the start of your program. Visit https://github.com/tensorflow/tfjs-node for more details.\n============================"));
        const r = {};
        return this.data.set(r, {
          values: t,
          dtype: n
        }), r
      }
      move(t, e, n, r) {
        this.data.set(t, {
          values: e,
          dtype: r
        })
      }
      numDataIds() {
        return this.data.numDataIds()
      }
      async read(t) {
        return this.readSync(t)
      }
      readSync(t) {
        const {
          dtype: e,
          complexTensors: n
        } = this.data.get(t);
        if ("complex64" === e) {
          const t = this.readSync(n.real.dataId),
            e = this.readSync(n.imag.dataId);
          return Ft.L.mergeRealAndImagArrays(t, e)
        }
        return this.data.get(t).values
      }
      bufferSync(t) {
        const e = this.readSync(t.dataId);
        let n = e;
        if ("string" === t.dtype) try {
          n = e.map(t => Ft.Jd.decodeString(t))
        } catch (t) {
          throw new Error("Failed to decode encoded string bytes into utf-8")
        }
        return Ft.T(t.shape, t.dtype, n)
      }
      makeOutput(t, e, n) {
        const r = this.write(t, e, n);
        return Object(Ft.ub)().makeTensorFromDataId(r, e, n, this)
      }
      disposeData(t) {
        if (this.data.has(t)) {
          const {
            complexTensors: e
          } = this.data.get(t);
          null != e && (e.real.dispose(), e.imag.dispose()), this.data.delete(t)
        }
      }
      async time(t) {
        const e = Ft.Jd.now();
        return t(), {
          kernelMs: Ft.Jd.now() - e
        }
      }
      memory() {
        return {
          unreliable: !0,
          reasons: ["The reported memory is an upper bound. Due to automatic garbage collection, the true allocated memory may be less."]
        }
      }
      complex(t, e) {
        const n = this.makeOutput(null, t.shape, "complex64");
        return this.data.get(n.dataId).complexTensors = {
          real: Object(Ft.ub)().keep(t.clone()),
          imag: Object(Ft.ub)().keep(e.clone())
        }, n
      }
      real(t) {
        return this.data.get(t.dataId).complexTensors.real.clone()
      }
      imag(t) {
        return this.data.get(t.dataId).complexTensors.imag.clone()
      }
      slice(t, e, n) {
        if (to(t, "slice"), Ft.fd.isSliceContinous(t.shape, e, n)) {
          const r = Ft.fd.computeFlatOffset(e, t.strides),
            s = Ft.Jd.sizeFromShape(n),
            i = this.readSync(t.dataId);
          return Ft.wd(i.subarray(r, r + s), n, t.dtype)
        }
        const r = Ft.T(n, t.dtype),
          s = this.bufferSync(t);
        for (let t = 0; t < r.size; ++t) {
          const n = r.indexToLoc(t).map((t, n) => t + e[n]);
          r.values[t] = s.get(...n)
        }
        return r.toTensor()
      }
      stridedSlice(t, e, n, r) {
        to(t, "stridedSlice");
        const s = Ft.fd.computeOutShape(e, n, r);
        if (s.some(t => 0 === t)) return Ft.wd([], s);
        const i = Ft.T(s, t.dtype),
          a = this.bufferSync(t);
        for (let t = 0; t < i.size; t++) {
          const n = i.indexToLoc(t),
            s = new Array(n.length);
          for (let t = 0; t < s.length; t++) s[t] = n[t] * r[t] + e[t];
          i.set(a.get(...s), ...n)
        }
        return i.toTensor()
      }
      diag(t) {
        const e = this.readSync(t.dataId),
          n = Ft.T([t.size, t.size], t.dtype),
          r = n.values;
        for (let n = 0; n < e.length; n++) r[n * t.size + n] = e[n];
        return n.toTensor()
      }
      unstack(t, e) {
        const n = t.shape[e],
          r = new Array(t.rank - 1);
        let s = 0;
        for (let n = 0; n < t.rank; n++) n !== e && (r[s++] = t.shape[n]);
        const i = new Array(t.rank).fill(0),
          a = t.shape.slice();
        a[e] = 1;
        const o = new Array(n);
        for (let n = 0; n < o.length; n++) i[e] = n, o[n] = this.slice(t, i, a).reshape(r);
        return o
      }
      reverse(t, e) {
        to(t, "reverse");
        const n = Ft.T(t.shape, t.dtype),
          r = this.bufferSync(t);
        for (let s = 0; s < n.size; s++) {
          const i = n.indexToLoc(s),
            a = i.slice();
          e.forEach(e => a[e] = t.shape[e] - 1 - a[e]), n.set(r.get(...a), ...i)
        }
        return n.toTensor()
      }
      concat(t, e) {
        if ("complex64" === t[0].dtype) {
          const n = t.map(t => Ft.Fc(t)),
            r = t.map(t => Ft.Mb(t));
          return Ft.Y(this.concat(n, e), this.concat(r, e))
        }
        const n = t.map(t => {
            const n = Ft.Jd.sizeFromShape(t.shape.slice(e));
            return t.as2D(-1, n)
          }),
          r = Ft.L.computeOutShape(n.map(t => t.shape), 1),
          s = Ft.T(r, t[0].dtype).values;
        if (1 === n[0].shape[0]) {
          let t = 0;
          n.forEach(e => {
            s.set(this.readSync(e.dataId), t), t += e.size
          })
        } else {
          let t = 0;
          n.forEach(e => {
            const n = this.readSync(e.dataId);
            let i = 0;
            for (let a = 0; a < e.shape[0]; ++a) {
              const o = a * r[1] + t;
              for (let t = 0; t < e.shape[1]; ++t) s[o + t] = n[i++]
            }
            t += e.shape[1]
          })
        }
        const i = Ft.L.computeOutShape(t.map(t => t.shape), e);
        return Ft.wd(s, i, t[0].dtype)
      }
      neg(t) {
        return to(t, "neg"), this.multiply(Ft.Pc(-1), t)
      }
      add(t, e) {
        return "complex64" === t.dtype || "complex64" === e.dtype ? this.broadcastedBinaryComplexOp(t.cast("complex64"), e.cast("complex64"), (t, e, n, r) => ({
          real: t + n,
          imag: e + r
        })) : this.broadcastedBinaryOp(t, e, Object(Ft.Id)(t.dtype, e.dtype), (t, e) => t + e)
      }
      addN(t) {
        to(t, "addN");
        const e = t.map(t => this.readSync(t.dataId)),
          n = Ft.T(t[0].shape, t[0].dtype),
          r = n.values;
        for (let n = 0; n < t.length; n++) {
          const t = e[n];
          for (let e = 0; e < r.length; e++) r[e] += t[e]
        }
        return n.toTensor()
      }
      softmax(t, e) {
        const n = Ft.Jd.parseAxisParam([e], t.shape),
          r = Object(Ft.fc)(t, n),
          s = Ft.L.expandShapeToKeepDim(r.shape, n),
          i = this.subtract(t, r.reshape(s)),
          a = this.exp(i),
          o = this.sum(a, n).reshape(s);
        return Ft.qb(a, o)
      }
      subtract(t, e) {
        return "complex64" === t.dtype || "complex64" === e.dtype ? this.broadcastedBinaryComplexOp(t.cast("complex64"), e.cast("complex64"), (t, e, n, r) => ({
          real: t - n,
          imag: e - r
        })) : this.broadcastedBinaryOp(t, e, Object(Ft.Id)(t.dtype, e.dtype), (t, e) => t - e)
      }
      pow(t, e) {
        return to([t, e], "pow"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => Math.pow(t, e))
      }
      batchMatMul(t, e, n, r) {
        to([t, e], "matMul");
        const s = n ? t.shape[1] : t.shape[2],
          i = n ? t.shape[2] : t.shape[1],
          a = r ? e.shape[1] : e.shape[2],
          o = t.shape[0],
          u = this.readSync(t.dataId),
          c = this.readSync(e.dataId),
          [l, h, d] = n ? [t.strides[0], 1, t.strides[1]] : [t.strides[0], t.strides[1], 1],
          [p, f, m] = r ? [1, e.strides[1], e.strides[0]] : [e.strides[1], 1, e.strides[0]],
          g = i * a,
          b = Ft.T([o, i, a], t.dtype),
          y = b.values,
          w = this.blockSize;
        for (let t = 0; t < o; t++)
          for (let e = 0; e < i; e += w)
            for (let n = 0; n < a; n += w)
              for (let r = 0; r < s; r += w) {
                const o = Math.min(e + w, i),
                  b = Math.min(n + w, a),
                  v = Math.min(r + w, s);
                for (let s = e; s < o; s++)
                  for (let e = n; e < b; e++) {
                    let n = 0;
                    for (let i = r; i < v; i++) n += u[t * l + s * h + i * d] * c[i * p + e * f + t * m];
                    y[t * g + (s * a + e)] += n
                  }
              }
        return b.toTensor()
      }
      fusedBatchMatMul({
        a: t,
        b: e,
        transposeA: n,
        transposeB: r,
        bias: s,
        activation: i,
        preluActivationWeights: a
      }) {
        let o = this.batchMatMul(t, e, n, r);
        return s && (o = this.add(o, s)), i && (o = uo(this, o, i, a)), o
      }
      multiply(t, e) {
        return "complex64" === t.dtype || "complex64" === e.dtype ? this.broadcastedBinaryComplexOp(t.cast("complex64"), e.cast("complex64"), (t, e, n, r) => ({
          real: t * n - e * r,
          imag: t * r + e * n
        })) : this.broadcastedBinaryOp(t, e, Object(Ft.Id)(t.dtype, e.dtype), (t, e) => t * e)
      }
      floorDiv(t, e) {
        to([t, e], "floorDiv");
        return this.broadcastedBinaryOp(t, e, "int32", (t, e) => Math.floor(t / e))
      }
      sum(t, e) {
        to(t, "sum"), Ft.L.assertAxesAreInnerMostDims("sum", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Object(Ft.Id)(t.dtype, "int32"), i = Ft.Pd(n, s), a = Ft.Jd.sizeFromShape(r), o = this.readSync(i.dataId), u = this.readSync(t.dataId);
        for (let t = 0; t < o.length; ++t) {
          const e = t * a;
          let n = 0;
          for (let t = 0; t < a; ++t) n += u[e + t];
          o[t] = n
        }
        return i
      }
      prod(t, e) {
        to(t, "sum");
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Object(Ft.Id)(t.dtype, "int32"), i = Ft.Pd(n, s), a = Ft.Jd.sizeFromShape(r), o = this.readSync(i.dataId), u = this.readSync(t.dataId);
        for (let t = 0; t < o.length; ++t) {
          const e = t * a;
          let n = 1;
          for (let t = 0; t < a; ++t) n *= u[e + t];
          o[t] = n
        }
        return i
      }
      unsortedSegmentSum(t, e, n) {
        to(t, "unsortedSegmentSum");
        const r = [],
          s = t.rank - e.rank;
        for (let t = 0; t < s; ++t) e = e.expandDims(t + 1);
        for (let s = 0; s < n; ++s) {
          const n = Ft.Pc(s, "int32"),
            i = Ft.wb(n, e).asType("float32").mul(t).sum(0);
          r.push(i)
        }
        return Ft.pd(r)
      }
      argMin(t, e) {
        to(t, "argMin");
        const n = [e];
        Ft.L.assertAxesAreInnerMostDims("argMin", n, t.rank);
        const [r, s] = Ft.L.computeOutAndReduceShapes(t.shape, n), i = Ft.Pd(r, "int32"), a = Ft.Jd.sizeFromShape(s), o = this.readSync(i.dataId), u = this.readSync(t.dataId);
        for (let t = 0; t < o.length; ++t) {
          const e = t * a;
          let n = u[e],
            r = 0;
          for (let t = 0; t < a; ++t) {
            const s = u[e + t];
            s < n && (n = s, r = t)
          }
          o[t] = r
        }
        return i
      }
      argMax(t, e) {
        to(t, "argMax");
        const n = [e];
        Ft.L.assertAxesAreInnerMostDims("argMax", n, t.rank);
        const [r, s] = Ft.L.computeOutAndReduceShapes(t.shape, n), i = Ft.Pd(r, "int32"), a = Ft.Jd.sizeFromShape(s), o = this.readSync(i.dataId), u = this.readSync(t.dataId);
        for (let t = 0; t < o.length; ++t) {
          const e = t * a;
          let n = u[e],
            r = 0;
          for (let t = 0; t < a; ++t) {
            const s = u[e + t];
            s > n && (n = s, r = t)
          }
          o[t] = r
        }
        return i
      }
      cumsum(t, e, n, r) {
        if (to(t, "cumsum"), e !== t.rank - 1) throw new Error(`backend.cumsum in CPU expects an inner-most axis=${t.rank-1} ` + `but got axis=${e}`);
        const s = Object(Ft.Id)(t.dtype, "int32"),
          i = Ft.Pd(t.shape, s),
          a = this.readSync(i.dataId),
          o = this.readSync(t.dataId),
          u = t.shape[t.rank - 1],
          c = r ? (t, e) => t + u - e - 1 : (t, e) => t + e;
        for (let t = 0; t < o.length; t += u)
          for (let e = 0; e < u; e++) {
            const r = c(t, e);
            if (0 === e) a[r] = n ? 0 : o[r];
            else {
              const s = c(t, e - 1);
              a[r] = n ? o[s] + a[s] : o[r] + a[s]
            }
          }
        return i
      }
      equal(t, e) {
        return to([t, e], "equal"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t === e ? 1 : 0)
      }
      notEqual(t, e) {
        return to([t, e], "notEqual"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t !== e ? 1 : 0)
      }
      less(t, e) {
        return to([t, e], "less"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t < e ? 1 : 0)
      }
      lessEqual(t, e) {
        return to([t, e], "lessEqual"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t <= e ? 1 : 0)
      }
      greater(t, e) {
        return to([t, e], "greater"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t > e ? 1 : 0)
      }
      greaterEqual(t, e) {
        return to([t, e], "greaterEqual"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t >= e ? 1 : 0)
      }
      logicalNot(t) {
        to(t, "logicalNot");
        const e = this.readSync(t.dataId),
          n = new Uint8Array(e.length);
        for (let t = 0; t < e.length; ++t) n[t] = e[t] ? 0 : 1;
        return this.makeOutput(n, t.shape, "bool")
      }
      logicalAnd(t, e) {
        return to([t, e], "logicalAnd"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t && e)
      }
      logicalOr(t, e) {
        return to([t, e], "logicalOr"), this.broadcastedBinaryOp(t, e, "bool", (t, e) => t || e)
      }
      select(t, e, n) {
        to([t, e, n], "select");
        const r = this.readSync(t.dataId),
          s = this.readSync(e.dataId),
          i = this.readSync(n.dataId),
          a = Ft.Pd(e.shape, Object(Ft.Id)(e.dtype, n.dtype)),
          o = this.readSync(a.dataId);
        let u = 0;
        const c = 0 === t.rank || t.rank > 1 || 1 === e.rank ? 1 : Ft.Jd.sizeFromShape(e.shape.slice(1));
        for (let t = 0; t < r.length; t++)
          for (let e = 0; e < c; e++) 1 === r[t] ? o[u++] = s[t] : o[u++] = i[t];
        return a
      }
      where(t) {
        to([t], "where");
        const e = this.readSync(t.dataId);
        return oo(t.shape, e)
      }
      topk(t, e, n) {
        to(t, "topk");
        const r = this.readSync(t.dataId);
        return ao(r, t.shape, t.dtype, e, n)
      }
      min(t, e) {
        to(t, "min"), Ft.L.assertAxesAreInnerMostDims("min", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Pd(n, t.dtype), i = Ft.Jd.sizeFromShape(r), a = this.readSync(s.dataId), o = this.readSync(t.dataId);
        for (let t = 0; t < a.length; ++t) {
          const e = t * i;
          let n = o[e];
          for (let t = 0; t < i; ++t) {
            const r = o[e + t];
            r < n && (n = r)
          }
          a[t] = n
        }
        return s
      }
      minimum(t, e) {
        return to([t, e], "minimum"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => Math.min(t, e))
      }
      mod(t, e) {
        return to([t, e], "mod"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => {
          const n = t % e;
          return t < 0 && e < 0 || t >= 0 && e >= 0 ? n : (n + e) % e
        })
      }
      maximum(t, e) {
        return to([t, e], "maximum"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => Math.max(t, e))
      }
      all(t, e) {
        to(t, "all"), Ft.L.assertAxesAreInnerMostDims("all", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Pd(n, t.dtype), i = Ft.Jd.sizeFromShape(r), a = this.readSync(s.dataId), o = this.readSync(t.dataId);
        for (let t = 0; t < a.length; ++t) {
          const e = t * i;
          let n = o[e];
          for (let t = 0; t < i; ++t) {
            const r = o[e + t];
            n = n && r
          }
          a[t] = n
        }
        return s
      }
      any(t, e) {
        to(t, "any"), Ft.L.assertAxesAreInnerMostDims("any", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Pd(n, t.dtype), i = Ft.Jd.sizeFromShape(r), a = this.readSync(s.dataId), o = this.readSync(t.dataId);
        for (let t = 0; t < a.length; ++t) {
          const e = t * i;
          let n = o[e];
          for (let t = 0; t < i; ++t) {
            const r = o[e + t];
            n = n || r
          }
          a[t] = n
        }
        return s
      }
      squaredDifference(t, e) {
        return to([t, e], "squaredDifference"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => {
          const n = t - e;
          return n * n
        })
      }
      ceil(t) {
        to(t, "ceil");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) n[t] = Math.ceil(e[t]);
        return this.makeOutput(n, t.shape, "float32")
      }
      floor(t) {
        to(t, "floor");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) n[t] = Math.floor(e[t]);
        return this.makeOutput(n, t.shape, "float32")
      }
      sign(t) {
        to(t, "x");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) e[t] < 0 ? n[t] = -1 : e[t] > 0 ? n[t] = 1 : n[t] = 0;
        return this.makeOutput(n, t.shape, "float32")
      }
      isNaN(t) {
        to(t, "x");
        const e = this.readSync(t.dataId),
          n = new Uint8Array(e.length);
        for (let t = 0; t < e.length; ++t) Number.isNaN(e[t]) && (n[t] = 1);
        return this.makeOutput(n, t.shape, "bool")
      }
      isInf(t) {
        to(t, "x");
        const e = this.readSync(t.dataId),
          n = new Uint8Array(e.length);
        for (let t = 0; t < e.length; ++t) Math.abs(e[t]) === 1 / 0 && (n[t] = 1);
        return this.makeOutput(n, t.shape, "bool")
      }
      isFinite(t) {
        to(t, "x");
        const e = this.readSync(t.dataId),
          n = new Uint8Array(e.length);
        for (let t = 0; t < e.length; ++t) Number.isFinite(e[t]) && (n[t] = 1);
        return this.makeOutput(n, t.shape, "bool")
      }
      round(t) {
        to(t, "round");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) {
          const r = Math.floor(e[t]);
          e[t] - r < .5 ? n[t] = Math.floor(e[t]) : e[t] - r > .5 ? n[t] = Math.ceil(e[t]) : n[t] = r % 2 == 0 ? r : r + 1
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      exp(t) {
        to(t, "exp");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) n[t] = Math.exp(e[t]);
        return this.makeOutput(n, t.shape, "float32")
      }
      expm1(t) {
        to(t, "expm1");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) n[t] = Math.expm1(e[t]);
        return this.makeOutput(n, t.shape, "float32")
      }
      log(t) {
        to(t, "log");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) {
          const r = e[t];
          n[t] = Math.log(r)
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      log1p(t) {
        to(t, "log1p");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) {
          const r = e[t];
          n[t] = Math.log1p(r)
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      sqrt(t) {
        to(t, "sqrt");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) {
          const r = e[t];
          n[t] = Math.sqrt(r)
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      rsqrt(t) {
        to(t, "rsqrt");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) {
          const r = e[t];
          n[t] = 1 / Math.sqrt(r)
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      reciprocal(t) {
        to(t, "reciprocal");
        const e = this.readSync(t.dataId),
          n = new Float32Array(e.length);
        for (let t = 0; t < e.length; ++t) n[t] = 1 / e[t];
        return this.makeOutput(n, t.shape, "float32")
      }
      linear(t) {
        return t
      }
      relu(t) {
        to(t, "relu");
        const e = Ft.Pd(t.shape, t.dtype),
          n = this.readSync(e.dataId),
          r = this.readSync(t.dataId);
        for (let t = 0; t < r.length; ++t) n[t] = Math.max(0, r[t]);
        return e
      }
      relu6(t) {
        to(t, "relu");
        const e = Ft.Pd(t.shape, t.dtype),
          n = this.readSync(e.dataId),
          r = this.readSync(t.dataId);
        for (let t = 0; t < r.length; ++t) n[t] = Math.min(Math.max(0, r[t]), 6);
        return e
      }
      prelu(t, e) {
        return to([t, e], "prelu"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => t < 0 ? e * t : t)
      }
      elu(t) {
        to(t, "elu");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) {
          const r = n[t];
          e[t] = r >= 0 ? r : Math.exp(r) - 1
        }
        return this.makeOutput(e, t.shape, "float32")
      }
      eluDer(t, e) {
        to([t, e], "eluDer");
        const n = new Float32Array(e.size),
          r = this.readSync(e.dataId),
          s = this.readSync(t.dataId);
        for (let t = 0; t < r.length; ++t) {
          const e = r[t];
          n[t] = e >= 1 ? s[t] : s[t] * (e + 1)
        }
        return this.makeOutput(n, e.shape, "float32")
      }
      selu(t) {
        to(t, "selu");
        const e = Ft.L.SELU_SCALEALPHA,
          n = Ft.L.SELU_SCALE,
          r = new Float32Array(t.size),
          s = this.readSync(t.dataId);
        for (let t = 0; t < s.length; ++t) {
          const i = s[t];
          r[t] = i >= 0 ? n * i : e * (Math.exp(i) - 1)
        }
        return this.makeOutput(r, t.shape, "float32")
      }
      clip(t, e, n) {
        to(t, "clip");
        const r = new Float32Array(t.size),
          s = this.readSync(t.dataId);
        for (let t = 0; t < s.length; ++t) {
          const i = s[t];
          r[t] = i > n ? n : i < e ? e : i
        }
        return this.makeOutput(r, t.shape, "float32")
      }
      abs(t) {
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.abs(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      complexAbs(t) {
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let r = 0; r < t.size; ++r) {
          const t = n[2 * r],
            s = n[2 * r + 1];
          e[r] = Math.hypot(t, s)
        }
        return this.makeOutput(e, t.shape, "float32")
      }
      int(t) {
        to(t, "int");
        const e = new Int32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = n[t];
        return this.makeOutput(e, t.shape, "int32")
      }
      sigmoid(t) {
        to(t, "sigmoid");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = 1 / (1 + Math.exp(-n[t]));
        return this.makeOutput(e, t.shape, "float32")
      }
      softplus(t) {
        to(t, "softplus");
        const e = Math.log(1.1920928955078125e-7) + 2,
          n = new Float32Array(t.size),
          r = this.readSync(t.dataId);
        for (let t = 0; t < r.length; ++t) {
          const s = r[t] > -e,
            i = r[t] < e,
            a = Math.exp(r[t]);
          let o;
          o = i ? a : s ? r[t] : Math.log(1 + a), n[t] = o
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      sin(t) {
        to(t, "sin");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.sin(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      cos(t) {
        to(t, "cos");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.cos(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      tan(t) {
        to(t, "tan");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.tan(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      asin(t) {
        to(t, "asin");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.asin(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      acos(t) {
        to(t, "acos");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.acos(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      atan(t) {
        to(t, "atan");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.atan(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      atan2(t, e) {
        return to([t, e], "atan2"), this.broadcastedBinaryOp(t, e, t.dtype, (t, e) => Math.atan2(t, e))
      }
      sinh(t) {
        to(t, "sinh");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.sinh(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      cosh(t) {
        to(t, "cosh");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.cosh(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      tanh(t) {
        to(t, "tanh");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Ft.Jd.tanh(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      asinh(t) {
        to(t, "asinh");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.asinh(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      acosh(t) {
        to(t, "acosh");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.acosh(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      atanh(t) {
        to(t, "atanh");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId);
        for (let t = 0; t < n.length; ++t) e[t] = Math.atanh(n[t]);
        return this.makeOutput(e, t.shape, "float32")
      }
      erf(t) {
        to(t, "erf");
        const e = new Float32Array(t.size),
          n = this.readSync(t.dataId),
          r = Ft.L.ERF_P,
          s = Ft.L.ERF_A1,
          i = Ft.L.ERF_A2,
          a = Ft.L.ERF_A3,
          o = Ft.L.ERF_A4,
          u = Ft.L.ERF_A5;
        for (let t = 0; t < n.length; ++t) {
          const c = Math.sign(n[t]),
            l = Math.abs(n[t]),
            h = 1 / (1 + r * l);
          e[t] = c * (1 - ((((u * h + o) * h + a) * h + i) * h + s) * h * Math.exp(-l * l))
        }
        return this.makeOutput(e, t.shape, "float32")
      }
      step(t, e = 0) {
        to(t, "step");
        const n = new Float32Array(t.size),
          r = this.readSync(t.dataId);
        for (let t = 0; t < r.length; ++t) {
          const s = r[t];
          isNaN(s) ? n[t] = NaN : n[t] = s > 0 ? 1 : e
        }
        return this.makeOutput(n, t.shape, "float32")
      }
      fusedConv2d({
        input: t,
        filter: e,
        convInfo: n,
        bias: r,
        activation: s,
        preluActivationWeights: i
      }) {
        let a = this.conv2d(t, e, n);
        return r && (a = this.add(a, r)), s && (a = uo(this, a, s, i)), a
      }
      conv2d(t, e, n) {
        to([t, e], "conv2d");
        const r = n.filterHeight,
          s = n.filterWidth,
          i = n.dilationHeight,
          a = n.dilationWidth,
          o = n.padInfo.left,
          u = n.padInfo.top,
          c = "channelsLast" === n.dataFormat,
          l = Ft.T(n.outShape, t.dtype),
          h = t.strides[0],
          d = c ? t.strides[1] : t.strides[2],
          p = c ? t.strides[2] : 1,
          f = c ? 1 : t.strides[1],
          m = l.strides[0],
          g = c ? l.strides[1] : l.strides[2],
          b = c ? l.strides[2] : 1,
          y = c ? 1 : l.strides[1],
          w = this.readSync(t.dataId),
          v = this.readSync(e.dataId),
          x = l.values;
        for (let t = 0; t < n.batchSize; ++t) {
          const c = t * h,
            l = t * m;
          for (let t = 0; t < n.outHeight; ++t) {
            const h = l + t * g,
              m = t * n.strideHeight - u;
            for (let t = 0; t < r; t++) {
              const r = m + t * i;
              if (r < 0 || r >= n.inHeight) continue;
              const u = t * e.strides[0],
                l = c + r * d;
              for (let t = 0; t < n.outWidth; ++t) {
                const r = h + t * b,
                  i = t * n.strideWidth - o;
                for (let t = 0; t < s; t++) {
                  const s = i + t * a;
                  if (s < 0 || s >= n.inWidth) continue;
                  const o = l + s * p;
                  let c = u + t * e.strides[1];
                  for (let t = 0; t < n.inChannels; ++t) {
                    const e = w[o + t * f];
                    for (let t = 0; t < n.outChannels; ++t) x[r + t * y] += e * v[c + t];
                    c += n.outChannels
                  }
                }
              }
            }
          }
        }
        return l.toTensor()
      }
      conv3d(t, e, n) {
        const r = n.filterDepth,
          s = n.filterHeight,
          i = n.filterWidth,
          a = n.dilationDepth,
          o = n.dilationHeight,
          u = n.dilationWidth,
          c = n.padInfo.front,
          l = n.padInfo.left,
          h = n.padInfo.top,
          d = Ft.T(n.outShape, t.dtype),
          p = this.readSync(t.dataId),
          f = this.readSync(e.dataId),
          m = d.values;
        for (let g = 0; g < n.batchSize; ++g) {
          const b = g * t.strides[0],
            y = g * d.strides[0];
          for (let g = 0; g < n.outDepth; ++g) {
            const w = y + g * d.strides[1],
              v = g * n.strideDepth - c;
            for (let c = 0; c < r; c++) {
              const r = v + c * a;
              if (r < 0 || r >= n.inDepth) continue;
              const g = c * e.strides[0],
                y = b + r * t.strides[1];
              for (let r = 0; r < n.outHeight; ++r) {
                const a = w + r * d.strides[2],
                  c = r * n.strideHeight - h;
                for (let r = 0; r < s; r++) {
                  const s = c + r * o;
                  if (s < 0 || s >= n.inHeight) continue;
                  const h = g + r * e.strides[1],
                    d = y + s * t.strides[2];
                  for (let t = 0; t < n.outWidth; ++t) {
                    const r = a + t * n.outChannels,
                      s = t * n.strideWidth - l;
                    for (let t = 0; t < i; t++) {
                      const i = s + t * u;
                      if (i < 0 || i >= n.inWidth) continue;
                      const a = h + t * e.strides[2],
                        o = d + i * n.inChannels;
                      let c = a;
                      for (let t = 0; t < n.inChannels; ++t) {
                        const e = p[o + t];
                        for (let t = 0; t < n.outChannels; ++t) m[r + t] += e * f[c + t];
                        c += n.outChannels
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return d.toTensor()
      }
      conv2dDerInput(t, e, n) {
        to([t, e], "conv2dDerInput");
        const r = Ft.T(n.inShape, "float32"),
          s = r.values,
          i = this.readSync(t.dataId),
          a = this.readSync(e.dataId),
          [o, u, c] = e.strides,
          {
            batchSize: l,
            filterHeight: h,
            filterWidth: d,
            inChannels: p,
            inHeight: f,
            inWidth: m,
            outChannels: g,
            outHeight: b,
            outWidth: y,
            strideHeight: w,
            strideWidth: v,
            dataFormat: x
          } = n,
          O = h - 1 - n.padInfo.top,
          S = d - 1 - n.padInfo.left,
          _ = "channelsLast" === x,
          k = r.strides[0],
          C = _ ? r.strides[1] : r.strides[2],
          E = _ ? r.strides[2] : 1,
          I = _ ? 1 : r.strides[1],
          T = t.strides[0],
          A = _ ? t.strides[1] : t.strides[2],
          N = _ ? t.strides[2] : 1,
          $ = _ ? 1 : t.strides[1];
        for (let t = 0; t < l; ++t)
          for (let e = 0; e < p; ++e)
            for (let n = 0; n < f; ++n) {
              const r = n - O,
                l = Math.max(0, Math.ceil(r / w)),
                p = Math.min(b, (h + r) / w);
              for (let f = 0; f < m; ++f) {
                const m = f - S,
                  b = Math.max(0, Math.ceil(m / v)),
                  x = Math.min(y, (d + m) / v);
                let O = 0;
                for (let n = l; n < p; ++n) {
                  const s = n * w - r;
                  for (let r = b; r < x; ++r) {
                    const l = T * t + A * n + N * r,
                      p = o * (h - 1 - s) + u * (d - 1 - (r * v - m)) + c * e;
                    for (let t = 0; t < g; ++t) {
                      O += i[l + $ * t] * a[p + t]
                    }
                  }
                }
                s[k * t + C * n + E * f + I * e] = O
              }
            }
        return r.toTensor()
      }
      conv3dDerInput(t, e, n) {
        const r = Ft.T(n.inShape, "float32"),
          s = r.values,
          [i, a, o, u] = r.strides,
          c = this.readSync(t.dataId),
          [l, h, d, p] = t.strides,
          f = this.readSync(e.dataId),
          [m, g, b, y] = e.strides,
          {
            batchSize: w,
            filterDepth: v,
            filterHeight: x,
            filterWidth: O,
            inChannels: S,
            inDepth: _,
            inHeight: k,
            inWidth: C,
            outChannels: E,
            outDepth: I,
            outHeight: T,
            outWidth: A,
            strideDepth: N,
            strideHeight: $,
            strideWidth: R
          } = n,
          j = v - 1 - n.padInfo.front,
          D = x - 1 - n.padInfo.top,
          F = O - 1 - n.padInfo.left;
        for (let t = 0; t < w; ++t)
          for (let e = 0; e < S; ++e)
            for (let n = 0; n < _; ++n) {
              const r = n - j,
                w = Math.max(0, Math.ceil(r / N)),
                S = Math.min(I, (v + r) / N);
              for (let _ = 0; _ < k; ++_) {
                const k = _ - D,
                  I = Math.max(0, Math.ceil(k / $)),
                  j = Math.min(T, (x + k) / $);
                for (let T = 0; T < C; ++T) {
                  const C = T - F,
                    D = Math.max(0, Math.ceil(C / R)),
                    M = Math.min(A, (O + C) / R);
                  let z = 0;
                  for (let n = w; n < S; ++n) {
                    const s = n * N - r;
                    for (let r = I; r < j; ++r) {
                      const i = r * $ - k;
                      for (let a = D; a < M; ++a) {
                        const o = l * t + h * n + d * r + p * a,
                          u = m * (v - 1 - s) + g * (x - 1 - i) + b * (O - 1 - (a * R - C)) + y * e;
                        for (let t = 0; t < E; ++t) {
                          z += c[o + t] * f[u + t]
                        }
                      }
                    }
                  }
                  s[i * t + a * n + o * _ + u * T + e] = z
                }
              }
            }
        return r.toTensor()
      }
      conv2dDerFilter(t, e, n) {
        to([t, e], "conv2dDerFilter");
        const r = n.strideHeight,
          s = n.strideWidth,
          i = n.filterHeight,
          a = n.filterWidth,
          o = "channelsLast" === n.dataFormat,
          u = Ft.T(n.filterShape, "float32"),
          c = n.padInfo.left,
          l = n.padInfo.top,
          h = this.bufferSync(t),
          d = this.bufferSync(e);
        for (let t = 0; t < i; ++t) {
          const e = Math.max(0, Math.ceil((l - t) / r)),
            i = Math.min(n.outHeight, (n.inHeight + l - t) / r);
          for (let p = 0; p < a; ++p) {
            const a = Math.max(0, Math.ceil((c - p) / s)),
              f = Math.min(n.outWidth, (n.inWidth + c - p) / s);
            for (let m = 0; m < n.inChannels; ++m)
              for (let g = 0; g < n.outChannels; ++g) {
                let b = 0;
                for (let u = 0; u < n.batchSize; ++u)
                  for (let n = e; n < i; ++n) {
                    const e = t + n * r - l;
                    for (let t = a; t < f; ++t) {
                      const r = p + t * s - c;
                      b += o ? h.get(u, e, r, m) * d.get(u, n, t, g) : h.get(u, m, e, r) * d.get(u, g, n, t)
                    }
                  }
                u.set(b, t, p, m, g)
              }
          }
        }
        return u.toTensor()
      }
      conv3dDerFilter(t, e, n) {
        const r = n.strideDepth,
          s = n.strideHeight,
          i = n.strideWidth,
          a = n.filterDepth,
          o = n.filterHeight,
          u = n.filterWidth,
          c = Ft.T(n.filterShape, "float32"),
          l = c.values,
          [h, d, p, f] = c.strides,
          m = this.readSync(e.dataId),
          [g, b, y, w] = e.strides,
          v = this.readSync(t.dataId),
          [x, O, S, _] = t.strides,
          k = n.padInfo.front,
          C = n.padInfo.left,
          E = n.padInfo.top;
        for (let t = 0; t < a; ++t) {
          const e = Math.max(0, Math.ceil((k - t) / r)),
            a = Math.min(n.outDepth, (n.inDepth + k - t) / r),
            c = t * h;
          for (let h = 0; h < o; ++h) {
            const o = Math.max(0, Math.ceil((E - h) / s)),
              I = Math.min(n.outHeight, (n.inHeight + E - h) / s),
              T = h * d + c;
            for (let c = 0; c < u; ++c) {
              const u = Math.max(0, Math.ceil((C - c) / i)),
                d = Math.min(n.outWidth, (n.inWidth + C - c) / i),
                A = c * p + T;
              for (let p = 0; p < n.inChannels; ++p) {
                const T = p * f + A;
                for (let f = 0; f < n.outChannels; ++f) {
                  let A = 0;
                  for (let l = 0; l < n.batchSize; ++l) {
                    const n = l * x,
                      T = l * g;
                    for (let l = e; l < a; ++l) {
                      const e = (t + l * r - k) * O + n,
                        a = l * b + T;
                      for (let t = o; t < I; ++t) {
                        const n = (h + t * s - E) * S + e,
                          r = t * y + a;
                        for (let t = u; t < d; ++t) {
                          const e = t * w + r;
                          A += v[(c + t * i - C) * _ + n + p] * m[e + f]
                        }
                      }
                    }
                  }
                  l[T + f] = A
                }
              }
            }
          }
        }
        return c.toTensor()
      }
      fusedDepthwiseConv2D({
        input: t,
        filter: e,
        convInfo: n,
        bias: r,
        activation: s,
        preluActivationWeights: i
      }) {
        let a = this.depthwiseConv2D(t, e, n);
        return r && (a = this.add(a, r)), s && (a = uo(this, a, s, i)), a
      }
      depthwiseConv2D(t, e, n) {
        to([t, e], "depthwiseConv2D");
        const r = n.filterHeight,
          s = n.filterWidth,
          i = n.dilationHeight,
          a = n.dilationWidth,
          o = n.padInfo.left,
          u = n.padInfo.top,
          c = n.outChannels / n.inChannels,
          l = Ft.T(n.outShape, t.dtype),
          h = this.readSync(t.dataId),
          d = this.readSync(e.dataId),
          p = l.values;
        for (let f = 0; f < n.batchSize; ++f) {
          const m = f * t.strides[0],
            g = f * l.strides[0];
          for (let f = 0; f < n.outHeight; ++f) {
            const b = g + f * l.strides[1],
              y = f * n.strideHeight - o;
            for (let o = 0; o < r; ++o) {
              const r = y + o * i;
              if (r < 0 || r >= n.inHeight) continue;
              const f = o * e.strides[0],
                g = m + r * t.strides[1];
              for (let t = 0; t < n.outWidth; ++t) {
                const r = b + t * l.strides[2],
                  i = t * n.strideWidth - u;
                for (let t = 0; t < s; ++t) {
                  const s = i + t * a;
                  if (s < 0 || s >= n.inWidth) continue;
                  const o = f + t * e.strides[1],
                    u = g + s * n.inChannels;
                  let l = r,
                    m = o;
                  for (let t = 0; t < n.inChannels; ++t) {
                    const e = h[u + t];
                    for (let t = 0; t < c; ++t) p[l + t] += e * d[m + t];
                    l += c, m += c
                  }
                }
              }
            }
          }
        }
        return l.toTensor()
      }
      depthwiseConv2DDerInput(t, e, n) {
        to([t, e], "depthwiseConv2DDerInput");
        const r = Ft.T(n.inShape, "float32"),
          s = r.values,
          [i, a, o] = r.strides,
          u = this.readSync(t.dataId),
          [c, l, h] = t.strides,
          d = this.readSync(e.dataId),
          [p, f, m] = e.strides,
          {
            batchSize: g,
            filterHeight: b,
            filterWidth: y,
            inChannels: w,
            inHeight: v,
            inWidth: x,
            outChannels: O,
            outHeight: S,
            outWidth: _,
            strideHeight: k,
            strideWidth: C
          } = n,
          E = b - 1 - n.padInfo.top,
          I = y - 1 - n.padInfo.left,
          T = O / w;
        for (let t = 0; t < g; ++t)
          for (let e = 0; e < w; ++e)
            for (let n = 0; n < v; ++n) {
              const r = n - E,
                g = Math.max(0, Math.ceil(r / k)),
                w = Math.min(S, (b + r) / k);
              for (let v = 0; v < x; ++v) {
                const x = v - I,
                  O = Math.max(0, Math.ceil(x / C)),
                  S = Math.min(_, (y + x) / C);
                let E = 0;
                for (let n = g; n < w; ++n) {
                  const s = n * k - r;
                  for (let r = O; r < S; ++r) {
                    const i = c * t + l * n + h * r,
                      a = p * (b - 1 - s) + f * (y - 1 - (r * C - x)) + m * e;
                    for (let t = 0; t < T; ++t) {
                      E += u[i + (e * T + t)] * d[a + t]
                    }
                  }
                }
                s[i * t + a * n + o * v + e] = E
              }
            }
        return r.toTensor()
      }
      depthwiseConv2DDerFilter(t, e, n) {
        to([t, e], "depthwiseConv2DDerFilter");
        const r = n.strideHeight,
          s = n.strideWidth,
          i = n.filterHeight,
          a = n.filterWidth,
          o = Ft.T(n.filterShape, "float32"),
          u = n.padInfo.left,
          c = n.padInfo.top,
          l = n.outChannels / n.inChannels,
          h = this.bufferSync(t),
          d = this.bufferSync(e);
        for (let t = 0; t < i; ++t) {
          const e = Math.max(0, Math.ceil((c - t) / r)),
            i = Math.min(n.outHeight, (n.inHeight + c - t) / r);
          for (let p = 0; p < a; ++p) {
            const a = Math.max(0, Math.ceil((u - p) / s)),
              f = Math.min(n.outWidth, (n.inWidth + u - p) / s);
            for (let m = 0; m < n.outChannels; ++m) {
              const g = Math.trunc(m / l),
                b = m % l;
              let y = 0;
              for (let o = 0; o < n.batchSize; ++o)
                for (let n = e; n < i; ++n) {
                  const e = t + n * r - c;
                  for (let t = a; t < f; ++t) {
                    const r = p + t * s - u;
                    y += h.get(o, e, r, g) * d.get(o, n, t, m)
                  }
                }
              o.set(y, t, p, g, b)
            }
          }
        }
        return o.toTensor()
      }
      tile(t, e) {
        return to(t, "tile"), io(this.bufferSync(t), e)
      }
      pad(t, e, n) {
        to(t, "pad");
        const r = e.map((e, n) => e[0] + t.shape[n] + e[1]),
          s = e.map(t => t[0]),
          i = this.bufferSync(t),
          a = Ft.T(r, t.dtype);
        0 !== n && a.values.fill(n);
        for (let e = 0; e < t.size; e++) {
          const t = i.indexToLoc(e),
            n = t.map((t, e) => t + s[e]);
          a.set(i.get(...t), ...n)
        }
        return a.toTensor()
      }
      gather(t, e, n) {
        to([t, e], "gather");
        const r = t.shape.slice(),
          s = this.readSync(e.dataId);
        r[n] = s.length;
        const i = Ft.T(r, t.dtype),
          a = this.bufferSync(t);
        for (let t = 0; t < i.size; ++t) {
          const e = i.indexToLoc(t),
            r = e.slice();
          r[n] = s[e[n]];
          const o = a.locToIndex(r);
          i.values[t] = a.values[o]
        }
        return i.toTensor()
      }
      batchToSpaceND(t, e, n) {
        to([t], "batchToSpaceND");
        const r = e.reduce((t, e) => t * e),
          s = Ft.L.getReshaped(t.shape, e, r),
          i = Ft.L.getPermuted(s.length, e.length),
          a = Ft.L.getReshapedPermuted(t.shape, e, r),
          o = Ft.L.getSliceBeginCoords(n, e.length),
          u = Ft.L.getSliceSize(a, n, e.length);
        return Ft.Fd(t.reshape(s), i).reshape(a).slice(o, u)
      }
      spaceToBatchND(t, e, n) {
        to([t], "spaceToBatchND");
        const r = e.reduce((t, e) => t * e),
          s = [
            [0, 0]
          ];
        s.push(...n);
        for (let n = 1 + e.length; n < t.shape.length; ++n) s.push([0, 0]);
        const i = t.pad(s),
          a = Ft.L.getReshaped(i.shape, e, r, !1),
          o = Ft.L.getPermuted(a.length, e.length, !1),
          u = Ft.L.getReshapedPermuted(i.shape, e, r, !1),
          c = Ft.Fd(i.reshape(a), o);
        return Object(Ft.Kc)(c, u)
      }
      maxPool(t, e) {
        return to(t, "maxPool"), eo(this.readSync(t.dataId), t.shape, t.dtype, t.strides, e, "max").toTensor()
      }
      maxPoolBackprop(t, e, n, r) {
        to([e, n], "maxPoolBackprop");
        const s = this.readSync(e.dataId),
          i = Object(Ft.T)(r.outShape, e.dtype, no(s, e.shape, e.dtype, r).values),
          a = r.strideHeight,
          o = r.strideWidth,
          u = r.dilationHeight,
          c = r.dilationWidth,
          l = r.effectiveFilterHeight,
          h = r.effectiveFilterWidth,
          d = h - 1 - r.padInfo.left,
          p = l - 1 - r.padInfo.top,
          f = Ft.T(e.shape, "float32"),
          m = this.bufferSync(t);
        for (let t = 0; t < r.batchSize; ++t)
          for (let e = 0; e < r.inChannels; ++e)
            for (let n = 0; n < r.inHeight; ++n)
              for (let s = 0; s < r.inWidth; ++s) {
                const g = n - p,
                  b = s - d;
                let y = 0;
                for (let n = 0; n < l; n += u) {
                  const s = (g + n) / a;
                  if (!(s < 0 || s >= r.outHeight || Math.floor(s) !== s))
                    for (let a = 0; a < h; a += c) {
                      const u = (b + a) / o;
                      if (u < 0 || u >= r.outWidth || Math.floor(u) !== u) continue;
                      const c = l * h - 1 - i.get(t, s, u, e) === n * h + a ? 1 : 0;
                      0 !== c && (y += m.get(t, s, u, e) * c)
                    }
                }
                f.set(y, t, n, s, e)
              }
        return f.toTensor()
      }
      avgPoolBackprop(t, e, n) {
        to([t, e], "avgPoolBackprop");
        const r = n.strideHeight,
          s = n.strideWidth,
          i = n.filterHeight,
          a = n.filterWidth,
          o = n.dilationHeight,
          u = n.dilationWidth,
          c = n.effectiveFilterHeight,
          l = n.effectiveFilterWidth,
          h = l - 1 - n.padInfo.left,
          d = c - 1 - n.padInfo.top,
          p = Ft.T(e.shape, "float32"),
          f = 1 / (i * a),
          m = this.bufferSync(t);
        for (let t = 0; t < n.batchSize; ++t)
          for (let e = 0; e < n.inChannels; ++e)
            for (let i = 0; i < n.inHeight; ++i)
              for (let a = 0; a < n.inWidth; ++a) {
                const g = i - d,
                  b = a - h;
                let y = 0;
                for (let i = 0; i < c; i += o) {
                  const a = (g + i) / r;
                  if (!(a < 0 || a >= n.outHeight || Math.floor(a) !== a))
                    for (let r = 0; r < l; r += u) {
                      const i = (b + r) / s;
                      i < 0 || i >= n.outWidth || Math.floor(i) !== i || (y += m.get(t, a, i, e))
                    }
                }
                p.set(y * f, t, i, a, e)
              }
        return p.toTensor()
      }
      pool3d(t, e, n) {
        to(t, "pool3d");
        const r = e.strideDepth,
          s = e.strideHeight,
          i = e.strideWidth,
          a = e.dilationDepth,
          o = e.dilationHeight,
          u = e.dilationWidth,
          c = e.effectiveFilterDepth,
          l = e.effectiveFilterHeight,
          h = e.effectiveFilterWidth,
          d = e.padInfo.front,
          p = e.padInfo.top,
          f = e.padInfo.left,
          m = "max" === n ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY,
          g = this.readSync(t.dataId),
          b = Ft.T(e.outShape, t.dtype),
          y = b.values,
          w = e.outShape[1] * e.outShape[2] * e.outShape[3] * e.outShape[4],
          v = e.outShape[2] * e.outShape[3] * e.outShape[4],
          x = e.outShape[3] * e.outShape[4],
          O = e.outShape[4];
        for (let b = 0; b < e.batchSize; ++b) {
          const S = b * w,
            _ = b * t.strides[0];
          for (let b = 0; b < e.inChannels; ++b)
            for (let w = 0; w < e.outDepth; ++w) {
              const k = w * r - d;
              let C = k;
              for (; C < 0;) C += a;
              const E = Math.min(e.inDepth, c + k),
                I = S + w * v;
              for (let r = 0; r < e.outHeight; ++r) {
                const c = r * s - p;
                let d = c;
                for (; d < 0;) d += o;
                const w = Math.min(e.inHeight, l + c),
                  v = I + r * x;
                for (let r = 0; r < e.outWidth; ++r) {
                  const s = r * i - f;
                  let c = s;
                  for (; c < 0;) c += u;
                  const l = Math.min(e.inWidth, h + s),
                    p = v + r * O;
                  let x = m,
                    S = 0,
                    k = 0;
                  for (let e = C; e < E; e += a) {
                    const r = _ + e * t.strides[1];
                    for (let e = d; e < w; e += o) {
                      const s = r + e * t.strides[2];
                      for (let e = c; e < l; e += u) {
                        const r = g[s + e * t.strides[3] + b];
                        if ("max" === n && r > x ? x = r : "avg" === n && (S += r, k++), isNaN(x)) break
                      }
                      if (isNaN(x)) break
                    }
                    if (isNaN(x)) break
                  }
                  y[p + b] = "avg" === n ? S / k : x
                }
              }
            }
        }
        return b.toTensor()
      }
      avgPool3d(t, e) {
        return to(t, "avgPool3d"), this.pool3d(t, e, "avg").toFloat()
      }
      avgPool3dBackprop(t, e, n) {
        to([t, e], "avgPool3dBackprop");
        const r = n.strideDepth,
          s = n.strideHeight,
          i = n.strideWidth,
          a = n.filterDepth,
          o = n.filterHeight,
          u = n.filterWidth,
          c = n.dilationDepth,
          l = n.dilationHeight,
          h = n.dilationWidth,
          d = n.effectiveFilterDepth,
          p = n.effectiveFilterHeight,
          f = n.effectiveFilterWidth,
          m = d - 1 - n.padInfo.front,
          g = f - 1 - n.padInfo.left,
          b = p - 1 - n.padInfo.top,
          y = Ft.T(e.shape, "float32"),
          w = 1 / (a * o * u),
          v = this.bufferSync(t);
        for (let t = 0; t < n.batchSize; ++t)
          for (let e = 0; e < n.inChannels; ++e)
            for (let a = 0; a < n.inDepth; ++a)
              for (let o = 0; o < n.inHeight; ++o)
                for (let u = 0; u < n.inWidth; ++u) {
                  const x = a - m,
                    O = o - b,
                    S = u - g;
                  let _ = 0;
                  for (let a = 0; a < d; a += c) {
                    const o = (x + a) / r;
                    if (!(o < 0 || o >= n.outDepth || Math.floor(o) !== o))
                      for (let r = 0; r < p; r += l) {
                        const a = (O + r) / s;
                        if (!(a < 0 || a >= n.outHeight || Math.floor(a) !== a))
                          for (let r = 0; r < f; r += h) {
                            const s = (S + r) / i;
                            s < 0 || s >= n.outWidth || Math.floor(s) !== s || (_ += v.get(t, o, a, s, e))
                          }
                      }
                  }
                  y.set(_ * w, t, a, o, u, e)
                }
        return y.toTensor()
      }
      maxPool3d(t, e) {
        return to(t, "maxPool3d"), this.pool3d(t, e, "max").toFloat()
      }
      maxPool3dPositions(t, e) {
        const n = Ft.T(e.outShape, "int32"),
          r = e.strideDepth,
          s = e.strideHeight,
          i = e.strideWidth,
          a = e.dilationDepth,
          o = e.dilationHeight,
          u = e.dilationWidth,
          c = e.effectiveFilterDepth,
          l = e.effectiveFilterHeight,
          h = e.effectiveFilterWidth,
          d = e.padInfo.front,
          p = e.padInfo.top,
          f = e.padInfo.left,
          m = this.bufferSync(t);
        for (let t = 0; t < e.batchSize; ++t)
          for (let g = 0; g < e.inChannels; ++g)
            for (let b = 0; b < e.outDepth; ++b) {
              const y = b * r - d;
              let w = y;
              for (; w < 0;) w += a;
              const v = Math.min(e.inDepth, c + y);
              for (let r = 0; r < e.outHeight; ++r) {
                const c = r * s - p;
                let d = c;
                for (; d < 0;) d += o;
                const x = Math.min(e.inHeight, l + c);
                for (let s = 0; s < e.outWidth; ++s) {
                  const p = s * i - f;
                  let O = p;
                  for (; O < 0;) O += u;
                  const S = Math.min(e.inWidth, h + p);
                  let _ = Number.NEGATIVE_INFINITY,
                    k = -1;
                  for (let e = w; e < v; e += a) {
                    const n = e - y;
                    for (let r = d; r < x; r += o) {
                      const s = r - c;
                      for (let i = O; i < S; i += u) {
                        const a = i - p,
                          o = m.get(t, e, r, i, g);
                        o >= _ && (_ = o, k = n * l * h + s * l + a)
                      }
                    }
                  }
                  n.set(k, t, b, r, s, g)
                }
              }
            }
        return n.toTensor()
      }
      maxPool3dBackprop(t, e, n, r) {
        to([e, n], "maxPool3dBackprop");
        const s = this.maxPool3dPositions(e, r),
          i = r.strideDepth,
          a = r.strideHeight,
          o = r.strideWidth,
          u = r.dilationDepth,
          c = r.dilationHeight,
          l = r.dilationWidth,
          h = r.effectiveFilterDepth,
          d = r.effectiveFilterHeight,
          p = r.effectiveFilterWidth,
          f = h - 1 - r.padInfo.front,
          m = p - 1 - r.padInfo.left,
          g = d - 1 - r.padInfo.top,
          b = Ft.T(e.shape, "float32"),
          y = this.bufferSync(s),
          w = this.bufferSync(t);
        for (let t = 0; t < r.batchSize; ++t)
          for (let e = 0; e < r.inChannels; ++e)
            for (let n = 0; n < r.inDepth; ++n)
              for (let s = 0; s < r.inHeight; ++s)
                for (let v = 0; v < r.inWidth; ++v) {
                  const x = n - f,
                    O = s - g,
                    S = v - m;
                  let _ = 0;
                  for (let n = 0; n < h; n += u) {
                    const s = (x + n) / i;
                    if (!(s < 0 || s >= r.outDepth || Math.floor(s) !== s))
                      for (let i = 0; i < d; i += c) {
                        const u = (O + i) / a;
                        if (!(u < 0 || u >= r.outHeight || Math.floor(u) !== u))
                          for (let a = 0; a < p; a += l) {
                            const c = (S + a) / o;
                            if (c < 0 || c >= r.outWidth || Math.floor(c) !== c) continue;
                            const l = h * d * p - 1 - y.get(t, s, u, c, e) === n * d * p + i * p + a ? 1 : 0;
                            0 !== l && (_ += w.get(t, s, u, c, e) * l)
                          }
                      }
                  }
                  b.set(_, t, n, s, v, e)
                }
        return b.toTensor()
      }
      cast(t, e) {
        return Ft.L.castTensor(t, e, this)
      }
      reshape(t, e) {
        return Ft.L.reshapeTensor(t, e)
      }
      avgPool(t, e) {
        return to(t, "avgPool"), to(t, "maxPool"), eo(this.readSync(t.dataId), t.shape, t.dtype, t.strides, e, "avg").toTensor().toFloat()
      }
      resizeBilinear(t, e, n, r) {
        to(t, "resizeBilinear");
        const [s, i, a, o] = t.shape, u = this.readSync(t.dataId), c = new Float32Array(Ft.Jd.sizeFromShape([s, e, n, o])), l = [r && e > 1 ? i - 1 : i, r && n > 1 ? a - 1 : a], h = [r && e > 1 ? e - 1 : e, r && n > 1 ? n - 1 : n];
        let d = 0;
        const p = l[0] / h[0],
          f = l[1] / h[1];
        for (let r = 0; r < s; r++)
          for (let s = 0; s < e; s++) {
            const e = p * s,
              l = Math.floor(e),
              h = e - l,
              m = Math.min(i - 1, Math.ceil(e)),
              g = r * t.strides[0] + l * t.strides[1],
              b = r * t.strides[0] + m * t.strides[1];
            for (let e = 0; e < n; e++) {
              const n = f * e,
                r = Math.floor(n),
                s = n - r,
                i = Math.min(a - 1, Math.ceil(n)),
                l = g + r * t.strides[2],
                p = b + r * t.strides[2],
                m = g + i * t.strides[2],
                y = b + i * t.strides[2];
              for (let t = 0; t < o; t++) {
                const e = u[l + t],
                  n = u[p + t],
                  r = e + (u[m + t] - e) * s,
                  i = r + (n + (u[y + t] - n) * s - r) * h;
                c[d++] = i
              }
            }
          }
        return Ft.wd(c, [s, e, n, o])
      }
      resizeBilinearBackprop(t, e, n) {
        to([t, e], "resizeBilinearBackprop");
        const [r, s, i, a] = e.shape, [, o, u] = t.shape, c = new Float32Array(r * s * i * a), l = [n && o > 1 ? s - 1 : s, n && u > 1 ? i - 1 : i], h = [n && o > 1 ? o - 1 : o, n && u > 1 ? u - 1 : u], d = l[0] / h[0], p = l[1] / h[1], f = this.readSync(t.dataId);
        let m = 0;
        for (let t = 0; t < r; t++) {
          const n = t * e.strides[0];
          for (let t = 0; t < o; t++) {
            const r = t * d,
              o = Math.floor(r),
              l = Math.min(Math.ceil(r), s - 1),
              h = n + o * e.strides[1],
              g = n + l * e.strides[1],
              b = r - o,
              y = 1 - b;
            for (let t = 0; t < u; t++) {
              const n = t * p,
                r = Math.floor(n),
                s = Math.min(Math.ceil(n), i - 1),
                o = n - r,
                u = 1 - o,
                l = h + r * e.strides[2],
                d = h + s * e.strides[2],
                w = g + r * e.strides[2],
                v = g + s * e.strides[2],
                x = y * u,
                O = y * o,
                S = b * u,
                _ = b * o;
              for (let t = 0; t < a; t++) {
                const e = f[m++];
                c[l + t] += e * x, c[d + t] += e * O, c[w + t] += e * S, c[v + t] += e * _
              }
            }
          }
        }
        return Ft.zd(c, [r, i, s, a], e.dtype)
      }
      resizeNearestNeighbor(t, e, n, r) {
        to(t, "resizeNearestNeighbor");
        const [s, i, a, o] = t.shape, u = this.readSync(t.dataId), c = new Float32Array(s * e * n * o), l = [r && e > 1 ? i - 1 : i, r && n > 1 ? a - 1 : a], h = [r && e > 1 ? e - 1 : e, r && n > 1 ? n - 1 : n], d = l[0] / h[0], p = l[1] / h[1];
        let f = 0;
        for (let l = 0; l < s; l++) {
          const s = l * t.strides[0];
          for (let l = 0; l < e; l++) {
            const e = d * l,
              h = s + Math.min(i - 1, r ? Math.round(e) : Math.floor(e)) * t.strides[1];
            for (let e = 0; e < n; e++) {
              const n = p * e,
                s = h + Math.min(a - 1, r ? Math.round(n) : Math.floor(n)) * t.strides[2];
              for (let t = 0; t < o; t++) {
                const e = u[s + t];
                c[f++] = e
              }
            }
          }
        }
        return Ft.wd(c, [s, e, n, o], t.dtype)
      }
      resizeNearestNeighborBackprop(t, e, n) {
        to([t, e], "resizeNearestNeighborBackprop");
        const [r, s, i, a] = e.shape, [, o, u] = t.shape, c = new Float32Array(r * s * i * a), l = this.readSync(t.dataId), h = [n && o > 1 ? s - 1 : s, n && u > 1 ? i - 1 : i], d = [n && o > 1 ? o - 1 : o, n && u > 1 ? u - 1 : u], p = h[0] / d[0], f = h[1] / d[1], m = 1 / p, g = 1 / f, b = 2 * Math.ceil(m) + 2, y = 2 * Math.ceil(g) + 2;
        for (let h = 0; h < r; h++) {
          const r = h * e.strides[0];
          for (let h = 0; h < s; h++) {
            const d = r + h * e.strides[1],
              w = Math.floor(h * m),
              v = Math.floor(w - b / 2);
            for (let m = 0; m < i; m++) {
              const w = d + m * e.strides[2],
                x = Math.floor(m * g),
                O = Math.floor(x - y / 2);
              for (let e = 0; e < a; e++) {
                let a = 0;
                for (let c = 0; c < b; c++) {
                  const d = c + v;
                  if (d < 0 || d >= o) continue;
                  const g = r + d * t.strides[1],
                    b = d * p;
                  if (h === Math.min(s - 1, n ? Math.round(b) : Math.floor(b)))
                    for (let r = 0; r < y; r++) {
                      const s = r + O;
                      if (s < 0 || s >= u) continue;
                      const o = g + s * t.strides[2],
                        c = s * f;
                      m === Math.min(i - 1, n ? Math.round(c) : Math.floor(c)) && (a += l[o + e])
                    }
                }
                c[w + e] = a
              }
            }
          }
        }
        return Ft.zd(c, e.shape, e.dtype)
      }
      batchNorm(t, e, n, r, s, i) {
        to([t, e, n, s, r], "batchNorm");
        const a = this.readSync(t.dataId),
          o = this.readSync(e.dataId),
          u = this.readSync(n.dataId),
          c = s ? this.readSync(s.dataId) : new Float32Array([1]),
          l = r ? this.readSync(r.dataId) : new Float32Array([0]),
          h = new Float32Array(a.length),
          d = l.length,
          p = c.length,
          f = u.length,
          m = o.length;
        let g = 0,
          b = 0,
          y = 0,
          w = 0;
        for (let t = 0; t < a.length; ++t) h[t] = l[g++] + (a[t] - o[b++]) * c[y++] / Math.sqrt(u[w++] + i), g >= d && (g = 0), b >= m && (b = 0), y >= p && (y = 0), w >= f && (w = 0);
        return Ft.zd(h, t.shape)
      }
      localResponseNormalization4D(t, e, n, r, s) {
        to(t, "localResponseNormalization4D");
        const i = t.shape[3],
          a = i - 1,
          o = this.readSync(t.dataId),
          u = t.size,
          c = new Float32Array(u);

        function l(t) {
          const n = t % i;
          let r = t - n + Math.max(0, n - e);
          const s = t - n + Math.min(n + e, a);
          let u = 0;
          for (; r <= s; r++) {
            const t = o[r];
            u += t * t
          }
          return u
        }
        for (let t = 0; t < u; t++) {
          const e = l(t),
            i = o[t] * Math.pow(n + r * e, -s);
          c[t] = i
        }
        return Ft.zd(c, t.shape)
      }
      LRNGrad(t, e, n, r, s, i, a) {
        to(t, "LRNGrad");
        const o = t.shape[3],
          u = this.readSync(t.dataId),
          c = this.readSync(e.dataId),
          l = this.readSync(n.dataId),
          h = new Float32Array(t.size),
          d = t.size;
        for (let t = 0; t < d; t++) {
          const e = t % o,
            n = t - e + Math.max(0, e - r),
            d = t - e + Math.min(o, e + r + 1);
          let p = 0;
          for (let t = n; t < d; t++) p += Math.pow(c[t], 2);
          p = i * p + s;
          for (let e = n; e < d; e++) {
            let n = -2 * i * a * c[e] * l[t] / p;
            t === e && (n += Math.pow(p, -a)), n *= u[t], h[e] += n
          }
        }
        return Ft.zd(h, t.shape)
      }
      multinomial(t, e, n, r) {
        to(t, "multinomial");
        const s = e ? t : Ft.gd(t),
          i = s.shape[0],
          a = s.shape[1],
          o = Ft.Pd([i, n], "int32"),
          u = this.readSync(o.dataId),
          c = this.readSync(s.dataId);
        for (let t = 0; t < i; ++t) {
          const e = t * a,
            s = new Float32Array(a - 1);
          s[0] = c[e];
          for (let t = 1; t < s.length; ++t) s[t] = s[t - 1] + c[e + t];
          const i = qa.alea(r.toString()),
            o = t * n;
          for (let t = 0; t < n; ++t) {
            const e = i();
            u[o + t] = s.length;
            for (let n = 0; n < s.length; n++)
              if (e < s[n]) {
                u[o + t] = n;
                break
              }
          }
        }
        return o
      }
      oneHot(t, e, n, r) {
        to(t, "oneHot");
        const s = new Float32Array(t.size * e);
        s.fill(r);
        const i = this.readSync(t.dataId);
        for (let r = 0; r < t.size; ++r) i[r] >= 0 && i[r] < e && (s[r * e + i[r]] = n);
        return Ft.yd(s, [t.size, e], "int32")
      }
      nonMaxSuppression(t, e, n, r, s) {
        to(t, "nonMaxSuppression");
        const i = this.readSync(t.dataId),
          a = this.readSync(e.dataId);
        return ro(i, a, n, r, s)
      }
      fft(t) {
        return this.fftBatch(t, !1)
      }
      ifft(t) {
        return this.fftBatch(t, !0)
      }
      fftBatch(t, e) {
        const n = t.shape[0],
          r = t.shape[1],
          s = Ft.T(t.shape, "float32"),
          i = Ft.T(t.shape, "float32"),
          a = Ft.Fc(t).as2D(n, r),
          o = Ft.Mb(t).as2D(n, r);
        for (let t = 0; t < n; t++) {
          const n = a.slice([t, 0], [1, r]),
            u = o.slice([t, 0], [1, r]),
            c = Ft.Y(n, u),
            l = this.readSync(this.fftImpl(c, e).dataId);
          for (let e = 0; e < r; e++) {
            const n = Ft.L.getComplexWithIndex(l, e);
            s.values[t * r + e] = n.real, i.values[t * r + e] = n.imag
          }
        }
        return Ft.Y(s.toTensor(), i.toTensor()).as2D(n, r)
      }
      fftImpl(t, e) {
        const n = t.as1D(),
          r = n.size;
        if (this.isExponentOf2(r)) {
          let s = this.fftRadix2(n, r, e).as2D(t.shape[0], t.shape[1]);
          return e && (s = Ft.Y(Ft.Fc(s).div(Ft.Pc(r)), Ft.Mb(s).div(Ft.Pc(r)))), s
        } {
          const n = this.readSync(t.dataId),
            s = this.fourierTransformByMatmul(n, r, e),
            i = Ft.L.splitRealAndImagArrays(s);
          return Ft.Y(i.real, i.imag).as2D(t.shape[0], t.shape[1])
        }
      }
      isExponentOf2(t) {
        return 0 == (t & t - 1)
      }
      fftRadix2(t, e, n) {
        if (1 === e) return t;
        const r = this.readSync(t.dataId),
          s = e / 2,
          i = Ft.L.complexWithEvenIndex(r);
        let a = Ft.Y(i.real, i.imag).as1D();
        const o = Ft.L.complexWithOddIndex(r);
        let u = Ft.Y(o.real, o.imag).as1D();
        a = this.fftRadix2(a, s, n), u = this.fftRadix2(u, s, n);
        const c = Ft.L.exponents(e, n),
          l = Ft.Y(c.real, c.imag).mul(u),
          h = a.add(l),
          d = a.sub(l),
          p = Ft.Fc(h).concat(Ft.Fc(d)),
          f = Ft.Mb(h).concat(Ft.Mb(d));
        return Ft.Y(p, f).as1D()
      }
      fourierTransformByMatmul(t, e, n) {
        const r = new Float32Array(2 * e);
        for (let s = 0; s < e; s++) {
          let i = 0,
            a = 0;
          for (let r = 0; r < e; r++) {
            const o = Ft.L.exponent(s * r, e, n),
              u = Ft.L.getComplexWithIndex(t, r);
            i += u.real * o.real - u.imag * o.imag, a += u.real * o.imag + u.imag * o.real
          }
          n && (i /= e, a /= e), Ft.L.assignToTypedArray(r, i, a, s)
        }
        return r
      }
      depthToSpace(t, e, n) {
        Ft.Jd.assert("NHWC" === n, () => `Only NHWC dataFormat supported on CPU for depthToSpace. Got ${n}`), Ft.Jd.assert(e > 1, () => `blockSize should be > 1 for depthToSpace, but was: ${e}`);
        const r = t.shape[0],
          s = t.shape[1],
          i = t.shape[2],
          a = t.shape[3],
          o = s * e,
          u = i * e,
          c = a / (e * e),
          l = this.readSync(t.dataId),
          h = new Float32Array(r * o * u * c);
        let d = 0;
        for (let t = 0; t < r; ++t)
          for (let n = 0; n < o; ++n) {
            const r = Math.floor(n / e),
              o = n % e;
            for (let n = 0; n < u; ++n) {
              const u = Math.floor(n / e),
                p = (o * e + n % e) * c;
              for (let e = 0; e < c; ++e) {
                const n = e + p + a * (u + i * (r + s * t));
                h[d++] = l[n]
              }
            }
          }
        return Ft.zd(h, [r, o, u, c])
      }
      broadcastedBinaryOp(t, e, n, r) {
        const s = Ft.L.assertAndGetBroadcastShape(t.shape, e.shape),
          i = Ft.T(s, n),
          a = this.readSync(t.dataId),
          o = this.readSync(e.dataId),
          u = Ft.L.getBroadcastDims(t.shape, s),
          c = Ft.L.getBroadcastDims(e.shape, s),
          l = i.values;
        if (u.length + c.length === 0)
          for (let t = 0; t < l.length; ++t) l[t] = r(a[t % a.length], o[t % o.length]);
        else {
          const n = this.bufferSync(t),
            s = this.bufferSync(e);
          for (let h = 0; h < l.length; ++h) {
            const d = i.indexToLoc(h),
              p = d.slice(-t.rank);
            u.forEach(t => p[t] = 0);
            const f = n.locToIndex(p),
              m = d.slice(-e.rank);
            c.forEach(t => m[t] = 0);
            const g = s.locToIndex(m);
            l[h] = r(a[f], o[g])
          }
        }
        return i.toTensor()
      }
      broadcastedBinaryComplexOp(t, e, n) {
        const r = Ft.L.assertAndGetBroadcastShape(t.shape, e.shape),
          s = Ft.T(r, "float32"),
          i = Ft.T(r, "float32"),
          a = this.readSync(t.dataId),
          o = this.readSync(e.dataId),
          u = Ft.L.getBroadcastDims(t.shape, r),
          c = Ft.L.getBroadcastDims(e.shape, r),
          l = s.values,
          h = i.values;
        if (u.length + c.length === 0)
          for (let t = 0; t < l.length; t++) {
            const e = t % a.length,
              r = t % o.length,
              s = n(a[2 * e], a[2 * e + 1], o[2 * r], o[2 * r + 1]);
            l[t] = s.real, h[t] = s.imag
          } else {
            const r = this.bufferSync(this.data.get(t.dataId).complexTensors.real),
              i = this.bufferSync(this.data.get(e.dataId).complexTensors.real);
            for (let d = 0; d < l.length; d++) {
              const p = s.indexToLoc(d),
                f = p.slice(-t.rank);
              u.forEach(t => f[t] = 0);
              const m = r.locToIndex(f),
                g = p.slice(-e.rank);
              c.forEach(t => g[t] = 0);
              const b = i.locToIndex(g),
                y = n(a[2 * m], a[2 * m + 1], o[2 * b], o[2 * b + 1]);
              l[d] = y.real, h[d] = y.imag
            }
          }
        return this.complex(s.toTensor(), i.toTensor())
      }
      split(t, e, n) {
        return so(t, e, n)
      }
      dispose() {}
      floatPrecision() {
        return 32
      }
      epsilon() {
        return super.epsilon()
      }
      cropAndResize(t, e, n, r, s, i) {
        const [a, o, u, c] = t.shape, l = e.shape[0], [h, d] = r, p = Ft.T([l, h, d, c], "float32"), f = this.readSync(e.dataId), m = this.readSync(n.dataId), g = this.readSync(t.dataId), b = t.strides, y = p.strides;
        for (let t = 0; t < l; t++) {
          const e = 4 * t,
            n = f[e],
            r = f[e + 1],
            l = f[e + 2],
            w = f[e + 3],
            v = m[t];
          if (v >= a) continue;
          const x = h > 1 ? (l - n) * (o - 1) / (h - 1) : 0,
            O = d > 1 ? (w - r) * (u - 1) / (d - 1) : 0;
          for (let e = 0; e < h; e++) {
            const a = h > 1 ? n * (o - 1) + e * x : .5 * (n + l) * (o - 1);
            if (a < 0 || a > o - 1)
              for (let n = 0; n < d; n++)
                for (let r = 0; r < c; r++) {
                  const s = r + n * y[2] + e * y[1] + t * y[0];
                  p.values[s] = i
                } else if ("bilinear" === s) {
                  const n = Math.floor(a),
                    s = Math.ceil(a),
                    o = a - n;
                  for (let a = 0; a < d; a++) {
                    const l = d > 1 ? r * (u - 1) + a * O : .5 * (r + w) * (u - 1);
                    if (l < 0 || l > u - 1) {
                      for (let n = 0; n < c; n++) {
                        const r = n + a * y[2] + e * y[1] + t * y[0];
                        p.values[r] = i
                      }
                      continue
                    }
                    const h = Math.floor(l),
                      f = Math.ceil(l),
                      m = l - h;
                    for (let r = 0; r < c; r++) {
                      let i = r + h * b[2] + n * b[1] + v * b[0];
                      const u = g[i];
                      i = r + f * b[2] + n * b[1] + v * b[0];
                      const c = g[i];
                      i = r + h * b[2] + s * b[1] + v * b[0];
                      const l = g[i];
                      i = r + f * b[2] + s * b[1] + v * b[0];
                      const d = u + (c - u) * m,
                        w = l + (g[i] - l) * m;
                      i = r + a * y[2] + e * y[1] + t * y[0], p.values[i] = d + (w - d) * o
                    }
                  }
                } else
                  for (let n = 0; n < d; ++n) {
                    const s = d > 1 ? r * (u - 1) + n * O : .5 * (r + w) * (u - 1);
                    if (s < 0 || s > u - 1) {
                      for (let r = 0; r < c; r++) {
                        const s = r + n * y[2] + e * y[1] + t * y[0];
                        p.values[s] = i
                      }
                      continue
                    }
                    const o = Math.round(s),
                      l = Math.round(a);
                    for (let r = 0; r < c; r++) {
                      const s = r + o * b[2] + l * b[1] + v * b[0],
                        i = r + n * y[2] + e * y[1] + t * y[0];
                      p.values[i] = g[s]
                    }
                  }
          }
        }
        return p.toTensor()
      }
      sparseToDense(t, e, n, r) {
        const {
          sliceRank: s,
          numUpdates: i,
          sliceSize: a,
          strides: o,
          outputSize: u
        } = Ft.L.calculateShapes(e, t, n);
        return this.scatter(t, e, n, u, a, i, s, o, r, !1)
      }
      gatherND(t, e) {
        const n = e.shape,
          r = n[n.length - 1],
          [s, i, a, o] = Ft.L.prepareAndValidate(t, e);
        if (0 === i) return Ft.wd([], s, t.dtype);
        const u = new Ft.s([i, a], t.dtype),
          c = this.readSync(e.dataId),
          l = this.readSync(t.dataId);
        for (let e = 0; e < i; e++) {
          const n = [];
          let s = 0;
          for (let t = 0; t < r; t++) {
            const i = c[e * r + t];
            s += i * o[t], n.push(i)
          }
          if (s < 0 || s >= t.size / a) throw new Error(`Invalid indices: ${n} does not index into ${t.shape}`);
          for (let t = 0; t < a; t++) u.values[e * a + t] = l[s * a + t]
        }
        return u.toTensor().reshape(s)
      }
      scatterND(t, e, n) {
        const {
          sliceRank: r,
          numUpdates: s,
          sliceSize: i,
          strides: a,
          outputSize: o
        } = Ft.L.calculateShapes(e, t, n), u = Ft.Pc(0);
        return this.scatter(t, e, n, o, i, s, r, a, u, !0)
      }
      fill(t, e, n) {
        n = n || Ft.Jd.inferDtype(e);
        const r = Ft.Jd.getArrayFromDType(n, Ft.Jd.sizeFromShape(t));
        return r.fill(e), Object(Ft.ub)().makeTensor(r, t, n, this)
      }
      onesLike(t) {
        if ("string" === t.dtype) throw new Error("onesLike is not supported for string tensors");
        return this.fill(t.shape, 1, t.dtype)
      }
      zerosLike(t) {
        const e = Ft.Jd.getArrayFromDType(t.dtype, Ft.Jd.sizeFromShape(t.shape));
        return this.makeOutput(e, t.shape, t.dtype)
      }
      linspace(t, e, n) {
        return Ft.L.linspaceImpl(t, e, n)
      }
      scatter(t, e, n, r, s, i, a, o, u, c) {
        const l = [r / s, s],
          h = this.readSync(t.dataId),
          d = this.readSync(e.dataId);
        if (0 === r) return Ft.wd([], n, e.dtype);
        const p = new Ft.s(l, e.dtype);
        p.values.fill(this.readSync(u.dataId)[0]);
        for (let t = 0; t < i; t++) {
          const i = [];
          let u = 0;
          for (let e = 0; e < a; e++) {
            const n = h[t * a + e];
            i.push(n), u += n * o[e]
          }
          if (u < 0 || u >= r / s) throw new Error(`Invalid indices: ${i} does not index into ${n}`);
          for (let n = 0; n < s; n++) c ? p.values[u * s + n] += d[t * s + n] : p.values[u * s + n] = 0 === e.rank ? d[0] : d[t * s + n]
        }
        return p.toTensor().reshape(n)
      }
    }
    /** @license See the LICENSE file. */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    Object(Ft.Hc)("cpu", () => new co, 1);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const lo = {
        kernelName: Ft.b,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          const {
            x: r,
            filter: s
          } = t, {
            strides: i,
            pad: a,
            dilations: o
          } = n, u = e, c = Ft.Jd.toNestedArray(r.shape, u.data.get(r.dataId).values), l = Ft.Jd.toNestedArray(s.shape, u.data.get(s.dataId).values), {
            batchSize: h,
            inHeight: d,
            inWidth: p,
            inChannels: f,
            outHeight: m,
            outWidth: g,
            padInfo: b,
            strideHeight: y,
            strideWidth: w,
            filterHeight: v,
            filterWidth: x,
            dilationHeight: O,
            dilationWidth: S,
            outShape: _
          } = Ft.L.computeDilation2DInfo(r.shape, s.shape, i, a, "NHWC", o), k = Ft.Jd.makeZerosNestedTypedArray(_, r.dtype);
          for (let t = 0; t < h; ++t)
            for (let e = 0; e < m; ++e) {
              const n = e * y - b.top;
              for (let r = 0; r < g; ++r) {
                const s = r * w - b.left;
                for (let i = 0; i < f; ++i) {
                  let a = Number.MIN_SAFE_INTEGER;
                  for (let e = 0; e < v; ++e) {
                    const r = n + e * O;
                    if (r >= 0 && r < d)
                      for (let n = 0; n < x; ++n) {
                        const o = s + n * S;
                        if (o >= 0 && o < p) {
                          const s = c[t][r][o][i] + l[e][n][i];
                          s > a && (a = s)
                        }
                      }
                  }
                  k[t][e][r][i] = a
                }
              }
            }
          return {
            dataId: u.write(Ft.Jd.toTypedArray(k, r.dtype), _, r.dtype),
            shape: _,
            dtype: r.dtype
          }
        }
      },
      ho = {
        kernelName: Ft.c,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          const {
            x: r,
            filter: s,
            dy: i
          } = t, {
            strides: a,
            pad: o,
            dilations: u
          } = n, c = e, l = Ft.Jd.toNestedArray(r.shape, c.data.get(r.dataId).values), h = Ft.Jd.toNestedArray(s.shape, c.data.get(s.dataId).values), {
            batchSize: d,
            inHeight: p,
            inWidth: f,
            inChannels: m,
            outHeight: g,
            outWidth: b,
            padInfo: y,
            strideHeight: w,
            strideWidth: v,
            filterHeight: x,
            filterWidth: O,
            dilationHeight: S,
            dilationWidth: _,
            outShape: k
          } = Ft.L.computeDilation2DInfo(r.shape, s.shape, a, o, "NHWC", u);
          Ft.Jd.assert(i.rank === k.length, () => `Error in ${Ft.c}, dy ` + `must have the same rank as output ${k.length}, but got ` + `${i.rank}`);
          const C = Ft.Jd.toNestedArray(k, c.data.get(i.dataId).values),
            E = Ft.Jd.makeZerosNestedTypedArray(s.shape, s.dtype);
          for (let t = 0; t < d; ++t)
            for (let e = 0; e < g; ++e) {
              const n = e * w - y.top;
              for (let r = 0; r < b; ++r) {
                const s = r * v - y.left;
                for (let i = 0; i < m; ++i) {
                  let a = Number.MIN_SAFE_INTEGER,
                    o = 0,
                    u = 0;
                  for (let e = 0; e < x; ++e) {
                    const r = n + e * S;
                    if (r >= 0 && r < p)
                      for (let n = 0; n < O; ++n) {
                        const c = s + n * _;
                        if (c >= 0 && c < f) {
                          const s = l[t][r][c][i] + h[e][n][i];
                          s > a && (a = s, o = e, u = n)
                        }
                      }
                  }
                  E[o][u][i] += C[t][e][r][i]
                }
              }
            }
          return {
            dataId: c.write(Ft.Jd.toTypedArray(E, r.dtype), s.shape, s.dtype),
            shape: s.shape,
            dtype: s.dtype
          }
        }
      },
      po = {
        kernelName: Ft.d,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          const {
            x: r,
            filter: s,
            dy: i
          } = t, {
            strides: a,
            pad: o,
            dilations: u
          } = n, c = e, l = Ft.Jd.toNestedArray(r.shape, c.data.get(r.dataId).values), h = Ft.Jd.toNestedArray(s.shape, c.data.get(s.dataId).values), {
            batchSize: d,
            inHeight: p,
            inWidth: f,
            inChannels: m,
            outHeight: g,
            outWidth: b,
            padInfo: y,
            strideHeight: w,
            strideWidth: v,
            filterHeight: x,
            filterWidth: O,
            dilationHeight: S,
            dilationWidth: _,
            outShape: k
          } = Ft.L.computeDilation2DInfo(r.shape, s.shape, a, o, "NHWC", u);
          Ft.Jd.assert(i.rank === k.length, () => `Error in ${Ft.d}, dy ` + `must have the same rank as output ${k.length}, but got ` + `${i.rank}`);
          const C = Ft.Jd.toNestedArray(k, c.data.get(i.dataId).values),
            E = Ft.Jd.makeZerosNestedTypedArray(r.shape, r.dtype);
          for (let t = 0; t < d; ++t)
            for (let e = 0; e < g; ++e) {
              const n = e * w - y.top;
              for (let r = 0; r < b; ++r) {
                const s = r * v - y.left;
                for (let i = 0; i < m; ++i) {
                  let a = Number.MIN_SAFE_INTEGER,
                    o = n < 0 ? 0 : n,
                    u = s < 0 ? 0 : s;
                  for (let e = 0; e < x; ++e) {
                    const r = n + e * S;
                    if (r >= 0 && r < p)
                      for (let n = 0; n < O; ++n) {
                        const c = s + n * _;
                        if (c >= 0 && c < f) {
                          const s = l[t][r][c][i] + h[e][n][i];
                          s > a && (a = s, o = r, u = c)
                        }
                      }
                  }
                  E[t][o][u][i] += C[t][e][r][i]
                }
              }
            }
          return {
            dataId: c.write(Ft.Jd.toTypedArray(E, r.dtype), r.shape, r.dtype),
            shape: r.shape,
            dtype: r.dtype
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function fo(t, e) {
      return {
        kernelName: t,
        backendName: "cpu",
        kernelFunc: ({
          inputs: n,
          backend: r
        }) => {
          const {
            a: s,
            b: i
          } = n, a = r;
          to([s, i], t);
          const o = a.data.get(s.dataId).values,
            u = a.data.get(i.dataId).values,
            [c, l] = e(s.shape, i.shape, o, u, s.dtype);
          return {
            dataId: a.write(c, l, s.dtype),
            shape: l,
            dtype: s.dtype
          }
        }
      }
    }

    function mo(t) {
      return (e, n, r, s, i) => {
        const a = Ft.L.assertAndGetBroadcastShape(e, n),
          o = a.length,
          u = Ft.Jd.computeStrides(a),
          c = Ft.Jd.sizeFromShape(a),
          l = Ft.Jd.getTypedArrayFromDType(i, c),
          h = e.length,
          d = n.length,
          p = Ft.Jd.computeStrides(e),
          f = Ft.Jd.computeStrides(n),
          m = Ft.L.getBroadcastDims(e, a),
          g = Ft.L.getBroadcastDims(n, a);
        if (m.length + g.length === 0)
          for (let e = 0; e < l.length; ++e) l[e] = t(r[e % r.length], s[e % s.length]);
        else
          for (let e = 0; e < l.length; ++e) {
            const n = Ft.Jd.indexToLoc(e, o, u),
              i = n.slice(-h);
            m.forEach(t => i[t] = 0);
            const a = Ft.Jd.locToIndex(i, h, p),
              c = n.slice(-d);
            g.forEach(t => c[t] = 0);
            const b = Ft.Jd.locToIndex(c, d, f);
            l[e] = t(r[a], s[b])
          }
        return [l, a]
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const go = mo((t, e) => t / e),
      bo = fo(Ft.e, go),
      yo = {
        kernelName: Ft.f,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          attrs: e,
          backend: n
        }) => {
          const {
            image: r
          } = t, s = n, i = Ft.Jd.getTypedArrayFromDType(r.dtype, Ft.Jd.sizeFromShape(r.shape)), [a, o, u, c] = r.shape, l = s.data.get(r.dataId).values;
          for (let t = 0; t < a; t++) {
            const e = t * u * o * c;
            for (let t = 0; t < o; t++) {
              const n = t * (u * c);
              for (let r = 0; r < u; r++) {
                const s = r * c;
                for (let o = 0; o < c; o++) {
                  const h = [a, t, r, o][2],
                    d = Math.round(u - h),
                    p = e + n + s + o;
                  let f = l[p];
                  if (d >= 0 && d < u) {
                    f = l[e + n + d * c + o]
                  }
                  i[p] = f
                }
              }
            }
          }
          return {
            dataId: s.write(i, r.shape, r.dtype),
            shape: r.shape,
            dtype: r.dtype
          }
        }
      };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function wo(t, e, n, r) {
      const s = Ft.Jd.getTypedArrayFromDType(r, Ft.Jd.sizeFromShape(n));
      for (let n = 0; n < s.length; ++n) {
        const r = n * e;
        let i = t[r];
        for (let n = 0; n < e; ++n) {
          const e = t[r + n];
          e > i && (i = e)
        }
        s[n] = i
      }
      return s
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function vo(t, e, n, r, s) {
      const i = e.length,
        a = Ft.Jd.sizeFromShape(e),
        o = Ft.Jd.computeStrides(e),
        u = Ft.Jd.computeStrides(s),
        c = Ft.Jd.getTypedArrayFromDType(n, Ft.Jd.sizeFromShape(s));
      for (let e = 0; e < a; ++e) {
        const n = Ft.Jd.indexToLoc(e, i, o),
          s = new Array(n.length);
        for (let t = 0; t < s.length; t++) s[t] = n[r[t]];
        c[Ft.Jd.locToIndex(s, i, u)] = t[e]
      }
      return c
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const xo = {
      kernelName: Ft.i,
      backendName: "cpu",
      kernelFunc: ({
        inputs: t,
        attrs: e,
        backend: n
      }) => {
        const {
          x: r
        } = t, {
          reductionIndices: s,
          keepDims: i
        } = e, a = n;
        let o = r.shape;
        const u = o.length,
          c = Ft.Jd.parseAxisParam(s, o);
        let l = c;
        const h = Ft.L.getAxesPermutation(l, u);
        let d = a.data.get(r.dataId).values;
        if (null != h) {
          const t = new Array(u);
          for (let e = 0; e < t.length; e++) t[e] = o[h[e]];
          d = vo(d, o, r.dtype, h, t), l = Ft.L.getInnerMostAxes(l.length, u), o = t
        }
        to(r, "max"), Ft.L.assertAxesAreInnerMostDims("max", l, u);
        const [p, f] = Ft.L.computeOutAndReduceShapes(o, l), m = wo(d, Ft.Jd.sizeFromShape(f), p, r.dtype), g = a.write(m, p, r.dtype);
        let b = p;
        if (i) {
          b = Ft.L.expandShapeToKeepDim(p, c)
        }
        return {
          dataId: g,
          shape: b,
          dtype: r.dtype
        }
      }
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Oo = {
        kernelName: Ft.j,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          attrs: e,
          backend: n
        }) => {
          const {
            x: r
          } = t, {
            filterSize: s,
            strides: i,
            pad: a,
            includeBatchInIndex: o
          } = e, u = n;
          to(r, "MaxPoolWithArgmax");
          const c = u.data.get(r.dataId).values,
            l = Ft.L.computePool2DInfo(r.shape, s, i, [1, 1], a),
            [h, d] = function (t, e, n, r, s) {
              const i = eo(t, 0, n, Ft.Jd.computeStrides(e), s, "max"),
                a = no(t, e, n, s, !0, r);
              return [i.values, a.values]
            }(c, r.shape, r.dtype, o, l),
            p = u.write(h, l.outShape, r.dtype),
            f = u.write(d, l.outShape, r.dtype);
          return [{
            dataId: p,
            shape: l.outShape,
            dtype: r.dtype
          }, {
            dataId: f,
            shape: l.outShape,
            dtype: "int32"
          }]
        }
      },
      So = Ft.Rb.nonMaxSuppressionV4Impl,
      _o = {
        kernelName: Ft.l,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          const {
            boxes: r,
            scores: s
          } = t, {
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o,
            padToMaxOutputSize: u
          } = n, c = e;
          to(r, "NonMaxSuppressionPadded");
          const l = c.data.get(r.dataId).values,
            h = c.data.get(s.dataId).values,
            {
              selectedIndices: d,
              validOutputs: p
            } = So(l, h, i, a, o, u);
          return [d, p]
        }
      },
      ko = Ft.Rb.nonMaxSuppressionV5Impl,
      Co = {
        kernelName: Ft.m,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          const {
            boxes: r,
            scores: s
          } = t, {
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o,
            softNmsSigma: u
          } = n, c = e;
          to(r, "NonMaxSuppressionWithScore");
          const l = c.data.get(r.dataId).values,
            h = c.data.get(s.dataId).values,
            d = i,
            p = a,
            f = o,
            m = u,
            {
              selectedIndices: g,
              selectedScores: b
            } = ko(l, h, d, p, f, m);
          return [g, b]
        }
      },
      Eo = {
        kernelName: Ft.o,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          attrs: e,
          backend: n
        }) => {
          const {
            image: r
          } = t, {
            radians: s,
            fillValue: i,
            center: a
          } = e, o = n, u = Ft.Jd.getTypedArrayFromDType(r.dtype, Ft.Jd.sizeFromShape(r.shape)), [c, l, h, d] = r.shape, [p, f] = Ft.L.getImageCenter(a, l, h), m = Math.sin(s), g = Math.cos(s), b = o.data.get(r.dataId).values;
          for (let t = 0; t < c; t++) {
            const e = t * h * l * d;
            for (let t = 0; t < l; t++) {
              const n = t * (h * d);
              for (let r = 0; r < h; r++) {
                const s = r * d;
                for (let a = 0; a < d; a++) {
                  const o = [c, t, r, a],
                    y = o[2],
                    w = o[1];
                  let v = (y - p) * g - (w - f) * m,
                    x = (y - p) * m + (w - f) * g;
                  v = Math.round(v + p), x = Math.round(x + f);
                  let O = i;
                  if ("number" != typeof i && (O = 3 === a ? 255 : i[a]), v >= 0 && v < h && x >= 0 && x < l) {
                    O = b[e + x * (h * d) + v * d + a]
                  }
                  u[e + n + s + a] = O
                }
              }
            }
          }
          return {
            dataId: o.write(u, r.shape, r.dtype),
            shape: r.shape,
            dtype: r.dtype
          }
        }
      },
      Io = {
        kernelName: Ft.p,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          backend: e
        }) => {
          const {
            x: n
          } = t, r = e;
          to(n, "square");
          const s = r.data.get(n.dataId).values,
            i = new Float32Array(s.length);
          for (let t = 0; t < s.length; ++t) {
            const e = s[t];
            i[t] = e * e
          }
          return {
            dataId: r.write(i, n.shape, n.dtype),
            shape: n.shape,
            dtype: n.dtype
          }
        }
      },
      To = mo((t, e) => {
        const n = t - e;
        return n * n
      }),
      Ao = [lo, po, ho, bo, yo, Oo, xo, _o, Co, Eo, Io, fo(Ft.q, To), {
        kernelName: Ft.t,
        backendName: "cpu",
        kernelFunc: ({
          inputs: t,
          attrs: e,
          backend: n
        }) => {
          const {
            x: r
          } = t, {
            perm: s
          } = e, i = n;
          to(r, "transpose");
          const a = r.shape.length,
            o = new Array(a);
          for (let t = 0; t < o.length; t++) o[t] = r.shape[s[t]];
          const u = vo(i.data.get(r.dataId).values, r.shape, r.dtype, s, o);
          return {
            dataId: i.write(u, o, r.dtype),
            shape: o,
            dtype: r.dtype
          }
        }
      }];
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    for (const t of Ao) Object(Ft.Ic)(t);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const No = {},
      $o = {
        alpha: !1,
        antialias: !1,
        premultipliedAlpha: !1,
        preserveDrawingBuffer: !1,
        depth: !1,
        stencil: !1,
        failIfMajorPerformanceCaveat: !0
      };

    function Ro(t) {
      t in No || (No[t] = function (t) {
          if (1 !== t && 2 !== t) throw new Error("Cannot get WebGL rendering context, WebGL is disabled.");
          const e = function (t) {
            if ("undefined" != typeof OffscreenCanvas && 2 === t) return new OffscreenCanvas(300, 150);
            if ("undefined" != typeof document) return document.createElement("canvas");
            throw new Error("Cannot create a canvas in this context")
          }(t);
          if (e.addEventListener("webglcontextlost", e => {
              e.preventDefault(), delete No[t]
            }, !1), 1 === t) return e.getContext("webgl", $o) || e.getContext("experimental-webgl", $o);
          return e.getContext("webgl2", $o)
        }
        /**
         * @license
         * Copyright 2017 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        (t));
      const e = No[t];
      return e.isContextLost() ? (delete No[t], Ro(t)) : (e.disable(e.DEPTH_TEST), e.disable(e.STENCIL_TEST), e.disable(e.BLEND), e.disable(e.DITHER), e.disable(e.POLYGON_OFFSET_FILL), e.disable(e.SAMPLE_COVERAGE), e.enable(e.SCISSOR_TEST), e.enable(e.CULL_FACE), e.cullFace(e.BACK), No[t])
    }
    var jo, Do, Fo;

    function Mo(t, e) {
      return [e, t]
    }

    function zo(t) {
      const e = Ft.Jd.sizeFromShape(t),
        n = Math.ceil(e / 4);
      return Ft.Jd.sizeToSquarishShape(n)
    }

    function Lo(t, e) {
      return [Math.max(1, Math.ceil(e / 2)), Math.max(1, Math.ceil(t / 2))]
    }

    function Bo(t, e) {
      const n = t;
      let r, s, i, a, o, u, c, l, h, d;
      return 2 === Object(Ft.vb)().getNumber("WEBGL_VERSION") ? (r = n.R32F, s = n.R16F, i = n.RGBA16F, a = n.RGBA32F, o = n.RED, c = 4, l = 1, h = n.HALF_FLOAT, d = n.FLOAT) : (r = t.RGBA, s = t.RGBA, i = t.RGBA, a = n.RGBA, o = t.RGBA, c = 4, l = 4, h = null != e ? e.HALF_FLOAT_OES : null, d = t.FLOAT), u = t.RGBA, {
        internalFormatFloat: r,
        internalFormatHalfFloat: s,
        internalFormatPackedHalfFloat: i,
        internalFormatPackedFloat: a,
        textureFormatFloat: o,
        downloadTextureFormat: u,
        downloadUnpackNumChannels: c,
        defaultNumChannels: l,
        textureTypeHalfFloat: h,
        textureTypeFloat: d
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Po(t, e) {
      const n = e();
      return Object(Ft.vb)().getBool("DEBUG") && function (t) {
        const e = t.getError();
        if (e !== t.NO_ERROR) throw new Error("WebGL Error: " + function (t, e) {
          switch (e) {
            case t.NO_ERROR:
              return "NO_ERROR";
            case t.INVALID_ENUM:
              return "INVALID_ENUM";
            case t.INVALID_VALUE:
              return "INVALID_VALUE";
            case t.INVALID_OPERATION:
              return "INVALID_OPERATION";
            case t.INVALID_FRAMEBUFFER_OPERATION:
              return "INVALID_FRAMEBUFFER_OPERATION";
            case t.OUT_OF_MEMORY:
              return "OUT_OF_MEMORY";
            case t.CONTEXT_LOST_WEBGL:
              return "CONTEXT_LOST_WEBGL";
            default:
              return `Unknown error code ${e}`
          }
        }(t, e))
      }(t), n
    }! function (t) {
      t[t.DENSE = 0] = "DENSE", t[t.SHARED_BATCH = 1] = "SHARED_BATCH"
    }(jo || (jo = {})),
    function (t) {
      t[t.RENDER = 0] = "RENDER", t[t.UPLOAD = 1] = "UPLOAD", t[t.PIXELS = 2] = "PIXELS", t[t.DOWNLOAD = 3] = "DOWNLOAD"
    }(Do || (Do = {})),
    function (t) {
      t[t.UNPACKED_FLOAT16 = 0] = "UNPACKED_FLOAT16", t[t.UNPACKED_FLOAT32 = 1] = "UNPACKED_FLOAT32", t[t.PACKED_4X1_UNSIGNED_BYTE = 2] = "PACKED_4X1_UNSIGNED_BYTE", t[t.PACKED_2X2_FLOAT32 = 3] = "PACKED_2X2_FLOAT32", t[t.PACKED_2X2_FLOAT16 = 4] = "PACKED_2X2_FLOAT16"
    }(Fo || (Fo = {}));
    const Wo = 5.96e-8,
      Uo = 65504;

    function Vo(t) {
      return !!(Object(Ft.vb)().getBool("WEBGL_RENDER_FLOAT32_ENABLED") || 0 === t || Wo < Math.abs(t) && Math.abs(t) < Uo)
    }

    function Ho(t, e) {
      return tu(t, () => t.getExtension(e), 'Extension "' + e + '" not supported on this browser.')
    }

    function Go(t, e) {
      const n = tu(t, () => t.createShader(t.FRAGMENT_SHADER), "Unable to create fragment WebGLShader.");
      if (Po(t, () => t.shaderSource(n, e)), Po(t, () => t.compileShader(n)), !1 === t.getShaderParameter(n, t.COMPILE_STATUS)) throw function (t, e) {
        const n = qo.exec(e);
        if (null == n) return console.log(`Couldn't parse line number in error: ${e}`), void console.log(t);
        const r = +n[1],
          s = t.split("\n"),
          i = s.length.toString().length + 2,
          a = s.map((t, e) => Ft.Jd.rightPad((e + 1).toString(), i) + t);
        let o = 0;
        for (let t = 0; t < a.length; t++) o = Math.max(a[t].length, o);
        const u = a.slice(0, r - 1),
          c = a.slice(r - 1, r),
          l = a.slice(r);
        console.log(u.join("\n")), console.log(e.split("\n")[0]), console.log(`%c ${Ft.Jd.rightPad(c[0],o)}`, "border:1px solid red; background-color:#e3d2d2; color:#a61717"), console.log(l.join("\n"))
      }(e, t.getShaderInfoLog(n)), new Error("Failed to compile fragment shader.");
      return n
    }
    const qo = /ERROR: [0-9]+:([0-9]+):/g;

    function Ko(t, e) {
      if (Po(t, () => t.validateProgram(e)), !1 === t.getProgramParameter(e, t.VALIDATE_STATUS)) throw console.log(t.getProgramInfoLog(e)), new Error("Shader program validation failed.")
    }

    function Jo(t, e, n, r, s, i, a) {
      const o = t.getAttribLocation(e, n);
      return -1 !== o && (Po(t, () => t.bindBuffer(t.ARRAY_BUFFER, r)), Po(t, () => t.vertexAttribPointer(o, s, t.FLOAT, !1, i, a)), Po(t, () => t.enableVertexAttribArray(o)), !0)
    }

    function Xo(t, e, n, r) {
      Po(t, () => (function (t, e, n) {
        eu(t, n), Po(t, () => t.activeTexture(t.TEXTURE0 + n)), Po(t, () => t.bindTexture(t.TEXTURE_2D, e))
      })(t, e, r)), Po(t, () => t.uniform1i(n, r))
    }

    function Yo(t, e, n) {
      Po(t, () => t.bindFramebuffer(t.FRAMEBUFFER, n)), Po(t, () => t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, e, 0))
    }

    function Zo(t, e) {
      Po(t, () => t.bindFramebuffer(t.FRAMEBUFFER, e)), Po(t, () => t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, null, 0))
    }

    function Qo(t) {
      const e = t.checkFramebufferStatus(t.FRAMEBUFFER);
      if (e !== t.FRAMEBUFFER_COMPLETE) throw new Error("Error binding framebuffer: " + function (t, e) {
        switch (e) {
          case t.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
            return "FRAMEBUFFER_INCOMPLETE_ATTACHMENT";
          case t.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
            return "FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT";
          case t.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
            return "FRAMEBUFFER_INCOMPLETE_DIMENSIONS";
          case t.FRAMEBUFFER_UNSUPPORTED:
            return "FRAMEBUFFER_UNSUPPORTED";
          default:
            return `unknown error ${e}`
        }
      }(t, e))
    }

    function tu(t, e, n) {
      const r = Po(t, () => e());
      if (null == r) throw new Error(n);
      return r
    }

    function eu(t, e) {
      const n = t.MAX_COMBINED_TEXTURE_IMAGE_UNITS - 1,
        r = e + t.TEXTURE0;
      if (r < t.TEXTURE0 || r > n) {
        throw new Error(`textureUnit must be in ${`[gl.TEXTURE0, gl.TEXTURE${n}]`}.`)
      }
    }

    function nu(t, e = 2) {
      return Ft.Jd.sizeFromShape(t.slice(0, t.length - e))
    }

    function ru(t) {
      if (0 === t.length) throw Error("Cannot get rows and columns of an empty shape array.");
      return [t.length > 1 ? t[t.length - 2] : 1, t[t.length - 1]]
    }

    function su(t) {
      let e = [1, 1, 1];
      return 0 === t.length || 1 === t.length && 1 === t[0] || (e = [nu(t), ...ru(t)]), e
    }

    function iu(t) {
      return t % 2 == 0
    }

    function au(t, e) {
      if (t = t.slice(-2), e = e.slice(-2), Ft.Jd.arraysEqual(t, e)) return !0;
      if (!t.length || !e.length) return !0;
      if (0 === t[0] || 0 === t[1] || 0 === e[0] || 0 === e[1]) return !0;
      if (t.length !== e.length) {
        const n = t.slice(-1)[0],
          r = e.slice(-1)[0];
        if (n === r) return !0;
        if (iu(n) && iu(r) && (1 === t[0] || 1 === e[0])) return !0
      }
      return t[1] === e[1] && iu(t[0]) && iu(e[0])
    }
    let ou, uu;

    function cu(t, e) {
      return null != t.getExtension(e)
    }

    function lu(t) {
      try {
        if (null != Ro(t)) return !0
      } catch (t) {
        return !1
      }
      return !1
    }

    function hu(t) {
      if (0 === t) return !1;
      const e = Ro(t);
      if (1 !== t) {
        if (cu(e, "EXT_color_buffer_float")) return du(e);
        const t = "EXT_color_buffer_half_float";
        if (cu(e, t)) {
          const n = e.getExtension(t);
          return function (t, e) {
            const n = Bo(t, e),
              r = t.createTexture();
            t.bindTexture(t.TEXTURE_2D, r);
            t.texImage2D(t.TEXTURE_2D, 0, n.internalFormatHalfFloat, 1, 1, 0, n.textureFormatFloat, n.textureTypeHalfFloat, null);
            const s = t.createFramebuffer();
            t.bindFramebuffer(t.FRAMEBUFFER, s), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, r, 0);
            const i = t.checkFramebufferStatus(t.FRAMEBUFFER) === t.FRAMEBUFFER_COMPLETE;
            return t.bindTexture(t.TEXTURE_2D, null), t.bindFramebuffer(t.FRAMEBUFFER, null), t.deleteTexture(r), t.deleteFramebuffer(s), i
          }(e, n)
        }
        return !1
      }
      return !!cu(e, "OES_texture_float") && (!!cu(e, "WEBGL_color_buffer_float") && du(e))
    }

    function du(t) {
      const e = Bo(t),
        n = t.createTexture();
      t.bindTexture(t.TEXTURE_2D, n);
      t.texImage2D(t.TEXTURE_2D, 0, e.internalFormatFloat, 1, 1, 0, e.textureFormatFloat, e.textureTypeFloat, null);
      const r = t.createFramebuffer();
      t.bindFramebuffer(t.FRAMEBUFFER, r), t.framebufferTexture2D(t.FRAMEBUFFER, t.COLOR_ATTACHMENT0, t.TEXTURE_2D, n, 0);
      const s = t.checkFramebufferStatus(t.FRAMEBUFFER) === t.FRAMEBUFFER_COMPLETE;
      return t.bindTexture(t.TEXTURE_2D, null), t.bindFramebuffer(t.FRAMEBUFFER, null), t.deleteTexture(n), t.deleteFramebuffer(r), s
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const pu = Object(Ft.vb)();
    pu.registerFlag("HAS_WEBGL", () => pu.getNumber("WEBGL_VERSION") > 0), pu.registerFlag("WEBGL_VERSION", () => lu(2) ? 2 : lu(1) ? 1 : 0), pu.registerFlag("WEBGL_CHECK_NUMERICAL_PROBLEMS", () => !1), pu.registerFlag("WEBGL_BUFFER_SUPPORTED", () => 2 === pu.get("WEBGL_VERSION")), pu.registerFlag("WEBGL_CPU_FORWARD", () => !0), pu.registerFlag("WEBGL_FORCE_F16_TEXTURES", () => !1), pu.registerFlag("WEBGL_PACK", () => pu.getBool("HAS_WEBGL")), pu.registerFlag("WEBGL_PACK_NORMALIZATION", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_PACK_CLIP", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_PACK_DEPTHWISECONV", () => !1), pu.registerFlag("WEBGL_PACK_BINARY_OPERATIONS", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_PACK_UNARY_OPERATIONS", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_PACK_ARRAY_OPERATIONS", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_PACK_IMAGE_OPERATIONS", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_PACK_REDUCE", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_LAZILY_UNPACK", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_CONV_IM2COL", () => pu.getBool("WEBGL_PACK")), pu.registerFlag("WEBGL_MAX_TEXTURE_SIZE", () => (function (t) {
      if (null == ou) {
        const e = Ro(t);
        ou = e.getParameter(e.MAX_TEXTURE_SIZE)
      }
      return ou
    })(pu.getNumber("WEBGL_VERSION"))), pu.registerFlag("WEBGL_MAX_TEXTURES_IN_SHADER", () => (function (t) {
      if (null == uu) {
        const e = Ro(t);
        uu = e.getParameter(e.MAX_TEXTURE_IMAGE_UNITS)
      }
      return Math.min(16, uu)
    })(pu.getNumber("WEBGL_VERSION"))), pu.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION", () => {
      const t = pu.getNumber("WEBGL_VERSION");
      return 0 === t ? 0 : function (t) {
        if (0 === t) return 0;
        let e;
        const n = Ro(t);
        return e = cu(n, "EXT_disjoint_timer_query_webgl2") && 2 === t ? 2 : cu(n, "EXT_disjoint_timer_query") ? 1 : 0, e
      }(t)
    }), pu.registerFlag("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE", () => pu.getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 && !Ft.nb.isMobile()), pu.registerFlag("WEBGL_RENDER_FLOAT32_CAPABLE", () => (function (t) {
      if (0 === t) return !1;
      const e = Ro(t);
      if (1 === t) {
        if (!cu(e, "OES_texture_float")) return !1
      } else if (!cu(e, "EXT_color_buffer_float")) return !1;
      return du(e)
    })(pu.getNumber("WEBGL_VERSION"))), pu.registerFlag("WEBGL_RENDER_FLOAT32_ENABLED", () => !pu.getBool("WEBGL_FORCE_F16_TEXTURES") && pu.getBool("WEBGL_RENDER_FLOAT32_CAPABLE")), pu.registerFlag("WEBGL_DOWNLOAD_FLOAT_ENABLED", () => hu(pu.getNumber("WEBGL_VERSION"))), pu.registerFlag("WEBGL_FENCE_API_ENABLED", () => (function (t) {
      return 2 === t && null != Ro(t).fenceSync
    })(pu.getNumber("WEBGL_VERSION"))), pu.registerFlag("WEBGL_SIZE_UPLOAD_UNIFORM", () => {
      return pu.getBool("WEBGL_RENDER_FLOAT32_ENABLED") ? 4 : 0
    }), pu.registerFlag("WEBGL_DELETE_TEXTURE_THRESHOLD", () => -1, t => {
      if (t < 0 && -1 !== t) throw new Error("WEBGL_DELETE_TEXTURE_THRESHOLD must be -1 (indicating never " + `delete) or at least 0, but got ${t}.`)
    });
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class fu {
      constructor(t, e) {
        this.outputShape = [], this.outputShape = t, this.variableNames = e.map((t, e) => `T${e}`);
        const n = [];
        this.variableNames.forEach(t => {
          n.push(`float v${t} = get${t}AtOutCoords();`)
        });
        const r = this.variableNames.map(t => `v${t}`).join(" + ");
        this.userCode = `\n      void main() {\n        ${n.join("\n        ")}\n\n        float result = ${r};\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class mu {
      constructor(t, e) {
        this.outputShape = [], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.variableNames = e.map((t, e) => `T${e}`);
        const n = [];
        this.variableNames.forEach(t => {
          n.push(`vec4 v${t} = get${t}AtOutCoords();`)
        });
        const r = this.variableNames.map(t => `v${t}`).join(" + ");
        this.userCode = `\n      void main() {\n        ${n.join("\n        ")}\n\n        vec4 result = ${r};\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class gu {
      constructor(t, e, n) {
        this.variableNames = ["A"];
        const r = t.windowSize,
          s = t.batchSize,
          i = t.inSize,
          a = Math.ceil(i / r);
        n || this.variableNames.push("bestIndicesA"), this.outputShape = [s, a];
        const o = "max" === e ? ">" : "<",
          u = n ? "inOffset + i;" : "round(getBestIndicesA(batch, inOffset + i));";
        this.userCode = `\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * ${r};\n\n        int bestIndex = inOffset;\n        float bestValue = getA(batch, bestIndex);\n\n        for (int i = 0; i < ${r}; i++) {\n          int inIdx = ${u};\n          float candidate = getA(batch, inIdx);\n          if (candidate ${o} bestValue) {\n            bestValue = candidate;\n            bestIndex = inIdx;\n          }\n        }\n        setOutput(float(bestIndex));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function bu(t, e) {
      return ["x", "y", "z", "w", "u", "v"].slice(0, e).map(e => `${t}.${e}`)
    }

    function yu(t, e) {
      return 1 === e ? [t] : bu(t, e)
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function wu() {
      let t, e, n, r, s, i, a, o, u, c;
      return 2 === Object(Ft.vb)().getNumber("WEBGL_VERSION") ? (t = "#version 300 es", e = "in", n = "out", r = "in", s = "texture", i = "outputColor", a = "out vec4 outputColor;", o = "\n      bool isnan_custom(float val) {\n        return (val > 0.0 || val < 0.0) ? false : val != 0.0;\n      }\n\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan_custom(val.x),\n          isnan_custom(val.y), isnan_custom(val.z), isnan_custom(val.w));\n      }\n\n      #define isnan(value) isnan_custom(value)\n    ", u = "", c = "\n      #define round(value) newRound(value)\n      int newRound(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 newRound(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    ") : (t = "", e = "attribute", n = "varying", r = "varying", s = "texture2D", i = "gl_FragColor", a = "", o = "\n      #define isnan(value) isnan_custom(value)\n      bool isnan_custom(float val) {\n        return (val > 0. || val < 1. || val == 0.) ? false : true;\n      }\n      bvec4 isnan_custom(vec4 val) {\n        return bvec4(isnan(val.x), isnan(val.y), isnan(val.z), isnan(val.w));\n      }\n    ", u = "\n      uniform float INFINITY;\n\n      bool isinf(float val) {\n        return abs(val) == INFINITY;\n      }\n      bvec4 isinf(vec4 val) {\n        return equal(abs(val), vec4(INFINITY));\n      }\n    ", c = "\n      int round(float value) {\n        return int(floor(value + 0.5));\n      }\n\n      ivec4 round(vec4 value) {\n        return ivec4(floor(value + vec4(0.5)));\n      }\n    "), {
        version: t,
        attribute: e,
        varyingVs: n,
        varyingFs: r,
        texture2D: s,
        output: i,
        defineOutput: a,
        defineSpecialNaN: o,
        defineSpecialInf: u,
        defineRound: c
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function vu(t, e, n = "index") {
      const r = Ft.Jd.computeStrides(e);
      return r.map((e, s) => {
        return `${`int ${t[s]} = ${n} / ${e}`}; ${s===r.length-1?`int ${t[s+1]} = ${n} - ${t[s]} * ${e}`:`index -= ${t[s]} * ${e}`};`
      }).join("")
    }

    function xu(t) {
      const e = Ft.Jd.computeStrides(t).map(t => t.toString());
      return `\n  int getFlatIndex(ivec3 coords) {\n    return coords.x * ${e[0]} + coords.y * ${e[1]} + coords.z;\n  }\n`
    }
    const Ou = "\n  const float FLOAT_MAX = 1.70141184e38;\n  const float FLOAT_MIN = 1.17549435e-38;\n\n  lowp vec4 encode_float(highp float v) {\n    if (isnan(v)) {\n      return vec4(255, 255, 255, 255);\n    }\n\n    highp float av = abs(v);\n\n    if(av < FLOAT_MIN) {\n      return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > FLOAT_MAX) {\n      return vec4(0.0, 0.0, 128.0, 127.0) / 255.0;\n    } else if(v < -FLOAT_MAX) {\n      return vec4(0.0, 0.0,  128.0, 255.0) / 255.0;\n    }\n\n    highp vec4 c = vec4(0,0,0,0);\n\n    highp float e = floor(log2(av));\n    highp float m = exp2(fract(log2(av))) - 1.0;\n\n    c[2] = floor(128.0 * m);\n    m -= c[2] / 128.0;\n    c[1] = floor(32768.0 * m);\n    m -= c[1] / 32768.0;\n    c[0] = floor(8388608.0 * m);\n\n    highp float ebias = e + 127.0;\n    c[3] = floor(ebias / 2.0);\n    ebias -= c[3] * 2.0;\n    c[2] += floor(ebias) * 128.0;\n\n    c[3] += 128.0 * step(0.0, -v);\n\n    return c / 255.0;\n  }\n",
      {
        getBroadcastDims: Su
      } = Ft.L;
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function _u(t, e, n, r) {
      const s = [];
      t.forEach(t => {
        const e = Ft.Jd.sizeFromShape(t.shapeInfo.logicalShape);
        t.shapeInfo.isUniform ? s.push(`uniform float ${t.name}${e>1?`[${e}]`:""};`) : (s.push(`uniform sampler2D ${t.name};`), s.push(`uniform int offset${t.name};`))
      });
      const i = s.join("\n"),
        a = t.map(t => (function (t, e, n = !1) {
          let r = "";
          r += n ? Cu(t) : ku(t);
          const s = t.shapeInfo.logicalShape,
            i = e.logicalShape;
          s.length <= i.length && (r += n ? function (t, e) {
            const n = t.name,
              r = n.charAt(0).toUpperCase() + n.slice(1),
              s = "get" + r + "AtOutCoords",
              i = t.shapeInfo.logicalShape.length,
              a = e.logicalShape.length,
              o = Su(t.shapeInfo.logicalShape, e.logicalShape),
              u = ju(a),
              c = a - i;
            let l;
            const h = ["x", "y", "z", "w", "u", "v"];
            l = 0 === i ? "" : a < 2 && o.length >= 1 ? "coords = 0;" : o.map(t => `coords.${h[t+c]} = 0;`).join("\n");
            let d = "";
            d = a < 2 && i > 0 ? "coords" : t.shapeInfo.logicalShape.map((t, e) => `coords.${h[e+c]}`).join(", ");
            let p = "return outputValue;";
            const f = 1 === Ft.Jd.sizeFromShape(t.shapeInfo.logicalShape),
              m = 1 === Ft.Jd.sizeFromShape(e.logicalShape);
            if (1 !== i || f || m) {
              if (f && !m) p = 1 === a ? "\n        return vec4(outputValue.x, outputValue.x, 0., 0.);\n      " : "\n        return vec4(outputValue.x);\n      ";
              else if (o.length) {
                const t = i - 2,
                  e = i - 1;
                o.indexOf(t) > -1 && o.indexOf(e) > -1 ? p = "return vec4(outputValue.x);" : o.indexOf(t) > -1 ? p = "return vec4(outputValue.x, outputValue.y, outputValue.x, outputValue.y);" : o.indexOf(e) > -1 && (p = "return vec4(outputValue.xx, outputValue.zz);")
              }
            } else p = "\n      return vec4(outputValue.xy, outputValue.xy);\n    ";
            return `\n    vec4 ${s}() {\n      ${u} coords = getOutputCoords();\n      ${l}\n      vec4 outputValue = get${r}(${d});\n      ${p}\n    }\n  `
          }(t, e) : function (t, e) {
            const n = t.name,
              r = n.charAt(0).toUpperCase() + n.slice(1),
              s = "get" + r + "AtOutCoords",
              i = e.texShape,
              a = t.shapeInfo.texShape,
              o = t.shapeInfo.logicalShape.length,
              u = e.logicalShape.length;
            if (!t.shapeInfo.isUniform && o === u && null == t.shapeInfo.flatOffset && Ft.Jd.arraysEqual(a, i)) return `\n      float ${s}() {\n        return sampleTexture(${n}, resultUV);\n      }\n    `;
            const c = ju(u),
              l = Su(t.shapeInfo.logicalShape, e.logicalShape),
              h = u - o;
            let d;
            const p = ["x", "y", "z", "w", "u", "v"];
            d = 0 === o ? "" : u < 2 && l.length >= 1 ? "coords = 0;" : l.map(t => `coords.${p[t+h]} = 0;`).join("\n");
            let f = "";
            f = u < 2 && o > 0 ? "coords" : t.shapeInfo.logicalShape.map((t, e) => `coords.${p[e+h]}`).join(", ");
            return `\n    float ${s}() {\n      ${c} coords = getOutputCoords();\n      ${d}\n      return get${r}(${f});\n    }\n  `
          }(t, e));
          return r
        })(t, e, r)).join("\n"),
        o = e.texShape,
        u = wu(),
        c = function (t) {
          return `\n    float sampleTexture(sampler2D textureSampler, vec2 uv) {\n      return ${t.texture2D}(textureSampler, uv).r;\n    }\n  `
        }(u);
      let l, h, d = function (t) {
        return `${t.version}\n    precision highp float;\n    precision highp int;\n    precision highp sampler2D;\n    ${t.varyingFs} vec2 resultUV;\n    ${t.defineOutput}\n    const vec2 halfCR = vec2(0.5, 0.5);\n\n    struct ivec5\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n    };\n\n    struct ivec6\n    {\n      int x;\n      int y;\n      int z;\n      int w;\n      int u;\n      int v;\n    };\n\n    uniform float NAN;\n    ${t.defineSpecialNaN}\n    ${t.defineSpecialInf}\n    ${t.defineRound}\n\n    int imod(int x, int y) {\n      return x - y * (x / y);\n    }\n\n    int idiv(int a, int b, float sign) {\n      int res = a / b;\n      int mod = imod(a, b);\n      if (sign < 0. && mod != 0) {\n        res -= 1;\n      }\n      return res;\n    }\n\n    //Based on the work of Dave Hoskins\n    //https://www.shadertoy.com/view/4djSRW\n    #define HASHSCALE1 443.8975\n    float random(float seed){\n      vec2 p = resultUV * seed;\n      vec3 p3  = fract(vec3(p.xyx) * HASHSCALE1);\n      p3 += dot(p3, p3.yzx + 19.19);\n      return fract((p3.x + p3.y) * p3.z);\n    }\n\n    ${Eu}\n    ${Iu}\n    ${Tu}\n  `
      }(u);
      return e.isPacked ? (l = function (t, e) {
        switch (t.length) {
          case 0:
            return Nu();
          case 1:
            return function (t, e) {
              const n = [Math.ceil(e[0] / 2), Math.ceil(e[1] / 2)];
              if (1 === n[0]) return `\n      int getOutputCoords() {\n        return 2 * int(resultUV.x * ${n[1]}.0);\n      }\n    `;
              if (1 === n[1]) return `\n      int getOutputCoords() {\n        return 2 * int(resultUV.y * ${n[0]}.0);\n      }\n    `;
              return `\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${n[0]}, ${n[1]}));\n      return 2 * (resTexRC.x * ${n[1]} + resTexRC.y);\n    }\n  `
            }(0, e);
          case 2:
            return function (t, e) {
              const n = [Math.ceil(e[0] / 2), Math.ceil(e[1] / 2)];
              if (Ft.Jd.arraysEqual(t, e)) return `\n      ivec2 getOutputCoords() {\n        return 2 * ivec2(resultUV.yx * vec2(${n[0]}, ${n[1]}));\n      }\n    `;
              const r = Math.ceil(t[1] / 2);
              return `\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${n[0]}, ${n[1]}));\n\n      int index = resTexRC.x * ${n[1]} + resTexRC.y;\n      int r = 2 * (index / ${r});\n      int c = imod(index, ${r}) * 2;\n\n      return ivec2(r, c);\n    }\n  `
            }(t, e);
          case 3:
            return function (t, e) {
              const n = [Math.ceil(e[0] / 2), Math.ceil(e[1] / 2)],
                r = Math.ceil(t[2] / 2),
                s = r * Math.ceil(t[1] / 2);
              return `\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${n[0]}, ${n[1]}));\n      int index = resTexRC.x * ${n[1]} + resTexRC.y;\n\n      int b = index / ${s};\n      index -= b * ${s};\n\n      int r = 2 * (index / ${r});\n      int c = imod(index, ${r}) * 2;\n\n      return ivec3(b, r, c);\n    }\n  `
            }(t, e);
          default:
            return function (t, e) {
              const n = [Math.ceil(e[0] / 2), Math.ceil(e[1] / 2)],
                r = Math.ceil(t[t.length - 1] / 2),
                s = r * Math.ceil(t[t.length - 2] / 2);
              let i = s,
                a = "",
                o = "b, r, c";
              for (let e = 2; e < t.length - 1; e++) i *= t[t.length - e - 1], a = `\n      int b${e} = index / ${i};\n      index -= b${e} * ${i};\n    ` + a, o = `b${e}, ` + o;
              return `\n    ivec${t.length} getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${n[0]}, ${n[1]}));\n      int index = resTexRC.x * ${n[1]} + resTexRC.y;\n\n      ${a}\n\n      int b = index / ${s};\n      index -= b * ${s};\n\n      int r = 2 * (index / ${r});\n      int c = imod(index, ${r}) * 2;\n\n      return ivec${t.length}(${o});\n    }\n  `
            }(t, e)
        }
      }(e.logicalShape, o), h = function (t) {
        return `\n    void setOutput(vec4 val) {\n      ${t.output} = val;\n    }\n  `
      }(u)) : (l = function (t, e) {
        switch (t.length) {
          case 0:
            return Nu();
          case 1:
            return function (t, e) {
              if (1 === e[0]) return `\n      int getOutputCoords() {\n        return int(resultUV.x * ${e[1]}.0);\n      }\n    `;
              if (1 === e[1]) return `\n      int getOutputCoords() {\n        return int(resultUV.y * ${e[0]}.0);\n      }\n    `;
              return `\n    int getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${e[0]}, ${e[1]}));\n      return resTexRC.x * ${e[1]} + resTexRC.y;\n    }\n  `
            }(0, e);
          case 2:
            return function (t, e) {
              if (Ft.Jd.arraysEqual(t, e)) return `\n      ivec2 getOutputCoords() {\n        return ivec2(resultUV.yx * vec2(${e[0]}, ${e[1]}));\n      }\n    `;
              if (1 === t[1]) return `\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(${e[0]}, ${e[1]}));\n        int index = resTexRC.x * ${e[1]} + resTexRC.y;\n        return ivec2(index, 0);\n      }\n    `;
              if (1 === t[0]) return `\n      ivec2 getOutputCoords() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n                               vec2(${e[0]}, ${e[1]}));\n        int index = resTexRC.x * ${e[1]} + resTexRC.y;\n        return ivec2(0, index);\n      }\n    `;
              return `\n    ivec2 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${e[0]}, ${e[1]}));\n      int index = resTexRC.x * ${e[1]} + resTexRC.y;\n      int r = index / ${t[1]};\n      int c = index - r * ${t[1]};\n      return ivec2(r, c);\n    }\n  `
            }(t, e);
          case 3:
            return function (t, e) {
              const n = vu(["r", "c", "d"], t);
              return `\n    ivec3 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n                             vec2(${e[0]}, ${e[1]}));\n      int index = resTexRC.x * ${e[1]} + resTexRC.y;\n      ${n}\n      return ivec3(r, c, d);\n    }\n  `
            }(t, e);
          case 4:
            return function (t, e) {
              const n = vu(["r", "c", "d", "d2"], t);
              return `\n    ivec4 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(${e[0]}, ${e[1]}));\n      int index = resTexRC.x * ${e[1]} + resTexRC.y;\n      ${n}\n      return ivec4(r, c, d, d2);\n    }\n  `
            }(t, e);
          case 5:
            return function (t, e) {
              const n = vu(["r", "c", "d", "d2", "d3"], t);
              return `\n    ivec5 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx * vec2(${e[0]},\n                             ${e[1]}));\n\n      int index = resTexRC.x * ${e[1]} + resTexRC.y;\n\n      ${n}\n\n      ivec5 outShape = ivec5(r, c, d, d2, d3);\n      return outShape;\n    }\n  `
            }(t, e);
          case 6:
            return function (t, e) {
              const n = vu(["r", "c", "d", "d2", "d3", "d4"], t);
              return `\n    ivec6 getOutputCoords() {\n      ivec2 resTexRC = ivec2(resultUV.yx *\n        vec2(${e[0]}, ${e[1]}));\n      int index = resTexRC.x * ${e[1]} + resTexRC.y;\n\n      ${n}\n\n      ivec6 result = ivec6(r, c, d, d2, d3, d4);\n      return result;\n    }\n  `
            }(t, e);
          default:
            throw new Error(`${t.length}-D output sampling is not yet supported`)
        }
      }(e.logicalShape, o), h = function (t) {
        return `\n    void setOutput(float val) {\n      ${t.output} = vec4(val, 0, 0, 0);\n    }\n  `
      }(u)), r && (d += Au), [d, c, h, i, l, a, n].join("\n")
    }

    function ku(t) {
      const e = t.shapeInfo.logicalShape;
      switch (e.length) {
        case 0:
          return function (t) {
            const e = t.name,
              n = "get" + e.charAt(0).toUpperCase() + e.slice(1);
            if (t.shapeInfo.isUniform) return `float ${n}() {return ${e};}`;
            const [r, s] = t.shapeInfo.texShape;
            if (1 === r && 1 === s) return `\n      float ${n}() {\n        return sampleTexture(${e}, halfCR);\n      }\n    `;
            const [i, a] = t.shapeInfo.texShape, o = $u(e);
            return `\n    float ${n}() {\n      vec2 uv = uvFromFlat(${i}, ${a}, ${o});\n      return sampleTexture(${e}, uv);\n    }\n  `
          }(t);
        case 1:
          return function (t) {
            const e = t.name,
              n = "get" + e.charAt(0).toUpperCase() + e.slice(1);
            if (t.shapeInfo.isUniform) return `\n      float ${n}(int index) {\n        ${Ru(t)}\n      }\n    `;
            const r = t.shapeInfo.texShape,
              s = r[0],
              i = r[1];
            if (1 === i && 1 === s) return `\n      float ${n}(int index) {\n        return sampleTexture(${e}, halfCR);\n      }\n    `;
            const a = $u(e);
            if (1 === i) return `\n      float ${n}(int index) {\n        vec2 uv = vec2(0.5, (float(index + ${a}) + 0.5) / ${s}.0);\n        return sampleTexture(${e}, uv);\n      }\n    `;
            if (1 === s) return `\n      float ${n}(int index) {\n        vec2 uv = vec2((float(index + ${a}) + 0.5) / ${i}.0, 0.5);\n        return sampleTexture(${e}, uv);\n      }\n    `;
            return `\n    float ${n}(int index) {\n      vec2 uv = uvFromFlat(${s}, ${i}, index + ${a});\n      return sampleTexture(${e}, uv);\n    }\n  `
          }(t);
        case 2:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              s = t.shapeInfo.texShape;
            if (null != s && Ft.Jd.arraysEqual(e, s)) {
              const t = s[0],
                e = s[1];
              return `\n    float ${r}(int row, int col) {\n      vec2 uv = (vec2(col, row) + halfCR) / vec2(${e}.0, ${t}.0);\n      return sampleTexture(${n}, uv);\n    }\n  `
            }
            const {
              newShape: i,
              keptDims: a
            } = Ft.Jd.squeezeShape(e), o = i;
            if (o.length < e.length) {
              const e = Du(t, o),
                n = ["row", "col"];
              return `\n      ${ku(e)}\n      float ${r}(int row, int col) {\n        return ${r}(${Fu(n,a)});\n      }\n    `
            }
            if (t.shapeInfo.isUniform) return `\n      float ${r}(int row, int col) {\n        int index = round(dot(vec2(row, col), vec2(${e[1]}, 1)));\n        ${Ru(t)}\n      }\n    `;
            const u = s[0],
              c = s[1],
              l = $u(n);
            if (1 === c) return `\n    float ${r}(int row, int col) {\n      float index = dot(vec3(row, col, ${l}), vec3(${e[1]}, 1, 1));\n      vec2 uv = vec2(0.5, (index + 0.5) / ${u}.0);\n      return sampleTexture(${n}, uv);\n    }\n  `;
            if (1 === u) return `\n    float ${r}(int row, int col) {\n      float index = dot(vec3(row, col, ${l}), vec3(${e[1]}, 1, 1));\n      vec2 uv = vec2((index + 0.5) / ${c}.0, 0.5);\n      return sampleTexture(${n}, uv);\n    }\n  `;
            return `\n  float ${r}(int row, int col) {\n    // Explicitly use integer operations as dot() only works on floats.\n    int index = row * ${e[1]} + col + ${l};\n    vec2 uv = uvFromFlat(${u}, ${c}, index);\n    return sampleTexture(${n}, uv);\n  }\n`
          }(t);
        case 3:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              s = e[1] * e[2],
              i = e[2],
              {
                newShape: a,
                keptDims: o
              } = Ft.Jd.squeezeShape(e),
              u = a;
            if (u.length < e.length) {
              const e = Du(t, u),
                n = ["row", "col", "depth"];
              return `\n        ${ku(e)}\n        float ${r}(int row, int col, int depth) {\n          return ${r}(${Fu(n,o)});\n        }\n      `
            }
            if (t.shapeInfo.isUniform) return `\n      float ${r}(int row, int col, int depth) {\n        int index = round(dot(vec3(row, col, depth),\n                          vec3(${s}, ${i}, 1)));\n        ${Ru(t)}\n      }\n    `;
            const c = t.shapeInfo.texShape,
              l = c[0],
              h = c[1],
              d = t.shapeInfo.flatOffset;
            if (h === s && null == d) return `\n        float ${r}(int row, int col, int depth) {\n          float texR = float(row);\n          float texC = dot(vec2(col, depth), vec2(${i}, 1));\n          vec2 uv = (vec2(texC, texR) + halfCR) /\n                     vec2(${h}.0, ${l}.0);\n          return sampleTexture(${n}, uv);\n        }\n      `;
            if (h === i && null == d) return `\n    float ${r}(int row, int col, int depth) {\n      float texR = dot(vec2(row, col), vec2(${e[1]}, 1));\n      float texC = float(depth);\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${h}.0, ${l}.0);\n      return sampleTexture(${n}, uv);\n    }\n  `;
            const p = $u(n);
            return `\n      float ${r}(int row, int col, int depth) {\n        // Explicitly use integer operations as dot() only works on floats.\n        int index = row * ${s} + col * ${i} + depth + ${p};\n        vec2 uv = uvFromFlat(${l}, ${h}, index);\n        return sampleTexture(${n}, uv);\n      }\n  `
          }(t);
        case 4:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              s = e[3],
              i = e[2] * s,
              a = e[1] * i,
              {
                newShape: o,
                keptDims: u
              } = Ft.Jd.squeezeShape(e);
            if (o.length < e.length) {
              const e = Du(t, o),
                n = ["row", "col", "depth", "depth2"];
              return `\n      ${ku(e)}\n      float ${r}(int row, int col, int depth, int depth2) {\n        return ${r}(${Fu(n,u)});\n      }\n    `
            }
            if (t.shapeInfo.isUniform) return `\n      float ${r}(int row, int col, int depth, int depth2) {\n        int index = round(dot(vec4(row, col, depth, depth2),\n                          vec4(${a}, ${i}, ${s}, 1)));\n        ${Ru(t)}\n      }\n    `;
            const c = t.shapeInfo.flatOffset,
              l = t.shapeInfo.texShape,
              h = l[0],
              d = l[1];
            if (d === a && null == c) return `\n      float ${r}(int row, int col, int depth, int depth2) {\n        float texR = float(row);\n        float texC =\n            dot(vec3(col, depth, depth2),\n                vec3(${i}, ${s}, 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${d}.0, ${h}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
            if (d === s && null == c) return `\n      float ${r}(int row, int col, int depth, int depth2) {\n        float texR = dot(vec3(row, col, depth),\n                         vec3(${e[1]*e[2]}, ${e[2]}, 1));\n        float texC = float(depth2);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${d}.0, ${h}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
            const p = $u(n);
            return `\n    float ${r}(int row, int col, int depth, int depth2) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * ${a} + col * ${i} +\n          depth * ${s} + depth2;\n      vec2 uv = uvFromFlat(${h}, ${d}, index + ${p});\n      return sampleTexture(${n}, uv);\n    }\n  `
          }(t);
        case 5:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              s = e[4],
              i = e[3] * s,
              a = e[2] * i,
              o = e[1] * a,
              {
                newShape: u,
                keptDims: c
              } = Ft.Jd.squeezeShape(e);
            if (u.length < e.length) {
              const e = Du(t, u),
                n = ["row", "col", "depth", "depth2", "depth3"];
              return `\n      ${ku(e)}\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        return ${r}(${Fu(n,c)});\n      }\n    `
            }
            if (t.shapeInfo.isUniform) return `\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        float index = dot(\n          vec4(row, col, depth, depth2),\n          vec4(${o}, ${a}, ${i}, ${s})) +\n          depth3;\n        ${Ru(t)}\n      }\n    `;
            const l = t.shapeInfo.flatOffset,
              h = t.shapeInfo.texShape,
              d = h[0],
              p = h[1];
            if (p === o && null == l) return `\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n                         vec4(${a}, ${i}, ${s}, 1));\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${p}.0, ${d}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
            if (p === s && null == l) return `\n      float ${r}(int row, int col, int depth, int depth2, int depth3) {\n        float texR = dot(\n          vec4(row, col, depth, depth2),\n          vec4(${e[1]*e[2]*e[3]},\n               ${e[2]*e[3]}, ${e[3]}, 1));\n        int texC = depth3;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${p}.0, ${d}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
            const f = $u(n);
            return `\n    float ${r}(int row, int col, int depth, int depth2, int depth3) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * ${o} + col * ${a} + depth * ${i} +\n          depth2 * ${s} + depth3 + ${f};\n      vec2 uv = uvFromFlat(${d}, ${p}, index);\n      return sampleTexture(${n}, uv);\n    }\n  `
          }(t);
        case 6:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              {
                newShape: s,
                keptDims: i
              } = Ft.Jd.squeezeShape(e);
            if (s.length < e.length) {
              const e = Du(t, s),
                n = ["row", "col", "depth", "depth2", "depth3", "depth4"];
              return `\n      ${ku(e)}\n      float ${r}(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        return ${r}(${Fu(n,i)});\n      }\n    `
            }
            const a = e[5],
              o = e[4] * a,
              u = e[3] * o,
              c = e[2] * u,
              l = e[1] * c;
            if (t.shapeInfo.isUniform) return `\n      float ${r}(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n        int index = round(dot(\n          vec4(row, col, depth, depth2),\n          vec4(${l}, ${c}, ${u}, ${o})) +\n          dot(\n            vec2(depth3, depth4),\n            vec2(${a}, 1)));\n        ${Ru(t)}\n      }\n    `;
            const h = t.shapeInfo.flatOffset,
              d = t.shapeInfo.texShape,
              p = d[0],
              f = d[1];
            if (f === l && null == h) return `\n      float ${r}(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        int texR = row;\n        float texC = dot(vec4(col, depth, depth2, depth3),\n          vec4(${c}, ${u}, ${o}, ${a})) +\n               float(depth4);\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                   vec2(${f}.0, ${p}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
            if (f === a && null == h) return `\n      float ${r}(int row, int col, int depth,\n                    int depth2, int depth3, int depth4) {\n        float texR = dot(vec4(row, col, depth, depth2),\n          vec4(${e[1]*e[2]*e[3]*e[4]},\n               ${e[2]*e[3]*e[4]},\n               ${e[3]*e[4]},\n               ${e[4]})) + float(depth3);\n        int texC = depth4;\n        vec2 uv = (vec2(texC, texR) + halfCR) /\n                  vec2(${f}.0, ${p}.0);\n        return sampleTexture(${n}, uv);\n      }\n    `;
            const m = $u(n);
            return `\n    float ${r}(int row, int col, int depth,\n                  int depth2, int depth3, int depth4) {\n      // Explicitly use integer operations as dot() only works on floats.\n      int index = row * ${l} + col * ${c} + depth * ${u} +\n          depth2 * ${o} + depth3 * ${a} + depth4 + ${m};\n      vec2 uv = uvFromFlat(${p}, ${f}, index);\n      return sampleTexture(${n}, uv);\n    }\n  `
          }(t);
        default:
          throw new Error(`${e.length}-D input sampling` + " is not yet supported")
      }
    }

    function Cu(t) {
      switch (t.shapeInfo.logicalShape.length) {
        case 0:
          return function (t) {
            const e = t.name,
              n = "get" + e.charAt(0).toUpperCase() + e.slice(1),
              r = wu();
            return `\n    vec4 ${n}() {\n      return ${r.texture2D}(${e}, halfCR);\n    }\n  `
          }(t);
        case 1:
          return function (t) {
            const e = t.name,
              n = "get" + e.charAt(0).toUpperCase() + e.slice(1),
              r = t.shapeInfo.texShape,
              s = [Math.ceil(r[0] / 2), Math.ceil(r[1] / 2)],
              i = wu();
            return `\n    vec4 ${n}(int index) {\n      vec2 uv = packedUVfrom1D(\n        ${s[0]}, ${s[1]}, index);\n      return ${i.texture2D}(${e}, uv);\n    }\n  `
          }(t);
        case 2:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              s = t.shapeInfo.texShape,
              i = s[0],
              a = s[1],
              o = wu();
            if (null != s && Ft.Jd.arraysEqual(e, s)) return `\n      vec4 ${r}(int row, int col) {\n        vec2 uv = (vec2(col, row) + halfCR) / vec2(${a}.0, ${i}.0);\n\n        return ${o.texture2D}(${n}, uv);\n      }\n    `;
            const u = [Math.ceil(s[0] / 2), Math.ceil(s[1] / 2)],
              c = Math.ceil(e[1] / 2);
            return `\n    vec4 ${r}(int row, int col) {\n      vec2 uv = packedUVfrom2D(${c}, ${u[0]}, ${u[1]}, row, col);\n      return ${o.texture2D}(${n}, uv);\n    }\n  `
          }(t);
        case 3:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = t.name,
              r = "get" + n.charAt(0).toUpperCase() + n.slice(1),
              s = t.shapeInfo.texShape,
              i = [Math.ceil(s[0] / 2), Math.ceil(s[1] / 2)];
            if (1 === e[0]) {
              const n = e.slice(1),
                s = [1, 2],
                i = Du(t, n),
                a = ["b", "row", "col"];
              return `\n        ${Cu(i)}\n        vec4 ${r}(int b, int row, int col) {\n          return ${r}(${Fu(a,s)});\n        }\n      `
            }
            const a = i[0],
              o = i[1],
              u = Math.ceil(e[2] / 2),
              c = u * Math.ceil(e[1] / 2),
              l = wu();
            return `\n    vec4 ${r}(int b, int row, int col) {\n      vec2 uv = packedUVfrom3D(\n        ${a}, ${o}, ${c}, ${u}, b, row, col);\n      return ${l.texture2D}(${n}, uv);\n    }\n  `
          }(t);
        default:
          return function (t) {
            const e = t.shapeInfo.logicalShape,
              n = e.length,
              r = t.name,
              s = "get" + r.charAt(0).toUpperCase() + r.slice(1),
              i = t.shapeInfo.texShape,
              a = [Math.ceil(i[0] / 2), Math.ceil(i[1] / 2)],
              o = a[0],
              u = a[1],
              c = Math.ceil(e[n - 1] / 2);
            let l = c * Math.ceil(e[n - 2] / 2),
              h = "int b, int row, int col",
              d = `b * ${l} + (row / 2) * ${c} + (col / 2)`;
            for (let t = 2; t < n - 1; t++) h = `int b${t}, ` + h, l *= e[n - t - 1], d = `b${t} * ${l} + ` + d;
            const p = wu();
            return `\n    vec4 ${s}(${h}) {\n      int index = ${d};\n      int texR = index / ${u};\n      int texC = index - texR * ${u};\n      vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${u}, ${o});\n      return ${p.texture2D}(${r}, uv);\n    }\n  `
          }(t)
      }
    }
    const Eu = "\nvec2 uvFromFlat(int texNumR, int texNumC, int index) {\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\nvec2 packedUVfrom1D(int texNumR, int texNumC, int index) {\n  int texelIndex = index / 2;\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
      Iu = "\nvec2 packedUVfrom2D(int texelsInLogicalRow, int texNumR,\n  int texNumC, int row, int col) {\n  int texelIndex = (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = texelIndex / texNumC;\n  int texC = texelIndex - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
      Tu = "\nvec2 packedUVfrom3D(int texNumR, int texNumC,\n    int texelsInBatch, int texelsInLogicalRow, int b,\n    int row, int col) {\n  int index = b * texelsInBatch + (row / 2) * texelsInLogicalRow + (col / 2);\n  int texR = index / texNumC;\n  int texC = index - texR * texNumC;\n  return (vec2(texC, texR) + halfCR) / vec2(texNumC, texNumR);\n}\n",
      Au = "\n  float getChannel(vec4 frag, vec2 innerDims) {\n    vec2 modCoord = mod(innerDims, 2.);\n    return modCoord.x == 0. ?\n      (modCoord.y == 0. ? frag.r : frag.g) :\n      (modCoord.y == 0. ? frag.b : frag.a);\n  }\n  float getChannel(vec4 frag, int dim) {\n    float modCoord = mod(float(dim), 2.);\n    return modCoord == 0. ? frag.r : frag.g;\n  }\n";

    function Nu() {
      return "\n    int getOutputCoords() {\n      return 0;\n    }\n  "
    }

    function $u(t) {
      return `offset${t}`
    }

    function Ru(t) {
      const e = t.name,
        n = Ft.Jd.sizeFromShape(t.shapeInfo.logicalShape);
      return n < 2 ? `return ${e};` : `\n    for (int i = 0; i < ${n}; i++) {\n      if (i == index) {\n        return ${e}[i];\n      }\n    }\n  `
    }

    function ju(t) {
      if (t <= 1) return "int";
      if (2 === t) return "ivec2";
      if (3 === t) return "ivec3";
      if (4 === t) return "ivec4";
      if (5 === t) return "ivec5";
      if (6 === t) return "ivec6";
      throw Error(`GPU for rank ${t} is not yet supported`)
    }

    function Du(t, e) {
      const n = JSON.parse(JSON.stringify(t));
      return n.shapeInfo.logicalShape = e, n
    }

    function Fu(t, e) {
      return e.map(e => t[e]).join(", ")
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Mu {
      constructor(t, e, n, r) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, Ft.Jd.assert(t.length > 2, () => `Packed arg${n.charAt(0).toUpperCase()+n.slice(1)} supports only inputs with rank above 2.`);
        const s = t[t.length - 1],
          i = Math.ceil(s / e);
        this.outputShape = t.slice(0, -1), i > 1 && this.outputShape.push(i), r || this.variableNames.push("bestIndicesA");
        const a = this.outputShape,
          o = a.length,
          u = ju(o),
          c = yu("coords", o);
        let l, h;
        if (1 === i) {
          h = o + 1;
          const t = ju(h);
          l = `\n        ${t} sourceLocR = ${t}(${c.join()}, 0);\n        ++${c[o-1]};\n        ${t} sourceLocG = ${t}(${c.join()}, 0);\n        ++${c[o-2]};\n        ${t} sourceLocA = ${t}(${c.join()}, 0);\n        --${c[o-1]};\n        ${t} sourceLocB = ${t}(${c.join()}, 0);\n        --${c[o-2]};`
        } else h = o, l = `\n        ${u} sourceLocR = coords;\n        ++${c[o-1]};\n        ${u} sourceLocG = coords;\n        ++${c[o-2]};\n        ${u} sourceLocA = coords;\n        --${c[o-1]};\n        ${u} sourceLocB = coords;\n        --${c[o-2]};`;
        const d = ["x", "y", "z", "w", "u", "v"].slice(0, h),
          p = "." + d[h - 1],
          f = d.map(t => "int " + t),
          m = yu("sourceLocR", h - 1).concat("inIdx.r"),
          g = yu("sourceLocG", h - 1).concat("inIdx.g"),
          b = yu("sourceLocB", h - 1).concat("inIdx.b"),
          y = yu("sourceLocA", h - 1).concat("inIdx.a"),
          w = "max" === n ? "greaterThan" : "lessThan",
          v = r ? "" : `\n          inIdx = round(vec4(getBestIndicesAChannel(${m.join()}),\n                             getBestIndicesAChannel(${g.join()}),\n                             getBestIndicesAChannel(${b.join()}),\n                             getBestIndicesAChannel(${y.join()})));`,
          x = `vec4(\n            getAChannel(${m.join()}),\n            hasNextCol ? getAChannel(${g.join()}) : 0.,\n            hasNextRow ? getAChannel(${b.join()}) : 0.,\n            hasNextRow && hasNextCol ? getAChannel(${y.join()}) : 0.)`,
          O = r ? "" : `\n      float getBestIndicesAChannel(${f.join()}) {\n        return getChannel(getBestIndicesA(${d.join()}),\n                                          vec2(${d.slice(-2).join()}));\n      }`;
        this.userCode = `\n      float getAChannel(${f.join()}) {\n        return getChannel(getA(${d.join()}),\n                               vec2(${d.slice(-2).join()}));\n      }\n      ${O}\n      void main() {\n        ${u} coords = getOutputCoords();\n        bool hasNextCol = ${c[o-1]} < ${a[o-1]-1};\n        bool hasNextRow = ${c[o-2]} < ${a[o-2]-1};\n        ${l}\n        ivec4 srcIdx = ivec4(sourceLocR${p}, sourceLocG${p},\n          sourceLocB${p}, sourceLocA${p}) * ${e};\n        ivec4 inIdx = srcIdx;\n        vec4 bestIndex = vec4(inIdx);\n        vec4 bestValue = ${x};\n\n        for (int i = 0; i < ${e}; i++) {\n          inIdx = srcIdx;\n          ${v}\n          vec4 candidate = ${x};\n          bvec4 nan = isnan(candidate);\n          bvec4 replace = bvec4(\n            vec4(${w}(candidate, bestValue)) * (vec4(1.0) - vec4(nan)));\n\n          bestValue = vec4(replace.x  ? candidate.x : bestValue.x,\n                           replace.y  ? candidate.y : bestValue.y,\n                           replace.z  ? candidate.z : bestValue.z,\n                           replace.w  ? candidate.w : bestValue.w);\n          bestIndex = mix(bestIndex, vec4(inIdx), vec4(replace));\n          srcIdx++;\n        }\n        setOutput(bestIndex);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class zu {
      constructor(t) {
        this.variableNames = ["dy"], this.outputShape = t.inShape;
        const e = t.filterHeight,
          n = t.filterWidth,
          r = t.strideHeight,
          s = t.strideWidth,
          i = t.dilationHeight,
          a = t.dilationWidth,
          o = t.effectiveFilterHeight,
          u = t.effectiveFilterWidth,
          c = o - 1 - t.padInfo.top,
          l = u - 1 - t.padInfo.left,
          h = 1 / (e * n);
        this.userCode = `\n      const ivec2 pads = ivec2(${c}, ${l});\n      const float avgMultiplier = float(${h});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${o};\n            wR += ${i}) {\n          float dyR = float(dyRCorner + wR) / ${r}.0;\n\n          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < ${u};\n            wC+= ${a}) {\n            float dyC = float(dyCCorner + wC) / ${s}.0;\n\n            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n\n            dotProd += dyValue * avgMultiplier;\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    class Lu {
      constructor(t) {
        this.variableNames = ["dy"], this.outputShape = t.inShape;
        const e = t.filterDepth,
          n = t.filterHeight,
          r = t.filterWidth,
          s = t.strideDepth,
          i = t.strideHeight,
          a = t.strideWidth,
          o = t.dilationDepth,
          u = t.dilationHeight,
          c = t.dilationWidth,
          l = t.effectiveFilterDepth,
          h = t.effectiveFilterHeight,
          d = t.effectiveFilterWidth,
          p = l - 1 - t.padInfo.front,
          f = h - 1 - t.padInfo.top,
          m = d - 1 - t.padInfo.left,
          g = 1 / (e * n * r);
        this.userCode = `\n      const ivec3 pads = ivec3(${p}, ${f}, ${m});\n      const float avgMultiplier = float(${g});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, d) with pos mask(:, :, :, ch) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < ${l};\n            wD += ${o}) {\n          float dyD = float(dyDCorner + wD) / ${s}.0;\n\n          if (dyD < 0.0 || dyD >= ${t.outDepth}.0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < ${h};\n              wR += ${u}) {\n            float dyR = float(dyRCorner + wR) / ${i}.0;\n\n            if (dyR < 0.0 || dyR >= ${t.outHeight}.0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < ${d};\n                wC += ${c}) {\n              float dyC = float(dyCCorner + wC) / ${a}.0;\n\n              if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n\n              dotProd += dyValue * avgMultiplier;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Bu {
      constructor(t, e, n, r, s, i) {
        this.outputShape = [], this.variableNames = ["x", "mean", "variance"], Ft.L.assertAndGetBroadcastShape(t, e), Ft.L.assertAndGetBroadcastShape(t, n);
        let a = "0.0";
        null != r && (Ft.L.assertAndGetBroadcastShape(t, r), this.variableNames.push("offset"), a = "getOffsetAtOutCoords()");
        let o = "1.0";
        null != s && (Ft.L.assertAndGetBroadcastShape(t, s), this.variableNames.push("scale"), o = "getScaleAtOutCoords()"), this.outputShape = t, this.userCode = `\n      void main() {\n        float x = getXAtOutCoords();\n        float mean = getMeanAtOutCoords();\n        float variance = getVarianceAtOutCoords();\n        float offset = ${a};\n        float scale = ${o};\n        float inv = scale * inversesqrt(variance + float(${i}));\n        setOutput(dot(vec3(x, -mean, offset), vec3(inv, inv, 1)));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Pu {
      constructor(t, e, n, r, s, i) {
        this.packedInputs = !0, this.packedOutput = !0, this.variableNames = ["x", "mean", "variance"], Ft.L.assertAndGetBroadcastShape(t, e), Ft.L.assertAndGetBroadcastShape(t, n);
        let a = "vec4(0.0)";
        null != r && (Ft.L.assertAndGetBroadcastShape(t, r), this.variableNames.push("offset"), a = "getOffsetAtOutCoords()");
        let o = "vec4(1.0)";
        null != s && (Ft.L.assertAndGetBroadcastShape(t, s), this.variableNames.push("scale"), o = "getScaleAtOutCoords()"), this.outputShape = t, this.userCode = `\n      void main() {\n        vec4 offset = ${a};\n        vec4 scale = ${o};\n\n        vec4 x = getXAtOutCoords();\n        vec4 mean = getMeanAtOutCoords();\n        vec4 variance = getVarianceAtOutCoords();\n\n        vec4 inv = scale * inversesqrt(variance + vec4(${i}));\n\n        setOutput((x - mean) * inv + offset);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Wu = {
      REAL: "return areal * breal - aimag * bimag;",
      IMAG: "return areal * bimag + aimag * breal;"
    };
    class Uu {
      constructor(t, e, n) {
        this.variableNames = ["AReal", "AImag", "BReal", "BImag"], this.outputShape = Ft.L.assertAndGetBroadcastShape(e, n), this.userCode = `\n      float binaryOpComplex(\n          float areal, float aimag, float breal, float bimag) {\n        ${t}\n      }\n\n      void main() {\n        float areal = getARealAtOutCoords();\n        float aimag = getAImagAtOutCoords();\n        float breal = getBRealAtOutCoords();\n        float bimag = getBImagAtOutCoords();\n        setOutput(binaryOpComplex(areal, aimag, breal, bimag));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Vu = "\n  if (isnan(a)) return a;\n  if (isnan(b)) return b;\n",
      Hu = "return a + b;",
      Gu = "return a - b;",
      qu = "return a * b;",
      Ku = "\nif (a == b) {\n  return 1.0;\n};\nreturn a / b;",
      Ju = "\n  float s = sign(a) * sign(b);\n  int ia = round(a);\n  int ib = round(b);\n  if (ib != 0) {\n    // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n    return float(idiv(ia, ib, s));\n  } else {\n    return NAN;\n  }\n",
      Xu = "\nif(a < 0.0 && floor(b) < b){\n  return NAN;\n}\nif (b == 0.0) {\n  return 1.0;\n}\nreturn (round(mod(b, 2.0)) != 1) ?\n    pow(abs(a), b) : sign(a) * pow(abs(a), b);\n",
      Yu = "return float(a == b);",
      Zu = "return float(a != b);",
      Qu = "return float(a < b);",
      tc = "return float(a <= b);",
      ec = "return float(a > b);",
      nc = "return float(a >= b);",
      rc = "return float(a >= 1.0 && b >= 1.0);",
      sc = "return float(a >= 1.0 || b >= 1.0);",
      ic = Vu + "\n  return max(a, b);\n",
      ac = Vu + "\n  return min(a, b);\n",
      oc = "if (b == 0.0) return NAN;\n  return mod(a, b);",
      uc = Vu + "\n  return atan(a, b);\n",
      cc = "return (b >= 1.0) ? a : a * (b + 1.0);",
      lc = "return (a < 0.) ? b * a : a;";
    class hc {
      constructor(t, e, n) {
        this.variableNames = ["A", "B"], this.outputShape = Ft.L.assertAndGetBroadcastShape(e, n), this.userCode = `\n      float binaryOperation(float a, float b) {\n        ${t}\n      }\n\n      void main() {\n        float a = getAAtOutCoords();\n        float b = getBAtOutCoords();\n        setOutput(binaryOperation(a, b));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const dc = "\n  result.r = isNaN.r > 0. ? NAN : result.r;\n  result.g = isNaN.g > 0. ? NAN : result.g;\n  result.b = isNaN.b > 0. ? NAN : result.b;\n  result.a = isNaN.a > 0. ? NAN : result.a;\n",
      pc = "\n  // vec4 one = vec4(equal(a, b));\n  // return one + (vec4(1.0) - one) * a / b;\n  vec4 result = a / b;\n  if(a.x == b.x) {\n    result.x = 1.;\n  }\n  if(a.y == b.y) {\n    result.y = 1.;\n  }\n  if(a.z == b.z) {\n    result.z = 1.;\n  }\n  if(a.w == b.w) {\n    result.w = 1.;\n  }\n\n  return result;\n",
      fc = "\n  ivec4 ia = round(a);\n  ivec4 ib = round(b);\n  bvec4 cond = notEqual(ib, ivec4(0));\n  ivec4 result = ivec4(0);\n  vec4 s = sign(a) * sign(b);\n\n  // Windows (D3D) wants guaranteed non-zero int division at compile-time.\n  if (cond[0]) {\n    result[0] = idiv(ia[0], ib[0], s[0]);\n  }\n  if (cond[1]) {\n    result[1] = idiv(ia[1], ib[1], s[1]);\n  }\n  if (cond[2]) {\n    result[2] = idiv(ia[2], ib[2], s[2]);\n  }\n  if (cond[3]) {\n    result[3] = idiv(ia[3], ib[3], s[3]);\n  }\n  return vec4(result);\n",
      mc = "\n  // isModRound1 has 1 for components with round(mod(b, 2.0)) == 1, 0 otherwise.\n  vec4 isModRound1 = vec4(equal(round(mod(b, 2.0)), ivec4(1)));\n  vec4 multiplier = sign(a) * isModRound1 + (vec4(1.0) - isModRound1);\n  vec4 result = multiplier * pow(abs(a), b);\n\n  // Ensure that a^0 = 1, including 0^0 = 1 as this correspond to TF and JS\n  bvec4 isExpZero = equal(b, vec4(0.0));\n  result.r = isExpZero.r ? 1.0 : result.r;\n  result.g = isExpZero.g ? 1.0 : result.g;\n  result.b = isExpZero.b ? 1.0 : result.b;\n  result.a = isExpZero.a ? 1.0 : result.a;\n\n  vec4 isNaN = vec4(lessThan(a, vec4(0.0))) * vec4(lessThan(floor(b), b));\n  " + dc + "\n  return result;\n",
      gc = "\n  vec4 aLessThanZero = vec4(lessThan(a, vec4(0.)));\n  return (aLessThanZero * (b * a)) + ((vec4(1.0) - aLessThanZero) * a);\n",
      bc = "\n  vec4 bGTEZero = vec4(greaterThanEqual(b, vec4(0.)));\n  return (bGTEZero * a) + ((vec4(1.0) - bGTEZero) * (a * (b + vec4(1.0))));\n",
      yc = "\n  vec4 result = atan(a, b);\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  " + dc + "\n  return result;\n",
      wc = "\n  return vec4(equal(a, b));\n",
      vc = "\n  return vec4(notEqual(a, b));\n",
      xc = "\n  return vec4(lessThan(a, b));\n",
      Oc = "\n  return vec4(lessThanEqual(a, b));\n",
      Sc = "\n  return vec4(greaterThan(a, b));\n",
      _c = "\n  return vec4(greaterThanEqual(a, b));\n",
      kc = "\n  return vec4(\n    vec4(greaterThanEqual(a, vec4(1.0))) *\n    vec4(greaterThanEqual(b, vec4(1.0))));\n",
      Cc = "\n  return min(\n    vec4(greaterThanEqual(a, vec4(1.0))) +\n    vec4(greaterThanEqual(b, vec4(1.0))),\n    vec4(1.0));\n",
      Ec = "\n  vec4 result = vec4(max(a, b));\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  " + dc + "\n  return result;\n",
      Ic = "\n  vec4 result = vec4(min(a, b));\n  vec4 isNaN = min(vec4(isnan(a)) + vec4(isnan(b)), vec4(1.0));\n  " + dc + "\n  return result;\n",
      Tc = "\n  vec4 result = mod(a, b);\n  vec4 isNaN = vec4(equal(b, vec4(0.0)));\n  " + dc + "\n  return result;\n";
    class Ac {
      constructor(t, e, n, r = !1) {
        this.variableNames = ["A", "B"], this.supportsBroadcasting = !0, this.packedInputs = !0, this.packedOutput = !0, this.outputShape = Ft.L.assertAndGetBroadcastShape(e, n);
        const s = this.outputShape.length;
        let i = "";
        if (r)
          if (0 === s || 1 === Ft.Jd.sizeFromShape(this.outputShape)) i = "\n          result.y = 0.;\n          result.z = 0.;\n          result.w = 0.;\n        ";
          else {
            if (i = `\n          ${ju(s)} coords = getOutputCoords();\n        `, 1 === s) i += `\n            result.y = (coords + 1) >= ${this.outputShape[0]} ? 0. : result.y;\n            result.z = 0.;\n            result.w = 0.;\n          `;
            else {
              const t = yu("coords", s);
              i += `\n            bool nextRowOutOfBounds =\n              (${t[s-2]} + 1) >= ${this.outputShape[s-2]};\n            bool nextColOutOfBounds =\n              (${t[s-1]} + 1) >= ${this.outputShape[s-1]};\n            result.y = nextColOutOfBounds ? 0. : result.y;\n            result.z = nextRowOutOfBounds ? 0. : result.z;\n            result.w = nextColOutOfBounds || nextRowOutOfBounds ? 0. : result.w;\n          `
            }
          } this.userCode = `\n      vec4 binaryOperation(vec4 a, vec4 b) {\n        ${t}\n      }\n\n      void main() {\n        vec4 a = getAAtOutCoords();\n        vec4 b = getBAtOutCoords();\n\n        vec4 result = binaryOperation(a, b);\n        ${i}\n\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Nc {
      constructor(t) {
        this.variableNames = ["A"], this.outputShape = t, this.userCode = "\n      uniform float minVal;\n      uniform float maxVal;\n\n      void main() {\n        float value = getAAtOutCoords();\n        if (isnan(value)) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, minVal, maxVal));\n      }\n    "
      }
      getCustomSetupFunc(t, e) {
        return (n, r) => {
          null == this.minLoc && (this.minLoc = n.getUniformLocationNoThrow(r, "minVal"), this.maxLoc = n.getUniformLocationNoThrow(r, "maxVal")), n.gl.uniform1f(this.minLoc, t), n.gl.uniform1f(this.maxLoc, e)
        }
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class $c {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.userCode = "\n      uniform float minVal;\n      uniform float maxVal;\n\n      void main() {\n        vec4 value = getAAtOutCoords();\n\n        if (any(isnan(value))) {\n          setOutput(value);\n          return;\n        }\n\n        setOutput(clamp(value, vec4(minVal), vec4(maxVal)));\n      }\n    "
      }
      getCustomSetupFunc(t, e) {
        return (n, r) => {
          null == this.minLoc && (this.minLoc = n.getUniformLocationNoThrow(r, "minVal"), this.maxLoc = n.getUniformLocationNoThrow(r, "maxVal")), n.gl.uniform1f(this.minLoc, t), n.gl.uniform1f(this.maxLoc, e)
        }
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Rc {
      constructor(t) {
        this.variableNames = ["real", "imag"], this.outputShape = t, this.userCode = "\n      void main() {\n        float re = abs(getRealAtOutCoords());\n        float im = abs(getImagAtOutCoords());\n        float mx = max(re, im);\n\n        // sadly the length function in glsl is not underflow-safe\n        // (at least not on Intel GPUs). So the safe solution is\n        // to ensure underflow-safety in all cases.\n        setOutput(\n          mx == 0.0 ? 0.0 : mx * length(vec2(1, min(re, im)/mx))\n        );\n      }\n    "
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class jc {
      constructor(t) {
        this.outputShape = [], this.outputShape = Ft.L.computeOutShape(t, 1), this.variableNames = t.map((t, e) => `T${e}`);
        const e = new Array(t.length - 1);
        e[0] = t[0][1];
        for (let n = 1; n < e.length; n++) e[n] = e[n - 1] + t[n][1];
        const n = [`if (yC < ${e[0]}) setOutput(getT0(yR, yC));`];
        for (let t = 1; t < e.length; t++) {
          const r = e[t - 1];
          n.push(`else if (yC < ${e[t]}) ` + `setOutput(getT${t}(yR, yC-${r}));`)
        }
        const r = e.length,
          s = e[e.length - 1];
        n.push(`else setOutput(getT${r}(yR, yC-${s}));`), this.userCode = `\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int yR = coords.x;\n        int yC = coords.y;\n\n        ${n.join("\n        ")}\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Dc {
      constructor(t, e) {
        this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [], this.outputShape = Ft.L.computeOutShape(t, e);
        const n = this.outputShape,
          r = n.length,
          s = ju(r),
          i = yu("coords", r),
          a = ["x", "y", "z", "w", "u", "v"].slice(0, r);
        this.variableNames = t.map((t, e) => `T${e}`);
        const o = new Array(t.length - 1);
        o[0] = t[0][e];
        for (let n = 1; n < o.length; n++) o[n] = o[n - 1] + t[n][e];
        const u = a[e],
          c = a.slice(-2),
          l = a.join();
        let h = `if (${u} < ${o[0]}) {\n        return getChannel(\n            getT0(${l}), vec2(${c.join()}));\n        }`;
        for (let t = 1; t < o.length; t++) {
          const e = o[t - 1];
          h += `\n        if (${u} < ${o[t]}  && ${u} >= ${o[t-1]}) {\n          return getChannel(\n            getT${t}(${Fc(a,u,e)}),\n            vec2(${Fc(c,u,e)}));\n        }`
        }
        const d = o.length,
          p = o[o.length - 1];
        h += `\n        return getChannel(\n          getT${d}(${Fc(a,u,p)}),\n          vec2(${Fc(c,u,p)}));`, this.userCode = `\n      float getValue(${a.map(t=>"int "+t)}) {\n        ${h}\n      }\n\n      void main() {\n        ${s} coords = getOutputCoords();\n        vec4 result = vec4(getValue(${i}), 0., 0., 0.);\n\n        ${i[r-1]} = ${i[r-1]} + 1;\n        if (${i[r-1]} < ${n[r-1]}) {\n          result.g = getValue(${i});\n        }\n\n        ${i[r-2]} = ${i[r-2]} + 1;\n        if (${i[r-2]} < ${n[r-2]}) {\n          result.a = getValue(${i});\n        }\n\n        ${i[r-1]} = ${i[r-1]} - 1;\n        if (${i[r-2]} < ${n[r-2]} &&\n            ${i[r-1]} < ${n[r-1]}) {\n          result.b = getValue(${i});\n        }\n        setOutput(result);\n      }\n    `
      }
    }

    function Fc(t, e, n) {
      const r = t.indexOf(e);
      return t.map((t, e) => e === r ? `${t} - ${n}` : t).join()
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Mc {
      constructor(t) {
        this.variableNames = ["x", "dy"], this.outputShape = t.filterShape;
        const e = t.strideHeight,
          n = t.strideWidth,
          r = t.padInfo.top,
          s = t.padInfo.left,
          i = "channelsLast" === t.dataFormat;
        this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int d2 = coords.w;\n\n        // Convolve x(?, ?, d1) with dy(:, :, d2) to get dw(wR, wC, d1, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int b = 0; b < ${t.batchSize}; b++) {\n          for (int yR = 0; yR < ${t.outHeight}; yR++) {\n            int xR = wR + yR * ${e} - ${r};\n\n            if (xR < 0 || xR >= ${t.inHeight}) {\n              continue;\n            }\n\n            for (int yC = 0; yC < ${t.outWidth}; yC++) {\n              int xC = wC + yC * ${n} - ${s};\n\n              if (xC < 0 || xC >= ${t.inWidth}) {\n                continue;\n              }\n\n              if (${i}) {\n                float dyValue = getDy(b, yR, yC, d2);\n                float xValue = getX(b, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              } else {\n                float dyValue = getDy(b, d2, yR, yC);\n                float xValue = getX(b, d1, xR, xC);\n                dotProd += (xValue * dyValue);\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    class zc {
      constructor(t) {
        this.variableNames = ["dy", "W"], this.outputShape = t.inShape;
        const e = t.filterHeight,
          n = t.filterWidth,
          r = t.strideHeight,
          s = t.strideWidth,
          i = "channelsLast" === t.dataFormat,
          a = e - 1 - t.padInfo.top,
          o = n - 1 - t.padInfo.left,
          u = i ? 1 : 2,
          c = i ? 2 : 3,
          l = i ? 3 : 1;
        this.userCode = `\n      const ivec2 pads = ivec2(${a}, ${o});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[${l}];\n\n        ivec2 dyCorner = ivec2(coords[${u}], coords[${c}]) - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        // Convolve dy(?, ?, d2) with w(:, :, d1, d2) to compute dx(xR, xC, d1).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${e}; wR++) {\n          float dyR = float(dyRCorner + wR) / ${r}.0;\n\n          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = ${e} - 1 - wR;\n\n          for (int wC = 0; wC < ${n}; wC++) {\n            float dyC = float(dyCCorner + wC) / ${s}.0;\n\n            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = ${n} - 1 - wC;\n\n            for (int d2 = 0; d2 < ${t.outChannels}; d2++) {\n\n              if (${i}) {\n                float xValue = getDy(batch, idyR, idyC, d2);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              } else {\n                float xValue = getDy(batch, d2, idyR, idyC);\n                float wValue = getW(wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    class Lc {
      constructor(t) {
        this.variableNames = ["x", "dy"], this.outputShape = t.filterShape;
        const e = t.strideDepth,
          n = t.strideHeight,
          r = t.strideWidth,
          s = t.padInfo.front,
          i = t.padInfo.top,
          a = t.padInfo.left;
        this.userCode = `\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int wF = coords.x;\n        int wR = coords.y;\n        int wC = coords.z;\n        int d1 = coords.w;\n        int d2 = coords.u;\n\n        float dotProd = 0.0;\n\n        for (int b = 0; b < ${t.batchSize}; b++) {\n          for (int yF = 0; yF < ${t.outDepth}; yF++) {\n            int xF = wF + yF * ${e} - ${s};\n\n            if (xF < 0 || xF >= ${t.inDepth}) {\n              continue;\n            }\n\n            for (int yR = 0; yR < ${t.outHeight}; yR++) {\n              int xR = wR + yR * ${n} - ${i};\n\n              if (xR < 0 || xR >= ${t.inHeight}) {\n                continue;\n              }\n\n              for (int yC = 0; yC < ${t.outWidth}; yC++) {\n                int xC = wC + yC * ${r} - ${a};\n\n                if (xC < 0 || xC >= ${t.inWidth}) {\n                  continue;\n                }\n\n                float dyValue = getDy(b, yF, yR, yC, d2);\n                float xValue = getX(b, xF, xR, xC, d1);\n                dotProd += (xValue * dyValue);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    class Bc {
      constructor(t) {
        this.variableNames = ["dy", "W"], this.outputShape = t.inShape;
        const e = t.filterDepth,
          n = t.filterHeight,
          r = t.filterWidth,
          s = t.strideDepth,
          i = t.strideHeight,
          a = t.strideWidth,
          o = e - 1 - t.padInfo.front,
          u = n - 1 - t.padInfo.top,
          c = r - 1 - t.padInfo.left;
        this.userCode = `\n      const ivec3 pads = ivec3(${o}, ${u}, ${c});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d1 = coords.u;\n\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyFCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        float dotProd = 0.0;\n        for (int wF = 0; wF < ${e}; wF++) {\n          float dyF = float(dyFCorner + wF) / ${s}.0;\n\n          if (dyF < 0.0 || dyF >= ${t.outDepth}.0 || fract(dyF) > 0.0) {\n            continue;\n          }\n          int idyF = int(dyF);\n\n          int wFPerm = ${e} - 1 - wF;\n\n          for (int wR = 0; wR < ${n}; wR++) {\n            float dyR = float(dyRCorner + wR) / ${i}.0;\n\n            if (dyR < 0.0 || dyR >= ${t.outHeight}.0 ||\n              fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            int wRPerm = ${n} - 1 - wR;\n\n            for (int wC = 0; wC < ${r}; wC++) {\n              float dyC = float(dyCCorner + wC) / ${a}.0;\n\n              if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              int wCPerm = ${r} - 1 - wC;\n\n              for (int d2 = 0; d2 < ${t.outChannels}; d2++) {\n                float xValue = getDy(batch, idyF, idyR, idyC, d2);\n                float wValue = getW(wFPerm, wRPerm, wCPerm, d1, d2);\n                dotProd += xValue * wValue;\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Pc {
      constructor(t) {
        this.variableNames = ["x", "dy"], this.outputShape = t.filterShape;
        const e = t.strideHeight,
          n = t.strideWidth,
          r = t.padInfo.top,
          s = t.padInfo.left,
          i = t.outChannels / t.inChannels;
        this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int wR = coords.x;\n        int wC = coords.y;\n        int d1 = coords.z;\n        int dm = coords.w;\n        int d2 = d1 * ${i} + dm;\n\n        float dotProd = 0.0;\n\n        // TO DO: Vec4 over the batch size\n        for (int b = 0; b < ${t.batchSize}; b++) {\n          for (int yR = 0; yR < ${t.outHeight}; yR++) {\n            int xR = wR + yR * ${e} - ${r};\n\n            if (xR < 0 || xR >= ${t.inHeight}) {\n              continue;\n            }\n\n            for (int yC = 0; yC < ${t.outWidth}; yC++) {\n              int xC = wC + yC * ${n} - ${s};\n\n              if (xC < 0 || xC >= ${t.inWidth}) {\n                continue;\n              }\n\n              float dyValue = getDy(b, yR, yC, d2);\n              float xValue = getX(b, xR, xC, d1);\n              dotProd += (xValue * dyValue);\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    class Wc {
      constructor(t) {
        this.variableNames = ["dy", "W"], this.outputShape = t.inShape;
        const e = t.filterHeight,
          n = t.filterWidth,
          r = t.strideHeight,
          s = t.strideWidth,
          i = e - 1 - t.padInfo.top,
          a = n - 1 - t.padInfo.left,
          o = t.outChannels / t.inChannels;
        this.userCode = `\n      const ivec2 pads = ivec2(${i}, ${a});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d1 = coords[3];\n        ivec2 dyCorner = coords.yz - pads;\n        int dyRCorner = dyCorner.x;\n        int dyCCorner = dyCorner.y;\n\n        float dotProd = 0.0;\n\n        for (int wR = 0; wR < ${e}; wR++) {\n          float dyR = float(dyRCorner + wR) / ${r}.0;\n\n          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          int wRPerm = ${e} - 1 - wR;\n\n          for (int wC = 0; wC < ${n}; wC++) {\n            float dyC = float(dyCCorner + wC) / ${s}.0;\n\n            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            int wCPerm = ${n} - 1 - wC;\n\n            // TO DO: Vec4 over the channelMul\n            for (int dm = 0; dm < ${o}; dm++) {\n              int d2 = d1 * ${o} + dm;\n              float xValue = getDy(batch, idyR, idyC, d2);\n              float wValue = getW(wRPerm, wCPerm, d1, dm);\n              dotProd += xValue * wValue;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Uc {
      constructor(t, e = !1, n = null, r = !1) {
        this.variableNames = ["x", "W"], this.outputShape = t.outShape;
        const s = t.padInfo.top,
          i = t.padInfo.left,
          a = t.strideHeight,
          o = t.strideWidth,
          u = t.dilationHeight,
          c = t.dilationWidth,
          l = t.filterHeight,
          h = t.filterWidth,
          d = 4 * Math.floor(t.inChannels / 4),
          p = t.inChannels % 4,
          f = "channelsLast" === t.dataFormat,
          m = f ? 1 : 2,
          g = f ? 2 : 3,
          b = f ? 3 : 1;
        let y = "",
          w = "";
        n && (y = r ? `float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          ${n}\n        }` : `\n          float activation(float x) {\n            ${n}\n          }\n        `, w = "result = activation(result);");
        const v = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), r && this.variableNames.push("preluActivationWeights"), this.userCode = `\n      ${y}\n\n      const ivec2 strides = ivec2(${a}, ${o});\n      const ivec2 pads = ivec2(${s}, ${i});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d2 = coords[${b}];\n\n        ivec2 xRCCorner =\n            ivec2(coords[${m}], coords[${g}]) * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, d2) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${l}; wR++) {\n          int xR = xRCorner + wR * ${u};\n\n          if (xR < 0 || xR >= ${t.inHeight}) {\n            continue;\n          }\n\n          for (int wC = 0; wC < ${h}; wC++) {\n            int xC = xCCorner + wC * ${c};\n\n            if (xC < 0 || xC >= ${t.inWidth}) {\n              continue;\n            }\n\n            for (int d1 = 0; d1 < ${d}; d1 += 4) {\n              vec4 wValues = vec4(\n                getW(wR, wC, d1, d2),\n                getW(wR, wC, d1 + 1, d2),\n                getW(wR, wC, d1 + 2, d2),\n                getW(wR, wC, d1 + 3, d2)\n              );\n\n              if (${f}) {\n                vec4 xValues = vec4(\n                  getX(batch, xR, xC, d1),\n                  getX(batch, xR, xC, d1 + 1),\n                  getX(batch, xR, xC, d1 + 2),\n                  getX(batch, xR, xC, d1 + 3)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec4 xValues = vec4(\n                  getX(batch, d1, xR, xC),\n                  getX(batch, d1 + 1, xR, xC),\n                  getX(batch, d1 + 2, xR, xC),\n                  getX(batch, d1 + 3, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n\n            if (${1===p}) {\n\n              if (${f}) {\n                dotProd +=\n                    getX(batch, xR, xC, ${d}) *\n                    getW(wR, wC, ${d}, d2);\n              } else {\n                dotProd +=\n                    getX(batch, ${d}, xR, xC) *\n                    getW(wR, wC, ${d}, d2);\n              }\n\n            } else if (${2===p}) {\n              vec2 wValues = vec2(\n                getW(wR, wC, ${d}, d2),\n                getW(wR, wC, ${d} + 1, d2)\n              );\n\n              if (${f}) {\n                vec2 xValues = vec2(\n                  getX(batch, xR, xC, ${d}),\n                  getX(batch, xR, xC, ${d} + 1)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec2 xValues = vec2(\n                  getX(batch, ${d}, xR, xC),\n                  getX(batch, ${d} + 1, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            } else if (${3===p}) {\n              vec3 wValues = vec3(\n                getW(wR, wC, ${d}, d2),\n                getW(wR, wC, ${d} + 1, d2),\n                getW(wR, wC, ${d} + 2, d2)\n              );\n\n              if (${f}) {\n                vec3 xValues = vec3(\n                  getX(batch, xR, xC, ${d}),\n                  getX(batch, xR, xC, ${d} + 1),\n                  getX(batch, xR, xC, ${d} + 2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else {\n                vec3 xValues = vec3(\n                  getX(batch, ${d}, xR, xC),\n                  getX(batch, ${d} + 1, xR, xC),\n                  getX(batch, ${d} + 2, xR, xC)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n\n            }\n          }\n        }\n\n        float result = dotProd;\n        ${v}\n        ${w}\n        setOutput(result);\n      }\n    `
      }
    }
    class Vc {
      constructor(t) {
        this.variableNames = ["x", "W"], this.outputShape = t.outShape;
        const e = t.padInfo.front,
          n = t.padInfo.top,
          r = t.padInfo.left,
          s = t.strideDepth,
          i = t.strideHeight,
          a = t.strideWidth,
          o = t.dilationDepth,
          u = t.dilationHeight,
          c = t.dilationWidth,
          l = t.filterDepth,
          h = t.filterHeight,
          d = t.filterWidth,
          p = 4 * Math.floor(t.inChannels / 4),
          f = t.inChannels % 4;
        this.userCode = `\n      const ivec3 strides = ivec3(${s}, ${i}, ${a});\n      const ivec3 pads = ivec3(${e}, ${n}, ${r});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int d2 = coords.u;\n\n        ivec3 xFRCCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xFCorner = xFRCCorner.x;\n        int xRCorner = xFRCCorner.y;\n        int xCCorner = xFRCCorner.z;\n\n        // Convolve x(?, ?, ?, d1) with w(:, :, :, d1, d2) to get\n        // y(yF, yR, yC, d2). ? = to be determined. : = across all\n        // values in that axis.\n        float dotProd = 0.0;\n        for (int wF = 0; wF < ${l}; wF++) {\n          int xF = xFCorner + wF * ${o};\n\n          if (xF < 0 || xF >= ${t.inDepth}) {\n            continue;\n          }\n\n          for (int wR = 0; wR < ${h}; wR++) {\n            int xR = xRCorner + wR * ${u};\n\n            if (xR < 0 || xR >= ${t.inHeight}) {\n              continue;\n            }\n\n            for (int wC = 0; wC < ${d}; wC++) {\n              int xC = xCCorner + wC * ${c};\n\n              if (xC < 0 || xC >= ${t.inWidth}) {\n                continue;\n              }\n\n              for (int d1 = 0; d1 < ${p}; d1 += 4) {\n                vec4 xValues = vec4(\n                  getX(batch, xF, xR, xC, d1),\n                  getX(batch, xF, xR, xC, d1 + 1),\n                  getX(batch, xF, xR, xC, d1 + 2),\n                  getX(batch, xF, xR, xC, d1 + 3)\n                );\n                vec4 wValues = vec4(\n                  getW(wF, wR, wC, d1, d2),\n                  getW(wF, wR, wC, d1 + 1, d2),\n                  getW(wF, wR, wC, d1 + 2, d2),\n                  getW(wF, wR, wC, d1 + 3, d2)\n                );\n\n                dotProd += dot(xValues, wValues);\n              }\n\n              if (${1===f}) {\n                dotProd +=\n                  getX(batch, xF, xR, xC, ${p}) *\n                  getW(wF, wR, wC, ${p}, d2);\n              } else if (${2===f}) {\n                vec2 xValues = vec2(\n                  getX(batch, xF, xR, xC, ${p}),\n                  getX(batch, xF, xR, xC, ${p} + 1)\n                );\n                vec2 wValues = vec2(\n                  getW(wF, wR, wC, ${p}, d2),\n                  getW(wF, wR, wC, ${p} + 1, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              } else if (${3===f}) {\n                vec3 xValues = vec3(\n                  getX(batch, xF, xR, xC, ${p}),\n                  getX(batch, xF, xR, xC, ${p} + 1),\n                  getX(batch, xF, xR, xC, ${p} + 2)\n                );\n                vec3 wValues = vec3(\n                  getW(wF, wR, wC, ${p}, d2),\n                  getW(wF, wR, wC, ${p} + 1, d2),\n                  getW(wF, wR, wC, ${p} + 2, d2)\n                );\n                dotProd += dot(xValues, wValues);\n              }\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Hc {
      constructor(t, e = !1, n = null, r = !1) {
        this.variableNames = ["x", "W"], this.outputShape = t.outShape;
        const s = t.inHeight,
          i = t.inWidth,
          a = t.padInfo.top,
          o = t.padInfo.left,
          u = t.strideHeight,
          c = t.strideWidth,
          l = t.dilationHeight,
          h = t.dilationWidth,
          d = t.filterHeight,
          p = t.filterWidth,
          f = t.outChannels / t.inChannels;
        let m = "",
          g = "";
        n && (m = r ? `float activation(float a) {\n          float b = getPreluActivationWeightsAtOutCoords();\n          ${n}\n        }` : `\n          float activation(float x) {\n            ${n}\n          }\n        `, g = "result = activation(result);");
        const b = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), r && this.variableNames.push("preluActivationWeights"), this.userCode = `\n      ${m}\n\n      const ivec2 strides = ivec2(${u}, ${c});\n      const ivec2 pads = ivec2(${a}, ${o});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2 / ${f};\n        int q = d2 - d1 * ${f};\n\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // Convolve x(?, ?, d1) with w(:, :, d1, q) to get y(yR, yC, d2).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        // TO DO(dsmilkov): Flatten the two for loops and vec4 the operations.\n        for (int wR = 0; wR < ${d}; wR++) {\n          int xR = xRCorner + wR * ${l};\n\n          if (xR < 0 || xR >= ${s}) {\n            continue;\n          }\n\n          for (int wC = 0; wC < ${p}; wC++) {\n            int xC = xCCorner + wC * ${h};\n\n            if (xC < 0 || xC >= ${i}) {\n              continue;\n            }\n\n            float xVal = getX(batch, xR, xC, d1);\n            float wVal = getW(wR, wC, d1, q);\n            dotProd += xVal * wVal;\n          }\n        }\n\n        float result = dotProd;\n        ${b}\n        ${g}\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Gc {
      constructor(t, e = !1, n = null, r = !1) {
        this.variableNames = ["x", "W"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t.outShape;
        const s = t.inHeight,
          i = t.inWidth,
          a = t.padInfo.top,
          o = t.padInfo.left,
          u = t.strideHeight,
          c = t.strideWidth,
          l = t.dilationHeight,
          h = t.dilationWidth,
          d = t.filterHeight,
          p = t.filterWidth,
          f = p;
        let m = "int xR; int xC; int xCOffset;";
        for (let t = 0; t < d; t++)
          for (let e = 0; e < p; e++) m += `\n          vec4 xTexelR${t}C${2*e} = vec4(0.);\n          vec4 wR${t}C${e} = vec4(0.);\n          vec4 xR${t}C${e} = vec4(0.);`;
        for (let t = 0; t < d; t++)
          for (let e = 0; e < f; e++) {
            const n = 2 * e;
            if (m += `\n          xR = xRCorner + ${t*l};\n          xC = xCCorner + ${n*h};\n        `, 1 === c) {
              if (n < p && (m += o % 2 == 1 ? `\n                xCOffset = xC + 1;\n                if(xR >= 0 && xR < ${s} && xCOffset >= 0 && xCOffset < ${i}) {\n                  xTexelR${t}C${n} = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if(xCOffset + 1 >= ${i}) {\n                    xTexelR${t}C${n}.zw = vec2(0.);\n                  }\n                } else {\n                  xTexelR${t}C${n} = vec4(0.);\n                }\n\n                xCOffset = xC + 1 - 2;\n                if(xR >= 0 && xR < ${s} && xCOffset >= 0 && xCOffset < ${i}) {\n                  vec4 previous = getX(batch, xR, xCOffset, d1);\n\n                  // Need to manually clear unused channels in case\n                  // we're reading from recycled texture.\n                  if(xCOffset + 1 >= ${i}) {\n                    previous.zw = vec2(0.);\n                  }\n\n                  xR${t}C${n} = vec4(previous.zw, xTexelR${t}C${n}.xy);\n                } else {\n                  xR${t}C${n} = vec4(0, 0, xTexelR${t}C${n}.xy);\n                }\n              ` : `\n                if(xR >= 0 && xR < ${s} && xC >= 0 && xC < ${i}) {\n                  xTexelR${t}C${n} = getX(batch, xR, xC, d1);\n                } else {\n                  xTexelR${t}C${n} = vec4(0.);\n                }\n\n                xR${t}C${n} = xTexelR${t}C${n};\n              `, n + 1 < p)) {
                const e = o % 2 == 0 ? Ft.Jd.nearestLargerEven(h) : h;
                h % 2 == 0 && o % 2 == 1 || h % 2 != 0 && o % 2 != 1 ? (m += `\n                  xCOffset = xC + ${o%2} + ${e};\n\n                  if(xR >= 0 && xR < ${s} &&\n                    xCOffset >= 0 && xCOffset < ${i}) {\n                    xTexelR${t}C${n+2} = getX(batch, xR, xCOffset, d1);\n                  }\n                `, h > 1 && (m += `\n                    xCOffset -= 2;\n                    if(xR >= 0 && xR < ${s} &&\n                      xCOffset >= 0 && xCOffset < ${i}) {\n                      xTexelR${t}C${n} = getX(batch, xR, xCOffset, d1);\n                    } else {\n                      xTexelR${t}C${n} = vec4(0.);\n                    }\n                  `), m += `\n                  xR${t}C${n+1} = vec4(\n                    xTexelR${t}C${n}.zw, xTexelR${t}C${n+2}.xy);\n                `) : m += `\n                  xCOffset = xC + ${e};\n\n                  if(xR >= 0 && xR < ${s} &&\n                    xCOffset >= 0 && xCOffset < ${i}) {\n                    xTexelR${t}C${n+2} = getX(batch, xR, xCOffset, d1);\n                  }\n\n                  xR${t}C${n+1} = xTexelR${t}C${n+2};\n                `
              }
            } else n < p && (m += `\n              if(xR >= 0 && xR < ${s}) {\n            `, o % 2 == 1 ? (m += `\n                xCOffset = xC + 1 - ${c};\n                if(xCOffset >= 0 && xCOffset < ${i}) {\n                  xTexelR${t}C${n} = getX(batch, xR, xCOffset, d1);\n                } else {\n                  xTexelR${t}C${n} = vec4(0.);\n                }\n\n                if(xC + 1 >= 0 && xC + 1 < ${i}) {\n                  xTexelR${t}C${n+2} = getX(batch, xR, xC + 1, d1);\n                } else {\n                  xTexelR${t}C${n+2} = vec4(0.);\n                }\n\n                xR${t}C${n} = vec4(\n                  xTexelR${t}C${n}.zw, xTexelR${t}C${n+2}.zw);\n              `, n + 1 < p && (m += `\n                  vec4 final = vec4(0.);\n                  xCOffset = xC + 1 + ${c};\n                  if(xCOffset >= 0 && xCOffset < ${i}) {\n                    final = getX(batch, xR, xCOffset, d1);\n                  }\n                  xR${t}C${n+1} = vec4(xTexelR${t}C${n+2}.xy, final.xy);\n                `)) : (m += `\n                if(xC >= 0 && xC < ${i}) {\n                  xTexelR${t}C${n} = getX(batch, xR, xC, d1);\n                } else {\n                  xTexelR${t}C${n} = vec4(0.);\n                }\n\n                xCOffset = xC + ${c};\n                if(xCOffset >= 0 && xCOffset < ${i}) {\n                  xTexelR${t}C${n+2} = getX(batch, xR, xCOffset, d1);\n                } else {\n                  xTexelR${t}C${n+2} = vec4(0.);\n                }\n\n                xR${t}C${n} = vec4(\n                  xTexelR${t}C${n}.xy, xTexelR${t}C${n+2}.xy);\n              `, n + 1 < p && (m += `\n                  xR${t}C${n+1} = vec4(\n                    xTexelR${t}C${n}.zw, xTexelR${t}C${n+2}.zw);\n                `)), m += "}");
            n < p && (m += `\n            vec4 wTexelR${t}C${n} = getW(${t}, ${n}, d1, q);\n            wR${t}C${n} = vec4(wTexelR${t}C${n}.xz, wTexelR${t}C${n}.xz);\n          `, n + 1 < p && (m += `\n              vec4 wTexelR${t}C${n+1} = getW(${t}, ${n+1}, d1, q);\n              wR${t}C${n+1} =\n                vec4(wTexelR${t}C${n+1}.xz, wTexelR${t}C${n+1}.xz);`))
          }
        for (let t = 0; t < d; t++)
          for (let e = 0; e < p; e++) m += `dotProd += xR${t}C${e} * wR${t}C${e};`;
        let g = "",
          b = "";
        n && (g = r ? `vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          ${n}\n        }` : `vec4 activation(vec4 x) {\n          ${n}\n        }`, b = "result = activation(result);");
        const y = e ? "result += getBiasAtOutCoords();" : "";
        e && this.variableNames.push("bias"), r && this.variableNames.push("preluActivationWeights"), this.userCode = `\n      ${g}\n\n      const ivec2 strides = ivec2(${u}, ${c});\n      const ivec2 pads = ivec2(${a}, ${o});\n\n      void main() {\n\n        ivec4 coords = getOutputCoords();\n        int batch = coords.x;\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int d2 = coords.w;\n        int d1 = d2;\n        int q = 0;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        vec4 dotProd = vec4(0.);\n\n        ${m}\n\n        vec4 result = dotProd;\n        ${y}\n        ${b}\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class qc {
      constructor(t, e, n, r, s) {
        this.variableNames = ["Image", "Boxes", "BoxInd"], this.outputShape = [];
        const [i, a, o, u] = t, [c] = e, [l, h] = n;
        this.outputShape = [c, l, h, u];
        const d = "bilinear" === r ? 1 : 0,
          [p, f] = [`${a-1}.0`, `${o-1}.0`],
          [m, g, b] = l > 1 ? [`${(a-1)/(l-1)}`, "(y2-y1) * height_ratio", `y1*${p} + float(y)*(height_scale)`] : ["0.0", "0.0", `0.5 * (y1+y2) * ${p}`],
          [y, w, v] = h > 1 ? [`${(o-1)/(h-1)}`, "(x2-x1) * width_ratio", `x1*${f} + float(x)*(width_scale)`] : ["0.0", "0.0", `0.5 * (x1+x2) * ${f}`];
        this.userCode = `\n      const float height_ratio = float(${m});\n      const float width_ratio = float(${y});\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int y = coords[1];\n        int x = coords[2];\n        int d = coords[3];\n\n        // get box vals\n        float y1 = getBoxes(b,0);\n        float x1 = getBoxes(b,1);\n        float y2 = getBoxes(b,2);\n        float x2 = getBoxes(b,3);\n\n        // get image in batch index\n        int bInd = round(getBoxInd(b));\n        if(bInd < 0 || bInd >= ${i}) {\n          return;\n        }\n\n        float height_scale = ${g};\n        float width_scale = ${w};\n\n        float in_y = ${b};\n        if( in_y < 0.0 || in_y > ${p} ) {\n          setOutput(float(${s}));\n          return;\n        }\n        float in_x = ${v};\n        if( in_x < 0.0 || in_x > ${f} ) {\n          setOutput(float(${s}));\n          return;\n        }\n\n        vec2 sourceFracIndexCR = vec2(in_x,in_y);\n        if(${d} == 1) {\n          // Compute the four integer indices.\n          ivec2 sourceFloorCR = ivec2(sourceFracIndexCR);\n          ivec2 sourceCeilCR = ivec2(ceil(sourceFracIndexCR));\n\n          float topLeft = getImage(b, sourceFloorCR.y, sourceFloorCR.x, d);\n          float bottomLeft = getImage(b, sourceCeilCR.y, sourceFloorCR.x, d);\n          float topRight = getImage(b, sourceFloorCR.y, sourceCeilCR.x, d);\n          float bottomRight = getImage(b, sourceCeilCR.y, sourceCeilCR.x, d);\n\n          vec2 fracCR = sourceFracIndexCR - vec2(sourceFloorCR);\n\n          float top = topLeft + (topRight - topLeft) * fracCR.x;\n          float bottom = bottomLeft + (bottomRight - bottomLeft) * fracCR.x;\n          float newValue = top + (bottom - top) * fracCR.y;\n          setOutput(newValue);\n        } else {\n          // Compute the coordinators of nearest neighbor point.\n          ivec2 sourceNearestCR = ivec2(floor(\n            sourceFracIndexCR + vec2(0.5,0.5)));\n          float newValue = getImage(b, sourceNearestCR.y, sourceNearestCR.x, d);\n          setOutput(newValue);\n        }\n      }\n    `
      }
    }
    class Kc {
      constructor(t, e, n) {
        this.variableNames = ["x"], this.outputShape = t;
        const r = t.length,
          s = e ? "0.0" : `getX(${Jc(r,"coords")})`,
          i = t[t.length - 1];
        let a = "",
          o = "";
        e ? (a = n ? `end != ${i-1}` : "end != 0", o = n ? "end + 1" : "end - 1") : (a = n ? `end + pow2 < ${i}` : "end >= pow2", o = n ? "end + pow2" : "end - pow2"), this.userCode = `\n      uniform float index;\n      void main() {\n        ${ju(r)} coords = getOutputCoords();\n        int end = ${Xc(r,"coords")};\n        float val = ${s};\n        int pow2 = int(pow(2.0, index));\n        if (${a}) {\n          int idx = ${o};\n          ${Xc(r,"coords")} = idx;\n          val += getX(${Jc(r,"coords")});\n        }\n        setOutput(val);\n      }\n    `
      }
      getCustomSetupFunc(t) {
        return (e, n) => {
          null == this.index && (this.index = e.getUniformLocation(n, "index")), e.gl.uniform1f(this.index, t)
        }
      }
    }

    function Jc(t, e) {
      if (1 === t) return `${e}`;
      if (2 === t) return `${e}.x, ${e}.y`;
      if (3 === t) return `${e}.x, ${e}.y, ${e}.z`;
      if (4 === t) return `${e}.x, ${e}.y, ${e}.z, ${e}.w`;
      throw Error(`Cumulative sum for rank ${t} is not yet supported`)
    }

    function Xc(t, e) {
      if (1 === t) return `${e}`;
      if (2 === t) return `${e}.y`;
      if (3 === t) return `${e}.z`;
      if (4 === t) return `${e}.w`;
      throw Error(`Cumulative sum for rank ${t} is not yet supported`)
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Yc {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !1, this.packedOutput = !0, this.outPackingScheme = jo.DENSE;
        const e = zo(t),
          n = wu();
        this.outputShape = t, this.userCode = `\n      ivec3 outCoordsFromFlatIndex(int index) {\n        ${vu(["r","c","d"],t)}\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n          vec2(${e[0]}, ${e[1]}));\n        int index = 4 * (resTexRC.x * ${e[1]} + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getA(rc.x, rc.y, rc.z);\n        }\n\n        ${n.output} = result;\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Zc {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, this.outPackingScheme = jo.DENSE;
        const e = zo(t),
          n = wu();
        this.outputShape = t, this.userCode = `\n      ivec3 outCoordsFromFlatIndex(int index) {\n        ${vu(["r","c","d"],t)}\n        return ivec3(r, c, d);\n      }\n\n      void main() {\n        ivec2 resTexRC = ivec2(resultUV.yx *\n          vec2(${e[0]}, ${e[1]}));\n        int index = 4 * (resTexRC.x * ${e[1]} + resTexRC.y);\n\n        vec4 result = vec4(0.);\n\n        for (int i=0; i<4; i++) {\n          int flatIndex = index + i;\n          ivec3 rc = outCoordsFromFlatIndex(flatIndex);\n          result[i] = getChannel(getA(rc.x, rc.y, rc.z), vec2(rc.y, rc.z));\n        }\n\n        ${n.output} = result;\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Qc {
      constructor(t, e, n) {
        this.variableNames = ["x"], this.outputShape = [], this.outputShape = t, this.blockSize = e, this.dataFormat = n, this.userCode = `\n    void main() {\n      ivec4 coords = getOutputCoords();\n      int b = coords[0];\n      int h = ${this.getHeightCoordString()};\n      int w = ${this.getWidthCoordString()};\n      int d = ${this.getDepthCoordString()};\n\n      int in_h = h / ${e};\n      int offset_h = imod(h, ${e});\n      int in_w = w / ${e};\n      int offset_w = imod(w, ${e});\n      int offset_d = (offset_h * ${e} + offset_w) *\n        ${this.getOutputDepthSize()};\n      int in_d = d + offset_d;\n\n      float result = ${this.getInputSamplingString()};\n      setOutput(result);\n    }\n  `
      }
      getHeightCoordString() {
        return "NHWC" === this.dataFormat ? "coords[1]" : "coords[2]"
      }
      getWidthCoordString() {
        return "NHWC" === this.dataFormat ? "coords[2]" : "coords[3]"
      }
      getDepthCoordString() {
        return "NHWC" === this.dataFormat ? "coords[3]" : "coords[1]"
      }
      getOutputDepthSize() {
        return "NHWC" === this.dataFormat ? this.outputShape[3] : this.outputShape[1]
      }
      getInputSamplingString() {
        return "NHWC" === this.dataFormat ? "getX(b, in_h, in_w, in_d)" : "getX(b, in_d, in_h, in_w)"
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class tl {
      constructor(t) {
        this.variableNames = ["X"], this.outputShape = [t, t], this.userCode = "\n      void main() {\n          ivec2 coords = getOutputCoords();\n          float val = coords[0] == coords[1] ? getX(coords[0]) : 0.0;\n          setOutput(val);\n      }\n    "
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class el {
      constructor(t) {
        this.variableNames = ["A"], this.outTexUsage = Do.DOWNLOAD;
        const e = wu();
        this.outputShape = t, this.userCode = `\n      ${Ou}\n\n      void main() {\n        float x = getAAtOutCoords();\n        ${e.output} = encode_float(x);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class nl {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !1, this.outTexUsage = Do.DOWNLOAD;
        const e = wu();
        this.outputShape = t, this.userCode = `\n      ${Ou}\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n        float x = getChannel(getAAtOutCoords(), vec2(coords.y, coords.z));\n        ${e.output} = encode_float(x);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class rl {
      constructor(t, e, n = !1) {
        this.variableNames = ["A"];
        const r = wu(),
          [s, i] = e;
        this.outputShape = t;
        let a = "result";
        n && (a = "floor(result * 255. + 0.5)"), this.userCode = `\n      ${xu(t)}\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n\n        int flatIndex = getFlatIndex(coords);\n        int offset = imod(flatIndex, 4);\n\n        flatIndex = idiv(flatIndex, 4, 1.);\n\n        int r = flatIndex / ${i};\n        int c = imod(flatIndex, ${i});\n        vec2 uv = (vec2(c, r) + halfCR) / vec2(${i}.0, ${s}.0);\n        vec4 values = ${r.texture2D}(A, uv);\n\n        float result;\n\n        if(offset == 0) {\n          result = values[0];\n        } else if(offset == 1) {\n          result = values[1];\n        } else if(offset == 2) {\n          result = values[2];\n        } else {\n          result = values[3];\n        }\n\n        ${r.output} = vec4(${a}, 0., 0., 0.);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class sl {
      constructor(t, e, n = !1) {
        this.variableNames = ["A"], this.packedInputs = !1, this.packedOutput = !0;
        const r = wu(),
          [s, i] = e;
        this.outputShape = t;
        let a = "",
          o = "result";
        n && (o = "floor(result * 255. + 0.5)");
        for (let e = 0; e <= 1; e++)
          for (let n = 0; n <= 1; n++) {
            const o = 2 * e + n;
            a += `\n          localCoords = coords;\n          if(localCoords[2] + ${n} < ${t[2]}) {\n            localCoords[2] += ${n};\n            if(localCoords[1] + ${e} < ${t[1]}) {\n              localCoords[1] += ${e};\n\n              flatIndex = getFlatIndex(localCoords);\n              offset = imod(flatIndex, 4);\n\n              flatIndex = idiv(flatIndex, 4, 1.);\n\n              r = flatIndex / ${i};\n              c = imod(flatIndex, ${i});\n              uv = (vec2(c, r) + halfCR) / vec2(${i}.0, ${s}.0);\n              values = ${r.texture2D}(A, uv);\n\n              if(offset == 0) {\n                result[${o}] = values[0];\n              } else if(offset == 1) {\n                result[${o}] = values[1];\n              } else if(offset == 2) {\n                result[${o}] = values[2];\n              } else {\n                result[${o}] = values[3];\n              }\n            }\n          }\n        `
          }
        this.userCode = `\n      ${xu(t)}\n\n      void main() {\n        ivec3 coords = getOutputCoords();\n\n        vec4 result = vec4(0.);\n        int flatIndex, r, c, offset;\n        ivec3 localCoords;\n        vec2 uv;\n        vec4 values;\n\n        ${a}\n\n        ${r.output} = ${o};\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const il = {
      REAL: "return real * expR - imag * expI;",
      IMAG: "return real * expI + imag * expR;"
    };
    class al {
      constructor(t, e, n) {
        this.variableNames = ["real", "imag"];
        const r = e[1];
        this.outputShape = e;
        const s = n ? `2.0 * ${Math.PI}` : `-2.0 * ${Math.PI}`,
          i = n ? `${r}.0` : "1.0";
        this.userCode = `\n      const float exponentMultiplier = ${s};\n\n      float unaryOpComplex(float real, float expR, float imag, float expI) {\n        ${t}\n      }\n\n      float mulMatDFT(int batch, int index) {\n        float indexRatio = float(index) / float(${r});\n        float exponentMultiplierTimesIndexRatio =\n            exponentMultiplier * indexRatio;\n\n        float result = 0.0;\n\n        for (int i = 0; i < ${r}; i++) {\n          // x = (-2|2 * PI / N) * index * i;\n          float x = exponentMultiplierTimesIndexRatio * float(i);\n          float expR = cos(x);\n          float expI = sin(x);\n          float real = getReal(batch, i);\n          float imag = getImag(batch, i);\n\n          result +=\n              unaryOpComplex(real, expR, imag, expI) / ${i};\n        }\n\n        return result;\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        setOutput(mulMatDFT(coords[0], coords[1]));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class ol {
      constructor(t, e) {
        this.outputShape = [], this.variableNames = ["x"], this.outputShape = t, this.userCode = "\n      uniform float value;\n      void main() {\n        // Input can be obtained from uniform value.\n        setOutput(value);\n      }\n    "
      }
      getCustomSetupFunc(t) {
        return (e, n) => {
          null == this.valueLoc && (this.valueLoc = e.getUniformLocationNoThrow(n, "value")), e.gl.uniform1f(this.valueLoc, t)
        }
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class ul {
      constructor(t, e, n) {
        this.variableNames = ["A", "indices"];
        const r = t.slice();
        r[n] = e, this.outputShape = r, this.rank = r.length;
        const s = ju(this.rank),
          i = function (t, e) {
            const n = t.length;
            if (n > 4) throw Error(`Gather for rank ${n} is not yet supported`);
            if (1 === n) return "int(getIndices(resRC))";
            const r = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"],
              s = [];
            for (let n = 0; n < t.length; n++) n === e ? s.push(`int(getIndices(${r[n]}))`) : s.push(`${r[n]}`);
            return s.join()
          }(t, n);
        this.userCode = `\n      void main() {\n        ${s} resRC = getOutputCoords();\n        setOutput(getA(${i}));\n      }\n    `
      }
    }
    class cl {
      constructor(t, e, n) {
        this.sliceDim = t, this.strides = e, this.variableNames = ["x", "indices"], this.outputShape = n;
        const r = ju(e.length),
          s = ju(n.length),
          i = this.sliceDim > 1 ? "strides[j]" : "strides";
        this.userCode = `\n        ${r} strides = ${r}(${this.strides});\n         void main() {\n          ${s} coords = getOutputCoords();\n          int flattenIndex = 0;\n          for (int j = 0; j < ${this.sliceDim}; j++) {\n            int index = round(getIndices(coords[0], j));\n            flattenIndex += index * ${i};\n          }\n          setOutput(getX(flattenIndex, coords[1]));\n        }\n      `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function ll(t) {
      const e = wu();
      return function (t, e) {
        const n = tu(t, () => t.createShader(t.VERTEX_SHADER), "Unable to create vertex WebGLShader.");
        if (Po(t, () => t.shaderSource(n, e)), Po(t, () => t.compileShader(n)), !1 === t.getShaderParameter(n, t.COMPILE_STATUS)) throw console.log(t.getShaderInfoLog(n)), new Error("Failed to compile vertex shader.");
        return n
      }(t, `${e.version}\n    precision highp float;\n    ${e.attribute} vec3 clipSpacePos;\n    ${e.attribute} vec2 uv;\n    ${e.varyingVs} vec2 resultUV;\n\n    void main() {\n      gl_Position = vec4(clipSpacePos, 1);\n      resultUV = uv;\n    }`)
    }

    function hl(t) {
      return function (t, e) {
        const n = tu(t, () => t.createBuffer(), "Unable to create WebGLBuffer");
        return Po(t, () => t.bindBuffer(t.ARRAY_BUFFER, n)), Po(t, () => t.bufferData(t.ARRAY_BUFFER, e, t.STATIC_DRAW)), n
      }(t, new Float32Array([-1, 1, 0, 0, 1, -1, -1, 0, 0, 0, 1, 1, 0, 1, 1, 1, -1, 0, 1, 0]))
    }

    function dl(t) {
      return function (t, e) {
        const n = tu(t, () => t.createBuffer(), "Unable to create WebGLBuffer");
        return Po(t, () => t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, n)), Po(t, () => t.bufferData(t.ELEMENT_ARRAY_BUFFER, e, t.STATIC_DRAW)), n
      }(t, new Uint16Array([0, 1, 2, 2, 1, 3]))
    }

    function pl(t, e, n, r, s, i) {
      ! function (t, e) {
        const n = Object(Ft.vb)().getNumber("WEBGL_MAX_TEXTURE_SIZE");
        if (t <= 0 || e <= 0) {
          throw new Error("Requested texture size " + `[${t}x${e}]` + " is invalid.")
        }
        if (t > n || e > n) {
          throw new Error("Requested texture size " + `[${t}x${e}]` + " greater than WebGL maximum on this browser / GPU " + `[${n}x${n}]` + ".")
        }
      }(e, n);
      const a = function (t) {
          return tu(t, () => t.createTexture(), "Unable to create WebGLTexture.")
        }(t),
        o = t.TEXTURE_2D;
      return Po(t, () => t.bindTexture(o, a)), Po(t, () => t.texParameteri(o, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE)), Po(t, () => t.texParameteri(o, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE)), Po(t, () => t.texParameteri(o, t.TEXTURE_MIN_FILTER, t.NEAREST)), Po(t, () => t.texParameteri(o, t.TEXTURE_MAG_FILTER, t.NEAREST)), Po(t, () => t.texImage2D(o, 0, r, e, n, 0, s, i, null)), Po(t, () => t.bindTexture(t.TEXTURE_2D, null)), a
    }

    function fl(t) {
      return t.internalFormatFloat
    }

    function ml(t) {
      return t.internalFormatHalfFloat
    }

    function gl(t) {
      return t.downloadTextureFormat
    }

    function bl(t) {
      return t.internalFormatPackedFloat
    }

    function yl(t) {
      return t.internalFormatPackedHalfFloat
    }

    function wl(t, e, n, r, s, i, a, o) {
      const u = t,
        c = new Float32Array(function (t, e) {
          const [n, r] = Lo(t, e);
          return n * r * 4
        }(i, a));
      return u.bindBuffer(u.PIXEL_PACK_BUFFER, e), u.getBufferSubData(u.PIXEL_PACK_BUFFER, 0, c), u.bindBuffer(u.PIXEL_PACK_BUFFER, null), c
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class vl {
      constructor(t) {
        this.outputTexture = null, this.program = null, this.disposed = !1, this.vertexAttrsAreBound = !1, this.itemsToPoll = [];
        const e = Object(Ft.vb)().getNumber("WEBGL_VERSION");
        null != t ? (this.gl = t, function (t, e) {
          No[t] = e
        }(e, t)) : this.gl = Ro(e);
        let n = "WEBGL_color_buffer_float";
        if (1 === Object(Ft.vb)().getNumber("WEBGL_VERSION")) {
          const t = "OES_texture_float",
            e = "OES_texture_half_float";
          if (this.textureFloatExtension = Ho(this.gl, t), cu(this.gl, e)) this.textureHalfFloatExtension = Ho(this.gl, e);
          else if (Object(Ft.vb)().get("WEBGL_FORCE_F16_TEXTURES")) throw new Error("GL context does not support half float textures, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.");
          if (this.colorBufferFloatExtension = this.gl.getExtension(n), cu(this.gl, "EXT_color_buffer_half_float")) this.colorBufferHalfFloatExtension = Ho(this.gl, "EXT_color_buffer_half_float");
          else if (Object(Ft.vb)().get("WEBGL_FORCE_F16_TEXTURES")) throw new Error("GL context does not support color renderable half floats, yet the environment flag WEBGL_FORCE_F16_TEXTURES is set to true.")
        } else if (n = "EXT_color_buffer_float", cu(this.gl, n)) this.colorBufferFloatExtension = this.gl.getExtension(n);
        else {
          if (!cu(this.gl, "EXT_color_buffer_half_float")) throw new Error("GL context does not support color renderable floats");
          this.colorBufferHalfFloatExtension = this.gl.getExtension("EXT_color_buffer_half_float")
        }
        this.vertexBuffer = hl(this.gl), this.indexBuffer = dl(this.gl), this.framebuffer = function (t) {
          return tu(t, () => t.createFramebuffer(), "Unable to create WebGLFramebuffer.")
        }(this.gl), this.textureConfig = Bo(this.gl, this.textureHalfFloatExtension)
      }
      get debug() {
        return Object(Ft.vb)().getBool("DEBUG")
      }
      dispose() {
        if (this.disposed) return;
        null != this.program && console.warn("Disposing a GPGPUContext that still has a bound WebGLProgram. This is probably a resource leak, delete the program with GPGPUContext.deleteProgram before disposing."), null != this.outputTexture && console.warn("Disposing a GPGPUContext that still has a bound output matrix texture.  This is probably a resource leak, delete the output matrix texture with GPGPUContext.deleteMatrixTexture before disposing.");
        const t = this.gl;
        Po(t, () => t.finish()), Po(t, () => t.bindFramebuffer(t.FRAMEBUFFER, null)), Po(t, () => t.deleteFramebuffer(this.framebuffer)), Po(t, () => t.bindBuffer(t.ARRAY_BUFFER, null)), Po(t, () => t.bindBuffer(t.ELEMENT_ARRAY_BUFFER, null)), Po(t, () => t.deleteBuffer(this.indexBuffer)), this.disposed = !0
      }
      createFloat32MatrixTexture(t, e) {
        return this.throwIfDisposed(),
          function (t, e, n, r) {
            const [s, i] = Mo(e, n);
            return pl(t, s, i, fl(r), r.textureFormatFloat, t.FLOAT)
          }(this.gl, t, e, this.textureConfig)
      }
      createFloat16MatrixTexture(t, e) {
        return this.throwIfDisposed(),
          function (t, e, n, r) {
            const [s, i] = Mo(e, n);
            return pl(t, s, i, ml(r), r.textureFormatFloat, r.textureTypeHalfFloat)
          }(this.gl, t, e, this.textureConfig)
      }
      createUnsignedBytesMatrixTexture(t, e) {
        return this.throwIfDisposed(),
          function (t, e, n, r) {
            const [s, i] = Mo(e, n);
            return pl(t, s, i, gl(r), t.RGBA, t.UNSIGNED_BYTE)
          }(this.gl, t, e, this.textureConfig)
      }
      uploadPixelDataToTexture(t, e) {
        this.throwIfDisposed(),
          function (t, e, n) {
            Po(t, () => t.bindTexture(t.TEXTURE_2D, e)), n.data instanceof Uint8Array ? Po(t, () => t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, n.width, n.height, 0, t.RGBA, t.UNSIGNED_BYTE, n.data)) : Po(t, () => t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, n)), Po(t, () => t.bindTexture(t.TEXTURE_2D, null))
          }(this.gl, t, e)
      }
      uploadDenseMatrixToTexture(t, e, n, r) {
        this.throwIfDisposed(),
          function (t, e, n, r, s, i) {
            let a, o, u;
            Po(t, () => t.bindTexture(t.TEXTURE_2D, e)), s instanceof Uint8Array ? (a = new Uint8Array(n * r * 4), o = t.UNSIGNED_BYTE, u = t.RGBA) : (a = new Float32Array(n * r * 4), o = t.FLOAT, u = i.internalFormatPackedFloat), a.set(s), Po(t, () => t.texImage2D(t.TEXTURE_2D, 0, u, n, r, 0, t.RGBA, o, a)), Po(t, () => t.bindTexture(t.TEXTURE_2D, null))
          }(this.gl, t, e, n, r, this.textureConfig)
      }
      createFloat16PackedMatrixTexture(t, e) {
        return this.throwIfDisposed(),
          function (t, e, n, r) {
            const [s, i] = Lo(e, n);
            return pl(t, s, i, yl(r), t.RGBA, r.textureTypeHalfFloat)
          }(this.gl, t, e, this.textureConfig)
      }
      createPackedMatrixTexture(t, e) {
        return this.throwIfDisposed(),
          function (t, e, n, r) {
            const [s, i] = Lo(e, n);
            return pl(t, s, i, bl(r), t.RGBA, t.FLOAT)
          }(this.gl, t, e, this.textureConfig)
      }
      deleteMatrixTexture(t) {
        this.throwIfDisposed(), this.outputTexture === t && (Zo(this.gl, this.framebuffer), this.outputTexture = null), Po(this.gl, () => this.gl.deleteTexture(t))
      }
      downloadByteEncodedFloatMatrixFromOutputTexture(t, e, n) {
        return this.downloadMatrixDriver(t, () => (function (t, e, n, r) {
          const [s, i] = Mo(e, n), a = new Uint8Array(e * n * 4);
          return Po(t, () => t.readPixels(0, 0, s, i, r.downloadTextureFormat, t.UNSIGNED_BYTE, a)), new Float32Array(a.buffer)
        })(this.gl, e, n, this.textureConfig))
      }
      downloadPackedMatrixFromBuffer(t, e, n, r, s, i) {
        return wl(this.gl, t, 0, 0, 0, s, i, this.textureConfig)
      }
      downloadFloat32MatrixFromBuffer(t, e) {
        return function (t, e, n) {
          const r = t,
            s = new Float32Array(n);
          return r.bindBuffer(r.PIXEL_PACK_BUFFER, e), r.getBufferSubData(r.PIXEL_PACK_BUFFER, 0, s), r.bindBuffer(r.PIXEL_PACK_BUFFER, null), s
        }(this.gl, t, e)
      }
      createBufferFromTexture(t, e, n) {
        this.bindTextureToFrameBuffer(t);
        const r = function (t, e, n, r) {
          const s = t.createBuffer();
          Po(t, () => t.bindBuffer(t.PIXEL_PACK_BUFFER, s));
          const i = 16 * e * n;
          return Po(t, () => t.bufferData(t.PIXEL_PACK_BUFFER, i, t.STREAM_READ)), Po(t, () => t.readPixels(0, 0, n, e, t.RGBA, t.FLOAT, 0)), Po(t, () => t.bindBuffer(t.PIXEL_PACK_BUFFER, null)), s
        }(this.gl, e, n, this.textureConfig);
        return this.unbindTextureToFrameBuffer(), r
      }
      createAndWaitForFence() {
        const t = this.createFence(this.gl);
        return this.pollFence(t)
      }
      createFence(t) {
        let e, n;
        if (Object(Ft.vb)().getBool("WEBGL_FENCE_API_ENABLED")) {
          const r = t,
            s = r.fenceSync(r.SYNC_GPU_COMMANDS_COMPLETE, 0);
          t.flush(), n = () => {
            const t = r.clientWaitSync(s, 0, 0);
            return t === r.ALREADY_SIGNALED || t === r.CONDITION_SATISFIED
          }, e = s
        } else Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") > 0 ? (e = this.beginQuery(), this.endQuery(), n = () => this.isQueryAvailable(e, Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))) : n = () => !0;
        return {
          query: e,
          isFencePassed: n
        }
      }
      downloadMatrixFromPackedTexture(t, e, n) {
        return this.downloadMatrixDriver(t, () => (function (t, e, n) {
          const r = new Float32Array(e * n * 4);
          return Po(t, () => t.readPixels(0, 0, n, e, t.RGBA, t.FLOAT, r)), r
        })(this.gl, e, n))
      }
      createProgram(t) {
        this.throwIfDisposed();
        const e = this.gl,
          n = Go(e, t),
          r = ll(e),
          s = function (t) {
            return tu(t, () => t.createProgram(), "Unable to create WebGLProgram.")
          }(e);
        return Po(e, () => e.attachShader(s, r)), Po(e, () => e.attachShader(s, n)),
          function (t, e) {
            if (Po(t, () => t.linkProgram(e)), !1 === t.getProgramParameter(e, t.LINK_STATUS)) throw console.log(t.getProgramInfoLog(e)), new Error("Failed to link vertex and fragment shaders.")
          }(e, s), this.debug && Ko(e, s), this.vertexAttrsAreBound || (this.setProgram(s), this.vertexAttrsAreBound = function (t, e, n) {
            return Po(t, () => t.bindBuffer(t.ARRAY_BUFFER, n)), Jo(t, e, "clipSpacePos", n, 3, 20, 0) && Jo(t, e, "uv", n, 2, 20, 12)
          }(e, this.program, this.vertexBuffer)), s
      }
      deleteProgram(t) {
        this.throwIfDisposed(), t === this.program && (this.program = null), null != t && Po(this.gl, () => this.gl.deleteProgram(t))
      }
      setProgram(t) {
        this.throwIfDisposed(), this.program = t, null != this.program && this.debug && Ko(this.gl, this.program), Po(this.gl, () => this.gl.useProgram(t))
      }
      getUniformLocation(t, e, n = !0) {
        return this.throwIfDisposed(), n ? function (t, e, n) {
          return tu(t, () => t.getUniformLocation(e, n), 'uniform "' + n + '" not present in program.')
        }(this.gl, t, e) : function (t, e, n) {
          return t.getUniformLocation(e, n)
        }(this.gl, t, e)
      }
      getAttributeLocation(t, e) {
        return this.throwIfDisposed(), Po(this.gl, () => this.gl.getAttribLocation(t, e))
      }
      getUniformLocationNoThrow(t, e) {
        return this.throwIfDisposed(), this.gl.getUniformLocation(t, e)
      }
      setInputMatrixTexture(t, e, n) {
        this.throwIfDisposed(), this.throwIfNoProgram(), Xo(this.gl, t, e, n)
      }
      setOutputMatrixTexture(t, e, n) {
        this.setOutputMatrixTextureDriver(t, n, e)
      }
      setOutputPackedMatrixTexture(t, e, n) {
        this.throwIfDisposed();
        const [r, s] = Lo(e, n);
        this.setOutputMatrixTextureDriver(t, r, s)
      }
      setOutputMatrixWriteRegion(t, e, n, r) {
        this.setOutputMatrixWriteRegionDriver(n, t, r, e)
      }
      setOutputPackedMatrixWriteRegion(t, e, n, r) {
        throw new Error("setOutputPackedMatrixWriteRegion not implemented.")
      }
      debugValidate() {
        null != this.program && Ko(this.gl, this.program), Qo(this.gl)
      }
      executeProgram() {
        this.throwIfDisposed(), this.throwIfNoProgram();
        const t = this.gl;
        this.debug && this.debugValidate(), Po(t, () => t.drawElements(t.TRIANGLES, 6, t.UNSIGNED_SHORT, 0))
      }
      blockUntilAllProgramsCompleted() {
        this.throwIfDisposed(), Po(this.gl, () => this.gl.finish())
      }
      getQueryTimerExtension() {
        return null == this.disjointQueryTimerExtension && (this.disjointQueryTimerExtension = Ho(this.gl, 2 === Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION") ? "EXT_disjoint_timer_query_webgl2" : "EXT_disjoint_timer_query")), this.disjointQueryTimerExtension
      }
      getQueryTimerExtensionWebGL2() {
        return this.getQueryTimerExtension()
      }
      getQueryTimerExtensionWebGL1() {
        return this.getQueryTimerExtension()
      }
      beginQuery() {
        if (2 === Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
          const t = this.gl,
            e = this.getQueryTimerExtensionWebGL2(),
            n = t.createQuery();
          return t.beginQuery(e.TIME_ELAPSED_EXT, n), n
        }
        const t = this.getQueryTimerExtensionWebGL1(),
          e = t.createQueryEXT();
        return t.beginQueryEXT(t.TIME_ELAPSED_EXT, e), e
      }
      endQuery() {
        if (2 === Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION")) {
          const t = this.gl,
            e = this.getQueryTimerExtensionWebGL2();
          return void t.endQuery(e.TIME_ELAPSED_EXT)
        }
        const t = this.getQueryTimerExtensionWebGL1();
        t.endQueryEXT(t.TIME_ELAPSED_EXT)
      }
      async waitForQueryAndGetTime(t) {
        return await Ft.Jd.repeatedTry(() => this.disposed || this.isQueryAvailable(t, Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))), this.getQueryTime(t, Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_VERSION"))
      }
      getQueryTime(t, e) {
        if (0 === e) return null;
        if (2 === e) {
          const e = this.gl;
          return e.getQueryParameter(t, e.QUERY_RESULT) / 1e6
        } {
          const e = this.getQueryTimerExtensionWebGL1();
          return e.getQueryObjectEXT(t, e.QUERY_RESULT_EXT) / 1e6
        }
      }
      isQueryAvailable(t, e) {
        if (0 === e) return !0;
        if (2 === e) {
          const e = this.gl,
            n = this.getQueryTimerExtensionWebGL2(),
            r = e.getQueryParameter(t, e.QUERY_RESULT_AVAILABLE);
          return null == this.disjoint && (this.disjoint = this.gl.getParameter(n.GPU_DISJOINT_EXT)), r && !this.disjoint
        } {
          const e = this.getQueryTimerExtensionWebGL1(),
            n = e.getQueryObjectEXT(t, e.QUERY_RESULT_AVAILABLE_EXT);
          return null == this.disjoint && (this.disjoint = this.gl.getParameter(e.GPU_DISJOINT_EXT)), n && !this.disjoint
        }
      }
      pollFence(t) {
        return new Promise(e => {
          this.addItemToPoll(() => t.isFencePassed(), () => e())
        })
      }
      pollItems() {
        const t = function (t) {
          let e = 0;
          for (; e < t.length; ++e) {
            if (!t[e]()) break
          }
          return e - 1
        }
        /**
         * @license
         * Copyright 2017 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        (this.itemsToPoll.map(t => t.isDoneFn));
        for (let e = 0; e <= t; ++e) {
          const {
            resolveFn: t
          } = this.itemsToPoll[e];
          t()
        }
        this.itemsToPoll = this.itemsToPoll.slice(t + 1)
      }
      addItemToPoll(t, e) {
        this.itemsToPoll.push({
          isDoneFn: t,
          resolveFn: e
        }), this.itemsToPoll.length > 1 || Ft.Jd.repeatedTry(() => (this.pollItems(), 0 === this.itemsToPoll.length))
      }
      bindTextureToFrameBuffer(t) {
        this.throwIfDisposed(), Yo(this.gl, t, this.framebuffer), this.debug && Qo(this.gl)
      }
      unbindTextureToFrameBuffer() {
        null != this.outputTexture ? (Yo(this.gl, this.outputTexture, this.framebuffer), this.debug && Qo(this.gl)) : Zo(this.gl, this.framebuffer)
      }
      downloadMatrixDriver(t, e) {
        this.bindTextureToFrameBuffer(t);
        const n = e();
        return this.unbindTextureToFrameBuffer(), n
      }
      setOutputMatrixTextureDriver(t, e, n) {
        this.throwIfDisposed();
        const r = this.gl;
        Yo(r, t, this.framebuffer), this.debug && Qo(r), this.outputTexture = t, Po(r, () => r.viewport(0, 0, e, n)), Po(r, () => r.scissor(0, 0, e, n))
      }
      setOutputMatrixWriteRegionDriver(t, e, n, r) {
        this.throwIfDisposed(), Po(this.gl, () => this.gl.scissor(t, e, n, r))
      }
      throwIfDisposed() {
        if (this.disposed) throw new Error("Attempted to use disposed GPGPUContext.")
      }
      throwIfNoProgram() {
        if (null == this.program) throw new Error("No GPU program is currently set.")
      }
    }

    function xl(t, e) {
      if (t.length !== e.length) throw Error(`Binary was compiled with ${t.length} inputs, but ` + `was executed with ${e.length} inputs`);
      t.forEach((t, n) => {
        const r = t.logicalShape,
          s = e[n],
          i = s.shape;
        if (!Ft.Jd.arraysEqual(r, i)) throw Error("Binary was compiled with different shapes than " + `the current args. Shapes ${r} and ${i} must match`);
        if (t.isUniform && s.isUniform) return;
        const a = t.texShape,
          o = s.isUniform ? null : s.texData.texShape;
        if (!Ft.Jd.arraysEqual(a, o)) throw Error("Binary was compiled with different texture shapes than the" + ` current args. Shape ${a} and ${o} must match`)
      })
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ol {
      constructor(t, e, n) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t;
        const {
          filterWidth: r,
          inChannels: s,
          strideWidth: i,
          strideHeight: a,
          padInfo: o,
          outWidth: u,
          dilationWidth: c,
          dilationHeight: l,
          dataFormat: h
        } = n, {
          left: d,
          top: p
        } = o, f = s * r, m = wu(), g = "channelsLast" === h, b = g ? 0 : 1, y = g ? 1 : 2;
        let w = "";
        for (let n = 0; n <= 1; n++)
          for (let r = 0; r <= 1; r++) w += `\n          blockIndex = rc.y + ${r};\n          pos = rc.x + ${n};\n\n          if(blockIndex < ${t[1]} && pos < ${t[0]}) {\n            offsetY = int(blockIndex / (${u})) * ${a} - ${p};\n            d0 = offsetY + ${l} * (pos / ${f});\n\n            if(d0 < ${e[b]} && d0 >= 0) {\n\n              offsetX = int(mod(float(blockIndex), ${u}.) * ${i}. - ${d}.);\n              d1 = offsetX + ${c} * (int(mod(float(pos), ${f}.) / ${s}.));\n\n              if(d1 < ${e[y]} && d1 >= 0) {\n\n                ch = int(mod(float(pos), ${s}.));\n\n                if (${g}) {\n                  innerDims = vec2(d1, ch);\n                  result[${2*n+r}] = getChannel(\n                    getA(d0, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                } else {\n                  innerDims = vec2(d0, d1);\n                  result[${2*n+r}] = getChannel(\n                    getA(ch, int(innerDims.x),\n                    int(innerDims.y)), innerDims);\n                }\n              }\n            }\n          }\n        `;
        this.userCode = `\n      void main() {\n        ivec2 rc = getOutputCoords();\n\n        vec4 result = vec4(0);\n\n        int blockIndex, pos, offsetY, d0, offsetX, d1, ch;\n        vec2 innerDims;\n\n        ${w}\n\n        ${m.output} = result;\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Sl {
      constructor(t, e, n, r, s) {
        this.variableNames = ["x"], this.outputShape = [];
        const i = e,
          a = t[3] - 1;
        let o;
        this.outputShape = t;
        const u = `float(${n}) + float(${r}) * sum`;
        o = .5 === s ? `inversesqrt(${u})` : 1 === s ? `1.0/(${u})` : `exp(log(${u}) * float(-${s}));`, this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n        int d = coords[3];\n        float x = getX(b, r, c, d);\n        float sum = 0.0;\n        for (int j = -${i}; j <= ${i}; j++) {\n          int idx = d + j;\n          if (idx >= 0 && idx <=  ${a}) {\n            float z = getX(b, r, c, idx);\n            sum += z * z;\n          }\n        }\n        float val = x * ${o};\n        setOutput(val);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class _l {
      constructor(t, e, n, r, s) {
        this.variableNames = ["inputImage", "outputImage", "dy"], this.outputShape = [], this.outputShape = t, this.depth = t[3], this.depthRadius = e, this.bias = n, this.alpha = r, this.beta = s, this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int r = coords[1];\n        int c = coords[2];\n\n        float result = 0.0;\n        for (int d = 0; d < ${this.depth}; ++d) {\n          int depthBegin = int(max(0.0, float(d - ${e})));\n          int depthEnd = int(min(float(${this.depth}),\n              float(d + ${e} + 1)));\n\n          const int MIN_DEPTH_BEGIN = 0;\n          const int MAX_DEPTH_END = ${this.depth};\n\n          float norm = 0.0;\n          for (int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k) {\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd) {\n              norm += getInputImage(b, r, c, k) * getInputImage(b, r, c, k);\n            }\n            else {\n              break;\n            }\n          }\n\n          norm = float(${r}) * norm + float(${n});\n\n          for(int k = MIN_DEPTH_BEGIN; k < MAX_DEPTH_END; ++k){\n            if (k < depthBegin){\n              continue;\n            }\n            else if (k >= depthBegin && k < depthEnd){\n              float dyi = -2.0 * float(${r})\n                * float(${s})\n                * getInputImage(b ,r ,c, k) * getOutputImage(b, r, c, d)\n                / norm;\n              if (k == d) {\n                dyi += pow(norm, -1.0 * ${s});\n              }\n              if (k == coords[3]) {\n                dyi *= getDy(b, r, c, d);\n                result += dyi;\n              }\n            }\n            else {\n              break;\n            }\n          }\n      }\n      setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class kl {
      constructor(t, e, n, r, s) {
        this.variableNames = ["x"], this.outputShape = [], this.packedInputs = !0, this.packedOutput = !0;
        const i = e,
          a = t[3] - 1;
        let o;
        this.outputShape = t;
        const u = `float(${n}) + float(${r}) * sum`;
        o = .5 === s ? `inversesqrt(${u})` : 1 === s ? `1.0/(${u})` : `exp(log(${u}) * float(-${s}));`, this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords.x;\n        int r = coords.y;\n        int c = coords.z;\n        int d = coords.w;\n\n        bool hasNextCol = d < ${this.outputShape[3]};\n        bool hasNextRow = c < ${this.outputShape[2]};\n\n        vec4 sum = vec4(0.);\n        vec4 xFragAtOutputCoords = getX(b, r, c, d);\n\n        vec4 xAtOutputCoords = vec4(\n          getChannel(xFragAtOutputCoords, vec2(c, d)),\n          hasNextCol ?\n            getChannel(xFragAtOutputCoords, vec2(c, d + 1)) : 0.0,\n          hasNextRow ?\n            getChannel(xFragAtOutputCoords , vec2(c + 1, d)) : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getChannel(xFragAtOutputCoords, vec2(c + 1, d + 1)) : 0.0\n        );\n\n        int firstChannel = d - ${i};\n        vec2 cache = vec2(0.);\n        if(firstChannel >= 0){\n          vec4 firstChannelFrag = getX(b, r, c, firstChannel);\n          cache.x = getChannel(firstChannelFrag, vec2(c, firstChannel));\n            if(hasNextRow){\n              cache.y = getChannel(firstChannelFrag, vec2(c + 1, firstChannel));\n            }\n        }\n\n        ivec2 depth = ivec2(d, d + 1);\n        for (int j = - ${i}; j <= ${i}; j++) {\n          ivec2 idx = depth + j;\n          bvec2 aboveLowerBound = greaterThanEqual(idx, ivec2(0));\n          bvec2 belowUpperBound = lessThanEqual(idx, ivec2(${a}));\n\n          bool depthInRange = aboveLowerBound.x && belowUpperBound.x;\n          bool depthPlusOneInRange = aboveLowerBound.y && belowUpperBound.y;\n\n          if(depthInRange || depthPlusOneInRange){\n            vec4 z = vec4(0.);\n            vec4 xFragAtCurrentDepth;\n            z.xz = cache.xy;\n            if(depthPlusOneInRange && hasNextCol){\n              xFragAtCurrentDepth = idx.y != d ?\n                getX(b, r, c, idx.y) : xFragAtOutputCoords;\n              z.y = getChannel(xFragAtCurrentDepth, vec2(c, idx.y));\n              if(hasNextRow){\n                z.w = getChannel(xFragAtCurrentDepth, vec2(c + 1, idx.y));\n              }\n            }\n            cache.xy = z.yw;\n            sum += z * z;\n          }\n        }\n        vec4 result = xAtOutputCoords * ${o};\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Cl {
      constructor(t) {
        this.variableNames = ["dy", "maxPos"], this.outputShape = t.inShape;
        const e = t.strideHeight,
          n = t.strideWidth,
          r = t.dilationHeight,
          s = t.effectiveFilterHeight,
          i = t.effectiveFilterWidth,
          a = s - 1 - t.padInfo.top,
          o = i - 1 - t.padInfo.left,
          u = s * i - 1;
        this.userCode = `\n      const ivec2 pads = ivec2(${a}, ${o});\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n\n        ivec2 dyRCCorner = coords.yz - pads;\n        int dyRCorner = dyRCCorner.x;\n        int dyCCorner = dyRCCorner.y;\n\n        // Convolve dy(?, ?, d) with pos mask(:, :, d) to get dx(xR, xC, d).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n        for (int wR = 0; wR < ${s};\n          wR += ${r}) {\n          float dyR = float(dyRCorner + wR) / ${e}.0;\n\n          if (dyR < 0.0 || dyR >= ${t.outHeight}.0 || fract(dyR) > 0.0) {\n            continue;\n          }\n          int idyR = int(dyR);\n\n          for (int wC = 0; wC < ${i}; wC++) {\n            float dyC = float(dyCCorner + wC) / ${n}.0;\n\n            if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                fract(dyC) > 0.0) {\n              continue;\n            }\n            int idyC = int(dyC);\n\n            float dyValue = getDy(b, idyR, idyC, d);\n            int maxPosValue = ${u} - int(getMaxPos(b, idyR, idyC, d));\n\n            // Get the current value, check it against the value from the\n            // position matrix.\n            int curPosValue = wR * ${i} + wC;\n            float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n            dotProd += dyValue * mask;\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    class El {
      constructor(t) {
        this.variableNames = ["dy", "maxPos"], this.outputShape = t.inShape;
        const e = t.strideDepth,
          n = t.strideHeight,
          r = t.strideWidth,
          s = t.dilationDepth,
          i = t.dilationHeight,
          a = t.dilationWidth,
          o = t.effectiveFilterDepth,
          u = t.effectiveFilterHeight,
          c = t.effectiveFilterWidth,
          l = o - 1 - t.padInfo.front,
          h = u - 1 - t.padInfo.top,
          d = c - 1 - t.padInfo.left,
          p = o * u * c - 1;
        this.userCode = `\n      const ivec3 pads = ivec3(${l}, ${h}, ${d});\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 dyCorner = ivec3(coords.y, coords.z, coords.w) - pads;\n        int dyDCorner = dyCorner.x;\n        int dyRCorner = dyCorner.y;\n        int dyCCorner = dyCorner.z;\n\n        // Convolve dy(?, ?, ?, ch) with pos mask(:, :, :, d) to get\n        // dx(xD, xR, xC, ch).\n        // ? = to be determined. : = across all values in that axis.\n        float dotProd = 0.0;\n\n        for (int wD = 0; wD < ${o};\n           wD += ${s}) {\n          float dyD = float(dyDCorner + wD) / ${e}.0;\n\n          if (dyD < 0.0 || dyD >= ${t.outDepth}.0 || fract(dyD) > 0.0) {\n            continue;\n          }\n          int idyD = int(dyD);\n\n          for (int wR = 0; wR < ${u};\n              wR += ${i}) {\n            float dyR = float(dyRCorner + wR) / ${n}.0;\n\n            if (dyR < 0.0 || dyR >= ${t.outHeight}.0 ||\n                fract(dyR) > 0.0) {\n              continue;\n            }\n            int idyR = int(dyR);\n\n            for (int wC = 0; wC < ${c};\n                wC += ${a}) {\n              float dyC = float(dyCCorner + wC) / ${r}.0;\n\n              if (dyC < 0.0 || dyC >= ${t.outWidth}.0 ||\n                  fract(dyC) > 0.0) {\n                continue;\n              }\n              int idyC = int(dyC);\n\n              float dyValue = getDy(batch, idyD, idyR, idyC, ch);\n              int maxPosValue = ${p} -\n                  int(getMaxPos(batch, idyD, idyR, idyC, ch));\n\n              // Get the current value, check it against the value from the\n              // position matrix.\n              int curPosValue =\n                  wD * ${u} * ${c} +\n                  wR * ${c} + wC;\n              float mask = float(maxPosValue == curPosValue ? 1.0 : 0.0);\n\n              dotProd += dyValue * mask;\n            }\n          }\n        }\n        setOutput(dotProd);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Il {
      constructor(t, e, n = !1, r = !1, s = !1, i = null, a = !1) {
        this.variableNames = ["matrixA", "matrixB"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = e;
        const o = n ? t[1] : t[2],
          u = Math.ceil(o / 2),
          c = n ? "i * 2, rc.y" : "rc.y, i * 2",
          l = r ? "rc.z, i * 2" : "i * 2, rc.z",
          h = n ? ["a.xxyy", "a.zzww"] : ["a.xxzz", "a.yyww"],
          d = r ? ["b.xzxz", "b.ywyw"] : ["b.xyxy", "b.zwzw"];
        let p = "",
          f = "";
        i && (p = a ? `vec4 activation(vec4 a) {\n          vec4 b = getPreluActivationWeightsAtOutCoords();\n          ${i}\n        }` : `vec4 activation(vec4 x) {\n          ${i}\n        }`, f = "result = activation(result);");
        const m = s ? "result += getBiasAtOutCoords();" : "";
        s && this.variableNames.push("bias"), a && this.variableNames.push("preluActivationWeights"), this.userCode = `\n      ${p}\n\n      const float sharedDimension = ${u}.0;\n\n      vec4 dot2x2ARowBCol(ivec3 rc) {\n        vec4 result = vec4(0);\n        for (int i = 0; i < ${u}; i++) {\n          vec4 a = getMatrixA(rc.x, ${c});\n          vec4 b = getMatrixB(rc.x, ${l});\n\n          // These swizzled products need to be separately added.\n          // See: https://github.com/tensorflow/tfjs/issues/1735\n          result += (${h[0]} * ${d[0]});\n          result += (${h[1]} * ${d[1]});\n        }\n        return result;\n      }\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n        vec4 result = dot2x2ARowBCol(rc);\n\n        ${m}\n\n        ${f}\n\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Tl {
      constructor(t, e, n) {
        this.variableNames = ["probs"], this.outputShape = [t, n], this.userCode = `\n      uniform float seed;\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n\n        float r = random(seed);\n        float cdf = 0.0;\n\n        for (int i = 0; i < ${e-1}; i++) {\n          cdf += getProbs(batch, i);\n\n          if (r < cdf) {\n            setOutput(float(i));\n            return;\n          }\n        }\n\n        // If no other event happened, last event happened.\n        setOutput(float(${e-1}));\n      }\n    `
      }
      getCustomSetupFunc(t) {
        return (e, n) => {
          null == this.seedLoc && (this.seedLoc = e.getUniformLocation(n, "seed")), e.gl.uniform1f(this.seedLoc, t)
        }
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Al {
      constructor(t, e, n, r) {
        this.variableNames = ["indices"], this.outputShape = [t, e], this.userCode = `\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int index = round(getIndices(coords.x));\n        setOutput(mix(float(${r}), float(${n}),\n                      float(index == coords.y)));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Nl {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !1, this.packedOutput = !0, this.outputShape = t;
        const e = t.length;
        if (0 === e) this.userCode = "\n        void main() {\n          setOutput(vec4(getA(), 0., 0., 0.));\n        }\n      ";
        else {
          const n = yu("rc", e),
            r = ju(e),
            s = function (t, e, n) {
              if (1 === t) return `rc > ${e[0]}`;
              let r = "";
              for (let s = t - 2; s < t; s++) r += `${n[s]} >= ${e[s]}`, s < t - 1 && (r += "||");
              return r
            }(e, t, n),
            i = function (t, e, n, r) {
              if (1 === t) return "";
              const s = r.slice(-2);
              return `\n    int r = ${s[0]};\n    int c = ${s[1]};\n    int rp1 = r + 1;\n    int cp1 = c + 1;\n\n    bool cEdge = cp1 >= ${e};\n    bool rEdge = rp1 >= ${n};\n  `
            }(e, t[t.length - 1], t[t.length - 2], n),
            a = function (t, e) {
              const n = t.length,
                r = function (t, e) {
                  const n = [];
                  for (let r = 0; r <= 1; r++)
                    for (let s = 0; s <= 1; s++) {
                      let i = `${0===r?"r":"rp1"}, ${0===s?"c":"cp1"}`;
                      for (let n = 2; n < t; n++) i = `${e[e.length-1-n]},` + i;
                      n.push(i)
                    }
                  return n
                }(n, e);
              if (1 === n) return `getA(rc),\n            rc + 1 >= ${t[0]} ? 0. : getA(rc + 1),\n            0, 0`;
              return `getA(${r[0]}),\n          cEdge ? 0. : getA(${r[1]}),\n          rEdge ? 0. : getA(${r[2]}),\n          rEdge || cEdge ? 0. : getA(${r[3]})`
            }
          /**
           * @license
           * Copyright 2017 Google LLC. All Rights Reserved.
           * Licensed under the Apache License, Version 2.0 (the "License");
           * you may not use this file except in compliance with the License.
           * You may obtain a copy of the License at
           *
           * http://www.apache.org/licenses/LICENSE-2.0
           *
           * Unless required by applicable law or agreed to in writing, software
           * distributed under the License is distributed on an "AS IS" BASIS,
           * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
           * See the License for the specific language governing permissions and
           * limitations under the License.
           * =============================================================================
           */
          (t, n);
          this.userCode = `\n        void main() {\n          ${r} rc = getOutputCoords();\n\n          if(${s}) {\n            setOutput(vec4(0));\n          } else {\n            ${i}\n\n            setOutput(vec4(${a}));\n          }\n        }\n      `
        }
      }
    }
    class $l {
      constructor(t, e, n) {
        this.variableNames = ["x"], this.outputShape = e.map((e, n) => e[0] + t[n] + e[1]);
        const r = t.length,
          s = ju(r),
          i = e.map(t => t[0]).join(","),
          a = e.map((e, n) => e[0] + t[n]).join(","),
          o = ["coords[0]", "coords[1]", "coords[2]", "coords[3]"].slice(0, r);
        this.userCode = 1 !== r ? `\n      ${s} start = ${s}(${i});\n      ${s} end = ${s}(${a});\n\n      void main() {\n        ${s} outC = getOutputCoords();\n        if (any(lessThan(outC, start)) || any(greaterThanEqual(outC, end))) {\n          setOutput(float(${n}));\n        } else {\n          ${s} coords = outC - start;\n          setOutput(getX(${o}));\n        }\n      }\n    ` : `\n        int start = ${i};\n        int end = ${a};\n\n        void main() {\n          int outC = getOutputCoords();\n          if (outC < start || outC >= end) {\n            setOutput(float(${n}));\n          } else {\n            setOutput(getX(outC - start));\n          }\n        }\n      `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Rl {
      constructor(t, e, n) {
        this.variableNames = ["x"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = e.map((e, n) => e[0] + t[n] + e[1]);
        const r = t.length,
          s = ju(r),
          i = e.map(t => t[0]).join(","),
          a = e.map((e, n) => e[0] + t[n]).join(","),
          o = yu("rc", r),
          u = yu("source", r),
          c = `${o[r-1]} < ${this.outputShape[r-1]}`,
          l = 1 === r ? "source" : `vec2(${u.slice(-2).join()})`,
          h = [`${s} rc = outputLoc;`, `${o[r-1]} += 1;\n       if(${c}) {\n      `, 1 === r ? "" : `}\n       rc = outputLoc;\n       ${o[r-2]} += 1;\n       if(${o[r-2]} < ${this.outputShape[r-2]}) {`, 1 === r ? "" : `  ${o[r-1]} += 1;\n         if(${c}) {`],
          d = 1 === r ? "rc < start || rc >= end" : "any(lessThan(rc, start)) || any(greaterThanEqual(rc, end))";
        let p = "";
        for (let t = 0, e = 1 === r ? 2 : 4; t < e; t++) p += `\n        ${h[t]}\n        if (${d}) {\n          result[${t}] = float(${n});\n        } else {\n          ${s} source = rc - start;\n          result[${t}] = getChannel(getX(${u.join()}), ${l});\n        }\n      `;
        p += 1 === r ? "} " : "}}", this.userCode = `\n      const ${s} start = ${s}(${i});\n      const ${s} end = ${s}(${a});\n\n      void main() {\n        ${s} outputLoc = getOutputCoords();\n        vec4 result = vec4(0.);\n        ${p}\n        setOutput(result);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class jl {
      constructor(t, e, n, r = !1, s = !1) {
        if (this.variableNames = ["x"], "avg" === e && n) throw new Error("Cannot compute positions for average pool.");
        const i = t.filterWidth,
          a = t.strideHeight,
          o = t.strideWidth,
          u = t.dilationHeight,
          c = t.dilationWidth,
          l = t.effectiveFilterHeight,
          h = t.effectiveFilterWidth,
          d = t.padInfo.top,
          p = t.padInfo.left;
        this.outputShape = t.outShape;
        const f = "avg" === e,
          m = `((batch  * ${t.inHeight} + xR) * ${t.inWidth} + xC) * ${t.inChannels} + d`,
          g = `(xR * ${t.inWidth} + xC) * ${t.inChannels} + d`;
        let b = "0.0";
        if (f || (b = "-1.0 / 1e-20"), n) {
          const e = ">=";
          return void(this.userCode = `\n        const ivec2 strides = ivec2(${a}, ${o});\n        const ivec2 pads = ivec2(${d}, ${p});\n\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int batch = coords[0];\n          int d = coords[3];\n\n          ivec2 xRCCorner = coords.yz * strides - pads;\n          int xRCorner = xRCCorner.x;\n          int xCCorner = xRCCorner.y;\n\n          // max/min x(?, ?, d) to get y(yR, yC, d).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n          float avgValue = 0.0;\n\n          for (int wR = 0; wR < ${l};\n              wR += ${u}) {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= ${t.inHeight}) {\n              continue;\n            }\n\n            for (int wC = 0; wC < ${h};\n                wC += ${c}) {\n              int xC = xCCorner + wC;\n\n              if (xC < 0 || xC >= ${t.inWidth}) {\n                continue;\n              }\n\n              float value = getX(batch, xR, xC, d);\n\n              // If a min / max value has already been found, use it. If not,\n              // use the current value.\n              float currMinMaxValue = mix(\n                  value, minMaxValue, minMaxValueFound);\n              if (value ${e} currMinMaxValue) {\n                minMaxValue = value;\n                minMaxValueFound = 1.0;\n                minMaxPosition = ${r?s?m:g:`wR * ${h} + wC`};\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      `)
        }
        let y = `${e}(${e}(${e}(` + "minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
        "avg" === e && (y = "avgValue / count");
        const w = 4 * Math.floor(i / 4),
          v = i % 4,
          x = `\n      if (${f}) {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    `;
        this.userCode = `\n      const ivec2 strides = ivec2(${a}, ${o});\n      const ivec2 pads = ivec2(${d}, ${p});\n      const float initializationValue = ${b};\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xR, int xC, int d) {\n        if (xC < 0 || xC >= ${t.inWidth}) {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xR, xC, d);\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int batch = coords[0];\n        int d = coords[3];\n\n        ivec2 xRCCorner = coords.yz * strides - pads;\n        int xRCorner = xRCCorner.x;\n        int xCCorner = xRCCorner.y;\n\n        // max/min x(?, ?, d) to get y(yR, yC, d).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(${b});\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wR = 0; wR < ${l};\n            wR += ${u}) {\n          int xR = xRCorner + wR;\n\n          if (xR < 0 || xR >= ${t.inHeight}) {\n            continue;\n          }\n\n          for (int wC = 0; wC < ${w}; wC += 4) {\n            int xC = xCCorner + wC * ${c};\n\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + ${c}, d),\n              getValue(batch, xR, xC + 2 * ${c}, d),\n              getValue(batch, xR, xC + 3 * ${c}, d)\n            );\n\n            ${x}\n          }\n\n          int xC = xCCorner + ${w};\n          if (${1===v}) {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              initializationValue,\n              initializationValue,\n              initializationValue\n            );\n\n            ${x}\n          } else if (${2===v}) {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + ${c}, d),\n              initializationValue,\n              initializationValue\n            );\n\n            ${x}\n          } else if (${3===v}) {\n            vec4 values = vec4(\n              getValue(batch, xR, xC, d),\n              getValue(batch, xR, xC + ${c}, d),\n              getValue(batch, xR, xC + 2 * ${c}, d),\n              initializationValue\n            );\n\n            ${x}\n          }\n        }\n        setOutput(${y});\n      }\n    `
      }
    }
    class Dl {
      constructor(t, e, n, r = !1, s = !1) {
        if (this.variableNames = ["x"], "avg" === e && n) throw new Error("Cannot compute positions for average pool.");
        const i = t.filterWidth,
          a = t.strideDepth,
          o = t.strideHeight,
          u = t.strideWidth,
          c = t.dilationDepth,
          l = t.dilationHeight,
          h = t.dilationWidth,
          d = t.effectiveFilterDepth,
          p = t.effectiveFilterHeight,
          f = t.effectiveFilterWidth,
          m = t.padInfo.front,
          g = t.padInfo.top,
          b = t.padInfo.left;
        this.outputShape = t.outShape;
        const y = "avg" === e;
        let w = "0.0";
        if (y || (w = "-1.0 / 1e-20"), n) {
          const e = ">=";
          return void(this.userCode = `\n        const ivec3 strides =\n            ivec3(${a}, ${o}, ${u});\n        const ivec3 pads = ivec3(${m}, ${g}, ${b});\n\n        void main() {\n          ivec5 coords = getOutputCoords();\n          int batch = coords.x;\n          int ch = coords.u;\n\n          ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n          int xDCorner = xCorner.x;\n          int xRCorner = xCorner.y;\n          int xCCorner = xCorner.z;\n\n          // max/min x(?, ?, ?, ch) to get y(yD, yR, yC, ch).\n          // ? = to be determined\n          float minMaxValue = 0.0;\n          float minMaxValueFound = 0.0;\n          int minMaxPosition = 0;\n\n          for (int wD = 0; wD < ${d};\n              wD += ${c}) {\n            int xD = xDCorner + wD;\n\n            if (xD < 0 || xD >= ${t.inDepth}) {\n              continue;\n            }\n\n            for (int wR = 0; wR < ${p};\n                wR += ${l}) {\n              int xR = xRCorner + wR;\n\n              if (xR < 0 || xR >= ${t.inHeight}) {\n                continue;\n              }\n\n              for (int wC = 0; wC < ${f};\n                  wC += ${h}) {\n                int xC = xCCorner + wC;\n\n                if (xC < 0 || xC >= ${t.inWidth}) {\n                  continue;\n                }\n\n                float value = getX(batch, xD, xR, xC, ch);\n\n                // If a min / max value has already been found, use it. If not,\n                // use the current value.\n                float currMinMaxValue = mix(\n                    value, minMaxValue, minMaxValueFound);\n                if (value ${e} currMinMaxValue) {\n                  minMaxValue = value;\n                  minMaxValueFound = 1.0;\n                  minMaxPosition = ${r?s?`(((batch * ${t.inDepth} + xD) * ${t.inHeight} + xR) * ${t.inWidth} + xC) * ${t.inChannels} + ch`:`((xD * ${t.inHeight} + xR) * ${t.inWidth} + xC) * ${t.inChannels} + ch`:`wD * ${p} * ${f} +\n                      wR * ${f} + wC`};\n                }\n              }\n            }\n          }\n          setOutput(float(minMaxPosition));\n        }\n      `)
        }
        let v = `${e}(${e}(${e}(` + "minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
        "avg" === e && (v = "avgValue / count");
        const x = 4 * Math.floor(i / 4),
          O = i % 4,
          S = `\n      if (${y}) {\n        avgValue += dot(values, ones);\n      } else {\n        minMaxValue = max(values, minMaxValue);\n      }\n    `;
        this.userCode = `\n      const ivec3 strides =\n        ivec3(${a}, ${o}, ${u});\n      const ivec3 pads = ivec3(${m}, ${g}, ${b});\n      const float initializationValue = ${w};\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float count = 0.0;\n\n      float getValue(int batch, int xD, int xR, int xC, int ch) {\n        if (xC < 0 || xC >= ${t.inWidth}) {\n          return initializationValue;\n        }\n        count += 1.0;\n        return getX(batch, xD, xR, xC, ch);\n      }\n\n      void main() {\n        ivec5 coords = getOutputCoords();\n        int batch = coords.x;\n        int ch = coords.u;\n\n        ivec3 xCorner = ivec3(coords.y, coords.z, coords.w) * strides - pads;\n        int xDCorner = xCorner.x;\n        int xRCorner = xCorner.y;\n        int xCCorner = xCorner.z;\n\n        // max/min x(?, ?, ?, d) to get y(yD, yR, yC, ch).\n        // ? = to be determined\n        vec4 minMaxValue = vec4(${w});\n        float avgValue = 0.0;\n        count = 0.0;\n\n        for (int wD = 0; wD < ${d};\n            wD += ${c}) {\n          int xD = xDCorner + wD;\n\n          if (xD < 0 || xD >= ${t.inDepth}) {\n            continue;\n          }\n\n          for (int wR = 0; wR < ${p};\n            wR += ${l}) {\n            int xR = xRCorner + wR;\n\n            if (xR < 0 || xR >= ${t.inHeight}) {\n              continue;\n            }\n\n            for (int wC = 0; wC < ${x}; wC += 4) {\n              int xC = xCCorner + wC * ${h};\n\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + ${h}, ch),\n                getValue(batch, xD, xR, xC + 2 * ${h}, ch),\n                getValue(batch, xD, xR, xC + 3 * ${h}, ch)\n              );\n\n              ${S}\n            }\n\n            int xC = xCCorner + ${x};\n            if (${1===O}) {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                initializationValue,\n                initializationValue,\n                initializationValue\n              );\n\n              ${S}\n            } else if (${2===O}) {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + ${h}, ch),\n                initializationValue,\n                initializationValue\n              );\n\n              ${S}\n            } else if (${3===O}) {\n              vec4 values = vec4(\n                getValue(batch, xD, xR, xC, ch),\n                getValue(batch, xD, xR, xC + ${h}, ch),\n                getValue(batch, xD, xR, xC + 2 * ${h}, ch),\n                initializationValue\n              );\n\n              ${S}\n            }\n          }\n          setOutput(${v});\n        }\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Fl {
      constructor(t, e) {
        this.variableNames = ["x"];
        const n = t.windowSize,
          r = t.batchSize,
          s = t.inSize,
          i = Math.ceil(s / n);
        this.outputShape = [r, i];
        let a = "0.0",
          o = "";
        "prod" === e ? a = "1.0" : "min" === e ? (a = "1.0 / 1e-20", o = "min") : "max" === e && (a = "-1.0 / 1e-20", o = "max");
        let u = `${e}(${e}(${e}(` + "minMaxValue[0], minMaxValue[1]), minMaxValue[2]), minMaxValue[3])";
        "sum" === e ? u = "sumValue" : "prod" === e ? u = "prodValue" : "all" === e ? u = "allValue" : "any" === e && (u = "anyValue");
        const c = 4 * Math.floor(n / 4),
          l = n % 4;
        let h = `\n      if (${"sum"===e}) {\n        sumValue += dot(values, ones);\n      } else if (${"prod"===e}) {\n        vec2 tmp = vec2(values[0], values[1]) * vec2(values[2], values[3]);\n        prodValue *= tmp[0] * tmp[1];\n      } else {\n        minMaxValue = ${o}(values, minMaxValue);\n      }\n    `,
          d = "vec4";
        "all" === e ? (a = "1.0", h = "\n        bool reducedAllValue = all(values);\n        float floatedReducedAllValue = float(reducedAllValue);\n        allValue = float(allValue >= 1.0 && floatedReducedAllValue >= 1.0);\n      ", d = "bvec4") : "any" === e && (a = "0.0", h = "\n        bool reducedAnyValue = any(values);\n        float floatedReducedAnyValue = float(reducedAnyValue);\n        anyValue = float(anyValue >= 1.0 || floatedReducedAnyValue >= 1.0);\n      ", d = "bvec4");
        let p = "";
        s % n > 0 && (p = `\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return initializationValue;\n        }\n      `), this.userCode = `\n      const float initializationValue = ${a};\n      const vec4 ones = vec4(1.0, 1.0, 1.0, 1.0);\n\n      float getValue(int batch, int inIdx) {\n        ${p}\n        return getX(batch, inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = outIdx * ${n};\n\n        vec4 minMaxValue = vec4(${a});\n        float prodValue = 1.0;\n        float sumValue = 0.0;\n        float allValue = 1.0;\n        float anyValue = 0.0;\n\n        for (int i = 0; i < ${c}; i += 4) {\n          int inIdx = inOffset + i;\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          ${h}\n        }\n\n        int inIdx = inOffset + ${c};\n        if (${1===l}) {\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          ${h}\n        } else if (${2===l}) {\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          ${h}\n        } else if (${3===l}) {\n          ${d} values = ${d}(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          ${h}\n        }\n        setOutput(${u});\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ml {
      constructor(t, e) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t;
        let n = "";
        for (let t = 0; t < 4; t++) {
          let e = "thisRC = rc;";
          t % 2 == 1 && (e += "thisRC.z += 1;"), t > 1 && (e += "thisRC.y += 1;"), n += `\n        ${e}\n        ${t>0?"if(thisRC.y < rows && thisRC.z < cols){":""}\n          int flatIndex = getFlatIndex(thisRC);\n\n          ivec3 inputRC = inputCoordsFromReshapedOutCoords(flatIndex);\n          vec2 inputRCInnerDims = vec2(float(inputRC.y),float(inputRC.z));\n\n          result[${t}] =\n            getChannel(getA(inputRC.x, inputRC.y, inputRC.z), inputRCInnerDims);\n        ${t>0?"}":""}\n      `
        }
        var r;
        /**
         * @license
         * Copyright 2018 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        this.userCode = `\n      ${r=e,`\n    ivec3 inputCoordsFromReshapedOutCoords(int index) {\n      ${vu(["r","c","d"],r)}\n      return ivec3(r, c, d);\n    }\n  `}\n      ${xu(t)}\n\n      void main() {\n        ivec3 rc = getOutputCoords();\n\n        vec4 result = vec4(0.);\n\n        ivec3 thisRC;\n        int rows = ${t[1]};\n        int cols = ${t[2]};\n\n        ${n}\n\n        setOutput(result);\n      }\n    `
      }
    }
    class zl {
      constructor(t, e, n) {
        this.variableNames = ["dy"], this.outputShape = [], this.outputShape = e.shape;
        const [, r, s] = e.shape, [, i, a] = t.shape, o = [n && i > 1 ? r - 1 : r, n && a > 1 ? s - 1 : s], u = [n && i > 1 ? i - 1 : i, n && a > 1 ? a - 1 : a], c = o[0] / u[0], l = o[1] / u[1], h = 1 / c, d = 1 / l, p = 2 * Math.ceil(h) + 2, f = 2 * Math.ceil(d) + 2;
        this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(${c});\n        const float widthScale = float(${l});\n\n        const float invHeightScale = float(${h});\n        const float invWidthScale = float(${d});\n\n        const int winHeight = int(${p});\n        const int winWidth = int(${f});\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(startRLerp - float(winHeight / 2));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(startCLerp - float(winWidth / 2));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= ${i}) {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= ${a}) {\n              continue;\n            }\n\n            float dxR = float(dyR) * heightScale;\n            int topDxRIndex = int(floor(dxR));\n            int bottomDxRIndex = int(min(ceil(dxR), ${r-1}.0));\n            float dxRLerp = dxR - float(topDxRIndex);\n            float inverseDxRLerp = 1.0 - dxRLerp;\n\n            float dxC = float(dyC) * widthScale;\n            int leftDxCIndex = int(floor(dxC));\n            int rightDxCIndex = int(min(ceil(dxC), ${s-1}.0));\n            float dxCLerp = dxC - float(leftDxCIndex);\n            float inverseDxCLerp = 1.0 - dxCLerp;\n\n            if (r == topDxRIndex && c == leftDxCIndex) {\n              // topLeft\n              accumulator +=\n                getDy(b, dyR, dyC, d) * inverseDxRLerp * inverseDxCLerp;\n            }\n\n            if (r == topDxRIndex && c == rightDxCIndex) {\n              // topRight\n              accumulator += getDy(b, dyR, dyC, d) * inverseDxRLerp * dxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == leftDxCIndex) {\n              // bottomLeft\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * inverseDxCLerp;\n            }\n\n            if (r == bottomDxRIndex && c == rightDxCIndex) {\n              // bottomRight\n              accumulator += getDy(b, dyR, dyC, d) * dxRLerp * dxCLerp;\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ll {
      constructor(t, e, n, r) {
        this.variableNames = ["A"], this.outputShape = [];
        const [s, i, a, o] = t;
        this.outputShape = [s, e, n, o];
        const u = [r && e > 1 ? i - 1 : i, r && n > 1 ? a - 1 : a],
          c = [r && e > 1 ? e - 1 : e, r && n > 1 ? n - 1 : n];
        this.userCode = `\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          ${u[0]/c[0]},\n          ${u[1]/c[1]});\n      const vec2 inputShapeRC = vec2(${i}.0, ${a}.0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec2 sourceFloorRC = ivec2(sourceFracIndexRC);\n        ivec2 sourceCeilRC = ivec2(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        float topLeft = getA(b, sourceFloorRC.x, sourceFloorRC.y, d);\n        float bottomLeft = getA(b, sourceCeilRC.x, sourceFloorRC.y, d);\n        float topRight = getA(b, sourceFloorRC.x, sourceCeilRC.y, d);\n        float bottomRight = getA(b, sourceCeilRC.x, sourceCeilRC.y, d);\n\n        vec2 fracRC = sourceFracIndexRC - vec2(sourceFloorRC);\n\n        float top = topLeft + (topRight - topLeft) * fracRC.y;\n        float bottom = bottomLeft + (bottomRight - bottomLeft) * fracRC.y;\n        float newValue = top + (bottom - top) * fracRC.x;\n\n        setOutput(newValue);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Bl {
      constructor(t, e, n, r) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = [];
        const [s, i, a, o] = t;
        this.outputShape = [s, e, n, o];
        const u = [r && e > 1 ? i - 1 : i, r && n > 1 ? a - 1 : a],
          c = [r && e > 1 ? e - 1 : e, r && n > 1 ? n - 1 : n];
        this.userCode = `\n      const vec3 effectiveInputOverOutputRatioRC = vec3(\n          ${u[0]/c[0]},\n          ${u[1]/c[1]},\n          ${u[1]/c[1]});\n      const vec3 inputShapeRC = vec3(${i}.0, ${a}.0,\n                                     ${a}.0);\n\n      float getAValue(int b, int r, int c, int d) {\n        return getChannel(getA(b, r, c, d), vec2(c, d));\n      }\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        // Calculate values for next column in yRC.z.\n        ivec3 yRC = coords.yzz + ivec3(0, 0, 1);\n\n        // Fractional source index.\n        vec3 sourceFracIndexRC = vec3(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the four integer indices.\n        ivec3 sourceFloorRC = ivec3(sourceFracIndexRC);\n        ivec3 sourceCeilRC = ivec3(\n          min(inputShapeRC - 1.0, ceil(sourceFracIndexRC)));\n\n        // Should we calculate next column and row elements in 2x2 packed cell.\n        bool hasNextCol = d < ${o-1};\n        bool hasNextRow = coords.z < ${n-1};\n\n        // In parallel, construct four corners for all four components in\n        // packed 2x2 cell.\n        vec4 topLeft = vec4(\n          getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 bottomLeft = vec4(\n          getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceFloorRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceFloorRC.z, d + 1) : 0.0);\n\n        vec4 topRight = vec4(\n          getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceFloorRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceFloorRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec4 bottomRight = vec4(\n          getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d),\n          hasNextCol ? getAValue(b, sourceCeilRC.x, sourceCeilRC.y, d + 1)\n                     : 0.0,\n          hasNextRow ? getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d)\n                     : 0.0,\n          (hasNextRow && hasNextCol) ?\n            getAValue(b, sourceCeilRC.x, sourceCeilRC.z, d + 1) : 0.0);\n\n        vec3 fracRC = sourceFracIndexRC - vec3(sourceFloorRC);\n\n        vec4 top = mix(topLeft, topRight, fracRC.yyzz);\n        vec4 bottom = mix(bottomLeft, bottomRight, fracRC.yyzz);\n        vec4 newValue = mix(top, bottom, fracRC.x);\n\n        setOutput(newValue);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Pl {
      constructor(t, e, n) {
        this.variableNames = ["dy"], this.outputShape = [], this.outputShape = e.shape;
        const [, r, s] = e.shape, [, i, a] = t.shape, o = [n && i > 1 ? r - 1 : r, n && a > 1 ? s - 1 : s], u = [n && i > 1 ? i - 1 : i, n && a > 1 ? a - 1 : a], c = o[0] / u[0], l = o[1] / u[1], h = 1 / c, d = 1 / l, p = 2 * Math.ceil(h) + 2, f = 2 * Math.ceil(d) + 2;
        this.userCode = `\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        int r = coords[1];\n        int c = coords[2];\n\n        float accumulator = 0.0;\n\n        const float heightScale = float(${c});\n        const float widthScale = float(${l});\n\n        const float invHeightScale = float(${h});\n        const float invWidthScale = float(${d});\n\n        const int winHeight = int(${p});\n        const int winWidth = int(${f});\n\n        // Compute bounds for where in dy we will look\n        float startRLerp = floor(float(r) * invHeightScale);\n        int startDyR = int(floor(startRLerp - float(winHeight / 2)));\n\n        float startCLerp = floor(float(c) * invWidthScale);\n        int startDyC = int(floor(startCLerp - float(winWidth / 2)));\n\n        // Loop over dy\n        for (int dyROffset = 0; dyROffset < winHeight; dyROffset++) {\n          int dyR = dyROffset + startDyR;\n\n          // Guard against the window exceeding the bounds of dy\n          if (dyR < 0 || dyR >= ${i}) {\n            continue;\n          }\n\n          for (int dyCOffset = 0; dyCOffset < winWidth; dyCOffset++) {\n            int dyC = dyCOffset + startDyC;\n\n            // Guard against the window exceeding the bounds of dy\n            if (dyC < 0 || dyC >= ${a}) {\n              continue;\n            }\n\n            float sourceFracRow =\n              float(${o[0]}) *\n                (float(dyR) / float(${u[0]}));\n\n            float sourceFracCol =\n                float(${o[1]}) *\n                  (float(dyC) / float(${u[1]}));\n\n            int sourceNearestRow = int(min(\n                float(int(${r}) - 1),\n                ${n} ? float(round(sourceFracRow)) :\n                                  float(floor(sourceFracRow))));\n\n            int sourceNearestCol = int(min(\n                float(int(${s}) - 1),\n                ${n} ? float(round(sourceFracCol)) :\n                                  float(floor(sourceFracCol))));\n\n            if (r == sourceNearestRow && c == sourceNearestCol) {\n              accumulator += getDy(b, dyR, dyC, d);\n            }\n          }\n        }\n        // End loop over dy\n\n        setOutput(accumulator);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Wl {
      constructor(t, e, n, r) {
        this.variableNames = ["A"], this.outputShape = [];
        const [s, i, a, o] = t;
        this.outputShape = [s, e, n, o];
        const u = [r && e > 1 ? i - 1 : i, r && n > 1 ? a - 1 : a],
          c = [r && e > 1 ? e - 1 : e, r && n > 1 ? n - 1 : n],
          l = r ? "0.5" : "0.0";
        this.userCode = `\n      const vec2 effectiveInputOverOutputRatioRC = vec2(\n          ${u[0]/c[0]},\n          ${u[1]/c[1]});\n      const vec2 inputShapeRC = vec2(${i}.0, ${a}.0);\n\n      void main() {\n        ivec4 coords = getOutputCoords();\n        int b = coords[0];\n        int d = coords[3];\n        ivec2 yRC = coords.yz;\n\n        // Fractional source index.\n        vec2 sourceFracIndexRC = vec2(yRC) * effectiveInputOverOutputRatioRC;\n\n        // Compute the coordinators of nearest neighbor point.\n        ivec2 sourceNearestRC = ivec2(\n          min(inputShapeRC - 1.0, floor(sourceFracIndexRC + ${l})));\n\n        float newValue = getA(b, sourceNearestRC.x, sourceNearestRC.y, d);\n\n        setOutput(newValue);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ul {
      constructor(t, e) {
        this.variableNames = ["x"];
        const n = t.length;
        if (n > 4) throw new Error(`WebGL backend: Reverse of rank-${n} tensor is not yet supported`);
        if (this.outputShape = t, 1 === n) return void(this.userCode = `\n        void main() {\n          int coord = getOutputCoords();\n          setOutput(getX(${t[0]} - coord - 1));\n        }\n      `);
        const r = t.map((n, r) => (n => -1 !== e.indexOf(n) && 1 !== t[n] ? `${t[n]} - coords[${n}] - 1` : `coords[${n}]`)(r)).join(","),
          s = ju(n);
        this.userCode = `\n      void main() {\n        ${s} coords = getOutputCoords();\n        setOutput(getX(${r}));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Vl {
      constructor(t, e) {
        this.variableNames = ["x"], this.packedInputs = !0, this.packedOutput = !0;
        const n = t.length;
        if (n > 4) throw new Error(`WebGL backend: Reverse of rank-${n} tensor is not yet supported`);
        this.outputShape = t;
        const r = yu("rc", n),
          s = `${r[n-1]} + 1 < ${this.outputShape[n-1]}`,
          i = `${r[n-2]} + 1 < ${this.outputShape[n-2]}`,
          a = ju(n);

        function o(n) {
          const r = t.map((r, s) => (function (n, r) {
            return -1 !== e.indexOf(n) && 1 !== t[n] ? `${t[n]} - ${r[n]} - 1` : `${r[n]}`
          })(s, n));
          return `getChannel(getX(${r.join(",")}), vec2(${r.slice(-2).join(",")}))`
        }
        this.userCode = 1 === n ? `\n        void main(){\n          int rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = getChannel(getX(${t[0]} - rc - 1),\n            ${t[0]} - rc - 1);\n          if(${s}){\n              result.g = getChannel(getX(${t[0]} - (rc  + 1) - 1),\n                ${t[0]} - (rc  + 1) - 1);\n          }\n          setOutput(result);\n        }\n      ` : `\n        void main() {\n          ${a} rc = getOutputCoords();\n          vec4 result = vec4(0.);\n          result.r = ${function(t){return o(t)}(r.slice())};\n          if(${s}){\n            result.g = ${function(t){return t[n-1]="("+t[n-1]+" + 1)",o(t)}(r.slice())};\n          }\n          if(${i}) {\n            result.b = ${function(t){return t[n-2]="("+t[n-2]+" + 1)",o(t)}(r.slice())};\n            if(${s}) {\n              result.a = ${function(t){return t[n-1]="("+t[n-1]+" + 1)",t[n-2]="("+t[n-2]+" + 1)",o(t)}(r.slice())};\n            }\n          }\n          setOutput(result);\n        }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Hl {
      constructor(t, e, n, r, s, i, a = !0) {
        this.variableNames = ["updates", "indices", "defaultValue"], this.outputShape = i;
        const o = ju(s.length),
          u = ju(i.length);
        let c = "";
        1 === n ? c = "i" : 2 === n && (c = "i, j");
        const l = `getIndices(${c})`;
        let h = "";
        1 === r ? h = "i" : 2 === r && (h = "i, coords[1]");
        const d = `getUpdates(${h})`,
          p = e > 1 ? "strides[j]" : "strides";
        this.userCode = `\n        ${o} strides = ${o}(${s});\n\n        void main() {\n          ${u} coords = getOutputCoords();\n          float sum = 0.0;\n          bool found = false;\n          for (int i = 0; i < ${t}; i++) {\n            int flattenedIndex = 0;\n            for (int j = 0; j < ${e}; j++) {\n              int index = round(${l});\n              flattenedIndex += index * ${p};\n            }\n            if (flattenedIndex == coords[0]) {\n              sum += ${d};\n              found = true;\n            }\n          }\n          setOutput(mix(getDefaultValue(), sum, float(found)));\n        }\n      `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Gl {
      constructor(t, e) {
        this.variableNames = ["x", "segmentIds"];
        const n = t.windowSize,
          r = t.batchSize,
          s = t.inSize,
          i = t.numSegments,
          a = i * Math.ceil(s / n);
        this.outputShape = [r, a];
        const o = 4 * Math.floor(n / 4),
          u = n % 4,
          c = "\n        sumValue += dot(values, segFilter);\n    ";
        let l = "";
        s % n > 0 && (l = `\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return initializationValue;\n        }\n      `);
        let h = "";
        s % n > 0 && (h = `\n        if (inIdx < 0 || inIdx >= ${s}) {\n          return -1.0;\n        }\n      `), this.userCode = `\n      const float initializationValue = 0.0;\n\n      float getValue(int batch, int inIdx) {\n        ${l}\n        return getX(batch, inIdx);\n      }\n\n      float getSegmentIdAtIndex(int inIdx) {\n        ${h}\n        return getSegmentIds(inIdx);\n      }\n\n      void main() {\n        ivec2 coords = getOutputCoords();\n        int batch = coords[0];\n        int outIdx = coords[1];\n        int inOffset = int(floor(float(outIdx) / float(\n          ${i})) * float(${n}));\n        int currentSeg = int(mod(float(outIdx), float(${i})));\n\n        float sumValue = 0.0;\n\n        for (int i = 0; i < ${o}; i += 4) {\n          int inIdx = inOffset + i;\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            getValue(batch, inIdx + 3)\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 3)) == currentSeg ? 1 : 0\n          );\n\n          ${c}\n        }\n\n        int inIdx = inOffset + ${o};\n        if (${1===u}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            initializationValue,\n            initializationValue,\n            initializationValue\n          );\n\n          int inIdxSeg = int(getSegmentIdAtIndex(inIdx));\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            0,\n            0,\n            0\n          );\n\n          ${c}\n        } else if (${2===u}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            initializationValue,\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n              0,\n              0\n          );\n\n          ${c}\n        } else if (${3===u}) {\n          vec4 values = vec4(\n            getValue(batch, inIdx),\n            getValue(batch, inIdx + 1),\n            getValue(batch, inIdx + 2),\n            initializationValue\n          );\n\n          vec4 segFilter = vec4(\n            int(getSegmentIdAtIndex(inIdx)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 1)) == currentSeg ? 1 : 0,\n            int(getSegmentIdAtIndex(inIdx + 2)) == currentSeg ? 1 : 0,\n            0\n          );\n\n          ${c}\n        }\n        setOutput(sumValue);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class ql {
      constructor(t, e, n) {
        let r, s;
        if (this.variableNames = ["c", "a", "b"], this.outputShape = e, n > 4) throw Error(`Where for rank ${n} is not yet supported`);
        if (1 === n) s = "resRC", r = "resRC";
        else {
          const n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w"],
            i = [],
            a = [];
          for (let r = 0; r < e.length; r++) a.push(`${n[r]}`), r < t && i.push(`${n[r]}`);
          r = i.join(), s = a.join()
        }
        const i = ju(n);
        this.userCode = `\n      void main() {\n        ${i} resRC = getOutputCoords();\n        float cVal = getC(${r});\n        if (cVal >= 1.0) {\n          setOutput(getA(${s}));\n        } else {\n          setOutput(getB(${s}));\n        }\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Kl {
      constructor(t) {
        this.variableNames = ["source"], this.outputShape = t, this.rank = t.length;
        const e = ju(this.rank),
          n = `uniform int start[${this.rank}];`,
          r = function (t) {
            if (1 === t) return "sourceLoc";
            if (t <= 6) return Jl.slice(0, t).map(t => "sourceLoc." + t).join(",");
            throw Error(`Slicing for rank ${t} is not yet supported`)
          }
        /**
         * @license
         * Copyright 2019 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        (this.rank);
        let s;
        s = `\n        ${e} sourceLoc;\n        ${e} coords = getOutputCoords();\n        ${t.map((t,e)=>`sourceLoc.${Jl[e]} = start[${e}] + coords.${Jl[e]};`).join("\n")}\n      `, this.userCode = `\n      ${n}\n      void main() {\n        ${s}\n        setOutput(getSource(${r}));\n      }\n    `
      }
      getCustomSetupFunc(t) {
        if (t.length !== this.rank) throw Error(`The rank (${this.rank}) of the program must match the ` + `length of start (${t.length})`);
        return (e, n) => {
          null == this.startLoc && (this.startLoc = e.getUniformLocationNoThrow(n, "start"), null == this.startLoc) || e.gl.uniform1iv(this.startLoc, t)
        }
      }
    }
    const Jl = ["x", "y", "z", "w", "u", "v"];
    class Xl {
      constructor(t) {
        this.variableNames = ["source"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.rank = t.length;
        const e = ju(this.rank),
          n = yu("coords", this.rank),
          r = yu("sourceLoc", this.rank),
          s = 1 === this.rank ? "sourceLoc" : `vec2(${r.slice(-2).join()})`,
          i = `getChannel(getSource(${r.join()}), ${s})`,
          a = `\n      result.x = ${i};\n      if (++${n[this.rank-1]} < ${t[this.rank-1]}) {\n        ++${r[this.rank-1]};\n        result.y = ${i};\n        --${r[this.rank-1]};\n      }\n    `,
          o = 1 === this.rank ? "" : `\n      --${n[this.rank-1]};\n      if (++${n[this.rank-2]} < ${t[this.rank-2]}) {\n        ++${r[this.rank-2]};\n        result.z = ${i};\n        if (++${n[this.rank-1]} < ${t[this.rank-1]}) {\n          ++${r[this.rank-1]};\n          result.w = ${i};\n        }\n      }\n    `,
          u = this.rank <= 4 ? `sourceLoc = coords +\n            ${e}(${t.map((t,e)=>`start[${e}]`).join()});` : t.map((t, e) => `${r[e]} = ${n[e]} + start[${e}];`).join("\n");
        this.userCode = `\n      uniform int start[${this.rank}];\n      void main() {\n        ${e} coords = getOutputCoords();\n        ${e} sourceLoc;\n        ${u}\n        vec4 result = vec4(0.);\n        ${a}\n        ${o}\n        setOutput(result);\n      }\n    `
      }
      getCustomSetupFunc(t) {
        if (t.length !== this.rank) throw Error(`The rank (${this.rank}) of the program must match the ` + `length of start (${t.length})`);
        return (e, n) => {
          null == this.startLoc && (this.startLoc = e.getUniformLocationNoThrow(n, "start"), null == this.startLoc) || e.gl.uniform1iv(this.startLoc, t)
        }
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Yl {
      constructor(t, e, n) {
        this.variableNames = ["x"], this.outputShape = n;
        const r = n.length,
          s = ju(n.length),
          i = ju(n.length);
        let a = "";
        if (1 === r) a = "coords * strides + begin";
        else {
          let t = 0;
          a = n.map((e, r) => (t++, 1 === n.length ? `coords * strides[${r}] + begin[${r}]` : `coords[${t-1}] * strides[${r}] + begin[${r}]`)).join(",")
        }
        this.userCode = `\n      ${s} begin = ${s}(${t});\n      ${s} strides = ${s}(${e});\n\n      void main() {\n        ${i} coords = getOutputCoords();\n        setOutput(getX(${a}));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Zl {
      constructor(t) {
        this.gpgpu = t, this.numUsedTextures = 0, this.numFreeTextures = 0, this._numBytesAllocated = 0, this._numBytesFree = 0, this.freeTextures = {}, this.logEnabled = !1, this.usedTextures = {}
      }
      acquireTexture(t, e, n) {
        const r = th(e, n),
          s = eh(t, r, n);
        s in this.freeTextures || (this.freeTextures[s] = []), s in this.usedTextures || (this.usedTextures[s] = []);
        const i = Ql(t, r, this.gpgpu.gl, this.gpgpu.textureConfig, n);
        if (this.freeTextures[s].length > 0) {
          this.numFreeTextures--, this.numUsedTextures++, this._numBytesFree -= i, this.log();
          const t = this.freeTextures[s].shift();
          return this.usedTextures[s].push(t), t
        }
        let a;
        return r === Fo.PACKED_2X2_FLOAT32 ? a = this.gpgpu.createPackedMatrixTexture(t[0], t[1]) : r === Fo.PACKED_2X2_FLOAT16 ? a = this.gpgpu.createFloat16PackedMatrixTexture(t[0], t[1]) : r === Fo.UNPACKED_FLOAT32 ? a = this.gpgpu.createFloat32MatrixTexture(t[0], t[1]) : r === Fo.UNPACKED_FLOAT16 ? a = this.gpgpu.createFloat16MatrixTexture(t[0], t[1]) : r === Fo.PACKED_4X1_UNSIGNED_BYTE && (a = this.gpgpu.createUnsignedBytesMatrixTexture(t[0], t[1])), this.usedTextures[s].push(a), this.numUsedTextures++, this._numBytesAllocated += i, this.log(), a
      }
      releaseTexture(t, e, n, r) {
        if (null == this.freeTextures) return;
        const s = th(n, r),
          i = eh(e, s, r);
        i in this.freeTextures || (this.freeTextures[i] = []);
        const a = Ql(e, s, this.gpgpu.gl, this.gpgpu.textureConfig, r),
          o = Object(Ft.vb)().get("WEBGL_DELETE_TEXTURE_THRESHOLD"); - 1 !== o && this._numBytesAllocated > o ? (this.gpgpu.deleteMatrixTexture(t), this._numBytesAllocated -= a) : (this.freeTextures[i].push(t), this.numFreeTextures++, this._numBytesFree += a), this.numUsedTextures--;
        const u = this.usedTextures[i],
          c = u.indexOf(t);
        if (c < 0) throw new Error("Cannot release a texture that was never provided by this texture manager");
        u.splice(c, 1), this.log()
      }
      log() {
        if (!this.logEnabled) return;
        const t = this.numFreeTextures + this.numUsedTextures;
        console.log("Free/Used", `${this.numFreeTextures} / ${this.numUsedTextures}`, `(${t})`);
        const e = this._numBytesFree / this._numBytesAllocated;
        console.log(`Bytes allocated: ${this._numBytesAllocated}`), console.log(`Bytes unused: ${this._numBytesFree} (${Math.round(100*e)}%)`)
      }
      get numBytesAllocated() {
        return this._numBytesAllocated
      }
      get numBytesFree() {
        return this._numBytesFree
      }
      getNumUsedTextures() {
        return this.numUsedTextures
      }
      getNumFreeTextures() {
        return this.numFreeTextures
      }
      dispose() {
        if (null != this.freeTextures) {
          for (const t in this.freeTextures) this.freeTextures[t].forEach(t => {
            this.gpgpu.deleteMatrixTexture(t)
          });
          for (const t in this.usedTextures) this.usedTextures[t].forEach(t => {
            this.gpgpu.deleteMatrixTexture(t)
          });
          this.freeTextures = null, this.usedTextures = null, this.numUsedTextures = 0, this.numFreeTextures = 0, this._numBytesAllocated = 0, this._numBytesFree = 0
        }
      }
    }

    function Ql(t, e, n, r, s) {
      const i = function (t, e) {
        switch (t) {
          case Fo.PACKED_2X2_FLOAT32:
            return bl(e);
          case Fo.PACKED_2X2_FLOAT16:
            return yl(e);
          case Fo.UNPACKED_FLOAT32:
            return fl(e);
          case Fo.UNPACKED_FLOAT16:
            return ml(e);
          case Fo.PACKED_4X1_UNSIGNED_BYTE:
            return gl(e);
          default:
            throw new Error(`Unknown physical texture type ${t}`)
        }
      }(e, r);
      let a;
      if (s) {
        const [e, n] = Lo(t[0], t[1]);
        a = e * n
      } else {
        const [e, n] = Mo(t[0], t[1]);
        a = e * n
      }
      return a * function (t, e) {
        const n = t;
        if (e === n.R32F) return 4;
        if (e === n.R16F) return 2;
        if (e === n.RGBA32F) return 16;
        if (e === t.RGBA) return 16;
        if (e === n.RGBA16F) return 8;
        throw new Error(`Unknown internal format ${e}`)
      }(n, i)
    }

    function th(t, e) {
      if (t === Do.UPLOAD) return Fo.PACKED_2X2_FLOAT32;
      if (t === Do.RENDER || null == t) return function (t) {
        return Object(Ft.vb)().getBool("WEBGL_RENDER_FLOAT32_ENABLED") ? t ? Fo.PACKED_2X2_FLOAT32 : Fo.UNPACKED_FLOAT32 : t ? Fo.PACKED_2X2_FLOAT16 : Fo.UNPACKED_FLOAT16
      }(e);
      if (t === Do.DOWNLOAD || t === Do.PIXELS) return Fo.PACKED_4X1_UNSIGNED_BYTE;
      throw new Error(`Unknown logical texture type ${t}`)
    }

    function eh(t, e, n) {
      return `${t[0]}_${t[1]}_${e}_${n}`
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class nh {
      constructor(t, e) {
        this.variableNames = ["A"];
        const n = new Array(t.length);
        for (let r = 0; r < n.length; r++) n[r] = t[r] * e[r];
        this.outputShape = n, this.rank = n.length;
        const r = ju(this.rank),
          s = function (t) {
            const e = t.length;
            if (e > 5) throw Error(`Tile for rank ${e} is not yet supported`);
            if (1 === e) return `imod(resRC, ${t[0]})`;
            const n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u"],
              r = [];
            for (let e = 0; e < t.length; e++) r.push(`imod(${n[e]}, ${t[e]})`);
            return r.join()
          }
        /**
         * @license
         * Copyright 2017 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        (t);
        this.userCode = `\n      void main() {\n        ${r} resRC = getOutputCoords();\n        setOutput(getA(${s}));\n      }\n    `
      }
    }
    class rh {
      constructor(t, e) {
        this.variableNames = ["A"], this.outputShape = t, this.userCode = `\n      float unaryOperation(float x) {\n        ${e}\n      }\n\n      void main() {\n        float x = getAAtOutCoords();\n        float y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    `
      }
    }
    const sh = "if (isnan(x)) return x;",
      ih = "return x;",
      ah = "return abs(x);",
      oh = sh + "\n  return (x < 0.0) ? 0.0 : x;\n",
      uh = sh + "\n  return (x < 0.0) ? 0.0 : min(6.0, x);\n",
      ch = "return (x >= 0.0) ? x : (exp(x) - 1.0);",
      lh = `\n  // Stable and Attracting Fixed Point (0, 1) for Normalized Weights.\n  // see: https://arxiv.org/abs/1706.02515\n  float scaleAlpha = ${Ft.L.SELU_SCALEALPHA};\n  float scale = ${Ft.L.SELU_SCALE};\n  return (x >= 0.0) ? scale * x : scaleAlpha * (exp(x) - 1.0);\n`;
    const hh = "return -x;",
      dh = "return ceil(x);",
      ph = "return floor(x);",
      fh = "\n  if (isnan(x)) { return 0.0; }\n  return sign(x);\n",
      mh = "return float(isnan(x));",
      gh = "return float(isinf(x));",
      bh = "return float(!isnan(x) && !isinf(x));",
      yh = "\n  // OpenGL ES does not support round function.\n  // The algorithm is based on banker's rounding.\n  float base = floor(x);\n  if ((x - base) < 0.5) {\n    return floor(x);\n  } else if ((x - base) > 0.5) {\n    return ceil(x);\n  } else {\n    if (mod(base, 2.0) == 0.0) {\n      return base;\n    } else {\n      return base + 1.0;\n    }\n  }\n",
      wh = "return exp(x);",
      vh = "return exp(x) - 1.0;",
      xh = "if (x < 0.0) return NAN;\n  return log(x);",
      Oh = "return log(1.0 + x);",
      Sh = "return sqrt(x);",
      _h = "return inversesqrt(x);",
      kh = "return 1.0 / (1.0 + exp(-1.0 * x));",
      Ch = "\n  float epsilon = 1.1920928955078125e-7;\n  float threshold = log(epsilon) + 2.0;\n\n  bool too_large = x > -threshold;\n  bool too_small = x < threshold;\n\n  float result;\n  float exp_x = exp(x);\n\n  if (too_large){\n    result = x;\n  }\n  else if (too_small){\n    result = exp_x;\n  }\n  else{\n    result = log(exp_x + 1.0);\n  }\n  return result;\n",
      Eh = sh + "\n  return sin(x);\n",
      Ih = sh + "\n  return cos(x);\n",
      Th = "return tan(x);",
      Ah = sh + "\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return asin(x);\n",
      Nh = sh + "\n  if (abs(x) > 1.) {\n    return NAN;\n  }\n  return acos(x);\n",
      $h = sh + "\n  return atan(x);\n",
      Rh = "\n  float e2x = exp(x);\n  return (e2x - 1.0 / e2x) / 2.0;\n",
      jh = "\n  float e2x = exp(-x);\n  return (e2x + 1.0 / e2x) / 2.0;\n",
      Dh = "\n  float e2x = exp(-2.0 * abs(x));\n  return sign(x) * (1.0 - e2x) / (1.0 + e2x);\n",
      Fh = sh + "return log(x + sqrt(x * x + 1.0));",
      Mh = sh + "\n  if (x < 1.0) return NAN;\n  return log(x + sqrt(x * x - 1.0));",
      zh = sh + "\n  if ((x < -1.0) || (x > 1.0)) return NAN;\n  return (log(1.0 + x) - log(1.0 - x)) / 2.0;",
      Lh = `\n  // Error function is calculated approximately with elementary function.\n  // See "Handbook of Mathematical Functions with Formulas,\n  // Graphs, and Mathematical Tables", Abramowitz and Stegun.\n  float p = ${Ft.L.ERF_P};\n  float a1 = ${Ft.L.ERF_A1};\n  float a2 = ${Ft.L.ERF_A2};\n  float a3 = ${Ft.L.ERF_A3};\n  float a4 = ${Ft.L.ERF_A4};\n  float a5 = ${Ft.L.ERF_A5};\n\n  float sign = sign(x);\n  x = abs(x);\n  float t = 1.0 / (1.0 + p * x);\n  return sign * (1.0 - (((((a5*t + a4)*t) + a3)*t + a2)*t + a1)*t*exp(-x*x));\n`,
      Bh = "return 1.0 / x;",
      Ph = "return float(!(x >= 1.0));",
      Wh = "return float(int(x));",
      Uh = "return x;",
      Vh = "return x;",
      Hh = "\n  vec4 result = log(x);\n  vec4 isNaN = vec4(lessThan(x, vec4(0.0)));\n  result.r = isNaN.r == 1.0 ? NAN : result.r;\n  result.g = isNaN.g == 1.0 ? NAN : result.g;\n  result.b = isNaN.b == 1.0 ? NAN : result.b;\n  result.a = isNaN.a == 1.0 ? NAN : result.a;\n\n  return result;\n",
      Gh = "\n  vec4 result = x * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n",
      qh = "\n  vec4 result = min(x, vec4(6.)) * vec4(greaterThanEqual(x, vec4(0.0)));\n  bvec4 isNaN = isnan(x);\n\n  result.r = isNaN.r ? x.r : result.r;\n  result.g = isNaN.g ? x.g : result.g;\n  result.b = isNaN.b ? x.b : result.b;\n  result.a = isNaN.a ? x.a : result.a;\n\n  return result;\n",
      Kh = "\n  vec4 result;\n\n  result.r = (x.r >= 0.0) ? x.r : (exp(x.r) - 1.0);\n  result.g = (x.g >= 0.0) ? x.g : (exp(x.g) - 1.0);\n  result.b = (x.b >= 0.0) ? x.b : (exp(x.b) - 1.0);\n  result.a = (x.a >= 0.0) ? x.a : (exp(x.a) - 1.0);\n\n  return result;\n";
    class Jh {
      constructor(t, e) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0, this.outputShape = t, this.userCode = `\n      vec4 unaryOperation(vec4 x) {\n        ${e}\n      }\n\n      void main() {\n        vec4 x = getAAtOutCoords();\n        vec4 y = unaryOperation(x);\n\n        setOutput(y);\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Xh {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !1, this.outputShape = t;
        const e = t.length,
          n = yu("rc", e),
          r = ju(e),
          s = function (t, e) {
            if (1 === t) return "rc";
            let n = "";
            for (let r = 0; r < t; r++) n += e[r], r < t - 1 && (n += ",");
            return n
          }(e, n),
          i = n.slice(-2),
          a = e <= 1 ? "rc" : `vec2(${i.join(",")})`;
        this.userCode = `\n      void main() {\n        ${r} rc = getOutputCoords();\n        vec4 packedInput = getA(${s});\n\n        setOutput(getChannel(packedInput, ${a}));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const {
      segment_util: Yh
    } = Ft.L, Zh = Ft.Rb.split, Qh = Ft.Rb.tile, td = Ft.Rb.topkImpl, ed = Ft.Rb.whereImpl, nd = 1e-7, rd = 1e-4, sd = {};

    function id(t, e = !1) {
      if ("linear" === t) return e ? Vh : ih;
      if ("relu" === t) return e ? Gh : oh;
      if ("elu" === t) return e ? Kh : ch;
      if ("relu6" === t) return e ? qh : uh;
      if ("prelu" === t) return e ? gc : lc;
      throw new Error(`Activation ${t} has not been implemented for the WebGL backend.`)
    }
    const ad = 128,
      od = 600;
    const ud = 1e3;
    class cd extends Ft.h {
      constructor(t) {
        if (super(), this.pendingRead = new WeakMap, this.pendingDisposal = new WeakSet, this.dataRefCount = new WeakMap, this.numBytesInGPU = 0, this.uploadWaitMs = 0, this.downloadWaitMs = 0, this.warnedAboutMemory = !1, this.warnedAboutCPUBackend = !1, this.pendingDeletes = 0, this.disposed = !1, !Object(Ft.vb)().getBool("HAS_WEBGL")) throw new Error("WebGL is not supported on this device");
        if (null == t) {
          const t = Ro(Object(Ft.vb)().getNumber("WEBGL_VERSION"));
          this.binaryCache = (e = Object(Ft.vb)().getNumber("WEBGL_VERSION")) in sd ? sd[e] : (sd[e] = {}, sd[e]), this.gpgpu = new vl(t), this.canvas = t.canvas, this.gpgpuCreatedLocally = !0
        } else this.gpgpu = t, this.binaryCache = {}, this.gpgpuCreatedLocally = !1, this.canvas = t.gl.canvas;
        var e;
        this.textureManager = new Zl(this.gpgpu), this.numMBBeforeWarning = null == Object(Ft.vb)().global.screen ? 1024 : Object(Ft.vb)().global.screen.height * Object(Ft.vb)().global.screen.width * window.devicePixelRatio * od / 1024 / 1024, this.texData = new Ft.a(this, Object(Ft.ub)())
      }
      numDataIds() {
        return this.texData.numDataIds() + (this.cpuBackend ? this.cpuBackend.numDataIds() : 0) - this.pendingDeletes
      }
      write(t, e, n) {
        if ((Object(Ft.vb)().getBool("WEBGL_CHECK_NUMERICAL_PROBLEMS") || Object(Ft.vb)().getBool("DEBUG")) && this.checkNumericalProblems(t), "complex64" === n && null != t) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
        const r = {};
        return this.texData.set(r, {
          shape: e,
          dtype: n,
          values: t,
          usage: Do.UPLOAD
        }), r
      }
      move(t, e, n, r) {
        if (Object(Ft.vb)().getBool("DEBUG") && this.checkNumericalProblems(e), "complex64" === r) throw new Error("Cannot write to a complex64 dtype. Please use tf.complex(real, imag).");
        this.texData.set(t, {
          shape: n,
          dtype: r,
          values: e,
          usage: Do.UPLOAD
        })
      }
      readSync(t) {
        const e = this.texData.get(t),
          {
            values: n,
            dtype: r,
            complexTensors: s,
            slice: i,
            shape: a,
            isPacked: o
          } = e;
        if (null != i) {
          let e;
          e = o ? new Jh(a, Uh) : new rh(a, Uh);
          const n = this.runWebGLProgram(e, [{
              dataId: t,
              shape: a,
              dtype: r
            }], r),
            s = this.readSync(n.dataId);
          return this.disposeData(n.dataId), s
        }
        if (null != n) return this.convertAndCacheOnCPU(t);
        if ("string" === r) return n;
        const u = null != this.activeTimers;
        let c, l;
        if (u && (c = Ft.Jd.now()), "complex64" === r) {
          const t = s.real.dataSync(),
            e = s.imag.dataSync();
          l = Ft.L.mergeRealAndImagArrays(t, e)
        } else l = this.getValuesFromTexture(t);
        return u && (this.downloadWaitMs += Ft.Jd.now() - c), this.convertAndCacheOnCPU(t, l)
      }
      async read(t) {
        if (this.pendingRead.has(t)) {
          const e = this.pendingRead.get(t);
          return new Promise(t => e.push(t))
        }
        const e = this.texData.get(t),
          {
            values: n,
            shape: r,
            slice: s,
            dtype: i,
            complexTensors: a,
            isPacked: o
          } = e;
        if (null != s) {
          let e;
          e = o ? new Jh(r, Uh) : new rh(r, Uh);
          const n = this.runWebGLProgram(e, [{
              dataId: t,
              shape: r,
              dtype: i
            }], i),
            s = this.read(n.dataId);
          return this.disposeData(n.dataId), s
        }
        if (null != n) return this.convertAndCacheOnCPU(t);
        if (!Object(Ft.vb)().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED") && 2 === Object(Ft.vb)().getNumber("WEBGL_VERSION")) throw new Error("tensor.data() with WEBGL_DOWNLOAD_FLOAT_ENABLED=false and WEBGL_VERSION=2 not yet supported.");
        let u, c, l = null;
        if ("complex64" !== i && Object(Ft.vb)().get("WEBGL_BUFFER_SUPPORTED")) {
          u = this.decode(t);
          const e = this.texData.get(u.dataId);
          l = this.gpgpu.createBufferFromTexture(e.texture, ...zo(r))
        }
        if (this.pendingRead.set(t, []), "complex64" !== i && await this.gpgpu.createAndWaitForFence(), "complex64" === i) {
          const t = await Promise.all([a.real.data(), a.imag.data()]),
            e = t[0],
            n = t[1];
          c = Ft.L.mergeRealAndImagArrays(e, n)
        } else if (null == l) c = this.getValuesFromTexture(t);
        else {
          const t = Ft.Jd.sizeFromShape(r);
          c = this.gpgpu.downloadFloat32MatrixFromBuffer(l, t)
        }
        null != u && this.disposeData(u.dataId);
        const h = this.convertAndCacheOnCPU(t, c),
          d = this.pendingRead.get(t);
        return this.pendingRead.delete(t), d.forEach(t => t(h)), this.pendingDisposal.has(t) && (this.pendingDisposal.delete(t), this.disposeData(t), this.pendingDeletes--), h
      }
      checkNumericalProblems(t) {
        if (null != t)
          for (let e = 0; e < t.length; e++) {
            const n = t[e];
            if (!Vo(n)) {
              if (Object(Ft.vb)().getBool("WEBGL_RENDER_FLOAT32_CAPABLE")) throw Error(`The value ${n} cannot be represented with your ` + "current settings. Consider enabling float32 rendering: 'tf.env().set('WEBGL_RENDER_FLOAT32_ENABLED', true);'");
              throw Error(`The value ${n} cannot be represented on this device.`)
            }
          }
      }
      getValuesFromTexture(t) {
        const {
          shape: e,
          dtype: n,
          isPacked: r
        } = this.texData.get(t), s = Ft.Jd.sizeFromShape(e);
        if (Object(Ft.vb)().getBool("WEBGL_DOWNLOAD_FLOAT_ENABLED")) {
          const n = this.decode(t),
            r = this.texData.get(n.dataId),
            i = this.gpgpu.downloadMatrixFromPackedTexture(r.texture, ...zo(e)).subarray(0, s);
          return this.disposeData(n.dataId), i
        }
        const i = Object(Ft.vb)().getBool("WEBGL_PACK") && !0 === r,
          a = i ? su(e) : e,
          o = i ? new nl(a) : new el(a),
          u = this.runWebGLProgram(o, [{
            shape: a,
            dtype: n,
            dataId: t
          }], "float32"),
          c = this.texData.get(u.dataId),
          l = this.gpgpu.downloadByteEncodedFloatMatrixFromOutputTexture(c.texture, c.texShape[0], c.texShape[1]).subarray(0, s);
        return this.disposeData(u.dataId), l
      }
      async time(t) {
        const e = this.activeTimers,
          n = [];
        let r = !1;
        null == this.programTimersStack ? (this.programTimersStack = n, r = !0) : this.activeTimers.push(n), this.activeTimers = n, t();
        const s = Ft.Jd.flatten(this.activeTimers.map(t => t.query)).filter(t => null != t),
          i = Ft.Jd.flatten(this.activeTimers.map(t => t.name)).filter(t => null != t);
        this.activeTimers = e, r && (this.programTimersStack = null);
        const a = {
          uploadWaitMs: this.uploadWaitMs,
          downloadWaitMs: this.downloadWaitMs,
          kernelMs: null,
          wallMs: null
        };
        if (Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) {
          const t = await Promise.all(s);
          a.kernelMs = Ft.Jd.sum(t), a.getExtraProfileInfo = () => t.map((t, e) => ({
            name: i[e],
            ms: t
          })).map(t => `${t.name}: ${t.ms}`).join(", ")
        } else a.kernelMs = {
          error: "WebGL query timers are not supported in this environment."
        };
        return this.uploadWaitMs = 0, this.downloadWaitMs = 0, a
      }
      memory() {
        return {
          unreliable: !1,
          numBytesInGPU: this.numBytesInGPU,
          numBytesInGPUAllocated: this.textureManager.numBytesAllocated,
          numBytesInGPUFree: this.textureManager.numBytesFree
        }
      }
      startTimer() {
        return Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? this.gpgpu.beginQuery() : {
          startMs: Ft.Jd.now(),
          endMs: null
        }
      }
      endTimer(t) {
        return Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0 ? (this.gpgpu.endQuery(), t) : (t.endMs = Ft.Jd.now(), t)
      }
      async getQueryTime(t) {
        if (Object(Ft.vb)().getNumber("WEBGL_DISJOINT_QUERY_TIMER_EXTENSION_RELIABLE") > 0) return this.gpgpu.waitForQueryAndGetTime(t);
        const e = t;
        return e.endMs - e.startMs
      }
      disposeData(t) {
        if (this.pendingDisposal.has(t)) return;
        if (this.pendingRead.has(t)) return this.pendingDisposal.add(t), void this.pendingDeletes++;
        if (!this.texData.has(t)) return;
        this.releaseGPUData(t);
        const {
          complexTensors: e
        } = this.texData.get(t);
        null != e && (e.real.dispose(), e.imag.dispose()), this.texData.delete(t)
      }
      releaseGPUData(t) {
        const {
          texture: e,
          dtype: n,
          texShape: r,
          usage: s,
          isPacked: i,
          slice: a
        } = this.texData.get(t), o = a && a.origDataId || t, u = this.dataRefCount.get(o);
        u > 1 ? this.dataRefCount.set(o, u - 1) : (this.dataRefCount.delete(o), null != e && (this.numBytesInGPU -= this.computeBytes(r, n), this.textureManager.releaseTexture(e, r, s, i)));
        const c = this.texData.get(t);
        c.texture = null, c.texShape = null, c.isPacked = !1, c.slice = null
      }
      getTexture(t) {
        return this.uploadToGPU(t), this.texData.get(t).texture
      }
      getDataInfo(t) {
        return this.texData.get(t)
      }
      getCPUBackend() {
        return Object(Ft.vb)().getBool("WEBGL_CPU_FORWARD") ? (null == this.cpuBackend && (this.cpuBackend = Object(Ft.ub)().findBackend("cpu")), this.cpuBackend) : null
      }
      shouldExecuteOnCPU(t, e = ad) {
        const n = this.getCPUBackend();
        return this.warnedAboutCPUBackend || null != n || Object(Ft.vb)().getBool("IS_TEST") || (console.warn("Your application contains ops that are small enough to be executed on the CPU backend, however the CPU backend cannot be found. Consider importing the CPU backend (@tensorflow/tfjs-backend-cpu) for better performance."), this.warnedAboutCPUBackend = !0), null != n && t.every(t => null == this.texData.get(t.dataId).texture && Ft.Jd.sizeFromShape(t.shape) < e)
      }
      getGPGPUContext() {
        return this.gpgpu
      }
      complex(t, e) {
        const n = this.makeOutput(t.shape, "complex64");
        return this.texData.get(n.dataId).complexTensors = {
          real: Object(Ft.ub)().keep(t.clone()),
          imag: Object(Ft.ub)().keep(e.clone())
        }, n
      }
      real(t) {
        return this.texData.get(t.dataId).complexTensors.real.clone()
      }
      imag(t) {
        return this.texData.get(t.dataId).complexTensors.imag.clone()
      }
      slice(t, e, n) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.slice(t, e, n);
        if (0 === Ft.Jd.sizeFromShape(n)) return Object(Ft.wd)([], n, t.dtype);
        const {
          isPacked: r
        } = this.texData.get(t.dataId), s = Ft.fd.isSliceContinous(t.shape, e, n);
        if (r || !s) {
          const r = Object(Ft.vb)().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new Xl(n) : new Kl(n),
            s = r.getCustomSetupFunc(e);
          return this.compileAndRun(r, [t], null, s)
        }
        return this.uploadToGPU(t.dataId), this.shallowSlice(t, e, n)
      }
      shallowSlice(t, e, n) {
        const r = this.texData.get(t.dataId),
          s = this.makeOutput(n, t.dtype),
          i = this.texData.get(s.dataId);
        Object.assign(i, r), i.shape = n, i.dtype = t.dtype;
        let a = Ft.fd.computeFlatOffset(e, t.strides);
        r.slice && (a += r.slice.flatOffset), i.slice = {
          flatOffset: a,
          origDataId: r.slice && r.slice.origDataId || t.dataId
        };
        const o = this.dataRefCount.get(i.slice.origDataId) || 1;
        return this.dataRefCount.set(i.slice.origDataId, o + 1), s
      }
      stridedSlice(t, e, n, r) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.stridedSlice(t, e, n, r);
        const s = Ft.fd.computeOutShape(e, n, r);
        if (s.some(t => 0 === t)) return Object(Ft.wd)([], s);
        const i = new Yl(e, r, s);
        return this.compileAndRun(i, [t])
      }
      reverse(t, e) {
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new Vl(t.shape, e) : new Ul(t.shape, e);
        return this.compileAndRun(n, [t])
      }
      concat(t, e) {
        if ("complex64" === t[0].dtype) {
          const n = t.map(t => Object(Ft.Fc)(t)),
            r = t.map(t => Object(Ft.Mb)(t));
          return Object(Ft.Y)(this.concat(n, e), this.concat(r, e))
        }
        if (this.shouldExecuteOnCPU(t)) return this.cpuBackend.concat(t, e);
        if (1 === t.length) return t[0];
        if (t.length > Object(Ft.vb)().getNumber("WEBGL_MAX_TEXTURES_IN_SHADER")) {
          const n = Math.floor(t.length / 2),
            r = this.concat(t.slice(0, n), e),
            s = this.concat(t.slice(n), e);
          return this.concat([r, s], e)
        }
        if (Object(Ft.vb)().getBool("WEBGL_PACK_ARRAY_OPERATIONS") && t[0].rank > 1) {
          const n = new Dc(t.map(t => t.shape), e);
          return this.compileAndRun(n, t)
        }
        const n = Ft.L.computeOutShape(t.map(t => t.shape), e),
          r = t.map(t => t.as2D(-1, Ft.Jd.sizeFromShape(t.shape.slice(e)))),
          s = new jc(r.map(t => t.shape));
        return this.compileAndRun(s, r).reshape(n)
      }
      neg(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.neg(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, hh, t.dtype);
        const e = new rh(t.shape, hh);
        return this.compileAndRun(e, [t])
      }
      batchMatMul(t, e, n, r) {
        const s = n ? t.shape[2] : t.shape[1],
          i = r ? e.shape[1] : e.shape[2],
          a = n ? t.shape[1] : t.shape[2],
          [o, , ] = t.shape;
        if ((1 === s || 1 === i) && a > ud) {
          n && (t = Object(Ft.Fd)(t, [0, 2, 1])), r && (e = Object(Ft.Fd)(e, [0, 2, 1]));
          const s = 1 === i ? t : t.as3D(o, a, 1),
            u = 1 === i ? 2 : 1,
            c = 1 === i ? e.as3D(o, 1, a) : e;
          return this.multiply(s, c).sum(u, !0)
        }
        const u = Object(Ft.Id)(t.dtype, e.dtype),
          c = new Il(t.shape, [o, s, i], n, r);
        return this.compileAndRun(c, [t, e], u)
      }
      fusedBatchMatMul({
        a: t,
        b: e,
        transposeA: n,
        transposeB: r,
        bias: s,
        activation: i,
        preluActivationWeights: a
      }) {
        const o = n ? t.shape[2] : t.shape[1],
          u = r ? e.shape[1] : e.shape[2],
          [c, , ] = t.shape,
          l = Object(Ft.Id)(t.dtype, e.dtype),
          h = null != s,
          d = null != a,
          p = i ? id(i, !0) : null,
          f = new Il(t.shape, [c, o, u], n, r, h, p, d),
          m = [t, e];
        return s && m.push(s), a && m.push(a), this.compileAndRun(f, m, l)
      }
      multiply(t, e) {
        if ("complex64" === t.dtype) {
          const n = this.texData.get(t.dataId),
            r = this.texData.get(e.dataId),
            s = new Uu(Wu.REAL, t.shape, e.shape),
            i = new Uu(Wu.IMAG, t.shape, e.shape),
            a = [this.makeComplexComponentTensorInfo(t, n.complexTensors.real), this.makeComplexComponentTensorInfo(t, n.complexTensors.imag), this.makeComplexComponentTensorInfo(e, r.complexTensors.real), this.makeComplexComponentTensorInfo(e, r.complexTensors.imag)],
            o = this.compileAndRun(s, a),
            u = this.compileAndRun(i, a),
            c = this.complex(o, u);
          return o.dispose(), u.dispose(), c
        }
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.multiply(t, e);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, qu, t.dtype);
        const n = new hc(qu, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], t.dtype)
      }
      batchNorm(t, e, n, r, s, i) {
        const a = [t, e, n];
        let o = null;
        null != r && (o = r.shape, a.push(r));
        let u = null;
        if (null != s && (u = s.shape, a.push(s)), Object(Ft.vb)().getBool("WEBGL_PACK_NORMALIZATION")) {
          const r = new Pu(t.shape, e.shape, n.shape, o, u, i);
          return this.compileAndRun(r, a)
        }
        const c = new Bu(t.shape, e.shape, n.shape, o, u, i);
        return this.compileAndRun(c, a)
      }
      localResponseNormalization4D(t, e, n, r, s) {
        const i = Object(Ft.vb)().getBool("WEBGL_PACK_NORMALIZATION") ? new kl(t.shape, e, n, r, s) : new Sl(t.shape, e, n, r, s);
        return this.compileAndRun(i, [t])
      }
      LRNGrad(t, e, n, r, s, i, a) {
        const o = new _l(e.shape, r, s, i, a);
        return this.compileAndRun(o, [e, n, t])
      }
      tile(t, e) {
        if ("string" === t.dtype) {
          const n = this.readSync(t.dataId).map(t => Ft.Jd.decodeString(t)),
            r = Object(Ft.T)(t.shape, t.dtype, n);
          return Qh(r, e)
        }
        const n = new nh(t.shape, e);
        return this.compileAndRun(n, [t])
      }
      pad(t, e, n) {
        const r = Object(Ft.vb)().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new Rl(t.shape, e, n) : new $l(t.shape, e, n);
        return this.compileAndRun(r, [t])
      }
      gather(t, e, n) {
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.gather(t, e, n);
        const r = new ul(t.shape, e.size, n);
        return this.compileAndRun(r, [t, e])
      }
      batchToSpaceND(t, e, n) {
        Ft.Jd.assert(t.rank <= 4, () => "batchToSpaceND for rank > 4 with a WebGL backend not implemented yet");
        const r = e.reduce((t, e) => t * e),
          s = Ft.L.getReshaped(t.shape, e, r),
          i = Ft.L.getPermuted(s.length, e.length),
          a = Ft.L.getReshapedPermuted(t.shape, e, r),
          o = Ft.L.getSliceBeginCoords(n, e.length),
          u = Ft.L.getSliceSize(a, n, e.length);
        return Object(Ft.Fd)(t.reshape(s), i).reshape(a).slice(o, u)
      }
      spaceToBatchND(t, e, n) {
        Ft.Jd.assert(t.rank <= 4, () => "spaceToBatchND for rank > 4 with a WebGL backend not implemented yet");
        const r = e.reduce((t, e) => t * e),
          s = [
            [0, 0]
          ];
        s.push(...n);
        for (let n = 1 + e.length; n < t.shape.length; ++n) s.push([0, 0]);
        const i = t.pad(s),
          a = Ft.L.getReshaped(i.shape, e, r, !1),
          o = Ft.L.getPermuted(a.length, e.length, !1),
          u = Ft.L.getReshapedPermuted(i.shape, e, r, !1),
          c = Object(Ft.Fd)(i.reshape(a), o);
        return Object(Ft.Kc)(c, u)
      }
      reduce(t, e, n) {
        const r = t.shape[0],
          s = t.shape[1],
          i = Ft.L.computeOptimalWindowSize(s),
          a = new Fl({
            windowSize: i,
            inSize: s,
            batchSize: r
          }, e),
          o = this.compileAndRun(a, [t], n);
        return 1 === o.shape[1] ? o : this.reduce(o, e, n)
      }
      argReduce(t, e, n = null) {
        let r = t.shape[0],
          s = t.shape[1];
        null != n && (r = n.shape[0], s = n.shape[1]);
        const i = Ft.L.computeOptimalWindowSize(s),
          a = new gu({
            windowSize: i,
            inSize: s,
            batchSize: r
          }, e, null == n),
          o = [t];
        null != n && o.push(n);
        const u = this.compileAndRun(a, o, "int32");
        return 1 === u.shape[1] ? u : this.argReduce(t, e, u)
      }
      argReducePacked(t, e, n = null) {
        const r = null != n ? n.shape : t.shape,
          s = r[r.length - 1],
          i = Ft.L.computeOptimalWindowSize(s),
          a = new Mu(r, i, e, null == n),
          o = null == n ? [t] : [t, n],
          u = this.compileAndRun(a, o, "int32");
        return u.rank === t.rank ? this.argReducePacked(t, e, u) : u
      }
      sum(t, e) {
        Ft.L.assertAxesAreInnerMostDims("sum", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Jd.sizeFromShape(r), i = t.as2D(-1, s), a = Ft.td(t.dtype);
        return this.reduce(i, "sum", a).reshape(n)
      }
      prod(t, e) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.prod(t, e);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Jd.sizeFromShape(r), i = t.as2D(-1, s), a = Ft.td(t.dtype);
        return this.reduce(i, "prod", a).reshape(n)
      }
      unsortedSegmentSum(t, e, n) {
        let r = 0;
        const s = Ft.L.getAxesPermutation([r], t.rank);
        let i = t;
        null != s && (i = Object(Ft.Fd)(t, s), r = Ft.L.getInnerMostAxes(1, t.rank)[0]);
        const a = Yh.computeOutShape(i.shape, r, n),
          o = Ft.Jd.sizeFromShape([i.shape[r]]),
          u = i.as2D(-1, o),
          c = Ft.td(t.dtype);
        let l = this.segOpCompute(u, "unsortedSegmentSum", e, c, n).reshape(a);
        return null != s && (l = Object(Ft.Fd)(l, Ft.L.getUndoAxesPermutation(s))), l
      }
      segOpCompute(t, e, n, r, s) {
        const i = t.shape[0],
          a = t.shape[1],
          o = Yh.segOpComputeOptimalWindowSize(a, s),
          u = new Gl({
            windowSize: o,
            inSize: a,
            batchSize: i,
            numSegments: s
          }, e),
          c = this.compileAndRun(u, [t, n], r);
        return c.shape[1] === s ? c : (n = Object(Ft.Ec)(0, s).tile([a / o]), this.segOpCompute(c, e, n, r, s))
      }
      argMinMaxReduce(t, e, n) {
        const r = [e];
        if (Ft.L.assertAxesAreInnerMostDims("arg" + n.charAt(0).toUpperCase() + n.slice(1), r, t.rank), !Object(Ft.vb)().getBool("WEBGL_PACK_REDUCE") || t.rank <= 2) {
          const [e, s] = Ft.L.computeOutAndReduceShapes(t.shape, r), i = Ft.Jd.sizeFromShape(s), a = t.as2D(-1, i);
          return this.argReduce(a, n).reshape(e)
        }
        return this.argReducePacked(t, n)
      }
      argMin(t, e) {
        return this.argMinMaxReduce(t, e, "min")
      }
      argMax(t, e) {
        return this.argMinMaxReduce(t, e, "max")
      }
      cumsum(t, e, n, r) {
        if (e !== t.rank - 1) throw new Error(`WebGL cumsum shader expects an inner-most axis=${t.rank-1} ` + `but got axis=${e}`);
        const s = t.shape[e];
        let i = t;
        for (let e = 0; e <= Math.ceil(Math.log2(s)) - 1; e++) {
          const n = new Kc(t.shape, !1, r),
            s = n.getCustomSetupFunc(e),
            a = i;
          i = this.compileAndRun(n, [i], i.dtype, s), a.dispose()
        }
        if (n) {
          const e = new Kc(t.shape, n, r),
            s = i;
          i = this.compileAndRun(e, [i]), s.dispose()
        }
        return i
      }
      equal(t, e) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, wc, "bool");
        const n = new hc(Yu, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      notEqual(t, e) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, vc, "bool");
        const n = new hc(Zu, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      less(t, e) {
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.less(t, e);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, xc, "bool");
        const n = new hc(Qu, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      lessEqual(t, e) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Oc, "bool");
        const n = new hc(tc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      greater(t, e) {
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.greater(t, e);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Sc, "bool");
        const n = new hc(ec, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      greaterEqual(t, e) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, _c, "bool");
        const n = new hc(nc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      logicalNot(t) {
        const e = new rh(t.shape, Ph);
        return this.compileAndRun(e, [t])
      }
      logicalAnd(t, e) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, kc, "bool");
        const n = new hc(rc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      logicalOr(t, e) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Cc, "bool");
        const n = new hc(sc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e], "bool")
      }
      select(t, e, n) {
        const r = new ql(t.rank, e.shape, e.rank);
        return this.compileAndRun(r, [t, e, n], Object(Ft.Id)(e.dtype, n.dtype))
      }
      where(t) {
        Ft.L.warn("tf.where() in webgl locks the UI thread. Call tf.whereAsync() instead");
        const e = t.dataSync();
        return ed(t.shape, e)
      }
      topk(t, e, n) {
        const r = t.dataSync();
        return td(r, t.shape, t.dtype, e, n)
      }
      min(t, e) {
        Ft.L.assertAxesAreInnerMostDims("min", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Jd.sizeFromShape(r), i = t.as2D(-1, s);
        return this.reduce(i, "min", i.dtype).reshape(n)
      }
      minimum(t, e) {
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.minimum(t, e);
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(Ic, t.shape, e.shape) : new hc(ac, t.shape, e.shape);
        return this.compileAndRun(n, [t, e])
      }
      mod(t, e) {
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(Tc, t.shape, e.shape) : new hc(oc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e])
      }
      maximum(t, e) {
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.maximum(t, e);
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(Ec, t.shape, e.shape) : new hc(ic, t.shape, e.shape);
        return this.compileAndRun(n, [t, e])
      }
      all(t, e) {
        Ft.L.assertAxesAreInnerMostDims("all", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Jd.sizeFromShape(r), i = t.as2D(-1, s);
        return this.reduce(i, "all", i.dtype).reshape(n)
      }
      any(t, e) {
        Ft.L.assertAxesAreInnerMostDims("any", e, t.rank);
        const [n, r] = Ft.L.computeOutAndReduceShapes(t.shape, e), s = Ft.Jd.sizeFromShape(r), i = t.as2D(-1, s);
        return this.reduce(i, "any", i.dtype).reshape(n)
      }
      floorDiv(t, e) {
        const n = Ju;
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, fc, "int32");
        const r = new hc(n, t.shape, e.shape);
        return this.compileAndRun(r, [t, e], "int32")
      }
      add(t, e) {
        if ("complex64" === t.dtype && "complex64" === e.dtype) return this.complexSeparableBinaryOp(t, e, Hu);
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.add(t, e);
        const n = Object(Ft.Id)(t.dtype, e.dtype);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Hu, n);
        const r = new hc(Hu, t.shape, e.shape);
        return this.compileAndRun(r, [t, e], n)
      }
      packedUnaryOp(t, e, n) {
        const r = new Jh(t.shape, e);
        return this.compileAndRun(r, [t], n)
      }
      packedBinaryOp(t, e, n, r, s = !1) {
        const i = new Ac(n, t.shape, e.shape, s);
        return this.compileAndRun(i, [t, e], r)
      }
      complexSeparableBinaryOp(t, e, n) {
        const r = this.texData.get(t.dataId),
          s = this.texData.get(e.dataId),
          [i, a] = [
            [r.complexTensors.real, s.complexTensors.real],
            [r.complexTensors.imag, s.complexTensors.imag]
          ].map(r => {
            const [s, i] = r, a = this.makeComplexComponentTensorInfo(t, s), o = this.makeComplexComponentTensorInfo(e, i), u = new hc(n, t.shape, e.shape);
            return this.compileAndRun(u, [a, o], Object(Ft.Id)(s.dtype, i.dtype))
          }),
          o = this.complex(i, a);
        return i.dispose(), a.dispose(), o
      }
      makeComplexComponentTensorInfo(t, e) {
        return {
          dataId: e.dataId,
          dtype: e.dtype,
          shape: t.shape
        }
      }
      addN(t) {
        if (1 === t.length) return t[0];
        if (t.length > Object(Ft.vb)().get("WEBGL_MAX_TEXTURES_IN_SHADER")) {
          const e = Math.floor(t.length / 2),
            n = this.addN(t.slice(0, e)),
            r = this.addN(t.slice(e));
          return this.addN([n, r])
        }
        const e = t.map(t => t.dtype).reduce((t, e) => Object(Ft.Id)(t, e)),
          n = t.map(t => t.shape),
          r = Object(Ft.vb)().getBool("WEBGL_PACK") ? new mu(t[0].shape, n) : new fu(t[0].shape, n);
        return this.compileAndRun(r, t, e)
      }
      subtract(t, e) {
        if ("complex64" === t.dtype && "complex64" === e.dtype) return this.complexSeparableBinaryOp(t, e, Gu);
        if (this.shouldExecuteOnCPU([t, e])) return this.cpuBackend.subtract(t, e);
        const n = Object(Ft.Id)(t.dtype, e.dtype);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS")) return this.packedBinaryOp(t, e, Gu, t.dtype);
        const r = new hc(Gu, t.shape, e.shape);
        return this.compileAndRun(r, [t, e], n)
      }
      pow(t, e) {
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(mc, t.shape, e.shape) : new hc(Xu, t.shape, e.shape),
          r = Object(Ft.Id)(t.dtype, e.dtype);
        return this.compileAndRun(n, [t, e], r)
      }
      ceil(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.ceil(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, dh, t.dtype);
        const e = new rh(t.shape, dh);
        return this.compileAndRun(e, [t])
      }
      floor(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.floor(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, ph, t.dtype);
        const e = new rh(t.shape, ph);
        return this.compileAndRun(e, [t])
      }
      sign(t) {
        const e = new rh(t.shape, fh);
        return this.compileAndRun(e, [t])
      }
      isNaN(t) {
        const e = new rh(t.shape, mh);
        return this.compileAndRun(e, [t], "bool")
      }
      isInf(t) {
        const e = new rh(t.shape, gh);
        return this.compileAndRun(e, [t], "bool")
      }
      isFinite(t) {
        const e = new rh(t.shape, bh);
        return this.compileAndRun(e, [t], "bool")
      }
      round(t) {
        const e = new rh(t.shape, yh);
        return this.compileAndRun(e, [t])
      }
      exp(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.exp(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, wh, t.dtype);
        const e = new rh(t.shape, wh);
        return this.compileAndRun(e, [t])
      }
      expm1(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.expm1(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, vh, t.dtype);
        const e = new rh(t.shape, vh);
        return this.compileAndRun(e, [t])
      }
      softmax(t, e) {
        const n = Ft.Jd.parseAxisParam([e], t.shape),
          r = Object(Ft.fc)(t, n),
          s = Ft.L.expandShapeToKeepDim(r.shape, n),
          i = this.subtract(t, r.reshape(s)),
          a = this.exp(i),
          o = this.sum(a, n).reshape(s);
        return Object(Ft.qb)(a, o)
      }
      log(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.log(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Hh, t.dtype);
        const e = new rh(t.shape, xh);
        return this.compileAndRun(e, [t])
      }
      log1p(t) {
        const e = new rh(t.shape, Oh);
        return this.compileAndRun(e, [t])
      }
      sqrt(t) {
        const e = new rh(t.shape, Sh);
        return this.compileAndRun(e, [t])
      }
      rsqrt(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.rsqrt(t);
        const e = new rh(t.shape, _h);
        return this.compileAndRun(e, [t])
      }
      reciprocal(t) {
        const e = new rh(t.shape, Bh);
        return this.compileAndRun(e, [t])
      }
      relu(t) {
        let e;
        return e = Object(Ft.vb)().getBool("WEBGL_PACK") ? new Jh(t.shape, Gh) : new rh(t.shape, oh), this.compileAndRun(e, [t])
      }
      relu6(t) {
        let e;
        return e = Object(Ft.vb)().getBool("WEBGL_PACK") ? new Jh(t.shape, qh) : new rh(t.shape, uh), this.compileAndRun(e, [t])
      }
      prelu(t, e) {
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(gc, t.shape, e.shape) : new hc(lc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e])
      }
      elu(t) {
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, Kh, t.dtype);
        const e = new rh(t.shape, ch);
        return this.compileAndRun(e, [t])
      }
      eluDer(t, e) {
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(bc, t.shape, e.shape) : new hc(cc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e])
      }
      selu(t) {
        const e = new rh(t.shape, lh);
        return this.compileAndRun(e, [t])
      }
      int(t) {
        const e = new rh(t.shape, Wh);
        return this.compileAndRun(e, [t], "int32")
      }
      clip(t, e, n) {
        let r;
        r = Object(Ft.vb)().getBool("WEBGL_PACK_CLIP") ? new $c(t.shape) : new Nc(t.shape);
        const s = r.getCustomSetupFunc(e, n);
        return this.compileAndRun(r, [t], null, s)
      }
      abs(t) {
        if (this.shouldExecuteOnCPU([t])) return this.cpuBackend.abs(t);
        if (Object(Ft.vb)().getBool("WEBGL_PACK_UNARY_OPERATIONS")) return this.packedUnaryOp(t, ah, t.dtype);
        const e = new rh(t.shape, ah);
        return this.compileAndRun(e, [t])
      }
      complexAbs(t) {
        const e = this.texData.get(t.dataId),
          n = new Rc(t.shape),
          r = [this.makeComplexComponentTensorInfo(t, e.complexTensors.real), this.makeComplexComponentTensorInfo(t, e.complexTensors.imag)];
        return this.compileAndRun(n, r)
      }
      sigmoid(t) {
        const e = new rh(t.shape, kh);
        return this.compileAndRun(e, [t])
      }
      softplus(t) {
        const e = new rh(t.shape, Ch);
        return this.compileAndRun(e, [t])
      }
      sin(t) {
        const e = new rh(t.shape, Eh);
        return this.compileAndRun(e, [t])
      }
      cos(t) {
        const e = new rh(t.shape, Ih);
        return this.compileAndRun(e, [t])
      }
      tan(t) {
        const e = new rh(t.shape, Th);
        return this.compileAndRun(e, [t])
      }
      asin(t) {
        const e = new rh(t.shape, Ah);
        return this.compileAndRun(e, [t])
      }
      acos(t) {
        const e = new rh(t.shape, Nh);
        return this.compileAndRun(e, [t])
      }
      atan(t) {
        const e = new rh(t.shape, $h);
        return this.compileAndRun(e, [t])
      }
      atan2(t, e) {
        const n = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac(yc, t.shape, e.shape) : new hc(uc, t.shape, e.shape);
        return this.compileAndRun(n, [t, e])
      }
      sinh(t) {
        const e = new rh(t.shape, Rh);
        return this.compileAndRun(e, [t])
      }
      cosh(t) {
        const e = new rh(t.shape, jh);
        return this.compileAndRun(e, [t])
      }
      tanh(t) {
        const e = new rh(t.shape, Dh);
        return this.compileAndRun(e, [t])
      }
      asinh(t) {
        const e = new rh(t.shape, Fh);
        return this.compileAndRun(e, [t])
      }
      acosh(t) {
        const e = new rh(t.shape, Mh);
        return this.compileAndRun(e, [t])
      }
      atanh(t) {
        const e = new rh(t.shape, zh);
        return this.compileAndRun(e, [t])
      }
      erf(t) {
        const e = new rh(t.shape, Lh);
        return this.compileAndRun(e, [t])
      }
      step(t, e) {
        const n = new rh(t.shape, function (t = 0) {
          return sh + `\n    return x > 0.0 ? 1.0 : float(${t});\n  `
        }(e));
        return this.compileAndRun(n, [t])
      }
      conv2dByMatMul(t, e, n, r, s, i) {
        const a = t.shape,
          o = this.texData.get(t.dataId),
          u = n.inChannels,
          c = a[0] * a[1] * a[2],
          l = n.outChannels,
          h = "channelsLast" === n.dataFormat,
          d = (1 === c || 1 === l) && u > ud,
          p = a[2] % 2 != 0 && !!o.isPacked;
        if (d || !Object(Ft.vb)().getBool("WEBGL_LAZILY_UNPACK") || !Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") || !p) {
          const o = h ? a[0] * a[1] * a[2] : a[0] * a[2] * a[3],
            u = this.reshape(t, [1, o, n.inChannels]),
            c = this.reshape(e, [1, n.inChannels, n.outChannels]);
          return this.reshape(this.fusedBatchMatMul({
            a: u,
            b: c,
            transposeA: !1,
            transposeB: !1,
            bias: r,
            activation: s,
            preluActivationWeights: i
          }), n.outShape)
        }
        const f = h ? a[0] * a[1] * (a[2] + 1) : a[0] * a[2] * (a[3] + 1),
          m = {
            dataId: t.dataId,
            shape: [1, f, n.inChannels],
            dtype: t.dtype
          },
          g = o.shape;
        o.shape = o.shape.slice(), o.shape[o.shape.length - 2]++, Ft.Jd.assert(au(o.shape, m.shape), () => `packed reshape ${o.shape} to ${m.shape} isn't free`);
        const b = this.reshape(e, [1, n.inChannels, n.outChannels]),
          y = this.fusedBatchMatMul({
            a: m,
            b: b,
            transposeA: !1,
            transposeB: !1,
            bias: r,
            activation: s,
            preluActivationWeights: i
          }),
          w = this.texData.get(y.dataId);
        return Ft.Jd.assert(w.isPacked, () => "batchMatMul result is expected to be packed"), o.shape = g, w.shape = n.outShape, Object(Ft.ub)().makeTensorFromDataId(y.dataId, n.outShape, y.dtype)
      }
      conv2dWithIm2Row(t, e, n, r, s, i) {
        const {
          filterWidth: a,
          filterHeight: o,
          inChannels: u,
          outWidth: c,
          outHeight: l,
          dataFormat: h
        } = n, d = "channelsLast" === h, p = a * o * u, f = l * c, m = [p, f], g = t.squeeze([0]), b = e.reshape([1, p, -1]), y = new Ol(m, g.shape, n), w = this.compileAndRun(y, [g]).reshape([1, m[0], m[1]]), v = null != r, x = null != i, O = s ? id(s, !0) : null, S = new Il(w.shape, [1, f, n.outChannels], !0, !1, v, O, x), _ = [w, b];
        r && _.push(r), x && _.push(i);
        const k = this.compileAndRun(S, _);
        return d ? k.reshape([1, l, c, n.outChannels]) : k.reshape([1, n.outChannels, l, c])
      }
      fusedConv2d({
        input: t,
        filter: e,
        convInfo: n,
        bias: r,
        activation: s,
        preluActivationWeights: i
      }) {
        if (1 === n.filterHeight && 1 === n.filterWidth && 1 === n.dilationHeight && 1 === n.dilationWidth && 1 === n.strideHeight && 1 === n.strideWidth && ("SAME" === n.padInfo.type || "VALID" === n.padInfo.type)) return this.conv2dByMatMul(t, e, n, r, s, i);
        if (Object(Ft.vb)().getBool("WEBGL_CONV_IM2COL") && 1 === t.shape[0]) return this.conv2dWithIm2Row(t, e, n, r, s, i);
        const a = null != r,
          o = null != i,
          u = s ? id(s, !1) : null,
          c = new Uc(n, a, u, o),
          l = [t, e];
        return r && l.push(r), i && l.push(i), this.compileAndRun(c, l)
      }
      conv2d(t, e, n) {
        if (1 === n.filterHeight && 1 === n.filterWidth && 1 === n.dilationHeight && 1 === n.dilationWidth && 1 === n.strideHeight && 1 === n.strideWidth && ("SAME" === n.padInfo.type || "VALID" === n.padInfo.type)) return this.conv2dByMatMul(t, e, n);
        if (Object(Ft.vb)().getBool("WEBGL_CONV_IM2COL") && 1 === t.shape[0]) return this.conv2dWithIm2Row(t, e, n);
        const r = new Uc(n);
        return this.compileAndRun(r, [t, e])
      }
      conv2dDerInput(t, e, n) {
        const r = new zc(n);
        return this.compileAndRun(r, [t, e])
      }
      conv2dDerFilter(t, e, n) {
        const r = new Mc(n);
        return this.compileAndRun(r, [t, e])
      }
      fusedDepthwiseConv2D({
        input: t,
        filter: e,
        convInfo: n,
        bias: r,
        activation: s,
        preluActivationWeights: i
      }) {
        const a = Object(Ft.vb)().getBool("WEBGL_PACK_DEPTHWISECONV") && n.strideWidth <= 2 && n.outChannels / n.inChannels == 1,
          o = s ? id(s, a) : null,
          u = [t, e],
          c = null != r,
          l = null != i;
        let h;
        return c && u.push(r), l && u.push(i), a ? (h = new Gc(n, c, o, l), this.compileAndRun(h, u)) : (h = new Hc(n, c, o, l), this.compileAndRun(h, u))
      }
      depthwiseConv2D(t, e, n) {
        let r;
        return Object(Ft.vb)().getBool("WEBGL_PACK_DEPTHWISECONV") && n.strideWidth <= 2 && n.outChannels / n.inChannels == 1 ? (r = new Gc(n), this.compileAndRun(r, [t, e])) : (r = new Hc(n), this.compileAndRun(r, [t, e]))
      }
      depthwiseConv2DDerInput(t, e, n) {
        const r = new Wc(n);
        return this.compileAndRun(r, [t, e])
      }
      depthwiseConv2DDerFilter(t, e, n) {
        const r = new Pc(n);
        return this.compileAndRun(r, [t, e])
      }
      conv3d(t, e, n) {
        const r = new Vc(n);
        return this.compileAndRun(r, [t, e])
      }
      conv3dDerInput(t, e, n) {
        const r = new Bc(n);
        return this.compileAndRun(r, [t, e])
      }
      conv3dDerFilter(t, e, n) {
        const r = new Lc(n);
        return this.compileAndRun(r, [t, e])
      }
      maxPool(t, e) {
        const n = new jl(e, "max", !1);
        return this.compileAndRun(n, [t])
      }
      avgPool(t, e) {
        const n = new jl(e, "avg", !1);
        return this.compileAndRun(n, [t], "float32")
      }
      maxPoolBackprop(t, e, n, r) {
        const s = new jl(r, "max", !0),
          i = this.compileAndRun(s, [e]),
          a = new Cl(r),
          o = this.compileAndRun(a, [t, i], e.dtype);
        return i.dispose(), o
      }
      avgPoolBackprop(t, e, n) {
        const r = new zu(n);
        return this.compileAndRun(r, [t], e.dtype)
      }
      cast(t, e) {
        return Ft.L.castTensor(t, e, this)
      }
      unstack(t, e) {
        const n = t.shape[e],
          r = new Array(t.rank - 1);
        let s = 0;
        for (let n = 0; n < t.rank; n++) n !== e && (r[s++] = t.shape[n]);
        const i = new Array(t.rank).fill(0),
          a = t.shape.slice();
        a[e] = 1;
        const o = new Array(n);
        for (let n = 0; n < o.length; n++) i[e] = n, o[n] = this.slice(t, i, a).reshape(r);
        return o
      }
      avgPool3d(t, e) {
        const n = new Dl(e, "avg", !1);
        return this.compileAndRun(n, [t], "float32")
      }
      avgPool3dBackprop(t, e, n) {
        const r = new Lu(n);
        return this.compileAndRun(r, [t], e.dtype)
      }
      maxPool3d(t, e) {
        const n = new Dl(e, "max", !1);
        return this.compileAndRun(n, [t], "float32")
      }
      maxPool3dBackprop(t, e, n, r) {
        const s = new Dl(r, "max", !0),
          i = this.compileAndRun(s, [e]),
          a = new El(r),
          o = this.compileAndRun(a, [t, i], e.dtype);
        return i.dispose(), o
      }
      reshape(t, e) {
        const n = this.texData.get(t.dataId);
        if (n.isPacked && !au(t.shape, e) && (null === n.texture || !au(n.shape, e))) {
          const n = this.packedReshape(t, e);
          return Object(Ft.ub)().makeTensorFromDataId(n.dataId, n.shape, n.dtype)
        }
        return Ft.L.reshapeTensor(t, e)
      }
      resizeBilinear(t, e, n, r) {
        const s = Object(Ft.vb)().getBool("WEBGL_PACK_IMAGE_OPERATIONS") ? new Bl(t.shape, e, n, r) : new Ll(t.shape, e, n, r);
        return this.compileAndRun(s, [t], "float32")
      }
      resizeBilinearBackprop(t, e, n) {
        const r = new zl(t, e, n);
        return this.compileAndRun(r, [t])
      }
      resizeNearestNeighbor(t, e, n, r) {
        const s = new Wl(t.shape, e, n, r);
        return this.compileAndRun(s, [t])
      }
      resizeNearestNeighborBackprop(t, e, n) {
        const r = new Pl(t, e, n);
        return this.compileAndRun(r, [t])
      }
      multinomial(t, e, n, r) {
        const s = e ? t : Object(Ft.gd)(t),
          i = s.shape[0],
          a = s.shape[1],
          o = new Tl(i, a, n),
          u = o.getCustomSetupFunc(r);
        return this.compileAndRun(o, [s], "int32", u)
      }
      oneHot(t, e, n, r) {
        const s = new Al(t.size, e, n, r);
        return this.compileAndRun(s, [t])
      }
      diag(t) {
        const e = new tl(t.size);
        return this.compileAndRun(e, [t])
      }
      cropAndResize(t, e, n, r, s, i) {
        const a = new qc(t.shape, e.shape, r, s, i);
        return this.compileAndRun(a, [t, e, n], "float32")
      }
      depthToSpace(t, e, n) {
        Ft.Jd.assert(e > 1, () => `blockSize should be > 1 for depthToSpace, but was: ${e}`);
        const r = t.shape[0],
          s = "NHWC" === n ? t.shape[1] : t.shape[2],
          i = "NHWC" === n ? t.shape[2] : t.shape[3],
          a = "NHWC" === n ? t.shape[3] : t.shape[1],
          o = s * e,
          u = i * e,
          c = a / (e * e),
          l = new Qc("NHWC" === n ? [r, o, u, c] : [r, c, o, u], e, n);
        return this.compileAndRun(l, [t])
      }
      split(t, e, n) {
        return Zh(t, e, n)
      }
      scatterND(t, e, n) {
        const {
          sliceRank: r,
          numUpdates: s,
          sliceSize: i,
          strides: a,
          outputSize: o
        } = Ft.L.calculateShapes(e, t, n), u = [o / i, i], c = t.reshape([s, r]), l = e.reshape([s, i]);
        if (0 === o) return Ft.L.reshapeTensor(Object(Ft.wd)([]), n);
        const h = Object(Ft.Pc)(0),
          d = new Hl(s, r, c.rank, l.rank, a, u);
        return this.compileAndRun(d, [l, c, h]).reshape(n)
      }
      sparseToDense(t, e, n, r) {
        const {
          sliceRank: s,
          numUpdates: i,
          strides: a,
          outputSize: o
        } = Ft.L.calculateShapes(e, t, n), u = new Hl(i, s, t.rank, e.rank, a, [o, 1], !1);
        return this.compileAndRun(u, [e, t, r]).reshape(n)
      }
      fft(t) {
        return this.fftImpl(t, !1)
      }
      ifft(t) {
        return this.fftImpl(t, !0)
      }
      fftImpl(t, e) {
        const n = this.texData.get(t.dataId),
          r = new al(il.REAL, t.shape, e),
          s = new al(il.IMAG, t.shape, e),
          i = [this.makeComplexComponentTensorInfo(t, n.complexTensors.real), this.makeComplexComponentTensorInfo(t, n.complexTensors.imag)],
          a = this.compileAndRun(r, i),
          o = this.compileAndRun(s, i),
          u = this.complex(a, o).as2D(t.shape[0], t.shape[1]);
        return a.dispose(), o.dispose(), u
      }
      gatherND(t, e) {
        const n = e.shape,
          r = n[n.length - 1],
          [s, i, a, o] = Ft.L.prepareAndValidate(t, e),
          u = e.reshape([i, r]),
          c = t.reshape([t.size / a, a]),
          l = new cl(r, o, [i, a]);
        return this.compileAndRun(l, [c, u]).reshape(s)
      }
      fill(t, e, n) {
        if ("string" === (n = n || Ft.Jd.inferDtype(e))) {
          const r = Ft.Jd.getArrayFromDType(n, Ft.Jd.sizeFromShape(t));
          return r.fill(e), Object(Ft.ub)().makeTensor(r, t, n, this)
        } {
          const r = new ol(t, e),
            s = r.getCustomSetupFunc(e);
          return this.compileAndRun(r, [], n, s)
        }
      }
      onesLike(t) {
        if ("string" === t.dtype) throw new Error("onesLike is not supported under string dtype");
        return this.fill(t.shape, 1, t.dtype)
      }
      zerosLike(t) {
        return this.fill(t.shape, "string" === t.dtype ? "" : 0, t.dtype)
      }
      linspace(t, e, n) {
        return Ft.L.linspaceImpl(t, e, n)
      }
      makeTensorInfo(t, e) {
        const n = this.write(null, t, e);
        return this.texData.get(n).usage = null, {
          dataId: n,
          shape: t,
          dtype: e
        }
      }
      makeOutput(t, e) {
        const {
          dataId: n
        } = this.makeTensorInfo(t, e);
        return Object(Ft.ub)().makeTensorFromDataId(n, t, e, this)
      }
      unpackTensor(t) {
        const e = new Xh(t.shape);
        return this.runWebGLProgram(e, [t], t.dtype)
      }
      packTensor(t) {
        const e = new Nl(t.shape);
        return this.runWebGLProgram(e, [t], t.dtype, null, !0)
      }
      packedReshape(t, e) {
        const n = [nu(t.shape), ...ru(t.shape)],
          r = {
            dtype: t.dtype,
            shape: n,
            dataId: t.dataId
          },
          s = [nu(e), ...ru(e)],
          i = new Ml(s, n),
          a = this.runWebGLProgram(i, [r], t.dtype, null, !0);
        return {
          dataId: a.dataId,
          shape: e,
          dtype: a.dtype
        }
      }
      decode(t) {
        const e = this.texData.get(t),
          {
            isPacked: n,
            shape: r,
            dtype: s
          } = e,
          i = su(r);
        let a;
        a = n ? new Zc(i) : new Yc(i);
        return {
          dtype: s,
          shape: r,
          dataId: this.runWebGLProgram(a, [{
            shape: i,
            dtype: s,
            dataId: t
          }], s, null, !0).dataId
        }
      }
      runWebGLProgram(t, e, n, r, s = !1) {
        const i = this.makeTensorInfo(t.outputShape, n),
          a = this.texData.get(i.dataId);
        if (t.packedOutput && (a.isPacked = !0), t.outPackingScheme === jo.DENSE) {
          const e = zo(t.outputShape);
          a.texShape = e.map(t => 2 * t)
        }
        if (null != t.outTexUsage && (a.usage = t.outTexUsage), 0 === Ft.Jd.sizeFromShape(i.shape)) return a.values = Ft.Jd.getTypedArrayFromDType(i.dtype, 0), i;
        const o = [],
          u = e.map(e => {
            if ("complex64" === e.dtype) throw new Error("GPGPUProgram does not support complex64 input. For complex64 dtypes, please separate the program into real and imaginary parts.");
            let n = this.texData.get(e.dataId);
            if (null == n.texture) {
              if (!t.packedInputs && Ft.Jd.sizeFromShape(e.shape) <= Object(Ft.vb)().getNumber("WEBGL_SIZE_UPLOAD_UNIFORM")) return {
                shape: e.shape,
                texData: null,
                isUniform: !0,
                uniformValues: n.values
              };
              t.packedInputs && (n.isPacked = !0, n.shape = e.shape)
            } else if (!!n.isPacked != !!t.packedInputs) e = n.isPacked ? this.unpackTensor(e) : this.packTensor(e), o.push(e), n = this.texData.get(e.dataId);
            else if (n.isPacked && !au(n.shape, e.shape)) {
              const t = e,
                r = e.shape;
              e.shape = n.shape, e = this.packedReshape(e, r), o.push(e), n = this.texData.get(e.dataId), t.shape = r
            }
            return this.uploadToGPU(e.dataId), {
              shape: e.shape,
              texData: n,
              isUniform: !1
            }
          });
        this.uploadToGPU(i.dataId);
        const c = {
            shape: i.shape,
            texData: a,
            isUniform: !1
          },
          l = function (t, e, n) {
            let r = "";
            e.concat(n).forEach(t => {
              const e = null != t.texData && null != t.texData.slice && t.texData.slice.flatOffset > 0,
                n = t.isUniform ? "uniform" : t.texData.texShape;
              r += `${t.shape}_${n}_${e}`
            });
            const s = t.userCode;
            let i = t.constructor.name;
            return i += "_" + r + "_" + s, i
          }(t, u, c),
          h = this.getAndSaveBinary(l, () => (function (t, e, n, r) {
            const s = e.userCode,
              i = n.map((t, n) => {
                const r = {
                  logicalShape: t.shape,
                  texShape: t.isUniform ? null : t.texData.texShape,
                  isUniform: t.isUniform,
                  isPacked: !t.isUniform && t.texData.isPacked,
                  flatOffset: null
                };
                return null != t.texData && null != t.texData.slice && t.texData.slice.flatOffset > 0 && (r.flatOffset = t.texData.slice.flatOffset), {
                  name: e.variableNames[n],
                  shapeInfo: r
                }
              }),
              a = i.map(t => t.shapeInfo),
              o = {
                logicalShape: r.shape,
                texShape: r.texData.texShape,
                isUniform: !1,
                isPacked: r.texData.isPacked,
                flatOffset: null
              },
              u = _u(i, o, s, e.packedInputs),
              c = t.createProgram(u);
            let l = null;
            const h = t.getUniformLocation(c, "NAN", !1);
            1 === Object(Ft.vb)().getNumber("WEBGL_VERSION") && (l = t.getUniformLocation(c, "INFINITY", !1));
            const d = {};
            for (let n = 0; n < e.variableNames.length; n++) {
              const r = e.variableNames[n],
                s = !1;
              d[r] = t.getUniformLocation(c, r, s), d[`offset${r}`] = t.getUniformLocation(c, `offset${r}`, s)
            }
            return {
              program: e,
              source: u,
              webGLProgram: c,
              uniformLocations: d,
              inShapeInfos: a,
              outShapeInfo: o,
              infLoc: l,
              nanLoc: h
            }
          })(this.gpgpu, t, u, c)),
          d = null != this.activeTimers;
        let p;
        if (d && (p = this.startTimer()), function (t, e, n, r, s) {
            xl(e.inShapeInfos, n), xl([e.outShapeInfo], [r]);
            const i = r.texData.texture,
              a = r.texData.texShape;
            r.texData.isPacked ? t.setOutputPackedMatrixTexture(i, a[0], a[1]) : t.setOutputMatrixTexture(i, a[0], a[1]), t.setProgram(e.webGLProgram), 1 === Object(Ft.vb)().getNumber("WEBGL_VERSION") && null !== e.infLoc && t.gl.uniform1f(e.infLoc, 1 / 0), null !== e.nanLoc && t.gl.uniform1f(e.nanLoc, NaN), n.forEach((n, r) => {
              const s = e.program.variableNames[r],
                i = e.uniformLocations[s],
                a = e.uniformLocations[`offset${s}`];
              if (null != i)
                if (n.isUniform)
                  if (Ft.Jd.sizeFromShape(n.shape) < 2) t.gl.uniform1f(i, n.uniformValues[0]);
                  else {
                    let e = n.uniformValues;
                    e instanceof Float32Array || (e = new Float32Array(e)), t.gl.uniform1fv(i, e)
                  }
              else null != n.texData.slice && null != a && t.gl.uniform1i(a, n.texData.slice.flatOffset), t.setInputMatrixTexture(n.texData.texture, i, r)
            }), null != s && s(t, e.webGLProgram), t.executeProgram()
          }(this.gpgpu, h, u, c, r), o.forEach(t => this.disposeData(t.dataId)), d && (p = this.endTimer(p), this.activeTimers.push({
            name: t.constructor.name,
            query: this.getQueryTime(p)
          })), !Object(Ft.vb)().getBool("WEBGL_LAZILY_UNPACK") && a.isPacked && !1 === s) {
          const t = this.unpackTensor(i);
          return this.disposeData(i.dataId), t
        }
        return i
      }
      compileAndRun(t, e, n, r, s = !1) {
        n = n || e[0].dtype;
        const i = this.runWebGLProgram(t, e, n, r, s);
        return Object(Ft.ub)().makeTensorFromDataId(i.dataId, i.shape, i.dtype)
      }
      getAndSaveBinary(t, e) {
        return t in this.binaryCache || (this.binaryCache[t] = e()), this.binaryCache[t]
      }
      getTextureManager() {
        return this.textureManager
      }
      dispose() {
        if (!this.disposed) {
          if (!Object(Ft.vb)().getBool("IS_TEST")) {
            Object.keys(this.binaryCache).forEach(t => {
              this.gpgpu.deleteProgram(this.binaryCache[t].webGLProgram), delete this.binaryCache[t]
            })
          }
          this.textureManager.dispose(), null != this.canvas && "undefined" != typeof HTMLCanvasElement && this.canvas instanceof HTMLCanvasElement ? this.canvas.remove() : this.canvas = null, this.gpgpuCreatedLocally && (this.gpgpu.program = null, this.gpgpu.dispose()), this.disposed = !0
        }
      }
      floatPrecision() {
        return null == this.floatPrecisionValue && (this.floatPrecisionValue = Object(Ft.Bd)(() => {
          if (!Object(Ft.vb)().get("WEBGL_RENDER_FLOAT32_ENABLED")) {
            const t = Object(Ft.vb)().getBool("DEBUG");
            Object(Ft.vb)().set("DEBUG", !1);
            const e = this.abs(Object(Ft.Pc)(1e-8)).dataSync()[0];
            if (Object(Ft.vb)().set("DEBUG", t), e > 0) return 32
          }
          return 16
        })), this.floatPrecisionValue
      }
      epsilon() {
        return 32 === this.floatPrecision() ? nd : rd
      }
      uploadToGPU(t) {
        const e = this.texData.get(t),
          {
            shape: n,
            dtype: r,
            values: s,
            texture: i,
            usage: a,
            isPacked: o
          } = e;
        if (null != i) return;
        const u = null != this.activeTimers;
        let c;
        u && (c = Ft.Jd.now());
        let l = e.texShape;
        if (null == l && (l = function (t, e = !1) {
            let n = Object(Ft.vb)().getNumber("WEBGL_MAX_TEXTURE_SIZE");
            if (e && (n *= 2, 1 === (t = t.map((e, n) => n >= t.length - 2 ? Ft.Jd.nearestLargerEven(t[n]) : t[n])).length && (t = [2, t[0]])), 2 !== t.length) {
              const e = Ft.Jd.squeezeShape(t);
              t = e.newShape
            }
            let r = Ft.Jd.sizeFromShape(t);
            if (t.length <= 1 && r <= n) return [1, r];
            if (2 === t.length && t[0] <= n && t[1] <= n) return t;
            if (3 === t.length && t[0] * t[1] <= n && t[2] <= n) return [t[0] * t[1], t[2]];
            if (3 === t.length && t[0] <= n && t[1] * t[2] <= n) return [t[0], t[1] * t[2]];
            if (4 === t.length && t[0] * t[1] * t[2] <= n && t[3] <= n) return [t[0] * t[1] * t[2], t[3]];
            if (4 === t.length && t[0] <= n && t[1] * t[2] * t[3] <= n) return [t[0], t[1] * t[2] * t[3]];
            if (e) {
              const e = nu(t);
              let n = 2,
                s = 2;
              return t.length && ([n, s] = ru(t)), r = e * (n / 2) * (s / 2), Ft.Jd.sizeToSquarishShape(r).map(t => 2 * t)
            }
            return Ft.Jd.sizeToSquarishShape(r)
          }(n, o), e.texShape = l), null != s) {
          const t = su(n);
          let i, a = l[1],
            h = l[0];
          const d = s instanceof Uint8Array;
          o ? ([a, h] = Lo(l[0], l[1]), i = new sl(t, [h, a], d)) : i = new rl(t, [h, a], d);
          const p = this.makeTensorInfo([h, a], r);
          this.texData.get(p.dataId).usage = d ? Do.PIXELS : Do.UPLOAD, this.gpgpu.uploadDenseMatrixToTexture(this.getTexture(p.dataId), a, h, s);
          const f = !0,
            m = this.runWebGLProgram(i, [p], r, null, f),
            g = this.texData.get(m.dataId);
          e.texture = g.texture, e.texShape = g.texShape, e.isPacked = g.isPacked, e.usage = g.usage, this.disposeData(p.dataId), this.texData.delete(m.dataId), e.values = null, u && (this.uploadWaitMs += Ft.Jd.now() - c)
        } else {
          const t = this.acquireTexture(l, a, r, o);
          e.texture = t
        }
      }
      convertAndCacheOnCPU(t, e) {
        const n = this.texData.get(t),
          {
            dtype: r
          } = n;
        return this.releaseGPUData(t), null != e && (n.values = function (t, e) {
            if ("float32" === e || "complex64" === e) return t;
            if ("int32" === e || "bool" === e) {
              const n = "int32" === e ? new Int32Array(t.length) : new Uint8Array(t.length);
              for (let e = 0; e < n.length; ++e) n[e] = Math.round(t[e]);
              return n
            }
            throw new Error(`Unknown dtype ${e}`)
          }
          /** @license See the LICENSE file. */
          (e, r)), n.values
      }
      acquireTexture(t, e, n, r) {
        if (this.numBytesInGPU += this.computeBytes(t, n), !this.warnedAboutMemory && this.numBytesInGPU > 1024 * this.numMBBeforeWarning * 1024) {
          const t = (this.numBytesInGPU / 1024 / 1024).toFixed(2);
          this.warnedAboutMemory = !0, console.warn(`High memory usage in GPU: ${t} MB, ` + "most likely due to a memory leak")
        }
        return this.textureManager.acquireTexture(t, e, r)
      }
      computeBytes(t, e) {
        return t[0] * t[1] * Ft.Jd.bytesPerElement(e)
      }
    }
    /**
     * @license
     * Copyright 2020 Google Inc. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    Ft.nb.isBrowser() && Object(Ft.Hc)("webgl", () => new cd, 2);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const ld = {
      kernelName: Ft.e,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        backend: e
      }) => {
        const {
          a: n,
          b: r
        } = t;
        /**
         * @license
         * Copyright 2020 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        return function (t, e, n) {
          let r = new hc(Ku, t.shape, e.shape);
          return Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") && (r = new Ac(pc, t.shape, e.shape, !0)), n.runWebGLProgram(r, [t, e], "float32")
        }(n, r, e)
      }
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class hd {
      constructor(t) {
        this.variableNames = ["Image"], this.outputShape = [];
        const e = t[2];
        this.outputShape = t, this.userCode = `\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int x = coords[2];\n\n          int coordX = ${e} - x;\n          float outputValue;\n          if(coordX >= 0 && coordX < ${e}) {\n            outputValue = getImage(coords[0], coords[1], coordX, coords[3]);\n          } else {\n            outputValue = getImage(coords[0], coords[1], coords[2], coords[3]);\n          }\n          setOutput(outputValue);\n        }\n    `
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const dd = {
      kernelName: Ft.f,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        backend: e
      }) => {
        const {
          image: n
        } = t, r = e, s = new hd(n.shape);
        return r.runWebGLProgram(s, [n], n.dtype)
      }
    };
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class pd {
      constructor(t) {
        this.variableNames = ["A"];
        const e = wu(),
          [n, r] = t;
        this.outputShape = t, this.userCode = `\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n        vec2 uv = (vec2(texC, texR) + halfCR) / vec2(${r}.0, ${n}.0);\n\n        vec4 values = ${e.texture2D}(A, uv);\n        float value;\n        if (depth == 0) {\n          value = values.r;\n        } else if (depth == 1) {\n          value = values.g;\n        } else if (depth == 2) {\n          value = values.b;\n        } else if (depth == 3) {\n          value = values.a;\n        }\n\n        setOutput(floor(value * 255.0 + 0.5));\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class fd {
      constructor(t) {
        this.variableNames = ["A"], this.packedInputs = !1, this.packedOutput = !0;
        const e = wu(),
          [n, r] = t;
        this.outputShape = t, this.userCode = `\n      void main() {\n        ivec3 coords = getOutputCoords();\n        int texR = coords[0];\n        int texC = coords[1];\n        int depth = coords[2];\n\n        vec4 result = vec4(0.);\n\n        for(int row=0; row<=1; row++) {\n          for(int col=0; col<=1; col++) {\n            texC = coords[1] + row;\n            depth = coords[2] + col;\n\n            vec2 uv = (vec2(texC, texR) + halfCR) /\n                       vec2(${r}.0, ${n}.0);\n            vec4 values = ${e.texture2D}(A, uv);\n            float value;\n            if (depth == 0) {\n              value = values.r;\n            } else if (depth == 1) {\n              value = values.g;\n            } else if (depth == 2) {\n              value = values.b;\n            } else if (depth == 3) {\n              value = values.a;\n            }\n\n            result[row * 2 + col] = floor(value * 255.0 + 0.5);\n          }\n        }\n\n        ${e.output} = result;\n      }\n    `
      }
    }
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const md = {
      kernelName: Ft.g,
      backendName: "webgl",
      kernelFunc: function (t) {
        const {
          inputs: e,
          backend: n,
          attrs: r
        } = t;
        let {
          pixels: s
        } = e;
        const {
          numChannels: i
        } = r, a = "undefined" != typeof HTMLVideoElement && s instanceof HTMLVideoElement, o = "undefined" != typeof HTMLImageElement && s instanceof HTMLImageElement, [u, c] = a ? [s.videoWidth, s.videoHeight] : [s.width, s.height], l = [c, u], h = [c, u, i];
        (o || a) && (null == gd && (gd = document.createElement("canvas").getContext("2d")), gd.canvas.width = u, gd.canvas.height = c, gd.drawImage(s, 0, 0, u, c), s = gd.canvas);
        const d = n.makeTensorInfo(l, "int32");
        n.texData.get(d.dataId).usage = Do.PIXELS, n.gpgpu.uploadPixelDataToTexture(n.getTexture(d.dataId), s);
        const p = Object(Ft.vb)().getBool("WEBGL_PACK") ? new fd(h) : new pd(h),
          f = n.runWebGLProgram(p, [d], "int32");
        return n.disposeData(d.dataId), f
      }
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
      /**
       * @license
       * Copyright 2020 Google LLC. All Rights Reserved.
       * Licensed under the Apache License, Version 2.0 (the "License");
       * you may not use this file except in compliance with the License.
       * You may obtain a copy of the License at
       *
       * http://www.apache.org/licenses/LICENSE-2.0
       *
       * Unless required by applicable law or agreed to in writing, software
       * distributed under the License is distributed on an "AS IS" BASIS,
       * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
       * See the License for the specific language governing permissions and
       * limitations under the License.
       * =============================================================================
       */
    };
    let gd;
    const {
      maxImpl: bd,
      transposeImpl: yd
    } = r;
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function wd(t, e, n) {
      const r = n.texData.get(t.dataId);
      return !r.isPacked || au(t.shape, e) || null !== r.texture && au(r.shape, e) ? {
          dataId: t.dataId,
          shape: e,
          dtype: t.dtype
        } :
        /**
         * @license
         * Copyright 2020 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        function (t, e, n) {
          const r = [nu(t.shape), ...ru(t.shape)],
            s = {
              dtype: t.dtype,
              shape: r,
              dataId: t.dataId
            },
            i = [nu(e), ...ru(e)],
            a = new Ml(i, r),
            o = n.runWebGLProgram(a, [s], t.dtype, null, !0);
          return {
            dataId: o.dataId,
            shape: e,
            dtype: o.dtype
          }
        }(t, e, n)
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function vd(t, e, n, r) {
      const s = Ft.Jd.sizeFromShape(e),
        i = wd(t, [Ft.Jd.sizeFromShape(t.shape) / s, s], r),
        a = function t(e, n, r, s) {
          const [i, a] = e.shape, o = Ft.L.computeOptimalWindowSize(a), u = new Fl({
            windowSize: o,
            inSize: a,
            batchSize: i
          }, r), c = s.runWebGLProgram(u, [e], n);
          return 1 === c.shape[1] ? c : t(c, n, r, s)
        }(i, t.dtype, "max", r);
      return i.dataId !== t.dataId && r.disposeData(i.dataId), wd(a, n, r)
    }
    /**
     * @license
     * Copyright 2017 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class xd {
      constructor(t, e) {
        this.variableNames = ["A"];
        const n = new Array(t.length);
        for (let r = 0; r < n.length; r++) n[r] = t[e[r]];
        this.outputShape = n, this.rank = n.length;
        const r = ju(this.rank),
          s = function (t) {
            const e = t.length;
            if (e > 6) throw Error(`Transpose for rank ${e} is not yet supported`);
            const n = ["resRC.x", "resRC.y", "resRC.z", "resRC.w", "resRC.u", "resRC.v"],
              r = new Array(e);
            for (let e = 0; e < t.length; e++) r[t[e]] = n[e];
            return r.join()
          }
        /**
         * @license
         * Copyright 2019 Google LLC. All Rights Reserved.
         * Licensed under the Apache License, Version 2.0 (the "License");
         * you may not use this file except in compliance with the License.
         * You may obtain a copy of the License at
         *
         * http://www.apache.org/licenses/LICENSE-2.0
         *
         * Unless required by applicable law or agreed to in writing, software
         * distributed under the License is distributed on an "AS IS" BASIS,
         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
         * See the License for the specific language governing permissions and
         * limitations under the License.
         * =============================================================================
         */
        (e);
        this.userCode = `\n    void main() {\n      ${r} resRC = getOutputCoords();\n      setOutput(getA(${s}));\n    }\n    `
      }
    }
    class Od {
      constructor(t, e) {
        this.variableNames = ["A"], this.packedInputs = !0, this.packedOutput = !0;
        const n = new Array(t.length);
        for (let r = 0; r < n.length; r++) n[r] = t[e[r]];
        if (this.outputShape = n, this.rank = n.length, this.rank > 6) throw Error(`Packed transpose for rank ${this.rank} is not yet supported.`);
        const r = ju(this.rank),
          s = bu("rc", this.rank),
          i = new Array(this.rank);
        for (let t = 0; t < e.length; t++) i[e[t]] = s[t];
        const a = `vec2(${i.slice(-2).join()})`,
          o = `++${s[this.rank-1]} < ${n[this.rank-1]}`,
          u = `getChannel(getA(${i.join()}), ${a})`;
        this.userCode = `\n    void main() {\n      ${r} rc = getOutputCoords();\n      vec4 result = vec4(0.);\n      result[0] = ${u};\n      if(${o}) {\n        result[1] = ${u};\n      }\n      --${s[this.rank-1]};\n      if(++${s[this.rank-2]} < ${n[this.rank-2]}) {\n        result[2] = ${u};\n        if(${o}) {\n          result[3] = ${u};\n        }\n      }\n      setOutput(result);\n    }\n    `
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    function Sd(t, e, n) {
      const r = Object(Ft.vb)().getBool("WEBGL_PACK_ARRAY_OPERATIONS") ? new Od(t.shape, e) : new xd(t.shape, e);
      return n.runWebGLProgram(r, [t], t.dtype)
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const _d = {
      kernelName: Ft.i,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        attrs: e,
        backend: n
      }) => {
        const {
          x: r
        } = t, {
          reductionIndices: s,
          keepDims: i
        } = e, a = n, o = r.shape.length, u = Ft.Jd.parseAxisParam(s, r.shape);
        let c = u;
        const l = Ft.L.getAxesPermutation(c, o),
          h = null != l,
          d = a.shouldExecuteOnCPU([r]);
        let p = r;
        if (h) {
          if (d) {
            const t = a.texData.get(p.dataId).values,
              e = new Array(o);
            for (let t = 0; t < e.length; t++) e[t] = r.shape[l[t]];
            const n = yd(t, r.shape, r.dtype, l, e);
            p = a.makeTensorInfo(e, r.dtype), a.texData.get(p.dataId).values = n
          } else p = Sd(r, l, a);
          c = Ft.L.getInnerMostAxes(c.length, o)
        }
        Ft.L.assertAxesAreInnerMostDims("max", c, o);
        const [f, m] = Ft.L.computeOutAndReduceShapes(p.shape, c);
        let g, b = f;
        if (i && (b = Ft.L.expandShapeToKeepDim(f, u)), d) {
          const t = a.texData.get(p.dataId).values,
            e = bd(t, Ft.Jd.sizeFromShape(m), b, r.dtype);
          g = a.makeTensorInfo(b, r.dtype), a.texData.get(g.dataId).values = e
        } else g = vd(p, m, b, a);
        return h && a.disposeData(p.dataId), g
      }
    };
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const kd = {
        kernelName: Ft.j,
        backendName: "webgl",
        kernelFunc: ({
          inputs: t,
          attrs: e,
          backend: n
        }) => {
          const {
            x: r
          } = t, {
            filterSize: s,
            strides: i,
            pad: a,
            includeBatchInIndex: o
          } = e, u = n;
          Ft.Jd.assert(4 === r.shape.length, () => `Error in maxPool: input must be rank 4 but got rank ${r.shape.length}.`);
          const c = [1, 1];
          Ft.Jd.assert(Ft.L.eitherStridesOrDilationsAreOne(i, c), () => "Error in maxPool: Either strides or dilations must be 1. " + `Got strides ${i} and dilations '${c}'`);
          const l = Ft.L.computePool2DInfo(r.shape, s, i, c, a),
            [h, d] = function (t, e, n, r) {
              let s = new jl(n, "max", !1);
              const i = r.runWebGLProgram(s, [t], "float32");
              return s = new jl(n, "max", !0, !0, e), [i, r.runWebGLProgram(s, [t], "float32")]
            }(r, o, l, u);
          return [h, d]
        }
      },
      Cd = {
        kernelName: Ft.k,
        backendName: "webgl",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          Ft.L.warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
          const {
            boxes: r,
            scores: s
          } = t, {
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o
          } = n, u = e, c = u.readSync(r.dataId), l = u.readSync(s.dataId), h = i, d = a, p = o;
          return Ft.Rb.nonMaxSuppressionV3Impl(c, l, h, d, p)
        }
      },
      Ed = Ft.Rb.nonMaxSuppressionV4Impl,
      Id = {
        kernelName: Ft.l,
        backendName: "webgl",
        kernelFunc: ({
          inputs: t,
          backend: e,
          attrs: n
        }) => {
          Ft.L.warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
          const {
            boxes: r,
            scores: s
          } = t, {
            maxOutputSize: i,
            iouThreshold: a,
            scoreThreshold: o,
            padToMaxOutputSize: u
          } = n, c = e, l = c.readSync(r.dataId), h = c.readSync(s.dataId), {
            selectedIndices: d,
            validOutputs: p
          } = Ed(l, h, i, a, o, u);
          return [d, p]
        }
      },
      Td = Ft.Rb.nonMaxSuppressionV5Impl;
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    class Ad {
      constructor(t, e, n, r) {
        this.variableNames = ["Image"], this.outputShape = [];
        const s = t[1],
          i = t[2],
          a = Math.sin(e).toFixed(3),
          o = Math.cos(e).toFixed(3);
        this.outputShape = t;
        const [u, c] = Ft.L.getImageCenter(r, s, i), l = u.toFixed(3), h = c.toFixed(3);
        let d = "";
        d = "number" == typeof n ? `float outputValue = ${n.toFixed(2)};` : `\n        vec3 fill = vec3(${n.join(",")});\n        float outputValue = fill[coords[3]];`, this.userCode = `\n        void main() {\n          ivec4 coords = getOutputCoords();\n          int x = coords[2];\n          int y = coords[1];\n          float coordXFloat = (float(x) - ${l}) * ${o} - (float(y) - ${h}) * ${a};\n          float coordYFloat = (float(x) - ${l}) * ${a} + (float(y) - ${h}) * ${o};\n          int coordX = int(round(coordXFloat + ${l}));\n          int coordY = int(round(coordYFloat + ${h}));\n          ${d}\n          if(coordX >= 0 && coordX < ${i} && coordY >= 0 && coordY < ${s}) {\n            outputValue = getImage(coords[0], coordY, coordX, coords[3]);\n          }\n          setOutput(outputValue);\n        }\n    `
      }
    }
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    const Nd = [_d, dd, md, ld, kd, Cd, Id, {
      kernelName: Ft.m,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        backend: e,
        attrs: n
      }) => {
        Ft.L.warn("tf.nonMaxSuppression() in webgl locks the UI thread. Call tf.nonMaxSuppressionAsync() instead");
        const {
          boxes: r,
          scores: s
        } = t, {
          maxOutputSize: i,
          iouThreshold: a,
          scoreThreshold: o,
          softNmsSigma: u
        } = n, c = e, l = c.readSync(r.dataId), h = c.readSync(s.dataId), d = i, p = a, f = o, m = u, {
          selectedIndices: g,
          selectedScores: b
        } = Td(l, h, d, p, f, m);
        return [g, b]
      }
    }, {
      kernelName: Ft.o,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        attrs: e,
        backend: n
      }) => {
        const {
          image: r
        } = t, {
          radians: s,
          fillValue: i,
          center: a
        } = e, o = n, u = new Ad(r.shape, s, i, a);
        return o.runWebGLProgram(u, [r], r.dtype)
      }
    }, {
      kernelName: Ft.p,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        backend: e
      }) => {
        const {
          x: n
        } = t, r = e, s = new rh(n.shape, "return x * x;");
        return r.runWebGLProgram(s, [n], n.dtype)
      }
    }, {
      kernelName: Ft.q,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        backend: e
      }) => {
        const {
          a: n,
          b: r
        } = t, s = e, i = Object(Ft.vb)().getBool("WEBGL_PACK_BINARY_OPERATIONS") ? new Ac("return (a - b) * (a - b);", n.shape, r.shape) : new hc("return (a - b) * (a - b);", n.shape, r.shape);
        return s.compileAndRun(i, [n, r])
      }
    }, {
      kernelName: Ft.t,
      backendName: "webgl",
      kernelFunc: ({
        inputs: t,
        attrs: e,
        backend: n
      }) => {
        const {
          x: r
        } = t, {
          perm: s
        } = e, i = n, a = r.shape.length, o = new Array(a);
        for (let t = 0; t < o.length; t++) o[t] = r.shape[s[t]];
        let u;
        if (i.shouldExecuteOnCPU([r])) {
          const t = i.texData.get(r.dataId).values,
            e = yd(t, r.shape, r.dtype, s, o);
          u = i.makeTensorInfo(o, r.dtype), i.texData.get(u.dataId).values = e
        } else u = Sd(r, s, i);
        return u
      }
    }];
    /**
     * @license
     * Copyright 2019 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    for (const t of Nd) Object(Ft.Ic)(t);
    /**
     * @license
     * Copyright 2020 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    /** @license See the LICENSE file. */
    Ft.Md;
    /**
     * @license
     * Copyright 2018 Google LLC. All Rights Reserved.
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     * http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     * =============================================================================
     */
    var $d = {
        libPath: "./",
        filename: "segmentation.zip"
      },
      Rd = function (t, e, n, r) {
        return new(n || (n = Promise))((function (s, i) {
          function a(t) {
            try {
              u(r.next(t))
            } catch (t) {
              i(t)
            }
          }

          function o(t) {
            try {
              u(r.throw(t))
            } catch (t) {
              i(t)
            }
          }

          function u(t) {
            var e;
            t.done ? s(t.value) : (e = t.value, e instanceof n ? e : new n((function (t) {
              t(e)
            }))).then(a, o)
          }
          u((r = r.apply(t, e || [])).next())
        }))
      },
      jd = function (t, e) {
        var n, r, s, i, a = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1]
          },
          trys: [],
          ops: []
        };
        return i = {
          next: o(0),
          throw: o(1),
          return: o(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this
        }), i;

        function o(i) {
          return function (o) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (s = 2 & i[0] ? r.return : i[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, i[1])).done) return s;
                switch (r = 0, s && (i = [2 & i[0], s.value]), i[0]) {
                  case 0:
                  case 1:
                    s = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(s = (s = a.trys).length > 0 && s[s.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue
                    }
                    if (3 === i[0] && (!s || i[1] > s[0] && i[1] < s[3])) {
                      a.label = i[1];
                      break
                    }
                    if (6 === i[0] && a.label < s[1]) {
                      a.label = s[1], s = i;
                      break
                    }
                    if (s && a.label < s[2]) {
                      a.label = s[2], a.ops.push(i);
                      break
                    }
                    s[2] && a.ops.pop(), a.trys.pop();
                    continue
                }
                i = e.call(t, a)
              } catch (t) {
                i = [6, t], r = 0
              } finally {
                n = s = 0
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              }
            }([i, o])
          }
        }
      },
      Dd = function () {
        function t(t, e) {
          this.jsonModel = t, this.weights = e
        }
        return t.prototype.load = function () {
          return Rd(this, void 0, void 0, (function () {
            var t, e, n, r;
            return jd(this, (function (s) {
              switch (s.label) {
                case 0:
                  return t = {
                    modelTopology: this.jsonModel.modelTopology,
                    format: this.jsonModel.format,
                    generatedBy: this.jsonModel.generatedBy,
                    convertedBy: this.jsonModel.convertedBy
                  }, null == this.jsonModel.weightsManifest ? [3, 2] : [4, this.loadWeights()];
                case 1:
                  e = s.sent(), n = e[0], r = e[1], t.weightSpecs = n, t.weightData = r, s.label = 2;
                case 2:
                  return null != this.jsonModel.trainingConfig && (t.trainingConfig = this.jsonModel.trainingConfig), null != this.jsonModel.userDefinedMetadata && (t.userDefinedMetadata = this.jsonModel.userDefinedMetadata), [2, t]
              }
            }))
          }))
        }, t.prototype.loadWeights = function () {
          return Rd(this, void 0, void 0, (function () {
            var t, e, n, r, s, i, a, o;
            return jd(this, (function (u) {
              for (t = [], e = [], n = 0, r = this.jsonModel.weightsManifest; n < r.length; n++) {
                for (s = r[n], i = 0, a = s.paths; i < a.length; i++) {
                  if (o = a[i], !this.weights[o]) throw new Error("Error loading weights: cannot find " + o);
                  t.push(this.weights[o])
                }
                e.push.apply(e, s.weights)
              }
              return [2, [e, this.toArrayBuffer(t)]]
            }))
          }))
        }, t.prototype.toArrayBuffer = function (t) {
          if (Array.isArray(t)) {
            for (var e = 0, n = 0, r = t; n < r.length; n++) {
              e += r[n].length
            }
            for (var s = new ArrayBuffer(e), i = new Uint8Array(s), a = 0, o = 0, u = t; o < u.length; o++) {
              a += u[o].copy(i, a)
            }
            return s
          }
          return t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength)
        }, t
      }(),
      Fd = n(39),
      Md = function () {
        return (Md = Object.assign || function (t) {
          for (var e, n = 1, r = arguments.length; n < r; n++)
            for (var s in e = arguments[n]) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
          return t
        }).apply(this, arguments)
      },
      zd = function (t, e, n, r) {
        return new(n || (n = Promise))((function (s, i) {
          function a(t) {
            try {
              u(r.next(t))
            } catch (t) {
              i(t)
            }
          }

          function o(t) {
            try {
              u(r.throw(t))
            } catch (t) {
              i(t)
            }
          }

          function u(t) {
            var e;
            t.done ? s(t.value) : (e = t.value, e instanceof n ? e : new n((function (t) {
              t(e)
            }))).then(a, o)
          }
          u((r = r.apply(t, e || [])).next())
        }))
      },
      Ld = function (t, e) {
        var n, r, s, i, a = {
          label: 0,
          sent: function () {
            if (1 & s[0]) throw s[1];
            return s[1]
          },
          trys: [],
          ops: []
        };
        return i = {
          next: o(0),
          throw: o(1),
          return: o(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this
        }), i;

        function o(i) {
          return function (o) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (n = 1, r && (s = 2 & i[0] ? r.return : i[0] ? r.throw || ((s = r.return) && s.call(r), 0) : r.next) && !(s = s.call(r, i[1])).done) return s;
                switch (r = 0, s && (i = [2 & i[0], s.value]), i[0]) {
                  case 0:
                  case 1:
                    s = i;
                    break;
                  case 4:
                    return a.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    a.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!(s = (s = a.trys).length > 0 && s[s.length - 1]) && (6 === i[0] || 2 === i[0])) {
                      a = 0;
                      continue
                    }
                    if (3 === i[0] && (!s || i[1] > s[0] && i[1] < s[3])) {
                      a.label = i[1];
                      break
                    }
                    if (6 === i[0] && a.label < s[1]) {
                      a.label = s[1], s = i;
                      break
                    }
                    if (s && a.label < s[2]) {
                      a.label = s[2], a.ops.push(i);
                      break
                    }
                    s[2] && a.ops.pop(), a.trys.pop();
                    continue
                }
                i = e.call(t, a)
              } catch (t) {
                i = [6, t], r = 0
              } finally {
                n = s = 0
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              }
            }([i, o])
          }
        }
      },
      Bd = function () {
        function t() {
          this._initializeSubscriber = new K
        }
        return Object.defineProperty(t.prototype, "width", {
          get: function () {
            return this._modelConfig ? this._modelConfig.width : 0
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(t.prototype, "height", {
          get: function () {
            return this._modelConfig ? this._modelConfig.height : 0
          },
          enumerable: !1,
          configurable: !0
        }), t.prototype.getOutput = function () {
          return this._cnnOutputData
        }, t.prototype.initialize = function (t, e) {
          return zd(this, void 0, void 0, (function () {
            var n, r, s, i, a = this;
            return Ld(this, (function (o) {
              switch (o.label) {
                case 0:
                  return this._config = t ? Md(Md({}, $d), t) : $d, this._initializeSubscription && this._initializeSubscription.unsubscribe(), this._initializeSubscription = this._initializeSubscriber.pipe(function t(e, n, r) {
                    return void 0 === r && (r = Number.POSITIVE_INFINITY), "function" == typeof n ? function (s) {
                      return s.pipe(t((function (t, r) {
                        return mt(e(t, r)).pipe(I((function (e, s) {
                          return n(t, e, r, s)
                        })))
                      }), r))
                    } : ("number" == typeof n && (r = n), function (t) {
                      return t.lift(new jt(e, r))
                    })
                  }((function (t) {
                    return t
                  }))).subscribe(), n = new X(0), r = new X(0), s = new X(0), i = new X(0), this._initializeSubscriber.next(ht(n, r, s, i).pipe(I((function (t) {
                    return t.reduce((function (t, e) {
                      return t + e
                    }), 0)
                  })), I((function (t) {
                    return e && e(t / 4)
                  })))), [4, this.getZipModel(this._config.libPath + "/" + this._config.filename, n).pipe(kt((function (t) {
                    return a.unzipModel(t.response)
                  })), kt((function (t) {
                    return a.retrieveModelConfig(t, "config.json", r).pipe(I((function (e) {
                      return {
                        jszip: t,
                        config: e
                      }
                    })))
                  })), kt((function (t) {
                    var e = t.jszip,
                      n = t.config;
                    return a.extractModel(e, n, s).pipe(I((function (t) {
                      return {
                        jszip: e,
                        config: n,
                        jsonModel: t
                      }
                    })))
                  })), kt((function (t) {
                    var e = t.jszip,
                      n = t.config,
                      r = t.jsonModel;
                    return a.extractWeights(e, r, i).pipe(I((function (t) {
                      return {
                        config: n,
                        jsonModel: r,
                        weights: t
                      }
                    })))
                  })), kt((function (t) {
                    var e = t.config,
                      n = t.jsonModel,
                      r = t.weights;
                    return mt(async function (t, e = {}) {
                        if (null == t) throw new Error("modelUrl in loadGraphModel() cannot be null. Please provide a url or an IOHandler that loads the model");
                        null == e && (e = {}), e.fromTFHub && null == t.load && (t.endsWith("/") || (t += "/"), t = `${t}${Ha}${Va}`);
                        const n = new Ga(t, e);
                        return await n.load(), n
                      }
                      /** @license See the LICENSE file. */
                      (new Dd(n, r), {
                        onProgress: function (t) {
                          return console.log(t)
                        }
                      })).pipe(I((function (t) {
                      return {
                        config: e,
                        graphModel: t
                      }
                    })))
                  })), I((function (t) {
                    var n = t.config,
                      r = t.graphModel;
                    e && e(100), a._modelConfig = n, a._model = r;
                    var s = Object(Ft.Pd)([1, a._modelConfig.height, a._modelConfig.width, 3]);
                    a._model.predict(s).dispose()
                  }))).toPromise()];
                case 1:
                  return o.sent(), this._initializeSubscription.unsubscribe(), [2]
              }
            }))
          }))
        }, t.prototype.getZipModel = function (t, e) {
          return V({
            url: t,
            method: "GET",
            responseType: "arraybuffer",
            async: !0,
            progressSubscriber: new x((function (t) {
              return e.next(t.loaded / t.total)
            }), (function (t) {}), (function () {
              return e.next(1)
            }))
          }).pipe(Ot(2))
        }, t.prototype.unzipModel = function (t) {
          return mt((new It).loadAsync(t))
        }, t.prototype.retrieveModelConfig = function (t, e, n) {
          var r = t.file(e);
          return r ? mt(r.async("text", (function (t) {
            return n.next(t.percent / 100)
          }))).pipe(I((function (t) {
            return JSON.parse(t)
          }))) : yt("Unable to retrieve model config: " + e + " is missing")
        }, t.prototype.extractModel = function (t, e, n) {
          if (!e) return yt("Invalid model config");
          var r = t.file(e.model);
          return r ? mt(r.async("uint8array", (function (t) {
            return n.next(t.percent / 100)
          }))).pipe(I((function (t) {
            return Object(Fd.a)(t)
          })), I((function (t) {
            return JSON.parse((new TextDecoder).decode(t))
          }))) : yt("Error extracting model: " + e.model + " is missing")
        }, t.prototype.extractWeights = function (t, e, n) {
          if (!e) return yt("Unable to extract weights: model is undefined");
          if (!e.weightsManifest) return et({});
          for (var r = [], s = {}, i = 0, a = e.weightsManifest; i < a.length; i++)
            for (var o = function (e) {
                var n = t.file(e);
                if (!n) return {
                  value: yt("Error extracting weight: " + e + " is missing")
                };
                var i = new X(0);
                s[e] = mt(n.async("nodebuffer", (function (t) {
                  return i.next(t.percent / 100)
                }))).pipe(I((function (t) {
                  return Object(Fd.a)(t)
                }))), r.push(i)
              }, u = 0, c = a[i].paths; u < c.length; u++) {
              var l = o(c[u]);
              if ("object" == typeof l) return l.value
            }
          return this._initializeSubscriber.next(ht(r).pipe(I((function (t) {
            return t.reduce((function (t, e) {
              return t + e
            }), 0)
          })), I((function (t) {
            return n.next(t / r.length)
          })))), gt(s)
        }, t.prototype.classify = function (t) {
          return zd(this, void 0, void 0, (function () {
            var e, n, r, s, i, a, o, u, c;
            return Ld(this, (function (l) {
              switch (l.label) {
                case 0:
                  return (e = t.getContext("2d")) ? (this._imageData = e.getImageData(0, 0, t.width, t.height), n = Ft.S.fromPixels(this._imageData), r = Ft.Nb.resizeBilinear(n, [this._modelConfig.height, this._modelConfig.width]), s = Object(Ft.U)(r, "float32"), i = s.reshape([1, this._modelConfig.height, this._modelConfig.width, 3]), a = Object(Ft.Pc)(255), o = i.div(a), u = this._model.predict(o), this._cnnOutput = u.argMax(-1), c = this, [4, this._cnnOutput.data()]) : (console.error("No rendering context"), [2]);
                case 1:
                  return c._cnnOutputData = l.sent(), n.dispose(), r.dispose(), s.dispose(), i.dispose(), a.dispose(), o.dispose(), u.dispose(), [2]
              }
            }))
          }))
        }, t.prototype.release = function () {
          this._cnnOutput.dispose(), this._model.dispose()
        }, t
      }();
    n.d(e, "Face", (function () {
      return Rt
    })), n.d(e, "Segmentation", (function () {
      return Bd
    }))
  }])
}));
